webpackJsonp([0],{

/***/ "+Ads":
/***/ (function(module, exports) {

module.exports = "<div class=\"modal fade\" bsModal [config]=\"config\" role=\"dialog\" tabindex=\"-1\">\n    <div class=\"modal-dialog modal-xl\">\n      <div class=\"modal-content\">\n        <!-- 'hidden' is used instead of ngIf so that the instance of pioneer-property-search is not destroyed when the condition is false and it preserves the search criteria and results -->\n        <pioneer-property-search [hidden]=\"propertyPopupType != PopupType.SEARCH\" (canceled)=\"cancelSearch()\"\n          (selected)=\"selectProperty($event)\" (goToAdd)=\"goToAdd()\" data-se-id=\"propertySearchComponent\">\n        </pioneer-property-search>\n        <pioneer-property-add *ngIf=\"propertyPopupType === PopupType.ADD\" (canceled)=\"cancelAdd()\" (accepted)=\"acceptAdd($event)\"></pioneer-property-add>\n      </div>\n    </div>\n  </div>"

/***/ }),

/***/ "/BnH":
/***/ (function(module, exports) {

module.exports = "<pioneer-confirmation-modal\n  data-se-id=\"add-payment-confirmation-modal\"\n  content=\"MESSAGES.CONFIRMATION.PROCEED\"\n  cancel=\"COMMON.BUTTON.CANCEL\"\n  [confirm]=\"confirmationModalConfig.confirm\"\n  [title]=\"confirmationModalConfig.title\"\n  (closed)=\"confirmBeforeAddPaymentHandler($event)\">\n</pioneer-confirmation-modal>\n\n<ng-container *ngIf=\"(calculatedTotalRemaining | async) > 0\">\n  <div class=\"row totals\">\n    <div class=\"col flex85 px-0\">\n      <span>{{ 'EVENT.COMMISSION.CALCULATED_TOTAL_PAID' | translate }}</span>\n    </div>\n    <div class=\"col flex15\">\n      <span class=\"bold\">\n        {{ calculatedTotalPaid===null?0:calculatedTotalPaid | async | number:'1.2-2' }} {{ onyxEvent.currency | uppercase }}\n      </span>\n    </div>\n  </div>\n  <div class=\"row totals\">\n    <div class=\"col flex85 px-0\">\n      <span>{{ 'EVENT.COMMISSION.CALCULATED_TOTAL_REMAINING' | translate }}</span>\n    </div>\n    <div class=\"col flex15\">\n      <span class=\"bold\">\n        {{ calculatedTotalRemaining | async | number:'1.2-2' }} {{ onyxEvent.currency | uppercase }}\n      </span>\n    </div>\n  </div>\n  <div class=\"row totals\">\n    <div class=\"col flex85 px-0\">\n      <span>{{ 'EVENT.COMMISSION.CALCULATED_TOTAL_PAYMENT' | translate }}</span>\n    </div>\n    <div class=\"col flex15\">\n      <span class=\"bold\">\n        {{ calculateTotalPayment | async | number:'1.2-2' }} {{ onyxEvent.currency | uppercase }}\n      </span>\n    </div>\n  </div>\n</ng-container>\n\n<ng-container *ngIf=\"showRequestPaymentFromAllVendors() && (totalVendorsWithRemainingPayment | async) > 0\">\n  <div class=\"button-bar button-vendors\" *pioneerAuthorize=\"{permission: 'PayCommission'}\">\n    <p *ngIf=\"finalPaymentHint\" class=\"text-hint\">{{ finalPaymentHint | translate }}</p>\n\n    <button class=\"btn btn-primary\"\n            (click)=\"confirmBeforeAuthorizingPayment()\"\n            data-se-id=\"paymentSubmitButton\"\n            [disabled]=\"disableConfirmBeforeAuthorizingPayment() | async\">\n\n      <ng-container *ngIf=\"(calculatedTotalRemaining | async) > 0\">\n        <span data-se-id=\"paymentSubmitButtonTotal\">{{ 'EVENT.COMMISSION.AUTHORIZE_PAYMENT_TOTAL' | translate }} {{ calculatedTotalRemaining | async | number:'1.2-2' }} {{ onyxEvent.currency | uppercase }}</span>\n        <br>\n      </ng-container>\n      {{ 'EVENT.COMMISSION.REQUEST_VENDOR_PAYMENT' | translate: {vendors: (totalVendorsWithRemainingPayment | async) }\n      }}\n    </button>\n  </div>\n</ng-container>\n"

/***/ }),

/***/ "/JMp":
/***/ (function(module, exports) {

module.exports = "<form [formGroup]=\"transientSearchForm\" *ngIf=\"transientSearchForm\" data-se-id=\"transientSearchForm\" id=\"transientSearchForm\">\n  <div class=\"row\">\n    <div class=\"col-md-3 form-container\">\n      <div class=\"form-group\">\n        <pioneer-form-input label=\"EVENT.TRANSIENT_RESERVATION.SEARCH_LAST_NAME_LABEL\">\n          <input type=\"text\"\n                 class=\"form-control\"\n                 formControlName=\"lastName\"\n                 placeholder=\"{{'EVENT.TRANSIENT_RESERVATION.SEARCH_LAST_NAME_PLACEHOLDER' | translate}}\"\n                 data-se-id=\"lastName\" />\n        </pioneer-form-input>\n      </div>\n    </div>\n    <div class=\"col-md-3 form-container\">\n      <div class=\"form-group\">\n        <pioneer-form-input label=\"EVENT.TRANSIENT_RESERVATION.SEARCH_FIRST_NAME_LABEL\">\n          <input type=\"text\"\n                 class=\"form-control\"\n                 formControlName=\"firstName\"\n                 placeholder=\"{{'EVENT.TRANSIENT_RESERVATION.SEARCH_FIRST_NAME_PLACEHOLDER' | translate}}\"\n                 data-se-id=\"firstName\"/>\n        </pioneer-form-input>\n      </div>\n    </div>\n    <div class=\"col-md-2 form-container\">\n      <div class=\"form-group\">\n        <pioneer-form-input label=\"EVENT.TRANSIENT_RESERVATION.SEARCH_CHECK_INS_FROM_LABEL\">\n          <select class=\"form-control form-control-sm\" formControlName=\"minCheckInDate\" data-se-id=\"minCheckInDate\">\n            <option *ngFor=\"let option of checkInDates\" [value]=\"option\">{{option | dateFormat }}</option>\n          </select>\n        </pioneer-form-input>\n      </div>\n    </div>\n    <div class=\"col-md-2 form-container\">\n      <div class=\"form-group\">\n        <pioneer-form-input label=\"EVENT.TRANSIENT_RESERVATION.SEARCH_CHECK_OUTS_FROM_LABEL\">\n          <select class=\"form-control form-control-sm\" formControlName=\"maxCheckOutDate\" data-se-id=\"maxCheckOutDate\">\n            <option *ngFor=\"let option of checkOutDates\" [value]=\"option\">{{option | dateFormat }}</option>\n          </select>\n        </pioneer-form-input>\n      </div>\n    </div>\n    <div class=\"col-md-2 form-container\">\n      <div class=\"form-group\">\n        <label><!-- Blank label to keep search button aligned with input fields --></label>\n        <button type=\"submit\"\n                class=\"btn btn-secondary btn-block align-bottom\"\n                [disabled]=\"disableSearch()\"\n                (click)=\"searchTransientReservations($event)\"\n                data-se-id=\"searchButton\">\n          {{'EVENT.TRANSIENT_RESERVATION.SEARCH_BUTTON_LABEL' | translate}}\n        </button>\n      </div>\n    </div>\n  </div>\n  <div *ngIf=\"isRatePlanCodeFilterVisible || isConfirmationFilterVisible\" class=\"row\">\n    <div *ngIf=\"isRatePlanCodeFilterVisible\" class=\"col-md-3 form-container\">\n      <div class=\"form-group\">\n        <pioneer-form-input label=\"EVENT.TRANSIENT_RESERVATION.SEARCH_RATE_PLAN_CODE_LABEL\">\n          <input type=\"text\"\n                 class=\"form-control\"\n                 formControlName=\"ratePlanCode\"\n                 placeholder=\"{{'EVENT.TRANSIENT_RESERVATION.SEARCH_RATE_PLAN_CODE_PLACEHOLDER' | translate}}\"\n                 maxlength=\"10\" />\n        </pioneer-form-input>\n      </div>\n    </div>\n    <div *ngIf=\"isConfirmationFilterVisible\" class=\"col-md-3 form-container\">\n      <div class=\"form-group\">\n        <pioneer-form-input label=\"EVENT.TRANSIENT_RESERVATION.SEARCH_CONFIRMATION_LABEL\">\n          <input type=\"text\"\n                 class=\"form-control\"\n                 formControlName=\"confirmation\"\n                 placeholder=\"{{'EVENT.TRANSIENT_RESERVATION.SEARCH_CONFIRMATION_PLACEHOLDER' | translate}}\"\n                 maxlength=\"10\" />\n        </pioneer-form-input>\n      </div>\n    </div>\n  </div>\n  <div class=\"row\">\n    <div class=\"col-md-6\">\n      <div *ngIf=\"transientSearchForm.errors?.first_name_or_last_name_required && (transientSearchForm.touched || transientSearchForm.dirty)\" class=\"alert alert-danger\">\n        {{'MESSAGES.VALIDATION.FIRST_NAME_OR_LAST_NAME_REQUIRED' | translate}}\n      </div>\n    </div>\n  </div>\n</form>\n"

/***/ }),

/***/ "/Y8/":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("rP7Y")(true);
// imports


// module
exports.push([module.i, ".collapsed-card .card-header{border-bottom:0}.add-vendor-message{color:#919191;font-style:italic;text-align:justify;max-width:420px;margin-left:auto;line-height:1.5;white-space:normal;margin-top:-30px;font-size:16px;font-weight:600}", "", {"version":3,"sources":["/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/vendor-lookup-form/vendor-lookup-form.component.css"],"names":[],"mappings":"AAAA,6BACI,eAAiB,CACpB,oBAEC,cAAe,kBACI,mBACC,gBACH,iBACC,gBACD,mBACG,iBACF,eACF,eACC,CAClB","file":"vendor-lookup-form.component.css","sourcesContent":[".collapsed-card .card-header {\n    border-bottom: 0;\n}\n.add-vendor-message {\n  color: #919191;\n  font-style: italic;\n  text-align: justify;\n  max-width: 420px;       /* optional: control wrapping width */\n  margin-left: auto;      /* align right inside flex or block */\n  line-height: 1.5;\n  white-space: normal;    /* ensures wrapping works */\n  margin-top: -30px;\n  font-size: 16px;\n  font-weight: 600;\n}\n"],"sourceRoot":""}]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),

/***/ "/Ynw":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("rP7Y")(true);
// imports


// module
exports.push([module.i, ".select-option-link{color:#23c0d2}", "", {"version":3,"sources":["/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/reservations/reservation-form/reservation-form.component.css"],"names":[],"mappings":"AAAA,oBACE,aAAe,CAChB","file":"reservation-form.component.css","sourcesContent":[".select-option-link {\n  color: #23C0D2;\n}\n"],"sourceRoot":""}]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("cDNt");


/***/ }),

/***/ "0T9V":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("rP7Y")(true);
// imports


// module
exports.push([module.i, ".order-one{-ms-flex-order:1!important;order:1!important}", "", {"version":3,"sources":["/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/payment/vendor-commission/vendor-commission.component.css"],"names":[],"mappings":"AAAA,WACE,2BAAA,iBAAoB,CACrB","file":"vendor-commission.component.css","sourcesContent":[".order-one {\n  order: 1 !important;\n}\n"],"sourceRoot":""}]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),

/***/ "0cpp":
/***/ (function(module, exports) {

module.exports = "<div class=\"content-container\">\n  <div class=\"row\">\n    <div class=\"card-content\">\n\n      <form [formGroup]=\"commissionForm\" novalidate>\n        <pioneer-basic-event-data\n          [parentForm]=\"commissionForm\"\n          [event]=\"onyxEvent\"\n          [isReadOnly]=\"true\"\n          [isMultiVendorPayments]=\"true\"\n          [eventMultiVendorStatus]=\"eventStatus\">\n        </pioneer-basic-event-data>\n      </form>\n\n      <ng-container *ngIf=\"configLoaded && statusLoaded\">\n        <ng-container *ngFor=\"let party of eventParties; let i = index; trackBy: trackVendorByFn\">\n          <pioneer-vendor-commission-card #card\n            [vendors]=\"onyxEvent.eventVendors\"\n            [vendor]=\"party\"\n            [isCardOpen]=\"i === openedCardIndex\"\n            (onToggleCard)=\"onToggle(i, card)\">\n          </pioneer-vendor-commission-card>\n        </ng-container>\n      </ng-container>\n\n      <pioneer-vendors-total-add-payment\n        [event]=\"onyxEvent\">\n      </pioneer-vendors-total-add-payment>\n    </div>\n  </div>\n</div>\n"

/***/ }),

/***/ "0nqh":
/***/ (function(module, exports) {

module.exports = "  <div class=\"card-header\">\n    {{ 'DASHBOARD.RECENT_TITLE_CARD.' +  eventSearchSortType | translate }}\n  </div>\n  <div class=\"dashboard-table\">\n    <table class=\"table\">\n      <tbody>\n        <tr *ngFor=\"let event of events | async\">\n          <td data-se-id=\"name\">\n            <a [routerLink]=\"['/event/' + event.eventId]\" *pioneerAuthorize=\"{permission: 'MultiVendor'}\">\n              <ng-container *ngTemplateOutlet=\"eventName\"></ng-container>\n            </a>\n            <a [routerLink]=\"['/event/' + event.eventId + '/' + event.propertyPartyId]\" *pioneerAuthorize=\"{permission: 'SingleVendor'}\">\n              <ng-container *ngTemplateOutlet=\"eventName\"></ng-container>\n            </a>\n            <ng-template #eventName>\n              <span style=\"overflow: hidden;\n                          text-overflow: ellipsis;\n                          white-space: initial;\n                          display: -webkit-box;\n                          -webkit-line-clamp: 2;\n                          -webkit-box-orient: vertical;\">\n                <ng-container *ngIf=\"isMultiPropertyUser === true\">\n                  {{ '[' + event.propertyName + '] ' }}\n                </ng-container>\n                {{event.name}}\n              </span>\n            </ng-template>\n          </td>\n        </tr>\n      </tbody>\n    </table>\n  </div>\n  <div class=\"card-footer\">\n    <a *ngIf=\"isFooterLinkActive(eventSearchSortType)\"\n      [routerLink]=\"\" (click)=\"onSelectFooter(eventSearchSortType)\" data-se-id=\"recently-event-predefined-search\">\n    {{ 'DASHBOARD.VIEW_RECENT_CARD.' + eventSearchSortType | translate }}</a>\n  </div>\n\n"

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "1DO0":
/***/ (function(module, exports) {

module.exports = "<p>\n  {{'LOGOUT.LOGOUT_CONFIRMATION' | translate}}\n\n  <button (click)=\"onLogout($event)\">{{'LOGOUT.LOGOUT' | translate}}</button>\n</p>\n"

/***/ }),

/***/ "1EdF":
/***/ (function(module, exports) {

module.exports = "<div class=\"content-container\">\n  <div class=\"row\">\n    <div class=\"card-content\">\n\n      <div class=\"card\">\n        <pioneer-header-summary\n          [event]=\"onyxEvent\"\n          [title]=\"'EVENT.OVERVIEW_CARDS.NIGHTS_BY_ROOM_TYPE_TITLE' | translate\"\n          [type] = \"headerRecordType\">\n        </pioneer-header-summary>\n        <pioneer-stay-summary\n          [event]=\"onyxEvent\"\n          [type]=\"headerRecordType\"\n          [vendor]=\"vendor\">\n        </pioneer-stay-summary>\n      </div>\n\n      <pioneer-date-room-type-summary\n        [event]=\"onyxEvent\"\n        [vendor]=\"vendor\">\n      </pioneer-date-room-type-summary>\n\n    </div>\n  </div>\n</div>\n"

/***/ }),

/***/ "1Wrw":
/***/ (function(module, exports) {

module.exports = "<div class=\"form-group form-search\">\n  <div class=\"input-group\" [class.show]=\"hasResults\">\n    <input class=\"form-control dropdown-toggle\" type=\"text\"\n           [(ngModel)]=\"nameSearch\"\n           placeholder=\"{{placeholderText | translate}}\"\n           (blur)=\"onBlur()\"\n           [disabled]=\"disabled\">\n    <div class=\"input-group-addon\"><i class=\"glyph-search\"></i></div>\n    <ng-content></ng-content>\n  </div>\n</div>\n"

/***/ }),

/***/ "1dqF":
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\">\n  <h5 class=\"modal-title\">{{ 'EVENT.PROPERTY.POPUP.ADD.VENDOR_TITLE' | translate }}</h5>\n  <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\" (click)=\"cancel()\">\n    <span aria-hidden=\"true\">&times;</span>\n  </button>\n</div>\n<div class=\"modal-body\">\n  <p class=\"text-muted text-warning\"></p>\n\n  <!-- FORM START -->\n  <div [formGroup]=\"propertyForm\">\n    <div class=\"row\">\n      <div class=\"form-container party-name form-required\">\n        <pioneer-form-input label=\"EVENT.PROPERTY.POPUP.SEARCH.FILTERS.SELECT_VENDOR\">\n          <select formControlName=\"payorType\" [(ngModel)]=\"vendorSelected\" class=\"form-control form-control-sm\">\n            <option *ngFor=\"let option of (propertyLookupStore.payorTypes | async)\" [ngValue]=\"option.key\">{{ option.value }}</option>\n          </select>\n        </pioneer-form-input>\n      </div>\n      <div class=\"form-container\">\n      </div>\n    </div>\n    <div class=\"row\">\n      <div class=\"form-container party-name form-required\">\n        <pioneer-form-input label=\"EVENT.PROPERTY.POPUP.ADD.NAME\">\n          <input type=\"text\" class=\"form-control\" formControlName=\"name\"\n            maxlength=\"50\"\n            [attr.placeholder]=\"'EVENT.PROPERTY.POPUP.ADD.NAME_PLACEHOLDER' | translate\" />\n        </pioneer-form-input>\n      </div>\n      <div class=\"form-container party-name form-required\">\n        <pioneer-form-input label=\"EVENT.PROPERTY.POPUP.ADD.COUNTRY\">\n          <select formControlName=\"countryCode\" (change)=\"onCountryCodeChanged()\" class=\"form-control form-control-sm\">\n            <option [ngValue]=\"null\">{{ 'EVENT.PROPERTY.POPUP.ADD.COUNTRY_PLACEHOLDER' | translate }}</option>\n            <option *ngFor=\"let option of (commonDataStore.countries | async)\" [ngValue]=\"option.key\">{{ option.value }}</option>\n          </select>\n        </pioneer-form-input>\n      </div>\n    </div>\n    <div class=\"row\">\n      <div class=\"form-container party-address form-required address1\">\n        <pioneer-form-input label=\"EVENT.PROPERTY.POPUP.ADD.ADDRESS_1\">\n          <input type=\"text\" class=\"form-control\" formControlName=\"address1\" maxlength=\"50\"\n            [attr.placeholder]=\"'EVENT.PROPERTY.POPUP.ADD.ADDRESS_1_PLACEHOLDER' | translate\" />\n        </pioneer-form-input>\n      </div>\n    </div>\n    <div class=\"row\">\n      <div class=\"form-container party-address\">\n        <pioneer-form-input label=\"EVENT.PROPERTY.POPUP.ADD.ADDRESS_2\">\n          <input type=\"text\" class=\"form-control\" formControlName=\"address2\" maxlength=\"50\"\n            [attr.placeholder]=\"'EVENT.PROPERTY.POPUP.ADD.ADDRESS_2_PLACEHOLDER' | translate\" />\n        </pioneer-form-input>\n      </div>\n      <div class=\"form-container party-address\">\n        <pioneer-form-input label=\"EVENT.PROPERTY.POPUP.ADD.ADDRESS_3\">\n          <input type=\"text\" class=\"form-control\" formControlName=\"address3\" maxlength=\"50\"\n            [attr.placeholder]=\"'EVENT.PROPERTY.POPUP.ADD.ADDRESS_3_PLACEHOLDER' | translate\" />\n        </pioneer-form-input>\n      </div>\n    </div>\n    <div class=\"row\">\n      <div class=\"form-container party-city form-required\">\n        <pioneer-form-input label=\"EVENT.PROPERTY.POPUP.ADD.CITY\">\n          <input type=\"text\" class=\"form-control\" formControlName=\"city\"\n            maxlength=\"50\"\n            [attr.placeholder]=\"'EVENT.PROPERTY.POPUP.ADD.CITY_PLACEHOLDER' | translate\" />\n        </pioneer-form-input>\n      </div>\n      <div class=\"form-container party-state-zip\">\n        <div class=\"row\">\n          <div *ngIf=\"showState\" class=\"form-container form-group party-state form-required\">\n            <pioneer-form-input label=\"EVENT.PROPERTY.POPUP.ADD.STATE\">\n              <select formControlName=\"stateProvinceCode\" class=\"form-control form-control-sm\">\n                <option [ngValue]=\"null\">{{ 'EVENT.PROPERTY.POPUP.ADD.STATE_PLACEHOLDER' | translate }}</option>\n                <option *ngFor=\"let option of (states$ | async)\" [ngValue]=\"option.key\">{{ option.value }}</option>\n              </select>\n              <div class=\"validation-messages\">\n                <pioneer-validation-message error=\"country_state_cross_error\" message=\"MESSAGES.VALIDATION.COUNTRY_STATE_CROSS_ERROR\">\n                </pioneer-validation-message>\n              </div>\n            </pioneer-form-input>\n          </div>\n          <div *ngIf=\"showPostalCode\" class=\"party-zip form-group form-required\">\n            <pioneer-form-input label=\"EVENT.PROPERTY.POPUP.ADD.POSTAL_CODE\">\n              <input type=\"text\" class=\"form-control\" formControlName=\"postalCode\" maxlength=\"15\"\n                [attr.placeholder]=\"'EVENT.PROPERTY.POPUP.ADD.POSTAL_CODE_PLACEHOLDER' | translate\" />\n              <div class=\"validation-messages\">\n                <pioneer-validation-message error=\"postal_code_country_cross_error\"\n                  message=\"MESSAGES.VALIDATION.POSTAL_CODE_COUNTRY_CROSS_ERROR\">\n                </pioneer-validation-message>\n              </div>\n            </pioneer-form-input>\n          </div>\n        </div>\n      </div>\n    </div>\n    <div class=\"row\">\n      <div class=\"form-container contact-name-first\">\n        <pioneer-form-input label=\"EVENT.PROPERTY.POPUP.ADD.FIRST_NAME\">\n          <input type=\"text\" class=\"form-control\" formControlName=\"contactFirstNm\"\n            maxlength=\"50\"\n            [attr.placeholder]=\"'EVENT.PROPERTY.POPUP.ADD.FIRST_NAME_PLACEHOLDER' | translate\" />\n        </pioneer-form-input>\n      </div>\n      <div class=\"form-container contact-name-last\">\n        <pioneer-form-input label=\"EVENT.PROPERTY.POPUP.ADD.LAST_NAME\">\n          <input type=\"text\" class=\"form-control\" formControlName=\"contactLastNm\"\n            maxlength=\"50\"\n            [attr.placeholder]=\"'EVENT.PROPERTY.POPUP.ADD.LAST_NAME_PLACEHOLDER' | translate\" />\n        </pioneer-form-input>\n      </div>\n    </div>\n    <div class=\"row\">\n      <div class=\"form-container form-group contact-email form-required\">\n        <pioneer-form-input label=\"EVENT.PROPERTY.POPUP.ADD.EMAIL\">\n          <input type=\"email\" class=\"form-control\" formControlName=\"email\"\n            maxlength=\"75\"\n            [attr.placeholder]=\"'EVENT.PROPERTY.POPUP.ADD.EMAIL_PLACEHOLDER' | translate\"\n            pioneerLowercase />\n        </pioneer-form-input>\n      </div>\n      <div class=\"form-container contact-tel\">\n        <div class=\"row\">\n          <div class=\"form-container contact-phone\">\n            <pioneer-form-input label=\"EVENT.PROPERTY.POPUP.ADD.PHONE\">\n              <input type=\"tel\" class=\"form-control\" formControlName=\"phoneNr\"\n                maxlength=\"20\"\n                [attr.placeholder]=\"'EVENT.PROPERTY.POPUP.ADD.PHONE_PLACEHOLDER' | translate\" />\n            </pioneer-form-input>\n          </div>\n          <div class=\"form-container contact-fax\">\n            <pioneer-form-input label=\"EVENT.PROPERTY.POPUP.ADD.FAX\">\n              <input type=\"tel\" class=\"form-control\" formControlName=\"faxNr\"\n                maxlength=\"20\"\n                [attr.placeholder]=\"'EVENT.PROPERTY.POPUP.ADD.FAX_PLACEHOLDER' | translate\" />\n            </pioneer-form-input>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n  <!-- FORM END -->\n</div>\n<div class=\"modal-footer\">\n  <button type=\"button\" class=\"btn btn-link\" data-dismiss=\"modal\" (click)=\"cancel()\"\n    data-se-id=\"cancelPropertyPopup\">{{ 'COMMON.BUTTON.CANCEL' | translate}}</button>\n  <button type=\"button\" class=\"btn btn-primary\" [disabled]=\"!propertyForm.valid\" (click)=\"accept()\"\n    data-se-id=\"acceptPropertyPopup\">{{ 'COMMON.BUTTON.SAVE' | translate }}</button>\n</div>\n"

/***/ }),

/***/ "21j7":
/***/ (function(module, exports) {

module.exports = "<pioneer-confirmation-modal\n  data-se-id=\"add-payment-confirmation-modal\"\n  content=\"MESSAGES.CONFIRMATION.PROCEED\"\n  cancel=\"COMMON.BUTTON.CANCEL\"\n  [confirm]=\"confirmationModalConfig.confirm\"\n  [title]=\"confirmationModalConfig.title\"\n  (closed)=\"confirmBeforeBulkActionHandler($event)\">\n</pioneer-confirmation-modal>\n\n<div class=\"modal fade\" bsModal [config]=\"config\" role=\"dialog\" tabindex=\"-1\" dataSeId=\"bulk-action-modal\">\n  <div *ngIf=\"!noEventsFound && !bulkActionInProcess\" class=\"modal-dialog modal-xl\">\n    <div class=\"modal-content\">\n      <div class=\"modal-header\">\n        <h5 class=\"modal-title\">{{ \"EVENTS.BULK_ACTION.TITLE\" | translate }} - {{'EVENTS.BULK_ACTION.' + bulkAction | translate}}</h5>\n        <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\" (click)=\"onCancel()\">\n          <span aria-hidden=\"true\">&times;</span>\n        </button>\n      </div>\n\n      <div class=\"modal-body\">\n        <div class=\"ooiv\" *ngIf=\"bulkAction === BulkAction.PAYMENT_REQUEST\">{{ \"EVENTS.BULK_ACTION.OOIV_RESTRICTION\" | translate }}<br><br></div>\n\n        <h4 class=\"card-title\">\n          {{ 'EVENTS.RESULTS_RETURNED' | translate: eventCountForTranslate }}\n        </h4>\n        <div class=\"table-responsive\">\n\n          <table class=\"table\">\n            <thead>\n            <tr>\n              <th>\n                <input type=\"checkbox\" id=\"select-all-events\" [(ngModel)]=\"allEventsChecked\" (change)=\"checkUncheckAll()\">\n              </th>\n              <th>\n                {{ 'EVENTS.EVENT_NAME' | translate }}\n              </th>\n              <th>\n                {{ 'EVENTS.MEETING_ID' | translate }}\n              </th>\n              <th>\n                {{ 'EVENTS.BULK_ACTION.START_DATE' | translate }}\n              </th>\n              <th>\n                {{ 'EVENTS.BULK_ACTION.END_DATE' | translate }}\n              </th>\n              <th>\n                {{ 'EVENTS.BULK_ACTION.VENDOR_NAME' | translate }}\n              </th>\n              <th *ngIf=\"bulkAction === BulkAction.PAYMENT_REQUEST\">\n                {{ 'EVENTS.BULK_ACTION.PAYMENT_AMOUNT' | translate }}\n              </th>\n              <th *ngIf=\"bulkAction === BulkAction.PAYMENT_REQUEST\">\n                {{ 'EVENTS.BULK_ACTION.MASTER_BILL' | translate }}\n              </th>\n              <th *ngIf=\"bulkAction === BulkAction.PAID_DIRECT\">\n                {{ 'EVENTS.BULK_ACTION.AMOUNT_RECEIVED' | translate }}\n              </th>\n            </tr>\n            </thead>\n\n            <tbody>\n              <tr *ngFor=\"let eventVendor of eventVendorSummaryList\">\n                <td><input type=\"checkbox\" id=\"{{ eventVendor.eventId }}\" [(ngModel)]=\"eventVendor.isSelected\" value=\"{{eventVendor.eventId}}\" (change)=\"isAllSelected()\"></td>\n                <td data-se-id=\"name\">\n                  <span *ngIf=\"eventVendor.autoGenerated\"\n                        class=\"tooltip-hint\"\n                        [tooltip]=\"'EVENTS.AUTO_GENERATED_TOOLTIP' | translate\"\n                        placement=\"right\">\n                    {{getEventNameLine1(eventVendor.name)}}\n                  </span>\n                  <span *ngIf=\"eventVendor.autoGenerated && getEventNameLine2(eventVendor.name)\"\n                                  class=\"tooltip-hint\"\n                                  [tooltip]=\"'EVENTS.AUTO_GENERATED_TOOLTIP' | translate\"\n                                  placement=\"right\">\n                    <br>{{getEventNameLine2(eventVendor.name)}}\n                  </span>\n                  <span *ngIf=\"!eventVendor.autoGenerated\">\n                    {{getEventNameLine1(eventVendor.name)}}\n                  </span>\n                  <span *ngIf=\"!eventVendor.autoGenerated && getEventNameLine2(eventVendor.name)\">\n                    <br>{{getEventNameLine2(eventVendor.name)}}\n                  </span>\n\n                </td>\n                <td data-se-id=\"eventReferenceNumber\">{{ eventVendor.eventReferenceNumber}}</td>\n                <td data-se-id=\"startDate\">{{ eventVendor.startDate | localeDateFormat }}</td>\n                <td data-se-id=\"endDate\">{{ eventVendor.endDate | localeDateFormat }}</td>\n                <td data-se-id=\"propertyName\">{{eventVendor.vendorName}}</td>\n                <td *ngIf=\"bulkAction === BulkAction.PAYMENT_REQUEST\" data-se-id=\"totalPayAmount\" class=\"text-right\">\n                    {{ eventVendor.dueAmount }} {{ eventVendor.currency }}\n                </td>\n\n                <td *ngIf=\"bulkAction === BulkAction.PAYMENT_REQUEST\" data-se-id=\"masterBill\">\n                  {{ eventVendor.masterBillPaid | masterBill }}\n                </td>\n                <td *ngIf=\"bulkAction === BulkAction.PAID_DIRECT\" data-se-id=\"amountReceived\">\n                  <div class=\"col-md-8 form-container\">\n                    <div class=\"form-group\">\n                       <div class=\"input-group\">\n                        <input type=\"number\" class=\"form-control\" data-se-id=\"adjustmentAmount\"\n                               placeholder=\"{{ 'EVENT.ADJUSTMENT.AMOUNT_FIELD_PLACEHOLDER' | translate }}\" min=\"1\"\n                               [readonly]=\"!eventVendor.isSelected\"\n                               [(ngModel)]=\"eventVendor.paymentAmount\"/>\n                        <div *ngIf=\"eventVendor.currency\" class=\"input-group-addon\">\n                          <span class=\"input-group-text\">{{ eventVendor.currency | uppercase }}</span>\n                        </div>\n                      </div>\n                    </div>\n                  </div>\n                </td>\n              </tr>\n            </tbody>\n\n          </table>\n        </div>\n      </div>\n\n      <div class=\"modal-footer\">\n        <div class=\"button-bar\">\n          <a routerLink=\".\" class=\"btn btn-link\" (click)=\"onCancel()\" data-se-id=\"cancelButton\">\n            {{'COMMON.BUTTON.CANCEL' | translate}}\n          </a>\n          <button type=\"button\" class=\"btn btn-primary\" [disabled]=\"disableBulkActionButton()\" (click)=\"confirmBeforeBulkAction()\" data-se-id=\"bulkActionButton\">\n            {{'EVENTS.BULK_ACTION.' + bulkAction | translate}}\n          </button>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div *ngIf=\"noEventsFound && !bulkActionInProcess\" class=\"modal-dialog\" role=\"document\">\n    <div class=\"modal-content\">\n      <div class=\"modal-body\">\n        <p data-se-id=\"content\">{{ 'EVENTS.BULK_ACTION.NO_EVENTS_ELIGIBLE' |translate }}</p>\n        <p class=\"ooiv\" *ngIf=\"bulkAction === BulkAction.PAYMENT_REQUEST\">{{ 'EVENTS.BULK_ACTION.OOIV_RESTRICTION_NO_DATA' |translate }}</p>\n        <div class=\"button-bar\">\n          <button data-se-id=\"confirmation-modal-confirm\" type=\"button\" class=\"btn btn-primary btn-sm\"\n                  (click)=\"onCancel()\">{{ 'EVENTS.BULK_ACTION.OK' | translate }}\n          </button>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div *ngIf=\"bulkActionInProcess\" class=\"modal-dialog modal-xl\" role=\"document\">\n    <div class=\"modal-content\">\n      <div class=\"modal-header\">\n        <h5 class=\"modal-title\">{{ \"EVENTS.BULK_ACTION.TITLE\" | translate }} - {{'EVENTS.BULK_ACTION.' + bulkAction | translate}}</h5>\n        <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\" (click)=\"onCancel()\">\n          <span aria-hidden=\"true\">&times;</span>\n        </button>\n      </div>\n      <div class=\"modal-body\">\n        <p data-se-id=\"content\" [innerHTML]=\"bulkActionInfo\"></p>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),

/***/ "32Uq":
/***/ (function(module, exports) {

module.exports = "<div class=\"content-container\">\n  <div class=\"row\">\n    <div class=\"card-content\" *ngIf=\"showTotalSummary()\">\n\n      <pioneer-vendor-header-summary [event]=\"onyxEvent\"\n                                     [title]=\"'EVENT.OVERVIEW_CARDS.SUMMARY_TITLE' | translate\"\n                                     [type]=\"headerRecordType\"\n                                     [total]=\"total\">\n      </pioneer-vendor-header-summary>\n\n    </div>\n  </div>\n</div>\n\n<div class=\"content-container\">\n  <div class=\"row\">\n    <div class=\"card-content\">\n\n      <ng-container *ngFor=\"let party of getEventProperties()\">\n        <pioneer-vendor-overview-card\n          [vendors]=\"getEventProperties()\"\n          [vendor]=\"party\">\n        </pioneer-vendor-overview-card>\n      </ng-container>\n\n    </div>\n  </div>\n</div>\n"

/***/ }),

/***/ "3EoA":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("rP7Y")(true);
// imports


// module
exports.push([module.i, ".field{padding-bottom:0;--tw-bg-opacity:1}@media (min-width:640px){.field{-ms-grid-columns:25% 75%;grid-template-columns:25% 75%;display:-ms-grid;display:grid;gap:1rem;width:100%;padding-bottom:.5rem}}dt{color:rgb(17 24 39/var(--tw-text-opacity))}dd,dt{--tw-text-opacity:1;font-size:small;line-height:1.25rem}dd{color:rgb(107 114 128/var(--tw-text-opacity));font-weight:500}dd,dl{margin:0}.modal-body{padding-right:60px;padding-left:60px}.dd-bordered{border-width:0 3px 0 0!important;border-color:inherit!important;border-style:solid}.space-between{display:-ms-flexbox;display:flex;-ms-flex-flow:row;flex-flow:row;-ms-flex-pack:justify;justify-content:space-between}#left{float:left}#left,#right{width:45%;background:#fff}#right{float:right}#events-block{position:relative;background:#fff;width:100%;padding:10px;display:inline-block}.divider{position:absolute;left:50%;top:0;bottom:0;border-left:2px solid gray}", "", {"version":3,"sources":["/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/event-collision-modal-multiprompt/event-collision-modal-multiprompt.component.css"],"names":[],"mappings":"AAAA,OACE,iBAAqB,iBACF,CAEpB,yBAGC,OACE,yBAAA,8BAA+B,iBAC/B,aAAc,SACJ,WACE,oBACW,CACxB,CACF,GAIC,0CAA8C,CAG/C,MAJC,oBAAqB,gBAEJ,mBACI,CAGvB,GAEE,8CAAiD,eAChC,CAGlB,MAGC,QAAU,CACX,YAGC,mBAAoB,iBACD,CACpB,aAGC,iCAAwC,+BACP,kBACb,CACrB,eAGC,oBAAA,aAAc,kBACd,cAAe,sBACf,6BAA+B,CAChC,MAIC,UAAY,CAEb,aAHC,UAAW,eAEO,CAGpB,OAEE,WAAa,CAEd,cAGC,kBAAmB,gBACD,WACN,aACE,oBACQ,CACvB,SAEC,kBAAmB,SACT,MACF,SACG,0BACiB,CAC7B","file":"event-collision-modal-multiprompt.component.css","sourcesContent":[".field {\n  padding-bottom: 0rem;\n  --tw-bg-opacity: 1;\n  /* background-color: rgb(249 250 251 / var(--tw-bg-opacity)); */\n}\n\n@media (min-width: 640px){\n  .field {\n    grid-template-columns: 25% 75%;\n    display: grid;\n    gap: 1rem;\n    width: 100%;\n    padding-bottom: 0.5rem;\n  }\n}\n\ndt {\n  --tw-text-opacity: 1;\n  color: rgb(17 24 39 / var(--tw-text-opacity));\n  font-size: small;\n  line-height: 1.25rem;\n}\n\ndd {\n  --tw-text-opacity: 1;\n  color: rgb(107 114 128 / var(--tw-text-opacity));\n  font-weight: 500;\n  font-size: small;\n  line-height: 1.25rem;\n}\n\ndd, dl {\n  margin: 0;\n}\n\n.modal-body{\n  padding-right: 60px;\n  padding-left: 60px;\n}\n\n.dd-bordered {\n  border-width: 0px 3px 0px 0px!important;\n  border-color: inherit !important;\n  border-style: solid;\n}\n\n.space-between {\n  display: flex;\n  flex-flow: row;\n  justify-content: space-between;\n}\n\n#left {\n  width: 45%;\n  float: left;\n  background: white;\n}\n\n#right {\n  width: 45%;\n  float: right;\n  background: white;\n}\n\n#events-block {\n  position: relative;\n  background: white;\n  width: 100%;\n  padding: 10px;\n  display: inline-block;\n}\n.divider{\n  position: absolute;\n  left: 50%;\n  top: 0%;\n  bottom: 0%;\n  border-left: 2px solid gray;\n}"],"sourceRoot":""}]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),

/***/ "3Ng8":
/***/ (function(module, exports) {

module.exports = "<div class=\"card\" [formGroup]=\"contactLookupForm\" id=\"card-agency\">\n  <div class=\"card-header\">\n    {{ 'EVENT.AGENCY.CARD_TITLE' | translate }}\n  </div>\n  <div class=\"card-block\">\n    <div class=\"col-12\">\n      <pioneer-inline-search-component *ngIf=\"isAgencyInlineSearchVisible() && (canChangeAgency$ | async) === true\" (results)=\"updateResults($event)\" [lookupStore]=\"agencyStore\"\n        [placeholderText]=\"'EVENT.AGENCY.SEARCH_PLACEHOLDER'\" [disabled]=\"!isAgencyInlineSearchEnabled()\" (blur)=\"inlineSearchTouched()\" >\n        <ul class=\"dropdown-menu\">\n          <li class=\"dropdown-item\"\n              *ngFor=\"let searchAgency of summaryResults\"\n              (mousedown)=\"onSelectedAgency(searchAgency)\"\n              data-se-id=\"agency-lookup-result\">\n            <p *ngIf=\"!searchAgency.agencyAlias || searchAgency.agencyAlias.length === 0\" class=\"prop-name\">{{searchAgency.name}}</p>\n            <p *ngIf=\"searchAgency.agencyAlias && searchAgency.agencyAlias.length !== 0\" class=\"prop-name\">{{searchAgency.agencyAlias}}</p>\n            <div *ngIf=\"searchAgency.address\" class=\"prop-info\">\n              <p class=\"addr\" data-se-id=\"agency-lookup-address-line1\">{{searchAgency.address.line1}}</p>\n              <p class=\"addr\">\n                {{searchAgency.address.city}}, {{searchAgency.address.state}} {{searchAgency.address.countryCode}}\n              </p>\n              <p class=\"pid\">Agency ID: {{searchAgency.agencyId}}</p>\n            </div>\n          </li>\n          <li *ngIf=\"(!summaryResults || summaryResults.length === 0) && !isCreateNewAgencyEnabled()\" class=\"dropdown-item\">\n            {{ 'COMMON.NO_RESULTS_FOUND' | translate }}\n          </li>\n          <li class=\"dropdown-item\" (mousedown)=\"startCreatingAgency()\" *ngIf=\"isCreateNewAgencyEnabled()\">\n            <a href=\"javascript:void(0)\" data-se-id=\"addNewAgencyButton\">+ {{ 'EVENT.AGENCY.ADD_NEW_AGENCY_BUTTON' | translate }}</a>\n          </li>\n        </ul>\n      </pioneer-inline-search-component>\n    </div>\n\n    <!-- warning message -->\n    <div *ngIf=\"uiShowManualAgencyWarningMessage()\" class=\"row\">\n      <div class=\"form-container mx-auto\">\n        <div class=\"row\">\n          <div class=\"col form-container col-md-12\">\n            <div class=\"form-group\">\n              <p class=\"lead\">\n                {{ 'EVENT.AGENCY.MEMBER_MESSAGE' | translate }}\n              </p>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n\n    <div [formGroup]=\"contactLookupForm\" *ngIf=\"newTravelAgency || isAgencySelected\" data-se-id=\"agencyForm\">\n      <div class=\"row\">\n        <div class=\"form-container party-name\" [ngClass]=\"{ 'form-required': newTravelAgency }\">\n          <div class=\"form-group\">\n            <pioneer-form-input label=\"EVENT.AGENCY.COMPANY_NAME\">\n              <input type=\"text\" class=\"form-control\" formControlName=\"name\" maxlength=\"50\" [attr.placeholder]=\"newTravelAgency ? ('EVENT.AGENCY.COMPANY_NAME_PLACEHOLDER' | translate) : ''\"\n                [readonly]=\"!isEditableOnlyManuallyAdded()\" data-se-id=\"name\"/>\n            </pioneer-form-input>\n          </div>\n        </div>\n        <div class=\"form-container party-name\">\n          <div class=\"form-group\">\n            <pioneer-form-input label=\"EVENT.AGENCY.DOING_BUSINESS_AS\">\n              <input type=\"text\" class=\"form-control\" formControlName=\"dbaName\" maxlength=\"50\" [attr.placeholder]=\"newTravelAgency ? ('EVENT.AGENCY.DOING_BUSINESS_AS_PLACEHOLDER' | translate) : ''\"\n                [readonly]=\"!isEditableOnlyManuallyAdded()\" data-se-id=\"dbaName\"/>\n            </pioneer-form-input>\n          </div>\n        </div>\n      </div>\n      <div class=\"row\">\n        <div class=\"col form-container party-name\" [ngClass]=\"{ 'form-required': newTravelAgency }\">\n          <div class=\"form-group\">\n            <pioneer-form-input label=\"EVENT.AGENCY.COUNTRY\">\n              <input *ngIf=\"!isEditableNonSubscriber(); else selectCountry\" type=\"text\" class=\"form-control\" formControlName=\"countryName\" [readonly]=\"true\" [value]=\"(selectedCountry$ | async)?.value\" />\n              <ng-template #selectCountry>\n                <select formControlName=\"countryCode\" (change)=\"onCountryCodeChanged()\" class=\"form-control form-control-sm\" data-se-id=\"countryCode\">\n                  <option [ngValue]=\"null\">{{ 'EVENT.AGENCY.COUNTRY_PLACEHOLDER' | translate }}</option>\n                  <option *ngFor=\"let option of (commonDataStore.countries | async)\" [ngValue]=\"option.key\">{{ option.value }}</option>\n                </select>\n              </ng-template>\n            </pioneer-form-input>\n          </div>\n        </div>\n        <div class=\"col form-container\">\n          <pioneer-form-input label=\"EVENT.AGENCY.AGENCY_ID\">\n            <span *ngIf=\"uiShowSystemGeneratedBadge()\" class=\"badge badge-warning\">{{ 'EVENT.AGENCY.AGENCY_ID_SYSTEM_GENERATED' | translate }}</span>\n            <input type=\"text\" pioneerUppercase class=\"form-control\" formControlName=\"code\" maxlength=\"8\" [readonly]=\"!newTravelAgency\" data-se-id=\"code\"/>\n          </pioneer-form-input>\n        </div>\n      </div>\n      <div class=\"row\">\n        <div class=\"col form-container\">\n          <div class=\"form-group\" [ngClass]=\"{ 'form-required': newTravelAgency }\">\n            <pioneer-form-input label=\"EVENT.AGENCY.ADDRESS\">\n              <input type=\"text\" class=\"form-control\" formControlName=\"line1\" maxlength=\"50\" [attr.placeholder]=\"newTravelAgency ? ('EVENT.AGENCY.ADDRESS_PLACEHOLDER' | translate) : ''\"\n                     [readonly]=\"!isEditableNonSubscriber()\" data-se-id=\"line1\"/>\n            </pioneer-form-input>\n          </div>\n        </div>\n      </div>\n      <div class=\"row\">\n        <div class=\"form-container party-name\">\n          <pioneer-form-input label=\"EVENT.AGENCY.ADDRESS_2\">\n            <input type=\"text\" class=\"form-control\" formControlName=\"line2\" maxlength=\"50\" [attr.placeholder]=\"newTravelAgency ? ('EVENT.AGENCY.ADDRESS_2_PLACEHOLDER' | translate) : ''\"\n                   [readonly]=\"!isEditableNonSubscriber()\" data-se-id=\"line2\"/>\n          </pioneer-form-input>\n        </div>\n        <div class=\"form-container party-name\">\n          <pioneer-form-input label=\"EVENT.AGENCY.ADDRESS_3\">\n            <input type=\"text\" class=\"form-control\" formControlName=\"line3\" maxlength=\"50\" [attr.placeholder]=\"newTravelAgency ? ('EVENT.AGENCY.ADDRESS_3_PLACEHOLDER' | translate) : ''\"\n                   [readonly]=\"!isEditableNonSubscriber()\" data-se-id=\"line3\"/>\n          </pioneer-form-input>\n        </div>\n      </div>\n      <div class=\"row from-group\">\n        <div class=\"form-container party-city\" [ngClass]=\"{ 'form-required': newTravelAgency }\">\n          <div class=\"form-group\">\n            <pioneer-form-input label=\"EVENT.AGENCY.CITY\">\n              <input type=\"text\" class=\"form-control\" formControlName=\"city\" maxlength=\"50\" [attr.placeholder]=\"newTravelAgency ? ('EVENT.AGENCY.CITY_PLACEHOLDER' | translate) : ''\"\n                     [readonly]=\"!isEditableNonSubscriber()\" data-se-id=\"city\"/>\n            </pioneer-form-input>\n          </div>\n        </div>\n        <div class=\"row form-container party-state-zip\">\n          <div class=\"party-state\" [ngClass]=\"{ 'form-required': newTravelAgency && isStateRequired(contactLookupForm, 'countryCode') }\">\n            <div class=\"form-group\">\n              <pioneer-form-input label=\"EVENT.AGENCY.STATE\">\n                <input *ngIf=\"!isEditableNonSubscriber(); else selectState\" type=\"text\" class=\"form-control\" formControlName=\"stateName\" [readonly]=\"true\" [value]=\"(selectedState$ | async)?.value\" />\n                <ng-template #selectState>\n                  <select *ngIf=\"isEditableNonSubscriber()\" formControlName=\"state\" class=\"form-control form-control-sm\" data-se-id=\"state\">\n                    <option [ngValue]=\"null\">{{ 'EVENT.AGENCY.STATE_PLACEHOLDER' | translate }}</option>\n                    <option *ngFor=\"let option of (states$ | async)\" [ngValue]=\"option.key\">{{ option.value }}</option>\n                  </select>\n                  <div class=\"validation-messages\">\n                    <pioneer-validation-message error=\"country_state_cross_error\" message=\"MESSAGES.VALIDATION.COUNTRY_STATE_CROSS_ERROR\">\n                    </pioneer-validation-message>\n                  </div>\n                </ng-template>\n              </pioneer-form-input>\n            </div>\n          </div>\n          <div class=\"party-zip\" [ngClass]=\"{ 'form-required': newTravelAgency && isPostalCodeRequired(contactLookupForm, 'countryCode') }\">\n            <div class=\"form-group\">\n              <pioneer-form-input label=\"EVENT.AGENCY.POSTAL_CODE\">\n                <input type=\"text\" class=\"form-control\" formControlName=\"postalCode\" maxlength=\"15\" [attr.placeholder]=\"newTravelAgency ? ('EVENT.AGENCY.POSTAL_CODE_PLACEHOLDER' | translate) : ''\"\n                       [readonly]=\"!isEditableNonSubscriber()\" data-se-id=\"postalCode\"/>\n                <div class=\"validation-messages\">\n                  <pioneer-validation-message error=\"postal_code_country_cross_error\" message=\"MESSAGES.VALIDATION.POSTAL_CODE_COUNTRY_CROSS_ERROR\">\n                  </pioneer-validation-message>\n                </div>\n              </pioneer-form-input>\n            </div>\n          </div>\n        </div>\n      </div>\n      <div [formGroup]=\"contactLookupForm.controls.contact\">\n        <div class=\"row\">\n          <div class=\"form-container contact-name-first\">\n            <pioneer-form-input label=\"EVENT.AGENCY.FIRST_NAME\">\n              <input type=\"text\"\n                class=\"form-control\"\n                formControlName=\"firstName\"\n                maxlength=\"50\"\n                [attr.placeholder]=\"newTravelAgency ? ('EVENT.AGENCY.FIRST_NAME_PLACEHOLDER' | translate) : ''\"\n                [readonly]=\"isReadOnly\"\n                data-se-id=\"firstName\"/>\n            </pioneer-form-input>\n          </div>\n          <div class=\"form-container contact-name-last\">\n            <pioneer-form-input label=\"EVENT.AGENCY.LAST_NAME\">\n              <input type=\"text\"\n                class=\"form-control\"\n                formControlName=\"lastName\"\n                maxlength=\"50\"\n                [attr.placeholder]=\"newTravelAgency ? ('EVENT.AGENCY.LAST_NAME_PLACEHOLDER' | translate) : ''\"\n                [readonly]=\"isReadOnly\"\n                data-se-id=\"lastName\"/>\n            </pioneer-form-input>\n          </div>\n        </div>\n        <div class=\"row\">\n          <div class=\"form-container contact-email form-required\">\n            <div class=\"form-group form-required\">\n              <pioneer-form-input label=\"EVENT.AGENCY.EMAIL_ADDRESS\">\n                <input type=\"email\"\n                  class=\"form-control\"\n                  formControlName=\"email\"\n                  maxlength=\"75\"\n                  [attr.placeholder]=\"newTravelAgency ? ('EVENT.AGENCY.EMAIL_ADDRESS_PLACEHOLDER' | translate) : ''\"\n                  [readonly]=\"isReadOnly\"\n                  data-se-id=\"email\"\n                  pioneerLowercase />\n              </pioneer-form-input>\n            </div>\n          </div>\n          <div class=\"form-container contact-tel\">\n            <div class=\"row\">\n              <div class=\"form-container contact-phone\">\n                <pioneer-form-input label=\"EVENT.AGENCY.PHONE_NUMBER\">\n                  <input type=\"tel\"\n                    class=\"form-control\"\n                    formControlName=\"phone\"\n                    maxlength=\"20\"\n                    [attr.placeholder]=\"newTravelAgency ? ('EVENT.AGENCY.PHONE_NUMBER_PLACEHOLDER' | translate) : ''\"\n                    [readonly]=\"isReadOnly\"\n                    data-se-id=\"phone\"/>\n                </pioneer-form-input>\n              </div>\n              <div class=\"form-container contact-fax\">\n                <pioneer-form-input label=\"EVENT.AGENCY.FAX_NUMBER\">\n                  <input type=\"tel\"\n                    class=\"form-control\"\n                    formControlName=\"fax\"\n                    maxlength=\"20\"\n                    [attr.placeholder]=\"newTravelAgency ? ('EVENT.AGENCY.FAX_NUMBER_PLACEHOLDER' | translate) : ''\"\n                    [readonly]=\"isReadOnly\"\n                    data-se-id=\"fax\"/>\n                </pioneer-form-input>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),

/***/ "3XMG":
/***/ (function(module, exports) {

module.exports = "<div>\n    <div *ngIf=\"hasSearched && searchResults?.length > 0\" class=\"modal-header\">\n        <h5 class=\"modal-title col\">\n          {{ 'EVENT.PROPERTY.POPUP.SEARCH.RESULTS.RESULTS_NUMBER_DISPLAYED' | translate : {\n            first: getFirstPageItemNumber() + 1,\n            last: getLastPageItemNumber(),\n            total: getSize()}\n          }}\n        </h5>\n        <div *ngIf=\"maxResultsExceeded()\" class=\"col\">\n            <p class=\"form-text text-muted\">{{ 'EVENT.PROPERTY.POPUP.SEARCH.RESULTS.RESULTS_LIMIT_WARNING' | translate }}</p>\n            <p class=\"form-text text-muted\">{{ 'EVENT.PROPERTY.POPUP.SEARCH.RESULTS.REFINE_SEARCH_INFO' | translate }}</p>\n        </div>\n    </div>\n    <div *ngIf=\"hasSearched\" class=\"modal-body\">\n      <div *ngIf=\"searchResults?.length > 0\" class=\"table-responsive table-dropdown\">\n        <table class=\"table\">\n            <thead>\n                <tr>\n                    <th>\n                        {{ 'EVENT.PROPERTY.POPUP.SEARCH.RESULTS.NAME' | translate }}\n                        <span class=\"text-caption text-nowrap\">{{ 'EVENT.PROPERTY.POPUP.SEARCH.RESULTS.ID' | translate }}</span>\n                    </th>\n                    <th>\n                        {{ 'EVENT.PROPERTY.POPUP.SEARCH.RESULTS.ADDRESS_1' | translate }}\n                        <span class=\"text-caption text-nowrap\">{{ 'EVENT.PROPERTY.POPUP.SEARCH.RESULTS.ADDRESS_2' | translate }} / {{ 'EVENT.PROPERTY.POPUP.SEARCH.RESULTS.ADDRESS_3' | translate }}</span>\n                    </th>\n                    <th>\n                        {{ 'EVENT.PROPERTY.POPUP.SEARCH.RESULTS.CITY' | translate }} / {{ 'EVENT.PROPERTY.POPUP.SEARCH.RESULTS.STATE' | translate }}\n                        <span class=\"text-caption text-nowrap\">{{ 'EVENT.PROPERTY.POPUP.SEARCH.RESULTS.POSTAL_CODE' | translate }}</span>\n                    </th>\n                    <th>{{ 'EVENT.PROPERTY.POPUP.SEARCH.RESULTS.COUNTRY' | translate }}</th>\n                </tr>\n            </thead>\n            <tbody>\n                <tr *ngFor=\"let property of searchResults | slice: getFirstPageItemNumber() : getLastPageItemNumber()\"\n                    (click)=\"selectProperty(property)\">\n                    <td>\n                        <span>{{ property.name }}</span>\n                        <span class=\"text-caption\">{{ property.propertyId }}</span>\n                        <span *ngIf=\"property.subscriber === true\" class=\"badge badge-success\">{{ 'COMMON.BADGE.GROUPPAY_SUBSCRIBER' | translate }}</span>\n                    </td>\n                    <td>\n                        <span>{{ property.address ? property.address.line1 : '' }}</span>\n                        <span class=\"text-caption\">{{ property.address ? property.address.line2 : '' }}</span>\n                        <span class=\"text-caption\">{{ property.address ? property.address.line3 : '' }}</span>\n                    </td>\n                    <td>\n                        <span>\n                            {{ property.address ? property.address.city : '' }}\n                            {{ property.address && property.address.city !== '' && property.address.state !== '' ? ', ' : '' }}\n                            {{ property.address ? property.address.state : '' }}\n                        </span>\n                        <span class=\"text-caption\">{{ property.address ? property.address.postalCode : '' }}</span>\n                    </td>\n                    <td><span>{{ property.address ? property.address.countryCode : '' }}</span></td>\n                </tr>\n            </tbody>\n        </table>\n    </div>\n    <div *ngIf=\"searchResults?.length === 0\" class=\"result-empty\">\n        <h3>{{ \"EVENT.PROPERTY.POPUP.SEARCH.RESULTS.NO_PROPERTIES_FOUND\" | translate }}</h3>\n        <figure class=\"figure\">\n            <i class=\"glyph-page figure-img\"></i>\n        </figure>\n    </div>\n    </div>\n    <div *ngIf=\"hasSearched || searchResults?.length > 0\" class=\"modal-footer\">\n        <div class=\"container\">\n            <div class=\"row justify-content-between\">\n                <ng-container *ngIf=\"hasSearched\">\n                    <div class=\"row\" *pioneerAuthorize=\"{permission: 'AddProperty'}\">\n                        <p class=\"col-xs form-text text-muted\">{{ 'EVENT.PROPERTY.ADD_NEW_PROPERTY_CAPTION' | translate }}</p>\n                        <a class=\"col form-text\" href=\"javascript:void(0)\" (click)=\"goToAddProperty()\">\n                            {{ 'EVENT.PROPERTY.ADD_NEW_PROPERTY_BUTTON' | translate }}\n                        </a>\n                    </div>\n                </ng-container>\n                <div *ngIf=\"searchResults?.length > 0\" class=\"row align-items-baseline\">\n                    <span class=\"col-md small\">\n                        {{ 'COMMON.PAGINATION.RESULTS_INFO' | translate : {\n                                first: getFirstPageItemNumber() + 1,\n                                last: getLastPageItemNumber(),\n                                total: searchResults.length\n                            }\n                        }}\n                    </span>\n                    <pagination class=\"col-xs\"\n                                [directionLinks]=\"true\"\n                                [boundaryLinks]=\"true\"\n                                [totalItems]=\"totalItems\"\n                                [maxSize]=\"itemsPerPage\"\n                                [(ngModel)]=\"currentPage\"\n                                previousText=\"&lsaquo;\"\n                                nextText=\"&rsaquo;\"\n                                firstText=\"&laquo;\"\n                                lastText=\"&raquo;\">\n                    </pagination>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),

/***/ "3XO/":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("rP7Y")(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"flash.messages.component.css","sourceRoot":""}]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),

/***/ "3aUR":
/***/ (function(module, exports) {

module.exports = "<div class=\"form-container pay-equation max-width-100\">\n  <div class=\"row\">\n    <div class=\"col form-container due-amount has-adjust\">\n      <div class=\"adjustment down\">\n        <!-- Room Commissions -->\n        <span class=\"currency\">\n          {{ paymentEquation?.roomCommissions | number:'1.2-2' }}\n          <span>{{ currency }}</span>\n        </span>\n        <span class=\"desc\">Room Commissions</span>\n\n        <!-- Adjustments -->\n        <ng-container *ngFor=\"let adjustment of paymentEquation?.adjustments\">\n          <span class=\"currency\" [ngClass]=\"adjustment.adjustmentAmount > 0 ? 'text-success' : 'text-warning'\">\n            {{ adjustment.adjustmentAmount | number:'1.2-2' }}\n            <span>{{ currency }}</span>\n          </span>\n          <span class=\"desc\">{{ adjustment.adjustmentType.description }} - {{ adjustment.description }}</span>\n        </ng-container>\n\n        <!-- Prepayment -->\n        <ng-container *ngIf=\"paymentEquation?.prepayment\">\n          <span class=\"currency text-warning\">\n            {{ -paymentEquation.prepayment.commissionAmount | number:'1.2-2' }}\n            <span>{{ currency }}</span>\n          </span>\n          <span class=\"desc\">{{ paymentEquation.prepayment.description }}</span>\n        </ng-container>\n      </div>\n\n      <div class=\"total\">\n        <span *ngIf=\"applyOoiv\" class=\"currency\">\n          * {{paymentEquation?.totalEstimatedTax | number:'1.2-2' }}\n          <span>{{ currency }}</span>\n        </span>\n        <span *ngIf=\"applyOoiv\" class=\"desc\"> {{ 'EVENT.COMMISSION.ESTIMATED_TAX' | translate }} </span>\n        <span class=\"currency\">\n          {{ (paymentEquation?.totalPaymentRequested + paymentEquation?.totalEstimatedTax) | number:'1.2-2' }}\n          <span>{{ currency }}</span>\n        </span>\n        <span *ngIf=\"isHotelApprover\" class=\"desc\">Total Payment Requested</span>\n        <span *ngIf=\"!isHotelApprover\" class=\"desc\">Total Payment Requested</span>\n        <span *ngIf=\"applyOoiv\" class=\"currency\"></span>\n        <span *ngIf=\"applyOoiv\" class=\"desc\" style=\"font-style: italic; font-size: 12px; padding-top: 10px;\">\n          {{ 'EVENT.COMMISSION.ESTIMATED_TAX_TEXT' | translate }}\n        </span>\n      </div>\n      <span *ngIf=\"showCurrencyNote\"\n            style=\"display: inline-block; border: 2px solid black; background-color: white; padding: 10px; font-size: 14px; margin-top: 20px;\">\n        <b style=\"font-weight: 800;\">{{ 'EVENT.COMMISSION.CURRENCY_NOTE_LABEL' | translate }}</b>{{ 'EVENT.COMMISSION.CURRENCY_NOTE_INFO' | translate }} {{fundCurrency}}\n      </span>\n    </div>\n  </div>\n</div>\n"

/***/ }),

/***/ "3cth":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("rP7Y")(true);
// imports


// module
exports.push([module.i, "*{margin:0;padding:0}.chart-panel{text-align:-webkit-center}.container{position:relative;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center}.banner{position:absolute}.chart-title{font-family:OpenSans-Bold,Open Sans Bold,Open Sans,sans-serif;font-weight:700;font-size:28px;margin-bottom:-5px}.chart-subtitle,.chart-title{opacity:.6;box-sizing:border-box;color:#292b2c;text-align:center;line-height:normal;place-content:center}.chart-subtitle{font-family:OpenSans-Regular,Open Sans,sans-serif;font-size:18px}svg{width:100%;height:100%;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center}.donut{transform-origin:center center;transition:.5s ease-in-out;stroke-dashoffset:0;cursor:pointer}.donut-disabled{cursor:default!important}.donut:hover{stroke-width:60}.color{height:15px;width:15px;border-radius:50%;display:inline-block}.bold{font-weight:700}table{width:inherit!important}td{padding-top:5px!important;padding-bottom:5px!important;border-style:none!important;white-space:nowrap!important;font-size:unquote(\"clamp(0.563rem, 0.346vw + 0.473rem, 0.75rem)\")}.table>tbody>tr:hover{background-color:#eef8ff;cursor:pointer}.tr-disabled{cursor:default!important}", "", {"version":3,"sources":["/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/agency-dashboard/status-chart/status-chart.component.css"],"names":[],"mappings":"AAAA,EACE,SAAU,SACC,CACZ,aAGC,yBAA2B,CAC5B,WAEC,kBAAmB,oBACnB,aAAc,qBACd,uBAAwB,sBACxB,kBAAoB,CACrB,QAGC,iBAAmB,CACpB,aAKC,8DAAwE,gBACvD,eAID,kBAEI,CACrB,6BAVC,WAAa,sBACU,cAGR,kBACI,mBACC,oBAEE,CAGxB,gBAGE,kDAAyD,cAIzC,CAEjB,IAEC,WAAY,YACC,oBACb,aAAc,qBACd,uBAAwB,sBACxB,kBAAoB,CACrB,OAGC,+BAAgC,2BACH,oBACR,cACL,CACjB,gBAGC,wBAA2B,CAC5B,aAGC,eAAiB,CAClB,OAGC,YAAa,WACD,kBACO,oBACG,CACvB,MAGC,eAAkB,CACnB,MAGC,uBAA0B,CAC3B,GAGC,0BAA4B,6BACG,4BACD,6BACC,iEACoC,CACpE,sBAGC,yBAA0B,cACV,CACjB,aAGC,wBAA2B,CAC5B","file":"status-chart.component.css","sourcesContent":["* {\n  margin: 0;\n  padding: 0;\n}\n\n.chart-panel {\n  text-align: -webkit-center;\n}\n.container {\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.banner {\n  position: absolute;\n}\n\n.chart-title {\n  opacity: 0.6;\n  box-sizing: border-box;\n  font-family: \"OpenSans-Bold\", \"Open Sans Bold\", \"Open Sans\", sans-serif;\n  font-weight: 700;\n  color: #292b2c;\n  text-align: center;\n  line-height: normal;\n  font-size: 28px;\n  place-content: center;\n  margin-bottom: -5px;\n}\n.chart-subtitle {\n  opacity: 0.6;\n  box-sizing: border-box;\n  font-family: \"OpenSans-Regular\", \"Open Sans\", sans-serif;\n  color: #292b2c;\n  text-align: center;\n  line-height: normal;\n  font-size: 18px;\n  place-content: center;\n}\nsvg {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.donut {\n  transform-origin: center center;\n  transition: 0.5s ease-in-out;\n  stroke-dashoffset: 0;\n  cursor: pointer;\n}\n\n.donut-disabled {\n  cursor: default !important;\n}\n\n.donut:hover {\n  stroke-width: 60;\n}\n\n.color {\n  height: 15px;\n  width: 15px;\n  border-radius: 50%;\n  display: inline-block;\n}\n\n.bold {\n  font-weight: bold;\n}\n\ntable {\n  width: inherit !important;\n}\n\ntd {\n  padding-top: 5px !important;\n  padding-bottom: 5px !important;\n  border-style: none !important;\n  white-space: nowrap !important;\n  font-size: unquote(\"clamp(0.563rem, 0.346vw + 0.473rem, 0.75rem)\");\n}\n\n.table > tbody > tr:hover {\n  background-color: #eef8ff;\n  cursor: pointer;\n}\n\n.tr-disabled {\n  cursor: default !important;\n}\n"],"sourceRoot":""}]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),

/***/ "3lFg":
/***/ (function(module, exports) {

module.exports = "<pioneer-confirmation-modal\n  #confirmWithdrawPaymentRequestModal\n  [title]=\"'EVENT.COMMISSION.WITHDRAW_PAYMENT_REQUEST_CONFIRM.TITLE'\"\n  [content]=\"'EVENT.COMMISSION.WITHDRAW_PAYMENT_REQUEST_CONFIRM.CONTENT'\"\n  [cancel]=\"'COMMON.BUTTON.CANCEL'\"\n  [confirm]=\"'EVENT.COMMISSION.WITHDRAW_PAYMENT_REQUEST_CONFIRM.CONFIRM_BUTTON'\"\n  (closed)=\"confirmWithdrawPaymentRequestHandler($event)\"\n  [action]=\"CONFIRM_ACTION\"\n  [customModal]=\"true\">\n</pioneer-confirmation-modal>\n\n<div class=\"card commission-card\" #cardWrapper>\n  <div class=\"card-header\" id=\"heading-{{vendor.chain}}-{{vendor.brand}}-{{vendor.propertyId}}\">\n    <div class=\"container\">\n      <div class=\"row justify-content-between\">\n        <div class=\"row justify-content-start\">\n          <span>\n            <a href=\"#!\" class=\"card-state-toggle no-text-decoration\" (click)=\"toggleCard($event)\">\n            <i class=\"far fa-fw {{isCardOpen ? 'fa-chevron-up' : 'fa-chevron-down'}}\"></i>\n            </a>\n            <ng-container *pioneerAuthorize=\"{permission: 'ViewGroupPayPropertyIndicators'}\">\n              <img *ngIf=\"vendor.subscriber\" src=\"{{imagesUrl}}/grouppay-logo-symbol.png\" width=\"22px\" height=\"22px\"\n                 tooltip=\"{{'EVENTS.PROPERTY_SUBSCRIBED_TOOLTIP' | translate }}\">\n            </ng-container>\n            &nbsp;{{ vendor.name}}&nbsp;{{(isVendorProperty() && validEventReferenceNumber()  ? (('EVENT.GROUP_CODE' | translate) + ':' + vendor.eventReferenceNumber) : '') }}&nbsp;\n          </span>\n          <span *ngIf=\"paymentSummary?.paymentStatus\" class=\"non-bold\">\n            {{ getPaymentStatus(paymentSummary?.paymentStatus) | paymentStatus }}\n          </span>\n          <span *ngIf=\"!paymentSummary?.paymentStatus\" class=\"no-payment\">\n            {{ 'PAYMENT_STATUS.READY_TO_INITIATE' | translate }}\n          </span>\n        </div>\n        <span class=\"non-bold\">\n          <a *ngIf=\"canWithdrawPaymentRequest()\" class=\"withdraw\" href=\"javascript:void(0)\" (click)=\"openWithDrawPaymentRequestModal()\">\n            {{ 'EVENT.COMMISSION.WITHDRAW_PAYMENT_REQUEST_BUTTON' | translate }}\n          </a>\n          <ng-container *ngIf=\"paymentSummary\">\n            {{ paymentSummary.calculatedPayment | number:'1.2-2' }} {{ onyxEvent.currency | uppercase }}\n          </ng-container>\n        </span>\n        <div *ngIf=\"!isReadOnly\" class=\"dropdown\">\n          <button class=\"btn btn-more\" data-toggle=\"dropdown\">\n            <i class=\"fas fa-ellipsis-h\"></i>\n          </button>\n          <ul class=\"dropdown-menu\">\n            <li role=\"menuitem\">\n              <a class=\"dropdown-item\" href=\"javascript:void(0)\" (click)=\"confirmBeforeDelete($event)\">\n                <i class=\"fal fa-trash-alt fa-fw\"></i>\n                {{ 'EVENT.PROPERTY.DELETE_VENDOR_BUTTON' | translate }}\n              </a>\n            </li>\n          </ul>\n        </div>\n      </div>\n    </div>\n  </div>\n\n  <div *ngIf=\"isCardOpen\">\n    <div class=\"card-block\">\n\n      <div class=\"button-bar\">\n        <ng-container *pioneerAuthorize=\"{permission: 'ExportReports'}\">\n          <div class=\"btn-group order-one\" *ngIf=\"ui.showDownloadDropdown\">\n            <button class=\"btn btn-primary dropdown-toggle\" data-toggle=\"dropdown\" data-se-id=\"download-reservation-summary-dropdown-button\">\n              {{ \"EVENT.COMMISSION.EXPORT_DROPDOWN\" | translate }}\n            </button>\n            <div class=\"dropdown-menu dropdown-menu-right\">\n              <button class=\"dropdown-item\"\n                      (click)=\"getPaymentsReport('excel')\"\n                      data-se-id=\"download-commission-excel-option\">\n                {{ \"COMMON.REPORT.EXPORT_EXCEL\" | translate }}\n              </button>\n              <button class=\"dropdown-item\"\n                      (click)=\"getPaymentsReport('pdf')\"\n                      data-se-id=\"download-commission-pdf-option\">\n                {{ \"EVENT.COMMISSION.EXPORT_PDF\" | translate }}\n              </button>\n            </div>\n          </div>\n        </ng-container>\n      </div>\n\n      <div [formGroup]=\"vendorForm\">\n        <div class=\"row\">\n          <div class=\"col form-container\">\n            <div class=\"form-group\">\n              <pioneer-form-input label=\"EVENT.COMMISSION.VENDOR_NAME\" [isReadOnly]=\"true\">\n                <input type=\"text\"\n                       class=\"form-control\"\n                       formControlName=\"vendorName\"\n                       maxlength=\"100\"\n                       data-se-id=\"vendorName\"\n                       [readonly]=\"true\"/>\n              </pioneer-form-input>\n            </div>\n          </div>\n          <div class=\"col form-container\">\n            <div class=\"form-group\">\n              <pioneer-form-input label=\"EVENT.COMMISSION.VENDOR_ID\" [isReadOnly]=\"true\">\n                <input type=\"text\" pioneerUppercase\n                       class=\"form-control\"\n                       formControlName=\"vendorId\"\n                       maxlength=\"20\"\n                       [readonly]=\"true\"\n                       data-se-id=\"vendorId\"/>\n              </pioneer-form-input>\n            </div>\n          </div>\n          <div class=\"col form-container\">\n            <div class=\"form-group\">\n              <pioneer-form-input label=\"EVENT.COMMISSION.VENDOR_TYPE\" [isReadOnly]=\"true\">\n                <input type=\"text\"\n                       class=\"form-control\"\n                       formControlName=\"vendorType\"\n                       maxlength=\"100\"\n                       data-se-id=\"vendorType\"\n                       [readonly]=\"true\"/>\n              </pioneer-form-input>\n            </div>\n          </div>\n          <div class=\"col form-container\">\n            <div class=\"form-group\">\n              <pioneer-form-input label=\"EVENT.COMMISSION.VENDOR_CURRENCY\" [isReadOnly]=\"true\">\n                <input type=\"text\" pioneerUppercase\n                       class=\"form-control\"\n                       formControlName=\"vendorCurrency\"\n                       maxlength=\"20\"\n                       [readonly]=\"true\"\n                       data-se-id=\"vendorCurrency\"/>\n              </pioneer-form-input>\n            </div>\n          </div>\n        </div>\n        <div class=\"row\">\n          <div class=\"col form-container\">\n            <div class=\"form-group\">\n              <pioneer-form-input label=\"EVENT.VENDOR_COMMISSION_RATE\" [isReadOnly]=\"true\">\n                <input type=\"number\"\n                       class=\"form-control\"\n                       formControlName=\"commissionRoomPercentage\"\n                       min=\"0\"\n                       max=\"100\"\n                       [readonly]=\"true\"/>\n              </pioneer-form-input>\n            </div>\n          </div>\n          <div class=\"col form-container\">\n            <label>&nbsp;</label>\n            <div class=\"form-group form-toggle\">\n              <div class=\"form-check center\">\n                <label class=\"custom-control custom-checkbox\">\n                  <input type=\"checkbox\" class=\"custom-control-input\"\n                         [checked]=\"vendor.commRetention\"\n                         formControlName=\"commRetention\"\n                         disabled=\"true\"\n                         data-se-id=\"commRetentionToggleCheckbox\"/>\n                  <span class=\"custom-control-indicator\"></span>\n                  <span class=\"custom-control-description\">{{ 'EVENT.COMMISSION.COMM_RETENTION' | translate }}</span>\n                </label>\n              </div>\n            </div>\n          </div>\n          <div class=\"col form-container\">\n          </div>\n          <div class=\"col form-container\">\n          </div>\n        </div>\n      </div>\n\n      <div class=\"button-bar\">\n\n        <ng-container *pioneerAuthorize=\"{permission: 'PayCommission'}\">\n          <p *ngIf=\"showPrepaymentHintText\" class=\"text-hint order-one\" data-se-id=\"prepaymentHintText\">\n            {{ 'EVENT.PREPAYMENT.PREPAYMENT_OPTION_MISSING_AGENCY' | translate }}\n          </p>\n          <button *ngIf=\"displayAddPrepaymentButton()\" class=\"btn btn-primary order-one\"\n                  (click)=\"displayPrepaymentClick()\"\n                  data-se-id=\"prepaymentButton\" [disabled]=\"!canMakePrepayment\">\n            {{ 'EVENT.PREPAYMENT.DISPLAY_PREPAYMENT_BUTTON' | translate }}\n          </button>\n        </ng-container>\n\n        <ng-container *pioneerAuthorize=\"{permission: 'AddAdjustment'}\">\n          <p *ngIf=\"displayAddAdjustmentButton() && disableAddAdjustmentButton()\" class=\"text-hint\">\n            {{ 'EVENT.ADJUSTMENT.DISABLED_ADD_ADJUSTMENT_BUTTON_MESSAGE' | translate }}\n          </p>\n          <div *ngIf=\"displayAddAdjustmentButton()\" class=\"btn-group order-one\">\n            <button class=\"btn btn-primary\" (click)=\"addAdjustmentClick()\"\n                    data-se-id=\"adjustmentDropdownToggle\" [disabled]=disableAddAdjustmentButton()>\n              {{ 'EVENT.ADJUSTMENT.DISPLAY_ADD_ADJUSTMENT_BUTTON' | translate }}\n            </button>\n          </div>\n        </ng-container>\n\n      </div>\n\n      <div *pioneerAuthorize=\"{permission: 'PayCommission'}\" data-se-id=\"addPrepaymentRoot\">\n        <pioneer-add-prepayment *ngIf=\"displayedPrepayment\" [event]=\"onyxEvent\" [vendor]=\"vendor\"\n                                [minAmount]=\"minAmountPrepayment\" (save)=\"onAddPrepayment()\"\n                                (cancel)=\"onCancelPrepayment()\"></pioneer-add-prepayment>\n      </div>\n\n      <div *pioneerAuthorize=\"{permission: 'AddAdjustment'}\" data-se-id=\"addAdjustmentRoot\">\n        <pioneer-add-adjustment *ngIf=\"!isCollapsedAddAdjustment\"\n                                [event]=\"onyxEvent\"\n                                [vendor]=\"vendor\"\n                                (save)=\"onAddAdjustment()\" (cancel)=\"onCancelAdjustment()\">\n        </pioneer-add-adjustment>\n      </div>\n\n      <ng-container *ngIf=\"ui.showAddPayment\">\n        <pioneer-add-payment\n          [event]=\"onyxEvent\"\n          [prepayment]=\"prepayment\"\n          [vendor]=\"vendor\"\n          data-se-id=\"addPaymentForm\">\n        </pioneer-add-payment>\n      </ng-container>\n\n      <pioneer-payment-summary *ngIf=\"ui.showPaymentSummary\"\n        [event]=\"onyxEvent\"\n        [prepayment]=\"prepayment\"\n        [vendor]=\"vendor\">\n      </pioneer-payment-summary>\n\n      <pioneer-payment-record *ngIf=\"ui.showPaymentRecord\"\n        [event]=\"onyxEvent\"\n        [prepayment]=\"prepayment\"\n        [finalPaymentStatusList]=\"finalPaymentStatusList\"\n        [vendor]=\"vendor\">\n      </pioneer-payment-record>\n\n      <pioneer-payment-reservations *ngIf=\"vendor.subscriber && isVendorProperty()\" [event]=\"onyxEvent\" [vendor]=\"vendor\"></pioneer-payment-reservations>\n\n      <pioneer-payment-rsvp *ngIf=\"!vendor.subscriber && isVendorProperty()\" [event]=\"onyxEvent\" [vendor]=\"vendor\"></pioneer-payment-rsvp>\n\n    </div>\n  </div>\n</div>\n"

/***/ }),

/***/ "3oKC":
/***/ (function(module, exports) {

module.exports = "<pioneer-confirmation-modal\n  #confirmDeleteModal\n  title=\"EVENT.PROPERTY.CONFIRM_DELETE_VENDOR_TITLE\"\n  content=\"EVENT.PROPERTY.CONFIRM_DELETE_VENDOR\"\n  cancel=\"COMMON.BUTTON.CANCEL\"\n  confirm=\"EVENT.PROPERTY.DELETE_VENDOR\"\n  (closed)=\"confirmHandler($event)\">\n</pioneer-confirmation-modal>\n\n<div class=\"card\" #cardWrapper>\n\n  <div class=\"card-header\" id=\"heading-{{vendor.chain}}-{{vendor.brand}}-{{vendor.propertyId}}\">\n    <div class=\"container\">\n      <div class=\"row justify-content-between\">\n        <span>\n          <a href=\"#!\" class=\"card-state-toggle\" (click)=\"toggleCard($event)\">\n            <i class=\"far fa-fw {{isCardOpen ? 'fa-chevron-up' : 'fa-chevron-down'}}\"></i>\n          </a>\n          <ng-container *pioneerAuthorize=\"{permission: 'ViewGroupPayPropertyIndicators'}\">\n            <img *ngIf=\"vendor.subscriber && grouppayLogo\" [src]=\"grouppayLogo\" width=\"22px\" height=\"22px\"\n                 tooltip=\"{{'EVENTS.PROPERTY_SUBSCRIBED_TOOLTIP' | translate }}\" alt=\"subscriber-vendor-logo\">\n          </ng-container>\n          {{ cardTitle }}\n        </span>\n        <div *ngIf=\"canRemoveVendor && !isReadOnly\" class=\"dropdown\">\n          <button class=\"btn btn-more\" data-toggle=\"dropdown\">\n            <i class=\"fas fa-ellipsis-h\"></i>\n          </button>\n          <ul class=\"dropdown-menu dropdown-menu-right\">\n            <li role=\"menuitem\">\n              <a class=\"dropdown-item\" role=\"button\" tabindex=\"0\" (click)=\"confirmBeforeDelete($event)\">\n                <i class=\"fal fa-trash-alt fa-fw\"></i>\n                {{ 'EVENT.PROPERTY.DELETE_VENDOR_BUTTON' | translate }}\n              </a>\n            </li>\n          </ul>\n        </div>\n      </div>\n    </div>\n  </div>\n\n  <div *ngIf=\"isCardOpen\">\n    <div class=\"card-block\">\n      <pioneer-child-contact-form [contactForm]=\"contactLookupForm\"\n                                  [partyType]=\"partyType\"\n                                  [contactReferenceNumberTitle]=\"contactReferenceNumberTitle\"\n                                  [isReadOnly]=\"isReadOnly || !isContactEditable\"\n                                  [canEditVendorCommRate]=\"canEditVendorCommRate\"\n                                  [showLongLabels]=\"showLongLabels\"\n                                  [showSubscriberBadge]=\"showSubscriberBadge\"\n                                  [inputEmail]=\"inputEmail\"\n                                  (outputEmail)=\"setupPropertyEmail($event)\">\n      </pioneer-child-contact-form>\n\n      <ng-container *ngIf=\"vendor.eventPartyId\">\n        <div *pioneerAuthorize=\"{permission: 'MultiVendor'}\">\n          <pioneer-attachment [eventId]=\"eventId\" [vendor]=\"vendor\"></pioneer-attachment>\n        </div>\n      </ng-container>\n    </div>\n  </div>\n</div>\n"

/***/ }),

/***/ "3r7E":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("rP7Y")(true);
// imports


// module
exports.push([module.i, ".order-one{-ms-flex-order:1!important;order:1!important}.no-payment,.non-bold{font-weight:400}.no-payment{color:#86b0f5}.no-text-decoration{text-decoration:none}.commission-card{margin-bottom:15px}a.withdraw{font-size:14px;font-weight:400;color:#22c8d9;margin-right:2rem}a.withdraw:hover{text-decoration:none}", "", {"version":3,"sources":["/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/payment/vendor-commission-card/vendor-commission-card.component.css"],"names":[],"mappings":"AAAA,WACE,2BAAA,iBAAoB,CACrB,sBAGC,eAAmB,CAGrB,YAEE,aAAc,CACf,oBAGC,oBAAsB,CACvB,iBAGG,kBAAoB,CACvB,WAGC,eAAgB,gBACI,cACL,iBACI,CACpB,iBAEC,oBAAsB,CACvB","file":"vendor-commission-card.component.css","sourcesContent":[".order-one {\n  order: 1 !important;\n}\n\n.non-bold {\n  font-weight:normal;\n}\n\n.no-payment {\n  font-weight:normal;\n  color: #86B0F5\n}\n\n.no-text-decoration {\n  text-decoration: none;\n}\n\n.commission-card{\n    margin-bottom: 15px;\n}\n\na.withdraw {\n  font-size: 14px;\n  font-weight: normal;\n  color: #22c8d9;\n  margin-right: 2rem;\n}\na.withdraw:hover {\n  text-decoration: none;\n}\n"],"sourceRoot":""}]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),

/***/ "3v0A":
/***/ (function(module, exports) {

module.exports = "<pioneer-confirmation-modal\n  data-se-id=\"add-agency-confirmation-modal\"\n  content=\"MESSAGES.CONFIRMATION.PROCEED\"\n  cancel=\"COMMON.BUTTON.CANCEL\"\n  [confirm]=\"confirmationModalConfig.confirm\"\n  [title]=\"confirmationModalConfig.title\"\n  (closed)=\"confirmBeforeAddAgencyHandler($event)\">\n</pioneer-confirmation-modal>\n\n<div class=\"content-container\">\n  <div class=\"row\">\n    <div class=\"card-content\">\n      <div class=\"card\" id=\"card-basic-agency-data\">\n        <div class=\"card-header\">\n          {{ 'EVENT.AGENCY_REVIEW.CANDIDATE_AGENCY_TITLE' | translate }}\n        </div>\n        <div class=\"card-block\">\n          <table class=\"table search-results-simple\">\n            <thead>\n            <tr>\n              <th>\n                {{ 'EVENT.AGENCY_REVIEW.AGENCY_ID_PROVIDED' | translate }}<br>\n              </th>\n              <th>\n                {{ 'EVENT.AGENCY_REVIEW.AGENCY_NAME' | translate }}<br>\n              </th>\n              <th>\n                {{ 'EVENT.AGENCY_REVIEW.AGENCY_ADDRESS' | translate }}<br>\n              </th>\n              <th>\n                {{ 'EVENT.AGENCY_REVIEW.EVENT_NAME' | translate }}<br>\n              </th>\n              <th>\n                {{ 'EVENT.AGENCY_REVIEW.CLIENT_NAME' | translate }}<br>\n              </th>\n            </tr>\n            </thead>\n            <tbody>\n            <tr>\n              <td data-se-id=\"agencyId\">\n                {{ agency?.taCode }}\n              </td>\n              <td data-se-id=\"agencyName\">\n                <span class=\"res-value\">{{ agency?.agencyName }}</span>\n              </td>\n              <td data-se-id=\"agencyAddress\">\n                <span class=\"res-value\">{{ agency?.agencyAddress1 ? agency.agencyAddress1 : '' }}</span>\n                <span class=\"res-value\">{{ agency?.agencyAddress2 ? ', ' + agency.agencyAddress2 : '' }}</span>\n                <span class=\"res-value\">{{ agency?.agencyAddress3 ? ', ' + agency.agencyAddress3 : '' }}</span>\n                <br>\n                <span class=\"res-value\">{{ agency?.agencyCity ? agency.agencyCity : '' }}</span>\n                <span class=\"res-value\">{{ agency?.agencyPostalCode ? ', ' + agency.agencyPostalCode : '' }}</span>\n                <span class=\"res-value\">{{ agency?.agencyStateProvinceCode ? ', ' + agency.agencyStateProvinceCode : '' }}</span>\n                <span class=\"res-value\">{{ agency?.agencyCountryCode ? ', ' + agency.agencyCountryCode : '' }}</span>\n              </td>\n              <td data-se-id=\"eventName\">\n                <a data-se-id=\"nameLink\" [routerLink]=\"['/event/' + agency?.eventId]\" *pioneerAuthorize=\"{permission: 'MultiVendor'}\">\n                  {{ agency?.eventName }}\n                </a>\n                <a data-se-id=\"nameLink\" [routerLink]=\"['/event/' + agency?.eventId + '/' + agency?.eventPartyId]\" *pioneerAuthorize=\"{permission: 'SingleVendor'}\">\n                  {{ agency?.eventName }}\n                </a>\n              </td>\n              <td data-se-id=\"clientName\">\n                <span class=\"res-value\">{{ agency?.clientName }}</span>\n              </td>\n            </tr>\n            </tbody>\n          </table>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div class=\"row\">\n    <div class=\"card-content\">\n      <div class=\"card\" id=\"card-basic-candidate-data\">\n        <div class=\"card-header\">\n          {{ 'EVENT.AGENCY_REVIEW.CANDIDATE_MATCHES_TITLE' | translate }}\n        </div>\n        <div class=\"card-block\">\n          <form [formGroup]=\"candidatesForm\" data-se-id=\"candidatesForm\">\n            <table class=\"table search-results-simple\">\n              <thead>\n              <tr>\n                <th> </th>\n                <th>\n                  {{ 'EVENT.AGENCY_REVIEW.ONYX_ID' | translate }}<br>\n                </th>\n                <th>\n                  {{ 'EVENT.AGENCY_REVIEW.AGENCY_NAME' | translate }}<br>\n                </th>\n                <th>\n                  {{ 'EVENT.AGENCY_REVIEW.AGENCY_ADDRESS' | translate }}<br>\n                </th>\n                <th>\n                  {{ 'EVENT.AGENCY_REVIEW.PAYMENT_LOCATION' | translate }}<br>\n                </th>\n                <th>\n                  {{ 'EVENT.AGENCY_REVIEW.SUBSCRIBER' | translate }}<br>\n                </th>\n                <th>\n                  {{ 'EVENT.AGENCY_REVIEW.MATCH' | translate }}<br>\n                </th>\n              </tr>\n              </thead>\n              <tbody>\n              <tr *ngFor=\"let candidate of agency?.candidates\">\n                <td data-se-id=\"select\">\n                  <div class=\"form-check\">\n                    <label class=\"custom-control custom-radio\">\n                      <input type=\"radio\"\n                             class=\"custom-control-input\"\n                             name=\"matchingOption\"\n                             data-se-id=\"matchingOption\"\n                             formControlName=\"matchingOption\"\n                             value=\"{{ candidate.matchingAgencyCandidateId }}\">\n                      <span class=\"custom-control-indicator\"></span>\n                    </label>\n                  </div>\n                </td>\n                <td data-se-id=\"candidateId\">\n                  {{ candidate.taCode }}\n                </td>\n                <td data-se-id=\"candidateName\">\n                  {{ candidate.agencyName }}\n                </td>\n                <td data-se-id=\"candidateAddress\">\n                  <span class=\"res-value\">{{ candidate.agencyAddress1 ? candidate.agencyAddress1 : '' }}</span>\n                  <span class=\"res-value\">{{ candidate.agencyAddress2 ? ', ' + candidate.agencyAddress2 : '' }}</span>\n                  <span class=\"res-value\">{{ candidate.agencyAddress3 ? ', ' + candidate.agencyAddress3 : '' }}</span>\n                  <br>\n                  <span class=\"res-value\">{{ candidate.agencyCity ? candidate.agencyCity : '' }}</span>\n                  <span class=\"res-value\">{{ candidate.agencyPostalCode ? ', ' + candidate.agencyPostalCode : '' }}</span>\n                  <span class=\"res-value\">{{ candidate.agencyStateProvinceCode ? ', ' + candidate.agencyStateProvinceCode : '' }}</span>\n                  <span class=\"res-value\">{{ candidate.agencyCountryCode ? ', ' + candidate.agencyCountryCode : '' }}</span>\n                </td>\n                <td data-se-id=\"paymentLocation\">\n                  {{ candidate.paymentLocation }}\n                  <br>\n                  {{ candidate.paymentMethod }}\n                </td>\n                <td data-se-id=\"suscriber\">\n                  {{ candidate.subscriber ? ('EVENT.AGENCY_REVIEW.IS_SUBSCRIBER' | translate) : ('EVENT.AGENCY_REVIEW.IS_NON_SUBSCRIBER' | translate)}}\n                </td>\n                <td data-se-id=\"matchRate\">\n                  {{ candidate.matchRate }}\n                </td>\n              </tr>\n              </tbody>\n            </table>\n              <div class=\"row\">\n                <p class=\"col-xs form-text text-muted\">{{ 'EVENT.AGENCY_REVIEW.NO_MATCHES_FOUND' | translate }}</p>\n                <a class=\"col form-text\" href=\"#\" (click)=\"confirmBeforeAddAgency()\">\n                  {{ 'EVENT.AGENCY_REVIEW.ADD_NEW_AGENCY' | translate }}\n                </a>\n              </div>\n          </form>\n        </div>\n      </div>\n        <div class=\"button-bar\">\n          <button class=\"btn btn-link\" data-se-id=\"cancelMatchButton\"\n                  (click)=\"cancelMatch()\" >\n            {{ 'EVENT.AGENCY_REVIEW.CANCEL_BUTTON' | translate}}\n          </button>\n          <button class=\"btn btn-primary\" data-se-id=\"matchButton\"\n                  (click)=\"matchCandidate()\"\n                  [disabled]=\"noOptionSelected()\">\n            {{ 'EVENT.AGENCY_REVIEW.MATCH_BUTTON' | translate}}\n          </button>\n        </div>\n    </div>\n  </div>\n</div>\n\n\n\n"

/***/ }),

/***/ "4VeM":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("rP7Y")(true);
// imports


// module
exports.push([module.i, ".order-one{-ms-flex-order:1!important;order:1!important}", "", {"version":3,"sources":["/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/reservations/vendor-reservation-page/vendor-reservation-page.component.css"],"names":[],"mappings":"AAAA,WACE,2BAAA,iBAAoB,CACrB","file":"vendor-reservation-page.component.css","sourcesContent":[".order-one {\n  order: 1 !important;\n}\n"],"sourceRoot":""}]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),

/***/ "4vyA":
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\">\n  <div class=\"container\">\n    <div class=\"row justify-content-between\">\n      <h5 class=\"modal-title\">{{ 'EVENT.PROPERTY.POPUP.SEARCH.TITLE_VENDOR' | translate }}</h5>\n      <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\" (click)=\"cancel()\">\n        <span aria-hidden=\"true\">&times;</span>\n      </button>\n    </div>\n  </div>\n</div>\n\n<div class=\"modal-body\">\n\n  <p class=\"text-muted text-warning\"></p>\n\n  <!-- FORM START -->\n  <form [formGroup]=\"propertySearchForm\" class=\"container\">\n    <div class=\"row\">\n      <div class=\"col form-container form-required\">\n          <pioneer-form-input label=\"EVENT.PROPERTY.POPUP.SEARCH.FILTERS.SELECT_VENDOR\">\n            <select formControlName=\"payorType\" class=\"form-control form-control-sm\">\n              <option *ngFor=\"let option of (propertyLookupStore.payorTypes | async)\"\n                      [ngValue]=\"option.key\">{{ option.value }}</option>\n            </select>\n          </pioneer-form-input>\n      </div>\n      <div class=\"col form-container\">\n      </div>\n      <div class=\"col form-container\">\n      </div>\n    </div>\n    <div class=\"row\">\n      <div class=\"col form-container\">\n        <pioneer-dropdown-search  [control]=\"propertySearchForm.controls.chain\"\n                                  label=\"EVENT.PROPERTY.POPUP.SEARCH.FILTERS.CHAIN\"\n                                  placeholder=\"EVENT.PROPERTY.POPUP.SEARCH.FILTERS.CHAIN_PLACEHOLDER\"\n                                  [options]=\"chains$ | async\"\n                                  controlName=\"chain\"\n                                  (selected)=\"chainSelected($event)\"\n                                  #chainDropdown>\n        </pioneer-dropdown-search>\n      </div>\n      <div class=\"col form-container\">\n        <pioneer-dropdown-search  [control]=\"propertySearchForm.controls.brand\"\n                                  label=\"EVENT.PROPERTY.POPUP.SEARCH.FILTERS.BRAND\"\n                                  placeholder=\"EVENT.PROPERTY.POPUP.SEARCH.FILTERS.BRAND_PLACEHOLDER\"\n                                  [options]=\"brands$ | async\"\n                                  controlName=\"brand\"\n                                  #brandDropdown>\n        </pioneer-dropdown-search>\n      </div>\n      <div class=\"col-6 form-container\">\n        <pioneer-form-input label=\"EVENT.PROPERTY.POPUP.SEARCH.FILTERS.VENDOR\">\n          <input type=\"text\" class=\"form-control\" formControlName=\"property\"\n            [attr.placeholder]=\"'EVENT.PROPERTY.POPUP.SEARCH.FILTERS.VENDOR_PLACEHOLDER' | translate\" />\n        </pioneer-form-input>\n      </div>\n    </div>\n    <div class=\"row\">\n      <div class=\"col form-container\">\n          <pioneer-dropdown-search  [control]=\"propertySearchForm.controls.country\"\n                                    label=\"EVENT.PROPERTY.POPUP.SEARCH.FILTERS.COUNTRY\"\n                                    placeholder=\"EVENT.PROPERTY.POPUP.SEARCH.FILTERS.COUNTRY_PLACEHOLDER\"\n                                    [options]=\"commonDataStore.countries | async\"\n                                    controlName=\"country\"\n                                    (selected)=\"countrySelected($event)\"\n                                    #countryDropdown>\n          </pioneer-dropdown-search>\n      </div>\n      <div class=\"col form-container\" *ngIf=\"(states$ | async)?.length > 0\">\n        <pioneer-dropdown-search  [control]=\"propertySearchForm.controls.state\"\n                                  label=\"EVENT.PROPERTY.POPUP.SEARCH.FILTERS.STATE\"\n                                  placeholder=\"EVENT.PROPERTY.POPUP.SEARCH.FILTERS.STATE_PLACEHOLDER\"\n                                  [options]=\"states$ | async\"\n                                  controlName=\"state\"\n                                  #stateDropdown>\n        </pioneer-dropdown-search>\n      </div>\n      <div class=\"col form-container\">\n        <pioneer-form-input label=\"EVENT.PROPERTY.POPUP.SEARCH.FILTERS.CITY\">\n          <input type=\"text\" class=\"form-control\" formControlName=\"city\"\n            [attr.placeholder]=\"'EVENT.PROPERTY.POPUP.SEARCH.FILTERS.CITY_PLACEHOLDER' | translate\" />\n        </pioneer-form-input>\n      </div>\n      <div class=\"col form-container\">\n        <div class=\"label-placeholder\"></div>\n        <button type=\"button\" class=\"btn btn-primary\" (click)=\"search()\" [disabled]=\"!propertySearchForm.valid\">\n          {{ 'EVENT.PROPERTY.POPUP.SEARCH.FILTERS.SEARCH_BUTTON' | translate }}\n        </button>\n      </div>\n    </div>\n    <div class=\"row\">\n      <div class=\"col form-container form-group\">\n        <div class=\"form-check\">\n          <label class=\"custom-control custom-checkbox\">\n            <input type=\"checkbox\" class=\"custom-control-input\" formControlName=\"onlySubscribers\">\n            <span class=\"custom-control-indicator\"></span>\n            <span class=\"custom-control-description\">{{ 'EVENT.PROPERTY.POPUP.SEARCH.FILTERS.ONLY_SUBSCRIBER' | translate }}</span>\n          </label>\n        </div>\n      </div>\n    </div>\n  </form>\n  <!-- FORM END -->\n\n  <pioneer-vendor-search-results [searchResults]=\"searchResults | async\"\n                                   [totalItems]=\"totalItems | async\"\n                                   [size]=\"size | async\"\n                                   (selected)=\"selectProperty($event)\"\n                                   (goToAdd)=\"goToAddProperty()\">\n  </pioneer-vendor-search-results>\n\n</div>\n"

/***/ }),

/***/ "57PB":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("rP7Y")(true);
// imports


// module
exports.push([module.i, "a.dropdown-item{font-size:14px}", "", {"version":3,"sources":["/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/reservations/reservation-button-bar/reservation-button-bar.component.css"],"names":[],"mappings":"AAAA,gBACE,cAAgB,CACjB","file":"reservation-button-bar.component.css","sourcesContent":["a.dropdown-item {\n  font-size: 14px;\n}"],"sourceRoot":""}]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),

/***/ "5cmY":
/***/ (function(module, exports) {

module.exports = "<script src=\"../event-list.component.ts\"></script>\n<div class=\"card-block\">\n  <h4 class=\"card-title\">\n    {{ 'EVENTS.RESULTS_RETURNED' | translate: eventCountForTranslate }}\n  </h4>\n</div>\n<div class=\"table-responsive\">\n  <table class=\"table search-results-simple\">\n    <thead>\n    <tr>\n      <th></th>\n      <th></th>\n      <th *pioneerAuthorize=\"{permission: 'ViewGroupPayPropertyIndicators'}\"></th>\n      <th>{{'EVENTS.EVENT_NAME' | translate}}</th>\n      <th>{{'EVENTS.MEETING_ID' | translate}}</th>\n      <th>{{'EVENTS.LOCATION' | translate}}</th>\n      <th>{{'EVENTS.END' | translate}}</th>\n      <th>{{'EVENTS.PREPAID_AMOUNT' | translate}}</th>\n      <th>{{'EVENTS.PAY_DATE_INITIATED' | translate}}</th>\n      <th>{{'EVENTS.PAY_DATE_UPDATED' | translate}}</th>\n      <th>{{'EVENTS.FINAL_PAYMENT_STATUS' | translate}}</th>\n      <th>{{'EVENTS.TOTAL_PAID_AMOUNT' | translate}}</th>\n      <th>{{'EVENTS.ESTIMATED_DUE_AMOUNT' | translate}}</th>\n    </tr>\n    </thead>\n    <tbody *ngFor=\"let event of events?.content\">\n\n      <tr>\n        <td [ngClass]=\"{ 'group-vendors': event.isExpanded }\"></td>\n        <td>\n          <a href=\"#!\" class=\"card-state-toggle\"\n             (click)=\"event.isExpanded ? onCardExpandClicked($event, event.eventId, false): onCardExpandClicked($event, event.eventId, true)\">\n            <i class=\"far fa-fw {{event.isExpanded ? 'fa-chevron-up' : 'fa-chevron-down'}}\"></i>\n          </a>\n        </td>\n        <td *pioneerAuthorize=\"{permission: 'ViewGroupPayPropertyIndicators'}\"></td>\n        <td data-se-id=\"name\" >\n          <a data-se-id=\"nameLink\" [routerLink]=\"['/event/' + event.eventId]\">\n            <span *ngIf=\"event.autoGenerated\"\n               class=\"tooltip-hint\"\n               [tooltip]=\"'EVENTS.AUTO_GENERATED_TOOLTIP' | translate\"\n               placement=\"right\">\n              {{getEventNameLine1(event.name)}}\n            </span>\n            <span *ngIf=\"event.autoGenerated && getEventNameLine2(event.name)\"\n               class=\"tooltip-hint\"\n               [tooltip]=\"'EVENTS.AUTO_GENERATED_TOOLTIP' | translate\"\n               placement=\"right\">\n               <br>{{getEventNameLine2(event.name)}}\n            </span>\n            <span *ngIf=\"!event.autoGenerated\">\n              {{getEventNameLine1(event.name)}}\n            </span>\n            <span *ngIf=\"!event.autoGenerated && getEventNameLine2(event.name)\">\n              <br>{{getEventNameLine2(event.name)}}\n            </span>\n          </a>\n        </td>\n        <td data-se-id=\"eventReferenceNumber\">\n          {{ event.eventReferenceNumber }}\n        </td>\n        <td>\n          <span>{{ event.city }}</span><span *ngIf=\"event.state\">, {{ event.state }}</span><span *ngIf=\"event.countryCode\">, {{ (getCountryName(event.countryCode) | async)?.value }}</span>\n        </td>\n        <td data-se-id=\"endDate\"> {{ event.endDate | date: 'shortDate' }} </td>\n        <td data-se-id=\"prepaymentAmount\" class=\"text-right\">\n            {{ getPaymentAmount(event.prepayStatus, event.prepaymentAmount) | number:'1.2-2' }} {{ event.currency}}\n        </td>\n        <td>{{ event.paymentCreatedDate | date: 'shortDate' }}</td>\n        <td>{{ event.paymentModifiedDate | date: 'shortDate' }}</td>\n        <td data-se-id=\"payStatus\"><span *ngIf=\"event.vendorsPaymentStatus\" class=\"badge badge-pill\" [ngClass]=\"getStatusClasses(event.vendorsPaymentStatus)\"> {{ event.vendorsPaymentStatus | paymentStatus }} </span></td>\n        <td data-se-id=\"totalPayAmount\" class=\"text-right\">\n          {{ getTotalEventPaymentAmount(event) | number:'1.2-2' }} {{ event.currency}}\n        </td>\n        <td data-se-id=\"estimatedDue\" class=\"text-right\">\n          <a [routerLink]=\"['/event/' + event.eventId + '/commission']\">\n          {{ getEstimatedDue(event.dueAmount) | number:'1.2-2' }} {{ event.currency}}\n          </a>\n        </td>\n      </tr>\n\n      <tr *ngIf=\"event.isExpanded\">\n        <th [ngClass]=\"{ 'group-vendors': event.isExpanded }\"></th>\n        <th class=\"subtitle\"></th>\n        <th class=\"subtitle\" *pioneerAuthorize=\"{permission: 'ViewGroupPayPropertyIndicators'}\"></th>\n        <th class=\"subtitle\"><small><strong>{{'EVENTS.VENDOR_NAME' | translate}}</strong></small></th>\n        <th class=\"subtitle\"><small><strong>{{'EVENTS.VENDOR_ID' | translate}}</strong></small></th>\n        <th class=\"subtitle\"><small><strong>{{'EVENTS.VENDOR_ADDRESS' | translate}}</strong></small></th>\n        <th class=\"subtitle\"></th>\n        <th class=\"subtitle\"></th>\n        <th class=\"subtitle\"></th>\n        <th class=\"subtitle\"></th>\n        <th class=\"subtitle\"><small><strong>{{'EVENTS.VENDOR_PAYMENT_STATUS' | translate}}</strong></small></th>\n        <th class=\"subtitle\"></th>\n        <th class=\"subtitle\"></th>\n      </tr>\n\n      <tr *ngFor=\"let vendor of event.eventVendors\" [ngClass]=\"{ 'hide': !event.isExpanded }\">\n              <td [ngClass]=\"{ 'group-vendors': event.isExpanded }\"></td>\n              <td></td>\n              <td *pioneerAuthorize=\"{permission: 'ViewGroupPayPropertyIndicators'}\">\n                <img *ngIf=\"vendor.subscriber\" src=\"{{imagesUrl}}/grouppay-logo-symbol.png\" width=\"22px\"  height=\"22px\"\n                     tooltip=\"{{'EVENTS.PROPERTY_SUBSCRIBED_TOOLTIP' | translate }}\">\n              </td>\n              <td data-se-id=\"vendorname\" >\n                    <span placement=\"right\">\n                      {{vendor.name}}\n                    </span>\n              </td>\n              <td data-se-id=\"vendorid\" >\n                  <span placement=\"right\">\n                    {{vendor.propertyId}}\n                  </span>\n              </td>\n              <td data-se-id=\"vendorAddress\" >\n                <span placement=\"right\">\n                  {{vendor.line1}}\n                </span>\n                <span placement=\"right\">\n                  {{vendor.line2}}\n                </span>\n                <span placement=\"right\">\n                  {{vendor.line3}}\n                </span>\n                <br>\n                <span placement=\"right\">\n                  {{vendor.city}},\n                </span>\n                <span placement=\"right\">\n                  {{vendor.state}},\n                </span>\n                <span placement=\"right\">\n                  {{vendor.postalCode}},\n                </span>\n                <br>\n                <span placement=\"right\">\n                  {{ (getCountryName(vendor.countryCode) | async)?.value }}\n                </span>\n              </td>\n              <td> </td>\n              <td class=\"text-right\">\n                <span *ngIf=\"vendor.paymentSummary?.prepaymentAmount\">\n                  {{ getPaymentAmount(vendor.paymentSummary?.prepayStatus, vendor.paymentSummary?.prepaymentAmount) | number:'1.2-2' }} {{ vendor.paymentSummary?.currency}}\n                </span>\n              </td>\n              <td>{{ vendor.paymentSummary?.paymentCreatedDate | date: 'shortDate' }}</td>\n              <td>{{ vendor.paymentSummary?.paymentModifiedDate | date: 'shortDate' }}</td>\n              <td>\n                <span *ngIf=\"vendor.paymentSummary?.payStatus\">\n                  {{ getPaymentStatus(vendor.paymentSummary?.payStatus) | paymentStatus }}\n                </span>\n                <span *ngIf=\"!vendor.paymentSummary?.payStatus\" class=\"no-payment\">\n                  {{ 'PAYMENT_STATUS.READY_TO_INITIATE' | translate }}\n                </span>\n              </td>\n              <td class=\"text-right\">\n                <ng-container *ngIf=\"vendor.paymentSummary?.paymentAmount\">\n                  <span *ngIf=\"!vendor.paymentSummary?.payStatus && isOoivEnabled; else noTooltipPaymentAmount\"\n                           class=\"tooltip-hint\"\n                           [tooltip]=\"'EVENTS.NO_TAXES_INCLUDED_TOOLTIP' | translate\"\n                           placement=\"left\">\n                    {{ getTotalVendorPaymentAmountByStatus(vendor.paymentSummary) | number:'1.2-2' }} {{ vendor.paymentSummary?.currency}}\n                  </span>\n                  <ng-template #noTooltipPaymentAmount>\n                    {{ getTotalVendorPaymentAmountByStatus(vendor.paymentSummary) | number:'1.2-2' }} {{ vendor.paymentSummary?.currency}}\n                   </ng-template>\n                </ng-container>\n              </td>\n              <td class=\"text-right\">\n                <span *ngIf=\"!vendor.paymentSummary?.payStatus && isOoivEnabled; else noTooltipEstimatedDue\"\n                        class=\"tooltip-hint\"\n                        [tooltip]=\"'EVENTS.NO_TAXES_INCLUDED_TOOLTIP' | translate\"\n                        placement=\"left\">\n                  {{ getEstimatedDue(vendor.paymentSummary?.dueAmount) | number:'1.2-2' }} {{ event.currency}}\n                </span>\n                <ng-template #noTooltipEstimatedDue>\n                  {{ getEstimatedDue(vendor.paymentSummary?.dueAmount) | number:'1.2-2' }} {{ event.currency}}\n                </ng-template>\n              </td>\n\n      </tr>\n\n    </tbody>\n  </table>\n</div>\n\n"

/***/ }),

/***/ "7CrU":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("rP7Y")(true);
// imports


// module
exports.push([module.i, ".width-all{width:100%}", "", {"version":3,"sources":["/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/rsvp/rsvp-bulk/rsvp-bulk.component.css"],"names":[],"mappings":"AAAA,WACE,UAAY,CACb","file":"rsvp-bulk.component.css","sourcesContent":[".width-all {\n  width: 100%;\n}\n"],"sourceRoot":""}]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),

/***/ "7twq":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("rP7Y")(true);
// imports


// module
exports.push([module.i, "div{width:100%;height:20%;padding-bottom:56%}iframe{width:100%;height:100%;position:absolute;display:block;top:0;left:0}", "", {"version":3,"sources":["/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/invoice-history/invoice-history.component.css"],"names":[],"mappings":"AAAA,IACE,WAAY,WACA,kBACQ,CACrB,OAGG,WAAY,YACC,kBACM,cACJ,MACR,MACC,CACX","file":"invoice-history.component.css","sourcesContent":["div {\n  width: 100%;\n  height: 20%;\n  padding-bottom: 56%; /* Change this till it fits the dimensions of your video */\n}\n\niframe {\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    display: block;\n    top: 0;\n    left: 0;\n}\n"],"sourceRoot":""}]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),

/***/ "8+hp":
/***/ (function(module, exports) {

module.exports = "<div [formGroup]=\"customEventFieldsForm\">\n  <div class=\"row\" *ngIf=\"(customLabels$ | async)?.userRef01 || (customLabels$ | async)?.userRef02 || (customLabels$ | async)?.userRef03\">\n    <div *ngIf=\"(customLabels$ | async)?.userRef01; else userRef01Empty\" class=\"col form-container\">\n      <div class=\"form-group\">\n        <label>{{(customLabels$ | async)?.userRef01}}</label>\n        <input type=\"text\"\n               class=\"form-control\"\n               formControlName=\"userRef01\"\n               maxlength=\"50\"\n               data-se-id=\"userRef01\"\n               [readonly]=\"!isNewEvent\"/>\n      </div>\n    </div>\n    <ng-template #userRef01Empty>\n      <div class=\"col\">\n        &nbsp;\n      </div>\n    </ng-template>\n    <div *ngIf=\"(customLabels$ | async)?.userRef02; else userRef02Empty\" class=\"col form-container\">\n      <div class=\"form-group\">\n        <label>{{(customLabels$ | async)?.userRef02}}</label>\n        <input type=\"text\"\n               class=\"form-control\"\n               formControlName=\"userRef02\"\n               maxlength=\"50\"\n               data-se-id=\"userRef02\"\n               [readonly]=\"!isNewEvent\"/>\n      </div>\n    </div>\n    <ng-template #userRef02Empty>\n      <div class=\"col\">\n        &nbsp;\n      </div>\n    </ng-template>\n    <div *ngIf=\"(customLabels$ | async)?.userRef03; else userRef03Empty\" class=\"col form-container\">\n      <div class=\"form-group\">\n        <label>{{(customLabels$ | async)?.userRef03}}</label>\n        <input type=\"text\"\n               class=\"form-control\"\n               formControlName=\"userRef03\"\n               maxlength=\"50\"\n               data-se-id=\"userRef03\"\n               [readonly]=\"!isNewEvent\"/>\n      </div>\n    </div>\n    <ng-template #userRef03Empty>\n      <div class=\"col\">\n        &nbsp;\n      </div>\n    </ng-template>\n  </div>\n  <div class=\"row\" *ngIf=\"(customLabels$ | async)?.userRef04 || (customLabels$ | async)?.userRef05\">\n    <div *ngIf=\"(customLabels$ | async)?.userRef04; else userRef04Empty\" class=\"col form-container\">\n      <div class=\"form-group\">\n        <label>{{(customLabels$ | async)?.userRef04}}</label>\n        <input type=\"text\"\n               class=\"form-control\"\n               formControlName=\"userRef04\"\n               maxlength=\"50\"\n               data-se-id=\"userRef04\"\n               [readonly]=\"!isNewEvent\"/>\n      </div>\n    </div>\n    <ng-template #userRef04Empty>\n      <div class=\"col\">\n        &nbsp;\n      </div>\n    </ng-template>\n    <div *ngIf=\"((customLabels$ | async)?.userRef05); else userRef05Empty\" class=\"col form-container\">\n      <div class=\"form-group\">\n        <label>{{(customLabels$ | async)?.userRef05}}</label>\n        <input type=\"text\"\n               class=\"form-control\"\n               formControlName=\"userRef05\"\n               maxlength=\"50\"\n               data-se-id=\"userRef05\"\n               [readonly]=\"!isNewEvent\"/>\n      </div>\n    </div>\n    <ng-template #userRef05Empty>\n      <div class=\"col\">\n        &nbsp;\n      </div>\n    </ng-template>\n    <div class=\"col\">\n      &nbsp;\n    </div>\n  </div>\n</div>\n"

/***/ }),

/***/ "89tT":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("rP7Y")(true);
// imports


// module
exports.push([module.i, ".modal{z-index:1051!important}", "", {"version":3,"sources":["/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/expiration-modal/expiration-modal.component.css"],"names":[],"mappings":"AAAA,OAME,sBAAyB,CAC1B","file":"expiration-modal.component.css","sourcesContent":[".modal {\n  /*\n   * Override z-index to 1051 for the expiration modal since\n   * the pattern-pack \"modal\" class has a z-index value of 1050\n   *\n   */\n  z-index: 1051 !important;\n}\n"],"sourceRoot":""}]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),

/***/ "8Q4s":
/***/ (function(module, exports) {

module.exports = "<form [formGroup]=\"eventFilterForm\"\n      (keydown.enter)=\"$event.preventDefault()\"\n      novalidate>\n\n  <ul class=\"list-group sub-nav collapse show\"\n      id=\"nav-filters\"\n      data-se-id=\"filterEventsNav\"\n      *pioneerAuthorize=\"{permission: 'EventSearch'}\">\n    <li class=\"list-group-item\">\n      <a class=\"item-link\"\n         data-toggle=\"collapse\"\n         data-parent=\"#nav-filters\"\n         href=\"#nav-filters-payment\"\n         data-se-id=\"paymentFilterMenu\">\n            <span *pioneerAuthorize=\"{permission: 'SingleVendor'}\" class=\"item-text\">\n              {{ 'COMMON.NAV.SEARCH_EVENTS.PAYMENT_FILTERS.LABEL' | translate }}\n            </span>\n            <span *pioneerAuthorize=\"{permission: 'MultiVendor'}\" class=\"item-text\">\n              {{ 'COMMON.NAV.SEARCH_EVENTS.PAYMENT_FILTERS.VENDOR_LABEL' | translate }}\n            </span>\n        <i class=\"nav-link-addon glyph-arrow-down\"></i>\n      </a>\n      <div id=\"nav-filters-payment\"\n           class=\"collapse show\">\n        <div class=\"form-group col\" formGroupName=\"paymentStatus\">\n          <!-- Note: The data-se-id must be on the label for the\n                 checkboxes to receive click actions -->\n          {{ eventFilterForm.getError('validatePaymentStatus') }}\n          <!-- unpaid checkbox -->\n          <div class=\"form-check\">\n            <label class=\"custom-control custom-checkbox\"\n                   data-se-id=\"payment-status-unpaid-filter-checkbox\">\n              <input type=\"checkbox\"\n                     formControlName=\"unpaid\"\n                     class=\"custom-control-input\">\n              <span class=\"custom-control-indicator\"></span>\n              <span class=\"custom-control-description\">\n                    {{ 'COMMON.NAV.SEARCH_EVENTS.PAYMENT_FILTERS.UNPAID' | translate }}\n                  </span>\n            </label>\n          </div>\n\n          <!-- payment in process checkbox -->\n          <div class=\"form-check\">\n            <label class=\"custom-control custom-checkbox\"\n                   data-se-id=\"payment-status-payment-in-process-filter-checkbox\">\n              <input type=\"checkbox\"\n                     formControlName=\"inProcess\"\n                     class=\"custom-control-input\">\n              <span class=\"custom-control-indicator\"></span>\n              <span class=\"custom-control-description\">\n                    {{ 'COMMON.NAV.SEARCH_EVENTS.PAYMENT_FILTERS.PAYMENT_IN_PROCESS' | translate }}\n                  </span>\n            </label>\n          </div>\n\n          <!-- paid checkbox -->\n          <div class=\"form-check\">\n            <label class=\"custom-control custom-checkbox\"\n                   data-se-id=\"payment-status-paid-filter-checkbox\">\n              <input type=\"checkbox\"\n                     formControlName=\"paid\"\n                     class=\"custom-control-input\">\n              <span class=\"custom-control-indicator\"></span>\n              <span class=\"custom-control-description\">\n                    {{ 'COMMON.NAV.SEARCH_EVENTS.PAYMENT_FILTERS.PAID' | translate }}\n                  </span>\n            </label>\n          </div>\n\n          <!-- cancelled checkbox -->\n          <ng-container *pioneerAuthorize=\"{permissions: ['AgencyEventLevelIndicators', 'HotelEventLevelIndicators', 'ViewAllPropertySearch']}\">\n            <div class=\"form-check\">\n              <label class=\"custom-control custom-checkbox\"\n                     data-se-id=\"payment-status-cancelled-filter-checkbox\">\n                <input type=\"checkbox\"\n                       formControlName=\"cancelled\"\n                       class=\"custom-control-input\">\n                <span class=\"custom-control-indicator\"></span>\n                <span class=\"custom-control-description\">\n                      {{ 'COMMON.NAV.SEARCH_EVENTS.PAYMENT_FILTERS.CANCELLED' | translate }}\n                    </span>\n              </label>\n            </div>\n          </ng-container>\n        </div>\n\n        <div class=\"form-group col\">\n          <!-- has prepayment checkbox -->\n          <div class=\"form-check\">\n            <label class=\"custom-control custom-checkbox\"\n                   data-se-id=\"has-prepayment-filter-checkbox\">\n              <input type=\"checkbox\"\n                     formControlName=\"hasPrepayment\"\n                     class=\"custom-control-input\">\n              <span class=\"custom-control-indicator\"></span>\n              <span class=\"custom-control-description\">\n                      {{ 'COMMON.NAV.SEARCH_EVENTS.PAYMENT_FILTERS.HAS_PREPAYMENT' | translate }}\n                    </span>\n            </label>\n          </div>\n        </div>\n\n        <div class=\"form-group col-sm-auto col-md-12\">\n          <label for=\"filterCommissionId\">{{\n            'COMMON.NAV.SEARCH_EVENTS.PAYMENT_FILTERS.COMMISSION_ID' | translate }}</label>\n          <input type=\"text\" class=\"form-control form-control-sm\" data-se-id=\"commissionIdInput\"\n                 formControlName=\"commissionId\"\n                 id=\"filterCommissionId\" placeholder=\"Commission ID\">\n        </div>\n        <div class=\"form-group col-sm-auto col-md-12\">\n          <label for=\"filterFundingId\">{{ 'COMMON.NAV.SEARCH_EVENTS.PAYMENT_FILTERS.FUNDING_ID' |\n            translate }}</label>\n          <input type=\"text\" class=\"form-control form-control-sm\"\n                 data-se-id=\"fundingReferenceIdInput\"\n                 formControlName=\"fundingReferenceId\"\n                 id=\"filterFundingId\" placeholder=\"{{ 'COMMON.NAV.SEARCH_EVENTS.PAYMENT_FILTERS.FUNDING_ID' | translate }}\">\n        </div>\n        <div class=\"form-group col-sm-auto col-md-12\">\n          <label for=\"filterPaymentId\">{{ 'COMMON.NAV.SEARCH_EVENTS.PAYMENT_FILTERS.PAYMENT_ID' |\n            translate }}</label>\n          <input type=\"text\" class=\"form-control form-control-sm\"\n                 data-se-id=\"paymentReferenceIdInput\"\n                 formControlName=\"paymentReferenceId\"\n                 id=\"filterPaymentId\" placeholder=\"Payment ID\">\n        </div>\n      </div>\n    </li>\n\n    <!-- Event Filters -->\n    <li class=\"list-group-item\">\n\n      <!-- This link expands the section below -->\n      <a class=\"item-link\"\n         data-toggle=\"collapse\"\n         data-parent=\"#nav-filters\"\n         href=\"#nav-filters-event\"\n         data-se-id=\"eventFilterMenu\">\n        <span\n          class=\"item-text\">{{ 'COMMON.NAV.SEARCH_EVENTS.EVENT_FILTERS.LABEL' | translate }}</span>\n        <i class=\"nav-link-addon glyph-arrow-down\"></i>\n      </a>\n\n      <!-- When the 'show' class is applied, this section expanded -->\n      <div class=\"collapse\"\n           [class.show]=\"isEventFilterMenuExpanded\"\n           id=\"nav-filters-event\">\n        <div class=\"form-group col\">\n          <label>{{ 'COMMON.NAV.SEARCH_EVENTS.EVENT_FILTERS.EVENT_STATUS' |  translate }}</label>\n          <!-- Completed Checkbox -->\n          <div class=\"form-check\">\n            <label class=\"custom-control custom-checkbox\"\n                   data-se-id=\"completedEventCheckbox\">\n              <input type=\"checkbox\"\n                     class=\"custom-control-input\"\n                     formControlName=\"eventStatusCompleted\">\n              <span class=\"custom-control-indicator\"></span>\n              <span class=\"custom-control-description\">{{ 'COMMON.NAV.SEARCH_EVENTS.EVENT_FILTERS.COMPLETED' | translate }}</span>\n            </label>\n          </div>\n\n          <!-- Missing Agency Checkbox -->\n          <div class=\"form-check\" *pioneerAuthorize=\"{permission: 'ViewMissingAgencyElements'}\">\n            <label class=\"custom-control custom-checkbox\"\n                   data-se-id=\"missingAgencyCheckbox\">\n              <input type=\"checkbox\"\n                     class=\"custom-control-input\"\n                     formControlName=\"eventStatusMissingAgency\">\n              <span class=\"custom-control-indicator\"></span>\n              <span class=\"custom-control-description\">{{ 'COMMON.NAV.SEARCH_EVENTS.EVENT_FILTERS.MISSING_AGENCY' | translate }}</span>\n            </label>\n          </div>\n\n          <!-- Include Archived Checkbox -->\n          <div class=\"form-check\">\n            <label class=\"custom-control custom-checkbox\"\n                   data-se-id=\"includeArchivedEventsCheckbox\">\n              <input type=\"checkbox\"\n                     class=\"custom-control-input\"\n                     formControlName=\"includeArchivedEvents\">\n              <span class=\"custom-control-indicator\"></span>\n              <span class=\"custom-control-description\">{{ 'COMMON.NAV.SEARCH_EVENTS.EVENT_FILTERS.ARCHIVED' | translate }}</span>\n            </label>\n          </div>\n\n          <!-- Include Comm Retention Checkbox -->\n          <div class=\"form-check\" *pioneerAuthorize=\"{permission: 'AgencyEventLevelIndicators'}\">\n            <label class=\"custom-control custom-checkbox\"\n                   data-se-id=\"includeCommRetentionEventsCheckbox\">\n              <input type=\"checkbox\"\n                     class=\"custom-control-input\"\n                     formControlName=\"includeCommRetentionEvents\">\n              <span class=\"custom-control-indicator\"></span>\n              <span class=\"custom-control-description\">{{ 'COMMON.NAV.SEARCH_EVENTS.EVENT_FILTERS.COMM_RETENTION' | translate }}</span>\n            </label>\n          </div>\n\n          <!-- Include Deleted Checkbox -->\n          <div class=\"form-check\" *pioneerAuthorize=\"{permission: 'ViewDeletedEvents'}\">\n            <label class=\"custom-control custom-checkbox\"\n                   data-se-id=\"includeDeletedEventsCheckbox\">\n              <input type=\"checkbox\"\n                     class=\"custom-control-input\"\n                     formControlName=\"includeDeletedEvents\">\n              <span class=\"custom-control-indicator\"></span>\n              <span class=\"custom-control-description\">{{ 'COMMON.NAV.SEARCH_EVENTS.EVENT_FILTERS.DELETED' | translate }}</span>\n            </label>\n          </div>\n        </div>\n\n        <!-- Event Payment Status -->\n        <div *pioneerAuthorize=\"{permission: 'MultiVendor'}\" class=\"form-group col\" formGroupName=\"eventPaymentStatus\">\n          <label>{{ 'COMMON.NAV.SEARCH_EVENTS.EVENT_FILTERS.EVENT_PAYMENT_STATUS' |  translate }}</label>\n\n          <!-- Paid Checkbox -->\n          <div class=\"form-check\">\n            <label class=\"custom-control custom-checkbox\">\n              <input type=\"checkbox\"\n                     class=\"custom-control-input\"\n                     formControlName=\"paid\">\n              <span class=\"custom-control-indicator\"></span>\n              <span class=\"custom-control-description\">{{ 'COMMON.NAV.SEARCH_EVENTS.EVENT_FILTERS.EVENT_PAYMENT_STATUS_PAID' | translate }}</span>\n            </label>\n          </div>\n\n          <!-- Partially Paid Checkbox -->\n          <div class=\"form-check\">\n            <label class=\"custom-control custom-checkbox\">\n              <input type=\"checkbox\"\n                     class=\"custom-control-input\"\n                     formControlName=\"partial\">\n              <span class=\"custom-control-indicator\"></span>\n              <span class=\"custom-control-description\">{{ 'COMMON.NAV.SEARCH_EVENTS.EVENT_FILTERS.EVENT_PAYMENT_STATUS_PARTIALLY_PAID' | translate }}</span>\n            </label>\n          </div>\n\n          <!-- Unpaid Checkbox -->\n          <div class=\"form-check\">\n            <label class=\"custom-control custom-checkbox\">\n              <input type=\"checkbox\"\n                     class=\"custom-control-input\"\n                     formControlName=\"unpaid\">\n              <span class=\"custom-control-indicator\"></span>\n              <span class=\"custom-control-description\">{{ 'COMMON.NAV.SEARCH_EVENTS.EVENT_FILTERS.EVENT_PAYMENT_STATUS_UNPAID' | translate }}</span>\n            </label>\n          </div>\n        </div>\n\n        <!-- Date Inputs -->\n        <div class=\"form-group col-sm-auto col-md-12\"\n             [ngClass]=\"{'form-error': eventFilterForm.controls['startDate'].invalid || eventFilterForm.controls['endDate'].invalid || eventFilterForm.getError('greater')}\"\n           >\n          <label for=\"filterDateStart\">{{ 'COMMON.NAV.SEARCH_EVENTS.EVENT_FILTERS.DATE_RANGE' |  translate }}</label>\n          <input type=\"date\" class=\"form-control-input-date form-control-sm\"\n                 formControlName=\"startDate\" id=\"filterDateStart\"\n                 placeholder=\"{{'EVENT.DATE_PLACEHOLDER' | translate}}\"\n                 data-se-id=\"filterDateStart\">\n          <input type=\"date\" class=\"form-control-input-date form-control-sm\"\n                 formControlName=\"endDate\" id=\"filterDateEnd\"\n                 placeholder=\"{{'EVENT.DATE_PLACEHOLDER' | translate}}\" data-se-id=\"filterDateEnd\">\n        </div>\n\n        <!-- Guest Name -->\n        <div class=\"form-group col-sm-auto col-md-12\">\n          <label for=\"filterDateStart\">{{ 'COMMON.NAV.SEARCH_EVENTS.EVENT_FILTERS.GUEST_NAME' |\n            translate }}</label>\n          <input type=\"text\"\n                 formControlName=\"guestName\"\n                 class=\"form-control form-control-sm\"\n                 id=\"filterGuest\"\n                 placeholder=\"First Last\"\n                 data-se-id=\"guestNameInput\">\n        </div>\n      </div>\n    </li>\n\n    <li class=\"list-group-item button-bar\">\n      <button class=\"btn btn-link btn-sm\" (click)=\"resetSearchFilters()\"\n              data-se-id=\"appNavResetButton\">{{ 'COMMON.NAV.SEARCH_EVENTS.RESET' | translate }}\n      </button>\n      <button class=\"btn btn-primary btn-sm\"\n              [disabled]=\"!eventFilterForm.valid\"\n              (click)=\"applySearchFilters(eventFilterForm.value)\"\n              data-se-id=\"appNavFilterButton\">{{ 'COMMON.NAV.SEARCH_EVENTS.FILTER' | translate }}\n      </button>\n    </li>\n  </ul>\n</form>\n"

/***/ }),

/***/ "8aQ7":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("rP7Y")(true);
// imports


// module
exports.push([module.i, ".order-one{-ms-flex-order:1!important;order:1!important}", "", {"version":3,"sources":["/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/rsvp/vendor-rsvp-page/vendor-rsvp-page.component.css"],"names":[],"mappings":"AAAA,WACE,2BAAA,iBAAoB,CACrB","file":"vendor-rsvp-page.component.css","sourcesContent":[".order-one {\n  order: 1 !important;\n}\n"],"sourceRoot":""}]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),

/***/ "8ek7":
/***/ (function(module, exports) {

module.exports = "<div class=\"modal fade\" bsModal [config]=\"config\" role=\"dialog\" tabindex=\"-1\"\n     data-se-id=\"expiration-modal\">\n  <div class=\"modal-dialog\" role=\"document\">\n    <div class=\"modal-content\">\n      <div class=\"modal-body\">\n        <p class=\"lead\" *ngIf=\"title\" [innerHTML]=\"title | translate\"></p>\n        <p>{{ content | translate }}</p>\n        <div *ngIf=\"!alreadyExpired\" class=\"button-bar\">\n          <button data-se-id=\"expiration-modal-cancel\" type=\"button\" class=\"btn btn-link btn-sm\"\n                  (click)=\"endSession()\">{{ logOutEarly | translate }}\n          </button>\n          <button data-se-id=\"expiration-modal-confirm\" type=\"button\" class=\"btn btn-primary btn-sm\"\n                  (click)=\"refreshAuthentication()\">{{ stayLoggedIn | translate }}\n          </button>\n        </div>\n        <div *ngIf=\"alreadyExpired\" class=\"button-bar\">\n          <button data-se-id=\"expiration-modal-confirm\" type=\"button\" class=\"btn btn-primary btn-sm\"\n                  (click)=\"endSession()\">{{ returnToLogin | translate }}\n          </button>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),

/***/ "8mhJ":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("rP7Y")(true);
// imports


// module
exports.push([module.i, ".text-right{text-align:right}", "", {"version":3,"sources":["/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/event-list/event-list-financial-table/event-list-financial.component.css"],"names":[],"mappings":"AACA,YACE,gBAAkB,CACnB","file":"event-list-financial.component.css","sourcesContent":["\n.text-right {\n  text-align: right;\n}\n"],"sourceRoot":""}]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),

/***/ "8w4W":
/***/ (function(module, exports) {

module.exports = "<pioneer-payment-title-summary\n  [iconClass]=\"'fa-exclamation-triangle'\"\n  [title]=\"errorTitle\"\n  [isCompleted]=\"false\"\n  [summary]=\"errorSummary\">\n</pioneer-payment-title-summary>\n"

/***/ }),

/***/ "9I5S":
/***/ (function(module, exports) {

module.exports = "<div [formGroup]=\"contactForm\">\n  <ng-template #firstNameLastName>\n    <div [formGroup]=\"contactForm.controls.contact\">\n    <div class=\"row\">\n      <div class=\"form-container contact-name-first\">\n        <pioneer-form-input [label]=\"showLongLabels ? 'EVENT.EVENT_CONTACT_FIRST_NAME' : 'EVENT.CONTACT_FIRST_NAME'\">\n          <input type=\"text\"\n                 class=\"form-control\"\n                 formControlName=\"firstName\"\n                 maxlength=\"50\"\n                 [attr.placeholder]=\"partyType === 'CLIENT' && !isReadOnly && clientContactEditable ? ('EVENT.CONTACT_FIRST_NAME_PLACEHOLDER' | translate) : ''\"\n                 [readonly]=\"getReadOnly()\"/>\n        </pioneer-form-input>\n      </div>\n      <div class=\"form-container contact-name-last\">\n        <pioneer-form-input [label]=\"showLongLabels ? 'EVENT.EVENT_CONTACT_LAST_NAME' : 'EVENT.CONTACT_LAST_NAME'\">\n          <input type=\"text\"\n                 class=\"form-control\"\n                 formControlName=\"lastName\"\n                 maxlength=\"50\"\n                 [attr.placeholder]=\"partyType === 'CLIENT' && !isReadOnly && clientContactEditable ? ('EVENT.CONTACT_LAST_NAME_PLACEHOLDER' | translate) : ''\"\n                 [readonly]=\"getReadOnly()\"/>\n        </pioneer-form-input>\n      </div>\n    </div>\n    <div class=\"row\">\n      <div class=\"form-container contact-email\">\n        <div class=\"form-group\" [ngClass]=\"{ 'form-required': partyType !== 'CLIENT' && !isReadOnly }\" >\n          <pioneer-form-input [label]=\"showLongLabels ? 'EVENT.EVENT_CONTACT_EMAIL_ADDRESS' : 'EVENT.CONTACT_EMAIL_ADDRESS'\">\n            <input type=\"email\"\n                   class=\"form-control\"\n                   formControlName=\"email\"\n                   maxlength=\"75\"\n                   [attr.placeholder]=\"partyType === 'CLIENT' && !isReadOnly && clientContactEditable ? ('EVENT.CONTACT_EMAIL_ADDRESS_PLACEHOLDER' | translate) : ''\"\n                   [readonly]=\"getReadOnly()\"\n                   pioneerLowercase />\n          </pioneer-form-input>\n        </div>\n      </div>\n      <div class=\"form-container contact-tel\">\n        <div class=\"row\">\n          <div class=\"contact-phone\">\n            <pioneer-form-input [label]=\"showLongLabels ? 'EVENT.EVENT_CONTACT_PHONE_NUMBER' : 'EVENT.CONTACT_PHONE_NUMBER'\">\n              <input type=\"tel\"\n                     class=\"form-control\"\n                     formControlName=\"phone\"\n                     maxlength=\"20\"\n                     [attr.placeholder]=\"partyType === 'CLIENT' && !isReadOnly && clientContactEditable ? ('EVENT.CONTACT_PHONE_NUMBER_PLACEHOLDER' | translate) : ''\"\n                     [readonly]=\"getReadOnly()\"/>\n            </pioneer-form-input>\n          </div>\n          <div class=\"form-container contact-fax\">\n            <pioneer-form-input [label]=\"showLongLabels ? 'EVENT.EVENT_CONTACT_FAX_NUMBER' : 'EVENT.CONTACT_FAX_NUMBER'\">\n              <input type=\"tel\"\n                     class=\"form-control\"\n                     formControlName=\"fax\"\n                     maxlength=\"20\"\n                     [attr.placeholder]=\"partyType === 'CLIENT' && !isReadOnly && clientContactEditable ? ('EVENT.CONTACT_FAX_NUMBER_PLACEHOLDER' | translate) : ''\"\n                     [readonly]=\"getReadOnly()\"/>\n            </pioneer-form-input>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n  </ng-template>\n\n  <ng-template #companyAddress>\n <div class=\"row\">\n    <div class=\"form-container party-name\">\n      <pioneer-form-input label=\"EVENT.CONTACT_COMPANY_NAME\">\n        <input type=\"text\"\n               class=\"form-control\"\n               formControlName=\"name\"\n               maxlength=\"100\"\n               [attr.placeholder]=\"partyType === 'CLIENT' && !isReadOnly ? ('EVENT.CONTACT_COMPANY_NAME_PLACEHOLDER' | translate) : ''\"\n               [readonly]=\"isReadOnly || partyType !== 'CLIENT'\"/>\n        <span *ngIf=\"partyType === 'PROPERTY' && showSubscriberBadge\" class=\"badge badge-success\">\n          {{ 'COMMON.BADGE.GROUPPAY_SUBSCRIBER' | translate }}\n        </span>\n      </pioneer-form-input>\n    </div>\n   <div *ngIf=\"partyType === 'PROPERTY'\" class=\"form-container party-name\">\n     <pioneer-form-input label=\"EVENT.PROPERTY.COUNTRY\">\n       <input type=\"text\"\n              class=\"form-control\"\n              formControlName=\"countryCode\"\n              maxlength=\"100\"\n              [readonly]=\"isReadOnly || partyType !== 'CLIENT'\"/>\n     </pioneer-form-input>\n   </div>\n   <div *ngIf=\"partyType === 'AGENCY'\" class=\"form-container party-name\">\n     <pioneer-form-input label=\"EVENT.CONTACT_AGENCY_ID\">\n       <input type=\"text\"\n              pioneerUppercase\n              class=\"form-control\"\n              formControlName=\"agencyId\"\n              maxlength=\"8\"\n              [readonly]=\"isReadOnly || partyType !== 'CLIENT'\"/>\n     </pioneer-form-input>\n   </div>\n    <div *ngIf=\"partyType === 'CLIENT'\" class=\"form-container party-id\">\n      <!-- These are the Onyx Identifiers and should not be visible after the integration work -->\n      <pioneer-form-input label=\"EVENT.CONTACT_CLIENT_ID\">\n        <input type=\"text\"\n               class=\"form-control\"\n               formControlName=\"code\"\n               maxlength=\"10\"\n               [attr.placeholder]=\"partyType === 'CLIENT' && !isReadOnly ? ('EVENT.CONTACT_CLIENT_ID_PLACEHOLDER' | translate) : ''\"\n               [readonly]=\"isReadOnly\"/>\n      </pioneer-form-input>\n    </div>\n    <div class=\"form-container party-address\">\n      <pioneer-form-input label=\"EVENT.CONTACT_ADDRESS\">\n        <input type=\"text\"\n               class=\"form-control\"\n               formControlName=\"line1\"\n               maxlength=\"50\"\n               [attr.placeholder]=\"partyType === 'CLIENT' && !isReadOnly && clientContactEditable ? ('EVENT.CONTACT_ADDRESS_PLACEHOLDER' | translate) : ''\"\n               [readonly]=\"getReadOnlyClient()\"/>\n      </pioneer-form-input>\n    </div>\n    <div class=\"form-container party-city\">\n      <pioneer-form-input label=\"EVENT.CONTACT_CITY\">\n        <input type=\"text\"\n               class=\"form-control\"\n               formControlName=\"city\"\n               maxlength=\"30\"\n               [attr.placeholder]=\"partyType === 'CLIENT' && !isReadOnly && clientContactEditable ? ('EVENT.CONTACT_CITY_PLACEHOLDER' | translate) : ''\"\n               [readonly]=\"getReadOnlyClient()\"/>\n      </pioneer-form-input>\n    </div>\n    <div class=\"form-container party-state-zip\">\n      <div class=\"row\">\n        <div class=\"form-container party-state\">\n          <pioneer-form-input label=\"EVENT.CONTACT_STATE\">\n            <input type=\"text\"\n                   class=\"form-control\"\n                   formControlName=\"state\"\n                   maxlength=\"3\"\n                   [attr.placeholder]=\"partyType === 'CLIENT' && !isReadOnly && clientContactEditable ? ('EVENT.CONTACT_STATE_PLACEHOLDER' | translate) : ''\"\n                   [readonly]=\"getReadOnlyClient()\"/>\n          </pioneer-form-input>\n        </div>\n        <div class=\"form-container party-zip\">\n          <pioneer-form-input label=\"EVENT.CONTACT_POSTAL_CODE\">\n            <input type=\"text\"\n                   class=\"form-control\"\n                   formControlName=\"postalCode\"\n                   maxlength=\"15\"\n                   [attr.placeholder]=\"partyType === 'CLIENT' && !isReadOnly && clientContactEditable ? ('EVENT.CONTACT_POSTAL_CODE_PLACEHOLDER' | translate) : ''\"\n                   [readonly]=\"getReadOnlyClient()\"/>\n          </pioneer-form-input>\n        </div>\n      </div>\n    </div>\n  </div>\n  </ng-template>\n\n  <ng-template #vendorInfo>\n    <div class=\"row\" *pioneerAuthorize=\"{permission: 'MultiVendor'}\">\n      <div class=\"form-container contact-tel\">\n        <div class=\"row\">\n          <div class=\"contact-phone\">\n            <div class=\"form-group\" [ngClass]=\"{ 'form-required': partyType !== 'CLIENT' && !isReadOnly }\" >\n              <pioneer-form-input [label]=\"showLongLabels ? 'EVENT.COMMISSION_RATE' : 'EVENT.COMMISSION_RATE'\" [isReadOnly]=\"isReadOnly\">\n                <input type=\"number\"\n                      class=\"form-control\"\n                      formControlName=\"commissionRoomPercentage\"\n                      min=\"0\"\n                      max=\"100\"\n                      [attr.placeholder]=\"partyType === 'CLIENT' && !isReadOnly && clientContactEditable && canEditVendorCommRate ? ('EVENT.CONTACT_PHONE_NUMBER_PLACEHOLDER' | translate) : ''\"\n                      [readonly]=\"isReadOnly || !canEditVendorCommRate\"\n                      placeholder=\"{{'EVENT.FINANCIAL_ROOM_COMMISSION_PLACEHOLDER' | translate}}\"/>\n              </pioneer-form-input>\n            </div>\n          </div>\n          <div class=\"col form-container\">\n            <ng-container *pioneerAuthorize=\"{permission: 'AgencyEventLevelIndicators'}\">\n              <label>&nbsp;</label>\n              <div class=\"form-group form-toggle\">\n                <div class=\"form-check center\">\n                  <label class=\"custom-control custom-checkbox\">\n                    <input type=\"checkbox\" class=\"custom-control-input\"\n                      [checked]=\"commRetention\"\n                      formControlName=\"commRetention\"\n                      [attr.disabled]=\"isReadOnly || !canEditVendorCommRate ? 'disabled' : null\"\n                      data-se-id=\"commRetentionToggleCheckbox\"/>\n                    <span class=\"custom-control-indicator\"></span>\n                    <span class=\"custom-control-description\">{{ 'EVENT.COMMISSION.COMM_RETENTION' | translate }}</span>\n                  </label>\n                </div>\n              </div>\n            </ng-container>\n          </div>\n        </div>\n      </div>\n    </div>\n  </ng-template>\n\n  <ng-container *ngIf=\"partyType === 'CLIENT'; then firstNameLastName; else companyAddress\"></ng-container>\n  <ng-container *ngIf=\"partyType === 'CLIENT'; then companyAddress; else firstNameLastName\"></ng-container>\n  <ng-container *ngIf=\"partyType === 'PROPERTY'; then vendorInfo; \"></ng-container>\n\n</div>\n"

/***/ }),

/***/ "9Xkd":
/***/ (function(module, exports) {

module.exports = "<div>\n    <div *ngIf=\"hasSearched && searchResults?.length > 0\" class=\"modal-header\">\n        <h5 class=\"modal-title col\">\n          {{ 'EVENT.PROPERTY.POPUP.SEARCH.RESULTS.RESULTS_VENDORS_NUMBER_DISPLAYED' | translate : {\n            first: getFirstPageItemNumber() + 1,\n            last: getLastPageItemNumber(),\n            total: getSize()}\n          }}\n        </h5>\n        <div *ngIf=\"maxResultsExceeded()\" class=\"col\">\n            <p class=\"form-text text-muted\">{{ 'EVENT.PROPERTY.POPUP.SEARCH.RESULTS.RESULTS_LIMIT_WARNING' | translate }}</p>\n            <p class=\"form-text text-muted\">{{ 'EVENT.PROPERTY.POPUP.SEARCH.RESULTS.REFINE_SEARCH_INFO' | translate }}</p>\n        </div>\n    </div>\n    <div *ngIf=\"hasSearched\" class=\"modal-body\">\n      <div *ngIf=\"searchResults?.length > 0\" class=\"table-responsive table-dropdown\">\n        <table class=\"table\">\n            <thead>\n                <tr>\n                    <th>\n                        {{ 'EVENT.PROPERTY.POPUP.SEARCH.RESULTS.NAME' | translate }}\n                        <span class=\"text-caption text-nowrap\">{{ 'EVENT.PROPERTY.POPUP.SEARCH.RESULTS.ID' | translate }}</span>\n                    </th>\n                    <th>\n                        {{ 'EVENT.PROPERTY.POPUP.SEARCH.RESULTS.ADDRESS_1' | translate }}\n                        <span class=\"text-caption text-nowrap\">{{ 'EVENT.PROPERTY.POPUP.SEARCH.RESULTS.ADDRESS_2' | translate }} / {{ 'EVENT.PROPERTY.POPUP.SEARCH.RESULTS.ADDRESS_3' | translate }}</span>\n                    </th>\n                    <th>\n                        {{ 'EVENT.PROPERTY.POPUP.SEARCH.RESULTS.CITY' | translate }} / {{ 'EVENT.PROPERTY.POPUP.SEARCH.RESULTS.STATE' | translate }}\n                        <span class=\"text-caption text-nowrap\">{{ 'EVENT.PROPERTY.POPUP.SEARCH.RESULTS.POSTAL_CODE' | translate }}</span>\n                    </th>\n                    <th>{{ 'EVENT.PROPERTY.POPUP.SEARCH.RESULTS.COUNTRY' | translate }}</th>\n                </tr>\n            </thead>\n            <tbody>\n                <tr *ngFor=\"let property of searchResults | slice: getFirstPageItemNumber() : getLastPageItemNumber()\"\n                    (click)=\"selectProperty(property)\">\n                    <td>\n                        <span>{{ property.name }}</span>\n                        <span class=\"text-caption\">{{ property.propertyId }}</span>\n                        <span *ngIf=\"property.subscriber === true\" class=\"badge badge-success\">{{ 'COMMON.BADGE.GROUPPAY_SUBSCRIBER' | translate }}</span>\n                    </td>\n                    <td>\n                        <span>{{ property.address ? property.address.line1 : '' }}</span>\n                        <span class=\"text-caption\">{{ property.address ? property.address.line2 : '' }}</span>\n                        <span class=\"text-caption\">{{ property.address ? property.address.line3 : '' }}</span>\n                    </td>\n                    <td>\n                        <span>\n                            {{ property.address ? property.address.city : '' }}\n                            {{ property.address && property.address.city !== '' && property.address.state !== '' ? ', ' : '' }}\n                            {{ property.address ? property.address.state : '' }}\n                        </span>\n                        <span class=\"text-caption\">{{ property.address ? property.address.postalCode : '' }}</span>\n                    </td>\n                    <td><span>{{ property.address ? property.address.countryCode : '' }}</span></td>\n                </tr>\n            </tbody>\n        </table>\n    </div>\n    <div *ngIf=\"searchResults?.length === 0\" class=\"result-empty\">\n        <h3>{{ \"EVENT.PROPERTY.POPUP.SEARCH.RESULTS.NO_VENDORS_FOUND\" | translate }}</h3>\n        <figure class=\"figure\">\n            <i class=\"glyph-page figure-img\"></i>\n        </figure>\n    </div>\n    </div>\n    <div *ngIf=\"hasSearched || searchResults?.length > 0\" class=\"modal-footer\">\n        <div class=\"container\">\n            <div class=\"row justify-content-between\">\n                <ng-container *ngIf=\"hasSearched\">\n                    <div class=\"row\" *pioneerAuthorize=\"{permission: 'AddProperty'}\">\n                        <p class=\"col-xs form-text text-muted\">{{ 'EVENT.PROPERTY.ADD_NEW_VENDOR_CAPTION' | translate }}</p>\n                        <a class=\"col form-text\" href=\"javascript:void(0)\" (click)=\"goToAddProperty()\">\n                            {{ 'EVENT.PROPERTY.ADD_NEW_VENDOR_BUTTON' | translate }}\n                        </a>\n                    </div>\n                </ng-container>\n                <div *ngIf=\"searchResults?.length > 0\" class=\"row align-items-baseline\">\n                    <span class=\"col-md small\">\n                        {{ 'COMMON.PAGINATION.RESULTS_INFO' | translate : {\n                                first: getFirstPageItemNumber() + 1,\n                                last: getLastPageItemNumber(),\n                                total: searchResults.length\n                            }\n                        }}\n                    </span>\n                    <pagination class=\"col-xs\"\n                                [directionLinks]=\"true\"\n                                [boundaryLinks]=\"true\"\n                                [totalItems]=\"totalItems\"\n                                [maxSize]=\"itemsPerPage\"\n                                [(ngModel)]=\"currentPage\"\n                                previousText=\"&lsaquo;\"\n                                nextText=\"&rsaquo;\"\n                                firstText=\"&laquo;\"\n                                lastText=\"&raquo;\">\n                    </pagination>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),

/***/ "A0KH":
/***/ (function(module, exports) {

module.exports = "<!--           Payment Record         -->\n<script\n  src=\"../payment-modifier-display-calculation/payment-modifier-display.component.ts\"></script>\n<div class=\"card\" data-se-id=\"payment-summary-card\">\n  <div class=\"card-header\" id=\"card-commission-payment\">\n    {{'EVENT.COMMISSION.PAYMENT_SUMMARY' | translate}}\n  </div>\n  <div class=\"card-block\">\n\n    <!-- rejected message -->\n    <div class=\"row\"\n         *ngIf=\"ui.showRejectedMessage\"\n         data-se-id=\"payment-summary-error-message\">\n      <div class=\"form-container pay-rejected mx-auto\">\n        <div class=\"row\">\n          <div class=\"col form-container col-md-12\">\n            <div class=\"form-group\">\n              <label class=\"form-control-label\">\n                {{ 'EVENT.COMMISSION.PROCESSING_ERROR' | translate }}\n              </label>\n              <p class=\"lead\">\n                {{ 'EVENT.COMMISSION.PROCESSING_ERROR_LEAD' | translate }}\n              </p>\n              <p class=\"lead text-center\">\n                <!-- todo: replace with support contact message when available: \"EVENT.COMMISSION.CONTACT_MESSAGE\" -->\n              </p>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"row reverse\">\n      <!-- payment calculation / adjustment list -->\n      <div class=\"form-container pay-equation flex98\">\n        <div class=\"row\">\n          <pioneer-payment-equation\n            [event]=\"onyxEvent\"\n            [vendor]=\"vendor\"\n            [strikeThroughPaymentLines]=\"ui.strikeThroughPaymentLines\"\n            [strikeThroughFinalPayment]=\"ui.strikeThroughFinalPayment\"\n            [strikeThroughPrepayment]=\"ui.strikeThroughPrepayment\"\n            [useModifiersMode]=\"true\">\n          </pioneer-payment-equation>\n        </div>\n      </div>\n    </div>\n\n    <pioneer-forecasted-commission\n      [event]=\"onyxEvent\"\n      [vendor]=\"vendor\">\n    </pioneer-forecasted-commission>\n\n    <ng-container *pioneerAuthorize=\"{permission: 'AgencyEventLevelIndicators'}\">\n      <div class=\"form-group form-toggle\">\n        <div class=\"form-check\">\n          <label>\n            {{ 'EVENT.COMMISSION.MASTER_BILL_PAID_1' | translate }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;\n          </label>\n          <label class=\"custom-control custom-checkbox\">\n            <input type=\"checkbox\" class=\"custom-control-input\"\n              (click)=\"toggleMasterBillPaidSetting()\"\n              [checked]=\"vendor.masterBillPaid\"\n              data-se-id=\"masterBillPaidToggleCheckbox\" />\n            <span class=\"custom-control-indicator\"></span>\n            <span class=\"custom-control-description\">{{ 'EVENT.COMMISSION.MASTER_BILL_PAID_2' | translate }}</span>\n          </label>\n        </div>\n      </div>\n    </ng-container>\n    <ng-container *pioneerAuthorize=\"{permission: 'PayCommission'}\">\n      <form *ngIf=\"showPaymentForm() | async\" [formGroup]=\"paymentForm\">\n        <div class=\"row\">\n          <div class=\"form-container pay-desc\">\n            <pioneer-form-input label=\"EVENT.COMMISSION.DESCRIPTION\" [isReadOnly]=\"false\">\n              <input type=\"text\"\n                    class=\"form-control\"\n                    [placeholder]=\"isAuthorizedPayment() ? ('EVENT.COMMISSION.DESCRIPTION_PLACEHOLDER' | translate) : ''\"\n                    id=\"paymentDesc\"\n                    formControlName=\"description\"\n                    [attr.disabled]=\"!isAuthorizedPayment() ? 'disabled' : null\"\n                    maxlength=\"255\">\n            </pioneer-form-input>\n          </div>\n        </div>\n        <ng-container *pioneerAuthorize=\"{permission: 'AgencyEventLevelIndicators'}\">\n          <div class=\"row\" *ngIf=\"canPaidDirectAndCancel() && showPayRejected() && !isSubscriber() && isEventFinished\">\n            <div class=\"form-container col-7\">\n              <pioneer-form-input label=\"{{getNonCommDescriptionLabel()}}\">\n                <select formControlName=\"type\" class=\"form-control form-control-sm\" data-se-id=\"nonCommissionType\" (change)=\"onNonCommissionTypeChange()\">\n                  <option [ngValue]=\"null\" data-se-id=\"nonCommissionTypeDefaultOption\">{{ 'EVENT.COMMISSION.NON_COMM_DESCRIPTION_PLACEHOLDER' | translate }}</option>\n                  <ng-container>\n                    <option *ngFor=\"let option of nonCommissionTypes\" [ngValue]=\"option\">{{ option.value }}</option>\n                  </ng-container>\n                </select>\n              </pioneer-form-input>\n            </div>\n            <div class=\"form-container col\">\n              <pioneer-form-input label=\"{{getAmountPaidLabel()}}\" *ngIf=\"isPayDirect()\" [required]=\"true\">\n                <input type=\"number\"\n                       class=\"form-control\"\n                       style=\"width: 14rem;\"\n                       formControlName=\"commissionAmount\"\n                       data-se-id=\"nonCommissionAmountPaid\"\n                       placeholder=\"{{'EVENT.COMMISSION.NON_COMM_AMOUNT_PAID_PLACEHOLDER' | translate}}\"\n                       required\n                       pioneerCurrency />\n                <pioneer-validation-message error=\"amount_paid_not_equals_total_calculated_payment\"\n                  message=\"MESSAGES.VALIDATION.AMOUNT_PAID_NOT_EQUALS_TOTAL_CALCULATED_PAYMENT\"\n                  [takeSpace]=\"true\">\n                </pioneer-validation-message>\n              </pioneer-form-input>\n            </div>\n          </div>\n          <div class=\"row\" *ngIf=\"canPaidDirectAndCancel() && showPayRejected() && !isSubscriber() && !isEventFinished\">\n            <div class=\"form-container col-7\">\n              <pioneer-form-input label=\"{{getNonCommDescriptionLabel()}}\">\n                <select formControlName=\"cancelType\" class=\"form-control form-control-sm\" data-se-id=\"cancelType\">\n                  <option [ngValue]=\"null\" data-se-id=\"cancelTypeDefaultOption\">{{ 'EVENT.COMMISSION.NON_COMM_DESCRIPTION_PLACEHOLDER' | translate }}</option>\n                  <ng-container>\n                    <option *ngFor=\"let option of cancelTypes\" [ngValue]=\"option\">{{ option.value }}</option>\n                  </ng-container>\n                </select>\n              </pioneer-form-input>\n            </div>\n          </div>\n        </ng-container>\n\n\n\n\n\n      </form>\n    </ng-container>\n  </div>\n</div>\n\n<ng-container *ngIf=\"isFullAgencyNonCommSelected()\">\n  <div class=\"button-bar\" *pioneerAuthorize=\"{permission: 'PayCommission'}\">\n    <button class=\"btn btn-link\" data-se-id=\"updatePaymentReturnButton\" (click)=\"unSelectNonCommType()\" >\n      {{'EVENT.COMMISSION.UPDATE_PAYMENT_RETURN' | translate}}\n    </button>\n\n    <button class=\"btn btn-primary\"\n            (click)=\"saveNonCommPaymentType()\"\n            data-se-id=\"updatePaymentSubmitButton\"\n            [disabled]=\"disablePaidDirect()\">\n\n      <span data-se-id=\"updatePaymentSubmitButtonText\">{{ 'EVENT.COMMISSION.UPDATE_PAYMENT' | translate }}</span>\n      <br>\n      <span data-se-id=\"updatePaymentSubmitButtonStatusText\">{{ isPayDirect() ? ('EVENT.COMMISSION.UPDATE_PAYMENT_PAID_DIRECT' | translate): ('EVENT.COMMISSION.UPDATE_PAYMENT_CANCELLED' | translate) }}</span>\n    </button>\n  </div>\n</ng-container>\n"

/***/ }),

/***/ "A8ep":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("rP7Y")(true);
// imports


// module
exports.push([module.i, ".address1{-ms-flex:0 0 100%;flex:0 0 100%;max-width:100%}", "", {"version":3,"sources":["/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/property-add/property-add.component.css"],"names":[],"mappings":"AAAA,UACI,kBAAA,cAAe,cACC,CACjB","file":"property-add.component.css","sourcesContent":[".address1 {\n    flex: 0 0 100%;\n    max-width: 100%;\n  }"],"sourceRoot":""}]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),

/***/ "AkXp":
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\">\n  <div class=\"container\">\n    <div class=\"row justify-content-between\">\n      <h5 class=\"modal-title\">{{ 'EVENT.PROPERTY.POPUP.SEARCH.TITLE_VENDOR_RATE' | translate }}</h5>\n      <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\" (click)=\"cancel()\">\n        <span aria-hidden=\"true\">&times;</span>\n      </button>\n    </div>\n  </div>\n</div>\n\n<div class=\"modal-body\">\n\n  <table class=\"table\">\n    <thead>\n        <tr>\n            <th>\n                {{ 'EVENT.PROPERTY.POPUP.SEARCH.RESULTS.NAME' | translate }}\n                <span class=\"text-caption text-nowrap\">{{ 'EVENT.PROPERTY.POPUP.SEARCH.RESULTS.ID' | translate }}</span>\n            </th>\n            <th>\n                {{ 'EVENT.PROPERTY.POPUP.SEARCH.RESULTS.ADDRESS_1' | translate }}\n                <span class=\"text-caption text-nowrap\">{{ 'EVENT.PROPERTY.POPUP.SEARCH.RESULTS.ADDRESS_2' | translate }} / {{ 'EVENT.PROPERTY.POPUP.SEARCH.RESULTS.ADDRESS_3' | translate }}</span>\n            </th>\n            <th>\n                {{ 'EVENT.PROPERTY.POPUP.SEARCH.RESULTS.CITY' | translate }} / {{ 'EVENT.PROPERTY.POPUP.SEARCH.RESULTS.STATE' | translate }}\n                <span class=\"text-caption text-nowrap\">{{ 'EVENT.PROPERTY.POPUP.SEARCH.RESULTS.POSTAL_CODE' | translate }}</span>\n            </th>\n            <th>{{ 'EVENT.PROPERTY.POPUP.SEARCH.RESULTS.COUNTRY' | translate }}\n                <span class=\"text-caption text-nowrap\">&nbsp;</span>\n            </th>\n        </tr>\n    </thead>\n    <tbody>\n        <tr>\n            <td>\n                <span>{{ property.name }}</span>\n                <span class=\"text-caption\">{{ property.pid }}</span>\n                <span *ngIf=\"property.subscriber === true\" class=\"badge badge-success\">{{ 'COMMON.BADGE.GROUPPAY_SUBSCRIBER' | translate }}</span>\n            </td>\n            <td>\n                <span>{{ property.address1 ? property.address1 : '' }}</span>\n                <span class=\"text-caption\">{{ property.address2 ? property.address2 : '' }}</span>\n                <span class=\"text-caption\">{{ property.address3 ? property.address3 : '' }}</span>\n            </td>\n            <td>\n                <span>\n                    {{ property.city ? property.city : '' }}\n                    {{ property.city !== '' && property.stateProvinceCode !== '' ? ', ' : '' }}\n                    {{ property.stateProvinceCode ? property.stateProvinceCode : '' }}\n                </span>\n                <span class=\"text-caption\">{{ property.postalCode ? property.postalCode : '' }}</span>\n            </td>\n            <td><span>{{ property.countryCode ? property.countryCode : '' }}</span></td>\n        </tr>\n        <tr>\n          <td>&nbsp;</td>\n          <td></td>\n          <td></td>\n          <td></td>\n          <td></td>\n        </tr>\n    </tbody>\n  </table>\n</div>\n\n<div [formGroup]=\"vendorRateForm\" class=\"modal-body\">\n  <div class=\"row\">\n    <div class=\"col form-container\">\n\n    </div>\n    <div class=\"col form-container\">\n      <div class=\"form-group form-required\">\n        <pioneer-form-input label=\"EVENT.VENDOR_COMMISSION_RATE\">\n          <input type=\"number\"\n                 class=\"form-control\"\n                 formControlName=\"commissionRoomPercentage\"\n                 min=\"0\"\n                 max=\"100\"\n                 data-se-id=\"commissionRateInput\"\n                 placeholder=\"{{'EVENT.FINANCIAL_ROOM_COMMISSION_PLACEHOLDER' | translate}}\"/>\n        </pioneer-form-input>\n      </div>\n    </div>\n    <div class=\"col form-container\">\n      <ng-container *pioneerAuthorize=\"{permission: 'AgencyEventLevelIndicators'}\">\n        <label>&nbsp;</label>\n        <div class=\"form-group form-toggle\">\n          <div class=\"form-check center\">\n            <label class=\"custom-control custom-checkbox\">\n              <input type=\"checkbox\" class=\"custom-control-input\"\n                formControlName=\"commRetention\"\n                data-se-id=\"commRetentionToggleCheckbox\"/>\n              <span class=\"custom-control-indicator\"></span>\n              <span class=\"custom-control-description\">{{ 'EVENT.COMMISSION.COMM_RETENTION' | translate }}</span>\n            </label>\n          </div>\n        </div>\n      </ng-container>\n    </div>\n    <div class=\"col form-container\">\n      <div class=\"label-placeholder\"></div>\n        <button type=\"button\" class=\"btn btn-primary\" (click)=\"addCommissionRate()\" [disabled]=\"!vendorRateForm.valid\">\n          {{ 'EVENT.VENDOR_COMMISSION_RATE_BUTTON' | translate }}\n        </button>\n      </div>\n  </div>\n</div>\n"

/***/ }),

/***/ "An3F":
/***/ (function(module, exports) {

module.exports = "<pioneer-confirmation-modal\n  #noRatePlanCodeModal\n  data-se-id=\"noRatePlanCodeModal\"\n  content=\"EVENT.RESERVATION.NO_RATE_PLAN_CODES\"\n  cancel=\"COMMON.BUTTON.CANCEL\"\n  confirm=\"EVENT.RESERVATION.ADD_RATE_PLAN_CODE\"\n  [title]=\"null\"\n  (closed)=\"noRatePlanCodeModalHandler($event)\">\n</pioneer-confirmation-modal>\n\n<ng-container>\n  <div class=\"button-bar\">\n    <ng-container *pioneerAuthorize=\"{permission: 'ExportReports'}\">\n      <div class=\"btn-group\" *ngIf=\"showDownloadDropdown\">\n        <button class=\"btn btn-primary dropdown-toggle\" data-toggle=\"dropdown\" data-se-id=\"download-reservation-summary-dropdown-button\">\n          {{ \"COMMON.REPORT.EXPORT_DROPDOWN\" | translate }}\n        </button>\n        <div class=\"dropdown-menu dropdown-menu-right\">\n          <button class=\"dropdown-item\"\n            (click)=\"getSummaryReport('excel')\"\n            data-se-id=\"download-reservation-summary-excel-option\">\n            {{ \"COMMON.REPORT.EXPORT_EXCEL\" | translate }}\n          </button>\n          <button class=\"dropdown-item\"\n            (click)=\"getSummaryReport('pdf')\"\n            data-se-id=\"download-reservation-summary-pdf-option\">\n            {{ \"COMMON.REPORT.EXPORT_PDF\" | translate }}\n          </button>\n        </div>\n      </div>\n    </ng-container>\n\n    <ng-container *pioneerAuthorize=\"{permission: 'AddReservation'}\">\n      <div class=\"btn-group\" *ngIf=\"isAddFormCollapsed && canManageReservations && (canChangeReservations$ | async) === true\">\n        <button class=\"btn btn-primary dropdown-toggle\" data-toggle=\"dropdown\" data-se-id=\"add-reservation-dropdown-button\">\n          {{ \"EVENT.RESERVATION.ADD_RESERVATION_BUTTON\" | translate }}\n        </button>\n        <div class=\"dropdown-menu dropdown-menu-right\">\n          <button class=\"dropdown-item\"\n                  data-toggle=\"collapse\"\n                  data-target=\"#addReservationCard\"\n                  aria-controls=\"addReservationCard\"\n                  [ngClass]=\"{ 'collapsed': isAddFormCollapsed }\"\n                  (click)=\"checkRatePlans($event)\"\n                  [attr.aria-expanded]=\"!isAddFormCollapsed\"\n                  data-se-id=\"add-individual-reservation-button\">\n            {{ \"COMMON.BUTTON.INDIVIDUAL\" | translate }}\n          </button>\n          <button class=\"dropdown-item\"\n                  (click)=\"openUploadBulkReservation($event)\"\n                  data-se-id=\"open-reservation-bulk-button\">\n            {{ \"COMMON.BUTTON.BULK\" | translate }}\n          </button>\n        </div>\n      </div>\n    </ng-container>\n\n  </div>\n\n  <ng-container *ngIf=\"canManageReservations\">\n    <div *ngIf=\"!isAddFormCollapsed\"  class=\"card collapse\" id=\"addReservationCard\">\n      <div id=\"card-add-reservation\" class=\"card-header\">\n        {{ \"EVENT.RESERVATION.ADD_RESERVATION_HEADER\" | translate }}\n      </div>\n      <div class=\"card-block\">\n        <pioneer-reservation-form [event]=\"onyxEvent\"></pioneer-reservation-form>\n      </div>\n    </div>\n    <div *ngIf=\"!isAddFormCollapsed\" class=\"button-bar\">\n      <a class=\"btn btn-link\"\n          (click)=\"cancelAddReservation();\"\n          data-toggle=\"collapse\"\n          data-target=\"#addReservationCard\"\n          aria-controls=\"addReservationCard\"\n          [ngClass]=\"{ 'collapsed': isAddFormCollapsed }\"\n          [attr.aria-expanded]=\"!isAddFormCollapsed\"\n          data-se-id=\"cancel-button\">\n        {{'COMMON.BUTTON.CANCEL' | translate}}\n      </a>\n      <button type=\"button\" class=\"btn btn-primary\"\n              (click)=\"addReservation();\"\n              data-se-id=\"save-reservation-button\"\n              [disabled]=\"disableSave()\">\n        {{ \"COMMON.BUTTON.SAVE\" | translate }}\n      </button>\n    </div>\n  </ng-container>\n\n  <pioneer-reservation-bulk *pioneerAuthorize=\"{permission: 'AddReservation'}\"\n                            [event]=\"onyxEvent\" data-se-id=\"reservationBulkModal\">\n  </pioneer-reservation-bulk>\n</ng-container>\n"

/***/ }),

/***/ "AqLj":
/***/ (function(module, exports) {

module.exports = "<pioneer-payment-title-summary\n  [iconClass]=\"action === 'confirm' ? 'fa-check text-success' : 'fa-times text-danger'\"\n  [title]=\"title | titlecase\"\n  [isCompleted]=\"isCompleted\"\n  [summary]=\"summary\"\n  [summary2]=\"summary2\"\n  [invoiceGenerated]=\"invoiceGenerated\"\n  [pendingWorkflow]=\"pendingWorkflow\">\n</pioneer-payment-title-summary>\n\n<div class=\"row\">\n  <div class=\"col-md\">\n\n    <!-- rejection details card -->\n    <pioneer-payment-legal-entity *ngIf=\"showLegalEntityForm()\"\n                                  [legalEntity]=\"legalEntity\" (validForm)=\"setValidForm($event)\"\n                                  (resultLegalEntity)=\"setResultLegalEntity($event)\">\n    </pioneer-payment-legal-entity>\n\n    <form [formGroup]=\"form\" (ngSubmit)=\"onSubmit()\" *ngIf=\"!isCompleted; else showCard\">\n      <!-- rejection details card -->\n      <pioneer-payment-rejection-reasons *ngIf=\"action === 'reject'\" [form]=\"form\"\n                                         [isHotelApprover]=\"isHotelApprover()\"></pioneer-payment-rejection-reasons>\n\n      <!-- email -->\n      <div class=\"form-group form-required\">\n        <pioneer-form-input label=\"{{emailLabel}}\" message=\"MESSAGES.VALIDATION.EMAIL_PAYMENT\">\n          <input type=\"email\" class=\"form-control\" formControlName=\"email\"\n                 placeholder=\"{{'COMMON.FORMS.EMAIL_PLACEHOLDER' | translate}}\" [disabled]=\"isEditEmailDisabled\"/>\n        </pioneer-form-input>\n      </div>\n\n      <ng-container *ngIf=\"event.eventId && !isSubscriber()\">\n        <div class=\"form-group form-required\" *pioneerAuthorizeCommission=\"{permission: 'AddFiles'}\">\n          <pioneer-pickup-report-attachment [event]=\"event\" (currentAttachment)=\"setCurrentAttachment($event)\"\n                                            [vendor]=\"vendor\"></pioneer-pickup-report-attachment>\n        </div>\n      </ng-container>\n\n      <div class=\"mb-5\" style=\"margin-top: -20px\">\n        <button type=\"submit\" [disabled]=\"disableForm()\" class=\"btn\" [ngClass]=\"{\n                  'btn-success': action === 'confirm',\n                  'btn-danger': action === 'reject'\n                }\">\n          <i class=\"far fa-lg\" [ngClass]=\"{\n                  'fa-check': action === 'confirm',\n                  'fa-times': action === 'reject'}\">\n          </i>\n          {{title | titlecase}}\n        </button>\n      </div>\n    </form>\n\n    <ng-template #showCard>\n      <pioneer-payment-action-complete [form]=\"form\"></pioneer-payment-action-complete>\n    </ng-template>\n\n    <div *ngIf=\"!isCompleted\">\n      <a routerLink=\"/payment\" [queryParams]=\"{'action': oppositeAction}\">\n        {{ 'EVENT.COMMISSION.CHANGE_MIND_LINK' | translate: {action: oppositeAction} }}\n      </a>\n    </div>\n  </div>\n\n  <div class=\"col-md\">\n    <div class=\"mb-5\">\n      <h3 class=\"mb-3\">{{'EVENT.COMMISSION.REQUEST' | translate}}</h3>\n      <pioneer-payment-calculation [currency]=\"event?.currency\" [paymentEquation]=\"paymentEquation\"\n                                   [isHotelApprover]=\"isHotelApprover()\" [applyOoiv]=\"applyOoiv\"\n                                   [showCurrencyNote]=\"showCurrencyNote()\"\n                                   [fundCurrency]=\"fundCurrency\"></pioneer-payment-calculation>\n    </div>\n\n    <div class=\"payment-event-details\">\n      <h3 class=\"mb-3\">{{'EVENT.COMMISSION.EVENT_DETAILS' | translate}}</h3>\n\n      <p class=\"mb-0\">\n        <span class=\"d-block\">{{'EVENT.NAME' | translate}}: <strong>{{getEventName()}}</strong></span>\n        <span *ngIf=\"isHotelApprover()\" class=\"d-block\">{{'EVENT.GROUP_CODE' | translate}}\n          : <strong>{{getVendorGroupCode()}}</strong></span>\n        <span *ngIf=\"!isHotelApprover()\" class=\"d-block\">{{'EVENTS.MEETING_ID' | translate}}\n          : <strong>{{getAgencyGroupCode()}}</strong></span>\n        <span class=\"d-block\">{{'EVENT.START_DATE' | translate}}\n          : <strong>{{getStartDate() | date: 'MM/dd/yyyy'}}</strong></span>\n        <span class=\"d-block\">{{'EVENT.END_DATE' | translate}}\n          : <strong>{{getEndDate() | date: 'MM/dd/yyyy'}}</strong></span>\n        <span *ngIf=\"isHotelApprover()\" class=\"d-block\">{{'EVENT.AGENCY_NAME' | translate}}\n          : <strong>{{event?.eventAgency.name}}</strong></span>\n        <span *ngIf=\"!isHotelApprover() \" class=\"d-block\">{{'EVENTS.PROPERTY_NAME' | translate}}\n          : <strong>{{event?.eventProperty.name}}</strong></span>\n        <span *ngIf=\"isHotelApprover()\" class=\"d-block\">{{'EVENT.AGENCY_ID' | translate}}\n          : <strong>{{event?.eventAgency.code}}</strong></span>\n        <span *ngIf=\"!isHotelApprover()\" class=\"d-block\">{{'EVENTS.PROPERTY_ID' | translate}}\n          : <strong>{{event?.eventProperty.propertyId}}</strong></span>\n      </p>\n    </div>\n\n  </div>\n</div>\n"

/***/ }),

/***/ "AvVL":
/***/ (function(module, exports) {

module.exports = "<div class=\"card commission-card\">\n  <div class=\"card-header\" id=\"heading-{{vendor.chain}}-{{vendor.brand}}-{{vendor.propertyId}}\">\n    <div class=\"container\">\n      <div class=\"row justify-content-between\">\n        <div class=\"col flex33\">\n          <span>\n            <a href=\"#!\" class=\"card-state-toggle no-text-decoration\"\n              (click)=\"vendor.isExpanded ? onCardExpandClicked($event, vendor.eventPartyId, vendor.chain, vendor.brand, vendor.propertyId, false)\n                                            : onCardExpandClicked($event, vendor.eventPartyId, vendor.chain, vendor.brand, vendor.propertyId, true)\">\n              <i class=\"far fa-fw {{vendor.isExpanded ? 'fa-chevron-up' : 'fa-chevron-down'}}\"></i>\n            </a>\n            <ng-container *pioneerAuthorize=\"{permission: 'ViewGroupPayPropertyIndicators'}\">\n              <img *ngIf=\"vendor.subscriber\" src=\"{{imagesUrl}}/grouppay-logo-symbol.png\" width=\"22px\" height=\"22px\"\n                 tooltip=\"{{'EVENTS.PROPERTY_SUBSCRIBED_TOOLTIP' | translate }}\">\n            </ng-container>\n            &nbsp;{{ vendor.name }}\n          </span>\n        </div>\n        <div class=\"col\" *ngIf=\"!vendor.isExpanded\">\n          <pioneer-vendor-header-summary [event]=\"onyxEvent\"\n                  [type]=\"headerRecordType\"\n                  [vendor]=\"vendor\">\n          </pioneer-vendor-header-summary>\n        </div>\n      </div>\n    </div>\n  </div>\n\n  <div *ngIf=\"vendor.isExpanded\">\n\n    <div class=\"card-block\">\n      <div [formGroup]=\"vendorForm\">\n        <div class=\"row\">\n          <div class=\"col form-container\">\n            <div class=\"form-group\">\n              <pioneer-form-input label=\"EVENT.COMMISSION.VENDOR_NAME\" [isReadOnly]=\"true\">\n                <input type=\"text\"\n                      class=\"form-control\"\n                      formControlName=\"vendorName\"\n                      maxlength=\"100\"\n                      data-se-id=\"vendorName\"\n                      [readonly]=\"true\"/>\n              </pioneer-form-input>\n            </div>\n          </div>\n          <div class=\"col form-container\">\n            <div class=\"form-group\">\n              <pioneer-form-input label=\"EVENT.COMMISSION.VENDOR_ADDRESS\" [isReadOnly]=\"true\">\n                <input type=\"text\" pioneerUppercase\n                      class=\"form-control\"\n                      formControlName=\"vendorAdress\"\n                      maxlength=\"20\"\n                      [readonly]=\"true\"\n                      data-se-id=\"vendorAdress\"/>\n              </pioneer-form-input>\n            </div>\n          </div>\n          <div class=\"col form-container\">\n            <div class=\"form-group\">\n              <pioneer-form-input label=\"EVENT.COMMISSION.VENDOR_STATE\" [isReadOnly]=\"true\">\n                <input type=\"text\"\n                      class=\"form-control\"\n                      formControlName=\"vendorState\"\n                      maxlength=\"100\"\n                      data-se-id=\"vendorState\"\n                      [readonly]=\"true\"/>\n              </pioneer-form-input>\n            </div>\n          </div>\n          <div class=\"col form-container\">\n            <div class=\"form-group\">\n              <pioneer-form-input label=\"EVENT.COMMISSION.VENDOR_ZIP\" [isReadOnly]=\"true\">\n                <input type=\"text\" pioneerUppercase\n                      class=\"form-control\"\n                      formControlName=\"vendorZip\"\n                      maxlength=\"20\"\n                      [readonly]=\"true\"\n                      data-se-id=\"vendorZip\"/>\n              </pioneer-form-input>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"card-block\">\n      <div class=\"content-container\">\n\n        <div class=\"clearfix mb-5\">\n          <div class=\"active-filters\">\n            <div class=\"view-select float-right\">\n              <div class=\"btn-group btn-group-sm\">\n                <button class=\"btn btn-default\"\n                        [ngClass]=\"{'active': !isInDetail }\"\n                        (click)=\"navigateTo('/event/' + onyxEvent.eventId + '/rsvp')\"\n                        data-se-id=\"rsvp-summary-toggle-button\">\n                  <i class=\"glyph-page\"></i>{{'EVENT.RESERVATION.SUMMARY_BUTTON' | translate}}\n                </button>\n                <button class=\"btn btn-default\"\n                        [ngClass]=\"{'active': isInDetail }\"\n                        (click)=\"navigateTo('/event/' + onyxEvent.eventId + '/rsvp/detail')\"\n                        data-se-id=\"rsvp-compare-toggle-button\"\n                        [disabled]=\"disableCompareButton$ | async\">\n                  <i class=\"glyph-pages\"></i>{{'EVENT.RESERVATION.COMPARE_BUTTON' | translate}}\n                </button>\n              </div>\n            </div>\n          </div>\n        </div>\n\n        <pioneer-add-rsvp\n          *ngIf=\"displayAddRsvp\"\n          [event]=\"onyxEvent\"\n          [showDownloadDropdown]=\"(areRsvpsPresent$ | async) === true\"\n          [summarySelected]=\"(showReservationCompareSummary$ | async) === true\"\n          [vendor]=\"vendor\">\n        </pioneer-add-rsvp>\n\n        <pioneer-rsvp-summary\n          *ngIf=\"showReservationCompareSummary$ | async\"\n          [event]=\"onyxEvent\"\n          [vendor]=\"vendor\">\n        </pioneer-rsvp-summary>\n\n        <pioneer-rsvp-compare\n          *ngIf=\"!(showReservationCompareSummary$ | async)\"\n          [event]=\"onyxEvent\"\n          [vendor]=\"vendor\">\n        </pioneer-rsvp-compare>\n\n      </div>\n    </div>\n\n  </div>\n\n</div>\n"

/***/ }),

/***/ "B/30":
/***/ (function(module, exports) {

module.exports = "<div class=\"content-container\">\n  <div class=\"row\">\n    <div class=\"card-content\">\n      <div class=\"card\" id=\"card-basic-event-data\">\n        <div class=\"card-header\">\n          {{ 'EVENT.PROPERTY_REVIEW.LIST_TITLE' | translate }}\n        </div>\n        <div class=\"card-block\">\n\n          <pioneer-matching-property-list\n            [properties]=\"properties | async\"\n            [currentPage]=\"currentPage\"\n            (sortPage)=\"sortList($event.field, $event.direction)\">\n          </pioneer-matching-property-list>\n\n          <div *ngIf=\"!(propertiesPresent | async)\" class=\"result-empty\">\n            <h3>{{'EVENT.PROPERTY_REVIEW.NO_RESULTS' | translate}}</h3>\n          </div>\n\n          <div class=\"card-footer\">\n            <pioneer-pagination *ngIf=\"propertiesPresent | async\"\n              [resultsPage]=\"properties | async\"\n              (updatePage)=\"onRefreshList($event.page)\"\n              [pagesizeType]=\"pagesizeType\">\n            </pioneer-pagination>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),

/***/ "BjH2":
/***/ (function(module, exports) {

module.exports = "<div class=\"form-group\">\n  <label for=\"{{ controlName }}\">{{ label | translate }}</label>\n  <div (pioneerFocusOutside)=\"closeDropdown()\" data-se-id=\"dropdown\">\n    <div  class=\"input-group\" (click)=\"toggleDropdown()\">\n      <input  #searchInputElement\n              type=\"text\"\n              class=\"form-control select\"\n              name=\"{{ controlName }}\"\n              [(ngModel)]=\"searchInput\"\n              [placeholder]=\"placeholder | translate\"\n              autocomplete=\"off\"\n              (keyup)=\"filter()\"\n              (keydown)=\"inputKeydown()\"\n              data-se-id=\"searchInput\"/>\n      <div class=\"input-group-addon\" (click)=\"iconClick()\" data-se-id=\"dropdownIcon\">\n        <span class=\"input-group-text\">\n          <span class=\"fas fa-sort-down\"></span>\n        </span>\n      </div>\n    </div>\n    <div  class=\"form-control dropdown\"\n          *ngIf=\"displayDropdown\">\n      <span (click)=\"select(option)\" class=\"dropdown-option empty\" unselectable=\"on\">\n        {{ 'COMMON.DROPDOWN_EMPTY_OPTION' | translate }}\n      </span>\n      <hr>\n      <span *ngIf=\"!dropdownOptions || dropdownOptions.length === 0\" class=\"dropdown-no-option\">\n        {{ 'COMMON.NO_RESULTS_FOUND' | translate }}\n      </span>\n      <span *ngFor=\"let option of dropdownOptions\"\n            class=\"dropdown-option\"\n            (click)=\"select(option)\"\n            innerHTML=\"{{ option.value | highlight : searchInput }}\"\n            unselectable=\"on\">\n      </span>\n    </div>\n  </div>\n</div>\n"

/***/ }),

/***/ "Cww6":
/***/ (function(module, exports) {

module.exports = "<div class=\"content-container\">\n  <div class=\"active-filters\" id=\"filter-control\">\n    <p class=\"filter-label\">{{ 'DASHBOARD.FILTERS_TITLE' | translate }}</p>\n    <div class=\"filter-list form-group\">\n      <div class=\"form-check\">\n        <label class=\"filter-item custom-control custom-checkbox checked\"\n               [class.checked]=\"showCompletedAndUnpaid\"\n               data-toggle=\"collapse\"\n               data-parent=\".card-content\"\n               href=\"#card-1\"\n               data-se-id=\"completedAndUnpaidFilter\"\n               (click)=\"toggleShowCompletedAndUnpaid()\">\n          <i class=\"button-state\"></i>\n          <span class=\"custom-control-description\">{{ 'DASHBOARD.COMPLETED_AND_UNPAID' | translate }}</span>\n        </label>\n        <label class=\"filter-item custom-control custom-checkbox checked\"\n               [class.checked]=\"showMissingAgency\"\n               data-toggle=\"collapse\"\n               data-parent=\".card-content\"\n               href=\"#card-2\"\n               data-se-id=\"missingAgencyFilter\"\n               (click)=\"toggleShowMissingAgency()\"\n               *pioneerAuthorize=\"{permission: 'ViewMissingAgencyElements'}\">\n          <i class=\"button-state\"></i>\n          <span class=\"custom-control-description\">{{ 'DASHBOARD.MISSING_AGENCY' | translate }}</span>\n        </label>\n      </div>\n    </div>\n  </div>\n\n  <div class=\"card-content\">\n    \n    <div class=\"card-deck\">\n      <pioneer-completed-unpaid></pioneer-completed-unpaid>\n    </div>\n    <div class=\"card-deck\" *pioneerAuthorize=\"{permission: 'ViewMissingAgencyElements'}\">\n      <pioneer-missing-agency></pioneer-missing-agency>\n    </div>\n\n    <!-- Third Row -->\n    <div class=\"card-deck\">\n      <!-- Recently Modified    -->\n        <pioneer-recent-events-card  eventSearchSortType = \"MODIFIED\"></pioneer-recent-events-card>\n      <!-- Recently Created -->\n       <pioneer-recent-events-card   eventSearchSortType = \"CREATED\"></pioneer-recent-events-card>\n      <!-- Recently Completed -->\n       <pioneer-recent-events-card   eventSearchSortType = \"COMPLETED\"></pioneer-recent-events-card>\n    </div>\n  </div>\n</div>\n"

/***/ }),

/***/ "Cxda":
/***/ (function(module, exports) {

module.exports = "\n<div *ngIf=\"!isMultiVendor()\" class=\"content-container\">\n  <div class=\"row\">\n    <div class=\"card-content\">\n\n      <div class=\"card\" id=\"card-basic-event-data\">\n        <div class=\"card-block\">\n          <iframe class=\"iframe\" frameBorder=\"0\" [src]=\"invoiceUrl | safe\"></iframe>\n        </div>\n      </div>\n\n    </div>\n  </div>\n</div>\n\n<div *ngIf=\"isMultiVendor()\" class=\"content-container\">\n  <div class=\"row\" style=\"padding-bottom: 0%\">\n    <iframe class=\"iframe\" frameBorder=\"0\" [src]=\"invoiceUrl | safe\"></iframe>\n  </div>\n</div>\n"

/***/ }),

/***/ "DCrO":
/***/ (function(module, exports) {

module.exports = "<div *ngIf=\"(dateRoomTypeDetail$ | async)?.length > 0\" class=\"card\">\n  <div class=\"card-header\" id=\"card-stay-summary\">{{'EVENT.OVERVIEW_CARDS.NIGHTS_BY_DATE_ROOM_TYPE_PER_DAY_TITLE' | translate}}</div>\n  <div class=\"card-summary-header\">\n    <table class=\"table\">\n      <thead>\n      <tr>\n        <th *ngFor=\"let total of dateRoomTypeTotal$ | async\">\n          {{total.nights}}\n        </th>\n      </tr>\n      </thead>\n      <tr>\n        <td *ngFor=\"let total of dateRoomTypeTotal$ | async\">\n          {{translateUnknownRoomType(total.roomType)}}\n        </td>\n      </tr>\n      <tbody>\n      </tbody>\n    </table>\n  </div>\n\n  <div class=\"table-responsive\">\n    <table class=\"table\">\n      <thead>\n        <tr>\n          <th>{{'EVENT.OVERVIEW_CARDS.DATE' | translate}}</th>\n          <th class=\"nights\" *ngFor=\"let total of dateRoomTypeTotal$ | async\">\n            {{translateUnknownRoomType(total.roomType)}}\n          </th>\n          <th class=\"nights\">{{'EVENT.OVERVIEW_CARDS.TOTAL_ROOMS' | translate}}</th>\n        </tr>\n      </thead>\n      <tbody>\n        <tr *ngFor=\"let detail of dateRoomTypeDetail$ | async\">\n          <td>{{detail.date | localeDateFormat}}</td>\n\n          <td class=\"nights\" *ngFor=\"let roomTypeNights of detail.nightsByRoomType\">\n            {{ roomTypeNights.nights }}\n          </td>\n          <td class=\"nights\">{{detail.total}}</td>\n        </tr>\n      </tbody>\n      <tfoot>\n        <tr>\n          <td class=\"nights\" *ngFor=\"let total of dateRoomTypeTotal$ | async\">\n            &nbsp;\n          </td>\n          <td>{{'EVENT.OVERVIEW_CARDS.TOTAL_ROOMS_NIGHTS' | translate}}</td>\n          <td class=\"nights\">{{ totalRoomNights$ | async }}</td>\n        </tr>\n      </tfoot>\n    </table>\n  </div>\n\n</div>\n"

/***/ }),

/***/ "DZNf":
/***/ (function(module, exports) {

module.exports = "<div class=\"modal fade\" bsModal [config]=\"config\" role=\"dialog\" tabindex=\"-1\" data-se-id=\"reservationModal\">\n  <div class=\"modal-dialog modal-xl\">\n    <div class=\"modal-content\">\n      <div class=\"modal-header\">\n        <h5 class=\"modal-title\">{{ title }}</h5>\n        <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\" (click)=\"cancel()\" data-se-id=\"closeReservationModal\">\n          <span aria-hidden=\"true\">&times;</span>\n        </button>\n      </div>\n      <div class=\"modal-body\">\n        <p class=\"text-muted text-warning\"></p>\n        <pioneer-reservation-form [event]=\"event\"></pioneer-reservation-form>\n      </div>\n      <div class=\"modal-footer\">\n        <small class=\"text-placeholder\">{{ placeholder }}</small>\n        <button type=\"button\" class=\"btn btn-link\" data-dismiss=\"modal\" (click)=\"cancel()\" data-se-id=\"cancelReservationModal\">{{'COMMON.BUTTON.CANCEL' | translate}}</button>\n        <button type=\"button\" class=\"btn btn-primary\" [disabled]=\"disableSave()\" (click)=\"accept()\" data-se-id=\"acceptReservationModal\">{{ \"COMMON.BUTTON.SAVE\" | translate }}</button>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),

/***/ "DxtM":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("rP7Y")(true);
// imports


// module
exports.push([module.i, ".order-one{-ms-flex-order:1!important;order:1!important}", "", {"version":3,"sources":["/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/payment/commission/commission.component.css"],"names":[],"mappings":"AAAA,WACE,2BAAA,iBAAoB,CACrB","file":"commission.component.css","sourcesContent":[".order-one {\n  order: 1 !important;\n}\n"],"sourceRoot":""}]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),

/***/ "EK+0":
/***/ (function(module, exports) {

module.exports = "<div class=\"content-container\">\n  <div class=\"card-content\">\n    <div *ngIf=\"messages !== undefined\">\n      <div  *ngFor=\"let item of messages\">\n        <div class=\"card alert-banner mb-4\" *ngIf=\"item.closed == false\">\n          <div class=\"row\">\n            <div\n              class=\"col-11 align-content-center\"\n              [innerHTML]=\"item.message\"\n            ></div>\n            <div class=\"col-1 text-right\">\n              <button class=\"btn\" (click)=\"item.closed = true\">\n                <img class=\"close-icon\" src=\"assets/svg/close-md.svg\" />\n              </button>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n    <div  class=\"row mb-4\" >\n      <div class=\"row col-md-8 welcome-banner\" *ngIf=\"username.username.length > 1 ;else welcome_default\">\n        {{'DASHBOARD_AGENCY.WELCOME.WITH_NAME' | translate: username}}\n      </div>\n      <div class=\"col-md-4 data-updated\">\n        {{'DASHBOARD_AGENCY.WELCOME.UPDATE_DATE' | translate}}<span>{{ updateDate | date : \"EEE, dd MMM yyyy HH:mm:ss Z\" }}</span>\n      </div>\n    </div>\n    <ng-template #welcome_default>\n      <div class=\"row col-md-8 welcome-banner\">{{'DASHBOARD_AGENCY.WELCOME.DEFAULT' | translate}}\n      </div>\n    </ng-template>\n      <div class=\"row\">\n      <div class=\"col-md-8\">\n        <div class=\"row overview-banner mb-3\" *ngIf=\"showOverview()\">\n          <div class=\"col-sm-8 overview-title\">{{'DASHBOARD_AGENCY.OVERVIEW.TITLE' | translate}}</div>\n          <div class=\"col-sm-4 overview-select\">\n            <select [(ngModel)]=\"headerSelected\" (change)=\"onHeaderSelectChange($event.target.value)\">\n              <option value=\"all\">{{'DASHBOARD_AGENCY.SELECT.ALL' | translate}}</option>\n              <option value=\"7\">{{'DASHBOARD_AGENCY.SELECT.WEEK' | translate}}</option>\n              <option value=\"30\">{{'DASHBOARD_AGENCY.SELECT.MONTH' | translate}}</option>\n              <option value=\"90\">{{'DASHBOARD_AGENCY.SELECT.QUARTER' | translate}}</option>\n              <option value=\"this\">{{'DASHBOARD_AGENCY.SELECT.CURRENT_YEAR' | translate}}</option>\n              <option value=\"last\">{{'DASHBOARD_AGENCY.SELECT.LAST_YEAR' | translate}}</option>\n            </select>\n          </div>\n        </div>\n        <div class=\"card-deck overview-panels\" *ngIf=\"showOverview()\">\n          <div class=\"card totals-card\" [ngClass]=\"{ 'is-loading': overview === undefined }\">\n            <div class=\"total-panel\" tooltip=\"{{'DASHBOARD_AGENCY.OVERVIEW.TOOL_TIP' | translate }}\">\n              <div class=\"total-text\" *ngIf=\"overview !== undefined\">\n                {{ overview.tot_comm_amt_str }}\n                <span class=\"currency\">{{ overview.currency }}\n                </span>\n              </div>\n            </div>\n            <div class=\"sub-text\">{{'DASHBOARD_AGENCY.OVERVIEW.TOTAL_AMT' | translate}}</div>\n          </div>\n          <div class=\"card totals-card\" [ngClass]=\"{ 'is-loading': overview === undefined }\">\n            <div class=\"total-panel\" tooltip=\"{{'DASHBOARD_AGENCY.OVERVIEW.TOOL_TIP' | translate }}\">\n              <div class=\"total-text\" *ngIf=\"overview !== undefined\">\n                {{ overview.tot_pmt_amt_str }}\n                <span class=\"currency\">{{ overview.currency }}</span>\n              </div>\n            </div>\n            <div class=\"sub-text\">{{'DASHBOARD_AGENCY.OVERVIEW.TOTAL_PAID' | translate}}</div>\n          </div>\n          <div class=\"card totals-card\" [ngClass]=\"{ 'is-loading': overview === undefined }\">\n            <div class=\"total-panel\">\n              <div class=\"total-text\" *ngIf=\"overview !== undefined\">\n                {{ overview.perc_comm_paid }}%\n              </div>\n            </div>\n            <div class=\"sub-text\">{{'DASHBOARD_AGENCY.OVERVIEW.COMM_PAID' | translate}}</div>\n          </div>\n        </div>\n        <pioneer-dashboard-to-do-card [todolist]=\"todolist\"></pioneer-dashboard-to-do-card>\n        <div\n          class=\"card recently\"\n          [ngClass]=\"{ 'is-loading': dataAll === undefined }\"\n        >\n          <div class=\"recently-title\">{{ 'DASHBOARD_AGENCY.RECENTLY.TITLE' | translate }}</div>\n          <div class=\"row col-12 recently-table\">\n            <table class=\"table\">\n              <thead>\n                <tr>\n                  <th scope=\"col\">{{ 'DASHBOARD_AGENCY.RECENTLY.EVENT_NAME' | translate }}</th>\n                  <th scope=\"col\">{{ 'DASHBOARD_AGENCY.RECENTLY.MEETING_ID' | translate }}</th>\n                  <th scope=\"col\">{{ 'DASHBOARD_AGENCY.RECENTLY.LOCATION' | translate }}</th>\n                  <th scope=\"col\" class=\"column-right\">{{ 'DASHBOARD_AGENCY.RECENTLY.DATE' | translate }}</th>\n                  <th *ngIf=\"false\" scope=\"col\" class=\"column-right\">{{ 'DASHBOARD_AGENCY.RECENTLY.ESTIMATED' | translate }}</th>\n                </tr>\n              </thead>\n              <tbody  *ngIf=\"lastmodified !== undefined\">\n                <tr\n                  *ngFor=\"let item of lastmodified\"\n                  [routerLink]=\"['/event/' + item.event_id]\"\n                >\n                  <td class=\"column-event\">{{ item.event_name }}</td>\n                  <td>{{ item.meeting_id }}</td>\n                  <td>{{ item.location | uppercase }}</td>\n                  <td class=\"column-right\">\n                    {{ item.event_start_date | date : \"MM/dd/yyyy\" }}\n                  </td>\n                  <td *ngIf=\"false\" class=\"column-right\">\n                    {{\n                      item.estimated_due !== null ? item.estimated_due : \"NA\"\n                    }}\n                  </td>\n                </tr>\n              </tbody>\n              <tbody *ngIf=\"lastmodified === undefined\">\n                <tr>\n                  <td style=\"width: 320px;\"><div class=\"row-loading\"></div></td>\n                  <td><div class=\"row-loading\"></div></td>\n                  <td><div class=\"row-loading\"></div></td>\n                  <td><div class=\"row-loading\"></div></td>\n                </tr>\n                <tr>\n                  <td><div class=\"row-loading\"></div></td>\n                  <td><div class=\"row-loading\"></div></td>\n                  <td><div class=\"row-loading\"></div></td>\n                  <td><div class=\"row-loading\"></div></td>\n                </tr>\n                <tr>\n                  <td><div class=\"row-loading\"></div></td>\n                  <td><div class=\"row-loading\"></div></td>\n                  <td><div class=\"row-loading\"></div></td>\n                  <td><div class=\"row-loading\"></div></td>\n                </tr>\n                <tr>\n                  <td><div class=\"row-loading\"></div></td>\n                  <td><div class=\"row-loading\"></div></td>\n                  <td><div class=\"row-loading\"></div></td>\n                  <td><div class=\"row-loading\"></div></td>\n                </tr>\n                <tr>\n                  <td><div class=\"row-loading\"></div></td>\n                  <td><div class=\"row-loading\"></div></td>\n                  <td><div class=\"row-loading\"></div></td>\n                  <td><div class=\"row-loading\"></div></td>\n                </tr>\n              </tbody>\n            </table>\n\n          </div>\n          <div class=\"row col-12 view-button\">\n            <button\n              class=\"btn btn-primary\"\n              data-se-id=\"view-all-events-button\"\n              (click)=\"navigateToSearch()\"\n            >\n            {{ 'DASHBOARD_AGENCY.RECENTLY.VIEW_ALL' | translate }}\n            </button>\n          </div>\n        </div>\n      </div>\n      <div class=\"col-md-4\">\n        <div\n          class=\"card status-card is-loading\"\n          [ngClass]=\"{ 'is-loading': status === undefined }\"\n        >\n          <div class=\"row status-banner\">\n            <div class=\"col-7 status-title\">Payment Status</div>\n            <div class=\"col-5 status-select\">\n              <select [(ngModel)]=\"statusSelected\" (change)=\"onStatusSelectChange($event.target.value)\">\n                <option value=\"all\">{{'DASHBOARD_AGENCY.SELECT.ALL' | translate}}</option>\n                <option value=\"7\">{{'DASHBOARD_AGENCY.SELECT.WEEK' | translate}}</option>\n                <option value=\"30\">{{'DASHBOARD_AGENCY.SELECT.MONTH' | translate}}</option>\n                <option value=\"90\">{{'DASHBOARD_AGENCY.SELECT.QUARTER' | translate}}</option>\n                <option value=\"this\">{{'DASHBOARD_AGENCY.SELECT.CURRENT_YEAR' | translate}}</option>\n                <option value=\"last\">{{'DASHBOARD_AGENCY.SELECT.LAST_YEAR' | translate}}</option>\n              </select>\n            </div>\n          </div>\n          <div class=\"status-chart\">\n            <div class=\"status-total-label\"></div>\n            <pioneer-status-chart\n              [chartData]=\"status\"\n              [height]=\"300\"\n              [width]=\"300\"\n              *ngIf=\"status !== undefined\"\n            ></pioneer-status-chart>\n          </div>\n          <div class=\"status-labels\">\n            <div class=\"status-amount\"></div>\n            <div class=\"status-color\"></div>\n            <div class=\"status-description\"></div>\n          </div>\n          <div class=\"status-labels\">\n            <div class=\"status-amount\"></div>\n            <div class=\"status-color\"></div>\n            <div class=\"status-description\"></div>\n          </div>\n          <div class=\"status-labels\">\n            <div class=\"status-amount\"></div>\n            <div class=\"status-color\"></div>\n            <div class=\"status-description\"></div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n\n<pioneer-update-status-popup> </pioneer-update-status-popup>\n"

/***/ }),

/***/ "EqCs":
/***/ (function(module, exports) {

module.exports = "<div class=\"left-nav\">\n  <ul class=\"nav flex-column\" id=\"nav-left-list\">\n    <li class=\"nav-item menu-toggle\">\n      <i class=\"glyph-hamburger nav-link\" (click)=\"toggleNavCollapsed()\"></i>\n    </li>\n\n    <li class=\"nav-item\" *pioneerAuthorize=\"{permission: 'ViewDashboard'}\">\n      <a *ngIf=\"!isOnDashboard()\"\n         href=\"#nav-dashboard-list\"\n         class=\"nav-link\"\n         data-toggle=\"collapse\"\n         data-parent=\"#nav-left-list\"\n         [routerLink]=\"['/dashboard']\">\n\n        <i class=\"glyph-guage nav-link-addon\"></i>\n        <span class=\"item-text\">{{ 'COMMON.NAV.DASHBOARD.LABEL' | translate }}</span>\n        <i class=\"nav-link-addon glyph-arrow-down\"></i>\n      </a>\n      <a *ngIf=\"isOnDashboard()\"\n         href=\"#nav-dashboard-list\"\n         class=\"nav-link active\"\n         data-toggle=\"collapse\"\n         data-parent=\"#nav-left-list\">\n\n        <i class=\"glyph-guage nav-link-addon\"></i>\n        <span class=\"item-text\">{{ 'COMMON.NAV.DASHBOARD.LABEL' | translate }}</span>\n        <i class=\"nav-link-addon glyph-arrow-down\"></i>\n      </a>\n      <ul *ngIf=\"isOnDashboard()\"\n          class=\"sub-nav collapse show\"\n          id=\"nav-dashboard-list\">\n        <li class=\"nav-item\">\n          <a href=\"javascript:void(0)\"\n             class=\"nav-link\"\n             (click)=\"completedAndUnpaidPredefinedSearch()\"\n             data-se-id=\"completed-and-unpaid-predefined-search\">\n            <span *ngIf=\"showCompletedAndUnpaidTotals() | async\"\n                  class=\"count\">{{ completedAndUnpaidTotal | async }}</span>\n            <span class=\"item-text\">{{ 'COMMON.NAV.DASHBOARD.CARDS.COMPLETED_AND_UNPAID' | translate }}</span>\n          </a>\n        </li>\n        <li class=\"nav-item\" *pioneerAuthorize=\"{permission: 'ViewMissingAgencyElements'}\">\n          <a href=\"javascript:void(0)\"\n             (click)=\"missingAgencyPredefinedSearch()\"\n             class=\"nav-link\"\n             data-se-id=\"missing-agency-predefined-search\">\n            <span *ngIf=\"showMissingAgencyTotals() | async\" class=\"count\">{{ missingAgencyTotal | async }}</span>\n            <span class=\"item-text\">{{ 'COMMON.NAV.DASHBOARD.CARDS.MISSING_AGENCY' | translate }}</span>\n          </a>\n        </li>\n      </ul>\n    </li>\n\n    <li class=\"nav-item\">\n      <a *ngIf=\"!isOnSearchEvents()\"\n         class=\"nav-link\"\n         href=\"#nav-filters\"\n         data-toggle=\"collapse\"\n         data-parent=\"#nav-left-list\"\n         (click)=\"navigateToSearch()\"\n         data-se-id=\"viewEventsLink\">\n\n        <i class=\"glyph-search nav-link-addon\"></i>\n        <span class=\"item-text\">\n          {{ 'COMMON.NAV.SEARCH_EVENTS.LABEL' | translate }}\n        </span>\n        <i class=\"nav-link-addon glyph-arrow-down\" *pioneerAuthorize=\"{permission: 'EventSearch'}\"></i>\n      </a>\n      <a *ngIf=\"isOnSearchEvents()\"\n         class=\"nav-link active\"\n         data-toggle=\"collapse\"\n         data-parent=\"#nav-left-list\"\n         href=\"#nav-filters\"\n         data-se-id=\"viewEventsLink\">\n        <i class=\"glyph-search nav-link-addon\"></i>\n        <span class=\"item-text\">\n          {{ 'COMMON.NAV.SEARCH_EVENTS.LABEL' | translate }}\n        </span>\n        <i class=\"nav-link-addon glyph-arrow-down\" *pioneerAuthorize=\"{permission: 'EventSearch'}\"></i>\n      </a>\n\n      <pioneer-event-search-filter *ngIf=\"isOnSearchEvents()\"></pioneer-event-search-filter>\n\n    </li>\n    <li class=\"nav-item\" *pioneerAuthorize=\"{permission: 'AddEvent'}\">\n      <a class=\"nav-link\"\n         [routerLink]=\"['/events/add']\"\n         routerLinkActive=\"active\"\n         [routerLinkActiveOptions]=\"{exact:true}\"\n         data-se-id=\"addEventLink\">\n        <i class=\"glyph-plus nav-link-addon\"></i>\n        <span class=\"item-text\">{{ 'COMMON.NAV.ADD_EVENT' | translate }}</span>\n      </a>\n    </li>\n    <li class=\"nav-item\" *pioneerAuthorize=\"{permission: 'AddEvent'}\">\n      <a class=\"nav-link\"\n         [routerLink]=\"['/events/event-match']\"\n         routerLinkActive=\"active\"\n         [routerLinkActiveOptions]=\"{exact:true}\"\n         data-se-id=\"eventMatchLink\">\n        <i class=\"far fa-solid fa-list nav-link-addon\"></i>\n        <span class=\"item-text\">{{ 'COMMON.NAV.EVENT_MATCH' | translate }}</span>\n      </a>\n    </li>\n    <li class=\"nav-item\" *pioneerAuthorize=\"{permission: 'ViewInternalReview'}\">\n      <a class=\"nav-link\"\n         [routerLink]=\"['/events/matching/property']\"\n         routerLinkActive=\"active\"\n         [routerLinkActiveOptions]=\"{exact:true}\"\n         data-se-id=\"propertyMatchesLink\">\n        <i class=\"far fa-exchange nav-link-addon\"></i>\n        <span class=\"item-text\">\n          {{ 'COMMON.NAV.PROPERTY_MATCHES' | translate: {\n          propertyMatches: propertyMatchesTotal | async\n        }\n          }}\n        </span>\n      </a>\n    </li>\n    <li class=\"nav-item\" *pioneerAuthorize=\"{permission: 'ViewMstrReports'}\">\n      <a\n        class=\"nav-link\"\n        href=\"javascript:void(0)\"\n        (click)=\"callMicrostrategy()\"\n        data-se-id=\"mstrLink\">\n        <i class=\"far fa-solid fa-file nav-link-addon\"></i>\n        <span class=\"item-text\">\n          {{ 'COMMON.NAV.BI_REPORTS' | translate }}\n        </span>\n\n      </a>\n    </li>\n    <li class=\"nav-item\" *ngIf=\"showInvoiceHistory\">\n      <a class=\"nav-link\"\n         [routerLink]=\"['/events/invoice-history']\"\n         routerLinkActive=\"active\"\n         [routerLinkActiveOptions]=\"{exact:true}\"\n         data-se-id=\"invoiceHistoryLink\">\n         <i class=\"far fa-solid fa-file nav-link-addon\"></i>\n        <span class=\"item-text\">{{ 'COMMON.NAV.INVOICE_HISTORY' | translate }}</span>\n      </a>\n    </li>\n    <router-outlet name=\"event\"></router-outlet>\n  </ul>\n</div>\n"

/***/ }),

/***/ "Evt2":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("rP7Y")(true);
// imports


// module
exports.push([module.i, ".items-link{color:#23c0d2}", "", {"version":3,"sources":["/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/payment/add-adjustment/add-adjustment.component.css"],"names":[],"mappings":"AACA,YACE,aAAe,CAChB","file":"add-adjustment.component.css","sourcesContent":["\n.items-link {\n  color: #23C0D2;\n}\n"],"sourceRoot":""}]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),

/***/ "F5Qg":
/***/ (function(module, exports) {

module.exports = "<div class=\"card\" [formGroup]=\"contactForm\" id=\"card-{{partyType | lowercase}}\">\n  <div class=\"card-header\">\n    {{ contactTypeTitle }} {{ 'EVENT.CONTACT_TITLE' | translate }}\n  </div>\n  <div class=\"card-block\">\n\n    <pioneer-child-contact-form [contactForm]=\"contactForm\"\n                                [partyType]=\"partyType\"\n                                [event]=\"onyxEvent\"\n                                [contactReferenceNumberTitle]=\"contactReferenceNumberTitle\"\n                                [isReadOnly]=\"isReadOnly\"\n                                [clientContactEditable]=\"clientContactEditable\">\n    </pioneer-child-contact-form>\n\n\n  </div>\n</div>\n"

/***/ }),

/***/ "FA5L":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("rP7Y")(true);
// imports


// module
exports.push([module.i, ".view-button{-ms-flex-pack:right;justify-content:right}", "", {"version":3,"sources":["/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/agency-dashboard/update-status-popup/update-status-popup.component.css"],"names":[],"mappings":"AAAA,aACE,oBAAA,qBAAuB,CACxB","file":"update-status-popup.component.css","sourcesContent":[".view-button {\n  justify-content: right;\n}"],"sourceRoot":""}]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),

/***/ "FEP9":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("rP7Y")(true);
// imports


// module
exports.push([module.i, ".order-one{-ms-flex-order:1!important;order:1!important}", "", {"version":3,"sources":["/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/invoice-history-vendor/invoice-history-vendor.component.css"],"names":[],"mappings":"AAAA,WACE,2BAAA,iBAAoB,CACrB","file":"invoice-history-vendor.component.css","sourcesContent":[".order-one {\n  order: 1 !important;\n}\n"],"sourceRoot":""}]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),

/***/ "FS9g":
/***/ (function(module, exports) {

module.exports = "<p>\n  {{'ROUTE_NOT_FOUND.DESCRIPTION' | translate}}\n</p>\n"

/***/ }),

/***/ "FgJP":
/***/ (function(module, exports) {

module.exports = "<div class=\"card-content max-width-100 p-0\">\n  <div class=\"card\">\n    <div class=\"card-header\">\n      {{cardHeader}}\n    </div>\n    <div class=\"card-block\">\n      <p *ngIf=\"reason\">\n        {{description?.value}}\n      </p>\n      <p *ngIf=\"reason\">\n        <strong>{{'COMMON.NAMES.DETAILS' | translate}}:</strong>\n        {{details?.value}}\n      </p>\n      <p>\n        <strong>{{'COMMON.NAMES.DATE' | translate}}:</strong>\n        {{datetime | date: 'MM/dd/yyyy'}}\n      </p>\n      <p>\n        <strong>{{'COMMON.NAMES.TIME' | translate}}:</strong>\n        {{datetime | date: 'HH:mm'}}\n      </p>\n      <p>\n        <strong>{{'EVENT.COMMISSION.ACTION_BY' | translate: {actionBy: actionBy} }}</strong>\n        {{email?.value}}\n      </p>\n    </div>\n  </div>\n</div>"

/***/ }),

/***/ "GQMu":
/***/ (function(module, exports) {

module.exports = "<div class=\"row justify-content-between\" *ngIf=\"existItems\">\n  <div class=\"col\" *ngIf=\"headerTitle\">\n    <span class=\"summary-title\">{{ headerTitle }}</span>\n  </div>\n  <div [ngClass]=\"divTableStyle\">\n    <table [ngClass]=\"tableStyle\">\n      <thead>\n      <tr data-se-id=\"staySummaryRow\">\n        <th data-se-id=\"totalItems\">{{(staySummary | async)?.totalItems}}</th>\n        <th data-se-id=\"totalNights\">{{(staySummary | async)?.totalNights}}</th>\n        <th class=\"currency\"  data-se-id=\"avgRoomRate\">\n          {{ (staySummary | async)?.avgRoomRate | number:'1.2-2' }}\n        </th>\n        <th class=\"currency\"  data-se-id=\"totalRevenue\">\n          <span [class.commission-sum]=\"isAbbreviated((staySummary | async)?.totalRevenue)\">\n            <span class=\"res-value\"\n                tooltip=\"{{ (staySummary | async)?.totalRevenue | number:'1.2-2' }} {{ onyxEvent.currency | uppercase }}\"\n                placement=\"right\"\n                triggers=\"mouseenter:mouseleave\"\n                container=\"body\">\n              {{ (staySummary | async)?.totalRevenue | abbreviateAmount }}\n            </span>\n          </span>\n        </th>\n        <th class=\"currency\"  data-se-id=\"totalCommission\">\n          <span [class.commission-sum]=\"isAbbreviated( (staySummary | async)?.totalCommission )\">\n            <span class=\"res-value\"\n                tooltip=\"{{ (staySummary | async)?.totalCommission | number:'1.2-2' }} {{ onyxEvent.currency | uppercase }}\"\n                placement=\"right\"\n                triggers=\"mouseenter:mouseleave\"\n                container=\"body\">\n              {{ (staySummary | async)?.totalCommission | abbreviateAmount }}\n            </span>\n          </span>\n        </th>\n      </tr>\n      </thead>\n      <tbody>\n      <tr>\n        <td>\n          {{recordType | translate}}\n          <span tooltip=\"{{headerTooltip}}\"\n                placement=\"right\"\n                triggers=\"mouseenter:mouseleave\"\n                container=\"body\"\n                *ngIf=\"headerTooltip\">\n              <i class=\"fal fa-question-circle text-muted\"></i>\n          </span>\n        </td>\n        <td>{{'EVENT.COMMISSION.ROOM_NIGHTS' | translate}}</td>\n        <td>{{'EVENT.COMMISSION.AVG_ROOM_RATE' | translate}}</td>\n        <td>{{'EVENT.COMMISSION.REVENUE' | translate}}</td>\n        <td>{{'EVENT.COMMISSION.COMMISSION' | translate}}</td>\n      </tr>\n      </tbody>\n    </table>\n  </div>\n</div>\n"

/***/ }),

/***/ "Gfsy":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("rP7Y")(true);
// imports


// module
exports.push([module.i, "@keyframes shine{to{background-position-x:-200%}}.to-do-list{padding:1rem 1.5rem;.to-do-title{height:17px;box-sizing:border-box;font-family:OpenSans-Bold,Open Sans Bold,Open Sans,sans-serif;font-weight:700;color:#292b2c;text-align:left;line-height:17px;letter-spacing:1px;margin-top:8px;margin-bottom:16px;font-size:17px}td{border-width:0 0 1px!important;padding:12px 2px 8px 2px!important}tr:hover{background-color:#eef8ff;cursor:pointer}.column-total{font-weight:700;text-align:right}.form-search{width:100%}.search-event{max-width:100%}.open-icon{height:18px;width:18px;margin-right:4px;filter:invert(13%) sepia(7%) saturate(362%) hue-rotate(156deg)\n      brightness(94%) contrast(88%)}.btn{background-color:#fff;border:1px;border-style:solid;border-color:#22c8d9;padding:.6rem 1rem;font-family:OpenSans-Regular,Open Sans,sans-serif;color:#292b2c;font-size:12px;line-height:normal}}.to-do-list.is-loading{.row-loading{background:#eee;background:linear-gradient(110deg,#ececec 8%,#f5f5f5 18%,#ececec 33%);border-radius:5px;background-size:200% 100%;animation:1.5s shine linear infinite;height:20px}}", "", {"version":3,"sources":["/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/agency-dashboard/dashboard-to-do-card/dashboard-to-do-card.component.css"],"names":[],"mappings":"AAAA,iBACE,GACE,2BAA6B,CAC9B,CACF,YAGC,oBAAqB,aAEnB,YAAa,sBACU,8DACiD,gBACvD,cACF,gBACE,iBACC,mBACE,eACJ,mBACI,cACJ,CACjB,GAEC,+BAAiC,kCACI,CACtC,SAEC,yBAA0B,cACV,CACjB,cAEC,gBAAkB,gBACA,CACnB,aAEC,UAAY,CACb,cAEC,cAAgB,CACjB,WAEC,YAAa,WACD,iBACM;mCAEc,CACjC,KAGC,sBAAuB,WACX,mBACQ,qBACE,mBACD,kDACoC,cAC1C,eACC,kBACI,CACrB,CACF,uBAEC,aACE,gBAAiB,sEACyD,kBACvD,0BACQ,qCACW,WACzB,CACd,CACF","file":"dashboard-to-do-card.component.css","sourcesContent":["@keyframes shine {\n  to {\n    background-position-x: -200%;\n  }\n}\n\n.to-do-list {\n  padding: 1rem 1.5rem;\n  .to-do-title {\n    height: 17px;\n    box-sizing: border-box;\n    font-family: \"OpenSans-Bold\", \"Open Sans Bold\", \"Open Sans\", sans-serif;\n    font-weight: 700;\n    color: #292b2c;\n    text-align: left;\n    line-height: 17px;\n    letter-spacing: 1px;\n    margin-top: 8px;\n    margin-bottom: 16px;\n    font-size: 17px;\n  }\n  td {\n    border-width: 0 0 1px !important;\n    padding: 12px 2px 8px 2px !important;\n  }\n  tr:hover {\n    background-color: #eef8ff;\n    cursor: pointer;\n  }\n  .column-total {\n    font-weight: bold;\n    text-align: right;\n  }\n  .form-search{\n    width: 100%;\n  }\n  .search-event {\n    max-width: 100%;\n  }\n  .open-icon {\n    height: 18px;\n    width: 18px;\n    margin-right: 4px;\n    filter: invert(13%) sepia(7%) saturate(362%) hue-rotate(156deg)\n      brightness(94%) contrast(88%);\n  }\n\n  .btn {\n    background-color: #fff;\n    border: 1px;\n    border-style: solid;\n    border-color: #22c8d9;\n    padding: 0.6rem 1rem;\n    font-family: \"OpenSans-Regular\", \"Open Sans\", sans-serif;\n    color: #292b2c;\n    font-size: 12px;\n    line-height: normal;\n  }\n}\n.to-do-list.is-loading {\n  .row-loading {\n    background: #eee;\n    background: linear-gradient(110deg, #ececec 8%, #f5f5f5 18%, #ececec 33%);\n    border-radius: 5px;\n    background-size: 200% 100%;\n    animation: 1.5s shine linear infinite;\n    height: 20px;\n  }\n}\n"],"sourceRoot":""}]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),

/***/ "ISFW":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("rP7Y")(true);
// imports


// module
exports.push([module.i, ".commission-sum{float:none!important}", "", {"version":3,"sources":["/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/overview/header-summary/header-summary.component.css"],"names":[],"mappings":"AAAA,gBACE,oBAAuB,CACxB","file":"header-summary.component.css","sourcesContent":[".commission-sum {\n  float: none !important;\n}"],"sourceRoot":""}]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),

/***/ "ISUr":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("rP7Y")(true);
// imports


// module
exports.push([module.i, ".form-group{margin-bottom:-2em}.table-responsive{max-height:29em}.ooiv{font-size:small;margin-bottom:revert}", "", {"version":3,"sources":["/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/bulk-action/bulk-action-popup/bulk-action-popup.component.css"],"names":[],"mappings":"AAAA,YACE,kBAAoB,CACrB,kBAEC,eAAiB,CAClB,MAEC,gBAAiB,oBACK,CACvB","file":"bulk-action-popup.component.css","sourcesContent":[".form-group {\n  margin-bottom: -2em;\n}\n.table-responsive {\n  max-height: 29em;\n}\n.ooiv {\n  font-size: small;\n  margin-bottom: revert;\n}\n"],"sourceRoot":""}]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),

/***/ "IoFL":
/***/ (function(module, exports) {

module.exports = "<div class=\"card\">\n  <div class=\"card-header\" id=\"card-stay-information\">{{'EVENT.COMMISSION.DETAILS' | translate}}\n  </div>\n  <div class=\"table-responsive\">\n    <table class=\"table\">\n      <thead>\n      <tr>\n        <th>{{'EVENT.COMMISSION.NAME' | translate}}</th>\n        <th>{{'EVENT.COMMISSION.CONFIRMATION_NUMBER' | translate}}</th>\n        <th>{{'EVENT.COMMISSION.CHECKIN_DATE' | translate}}</th>\n        <th>{{'EVENT.COMMISSION.CHECKOUT_DATE' | translate}}</th>\n        <th class=\"nights\">{{'EVENT.COMMISSION.NUMBER_NIGHTS' | translate}}</th>\n        <th>{{'EVENT.COMMISSION.ROOM_TYPE' | translate}}</th>\n        <th class=\"currency\">\n          {{'EVENT.COMMISSION.ROOM_RATE' | translate}}\n          <br><small>({{ onyxEvent.currency | uppercase }})</small>\n        </th>\n        <th class=\"currency\">\n          {{'EVENT.COMMISSION.REVENUE' | translate}}\n          <br><small>({{ onyxEvent.currency | uppercase }})</small>\n        </th>\n        <th class=\"currency\">\n          {{'EVENT.COMMISSION.COMMISSION' | translate}}\n          <br><small>({{ onyxEvent.currency | uppercase }})</small>\n        </th>\n      </tr>\n      </thead>\n      <tbody>\n      <tr *ngFor=\"let rsvp of rsvpsPage?.content\"\n          data-se-id=\"rsvpRow\">\n        <td class=\"field-wrap\" data-se-id=\"lastName\">{{rsvp.lastName}}, {{rsvp.firstName}}</td>\n        <td>{{rsvp.confirmation}}</td>\n        <td>{{rsvp.checkInDate | dateFormat}}</td>\n        <td>{{rsvp.checkOutDate | dateFormat}}</td>\n        <td class=\"nights\">{{rsvp.nights}}</td>\n        <td>{{rsvp.roomType}}</td>\n        <td class=\"currency\">{{ rsvp.roomRate | number:'1.2-2' }}</td>\n        <td class=\"currency\" data-se-id=\"revenue\">{{ rsvp.revenue | number:'1.2-2' }}\n        </td>\n        <td class=\"currency\" data-se-id=\"commission\">{{ rsvp.commission | number:'1.2-2' }}\n        </td>\n      </tr>\n      </tbody>\n      <tfoot>\n      <tr data-se-id=\"rsvpSummaryRow\">\n        <td>{{'EVENT.COMMISSION.TOTAL' | translate}}</td>\n        <td></td>\n        <td></td>\n        <td></td>\n        <td class=\"nights\">{{ staySummary?.totalNights }}</td>\n        <td></td>\n        <td></td>\n        <td class=\"currency\">{{ staySummary?.totalRevenue | number:'1.2-2' }}</td>\n        <td class=\"currency\" data-se-id=\"totalCommission\">\n          {{ staySummary?.totalCommission | number:'1.2-2' }}\n        </td>\n      </tr>\n      </tfoot>\n    </table>\n  </div>\n  <div class=\"card-footer\" *ngIf=\"rsvpsPage?.totalElements > 0\">\n    <pioneer-pagination\n      [resultsPage]=\"rsvpsPage\"\n      (updatePage)=\"goToRecordsPage($event.page)\"\n      [pagesizeType]=\"pagesizeType\">\n    </pioneer-pagination>\n  </div>\n</div>\n"

/***/ }),

/***/ "J4+O":
/***/ (function(module, exports) {

module.exports = "<div class=\"card-content max-width-100 p-0\">\n  <div class=\"card\">\n    <div class=\"card-header form-required\">\n      {{'EVENT.COMMISSION.REJECTION_REASONS_HEADER' | translate}} <span class=\"text-danger\">*</span>\n    </div>\n    <div class=\"card-block\" [formGroup]=\"form\">\n      <div class=\"form-group\">\n        <div class=\"form-check\" *ngFor=\"let reason of reasons\">\n          <label class=\"custom-control custom-radio\">\n            <input type=\"radio\" class=\"custom-control-input\" formControlName=\"reason\" value=\"{{reason?.value}}\">\n            <span class=\"custom-control-indicator\"></span>\n            <span class=\"custom-control-description\">{{reason?.description}}</span>\n          </label>\n        </div>\n      </div>\n      <div class=\"form-group form-required\" [hidden]=\"!reason?.dirty\">\n        <pioneer-form-input label=\"COMMON.NAMES.DETAILS\" message=\"MESSAGES.VALIDATION.REJECT_DETAILS\">\n          <textarea class=\"form-control\" formControlName=\"details\" rows=\"10\" maxlength=\"500\"\n            placeholder=\"{{'EVENT.COMMISSION.REJECT_DETAILS_PLACEHOLDER' | translate}}\">\n          </textarea>\n          <span class=\"pull-right char\"><em>{{ 500 - details?.value.length }} {{'COMMON.FORMS.CHAR_REMAINING' | translate}}</em></span>\n        </pioneer-form-input>\n      </div>\n    </div>\n  </div>\n</div>"

/***/ }),

/***/ "JVpk":
/***/ (function(module, exports) {

module.exports = "<div class=\"content-container\" *pioneerAuthorize=\"{permission: 'LinkReservation'}\" data-se-id=\"transientReservation\">\n\n  <div class=\"row\">\n\n    <div class=\"card-content\">\n\n      <div class=\"card\" id=\"card-transient-reservation\">\n\n        <div class=\"card-header\" id=\"card-reservation-list\">\n          {{'EVENT.TRANSIENT_RESERVATION.SEARCH_TITLE' | translate }}\n          <span tooltip=\"{{'EVENT.TRANSIENT_RESERVATION.SEARCH_TITLE_TOOLTIP' | translate }}\"\n                placement=\"right\"\n                triggers=\"mouseenter:mouseleave\"\n                container=\"body\">\n            <i class=\"fal fa-question-circle text-muted\"></i>\n          </span>\n        </div>\n\n        <div class=\"card-block\">\n          <pioneer-transient-search\n            [event]=\"onyxEvent\"\n            [searchResults]=\"searchResults\"\n            (hasSearched)=\"onHasSearched()\"\n            (searchClicked)=\"onSearchClicked()\"\n            [validateNameFilters]=\"false\"\n            [isRatePlanCodeFilterVisible]=\"true\"\n            [isConfirmationFilterVisible]=\"true\"\n            data-se-id=\"transientReservationSearch\">\n          </pioneer-transient-search>\n        </div>\n\n        <pioneer-transient-table\n          *ngIf=\"hasSearched\"\n          [event]=\"onyxEvent\"\n          [searchResults]=\"searchResults\"\n          (updatePage)=\"onRefreshList($event.page)\"\n          [selectorType]=\"'checkbox'\"\n          data-se-id=\"transientReservationTable\">\n        </pioneer-transient-table>\n\n        <div class=\"card-footer\" *ngIf=\"searchResults?.totalElements > 0\">\n          <pioneer-pagination\n            [resultsPage]=\"searchResults\"\n            (updatePage)=\"onRefreshList($event.page)\"\n            [pagesizeType]=\"pagesizeType\">\n          </pioneer-pagination>\n        </div>\n\n        <div *ngIf=\"!hasSearched\" class=\"card-watermark mb-4\" data-se-id=\"beginSearchMessage\">\n          <h3 class=\"mb-2\">{{'EVENT.TRANSIENT_RESERVATION.BEGIN_SEARCH' | translate }}</h3>\n          <figure class=\"figure\">\n            <figcaption class=\"figure-caption\">\n              {{'EVENT.TRANSIENT_RESERVATION.BEGIN_SEARCH_CAPTION' | translate }}\n            </figcaption>\n          </figure>\n        </div>\n\n      </div>\n\n    </div>\n\n  </div>\n\n</div>\n"

/***/ }),

/***/ "JWMH":
/***/ (function(module, exports) {

module.exports = "<pioneer-confirmation-modal\n  data-se-id=\"add-property-confirmation-modal\"\n  content=\"MESSAGES.CONFIRMATION.PROCEED\"\n  cancel=\"COMMON.BUTTON.CANCEL\"\n  [confirm]=\"confirmationModalConfig.confirm\"\n  [title]=\"confirmationModalConfig.title\"\n  (closed)=\"confirmBeforeAddPropertyHandler($event)\">\n</pioneer-confirmation-modal>\n\n<div class=\"content-container\">\n  <div class=\"row\">\n    <div class=\"card-content\">\n      <div class=\"card\" id=\"card-basic-event-data\">\n        <div class=\"card-header\">\n          {{ 'EVENT.PROPERTY_REVIEW.CANDIDATE_PROPERTY_TITLE' | translate }}\n        </div>\n        <div class=\"card-block\">\n          <table class=\"table search-results-simple\">\n            <thead>\n              <tr>\n                <th>\n                  {{ 'EVENT.PROPERTY_REVIEW.VENDOR_ID' | translate }}<br>\n                  <span class=\"font-weight-normal\">&nbsp;</span>\n                </th>\n                <th>\n                  {{ 'EVENT.PROPERTY_REVIEW.PROPERTY_NAME' | translate }}<br>\n                  <span class=\"font-weight-normal\">{{ 'EVENT.PROPERTY_REVIEW.ADDRESS' | translate }}</span>\n                </th>\n                <th>\n                  {{ 'EVENT.PROPERTY_REVIEW.CITY' | translate }}<br>\n                  <span class=\"font-weight-normal\">{{ 'EVENT.PROPERTY_REVIEW.COUNTRY' | translate }}</span>\n                </th>\n              </tr>\n            </thead>\n            <tbody>\n              <tr>\n                <td data-se-id=\"vendorId\" *ngIf=\"!isNotProvided(property?.vendorId)\">\n                  {{ property?.vendorId }}\n                </td>\n                <td data-se-id=\"vendorId\" *ngIf=\"isNotProvided(property?.vendorId)\">\n                  {{'EVENT.PROPERTY_REVIEW.NOT_PROVIDED' | translate}}\n                </td>                \n                <td data-se-id=\"name\">\n                  <span class=\"res-value\">{{ property?.name }}</span><br>\n                  <span class=\"res-value text-muted\">{{ property?.address1 }}</span>\n                </td>\n                <td data-se-id=\"city\">\n                  <span class=\"res-value\">{{ property?.city }}</span><br>\n                  <span class=\"res-value text-muted\">{{ property?.countryCode }}</span>\n                </td>\n              </tr>\n            </tbody>\n          </table>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div class=\"row\">\n    <div class=\"card-content\">\n      <div class=\"card\" id=\"card-basic-event-data\">\n        <div class=\"card-header\">\n          {{ 'EVENT.PROPERTY_REVIEW.CANDIDATE_MATCHES_TITLE' | translate }}\n        </div>\n        <div class=\"card-block\">\n          <form [formGroup]=\"candidatesForm\" data-se-id=\"candidatesForm\">\n            <table class=\"table search-results-simple\">\n              <thead>\n                <tr>\n                  <th> </th>\n                  <th>\n                    {{ 'EVENT.PROPERTY_REVIEW.ONYX_ID' | translate }}<br>\n                    <span class=\"font-weight-normal\">&nbsp;</span>\n                  </th>\n                  <th>\n                    {{ 'EVENT.PROPERTY_REVIEW.BRAND' | translate }}<br>\n                    <span class=\"font-weight-normal\">&nbsp;</span>\n                  </th>\n                  <th>\n                    {{ 'EVENT.PROPERTY_REVIEW.PROPERTY_NAME' | translate }}<br>\n                    <span class=\"font-weight-normal\">{{ 'EVENT.PROPERTY_REVIEW.ADDRESS' | translate }}</span>\n                  </th>\n                  <th>\n                    {{ 'EVENT.PROPERTY_REVIEW.CITY' | translate }}<br>\n                    <span class=\"font-weight-normal\">{{ 'EVENT.PROPERTY_REVIEW.COUNTRY' | translate }}</span>\n                  </th>\n                  <th>\n                    {{ 'EVENT.PROPERTY_REVIEW.MATCH' | translate }}<br>\n                    <span class=\"font-weight-normal\">&nbsp;</span>\n                  </th>\n                </tr>\n              </thead>\n              <tbody>\n                <tr *ngFor=\"let candidate of property?.candidates\">\n                  <td data-se-id=\"select\">\n                    <div class=\"form-check\">\n                      <label class=\"custom-control custom-radio\">\n                        <input type=\"radio\"\n                              class=\"custom-control-input\"\n                              name=\"matchingOption\"\n                              data-se-id=\"matchingOption\"\n                              formControlName=\"matchingOption\"\n                              value=\"{{ candidate.matchingCandidateId }}\">\n                        <span class=\"custom-control-indicator\"></span>\n                      </label>\n                    </div>\n                  </td>\n                  <td data-se-id=\"pid\">\n                    {{ candidate.pid }}\n                  </td>\n                  <td data-se-id=\"brand\">\n                    {{ candidate.brand }}\n                  </td>\n                  <td data-se-id=\"name\">\n                    <span class=\"res-value\">{{ candidate.name }}</span><br>\n                    <span class=\"res-value text-muted\">{{ candidate.address1 }}</span>\n                  </td>\n                  <td data-se-id=\"city\">\n                    <span class=\"res-value\">{{ candidate.city }}</span><br>\n                    <span class=\"res-value text-muted\">{{ candidate.countryCode }}</span>\n                  </td>\n                  <td data-se-id=\"matchRate\">\n                    {{ candidate.matchRate }}\n                  </td>\n                </tr>\n              </tbody>\n            </table>\n            <ng-container>\n              <div class=\"row\">\n                  <p class=\"col-xs form-text text-muted\">{{ 'EVENT.PROPERTY_REVIEW.NO_MATCHES_FOUND' | translate }}</p>\n                  <a class=\"col form-text\" href=\"javascript:void(0)\" (click)=\"confirmBeforeAddProperty()\">\n                      {{ 'EVENT.PROPERTY_REVIEW.ADD_NEW_PROPERTY' | translate }}\n                  </a>\n              </div>\n            </ng-container>\n          </form>\n        </div>\n      </div>\n      <ng-container>\n        <div class=\"button-bar\">\n          <button class=\"btn btn-link\" data-se-id=\"cancelMatchButton\"\n            (click)=\"cancelMatch()\" >\n            {{ 'EVENT.PROPERTY_REVIEW.CANCEL_BUTTON' | translate}}\n          </button>\n          <button class=\"btn btn-primary\" data-se-id=\"matchButton\"\n            (click)=\"matchCandidate()\"\n            [disabled]=\"noOptionSelected()\">\n            {{ 'EVENT.PROPERTY_REVIEW.MATCH_BUTTON' | translate}}\n          </button>\n        </div>\n      </ng-container>\n    </div>\n  </div>\n</div>\n\n\n"

/***/ }),

/***/ "Jeo/":
/***/ (function(module, exports) {

module.exports = "<pioneer-confirmation-modal\n  data-se-id=\"attachmentConfirmationModal\"\n  content=\"EVENT.CONFIRM_REMOVE_DOCUMENT\"\n  cancel=\"COMMON.BUTTON.CANCEL\"\n  confirm=\"EVENT.REMOVE_DOCUMENT\"\n  [title]=\"'EVENT.CONFIRM_REMOVE_DOCUMENT_TITLE'\"\n  (closed)=\"confirmHandler($event)\">\n</pioneer-confirmation-modal>\n<div class=\"doc-library\"\n     id=\"card-attachment\">\n  <div class=\"card\">\n    <div class=\"card-block\">\n      <form>\n        <div class=\"card-title\">{{'EVENT.EVENT_DOCUMENTS' | translate}}<span class=\"document-count\">{{attachments.size}}</span>\n          <div *pioneerAuthorize=\"{permission: 'AddFiles'}\" class=\"button-bar\">\n            <label class=\"upload-link\">\n              {{'EVENT.UPLOAD_DOCUMENT' | translate}}\n              <i class=\"glyph-cloud-up\"></i>\n              <input #file\n                   data-se-id=\"file_upload\"\n                   hidden\n                   type=\"file\"\n                   accept=\"{{fileTypes}}\"\n                   placeholder=\"{{'EVENT.UPLOAD_DOCUMENT' | translate}}\"\n                   (change)=\"uploadFile($event)\"/>\n            </label>\n          </div>\n        </div>\n      </form>\n      <ol class=\"file-list\" data-se-id=\"uploaded_attachments\">\n        <li class=\"file-item file-uploading\" [hidden]=\"!isUploadInProgress\">\n          <div class=\"progress\">\n            <div class=\"progress-bar progress-bar-striped progress-bar-animated\"\n                 role=\"progressbar\"\n                 aria-valuenow=\"100\"\n                 aria-valuemin=\"0\"\n                 aria-valuemax=\"100\"\n                 style=\"width: 100%\">{{'EVENT.UPLOADING' | translate}}\n            </div>\n          </div>\n        </li>\n        <li *ngFor=\"let attachment of attachments\" class=\"file-item\"\n            [class.item-new]=\"isNewAttachment && attachment === attachments.get(0)\"\n            data-se-id=\"attachment\"\n            [class.discarded]=\"removedAttachments.has(attachment.uniqueId)\">\n          <div class=\"item-link document-item\"\n               [attr.filetype]=\"getFileExtension(attachment.name)\">\n            <i class=\"icon-file\" [class.can-remove]=\"canDeleteFile(attachment)\"\n               data-se-id=\"attachmentIcon\"\n               (click)=\"canDeleteFile(attachment) ? confirmBeforeDelete(attachment) : openFile(attachment)\"></i>\n            <span class=\"item-file-name\"\n                  (click)=\"openFile(attachment)\"\n                  data-se-id=\"name\">{{attachment.name}}</span>\n          </div>\n          <div class=\"item-detail\">\n            <span class=\"item-detail-user\" data-se-id=\"uploader\">{{attachment.uploader}}\n              <ng-container [ngSwitch]=\"attachment.creatorType\">\n                <ng-container *ngSwitchCase=\"'HOTEL'\">({{'COMMON.USER_TYPE.HOTEL' | translate}})</ng-container>\n                <ng-container *ngSwitchCase=\"'AGENCY'\">({{'COMMON.USER_TYPE.AGENCY' | translate}})</ng-container>\n                <ng-container *ngSwitchCase=\"'SUPPORT'\">({{'COMMON.USER_TYPE.SUPPORT' | translate}})</ng-container>\n              </ng-container>\n            </span>\n            <span class=\"item-detail-date\" data-se-id=\"uploadDate\">\n              {{attachment.uploadDate | date: 'medium'}} {{'COMMON.UTC_DATE' | translate}}\n            </span>\n          </div>\n        </li>\n      </ol>\n    </div>\n  </div>\n</div>\n"

/***/ }),

/***/ "K2V+":
/***/ (function(module, exports) {

module.exports = "<form class=\"form-signin\" method=\"POST\" action=\"#\" role=\"form\" (ngSubmit)=\"onLogin($event)\">\n  <div class=\"login-content\">\n    <div class=\"login-container\">\n      <div class=\"login-logo\" id=\"loginLogo\"><span class=\"sr-only\">Onyx CenterSource</span></div>\n      <div class=\"login-form\">\n        <h4 id=\"subtitle\">{{ 'LOGIN.TITLE' | translate }}</h4>\n        <div class=\"form-group\">\n          <label for=\"loginUsername\">{{ 'LOGIN.USERNAME' | translate }}</label>\n          <input id=\"loginUsername\" required=\"\" type=\"text\" maxlength=\"100\" class=\"form-control\"\n                 [(ngModel)]=\"email\"\n                 [ngModelOptions]=\"{standalone: true}\"\n                 placeholder=\"{{ 'LOGIN.USERNAME_PLACEHOLDER' | translate }}\"/>\n        </div>\n        <div class=\"form-group\">\n          <label for=\"loginPassword\">{{ 'LOGIN.PASSWORD' | translate }}</label>\n          <input id=\"loginPassword\" required=\"\" type=\"password\" maxlength=\"25\" class=\"form-control\"\n                 length=\"40\" [(ngModel)]=\"password\" [ngModelOptions]=\"{standalone: true}\"\n                 placeholder=\"{{ 'LOGIN.PASSWORD_PLACEHOLDER' | translate }}\"/>\n        </div>\n        <div class=\"form-group\">\n          <button type=\"submit\" id=\"loginSubmit\" class=\"btn btn-primary btn-block\">\n            {{ 'LOGIN.LOGIN' | translate }}\n          </button>\n        </div>\n      </div>\n    </div>\n  </div>\n</form>\n"

/***/ }),

/***/ "K4wc":
/***/ (function(module, exports) {

module.exports = "<div class=\"card-header\" id=\"card-stay-summary\">{{ headerTitle }}</div>\n\n<div class=\"card-summary-header\">\n  <table class=\"table\">\n    <thead>\n    <tr data-se-id=\"staySummaryRow\">\n      <th data-se-id=\"totalItems\">{{(staySummary | async)?.totalItems}}</th>\n      <th data-se-id=\"totalNights\">{{(staySummary | async)?.totalNights}}</th>\n      <th class=\"currency\"  data-se-id=\"avgRoomRate\">\n        {{ (staySummary | async)?.avgRoomRate | number:'1.2-2' }}\n      </th>\n      <th class=\"currency\"  data-se-id=\"totalRevenue\">\n        <span [class.commission-sum]=\"isAbbreviated((staySummary | async)?.totalRevenue)\">\n          <span class=\"res-value\"\n              tooltip=\"{{ (staySummary | async)?.totalRevenue | number:'1.2-2' }} {{ onyxEvent.currency | uppercase }}\"\n              placement=\"right\"\n              triggers=\"mouseenter:mouseleave\"\n              container=\"body\">\n            {{ (staySummary | async)?.totalRevenue | abbreviateAmount }}\n          </span>\n        </span>\n      </th>\n      <th class=\"currency\"  data-se-id=\"totalCommission\">\n        <span [class.commission-sum]=\"isAbbreviated( (staySummary | async)?.totalCommission )\">\n          <span class=\"res-value\"\n              tooltip=\"{{ (staySummary | async)?.totalCommission | number:'1.2-2' }} {{ onyxEvent.currency | uppercase }}\"\n              placement=\"right\"\n              triggers=\"mouseenter:mouseleave\"\n              container=\"body\">\n            {{ (staySummary | async)?.totalCommission | abbreviateAmount }}\n          </span>\n        </span>\n      </th>\n    </tr>\n    </thead>\n    <tbody>\n    <tr>\n      <td>\n        {{recordType | translate}}\n        <span tooltip=\"{{headerTooltip}}\"\n              placement=\"right\"\n              triggers=\"mouseenter:mouseleave\"\n              container=\"body\"\n              *ngIf=\"headerTooltip\">\n            <i class=\"fal fa-question-circle text-muted\"></i>\n        </span>\n      </td>\n      <td>{{'EVENT.COMMISSION.ROOM_NIGHTS' | translate}}</td>\n      <td>{{'EVENT.COMMISSION.AVG_ROOM_RATE' | translate}}</td>\n      <td>{{'EVENT.COMMISSION.REVENUE' | translate}}</td>\n      <td>{{'EVENT.COMMISSION.COMMISSION' | translate}}</td>\n    </tr>\n    </tbody>\n  </table>\n</div>\n"

/***/ }),

/***/ "KTxh":
/***/ (function(module, exports) {

module.exports = "<div class=\"content-container\" data-se-id=\"event-list\">\n    <div class=\"row\">\n\n      <div class=\"event-search\">\n        <form [formGroup]=\"eventSearchTextForm\" novalidate *pioneerAuthorize=\"{permission: 'EventSearch'}\">\n        <div class=\"form-group form-search\">\n          <div class=\"input-group\">\n            <input class=\"form-control\" type=\"text\" id=\"search\" maxlength=\"100\" name=\"search\"\n                   required autocomplete=\"off\"\n                   formControlName=\"searchText\"\n                   (keydown.enter)=\"addSearchText(eventSearchTextForm.value)\"\n                   placeholder=\"{{ 'EVENTS.SEARCH_PLACEHOLDER' | translate }}\"/>\n            <div class=\"input-group-addon\">\n              <i (click)=\"addSearchText(eventSearchTextForm.value)\" class=\"glyph-search\"></i>\n            </div>\n          </div>\n        </div>\n        </form>\n        <div class=\"active-filters\">\n          <p class=\"filter-label\" *pioneerAuthorize=\"{permission: 'EventSearch'}\">\n            {{'EVENTS.ACTIVE_FILTERS' | translate}}\n          </p>\n\n          <ng-container *pioneerAuthorize=\"{permission: 'SingleVendor'}\">\n            <div class=\"view-select float-right\">\n              <div class=\"btn-group btn-group-sm\">\n                <button class=\"btn btn-default\"\n                        [ngClass]=\"{'active': (isDefaultViewSelected | async) }\"\n                        (click)=\"updateToDefaultURL()\"\n                        data-se-id=\"event-default-toggle-button\">\n                  <i class=\"glyph-page\"></i>{{'EVENTS.DEFAULT_BUTTON' | translate}}\n                </button>\n                <button class=\"btn btn-default\"\n                        [ngClass]=\"{'active': !(isDefaultViewSelected | async) }\"\n                        (click)=\"updateToFinancialURL()\"\n                        data-se-id=\"event-financial-toggle-button\">\n                  <i class=\"glyph-pages\"></i>{{'EVENTS.FINANCIAL_BUTTON' | translate}}\n                </button>\n              </div>\n            </div>\n          </ng-container>\n\n          <ol class=\"filter-list\" *pioneerAuthorize=\"{permission: 'EventSearch'}\">\n            <li *ngFor=\"let searchText of searchTextSet | async\"\n                class=\"filter-item search-filter\"\n                data-se-id=\"searchFilterToken\"\n                (click)=\"removeSearchText($event)\">\n              {{ searchText }}\n            </li>\n            <li *ngFor=\"let searchFilter of searchFilterSet | async\"\n                class=\"filter-item nav-filter\"\n                data-se-id=\"searchFilterToken\"\n                (click)=\"removeSearchFilter($event, searchFilter)\">\n              <span class=\"field-name\">\n                {{ getTokenFilterFieldTranslationKey(searchFilter.filterField) | translate }}\n              </span>\n              <span class=\"field-value\">\n                {{ getTokenValue(searchFilter) }}\n              </span>\n            </li>\n            <li class=\"filter-clear\" data-se-id=\"resetSearch\">\n              <span class=\"clear-link \" (click)=\"resetSearch()\">{{'EVENTS.CLEAR_FILTERS' | translate}}</span>\n            </li>\n            <li class=\"filter-none\">{{'EVENTS.NO_FILTERS' | translate}}</li>\n          </ol>\n          <div class=\"button-bar\">\n            <ng-container *pioneerAuthorize=\"{permission: 'ViewBulkAction'}\">\n              <div class=\"btn-group\">\n                <button class=\"btn btn-primary dropdown-toggle\" data-toggle=\"dropdown\"\n                        data-se-id=\"bulk-action-dropdown-button\">\n                  {{ \"EVENTS.BULK_ACTION.TITLE\" | translate }}\n                </button>\n                <div class=\"dropdown-menu dropdown-menu-right\">\n                  <button\n                    (click)=\"openBulkActionModal(BulkAction.PAYMENT_REQUEST)\"\n                    class=\"dropdown-item\"\n                    data-se-id=\"bulk-action-request-payment-option\">\n                    {{'EVENTS.BULK_ACTION.PAYMENT_REQUEST' | translate}}\n                  </button>\n                  <button\n                    (click)=\"openBulkActionModal(BulkAction.PAID_DIRECT)\"\n                    class=\"dropdown-item\"\n                    data-se-id=\"bulk-action-paid-direct-option\">\n                    {{'EVENTS.BULK_ACTION.PAID_DIRECT' | translate}}\n                  </button>\n                  <button\n                    (click)=\"openBulkActionModal(BulkAction.CANCELLED)\"\n                    class=\"dropdown-item\"\n                    data-se-id=\"bulk-action-cancelled-option\">\n                    {{'EVENTS.BULK_ACTION.CANCELLED' | translate}}\n                  </button>\n                </div>\n              </div>\n            </ng-container>\n            <ng-container *pioneerAuthorize=\"{permission: 'ExportReports'}\">\n              <div class=\"btn-group\" *ngIf=\"(eventsPresent | async) === true\">\n                <button class=\"btn btn-primary dropdown-toggle\" data-toggle=\"dropdown\"\n                  data-se-id=\"download-reservation-summary-dropdown-button\">\n                  {{ \"COMMON.REPORT.EXPORT_DROPDOWN\" | translate }}\n                </button>\n                <div class=\"dropdown-menu dropdown-menu-right\">\n                  <button\n                    (click)=\"exportEventExcel()\"\n                    class=\"dropdown-item\"\n                    data-se-id=\"download-reservation-summary-excel-option\">\n                    {{'COMMON.REPORT.EXPORT_EXCEL' | translate}}\n                  </button>\n                </div>\n              </div>\n            </ng-container>\n          </div>\n        </div>\n      </div>\n\n      <div class=\"card-content\" *ngIf=\"showEventListControl\">\n\n        <div *ngIf=\"eventList && eventList.filtered && eventList.filtered.totalElements <= 0\" class=\"result-empty\">\n          <h3>{{'EVENTS.NO_EVENTS' | translate}}</h3>\n          <figure class=\"figure\"><i class=\"glyph-calendar figure-img\"></i>\n            <figcaption class=\"figure-caption\">\n              <a (click)=\"resetSearch()\">{{ 'EVENTS.RESET_FILTERS' | translate }}</a>\n            </figcaption>\n          </figure>\n        </div>\n\n        <div *ngIf=\"eventList && eventList.filtered && eventList.filtered.totalElements > 0\" class=\"card\">\n          <div class=\"loading-data\" *ngIf=\"eventList.original === null\">\n            <span class=\"loader\"></span>\n          </div>\n          <ng-container *ngIf=\"eventList && eventList.filtered && eventList.filtered.content !==undefined\">\n\n            <ng-container *pioneerAuthorize=\"{permission: 'SingleVendor'}\">\n              <pioneer-event-list-default-table *ngIf=\"isDefaultViewSelected | async\"\n                                                [events]=\"eventList.filtered\">\n              </pioneer-event-list-default-table>\n              <pioneer-event-list-financial-table *ngIf=\"!(isDefaultViewSelected | async)\"\n                                                  [events]=\"eventList.filtered\">\n              </pioneer-event-list-financial-table>\n            </ng-container>\n\n            <ng-container *pioneerAuthorize=\"{permission: 'MultiVendor'}\">\n              <pioneer-event-list-multi-vendor-table [events]=\"eventList.filtered\">\n              </pioneer-event-list-multi-vendor-table>\n            </ng-container>\n\n          </ng-container>\n          <div class=\"card-footer\">\n            <pioneer-pagination-refresh *ngIf=\"eventList && eventList.filtered && eventList.filtered.totalElements > 0\"\n              [resultsPage]=\"eventList.filtered\"\n              (updatePage)=\"loadEvenList($event.page)\"\n              [disablePagination]=\"eventList.isUserSearching.searching\"\n              [resetTable]=\"eventList.isUserSearching.resetTable\"\n              [pagesizeType]=\"pagesizeType\"\n              [elResultsPage]=\"elementsPerPage\">\n            </pioneer-pagination-refresh>\n          </div>\n\n        </div>\n\n      </div>\n    </div>\n</div>\n<pioneer-bulk-action-popup *pioneerAuthorize=\"{permission: 'ViewBulkAction'}\"\n                           (refreshEvents)=\"loadEvenList(0)\">\n</pioneer-bulk-action-popup>\n"

/***/ }),

/***/ "Kbn7":
/***/ (function(module, exports) {

module.exports = "<div class=\"splash-content\">\n  <div id=\"flashMessages\">\n    <div class=\"flash-message alert alert-danger\">\n      {{ error | translate }}\n    </div>\n  </div>\n  <div class=\"splash-container\">\n    <div class=\"login-logo error\"><span class=\"sr-only\">Onyx CenterSource</span></div>\n  </div>\n</div>\n"

/***/ }),

/***/ "LfX5":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("rP7Y")(true);
// imports


// module
exports.push([module.i, ".label-placeholder{display:inline-block}.form-container .btn{width:100%}", "", {"version":3,"sources":["/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/vendor-search/vendor-search.component.css"],"names":[],"mappings":"AAAA,mBACI,oBAAsB,CACzB,qBAGG,UAAY,CACf","file":"vendor-search.component.css","sourcesContent":[".label-placeholder {\n    display: inline-block;\n}\n\n.form-container .btn {\n    width: 100%;\n}\n"],"sourceRoot":""}]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),

/***/ "LhFe":
/***/ (function(module, exports) {

module.exports = "<pioneer-invoice-history>\n</pioneer-invoice-history>\n"

/***/ }),

/***/ "LrqM":
/***/ (function(module, exports) {

module.exports = "<div class=\"card commission-card\">\n  <div class=\"card-header\" id=\"heading-{{vendor.chain}}-{{vendor.brand}}-{{vendor.propertyId}}\">\n    <div class=\"container\">\n      <div class=\"row justify-content-between\">\n        <div class=\"row justify-content-start\">\n          <span>\n            <a href=\"#!\" class=\"card-state-toggle no-text-decoration\"\n               (click)=\"vendor.isExpanded ? onCardExpandClicked($event, vendor.eventPartyId, vendor.chain, vendor.brand, vendor.propertyId, false)\n                                            : onCardExpandClicked($event, vendor.eventPartyId, vendor.chain, vendor.brand, vendor.propertyId, true)\">\n              <i class=\"far fa-fw {{vendor.isExpanded ? 'fa-chevron-up' : 'fa-chevron-down'}}\"></i>\n            </a>\n            <ng-container *pioneerAuthorize=\"{permission: 'ViewGroupPayPropertyIndicators'}\">\n              <img *ngIf=\"vendor.subscriber\" src=\"{{imagesUrl}}/grouppay-logo-symbol.png\" width=\"22px\" height=\"22px\"\n                   tooltip=\"{{'EVENTS.PROPERTY_SUBSCRIBED_TOOLTIP' | translate }}\">\n            </ng-container>\n            &nbsp;{{ vendor.name}}&nbsp;\n          </span>\n        </div>\n      </div>\n    </div>\n  </div>\n\n  <div *ngIf=\"vendor.isExpanded\">\n    <div *ngIf=\"token\">\n      <pioneer-invoice-history [auth]=\"token\"></pioneer-invoice-history>\n    </div>\n  </div>\n</div>\n"

/***/ }),

/***/ "M+FI":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("rP7Y")(true);
// imports


// module
exports.push([module.i, ".filter-tag{display:inline-block;border:1px solid #9cafbe;border-radius:.3125rem;background-color:#eeeff0;font-size:.75rem;padding:.3125rem .625rem;margin-right:.625rem;margin-bottom:.3125rem;white-space:nowrap}.filter-tag .filter-tag-close,.filter-tag .filter-tag-text{display:inline-block;vertical-align:middle}.filter-tag .filter-tag-close{font-size:1rem;color:#9cafbe;margin-left:.625rem;border:none;cursor:pointer}.filter-tag .filter-tag-close:hover{color:#697680}", "", {"version":3,"sources":["/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/rate-plan-code/rate-plan-code/rate-plan-code.component.css"],"names":[],"mappings":"AAAA,YACE,qBAAsB,yBACI,uBACD,yBACC,iBACP,yBACS,qBACL,uBACE,kBACL,CACrB,2DAGC,qBAAsB,qBACC,CAGzB,8BAGE,eAAgB,cACD,oBACO,YACT,cACG,CACjB,oCAEC,aAAe,CAChB","file":"rate-plan-code.component.css","sourcesContent":[".filter-tag {\n  display: inline-block;\n  border: 1px solid #9cafbe;\n  border-radius: 0.3125rem;\n  background-color: #eeeff0;\n  font-size: 0.75rem;\n  padding: 0.3125rem 0.625rem;\n  margin-right: 0.625rem;\n  margin-bottom: 0.3125rem;\n  white-space: nowrap;\n}\n\n.filter-tag .filter-tag-text {\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.filter-tag .filter-tag-close {\n  display: inline-block;\n  vertical-align: middle;\n  font-size: 1rem;\n  color: #9cafbe;\n  margin-left: 0.625rem;\n  border: none;\n  cursor: pointer;\n}\n.filter-tag .filter-tag-close:hover {\n  color: #697680;\n}\n"],"sourceRoot":""}]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),

/***/ "M8zK":
/***/ (function(module, exports) {

module.exports = "<div class=\"modal fade\" bsModal [config]=\"config\" role=\"dialog\" tabindex=\"-1\"\n     data-se-id=\"event-collision-modal\" (onHide)=\"onHide()\">\n  <div class=\"modal-dialog  modal-lg\" role=\"document\">\n    <div class=\"modal-content\">\n      <div class=\"modal-body\">\n        <p class=\"lead\" *ngIf=\"title\" [innerHTML]=\"title | translate\" data-se-id=\"title\"></p>\n        <p data-se-id=\"content\" [innerHTML]=\"content | translate\"></p>\n          <!-- Change this for a loop -->\n          <div class=\"container\">\n            <div class=\"row g-2\">\n              <div class=\"col-6 p-0\">\n                <div class=\"border bg-light\"><p class=\"lead\" *ngIf=\"heading\" [innerHTML]=\"heading | translate\" data-se-id=\"heading\"></p></div>\n              </div>\n              <div class=\"col-6 p-0\">\n                <div class=\"border bg-light\"><p class=\"lead\" *ngIf=\"headingDetails\" [innerHTML]=\"headingDetails | translate\" data-se-id=\"heading\"></p></div>\n              </div>\n            </div>\n          </div>\n          <dl>\n            <div class=\"field\">\n                <dt>{{ \"EVENT_COLLISION.MODAL.SINGLE.CREATED_BY\" | translate }}</dt>\n                <dd *ngIf=\"match?.created_by\" [innerHTML]=\"match?.created_by | translate\" class=\"dd-bordered\"></dd>\n            </div>\n          </dl>\n          <dl>\n            <div class=\"field\">\n                <dt>{{ \"EVENT_COLLISION.MODAL.SINGLE.CLIENT_COMPANY\" | translate }}</dt>\n                <dd [innerHTML]=\"match?.client_name | translate\" class=\"dd-bordered\"></dd>\n                <dt>{{ \"EVENT_COLLISION.MODAL.SINGLE.CLIENT_COMPANY\" | translate }}</dt>\n                <dd *ngIf=\"eventMatch?.clientCompany\" [innerHTML]=\"eventMatch?.clientCompany | translate\"></dd>\n            </div>\n          </dl>\n          <dl>\n            <div class=\"field\">\n                <dt>{{ \"EVENT_COLLISION.MODAL.SINGLE.EVENT_NAME\" | translate }}</dt>\n                <dd *ngIf=\"match?.name\" [innerHTML]=\"match?.name | translate\" class=\"dd-bordered\"></dd>\n                <dt>{{ \"EVENT_COLLISION.MODAL.SINGLE.EVENT_NAME\" | translate }}</dt>\n                <dd *ngIf=\"eventMatch?.eventName\" [innerHTML]=\"eventMatch?.eventName | translate\"></dd>\n            </div>\n          </dl>\n          <dl>\n            <div class=\"field\">\n                <dt *ngIf=\"!isPropertyUser\">{{ \"EVENT_COLLISION.MODAL.SINGLE.GROUP_CODE\" | translate }}</dt>\n                <dt *ngIf=\"isPropertyUser\">{{ \"EVENT_COLLISION.MODAL.SINGLE.MEETING_ID\" | translate }}</dt>\n                <dd *ngIf=\"match?.group_code\" [innerHTML]=\"match?.group_code | translate\" class=\"dd-bordered\"></dd>\n                <dt *ngIf=\"isPropertyUser\">{{ \"EVENT_COLLISION.MODAL.SINGLE.GROUP_CODE\" | translate }}</dt>\n                <dt *ngIf=\"!isPropertyUser\">{{ \"EVENT_COLLISION.MODAL.SINGLE.MEETING_ID\" | translate }}</dt>\n                <dd *ngIf=\"eventMatch?.groupCode\" [innerHTML]=\"eventMatch?.groupCode | translate\"></dd>\n            </div>\n          </dl>\n          <dl>\n            <div class=\"field\">\n                <dt>{{ \"EVENT_COLLISION.MODAL.SINGLE.START_DATE\" | translate }}</dt>\n                <dd *ngIf=\"match?.start_date\" [innerHTML]=\"match?.start_date | translate\" class=\"dd-bordered\"></dd>\n                <dt>{{ \"EVENT_COLLISION.MODAL.SINGLE.START_DATE\" | translate }}</dt>\n                <dd *ngIf=\"eventMatch?.startDate\" [innerHTML]=\"eventMatch?.startDate | translate\"></dd>\n            </div>\n          </dl>\n          <dl>\n            <div class=\"field\">\n                <dt>{{ \"EVENT_COLLISION.MODAL.SINGLE.END_DATE\" | translate }}</dt>\n                <dd *ngIf=\"match?.end_date\" [innerHTML]=\"match?.end_date | translate\" class=\"dd-bordered\"></dd>\n                <dt>{{ \"EVENT_COLLISION.MODAL.SINGLE.END_DATE\" | translate }}</dt>\n                <dd *ngIf=\"eventMatch?.endDate\" [innerHTML]=\"eventMatch?.endDate | translate\"></dd>\n            </div>\n          </dl>\n          <dl>\n            <div class=\"field\">\n                <dt>{{ \"EVENT_COLLISION.MODAL.SINGLE.PROPERTY\" | translate }}</dt>\n                <dd *ngIf=\"match?.property_name\" [innerHTML]=\"completePropertyForEventMatched() | translate\" class=\"dd-bordered\"></dd>\n                <dt>{{ \"EVENT_COLLISION.MODAL.SINGLE.PROPERTY\" | translate }}</dt>\n                <dd *ngIf=\"eventMatch?.property\" [innerHTML]=\"eventMatch?.property | translate\"></dd>\n                <!-- <dd>displays the name and address of the Property selected for the existing event. </dd> -->\n            </div>\n          </dl>\n          <!-- End loop -->\n        <div class=\"mt-5 mb-3 text-right\">\n          <button data-se-id=\"event-collision-modal-confirm\" type=\"button\" class=\"btn btn-primary btn\"\n                  (click)=\"confirmMatchingEvent()\">{{ confirm | translate }}\n          </button>\n        </div>\n        <p data-se-id=\"content\" [innerHTML]=\"contentFinal | translate\" *ngIf=\"mode === 'ADD'\"></p>\n        <p data-se-id=\"content\" [innerHTML]=\"contentFinalAddVendor | translate\" *ngIf=\"mode === 'UPDATE'\"></p>\n        <div class=\"mt-2 mb-3 space-between\">\n          <button data-se-id=\"event-collision-modal-cancel\" type=\"button\" class=\"btn btn-info btn\"\n                  (click)=\"cancelEventMatching()\">{{ cancel | translate }}\n          </button>\n          <button data-se-id=\"event-collision-modal-create\" type=\"button\" class=\"btn\"\n                  (click)=\"createNewEvent()\" *ngIf=\"mode === 'ADD'\">{{ create | translate }}\n          </button>\n          <button data-se-id=\"event-collision-modal-create\" type=\"button\" class=\"btn\"\n                  (click)=\"createNewEvent()\" *ngIf=\"mode === 'UPDATE'\">{{ notConfirm | translate }}\n          </button>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),

/***/ "ME4C":
/***/ (function(module, exports) {

module.exports = "<div *ngIf=\"propertyCount > 0\" >\n  <table class=\"table search-results-simple\">\n    <thead>\n      <tr>\n        <th><pioneer-pagination-sort\n          [label]=\"'EVENT.PROPERTY_REVIEW.DATE_ADDED' | translate\"\n          [field]=\"'createdDate'\"\n          (sortPage)=\"sortList($event.field, $event.direction)\">\n        </pioneer-pagination-sort></th>\n        <th><pioneer-pagination-sort\n          [label]=\"'EVENT.PROPERTY_REVIEW.AGENCY_NAME' | translate\"\n          [field]=\"'vendorSource'\"\n          (sortPage)=\"sortList($event.field, $event.direction)\">\n        </pioneer-pagination-sort></th>\n        <th>{{'EVENT.PROPERTY_REVIEW.VENDOR_ID' | translate}}</th>\n        <th>{{'EVENT.PROPERTY_REVIEW.PROPERTY_NAME' | translate}}</th>\n        <th></th>\n      </tr>\n    </thead>\n    <tbody>\n      <tr *ngFor=\"let property of properties?.content\">\n        <td data-se-id=\"createdDate\">\n          {{ property.createdDate | date: 'shortDate' }}\n        </td>\n        <td data-se-id=\"vendorSource\">\n          {{ property.vendorSource }}\n        </td>\n        <td data-se-id=\"vendorId\" *ngIf=\"!isNotProvided(property.vendorId)\">\n          {{ property.vendorId }}\n        </td>\n        <td data-se-id=\"vendorId\" *ngIf=\"isNotProvided(property.vendorId)\">\n          {{'EVENT.PROPERTY_REVIEW.NOT_PROVIDED' | translate}}\n        </td>\n        <td data-se-id=\"name\">\n          {{ property.name }}\n        </td>\n        <td data-se-id=\"view-matches\">\n          <a class=\"col form-text\" href=\"javascript:void(0)\" (click)=\"selectProperty(property)\">\n            {{ 'EVENT.PROPERTY_REVIEW.VIEW_MATCHES' | translate }}\n          </a>\n        </td>\n      </tr>\n    </tbody>\n  </table>\n</div>\n"

/***/ }),

/***/ "MKb2":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("rP7Y")(true);
// imports


// module
exports.push([module.i, ".label-placeholder{display:inline-block}.form-container .btn{width:100%}", "", {"version":3,"sources":["/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/property-search/property-search.component.css"],"names":[],"mappings":"AAAA,mBACI,oBAAsB,CACzB,qBAGG,UAAY,CACf","file":"property-search.component.css","sourcesContent":[".label-placeholder {\n    display: inline-block;\n}\n\n.form-container .btn {\n    width: 100%;\n}\n"],"sourceRoot":""}]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),

/***/ "Mb9j":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("rP7Y")(true);
// imports


// module
exports.push([module.i, ".select{cursor:pointer}.dropdown{position:absolute;z-index:4;max-height:20rem;overflow-y:auto;padding:.5rem .2rem;border-radius:.3rem}.dropdown-no-option,.dropdown-option{padding:.3rem .75rem;border-radius:.3rem;display:block;cursor:pointer}.dropdown hr{margin-top:.3rem;margin-bottom:.3rem}.dropdown-option.empty{font-style:italic}.dropdown-option:hover{background-color:#23c0d2;color:#fff}[unselectable=on]{-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;user-select:none}", "", {"version":3,"sources":["/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/dropdown-search/dropdown-search.component.css"],"names":[],"mappings":"AAAA,QACI,cAAgB,CACnB,UAGC,kBAAmB,UACR,iBACO,gBACD,oBACM,mBACD,CACvB,qCAGC,qBAAwB,oBACF,cACP,cACC,CACjB,aAGC,iBAAmB,mBACG,CACvB,uBAGC,iBAAmB,CACpB,uBAGC,yBAA0B,UACb,CACd,kBAGC,sBAAuB,yBAEG,qBACJ,gBACJ,CACnB","file":"dropdown-search.component.css","sourcesContent":[".select {\n    cursor: pointer;\n}\n\n.dropdown {\n  position: absolute;\n  z-index: 4;\n  max-height: 20rem;\n  overflow-y: auto;\n  padding: 0.5rem 0.2rem;\n  border-radius: 0.3rem;\n}\n  \n.dropdown-option, .dropdown-no-option {\n  padding: 0.3rem 0.75rem;\n  border-radius: 0.3rem;\n  display: block;\n  cursor: pointer;\n}\n\n.dropdown hr {\n  margin-top: 0.3rem;\n  margin-bottom: 0.3rem;\n}\n\n.dropdown-option.empty {\n  font-style: italic;\n}\n  \n.dropdown-option:hover {\n  background-color: #23C0D2;\n  color: white;\n}\n\n[unselectable=on] {\n  -moz-user-select: none;\n  -khtml-user-select: none;\n  -webkit-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n"],"sourceRoot":""}]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),

/***/ "MgpT":
/***/ (function(module, exports) {

module.exports = "<div class=\"content-container\">\n  <div class=\"row\">\n    <div class=\"card-content\" *ngIf=\"showTotalSummary()\">\n\n      <pioneer-vendor-header-summary [event]=\"onyxEvent\"\n                                     [title]=\"'EVENT.RSVPS.SUMMARY_MULTI_PRO_TITLE' | translate\"\n                                     [type]=\"headerRecordType\"\n                                     [total]=\"total\">\n      </pioneer-vendor-header-summary>\n\n    </div>\n  </div>\n</div>\n\n<div class=\"content-container\">\n  <div class=\"row\">\n    <div class=\"card-content\">\n\n      <ng-container *ngFor=\"let party of getEventProperties()\">\n        <pioneer-vendor-rsvp-card\n          [vendors]=\"getEventProperties()\"\n          [vendor]=\"party\">\n        </pioneer-vendor-rsvp-card>\n      </ng-container>\n\n    </div>\n  </div>\n</div>\n"

/***/ }),

/***/ "Mz5u":
/***/ (function(module, exports) {

module.exports = "<div class=\"content-container\">\n  <div class=\"row\">\n    <div class=\"card-content\">\n\n      <pioneer-reservation-filter\n        [event]=\"onyxEvent\">\n      </pioneer-reservation-filter>\n\n      <pioneer-reservation-button-bar\n        [event]=\"onyxEvent\"\n        data-se-id=\"addReservation\"\n        [showDownloadDropdown]=\"(showDownloadDropdown() | async) === true\"\n        [summarySelected]=\"(getSummarySelected() | async) === true\"\n        [vendor]=\"onyxEvent.eventProperty\">\n      </pioneer-reservation-button-bar>\n\n      <div [hidden]=\"canManageReservations\" class=\"result-empty\" data-se-id=\"canNotAddReservations\">\n        <p class=\"text-hint\">{{ \"EVENT.RESERVATION.RESERVATIONS_CAN_NOT_ADDED_CAPTION\" | translate }}</p>\n      </div>\n\n      <pioneer-reservation-summary-table\n        *ngIf=\"getSummarySelected() | async\"\n        [event]=\"onyxEvent\">\n      </pioneer-reservation-summary-table>\n\n      <pioneer-reservation-detail-table\n        *ngIf=\"!(getSummarySelected() | async)\"\n        [event]=\"onyxEvent\">\n      </pioneer-reservation-detail-table>\n\n    </div>\n  </div>\n</div>\n"

/***/ }),

/***/ "NM7u":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("rP7Y")(true);
// imports


// module
exports.push([module.i, ".form-container.info-rates{padding-right:15px;padding-left:15px;-ms-flex:0 0 20%;flex:0 0 20%;max-width:20%}.form-container.info-rates-list{padding-right:15px;padding-left:15px;-ms-flex:0 0 80%;flex:0 0 80%;max-width:80%}.form-group.form-error .input-group .form-control:focus{box-shadow:0 0 0 3px rgba(195,0,47,.5)}.form-group.form-error .input-group .form-control{border-color:#c3002f}.form-group .input-group .form-control:focus{border-color:#23c0d2;box-shadow:0 0 0 3px rgba(35,192,210,.5);overflow:visible;border-width:1px}.input-group>.form-control:focus{margin:0}.input-group-btn>.btn-group{border:1px solid #979797;padding:1rem}.btn-group{border-radius:.66rem;box-shadow:none}.btn-inactive{color:#292b2c;background-color:#fff;border-color:#979797}.form-control-feedback{position:relative}.form-check.center{padding-top:6px}.remove-required:after{content:\"\"!important;color:inherit!important}.non-bold{font-weight:400}.badge-secondary{color:#fff;background-color:grey}", "", {"version":3,"sources":["/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/basic-event-data/basic-event-data.component.css"],"names":[],"mappings":"AAAA,2BACE,mBAAoB,kBACD,iBACnB,aAAc,aACC,CAChB,gCAGC,mBAAoB,kBACD,iBACnB,aAAc,aACC,CAChB,wDAGC,sCAAyC,CAC1C,kDAGC,oBAAsB,CACvB,6CAGC,qBAAsB,yCACwB,iBAC5B,gBACA,CACnB,iCAGC,QAAY,CACb,4BAGC,yBAA0B,YACZ,CACf,WAGC,qBAAuB,eACN,CAClB,cAGC,cAAe,sBACQ,oBACD,CACvB,uBAGC,iBAAmB,CACpB,mBAGC,eAAiB,CAClB,uBAGG,qBAAuB,uBACG,CAC7B,UAGC,eAAmB,CACpB,iBAGC,WAAY,qBACW,CACxB","file":"basic-event-data.component.css","sourcesContent":[".form-container.info-rates {\n  padding-right: 15px;\n  padding-left: 15px;\n  flex: 0 0 20%;\n  max-width: 20%;\n}\n\n.form-container.info-rates-list {\n  padding-right: 15px;\n  padding-left: 15px;\n  flex: 0 0 80%;\n  max-width: 80%;\n}\n\n.form-group.form-error .input-group .form-control:focus {\n  box-shadow: 0 0 0 3px rgba(195,0,47,0.5);\n}\n\n.form-group.form-error .input-group .form-control {\n  border-color: #c3002f;\n}\n\n.form-group .input-group .form-control:focus {\n  border-color: #23c0d2;\n  box-shadow: 0 0 0 3px rgba(35, 192, 210, 0.5);\n  overflow: visible;\n  border-width: 1px;\n}\n\n.input-group > .form-control:focus {\n  margin: 0px;\n}\n\n.input-group-btn > .btn-group {\n  border: 1px solid #979797;\n  padding: 1rem;\n}\n\n.btn-group {\n  border-radius: 0.66rem;\n  box-shadow: none;\n}\n\n.btn-inactive {\n  color: #292b2c;\n  background-color: #fff;\n  border-color: #979797;\n}\n\n.form-control-feedback {\n  position: relative;\n}\n\n.form-check.center {\n  padding-top: 6px;\n}\n\n.remove-required:after {\n    content: '' !important;\n    color: inherit !important;\n}\n\n.non-bold {\n  font-weight:normal;\n}\n\n.badge-secondary {\n  color:white;\n  background-color: grey;\n}\n"],"sourceRoot":""}]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),

/***/ "NuAM":
/***/ (function(module, exports) {

module.exports = "<form [formGroup]=\"legalEntityForm\">\n  <div class=\"mb-5\">\n    <h3 class=\"mb-3\">{{'EVENT.COMMISSION.LEGAL_ENTITY.TITLE' | translate}}</h3>\n  </div>\n\n  <!-- VAT ID Number -->\n  <div class=\"form-group form-required\">\n    <pioneer-form-input label=\"{{'EVENT.COMMISSION.LEGAL_ENTITY.VAT_ID'}}\" message=\"MESSAGES.VALIDATION.LEGAL_ENTITY.VAT_ID\">\n      <span><br></span>\n      <span class=\"vat-id-instruction\">\n        {{ 'EVENT.COMMISSION.LEGAL_ENTITY.VAT_ID_INSTRUCTION_1' | translate }}\n      </span>\n      <span class=\"vat-id-instruction\">\n        <br>{{ 'EVENT.COMMISSION.LEGAL_ENTITY.VAT_ID_INSTRUCTION_2' | translate }}\n      </span>\n      <input type=\"email\" class=\"form-control\" maxlength=\"25\" formControlName=\"vatId\" placeholder=\"{{'EVENT.COMMISSION.LEGAL_ENTITY.VAT_ID_PLACEHOLDER' | translate}}\"/>\n    </pioneer-form-input>\n  </div>\n\n  <!-- Lega Entity Name -->\n  <div class=\"form-group form-required\">\n    <pioneer-form-input label=\"{{'EVENT.COMMISSION.LEGAL_ENTITY.NAME'}}\" message=\"MESSAGES.VALIDATION.LEGAL_ENTITY.NAME\">\n      <input type=\"email\" class=\"form-control\" maxlength=\"250\" formControlName=\"name\" placeholder=\"{{'EVENT.COMMISSION.LEGAL_ENTITY.NAME_PLACEHOLDER' | translate}}\"/>\n    </pioneer-form-input>\n  </div>\n\n  <!-- Country -->\n  <div class=\"form-group form-required\">\n    <pioneer-form-input label=\"{{'EVENT.COMMISSION.LEGAL_ENTITY.COUNTRY'}}\">\n      <select formControlName=\"country\" (change)=\"onCountryCodeChanged()\" class=\"form-control form-control-sm\">\n        <option [ngValue]=\"null\">{{ 'EVENT.EVENT_COUNTRY_PLACEHOLDER' | translate }}</option>\n        <option *ngFor=\"let option of countries\" [ngValue]=\"option.key\" >{{ option.value }}</option>\n      </select>\n    </pioneer-form-input>\n  </div>\n\n  <!-- Address 1 -->\n  <div class=\"form-group form-required\">\n    <pioneer-form-input label=\"{{'EVENT.COMMISSION.LEGAL_ENTITY.ADDRESS1'}}\" message=\"MESSAGES.VALIDATION.LEGAL_ENTITY.ADDRESS1\">\n      <input type=\"email\" class=\"form-control\" maxlength=\"100\" formControlName=\"address1\" placeholder=\"{{'EVENT.COMMISSION.LEGAL_ENTITY.ADDRESS1_PLACEHOLDER' | translate}}\"/>\n    </pioneer-form-input>\n  </div>\n\n  <!-- Address 2 -->\n  <div class=\"form-group\">\n    <pioneer-form-input label=\"{{'EVENT.COMMISSION.LEGAL_ENTITY.ADDRESS2'}}\" message=\"MESSAGES.VALIDATION.LEGAL_ENTITY.ADDRESS2\">\n      <input type=\"email\" class=\"form-control\" maxlength=\"100\" formControlName=\"address2\" placeholder=\"{{'EVENT.COMMISSION.LEGAL_ENTITY.ADDRESS2_PLACEHOLDER' | translate}}\"/>\n    </pioneer-form-input>\n  </div>\n\n  <!-- Address 3 -->\n  <div class=\"form-group\">\n    <pioneer-form-input label=\"{{'EVENT.COMMISSION.LEGAL_ENTITY.ADDRESS3'}}\" message=\"MESSAGES.VALIDATION.LEGAL_ENTITY.ADDRESS3\">\n      <input type=\"email\" class=\"form-control\" maxlength=\"100\" formControlName=\"address3\" placeholder=\"{{'EVENT.COMMISSION.LEGAL_ENTITY.ADDRESS3_PLACEHOLDER' | translate}}\"/>\n    </pioneer-form-input>\n  </div>\n\n  <!-- City -->\n  <div class=\"form-group form-required\">\n    <pioneer-form-input label=\"{{'EVENT.COMMISSION.LEGAL_ENTITY.CITY'}}\" message=\"MESSAGES.VALIDATION.LEGAL_ENTITY.CITY\">\n      <input type=\"email\" class=\"form-control\" maxlength=\"50\" formControlName=\"city\" placeholder=\"{{'EVENT.COMMISSION.LEGAL_ENTITY.CITY_PLACEHOLDER' | translate}}\">\n    </pioneer-form-input>\n  </div>\n\n  <!-- State -->\n  <div class=\"form-group\" [ngClass]=\"{ 'form-required': isStateRequired(legalEntityForm, 'country') }\">\n    <pioneer-form-input label=\"{{'EVENT.COMMISSION.LEGAL_ENTITY.STATE'}}\">\n      <select formControlName=\"state\" class=\"form-control form-control-sm\">\n        <option [ngValue]=\"null\" >{{ 'EVENT.EVENT_STATE_PLACEHOLDER' | translate }}</option>\n        <option *ngFor=\"let option of (states$ | async)\" [ngValue]=\"option.key\" >{{ option.value }}</option>\n      </select>\n      <div class=\"validation-messages\">\n        <pioneer-validation-message error=\"country_state_cross_error\" message=\"MESSAGES.VALIDATION.REQUIRED\">\n        </pioneer-validation-message>\n      </div>\n    </pioneer-form-input>\n  </div>\n\n  <!-- Postal Code -->\n  <div class=\"form-group\">\n    <pioneer-form-input label=\"{{'EVENT.COMMISSION.LEGAL_ENTITY.POSTAL'}}\" message=\"MESSAGES.VALIDATION.LEGAL_ENTITY.POSTAL\">\n      <input type=\"email\" class=\"form-control\" maxlength=\"15\" formControlName=\"postal\" placeholder=\"{{'EVENT.COMMISSION.LEGAL_ENTITY.POSTAL_PLACEHOLDER' | translate}}\"/>\n    </pioneer-form-input>\n  </div>\n\n  <div class=\"mb-5\">\n    <p class=\"font-weight-bold mb-5\">\n      {{ 'EVENT.COMMISSION.CONFIRM_SUMMARY_LEGAL_ENTITY' | translate }}\n    </p>\n  </div>\n\n</form>\n"

/***/ }),

/***/ "O2zu":
/***/ (function(module, exports) {

module.exports = "<div class=\"content-container\">\n  <div class=\"row\">\n    <div class=\"card-content\" *ngIf=\"showTotalSummary()\">\n\n      <pioneer-reservation-filter\n        [event]=\"onyxEvent\">\n      </pioneer-reservation-filter>\n\n      <pioneer-vendor-header-summary [event]=\"onyxEvent\"\n                                     [title]=\"'EVENT.RESERVATION.SUMMARY_MULTI_PRO_TITLE' | translate\"\n                                     [type]=\"headerRecordType\"\n                                     [total]=\"total\">\n      </pioneer-vendor-header-summary>\n\n    </div>\n  </div>\n</div>\n\n<div class=\"content-container\">\n  <div class=\"row\">\n    <div class=\"card-content\">\n\n      <ng-container *ngFor=\"let party of getEventSubscriberProperties()\">\n        <pioneer-vendor-reservation-card\n          [vendors]=\"getEventSubscriberProperties()\"\n          [vendor]=\"party\">\n        </pioneer-vendor-reservation-card>\n      </ng-container>\n\n    </div>\n  </div>\n</div>\n"

/***/ }),

/***/ "O49O":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("rP7Y")(true);
// imports


// module
exports.push([module.i, ".text-right{text-align:right}.hide{display:none}table td{padding:1rem .5rem 0!important;border-color:#c7c7c7!important}table .group-vendors{background-color:#23c0d2}table td:first-child,table th:first-child{padding-left:0!important}table th.subtitle{padding:0!important;background-color:#e8e6e6}.no-payment{color:#86b0f5}.badge-secondary{color:#fff;background-color:grey}", "", {"version":3,"sources":["/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/event-list/event-list-multi-vendor-table/event-list-multi-vendor.component.css"],"names":[],"mappings":"AACA,YACE,gBAAkB,CACnB,MAGC,YAAc,CACf,SAGC,+BAAqC,8BACJ,CAClC,qBAGC,wBAA0B,CAC3B,0CAIC,wBAA6B,CAC9B,kBAGC,oBAAwB,wBACE,CAC3B,YAGC,aAAc,CACf,iBAGC,WAAY,qBACW,CACxB","file":"event-list-multi-vendor.component.css","sourcesContent":["\n.text-right {\n  text-align: right;\n}\n\n.hide {\n  display: none;\n}\n\ntable td {\n  padding: 1rem 0.5rem 0rem !important;\n  border-color: #c7c7c7 !important;\n}\n\ntable .group-vendors {\n  background-color: #23C0D2;\n}\n\ntable th:first-child,\ntable td:first-child {\n  padding-left: 0px !important;\n}\n\ntable th.subtitle {\n  padding: 0px !important;\n  background-color: #E8E6E6;\n}\n\n.no-payment {\n  color: #86B0F5\n}\n\n.badge-secondary {\n  color:white;\n  background-color: grey;\n}\n"],"sourceRoot":""}]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),

/***/ "OMmu":
/***/ (function(module, exports) {

module.exports = "<div class=\"row mb-5\">\n  <div [className]=\"isCompleted ? 'col-md-8' : 'col-md'\">\n    <h2>\n      <i class=\"far {{iconClass}}\">\n      </i>\n      {{title}}\n    </h2>\n  </div>\n  <div class=\"col-md-4 text-md-right\" *ngIf=\"isCompleted\">\n    <button class=\"btn btn-secondary\" (click)=\"print($event)\">\n      <i class=\"far fa-print\"></i>\n      {{'EVENT.COMMISSION.PRINT' | translate}}\n    </button>\n  </div>\n</div>\n\n<ng-container *ngIf=\"isLoading$ | async; else notLoading\">\n</ng-container>\n\n<ng-template #notLoading>\n  <ng-container *ngIf=\"resendPaymentRequestAllowed$ | async; else other\">\n    <p class=\"mb-5\">\n      <button class=\"btn btn-secondary\" (click)=\"resendPaymentRequest()\" [disabled]=\"resendPaymentRequestDisabled$ | async\">\n        <i class=\"far fa-envelope\"></i>\n        {{'EVENT.COMMISSION.RESEND_PAYMENT_APPROVAL_REQUEST' | translate}}\n      </button>\n    </p>\n  </ng-container>\n\n  <ng-template #other>\n    <p class=\"font-weight-bold mb-5\" *ngIf=\"!invoiceGenerated && !pendingWorkflow\">\n      {{summary}}\n      <ng-container *ngIf=\"summary2\">\n        <br>\n        <br>\n        {{summary2}}\n      </ng-container>\n    </p>\n\n    <ng-container *ngIf=\"invoiceGenerated && !pendingWorkflow\">\n      <p class=\"mb-5\">\n        {{summary}}\n      </p>\n\n      <p class=\"font-weight-bold mb-5\">\n        {{invoiceGenerated}}\n      </p>\n    </ng-container>\n\n    <ng-container *ngIf=\"pendingWorkflow\">\n      <p class=\"mb-5\">\n        {{summary}}\n        <ng-container *ngIf=\"summary2\">\n          <br>\n          <br>\n          {{summary2}}\n        </ng-container>\n      </p>\n    </ng-container>\n  </ng-template>\n</ng-template>\n"

/***/ }),

/***/ "OprT":
/***/ (function(module, exports) {

module.exports = "<pioneer-confirmation-modal\n  #confirmUpdateRsvpModal\n  data-se-id=\"updateRsvpConfirmationModal\"\n  content=\"EVENT.RSVPS.CONFIRM_UPDATE_RSVP\"\n  cancel=\"COMMON.BUTTON.CANCEL\"\n  confirm=\"EVENT.RSVPS.UPDATE_RSVP\"\n  (closed)=\"confirmUpdateHandler($event)\">\n</pioneer-confirmation-modal>\n\n<div *ngIf=\"ui.showCards\">\n\n  <!--              No Matches         -->\n  <div *ngIf=\"ui.showNoMatchesCard\"\n       id=\"card-no-match-list\"\n       class=\"card\">\n    <div class=\"card-reservation-list\">\n      <pioneer-header-summary [event]=\"onyxEvent\"\n                              [title]=\"getNoMatchCardHeaderTitle() | async | translate\"\n                              [tooltipText]=\"'EVENT.COMMISSION.HEADER_SUMMARY_TOOLTIP' | translate\"\n                              [type] = \"headerRecordType\"\n                              [matchType]=\"MatchTypeEnum.NO_MATCH\"\n                              [vendor]=\"vendor\">\n      </pioneer-header-summary>\n    </div>\n\n    <div *ngIf=\"ui.showNoMatchesDetails\"\n         class=\"table-responsive table-dropdown\">\n      <table class=\"table reservation-list match-none\">\n        <thead>\n        <tr>\n          <th>\n            <br>{{ 'EVENT.RESERVATION.NAME' | translate }}<br>\n            <span class=\"font-weight-normal\">{{ 'EVENT.RESERVATION.CONFIRMATION_NUMBER' | translate }}</span>\n          </th>\n          <th><br>{{ 'EVENT.RESERVATION.STATUS' | translate }}</th>\n          <th><br>{{ 'EVENT.RESERVATION.CHECKIN_DATE' | translate }}</th>\n          <th><br>{{ 'EVENT.RESERVATION.CHECKOUT_DATE' | translate }}</th>\n          <th class=\"nights\"><br>{{ 'EVENT.RESERVATION.NUMBER_ROOMS' | translate }}</th>\n          <th class=\"nights\"><br>{{ 'EVENT.COMMISSION.ROOM_NIGHTS' | translate }}</th>\n          <th>\n            <br>{{ 'EVENT.RESERVATION.RATE_PLAN_CODE' | translate }}<br>\n            <span class=\"font-weight-normal\">{{ 'EVENT.RESERVATION.ROOM_TYPE' | translate }}</span>\n          </th>\n          <th class=\"currency\">\n            <small>({{ onyxEvent.currency | uppercase }})</small>\n            <br>{{ 'EVENT.RESERVATION.ROOM_RATE' | translate }}\n          </th>\n          <th class=\"currency\">\n            <small>({{ onyxEvent.currency | uppercase }})</small>\n            <br>{{ 'EVENT.RESERVATION.REVENUE' | translate }}\n          </th>\n          <th class=\"currency\">\n            <small>({{ onyxEvent.currency | uppercase }})</small>\n            <br>{{ 'EVENT.RESERVATION.COMMISSION' | translate }}\n          </th>\n        </tr>\n        </thead>\n        <tbody data-se-id=\"reservationDetailNoMatch\">\n        <tr *ngFor=\"let compare of noMatchPage?.content\"\n            [attr.data-res-id]=\"getReservationId(compare.reservation)\"\n            data-se-id=\"reservationDetailEntry\"\n            [ngClass]=\"getStatusClass(compare)\">\n          <td class=\"field-wrap\" data-se-id=\"name\">\n            <span *ngIf=\"compare.reservation && compare.reservation.firstName; else noMatchesOnlyLastName\">\n              {{ compare.reservation.lastName }}, {{ compare.reservation.firstName }}\n            </span>\n            <ng-template #noMatchesOnlyLastName>\n              <span *ngIf=\"compare.reservation\">\n                {{ compare.reservation.lastName }}\n              </span>\n            </ng-template>\n            <div *ngIf=\"compare.reservation\" class=\"text-muted\">{{ compare.reservation.confirmation }}</div>\n          </td>\n          <td data-se-id=\"status\" class=\"res-status\">\n            <div *ngIf=\"compare.reservation\">{{ compare.reservation.status | reservationStatus }}</div>\n          </td>\n          <td data-se-id=\"checkIn\">\n            <div *ngIf=\"compare.reservation\">{{ compare.reservation.checkInDate | dateFormat }}</div>\n          </td>\n          <td data-se-id=\"checkOut\">\n            <div *ngIf=\"compare.reservation\">{{ compare.reservation.checkOutDate | dateFormat }}</div>\n          </td>\n          <td class=\"nights\" data-se-id=\"rooms\">\n            <span *ngIf=\"compare.reservation\"\n                  class=\"res-value\">{{ compare.reservation.rooms }}</span>\n          </td>\n          <td class=\"nights\" data-se-id=\"nights\">\n            <span *ngIf=\"compare.reservation\"\n                  class=\"res-value\">{{ compare.reservation.roomNights }}</span>\n          </td>\n          <td data-se-id=\"ratePlanCode\">\n            <span *ngIf=\"compare.reservation\" class=\"res-value\">{{ compare.reservation.ratePlanCode }}</span>\n            <div *ngIf=\"compare.reservation\">{{ compare.reservation.roomType }}</div>\n          </td>\n          <td class=\"currency\" data-se-id=\"roomRate\">\n            <span *ngIf=\"compare.reservation\"\n              class=\"res-value\">{{ compare.reservation.roomRate | number:'1.2-2' }}</span>\n          </td>\n          <td class=\"currency\" data-se-id=\"revenue\">\n            <span *ngIf=\"compare.reservation\"\n              class=\"res-value\">{{ compare.reservation.revenue | number:'1.2-2' }}</span>\n          </td>\n          <td class=\"currency\" data-se-id=\"commission\">\n            <span *ngIf=\"compare.reservation\"\n              class=\"res-value\">{{ compare.reservation.commission | number:'1.2-2' }}</span>\n          </td>\n        </tr>\n        </tbody>\n      </table>\n    </div>\n\n    <!-- No Matches Warning Card -->\n    <div *ngIf=\"ui.showNoMatchesWarningCard\"\n         class=\"result-empty\"\n         data-se-id=\"no-matches-warning\">\n      <h3>{{ 'EVENT.RESERVATION.NO_FILTERED_RESERVATIONS_FOUND' | translate }}</h3>\n      <figure class=\"figure\">\n        <i class=\"glyph-page figure-img\"></i>\n        <figcaption class=\"figure-caption\">\n          <a (click)=\"resetStatusCodes()\">\n            {{ 'EVENT.RESERVATION.NO_FILTERED_RESERVATIONS_FOUND_CAPTION' | translate }}\n          </a>\n        </figcaption>\n      </figure>\n    </div>\n\n    <div class=\"card-footer\" *ngIf=\"noMatchPage?.totalElements > 0\">\n      <pioneer-pagination\n        [resultsPage]=\"noMatchPage\"\n        (updatePage)=\"onRefreshNoMatchList($event.page, $event.itemsPerPage)\"\n        [pagesizeType]=\"noMatchespagesizeType\">\n      </pioneer-pagination>\n    </div>\n\n  </div>\n\n  <!--              Partial Matches         -->\n  <div *ngIf=\"ui.showPartialMatchesCard\"\n       id=\"card-partial-match-list\"\n       class=\"card\">\n    <div class=\"card-reservation-list\">\n      <pioneer-header-summary [event]=\"onyxEvent\"\n                              [title]=\"'EVENT.RESERVATION.PARTIAL_MATCH_TITLE' | translate\"\n                              [tooltipText]=\"'EVENT.COMMISSION.HEADER_SUMMARY_TOOLTIP' | translate\"\n                              [type] = \"headerRecordType\"\n                              [matchType]=\"MatchTypeEnum.PARTIAL_MATCH\"\n                              [vendor]=\"vendor\">\n      </pioneer-header-summary>\n    </div>\n\n    <div *ngIf=\"ui.showPartialMatchesDetails\"  class=\"table-responsive table-dropdown\">\n      <table class=\"table reservation-list match-partial\">\n        <thead>\n        <tr>\n          <ng-container *ngIf=\"(canChangeRSVPs$ | async) === true\">\n            <th *pioneerAuthorize=\"{permission: 'EditRsvp'}\"></th>\n          </ng-container>\n          <th><br>{{ 'EVENT.RSVPS.TYPE' | translate }}</th>\n          <th>\n            <br>{{ 'EVENT.RESERVATION.NAME' | translate }}<br>\n            <span class=\"font-weight-normal\">{{ 'EVENT.RESERVATION.CONFIRMATION_NUMBER' | translate }}</span>\n          </th>\n          <th><br>{{ 'EVENT.RESERVATION.STATUS' | translate }}</th>\n          <th><br>{{ 'EVENT.RESERVATION.CHECKIN_DATE' | translate }}</th>\n          <th><br>{{ 'EVENT.RESERVATION.CHECKOUT_DATE' | translate }}</th>\n          <th class=\"nights\"><br>{{ 'EVENT.RESERVATION.NUMBER_ROOMS' | translate }}</th>\n          <th class=\"nights\"><br>{{ 'EVENT.RESERVATION.NUMBER_NIGHTS' | translate }}</th>\n          <th class=\"nights\"><br>{{ 'EVENT.COMMISSION.ROOM_NIGHTS' | translate }}</th>\n          <th>\n            <br>{{ 'EVENT.RESERVATION.RATE_PLAN_CODE' | translate }}<br>\n            <span class=\"font-weight-normal\">{{ 'EVENT.RESERVATION.ROOM_TYPE' | translate }}</span>\n          </th>\n          <th class=\"currency\">\n            <small>({{ onyxEvent.currency | uppercase }})</small>\n            <br>{{ 'EVENT.RESERVATION.ROOM_RATE' | translate }}\n          </th>\n          <th class=\"currency\">\n            <small>({{ onyxEvent.currency | uppercase }})</small>\n            <br>{{ 'EVENT.RESERVATION.REVENUE' | translate }}\n          </th>\n          <th class=\"currency\">\n            <small>({{ onyxEvent.currency | uppercase }})</small>\n            <br>{{ 'EVENT.RESERVATION.COMMISSION' | translate }}\n          </th>\n        </tr>\n        </thead>\n        <tbody data-se-id=\"reservationDetailPartial\">\n        <tr *ngFor=\"let compare of partialMatchPage?.content; last as isLast\"\n            [attr.data-rsvp-id]=\"getRsvpId(compare.rsvp)\"\n            [attr.data-res-id]=\"getReservationId(compare.reservation)\"\n            data-se-id=\"reservationDetailEntry\"\n            [ngClass]=\"getStatusClass(compare)\">\n          <ng-container *ngIf=\"(canChangeRSVPs$ | async) === true\">\n            <td class=\"col-more\" *pioneerAuthorize=\"{permission: 'EditRsvp'}\" data-se-id=\"openDropdownMenu\">\n              <!-- Bootstrap (jQuery) -->\n              <div [ngClass]=\"isLast ? 'dropup' : 'dropdown'\">\n                <button class=\"btn btn-more\" data-toggle=\"dropdown\">\n                  <i class=\"far fa-ellipsis-h\"></i>\n                </button>\n                <ul class=\"dropdown-menu\">\n                  <li role=\"menuitem\" *pioneerAuthorize=\"{permission: 'EditRsvp'}\">\n                    <a class=\"dropdown-item\" href=\"javascript:void(0)\" (click)=\"confirmBeforeUpdate($event, compare)\" data-se-id=\"openUpdateRsvpModal\">\n                      <i class=\"fal fa-user-edit fa-fw\"></i>\n                      {{ 'EVENT.RSVPS.UPDATE_RSVP_MENU_ITEM' | translate }}\n                    </a>\n                  </li>\n                </ul>\n              </div>\n            </td>\n          </ng-container>\n          <td data-se-id=\"type\">\n            <span class=\"res-value\">{{ 'EVENT.RSVPS.TYPE_RESERVATION' | translate }}</span>\n            <span class=\"rsvp-value\">{{ 'EVENT.RSVPS.TYPE_RSVP' | translate }}</span>\n          </td>\n          <td class=\"field-wrap\" data-se-id=\"name\">\n            <span class=\"res-value\" *ngIf=\"compare.reservation.firstName; else partialMatchesOnlyLastNameReservation\">\n              {{ compare.reservation.lastName }}, {{ compare.reservation.firstName }}\n            </span>\n            <ng-template #partialMatchesOnlyLastNameReservation>\n              <span class=\"res-value\">\n                {{ compare.reservation.lastName }}\n              </span>\n            </ng-template>\n            <span class=\"rsvp-value\" *ngIf=\"compare.rsvp.firstName; else partialMatchesOnlyLastNameRsvp\">\n              {{ compare.rsvp.lastName }}, {{ compare.rsvp.firstName }}\n            </span>\n            <ng-template #partialMatchesOnlyLastNameRsvp>\n              <span class=\"rsvp-value\">\n                {{ compare.rsvp.lastName }}\n              </span>\n            </ng-template>\n            <div class=\"text-muted\">{{ compare.reservation.confirmation }}</div>\n          </td>\n          <td data-se-id=\"status\" class=\"res-status\"\n              [class.diff-down]=\"isNotCommissionable(compare)\">\n            <span class=\"res-value\">{{ compare.reservation.status | reservationStatus }}</span>\n            <span class=\"rsvp-value\">--</span>\n          </td>\n          <td data-se-id=\"checkIn\"\n              [class.diff-up]=\"isNightsUp(compare)\"\n              [class.diff-down]=\"isNightsDown(compare)\"\n              [class.diff]=\"isDatesBold(compare)\">\n            <span class=\"res-value\">{{ compare.reservation.checkInDate | dateFormat }}</span>\n            <span class=\"rsvp-value\">{{ compare.rsvp.checkInDate | dateFormat }}</span>\n          </td>\n          <td data-se-id=\"checkOut\"\n              [class.diff-up]=\"isNightsUp(compare)\"\n              [class.diff-down]=\"isNightsDown(compare)\"\n              [class.diff]=\"isDatesBold(compare)\">\n            <span class=\"res-value\">{{ compare.reservation.checkOutDate | dateFormat }}</span>\n            <span class=\"rsvp-value\">{{ compare.rsvp.checkOutDate | dateFormat }}</span>\n          </td>\n          <td class=\"nights\" data-se-id=\"rooms\">\n            <span class=\"res-value\">{{ compare.reservation.rooms }}</span>\n            <span class=\"rsvp-value\">1</span>\n          </td>\n          <td class=\"nights\" data-se-id=\"nights\"\n              [class.diff-up]=\"isNightsUp(compare)\"\n              [class.diff-down]=\"isNightsDown(compare)\">\n            <span class=\"res-value\">{{ compare.reservation.nights }}</span>\n            <span class=\"rsvp-value\">{{ compare.rsvp.nights }}</span>\n          </td>\n          <td class=\"nights\" data-se-id=\"roomNights\">\n            <span class=\"res-value\">{{ compare.reservation.roomNights }}</span>\n            <span class=\"rsvp-value\">{{ compare.rsvp.nights }}</span>\n          </td>\n          <td data-se-id=\"ratePlanCode\">\n            <span class=\"res-value\">{{ compare.reservation.ratePlanCode }}</span>\n            <span class=\"rsvp-value\">--</span>\n            <span class=\"res-value text-muted\">{{ compare.reservation.roomType }}</span>\n          </td>\n          <td class=\"currency\" data-se-id=\"roomRate\"\n              [class.diff-up]=\"isRoomRateUp(compare)\"\n              [class.diff-down]=\"isRoomRateDown(compare)\">\n            <span class=\"res-value\">{{ compare.reservation.roomRate | number:'1.2-2' }}</span>\n            <span class=\"rsvp-value\">{{ compare.rsvp.roomRate | number:'1.2-2' }}</span>\n          </td>\n          <td class=\"currency\" data-se-id=\"revenue\"\n              [class.diff-up]=\"isRevenueUp(compare)\"\n              [class.diff-down]=\"isRevenueDown(compare)\">\n            <span class=\"res-value\">{{ compare.reservation.revenue | number:'1.2-2' }}</span>\n            <span class=\"rsvp-value\">{{ compare.rsvp.revenue | number:'1.2-2' }}</span>\n          </td>\n          <td class=\"currency\" data-se-id=\"commission\"\n              [class.diff-up]=\"isCommissionUp(compare)\"\n              [class.diff-down]=\"isCommissionDown(compare)\">\n            <span\n              class=\"res-value\">{{ compare.reservation.commission | number:'1.2-2' }}</span>\n            <span class=\"rsvp-value\">{{ compare.rsvp.commission | number:'1.2-2' }}</span>\n          </td>\n        </tr>\n        </tbody>\n      </table>\n    </div>\n\n    <!-- Partial Matches Warning Card -->\n    <div *ngIf=\"this.ui.showPartialMatchesWarningCard\"\n         class=\"result-empty\"\n         data-se-id=\"partial-matches-warning\">\n      <h3>{{ 'EVENT.RESERVATION.NO_FILTERED_RESERVATIONS_FOUND' | translate }}</h3>\n      <figure class=\"figure\">\n        <i class=\"glyph-page figure-img\"></i>\n        <figcaption class=\"figure-caption\">\n          <a (click)=\"resetStatusCodes()\">\n            {{ 'EVENT.RESERVATION.NO_FILTERED_RESERVATIONS_FOUND_CAPTION' | translate }}\n          </a>\n        </figcaption>\n      </figure>\n    </div>\n\n    <div class=\"card-footer\" *ngIf=\"partialMatchPage?.totalElements > 0\">\n      <pioneer-pagination\n        [resultsPage]=\"partialMatchPage\"\n        (updatePage)=\"onRefreshPartialMatchList($event.page, $event.itemsPerPage)\"\n        [pagesizeType]=\"partialMatchespagesizeType\">\n      </pioneer-pagination>\n    </div>\n  </div>\n\n\n  <!--              Exact Matches         -->\n  <div *ngIf=\"ui.showExactMatchesCard\"\n       id=\"card-exact-match-list\"\n       class=\"card\">\n    <div class=\"card-reservation-list\">\n      <pioneer-header-summary [event]=\"onyxEvent\"\n                              [title]=\"'EVENT.RESERVATION.EXACT_MATCH_TITLE' | translate\"\n                              [tooltipText]=\"'EVENT.COMMISSION.HEADER_SUMMARY_TOOLTIP' | translate\"\n                              [type] = \"headerRecordType\"\n                              [matchType]=\"MatchTypeEnum.EXACT_MATCH\"\n                              [vendor]=\"vendor\">\n      </pioneer-header-summary>\n    </div>\n\n    <div *ngIf=\"ui.showExactMatchesDetails\"\n         class=\"table-responsive table-dropdown\">\n      <table class=\"table reservation-list match-exact\">\n        <thead>\n        <tr>\n          <th>\n            <br>{{ 'EVENT.RESERVATION.NAME' | translate }}<br>\n            <span class=\"font-weight-normal\">{{ 'EVENT.RESERVATION.CONFIRMATION_NUMBER' | translate }}</span>\n          </th>\n          <th><br>{{ 'EVENT.RESERVATION.STATUS' | translate }}</th>\n          <th><br>{{ 'EVENT.RESERVATION.CHECKIN_DATE' | translate }}</th>\n          <th><br>{{ 'EVENT.RESERVATION.CHECKOUT_DATE' | translate }}</th>\n          <th class=\"nights\"><br>{{ 'EVENT.RESERVATION.NUMBER_ROOMS' | translate }}</th>\n          <th class=\"nights\"><br>{{ 'EVENT.COMMISSION.ROOM_NIGHTS' | translate }}</th>\n          <th>\n            <br>{{ 'EVENT.RESERVATION.RATE_PLAN_CODE' | translate }}<br>\n            <span class=\"font-weight-normal\">{{ 'EVENT.RESERVATION.ROOM_TYPE' | translate }}</span>\n          </th>\n          <th class=\"currency\">\n            <small>({{ onyxEvent.currency | uppercase }})</small><br>\n            {{ 'EVENT.RESERVATION.ROOM_RATE' | translate }}\n          </th>\n          <th class=\"currency\">\n            <small>({{ onyxEvent.currency | uppercase }})</small><br>\n            {{ 'EVENT.RESERVATION.REVENUE' | translate }}\n          </th>\n          <th class=\"currency\">\n            <small>({{ onyxEvent.currency | uppercase }})</small><br>\n            {{ 'EVENT.RESERVATION.COMMISSION' | translate }}\n          </th>\n        </tr>\n        </thead>\n        <tbody data-se-id=\"reservationDetailExact\">\n        <tr *ngFor=\"let compare of exactMatchPage?.content\"\n            [attr.data-rsvp-id]=\"getRsvpId(compare.rsvp.eventRsvpId)\"\n            [attr.data-res-id]=\"getReservationId(compare.reservation)\"\n            data-se-id=\"reservationDetailEntry\"\n            [ngClass]=\"getStatusClass(compare)\">\n          <td class=\"field-wrap\" data-se-id=\"name\">\n            <span *ngIf=\"compare.reservation.firstName; else exactMatchesOnlyLastName\">\n              {{ compare.reservation.lastName }}, {{ compare.reservation.firstName }}\n            </span>\n            <ng-template #exactMatchesOnlyLastName>\n              <span>\n                {{ compare.reservation.lastName }}\n              </span>\n            </ng-template>\n            <div class=\"text-muted\">{{ compare.reservation.confirmation }}</div>\n          </td>\n          <td data-se-id=\"status\" class=\"res-status\">{{ compare.reservation.status | reservationStatus }}</td>\n          <td data-se-id=\"checkIn\">{{ compare.reservation.checkInDate | dateFormat }}</td>\n          <td data-se-id=\"checkOut\">{{ compare.reservation.checkOutDate | dateFormat }}</td>\n          <td class=\"nights\" data-se-id=\"rooms\">{{ compare.reservation.rooms }}</td>\n          <td class=\"nights\" data-se-id=\"nights\">{{ compare.reservation.roomNights }}</td>\n          <td data-se-id=\"roomType\">\n            <span class=\"res-value\">{{ compare.reservation.ratePlanCode }}</span>\n            <span class=\"res-value text-muted\">{{ compare.reservation.roomType }}</span>\n          </td>\n          <td class=\"currency\" data-se-id=\"roomRate\">{{ compare.reservation.roomRate | number:'1.2-2' }}\n          </td>\n          <td class=\"currency\" data-se-id=\"revenue\">{{ compare.reservation.revenue | number:'1.2-2' }}\n          </td>\n          <td class=\"currency\" data-se-id=\"commission\">{{ compare.reservation.commission | number:'1.2-2' }}\n          </td>\n        </tr>\n        </tbody>\n      </table>\n    </div>\n\n    <!-- Exact Matches Warning Card -->\n    <div *ngIf=\"ui.showExactMatchesWarningCard\"\n         class=\"result-empty\"\n         data-se-id=\"exact-matches-warning\">\n      <h3>{{ 'EVENT.RESERVATION.NO_FILTERED_RESERVATIONS_FOUND' | translate }}</h3>\n      <figure class=\"figure\">\n        <i class=\"glyph-page figure-img\"></i>\n        <figcaption class=\"figure-caption\">\n          <a (click)=\"resetStatusCodes()\">\n            {{ 'EVENT.RESERVATION.NO_FILTERED_RESERVATIONS_FOUND_CAPTION' | translate }}\n          </a>\n        </figcaption>\n      </figure>\n    </div>\n\n    <div class=\"card-footer\" *ngIf=\"exactMatchPage?.totalElements > 0\">\n      <pioneer-pagination\n        [resultsPage]=\"exactMatchPage\"\n        (updatePage)=\"onRefreshExactMatchList($event.page, $event.itemsPerPage)\"\n        [pagesizeType]=\"exactMatchespagesizeType\">\n      </pioneer-pagination>\n    </div>\n\n  </div>\n\n</div>\n\n<div *ngIf=\"ui.showNoReservationsWarning\" class=\"result-empty\" data-se-id=\"reservationDetailNotFound\">\n  <h3>{{ \"EVENT.RESERVATION.NO_RESERVATIONS_FOUND\" | translate }}</h3>\n  <figure class=\"figure\">\n    <i class=\"glyph-page figure-img\"></i>\n  </figure>\n</div>\n"

/***/ }),

/***/ "P7oG":
/***/ (function(module, exports) {

module.exports = "<div class=\"card-header\">{{ 'DASHBOARD.MISSING_AGENCY' | translate }}</div>\n<div class=\"card-block\">\n  <p class=\"dashboard-display text-warning\">\n    <span data-se-id = \"missingAgencyTotal\" class=\"count\">{{ missingAgencyTotal | async }}</span>\n  </p>\n</div>\n<div class=\"card-footer\">\n  <a href=\"javascript:void(0)\"\n     (click)=\"missingAgencyPredefinedSearch()\"\n     data-se-id=\"missing-agency-predefined-search\">\n    {{ 'DASHBOARD.VIEW_MISSING_AGENCY' | translate }}\n  </a>\n</div>\n"

/***/ }),

/***/ "PHNp":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("rP7Y")(true);
// imports


// module
exports.push([module.i, "a:active,a:hover,a:link,a:visited{text-decoration:none!important}", "", {"version":3,"sources":["/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/vendor-card-detail/vendor-card-detail.component.css"],"names":[],"mappings":"AAgBA,kCACE,8BAAgC,CACjC","file":"vendor-card-detail.component.css","sourcesContent":["/* unvisited link */\na:link {\n  text-decoration: none !important;\n}\n\n/* visited link */\na:visited {\n  text-decoration:none  !important;\n}\n\n/* mouse over link */\na:hover {\n  text-decoration:none !important;\n}\n\n/* selected link */\na:active {\n  text-decoration:none !important;\n}\n"],"sourceRoot":""}]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),

/***/ "PUE1":
/***/ (function(module, exports) {

module.exports = "<pioneer-confirmation-modal\n  #confirmDeleteModal\n  data-se-id=\"event-delete-confirmation-modal\"\n  content=\"MESSAGES.CONFIRMATION.DELETE_EVENT\"\n  cancel=\"COMMON.BUTTON.CANCEL\"\n  confirm=\"COMMON.BUTTON.DELETE\"\n  [title]=\"confirmationModalConfig.title\"\n  (closed)=\"confirmBeforeDeletingHandler($event)\">\n</pioneer-confirmation-modal>\n\n<pioneer-confirmation-modal\n  #confirmUnmatchModal\n  data-se-id=\"event-delete-confirmation-modal\"\n  content=\"MESSAGES.CONFIRMATION.UNMATCH_EVENT\"\n  cancel=\"COMMON.BUTTON.CANCEL\"\n  confirm=\"COMMON.BUTTON.OK\"\n  [title]=\"confirmationModalConfig.title\"\n  (closed)=\"confirmBeforeUnmatchingHandler($event)\">\n</pioneer-confirmation-modal>\n\n<pioneer-event-collision-modal\n  data-se-id=\"event-collision-modal\"\n  mode=\"UPDATE\"\n  (closed)=\"confirmBeforeSaveEventHandler($event)\"\n  (canceled)=\"cancelMatchingWizard($event)\">\n</pioneer-event-collision-modal>\n\n<pioneer-event-collision-modal-multiprompt\n  data-se-id=\"event-collision-modal-multiprompt\"\n  mode=\"UPDATE\"\n  (closed)=\"confirmBeforeSaveEventHandler($event)\"\n  (canceled)=\"cancelMatchingWizard($event)\">\n</pioneer-event-collision-modal-multiprompt>\n\n<pioneer-unmatch-event-modal\n  data-se-id=\"unmatch-event-modal\"\n  [event]=\"onyxEvent\"\n  (closed)=\"confirmUnmatchPopupHandler($event)\">\n</pioneer-unmatch-event-modal>\n<ng-template #eventButtonBar>\n  <pioneer-event-button-bar\n    data-se-id=\"edit-event-button-bar\"\n    [eventForm]=\"eventForm\"\n    [isReadOnly]=\"isReadOnly\"\n    [isEventLockdown]=\"isEventLockdown\"\n    [isNotEditable]=\"(canEditContractSummary$ | async) === false\"\n    [hidden]=\"hideEditButton\"\n    [isMultiVendor]=\"isMultiVendor\"\n    (save)=\"onSaveBtn(eventForm.value)\"\n    (cancel)=\"cancel()\"\n    [canBeDeleted]=\"canBeDeleted\"\n    (delete)=\"confirmBeforeDeleting()\"\n    (edit)=\"edit()\"\n    (unmatch)=\"unmatch()\"\n    [canBeUnmatched]=\"canBeUnmatched | async\">\n  </pioneer-event-button-bar>\n</ng-template>\n\n<div class=\"content-container\">\n  <div class=\"row\">\n    <div class=\"card-content\">\n      <form [formGroup]=\"eventForm\" novalidate>\n\n        <ng-container *ngTemplateOutlet=\"eventButtonBar\"></ng-container>\n\n        <pioneer-basic-event-data\n          [parentForm]=\"eventForm\"\n          [event]=\"onyxEvent\"\n          [isReadOnly]=\"isReadOnly || (canEditContractSummary$ | async) === false\"\n          [isMultiVendorUserAndEventCreatedByProperty]=\"isMultiVendorUserAndEventCreatedByProperty\"\n          [focusEventNameSubject]=\"focusEventNameSubject\">\n        </pioneer-basic-event-data>\n\n        <ng-container *pioneerAuthorize=\"{permission: 'SingleVendor'}\">\n          <pioneer-property-lookup-form\n            [parentForm]=\"eventForm\"\n            [event]=\"onyxEvent\"\n            [isReadOnly]=\"isReadOnly\"\n            [inputEmail]=\"agencyEmail\"\n            (outputEmail)=\"setupPropertyEmail($event)\">\n          </pioneer-property-lookup-form>\n        </ng-container>\n\n        <ng-container *pioneerAuthorize=\"{permission: 'MultiVendor'}\">\n          <pioneer-vendor-lookup-form\n            [parentForm]=\"eventForm\"\n            [isReadOnly]=\"isReadOnly\"\n            [inputEmail]=\"agencyEmail\"\n            (removeVendorProcess)=\"removeVendorProcess($event)\"\n            (outputEmail)=\"setupPropertyEmail($event)\">\n          </pioneer-vendor-lookup-form>\n        </ng-container>\n\n        <pioneer-agency-form\n          [parentForm]=\"eventForm\"\n          [event]=\"onyxEvent\"\n          [isReadOnly]=\"isReadOnly || (canEditAgencyContact$ | async) === false\"\n          [inputEmail]=\"propertyEmail\"\n          (outputEmail)=\"setupAgencyEmail($event)\"\n          (selectedAgency)=\"selectedAgency()\">\n        </pioneer-agency-form>\n\n        <pioneer-contact-form\n          [parentForm]=\"eventForm\"\n          partyType=\"CLIENT\"\n          [event]=\"onyxEvent\"\n          [isReadOnly]=\"isReadOnly || (canEditClientContact$ | async) === false\"\n          [clientContactEditable]=\"clientContactEditable\">\n        </pioneer-contact-form>\n\n        <ng-container *ngTemplateOutlet=\"eventButtonBar\"></ng-container>\n\n      </form>\n      <ng-container *ngIf=\"onyxEvent.eventId\">\n        <div *pioneerAuthorize=\"{permission: 'SingleVendor'}\">\n          <pioneer-attachment [eventId]=\"onyxEvent.eventId\" [vendor]=\"propertyUserEventParty\"></pioneer-attachment>\n        </div>\n      </ng-container>\n    </div>\n  </div>\n</div>\n"

/***/ }),

/***/ "QLMO":
/***/ (function(module, exports) {

module.exports = "<div class=\"form-group\" [class.form-error]=\"displayError\" [class.form-required]=\"isRequired\">\n  <label *ngIf=\"showLabel\" for=\"{{ inputControl.name }}\">{{label | translate}}</label>\n  <ng-content></ng-content>\n  <div class=\"validation-messages\" *ngFor=\"let error of getDefaultErrors\">\n    <pioneer-validation-message [for]=\"inputControl.name\"\n                                [error]=\"error\"\n                                [message]=\"message\">\n    </pioneer-validation-message>\n  </div>\n  <ng-content class=\"form-text form-control-feedback\" select=\".validation-messages\"></ng-content>\n</div>\n"

/***/ }),

/***/ "Qe5c":
/***/ (function(module, exports) {

module.exports = "<div class=\"row align-items-baseline\">\n  <span class=\"col-md\">\n      {{ 'COMMON.PAGINATION.RESULTS_INFO' | translate : {\n              first: firstPageItemNumber,\n              last: lastPageItemNumber,\n              total: resultsPage.totalElements\n          }\n      }}\n  </span>\n  <div class=\"col-xs\">\n    <select class=\"form-control form-control-sm\" [(ngModel)]=\"selectedItemsPerPage\" (ngModelChange)=\"onChangeItemsPerPage($event)\">\n      <option [ngValue]=\"10\">10</option>\n      <option [ngValue]=\"25\">25</option>\n      <option [ngValue]=\"50\">50</option>\n      <option [ngValue]=\"100\">100</option>\n    </select>\n  </div>\n  <pagination class=\"col-xs\"\n              [directionLinks]=\"true\"\n              [boundaryLinks]=\"true\"\n              [totalItems]=\"resultsPage.totalElements\"\n              [itemsPerPage]=\"resultsPage.size\"\n              [maxSize]=\"10\"\n              [(ngModel)]=\"currentPageNumber\"\n              (pageChanged)=\"goToPage($event.page)\"\n              previousText=\"&lsaquo;\"\n              nextText=\"&rsaquo;\"\n              firstText=\"&laquo;\"\n              lastText=\"&raquo;\">\n  </pagination>\n</div>\n"

/***/ }),

/***/ "R0p8":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("rP7Y")(true);
// imports


// module
exports.push([module.i, ".payment-event-details{background-color:#292b2c!important;color:#fff;padding:1rem 1rem!important}", "", {"version":3,"sources":["/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/payment/payment-action/payment-action.component.css"],"names":[],"mappings":"AAAA,uBACE,mCAAqC,WACxB,2BACiB,CAC/B","file":"payment-action.component.css","sourcesContent":[".payment-event-details {\n  background-color: #292b2c !important;\n  color: white;\n  padding: 1rem 1rem !important;\n}"],"sourceRoot":""}]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),

/***/ "RN5c":
/***/ (function(module, exports) {

module.exports = "<div class=\"modal fade\" bsModal [config]=\"config\" role=\"dialog\" tabindex=\"-1\" data-se-id=\"iata-by-default-modal\">\n  <div class=\"modal-dialog\" role=\"document\">\n    <div class=\"modal-content\">\n      <div class=\"modal-header\">\n        <h5 class=\"modal-title\">{{ 'DEFAULT_IATA_SELECTOR.TITLE' | translate }}</h5>\n      </div>\n      <div class=\"modal-body\" style=\"font-size: 14px;\">\n        <div class=\"row\">\n          <div class=\"col form-container\">        \n            <p>{{ 'DEFAULT_IATA_SELECTOR.CONTENT' | translate }}</p>\n          </div>\n        </div>\n        <div class=\"row\">\n          <div class=\"col form-container\">        \n            <pioneer-dropdown-search  [control]=\"agencyControl\"\n                                      label=\"DEFAULT_IATA_SELECTOR.LABEL\" \n                                      placeholder=\"DEFAULT_IATA_SELECTOR.PLACEHOLDER\"\n                                      controlName=\"agency\"\n                                      [options]=\"agencies\"\n                                      (selected)=\"agencySelected($event)\"\n                                      #agencyDropdown>\n            </pioneer-dropdown-search>   \n          </div>\n        </div>\n        <div class=\"row\" >\n          <div class=\"col form-container\" style=\"text-align: right;\">\n            <button type=\"button\" class=\"btn btn-primary\" [disabled]=\"!enableButton\" (click)=\"apply()\">\n              {{ 'DEFAULT_IATA_SELECTOR.BUTTON' | translate }}\n            </button>          \n          </div>    \n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),

/***/ "RYae":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("rP7Y")(true);
// imports


// module
exports.push([module.i, ".collapsed-card .card-header{border-bottom:0}", "", {"version":3,"sources":["/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/property-lookup-form/property-lookup-form.component.css"],"names":[],"mappings":"AAAA,6BACI,eAAiB,CACpB","file":"property-lookup-form.component.css","sourcesContent":[".collapsed-card .card-header {\n    border-bottom: 0;\n}\n"],"sourceRoot":""}]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),

/***/ "S4zL":
/***/ (function(module, exports) {

module.exports = "<div class=\"filter-tag\" *ngFor=\"let rate of ratePlanCodes; index as i\">\n  <span class=\"filter-tag-text\" title={{getTitleFromRpc(rate)}}>{{rate.ratePlanCode}}</span>\n  <!-- This cannot be a button.  If this were a button, then clicking 'Enter' anywhere in the form will click it -->\n  <i *ngIf=\"showCloseIcon && rate.closeable\" class=\"far fa-times filter-tag-close\" (click)=\"removeRate(i)\"></i>\n</div>\n"

/***/ }),

/***/ "TAjX":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("rP7Y")(true);
// imports


// module
exports.push([module.i, ".address1{-ms-flex:0 0 100%;flex:0 0 100%;max-width:100%}", "", {"version":3,"sources":["/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/vendor-add/vendor-add.component.css"],"names":[],"mappings":"AAAA,UACI,kBAAA,cAAe,cACC,CACjB","file":"vendor-add.component.css","sourcesContent":[".address1 {\n    flex: 0 0 100%;\n    max-width: 100%;\n  }"],"sourceRoot":""}]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),

/***/ "Twnd":
/***/ (function(module, exports) {

module.exports = "<div class=\"button-bar\">\n\n  <a routerLink=\".\" class=\"btn btn-link\" [hidden]=\"isReadOnly\" (click)=\"cancelClick()\" data-se-id=\"cancelButton\">\n    {{'COMMON.BUTTON.CANCEL' | translate}}\n  </a>\n  <button *pioneerAuthorize=\"{permission: 'AddEvent'}\" type=\"button\" class=\"btn btn-primary\" [hidden]=\"isReadOnly\"\n    [disabled]=\"!eventForm.valid\" (click)=\"saveClick()\" data-se-id=\"saveButton\">\n    {{'COMMON.BUTTON.SAVE' | translate}}\n  </button>\n\n  <a *ngIf=\"isReadOnly === true && isSupportUser() === true\">\n    <button class=\"btn btn-danger\" [hidden]=\"!canBeUnmatched\" (click)=\"unmatchClick()\"  data-se-id=\"unmatchButton\">\n      {{'COMMON.BUTTON.UNMATCH' | translate}}\n    </button>\n  </a>\n\n  <a *pioneerAuthorize=\"{permission: 'DeleteEvent'}\" [hidden]=\"!isReadOnly\">\n\n    <button class=\"btn btn-danger\" [hidden]=\"!canBeDeleted\" (click)=\"deleteClick()\" [disabled]=\"!eventForm.valid\"\n      data-se-id=\"deleteButton\">\n      {{'COMMON.BUTTON.DELETE' | translate}}\n    </button>\n\n    <p class=\"text-hint\" [hidden]=\"canBeDeleted\">\n      {{'EVENT.NOT_ELIGIBLE_FOR_DELETION' | translate }}\n    </p>\n  </a>\n\n  <a>\n    <button *pioneerAuthorize=\"{permission: 'EditEvent'}\" type=\"button\" class=\"btn btn-primary\" [hidden]=\"!isReadOnly\" [disabled]=\"isNotEditable\"\n      (click)=\"editClick()\" data-se-id=\"editButton\">\n      {{'COMMON.BUTTON.EDIT' | translate}}\n    </button>\n  </a>\n\n</div>\n"

/***/ }),

/***/ "UZA7":
/***/ (function(module, exports) {

module.exports = "<div class=\"modal fade\" bsModal [config]=\"config\" role=\"dialog\" tabindex=\"-1\" dataSeId = 'reservation-bulk-modal'>\n  <div class=\"modal-dialog modal-lg\" role=\"document\">\n    <div class=\"modal-content\">\n      <div class=\"modal-header\">\n        <h5 class=\"modal-title\">{{'EVENT.RESERVATION.UPLOAD_BULK_RESERVATION.TITLE' | translate}}</h5>\n        <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\" (click)=\"cancel()\">\n          <span aria-hidden=\"true\">&times;</span>\n        </button>\n      </div>\n      <div class=\"modal-body\">\n        <div class=\"row\">\n          <div class=\"col-md-4 text-center\">\n            <div class=\"mt-2\">\n              <a [href]=\"templateUrl\">\n                <i class=\"fal fa-file-spreadsheet fa-5x mb-3\"></i>\n                <p>\n                    {{'EVENT.RESERVATION.UPLOAD_BULK_RESERVATION.DOWNLOAD' | translate}}\n                    <br>\n                    {{'EVENT.RESERVATION.UPLOAD_BULK_RESERVATION.EXAMPLE_TEMPLATE' | translate}}\n                </p>\n              </a>\n            </div>\n          </div>\n          <div class=\"col-md-8\">\n            <p>\n              <strong>\n                {{'EVENT.RESERVATION.UPLOAD_BULK_RESERVATION.RECOMMENDATIONS_INTRO' | translate}}\n              </strong>\n            </p>\n            <ul>\n              <li>{{'EVENT.RESERVATION.UPLOAD_BULK_RESERVATION.RECOMMENDATIONS_BLANK_CELLS' | translate}}</li>\n              <li>{{'EVENT.RESERVATION.UPLOAD_BULK_RESERVATION.RECOMMENDATIONS_CHARACTERS' | translate}}</li>\n              <li>{{'EVENT.RESERVATION.UPLOAD_BULK_RESERVATION.RECOMMENDATIONS_DATE_FORMAT' | translate}}</li>\n              <li>{{'EVENT.RESERVATION.UPLOAD_BULK_RESERVATION.RECOMMENDATIONS_MAX_ROWS' | translate}}</li>\n            </ul>\n          </div>\n        </div>\n        <div class=\"progress\" [hidden]=\"!isUploadInProgress\">\n          <div class=\"progress-bar progress-bar-striped progress-bar-animated\"\n               role=\"progressbar\"\n               aria-valuenow=\"100\"\n               aria-valuemin=\"0\"\n               aria-valuemax=\"100\"\n               style=\"width: 100%\">{{'EVENT.UPLOADING' | translate}}\n          </div>\n        </div>\n\n      </div>\n      <div class=\"modal-footer\">\n        <form data-se-id=\"reservationBulkForm\">\n          <button type=\"button\" class=\"btn btn-link\" data-dismiss=\"modal\" (click)=\"cancel()\" data-se-id=\"reservation-bulk-modal-cancel\">\n            {{'COMMON.BUTTON.CANCEL' | translate}}\n          </button>\n          <label class=\"btn btn-primary\" for=\"file\" data-se-id=\"reservation-bulk-modal-upload\">\n            {{'EVENT.RESERVATION.UPLOAD_BULK_RESERVATION.UPLOAD_BUTTON' | translate}}\n          </label>\n          <input #file\n                 id=\"file\"\n                 data-se-id=\"reservation-bulk-input-file\"\n                 hidden\n                 type=\"file\"\n                 accept=\"{{fileExtensions}}\"\n                 [disabled]=\"isUploadInProgress\"\n                 (change)=\"importReservationFile($event)\"/>\n        </form>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),

/***/ "Um/v":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("rP7Y")(true);
// imports


// module
exports.push([module.i, ".modal-header{border-bottom-style:none;-ms-flex-align:baseline;align-items:baseline}.modal-header .text-muted{font-style:italic;text-align:right;margin-block-end:0}.table tbody tr{cursor:pointer}.table tbody tr:hover{background-color:#eceeef}.text-caption{font-size:85%;color:#62798a;display:block}.text-nowrap{white-space:nowrap!important}.label-placeholder{display:inline-block}.form-container .btn{width:100%}", "", {"version":3,"sources":["/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/vendor-rate/vendor-rate.component.css"],"names":[],"mappings":"AAAA,cACE,yBAA0B,wBAC1B,oBAAsB,CACvB,0BAGC,kBAAmB,iBACD,kBACE,CACrB,gBAGC,cAAgB,CACjB,sBAGC,wBAAyC,CAC1C,cAGC,cAAe,cACA,aACA,CAChB,aAGC,4BAA8B,CAC/B,mBAGC,oBAAsB,CACvB,qBAGC,UAAY,CACb","file":"vendor-rate.component.css","sourcesContent":[".modal-header {\n  border-bottom-style: none;\n  align-items: baseline;\n}\n\n.modal-header .text-muted {\n  font-style: italic;\n  text-align: right;\n  margin-block-end: 0;\n}\n\n.table tbody tr {\n  cursor: pointer;\n}\n\n.table tbody tr:hover {\n  background-color: rgba(236, 238, 239, 1);\n}\n\n.text-caption {\n  font-size: 85%;\n  color: #62798a;\n  display: block;\n}\n\n.text-nowrap {\n  white-space: nowrap!important;\n}\n\n.label-placeholder {\n  display: inline-block;\n}\n\n.form-container .btn {\n  width: 100%;\n}\n"],"sourceRoot":""}]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),

/***/ "Uvhx":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("rP7Y")(true);
// imports


// module
exports.push([module.i, ".vat-id-instruction{font-style:italic;font-size:13px}", "", {"version":3,"sources":["/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/payment/payment-legal-entity/payment-legal-entity.component.css"],"names":[],"mappings":"AAAA,oBACE,kBAAmB,cACH,CACjB","file":"payment-legal-entity.component.css","sourcesContent":[".vat-id-instruction {\n  font-style: italic;\n  font-size: 13px;\n}\n"],"sourceRoot":""}]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),

/***/ "UxNZ":
/***/ (function(module, exports) {

module.exports = "<div class=\"content-container\">\n  <div class=\"row\">\n    <div class=\"card-content\">\n\n      <div class=\"clearfix mb-5\">\n        <div class=\"active-filters\">\n          <div class=\"view-select float-right\">\n            <div class=\"btn-group btn-group-sm\">\n              <button class=\"btn btn-default\"\n                      [ngClass]=\"{'active': !isInDetail }\"\n                      (click)=\"navigateTo('/event/' + eventLink + '/rsvp')\"\n                      data-se-id=\"rsvp-summary-toggle-button\">\n                <i class=\"glyph-page\"></i>{{'EVENT.RESERVATION.SUMMARY_BUTTON' | translate}}\n              </button>\n              <button class=\"btn btn-default\"\n                      [ngClass]=\"{'active': isInDetail }\"\n                      (click)=\"navigateTo('/event/' + eventLink + '/rsvp/detail')\"\n                      data-se-id=\"rsvp-compare-toggle-button\"\n                      [disabled]=\"disableCompareButton$ | async\">\n                <i class=\"glyph-pages\"></i>{{'EVENT.RESERVATION.COMPARE_BUTTON' | translate}}\n              </button>\n            </div>\n          </div>\n        </div>\n      </div>\n\n      <pioneer-add-rsvp\n        [event]=\"onyxEvent\"\n        [showDownloadDropdown]=\"(areRsvpsPresent$ | async) === true\"\n        [summarySelected]=\"(showReservationCompareSummary$ | async) === true\"\n        [vendor]=\"vendor\">\n      </pioneer-add-rsvp>\n\n      <pioneer-rsvp-summary\n        *ngIf=\"showReservationCompareSummary$ | async\"\n        [event]=\"onyxEvent\"\n        [vendor]=\"vendor\">\n      </pioneer-rsvp-summary>\n\n      <pioneer-rsvp-compare\n        *ngIf=\"!(showReservationCompareSummary$ | async)\"\n        [event]=\"onyxEvent\"\n        [vendor]=\"vendor\">\n      </pioneer-rsvp-compare>\n\n    </div>\n  </div>\n</div>\n"

/***/ }),

/***/ "VmT3":
/***/ (function(module, exports) {

module.exports = "<pioneer-confirmation-modal\n  data-se-id=\"prepaymentConfirmationModal\"\n  content=\"MESSAGES.CONFIRMATION.PROCEED\"\n  cancel=\"COMMON.BUTTON.CANCEL\"\n  confirm=\"COMMON.BUTTON.CONFIRM\"\n  (closed)=\"prepaymentConfirmationClosed($event)\"\n  [title]=\"confirmationModalConfig.title\">\n</pioneer-confirmation-modal>\n\n<div class=\"card\" data-se-id=\"addPrepaymentCard\">\n  <div class=\"card-header\" data-se-id=\"addPrepaymentCardHeader\">\n    {{ \"EVENT.PREPAYMENT.PREPAYMENT_CARD_TITLE\" | translate }}\n  </div>\n  <div class=\"card-block\">\n    <form [formGroup]=\"prepaymentForm\" data-se-id=\"prepaymentForm\" id=\"prepaymentForm\">\n      <div class=\"row\">\n        <div class=\"col-md-3 form-container\">\n          <div class=\"form-group form-required\" data-se-id=\"prepaymentAmountFormGroup\">\n            <pioneer-form-input label=\"EVENT.PREPAYMENT.AMOUNT\">\n              <div class=\"input-group\">\n                <input formControlName=\"prepaymentAmount\" type=\"number\" class=\"form-control\" data-se-id=\"prepaymentAmount\"\n                  placeholder=\"{{ 'EVENT.PREPAYMENT.AMOUNT_PLACEHOLDER' | translate }}\" maxlength=\"11\">\n                <div *ngIf=\"event.currency\" class=\"input-group-addon\">\n                  <span class=\"input-group-text\">{{ event.currency | uppercase }}</span>\n                </div>\n              </div>\n              <div class=\"validation-messages\">\n                <pioneer-validation-message for=\"prepaymentAmount\" error=\"min\" message=\"{{ 'MESSAGES.VALIDATION.MIN_AMOUNT' | translate : '{ amount: 100, currency: \\'' + (event.currency | uppercase) + '\\' }' }}\"></pioneer-validation-message>\n              </div>\n            </pioneer-form-input>\n          </div>\n        </div>\n        <div class=\"col-md-9 form-container\">\n          <div class=\"form-group\">\n            <pioneer-form-input label=\"EVENT.PREPAYMENT.DESCRIPTION\">\n              <input formControlName=\"description\" type=\"text\" class=\"form-control\" data-se-id=\"description\"\n                placeholder=\"{{ 'EVENT.PREPAYMENT.DESCRIPTION_PLACEHOLDER' | translate }}\" maxlength=\"255\">\n            </pioneer-form-input>\n          </div>\n        </div>\n      </div>\n    </form>\n  </div>\n</div>\n<div class=\"button-bar\">\n  <a routerLink=\".\" class=\"btn btn-link\" (click)=\"cancelClick()\" data-se-id=\"cancelButton\">\n    {{'COMMON.BUTTON.CANCEL' | translate}}\n  </a>\n  <button type=\"button\" class=\"btn btn-primary\" [disabled]=\"disableSave()\" (click)=\"saveClick()\" data-se-id=\"saveButton\">\n    {{ \"EVENT.PREPAYMENT.SAVE_PREPAYMENT_BUTTON\" | translate }}\n  </button>\n</div>\n"

/***/ }),

/***/ "VsoP":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("rP7Y")(true);
// imports


// module
exports.push([module.i, ".can-remove:hover:after{border-radius:3px 12px 3px 3px;content:\"V\"!important;background-color:#c3002f}.file-btn{border-radius:60px;color:#000;font-size:20px;background:#fff;padding:10px 30px 10px 30px;border:1px solid #000;text-decoration:none}.file-btn:hover{background:#e8e8e8;text-decoration:none}.doc-library .file-list .file-item .item-link{display:block!important;color:#000!important;text-decoration:none!important;cursor:pointer!important;font-size:15px!important}", "", {"version":3,"sources":["/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/pickup-report-attachment/pickup-report-attachment.component.css"],"names":[],"mappings":"AAAA,wBACE,+BAAgC,sBACJ,wBACF,CAC3B,UAKC,mBAAoB,WACL,eACC,gBACI,4BACS,sBACH,oBACJ,CACvB,gBAGC,mBAAoB,oBACE,CACvB,8CAGC,wBAA0B,qBACA,+BACO,yBACN,wBACA,CAC5B","file":"pickup-report-attachment.component.css","sourcesContent":[".can-remove:hover::after {\n  border-radius: 3px 12px 3px 3px;\n  content: '\\0056' !important;\n  background-color: #c3002f;\n}\n\n.file-btn {\n  -webkit-border-radius: 60px;\n  -moz-border-radius: 60px;\n  border-radius: 60px;\n  color: #000000;\n  font-size: 20px;\n  background: #ffffff;\n  padding: 10px 30px 10px 30px;\n  border: solid #000000 1px;\n  text-decoration: none;\n}\n\n.file-btn:hover {\n  background: #e8e8e8;\n  text-decoration: none;\n}\n\n.doc-library .file-list .file-item .item-link {\n  display: block !important;\n  color: #000000 !important;\n  text-decoration: none !important;\n  cursor: pointer !important;\n  font-size: 15px !important;\n}\n"],"sourceRoot":""}]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),

/***/ "WXh5":
/***/ (function(module, exports) {

module.exports = "<div class=\"modal fade\" bsModal role=\"dialog\" tabindex=\"-1\">\n    <div class=\"modal-dialog modal-xl\">\n      <div class=\"modal-content\">\n        <div class=\"modal-header\">\n          <div class=\"container\">\n            <div class=\"row justify-content-between\">\n              <h5 class=\"modal-title\">{{ \"EVENT.UNMATCH_POPUP.TITLE\" | translate }}</h5>\n              <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\" (click)=\"onCancel()\">\n                <span aria-hidden=\"true\">&times;</span>\n              </button>\n            </div>\n          </div>\n        </div>        \n        <div class=\"modal-body\">\n          <div class=\"container\">\n            <div class=\"row g-2\">\n              <p class=\"lead\" data-se-id=\"heading\">\n                {{ \"EVENT.UNMATCH_POPUP.CONTENT_1\" | translate }} {{ \"EVENT.UNMATCH_POPUP.CONTENT_2\" | translate }} {{ \"EVENT.UNMATCH_POPUP.CONTENT_3\" | translate }}\n              </p>\n            </div>\n            <div class=\"row g-2\" style=\"align-items: baseline;\" *ngIf=\"agency.code && agency.code != null && agency.code.length > 0\">\n              <p class=\"lead\" style=\"font-size: 1.15rem\" data-se-id=\"heading\">\n                <input type=\"checkbox\" id=\"agency_{{ agency.code }}\" (change)=\"changeIsPartySelected($event, agency.type, agency.code)\" value=\"{{agency.code}}\">&nbsp;&nbsp;&nbsp;{{ \"EVENT.UNMATCH_POPUP.AGENCY\" | translate }} {{agency.name}} - {{agency.code}}\n              </p>\n            </div>\n            <div class=\"row g-2\" style=\"align-items: baseline;\" *ngFor=\"let vendor of vendors\">\n              <input type=\"checkbox\" id=\"vendor_{{ vendor.code }}\" (change)=\"changeIsPartySelected($event, vendor.type, vendor.code)\" value=\"{{vendor.code}}\" [disabled]=\"isAgencySelected()\">\n              <p class=\"lead\" style=\"font-size: 1.15rem\" data-se-id=\"heading\">  \n                &nbsp;&nbsp;&nbsp;{{ \"EVENT.UNMATCH_POPUP.HOTEL\" | translate }} {{vendor.name}}<br/>\n                &nbsp;&nbsp;&nbsp;{{vendor.address}}\n              </p>\n            </div>\n            <div class=\"row g-2 form-group form-required\">\n              <label for=\"reasonForUnmatch\">{{ \"EVENT.UNMATCH_POPUP.REASON_FOR_UNMATCH\" | translate }}</label>\n              <textarea class=\"form-control\"\n                        [(ngModel)]=\"reasonForUnmatch\"\n                        maxlength=\"1024\"\n                        data-se-id=\"reasonForUnmatch\"\n                        rows=\"4\"></textarea>\n            </div>            \n          </div>          \n        </div>  \n        <div class=\"modal-footer\">\n          <div class=\"button-bar\">\n            <a routerLink=\".\" class=\"btn btn-link\" data-se-id=\"cancelButton\" (click)=\"onCancel()\">\n              {{ \"EVENT.UNMATCH_POPUP.CANCEL_BTN\" | translate }}\n            </a>\n            <button type=\"button\" class=\"btn btn-primary\" data-se-id=\"unmatchButton\"  (click)=\"onUnmatch()\" [disabled]=\"isPartySelected.size === 0 || reasonForUnmatch.length === 0\">\n              {{ \"EVENT.UNMATCH_POPUP.UNMATCH_BTN\" | translate }}\n            </button>\n          </div>\n        </div>        \n      </div>\n    </div>\n  </div>\n"

/***/ }),

/***/ "X9TO":
/***/ (function(module, exports) {

module.exports = "<div class=\"row align-items-baseline\">\n  <span class=\"col-md\">\n      {{ 'COMMON.PAGINATION.RESULTS_INFO' | translate : {\n              first: firstPageItemNumber,\n              last: lastPageItemNumber,\n              total: resultsPage.totalElements\n          }\n      }}\n  </span>\n  <div class=\"col-xs\">\n    <select class=\"form-control form-control-sm\" [(ngModel)]=\"selectedItemsPerPage\" (ngModelChange)=\"onChangeItemsPerPage($event)\">\n      <ng-container *ngFor=\"let item of elResultsPage\">\n        <option [ngValue]=\"item\">{{item}}</option>\n      </ng-container>\n    </select>\n  </div>\n  <pagination class=\"col-xs\"\n              [directionLinks]=\"true\"\n              [boundaryLinks]=\"true\"\n              [totalItems]=\"resultsPage.totalElements\"\n              [itemsPerPage]=\"resultsPage.size\"\n              [maxSize]=\"10\"\n              [(ngModel)]=\"currentPageNumber\"\n              [disabled]=\"disablePagination\"\n              (pageChanged)=\"goToPage($event.page)\"\n              previousText=\"&lsaquo;\"\n              nextText=\"&rsaquo;\"\n              firstText=\"&laquo;\"\n              lastText=\"&raquo;\">\n  </pagination>\n</div>\n"

/***/ }),

/***/ "XRtp":
/***/ (function(module, exports) {

module.exports = "<a class=\"form-text\" href=\"javascript:void(0)\" (click)=\"sortList()\">\n  {{label}}\n  <i [ngClass]=\"isSorted && isAsc ? 'fas fa-caret-up' : 'fas fa-caret-down'\" class=\"\" *ngIf=\"isSorted\" ></i>\n</a>\n"

/***/ }),

/***/ "XZrh":
/***/ (function(module, exports) {

module.exports = "<div class=\"card\" [ngClass]=\"{ 'collapsed-card': showAdvancedPropertySearch && !isPropertySelected }\" id=\"card-{{partyType | lowercase}}\" data-se-id=\"propertyLookupForm\">\n\n  <div class=\"card-header\">\n    <div class=\"container\">\n      <div class=\"row justify-content-between\">\n        {{ 'EVENT.EVENT_VENDORS' | translate }}\n        <span class=\"text-danger\" *ngIf=\"isReadyOnlyProperty\">*</span>\n      </div>\n    </div>\n  </div>\n\n  <div class=\"card-block\">\n    <div id=\"vendors\">\n      <ng-container *ngFor=\"let party of onyxEvent.eventVendors; let i = index; trackBy: trackVendorByFn\">\n        <pioneer-vendor-card-detail #card\n          [parentForm]=\"parentForm\"\n          [vendor]=\"party\"\n          [inputEmail]=\"inputEmail\"\n          (deleteVendor)=\"onDeleteVendor($event)\"\n          [isReadOnly]=\"isReadOnly\"\n          (outputEmail)=\"setupPropertyEmail($event)\"\n          [isCardOpen]=\"i === openedCardIndex\"\n          (onToggleCard)=\"onToggle(i, card)\">\n        </pioneer-vendor-card-detail>\n      </ng-container>\n    </div>\n  </div>\n\n  <div *ngIf=\"isPropertyMissing()\" class=\"card-block\">\n    <div class=\"alert alert-danger\">\n      {{ 'EVENT.VENDOR_REQUIRED' | translate }}\n    </div>\n  </div>\n\n  <div class=\"card-footer\">\n    <div class=\"container\">\n        <button *ngIf=\"shouldShowAddVendorButton()\"\n                type=\"button\"\n                class=\"btn btn-primary float-right\"\n                (click)=\"openAdvancedPropertySearchPopup()\"\n                [disabled]=\"!isValidRequiredInformation()\"\n                [title]=\"addVendorButtonTittle\">\n          {{ ('EVENT.ADD_VENDOR' | translate) }}\n        </button>\n         <!-- Informative Message -->\n        <div *ngIf=\"shouldShowAddVendorsMessage()\"\n              class=\"add-vendor-message\">\n              <b style=\"font-weight: 900;\">{{ ('EVENT.ADD_VENDOR_NOTE_1' | translate) }}</b><br>\n              {{ ('EVENT.ADD_VENDOR_NOTE_2' | translate) }}\n        </div>\n    </div>\n  </div>\n\n</div>\n\n<pioneer-vendor-popup *pioneerAuthorize=\"{permission: 'ViewExtendedPropertySearch'}\"\n                      [currentEventVendors]=\"onyxEvent.eventVendors\"\n                      (closed)=\"closedPropertyPopup($event)\">\n</pioneer-vendor-popup>\n"

/***/ }),

/***/ "Xi0/":
/***/ (function(module, exports) {

module.exports = "<div class=\"content-container\">\n  <div class=\"row\">\n    <div class=\"card-content\">\n\n      <form [formGroup]=\"commissionForm\" novalidate>\n        <pioneer-basic-event-data\n          [parentForm]=\"commissionForm\"\n          [event]=\"onyxEvent\"\n          [isReadOnly]=\"true\">\n        </pioneer-basic-event-data>\n      </form>\n\n      <div class=\"button-bar\">\n\n        <ng-container *pioneerAuthorize=\"{permission: 'PayCommission'}\">\n          <p *ngIf=\"showPrepaymentHintText\" class=\"text-hint order-one\" data-se-id=\"prepaymentHintText\">\n            {{ 'EVENT.PREPAYMENT.PREPAYMENT_OPTION_MISSING_AGENCY' | translate }}\n          </p>\n          <button *ngIf=\"displayAddPrepaymentButton()\" class=\"btn btn-primary order-one\" (click)=\"displayPrepaymentClick()\"\n            data-se-id=\"prepaymentButton\" [disabled]=\"!canMakePrepayment\">\n            {{ 'EVENT.PREPAYMENT.DISPLAY_PREPAYMENT_BUTTON' | translate }}\n          </button>\n        </ng-container>\n\n        <ng-container *pioneerAuthorize=\"{permission: 'ExportReports'}\">\n          <div class=\"btn-group order-one\" *ngIf=\"ui.showDownloadDropdown\">\n            <button class=\"btn btn-primary dropdown-toggle\" data-toggle=\"dropdown\" data-se-id=\"download-reservation-summary-dropdown-button\">\n              {{ \"EVENT.COMMISSION.EXPORT_DROPDOWN\" | translate }}\n            </button>\n            <div class=\"dropdown-menu dropdown-menu-right\">\n              <button class=\"dropdown-item\"\n                (click)=\"getPaymentsReport('excel')\"\n                data-se-id=\"download-commission-excel-option\">\n                {{ \"COMMON.REPORT.EXPORT_EXCEL\" | translate }}\n              </button>\n              <button class=\"dropdown-item\"\n                      (click)=\"getPaymentsReport('pdf')\"\n                      data-se-id=\"download-commission-pdf-option\">\n                {{ \"EVENT.COMMISSION.EXPORT_PDF\" | translate }}\n              </button>\n            </div>\n          </div>\n        </ng-container>\n\n        <ng-container *pioneerAuthorize=\"{permission: 'AddAdjustment'}\">\n          <p *ngIf=\"displayAddAdjustmentButton() && disableAddAdjustmentButton()\" class=\"text-hint\">\n            {{ 'EVENT.ADJUSTMENT.DISABLED_ADD_ADJUSTMENT_BUTTON_MESSAGE' | translate }}\n          </p>\n          <div *ngIf=\"displayAddAdjustmentButton() && (canAddAdjustment$ | async) === true\" class=\"btn-group order-one\">\n            <button class=\"btn btn-primary\" (click)=\"addAdjustmentClick()\"\n              data-se-id=\"adjustmentDropdownToggle\" [disabled]=disableAddAdjustmentButton()>\n              {{ 'EVENT.ADJUSTMENT.DISPLAY_ADD_ADJUSTMENT_BUTTON' | translate }}\n            </button>\n          </div>\n        </ng-container>\n\n      </div>\n\n      <div *pioneerAuthorize=\"{permission: 'PayCommission'}\" data-se-id=\"addPrepaymentRoot\">\n        <pioneer-add-prepayment *ngIf=\"displayedPrepayment\" [event]=\"onyxEvent\" [vendor]=\"onyxEvent.eventProperty\" [minAmount]=\"minAmountPrepayment\" (save)=\"onAddPrepayment()\" (cancel)=\"onCancelPrepayment()\"></pioneer-add-prepayment>\n      </div>\n\n      <ng-container *ngIf=\"(canAddAdjustment$ | async) === true\">\n        <div *pioneerAuthorize=\"{permission: 'AddAdjustment'}\" data-se-id=\"addAdjustmentRoot\">\n          <pioneer-add-adjustment *ngIf=\"!isCollapsedAddAdjustment\"\n            [event]=\"onyxEvent\"\n            [vendor]=\"onyxEvent.eventProperty\"\n            (save)=\"onAddAdjustment()\" (cancel)=\"onCancelAdjustment()\">\n          </pioneer-add-adjustment>\n        </div>\n      </ng-container>\n\n      <ng-container *ngIf=\"ui.showAddPayment\">\n        <pioneer-add-payment\n          [event]=\"onyxEvent\"\n          [prepayment]=\"prepayment\"\n          [vendor]=\"onyxEvent.eventProperty\"\n          data-se-id=\"addPaymentForm\">\n        </pioneer-add-payment>\n      </ng-container>\n\n      <pioneer-payment-summary\n        *ngIf=\"ui.showPaymentSummary\"\n        [event]=\"onyxEvent\"\n        [prepayment]=\"prepayment\"\n        [vendor]=\"onyxEvent.eventProperty\">\n      </pioneer-payment-summary>\n\n      <pioneer-payment-record\n        *ngIf=\"ui.showPaymentRecord\"\n        [event]=\"onyxEvent\"\n        [prepayment]=\"prepayment\"\n        [finalPaymentStatusList]=\"finalPaymentStatusList\"\n        [vendor]=\"onyxEvent.eventProperty\">\n      </pioneer-payment-record>\n\n      <pioneer-payment-reservations *ngIf=\"onyxEvent.eventProperty.subscriber\" [event]=\"onyxEvent\" [vendor]=\"onyxEvent.eventProperty\"></pioneer-payment-reservations>\n\n      <pioneer-payment-rsvp *ngIf=\"!onyxEvent.eventProperty.subscriber\" [event]=\"onyxEvent\" [vendor]=\"onyxEvent.eventProperty\"></pioneer-payment-rsvp>\n\n    </div>\n  </div>\n</div>\n"

/***/ }),

/***/ "YYg3":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("rP7Y")(true);
// imports


// module
exports.push([module.i, ".order-one{-ms-flex-order:1!important;order:1!important}.no-payment,.non-bold{font-weight:400}.no-payment{color:#86b0f5}.no-text-decoration{text-decoration:none}.commission-card{margin-bottom:15px}", "", {"version":3,"sources":["/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/reservations/vendor-reservation-card/vendor-reservation-card.component.css"],"names":[],"mappings":"AAAA,WACE,2BAAA,iBAAoB,CACrB,sBAGC,eAAmB,CAGrB,YAEE,aAAc,CACf,oBAGC,oBAAsB,CACvB,iBAGC,kBAAoB,CACrB","file":"vendor-reservation-card.component.css","sourcesContent":[".order-one {\n  order: 1 !important;\n}\n\n.non-bold {\n  font-weight:normal;\n}\n\n.no-payment {\n  font-weight:normal;\n  color: #86B0F5\n}\n\n.no-text-decoration {\n  text-decoration: none;\n}\n\n.commission-card{\n  margin-bottom: 15px;\n}\n"],"sourceRoot":""}]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),

/***/ "ZGDz":
/***/ (function(module, exports) {

module.exports = "<div class=\"card commission-card\">\n\n  <div class=\"card-header\" id=\"heading-{{vendor.chain}}-{{vendor.brand}}-{{vendor.propertyId}}\">\n    <div class=\"container\">\n      <div class=\"row justify-content-between\">\n        <div class=\"col flex33\">\n          <span>\n            <a href=\"#!\" class=\"card-state-toggle no-text-decoration\"\n              (click)=\"vendor.isExpanded ? onCardExpandClicked($event, vendor.eventPartyId, vendor.chain, vendor.brand, vendor.propertyId, false)\n                                            : onCardExpandClicked($event, vendor.eventPartyId, vendor.chain, vendor.brand, vendor.propertyId, true)\">\n              <i class=\"far fa-fw {{vendor.isExpanded ? 'fa-chevron-up' : 'fa-chevron-down'}}\"></i>\n            </a>\n            <ng-container *pioneerAuthorize=\"{permission: 'ViewGroupPayPropertyIndicators'}\">\n              <img *ngIf=\"vendor.subscriber\" src=\"{{imagesUrl}}/grouppay-logo-symbol.png\" width=\"22px\" height=\"22px\"\n                   tooltip=\"{{'EVENTS.PROPERTY_SUBSCRIBED_TOOLTIP' | translate }}\">\n            </ng-container>\n            &nbsp;{{ vendor.name }}\n          </span>\n        </div>\n        <div class=\"col\" *ngIf=\"!vendor.isExpanded\">\n          <pioneer-vendor-header-summary [event]=\"onyxEvent\"\n                  [type]=\"headerRecordType\"\n                  [vendor]=\"vendor\">\n          </pioneer-vendor-header-summary>\n        </div>\n      </div>\n    </div>\n  </div>\n\n  <div *ngIf=\"vendor.isExpanded\">\n    <div class=\"card-block\">\n      <div class=\"content-container\">\n        <div class=\"row\">\n\n          <div class=\"card\">\n            <pioneer-header-summary\n              [event]=\"onyxEvent\"\n              [title]=\"'EVENT.OVERVIEW_CARDS.NIGHTS_BY_ROOM_TYPE_TITLE' | translate\"\n              [type] = \"headerRecordType\"\n              [vendor]=\"vendor\">\n            </pioneer-header-summary>\n            <pioneer-stay-summary\n              [event]=\"onyxEvent\"\n              [type]=\"headerRecordType\"\n              [vendor]=\"vendor\">\n            </pioneer-stay-summary>\n          </div>\n\n          <pioneer-date-room-type-summary\n            [event]=\"onyxEvent\"\n            [vendor]=\"vendor\">\n          </pioneer-date-room-type-summary>\n\n        </div>\n      </div>\n    </div>\n  </div>\n\n</div>\n"

/***/ }),

/***/ "Zod0":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("rP7Y")(true);
// imports


// module
exports.push([module.i, ".input-group-less-width{width:50%}", "", {"version":3,"sources":["/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/payment/forecasted-commission/forecasted-commission.component.css"],"names":[],"mappings":"AAAA,wBACE,SAAW,CACZ","file":"forecasted-commission.component.css","sourcesContent":[".input-group-less-width {\n  width: 50%;\n}\n"],"sourceRoot":""}]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),

/***/ "ZoyG":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("rP7Y")(true);
// imports


// module
exports.push([module.i, ".no-link{text-decoration:unset;cursor:unset}.help-button{-ms-flex-item-align:end;-ms-grid-row-align:end;align-self:end;padding-right:5px!important}.help-button .btn-group{margin-bottom:22px}.help-button .btn{background-color:#2f455c;height:34px;padding:2px 35px 2px 16px;font-size:12px}.help-button .dropdown-item{white-space:nowrap}.options{padding-left:5px!important}", "", {"version":3,"sources":["/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/navigation/header/header.component.css"],"names":[],"mappings":"AACA,SACE,sBAAuB,YACT,CACf,aAGC,wBAAA,uBAAA,eAAgB,2BACc,CAC/B,wBAEC,kBAAoB,CACrB,kBAEC,yBAA0B,YACb,0BACc,cACX,CACjB,4BAEC,kBAAoB,CACrB,SAEC,0BAA6B,CAC9B","file":"header.component.css","sourcesContent":["\n.no-link {\n  text-decoration: unset;\n  cursor: unset;\n}\n\n.help-button {\n  align-self: end;\n  padding-right: 5px !important;\n}\n.help-button .btn-group{\n  margin-bottom: 22px;\n}\n.help-button .btn{\n  background-color: #2F455C;\n  height: 34px;\n  padding: 2px 35px 2px 16px;\n  font-size: 12px;\n}\n.help-button .dropdown-item{\n  white-space: nowrap;\n}\n.options{\n  padding-left: 5px !important;\n}\n"],"sourceRoot":""}]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),

/***/ "Zu/a":
/***/ (function(module, exports) {

module.exports = "<div class=\"modal fade\" bsModal [config]=\"config\" role=\"dialog\" tabindex=\"-1\"\n     data-se-id=\"confirmation-modal\">\n  <div class=\"modal-dialog\" role=\"document\" [ngClass]=\"{'modal-lg': customModal}\">\n    <div class=\"modal-content\" [ngClass]=\"{'custom-modal': customModal}\">\n      <div class=\"modal-body\">\n        <p class=\"lead\" *ngIf=\"title\" [innerHTML]=\"title | translate\" data-se-id=\"title\"></p>\n        <p *ngIf=\"title && customModal\" class=\"h-line\"></p>\n        <p id=\"content\" data-se-id=\"content\" [innerHTML]=\"content | translate\" [ngClass]=\"{'custom-content': customContent}\"></p>\n        <div class=\"button-bar\">\n          <button data-se-id=\"confirmation-modal-cancel\" type=\"button\" class=\"btn btn-link\" [ngClass]=\"{ 'btn-sm': !customModal}\"\n                  (click)=\"onCancel()\" title=\"{{ cancel | translate }}\">\n            {{ cancel | translate }}\n          </button>\n          <button data-se-id=\"confirmation-modal-confirm\" type=\"button\" class=\"btn btn-primary\" [ngClass]=\"{ 'btn-sm': !customModal}\"\n                  style=\"margin-right: 1rem;\"\n                  (click)=\"onAccept()\" title=\"{{ confirm | translate }}\">\n            <span [class]=\"confirmClass\">{{ confirm | translate }}</span>\n          </button>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),

/***/ "aYlK":
/***/ (function(module, exports) {

module.exports = "<div class=\"button-bar\">\n  <!-- Report buttons -->\n  <ng-container *pioneerAuthorize=\"{permission: 'ExportReports'}\">\n    <div class=\"btn-group\" *ngIf=\"showDownloadDropdown\">\n      <button class=\"btn btn-primary dropdown-toggle\" data-toggle=\"dropdown\" data-se-id=\"download-rsvp-summary-dropdown-button\">\n        {{ \"COMMON.REPORT.EXPORT_DROPDOWN\" | translate }}\n      </button>\n      <div class=\"dropdown-menu dropdown-menu-right\">\n        <button class=\"dropdown-item\"\n          (click)=\"getRsvpReport('excel')\"\n          data-se-id=\"download-rsvp-summary-excel-option\">\n          {{ \"COMMON.REPORT.EXPORT_EXCEL\" | translate }}\n        </button>\n        <button class=\"dropdown-item\"\n                (click)=\"getRsvpReport('pdf')\"\n                data-se-id=\"download-rsvp-summary-pdf-option\">\n          {{ \"COMMON.REPORT.EXPORT_PDF\" | translate }}\n        </button>\n      </div>\n    </div>\n  </ng-container>\n  <!-- Report buttons -->\n\n  <!-- Add RSVP dropdown button -->\n  <ng-container *ngIf=\"showAddRsvpButtons\">\n    <div class=\"btn-group\" *ngIf=\"displayAddRsvp() && (canChangeRSVPs$ | async) === true\">\n      <button class=\"btn btn-primary dropdown-toggle\" data-toggle=\"dropdown\" data-se-id=\"add-rsvp-dropdown-button\">\n        {{ \"EVENT.RSVPS.ADD_RSVP_BUTTON\" | translate }}\n      </button>\n      <div class=\"dropdown-menu dropdown-menu-right\">\n        <button *pioneerAuthorize=\"{permission: 'AddRsvp'}\"\n                class=\"dropdown-item\"\n                data-toggle=\"collapse\"\n                data-target=\"#addRsvpCard\"\n                aria-controls=\"addRsvpCard\"\n                [ngClass]=\"{ 'collapsed': isAddRsvpCollapsed }\"\n                (click)=\"isAddRsvpCollapsed = !isAddRsvpCollapsed\"\n                [attr.aria-expanded]=\"!isAddRsvpCollapsed\"\n                data-se-id=\"add-individual-rsvp-button\">\n          {{ \"COMMON.BUTTON.INDIVIDUAL\" | translate }}\n        </button>\n        <button *pioneerAuthorize=\"{permission: 'UploadRsvp'}\"\n                class=\"dropdown-item\"\n                (click)=\"openUploadBulkRsvp($event)\"\n                data-se-id=\"open-rsvp-bulk-button\">\n          {{ \"COMMON.BUTTON.BULK\" | translate }}\n        </button>\n      </div>\n    </div>\n  </ng-container>\n  <!-- Add RSVP dropdown button -->\n</div>\n\n<!-- Add RSVP Card -->\n<div *ngIf=\"!isAddRsvpCollapsed\" class=\"card collapse\" id=\"addRsvpCard\">\n  <div id=\"card-add-rsvp\" class=\"card-header\">\n    {{ \"EVENT.RSVPS.ADD_RSVP_HEADER\" | translate }}\n  </div>\n  <div class=\"card-block\">\n    <pioneer-rsvp-form [event]=\"onyxEvent\" [vendor]=\"vendor\"></pioneer-rsvp-form>\n  </div>\n</div>\n<!-- Add RSVP Card -->\n<!-- Cancel/Save buttons -->\n<div *ngIf=\"!isAddRsvpCollapsed\" class=\"button-bar\">\n  <a class=\"btn btn-link\"\n    (click)=\"cancelAddRsvp();\"\n    data-toggle=\"collapse\"\n    data-target=\"#addRsvpCard\"\n    aria-controls=\"addRsvpCard\"\n    [ngClass]=\"{ 'collapsed': isAddRsvpCollapsed }\"\n    [attr.aria-expanded]=\"!isAddRsvpCollapsed\"\n    data-se-id=\"cancel-button\">\n    {{'COMMON.BUTTON.CANCEL' | translate}}\n  </a>\n  <button class=\"btn btn-primary\"\n          (click)=\"addRsvp();\"\n          data-se-id=\"addGuestButton\"\n          [disabled]=\"disableSave()\">\n    {{ \"EVENT.RSVPS.ADD_RSVP_BUTTON\" | translate }}\n  </button>\n</div>\n<!-- Cancel/Save buttons -->\n\n<pioneer-rsvp-bulk [event]=\"onyxEvent\" [vendor]=\"vendor\" data-se-id=\"rsvpBulkModal\"></pioneer-rsvp-bulk>\n<div [hidden]=\"!hasFinalPayment || isRequestPaymentRejected\" class=\"result-empty\" data-se-id=\"canNotAddRsvps\">\n  <p class=\"text-hint\">{{ \"EVENT.RSVPS.RSVPS_CAN_NOT_ADDED_CAPTION\" | translate }}</p>\n</div>\n"

/***/ }),

/***/ "auuo":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("rP7Y")(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"event-match.component.css","sourceRoot":""}]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),

/***/ "b9Cn":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("rP7Y")(true);
// imports


// module
exports.push([module.i, ".take-space{position:relative!important}", "", {"version":3,"sources":["/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/validation-message/validation-message.component.css"],"names":[],"mappings":"AAAA,YACE,2BAA8B,CAC/B","file":"validation-message.component.css","sourcesContent":[".take-space {\n  position: relative !important;\n}\n"],"sourceRoot":""}]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),

/***/ "c+TZ":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("rP7Y")(true);
// imports


// module
exports.push([module.i, ".modal-header{border-bottom-style:none;-ms-flex-align:baseline;align-items:baseline}.modal-header .text-muted{font-style:italic;text-align:right;margin-block-end:0}.table tbody tr{cursor:pointer}.table tbody tr:hover{background-color:#eceeef}.text-caption{font-size:85%;color:#62798a;display:block}.text-nowrap{white-space:nowrap!important}", "", {"version":3,"sources":["/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/property-search-results/property-search-results.component.css"],"names":[],"mappings":"AAAA,cACI,yBAA0B,wBAC1B,oBAAsB,CACzB,0BAGG,kBAAmB,iBACD,kBACE,CACvB,gBAGG,cAAgB,CACnB,sBAGG,wBAAyC,CAC5C,cAGG,cAAe,cACA,aACA,CAClB,aAGG,4BAA8B,CACjC","file":"property-search-results.component.css","sourcesContent":[".modal-header {\n    border-bottom-style: none;\n    align-items: baseline;\n}\n\n.modal-header .text-muted {\n    font-style: italic;\n    text-align: right;\n    margin-block-end: 0;\n}\n\n.table tbody tr {\n    cursor: pointer;\n}\n\n.table tbody tr:hover {\n    background-color: rgba(236, 238, 239, 1);\n}\n\n.text-caption {\n    font-size: 85%;\n    color: #62798a;\n    display: block;\n}\n\n.text-nowrap {\n    white-space: nowrap!important;\n}\n"],"sourceRoot":""}]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),

/***/ "c28g":
/***/ (function(module, exports) {

module.exports = "<div class=\"active-filters\" id=\"filter-control\">\n  <p class=\"filter-label\">{{'EVENT.RESERVATION.STATUS_FILTER_TITLE' | translate }}</p>\n\n  <ng-container *ngIf=\"!isMultiVendor()\">\n    <div class=\"view-select float-right\">\n      <div class=\"btn-group btn-group-sm\">\n        <button class=\"btn btn-default\"\n                [ngClass]=\"{'active': (getSummarySelected() | async) }\"\n                [routerLink]=\"['/event/' + eventLink + '/reservations']\"\n                data-se-id=\"reservation-summary-toggle-button\">\n          <i class=\"glyph-page\"></i>{{'EVENT.RESERVATION.SUMMARY_BUTTON' | translate}}\n        </button>\n        <button class=\"btn btn-default\"\n                [ngClass]=\"{'active': !(getSummarySelected() | async) }\"\n                [routerLink]=\"['/event/' + eventLink + '/reservations/detail']\"\n                data-se-id=\"reservation-detail-toggle-button\"\n                [disabled]=\"disableCompareButton$ | async\">\n          <i class=\"glyph-pages\"></i>{{'EVENT.RESERVATION.COMPARE_BUTTON' | translate}}\n        </button>\n      </div>\n    </div>\n  </ng-container>\n\n  <div class=\"filter-list form-group\">\n    <div class=\"form-check\">\n      <label class=\"filter-item custom-control custom-checkbox\"\n             (click)=\"toggleStatusCode(ReservationStatusCode.RESERVED)\"\n             [ngClass]=\"{'checked': reserved}\" data-se-id=\"filter-button-reserved\">\n        <i class=\"button-state\"></i>\n        <span class=\"custom-control-description\">\n          {{ 'RESERVATION_STATUS.RESERVED' | translate }}</span>\n      </label>\n      <label class=\"filter-item custom-control custom-checkbox\"\n             (click)=\"toggleCheckedIn()\"\n             [ngClass]=\"{'checked': checkedIn}\" data-se-id=\"filter-button-checked-in\">\n        <i class=\"button-state\"></i>\n        <span class=\"custom-control-description\">{{\n          'RESERVATION_STATUS.CHECKED_IN' | translate }}</span>\n      </label>\n      <label class=\"filter-item custom-control custom-checkbox\"\n             (click)=\"toggleCheckedOut()\"\n             [ngClass]=\"{'checked': checkedOut}\" data-se-id=\"filter-button-checked-out\">\n        <i class=\"button-state\"></i>\n        <span class=\"custom-control-description\">{{\n          'RESERVATION_STATUS.CHECKED_OUT' | translate }}</span>\n      </label>\n      <label class=\"filter-item custom-control custom-checkbox\"\n             (click)=\"toggleCancelled()\"\n             [ngClass]=\"{'checked': cancelled}\" data-se-id=\"filter-button-cancelled\">\n        <i class=\"button-state\"></i>\n        <span class=\"custom-control-description\">{{\n          'RESERVATION_STATUS.CANCELLED' | translate }}</span>\n      </label>\n      <label class=\"filter-item custom-control custom-checkbox\"\n             (click)=\"toggleNoShow()\"\n             [ngClass]=\"{'checked': noShow}\" data-se-id=\"filter-button-no-show\">\n        <i class=\"button-state\"></i>\n        <span class=\"custom-control-description\">{{\n          'RESERVATION_STATUS.NO_SHOW' | translate }}</span>\n      </label>\n      <!-- <label [hidden]=\"summarySelected\" class=\"filter-item custom-control custom-checkbox\"\n              (click)=\"toggleRsvp()\"\n              [ngClass]=\"{'checked': rsvp}\" data-se-id=\"filter-button-rsvp\">\n         <i class=\"button-state\"></i>\n         <span class=\"custom-control-description\">{{\n           'RESERVATION_STATUS.RSVP' | translate }}</span>\n       </label>-->\n    </div>\n  </div>\n</div>\n"

/***/ }),

/***/ "cAE2":
/***/ (function(module, exports) {

module.exports = "<form *ngIf=\"showForecastedCommissionForm()\" [formGroup]=\"forecastedCommissionForm\">\n  <div class=\"row\">\n    <div class=\"form-container col-5\">\n      <pioneer-form-input label=\"EVENT.COMMISSION.FORECAST_COMMISSION_AMOUNT\">\n        <div class=\"input-group input-group-less-width\">\n          <input type=\"number\"\n                  formControlName=\"forecastedCommissionAmount\"\n                  class=\"form-control\"\n                  data-se-id=\"forecastCommissionAmountFormGroup\"\n                  placeholder=\"{{ 'EVENT.COMMISSION.FORECAST_COMMISSION_AMOUNT_PLACEHOLDER' | translate }}\"\n                  min=\"0\"\n                  [attr.disabled]=\"!isMultiVendor() ? 'disabled' : null\"\n                  (focusout)=\"onFocusOutForecastedCommission($event)\"/>\n          <div *ngIf=\"onyxEvent.currency\" class=\"input-group-addon\">\n            <span class=\"input-group-text\">{{ onyxEvent.currency | uppercase }}</span>\n          </div>\n        </div>\n      </pioneer-form-input>\n    </div>\n  </div>\n</form>\n"

/***/ }),

/***/ "cDNt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/node_modules/core-js/es6/symbol.js
var symbol = __webpack_require__("GWWY");
var symbol_default = /*#__PURE__*/__webpack_require__.n(symbol);

// EXTERNAL MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/node_modules/core-js/es6/object.js
var es6_object = __webpack_require__("f/CF");
var object_default = /*#__PURE__*/__webpack_require__.n(es6_object);

// EXTERNAL MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/node_modules/core-js/es6/function.js
var es6_function = __webpack_require__("KvE9");
var function_default = /*#__PURE__*/__webpack_require__.n(es6_function);

// EXTERNAL MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/node_modules/core-js/es6/parse-int.js
var parse_int = __webpack_require__("zbpw");
var parse_int_default = /*#__PURE__*/__webpack_require__.n(parse_int);

// EXTERNAL MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/node_modules/core-js/es6/parse-float.js
var parse_float = __webpack_require__("NzKl");
var parse_float_default = /*#__PURE__*/__webpack_require__.n(parse_float);

// EXTERNAL MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/node_modules/core-js/es6/number.js
var number = __webpack_require__("ajBu");
var number_default = /*#__PURE__*/__webpack_require__.n(number);

// EXTERNAL MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/node_modules/core-js/es6/math.js
var math = __webpack_require__("feEK");
var math_default = /*#__PURE__*/__webpack_require__.n(math);

// EXTERNAL MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/node_modules/core-js/es6/string.js
var string = __webpack_require__("r24B");
var string_default = /*#__PURE__*/__webpack_require__.n(string);

// EXTERNAL MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/node_modules/core-js/es6/date.js
var es6_date = __webpack_require__("pEMT");
var date_default = /*#__PURE__*/__webpack_require__.n(es6_date);

// EXTERNAL MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/node_modules/core-js/es6/array.js
var array = __webpack_require__("jOBH");
var array_default = /*#__PURE__*/__webpack_require__.n(array);

// EXTERNAL MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/node_modules/core-js/es6/regexp.js
var regexp = __webpack_require__("Rjcp");
var regexp_default = /*#__PURE__*/__webpack_require__.n(regexp);

// EXTERNAL MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/node_modules/core-js/es6/map.js
var es6_map = __webpack_require__("W8w6");
var map_default = /*#__PURE__*/__webpack_require__.n(es6_map);

// EXTERNAL MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/node_modules/core-js/es6/set.js
var set = __webpack_require__("yJzT");
var set_default = /*#__PURE__*/__webpack_require__.n(set);

// EXTERNAL MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/node_modules/classlist.js/classList.js
var classList = __webpack_require__("Fc+4");
var classList_default = /*#__PURE__*/__webpack_require__.n(classList);

// EXTERNAL MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/node_modules/core-js/es6/reflect.js
var reflect = __webpack_require__("/wY1");
var reflect_default = /*#__PURE__*/__webpack_require__.n(reflect);

// EXTERNAL MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/node_modules/core-js/es7/reflect.js
var es7_reflect = __webpack_require__("+iEx");
var es7_reflect_default = /*#__PURE__*/__webpack_require__.n(es7_reflect);

// EXTERNAL MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/node_modules/web-animations-js/web-animations.min.js
var web_animations_min = __webpack_require__("lDyL");
var web_animations_min_default = /*#__PURE__*/__webpack_require__.n(web_animations_min);

// EXTERNAL MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/node_modules/zone.js/dist/zone.js
var zone = __webpack_require__("eFQL");
var zone_default = /*#__PURE__*/__webpack_require__.n(zone);

// EXTERNAL MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/node_modules/intl/index.js
var intl = __webpack_require__("Pha3");
var intl_default = /*#__PURE__*/__webpack_require__.n(intl);

// EXTERNAL MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/node_modules/date-input-polyfill/date-input-polyfill.dist.js
var date_input_polyfill_dist = __webpack_require__("xYza");
var date_input_polyfill_dist_default = /*#__PURE__*/__webpack_require__.n(date_input_polyfill_dist);

// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/polyfills.ts
/**
 * This file includes polyfills needed by Angular and is loaded before the app.
 * You can add your own extra polyfills to this file.
 *
 * This file is divided into 2 sections:
 *   1. Browser polyfills. These are applied before loading ZoneJS and are sorted by browsers.
 *   2. Application imports. Files imported after ZoneJS that should be loaded before your main
 *      file.
 *
 * The current setup is for so-called "evergreen" browsers; the last versions of browsers that
 * automatically update themselves. This includes Safari >= 10, Chrome >= 55 (including Opera),
 * Edge >= 13 on the desktop, and iOS 10 and Chrome on mobile.
 *
 * Learn more in https://angular.io/docs/ts/latest/guide/browser-support.html
 */
/***************************************************************************************************
 * BROWSER POLYFILLS
 */
/** IE9, IE10 and IE11 requires all of the following polyfills. **/













/** IE10 and IE11 requires the following for NgClass support on SVG elements */
 // Run `npm install --save classlist.js`.
/** IE10 and IE11 requires the following to support `@angular/animation`. */
// import 'web-animations-js';  // Run `npm install --save web-animations-js`.
/** Evergreen browsers require these. **/


/** ALL Firefox browsers require the following to support `@angular/animation`. **/
 // Run `npm install --save web-animations-js`.
/** Removing for security issue with the version dompurify the library uses */
// import { SwaggerUIBundle, SwaggerUIStandalonePreset } from 'swagger-ui-dist';
// export const swaggerUIBundle = SwaggerUIBundle;
// export const swaggerUIStandalonePreset = SwaggerUIStandalonePreset;
/***************************************************************************************************
 * Zone JS is required by Angular itself.
 */
 // Included with Angular-CLI.
/***************************************************************************************************
 * APPLICATION IMPORTS
 */
/**
 * Date, currency, decimal and percent pipes.
 * Needed for: All but Chrome, Firefox, Edge, IE11 and Safari 10
 */
 // Run `npm install --save intl`.
/**
 * Date input support for IE, Firefox, and OS X Safari
 */

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/polyfills.js.map
// EXTERNAL MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/node_modules/@angular/platform-browser-dynamic/@angular/platform-browser-dynamic.es5.js + 1 modules
var platform_browser_dynamic_es5 = __webpack_require__("Qa4U");

// EXTERNAL MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/node_modules/@angular/platform-browser/@angular/platform-browser.es5.js
var platform_browser_es5 = __webpack_require__("fc+i");

// EXTERNAL MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/node_modules/@angular/core/@angular/core.es5.js
var core_es5 = __webpack_require__("/oeL");

// EXTERNAL MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/node_modules/@angular/forms/@angular/forms.es5.js
var forms_es5 = __webpack_require__("bm2B");

// EXTERNAL MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/node_modules/@angular/http/@angular/http.es5.js
var http_es5 = __webpack_require__("CPp0");

// EXTERNAL MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/node_modules/@angular/router/@angular/router.es5.js
var router_es5 = __webpack_require__("BkNc");

// EXTERNAL MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/node_modules/@angular/common/@angular/common.es5.js
var common_es5 = __webpack_require__("qbdv");

// EXTERNAL MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/node_modules/@ngx-translate/core/index.js + 8 modules
var core = __webpack_require__("9Qcf");

// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/generic-error/generic-error.component.ts
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};


var GenericErrorComponent = (function () {
    function GenericErrorComponent(route) {
        var _this = this;
        this.route = route;
        this.error = 'MESSAGES.ERROR.GENERIC_ERROR';
        this.route.params.subscribe(function (params) {
            if (params['error']) {
                _this.error = params['error'];
            }
        });
    }
    return GenericErrorComponent;
}());
GenericErrorComponent = __decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-generic-error',
        template: __webpack_require__("Kbn7")
    }),
    __metadata("design:paramtypes", [typeof (generic_error_component__a = typeof router_es5["ActivatedRoute"] !== "undefined" && router_es5["ActivatedRoute"]) === "function" && generic_error_component__a || Object])
], GenericErrorComponent);

var generic_error_component__a;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/generic-error.component.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/shared.routes.ts

var routes = [
    {
        path: 'error',
        component: GenericErrorComponent
    }
];
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/shared.routes.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/route-not-found/route-not-found.component.ts
var route_not_found_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var route_not_found_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var RouteNotFoundComponent = (function () {
    function RouteNotFoundComponent() {
    }
    RouteNotFoundComponent.prototype.ngOnInit = function () {
    };
    return RouteNotFoundComponent;
}());
RouteNotFoundComponent = route_not_found_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-route-not-found',
        template: __webpack_require__("FS9g"),
        styles: [__webpack_require__("iS/x")]
    }),
    route_not_found_component___metadata("design:paramtypes", [])
], RouteNotFoundComponent);

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/route-not-found.component.js.map
// EXTERNAL MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/node_modules/rxjs/Subject.js
var Subject = __webpack_require__("rlar");
var Subject_default = /*#__PURE__*/__webpack_require__.n(Subject);

// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/log/log.service.ts
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var log_service___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var log_service___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};


var log_service_LogService = (function () {
    function LogService() {
        // Create a new Subject and expose the stream as an Observable.
        this.logStream = new Subject["Subject"]();
        this.logs = this.logStream.asObservable();
    }
    LogService.prototype.log = function (logMessage) {
        // Add the message to the log stream
        this.logStream.next(logMessage);
    };
    LogService.prototype.error = function (message) {
        this.log(new LogMessage(LogLevel.ERROR, message));
    };
    LogService.prototype.warn = function (message) {
        this.log(new LogMessage(LogLevel.WARN, message));
    };
    LogService.prototype.info = function (message) {
        this.log(new LogMessage(LogLevel.INFO, message));
    };
    LogService.prototype.debug = function (message) {
        this.log(new LogMessage(LogLevel.DEBUG, message));
    };
    LogService.prototype.verbose = function (message) {
        this.log(new LogMessage(LogLevel.VERBOSE, message));
    };
    return LogService;
}());
log_service_LogService = log_service___decorate([
    Object(core_es5["Injectable"])(),
    log_service___metadata("design:paramtypes", [])
], log_service_LogService);

var BaseLogSubscriberService = (function () {
    function BaseLogSubscriberService(logService) {
        this.logService = logService;
        this.logs = this.logService.logs;
    }
    BaseLogSubscriberService.prototype.init = function (level) {
        this.logs.subscribe(this.log.bind(this));
    };
    BaseLogSubscriberService.prototype.log = function (message) {
        // No implementation
    };
    return BaseLogSubscriberService;
}());

var FilteredLogSubscriberService = (function (_super) {
    __extends(FilteredLogSubscriberService, _super);
    function FilteredLogSubscriberService(ls) {
        return _super.call(this, ls) || this;
    }
    FilteredLogSubscriberService.prototype.init = function (level) {
        // Filter the logs to include the specified log level
        this.logs = this.logs.filter(function (logMessage) { return logMessage.level <= level; });
        _super.prototype.init.call(this, level);
    };
    return FilteredLogSubscriberService;
}(BaseLogSubscriberService));

var LogMessage = (function () {
    function LogMessage(level, message) {
        if (level === void 0) { level = LogLevel.INFO; }
        if (message === void 0) { message = ''; }
        this.level = level;
        this.message = message;
    }
    return LogMessage;
}());

var LogLevel;
(function (LogLevel) {
    LogLevel[LogLevel["ERROR"] = 0] = "ERROR";
    LogLevel[LogLevel["WARN"] = 1] = "WARN";
    LogLevel[LogLevel["INFO"] = 2] = "INFO";
    LogLevel[LogLevel["DEBUG"] = 3] = "DEBUG";
    LogLevel[LogLevel["VERBOSE"] = 4] = "VERBOSE";
})(LogLevel || (LogLevel = {}));
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/log.service.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/environments/environment-defaults.ts
var environmentDefaults = {
    // Pioneer Server Endpoints
    baseUrl: 'http://localhost:8080',
    hostname: 'localhost',
    // angular-cli compile mode
    production: true,
    // AWS Configuration
    region: 'us-east-1',
    awsUri: 'amazonaws.com',
    // Log handlers and log levels
    logServices: {
        consoleLogSubscriber: {
            logLevel: 3
        },
        httpLogSubscriber: {
            logLevel: 0
        }
    },
    // Close messages at 3.5 seconds
    alertMessageTimer: 3500,
    emailValidation: false,
    events: {
        maxEvents: 100,
        acceptedFileExtensions: '.jpg, .jpeg, .pdf',
        acceptedFileTypes: ['application/pdf', 'image/jpeg'],
        maxFileSize: 100
    },
    paymentActionReport: {
        maxEvents: 100,
        acceptedFileExtensions: '.pdf, .csv, .xlsx',
        acceptedFileTypes: ['application/pdf', 'text/csv', 'text/x-csv',
            'application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'],
        maxFileSize: 100
    },
    bulkEvents: {
        acceptedFileExtensions: '.csv',
        acceptedFileTypes: ['text/csv', 'text/x-csv', 'text/plain', 'application/vnd.ms-excel']
    },
    rsvps: {
        acceptedFileExtensions: '.xlsx',
        acceptedFileTypes: ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet']
    },
    reservations: {
        acceptedFileExtensions: ['.xlsx'],
        acceptedFileTypes: ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet']
    },
    payments: {
        paymentDelayDaysAfterEventEnd: 3
    },
    googleAnalytics: {
        id: 'UA-92766055-1',
        loadType: 'auto'
    },
    policyUrl: 'https://onyxcentersource.com/privacy-policy/',
    portalUrl: 'https://portal.uat.onyxcentersource.com',
    onyxCommonDataUrl: 'https://ocd-service.uat.onyxcentersource.com/api',
    onyxGPImagesCommonDataUrl: 'https://cdn.onyxcentersource.com/static/custom/gp',
    invoiceHistoryUrl: 'https://ooiv-invoice-history.dev.onyxcentersource.com',
    // redirect to portal after 3 seconds
    portalRedirectTimer: 3000,
    portalLogout: '/j_spring_security_logout',
    allowApiDocs: false,
    logout: '/external-login-expired',
    cwr: {
        enable: false
    },
    // new agency dashboard
    agencyDashboardUrl: 'https://agency-dashboard.dev2.onyxcentersource.com',
    showAgencyDashboard: false,
    supportUrl: 'https://www.onyxcentersource.com/need-assistance'
};
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/environment-defaults.js.map
// EXTERNAL MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/node_modules/lodash.defaultsdeep/index.js
var lodash_defaultsdeep = __webpack_require__("Ne7M");
var lodash_defaultsdeep_default = /*#__PURE__*/__webpack_require__.n(lodash_defaultsdeep);

// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/environments/environment.ci.ts


var override = {
    baseUrl: 'https://pioneer-ci-service.dev.onyxcentersource.com',
    hostname: 'pioneer-ci.dev.onyxcentersource.com',
    onyxCommonDataUrl: 'https://pioneer-ci-service.dev.onyxcentersource.com/ocd/api',
    googleAnalytics: {
        id: 'UA-96125697-1',
        loadType: 'auto'
    }
};
var environment_ci_environment = lodash_defaultsdeep(override, environmentDefaults);
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/environment.ci.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/environments/environment.ci2.ts


var environment_ci2_override = {
    baseUrl: 'https://pioneer-ci2-service.dev.onyxcentersource.com',
    hostname: 'pioneer-ci2.dev.onyxcentersource.com',
    onyxCommonDataUrl: 'https://pioneer-ci2-service.dev.onyxcentersource.com/ocd/api',
    googleAnalytics: {
        id: 'UA-96125697-1',
        loadType: 'auto'
    }
};
var environment_ci2_environment = lodash_defaultsdeep(environment_ci2_override, environmentDefaults);
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/environment.ci2.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/environments/environment.dev.ts


var environment_dev_override = {
    baseUrl: 'https://pioneer-service.dev.onyxcentersource.com',
    hostname: 'pioneer.dev.onyxcentersource.com',
    portalUrl: 'https://portal.dev.onyxcentersource.com',
    onyxGPImagesCommonDataUrl: 'https://cdn.onyxcentersource.com/static/custom/gp',
    invoiceHistoryUrl: 'https://ooiv-invoice-history.dev.onyxcentersource.com',
    allowApiDocs: true,
    emailValidation: true,
    cwr: {
        enable: true
    },
    agencyDashboardUrl: 'https://agency-dashboard.dev.onyxcentersource.com',
    showAgencyDashboard: false
};
var environment_dev_environment = lodash_defaultsdeep(environment_dev_override, environmentDefaults);
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/environment.dev.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/environments/environment.dev2.ts


var environment_dev2_override = {
    baseUrl: 'https://pioneer2-service.dev.onyxcentersource.com',
    hostname: 'pioneer2.dev.onyxcentersource.com',
    portalUrl: 'https://portal.dev.onyxcentersource.com',
    onyxGPImagesCommonDataUrl: 'https://cdn.onyxcentersource.com/static/custom/gp',
    invoiceHistoryUrl: 'https://ooiv-invoice-history.dev.onyxcentersource.com',
    allowApiDocs: true,
    emailValidation: true,
    agencyDashboardUrl: 'https://agency-dashboard2.dev.onyxcentersource.com',
    showAgencyDashboard: true
};
var environment_dev2_environment = lodash_defaultsdeep(environment_dev2_override, environmentDefaults);
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/environment.dev2.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/environments/environment.dev3.ts


var environment_dev3_override = {
    baseUrl: 'https://pioneer3-service.dev.onyxcentersource.com',
    hostname: 'pioneer3.dev.onyxcentersource.com',
    portalUrl: 'https://portal.dev.onyxcentersource.com',
    onyxGPImagesCommonDataUrl: 'https://cdn.onyxcentersource.com/static/custom/gp',
    invoiceHistoryUrl: 'https://ooiv-invoice-history.dev.onyxcentersource.com',
    emailValidation: true,
    allowApiDocs: true,
    agencyDashboardUrl: 'https://agency-dashboard3.dev.onyxcentersource.com',
    showAgencyDashboard: false
};
var environment_dev3_environment = lodash_defaultsdeep(environment_dev3_override, environmentDefaults);
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/environment.dev3.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/environments/environment.prod.ts


var environment_prod_override = {
    baseUrl: 'https://groups-service.onyxcentersource.com',
    hostname: 'groups.onyxcentersource.com',
    portalUrl: 'https://portal.onyxcentersource.com',
    onyxCommonDataUrl: 'https://ocd.service.onyxcentersource.com/api',
    onyxGPImagesCommonDataUrl: 'https://cdn.onyxcentersource.com/static/custom/gp',
    invoiceHistoryUrl: 'https://ooiv-invoice-history.app.onyxcentersource.com',
    emailValidation: true,
    logServices: {
        consoleLogSubscriber: {
            logLevel: 2
        },
        httpLogSubscriber: {
            logLevel: 0
        }
    },
    cwr: {
        enable: true
    },
    agencyDashboardUrl: 'https://agency-dashboard.service.onyxcentersource.com',
    showAgencyDashboard: false
};
var environment_prod_environment = lodash_defaultsdeep(environment_prod_override, environmentDefaults);
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/environment.prod.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/environments/environment.prodShadow.ts


var environment_prodShadow_override = {
    baseUrl: 'https://groups-service-shadow.onyxcentersource.com',
    hostname: 'groups-shadow.onyxcentersource.com',
    portalUrl: 'https://portal.onyxcentersource.com',
    onyxCommonDataUrl: 'https://ocd.service.onyxcentersource.com/api',
    onyxGPImagesCommonDataUrl: 'https://cdn.onyxcentersource.com/static/custom/gp',
    invoiceHistoryUrl: 'https://ooiv-invoice-history.app.onyxcentersource.com',
    emailValidation: true,
    logServices: {
        consoleLogSubscriber: {
            logLevel: 2
        },
        httpLogSubscriber: {
            logLevel: 0
        }
    },
    cwr: {
        enable: true
    },
    agencyDashboardUrl: 'https://agency-dashboard.service.onyxcentersource.com',
    showAgencyDashboard: false
};
var environment_prodShadow_environment = lodash_defaultsdeep(environment_prodShadow_override, environmentDefaults);
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/environment.prodShadow.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/environments/environment.qa.ts


var environment_qa_override = {
    baseUrl: 'https://pioneer-service.qa.onyxcentersource.com',
    hostname: 'pioneer.qa.onyxcentersource.com',
    portalUrl: 'https://portal.qa.onyxcentersource.com',
    onyxGPImagesCommonDataUrl: 'https://cdn.onyxcentersource.com/static/custom/gp',
    invoiceHistoryUrl: 'https://ooiv-invoice-history.qa.onyxcentersource.com',
    emailValidation: true,
    allowApiDocs: true,
    cwr: {
        enable: true
    },
    agencyDashboardUrl: 'https://agency-dashboard.qa.onyxcentersource.com',
    showAgencyDashboard: false
};
var environment_qa_environment = lodash_defaultsdeep(environment_qa_override, environmentDefaults);
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/environment.qa.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/environments/environment.qa2.ts


var environment_qa2_override = {
    baseUrl: 'https://pioneer2-service.qa.onyxcentersource.com',
    hostname: 'pioneer2.qa.onyxcentersource.com',
    portalUrl: 'https://portal.qa.onyxcentersource.com',
    onyxGPImagesCommonDataUrl: 'https://cdn.onyxcentersource.com/static/custom/gp',
    invoiceHistoryUrl: 'https://ooiv-invoice-history2.qa.onyxcentersource.com',
    emailValidation: true,
    allowApiDocs: true,
    agencyDashboardUrl: 'https://agency-dashboard2.qa.onyxcentersource.com',
    showAgencyDashboard: true
};
var environment_qa2_environment = lodash_defaultsdeep(environment_qa2_override, environmentDefaults);
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/environment.qa2.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/environments/environment.qa3.ts


var environment_qa3_override = {
    baseUrl: 'https://pioneer3-service.qa.onyxcentersource.com',
    hostname: 'pioneer3.qa.onyxcentersource.com',
    portalUrl: 'https://portal.qa.onyxcentersource.com',
    onyxGPImagesCommonDataUrl: 'https://cdn.onyxcentersource.com/static/custom/gp',
    invoiceHistoryUrl: 'https://ooiv-invoice-history3.qa.onyxcentersource.com',
    emailValidation: true,
    allowApiDocs: true,
    agencyDashboardUrl: 'https://agency-dashboard3.qa.onyxcentersource.com',
    showAgencyDashboard: false
};
var environment_qa3_environment = lodash_defaultsdeep(environment_qa3_override, environmentDefaults);
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/environment.qa3.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/environments/environment.qaec.ts


var environment_qaec_override = {
    baseUrl: 'https://pioneer2poc-service.qa.onyxcentersource.com',
    hostname: 'pioneer-ec.qa.onyxcentersource.com',
    portalUrl: 'https://portal.qa.onyxcentersource.com',
    invoiceHistoryUrl: 'https://ooiv-invoice-history.qa.onyxcentersource.com',
    allowApiDocs: true
};
var environment_qaec_environment = lodash_defaultsdeep(environment_qaec_override, environmentDefaults);
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/environment.qaec.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/environments/environment.sec.ts


var environment_sec_override = {
    baseUrl: 'https://pioneer-sec-service.uat.onyxcentersource.com',
    hostname: 'pioneer-sec.uat.onyxcentersource.com'
};
var environment_sec_environment = lodash_defaultsdeep(environment_sec_override, environmentDefaults);
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/environment.sec.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/environments/environment.uat.ts


var environment_uat_override = {
    baseUrl: 'https://pioneer-service.uat.onyxcentersource.com',
    hostname: 'pioneer.uat.onyxcentersource.com',
    portalUrl: 'https://portal.uat.onyxcentersource.com',
    onyxCommonDataUrl: 'https://ocd-service.uat.onyxcentersource.com/api',
    onyxGPImagesCommonDataUrl: 'https://cdn.onyxcentersource.com/static/custom/gp',
    emailValidation: true,
    cwr: {
        enable: true
    },
    invoiceHistoryUrl: 'https://ooiv-invoice-history.uat.onyxcentersource.com',
    agencyDashboardUrl: 'https://agency-dashboard.uat.onyxcentersource.com',
    showAgencyDashboard: true
};
var environment_uat_environment = lodash_defaultsdeep(environment_uat_override, environmentDefaults);
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/environment.uat.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/environments/environment.local.ts


// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.local.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `angular-cli.json`.
var environment_local_override = {
    baseUrl: 'http://localhost:8080',
    hostname: 'localhost',
    onyxCommonDataUrl: 'http://localhost:8080/ocd/api',
    onyxGPImagesCommonDataUrl: 'https://cdn.dev.onyxcentersource.com/static/custom/gp',
    invoiceHistoryUrl: 'https://ooiv-invoice-history.dev.onyxcentersource.com',
    production: false,
    logServices: {
        consoleLogSubscriber: {
            logLevel: 4
        },
        httpLogSubscriber: {
            logLevel: 0
        }
    },
    googleAnalytics: {
        id: 'UA-96125697-1',
        loadType: 'auto'
    },
    allowApiDocs: true,
    logout: '/login',
    cwr: {
        enable: true
    },
    agencyDashboardUrl: 'https://agency-dashboard.dev.onyxcentersource.com',
    showAgencyDashboard: true
};
var environment_local_environment = lodash_defaultsdeep(environment_local_override, environmentDefaults);
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/environment.local.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/environments/environment.demo.ts


var environment_demo_override = {
    baseUrl: 'https://groups-service.demo.onyxcentersource.com',
    hostname: 'groups.demo.onyxcentersource.com',
    portalUrl: 'https://portal.demo.onyxcentersource.com',
    onyxCommonDataUrl: 'https://ocd-service.demo.onyxcentersource.com/api',
    onyxGPImagesCommonDataUrl: 'https://cdn.onyxcentersource.com/static/custom/gp',
    invoiceHistoryUrl: 'https://ooiv-invoice-history.demo.onyxcentersource.com',
    emailValidation: true,
    cwr: {
        enable: true
    },
    agencyDashboardUrl: 'https://agency-dashboard.demo.onyxcentersource.com',
    showAgencyDashboard: false
};
var environment_demo_environment = lodash_defaultsdeep(environment_demo_override, environmentDefaults);
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/environment.demo.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/environment/services/environment.configuration.ts
/* tslint:disable:no-shadowed-variable */
var environment_configuration___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var environment_configuration___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
















var environments = {
    default: environment_local_environment,
    ci: environment_ci_environment,
    ci2: environment_ci2_environment,
    dev: environment_dev_environment,
    dev2: environment_dev2_environment,
    dev3: environment_dev3_environment,
    prod: environment_prod_environment,
    prodShadow: environment_prodShadow_environment,
    qa: environment_qa_environment,
    qa2: environment_qa2_environment,
    qa3: environment_qa3_environment,
    qaec: environment_qaec_environment,
    sec: environment_sec_environment,
    uat: environment_uat_environment,
    demo: environment_demo_environment
};
var Environments = new core_es5["InjectionToken"]('Environments');
var EnvironmentConfiguration = (function () {
    function EnvironmentConfiguration(environments) {
        var hostname = (window.location && window.location.hostname) ? window.location.hostname.toLowerCase() : null;
        var environmentType = environments.default;
        var environmentNames = Object.keys(environments).filter(function (envName) { return envName !== 'default'; });
        var selectedEnvName = environmentNames.find(function (envName) {
            if (environments[envName] && environments[envName].hostname) {
                return environments[envName].hostname.toLowerCase() === hostname;
            }
            else {
                return false;
            }
        });
        if (selectedEnvName && environments[selectedEnvName]) {
            environmentType = environments[selectedEnvName];
        }
        // Override default behavior by setting window.environment in index.html
        if (window['environment'] && environments[window['environment']]) {
            environmentType = environments[window['environment']];
        }
        Object.assign(this, environmentType);
    }
    return EnvironmentConfiguration;
}());
EnvironmentConfiguration = environment_configuration___decorate([
    Object(core_es5["Injectable"])(),
    __param(0, Object(core_es5["Inject"])(Environments)),
    environment_configuration___metadata("design:paramtypes", [Object])
], EnvironmentConfiguration);

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/environment.configuration.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/error-handler/error-handler.ts
var error_handler___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var error_handler___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var error_handler___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};



var error_handler_LogErrorHandler = (function (_super) {
    error_handler___extends(LogErrorHandler, _super);
    function LogErrorHandler(log, environment) {
        var _this = 
        // Tell Angular to rethrow exceptions.  This ensures that operations like
        // bootstrap will fail if there is an error.
        _super.call(this, true) || this;
        _this.log = log;
        _this.environment = environment;
        return _this;
    }
    LogErrorHandler.prototype.handleError = function (error) {
        // Log the error using the LogService
        this.log.error(error.toString());
        // Provide the standard Angular error handling if the log level is verbose
        if (this.environment.logServices.consoleLogSubscriber &&
            this.environment.logServices.consoleLogSubscriber.logLevel >= LogLevel.VERBOSE) {
            _super.prototype.handleError.call(this, error);
        }
    };
    return LogErrorHandler;
}(core_es5["ErrorHandler"]));
error_handler_LogErrorHandler = error_handler___decorate([
    Object(core_es5["Injectable"])(),
    error_handler___metadata("design:paramtypes", [typeof (error_handler__a = typeof log_service_LogService !== "undefined" && log_service_LogService) === "function" && error_handler__a || Object, typeof (_b = typeof EnvironmentConfiguration !== "undefined" && EnvironmentConfiguration) === "function" && _b || Object])
], error_handler_LogErrorHandler);

var error_handler__a, _b;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/error-handler.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/log/console-log-subscriber.service.ts
var console_log_subscriber_service___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var console_log_subscriber_service___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var console_log_subscriber_service___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};


var console_log_subscriber_service_ConsoleLogSubscriberService = (function (_super) {
    console_log_subscriber_service___extends(ConsoleLogSubscriberService, _super);
    function ConsoleLogSubscriberService(logService) {
        return _super.call(this, logService) || this;
    }
    ConsoleLogSubscriberService.prototype.log = function (logMessage) {
        // Since the LogLevel enum is aligned with the the console function names
        // use the string value to call the corresponding logging function.
        var level = LogLevel[logMessage.level].toLowerCase();
        if (console[level]) {
            console[level](logMessage.message);
        }
    };
    return ConsoleLogSubscriberService;
}(FilteredLogSubscriberService));
console_log_subscriber_service_ConsoleLogSubscriberService = console_log_subscriber_service___decorate([
    Object(core_es5["Injectable"])(),
    console_log_subscriber_service___metadata("design:paramtypes", [typeof (console_log_subscriber_service__a = typeof log_service_LogService !== "undefined" && log_service_LogService) === "function" && console_log_subscriber_service__a || Object])
], console_log_subscriber_service_ConsoleLogSubscriberService);

var console_log_subscriber_service__a;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/console-log-subscriber.service.js.map
// EXTERNAL MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/node_modules/rxjs/Observable.js
var Observable = __webpack_require__("bKpL");
var Observable_default = /*#__PURE__*/__webpack_require__.n(Observable);

// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/utils/guid.ts
/*tslint:disable:no-bitwise*/
var Guid = (function () {
    function Guid() {
    }
    Guid.newGuid = function () {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    };
    return Guid;
}());

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/guid.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/flash-messages/flash.message.record.ts

var MessageLevel;
(function (MessageLevel) {
    MessageLevel[MessageLevel["ERROR"] = 0] = "ERROR";
    MessageLevel[MessageLevel["WARN"] = 1] = "WARN";
    MessageLevel[MessageLevel["INFO"] = 2] = "INFO";
    MessageLevel[MessageLevel["SUCCESS"] = 3] = "SUCCESS";
})(MessageLevel || (MessageLevel = {}));
var flash_message_record_FlashMessage = (function () {
    function FlashMessage(level, message, displayThroughNavigation, autoClose) {
        if (displayThroughNavigation === void 0) { displayThroughNavigation = false; }
        if (autoClose === void 0) { autoClose = false; }
        this.id = Guid.newGuid();
        this.level = level;
        this.message = message;
        this.displayThroughNavigation = displayThroughNavigation;
        this.autoClose = autoClose;
    }
    return FlashMessage;
}());

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/flash.message.record.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/flash-messages/service/flash.messages.service.ts
var flash_messages_service___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var flash_messages_service___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};





/**
 * This will display a message to the user.
 *
 * If it is an error it will wait for the user to click close before removing.
 *
 * Usage:
 *
 * this.flashMessagesService.info('We are in about component!');
 * this.flashMessagesService.error('Failure!');
 * this.flashMessagesService.warn('Warn!');
 * this.flashMessagesService.success('Success!');
 */
var flash_messages_service_FlashMessagesService = (function () {
    function FlashMessagesService(logService, translateService) {
        this.logService = logService;
        this.translateService = translateService;
        // Create a new Subject and expose the stream as an Observable.
        this.messageStream = new Subject["Subject"]();
    }
    Object.defineProperty(FlashMessagesService.prototype, "messages", {
        get: function () {
            return this.messageStream.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FlashMessagesService.prototype, "closeMessageStream", {
        get: function () {
            if (!this._closeMessageStream) {
                this._closeMessageStream = new Subject["Subject"]();
            }
            return this._closeMessageStream.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    FlashMessagesService.prototype.closeMessage = function (message) {
        this._closeMessageStream.next(message);
    };
    FlashMessagesService.prototype.post = function (flashMessage) {
        // Add the message to the log stream
        this.messageStream.next(flashMessage);
    };
    FlashMessagesService.prototype.error = function (flashMessage, logMessage, translateParams, displayThroughNavigation, autoClose) {
        if (logMessage === void 0) { logMessage = null; }
        if (translateParams === void 0) { translateParams = {}; }
        if (displayThroughNavigation === void 0) { displayThroughNavigation = false; }
        if (autoClose === void 0) { autoClose = false; }
        this.logMessage(LogLevel.ERROR, logMessage);
        this.flashMessage(MessageLevel.ERROR, flashMessage, displayThroughNavigation, autoClose, translateParams);
    };
    FlashMessagesService.prototype.warn = function (flashMessage, logMessage, translateParams, displayThroughNavigation, autoClose) {
        if (logMessage === void 0) { logMessage = null; }
        if (translateParams === void 0) { translateParams = {}; }
        if (displayThroughNavigation === void 0) { displayThroughNavigation = false; }
        if (autoClose === void 0) { autoClose = false; }
        this.logMessage(LogLevel.WARN, logMessage);
        this.flashMessage(MessageLevel.WARN, flashMessage, displayThroughNavigation, autoClose, translateParams);
    };
    FlashMessagesService.prototype.info = function (flashMessage, logMessage, translateParams, displayThroughNavigation, autoClose) {
        if (logMessage === void 0) { logMessage = null; }
        if (translateParams === void 0) { translateParams = {}; }
        if (displayThroughNavigation === void 0) { displayThroughNavigation = false; }
        if (autoClose === void 0) { autoClose = false; }
        this.logMessage(LogLevel.INFO, logMessage);
        this.flashMessage(MessageLevel.INFO, flashMessage, displayThroughNavigation, autoClose, translateParams);
    };
    FlashMessagesService.prototype.success = function (flashMessage, logOrDisplay, translateOrClose) {
        var display = true;
        var close = true;
        var translate = {};
        if (logOrDisplay !== undefined) {
            if (typeof logOrDisplay === 'string') {
                this.logMessage(LogLevel.VERBOSE, logOrDisplay);
            }
            else if (typeof logOrDisplay === 'boolean') {
                display = logOrDisplay;
            }
        }
        if (translateOrClose !== undefined) {
            if (typeof translateOrClose === 'boolean') {
                close = translateOrClose;
            }
            else {
                translate = translateOrClose;
            }
        }
        this.flashMessage(MessageLevel.SUCCESS, flashMessage, display, close, translate);
    };
    FlashMessagesService.prototype.flashMessage = function (level, message, displayThroughNavigation, autoClose, translateParams) {
        var _this = this;
        if (translateParams === void 0) { translateParams = {}; }
        /**
         * .subscribe is used instead of .instant because of an issue that exists
         * when a flash message needs to be thrown during ngOnInit.  If .instant is used,
         * the label will be untranslated.
         */
        this.translateService.get(message, translateParams).subscribe(function (translation) {
            _this.post(new flash_message_record_FlashMessage(level, translation, displayThroughNavigation, autoClose));
        });
    };
    FlashMessagesService.prototype.logMessage = function (level, message) {
        if (message) {
            this.logService.log(new LogMessage(level, message));
        }
    };
    return FlashMessagesService;
}());
flash_messages_service_FlashMessagesService = flash_messages_service___decorate([
    Object(core_es5["Injectable"])(),
    flash_messages_service___metadata("design:paramtypes", [typeof (flash_messages_service__a = typeof log_service_LogService !== "undefined" && log_service_LogService) === "function" && flash_messages_service__a || Object, typeof (flash_messages_service__b = typeof core["c" /* TranslateService */] !== "undefined" && core["c" /* TranslateService */]) === "function" && flash_messages_service__b || Object])
], flash_messages_service_FlashMessagesService);

var flash_messages_service__a, flash_messages_service__b;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/flash.messages.service.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/utils/error-handler.service.ts
var error_handler_service___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var error_handler_service___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};




var error_handler_service_ErrorHandlerService = (function () {
    function ErrorHandlerService(logService, flashMessageService) {
        this.logService = logService;
        this.flashMessageService = flashMessageService;
    }
    ErrorHandlerService.prototype.handle = function (logMessage, flashMessage, handleType) {
        var _this = this;
        if (flashMessage === void 0) { flashMessage = ''; }
        if (handleType === void 0) { handleType = ErrorHandlerType.THROW_ERROR; }
        // Return a function that conforms to the shape if a catch callback
        return function (error) {
            return _this.processError(logMessage, flashMessage, handleType, error);
        };
    };
    ErrorHandlerService.prototype.handleObservable = function (logMessage, flashMessage) {
        if (flashMessage === void 0) { flashMessage = ''; }
        return this.handle(logMessage, flashMessage, ErrorHandlerType.THROW_OBSERVABLE);
    };
    ErrorHandlerService.prototype.throw = function (logMessage, flashMessage, handleType, error) {
        if (flashMessage === void 0) { flashMessage = ''; }
        if (handleType === void 0) { handleType = ErrorHandlerType.THROW_ERROR; }
        if (error === void 0) { error = logMessage; }
        return this.processError(logMessage, flashMessage, handleType, error);
    };
    ErrorHandlerService.prototype.processError = function (logMessage, flashMessage, handleType, error) {
        if (flashMessage === void 0) { flashMessage = ''; }
        if (handleType === void 0) { handleType = ErrorHandlerType.THROW_ERROR; }
        if (error === void 0) { error = null; }
        if (logMessage) {
            this.logService.error(logMessage);
        }
        if (flashMessage) {
            this.flashMessageService.error(flashMessage);
        }
        switch (handleType) {
            case ErrorHandlerType.DO_NOT_THROW:
                // Do not thow re-throw the error
                break;
            case ErrorHandlerType.THROW_OBSERVABLE:
                return Observable["Observable"].throw(this.getErrorMessage(error));
            // case ErrorHandlerType.THROW_ERROR:
            default:
                throw new Error(error);
        }
    };
    ErrorHandlerService.prototype.getErrorMessage = function (error) {
        if (error && error.json && error.json().error) {
            return error.json().error;
        }
        else {
            return 'An error occurred';
        }
    };
    /**
     * Remove the status code and the exception from the given backend error message
     * This method must be ONLY used for backend error messages with format:
     * "Response with status [statusCode]: WebApplicationException: [errorMessage]"
     *
     * @param backendErrorMessage
     * @returns {string} error message
     */
    ErrorHandlerService.prototype.getErrorMessageFromBackendError = function (backendErrorMessage) {
        return backendErrorMessage.substring(backendErrorMessage.lastIndexOf('WebApplicationException: ')
            + 'WebApplicationException: '.length);
    };
    return ErrorHandlerService;
}());
error_handler_service_ErrorHandlerService = error_handler_service___decorate([
    Object(core_es5["Injectable"])(),
    error_handler_service___metadata("design:paramtypes", [typeof (error_handler_service__a = typeof log_service_LogService !== "undefined" && log_service_LogService) === "function" && error_handler_service__a || Object, typeof (error_handler_service__b = typeof flash_messages_service_FlashMessagesService !== "undefined" && flash_messages_service_FlashMessagesService) === "function" && error_handler_service__b || Object])
], error_handler_service_ErrorHandlerService);

var ErrorHandlerType;
(function (ErrorHandlerType) {
    ErrorHandlerType[ErrorHandlerType["DO_NOT_THROW"] = 0] = "DO_NOT_THROW";
    ErrorHandlerType[ErrorHandlerType["THROW_ERROR"] = 1] = "THROW_ERROR";
    ErrorHandlerType[ErrorHandlerType["THROW_OBSERVABLE"] = 2] = "THROW_OBSERVABLE";
})(ErrorHandlerType || (ErrorHandlerType = {}));
var error_handler_service__a, error_handler_service__b;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/error-handler.service.js.map
// EXTERNAL MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/node_modules/@angular/common/@angular/common/http.es5.js
var common_http_es5 = __webpack_require__("XKz0");

// EXTERNAL MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/node_modules/rxjs/operators.js
var operators = __webpack_require__("cAzY");
var operators_default = /*#__PURE__*/__webpack_require__.n(operators);

// EXTERNAL MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/node_modules/rxjs/observable/timer.js
var timer = __webpack_require__("vioa");
var timer_default = /*#__PURE__*/__webpack_require__.n(timer);

// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/log/http-log-subscriber.service.ts
var http_log_subscriber_service___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var http_log_subscriber_service___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var http_log_subscriber_service___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};











var http_log_subscriber_service_HttpLogSubscriberService = (function (_super) {
    http_log_subscriber_service___extends(HttpLogSubscriberService, _super);
    function HttpLogSubscriberService(logService, http, consoleLogSubscriber, translateService, flashMessagesService, router, environment) {
        var _this = _super.call(this, logService) || this;
        _this.http = http;
        _this.consoleLogSubscriber = consoleLogSubscriber;
        _this.translateService = translateService;
        _this.flashMessagesService = flashMessagesService;
        _this.router = router;
        _this.environment = environment;
        _this.errorUrl = _this.environment.baseUrl + "/api/error";
        _this.HTTP_ERROR_MSG = 'HttpLogSubscriberService - Could not stream message to the server;';
        _this.onDestroy$ = new Subject["Subject"]();
        _this.requestCount = 0;
        return _this;
    }
    HttpLogSubscriberService.prototype.log = function (logMessage) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var bodyString, headers, options, post;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        bodyString = JSON.stringify(logMessage);
                        headers = new common_http_es5["d" /* HttpHeaders */]({ 'Content-Type': 'application/json' });
                        options = { headers: headers };
                        this.requestCount++;
                        if (!(this.requestCount > 10)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.router.navigate(['/dashboard'])];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.flashMessagesService.warn(this.translateService.instant('MESSAGES.ERROR.GENERIC_ERROR_TOO_MANY_REQUEST'))];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                    case 3:
                        if (this.requestCount === 1) {
                            // If it is the first request, a timer is started to reset the counter after 1.5 second.
                            Object(timer["timer"])(1500)
                                .pipe(Object(operators["takeUntil"])(this.onDestroy$))
                                .subscribe(function () {
                                _this.requestCount = 0;
                            });
                        }
                        post = this.http.post(this.errorUrl, bodyString, options);
                        return [2 /*return*/, post.pipe(Object(operators["takeUntil"])(this.onDestroy$)).subscribe(function (response) {
                            }, function (error) {
                                _this.consoleLogSubscriber.log(new LogMessage(LogLevel.ERROR, _this.HTTP_ERROR_MSG + error));
                                _this.consoleLogSubscriber.log(logMessage);
                            })];
                }
            });
        });
    };
    HttpLogSubscriberService.prototype.ngOnDestroy = function () {
        this.onDestroy$.next();
        this.onDestroy$.complete();
    };
    return HttpLogSubscriberService;
}(FilteredLogSubscriberService));
http_log_subscriber_service_HttpLogSubscriberService = http_log_subscriber_service___decorate([
    Object(core_es5["Injectable"])(),
    http_log_subscriber_service___metadata("design:paramtypes", [typeof (http_log_subscriber_service__a = typeof log_service_LogService !== "undefined" && log_service_LogService) === "function" && http_log_subscriber_service__a || Object, typeof (http_log_subscriber_service__b = typeof common_http_es5["b" /* HttpClient */] !== "undefined" && common_http_es5["b" /* HttpClient */]) === "function" && http_log_subscriber_service__b || Object, typeof (_c = typeof console_log_subscriber_service_ConsoleLogSubscriberService !== "undefined" && console_log_subscriber_service_ConsoleLogSubscriberService) === "function" && _c || Object, typeof (_d = typeof core["c" /* TranslateService */] !== "undefined" && core["c" /* TranslateService */]) === "function" && _d || Object, typeof (_e = typeof flash_messages_service_FlashMessagesService !== "undefined" && flash_messages_service_FlashMessagesService) === "function" && _e || Object, typeof (_f = typeof router_es5["Router"] !== "undefined" && router_es5["Router"]) === "function" && _f || Object, typeof (_g = typeof EnvironmentConfiguration !== "undefined" && EnvironmentConfiguration) === "function" && _g || Object])
], http_log_subscriber_service_HttpLogSubscriberService);

var http_log_subscriber_service__a, http_log_subscriber_service__b, _c, _d, _e, _f, _g;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/http-log-subscriber.service.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/flash-messages/component/flash.messages.component.ts
var flash_messages_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var flash_messages_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};






var flash_messages_component_FlashMessagesComponent = (function () {
    function FlashMessagesComponent(flashMessagesService, logService, environment) {
        this.flashMessagesService = flashMessagesService;
        this.logService = logService;
        this.environment = environment;
        this.messages = [];
    }
    FlashMessagesComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.flashMessagesService.messages.subscribe(function (newMessage) {
            _this.show(newMessage);
        });
    };
    Object.defineProperty(FlashMessagesComponent.prototype, "alertTimer", {
        get: function () {
            return this.environment.alertMessageTimer != null ? this.environment.alertMessageTimer : 3500;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Removes any non-persistent error messages.
     * Unless specified, no error messages are persistent.
     * For other messages, they will close via timerClose
     * unless specified as persistent.
     */
    FlashMessagesComponent.prototype.clearNonPersistentMessages = function () {
        this.messages = this.messages.filter(function (message) { return message.displayThroughNavigation; });
    };
    FlashMessagesComponent.prototype.show = function (newMessage) {
        this.logService.debug("Received message " + JSON.stringify(newMessage));
        this.messages.push(newMessage);
        this.timerClose(newMessage);
    };
    FlashMessagesComponent.prototype.findClass = function (message) {
        var messageCssClass;
        switch (message.level) {
            case MessageLevel.ERROR:
                messageCssClass = 'alert-danger';
                break;
            case MessageLevel.SUCCESS:
                messageCssClass = 'alert-success';
                break;
            case MessageLevel.WARN:
                messageCssClass = 'alert-warning';
                break;
            default: {
                messageCssClass = 'alert-info';
            }
        }
        return messageCssClass;
    };
    FlashMessagesComponent.prototype.closeMessage = function (message) {
        this.remove(message);
        this.flashMessagesService.closeMessage(message);
    };
    FlashMessagesComponent.prototype.showClose = function (message) {
        return !message.autoClose;
    };
    FlashMessagesComponent.prototype.timerClose = function (message) {
        var _this = this;
        if (message.autoClose) {
            /**
             * .take(1) ensures that interval(this.alertTimer)  only happens once and then cleans up the observable.
             * Otherwise, the selenium tests will timeout waiting for the flashMessage interval to resolve.
             */
            Observable["Observable"].interval(this.alertTimer).take(1).subscribe(function () {
                _this.logService.debug("Observable.timer executing for id: " + message.id);
                _this.remove(message);
            });
        }
    };
    FlashMessagesComponent.prototype.remove = function (message) {
        this.messages = this.messages.filter(function (value, key) { return value.id !== message.id; });
    };
    return FlashMessagesComponent;
}());
flash_messages_component_FlashMessagesComponent = flash_messages_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-flash-messages',
        template: __webpack_require__("vFLc"),
        styles: [__webpack_require__("3XO/")]
    }),
    flash_messages_component___metadata("design:paramtypes", [typeof (flash_messages_component__a = typeof flash_messages_service_FlashMessagesService !== "undefined" && flash_messages_service_FlashMessagesService) === "function" && flash_messages_component__a || Object, typeof (flash_messages_component__b = typeof log_service_LogService !== "undefined" && log_service_LogService) === "function" && flash_messages_component__b || Object, typeof (flash_messages_component__c = typeof EnvironmentConfiguration !== "undefined" && EnvironmentConfiguration) === "function" && flash_messages_component__c || Object])
], flash_messages_component_FlashMessagesComponent);

var flash_messages_component__a, flash_messages_component__b, flash_messages_component__c;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/flash.messages.component.js.map
// EXTERNAL MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/node_modules/immutable/dist/immutable.js
var immutable = __webpack_require__("2xpM");
var immutable_default = /*#__PURE__*/__webpack_require__.n(immutable);

// EXTERNAL MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/node_modules/rxjs/BehaviorSubject.js
var BehaviorSubject = __webpack_require__("gvep");
var BehaviorSubject_default = /*#__PURE__*/__webpack_require__.n(BehaviorSubject);

// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/lookup-address.ts
var lookup_address___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var LookupAddressRecord = Object(immutable["Record"])({
    line1: null,
    line2: null,
    line3: null,
    countryCode: null,
    city: null,
    state: null,
    postalCode: null
});
var LookupAddress = (function (_super) {
    lookup_address___extends(LookupAddress, _super);
    function LookupAddress() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return LookupAddress;
}(LookupAddressRecord));

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/lookup-address.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/models/property-lookup-summary.ts
var property_lookup_summary___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var PropertyLookupSummaryRecord = Object(immutable["Record"])({
    chain: null,
    brand: null,
    propertyId: null,
    name: null,
    address: new LookupAddress({}),
    manuallyAdded: null,
    subscriber: false
});
var PropertyLookupSummary = (function (_super) {
    property_lookup_summary___extends(PropertyLookupSummary, _super);
    function PropertyLookupSummary() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return PropertyLookupSummary;
}(PropertyLookupSummaryRecord));

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/property-lookup-summary.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/lookup-contact.ts
var lookup_contact___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var LookupContactRecord = Object(immutable["Record"])({
    firstName: null,
    lastName: null,
    email: null,
    phone: null,
    fax: null
});
var LookupContact = (function (_super) {
    lookup_contact___extends(LookupContact, _super);
    function LookupContact() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return LookupContact;
}(LookupContactRecord));

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/lookup-contact.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/models/property-lookup-detail.ts
var property_lookup_detail___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var PropertyLookupDetailRecord = Object(immutable["Record"])({
    chain: null,
    brand: null,
    propertyId: null,
    name: null,
    contact: new LookupContact({}),
    address: new LookupAddress({}),
    currency: null,
    subscriber: false,
    manuallyAdded: null,
    statusFlag: null,
    payorType: null
});
var PropertyLookupDetail = (function (_super) {
    property_lookup_detail___extends(PropertyLookupDetail, _super);
    function PropertyLookupDetail() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return PropertyLookupDetail;
}(PropertyLookupDetailRecord));

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/property-lookup-detail.js.map
// EXTERNAL MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/node_modules/http-status-codes/index.js
var http_status_codes = __webpack_require__("yVN2");
var http_status_codes_default = /*#__PURE__*/__webpack_require__.n(http_status_codes);

// EXTERNAL MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/node_modules/@ngx-translate/core/src/util.js
var util = __webpack_require__("ansA");

// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/utils/comparator-utils.ts
var ComparatorUtils = (function () {
    function ComparatorUtils() {
    }
    ComparatorUtils.isDefined = function (obj) {
        if (obj === null || typeof obj === 'undefined') {
            return false;
        }
        else {
            return true;
        }
    };
    ComparatorUtils.isUndefined = function (obj) {
        return !ComparatorUtils.isDefined(obj);
    };
    ComparatorUtils.compareNullable = function (obj1, obj2) {
        if (ComparatorUtils.isUndefined(obj1) && ComparatorUtils.isUndefined(obj2)) {
            return 0;
        }
        else if (ComparatorUtils.isDefined(obj1) && ComparatorUtils.isUndefined(obj2)) {
            return -1;
        }
        else if (ComparatorUtils.isUndefined(obj1) && ComparatorUtils.isDefined(obj2)) {
            return 1;
        }
        else {
            return 0;
        }
    };
    ComparatorUtils.compareString = function (string1, string2) {
        var nullCompare = ComparatorUtils.compareNullable(string1, string2);
        if (nullCompare !== 0) {
            return nullCompare;
        }
        else if (string1.toLowerCase() < string2.toLowerCase()) {
            return -1;
        }
        else if (string1.toLowerCase() > string2.toLowerCase()) {
            return 1;
        }
        else {
            return 0;
        }
    };
    ComparatorUtils.compareLastNameFirstName = function (fullName1, fullName2) {
        var nullCompare = ComparatorUtils.compareNullable(fullName1, fullName2);
        if (nullCompare !== 0) {
            return nullCompare;
        }
        var firstNameNullCompare = ComparatorUtils.compareNullable(fullName1.firstName, fullName2.firstName);
        if (firstNameNullCompare !== 0) {
            return firstNameNullCompare;
        }
        var lastNameNullCompare = ComparatorUtils.compareNullable(fullName1.lastName, fullName2.lastName);
        if (lastNameNullCompare !== 0) {
            return lastNameNullCompare;
        }
        if (ComparatorUtils.isDefined(fullName1.lastName) && ComparatorUtils.isDefined(fullName2.lastName)) {
            var lastNameCompare = ComparatorUtils.compareString(fullName1.lastName, fullName2.lastName);
            if (lastNameCompare !== 0) {
                return lastNameCompare;
            }
        }
        if (ComparatorUtils.isDefined(fullName1.firstName) && ComparatorUtils.isDefined(fullName2.firstName)) {
            var firstNameCompare = ComparatorUtils.compareString(fullName1.firstName, fullName2.firstName);
            if (firstNameCompare !== 0) {
                return firstNameCompare;
            }
        }
        return 0;
    };
    ComparatorUtils.compareRsvps = function (rsvp1, rsvp2) {
        return ComparatorUtils.compareLastNameFirstName({ firstName: rsvp1.firstName, lastName: rsvp1.lastName }, { firstName: rsvp2.firstName, lastName: rsvp2.lastName });
    };
    return ComparatorUtils;
}());

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/comparator-utils.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/utils/pioneer-utils.ts

var pioneer_utils_PioneerUtils = (function () {
    function PioneerUtils() {
    }
    PioneerUtils.getLastElement = function (elements) {
        return elements && elements.length > 0 ? elements[elements.length - 1] : null;
    };
    PioneerUtils.safeTrim = function (value) {
        return !value ? value : value.trim();
    };
    PioneerUtils.trimToNull = function (value) {
        var trimmedValue = this.safeTrim(value);
        return trimmedValue && trimmedValue.length > 0 ? trimmedValue : null;
    };
    PioneerUtils.orderDropdownByValue = function (dropdownItems) {
        dropdownItems.sort(function (anItem, anotherItem) {
            return ComparatorUtils.compareString(anItem.value, anotherItem.value);
        });
    };
    PioneerUtils.safeSubstring = function (value, start, end) {
        var result = undefined;
        if (value) {
            if (end) {
                result = value.substring(start, end);
            }
            else {
                result = value.substring(start);
            }
        }
        return result;
    };
    PioneerUtils.addTrailingZeros = function (value) {
        if (!value) {
            return '0.00';
        }
        var _a = (value || '').toString().split('.'), _b = _a[1], fraction = _b === void 0 ? '' : _b;
        if (fraction.length < 2) {
            return value.toFixed(2);
        }
        return '' + value;
    };
    PioneerUtils.formatDecimal = function (value, decimalPlaces) {
        if (decimalPlaces === void 0) { decimalPlaces = 2; }
        var factor = Math.pow(10, decimalPlaces);
        var parsedValue = parseFloat(value);
        if (isNaN(parsedValue)) {
            return value;
        }
        var truncated = Math.floor(parsedValue * factor) / factor;
        return truncated.toFixed(decimalPlaces);
    };
    return PioneerUtils;
}());

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/pioneer-utils.js.map
// EXTERNAL MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/node_modules/rxjs/ReplaySubject.js
var ReplaySubject = __webpack_require__("0imh");
var ReplaySubject_default = /*#__PURE__*/__webpack_require__.n(ReplaySubject);

// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/auth/models/User.ts
var User___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var UserRecord = Object(immutable["Record"])({
    username: null,
    email: null,
    firstName: null,
    lastName: null,
    expiration: null,
    allChains: null,
    allBrands: null,
    allProperties: null,
    allArcIatas: null,
    customerInfo: null,
    type: null
});
var User = (function (_super) {
    User___extends(User, _super);
    function User() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return User;
}(UserRecord));

var UserType;
(function (UserType) {
    UserType[UserType["HOTEL"] = 'HOTEL'] = "HOTEL";
    UserType[UserType["AGENCY"] = 'AGENCY'] = "AGENCY";
    UserType[UserType["SUPPORT"] = 'SUPPORT'] = "SUPPORT";
})(UserType || (UserType = {}));
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/User.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/models/multi-agency.ts
var multi_agency___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var MultiAgencyRecord = Object(immutable["Record"])({
    agencyId: null,
    agencyName: null
});
var MultiAgency = (function (_super) {
    multi_agency___extends(MultiAgency, _super);
    function MultiAgency() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return MultiAgency;
}(MultiAgencyRecord));

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/multi-agency.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/utils/response-util.ts

var response_util_ResponseUtil = (function () {
    function ResponseUtil() {
    }
    ResponseUtil.unwrapErrorMessage = function (response) {
        var customMessage = '';
        if (response.json() && response.json().error) {
            customMessage = response.json().error;
        }
        var errorMessage = "Response with status " + response.status + ": " + customMessage;
        return Observable["Observable"].throw(errorMessage);
    };
    ResponseUtil.getFileNameFromHttpResponse = function (httpResponse) {
        var fileName = undefined;
        var contentDispositionHeader = httpResponse.headers.get('Content-Disposition');
        if (contentDispositionHeader) {
            var result = contentDispositionHeader.split(';')[1].trim().split('=')[1];
            fileName = result.replace(/"/g, '');
        }
        return fileName;
    };
    return ResponseUtil;
}());

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/response-util.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/permission/services/authentication.http.service.ts
var authentication_http_service___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var authentication_http_service___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};




var authentication_http_service_AuthenticationHttpService = (function () {
    function AuthenticationHttpService(http, environment) {
        this.http = http;
        this.environment = environment;
        this.loginURL = this.environment.baseUrl + '/api/auth/login';
        this.permissionURL = this.environment.baseUrl + '/api/auth/permissions';
        this.jtiURL = this.environment.baseUrl + '/api/auth/username';
        this.refreshURL = this.environment.baseUrl + '/api/auth/refresh';
        this.updateIataURL = this.environment.baseUrl + '/api/auth/update/iata';
        this.clientContactEditableURL = this.environment.baseUrl + '/api/auth/customer/edit';
    }
    AuthenticationHttpService.prototype.login = function (username, password) {
        var loginPayload = { 'userId': username, 'password': password };
        return this.http.post(this.loginURL, loginPayload)
            .catch(response_util_ResponseUtil.unwrapErrorMessage).share();
    };
    AuthenticationHttpService.prototype.getPermissions = function (token, defaultArciata) {
        var headers = new common_http_es5["d" /* HttpHeaders */]({
            'Content-Type': 'application/json',
            'Authorization': token,
        });
        var options = null;
        if (defaultArciata == null || defaultArciata.length === 0) {
            options = {
                headers: headers
            }; // Create a request option
        }
        else {
            options = {
                headers: headers,
                params: new common_http_es5["e" /* HttpParams */]().set('arcIata', defaultArciata)
            }; // Create a request option
        }
        return this.http.get(this.permissionURL, options)
            .catch(response_util_ResponseUtil.unwrapErrorMessage).share();
    };
    AuthenticationHttpService.prototype.getJti = function (token) {
        var headers = new common_http_es5["d" /* HttpHeaders */]({
            'Content-Type': 'application/json',
            'Authorization': token,
        });
        var options = null;
        options = {
            headers: headers
        }; // Create a request option
        return this.http.get(this.jtiURL, options)
            .catch(response_util_ResponseUtil.unwrapErrorMessage).share();
    };
    AuthenticationHttpService.prototype.refreshPermissions = function (token) {
        var headers = new common_http_es5["d" /* HttpHeaders */]({
            'Content-Type': 'application/json',
            'Authorization': token,
        });
        var options = {
            headers: headers
        }; // Create a request option
        return this.http.get(this.refreshURL, options)
            .catch(response_util_ResponseUtil.unwrapErrorMessage).share();
    };
    AuthenticationHttpService.prototype.updateIataFromToken = function (token, newArciata) {
        var headers = new common_http_es5["d" /* HttpHeaders */]({
            'Content-Type': 'application/json',
            'Authorization': token,
        });
        var options = {
            headers: headers,
            params: new common_http_es5["e" /* HttpParams */]().set('arcIata', newArciata)
        }; // Create a request option
        return this.http.get(this.updateIataURL, options)
            .catch(response_util_ResponseUtil.unwrapErrorMessage).share();
    };
    AuthenticationHttpService.prototype.retrieveAgencies = function (token) {
        var headers = new common_http_es5["d" /* HttpHeaders */]({
            'Content-Type': 'application/json',
            'Authorization': token,
        });
        var options = {
            headers: headers
        }; // Create a request option
        return this.http.get(this.environment.baseUrl + '/api/lookup/agencies/token', options)
            .catch(response_util_ResponseUtil.unwrapErrorMessage).share();
    };
    AuthenticationHttpService.prototype.isClientContactEditable = function (token) {
        var headers = new common_http_es5["d" /* HttpHeaders */]({
            'Content-Type': 'application/json',
            'Authorization': token,
        });
        var options = {
            headers: headers
        }; // Create a request option
        return this.http.get(this.clientContactEditableURL, options)
            .catch(response_util_ResponseUtil.unwrapErrorMessage).share();
    };
    return AuthenticationHttpService;
}());
authentication_http_service_AuthenticationHttpService = authentication_http_service___decorate([
    Object(core_es5["Injectable"])(),
    authentication_http_service___metadata("design:paramtypes", [typeof (authentication_http_service__a = typeof common_http_es5["b" /* HttpClient */] !== "undefined" && common_http_es5["b" /* HttpClient */]) === "function" && authentication_http_service__a || Object, typeof (authentication_http_service__b = typeof EnvironmentConfiguration !== "undefined" && EnvironmentConfiguration) === "function" && authentication_http_service__b || Object])
], authentication_http_service_AuthenticationHttpService);

var authentication_http_service__a, authentication_http_service__b;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/authentication.http.service.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/service/pagination/pagesize-type.ts
var PagesizeType = (function () {
    function PagesizeType() {
    }
    return PagesizeType;
}());

PagesizeType.EVENTS = 'EVENTS_PAGESIZE';
PagesizeType.GROUP_RESERVATIONS_SUMMARY = 'GROUP_RESERVATIONS_SUMMARY_PAGESIZE';
PagesizeType.GROUP_RESERVATIONS_NO_MATCHES = 'GROUP_RESERVATIONS_NO_MATCHES_PAGESIZE';
PagesizeType.GROUP_RESERVATIONS_PARTIAL_MATCHES = 'GROUP_RESERVATIONS_PARTIAL_MATCHES_PAGESIZE';
PagesizeType.GROUP_RESERVATIONS_EXACT_MATCHES = 'GROUP_RESERVATIONS_EXACT_MATCHES_PAGESIZE';
PagesizeType.RSVP_SUMMARY = 'RSVP_SUMMARY_PAGESIZE';
PagesizeType.RSVP_NO_MATCHES = 'RSVP_NO_MATCHES_PAGESIZE';
PagesizeType.RSVP_PARTIAL_MATCHES = 'RSVP_PARTIAL_MATCHES_PAGESIZE';
PagesizeType.RSVP_EXACT_MATCHES = 'RSVP_EXACT_MATCHES_PAGESIZE';
PagesizeType.TRANSIENT_RESERVATIONS = 'TRANSIENT_RESERVATIONS_PAGESIZE';
PagesizeType.PAYMENT_RESERVATIONS = 'PAYMENT_RESERVATIONS_PAGESIZE';
PagesizeType.PAYMENT_RSVP = 'PAYMENT_RSVP_PAGESIZE';
PagesizeType.MATCHING_PROPERTY = 'MATCHING_PROPERTY_PAGESIZE';
PagesizeType.EVENT_MATCHING = 'EVENT_MATCHING_PAGESIZE';
PagesizeType.MATCHING_AGENCY = 'MATCHING_AGENCY_PAGESIZE';
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/pagesize-type.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/event-reservation-source.ts
var EventReservationSource = (function () {
    function EventReservationSource() {
    }
    return EventReservationSource;
}());

/**
* Reservation from file integration with FTP through IVE.
*/
EventReservationSource.FILE = 'FILE';
/**
 * Manual reservation created by the UI user.
 */
EventReservationSource.MANUAL = 'MANUAL';
/**
 * Reservation from uploaded spreadsheet.
 */
EventReservationSource.UPLOADED = 'UPLOADED';
/**
 * Reservation created from an unmatched RSVP.
 */
EventReservationSource.RSVP = 'RSVP';
/**
 * Out-of-block reservation.
 */
EventReservationSource.OUT_OF_BLOCK = 'OUT_OF_BLOCK';
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/event-reservation-source.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/constants.ts

var Constants = (function () {
    function Constants() {
    }
    return Constants;
}());

Constants.UI_MODIFIABLE_SOURCES = [
    EventReservationSource.MANUAL,
    EventReservationSource.RSVP,
    EventReservationSource.UPLOADED
];
Constants.UI_UNLINKABLE_SOURCES = [
    EventReservationSource.OUT_OF_BLOCK
];
Constants.DATE_FORMAT_MMM_DD = 'MMM-dd';
Constants.DATE_FORMAT_MM_DD_YYYY = 'MMM-dd-yyyy';
Constants.RSVP_COMPARE_PDF_FILE_NAME_SUFFIX = '_rsvp-compare.pdf';
Constants.PDF_EMPTY_CELL = '--';
Constants.SESSION_EXPIRE_WARNING_SECONDS = 120;
Constants.COUNTRIES_WITH_STATES = ['US', 'CA', 'AU'];
Constants.COUNTRIES_WITH_POSTAL_CODE = ['US', 'CA'];
Constants.STATE_INVALID_DUPLICATED = ['PQ', 'NF', 'YU'];
Constants.STATE_QUEBEC_INVALID = 'PQ';
Constants.STATE_QUEBEC_VALID = 'QC';
Constants.STATE_NEW_FOUNDLAND_INVALID = 'NF';
Constants.STATE_NEW_FOUNDLAND_VALID = 'NL';
Constants.STATE_YUKON_INVALID = 'YU';
Constants.STATE_YUKON_VALID = 'YT';
Constants.INITIAL_FILTER_PARAMS = '[' +
    '{"filterField":"paymentStatus","filterValue":"paid"},' +
    '{"filterField":"paymentStatus","filterValue":"paymentInProcess"},' +
    '{"filterField":"paymentStatus","filterValue":"unpaid"}' +
    ']';
Constants.INITIAL_FILTER_PARAMS_FUll_AGENCY = '[' +
    '{"filterField":"paymentStatus","filterValue":"paid"},' +
    '{"filterField":"paymentStatus","filterValue":"paymentInProcess"},' +
    '{"filterField":"paymentStatus","filterValue":"unpaid"},' +
    '{"filterField":"paymentStatus","filterValue":"cancelled"}' +
    ']';
Constants.INITIAL_FILTER_PARAMS_NO_SEARCH = '[' +
    '{"filterField":"paymentStatus","filterValue":"paid"},' +
    '{"filterField":"paymentStatus","filterValue":"paymentInProcess"},' +
    '{"filterField":"includeArchivedEvents","filterValue":"true"}' +
    ']';
Constants.INITIAL_FILTER_PARAMS_FUll_AGENCY_ARCHIVED = '[' +
    '{"filterField":"paymentStatus","filterValue":"paid"},' +
    '{"filterField":"paymentStatus","filterValue":"paymentInProcess"},' +
    '{"filterField":"paymentStatus","filterValue":"unpaid"},' +
    '{"filterField":"paymentStatus","filterValue":"cancelled"},' +
    '{"filterField":"includeArchivedEvents","filterValue":"true"}' +
    ']';
Constants.PROPERTY_SEARCH_MAX_RESULTS = 50;
Constants.PROPERTY_SEARCH_ITEMS_PER_PAGE = 10;
Constants.SEARCH_DEFAULT_ITEMS_PER_PAGE = 10;
Constants.SEARCH_DEFAULT_PAGE = 0;
Constants.EVENTS_NAME_MAX_SIZE = 33;
Constants.AGENCY_SERVICE_ERROR_RESPONSE = 'Error calling agency service';
Constants.COMMISSION_TOKEN_KEY = 'commission_token';
Constants.SORT_DIRECTION_ASC = 'asc';
Constants.SORT_DIRECTION_DESC = 'desc';
Constants.DEFAULT_MATCHING_PROPERTY_FIELD_SORT_FIELD = 'matchingPropertyId';
Constants.DEFAULT_MATCHING_AGENCY_FIELD_SORT_FIELD = 'matchingAgencyId';
Constants.NOT_PROVIDED_VENDOR_ID_PREFIX = 'NOP@';
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/constants.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/permission/models/user-token.model.ts
var user_token_model___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var UserTokenRecord = Object(immutable["Record"])({
    token: null,
    permissions: [],
    jti: null,
    email: null,
    firstName: null,
    lastName: null,
    hotelInfo: null,
    agencyInfo: null,
    userType: null,
    exp: null
});
var UserToken = (function (_super) {
    user_token_model___extends(UserToken, _super);
    function UserToken() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return UserToken;
}(UserTokenRecord));

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/user-token.model.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/dashboard/dashboard-page/dashboard-filter.ts
var dashboard_filter___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var DashboardFilterStateRecord = Object(immutable["Record"])({
    completedAndUnpaid: true,
    missingAgency: true
});
var DashboardFilterState = (function (_super) {
    dashboard_filter___extends(DashboardFilterState, _super);
    function DashboardFilterState() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return DashboardFilterState;
}(DashboardFilterStateRecord));

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/dashboard-filter.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/permission/services/user.local.storage.service.ts
var user_local_storage_service___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var user_local_storage_service___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};







var user_local_storage_service_UserLocalStorageService = (function () {
    function UserLocalStorageService(logService) {
        this.logService = logService;
        this.TOKEN_NAME = 'id_token';
        this.TOKEN_COMMISSION_NAME = 'commission_token';
        this.EMAIL_PREFIX = 'dashboard_filters_';
        this.EXP_TOKEN_NAME = 'exp_token';
    }
    UserLocalStorageService.prototype.getToken = function () {
        try {
            return this.fromUserPermissions().token;
        }
        catch (error) {
            this.removeUserToken();
            this.logService.error('Unable to read token' + error);
            return null;
        }
    };
    UserLocalStorageService.prototype.getExpToken = function () {
        try {
            var exp = Number(this.getItem(this.EXP_TOKEN_NAME));
            return exp;
        }
        catch (error) {
            this.logService.error('Unable to read exp token' + error);
            return null;
        }
    };
    UserLocalStorageService.prototype.getUserPermissionToken = function () {
        try {
            return this.fromUserPermissions();
        }
        catch (error) {
            this.removeUserToken();
            this.logService.error('Unable to read token' + error);
            return null;
        }
    };
    UserLocalStorageService.prototype.getTokenCommission = function () {
        try {
            return this.fromUserPermissionsCommission().token;
        }
        catch (error) {
            this.removeUserToken();
            this.logService.error('Unable to read token' + error);
            return null;
        }
    };
    UserLocalStorageService.prototype.getPermissions = function () {
        try {
            return this.fromUserPermissions().permissions;
        }
        catch (error) {
            this.removeUserToken();
            this.logService.error('Unable to read token' + error);
            return [];
        }
    };
    UserLocalStorageService.prototype.getPermissionsCommission = function () {
        try {
            return this.fromUserPermissionsCommission().permissions;
        }
        catch (error) {
            this.removeUserToken();
            this.logService.error('Unable to read token' + error);
            return [];
        }
    };
    UserLocalStorageService.prototype.getDashboardFilterState = function (email) {
        email = this.EMAIL_PREFIX + email;
        var dashboardFilterStateJson = this.getItemAsJson(email);
        return new DashboardFilterState(dashboardFilterStateJson);
    };
    UserLocalStorageService.prototype.removeUserToken = function () {
        this.removeItem(this.TOKEN_NAME);
    };
    UserLocalStorageService.prototype.setUserToken = function (userPermission) {
        this.setItem(this.TOKEN_NAME, JSON.stringify(userPermission));
    };
    UserLocalStorageService.prototype.setDashboardFilterState = function (email, dashboardFilterState) {
        email = this.EMAIL_PREFIX + email;
        this.setItem(email, JSON.stringify(dashboardFilterState));
    };
    UserLocalStorageService.prototype.fromUserPermissions = function () {
        return new UserToken(this.getItemAsJson(this.TOKEN_NAME));
    };
    UserLocalStorageService.prototype.fromUserPermissionsCommission = function () {
        var role = this.getItemAsJsonCommission(this.TOKEN_COMMISSION_NAME);
        role.permissions = ['GetFiles', 'AddFiles', 'DeleteFiles'];
        return new UserToken(role);
    };
    UserLocalStorageService.prototype.setItem = function (key, value) {
        localStorage.setItem(key, value);
    };
    UserLocalStorageService.prototype.getItem = function (key) {
        return localStorage.getItem(key);
    };
    UserLocalStorageService.prototype.getItemAsJson = function (key) {
        try {
            var stringItem = this.getItem(key);
            if (stringItem != null) {
                return JSON.parse(stringItem);
            }
        }
        catch (error) {
            this.removeItem(key);
            this.logService.error('Unable to read token' + error);
        }
        return null;
    };
    UserLocalStorageService.prototype.getItemAsJsonCommission = function (key) {
        try {
            var stringItem = this.getItem(key);
            if (stringItem != null) {
                return { token: stringItem, permission: [] };
            }
        }
        catch (error) {
            this.removeItem(key);
            this.logService.error('Unable to read token' + error);
        }
        return null;
    };
    UserLocalStorageService.prototype.removeItem = function (key) {
        localStorage.removeItem(key);
    };
    Object.defineProperty(UserLocalStorageService.prototype, "length", {
        get: function () {
            return localStorage.length;
        },
        enumerable: true,
        configurable: true
    });
    UserLocalStorageService.prototype.key = function (i) {
        return localStorage.key(i);
    };
    UserLocalStorageService.prototype.setToken = function (token) {
        var userPermission = this.getItemAsJson(this.TOKEN_NAME);
        userPermission.token = token;
        this.setUserToken(userPermission);
    };
    UserLocalStorageService.prototype.setExpToken = function (exp) {
        this.setItem(this.EXP_TOKEN_NAME, exp);
    };
    UserLocalStorageService.prototype.resetPagesizes = function () {
        this.setPagesize(PagesizeType.EVENTS, Constants.SEARCH_DEFAULT_ITEMS_PER_PAGE);
        this.setPagesize(PagesizeType.GROUP_RESERVATIONS_SUMMARY, Constants.SEARCH_DEFAULT_ITEMS_PER_PAGE);
        this.setPagesize(PagesizeType.GROUP_RESERVATIONS_NO_MATCHES, Constants.SEARCH_DEFAULT_ITEMS_PER_PAGE);
        this.setPagesize(PagesizeType.GROUP_RESERVATIONS_PARTIAL_MATCHES, Constants.SEARCH_DEFAULT_ITEMS_PER_PAGE);
        this.setPagesize(PagesizeType.GROUP_RESERVATIONS_EXACT_MATCHES, Constants.SEARCH_DEFAULT_ITEMS_PER_PAGE);
        this.setPagesize(PagesizeType.RSVP_SUMMARY, Constants.SEARCH_DEFAULT_ITEMS_PER_PAGE);
        this.setPagesize(PagesizeType.RSVP_NO_MATCHES, Constants.SEARCH_DEFAULT_ITEMS_PER_PAGE);
        this.setPagesize(PagesizeType.RSVP_PARTIAL_MATCHES, Constants.SEARCH_DEFAULT_ITEMS_PER_PAGE);
        this.setPagesize(PagesizeType.RSVP_EXACT_MATCHES, Constants.SEARCH_DEFAULT_ITEMS_PER_PAGE);
        this.setPagesize(PagesizeType.TRANSIENT_RESERVATIONS, Constants.SEARCH_DEFAULT_ITEMS_PER_PAGE);
        this.setPagesize(PagesizeType.PAYMENT_RESERVATIONS, Constants.SEARCH_DEFAULT_ITEMS_PER_PAGE);
        this.setPagesize(PagesizeType.PAYMENT_RSVP, Constants.SEARCH_DEFAULT_ITEMS_PER_PAGE);
        this.setPagesize(PagesizeType.MATCHING_PROPERTY, Constants.SEARCH_DEFAULT_ITEMS_PER_PAGE);
        this.setPagesize(PagesizeType.EVENT_MATCHING, Constants.SEARCH_DEFAULT_ITEMS_PER_PAGE);
        this.setPagesize(PagesizeType.MATCHING_AGENCY, Constants.SEARCH_DEFAULT_ITEMS_PER_PAGE);
    };
    UserLocalStorageService.prototype.getPagesize = function (pagesizeType) {
        return +this.getItem(pagesizeType);
    };
    UserLocalStorageService.prototype.setPagesize = function (pagesizeType, pagesize) {
        this.setItem(pagesizeType, pagesize);
    };
    return UserLocalStorageService;
}());
user_local_storage_service_UserLocalStorageService = user_local_storage_service___decorate([
    Object(core_es5["Injectable"])(),
    user_local_storage_service___metadata("design:paramtypes", [typeof (user_local_storage_service__a = typeof log_service_LogService !== "undefined" && log_service_LogService) === "function" && user_local_storage_service__a || Object])
], user_local_storage_service_UserLocalStorageService);

var user_local_storage_service__a;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/user.local.storage.service.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/permission/services/authentication.store.ts
var authentication_store___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var authentication_store___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};














var authentication_store_AuthenticationStore = AuthenticationStore_1 = (function () {
    function AuthenticationStore(authenticationHttpService, logService, userLocalStorageService, router, environment) {
        this.authenticationHttpService = authenticationHttpService;
        this.logService = logService;
        this.userLocalStorageService = userLocalStorageService;
        this.router = router;
        this.environment = environment;
        this.userAuthenticated = new ReplaySubject["ReplaySubject"](1);
        this.userBehaviorSubject = new BehaviorSubject["BehaviorSubject"](new User());
        this.defaultAgency = new BehaviorSubject["BehaviorSubject"](null);
        this.defaultAgency$ = this.defaultAgency.asObservable();
        this.clientContactEditable = new BehaviorSubject["BehaviorSubject"](null);
        this.clientContactEditable$ = this.clientContactEditable.asObservable();
        this.init();
    }
    AuthenticationStore.prototype.init = function () {
        this.isClientContactSetUp = false;
        this.clientContactEditable.next(true);
        var encodedToken = this.getToken();
        this.setUserFromToken(encodedToken, null);
        this.setClientContactEditable(encodedToken);
    };
    Object.defineProperty(AuthenticationStore.prototype, "user", {
        get: function () {
            return this.userBehaviorSubject.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    AuthenticationStore.prototype.login = function (username, password) {
        var _this = this;
        var login = this.authenticationHttpService.login(username, password);
        return login.map(function (userPermission) {
            if (userPermission && userPermission.token) {
                // set token property
                var tokenString = userPermission.token;
                // store username and jwt token in local storage to keep user logged in between page refreshes
                _this.userLocalStorageService.setUserToken(userPermission);
                _this.setExternalLogin(false);
                _this.updateState();
                _this.setUserFromToken(userPermission.token, null);
                _this.userLocalStorageService.resetPagesizes();
                // return true to indicate successful login
                return true;
            }
            else {
                _this.userLocalStorageService.removeUserToken();
                // return false to indicate failed login
                return false;
            }
        });
    };
    AuthenticationStore.prototype.refreshAuthentication = function () {
        return this.refreshPermissionsFromToken(this.getToken(), this.isExternalLogin());
    };
    AuthenticationStore.prototype.handleJtiFromExternalSource = function (token) {
        return this.getJtiFromToken(token);
    };
    AuthenticationStore.prototype.handleTokenFromExternalSource = function (token, jti) {
        return this.generatePermissionsFromToken(token, jti, true);
    };
    AuthenticationStore.prototype.getJtiFromToken = function (token) {
        var _this = this;
        return this.authenticationHttpService.getJti(token)
            .catch(function (error) {
            _this.logService.error("Failed to get jti");
            return Observable["Observable"].throw(ExternalSourceError.DEFAULT_ERROR);
        })
            .map(function (jti) {
            // Make sure we got a valid response back from the server
            if (jti && jti.jti) {
                _this.userLocalStorageService.setExpToken(jti.exp);
                return jti;
            }
            else {
                _this.logService.error("Received invalid Jti");
                throw new Error('Invalid Jti');
            }
        });
    };
    AuthenticationStore.prototype.generatePermissionsFromToken = function (token, jti, externalLogin) {
        var _this = this;
        // Make sure token is not expired
        if (this.isTokenExpired()) {
            this.logService.error("Token is expired: " + token);
            return Observable["Observable"].throw(ExternalSourceError.TOKEN_EXPIRED);
        }
        var agencyId = null;
        if (jti) {
            var defaultArcIataJson = this.userLocalStorageService.getItem(jti
                + AuthenticationStore_1.DEFAULT_AGENCY_STR);
            if (defaultArcIataJson != null && defaultArcIataJson.length > 0) {
                var defaultArcIata = JSON.parse(defaultArcIataJson);
                if (defaultArcIata && defaultArcIata.agencyId
                    && defaultArcIata.agencyId != null
                    && defaultArcIata.agencyId.length > 0) {
                    agencyId = defaultArcIata.agencyId;
                }
            }
        }
        return this.authenticationHttpService.getPermissions(token, agencyId)
            .catch(function (error) {
            _this.logService.error("Failed to get permissions");
            return Observable["Observable"].throw(ExternalSourceError.DEFAULT_ERROR);
        })
            .map(function (userPermission) {
            // Make sure we got a valid response back from the server
            if (userPermission && userPermission.token) {
                // store username and jwt token in local storage to keep user logged in between page refreshes
                _this.userLocalStorageService.setUserToken(userPermission);
                _this.setExternalLogin(externalLogin);
                _this.setUserFromToken(userPermission.token, null);
                if (userPermission && userPermission.agencyInfo
                    && userPermission.agencyInfo.defaultArcIata
                    && userPermission.agencyInfo.defaultArcIata != null) {
                    _this.userLocalStorageService.setItem(userPermission.jti.toUpperCase() + AuthenticationStore_1.DEFAULT_AGENCY_STR, JSON.stringify(userPermission.agencyInfo.defaultArcIata));
                    _this.userLocalStorageService.setItem(userPermission.jti.toUpperCase() + AuthenticationStore_1.CURRENT_AGENCY_STR, JSON.stringify(userPermission.agencyInfo.defaultArcIata));
                    _this.userLocalStorageService.setExpToken(userPermission.exp);
                    _this.defaultAgency.next(userPermission.agencyInfo.defaultArcIata);
                }
                if (userPermission && userPermission.agencyInfo) {
                    _this.authenticationHttpService.retrieveAgencies(userPermission.token).subscribe(function (data) {
                        if (data && data.length > 1) {
                            var agencies_1 = Object(immutable["List"])();
                            data.forEach(function (agency) {
                                var item = new MultiAgency({
                                    'agencyId': pioneer_utils_PioneerUtils.safeTrim(agency.agencyId),
                                    'agencyName': pioneer_utils_PioneerUtils.safeTrim(agency.agencyName)
                                });
                                agencies_1 = agencies_1.push(item);
                            });
                            _this.userLocalStorageService.setItem(AuthenticationStore_1.MULTI_AGENCY_STR, JSON.stringify(agencies_1));
                            _this.defaultAgency.next(JSON.stringify(agencies_1));
                        }
                    }, function (error) {
                    });
                }
                return userPermission;
            }
            else {
                _this.logService.error("Received invalid permissions");
                throw new Error('Invalid UserPermission');
            }
        });
    };
    AuthenticationStore.prototype.refreshPermissionsFromToken = function (token, externalLogin) {
        var _this = this;
        // Make sure token is not expired
        if (this.isTokenExpired()) {
            this.logService.error("Token is expired: " + token);
            return Observable["Observable"].throw(ExternalSourceError.TOKEN_EXPIRED);
        }
        return this.authenticationHttpService.refreshPermissions(token)
            .catch(function (error) {
            _this.logService.error("Failed to get permissions");
            return Observable["Observable"].throw(ExternalSourceError.DEFAULT_ERROR);
        })
            .map(function (userPermission) {
            // Make sure we got a valid response back from the server
            if (userPermission && userPermission.token) {
                // store username and jwt token in local storage to keep user logged in between page refreshes
                _this.userLocalStorageService.setUserToken(userPermission);
                _this.setExternalLogin(externalLogin);
                _this.setUserFromToken(userPermission.token, null);
                return userPermission;
            }
            else {
                _this.logService.error("Received invalid permissions");
                throw new Error('Invalid UserPermission');
            }
        });
    };
    AuthenticationStore.prototype.assignDefaultArcIata = function (token, externalLogin, agencyId) {
        var _this = this;
        // Make sure token is not expired
        if (this.isTokenExpired()) {
            this.logService.error("Token is expired: " + token);
            return Observable["Observable"].throw(ExternalSourceError.TOKEN_EXPIRED);
        }
        return this.authenticationHttpService.getPermissions(token, agencyId)
            .catch(function (error) {
            _this.logService.error("Failed to get permissions");
            return Observable["Observable"].throw(ExternalSourceError.DEFAULT_ERROR);
        })
            .map(function (userPermission) {
            // Make sure we got a valid response back from the server
            if (userPermission && userPermission.token) {
                // store username and jwt token in local storage to keep user logged in between page refreshes
                _this.userLocalStorageService.setUserToken(userPermission);
                _this.setExternalLogin(externalLogin);
                _this.setUserFromToken(userPermission.token, null);
                if (userPermission && userPermission.agencyInfo
                    && userPermission.agencyInfo.defaultArcIata
                    && userPermission.agencyInfo.defaultArcIata != null) {
                    _this.userLocalStorageService.setItem(userPermission.jti.toUpperCase() + AuthenticationStore_1.DEFAULT_AGENCY_STR, JSON.stringify(userPermission.agencyInfo.defaultArcIata));
                    _this.userLocalStorageService.setItem(userPermission.jti.toUpperCase() + AuthenticationStore_1.CURRENT_AGENCY_STR, JSON.stringify(userPermission.agencyInfo.defaultArcIata));
                    _this.defaultAgency.next(userPermission.agencyInfo.defaultArcIata);
                }
                return userPermission;
            }
            else {
                _this.logService.error("Received invalid permissions");
                throw new Error('Invalid UserPermission');
            }
        });
    };
    AuthenticationStore.prototype.getToken = function () {
        return this.userLocalStorageService.getToken();
    };
    AuthenticationStore.prototype.getUserPermissionToken = function () {
        return this.userLocalStorageService.getUserPermissionToken();
    };
    AuthenticationStore.prototype.removeToken = function () {
        this.userLocalStorageService.removeItem(AuthenticationStore_1.TOKEN_NAME);
    };
    AuthenticationStore.prototype.removeExpToken = function () {
        this.userLocalStorageService.removeItem(AuthenticationStore_1.EXP_TOKEN_NAME);
    };
    AuthenticationStore.prototype.hasToken = function () {
        return !!this.getToken();
    };
    AuthenticationStore.prototype.removeMultiAgency = function () {
        this.userLocalStorageService.removeItem(AuthenticationStore_1.MULTI_AGENCY_STR);
        this.defaultAgency.next(AuthenticationStore_1.MULTI_AGENCY_STR);
    };
    AuthenticationStore.prototype.isExternalLogin = function () {
        var loginSourceStr = this.userLocalStorageService.getItem(AuthenticationStore_1.EXTERNAL_LOGIN);
        return loginSourceStr === 'true';
    };
    AuthenticationStore.prototype.setExternalLogin = function (externalLogin) {
        this.userLocalStorageService.setItem(AuthenticationStore_1.EXTERNAL_LOGIN, externalLogin ? 'true' : 'false');
    };
    AuthenticationStore.prototype.removeExternalLogin = function () {
        this.userLocalStorageService.removeItem(AuthenticationStore_1.EXTERNAL_LOGIN);
    };
    AuthenticationStore.prototype.hasPermission = function (arg) {
        var testPermissions;
        if (arg instanceof Array) {
            // arg must be string[]
            testPermissions = arg.map(function (perm) { return perm.toLowerCase(); });
        }
        else {
            // arg must be a string
            testPermissions = [arg.toLowerCase()];
        }
        var userPermissions = this.userLocalStorageService.getPermissions().map(function (perm) { return perm.toLowerCase(); });
        // this.logService.info(`userPermissions: [${userPermissions}]`);
        if (userPermissions.find(function (up) { return Object(util["b" /* isDefined */])(testPermissions.find(function (tp) { return tp === up; })); })) {
            // this.logService.info(`Permission: true`);
            return true;
        }
        else {
            // this.logService.info(`Permission: false`);
            return false;
        }
    };
    AuthenticationStore.prototype.hasPermissionCommission = function (arg) {
        var testPermissions;
        if (arg instanceof Array) {
            // arg must be string[]
            testPermissions = arg.map(function (perm) { return perm.toLowerCase(); });
        }
        else {
            // arg must be a string
            testPermissions = [arg.toLowerCase()];
        }
        var userPermissions = this.userLocalStorageService.getPermissionsCommission().map(function (perm) { return perm.toLowerCase(); });
        // this.logService.info(`userPermissions: [${userPermissions}]`);
        if (userPermissions.find(function (up) { return Object(util["b" /* isDefined */])(testPermissions.find(function (tp) { return tp === up; })); })) {
            // this.logService.info(`Permission: true`);
            return true;
        }
        else {
            // this.logService.info(`Permission: false`);
            return false;
        }
    };
    AuthenticationStore.prototype.getTokenExpirationDate = function (exp) {
        if (exp) {
            return null;
        }
        var date = new Date(0);
        date.setUTCSeconds(exp);
        return date;
    };
    AuthenticationStore.prototype.isTokenExpired = function () {
        var expiration = this.userLocalStorageService.getExpToken();
        if (!expiration) {
            return true;
        }
        var date = this.getTokenExpirationDate(expiration);
        if (date === null) {
            return false;
        }
        return !(date.valueOf() > (new Date().valueOf()));
    };
    AuthenticationStore.prototype.isTokenValid = function () {
        var isTokenValid = !this.isTokenExpired();
        this.logService.verbose("isTokenValid: " + isTokenValid);
        return isTokenValid;
    };
    /**
     * This method will test to determine if the current token is expired.  It will put those
     * results in the Subject so that listeners will be made aware.
     *
     */
    AuthenticationStore.prototype.updateState = function () {
        this.userAuthenticated.next(this.isTokenValid());
    };
    AuthenticationStore.prototype.isLoggedIn = function () {
        this.updateState();
        return this.userAuthenticated.asObservable();
    };
    Object.defineProperty(AuthenticationStore.prototype, "permissions", {
        get: function () {
            return this.userLocalStorageService.getPermissions();
        },
        enumerable: true,
        configurable: true
    });
    AuthenticationStore.prototype.logout = function (routeToLogin) {
        if (routeToLogin === void 0) { routeToLogin = true; }
        this.userLocalStorageService.resetPagesizes();
        this.removeToken();
        this.removeExpToken();
        this.updateState();
        if (routeToLogin) {
            this.router.navigate([this.environment.logout], { queryParams: { 'redirect': true } });
        }
    };
    AuthenticationStore.prototype.setUserFromToken = function (token, exp) {
        if (!token) {
            return;
        }
        if (!this.isClientContactSetUp) {
            this.setClientContactEditable(token);
        }
        var userPermissionToken = this.getUserPermissionToken();
        if (!userPermissionToken) {
            return;
        }
        var expir = null;
        if (exp) {
            expir = Number(exp);
        }
        else {
            expir = userPermissionToken.exp;
        }
        var user = new User({
            username: userPermissionToken.jti || '',
            email: userPermissionToken.email || '',
            firstName: userPermissionToken.firstname || '',
            lastName: userPermissionToken.lastname || '',
            expiration: new Date(expir * 1000),
            allChains: userPermissionToken.hotelInfo ? userPermissionToken.hotelInfo.allChains : null,
            allBrands: userPermissionToken.hotelInfo ? userPermissionToken.hotelInfo.allBrands : null,
            allProperties: userPermissionToken.hotelInfo ? userPermissionToken.hotelInfo.allProperties : null,
            allArcIatas: userPermissionToken.agencyInfo ? userPermissionToken.agencyInfo.allArcIatas : null,
            customerInfo: userPermissionToken.agencyInfo ? userPermissionToken.agencyInfo.customerInfo : null,
            type: userPermissionToken.userType
        });
        this.defaultAgency.next(token);
        this.setUserBehaviorSubject(user);
    };
    // marked protected so that MockAuthenticationStore can override as public
    AuthenticationStore.prototype.setUserBehaviorSubject = function (user) {
        this.userBehaviorSubject.next(user);
    };
    AuthenticationStore.prototype.getUserSync = function () {
        return this.userBehaviorSubject.getValue();
    };
    AuthenticationStore.prototype.refreshToken = function (token, exp) {
        this.userLocalStorageService.setToken(token);
        this.userLocalStorageService.setExpToken(exp);
        this.setUserFromToken(token, exp);
        this.updateState();
    };
    AuthenticationStore.prototype.refreshExpToken = function (exp) {
        this.userLocalStorageService.setExpToken(exp);
        this.updateState();
    };
    AuthenticationStore.prototype.isSinglePropertyUser = function () {
        var user = this.userBehaviorSubject.getValue();
        return (user.allChains && user.allChains.length === 1
            && user.allBrands && user.allBrands.length === 1
            && user.allProperties && user.allProperties.length === 1);
    };
    AuthenticationStore.prototype.isPropertyUser = function () {
        var user = this.userBehaviorSubject.getValue();
        return (user.type === UserType.HOTEL);
    };
    AuthenticationStore.prototype.isMultiPropertyUser = function () {
        return this.isPropertyUser() && !this.isSinglePropertyUser();
    };
    AuthenticationStore.prototype.isAgencyUser = function () {
        var user = this.userBehaviorSubject.getValue();
        return (user.type === UserType.AGENCY);
    };
    AuthenticationStore.prototype.userType = function () {
        var user = this.userBehaviorSubject.getValue();
        return UserType[user.type];
    };
    AuthenticationStore.prototype.isSupportUser = function () {
        var user = this.userBehaviorSubject.getValue();
        return (user.type === UserType.SUPPORT);
    };
    AuthenticationStore.prototype.matchUserType = function (userType) {
        var user = this.userBehaviorSubject.getValue();
        return (userType === user.type.toString());
    };
    AuthenticationStore.prototype.updateIataFromToken = function (newArcIata) {
        var _this = this;
        var token = this.getToken();
        var externalLogin = this.isExternalLogin();
        // Make sure token is not expired
        if (this.isTokenExpired()) {
            this.logService.error("Token is expired: " + token);
            return Observable["Observable"].throw(ExternalSourceError.TOKEN_EXPIRED);
        }
        return this.authenticationHttpService.updateIataFromToken(token, newArcIata)
            .catch(function (error) {
            _this.logService.error("Failed to get update the iata from token");
            return Observable["Observable"].throw(ExternalSourceError.DEFAULT_ERROR);
        })
            .map(function (userPermission) {
            // Make sure we got a valid response back from the server
            if (userPermission && userPermission.token) {
                // store username and jwt token in local storage to keep user logged in between page refreshes
                _this.userLocalStorageService.setUserToken(userPermission);
                _this.userLocalStorageService.setExpToken(userPermission.exp);
                _this.setExternalLogin(externalLogin);
                _this.setUserFromToken(userPermission.token, null);
                return userPermission;
            }
            else {
                _this.logService.error("Received invalid permissions");
                throw new Error('Invalid UserPermission');
            }
        });
    };
    AuthenticationStore.prototype.openDefaultArcIataModalPanel = function (token) {
        var userPermissiontoken = this.getUserPermissionToken();
        if (userPermissiontoken && userPermissiontoken.agencyInfo
            && (!userPermissiontoken.agencyInfo.defaultArcIata || userPermissiontoken.agencyInfo.defaultArcIata == null)) {
            this.userLocalStorageService.removeItem(userPermissiontoken.jti.toUpperCase() + AuthenticationStore_1.CURRENT_AGENCY_STR);
            return true;
        }
    };
    AuthenticationStore.prototype.getDefaultArcIata = function () {
        var token = this.getUserPermissionToken();
        if (token) {
            if (token && token.agencyInfo && token.agencyInfo.defaultArcIata) {
                return token.agencyInfo.defaultArcIata.agencyId;
            }
        }
        return undefined;
    };
    AuthenticationStore.prototype.setClientContactEditable = function (token) {
        var _this = this;
        if (token && !this.isClientContactSetUp) {
            var userPermissiontoken = this.getUserPermissionToken();
            if (userPermissiontoken && userPermissiontoken.agencyInfo
                && userPermissiontoken.agencyInfo.allCustomers
                && userPermissiontoken.agencyInfo.allCustomers != null) {
                this.authenticationHttpService.isClientContactEditable(token).subscribe(function (data) {
                    if (data) {
                        _this.isClientContactSetUp = true;
                        _this.clientContactEditable.next(data.clientContactEditable);
                    }
                }, function (error) {
                });
            }
        }
    };
    AuthenticationStore.prototype.isMultiVendor = function () {
        return this.hasPermission('MultiVendor');
    };
    return AuthenticationStore;
}());
authentication_store_AuthenticationStore.TOKEN_NAME = 'id_token';
authentication_store_AuthenticationStore.EXTERNAL_LOGIN = 'external_login';
authentication_store_AuthenticationStore.DEFAULT_AGENCY_STR = '_DEFAULT_AGENCY';
authentication_store_AuthenticationStore.CURRENT_AGENCY_STR = '_CURRENT_AGENCY';
authentication_store_AuthenticationStore.MULTI_AGENCY_STR = 'MULTI_AGENCY';
authentication_store_AuthenticationStore.EXP_TOKEN_NAME = 'exp_token';
authentication_store_AuthenticationStore = AuthenticationStore_1 = authentication_store___decorate([
    Object(core_es5["Injectable"])(),
    authentication_store___metadata("design:paramtypes", [typeof (authentication_store__a = typeof authentication_http_service_AuthenticationHttpService !== "undefined" && authentication_http_service_AuthenticationHttpService) === "function" && authentication_store__a || Object, typeof (authentication_store__b = typeof log_service_LogService !== "undefined" && log_service_LogService) === "function" && authentication_store__b || Object, typeof (authentication_store__c = typeof user_local_storage_service_UserLocalStorageService !== "undefined" && user_local_storage_service_UserLocalStorageService) === "function" && authentication_store__c || Object, typeof (authentication_store__d = typeof router_es5["Router"] !== "undefined" && router_es5["Router"]) === "function" && authentication_store__d || Object, typeof (authentication_store__e = typeof EnvironmentConfiguration !== "undefined" && EnvironmentConfiguration) === "function" && authentication_store__e || Object])
], authentication_store_AuthenticationStore);

var ExternalSourceError;
(function (ExternalSourceError) {
    ExternalSourceError[ExternalSourceError["TOKEN_EXPIRED"] = 0] = "TOKEN_EXPIRED";
    ExternalSourceError[ExternalSourceError["TOKEN_INVALID_FORMAT"] = 1] = "TOKEN_INVALID_FORMAT";
    ExternalSourceError[ExternalSourceError["DEFAULT_ERROR"] = 2] = "DEFAULT_ERROR";
})(ExternalSourceError || (ExternalSourceError = {}));
var AuthenticationStore_1, authentication_store__a, authentication_store__b, authentication_store__c, authentication_store__d, authentication_store__e;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/authentication.store.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/utils/response-util.service.ts
var response_util_service___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var response_util_service___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};








var response_util_service_ResponseUtilService = (function () {
    function ResponseUtilService(authStore, logService, flashMessagesService) {
        this.authStore = authStore;
        this.logService = logService;
        this.flashMessagesService = flashMessagesService;
    }
    ResponseUtilService.prototype.handleError = function (response) {
        if ((response instanceof http_es5["Response"] && response.status === http_status_codes["UNAUTHORIZED"])
            || response instanceof Error) {
            this.authStore.logout();
            this.logService.warn('Logging out due to AuthHttp error or invalid JWT token');
            this.logService.warn(response.toString());
            // return empty since we handled the error
            return Observable["Observable"].empty();
        }
        else if (response instanceof http_es5["Response"] && response.status === http_status_codes["INTERNAL_SERVER_ERROR"]) {
            var _response = response;
            var errorResponse = _response['_body'];
            if (errorResponse && errorResponse.includes('vendor email address is missing for this request')) {
                this.flashMessagesService.error('MESSAGES.ERROR.VENDOR_EMAIL_MISSING', errorResponse);
            }
            else {
                this.flashMessagesService.error('MESSAGES.ERROR.INTERNAL_SERVER_ERROR', 'An unexpected error has occurred');
            }
            return Observable["Observable"].empty();
        }
        else if (!(response instanceof http_es5["Response"]) && response.status === http_status_codes["BAD_REQUEST"]) {
            var errorResponse = response;
            if (errorResponse.error.includes('Unable to request final payment.')) {
                this.flashMessagesService.error('MESSAGES.ERROR.OOIV_HEALTH', 'An unexpected error has occurred');
            }
            else {
                this.flashMessagesService.error('MESSAGES.ERROR.INTERNAL_SERVER_ERROR', 'An unexpected error has occurred');
            }
            return Observable["Observable"].empty();
        }
        else if (!(response instanceof http_es5["Response"]) && response.status === http_status_codes["FORBIDDEN"]) {
            var errorResponse = response;
            if (errorResponse.error.includes('Invalid Tax ID')) {
                this.flashMessagesService.error('MESSAGES.ERROR.INVALID_VAT_ID', 'An unexpected error has occurred');
            }
            else {
                this.flashMessagesService.error('MESSAGES.ERROR.INTERNAL_SERVER_ERROR', 'An unexpected error has occurred');
            }
            return Observable["Observable"].empty();
        }
        else {
            return response_util_ResponseUtil.unwrapErrorMessage(response);
        }
    };
    return ResponseUtilService;
}());
response_util_service_ResponseUtilService = response_util_service___decorate([
    Object(core_es5["Injectable"])(),
    response_util_service___metadata("design:paramtypes", [typeof (response_util_service__a = typeof authentication_store_AuthenticationStore !== "undefined" && authentication_store_AuthenticationStore) === "function" && response_util_service__a || Object, typeof (response_util_service__b = typeof log_service_LogService !== "undefined" && log_service_LogService) === "function" && response_util_service__b || Object, typeof (response_util_service__c = typeof flash_messages_service_FlashMessagesService !== "undefined" && flash_messages_service_FlashMessagesService) === "function" && response_util_service__c || Object])
], response_util_service_ResponseUtilService);

var response_util_service__a, response_util_service__b, response_util_service__c;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/response-util.service.js.map
// EXTERNAL MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/node_modules/angular2-jwt/angular2-jwt.js
var angular2_jwt = __webpack_require__("W4CS");
var angular2_jwt_default = /*#__PURE__*/__webpack_require__.n(angular2_jwt);

// EXTERNAL MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/node_modules/ngx-spinner/ngx-spinner.umd.js
var ngx_spinner_umd = __webpack_require__("eSpQ");
var ngx_spinner_umd_default = /*#__PURE__*/__webpack_require__.n(ngx_spinner_umd);

// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/spinner.service.ts
var spinner_service___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var spinner_service___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};


var SpinnerService = (function () {
    function SpinnerService(spinner) {
        this.spinner = spinner;
        this.requests = 0;
    }
    SpinnerService.prototype.start = function () {
        var _this = this;
        if (this.requests === 0) {
            setTimeout(function () {
                if (_this.requests > 0) {
                    _this.spinner.show();
                }
            }, 1000);
        }
        this.requests++;
    };
    SpinnerService.prototype.finish = function () {
        this.requests--;
        if (this.requests === 0) {
            this.spinner.hide();
        }
    };
    return SpinnerService;
}());
SpinnerService = spinner_service___decorate([
    Object(core_es5["Injectable"])(),
    spinner_service___metadata("design:paramtypes", [typeof (spinner_service__a = typeof ngx_spinner_umd["NgxSpinnerService"] !== "undefined" && ngx_spinner_umd["NgxSpinnerService"]) === "function" && spinner_service__a || Object])
], SpinnerService);

var spinner_service__a;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/spinner.service.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/http/app.auth.http.service.ts
var app_auth_http_service___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var app_auth_http_service___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};




var AppAuthHttpService = (function () {
    function AppAuthHttpService(http, authenticationStore, spinnerService) {
        this.http = http;
        this.authenticationStore = authenticationStore;
        this.spinnerService = spinnerService;
    }
    AppAuthHttpService.prototype.get = function (url, options, isSpinner) {
        var _this = this;
        if (isSpinner === void 0) { isSpinner = true; }
        if (isSpinner) {
            this.spinnerService.start();
        }
        return this.http.get(url, options)
            .map(function (response) {
            _this.refreshTokenFromResponse(response);
            return response;
        })
            .finally(function () {
            if (isSpinner) {
                _this.spinnerService.finish();
            }
        });
    };
    AppAuthHttpService.prototype.post = function (url, body, options, isSpinner) {
        var _this = this;
        if (isSpinner === void 0) { isSpinner = true; }
        if (isSpinner) {
            this.spinnerService.start();
        }
        return this.http.post(url, body, options)
            .map(function (response) {
            _this.refreshTokenFromResponse(response);
            return response;
        })
            .finally(function () {
            if (isSpinner) {
                _this.spinnerService.finish();
            }
        });
    };
    AppAuthHttpService.prototype.put = function (url, body, options) {
        var _this = this;
        this.spinnerService.start();
        return this.http.put(url, body, options)
            .map(function (response) {
            _this.refreshTokenFromResponse(response);
            return response;
        })
            .finally(function () {
            _this.spinnerService.finish();
        });
    };
    AppAuthHttpService.prototype.delete = function (url, options) {
        var _this = this;
        this.spinnerService.start();
        return this.http.delete(url, options)
            .map(function (response) {
            _this.refreshTokenFromResponse(response);
            return response;
        })
            .finally(function () {
            _this.spinnerService.finish();
        });
    };
    AppAuthHttpService.prototype.refreshTokenFromResponse = function (response) {
        var token = response.headers.get('Authorization');
        var exp = response.headers.get('X-Token-Expiration');
        this.authenticationStore.refreshToken(token, exp);
    };
    return AppAuthHttpService;
}());
AppAuthHttpService = app_auth_http_service___decorate([
    Object(core_es5["Injectable"])(),
    app_auth_http_service___metadata("design:paramtypes", [typeof (app_auth_http_service__a = typeof angular2_jwt["AuthHttp"] !== "undefined" && angular2_jwt["AuthHttp"]) === "function" && app_auth_http_service__a || Object, typeof (app_auth_http_service__b = typeof authentication_store_AuthenticationStore !== "undefined" && authentication_store_AuthenticationStore) === "function" && app_auth_http_service__b || Object, typeof (app_auth_http_service__c = typeof SpinnerService !== "undefined" && SpinnerService) === "function" && app_auth_http_service__c || Object])
], AppAuthHttpService);

var app_auth_http_service__a, app_auth_http_service__b, app_auth_http_service__c;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app.auth.http.service.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/lookup/property-lookup/property-lookup.http.service.ts
var property_lookup_http_service___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var property_lookup_http_service___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};







var property_lookup_http_service_PropertyLookupHttpService = (function () {
    function PropertyLookupHttpService(http, environment, responseUtilService) {
        this.http = http;
        this.environment = environment;
        this.responseUtilService = responseUtilService;
        this.propertySearchURL = this.environment.baseUrl + "/api/lookup/properties";
        this.propertyAdvancedSearchURL = this.environment.baseUrl + "/api/lookup/properties/advanced";
        this.propertyDetailsURL = this.environment.baseUrl + "/api/lookup/properties/details";
        this.vendorTypeEndpoint = '/payorType';
    }
    PropertyLookupHttpService.prototype.search = function (propertyName) {
        var _this = this;
        var params = new http_es5["URLSearchParams"]();
        params.set('propertyName', propertyName);
        return this.http.get(this.propertySearchURL, { search: params })
            .map(function (res) { return res.json().map(function (object) { return new PropertyLookupSummary(object); }); })
            .catch(function (response) { return _this.responseUtilService.handleError(response); })
            .share();
    };
    PropertyLookupHttpService.prototype.advancedSearch = function (searchRequest) {
        var _this = this;
        var headers = new http_es5["Headers"]({ 'Content-Type': 'application/json' });
        var options = new http_es5["RequestOptions"]({ headers: headers }); // Create a request option
        return this.http.post("" + this.propertyAdvancedSearchURL, JSON.stringify(searchRequest), options)
            .map(function (res) { return res.json(); })
            .catch(function (response) { return _this.responseUtilService.handleError(response); })
            .share();
    };
    PropertyLookupHttpService.prototype.advancedVendorSearch = function (searchRequest) {
        var _this = this;
        var headers = new http_es5["Headers"]({ 'Content-Type': 'application/json' });
        var options = new http_es5["RequestOptions"]({ headers: headers }); // Create a request option
        return this.http.post("" + this.propertyAdvancedSearchURL, JSON.stringify(searchRequest), options)
            .map(function (res) { return res.json(); })
            .catch(function (response) { return _this.responseUtilService.handleError(response); })
            .share();
    };
    PropertyLookupHttpService.prototype.getDetail = function (propertyQuery) {
        var _this = this;
        var headers = new http_es5["Headers"]({ 'Content-Type': 'application/json' });
        var options = new http_es5["RequestOptions"]({ headers: headers }); // Create a request option
        return this.http.post("" + this.propertyDetailsURL, JSON.stringify(propertyQuery), options)
            .map(function (response) { return new PropertyLookupDetail(response.json()); })
            .catch(function (response) { return _this.responseUtilService.handleError(response); }).share();
    };
    PropertyLookupHttpService.prototype.getPayorTypes = function () {
        var _this = this;
        return this.http.get("" + this.propertySearchURL + this.vendorTypeEndpoint)
            .map(function (response) { return response.json(); })
            .catch(function (response) { return _this.responseUtilService.handleError(response); }).share();
    };
    return PropertyLookupHttpService;
}());
property_lookup_http_service_PropertyLookupHttpService = property_lookup_http_service___decorate([
    Object(core_es5["Injectable"])(),
    property_lookup_http_service___metadata("design:paramtypes", [typeof (property_lookup_http_service__a = typeof AppAuthHttpService !== "undefined" && AppAuthHttpService) === "function" && property_lookup_http_service__a || Object, typeof (property_lookup_http_service__b = typeof EnvironmentConfiguration !== "undefined" && EnvironmentConfiguration) === "function" && property_lookup_http_service__b || Object, typeof (property_lookup_http_service__c = typeof response_util_service_ResponseUtilService !== "undefined" && response_util_service_ResponseUtilService) === "function" && property_lookup_http_service__c || Object])
], property_lookup_http_service_PropertyLookupHttpService);

var property_lookup_http_service__a, property_lookup_http_service__b, property_lookup_http_service__c;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/property-lookup.http.service.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/models/page.ts

var page_Page = (function () {
    function Page() {
    }
    Page.empty = function () {
        var pageObj = new Page();
        pageObj.content = Object(immutable["List"])();
        pageObj.number = 0; // the page number
        pageObj.size = 25; // the maximum number of elements for each page
        pageObj.totalElements = 0; // the total number of elements for all pages
        pageObj.totalPages = 0; // the total number of pages
        pageObj.numberOfElements = 0; // the total number of elements on this page
        pageObj.sort = Object(immutable["List"])();
        return pageObj;
    };
    return Page;
}());

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/page.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/models/property-lookup-detail-query.ts
var property_lookup_detail_query___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var PropertyLookupDetailQueryRecord = Object(immutable["Record"])({
    chain: null,
    brand: null,
    propertyId: null,
    name: null,
    address: new LookupAddress({}),
    manuallyAdded: null
});
var PropertyLookupDetailQuery = (function (_super) {
    property_lookup_detail_query___extends(PropertyLookupDetailQuery, _super);
    function PropertyLookupDetailQuery() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return PropertyLookupDetailQuery;
}(PropertyLookupDetailQueryRecord));

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/property-lookup-detail-query.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/dropdown-item.ts
var DropdownItem = (function () {
    function DropdownItem(key, value) {
        this.key = key;
        this.value = value;
        this.key = key;
        this.value = value;
    }
    return DropdownItem;
}());

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/dropdown-item.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/service/common-data/common-data.mapper.ts



var common_data_mapper_CommonDataMapper = (function () {
    function CommonDataMapper() {
    }
    CommonDataMapper.convertCountriesToDropDownItem = function (countries) {
        return countries.map(function (country) { return CommonDataMapper.convertCountryToDropDownItem(country); });
    };
    CommonDataMapper.convertCurrenciesToDropDownItem = function (currencies) {
        return currencies.map(function (currency) { return CommonDataMapper.convertCurrencyToDropDownItem(currency); });
    };
    CommonDataMapper.convertStatesToDropDownItem = function (states) {
        return states.map(function (state) { return CommonDataMapper.convertStateToDropDownItem(state); });
    };
    CommonDataMapper.removeDuplicateStatesToDropDownItem = function (state) {
        return Constants.STATE_INVALID_DUPLICATED.indexOf(pioneer_utils_PioneerUtils.safeTrim(state.stateCode)) < 0;
    };
    CommonDataMapper.fixDuplicateState = function (state) {
        switch (state) {
            case Constants.STATE_QUEBEC_INVALID:
                return Constants.STATE_QUEBEC_VALID;
            case Constants.STATE_NEW_FOUNDLAND_INVALID:
                return Constants.STATE_NEW_FOUNDLAND_VALID;
            case Constants.STATE_YUKON_INVALID:
                return Constants.STATE_YUKON_VALID;
            default:
                return state;
        }
    };
    CommonDataMapper.convertCountryToDropDownItem = function (country) {
        return new DropdownItem(pioneer_utils_PioneerUtils.safeTrim(country.code), pioneer_utils_PioneerUtils.safeTrim(country.longDescription));
    };
    CommonDataMapper.convertCurrencyToDropDownItem = function (currency) {
        return new DropdownItem(pioneer_utils_PioneerUtils.safeTrim(currency.code), pioneer_utils_PioneerUtils.safeTrim(currency.shortDescription));
    };
    CommonDataMapper.convertStateToDropDownItem = function (state) {
        return new DropdownItem(pioneer_utils_PioneerUtils.safeTrim(state.stateCode), pioneer_utils_PioneerUtils.safeTrim(state.name));
    };
    CommonDataMapper.convertPayorTypesToDropDownItem = function (payorTypes) {
        return payorTypes.map(function (payorType) { return CommonDataMapper.convertPayorTypeToDropDownItem(payorType); });
    };
    CommonDataMapper.convertPayorTypeToDropDownItem = function (payorType) {
        return new DropdownItem(pioneer_utils_PioneerUtils.safeTrim(payorType.code), pioneer_utils_PioneerUtils.safeTrim(payorType.longDescription));
    };
    return CommonDataMapper;
}());

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/common-data.mapper.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/lookup/property-lookup/property-lookup.store.ts
var property_lookup_store___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var property_lookup_store___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};











var property_lookup_store_PropertyLookupStore = (function () {
    function PropertyLookupStore(propertyLookupService, logService, flashMessagesService) {
        var _this = this;
        this.propertyLookupService = propertyLookupService;
        this.logService = logService;
        this.flashMessagesService = flashMessagesService;
        this.mySelectedResultsCached = new BehaviorSubject["BehaviorSubject"](null);
        this.mySelectedResults = new Subject["Subject"]();
        this.mySearchResults = new BehaviorSubject["BehaviorSubject"](Object(immutable["List"])([]));
        this.mySearchResultsPage = new BehaviorSubject["BehaviorSubject"](page_Page.empty());
        this.payorTypes$ = new BehaviorSubject["BehaviorSubject"]([]);
        this.mySelectedResults.subscribe(function (res) {
            _this.mySelectedResultsCached.next(res);
        });
    }
    Object.defineProperty(PropertyLookupStore.prototype, "selected", {
        get: function () {
            return this.mySelectedResults.asObservable().share();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PropertyLookupStore.prototype, "selectedCached", {
        get: function () {
            return this.mySelectedResultsCached.asObservable().filter(function (res) { return !!res; }).share();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PropertyLookupStore.prototype, "searchResults", {
        get: function () {
            return this.mySearchResults.asObservable().share();
        },
        enumerable: true,
        configurable: true
    });
    PropertyLookupStore.prototype.clearSearchResults = function () {
        this.mySearchResults.next(Object(immutable["List"])([]));
    };
    PropertyLookupStore.prototype.search = function (searchText) {
        var _this = this;
        this.logService.debug("searchText: " + searchText);
        return this.propertyLookupService.search(searchText)
            .catch(function (error) {
            _this.flashMessagesService.warn('MESSAGES.ERROR.PROPERTY_LOOKUP_SEARCH', "Error retrieving PropertyLookupSearch: " + error);
            return Observable["Observable"].throw(error);
        })
            .map(function (res) {
            _this.mySearchResults.next(res);
            return res;
        });
    };
    Object.defineProperty(PropertyLookupStore.prototype, "advancedSearchTotalElements", {
        get: function () {
            return this.mySearchResultsPage.asObservable().map(function (page) { return page.totalElements; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PropertyLookupStore.prototype, "advancedSearchSize", {
        get: function () {
            return this.mySearchResultsPage.asObservable().map(function (page) { return page.size; });
        },
        enumerable: true,
        configurable: true
    });
    PropertyLookupStore.prototype.advancedSearch = function (searchRequest) {
        var _this = this;
        this.logService.debug("searchRequest: " + searchRequest);
        return this.propertyLookupService.advancedSearch(searchRequest)
            .catch(function (error) {
            _this.flashMessagesService.warn('MESSAGES.ERROR.PROPERTY_LOOKUP_SEARCH', "Error retrieving PropertyLookupSearch: " + error);
            return Observable["Observable"].throw(error);
        })
            .map(function (res) {
            _this.mySearchResultsPage.next(res);
            _this.logService.debug("searchResult: " + res);
            return res;
        });
    };
    PropertyLookupStore.prototype.advancedVendorSearch = function (searchRequest) {
        var _this = this;
        this.logService.debug("searchRequest: " + searchRequest);
        return this.propertyLookupService.advancedVendorSearch(searchRequest)
            .catch(function (error) {
            _this.flashMessagesService.warn('MESSAGES.ERROR.VENDOR_LOOKUP_SEARCH', "Error retrieving PropertyLookupSearch: " + error);
            return Observable["Observable"].throw(error);
        })
            .map(function (res) {
            _this.mySearchResultsPage.next(res);
            _this.logService.debug("searchResult: " + res);
            return res;
        });
    };
    PropertyLookupStore.prototype.getDetail = function (chainOrPropertyQuery, brand, propertyId) {
        var _this = this;
        var propertyQuery;
        if (typeof chainOrPropertyQuery === 'string') {
            propertyQuery = new PropertyLookupDetailQuery({
                chain: chainOrPropertyQuery,
                brand: brand,
                propertyId: propertyId,
            });
        }
        else {
            propertyQuery = chainOrPropertyQuery;
        }
        this.logService.debug("summaryRecord: " + JSON.stringify(propertyQuery));
        return this.propertyLookupService.getDetail(propertyQuery)
            .catch(function (error) {
            _this.flashMessagesService.error('MESSAGES.ERROR.PROPERTY_LOOKUP_GET_DETAILS', "Error retrieving PropertyLookupDetail: " + error);
            return Observable["Observable"].throw(error);
        })
            .map(function (res) {
            _this.mySelectedResults.next(res);
            return res;
        });
    };
    Object.defineProperty(PropertyLookupStore.prototype, "payorTypes", {
        get: function () {
            return this.payorTypes$.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    PropertyLookupStore.prototype.loadPayorTypes = function () {
        var _this = this;
        return this.propertyLookupService.getPayorTypes()
            .catch(function (error) {
            _this.flashMessagesService.error('MESSAGES.ERROR.COULD_NOT_GET_VENDOR_TYPES', "Error retrieving vendor types: " + error);
            return Observable["Observable"].throw(error);
        })
            .map(function (payorTypes) { return common_data_mapper_CommonDataMapper.convertPayorTypesToDropDownItem(payorTypes); })
            .map(function (payorTypes) {
            _this.payorTypes$.next(payorTypes);
            return payorTypes;
        });
    };
    return PropertyLookupStore;
}());
property_lookup_store_PropertyLookupStore = property_lookup_store___decorate([
    Object(core_es5["Injectable"])(),
    property_lookup_store___metadata("design:paramtypes", [typeof (property_lookup_store__a = typeof property_lookup_http_service_PropertyLookupHttpService !== "undefined" && property_lookup_http_service_PropertyLookupHttpService) === "function" && property_lookup_store__a || Object, typeof (property_lookup_store__b = typeof log_service_LogService !== "undefined" && log_service_LogService) === "function" && property_lookup_store__b || Object, typeof (property_lookup_store__c = typeof flash_messages_service_FlashMessagesService !== "undefined" && flash_messages_service_FlashMessagesService) === "function" && property_lookup_store__c || Object])
], property_lookup_store_PropertyLookupStore);

var property_lookup_store__a, property_lookup_store__b, property_lookup_store__c;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/property-lookup.store.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/models/agency-lookup-summary.ts
var agency_lookup_summary___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var AgencyLookupSummaryRecord = Object(immutable["Record"])({
    agencyId: null,
    name: null,
    agencyAlias: null,
    address: new LookupAddress({}),
    manuallyAdded: null
});
var AgencyLookupSummary = (function (_super) {
    agency_lookup_summary___extends(AgencyLookupSummary, _super);
    function AgencyLookupSummary() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return AgencyLookupSummary;
}(AgencyLookupSummaryRecord));

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/agency-lookup-summary.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/lookup/agency-lookup/agency-lookup.http.service.ts
var agency_lookup_http_service___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var agency_lookup_http_service___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};






var agency_lookup_http_service_AgencyLookupHttpService = (function () {
    function AgencyLookupHttpService(http, environment, responseUtilService) {
        this.http = http;
        this.environment = environment;
        this.responseUtilService = responseUtilService;
        this.agencySearchURL = this.environment.baseUrl + "/api/lookup/agencies";
        this.agencyDetailsURL = this.environment.baseUrl + "/api/lookup/agencies/details";
        this.subscriberAgencyURL = this.environment.baseUrl + "/api/lookup/agencies/subscriber";
    }
    AgencyLookupHttpService.prototype.search = function (searchText) {
        var _this = this;
        var params = new http_es5["URLSearchParams"]();
        params.set('query', searchText);
        return this.http.get(this.agencySearchURL, { search: params })
            .map(function (res) { return res.json().map(function (object) { return new AgencyLookupSummary(object); }); })
            .catch(function (response) { return _this.responseUtilService.handleError(response); }).share();
    };
    AgencyLookupHttpService.prototype.getDetail = function (summaryRecord) {
        var _this = this;
        var headers = new http_es5["Headers"]({ 'Content-Type': 'application/json' });
        var options = new http_es5["RequestOptions"]({ headers: headers }); // Create a request option
        return this.http.post("" + this.agencyDetailsURL, JSON.stringify(summaryRecord), options)
            .map(function (response) { return response.json(); })
            .catch(function (response) { return _this.responseUtilService.handleError(response); }).share();
    };
    AgencyLookupHttpService.prototype.isSubscriberAgency = function (arcIata) {
        var _this = this;
        var headers = new http_es5["Headers"]({ 'Content-Type': 'application/json' });
        var options = new http_es5["RequestOptions"]({ headers: headers }); // Create a request option
        return this.http.get(this.subscriberAgencyURL + "/" + arcIata, options)
            .map(function (res) { return Boolean(res.json()); })
            .catch(function (response) { return _this.responseUtilService.handleError(response); }).share();
    };
    return AgencyLookupHttpService;
}());
agency_lookup_http_service_AgencyLookupHttpService = agency_lookup_http_service___decorate([
    Object(core_es5["Injectable"])(),
    agency_lookup_http_service___metadata("design:paramtypes", [typeof (agency_lookup_http_service__a = typeof AppAuthHttpService !== "undefined" && AppAuthHttpService) === "function" && agency_lookup_http_service__a || Object, typeof (agency_lookup_http_service__b = typeof EnvironmentConfiguration !== "undefined" && EnvironmentConfiguration) === "function" && agency_lookup_http_service__b || Object, typeof (agency_lookup_http_service__c = typeof response_util_service_ResponseUtilService !== "undefined" && response_util_service_ResponseUtilService) === "function" && agency_lookup_http_service__c || Object])
], agency_lookup_http_service_AgencyLookupHttpService);

var agency_lookup_http_service__a, agency_lookup_http_service__b, agency_lookup_http_service__c;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/agency-lookup.http.service.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/lookup/agency-lookup/agency-lookup.store.ts
var agency_lookup_store___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var agency_lookup_store___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};









var agency_lookup_store_AgencyLookupStore = (function () {
    function AgencyLookupStore(agencyLookupHttpService, logService, flashMessagesService) {
        this.agencyLookupHttpService = agencyLookupHttpService;
        this.logService = logService;
        this.flashMessagesService = flashMessagesService;
        this.mySelectedResults = new Subject["Subject"]();
        this.mySearchResults = new BehaviorSubject["BehaviorSubject"](Object(immutable["List"])([]));
        this.subscriberCache = new Map();
        this.cacheExpirationTime = 60 * 60 * 1000; // 1 hour in milliseconds
    }
    Object.defineProperty(AgencyLookupStore.prototype, "selected", {
        get: function () {
            return this.mySelectedResults.asObservable().share();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AgencyLookupStore.prototype, "searchResults", {
        get: function () {
            return this.mySearchResults.asObservable().share();
        },
        enumerable: true,
        configurable: true
    });
    AgencyLookupStore.prototype.clearSearchResults = function () {
        this.mySearchResults.next(Object(immutable["List"])([]));
    };
    AgencyLookupStore.prototype.search = function (searchText) {
        var _this = this;
        this.logService.debug("searchText: " + searchText);
        return this.agencyLookupHttpService.search(searchText)
            .catch(function (error) {
            _this.flashMessagesService.warn('MESSAGES.ERROR.AGENCY_LOOKUP_SEARCH', "Error retrieving AgencyLookupSearch: " + error);
            return Observable["Observable"].throw(error);
        })
            .map(function (res) {
            _this.mySearchResults.next(res);
            return res;
        });
    };
    AgencyLookupStore.prototype.getDetail = function (summaryRecord) {
        var _this = this;
        this.logService.debug("summaryRecord: " + JSON.stringify(summaryRecord));
        return this.agencyLookupHttpService.getDetail(summaryRecord)
            .catch(function (error) {
            _this.flashMessagesService.error('MESSAGES.ERROR.AGENCY_LOOKUP_GET_DETAILS', "Error retrieving AgencyLookupDetail: " + error);
            return Observable["Observable"].throw(error);
        })
            .map(function (res) {
            _this.mySelectedResults.next(res);
            return res;
        });
    };
    AgencyLookupStore.prototype.isSubscriberAgency = function (arcIata) {
        var _this = this;
        this.logService.debug("checkSubscriberAgency - iata: " + arcIata);
        var cachedEntry = this.subscriberCache.get(arcIata);
        var entryExists = !!cachedEntry;
        var entryExpired = !!cachedEntry && !!cachedEntry.value && cachedEntry.value.expiry < Date.now();
        if (!entryExists) {
            cachedEntry = new BehaviorSubject["BehaviorSubject"](null);
            this.subscriberCache.set(arcIata, cachedEntry);
        }
        if (!entryExists || entryExpired) {
            this.agencyLookupHttpService.isSubscriberAgency(arcIata).pipe(Object(operators["take"])(1), Object(operators["tap"])(function (isSubscriber) {
                var newEntry = { value: isSubscriber, expiry: Date.now() + _this.cacheExpirationTime };
                cachedEntry.next(newEntry);
            }), Object(operators["catchError"])(function (error) {
                _this.flashMessagesService.error('MESSAGES.ERROR.SUBSCRIBER_AGENCY_VERIFICATION', "Error checking SubscriberAgency: " + error);
                return Observable["Observable"].throw(error);
            })).subscribe();
        }
        return cachedEntry.asObservable().pipe(Object(operators["filter"])(function (entry) { return !!entry; }), Object(operators["map"])(function (entry) { return entry.value; }));
    };
    return AgencyLookupStore;
}());
agency_lookup_store_AgencyLookupStore = agency_lookup_store___decorate([
    Object(core_es5["Injectable"])(),
    agency_lookup_store___metadata("design:paramtypes", [typeof (agency_lookup_store__a = typeof agency_lookup_http_service_AgencyLookupHttpService !== "undefined" && agency_lookup_http_service_AgencyLookupHttpService) === "function" && agency_lookup_store__a || Object, typeof (agency_lookup_store__b = typeof log_service_LogService !== "undefined" && log_service_LogService) === "function" && agency_lookup_store__b || Object, typeof (agency_lookup_store__c = typeof flash_messages_service_FlashMessagesService !== "undefined" && flash_messages_service_FlashMessagesService) === "function" && agency_lookup_store__c || Object])
], agency_lookup_store_AgencyLookupStore);

var agency_lookup_store__a, agency_lookup_store__b, agency_lookup_store__c;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/agency-lookup.store.js.map
// EXTERNAL MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/node_modules/ngx-bootstrap/accordion/index.js
var accordion = __webpack_require__("C2n2");

// EXTERNAL MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/node_modules/ngx-bootstrap/alert/index.js
var ngx_bootstrap_alert = __webpack_require__("fSDq");

// EXTERNAL MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/node_modules/ngx-bootstrap/dropdown/index.js
var dropdown = __webpack_require__("ZBFC");

// EXTERNAL MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/node_modules/ngx-bootstrap/modal/index.js
var modal = __webpack_require__("WYiA");

// EXTERNAL MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/node_modules/ngx-bootstrap/popover/index.js
var popover = __webpack_require__("eTxu");

// EXTERNAL MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/node_modules/ngx-bootstrap/tooltip/index.js
var tooltip = __webpack_require__("In3T");

// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/bootstrap/bootstrap.module.ts
var bootstrap_module___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var bootstrap_module___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};







var BootstrapModule = (function () {
    function BootstrapModule() {
    }
    return BootstrapModule;
}());
BootstrapModule = bootstrap_module___decorate([
    Object(core_es5["NgModule"])({
        imports: [
            accordion["a" /* AccordionModule */].forRoot(),
            ngx_bootstrap_alert["a" /* AlertModule */].forRoot(),
            dropdown["a" /* BsDropdownModule */].forRoot(),
            modal["c" /* ModalModule */].forRoot(),
            popover["a" /* PopoverModule */].forRoot(),
            tooltip["a" /* TooltipModule */].forRoot() // Don't work for bootstrap 4 Alpha 6 at the moment
        ],
        exports: [
            accordion["a" /* AccordionModule */],
            ngx_bootstrap_alert["a" /* AlertModule */],
            dropdown["a" /* BsDropdownModule */],
            modal["c" /* ModalModule */],
            popover["a" /* PopoverModule */],
            tooltip["a" /* TooltipModule */]
        ],
        declarations: [],
        providers: []
    }),
    bootstrap_module___metadata("design:paramtypes", [])
], BootstrapModule);

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/bootstrap.module.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/validation-message/validation-message.component.ts
var validation_message_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var validation_message_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};



var ValidationMessageComponent = (function () {
    function ValidationMessageComponent(form, translateService) {
        this.form = form;
        this.translateService = translateService;
        this.takeSpace = false;
        if (!this.form) {
            throw new Error("A form ControlContainer could not be found. The ValidationMessageComponent must exists within a \"formGroup\"");
        }
    }
    Object.defineProperty(ValidationMessageComponent.prototype, "valid", {
        get: function () {
            // If the user has touched the control then validate it, otherwise it should be considered valid.
            return this.control.touched ? !this.control.hasError(this.error) : true;
        },
        enumerable: true,
        configurable: true
    });
    ValidationMessageComponent.prototype.getValidationMessage = function (error) {
        // Return the user specified validation message if present, otherwise
        // fall back to the default message configured in the transaltion service
        var key = "MESSAGES.VALIDATION." + error.toUpperCase();
        return this.translateService.instant(this.message || key);
    };
    ValidationMessageComponent.prototype.ngOnInit = function () {
        // If the "for" attribute is specified find the control with a matching value in the formControlName attribute
        // otherwise return the form itself.  This allows for both input and form level validation to be handled.
        this.control = this.for ? this.form.control.get(this.for) : this.form;
        // Ensure that a form control is found with the correct name if the "for" attribute is specified
        if (this.for && !this.control) {
            throw new Error("Value in the \"for\" attribute: \"" + this.for + "\" could not be located in a corresponding \"formControlName\"");
        }
        // Ensure the "error" attribute is specified. IE: "required", "minlength"
        if (!this.error) {
            throw new Error("A value in the \"error\" attribute is required and should be the name of the rule associated with this message.");
        }
    };
    return ValidationMessageComponent;
}());
validation_message_component___decorate([
    Object(core_es5["Input"])(),
    validation_message_component___metadata("design:type", String)
], ValidationMessageComponent.prototype, "for", void 0);
validation_message_component___decorate([
    Object(core_es5["Input"])(),
    validation_message_component___metadata("design:type", String)
], ValidationMessageComponent.prototype, "error", void 0);
validation_message_component___decorate([
    Object(core_es5["Input"])(),
    validation_message_component___metadata("design:type", String)
], ValidationMessageComponent.prototype, "message", void 0);
validation_message_component___decorate([
    Object(core_es5["Input"])(),
    validation_message_component___metadata("design:type", Object)
], ValidationMessageComponent.prototype, "takeSpace", void 0);
ValidationMessageComponent = validation_message_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-validation-message',
        template: __webpack_require__("wvGA"),
        styles: [__webpack_require__("b9Cn")]
    }),
    validation_message_component___metadata("design:paramtypes", [typeof (validation_message_component__a = typeof forms_es5["ControlContainer"] !== "undefined" && forms_es5["ControlContainer"]) === "function" && validation_message_component__a || Object, typeof (validation_message_component__b = typeof core["c" /* TranslateService */] !== "undefined" && core["c" /* TranslateService */]) === "function" && validation_message_component__b || Object])
], ValidationMessageComponent);

var validation_message_component__a, validation_message_component__b;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/validation-message.component.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/form-input/form-input.component.ts
var form_input_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var form_input_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};




var FormInputComponent = (function () {
    function FormInputComponent(logService) {
        this.logService = logService;
        this.isReadOnly = false;
        this.required = false;
        this.overrideErrors = [];
    }
    FormInputComponent.prototype.ngOnInit = function () {
    };
    FormInputComponent.prototype.ngAfterContentInit = function () {
        this.overrideErrors = this.getOverrideErrors();
    };
    FormInputComponent.prototype.getOverrideErrors = function () {
        // The overrideErrors are gathered from any 'ValidationMessageComponent' that are
        // declared as part of the FormInputComponent content. <ng-content>
        return this.overrideValidationMessages.map(function (message) { return message.error; });
    };
    /**
     * Default errors generated from the errors associated with the control.
     * These are typically created when the FormBuild group is initialized.
     * By eliminating the override errors (those the developer specifies in ng-content)
     * the control can automatically generate validation messages for any errors
     * that have not been specifically overridden.
     *
     * @returns {Array}
     */
    FormInputComponent.prototype.getFormControlErrors = function () {
        var errorObject = this.inputControl.errors;
        if (!errorObject) {
            return [];
        }
        return Object.keys(errorObject);
    };
    Object.defineProperty(FormInputComponent.prototype, "getDefaultErrors", {
        get: function () {
            if (this.isReadOnly) {
                // Show no errors while component is in readonly mode.
                return [];
            }
            var defaultErrors = this.getFormControlErrors();
            var overrideErrors = this.overrideErrors;
            // Get the errors from the form error object and filter out any that are
            // provided in the override errors.
            var filteredErrors = defaultErrors.filter(function (error) { return overrideErrors.indexOf(error) === -1; });
            return filteredErrors;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormInputComponent.prototype, "isRequired", {
        get: function () {
            return this.required === true || this.getFormControlErrors().filter(function (error) { return error === 'required'; }).length > 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormInputComponent.prototype, "showLabel", {
        get: function () {
            return this.label != null && this.label.length > 0;
        },
        enumerable: true,
        configurable: true
    });
    FormInputComponent.prototype.isFormControlInvalid = function () {
        if (this.inputControl && this.inputControl.control) {
            return this.inputControl.control.invalid;
        }
        return false;
    };
    FormInputComponent.prototype.isFormControlTouched = function () {
        if (this.inputControl && this.inputControl.control) {
            return this.inputControl.control.touched;
        }
        return false;
    };
    FormInputComponent.prototype.getFormControlName = function () {
        if (this.inputControl) {
            return this.inputControl.name;
        }
        return null;
    };
    Object.defineProperty(FormInputComponent.prototype, "isValid", {
        get: function () {
            var overrideErrorsAreValid = !this.overrideValidationMessages.some(function (message) { return !message.valid; });
            var defaultErrorsAreValid = !this.isFormControlInvalid();
            var touched = this.isFormControlTouched();
            if (touched) {
                this.logService.verbose(this.getFormControlName() + ' - touched {' + touched + '} ' +
                    'defaultErrorsAreValid: {' + defaultErrorsAreValid + '} ' +
                    'overrideErrorsAreValid: {' + overrideErrorsAreValid + '}');
            }
            return touched ? defaultErrorsAreValid && overrideErrorsAreValid : true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormInputComponent.prototype, "displayError", {
        get: function () {
            return !this.isValid;
        },
        enumerable: true,
        configurable: true
    });
    return FormInputComponent;
}());
form_input_component___decorate([
    Object(core_es5["Input"])(),
    form_input_component___metadata("design:type", Object)
], FormInputComponent.prototype, "isReadOnly", void 0);
form_input_component___decorate([
    Object(core_es5["Input"])(),
    form_input_component___metadata("design:type", String)
], FormInputComponent.prototype, "label", void 0);
form_input_component___decorate([
    Object(core_es5["Input"])(),
    form_input_component___metadata("design:type", String)
], FormInputComponent.prototype, "message", void 0);
form_input_component___decorate([
    Object(core_es5["Input"])(),
    form_input_component___metadata("design:type", Object)
], FormInputComponent.prototype, "required", void 0);
form_input_component___decorate([
    Object(core_es5["ContentChild"])(forms_es5["FormControlName"]),
    form_input_component___metadata("design:type", typeof (form_input_component__a = typeof forms_es5["FormControlName"] !== "undefined" && forms_es5["FormControlName"]) === "function" && form_input_component__a || Object)
], FormInputComponent.prototype, "inputControl", void 0);
form_input_component___decorate([
    Object(core_es5["ContentChildren"])(ValidationMessageComponent),
    form_input_component___metadata("design:type", typeof (form_input_component__b = typeof core_es5["QueryList"] !== "undefined" && core_es5["QueryList"]) === "function" && form_input_component__b || Object)
], FormInputComponent.prototype, "overrideValidationMessages", void 0);
FormInputComponent = form_input_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-form-input',
        template: __webpack_require__("QLMO")
    }),
    form_input_component___metadata("design:paramtypes", [typeof (form_input_component__c = typeof log_service_LogService !== "undefined" && log_service_LogService) === "function" && form_input_component__c || Object])
], FormInputComponent);

var form_input_component__a, form_input_component__b, form_input_component__c;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/form-input.component.js.map
// EXTERNAL MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/node_modules/rxjs/add/operator/onErrorResumeNext.js
var onErrorResumeNext = __webpack_require__("NOvV");
var onErrorResumeNext_default = /*#__PURE__*/__webpack_require__.n(onErrorResumeNext);

// EXTERNAL MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/lookup/lookup.store.ts
var lookup_store = __webpack_require__("roPR");
var lookup_store_default = /*#__PURE__*/__webpack_require__.n(lookup_store);

// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/inline-search/inline-search.component.ts
var inline_search_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var inline_search_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};







var inline_search_component_InlineSearchComponent = (function () {
    function InlineSearchComponent(el, logService) {
        this.el = el;
        this.logService = logService;
        this.results = new core_es5["EventEmitter"]();
        this.blur = new core_es5["EventEmitter"]();
        this.disabled = false;
        this.hasResults = false;
    }
    InlineSearchComponent.prototype.ngOnInit = function () {
        var _this = this;
        var eventStream = Observable["Observable"].fromEvent(this.el.nativeElement, 'keyup')
            .map(function () { return _this.nameSearch; })
            .debounceTime(250)
            .share();
        eventStream.filter(function (text) { return Object(util["b" /* isDefined */])(text) && text.length <= 1; })
            .subscribe(function (_) {
            _this.setResults(Object(immutable["List"])([]));
            _this.hasResults = false;
        });
        eventStream.filter(function (text) { return Object(util["b" /* isDefined */])(text) && text.length > 1; })
            .map(function (query) { return _this.search(query).onErrorResumeNext(); })
            .switch()
            .subscribe(function (results) {
            _this.logService.info("InlineSearchBox: results " + JSON.stringify(results));
            _this.setResults(results);
            _this.hasResults = true;
        }, function (error) {
            _this.logService.error("InlineSearchBox: " + error);
        });
        this.lookupStore.selected.subscribe(function () {
            // Clear the search field and result dropdown upon selecting a lookup.
            _this.resetSearch();
            _this.hasResults = false;
        });
    };
    InlineSearchComponent.prototype.setResults = function (results) {
        this.results.next(results);
    };
    InlineSearchComponent.prototype.onBlur = function () {
        this.blur.next(true);
        this.resetSearch();
        this.hasResults = false;
    };
    InlineSearchComponent.prototype.resetSearch = function () {
        this.nameSearch = '';
        this.setResults(Object(immutable["List"])([]));
    };
    InlineSearchComponent.prototype.search = function (query) {
        var _this = this;
        return this.lookupStore.search(query)
            .catch(function (error) {
            _this.logService.error("InlineSearchBox: " + error);
            _this.setResults([]);
            _this.hasResults = false;
            return Observable["Observable"].throw(error);
        });
    };
    return InlineSearchComponent;
}());
inline_search_component___decorate([
    Object(core_es5["Output"])('results'),
    inline_search_component___metadata("design:type", typeof (inline_search_component__a = typeof core_es5["EventEmitter"] !== "undefined" && core_es5["EventEmitter"]) === "function" && inline_search_component__a || Object)
], inline_search_component_InlineSearchComponent.prototype, "results", void 0);
inline_search_component___decorate([
    Object(core_es5["Output"])('blur'),
    inline_search_component___metadata("design:type", typeof (inline_search_component__b = typeof core_es5["EventEmitter"] !== "undefined" && core_es5["EventEmitter"]) === "function" && inline_search_component__b || Object)
], inline_search_component_InlineSearchComponent.prototype, "blur", void 0);
inline_search_component___decorate([
    Object(core_es5["Input"])('placeholderText'),
    inline_search_component___metadata("design:type", String)
], inline_search_component_InlineSearchComponent.prototype, "placeholderText", void 0);
inline_search_component___decorate([
    Object(core_es5["Input"])('lookupStore'),
    inline_search_component___metadata("design:type", typeof (inline_search_component__c = typeof lookup_store["LookupStore"] !== "undefined" && lookup_store["LookupStore"]) === "function" && inline_search_component__c || Object)
], inline_search_component_InlineSearchComponent.prototype, "lookupStore", void 0);
inline_search_component___decorate([
    Object(core_es5["Input"])('disabled'),
    inline_search_component___metadata("design:type", Object)
], inline_search_component_InlineSearchComponent.prototype, "disabled", void 0);
inline_search_component_InlineSearchComponent = inline_search_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-inline-search-component',
        template: __webpack_require__("1Wrw")
    }),
    inline_search_component___metadata("design:paramtypes", [typeof (inline_search_component__d = typeof core_es5["ElementRef"] !== "undefined" && core_es5["ElementRef"]) === "function" && inline_search_component__d || Object, typeof (inline_search_component__e = typeof log_service_LogService !== "undefined" && log_service_LogService) === "function" && inline_search_component__e || Object])
], inline_search_component_InlineSearchComponent);

var inline_search_component__a, inline_search_component__b, inline_search_component__c, inline_search_component__d, inline_search_component__e;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/inline-search.component.js.map
// EXTERNAL MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/node_modules/ng2-page-scroll/ng2-page-scroll.js + 6 modules
var ng2_page_scroll = __webpack_require__("U89H");

// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/confirmation-modal/confirmation-modal.component.ts
var confirmation_modal_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var confirmation_modal_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};


/*
 * Template Implementation Example
 *
 * <!-- Button to activate modal -->
 * <button type="button" class="btn btn-primary" (click)="confirmBeforeAuthorizingPayment()">Save</button>
 *
 * <!-- Modal component -->
 * <pioneer-confirmation-modal (closed)="confirmHandler($event)"></pioneer-confirmation-modal>
 *
 *
 * Component Implementation Example
 *
 * import { Component, OnInit, ViewChild } from '@angular/core';
 * import { ModalDirective } from 'ngx-bootstrap/modal';
 * import { ConfirmationModalComponent } from '../../shared/confirmation-modal/confirmation-modal.component';
 * @Component({
 *  selector: 'pioneer-example',
 *  templateUrl: './example.component.html'
 * })
 * export class ExampleComponent {
 *   @ViewChild(ConfirmationModalComponent)
 *   public confirmationModal: ConfirmationModalComponent;
 *
 *   public confirmBeforeAuthorizingPayment(): void {
 *     this.confirmationModal.open();
 *   }
 *
 *   public confirmHandler(value) {
 *     if (value) {
 *       this.save();
 *     }
 *   }
 *
 *   public save() {
 *     ...
 *   }
 * }
 */
var confirmation_modal_component_ConfirmationModalComponent = (function () {
    function ConfirmationModalComponent() {
        this.cancel = 'COMMON.BUTTON.DISCARD';
        this.confirm = 'COMMON.BUTTON.CONTINUE';
        this.title = 'MESSAGES.CONFIRMATION.EXIT_TITLE';
        this.content = 'MESSAGES.CONFIRMATION.EXIT_MESSAGE';
        this.confirmClass = 'inherit';
        this.config = {
            backdrop: 'static'
        };
        this.closed = new core_es5["EventEmitter"]();
        this.action = true;
        this.customModal = false;
        this.customContent = false;
    }
    Object.defineProperty(ConfirmationModalComponent.prototype, "isShown", {
        get: function () { return this.confirmationModal.isShown; },
        enumerable: true,
        configurable: true
    });
    ConfirmationModalComponent.prototype.ngOnInit = function () {
    };
    ConfirmationModalComponent.prototype.open = function () {
        this.confirmationModal.show();
    };
    /**
     * Closes the confirmation modal upon accept or cancel.
     * @deprecated Use `onAccept` or `onCancel` instead.
     * @param value - The value indicating whether the action is accepted or cancelled.
     */
    ConfirmationModalComponent.prototype.close = function (value) {
        if (value) {
            this.onAccept();
        }
        else {
            this.onCancel();
        }
    };
    ConfirmationModalComponent.prototype.onAccept = function () {
        this.closed.emit(this.action);
        this.confirmationModal.hide();
    };
    ConfirmationModalComponent.prototype.onCancel = function () {
        this.closed.emit(false);
        this.confirmationModal.hide();
    };
    return ConfirmationModalComponent;
}());
confirmation_modal_component___decorate([
    Object(core_es5["Input"])(),
    confirmation_modal_component___metadata("design:type", Object)
], confirmation_modal_component_ConfirmationModalComponent.prototype, "cancel", void 0);
confirmation_modal_component___decorate([
    Object(core_es5["Input"])(),
    confirmation_modal_component___metadata("design:type", Object)
], confirmation_modal_component_ConfirmationModalComponent.prototype, "confirm", void 0);
confirmation_modal_component___decorate([
    Object(core_es5["Input"])(),
    confirmation_modal_component___metadata("design:type", Object)
], confirmation_modal_component_ConfirmationModalComponent.prototype, "title", void 0);
confirmation_modal_component___decorate([
    Object(core_es5["Input"])(),
    confirmation_modal_component___metadata("design:type", Object)
], confirmation_modal_component_ConfirmationModalComponent.prototype, "content", void 0);
confirmation_modal_component___decorate([
    Object(core_es5["Input"])(),
    confirmation_modal_component___metadata("design:type", Object)
], confirmation_modal_component_ConfirmationModalComponent.prototype, "confirmClass", void 0);
confirmation_modal_component___decorate([
    Object(core_es5["Input"])(),
    confirmation_modal_component___metadata("design:type", Object)
], confirmation_modal_component_ConfirmationModalComponent.prototype, "config", void 0);
confirmation_modal_component___decorate([
    Object(core_es5["Output"])(),
    confirmation_modal_component___metadata("design:type", Object)
], confirmation_modal_component_ConfirmationModalComponent.prototype, "closed", void 0);
confirmation_modal_component___decorate([
    Object(core_es5["ViewChild"])(modal["b" /* ModalDirective */]),
    confirmation_modal_component___metadata("design:type", typeof (confirmation_modal_component__a = typeof modal["b" /* ModalDirective */] !== "undefined" && modal["b" /* ModalDirective */]) === "function" && confirmation_modal_component__a || Object)
], confirmation_modal_component_ConfirmationModalComponent.prototype, "confirmationModal", void 0);
confirmation_modal_component___decorate([
    Object(core_es5["Input"])(),
    confirmation_modal_component___metadata("design:type", Object)
], confirmation_modal_component_ConfirmationModalComponent.prototype, "action", void 0);
confirmation_modal_component___decorate([
    Object(core_es5["Input"])(),
    confirmation_modal_component___metadata("design:type", Object)
], confirmation_modal_component_ConfirmationModalComponent.prototype, "customModal", void 0);
confirmation_modal_component___decorate([
    Object(core_es5["Input"])(),
    confirmation_modal_component___metadata("design:type", Object)
], confirmation_modal_component_ConfirmationModalComponent.prototype, "customContent", void 0);
confirmation_modal_component_ConfirmationModalComponent = confirmation_modal_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-confirmation-modal',
        template: __webpack_require__("Zu/a"),
        styles: [__webpack_require__("epPf")]
    }),
    confirmation_modal_component___metadata("design:paramtypes", [])
], confirmation_modal_component_ConfirmationModalComponent);

var confirmation_modal_component__a;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/confirmation-modal.component.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/event-collision-match.ts
var event_collision_match___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var EventCollisionMatchRecord = Object(immutable["Record"])({
    createdBy: null,
    clientCompany: null,
    eventName: null,
    groupCode: null,
    startDate: null,
    endDate: null,
    property: null,
    eventMatchId: null
});
var EventCollisionMatch = (function (_super) {
    event_collision_match___extends(EventCollisionMatch, _super);
    function EventCollisionMatch() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return EventCollisionMatch;
}(EventCollisionMatchRecord));

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/event-collision-match.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/event-collision-modal/event-collision-modal-response.ts
var event_collision_modal_response___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var EventCollisionModalResponseRecord = Object(immutable["Record"])({
    selectedButton: null,
    selectedMatches: null,
});
var EventCollisionModalResponse = (function (_super) {
    event_collision_modal_response___extends(EventCollisionModalResponse, _super);
    function EventCollisionModalResponse() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return EventCollisionModalResponse;
}(EventCollisionModalResponseRecord));

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/event-collision-modal-response.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/event-collision-modal/event-collision-modal-response.enum.ts
var EventCollisionModalResponseEnum;
(function (EventCollisionModalResponseEnum) {
    EventCollisionModalResponseEnum[EventCollisionModalResponseEnum["MergeEvents"] = 0] = "MergeEvents";
    EventCollisionModalResponseEnum[EventCollisionModalResponseEnum["DoNotMergeEvents"] = 1] = "DoNotMergeEvents";
})(EventCollisionModalResponseEnum || (EventCollisionModalResponseEnum = {}));
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/event-collision-modal-response.enum.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/event-collision-modal/event-collision-modal.component.ts
var event_collision_modal_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var event_collision_modal_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};







var event_collision_modal_component_EventCollisionModalComponent = (function () {
    function EventCollisionModalComponent(authenticationStore) {
        this.authenticationStore = authenticationStore;
        this.EventCollisionModalResponse = EventCollisionModalResponse;
        this.create = 'EVENT_COLLISION.MODAL.SINGLE.CREATE';
        this.confirm = 'EVENT_COLLISION.MODAL.SINGLE.CONFIRM';
        this.notConfirm = 'EVENT_COLLISION.MODAL.SINGLE.NOT_CONFIRM';
        this.cancel = 'EVENT_COLLISION.MODAL.SINGLE.CANCEL';
        this.title = 'EVENT_COLLISION.MODAL.SINGLE.TITLE';
        this.content = 'EVENT_COLLISION.MODAL.SINGLE.INSTRUCTION_TEXT';
        this.contentFinal = 'EVENT_COLLISION.MODAL.SINGLE.INSTRUCTION_FINAL_TEXT';
        this.contentFinalAddVendor = 'EVENT_COLLISION.MODAL.SINGLE.INSTRUCTION_FINAL_TEXT_NOT_CONFIRM';
        this.heading = 'EVENT_COLLISION.MODAL.SINGLE.HEADING';
        this.headingDetails = 'EVENT_COLLISION.MODAL.SINGLE.HEADING_DETAILS';
        this.match = {};
        this.config = {
            backdrop: 'static'
        };
        this.closed = new core_es5["EventEmitter"]();
        this.canceled = new core_es5["EventEmitter"]();
    }
    EventCollisionModalComponent.prototype.ngOnInit = function () {
    };
    Object.defineProperty(EventCollisionModalComponent.prototype, "isPropertyUser", {
        get: function () {
            return this.authenticationStore.isPropertyUser();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EventCollisionModalComponent.prototype, "isShown", {
        get: function () { return this.confirmationModal.isShown; },
        enumerable: true,
        configurable: true
    });
    EventCollisionModalComponent.prototype.open = function (eventMatch, match) {
        this.response = undefined;
        this.eventMatch = eventMatch;
        this.match = match;
        this.confirmationModal.show();
    };
    EventCollisionModalComponent.prototype.confirmMatchingEvent = function () {
        var selectedMatches = [];
        selectedMatches.push(this.eventMatch.eventMatchId);
        this.response = new EventCollisionModalResponse({
            selectedButton: EventCollisionModalResponseEnum.MergeEvents,
            selectedMatches: selectedMatches
        });
        this.confirmationModal.hide();
    };
    EventCollisionModalComponent.prototype.createNewEvent = function () {
        this.response = new EventCollisionModalResponse({
            selectedButton: EventCollisionModalResponseEnum.DoNotMergeEvents,
            selectedMatches: []
        });
        this.confirmationModal.hide();
    };
    EventCollisionModalComponent.prototype.cancelEventMatching = function () {
        this.response = new EventCollisionModalResponse({
            selectedButton: undefined,
            selectedMatches: []
        });
        this.confirmationModal.hide();
    };
    EventCollisionModalComponent.prototype.completePropertyForEventMatched = function () {
        return this.match.property_name + ' ' + this.match.property_address;
    };
    EventCollisionModalComponent.prototype.onHide = function () {
        if (this.response.selectedButton === undefined) {
            this.canceled.emit(this.response);
        }
        else {
            this.closed.emit(this.response);
        }
    };
    return EventCollisionModalComponent;
}());
event_collision_modal_component___decorate([
    Object(core_es5["Input"])(),
    event_collision_modal_component___metadata("design:type", Object)
], event_collision_modal_component_EventCollisionModalComponent.prototype, "create", void 0);
event_collision_modal_component___decorate([
    Object(core_es5["Input"])(),
    event_collision_modal_component___metadata("design:type", Object)
], event_collision_modal_component_EventCollisionModalComponent.prototype, "confirm", void 0);
event_collision_modal_component___decorate([
    Object(core_es5["Input"])(),
    event_collision_modal_component___metadata("design:type", Object)
], event_collision_modal_component_EventCollisionModalComponent.prototype, "notConfirm", void 0);
event_collision_modal_component___decorate([
    Object(core_es5["Input"])(),
    event_collision_modal_component___metadata("design:type", Object)
], event_collision_modal_component_EventCollisionModalComponent.prototype, "cancel", void 0);
event_collision_modal_component___decorate([
    Object(core_es5["Input"])(),
    event_collision_modal_component___metadata("design:type", Object)
], event_collision_modal_component_EventCollisionModalComponent.prototype, "title", void 0);
event_collision_modal_component___decorate([
    Object(core_es5["Input"])(),
    event_collision_modal_component___metadata("design:type", Object)
], event_collision_modal_component_EventCollisionModalComponent.prototype, "content", void 0);
event_collision_modal_component___decorate([
    Object(core_es5["Input"])(),
    event_collision_modal_component___metadata("design:type", Object)
], event_collision_modal_component_EventCollisionModalComponent.prototype, "contentFinal", void 0);
event_collision_modal_component___decorate([
    Object(core_es5["Input"])(),
    event_collision_modal_component___metadata("design:type", Object)
], event_collision_modal_component_EventCollisionModalComponent.prototype, "contentFinalAddVendor", void 0);
event_collision_modal_component___decorate([
    Object(core_es5["Input"])(),
    event_collision_modal_component___metadata("design:type", Object)
], event_collision_modal_component_EventCollisionModalComponent.prototype, "heading", void 0);
event_collision_modal_component___decorate([
    Object(core_es5["Input"])(),
    event_collision_modal_component___metadata("design:type", Object)
], event_collision_modal_component_EventCollisionModalComponent.prototype, "headingDetails", void 0);
event_collision_modal_component___decorate([
    Object(core_es5["Input"])(),
    event_collision_modal_component___metadata("design:type", typeof (event_collision_modal_component__a = typeof EventCollisionMatch !== "undefined" && EventCollisionMatch) === "function" && event_collision_modal_component__a || Object)
], event_collision_modal_component_EventCollisionModalComponent.prototype, "eventMatch", void 0);
event_collision_modal_component___decorate([
    Object(core_es5["Input"])(),
    event_collision_modal_component___metadata("design:type", Object)
], event_collision_modal_component_EventCollisionModalComponent.prototype, "match", void 0);
event_collision_modal_component___decorate([
    Object(core_es5["Input"])(),
    event_collision_modal_component___metadata("design:type", Object)
], event_collision_modal_component_EventCollisionModalComponent.prototype, "config", void 0);
event_collision_modal_component___decorate([
    Object(core_es5["Input"])(),
    event_collision_modal_component___metadata("design:type", typeof (event_collision_modal_component__b = typeof User !== "undefined" && User) === "function" && event_collision_modal_component__b || Object)
], event_collision_modal_component_EventCollisionModalComponent.prototype, "user", void 0);
event_collision_modal_component___decorate([
    Object(core_es5["Input"])(),
    event_collision_modal_component___metadata("design:type", String)
], event_collision_modal_component_EventCollisionModalComponent.prototype, "mode", void 0);
event_collision_modal_component___decorate([
    Object(core_es5["Output"])(),
    event_collision_modal_component___metadata("design:type", Object)
], event_collision_modal_component_EventCollisionModalComponent.prototype, "closed", void 0);
event_collision_modal_component___decorate([
    Object(core_es5["Output"])(),
    event_collision_modal_component___metadata("design:type", Object)
], event_collision_modal_component_EventCollisionModalComponent.prototype, "canceled", void 0);
event_collision_modal_component___decorate([
    Object(core_es5["ViewChild"])(modal["b" /* ModalDirective */]),
    event_collision_modal_component___metadata("design:type", typeof (event_collision_modal_component__c = typeof modal["b" /* ModalDirective */] !== "undefined" && modal["b" /* ModalDirective */]) === "function" && event_collision_modal_component__c || Object)
], event_collision_modal_component_EventCollisionModalComponent.prototype, "confirmationModal", void 0);
event_collision_modal_component_EventCollisionModalComponent = event_collision_modal_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-event-collision-modal',
        template: __webpack_require__("M8zK"),
        styles: [__webpack_require__("dPvB")]
    }),
    event_collision_modal_component___metadata("design:paramtypes", [typeof (event_collision_modal_component__d = typeof authentication_store_AuthenticationStore !== "undefined" && authentication_store_AuthenticationStore) === "function" && event_collision_modal_component__d || Object])
], event_collision_modal_component_EventCollisionModalComponent);

var event_collision_modal_component__a, event_collision_modal_component__b, event_collision_modal_component__c, event_collision_modal_component__d;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/event-collision-modal.component.js.map
// EXTERNAL MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/node_modules/ngx-bootstrap/pagination/index.js
var pagination = __webpack_require__("6hm2");

// EXTERNAL MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/node_modules/rxjs/add/observable/combineLatest.js
var combineLatest = __webpack_require__("vJ3t");
var combineLatest_default = /*#__PURE__*/__webpack_require__.n(combineLatest);

// EXTERNAL MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/node_modules/rxjs/add/observable/from.js
var from = __webpack_require__("XL2q");
var from_default = /*#__PURE__*/__webpack_require__.n(from);

// EXTERNAL MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/node_modules/rxjs/add/observable/fromEvent.js
var fromEvent = __webpack_require__("Xtvq");
var fromEvent_default = /*#__PURE__*/__webpack_require__.n(fromEvent);

// EXTERNAL MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/node_modules/rxjs/add/observable/interval.js
var interval = __webpack_require__("ACG2");
var interval_default = /*#__PURE__*/__webpack_require__.n(interval);

// EXTERNAL MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/node_modules/rxjs/add/observable/throw.js
var observable_throw = __webpack_require__("S7im");
var throw_default = /*#__PURE__*/__webpack_require__.n(observable_throw);

// EXTERNAL MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/node_modules/rxjs/add/observable/never.js
var never = __webpack_require__("dyFf");
var never_default = /*#__PURE__*/__webpack_require__.n(never);

// EXTERNAL MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/node_modules/rxjs/add/observable/empty.js
var empty = __webpack_require__("hbO+");
var empty_default = /*#__PURE__*/__webpack_require__.n(empty);

// EXTERNAL MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/node_modules/rxjs/add/operator/catch.js
var operator_catch = __webpack_require__("xpf9");
var catch_default = /*#__PURE__*/__webpack_require__.n(operator_catch);

// EXTERNAL MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/node_modules/rxjs/add/operator/concat.js
var concat = __webpack_require__("R0J0");
var concat_default = /*#__PURE__*/__webpack_require__.n(concat);

// EXTERNAL MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/node_modules/rxjs/add/operator/debounceTime.js
var debounceTime = __webpack_require__("azLz");
var debounceTime_default = /*#__PURE__*/__webpack_require__.n(debounceTime);

// EXTERNAL MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/node_modules/rxjs/add/operator/delay.js
var delay = __webpack_require__("l3Q+");
var delay_default = /*#__PURE__*/__webpack_require__.n(delay);

// EXTERNAL MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/node_modules/rxjs/add/operator/filter.js
var operator_filter = __webpack_require__("gbhw");
var filter_default = /*#__PURE__*/__webpack_require__.n(operator_filter);

// EXTERNAL MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/node_modules/rxjs/add/operator/finally.js
var operator_finally = __webpack_require__("zc4d");
var finally_default = /*#__PURE__*/__webpack_require__.n(operator_finally);

// EXTERNAL MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/node_modules/rxjs/add/operator/first.js
var first = __webpack_require__("ZQKz");
var first_default = /*#__PURE__*/__webpack_require__.n(first);

// EXTERNAL MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/node_modules/rxjs/add/operator/map.js
var operator_map = __webpack_require__("5v8a");
var operator_map_default = /*#__PURE__*/__webpack_require__.n(operator_map);

// EXTERNAL MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/node_modules/rxjs/add/operator/share.js
var share = __webpack_require__("qm+V");
var share_default = /*#__PURE__*/__webpack_require__.n(share);

// EXTERNAL MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/node_modules/rxjs/add/operator/switch.js
var operator_switch = __webpack_require__("mvrJ");
var switch_default = /*#__PURE__*/__webpack_require__.n(operator_switch);

// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/version/service/version.http.service.ts
var version_http_service___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var version_http_service___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};




var VersionHttpService = (function () {
    function VersionHttpService(http, environment, responseUtilService) {
        this.http = http;
        this.environment = environment;
        this.responseUtilService = responseUtilService;
        this.pulse = this.environment.baseUrl + '/pulse';
    }
    VersionHttpService.prototype.getFrontendVersion = function () {
        var _this = this;
        return this.http.get('/assets/version.json')
            .catch(function (response) { return _this.responseUtilService.handleError(response); }).share();
    };
    VersionHttpService.prototype.getBackendVersion = function () {
        var _this = this;
        return this.http.get(this.pulse)
            .catch(function (response) { return _this.responseUtilService.handleError(response); }).share();
    };
    return VersionHttpService;
}());
VersionHttpService = version_http_service___decorate([
    Object(core_es5["Injectable"])(),
    version_http_service___metadata("design:paramtypes", [typeof (version_http_service__a = typeof common_http_es5["b" /* HttpClient */] !== "undefined" && common_http_es5["b" /* HttpClient */]) === "function" && version_http_service__a || Object, typeof (version_http_service__b = typeof EnvironmentConfiguration !== "undefined" && EnvironmentConfiguration) === "function" && version_http_service__b || Object, typeof (version_http_service__c = typeof response_util_service_ResponseUtilService !== "undefined" && response_util_service_ResponseUtilService) === "function" && version_http_service__c || Object])
], VersionHttpService);

var version_http_service__a, version_http_service__b, version_http_service__c;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/version.http.service.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/version/service/version.store.ts
var version_store___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var version_store___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};




var version_store_VersionStore = (function () {
    function VersionStore(versionHttp, logService) {
        this.versionHttp = versionHttp;
        this.logService = logService;
        this.currentFrontendVersion = new Subject["Subject"]();
        this.currentBackendVersion = new Subject["Subject"]();
    }
    VersionStore.prototype.getFrontendVersion = function () {
        var _this = this;
        this.versionHttp.getFrontendVersion().subscribe(function (versionObj) {
            _this.logService.verbose("VersionStore versionObj: " + JSON.stringify(versionObj));
            _this.currentFrontendVersion.next(versionObj);
        });
        return this.currentFrontendVersion.asObservable();
    };
    VersionStore.prototype.getBackendVersion = function () {
        var _this = this;
        this.versionHttp.getBackendVersion().subscribe(function (versionObj) {
            _this.logService.verbose("VersionStore versionObj: " + JSON.stringify(versionObj));
            _this.currentBackendVersion.next(versionObj);
        });
        return this.currentBackendVersion.asObservable();
    };
    return VersionStore;
}());
version_store_VersionStore = version_store___decorate([
    Object(core_es5["Injectable"])(),
    version_store___metadata("design:paramtypes", [typeof (version_store__a = typeof VersionHttpService !== "undefined" && VersionHttpService) === "function" && version_store__a || Object, typeof (version_store__b = typeof log_service_LogService !== "undefined" && log_service_LogService) === "function" && version_store__b || Object])
], version_store_VersionStore);

var version_store__a, version_store__b;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/version.store.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/version/version.component.ts
var version_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var version_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};



var VersionComponent = (function () {
    function VersionComponent(versionStore, logService) {
        this.versionStore = versionStore;
        this.logService = logService;
        this.frontendVersionObj = {};
        this.backendVersionObj = {};
    }
    VersionComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.versionStore.getFrontendVersion().subscribe(function (versionObj) {
            _this.frontendVersionObj = versionObj;
        });
        this.versionStore.getBackendVersion().subscribe(function (versionObj) {
            _this.backendVersionObj = versionObj;
        });
    };
    return VersionComponent;
}());
VersionComponent = version_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-version',
        template: __webpack_require__("xhPN")
    }),
    version_component___metadata("design:paramtypes", [typeof (version_component__a = typeof version_store_VersionStore !== "undefined" && version_store_VersionStore) === "function" && version_component__a || Object, typeof (version_component__b = typeof log_service_LogService !== "undefined" && log_service_LogService) === "function" && version_component__b || Object])
], VersionComponent);

var version_component__a, version_component__b;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/version.component.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/permission/services/angular2-jwt.config.ts




function authFactory(http, options, userLocalStorageService) {
    return new angular2_jwt["AuthHttp"](new angular2_jwt["AuthConfig"]({
        // Config options if you want
        noTokenScheme: true,
        tokenName: authentication_store_AuthenticationStore.TOKEN_NAME,
        tokenGetter: function () { return userLocalStorageService.getToken(); },
        noJwtError: true,
        noClientCheck: true,
        globalHeaders: [
            { 'Cache-Control': 'no-cache, no-store, must-revalidate' },
            { 'Pragma': 'no-cache' },
            { 'Expires': 'Thu, 01 Jan 1970 00:00:00 GMT' },
            { 'If-Modified-Since': '0' }
        ],
    }), http, options);
}
// Include this in your ngModule providers
var authProvider = {
    provide: angular2_jwt["AuthHttp"],
    deps: [http_es5["Http"], http_es5["RequestOptions"], user_local_storage_service_UserLocalStorageService],
    useFactory: authFactory
};
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/angular2-jwt.config.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/permission/models/authorize.model.ts
var AuthorizationModel = (function () {
    function AuthorizationModel() {
    }
    return AuthorizationModel;
}());

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/authorize.model.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/permission/directive/authorization-directive.ts
var authorization_directive___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var authorization_directive___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};





/**
 *
 @example <caption>Example usage of AuthorizeDirective.</caption>
 * <div *pioneerAuthorize="{permission: 'AddEvent'}"></div>
 * and
 * <div *pioneerAuthorize="{permissions: ['AddEvent', 'EditEvent']}"></div>
 */
var AuthorizeDirective = (function () {
    function AuthorizeDirective(viewContainer, template, authStore, translateService, logService) {
        this.viewContainer = viewContainer;
        this.template = template;
        this.authStore = authStore;
        this.translateService = translateService;
        this.logService = logService;
    }
    Object.defineProperty(AuthorizeDirective.prototype, "authorize", {
        set: function (authorizationModel) {
            // this.logService.info('authorize - authorizationModel: ' + JSON.stringify(authorizationModel));
            if (this.authStore.hasPermission(this.getPermissions(authorizationModel))) {
                this.logService.verbose('show me');
                this.viewContainer.createEmbeddedView(this.template);
            }
            else {
                this.logService.verbose('hide me');
                this.viewContainer.clear();
            }
        },
        enumerable: true,
        configurable: true
    });
    AuthorizeDirective.prototype.getPermissions = function (authorizationModel) {
        if (authorizationModel.permission) {
            return Array.of(authorizationModel.permission.toLowerCase());
        }
        else if (authorizationModel.permissions) {
            return authorizationModel.permissions.map(function (perm) { return perm.toLowerCase(); });
        }
        else {
            throw new Error(this.translateService.instant('MESSAGES.ERROR.INVALID_AUTHORIZE_FORMAT'));
        }
    };
    return AuthorizeDirective;
}());
authorization_directive___decorate([
    Object(core_es5["Input"])('pioneerAuthorize'),
    authorization_directive___metadata("design:type", typeof (authorization_directive__a = typeof AuthorizationModel !== "undefined" && AuthorizationModel) === "function" && authorization_directive__a || Object),
    authorization_directive___metadata("design:paramtypes", [typeof (authorization_directive__b = typeof AuthorizationModel !== "undefined" && AuthorizationModel) === "function" && authorization_directive__b || Object])
], AuthorizeDirective.prototype, "authorize", null);
AuthorizeDirective = authorization_directive___decorate([
    Object(core_es5["Directive"])({
        selector: '[pioneerAuthorize]'
    }),
    authorization_directive___metadata("design:paramtypes", [typeof (authorization_directive__c = typeof core_es5["ViewContainerRef"] !== "undefined" && core_es5["ViewContainerRef"]) === "function" && authorization_directive__c || Object, typeof (authorization_directive__d = typeof core_es5["TemplateRef"] !== "undefined" && core_es5["TemplateRef"]) === "function" && authorization_directive__d || Object, typeof (authorization_directive__e = typeof authentication_store_AuthenticationStore !== "undefined" && authentication_store_AuthenticationStore) === "function" && authorization_directive__e || Object, typeof (authorization_directive__f = typeof core["c" /* TranslateService */] !== "undefined" && core["c" /* TranslateService */]) === "function" && authorization_directive__f || Object, typeof (authorization_directive__g = typeof log_service_LogService !== "undefined" && log_service_LogService) === "function" && authorization_directive__g || Object])
], AuthorizeDirective);

var authorization_directive__a, authorization_directive__b, authorization_directive__c, authorization_directive__d, authorization_directive__e, authorization_directive__f, authorization_directive__g;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/authorization-directive.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/permission/directive/authorization-commission-directive.ts
var authorization_commission_directive___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var authorization_commission_directive___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};





/**
 *
 @example <caption>Example usage of AuthorizeCommissionDirective.</caption>
 * <div *pioneerAuthorizeCommission="{permission: 'AddEvent'}"></div>
 * and
 * <div *pioneerAuthorizeCommission="{permissions: ['AddEvent', 'EditEvent']}"></div>
 */
var AuthorizeCommissionDirective = (function () {
    function AuthorizeCommissionDirective(viewContainer, template, authStore, translateService, logService) {
        this.viewContainer = viewContainer;
        this.template = template;
        this.authStore = authStore;
        this.translateService = translateService;
        this.logService = logService;
    }
    Object.defineProperty(AuthorizeCommissionDirective.prototype, "authorizeCommission", {
        set: function (authorizationModel) {
            // this.logService.info('authorize - authorizationModel: ' + JSON.stringify(authorizationModel));
            if (this.authStore.hasPermissionCommission(this.getPermissions(authorizationModel))) {
                this.logService.verbose('show me');
                this.viewContainer.createEmbeddedView(this.template);
            }
            else {
                this.logService.verbose('hide me');
                this.viewContainer.clear();
            }
        },
        enumerable: true,
        configurable: true
    });
    AuthorizeCommissionDirective.prototype.getPermissions = function (authorizationModel) {
        if (authorizationModel.permission) {
            return Array.of(authorizationModel.permission.toLowerCase());
        }
        else if (authorizationModel.permissions) {
            return authorizationModel.permissions.map(function (perm) { return perm.toLowerCase(); });
        }
        else {
            throw new Error(this.translateService.instant('MESSAGES.ERROR.INVALID_AUTHORIZE_FORMAT'));
        }
    };
    return AuthorizeCommissionDirective;
}());
authorization_commission_directive___decorate([
    Object(core_es5["Input"])('pioneerAuthorizeCommission'),
    authorization_commission_directive___metadata("design:type", typeof (authorization_commission_directive__a = typeof AuthorizationModel !== "undefined" && AuthorizationModel) === "function" && authorization_commission_directive__a || Object),
    authorization_commission_directive___metadata("design:paramtypes", [typeof (authorization_commission_directive__b = typeof AuthorizationModel !== "undefined" && AuthorizationModel) === "function" && authorization_commission_directive__b || Object])
], AuthorizeCommissionDirective.prototype, "authorizeCommission", null);
AuthorizeCommissionDirective = authorization_commission_directive___decorate([
    Object(core_es5["Directive"])({
        selector: '[pioneerAuthorizeCommission]'
    }),
    authorization_commission_directive___metadata("design:paramtypes", [typeof (authorization_commission_directive__c = typeof core_es5["ViewContainerRef"] !== "undefined" && core_es5["ViewContainerRef"]) === "function" && authorization_commission_directive__c || Object, typeof (authorization_commission_directive__d = typeof core_es5["TemplateRef"] !== "undefined" && core_es5["TemplateRef"]) === "function" && authorization_commission_directive__d || Object, typeof (authorization_commission_directive__e = typeof authentication_store_AuthenticationStore !== "undefined" && authentication_store_AuthenticationStore) === "function" && authorization_commission_directive__e || Object, typeof (authorization_commission_directive__f = typeof core["c" /* TranslateService */] !== "undefined" && core["c" /* TranslateService */]) === "function" && authorization_commission_directive__f || Object, typeof (authorization_commission_directive__g = typeof log_service_LogService !== "undefined" && log_service_LogService) === "function" && authorization_commission_directive__g || Object])
], AuthorizeCommissionDirective);

var authorization_commission_directive__a, authorization_commission_directive__b, authorization_commission_directive__c, authorization_commission_directive__d, authorization_commission_directive__e, authorization_commission_directive__f, authorization_commission_directive__g;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/authorization-commission-directive.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/permission/permission.module.ts
var permission_module___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};









var PermissionModule = (function () {
    function PermissionModule() {
    }
    return PermissionModule;
}());
PermissionModule = permission_module___decorate([
    Object(core_es5["NgModule"])({
        imports: [
            common_es5["CommonModule"]
        ],
        declarations: [
            AuthorizeDirective,
            AuthorizeCommissionDirective
        ],
        providers: [
            log_service_LogService,
            console_log_subscriber_service_ConsoleLogSubscriberService,
            http_log_subscriber_service_HttpLogSubscriberService,
            user_local_storage_service_UserLocalStorageService,
            authProvider
        ],
        exports: [
            AuthorizeDirective,
            AuthorizeCommissionDirective
        ]
    })
], PermissionModule);

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/permission.module.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/reservation-status-code.enum.ts
/**
 * GroupPay status codes
 * https://onyxpayments.atlassian.net/wiki/display/PION/GroupPay+Status+Codes
 */
/**
 * GroupPay status codes
 * https://onyxpayments.atlassian.net/wiki/display/PION/GroupPay+Status+Codes
 */ var ReservationStatusCode;
(function (ReservationStatusCode) {
    ReservationStatusCode[ReservationStatusCode["RESERVED"] = 'R'] = "RESERVED";
    ReservationStatusCode[ReservationStatusCode["CHECKED_IN"] = 'I'] = "CHECKED_IN";
    ReservationStatusCode[ReservationStatusCode["CHECKED_OUT"] = 'O'] = "CHECKED_OUT";
    ReservationStatusCode[ReservationStatusCode["CANCELLED"] = 'C'] = "CANCELLED";
    ReservationStatusCode[ReservationStatusCode["NO_SHOW"] = 'N'] = "NO_SHOW";
})(ReservationStatusCode || (ReservationStatusCode = {}));
var STATUS_CODE_RSVP = 'RSVP';
var OVERVIEW_STATUS_CODES = [
    ReservationStatusCode.RESERVED,
    ReservationStatusCode.CHECKED_OUT,
    ReservationStatusCode.CHECKED_IN
];
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/reservation-status-code.enum.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/pipes/reservation-status.pipe.ts
var reservation_status_pipe___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var reservation_status_pipe___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};



var reservation_status_pipe_ReservationStatusPipe = (function () {
    function ReservationStatusPipe(translateService) {
        this.translateService = translateService;
    }
    ReservationStatusPipe.prototype.transform = function (value, args) {
        value = value.toUpperCase().toString();
        var returnValue = '';
        switch (value) {
            case 'rsvp':
                returnValue = this.translateService.instant('RESERVATION_STATUS.READY');
                break;
            case ReservationStatusCode.CANCELLED.toString():
                returnValue = this.translateService.instant('RESERVATION_STATUS.CANCELLED');
                break;
            case ReservationStatusCode.CHECKED_IN.toString():
                returnValue = this.translateService.instant('RESERVATION_STATUS.CHECKED_IN');
                break;
            case ReservationStatusCode.CHECKED_OUT.toString():
                returnValue = this.translateService.instant('RESERVATION_STATUS.CHECKED_OUT');
                break;
            case ReservationStatusCode.NO_SHOW.toString():
                returnValue = this.translateService.instant('RESERVATION_STATUS.NO_SHOW');
                break;
            case ReservationStatusCode.RESERVED.toString():
                returnValue = this.translateService.instant('RESERVATION_STATUS.RESERVED');
                break;
            default:
                returnValue = this.translateService.instant('RESERVATION_STATUS.UNKNOWN', { key: value });
        }
        return returnValue;
    };
    return ReservationStatusPipe;
}());
reservation_status_pipe_ReservationStatusPipe = reservation_status_pipe___decorate([
    Object(core_es5["Pipe"])({
        name: 'reservationStatus'
    }),
    reservation_status_pipe___metadata("design:paramtypes", [typeof (reservation_status_pipe__a = typeof core["c" /* TranslateService */] !== "undefined" && core["c" /* TranslateService */]) === "function" && reservation_status_pipe__a || Object])
], reservation_status_pipe_ReservationStatusPipe);

var reservation_status_pipe__a;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/reservation-status.pipe.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/pipes/payment-status.pipe.ts
var payment_status_pipe___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var payment_status_pipe___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};



var PaymentStatusPipe = (function () {
    function PaymentStatusPipe(translateService, logService) {
        this.translateService = translateService;
        this.logService = logService;
    }
    PaymentStatusPipe.prototype.transform = function (value, args) {
        // Pipes need to handle nulls/undefined
        if (!value) {
            value = '';
        }
        value = value.toLowerCase().toString();
        var returnValue = '';
        switch (value) {
            case 'ready':
                returnValue = this.translateService.instant('PAYMENT_STATUS.READY');
                break;
            case 'pending':
                returnValue = this.translateService.instant('PAYMENT_STATUS.PENDING');
                break;
            case 'invoiced':
                returnValue = this.translateService.instant('PAYMENT_STATUS.INVOICED');
                break;
            case 'invoice-rejected':
                returnValue = this.translateService.instant('PAYMENT_STATUS.INVOICE_REJECTED');
                break;
            case 'funded':
                returnValue = this.translateService.instant('PAYMENT_STATUS.FUNDED');
                break;
            case 'pay-sent':
                returnValue = this.translateService.instant('PAYMENT_STATUS.PAY_SENT');
                break;
            case 'pay-rejected':
                returnValue = this.translateService.instant('PAYMENT_STATUS.PAY_REJECTED');
                break;
            case 'requested':
                returnValue = this.translateService.instant('PAYMENT_STATUS.REQUESTED');
                break;
            case 'request-rejected':
                returnValue = this.translateService.instant('PAYMENT_STATUS.REQUEST_REJECTED');
                break;
            case 'resent-request':
                returnValue = this.translateService.instant('PAYMENT_STATUS.RESENT_REQUEST');
                break;
            case 'paid-direct':
                returnValue = this.translateService.instant('PAYMENT_STATUS.PAID_DIRECT');
                break;
            case 'cancelled':
                returnValue = this.translateService.instant('PAYMENT_STATUS.CANCELLED');
                break;
            case 'paid':
                returnValue = this.translateService.instant('PAYMENT_STATUS.PAID');
                break;
            case 'unpaid':
                returnValue = this.translateService.instant('PAYMENT_STATUS.UNPAID');
                break;
            case 'partial':
                returnValue = this.translateService.instant('PAYMENT_STATUS.PARTIAL');
                break;
            case 'error':
                returnValue = this.translateService.instant('PAYMENT_STATUS.ERROR');
                break;
            case 'ready-to-initiate':
                returnValue = this.translateService.instant('PAYMENT_STATUS.READY_TO_INITIATE');
                break;
            case 'check-stopped':
                returnValue = this.translateService.instant('PAYMENT_STATUS.CHECK_STOPPED');
                break;
            case 'pay-cleared':
                returnValue = this.translateService.instant('PAYMENT_STATUS.PAY_CLEARED');
                break;
            case 'pay-reissued':
                returnValue = this.translateService.instant('PAYMENT_STATUS.PAY_REISSUED');
                break;
            case 'pending-wf-approval':
                returnValue = this.translateService.instant('PAYMENT_STATUS.PENDING_APPROVAL');
                break;
            case 'wf-rejected':
                returnValue = this.translateService.instant('PAYMENT_STATUS.REJECTED_APPROVAL');
                break;
            default:
                this.logService.info(this.translateService.instant('PAYMENT_STATUS.UNKNOWN', { key: value }));
        }
        return returnValue;
    };
    return PaymentStatusPipe;
}());
PaymentStatusPipe = payment_status_pipe___decorate([
    Object(core_es5["Pipe"])({
        name: 'paymentStatus'
    }),
    payment_status_pipe___metadata("design:paramtypes", [typeof (payment_status_pipe__a = typeof core["c" /* TranslateService */] !== "undefined" && core["c" /* TranslateService */]) === "function" && payment_status_pipe__a || Object, typeof (payment_status_pipe__b = typeof log_service_LogService !== "undefined" && log_service_LogService) === "function" && payment_status_pipe__b || Object])
], PaymentStatusPipe);

var payment_status_pipe__a, payment_status_pipe__b;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/payment-status.pipe.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/environment/environment.module.ts
var environment_module___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



var EnvironmentModule = (function () {
    function EnvironmentModule() {
    }
    return EnvironmentModule;
}());
EnvironmentModule = environment_module___decorate([
    Object(core_es5["NgModule"])({
        imports: [
            common_es5["CommonModule"]
        ],
        declarations: [],
        exports: [],
        providers: [
            {
                provide: Environments,
                useValue: environments,
            },
            EnvironmentConfiguration
        ]
    })
], EnvironmentModule);

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/environment.module.js.map
// EXTERNAL MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/node_modules/util/util.js
var util_util = __webpack_require__("N+n4");
var util_default = /*#__PURE__*/__webpack_require__.n(util_util);

// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/pipes/absolute-value.pipe.ts
var absolute_value_pipe___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var absolute_value_pipe___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};


var absolute_value_pipe_AbsoluteValuePipe = (function () {
    function AbsoluteValuePipe() {
    }
    AbsoluteValuePipe.prototype.transform = function (value, args) {
        if (Object(util_util["isNumber"])(value)) {
            return Math.abs(value);
        }
        return value;
    };
    return AbsoluteValuePipe;
}());
absolute_value_pipe_AbsoluteValuePipe = absolute_value_pipe___decorate([
    Object(core_es5["Pipe"])({
        name: 'absolute'
    }),
    absolute_value_pipe___metadata("design:paramtypes", [])
], absolute_value_pipe_AbsoluteValuePipe);

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/absolute-value.pipe.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/expiration-modal/expiration-modal.component.ts
var expiration_modal_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var expiration_modal_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};



var expiration_modal_component_ExpirationModalComponent = (function () {
    function ExpirationModalComponent(authenticationStore) {
        this.authenticationStore = authenticationStore;
        this.logOutEarly = 'AUTHENTICATION_EXPIRATION.LOG_OUT_EARLY';
        this.stayLoggedIn = 'AUTHENTICATION_EXPIRATION.STAY_LOGGED_IN';
        this.returnToLogin = 'AUTHENTICATION_EXPIRATION.RETURN_TO_LOGIN';
        this.title = 'AUTHENTICATION_EXPIRATION.TITLE';
        this.content = 'AUTHENTICATION_EXPIRATION.CONTENT_NOT_EXPIRED';
        this.config = {
            backdrop: 'static',
            keyboard: false
        };
        this.closed = new core_es5["EventEmitter"]();
        this.expiredAlready = false;
    }
    Object.defineProperty(ExpirationModalComponent.prototype, "alreadyExpired", {
        get: function () {
            return this.expiredAlready;
        },
        enumerable: true,
        configurable: true
    });
    ExpirationModalComponent.prototype.setAlreadyExpired = function (expired) {
        this.expiredAlready = expired;
    };
    ExpirationModalComponent.prototype.ngOnInit = function () {
    };
    ExpirationModalComponent.prototype.open = function () {
        this.expirationModal.show();
    };
    ExpirationModalComponent.prototype.close = function (value) {
        this.closed.emit(value);
        this.expirationModal.hide();
    };
    ExpirationModalComponent.prototype.endSession = function () {
        this.authenticationStore.logout();
        this.close(false);
    };
    ExpirationModalComponent.prototype.refreshAuthentication = function () {
        var _this = this;
        this.authenticationStore.refreshAuthentication().subscribe(function () {
            _this.close(true);
        });
    };
    return ExpirationModalComponent;
}());
expiration_modal_component___decorate([
    Object(core_es5["ViewChild"])(modal["b" /* ModalDirective */]),
    expiration_modal_component___metadata("design:type", typeof (expiration_modal_component__a = typeof modal["b" /* ModalDirective */] !== "undefined" && modal["b" /* ModalDirective */]) === "function" && expiration_modal_component__a || Object)
], expiration_modal_component_ExpirationModalComponent.prototype, "expirationModal", void 0);
expiration_modal_component___decorate([
    Object(core_es5["Input"])(),
    expiration_modal_component___metadata("design:type", Object)
], expiration_modal_component_ExpirationModalComponent.prototype, "logOutEarly", void 0);
expiration_modal_component___decorate([
    Object(core_es5["Input"])(),
    expiration_modal_component___metadata("design:type", Object)
], expiration_modal_component_ExpirationModalComponent.prototype, "stayLoggedIn", void 0);
expiration_modal_component___decorate([
    Object(core_es5["Input"])(),
    expiration_modal_component___metadata("design:type", Object)
], expiration_modal_component_ExpirationModalComponent.prototype, "returnToLogin", void 0);
expiration_modal_component___decorate([
    Object(core_es5["Input"])(),
    expiration_modal_component___metadata("design:type", Object)
], expiration_modal_component_ExpirationModalComponent.prototype, "title", void 0);
expiration_modal_component___decorate([
    Object(core_es5["Input"])(),
    expiration_modal_component___metadata("design:type", Object)
], expiration_modal_component_ExpirationModalComponent.prototype, "content", void 0);
expiration_modal_component___decorate([
    Object(core_es5["Input"])(),
    expiration_modal_component___metadata("design:type", Object)
], expiration_modal_component_ExpirationModalComponent.prototype, "config", void 0);
expiration_modal_component___decorate([
    Object(core_es5["Output"])(),
    expiration_modal_component___metadata("design:type", Object)
], expiration_modal_component_ExpirationModalComponent.prototype, "closed", void 0);
expiration_modal_component_ExpirationModalComponent = expiration_modal_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-expiration-modal',
        template: __webpack_require__("8ek7"),
        styles: [__webpack_require__("89tT")]
    }),
    expiration_modal_component___metadata("design:paramtypes", [typeof (expiration_modal_component__b = typeof authentication_store_AuthenticationStore !== "undefined" && authentication_store_AuthenticationStore) === "function" && expiration_modal_component__b || Object])
], expiration_modal_component_ExpirationModalComponent);

var expiration_modal_component__a, expiration_modal_component__b;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/expiration-modal.component.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/dropdown-search/dropdown-search.component.ts
var dropdown_search_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var dropdown_search_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};


var dropdown_search_component_DropdownSearchComponent = (function () {
    function DropdownSearchComponent(renderer) {
        this.renderer = renderer;
        this.selected = new core_es5["EventEmitter"]();
        this.displayDropdown = false;
        this.searchInput = '';
    }
    Object.defineProperty(DropdownSearchComponent.prototype, "options", {
        set: function (options) {
            this._originalOptions = options;
            this.dropdownOptions = options ? options.slice() : options;
        },
        enumerable: true,
        configurable: true
    });
    DropdownSearchComponent.prototype.ngOnInit = function () { };
    DropdownSearchComponent.prototype.iconClick = function () {
        this.searchInputElement.nativeElement.focus();
    };
    DropdownSearchComponent.prototype.filter = function () {
        var searchValue = this.searchInput ? this.searchInput.trim().toLowerCase() : '';
        this.dropdownOptions = this._originalOptions.filter(function (item) {
            return (item.key && item.key.toLowerCase().indexOf(searchValue) >= 0)
                || (item.value && item.value.toLowerCase().search(searchValue) >= 0);
        });
    };
    DropdownSearchComponent.prototype.select = function (option) {
        this.searchInputElement.nativeElement.focus();
        this.selectedOption = option;
        if (option) {
            this.control.setValue(option.key);
            this.searchInput = option.value;
        }
        else {
            this.reset();
        }
        this.closeDropdown();
        this.selected.emit(option);
    };
    DropdownSearchComponent.prototype.reset = function () {
        this.selectedOption = undefined;
        if (this.control) {
            this.control.setValue('');
        }
        this.searchInput = '';
    };
    DropdownSearchComponent.prototype.closeDropdown = function () {
        this.searchInput = this.selectedOption ? this.selectedOption.value : '';
        this.dropdownOptions = this._originalOptions ? this._originalOptions.slice() : this._originalOptions;
        this.displayDropdown = false;
    };
    DropdownSearchComponent.prototype.toggleDropdown = function () {
        if (this.displayDropdown) {
            this.closeDropdown();
        }
        else {
            this.openDropdown();
        }
    };
    DropdownSearchComponent.prototype.inputKeydown = function () {
        this.displayDropdown = true;
    };
    DropdownSearchComponent.prototype.openDropdown = function () {
        this.searchInput = '';
        this.displayDropdown = true;
    };
    return DropdownSearchComponent;
}());
dropdown_search_component___decorate([
    Object(core_es5["Input"])(),
    dropdown_search_component___metadata("design:type", typeof (dropdown_search_component__a = typeof forms_es5["FormControl"] !== "undefined" && forms_es5["FormControl"]) === "function" && dropdown_search_component__a || Object)
], dropdown_search_component_DropdownSearchComponent.prototype, "control", void 0);
dropdown_search_component___decorate([
    Object(core_es5["Input"])(),
    dropdown_search_component___metadata("design:type", String)
], dropdown_search_component_DropdownSearchComponent.prototype, "label", void 0);
dropdown_search_component___decorate([
    Object(core_es5["Input"])(),
    dropdown_search_component___metadata("design:type", String)
], dropdown_search_component_DropdownSearchComponent.prototype, "placeholder", void 0);
dropdown_search_component___decorate([
    Object(core_es5["Input"])('options'),
    dropdown_search_component___metadata("design:type", Array),
    dropdown_search_component___metadata("design:paramtypes", [Array])
], dropdown_search_component_DropdownSearchComponent.prototype, "options", null);
dropdown_search_component___decorate([
    Object(core_es5["Input"])(),
    dropdown_search_component___metadata("design:type", String)
], dropdown_search_component_DropdownSearchComponent.prototype, "controlName", void 0);
dropdown_search_component___decorate([
    Object(core_es5["Output"])(),
    dropdown_search_component___metadata("design:type", Object)
], dropdown_search_component_DropdownSearchComponent.prototype, "selected", void 0);
dropdown_search_component___decorate([
    Object(core_es5["ViewChild"])('searchInputElement'),
    dropdown_search_component___metadata("design:type", typeof (dropdown_search_component__b = typeof core_es5["ElementRef"] !== "undefined" && core_es5["ElementRef"]) === "function" && dropdown_search_component__b || Object)
], dropdown_search_component_DropdownSearchComponent.prototype, "searchInputElement", void 0);
dropdown_search_component_DropdownSearchComponent = dropdown_search_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-dropdown-search',
        template: __webpack_require__("BjH2"),
        styles: [__webpack_require__("Mb9j")]
    }),
    dropdown_search_component___metadata("design:paramtypes", [typeof (dropdown_search_component__c = typeof core_es5["Renderer2"] !== "undefined" && core_es5["Renderer2"]) === "function" && dropdown_search_component__c || Object])
], dropdown_search_component_DropdownSearchComponent);

var dropdown_search_component__a, dropdown_search_component__b, dropdown_search_component__c;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/dropdown-search.component.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/iata-by-default-modal/iata-by-default-modal.component.ts
var iata_by_default_modal_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var iata_by_default_modal_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};












var iata_by_default_modal_component_IataByDefaultModalComponent = (function () {
    function IataByDefaultModalComponent(http, environment, responseUtilService, router, logService, authenticationStore) {
        this.http = http;
        this.environment = environment;
        this.responseUtilService = responseUtilService;
        this.router = router;
        this.logService = logService;
        this.authenticationStore = authenticationStore;
        this.enableButton = false;
        this.agencyControl = new forms_es5["FormControl"]();
        this.agencies = [];
        this.token = null;
        this.defaultArcIata = null;
        this.config = {
            backdrop: 'static',
            keyboard: false
        };
        this.closed = new core_es5["EventEmitter"]();
    }
    IataByDefaultModalComponent.prototype.ngOnInit = function () {
    };
    IataByDefaultModalComponent.prototype.open = function (token, multiAgencies) {
        var _this = this;
        this.token = token;
        multiAgencies.forEach(function (agency) {
            var agencyId = pioneer_utils_PioneerUtils.safeTrim(agency.agencyId);
            var agencyName = pioneer_utils_PioneerUtils.safeTrim(agency.agencyName);
            _this.agencies.push(new DropdownItem(agencyId, agencyName + ' - ' + agencyId));
        });
        this.iataByDefaultModal.show();
    };
    IataByDefaultModalComponent.prototype.close = function (value) {
        this.closed.emit(value);
        this.iataByDefaultModal.hide();
    };
    IataByDefaultModalComponent.prototype.endSession = function () {
        this.close(false);
    };
    IataByDefaultModalComponent.prototype.refreshAuthentication = function () {
        var _this = this;
        this.authenticationStore.refreshAuthentication().subscribe(function () {
            _this.close(true);
        });
    };
    IataByDefaultModalComponent.prototype.agencySelected = function (agency) {
        if (agency) {
            this.enableButton = true;
            this.defaultArcIata = agency.key;
        }
        else {
            this.enableButton = false;
            this.defaultArcIata = null;
        }
    };
    IataByDefaultModalComponent.prototype.apply = function () {
        var _this = this;
        this.authenticationStore.assignDefaultArcIata(this.token, true, this.defaultArcIata).subscribe(function (userPermission) {
            _this.router.navigate(['/'], { replaceUrl: true });
        }, function (error) {
            if (error === ExternalSourceError.TOKEN_EXPIRED) {
                _this.router.navigate(['/external-login-expired']);
                _this.logService.debug("after navigate['/external-login-expired']");
            }
            else {
                _this.router.navigate(['/error', { error: 'MESSAGES.ERROR.EXTERNAL_LOGIN_ERROR' }]);
            }
        });
    };
    return IataByDefaultModalComponent;
}());
iata_by_default_modal_component___decorate([
    Object(core_es5["ViewChild"])(modal["b" /* ModalDirective */]),
    iata_by_default_modal_component___metadata("design:type", typeof (iata_by_default_modal_component__a = typeof modal["b" /* ModalDirective */] !== "undefined" && modal["b" /* ModalDirective */]) === "function" && iata_by_default_modal_component__a || Object)
], iata_by_default_modal_component_IataByDefaultModalComponent.prototype, "iataByDefaultModal", void 0);
iata_by_default_modal_component___decorate([
    Object(core_es5["ViewChild"])('agencyDropdown'),
    iata_by_default_modal_component___metadata("design:type", typeof (iata_by_default_modal_component__b = typeof dropdown_search_component_DropdownSearchComponent !== "undefined" && dropdown_search_component_DropdownSearchComponent) === "function" && iata_by_default_modal_component__b || Object)
], iata_by_default_modal_component_IataByDefaultModalComponent.prototype, "agencyDropdown", void 0);
iata_by_default_modal_component___decorate([
    Object(core_es5["Input"])(),
    iata_by_default_modal_component___metadata("design:type", Object)
], iata_by_default_modal_component_IataByDefaultModalComponent.prototype, "config", void 0);
iata_by_default_modal_component___decorate([
    Object(core_es5["Output"])(),
    iata_by_default_modal_component___metadata("design:type", Object)
], iata_by_default_modal_component_IataByDefaultModalComponent.prototype, "closed", void 0);
iata_by_default_modal_component_IataByDefaultModalComponent = iata_by_default_modal_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-iata-by-default-modal',
        template: __webpack_require__("RN5c")
    }),
    iata_by_default_modal_component___metadata("design:paramtypes", [typeof (iata_by_default_modal_component__c = typeof AppAuthHttpService !== "undefined" && AppAuthHttpService) === "function" && iata_by_default_modal_component__c || Object, typeof (iata_by_default_modal_component__d = typeof EnvironmentConfiguration !== "undefined" && EnvironmentConfiguration) === "function" && iata_by_default_modal_component__d || Object, typeof (iata_by_default_modal_component__e = typeof response_util_service_ResponseUtilService !== "undefined" && response_util_service_ResponseUtilService) === "function" && iata_by_default_modal_component__e || Object, typeof (iata_by_default_modal_component__f = typeof router_es5["Router"] !== "undefined" && router_es5["Router"]) === "function" && iata_by_default_modal_component__f || Object, typeof (iata_by_default_modal_component__g = typeof log_service_LogService !== "undefined" && log_service_LogService) === "function" && iata_by_default_modal_component__g || Object, typeof (_h = typeof authentication_store_AuthenticationStore !== "undefined" && authentication_store_AuthenticationStore) === "function" && _h || Object])
], iata_by_default_modal_component_IataByDefaultModalComponent);

var iata_by_default_modal_component__a, iata_by_default_modal_component__b, iata_by_default_modal_component__c, iata_by_default_modal_component__d, iata_by_default_modal_component__e, iata_by_default_modal_component__f, iata_by_default_modal_component__g, _h;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/iata-by-default-modal.component.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/pipes/date-format.pipe.ts
var date_format_pipe___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var date_format_pipe___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



var date_format_pipe_DateFormatPipe = (function (_super) {
    date_format_pipe___extends(DateFormatPipe, _super);
    function DateFormatPipe() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DateFormatPipe.prototype.transform = function (value, args) {
        return _super.prototype.transform.call(this, value, Constants.DATE_FORMAT_MMM_DD);
    };
    return DateFormatPipe;
}(common_es5["DatePipe"]));
date_format_pipe_DateFormatPipe = date_format_pipe___decorate([
    Object(core_es5["Pipe"])({
        name: 'dateFormat'
    })
], date_format_pipe_DateFormatPipe);

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/date-format.pipe.js.map
// EXTERNAL MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/node_modules/date-fns/format/index.js
var date_fns_format = __webpack_require__("r5wF");
var format_default = /*#__PURE__*/__webpack_require__.n(date_fns_format);

// EXTERNAL MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/node_modules/date-fns/is_valid/index.js
var is_valid = __webpack_require__("lzRm");
var is_valid_default = /*#__PURE__*/__webpack_require__.n(is_valid);

// EXTERNAL MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/node_modules/date-fns/parse/index.js
var parse = __webpack_require__("hAEu");
var parse_default = /*#__PURE__*/__webpack_require__.n(parse);

// EXTERNAL MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/node_modules/date-fns/difference_in_calendar_days/index.js
var difference_in_calendar_days = __webpack_require__("iEGb");
var difference_in_calendar_days_default = /*#__PURE__*/__webpack_require__.n(difference_in_calendar_days);

// EXTERNAL MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/node_modules/date-fns/sub_days/index.js
var sub_days = __webpack_require__("Uo3b");
var sub_days_default = /*#__PURE__*/__webpack_require__.n(sub_days);

// EXTERNAL MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/node_modules/date-fns/add_days/index.js
var add_days = __webpack_require__("zBAW");
var add_days_default = /*#__PURE__*/__webpack_require__.n(add_days);

// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/utils/date.util.ts






var date_util_DateUtil = (function () {
    function DateUtil() {
    }
    DateUtil.formatDate = function (date, formatStr) {
        if (formatStr === void 0) { formatStr = 'YYYY-MM-DD'; }
        if (date !== null && is_valid(new Date(date))) {
            return date_fns_format(date, formatStr);
        }
        else {
            return '';
        }
    };
    DateUtil.parseDate = function (date) {
        return parse(date);
    };
    DateUtil.isValidDateString = function (date) {
        return this.isValidDate(this.parseDate(date));
    };
    DateUtil.isValidDate = function (date) {
        return date instanceof Date && !isNaN(date.valueOf());
    };
    DateUtil.differenceInCalendarDays = function (end, start) {
        return difference_in_calendar_days(end, start);
    };
    DateUtil.subtractDaysFromDate = function (date, amount) {
        return sub_days(date, amount);
    };
    DateUtil.addDaysToDate = function (date, amount) {
        return add_days(date, amount);
    };
    DateUtil.getLocalDateFormat = function (date) {
        if (date !== null && is_valid(new Date(date))) {
            return this.parseDate(date).toLocaleDateString();
        }
        else {
            return '';
        }
    };
    return DateUtil;
}());

date_util_DateUtil.MILLISECONDS_PER_DAY = 24 * 60 * 60 * 1000;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/date.util.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/pipes/locale-date-format.pipe.ts
var locale_date_format_pipe___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


var locale_date_format_pipe_LocaleDateFormatPipe = (function () {
    function LocaleDateFormatPipe() {
    }
    LocaleDateFormatPipe.prototype.transform = function (value, args) {
        return date_util_DateUtil.getLocalDateFormat(value);
    };
    return LocaleDateFormatPipe;
}());
locale_date_format_pipe_LocaleDateFormatPipe = locale_date_format_pipe___decorate([
    Object(core_es5["Pipe"])({
        name: 'localeDateFormat'
    })
], locale_date_format_pipe_LocaleDateFormatPipe);

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/locale-date-format.pipe.js.map
// EXTERNAL MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/node_modules/pdfmake/build/pdfmake.js
var pdfmake = __webpack_require__("SQ0N");
var pdfmake_default = /*#__PURE__*/__webpack_require__.n(pdfmake);

// EXTERNAL MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/node_modules/pdfmake/build/vfs_fonts.js
var vfs_fonts = __webpack_require__("vdd2");
var vfs_fonts_default = /*#__PURE__*/__webpack_require__.n(vfs_fonts);

// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/pdf/pdf-cell-type.enum.ts
var PdfCellType;
(function (PdfCellType) {
    PdfCellType[PdfCellType["TEXT"] = 0] = "TEXT";
    PdfCellType[PdfCellType["NUMBER"] = 1] = "NUMBER";
    PdfCellType[PdfCellType["DATE"] = 2] = "DATE";
    PdfCellType[PdfCellType["HEADER"] = 3] = "HEADER";
})(PdfCellType || (PdfCellType = {}));
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/pdf-cell-type.enum.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/pdf/pdf-cell.ts



var pdf_cell_PdfCell = (function () {
    function PdfCell(text, type, additionalStyles) {
        this.style = [];
        if (!type) {
            type = PdfCellType.TEXT;
        }
        if (type === PdfCellType.TEXT) {
            this.style.push('textCell');
            this.text = text;
        }
        else if (type === PdfCellType.NUMBER) {
            this.style.push('numericCell');
            this.text = text;
        }
        else if (type === PdfCellType.DATE) {
            this.style.push('textCell');
            this.text = new date_format_pipe_DateFormatPipe(Constants.DATE_FORMAT_MMM_DD).transform(text);
        }
        else if (type === PdfCellType.HEADER) {
            this.text = text;
            this.style.push('headerTitle');
        }
        if (additionalStyles && additionalStyles.length > 0) {
            this.style = this.style.concat(additionalStyles);
        }
        if (!this.text || this.text === '') {
            this.text = Constants.PDF_EMPTY_CELL;
        }
    }
    return PdfCell;
}());

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/pdf-cell.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/pdf/pdf-row.ts
var PdfRow = (function () {
    function PdfRow(pdfCells) {
        var _this = this;
        this.pdfCells = [];
        if (pdfCells) {
            pdfCells.forEach(function (cell) { return _this.pdfCells.push(cell); });
        }
    }
    PdfRow.prototype.addCell = function (pdfCell) {
        this.pdfCells.push(pdfCell);
    };
    return PdfRow;
}());

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/pdf-row.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/pdf/pdf-table.ts


var pdf_table_PdfTable = (function () {
    function PdfTable(pdfColDefs, data) {
        var _this = this;
        this.body = [];
        this.widths = [];
        var headers = [];
        pdfColDefs.forEach(function (colDef) {
            _this.widths.push(colDef.width);
            headers.push(colDef.header);
        });
        this.addHeaders(headers);
        data.forEach(function (rowData) {
            var row = new PdfRow();
            for (var i = 0; i < rowData.length; i++) {
                row.addCell(new pdf_cell_PdfCell(rowData[i], pdfColDefs[i].type));
            }
            _this.addRow(row);
        });
    }
    PdfTable.prototype.addHeaders = function (headersParam) {
        if (headersParam) {
            var headersRow_1 = [];
            headersParam.forEach(function (header) {
                headersRow_1.push({ text: header, style: 'headerCell' });
            });
            this.body.push(headersRow_1);
        }
    };
    PdfTable.prototype.addRow = function (row) {
        this.body.push(row.pdfCells);
    };
    return PdfTable;
}());

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/pdf-table.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/pdf/pdf-col-def.ts

var pdf_col_def_PdfColDef = (function () {
    function PdfColDef(header, type, width) {
        this.header = header;
        this.type = type ? type : PdfCellType.TEXT;
        this.width = width ? width : 'auto';
    }
    return PdfColDef;
}());

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/pdf-col-def.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/pdf/pdf-doc.ts



var pdfDocStyles = __webpack_require__("sUjQ");
var pdf_doc_PdfDoc = (function () {
    function PdfDoc() {
        this.pageOrientation = 'landscape';
        this.content = [];
        this.footer = this.buildFooter();
        this.styles = pdfDocStyles;
    }
    PdfDoc.prototype.addTableHeader = function (data) {
        this.content.push(this.addHeaderTable(data, 6));
    };
    PdfDoc.prototype.addLineBreak = function () {
        this.content.push({ text: ' ' });
    };
    PdfDoc.prototype.addCard = function (cardTitle, pdfColDefs, data, hasHeaders, lineNumbers) {
        this.content.push({ text: cardTitle, style: 'cardTitle' });
        this.content.push({ text: ' ' });
        this.content.push(this.addTable(pdfColDefs, data, hasHeaders, lineNumbers));
    };
    PdfDoc.prototype.addHeaderTable = function (data, columnCount) {
        var pdfColDefs = [];
        for (var i = 0; i < columnCount; i++) {
            pdfColDefs.push(new pdf_col_def_PdfColDef(undefined, PdfCellType.HEADER, '*'));
        }
        return {
            'layout': {
                hLineWidth: function (i) { return (i === 2) ? 2 : 0; },
                vLineWidth: function () { return 0; },
                hLineColor: function () { return 'black'; },
                vLineColor: function () { return 'black'; }
            },
            'table': new pdf_table_PdfTable(pdfColDefs, data)
        };
    };
    PdfDoc.prototype.addTable = function (pdfColDefs, data, hasHeaders, lineNumbers) {
        return {
            'layout': this.getTableLayout(hasHeaders, lineNumbers),
            'table': new pdf_table_PdfTable(pdfColDefs, data)
        };
    };
    PdfDoc.prototype.getTableLayout = function (hasHeaders, lineNumbers) {
        return {
            hLineWidth: this.getHLineWidth(2, 1, hasHeaders, lineNumbers),
            vLineWidth: this.getVLineWidth(2, 0),
            hLineColor: this.getHLineColor('black', 'gray'),
            vLineColor: this.getVLineColor('black', 'gray')
        };
    };
    PdfDoc.prototype.getHLineWidth = function (horizontalBorderWidth, innerHorizontalLinesWidth, hasHeaders, innerHorizontalLineNumbers) {
        return function (i, node) {
            if (i === 0 || i === node.table.body.length) {
                return horizontalBorderWidth;
            }
            else if (i === 1 && hasHeaders) {
                return horizontalBorderWidth;
            }
            else if (!innerHorizontalLineNumbers || innerHorizontalLineNumbers.indexOf(i) >= 0) {
                return innerHorizontalLinesWidth;
            }
            else {
                return 0;
            }
        };
    };
    PdfDoc.prototype.getVLineWidth = function (verticalBorderWidth, innerVerticalLinesWidth) {
        return function (i, node) {
            return (i === 0 || i === node.table.widths.length) ? verticalBorderWidth : innerVerticalLinesWidth;
        };
    };
    PdfDoc.prototype.getHLineColor = function (horizontalBorderColor, innerHorizontalLinesColor) {
        return function (i, node) {
            return (i === 0 || i === node.table.body.length) ? horizontalBorderColor : innerHorizontalLinesColor;
        };
    };
    PdfDoc.prototype.getVLineColor = function (verticalBorderColor, innerVerticalLinesColor) {
        return function (i, node) {
            return (i === 0 || i === node.table.widths.length) ? verticalBorderColor : innerVerticalLinesColor;
        };
    };
    PdfDoc.prototype.buildFooter = function () {
        return function (currentPage, pageCount) {
            return {
                text: currentPage.toString() + ' / ' + pageCount,
                alignment: 'right',
                style: 'pageNumberFooter',
                margin: [0, 20, 20, 0]
            };
        };
    };
    return PdfDoc;
}());

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/pdf-doc.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/match-type.enum.ts
var MatchTypeEnum;
(function (MatchTypeEnum) {
    MatchTypeEnum[MatchTypeEnum["EXACT_MATCH"] = 'Exact'] = "EXACT_MATCH";
    MatchTypeEnum[MatchTypeEnum["PARTIAL_MATCH"] = 'Partial'] = "PARTIAL_MATCH";
    MatchTypeEnum[MatchTypeEnum["NO_MATCH"] = 'NoMatch'] = "NO_MATCH";
})(MatchTypeEnum || (MatchTypeEnum = {}));
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/match-type.enum.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/utils/event-utils.ts
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var EventUtils = (function () {
    function EventUtils() {
    }
    EventUtils.isEventValid = function (onyxEvent, isAgencyUser) {
        return Boolean(onyxEvent &&
            this.isEventBasicInformationValid(onyxEvent, isAgencyUser) &&
            this.isEventStartEndDateValid(onyxEvent) &&
            this.isEventPropertyValid(onyxEvent.eventProperty) &&
            this.isEventAgencyValid(onyxEvent.eventAgency) &&
            this.isEventReferenceNumberValid(onyxEvent.eventProperty, onyxEvent.eventAgency));
    };
    EventUtils.isEventBasicInformationValid = function (onyxEvent, isAgencyUser) {
        return Boolean(this.getEventName(onyxEvent, isAgencyUser));
    };
    EventUtils.isEventPropertyValid = function (eventProperty) {
        return Boolean(eventProperty && eventProperty.name && eventProperty.chain && eventProperty.brand && eventProperty.propertyId);
    };
    EventUtils.isEventAgencyValid = function (eventAgency) {
        return Boolean(eventAgency && eventAgency.name);
    };
    EventUtils.isEventReferenceNumberValid = function (eventProperty, eventAgency) {
        return Boolean(eventProperty && eventProperty.eventReferenceNumber
            || eventAgency && eventAgency.eventReferenceNumber);
    };
    EventUtils.isEventStartEndDateValid = function (onyxEvent) {
        var _propertyDates = true;
        var _agencyDates = true;
        if (onyxEvent.eventProperty) {
            _propertyDates = onyxEvent.eventProperty.startDate &&
                onyxEvent.eventProperty.endDate &&
                new Date(onyxEvent.eventProperty.startDate) < new Date(onyxEvent.eventProperty.endDate);
        }
        if (onyxEvent.eventAgency) {
            _agencyDates = onyxEvent.eventAgency.startDate &&
                onyxEvent.eventAgency.endDate &&
                new Date(onyxEvent.eventAgency.startDate) < new Date(onyxEvent.eventAgency.endDate);
        }
        return Boolean(_propertyDates && _agencyDates);
    };
    EventUtils.doesEventHaveAgency = function (onyxEvent) {
        return Boolean(onyxEvent && onyxEvent.eventAgency && onyxEvent.eventAgency.code);
    };
    EventUtils.getEventGroupCode = function (event, isAgencyUser) {
        var _eventReferenceNumber = '';
        var _propertyReferenceNumber = null;
        var _agencyReferenceNumber = null;
        if (event.eventProperty && event.eventProperty.eventReferenceNumber) {
            _propertyReferenceNumber = event.eventProperty.eventReferenceNumber;
        }
        if (event.eventAgency && event.eventAgency.eventReferenceNumber) {
            _agencyReferenceNumber = event.eventAgency.eventReferenceNumber;
        }
        if (isAgencyUser) {
            if (_agencyReferenceNumber) {
                _eventReferenceNumber = _agencyReferenceNumber;
            }
            else if (_propertyReferenceNumber) {
                _eventReferenceNumber = _propertyReferenceNumber;
            }
        }
        else {
            if (_propertyReferenceNumber) {
                _eventReferenceNumber = _propertyReferenceNumber;
            }
            else if (_agencyReferenceNumber) {
                _eventReferenceNumber = _agencyReferenceNumber;
            }
        }
        return _eventReferenceNumber;
    };
    EventUtils.getEventStartDate = function (event, isAgencyUser) {
        var _eventStartDate = '';
        var _propertyStartDate = null;
        var _agencyStartDate = null;
        if (event.eventProperty && event.eventProperty.startDate) {
            _propertyStartDate = event.eventProperty.startDate;
        }
        if (event.eventAgency && event.eventAgency.startDate) {
            _agencyStartDate = event.eventAgency.startDate;
        }
        if (isAgencyUser) {
            if (_agencyStartDate) {
                _eventStartDate = _agencyStartDate;
            }
            else if (_propertyStartDate) {
                _eventStartDate = _propertyStartDate;
            }
        }
        else {
            if (_propertyStartDate) {
                _eventStartDate = _propertyStartDate;
            }
            else if (_agencyStartDate) {
                _eventStartDate = _agencyStartDate;
            }
        }
        return _eventStartDate;
    };
    EventUtils.getEventEndDate = function (event, isAgencyUser) {
        var _eventEndDate = '';
        var _propertyEndDate = null;
        var _agencyEndDate = null;
        if (event.eventProperty && event.eventProperty.endDate) {
            _propertyEndDate = event.eventProperty.endDate;
        }
        if (event.eventAgency && event.eventAgency.endDate) {
            _agencyEndDate = event.eventAgency.endDate;
        }
        if (isAgencyUser) {
            if (_agencyEndDate) {
                _eventEndDate = _agencyEndDate;
            }
            else if (_propertyEndDate) {
                _eventEndDate = _propertyEndDate;
            }
        }
        else {
            if (_propertyEndDate) {
                _eventEndDate = _propertyEndDate;
            }
            else if (_agencyEndDate) {
                _eventEndDate = _agencyEndDate;
            }
        }
        return _eventEndDate;
    };
    EventUtils.getEventName = function (event, isAgencyUser) {
        var _eventName = '';
        var _propertyName = null;
        var _agencyName = null;
        if (event.eventProperty && event.eventProperty.partyEventName) {
            _propertyName = event.eventProperty.partyEventName;
        }
        if (event.eventAgency && event.eventAgency.partyEventName) {
            _agencyName = event.eventAgency.partyEventName;
        }
        if (isAgencyUser) {
            if (_agencyName) {
                _eventName = _agencyName;
            }
            else if (_propertyName) {
                _eventName = _propertyName;
            }
        }
        else {
            if (_propertyName) {
                _eventName = _propertyName;
            }
            else if (_agencyName) {
                _eventName = _agencyName;
            }
        }
        return _eventName;
    };
    EventUtils.getEventUserRef = function (event, isAgencyUser, userRefName) {
        var _eventEventUserRef = null;
        var _propertyUserRef = null;
        var _agencyUserRef = null;
        if (event.eventProperty && event.eventProperty[userRefName]) {
            _propertyUserRef = event.eventProperty[userRefName];
        }
        if (event.eventAgency && event.eventAgency[userRefName]) {
            _agencyUserRef = event.eventAgency[userRefName];
        }
        if (isAgencyUser) {
            if (_agencyUserRef) {
                _eventEventUserRef = _agencyUserRef;
            }
            else if (_propertyUserRef) {
                _eventEventUserRef = _propertyUserRef;
            }
        }
        else {
            if (_propertyUserRef) {
                _eventEventUserRef = _propertyUserRef;
            }
            else if (_agencyUserRef) {
                _eventEventUserRef = _agencyUserRef;
            }
        }
        return _eventEventUserRef;
    };
    /**
     * Serialize an OnyxEvent ignoring the isExpanded property from Party objects
     * @param anEvent
     * @returns
     */
    EventUtils.serializeEvent = function (anEvent) {
        var eventCopy = anEvent.toJS();
        eventCopy.eventVendors = anEvent.eventVendors.map(function (eventVendor) {
            if (eventVendor.toJS) {
                return eventVendor.toJS();
            }
            return __assign({}, eventVendor);
        });
        if (eventCopy.eventAgency) {
            delete eventCopy.eventAgency.isExpanded;
        }
        if (eventCopy.eventProperty) {
            delete eventCopy.eventProperty.isExpanded;
        }
        if (eventCopy.eventClient) {
            delete eventCopy.eventClient.isExpanded;
        }
        if (eventCopy.eventVendors) {
            eventCopy.eventVendors = eventCopy.eventVendors.map(function (vendor) {
                return __assign({}, vendor, { isExpanded: undefined });
            });
        }
        return JSON.stringify(eventCopy);
    };
    return EventUtils;
}());

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/event-utils.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/pdf/pdf.service.ts
var pdf_service___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var pdf_service___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};












var pdf_service_PdfService = (function () {
    function PdfService(translateService, dateFormatPipe, reservationStatusPipe, decimalPipe) {
        this.translateService = translateService;
        this.dateFormatPipe = dateFormatPipe;
        this.reservationStatusPipe = reservationStatusPipe;
        this.decimalPipe = decimalPipe;
        pdfmake["vfs"] = vfs_fonts["pdfMake"].vfs;
    }
    PdfService.prototype.downloadRsvpCompare = function (event, noMatches, partialMatches, exactMatches) {
        var pdfDoc = new pdf_doc_PdfDoc();
        pdfDoc.addTableHeader(this.buildDocHeader(event));
        pdfDoc.addLineBreak();
        pdfDoc.addLineBreak();
        var hasHeaders = true;
        var dataColDefsNoMatch = this.buildDataColDefs(MatchTypeEnum.NO_MATCH);
        var noMatchesData = this.convertListToData(noMatches, MatchTypeEnum.NO_MATCH);
        pdfDoc.addCard(this.translateService.instant('EVENT.RSVPS.NO_MATCHING_TITLE'), dataColDefsNoMatch, noMatchesData, hasHeaders);
        pdfDoc.addLineBreak();
        pdfDoc.addLineBreak();
        var dataColDefsPartialMatches = this.buildDataColDefs(MatchTypeEnum.PARTIAL_MATCH);
        var partialMatchesData = this.convertListToData(partialMatches, MatchTypeEnum.PARTIAL_MATCH);
        var partialMatchesLines = this.getInnerHorizontalLines(partialMatches, hasHeaders);
        pdfDoc.addCard(this.translateService.instant('EVENT.RSVPS.PARTIAL_MATCHING_TITLE'), dataColDefsPartialMatches, partialMatchesData, hasHeaders, partialMatchesLines);
        pdfDoc.addLineBreak();
        pdfDoc.addLineBreak();
        var dataColDefsExactMatches = this.buildDataColDefs(MatchTypeEnum.EXACT_MATCH);
        var exactMatchesData = this.convertListToData(exactMatches, MatchTypeEnum.EXACT_MATCH);
        pdfDoc.addCard(this.translateService.instant('EVENT.RSVPS.EXACT_MATCHING_TITLE'), dataColDefsExactMatches, exactMatchesData, hasHeaders);
        var name = EventUtils.getEventName(event, false);
        pdfmake["createPdf"](pdfDoc).download((name ? name : '') + Constants.RSVP_COMPARE_PDF_FILE_NAME_SUFFIX);
    };
    PdfService.prototype.buildDocHeader = function (event) {
        return [
            [
                this.translateService.instant('EVENT.NAME'),
                this.translateService.instant('EVENT.CURRENCY_HEADER'),
                this.translateService.instant('EVENT.RSVPS.PDF.GROUP_CODE'),
                this.translateService.instant('EVENT.CONTACT_PROPERTY'),
                this.translateService.instant('EVENT.START_DATE'),
                this.translateService.instant('EVENT.END_DATE')
            ],
            [
                EventUtils.getEventName(event, false),
                event.currency,
                event.eventProperty ? event.eventProperty.eventReferenceNumber : '',
                event.eventProperty ? event.eventProperty.name : '',
                this.dateFormatPipe.transform(event.eventProperty.startDate, Constants.DATE_FORMAT_MM_DD_YYYY),
                this.dateFormatPipe.transform(event.eventProperty.endDate, Constants.DATE_FORMAT_MM_DD_YYYY)
            ]
        ];
    };
    PdfService.prototype.buildDataColDefs = function (matchType) {
        var dataColDefs = [];
        if (matchType === MatchTypeEnum.PARTIAL_MATCH) {
            dataColDefs.push(new pdf_col_def_PdfColDef(this.translateService.instant('EVENT.RSVPS.TYPE'), PdfCellType.TEXT, 'auto'));
        }
        dataColDefs.push(new pdf_col_def_PdfColDef(this.translateService.instant('EVENT.RSVPS.NAME'), PdfCellType.TEXT, '*'));
        if (matchType === MatchTypeEnum.PARTIAL_MATCH || matchType === MatchTypeEnum.EXACT_MATCH) {
            dataColDefs.push(new pdf_col_def_PdfColDef(this.translateService.instant('EVENT.RESERVATION.CONFIRMATION_NUMBER')));
            dataColDefs.push(new pdf_col_def_PdfColDef(this.translateService.instant('EVENT.RESERVATION.STATUS')));
            dataColDefs.push(new pdf_col_def_PdfColDef(this.translateService.instant('EVENT.RESERVATION.ROOM_TYPE')));
            dataColDefs.push(new pdf_col_def_PdfColDef(this.translateService.instant('EVENT.RESERVATION.CHECKIN_DATE'), PdfCellType.DATE));
            dataColDefs.push(new pdf_col_def_PdfColDef(this.translateService.instant('EVENT.RESERVATION.CHECKOUT_DATE'), PdfCellType.DATE));
        }
        dataColDefs.push(new pdf_col_def_PdfColDef(this.translateService.instant('EVENT.RESERVATION.NUMBER_NIGHTS'), PdfCellType.NUMBER));
        dataColDefs.push(new pdf_col_def_PdfColDef(this.translateService.instant('EVENT.RESERVATION.ROOM_RATE'), PdfCellType.NUMBER));
        dataColDefs.push(new pdf_col_def_PdfColDef(this.translateService.instant('EVENT.RESERVATION.REVENUE'), PdfCellType.NUMBER));
        dataColDefs.push(new pdf_col_def_PdfColDef(this.translateService.instant('EVENT.RESERVATION.COMMISSION'), PdfCellType.NUMBER));
        return dataColDefs;
    };
    PdfService.prototype.convertListToData = function (list, matchType) {
        var _this = this;
        var data = [];
        list.forEach(function (reservationCompare) {
            if (reservationCompare.reservation) {
                data.push(_this.convertObjectToRow(reservationCompare.reservation, matchType));
            }
            if (matchType !== MatchTypeEnum.EXACT_MATCH && reservationCompare.rsvp) {
                data.push(_this.convertObjectToRow(reservationCompare.rsvp, matchType));
            }
        });
        return data;
    };
    PdfService.prototype.getInnerHorizontalLines = function (list, hasHeaders) {
        var lines = [];
        var line = hasHeaders ? 1 : 0;
        list.forEach(function (reservationCompare) {
            if (reservationCompare.reservation && reservationCompare.rsvp) {
                line += 2;
            }
            else {
                line++;
            }
            lines.push(line);
        });
        return lines;
    };
    PdfService.prototype.convertObjectToRow = function (object, matchType) {
        var row = [];
        if (matchType === MatchTypeEnum.PARTIAL_MATCH) {
            if (object.eventReservationId) {
                row.push(this.translateService.instant('EVENT.RSVPS.PDF.TYPE_RESERVATION'));
            }
            else if (object.eventRsvpId) {
                row.push(this.translateService.instant('EVENT.RSVPS.TYPE_RSVP'));
            }
        }
        row.push(object.lastName + ', ' + object.firstName);
        if (matchType === MatchTypeEnum.PARTIAL_MATCH || matchType === MatchTypeEnum.EXACT_MATCH) {
            if (object.eventReservationId) {
                row.push(object.confirmation);
                row.push(this.reservationStatusPipe.transform(object.status));
                row.push(object.roomType);
                row.push(object.checkInDate);
                row.push(object.checkOutDate);
            }
            else if (object.eventRsvpId) {
                row.push('');
                row.push('');
                row.push('');
                row.push('');
                row.push('');
            }
        }
        row.push(object.nights);
        row.push(this.decimalPipe.transform(object.roomRate, '1.2-2'));
        row.push(this.decimalPipe.transform(object.revenue, '1.2-2'));
        row.push(this.decimalPipe.transform(object.commission, '1.2-2'));
        return row;
    };
    return PdfService;
}());
pdf_service_PdfService = pdf_service___decorate([
    Object(core_es5["Injectable"])(),
    pdf_service___metadata("design:paramtypes", [typeof (pdf_service__a = typeof core["c" /* TranslateService */] !== "undefined" && core["c" /* TranslateService */]) === "function" && pdf_service__a || Object, typeof (pdf_service__b = typeof common_es5["DatePipe"] !== "undefined" && common_es5["DatePipe"]) === "function" && pdf_service__b || Object, typeof (pdf_service__c = typeof reservation_status_pipe_ReservationStatusPipe !== "undefined" && reservation_status_pipe_ReservationStatusPipe) === "function" && pdf_service__c || Object, typeof (pdf_service__d = typeof common_es5["DecimalPipe"] !== "undefined" && common_es5["DecimalPipe"]) === "function" && pdf_service__d || Object])
], pdf_service_PdfService);

var pdf_service__a, pdf_service__b, pdf_service__c, pdf_service__d;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/pdf.service.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/payment-type.ts
var PaymentType = (function () {
    function PaymentType() {
    }
    return PaymentType;
}());

PaymentType.PREPAYMENT = 'pre';
PaymentType.FINAL_PAYMENT = 'final';
PaymentType.PAID_DIRECT = 'direct';
PaymentType.EVENT_CANCELLED = 'cancelled';
PaymentType.INITIAL = 'initial';
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/payment-type.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/pipes/payment-type.pipe.ts
var payment_type_pipe___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var payment_type_pipe___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};




var payment_type_pipe_PaymentTypePipe = (function () {
    function PaymentTypePipe(translateService, logService) {
        this.translateService = translateService;
        this.logService = logService;
    }
    PaymentTypePipe.prototype.transform = function (value, args) {
        // Pipes need to handle nulls/undefined
        if (!value) {
            value = '';
        }
        value = value.toLowerCase().toString();
        var returnValue = '';
        switch (value) {
            case PaymentType.FINAL_PAYMENT:
            case PaymentType.INITIAL:
                returnValue = this.translateService.instant('PAYMENT_TYPE.FINAL_PAYMENT');
                break;
            case PaymentType.PREPAYMENT:
                returnValue = this.translateService.instant('PAYMENT_TYPE.PREPAYMENT');
                break;
            default:
                this.logService.info(this.translateService.instant('PAYMENT_TYPE.UNKNOWN', { key: value }));
        }
        return returnValue;
    };
    return PaymentTypePipe;
}());
payment_type_pipe_PaymentTypePipe = payment_type_pipe___decorate([
    Object(core_es5["Pipe"])({
        name: 'paymentType'
    }),
    payment_type_pipe___metadata("design:paramtypes", [typeof (payment_type_pipe__a = typeof core["c" /* TranslateService */] !== "undefined" && core["c" /* TranslateService */]) === "function" && payment_type_pipe__a || Object, typeof (payment_type_pipe__b = typeof log_service_LogService !== "undefined" && log_service_LogService) === "function" && payment_type_pipe__b || Object])
], payment_type_pipe_PaymentTypePipe);

var payment_type_pipe__a, payment_type_pipe__b;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/payment-type.pipe.js.map
// EXTERNAL MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/node_modules/ngx-bootstrap/index.js + 120 modules
var ngx_bootstrap = __webpack_require__("bqRb");

// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/spinner.interceptor.ts
var spinner_interceptor___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var spinner_interceptor___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};



var spinner_interceptor_SpinnerInterceptor = (function () {
    function SpinnerInterceptor(spinnerService) {
        this.spinnerService = spinnerService;
    }
    SpinnerInterceptor.prototype.intercept = function (req, next) {
        var _this = this;
        this.spinnerService.start();
        return next.handle(req).pipe(Object(operators["finalize"])(function () {
            _this.spinnerService.finish();
        }));
    };
    return SpinnerInterceptor;
}());
spinner_interceptor_SpinnerInterceptor = spinner_interceptor___decorate([
    Object(core_es5["Injectable"])(),
    spinner_interceptor___metadata("design:paramtypes", [typeof (spinner_interceptor__a = typeof SpinnerService !== "undefined" && SpinnerService) === "function" && spinner_interceptor__a || Object])
], spinner_interceptor_SpinnerInterceptor);

var spinner_interceptor__a;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/spinner.interceptor.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/interceptors/cache.interceptor.ts
var cache_interceptor___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var cache_interceptor___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};


var CacheInterceptor = (function () {
    function CacheInterceptor(environment) {
        this.environment = environment;
    }
    CacheInterceptor.prototype.intercept = function (req, next) {
        var clonedReq = req.clone();
        if (req.method === 'GET' && this.shouldBeIntercepted(req.url)) {
            clonedReq = req.clone({
                headers: this.addNoCacheHeaders(req.headers),
            });
        }
        return next.handle(clonedReq);
    };
    CacheInterceptor.prototype.shouldBeIntercepted = function (url) {
        return url.indexOf(this.environment.baseUrl) !== -1;
    };
    CacheInterceptor.prototype.addNoCacheHeaders = function (headers) {
        headers = headers.append('Cache-Control', 'no-cache');
        headers = headers.append('Pragma', 'no-cache');
        return headers;
    };
    return CacheInterceptor;
}());
CacheInterceptor = cache_interceptor___decorate([
    Object(core_es5["Injectable"])(),
    cache_interceptor___metadata("design:paramtypes", [typeof (cache_interceptor__a = typeof EnvironmentConfiguration !== "undefined" && EnvironmentConfiguration) === "function" && cache_interceptor__a || Object])
], CacheInterceptor);

var cache_interceptor__a;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/cache.interceptor.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/report-type.enum.ts
var ReportType;
(function (ReportType) {
    ReportType[ReportType["EVENT_LIST"] = 0] = "EVENT_LIST";
    ReportType[ReportType["RESERVATION_SUMMARY"] = 1] = "RESERVATION_SUMMARY";
    ReportType[ReportType["PAYMENT_SUMMARY"] = 2] = "PAYMENT_SUMMARY";
    ReportType[ReportType["RSVP_SUMMARY"] = 3] = "RSVP_SUMMARY";
    ReportType[ReportType["RESERVATION_COMPARE"] = 4] = "RESERVATION_COMPARE";
    ReportType[ReportType["RSVP_COMPARE"] = 5] = "RSVP_COMPARE";
})(ReportType || (ReportType = {}));
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/report-type.enum.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/service/report.service.ts
var report_service___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var report_service___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};








var report_service_ReportService = (function () {
    function ReportService(httpClient, environment, authStore, responseUtilService, translateService) {
        this.httpClient = httpClient;
        this.environment = environment;
        this.authStore = authStore;
        this.responseUtilService = responseUtilService;
        this.translateService = translateService;
        this.reportEndpoint = this.environment.baseUrl + '/api/events';
    }
    ReportService.prototype.getReservationsReport = function (eventId, eventPartyId, isSummary, fileType) {
        var _this = this;
        var token = this.authStore.getToken();
        var reportType = isSummary ? 'summary' : 'compare';
        var url = this.reportEndpoint + "/" + eventId + "/" + eventPartyId + "/report/reservations/" + reportType + "/" + fileType + "?Authorization=" + token;
        return this.httpClient.get(url, { observe: 'response', responseType: 'blob' })
            .catch(function (err) { return _this.responseUtilService.handleError(err); });
    };
    ReportService.prototype.getPaymentsReport = function (eventId, eventPartyId, fileType) {
        var _this = this;
        var token = this.authStore.getToken();
        var url = this.reportEndpoint + "/" + eventId + "/" + eventPartyId + "/report/payments/summary/" + fileType + "?Authorization=" + token;
        return this.httpClient.get(url, { observe: 'response', responseType: 'blob' })
            .catch(function (err) { return _this.responseUtilService.handleError(err); });
    };
    ReportService.prototype.getRsvpReport = function (eventId, eventPartyId, fileType, summarySelected) {
        var _this = this;
        var token = this.authStore.getToken();
        var rsvpType = summarySelected ? 'summary' : 'compare';
        var url = this.reportEndpoint + "/" + eventId + "/" + eventPartyId + "/report/rsvp/" + rsvpType + "/" + fileType + "?Authorization=" + token;
        return this.httpClient.get(url, { observe: 'response', responseType: 'blob' })
            .catch(function (err) { return _this.responseUtilService.handleError(err); });
    };
    ReportService.prototype.buildReportFileName = function (reportType, event, fileType) {
        var reportTypePrefix;
        switch (reportType) {
            case ReportType.EVENT_LIST:
                reportTypePrefix = this.translateService.instant('COMMON.REPORT.NAMES.EVENT_LIST');
                break;
            case ReportType.RESERVATION_SUMMARY:
                reportTypePrefix = this.translateService.instant('COMMON.REPORT.NAMES.RESERVATION_SUMMARY');
                break;
            case ReportType.PAYMENT_SUMMARY:
                reportTypePrefix = this.translateService.instant('COMMON.REPORT.NAMES.PAYMENT_SUMMARY');
                break;
            case ReportType.RSVP_SUMMARY:
                reportTypePrefix = this.translateService.instant('COMMON.REPORT.NAMES.RSVP_SUMMARY');
                break;
            case ReportType.RESERVATION_COMPARE:
                reportTypePrefix = this.translateService.instant('COMMON.REPORT.NAMES.RESERVATION_COMPARE');
                break;
            case ReportType.RSVP_COMPARE:
                reportTypePrefix = this.translateService.instant('COMMON.REPORT.NAMES.RSVP_COMPARE');
                break;
            default:
                reportTypePrefix = '';
        }
        var extension = fileType === 'pdf' ? '.pdf' : '.xlsx';
        var groupCode = event ? event.eventProperty.eventReferenceNumber + '_' : '';
        return reportTypePrefix + '_' + groupCode + date_util_DateUtil.formatDate(new Date(), 'YYYYMMDD') + extension;
    };
    return ReportService;
}());
report_service_ReportService = report_service___decorate([
    Object(core_es5["Injectable"])(),
    report_service___metadata("design:paramtypes", [typeof (report_service__a = typeof common_http_es5["b" /* HttpClient */] !== "undefined" && common_http_es5["b" /* HttpClient */]) === "function" && report_service__a || Object, typeof (report_service__b = typeof EnvironmentConfiguration !== "undefined" && EnvironmentConfiguration) === "function" && report_service__b || Object, typeof (report_service__c = typeof authentication_store_AuthenticationStore !== "undefined" && authentication_store_AuthenticationStore) === "function" && report_service__c || Object, typeof (report_service__d = typeof response_util_service_ResponseUtilService !== "undefined" && response_util_service_ResponseUtilService) === "function" && report_service__d || Object, typeof (report_service__e = typeof core["c" /* TranslateService */] !== "undefined" && core["c" /* TranslateService */]) === "function" && report_service__e || Object])
], report_service_ReportService);

var report_service__a, report_service__b, report_service__c, report_service__d, report_service__e;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/report.service.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/utils/number.util.ts
var NumberUtils = (function () {
    function NumberUtils() {
    }
    NumberUtils.round2Fixed = function (value) {
        value = +value;
        if (isNaN(value)) {
            return NaN;
        }
        // Shift
        value = value.toString().split('e');
        value = Math.round(+(value[0] + 'e' + (value[1] ? (+value[1] + 2) : 2)));
        // Shift back
        value = value.toString().split('e');
        return Number((+(value[0] + 'e' + (value[1] ? (+value[1] - 2) : -2))).toFixed(2));
    };
    NumberUtils.getDecimalSeparator = function () {
        return (1.1).toLocaleString().substring(1, 2);
    };
    return NumberUtils;
}());

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/number.util.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/pipes/abbreviate-amount.pipe.ts
var abbreviate_amount_pipe___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var abbreviate_amount_pipe___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};



var abbreviate_amount_pipe_AbbreviateAmountPipe = (function () {
    function AbbreviateAmountPipe(decimalPipe) {
        this.decimalPipe = decimalPipe;
    }
    AbbreviateAmountPipe.prototype.transform = function (value, args) {
        var result;
        var formatted = this.decimalPipe.transform(value, '1.2-2');
        var parsed = this.parse(formatted);
        if (parsed < 1000) {
            result = formatted;
        }
        else {
            var aux = value / 1000.0;
            formatted = this.decimalPipe.transform(aux, '1.1-1');
            parsed = this.parse(formatted);
            if (parsed < 1000) {
                result = formatted.concat(' K');
            }
            else {
                aux = value / 1000000.0;
                result = this.decimalPipe.transform(aux, '1.1-1').concat(' M');
            }
        }
        return result;
    };
    /**
     * Converts string to number.
     *
     * @param input
     */
    AbbreviateAmountPipe.prototype.parse = function (input) {
        // Obtain the decimal separator
        var decimalSeparator = NumberUtils.getDecimalSeparator();
        // Normalize the number if there's more than one decimal separator in the String
        var pattern = '([' + decimalSeparator + '])(?=.*\\1)';
        var formatted = input.replace(new RegExp(pattern, 'g'), '');
        // Remove anything that is not a number or a decimal separator
        formatted = formatted.replace(new RegExp('[^0-9' + decimalSeparator + ']', 'g'), '');
        return Number(formatted);
    };
    return AbbreviateAmountPipe;
}());
abbreviate_amount_pipe_AbbreviateAmountPipe = abbreviate_amount_pipe___decorate([
    Object(core_es5["Pipe"])({
        name: 'abbreviateAmount'
    }),
    abbreviate_amount_pipe___metadata("design:paramtypes", [typeof (abbreviate_amount_pipe__a = typeof common_es5["DecimalPipe"] !== "undefined" && common_es5["DecimalPipe"]) === "function" && abbreviate_amount_pipe__a || Object])
], abbreviate_amount_pipe_AbbreviateAmountPipe);

var abbreviate_amount_pipe__a;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/abbreviate-amount.pipe.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/directives/focus-outside.directive.ts
var focus_outside_directive___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var focus_outside_directive___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
/**
 * Followed the example in https://christianliebel.com/2016/05/angular-2-a-simple-click-outside-directive/
 */

var focus_outside_directive_FocusOutsideDirective = (function () {
    function FocusOutsideDirective(_elementRef) {
        this._elementRef = _elementRef;
        this.pioneerFocusOutside = new core_es5["EventEmitter"]();
        this.tabindex = -1;
    }
    FocusOutsideDirective.prototype.onFocusIn = function (targetElement) {
        var focusedInside = this._elementRef.nativeElement.contains(targetElement);
        if (!focusedInside) {
            this.pioneerFocusOutside.emit();
        }
    };
    return FocusOutsideDirective;
}());
focus_outside_directive___decorate([
    Object(core_es5["Output"])(),
    focus_outside_directive___metadata("design:type", Object)
], focus_outside_directive_FocusOutsideDirective.prototype, "pioneerFocusOutside", void 0);
focus_outside_directive___decorate([
    Object(core_es5["HostBinding"])('tabindex'),
    focus_outside_directive___metadata("design:type", Object)
], focus_outside_directive_FocusOutsideDirective.prototype, "tabindex", void 0);
focus_outside_directive___decorate([
    Object(core_es5["HostListener"])('document:focusin', ['$event.target']),
    focus_outside_directive___metadata("design:type", Function),
    focus_outside_directive___metadata("design:paramtypes", [Object]),
    focus_outside_directive___metadata("design:returntype", void 0)
], focus_outside_directive_FocusOutsideDirective.prototype, "onFocusIn", null);
focus_outside_directive_FocusOutsideDirective = focus_outside_directive___decorate([
    Object(core_es5["Directive"])({
        selector: '[pioneerFocusOutside]'
    }),
    focus_outside_directive___metadata("design:paramtypes", [typeof (focus_outside_directive__a = typeof core_es5["ElementRef"] !== "undefined" && core_es5["ElementRef"]) === "function" && focus_outside_directive__a || Object])
], focus_outside_directive_FocusOutsideDirective);

var focus_outside_directive__a;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/focus-outside.directive.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/pipes/highlight.pipe.ts
var highlight_pipe___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var HighlightPipe = (function () {
    function HighlightPipe() {
    }
    HighlightPipe.prototype.transform = function (value, searchText) {
        if (!searchText) {
            return value;
        }
        return value.replace(new RegExp(searchText, 'gi'), function (match) {
            return "<strong>" + match + "</strong>";
        });
    };
    return HighlightPipe;
}());
HighlightPipe = highlight_pipe___decorate([
    Object(core_es5["Pipe"])({
        name: 'highlight'
    })
], HighlightPipe);

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/highlight.pipe.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/pagination/pagination.component.ts
var pagination_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var pagination_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};




var pagination_component_PaginationComponent = (function () {
    function PaginationComponent(userLocalStorageService) {
        this.userLocalStorageService = userLocalStorageService;
        this.updatePage = new core_es5["EventEmitter"]();
    }
    PaginationComponent.prototype.ngOnInit = function () {
        if (this.pagesizeType === undefined) {
            throw new Error('The "paginatedList" input is undefined');
        }
        else {
            this.selectedItemsPerPage = this.userLocalStorageService.getPagesize(this.pagesizeType);
        }
    };
    PaginationComponent.prototype.ngOnChanges = function (changes) {
        var pagesize = this.userLocalStorageService.getPagesize(this.pagesizeType);
        this.selectedItemsPerPage = this.resultsPage ? this.resultsPage.size : pagesize;
        this.userLocalStorageService.setPagesize(this.pagesizeType, this.selectedItemsPerPage);
    };
    Object.defineProperty(PaginationComponent.prototype, "firstPageItemNumber", {
        get: function () {
            return (this.resultsPage.number * this.resultsPage.size) + 1;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PaginationComponent.prototype, "lastPageItemNumber", {
        get: function () {
            return (this.resultsPage.number * this.resultsPage.size) + this.resultsPage.numberOfElements;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PaginationComponent.prototype, "currentPageNumber", {
        get: function () {
            return this.resultsPage.number + 1;
        },
        enumerable: true,
        configurable: true
    });
    PaginationComponent.prototype.goToPage = function (pageNumber) {
        var page = pageNumber ? pageNumber - 1 : this.currentPageNumber - 1;
        var itemsPerPage = this.selectedItemsPerPage;
        this.updatePage.emit({ page: page, itemsPerPage: itemsPerPage });
    };
    PaginationComponent.prototype.onChangeItemsPerPage = function (newItemsPerPage) {
        this.selectedItemsPerPage = newItemsPerPage;
        this.userLocalStorageService.setPagesize(this.pagesizeType, this.selectedItemsPerPage);
        this.goToPage();
    };
    return PaginationComponent;
}());
pagination_component___decorate([
    Object(core_es5["Input"])(),
    pagination_component___metadata("design:type", typeof (pagination_component__a = typeof PagesizeType !== "undefined" && PagesizeType) === "function" && pagination_component__a || Object)
], pagination_component_PaginationComponent.prototype, "pagesizeType", void 0);
pagination_component___decorate([
    Object(core_es5["Input"])(),
    pagination_component___metadata("design:type", typeof (pagination_component__b = typeof page_Page !== "undefined" && page_Page) === "function" && pagination_component__b || Object)
], pagination_component_PaginationComponent.prototype, "resultsPage", void 0);
pagination_component___decorate([
    Object(core_es5["Output"])(),
    pagination_component___metadata("design:type", typeof (pagination_component__c = typeof core_es5["EventEmitter"] !== "undefined" && core_es5["EventEmitter"]) === "function" && pagination_component__c || Object)
], pagination_component_PaginationComponent.prototype, "updatePage", void 0);
pagination_component_PaginationComponent = pagination_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-pagination',
        template: __webpack_require__("Qe5c")
    }),
    pagination_component___metadata("design:paramtypes", [typeof (pagination_component__d = typeof user_local_storage_service_UserLocalStorageService !== "undefined" && user_local_storage_service_UserLocalStorageService) === "function" && pagination_component__d || Object])
], pagination_component_PaginationComponent);

var pagination_component__a, pagination_component__b, pagination_component__c, pagination_component__d;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/pagination.component.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/pagination-refresh/pagination-refresh.component.ts
var pagination_refresh_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var pagination_refresh_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};






var pagination_refresh_component_PaginationRefreshComponent = (function () {
    function PaginationRefreshComponent(userLocalStorageService, consoleLogSubscriberService) {
        this.userLocalStorageService = userLocalStorageService;
        this.consoleLogSubscriberService = consoleLogSubscriberService;
        this.disablePagination = false;
        this.resetTable = false;
        this.elResultsPage = [10, 25, 50, 100];
        this.updatePage = new core_es5["EventEmitter"]();
        this.currentPageNumber = 1;
    }
    PaginationRefreshComponent.prototype.ngOnInit = function () {
        if (this.pagesizeType === undefined) {
            throw new Error('The "paginatedList" input is undefined');
        }
        else {
            var actualSelectNumberPerPage = this.userLocalStorageService.getPagesize(this.pagesizeType);
            var existNumberPerPage = this.selectedNumberExist(actualSelectNumberPerPage);
            if (!existNumberPerPage) {
                this.onChangeItemsPerPage(this.elResultsPage[0]);
            }
            else {
                this.selectedItemsPerPage = actualSelectNumberPerPage;
            }
        }
    };
    PaginationRefreshComponent.prototype.ngOnChanges = function (changes) {
        if (changes.resetTable) {
            if (changes.resetTable.currentValue) {
                this.currentPageNumber = 1;
            }
        }
        if (changes.resultsPage && changes.resultsPage.currentValue !== changes.resultsPage.previousValue) {
            var pagesize = this.userLocalStorageService.getPagesize(this.pagesizeType);
            this.selectedItemsPerPage = this.resultsPage ? this.resultsPage.size : pagesize;
            this.userLocalStorageService.setPagesize(this.pagesizeType, this.selectedItemsPerPage);
        }
    };
    PaginationRefreshComponent.prototype.selectedNumberExist = function (actualSelectNumberPerPage) {
        return this.elResultsPage.filter(function (el) { return el === actualSelectNumberPerPage; }).length > 0;
    };
    PaginationRefreshComponent.prototype.logConsole = function (message) {
        this.consoleLogSubscriberService.log(new LogMessage(LogLevel.INFO, message));
    };
    Object.defineProperty(PaginationRefreshComponent.prototype, "firstPageItemNumber", {
        get: function () {
            return (this.resultsPage.number * this.resultsPage.size) + 1;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PaginationRefreshComponent.prototype, "lastPageItemNumber", {
        get: function () {
            return (this.resultsPage.number * this.resultsPage.size) + this.resultsPage.numberOfElements;
        },
        enumerable: true,
        configurable: true
    });
    PaginationRefreshComponent.prototype.goToPage = function (pageNumber) {
        var page = pageNumber ? pageNumber - 1 : 0;
        var itemsPerPage = this.selectedItemsPerPage;
        this.currentPageNumber = page + 1;
        if (!this.resetTable) {
            this.updatePage.emit({ page: page, itemsPerPage: itemsPerPage });
        }
    };
    PaginationRefreshComponent.prototype.onChangeItemsPerPage = function (newItemsPerPage) {
        this.selectedItemsPerPage = newItemsPerPage;
        this.userLocalStorageService.setPagesize(this.pagesizeType, this.selectedItemsPerPage);
        this.goToPage();
    };
    return PaginationRefreshComponent;
}());
pagination_refresh_component___decorate([
    Object(core_es5["Input"])(),
    pagination_refresh_component___metadata("design:type", typeof (pagination_refresh_component__a = typeof PagesizeType !== "undefined" && PagesizeType) === "function" && pagination_refresh_component__a || Object)
], pagination_refresh_component_PaginationRefreshComponent.prototype, "pagesizeType", void 0);
pagination_refresh_component___decorate([
    Object(core_es5["Input"])(),
    pagination_refresh_component___metadata("design:type", typeof (pagination_refresh_component__b = typeof page_Page !== "undefined" && page_Page) === "function" && pagination_refresh_component__b || Object)
], pagination_refresh_component_PaginationRefreshComponent.prototype, "resultsPage", void 0);
pagination_refresh_component___decorate([
    Object(core_es5["Input"])(),
    pagination_refresh_component___metadata("design:type", Object)
], pagination_refresh_component_PaginationRefreshComponent.prototype, "disablePagination", void 0);
pagination_refresh_component___decorate([
    Object(core_es5["Input"])(),
    pagination_refresh_component___metadata("design:type", Object)
], pagination_refresh_component_PaginationRefreshComponent.prototype, "resetTable", void 0);
pagination_refresh_component___decorate([
    Object(core_es5["Input"])(),
    pagination_refresh_component___metadata("design:type", Array)
], pagination_refresh_component_PaginationRefreshComponent.prototype, "elResultsPage", void 0);
pagination_refresh_component___decorate([
    Object(core_es5["Output"])(),
    pagination_refresh_component___metadata("design:type", typeof (pagination_refresh_component__c = typeof core_es5["EventEmitter"] !== "undefined" && core_es5["EventEmitter"]) === "function" && pagination_refresh_component__c || Object)
], pagination_refresh_component_PaginationRefreshComponent.prototype, "updatePage", void 0);
pagination_refresh_component_PaginationRefreshComponent = pagination_refresh_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-pagination-refresh',
        template: __webpack_require__("X9TO")
    }),
    pagination_refresh_component___metadata("design:paramtypes", [typeof (pagination_refresh_component__d = typeof user_local_storage_service_UserLocalStorageService !== "undefined" && user_local_storage_service_UserLocalStorageService) === "function" && pagination_refresh_component__d || Object, typeof (pagination_refresh_component__e = typeof console_log_subscriber_service_ConsoleLogSubscriberService !== "undefined" && console_log_subscriber_service_ConsoleLogSubscriberService) === "function" && pagination_refresh_component__e || Object])
], pagination_refresh_component_PaginationRefreshComponent);

var pagination_refresh_component__a, pagination_refresh_component__b, pagination_refresh_component__c, pagination_refresh_component__d, pagination_refresh_component__e;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/pagination-refresh.component.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/payment/model/payment-equation.ts
var payment_equation___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var PaymentEquationRecord = Object(immutable["Record"])({
    roomCommissions: null,
    adjustments: null,
    prepayment: null,
    totalPaymentRequested: null,
    totalEstimatedTax: null
});
var PaymentEquation = (function (_super) {
    payment_equation___extends(PaymentEquation, _super);
    function PaymentEquation() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return PaymentEquation;
}(PaymentEquationRecord));

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/payment-equation.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/components/payment-calculation/payment-calculation.component.ts
var payment_calculation_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var payment_calculation_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};


var PaymentCalculationComponent = (function () {
    function PaymentCalculationComponent() {
    }
    PaymentCalculationComponent.prototype.ngOnInit = function () {
    };
    return PaymentCalculationComponent;
}());
payment_calculation_component___decorate([
    Object(core_es5["Input"])(),
    payment_calculation_component___metadata("design:type", String)
], PaymentCalculationComponent.prototype, "currency", void 0);
payment_calculation_component___decorate([
    Object(core_es5["Input"])(),
    payment_calculation_component___metadata("design:type", typeof (payment_calculation_component__a = typeof PaymentEquation !== "undefined" && PaymentEquation) === "function" && payment_calculation_component__a || Object)
], PaymentCalculationComponent.prototype, "paymentEquation", void 0);
payment_calculation_component___decorate([
    Object(core_es5["Input"])(),
    payment_calculation_component___metadata("design:type", Boolean)
], PaymentCalculationComponent.prototype, "isHotelApprover", void 0);
payment_calculation_component___decorate([
    Object(core_es5["Input"])(),
    payment_calculation_component___metadata("design:type", Boolean)
], PaymentCalculationComponent.prototype, "showCurrencyNote", void 0);
payment_calculation_component___decorate([
    Object(core_es5["Input"])(),
    payment_calculation_component___metadata("design:type", Object)
], PaymentCalculationComponent.prototype, "fundCurrency", void 0);
payment_calculation_component___decorate([
    Object(core_es5["Input"])(),
    payment_calculation_component___metadata("design:type", Boolean)
], PaymentCalculationComponent.prototype, "applyOoiv", void 0);
PaymentCalculationComponent = payment_calculation_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-payment-calculation',
        template: __webpack_require__("3aUR")
    }),
    payment_calculation_component___metadata("design:paramtypes", [])
], PaymentCalculationComponent);

var payment_calculation_component__a;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/payment-calculation.component.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/directives/uppercase.directive.ts
var uppercase_directive___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var uppercase_directive___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};


var UppercaseDirective = (function () {
    function UppercaseDirective(control) {
        this.control = control;
    }
    UppercaseDirective.prototype.onInput = function (value) {
        this.capitalize(value);
    };
    UppercaseDirective.prototype.capitalize = function (value) {
        this.control.control.patchValue(value.toUpperCase());
    };
    return UppercaseDirective;
}());
uppercase_directive___decorate([
    Object(core_es5["HostListener"])('input', ['$event.target.value']),
    uppercase_directive___metadata("design:type", Function),
    uppercase_directive___metadata("design:paramtypes", [String]),
    uppercase_directive___metadata("design:returntype", void 0)
], UppercaseDirective.prototype, "onInput", null);
UppercaseDirective = uppercase_directive___decorate([
    Object(core_es5["Directive"])({
        selector: '[pioneerUppercase]'
    }),
    uppercase_directive___metadata("design:paramtypes", [typeof (uppercase_directive__a = typeof forms_es5["NgControl"] !== "undefined" && forms_es5["NgControl"]) === "function" && uppercase_directive__a || Object])
], UppercaseDirective);

var uppercase_directive__a;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/uppercase.directive.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/pipes/master-bill.pipe.ts
var master_bill_pipe___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var master_bill_pipe___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};



var MasterBillPipe = (function () {
    function MasterBillPipe(translateService, logService) {
        this.translateService = translateService;
        this.logService = logService;
    }
    MasterBillPipe.prototype.transform = function (value, args) {
        // Pipes need to handle nulls/undefined
        if (!value) {
            value = false;
        }
        var returnValue = '';
        switch (value) {
            case false:
                returnValue = this.translateService.instant('EVENTS.MASTER_BILL_NOT_PAID');
                break;
            case true:
                returnValue = this.translateService.instant('EVENTS.MASTER_BILL_PAID');
                break;
            default:
                this.logService.info(this.translateService.instant('EVENTS.MASTER_BILL_UNKNOWN', { key: value }));
        }
        return returnValue;
    };
    return MasterBillPipe;
}());
MasterBillPipe = master_bill_pipe___decorate([
    Object(core_es5["Pipe"])({
        name: 'masterBill'
    }),
    master_bill_pipe___metadata("design:paramtypes", [typeof (master_bill_pipe__a = typeof core["c" /* TranslateService */] !== "undefined" && core["c" /* TranslateService */]) === "function" && master_bill_pipe__a || Object, typeof (master_bill_pipe__b = typeof log_service_LogService !== "undefined" && log_service_LogService) === "function" && master_bill_pipe__b || Object])
], MasterBillPipe);

var master_bill_pipe__a, master_bill_pipe__b;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/master-bill.pipe.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/contact.ts
var contact___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var ContactRecord = Object(immutable["Record"])({
    eventContactId: 0,
    version: 0,
    createDate: null,
    modifiedDate: null,
    partyType: null,
    eventId: null,
    firstName: null,
    lastName: null,
    email: null,
    phone: null,
    fax: null
});
var Contact = (function (_super) {
    contact___extends(Contact, _super);
    function Contact() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Contact;
}(ContactRecord));

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/contact.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/vendor-payment-summary.ts
var vendor_payment_summary___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var VendorPaymentSummaryRecord = Object(immutable["Record"])({
    prepaymentId: 0,
    prepayStatus: null,
    prepaymentCreatedDate: null,
    prepaymentModifiedDate: null,
    prepaymentAmount: null,
    paymentId: 0,
    payStatus: null,
    paymentCreatedDate: null,
    paymentModifiedDate: null,
    paymentAmount: null,
    taxAmount: null,
    adjustmentAmount: null,
    dueAmount: null,
    currency: null
});
var VendorPaymentSummary = (function (_super) {
    vendor_payment_summary___extends(VendorPaymentSummary, _super);
    function VendorPaymentSummary() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return VendorPaymentSummary;
}(VendorPaymentSummaryRecord));

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/vendor-payment-summary.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/party.ts
var party___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var PartyRecord = Object(immutable["Record"])({
    eventPartyId: 0,
    version: 0,
    createDate: null,
    modifiedDate: null,
    brand: null,
    chain: null,
    propertyId: null,
    agencyId: null,
    partyType: null,
    payorType: null,
    code: null,
    name: null,
    dbaName: null,
    countryCode: null,
    eventId: null,
    line1: null,
    line2: null,
    line3: null,
    city: null,
    state: null,
    postalCode: null,
    eventReferenceNumber: null,
    startDate: null,
    endDate: null,
    autoGeneratedCode: null,
    manuallyAdded: null,
    contact: new Contact(),
    subscriber: null,
    commissionRoomPercentage: null,
    commRetention: false,
    masterBillPaid: false,
    isExpanded: false,
    paymentSummary: new VendorPaymentSummary(),
    partyEventName: null,
    createdEvent: null,
    mergedEvent: null,
    ratePlanCodes: [],
    userRef01: null,
    userRef02: null,
    userRef03: null,
    userRef04: null,
    userRef05: null,
    taxResponseList: null,
    config: null,
    eventAgencyStatus: null,
    originalCode: null
});
var Party = (function (_super) {
    party___extends(Party, _super);
    function Party() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Party;
}(PartyRecord));

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/party.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/event.ts
var event___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var EventRecord = Object(immutable["Record"])({
    eventId: null,
    version: null,
    createdDate: null,
    modifiedDate: null,
    eventAgency: new Party(),
    eventClient: new Party(),
    eventProperty: new Party(),
    eventVendors: [],
    inactive: null,
    autoGenerated: false,
    autoPayment: null,
    canBeDeleted: false,
    canBeUnmatched: false,
    canManageReservations: false,
    currency: null,
    ratePlanCodes: [],
    shoulderDatesCommission: false,
    city: null,
    state: null,
    countryCode: null,
    eventMatchId: null,
    evTmpGuid: null,
    hasOoivExceptions: null
});
var OnyxEvent = (function (_super) {
    event___extends(OnyxEvent, _super);
    function OnyxEvent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OnyxEvent.prototype.isAgencyControlled = function () {
        return !this.eventProperty.subscriber;
    };
    OnyxEvent.prototype.isPropertyControlled = function () {
        return this.eventProperty.subscriber;
    };
    return OnyxEvent;
}(EventRecord));

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/event.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/rate-plan-code-reservation-counts.ts
var rate_plan_code_reservation_counts___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var RatePlanCodeReservationCountsRecord = Object(immutable["Record"])({
    eventId: null,
    ratePlanCode: null,
    reservationCount: null
});
var RatePlanCodeReservationCounts = (function (_super) {
    rate_plan_code_reservation_counts___extends(RatePlanCodeReservationCounts, _super);
    function RatePlanCodeReservationCounts() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return RatePlanCodeReservationCounts;
}(RatePlanCodeReservationCountsRecord));

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/rate-plan-code-reservation-counts.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/event-has-items-by-vendor.ts
var event_has_items_by_vendor___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var EventHasItemsByVendorRecord = Object(immutable["Record"])({
    hasReservationsByVendor: null,
    hasRsvpsByVendor: null
});
var EventHasItemsByVendor = (function (_super) {
    event_has_items_by_vendor___extends(EventHasItemsByVendor, _super);
    function EventHasItemsByVendor() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return EventHasItemsByVendor;
}(EventHasItemsByVendorRecord));

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/event-has-items-by-vendor.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/service/event.http.service.ts
var event_http_service___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var event_http_service___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};










var event_http_service_EventHttpService = (function () {
    function EventHttpService(http, environment, responseUtilService) {
        this.http = http;
        this.environment = environment;
        this.responseUtilService = responseUtilService;
        this.eventsGetUrl = this.environment.baseUrl + '/api/events';
        this.eventSearchUrl = this.environment.baseUrl + '/api/events/search';
        this.eventDashboardSearchUrl = this.environment.baseUrl + '/api/events/search-dashboard';
        this.eventsAddUrl = this.environment.baseUrl + '/api/events';
        this.eventsAddAgencyUrl = this.environment.baseUrl + '/api/events/agency';
        this.eventsUpdateUrl = this.environment.baseUrl + '/api/events';
        this.eventsUpdateAgencyUrl = this.environment.baseUrl + '/api/events/agency';
        this.eventsUpdateIndicatorsUrl = this.environment.baseUrl + '/api/events/indicators';
        this.eventsBulkUploadUrl = this.environment.baseUrl + '/api/events/bulkUpload';
        this.eventReportExcelUrl = this.environment.baseUrl + '/api/events/report/excel ';
        this.staySummaryUrl = this.environment.baseUrl + '/api/events/stay-summary';
        this.vendorStaySummaryUrl = this.environment.baseUrl + '/api/events/stay-summary-vendor';
        this.eventsUpdateAutoPayUrl = this.environment.baseUrl + '/api/events/auto-pay';
        this.ratePlanCodeValidationUrl = this.environment.baseUrl + '/api/events/rate-plan-code-validation';
        this.eventsUrl = this.environment.baseUrl + '/api/events';
    }
    Object.defineProperty(EventHttpService.prototype, "jsonOptions", {
        get: function () {
            var headers = new http_es5["Headers"]({ 'Content-Type': 'application/json' });
            var options = new http_es5["RequestOptions"]({ headers: headers });
            return options;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EventHttpService.prototype, "fileOptions", {
        get: function () {
            var headers = new http_es5["Headers"]({ 'Content-Type': 'application/json' });
            var options = new http_es5["RequestOptions"]({
                headers: headers,
                responseType: http_es5["ResponseContentType"].Blob
            });
            return options;
        },
        enumerable: true,
        configurable: true
    });
    EventHttpService.prototype.search = function (sp, page, size, isSpinner) {
        var _this = this;
        if (isSpinner === void 0) { isSpinner = true; }
        return this.http.post(this.eventSearchUrl + "?page=" + page + "&size=" + size, JSON.stringify(sp.toJS()), this.jsonOptions, isSpinner)
            .map(function (response) {
            var eventsPage = response.json();
            eventsPage.content = Object(immutable["List"])(eventsPage.content);
            return eventsPage;
        })
            .catch(function (response) {
            _this.responseUtilService.handleError(response);
            return Observable["Observable"].throw(response);
        })
            .share();
    };
    EventHttpService.prototype.get = function (eventId) {
        var _this = this;
        return this.http.get(this.eventsGetUrl + "/" + eventId)
            .map(function (response) { return response.json(); })
            .catch(function (response) { return _this.responseUtilService.handleError(response); }).share();
    };
    EventHttpService.prototype.getByParty = function (eventId, eventPartyId) {
        var _this = this;
        return this.http.get(this.eventsGetUrl + "/" + eventId + "/" + eventPartyId)
            .map(function (response) { return response.json(); })
            .catch(function (response) { return _this.responseUtilService.handleError(response); }).share();
    };
    EventHttpService.prototype.add = function (newRec) {
        var _this = this;
        return this.http.post(this.eventsAddUrl, JSON.stringify(newRec.toJS()), this.jsonOptions)
            .map(function (response) { return response.json(); })
            .catch(function (response) { return _this.responseUtilService.handleError(response); }).share();
    };
    EventHttpService.prototype.addAsAgency = function (newRec) {
        var _this = this;
        return this.http.post(this.eventsAddAgencyUrl, JSON.stringify(newRec.toJS()), this.jsonOptions)
            .map(function (response) { return response.json(); })
            .catch(function (response) { return _this.responseUtilService.handleError(response); }).share();
    };
    EventHttpService.prototype.update = function (updatedRec) {
        var _this = this;
        return this.http.put(this.eventsUpdateUrl, JSON.stringify(updatedRec.toJS()), this.jsonOptions)
            .map(function (response) { return response.json(); })
            .catch(function (response) { return _this.responseUtilService.handleError(response); }).share();
    };
    EventHttpService.prototype.updateAsAgency = function (updatedRec) {
        var _this = this;
        return this.http.put(this.eventsUpdateAgencyUrl, JSON.stringify(updatedRec.toJS()), this.jsonOptions)
            .map(function (response) { return response.json(); })
            .catch(function (response) { return _this.responseUtilService.handleError(response); }).share();
    };
    EventHttpService.prototype.delete = function (eventId) {
        var _this = this;
        return this.http.delete(this.eventsGetUrl + "/" + eventId)
            .map(function (response) { return response.json(); })
            .catch(function (response) { return _this.responseUtilService.handleError(response); }).share();
    };
    EventHttpService.prototype.updateIndicators = function (updatedRec) {
        var _this = this;
        return this.http.put(this.eventsUpdateIndicatorsUrl, JSON.stringify(updatedRec.toJS()), this.jsonOptions)
            .map(function (response) { return response.json(); })
            .catch(function (response) { return _this.responseUtilService.handleError(response); }).share();
    };
    EventHttpService.prototype.importEventsViaCsv = function (file) {
        var _this = this;
        var formData = new FormData();
        formData.append('file', file);
        return this.http.post("" + this.eventsBulkUploadUrl, formData)
            .map(function (response) { return response.json(); })
            .catch(function (response) { return _this.responseUtilService.handleError(response); }).share();
    };
    EventHttpService.prototype.downloadInvalidEventsCsv = function (fileId) {
        this.http.get("" + this.eventsBulkUploadUrl + "/" + fileId);
        return Observable["Observable"].of(null);
    };
    EventHttpService.prototype.getRecentlyEvents = function (searchParameters) {
        return this.http.post(this.eventDashboardSearchUrl, JSON.stringify(searchParameters), this.jsonOptions)
            .map(function (response) { return response.json(); }).catch(response_util_ResponseUtil.unwrapErrorMessage).share();
    };
    EventHttpService.prototype.exportEventExcel = function (searchParameters) {
        var _this = this;
        return this.http.post(this.eventReportExcelUrl, JSON.stringify(searchParameters), this.fileOptions)
            .map(function (res) { return new Blob([res.blob()], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }); })
            .catch(function (response) { return _this.responseUtilService.handleError(response); });
    };
    EventHttpService.prototype.getStaySummary = function (event) {
        return this.httpPost(this.staySummaryUrl, event);
    };
    EventHttpService.prototype.getVendorStaySummary = function (request) {
        return this.httpPost(this.vendorStaySummaryUrl, request);
    };
    EventHttpService.prototype.getRatePlanCodeValidation = function (request) {
        return this.httpPost(this.ratePlanCodeValidationUrl, request);
    };
    EventHttpService.prototype.getReservationCountForRatePlanCode = function (eventPartyId, ratePlanCode) {
        var _this = this;
        var url = this.environment.baseUrl + ("/api/events/" + eventPartyId + "/rate-plan-codes/" + ratePlanCode + "/reservation-counts");
        return this.http.get(url)
            .map(function (response) { return new RatePlanCodeReservationCounts(response.json()); })
            .catch(function (response) { return _this.responseUtilService.handleError(response); }).share();
    };
    EventHttpService.prototype.httpPost = function (url, request) {
        var _this = this;
        var options = new http_es5["RequestOptions"]({ headers: new http_es5["Headers"]({ 'Content-Type': 'application/json' }) });
        return this.http.post(url, JSON.stringify(request), options)
            .map(function (response) { return response.json(); })
            .catch(function (error) { return _this.responseUtilService.handleError(error); })
            .share();
    };
    EventHttpService.prototype.status = function (eventId) {
        var _this = this;
        return this.http.get(this.eventsGetUrl + "/" + eventId + "/status")
            .map(function (response) { return response.json(); })
            .catch(function (response) { return _this.responseUtilService.handleError(response); }).share();
    };
    EventHttpService.prototype.updateAutoPayment = function (updatedRec) {
        var _this = this;
        return this.http.put(this.eventsUpdateAutoPayUrl, JSON.stringify(updatedRec.toJS()), this.jsonOptions)
            .map(function (response) { return response.json(); })
            .catch(function (response) { return _this.responseUtilService.handleError(response); }).share();
    };
    EventHttpService.prototype.fetchHasItems = function (eventId) {
        var _this = this;
        return this.http.get(this.eventsUrl + "/" + eventId + "/has-items")
            .map(function (response) { return new EventHasItemsByVendor(response.json()); })
            .catch(function (response) { return _this.responseUtilService.handleError(response); })
            .share();
    };
    EventHttpService.prototype.fetchHasItemsByParty = function (eventId, eventPartyId) {
        var _this = this;
        return this.http.get(this.eventsUrl + "/" + eventId + "/" + eventPartyId + "/has-items")
            .map(function (response) { return new EventHasItemsByVendor(response.json()); })
            .catch(function (response) { return _this.responseUtilService.handleError(response); })
            .share();
    };
    return EventHttpService;
}());
event_http_service_EventHttpService = event_http_service___decorate([
    Object(core_es5["Injectable"])(),
    event_http_service___metadata("design:paramtypes", [typeof (event_http_service__a = typeof AppAuthHttpService !== "undefined" && AppAuthHttpService) === "function" && event_http_service__a || Object, typeof (event_http_service__b = typeof EnvironmentConfiguration !== "undefined" && EnvironmentConfiguration) === "function" && event_http_service__b || Object, typeof (event_http_service__c = typeof response_util_service_ResponseUtilService !== "undefined" && response_util_service_ResponseUtilService) === "function" && event_http_service__c || Object])
], event_http_service_EventHttpService);

var event_http_service__a, event_http_service__b, event_http_service__c;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/event.http.service.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/service/event.store.ts
var event_store___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var event_store___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};







var event_store_EventStore = (function () {
    function EventStore(eventHttpService, translateService, userLocalStorageService, flashMessagesService) {
        this.eventHttpService = eventHttpService;
        this.translateService = translateService;
        this.userLocalStorageService = userLocalStorageService;
        this.flashMessagesService = flashMessagesService;
        this.mySelectedEvent = new BehaviorSubject["BehaviorSubject"](null);
    }
    Object.defineProperty(EventStore.prototype, "selectedEvent", {
        /**
         * Returns an observable containing the current event.
         * Used in any case when data needs to be shown on a screen.
         *
         * @returns {Observable<T>}
         */
        get: function () {
            return this.mySelectedEvent.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    EventStore.prototype.resetSelectedEvent = function () {
        this.mySelectedEvent.next(null);
    };
    /**
     * Retrieves event.  This method returns an observable
     * and should be used only in route resolvers.
     *
     * @param eventId
     * @returns {Observable<OnyxEvent>}
     */
    EventStore.prototype.getEvent = function (eventId) {
        var _this = this;
        return this.eventHttpService.get(eventId)
            .catch(function (error) {
            // Catch error here so resolver also displays error.
            _this.flashMessagesService.error('MESSAGES.ERROR.GET_EVENT', "Error retrieving OnyxEvent: " + error);
            return Observable["Observable"].throw(error);
        })
            .map(function (res) {
            _this.mySelectedEvent.next(res);
            return res;
        });
    };
    /**
     * Retrieves event.  This method returns an observable
     * and should be used only in route resolvers.
     *
     * @param eventId
     * @param eventPartyId
     * @returns {Observable<OnyxEvent>}
     */
    EventStore.prototype.getEventByParty = function (eventId, eventPartyId) {
        var _this = this;
        return this.eventHttpService.getByParty(eventId, eventPartyId)
            .catch(function (error) {
            // Catch error here so resolver also displays error.
            _this.flashMessagesService.error('MESSAGES.ERROR.GET_EVENT', "Error retrieving OnyxEvent: " + error);
            return Observable["Observable"].throw(error);
        })
            .map(function (res) {
            _this.mySelectedEvent.next(res);
            return res;
        });
    };
    EventStore.prototype.setEvent = function (event) {
        this.mySelectedEvent.next(event);
    };
    EventStore.prototype.addEvent = function (newRec) {
        var _this = this;
        return this.eventHttpService.add(newRec)
            .map(function (res) {
            _this.flashMessagesService.success('MESSAGES.SUCCESS.SAVE_EVENT');
            _this.mySelectedEvent.next(res);
            setTimeout(function () {
                if (res.hasOoivExceptions) {
                    _this.flashMessagesService.error(_this.translateService.instant('MESSAGES.ERROR.ADDITIONAL_TAX_INFO_PROMPT', { 'role': 'Agency' }));
                }
            }, 2000);
            return res;
        });
    };
    EventStore.prototype.addAgencyEvent = function (newRec) {
        var _this = this;
        return this.eventHttpService.addAsAgency(newRec)
            .map(function (res) {
            _this.flashMessagesService.success('MESSAGES.SUCCESS.SAVE_EVENT');
            _this.mySelectedEvent.next(res);
            setTimeout(function () {
                if (res.hasOoivExceptions) {
                    _this.flashMessagesService.error(_this.translateService.instant('MESSAGES.ERROR.ADDITIONAL_TAX_INFO_PROMPT', { 'role': 'Agency' }));
                }
            }, 2000);
            return res;
        });
    };
    EventStore.prototype.updateEvent = function (newRec) {
        var _this = this;
        return this.eventHttpService.update(newRec)
            .map(function (res) {
            _this.flashMessagesService.success('MESSAGES.SUCCESS.SAVE_EVENT');
            _this.mySelectedEvent.next(res);
            setTimeout(function () {
                if (res.hasOoivExceptions) {
                    _this.flashMessagesService.error(_this.translateService.instant('MESSAGES.ERROR.ADDITIONAL_TAX_INFO_PROMPT', { 'role': 'Agency' }));
                }
            }, 2000);
            return res;
        });
    };
    EventStore.prototype.updateAgencyEvent = function (newRec) {
        var _this = this;
        return this.eventHttpService.updateAsAgency(newRec)
            .map(function (res) {
            _this.flashMessagesService.success('MESSAGES.SUCCESS.SAVE_EVENT');
            _this.mySelectedEvent.next(res);
            setTimeout(function () {
                if (res.hasOoivExceptions) {
                    _this.flashMessagesService.error(_this.translateService.instant('MESSAGES.ERROR.ADDITIONAL_TAX_INFO_PROMPT', { 'role': 'Agency' }));
                }
            }, 2000);
            return res;
        });
    };
    EventStore.prototype.updateEventIndicators = function (newRec) {
        var _this = this;
        return this.eventHttpService.updateIndicators(newRec)
            .map(function (res) {
            _this.flashMessagesService.success('MESSAGES.SUCCESS.SAVE_EVENT');
            _this.mySelectedEvent.next(res);
            return res;
        });
    };
    EventStore.prototype.downloadInvalidEventsCsv = function (fileId) {
        return this.eventHttpService.downloadInvalidEventsCsv(fileId);
    };
    EventStore.prototype.deleteEvent = function (eventId) {
        var _this = this;
        return this.eventHttpService.delete(eventId)
            .catch((function (error) {
            _this.flashMessagesService.error('MESSAGES.ERROR.DELETE_EVENT');
            return Observable["Observable"].throw(error);
        }))
            .map(function (res) {
            _this.flashMessagesService.success('MESSAGES.SUCCESS.DELETE_EVENT');
            _this.mySelectedEvent.next(null);
            return res;
        });
    };
    EventStore.prototype.importEventsViaCsv = function (file) {
        return this.eventHttpService.importEventsViaCsv(file)
            .catch((function (error) {
            return Observable["Observable"].throw(error);
        }))
            .map(function (importResponse) {
            return importResponse;
        });
    };
    EventStore.prototype.getStaySummary = function (event) {
        var _this = this;
        return this.eventHttpService.getStaySummary(event)
            .catch(function (error) {
            _this.flashMessagesService.error('MESSAGES.ERROR.GET_EVENT', "Error retrieving stay summary: " + error);
            return Observable["Observable"].throw(error);
        });
    };
    EventStore.prototype.getVendorStaySummary = function (request) {
        var _this = this;
        return this.eventHttpService.getVendorStaySummary(request)
            .catch(function (error) {
            _this.flashMessagesService.error('MESSAGES.ERROR.GET_EVENT', "Error retrieving vendor stay summary: " + error);
            return Observable["Observable"].throw(error);
        });
    };
    EventStore.prototype.getRatePlanCodeValidation = function (request) {
        return this.eventHttpService.getRatePlanCodeValidation(request)
            .catch(function (error) {
            return Observable["Observable"].throw(error);
        });
    };
    EventStore.prototype.getReservationCountForRatePlanCode = function (eventPartyId, ratePlanCode) {
        return this.eventHttpService.getReservationCountForRatePlanCode(eventPartyId, ratePlanCode)
            .catch(function (error) {
            return Observable["Observable"].throw(error);
        });
    };
    EventStore.prototype.getEventStatus = function (eventId) {
        var _this = this;
        return this.eventHttpService.status(eventId)
            .catch(function (error) {
            // Catch error here so resolver also displays error.
            _this.flashMessagesService.error('MESSAGES.ERROR.GET_EVENT_STATUS', "Error retrieving OnyxSummaryEvent: " + error);
            return Observable["Observable"].throw(error);
        })
            .map(function (res) {
            return res.vendorsPaymentStatus;
        });
    };
    EventStore.prototype.updateAutoPayment = function (event) {
        var _this = this;
        return this.eventHttpService.updateAutoPayment(event)
            .map(function (res) {
            _this.flashMessagesService.success('MESSAGES.SUCCESS.SAVE_EVENT');
            _this.mySelectedEvent.next(res);
            return res;
        });
    };
    return EventStore;
}());
event_store_EventStore = event_store___decorate([
    Object(core_es5["Injectable"])(),
    event_store___metadata("design:paramtypes", [typeof (event_store__a = typeof event_http_service_EventHttpService !== "undefined" && event_http_service_EventHttpService) === "function" && event_store__a || Object, typeof (event_store__b = typeof core["c" /* TranslateService */] !== "undefined" && core["c" /* TranslateService */]) === "function" && event_store__b || Object, typeof (event_store__c = typeof user_local_storage_service_UserLocalStorageService !== "undefined" && user_local_storage_service_UserLocalStorageService) === "function" && event_store__c || Object, typeof (event_store__d = typeof flash_messages_service_FlashMessagesService !== "undefined" && flash_messages_service_FlashMessagesService) === "function" && event_store__d || Object])
], event_store_EventStore);

var event_store__a, event_store__b, event_store__c, event_store__d;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/event.store.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/multi-agency/multi-agency.service.ts
var multi_agency_service___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var multi_agency_service___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};











var multi_agency_service_MultiAgencyService = MultiAgencyService_1 = (function () {
    function MultiAgencyService(authenticationStore, userLocalStorageService, eventStore) {
        this.authenticationStore = authenticationStore;
        this.userLocalStorageService = userLocalStorageService;
        this.eventStore = eventStore;
        this.multiAgency = Object(immutable["List"])();
        this.singleAgencySubject = new ReplaySubject["ReplaySubject"](1);
        this.multiAgencySubject = new ReplaySubject["ReplaySubject"](1);
        this.defaultAgency = new BehaviorSubject["BehaviorSubject"](null);
        this.defaultAgency$ = this.defaultAgency.asObservable();
        this.agenciesList = new BehaviorSubject["BehaviorSubject"](null);
        this.agenciesList$ = this.agenciesList.asObservable();
        this.isEventSelected = new BehaviorSubject["BehaviorSubject"](null);
        this.isEventSelected$ = this.isEventSelected.asObservable();
        this.currentAgencyId = null;
        this.init();
    }
    MultiAgencyService.prototype.init = function () {
        var _this = this;
        this.authenticationStore.user.subscribe(function (user) {
            _this.user = user;
        });
        this.authenticationStore.defaultAgency$.subscribe(function () {
            _this.setAgencyInfo();
            _this.setMultiAgencies();
        });
        this.eventStore.selectedEvent.subscribe(function (event) {
            if (event && EventUtils.getEventName(event, _this.authenticationStore.isAgencyUser())) {
                _this.isEventSelected.next(true);
            }
            else {
                _this.isEventSelected.next(false);
            }
            _this.onyxEvent = new OnyxEvent(event);
        });
        this.agencySelectedUI = false;
    };
    MultiAgencyService.prototype.setAgencyInfo = function () {
        if (!this.agencySelectedUI && this.user.type === UserType.AGENCY) {
            var current_agency_key = this.user.username.toUpperCase() + '_' + MultiAgencyService_1.CURRENT_AGENCY;
            var agency = this.userLocalStorageService.getItemAsJson(current_agency_key);
            if (agency) {
                this.setDefaultAgency(agency);
            }
            else {
                this.resetDefaultAgency();
            }
        }
    };
    MultiAgencyService.prototype.setDefaultAgency = function (multiAgency) {
        if (this.currentAgencyId !== multiAgency.agencyId) {
            var current_agency_key = this.user.username.toUpperCase() + '_' + MultiAgencyService_1.CURRENT_AGENCY;
            this.userLocalStorageService.setItem(current_agency_key, JSON.stringify(multiAgency));
            this.currentAgencyId = multiAgency.agencyId;
            this.defaultAgency.next(multiAgency);
        }
    };
    MultiAgencyService.prototype.resetDefaultAgency = function () {
        this.defaultAgency.next(null);
    };
    Object.defineProperty(MultiAgencyService.prototype, "oldAgencyId", {
        get: function () {
            return this.currentAgencyId;
        },
        enumerable: true,
        configurable: true
    });
    MultiAgencyService.prototype.setMultiAgencies = function () {
        if (this.userLocalStorageService.getItem(MultiAgencyService_1.MULTI_AGENCY)) {
            this.multiAgency = this.userLocalStorageService.getItemAsJson(MultiAgencyService_1.MULTI_AGENCY);
            this.agenciesList.next(this.multiAgency);
        }
        else {
            this.multiAgency = null;
            this.agenciesList.next(null);
        }
    };
    Object.defineProperty(MultiAgencyService.prototype, "agencies", {
        get: function () {
            return this.agenciesList$
                .catch(function (error) {
                return Observable["Observable"].throw(error);
            })
                .map(function (agencies) {
                return agencies;
            });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MultiAgencyService.prototype, "defaultAgencyId", {
        get: function () {
            return this.defaultAgency$
                .catch(function (error) {
                return Observable["Observable"].throw(error);
            })
                .map(function (agency) {
                return agency ? agency.agencyId : null;
            });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MultiAgencyService.prototype, "defaultAgencyName", {
        get: function () {
            return this.defaultAgency$
                .catch(function (error) {
                return Observable["Observable"].throw(error);
            })
                .map(function (agency) {
                return agency.agencyName;
            });
        },
        enumerable: true,
        configurable: true
    });
    MultiAgencyService.prototype.isMultiAgency = function () {
        this.multiAgencySubject.next(this.hasDefaultAgency() && this.hasMultiAgency());
        return this.multiAgencySubject.asObservable();
    };
    MultiAgencyService.prototype.isSingleAgency = function () {
        this.singleAgencySubject.next(this.hasDefaultAgency() && !this.hasMultiAgency());
        return this.singleAgencySubject.asObservable();
    };
    MultiAgencyService.prototype.isSingleAgencyNew = function () {
        return this.defaultAgency$ && !this.hasMultiAgency();
    };
    MultiAgencyService.prototype.hasDefaultAgency = function () {
        var hasAgency;
        this.defaultAgency$.take(1).subscribe(function (agency) {
            if (agency && agency.agencyId) {
                hasAgency = true;
            }
            else {
                hasAgency = false;
            }
        });
        return hasAgency;
    };
    MultiAgencyService.prototype.hasMultiAgency = function () {
        return this.multiAgency && this.multiAgency[0];
    };
    MultiAgencyService.prototype.setEventSelected = function (value) {
        this.isEventSelected.next(value);
    };
    MultiAgencyService.prototype.setAgencySelectedUI = function (value) {
        this.agencySelectedUI = value;
    };
    return MultiAgencyService;
}());
multi_agency_service_MultiAgencyService.CURRENT_AGENCY = 'CURRENT_AGENCY';
multi_agency_service_MultiAgencyService.MULTI_AGENCY = 'MULTI_AGENCY';
multi_agency_service_MultiAgencyService = MultiAgencyService_1 = multi_agency_service___decorate([
    Object(core_es5["Injectable"])(),
    multi_agency_service___metadata("design:paramtypes", [typeof (multi_agency_service__a = typeof authentication_store_AuthenticationStore !== "undefined" && authentication_store_AuthenticationStore) === "function" && multi_agency_service__a || Object, typeof (multi_agency_service__b = typeof user_local_storage_service_UserLocalStorageService !== "undefined" && user_local_storage_service_UserLocalStorageService) === "function" && multi_agency_service__b || Object, typeof (multi_agency_service__c = typeof event_store_EventStore !== "undefined" && event_store_EventStore) === "function" && multi_agency_service__c || Object])
], multi_agency_service_MultiAgencyService);

var MultiAgencyService_1, multi_agency_service__a, multi_agency_service__b, multi_agency_service__c;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/multi-agency.service.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/matching-property-field.ts
var MatchingPropertyField = (function () {
    function MatchingPropertyField() {
    }
    return MatchingPropertyField;
}());

MatchingPropertyField.MATCHING_PROPERTY_ID = 'matchingPropertyId';
MatchingPropertyField.VENDOR_SOURCE = 'vendorSource';
MatchingPropertyField.CREATED_DATE = 'createdDate';
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/matching-property-field.js.map
// EXTERNAL MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/node_modules/rxjs/operators/map.js
var operators_map = __webpack_require__("L8VJ");
var operators_map_default = /*#__PURE__*/__webpack_require__.n(operators_map);

// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/event-collision/event-collision.service.ts
var event_collision_service___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var event_collision_service___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};





var event_collision_service_EventCollisionService = (function () {
    function EventCollisionService(http, environment, responseUtilService) {
        this.http = http;
        this.environment = environment;
        this.responseUtilService = responseUtilService;
        this.matchingUrl = this.environment.baseUrl + '/api/event-matches/matching';
        this.mergeMachingUrl = this.environment.baseUrl + '/api/event-matches/merge-matching';
        this.cancelMatchingUrl = this.environment.baseUrl + '/api/event-matches/cancel';
        this.createNewMatchingUrl = this.environment.baseUrl + '/api/event-matches/createnew';
        this.unmatchEventUrl = this.environment.baseUrl + '/api/event-matches/unmatch';
    }
    Object.defineProperty(EventCollisionService.prototype, "jsonOptions", {
        get: function () {
            var headers = new http_es5["Headers"]({ 'Content-Type': 'application/json' });
            var options = new http_es5["RequestOptions"]({ headers: headers });
            return options;
        },
        enumerable: true,
        configurable: true
    });
    EventCollisionService.prototype.getEventCollisionPropertyMatches = function (event_info) {
        var _this = this;
        return this.http
            .put(this.matchingUrl, JSON.stringify({ event_info: event_info }), this.jsonOptions)
            .map(function (response) { return response.json(); })
            .catch(function (response) { return _this.responseUtilService.handleError(response); })
            .share();
    };
    EventCollisionService.prototype.updateEventCollisionMatch = function (event_info) {
        var _this = this;
        return this.http
            .put(this.mergeMachingUrl, JSON.stringify(event_info), this.jsonOptions)
            .map(function (response) { return response.json(); })
            .catch(function (response) { return _this.responseUtilService.handleError(response); })
            .share();
    };
    EventCollisionService.prototype.cancelEventCollisionMatch = function (matchesToCancel) {
        var _this = this;
        return this.http.put("" + this.cancelMatchingUrl, JSON.stringify(matchesToCancel), this.jsonOptions)
            .catch(function (response) { return _this.responseUtilService.handleError(response); })
            .share();
    };
    EventCollisionService.prototype.createNewEventCollisionMatch = function (eventMatchId) {
        var _this = this;
        return this.http.put(this.createNewMatchingUrl + "/" + eventMatchId, null, null)
            .catch(function (response) { return _this.responseUtilService.handleError(response); })
            .share();
    };
    EventCollisionService.prototype.unmatchEvent = function (unmatchInfo) {
        var _this = this;
        return this.http
            .post(this.unmatchEventUrl, JSON.stringify(unmatchInfo), this.jsonOptions)
            .map(function (response) { return response.json(); })
            .catch(function (response) { return _this.responseUtilService.handleError(response); })
            .share();
    };
    return EventCollisionService;
}());
event_collision_service_EventCollisionService = event_collision_service___decorate([
    Object(core_es5["Injectable"])(),
    event_collision_service___metadata("design:paramtypes", [typeof (event_collision_service__a = typeof AppAuthHttpService !== "undefined" && AppAuthHttpService) === "function" && event_collision_service__a || Object, typeof (event_collision_service__b = typeof EnvironmentConfiguration !== "undefined" && EnvironmentConfiguration) === "function" && event_collision_service__b || Object, typeof (event_collision_service__c = typeof response_util_service_ResponseUtilService !== "undefined" && response_util_service_ResponseUtilService) === "function" && event_collision_service__c || Object])
], event_collision_service_EventCollisionService);

var event_collision_service__a, event_collision_service__b, event_collision_service__c;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/event-collision.service.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/service/matching-property.http.service.ts
var matching_property_http_service___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var matching_property_http_service___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};





var matching_property_http_service_MatchingPropertyHttpService = (function () {
    function MatchingPropertyHttpService(http, environment, responseUtilService) {
        this.http = http;
        this.environment = environment;
        this.responseUtilService = responseUtilService;
        this.aggregateBaseURL = '/api/matching';
        this.propertyMatchesCountURL = this.environment.baseUrl + this.aggregateBaseURL + '/count';
        this.propertyMatchesSearchURL = this.environment.baseUrl + this.aggregateBaseURL + '/search';
        this.propertyMatchesAssignURL = this.environment.baseUrl + this.aggregateBaseURL + '/assign/candidate';
        this.propertyMatchesAddURL = this.environment.baseUrl + this.aggregateBaseURL + '/assign/new';
    }
    MatchingPropertyHttpService.prototype.getPropertyMatchesCount = function () {
        var _this = this;
        var headers = new http_es5["Headers"]({ 'Content-Type': 'application/json' });
        var options = new http_es5["RequestOptions"]({ headers: headers }); // Create a request option
        return this.http.get("" + this.propertyMatchesCountURL, options)
            .map(function (response) { return response.json(); })
            .catch(function (response) { return _this.responseUtilService.handleError(response); })
            .share();
    };
    MatchingPropertyHttpService.prototype.getPropertyMatches = function (page, size, sort) {
        var _this = this;
        var headers = new http_es5["Headers"]({ 'Content-Type': 'application/json' });
        var options = new http_es5["RequestOptions"]({ headers: headers }); // Create a request option
        return this.http.get(this.propertyMatchesSearchURL + "?page=" + page + "&size=" + size + "&" + sort, options)
            .map(function (response) { return response.json(); })
            .catch(function (response) { return _this.responseUtilService.handleError(response); })
            .share();
    };
    MatchingPropertyHttpService.prototype.assign = function (property) {
        var _this = this;
        var headers = new http_es5["Headers"]({ 'Content-Type': 'application/json' });
        var options = new http_es5["RequestOptions"]({ headers: headers });
        return this.http.post(this.propertyMatchesAssignURL, JSON.stringify(property.toJS()), options)
            .catch(function (response) { return _this.responseUtilService.handleError(response); })
            .share();
    };
    MatchingPropertyHttpService.prototype.add = function (newRec) {
        var _this = this;
        var headers = new http_es5["Headers"]({ 'Content-Type': 'application/json' });
        var options = new http_es5["RequestOptions"]({ headers: headers });
        return this.http.post(this.propertyMatchesAddURL, JSON.stringify(newRec.toJS()), options)
            .map(function (response) { return response.json(); })
            .catch(function (response) { return _this.responseUtilService.handleError(response); }).share();
    };
    return MatchingPropertyHttpService;
}());
matching_property_http_service_MatchingPropertyHttpService = matching_property_http_service___decorate([
    Object(core_es5["Injectable"])(),
    matching_property_http_service___metadata("design:paramtypes", [typeof (matching_property_http_service__a = typeof AppAuthHttpService !== "undefined" && AppAuthHttpService) === "function" && matching_property_http_service__a || Object, typeof (matching_property_http_service__b = typeof EnvironmentConfiguration !== "undefined" && EnvironmentConfiguration) === "function" && matching_property_http_service__b || Object, typeof (matching_property_http_service__c = typeof response_util_service_ResponseUtilService !== "undefined" && response_util_service_ResponseUtilService) === "function" && matching_property_http_service__c || Object])
], matching_property_http_service_MatchingPropertyHttpService);

var matching_property_http_service__a, matching_property_http_service__b, matching_property_http_service__c;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/matching-property.http.service.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/event-collision-info.ts
var event_collision_info___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var EventCollisionInfoRecord = Object(immutable["Record"])({
    create_party: null,
    id: '0_0',
    event_name: null,
    start_date: null,
    end_date: null,
    first_name: null,
    last_name: null,
    email: null,
    phone: null,
    fax: null,
    event_party_id: null,
    chain: null,
    brand: null,
    property_id: null,
    property_name: null,
    property_address: null,
    property_zip: null,
    property_city: null,
    property_state: null,
    property_country: null,
    agency_id: null,
    name: null,
    dba_name: null,
    line1: null,
    line2: null,
    line3: null,
    city: null,
    state: null,
    postal_code: null,
    country_code: null,
    event_reference_number: null,
    auto_generated_code: null,
    manually_added: null,
    subscriber: 'Y',
    client_first_name: null,
    client_last_name: null,
    client_email: null,
    client_phone: null,
    client_fax: null,
    client_name: null,
    client_id: null,
    client_line1: null,
    client_city: null,
    client_state: null,
    client_zip: null,
    action: null,
    user_id: null,
    ev_tmp_guid: null,
    edited_event_id: null,
    edited_agency_id: null,
    edited_vendor_code: null,
    event_city: null,
    event_state: null,
    event_country_code: null,
    vendors: [],
});
var EventCollisionInfo = (function (_super) {
    event_collision_info___extends(EventCollisionInfo, _super);
    function EventCollisionInfo() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return EventCollisionInfo;
}(EventCollisionInfoRecord));

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/event-collision-info.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/event-collision-info-vendor.ts
var event_collision_info_vendor___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var EventCollisionInfoVendorRecord = Object(immutable["Record"])({
    chain: '',
    brand: '',
    property_id: '',
    property_name: '',
    property_address: '',
    property_zip: '',
    property_city: '',
    property_state: '',
    property_country: '',
    edited_vendor_code: '',
});
var EventCollisionInfoVendor = (function (_super) {
    event_collision_info_vendor___extends(EventCollisionInfoVendor, _super);
    function EventCollisionInfoVendor() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return EventCollisionInfoVendor;
}(EventCollisionInfoVendorRecord));

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/event-collision-info-vendor.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/service/matching-property.store.ts
var matching_property_store___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var matching_property_store___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
















var matching_property_store_MatchingPropertyStore = (function () {
    function MatchingPropertyStore(matchingPropertyHttpService, flashMessagesService, logService, translateService, authenticationStore, userLocalStorageService, eventCollisionService) {
        this.matchingPropertyHttpService = matchingPropertyHttpService;
        this.flashMessagesService = flashMessagesService;
        this.logService = logService;
        this.translateService = translateService;
        this.authenticationStore = authenticationStore;
        this.userLocalStorageService = userLocalStorageService;
        this.eventCollisionService = eventCollisionService;
        this.propertyPage = new BehaviorSubject["BehaviorSubject"](page_Page.empty());
        this.init();
    }
    MatchingPropertyStore.prototype.init = function () {
        if (this.authenticationStore.isSupportUser()) {
            this.getMatchingProperties(Constants.SEARCH_DEFAULT_PAGE, this.userLocalStorageService.getPagesize(PagesizeType.MATCHING_PROPERTY), Constants.DEFAULT_MATCHING_PROPERTY_FIELD_SORT_FIELD, null, Constants.SORT_DIRECTION_ASC).take(1).subscribe();
        }
    };
    Object.defineProperty(MatchingPropertyStore.prototype, "properties", {
        get: function () {
            return this.propertyPage.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MatchingPropertyStore.prototype, "totalPropertyCount", {
        get: function () {
            return this.propertyPage.asObservable().map(function (page) { return page.totalElements; });
        },
        enumerable: true,
        configurable: true
    });
    MatchingPropertyStore.prototype.getMatchingProperties = function (page, size, sortField, secondarySortField, sortDirection) {
        var _this = this;
        var sort = 'sort=' + sortField + ',' + sortDirection;
        if (secondarySortField) {
            sort = sort + '&sort=' + secondarySortField + ',' + sortDirection;
        }
        return this.matchingPropertyHttpService.getPropertyMatches(page, size, sort).catch(function (error) {
            _this.flashMessagesService.error(_this.translateService.instant('MESSAGES.ERROR.GET_MATCHING_PROPERTIES'));
            _this.logService.error("Error getting Matching Properties: " + error);
            return Observable["Observable"].throw(error);
        }).map(function (propertyMatches) {
            _this.propertyPage.next(propertyMatches);
            return propertyMatches;
        });
    };
    MatchingPropertyStore.prototype.assignMatchingCandidate = function (property) {
        var _this = this;
        return this.matchingPropertyHttpService.assign(property)
            .catch(function (error) {
            _this.flashMessagesService.error(_this.translateService.instant('MESSAGES.ERROR.ASSIGN_MATCHING_PROPERTIES'));
            _this.logService.error("Error assigning Matching Properties: " + error);
            return Observable["Observable"].throw(error);
        })
            .map(function (result) {
            _this.flashMessagesService.success('EVENT.PROPERTY_REVIEW.CANDIDATE_ASSIGNED');
            return result;
        });
    };
    MatchingPropertyStore.prototype.addProperty = function (newRec) {
        var _this = this;
        return this.matchingPropertyHttpService.add(newRec)
            .catch(function (error) {
            _this.flashMessagesService.error('MESSAGES.ERROR.ADD_PROPERTY', "Error adding property: " + error);
            return Observable["Observable"].throw(error);
        })
            .map(function (res) {
            _this.flashMessagesService.success('MESSAGES.SUCCESS.ADD_PROPERTY_MATCHING');
            return res;
        });
    };
    /* getMatchingCollisionProperties(eventInfo: any): Observable<any> {
      const eventInfoList = {
        "event_info":[
          eventInfo
        ]
      }
      return this.matchingPropertyHttpService.getEventCollisionPropertyMatches(eventInfoList).catch(error => {
        this.flashMessagesService.error(this.translateService.instant('MESSAGES.ERROR.GET_MATCHING_PROPERTIES'));
        this.logService.error(`Error getting Matching Properties: ${error}`);
        return Observable.throw(error);
      }).map(propertyMatches => {
        this.propertyPage.next(propertyMatches);
        return propertyMatches;
      });
    } */
    MatchingPropertyStore.prototype.getMatchingCollisionProperties = function (info, edited_event_id, user_id, ev_tmp_guid) {
        var eventCollisionInfo = this.buildEventInfoForEventCollision(info, edited_event_id, user_id, ev_tmp_guid);
        return this.eventCollisionService.getEventCollisionPropertyMatches(eventCollisionInfo)
            .catch(function (error) {
            return Observable["Observable"].throw(error);
        })
            .map(function (res) {
            return res;
        });
    };
    MatchingPropertyStore.prototype.updateEventCollisionMatch = function (eventInfo) {
        return this.eventCollisionService.updateEventCollisionMatch(eventInfo)
            .pipe(Object(operators_map["map"])(function (response) { return response; }));
    };
    MatchingPropertyStore.prototype.cancelMatching = function (matchesToCancel) {
        return this.eventCollisionService.cancelEventCollisionMatch(matchesToCancel);
    };
    MatchingPropertyStore.prototype.createNewMatching = function (eventMatchId) {
        return this.eventCollisionService.createNewEventCollisionMatch(eventMatchId);
    };
    MatchingPropertyStore.prototype.unmatchEvent = function (unmatchInfo) {
        var _this = this;
        return this.eventCollisionService.unmatchEvent(unmatchInfo)
            .catch(function (error) {
            return Observable["Observable"].throw(error);
        })
            .map(function (res) {
            _this.flashMessagesService.success('MESSAGES.SUCCESS.UNMATCH_EVENT');
            return res;
        });
    };
    MatchingPropertyStore.prototype.buildEventInfoForEventCollision = function (info, edited_event_id, user_id, ev_tmp_guid) {
        var vendors = info.eventProperties.map(function (vendor) {
            return new EventCollisionInfoVendor({
                chain: vendor.chain,
                brand: vendor.brand,
                property_id: vendor.propertyId,
                property_name: vendor.name,
                property_address: vendor.line1 + " " + vendor.line2,
                property_zip: vendor.postalCode,
                property_city: vendor.city,
                property_state: vendor.state,
                property_country: vendor.countryCode,
                edited_vendor_code: vendor.chain + '|' + vendor.brand + '|' + vendor.propertyId,
            });
        });
        var event = info.event;
        var eventAgency = info.eventAgency;
        var eventClient = info.eventClient;
        var firstProperty = info.eventProperties[0];
        var isPropertyUser = this.authenticationStore.isPropertyUser();
        var contact = isPropertyUser ? firstProperty.contact : eventAgency.contact;
        var partyOfUser = isPropertyUser ? firstProperty : eventAgency;
        var eventCollisionInfo = new EventCollisionInfo({
            create_party: contact.partyType.toString() || '',
            event_name: event.name,
            start_date: event.startDate,
            end_date: event.endDate,
            first_name: contact.firstName || '',
            last_name: contact.lastName || '',
            email: contact.email || '',
            phone: contact.phone || '',
            fax: contact.fax || '',
            agency_id: eventAgency.agencyId ? eventAgency.agencyId : eventAgency.code,
            name: eventAgency.name,
            dba_name: eventAgency.dbaName,
            line1: eventAgency.line1,
            line2: eventAgency.line2,
            line3: eventAgency.line3,
            city: eventAgency.city,
            state: eventAgency.state,
            postal_code: eventAgency.postalCode,
            country_code: eventAgency.countryCode,
            event_reference_number: event.eventReferenceNumber,
            auto_generated_code: partyOfUser.autoGenerated ? 'Y' : 'N',
            manually_added: partyOfUser.manuallyAdded ? 'Y' : 'N',
            client_first_name: eventClient.contact.firstName ? eventClient.contact.firstName : '',
            client_last_name: eventClient.contact.lastName ? eventClient.contact.lastName : '',
            client_email: eventClient.contact.email ? eventClient.contact.email : '',
            client_phone: eventClient.contact.phone ? eventClient.contact.phone : '',
            client_fax: eventClient.contact.fax ? eventClient.contact.fax : '',
            client_name: eventClient.name ? eventClient.name : '',
            client_id: eventClient.clientReferenceNumber ? eventClient.clientReferenceNumber : '',
            client_line1: eventClient.line1 ? eventClient.line1 : '',
            client_city: eventClient.city ? eventClient.city : '',
            client_state: eventClient.state ? eventClient.state : '',
            client_zip: eventClient.postalCode ? eventClient.postalCode : '',
            action: 'ADD',
            user_id: user_id,
            ev_tmp_guid: ev_tmp_guid,
            edited_event_id: edited_event_id,
            edited_agency_id: eventAgency.agencyId ? eventAgency.agencyId : eventAgency.code,
            event_city: isPropertyUser ? firstProperty.city || '' : event.city || '',
            event_state: isPropertyUser ? firstProperty.state || '' : event.state || '',
            event_country_code: isPropertyUser ? firstProperty.countryCode || '' : event.countryCode || '',
            vendors: vendors,
        });
        return [eventCollisionInfo];
    };
    return MatchingPropertyStore;
}());
matching_property_store_MatchingPropertyStore = matching_property_store___decorate([
    Object(core_es5["Injectable"])(),
    matching_property_store___metadata("design:paramtypes", [typeof (matching_property_store__a = typeof matching_property_http_service_MatchingPropertyHttpService !== "undefined" && matching_property_http_service_MatchingPropertyHttpService) === "function" && matching_property_store__a || Object, typeof (matching_property_store__b = typeof flash_messages_service_FlashMessagesService !== "undefined" && flash_messages_service_FlashMessagesService) === "function" && matching_property_store__b || Object, typeof (matching_property_store__c = typeof log_service_LogService !== "undefined" && log_service_LogService) === "function" && matching_property_store__c || Object, typeof (matching_property_store__d = typeof core["c" /* TranslateService */] !== "undefined" && core["c" /* TranslateService */]) === "function" && matching_property_store__d || Object, typeof (matching_property_store__e = typeof authentication_store_AuthenticationStore !== "undefined" && authentication_store_AuthenticationStore) === "function" && matching_property_store__e || Object, typeof (matching_property_store__f = typeof user_local_storage_service_UserLocalStorageService !== "undefined" && user_local_storage_service_UserLocalStorageService) === "function" && matching_property_store__f || Object, typeof (matching_property_store__g = typeof event_collision_service_EventCollisionService !== "undefined" && event_collision_service_EventCollisionService) === "function" && matching_property_store__g || Object])
], matching_property_store_MatchingPropertyStore);

var matching_property_store__a, matching_property_store__b, matching_property_store__c, matching_property_store__d, matching_property_store__e, matching_property_store__f, matching_property_store__g;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/matching-property.store.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/matching-property/matching-property.service.ts
var matching_property_service___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var matching_property_service___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};







var matching_property_service_MatchingPropertyService = (function () {
    function MatchingPropertyService(matchingPropertyStore, userLocalStorageService) {
        this.matchingPropertyStore = matchingPropertyStore;
        this.userLocalStorageService = userLocalStorageService;
        this.selectedProperty = new BehaviorSubject["BehaviorSubject"](null);
        this.selectedProperty$ = this.selectedProperty.asObservable();
        this.selectedField = new BehaviorSubject["BehaviorSubject"](null);
        this.selectedField$ = this.selectedField.asObservable();
        this.selectedPage = new BehaviorSubject["BehaviorSubject"](null);
        this.selectedPage$ = this.selectedPage.asObservable();
        this.init();
    }
    MatchingPropertyService.prototype.init = function () {
        this.setDefaultSort();
        this.setDefaultPage();
    };
    MatchingPropertyService.prototype.setSelectedProperty = function (property) {
        this.selectedProperty.next(property);
    };
    MatchingPropertyService.prototype.resetSelectedProperty = function () {
        this.selectedProperty.next(null);
    };
    MatchingPropertyService.prototype.setSelectedField = function (field) {
        this.selectedField.next(field);
    };
    MatchingPropertyService.prototype.resetSelectedField = function () {
        this.selectedField.next(Constants.DEFAULT_MATCHING_PROPERTY_FIELD_SORT_FIELD);
        this.setDefaultSort();
    };
    MatchingPropertyService.prototype.setSelectedPage = function (page) {
        this.selectedPage.next(page);
    };
    MatchingPropertyService.prototype.resetSelectedPage = function () {
        this.selectedPage.next(null);
    };
    MatchingPropertyService.prototype.setCurrentField = function (field) {
        this.currentField = field;
    };
    MatchingPropertyService.prototype.setCurrentDirection = function (direction) {
        this.currentDirection = direction;
    };
    MatchingPropertyService.prototype.assignMatchingCandidate = function (property) {
        return this.matchingPropertyStore.assignMatchingCandidate(property);
    };
    MatchingPropertyService.prototype.refreshMatchingProperties = function (page) {
        this.currentPage = page;
        return this.matchingPropertyStore.getMatchingProperties(this.currentPage, this.userLocalStorageService.getPagesize(PagesizeType.MATCHING_PROPERTY), this.currentField, this.getSecondarySource(this.currentField), this.currentDirection);
    };
    MatchingPropertyService.prototype.addProperty = function (newRec) {
        return this.matchingPropertyStore.addProperty(newRec);
    };
    MatchingPropertyService.prototype.setDefaultSort = function () {
        this.currentField = Constants.DEFAULT_MATCHING_PROPERTY_FIELD_SORT_FIELD;
        this.currentDirection = Constants.SORT_DIRECTION_ASC;
    };
    MatchingPropertyService.prototype.setDefaultPage = function () {
        this.currentPage = Constants.SEARCH_DEFAULT_PAGE;
    };
    Object.defineProperty(MatchingPropertyService.prototype, "properties", {
        get: function () {
            return this.matchingPropertyStore.properties;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MatchingPropertyService.prototype, "totalPropertyCount", {
        get: function () {
            return this.matchingPropertyStore.totalPropertyCount;
        },
        enumerable: true,
        configurable: true
    });
    MatchingPropertyService.prototype.getSecondarySource = function (field) {
        if (field === MatchingPropertyField.CREATED_DATE) {
            return MatchingPropertyField.VENDOR_SOURCE;
        }
        else if (field === MatchingPropertyField.VENDOR_SOURCE) {
            return MatchingPropertyField.CREATED_DATE;
        }
        else {
            return MatchingPropertyField.MATCHING_PROPERTY_ID;
        }
    };
    return MatchingPropertyService;
}());
matching_property_service_MatchingPropertyService = matching_property_service___decorate([
    Object(core_es5["Injectable"])(),
    matching_property_service___metadata("design:paramtypes", [typeof (matching_property_service__a = typeof matching_property_store_MatchingPropertyStore !== "undefined" && matching_property_store_MatchingPropertyStore) === "function" && matching_property_service__a || Object, typeof (matching_property_service__b = typeof user_local_storage_service_UserLocalStorageService !== "undefined" && user_local_storage_service_UserLocalStorageService) === "function" && matching_property_service__b || Object])
], matching_property_service_MatchingPropertyService);

var matching_property_service__a, matching_property_service__b;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/matching-property.service.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/pagination-sort/pagination-sort.component.ts
var pagination_sort_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var pagination_sort_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};


var pagination_sort_component_PaginationSortComponent = (function () {
    function PaginationSortComponent(matchingPropertyService) {
        this.matchingPropertyService = matchingPropertyService;
        this.sortPage = new core_es5["EventEmitter"]();
    }
    PaginationSortComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.matchingPropertyService.selectedField$.subscribe(function (field) {
            if (field && field === _this.field) {
                _this.isSorted = true;
            }
            else {
                _this.resetSort();
            }
        });
    };
    PaginationSortComponent.prototype.resetSort = function () {
        this.isSorted = false;
        this.isAsc = false;
    };
    PaginationSortComponent.prototype.sortList = function () {
        this.isSorted = true;
        this.isAsc = !this.isAsc;
        if (this.isAsc) {
            this.sortPage.emit({ field: this.field, direction: 'asc' });
        }
        else {
            this.sortPage.emit({ field: this.field, direction: 'desc' });
        }
        this.matchingPropertyService.setSelectedField(this.field);
    };
    return PaginationSortComponent;
}());
pagination_sort_component___decorate([
    Object(core_es5["Input"])(),
    pagination_sort_component___metadata("design:type", String)
], pagination_sort_component_PaginationSortComponent.prototype, "label", void 0);
pagination_sort_component___decorate([
    Object(core_es5["Input"])(),
    pagination_sort_component___metadata("design:type", String)
], pagination_sort_component_PaginationSortComponent.prototype, "field", void 0);
pagination_sort_component___decorate([
    Object(core_es5["Output"])(),
    pagination_sort_component___metadata("design:type", typeof (pagination_sort_component__a = typeof core_es5["EventEmitter"] !== "undefined" && core_es5["EventEmitter"]) === "function" && pagination_sort_component__a || Object)
], pagination_sort_component_PaginationSortComponent.prototype, "sortPage", void 0);
pagination_sort_component_PaginationSortComponent = pagination_sort_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-pagination-sort',
        template: __webpack_require__("XRtp")
    }),
    pagination_sort_component___metadata("design:paramtypes", [typeof (pagination_sort_component__b = typeof matching_property_service_MatchingPropertyService !== "undefined" && matching_property_service_MatchingPropertyService) === "function" && pagination_sort_component__b || Object])
], pagination_sort_component_PaginationSortComponent);

var pagination_sort_component__a, pagination_sort_component__b;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/pagination-sort.component.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/service/event-match-log.http.service.ts
var event_match_log_http_service___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var event_match_log_http_service___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};





var event_match_log_http_service_EventMatchLogHttpService = (function () {
    function EventMatchLogHttpService(http, environment, responseUtilService) {
        this.http = http;
        this.environment = environment;
        this.responseUtilService = responseUtilService;
        this.aggregateBaseURL = '/api/event-matches';
        this.eventUrl = this.environment.baseUrl + '/api/events';
        this.eventMatchLogSearchURL = this.environment.baseUrl + this.aggregateBaseURL + '/search';
        this.eventMatchLogReportExcelUrl = this.environment.baseUrl + this.aggregateBaseURL + '/report/excel ';
        this.eventMatchConfigURL = this.environment.baseUrl + this.aggregateBaseURL + '/matching-endpoint-conf ';
    }
    Object.defineProperty(EventMatchLogHttpService.prototype, "fileOptions", {
        get: function () {
            var headers = new http_es5["Headers"]({ 'Content-Type': 'application/json' });
            var options = new http_es5["RequestOptions"]({
                headers: headers,
                responseType: http_es5["ResponseContentType"].Blob
            });
            return options;
        },
        enumerable: true,
        configurable: true
    });
    EventMatchLogHttpService.prototype.getEventMatchLog = function (page, size, sort) {
        var _this = this;
        var headers = new http_es5["Headers"]({ 'Content-Type': 'application/json' });
        var options = new http_es5["RequestOptions"]({ headers: headers }); // Create a request option
        return this.http.get(this.eventMatchLogSearchURL + "?page=" + page + "&size=" + size + "&" + sort, options)
            .map(function (response) { return response.json(); })
            .catch(function (response) { return _this.responseUtilService.handleError(response); })
            .share();
    };
    EventMatchLogHttpService.prototype.exportEventMatchLogExcel = function () {
        var _this = this;
        return this.http.post(this.eventMatchLogReportExcelUrl, null, this.fileOptions)
            .map(function (res) { return new Blob([res.blob()], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }); })
            .catch(function (response) { return _this.responseUtilService.handleError(response); });
    };
    EventMatchLogHttpService.prototype.getEventMatchConfigURL = function () {
        var _this = this;
        var headers = new http_es5["Headers"]({ 'Content-Type': 'application/json' });
        var options = new http_es5["RequestOptions"]({ headers: headers }); // Create a request option
        return this.http.get(this.eventMatchConfigURL, options)
            .map(function (response) { return response.json(); })
            .catch(function (response) { return _this.responseUtilService.handleError(response); })
            .share();
    };
    EventMatchLogHttpService.prototype.getMatchesByEvent = function (eventId) {
        var _this = this;
        var eventMathesUrl = this.eventUrl + "/" + eventId + "/matches";
        var headers = new http_es5["Headers"]({ 'Content-Type': 'application/json' });
        var options = new http_es5["RequestOptions"]({ headers: headers }); // Create a request option
        return this.http.get(eventMathesUrl, options)
            .map(function (response) { return response.json(); })
            .catch(function (response) { return _this.responseUtilService.handleError(response); })
            .share();
    };
    return EventMatchLogHttpService;
}());
event_match_log_http_service_EventMatchLogHttpService = event_match_log_http_service___decorate([
    Object(core_es5["Injectable"])(),
    event_match_log_http_service___metadata("design:paramtypes", [typeof (event_match_log_http_service__a = typeof AppAuthHttpService !== "undefined" && AppAuthHttpService) === "function" && event_match_log_http_service__a || Object, typeof (event_match_log_http_service__b = typeof EnvironmentConfiguration !== "undefined" && EnvironmentConfiguration) === "function" && event_match_log_http_service__b || Object, typeof (event_match_log_http_service__c = typeof response_util_service_ResponseUtilService !== "undefined" && response_util_service_ResponseUtilService) === "function" && event_match_log_http_service__c || Object])
], event_match_log_http_service_EventMatchLogHttpService);

var event_match_log_http_service__a, event_match_log_http_service__b, event_match_log_http_service__c;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/event-match-log.http.service.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/party-for-unmatch-event.ts
var party_for_unmatch_event___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var PartyForUnmatchEventRecord = Object(immutable["Record"])({
    type: null,
    code: null,
    name: null,
    address: null
});
var PartyForUnmatchEvent = (function (_super) {
    party_for_unmatch_event___extends(PartyForUnmatchEvent, _super);
    function PartyForUnmatchEvent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return PartyForUnmatchEvent;
}(PartyForUnmatchEventRecord));

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/party-for-unmatch-event.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/property-popup-type.enum.ts
var PopupType;
(function (PopupType) {
    PopupType[PopupType["SEARCH"] = 'S'] = "SEARCH";
    PopupType[PopupType["ADD"] = 'A'] = "ADD";
    PopupType[PopupType["RATE"] = 'R'] = "RATE";
})(PopupType || (PopupType = {}));
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/property-popup-type.enum.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/unmatch-event-party-request.ts
var unmatch_event_party_request___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var UnmatchEventPartyRequestRecord = Object(immutable["Record"])({
    type: null,
    code: null
});
var UnmatchEventPartyRequest = (function (_super) {
    unmatch_event_party_request___extends(UnmatchEventPartyRequest, _super);
    function UnmatchEventPartyRequest() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return UnmatchEventPartyRequest;
}(UnmatchEventPartyRequestRecord));

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/unmatch-event-party-request.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/unmatch-event-request.ts
var unmatch_event_request___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var UnmatchEventRequestRecord = Object(immutable["Record"])({
    action: null,
    event_id: null,
    parties: null,
    reason: null,
    unmatched_by: null,
    party_initiator_type: null,
    party_initiator_code: null,
    event_info: null,
});
var UnmatchEventRequest = (function (_super) {
    unmatch_event_request___extends(UnmatchEventRequest, _super);
    function UnmatchEventRequest() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return UnmatchEventRequest;
}(UnmatchEventRequestRecord));

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/unmatch-event-request.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/unmatch-event-popup/unmatch-event-popup.component.ts
var unmatch_event_popup_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var unmatch_event_popup_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};







var unmatch_event_popup_component_UnmatchEventPopupComponent = (function () {
    function UnmatchEventPopupComponent() {
        this.closed = new core_es5["EventEmitter"]();
        this.reasonForUnmatch = '';
        this.isPartySelected = new Map();
        this.PopupType = PopupType;
    }
    Object.defineProperty(UnmatchEventPopupComponent.prototype, "isShown", {
        get: function () { return this.unmatchEventModal.isShown; },
        enumerable: true,
        configurable: true
    });
    UnmatchEventPopupComponent.prototype.ngOnInit = function () {
        this.agency = new PartyForUnmatchEvent({});
        this.vendors = [];
        this.isPartySelected = new Map();
        this.reasonForUnmatch = '';
    };
    UnmatchEventPopupComponent.prototype.open = function () {
        this.setAgencyForUnmatchEvent();
        this.setVendorsForUnmatchEvent();
        this.unmatchEventModal.show();
    };
    UnmatchEventPopupComponent.prototype.onUnmatch = function () {
        var parties = [];
        if (this.isAgencySelected()) {
            var party = new UnmatchEventPartyRequest({
                type: this.agency.type,
                code: this.agency.code
            });
            parties.push(party);
        }
        else {
            this.isPartySelected.forEach(function (value, key) {
                parties.push(value);
            });
        }
        var unmatchEventRequest = new UnmatchEventRequest({
            action: (parties[0].type === 'AGENCY' ? 'UNMATCH_AGENCY' : 'UNMATCH_VENDOR'),
            event_id: this.event.eventId,
            parties: parties,
            reason: this.reasonForUnmatch,
            unmatched_by: null,
            party_initiator_type: null,
            party_initiator_code: null,
            event_info: null,
        });
        this.ngOnInit();
        this.unmatchEventModal.hide();
        this.closed.emit(unmatchEventRequest);
    };
    UnmatchEventPopupComponent.prototype.onCancel = function () {
        this.ngOnInit();
        this.unmatchEventModal.hide();
    };
    UnmatchEventPopupComponent.prototype.setAgencyForUnmatchEvent = function () {
        if (this.event && this.event.eventAgency) {
            this.agency = new PartyForUnmatchEvent({
                type: this.event.eventAgency.partyType,
                code: this.event.eventAgency.code,
                name: this.event.eventAgency.name,
                address: this.retrieveCompleteAddress(this.event.eventAgency)
            });
        }
    };
    UnmatchEventPopupComponent.prototype.setVendorsForUnmatchEvent = function () {
        if (this.event && this.event.eventVendors) {
            this.event.eventVendors.forEach(function addVendorForUnmatch(vendor) {
                if ((vendor.createdEvent && vendor.createdEvent === 'Y') || (vendor.mergedEvent && vendor.mergedEvent === 'Y')) {
                    var party = new PartyForUnmatchEvent({
                        type: vendor.partyType,
                        code: vendor.code,
                        name: vendor.name,
                        address: this.retrieveCompleteAddress(vendor)
                    });
                    this.vendors.push(party);
                }
            }, this);
        }
    };
    UnmatchEventPopupComponent.prototype.retrieveCompleteAddress = function (vendor) {
        var address = '';
        if (vendor.line1 && vendor.line1.trim().length > 0) {
            address = address + vendor.line1.trim();
        }
        if (vendor.line2 && vendor.line2.trim().length > 0) {
            address = address + ' ' + vendor.line2.trim();
        }
        if (vendor.line3 && vendor.line3.trim().length > 0) {
            address = address + ' ' + vendor.line3.trim();
        }
        if (vendor.city && vendor.city.trim().length > 0) {
            address = address + ', ' + vendor.city.trim();
        }
        if (vendor.state && vendor.state.trim().length > 0) {
            address = address + ', ' + vendor.state.trim();
        }
        if (vendor.postalCode && vendor.postalCode.trim().length > 0) {
            address = address + ', ' + vendor.postalCode.trim();
        }
        if (vendor.countryCode && vendor.countryCode.trim().length > 0) {
            address = address + ', ' + vendor.countryCode.trim();
        }
        return address;
    };
    UnmatchEventPopupComponent.prototype.changeIsPartySelected = function (event, type, code) {
        if (event.currentTarget.checked === true) {
            var party = new UnmatchEventPartyRequest({
                type: type,
                code: code
            });
            this.isPartySelected.set(type + '_' + code, party);
        }
        else {
            this.isPartySelected.delete(type + '_' + code);
        }
    };
    UnmatchEventPopupComponent.prototype.isAgencySelected = function () {
        var keys = Array.from(this.isPartySelected.keys());
        var found = keys.find(function (key) { return key.startsWith('AGENCY'); });
        return (found && found.length > 0);
    };
    return UnmatchEventPopupComponent;
}());
unmatch_event_popup_component___decorate([
    Object(core_es5["Input"])(),
    unmatch_event_popup_component___metadata("design:type", typeof (unmatch_event_popup_component__a = typeof OnyxEvent !== "undefined" && OnyxEvent) === "function" && unmatch_event_popup_component__a || Object)
], unmatch_event_popup_component_UnmatchEventPopupComponent.prototype, "event", void 0);
unmatch_event_popup_component___decorate([
    Object(core_es5["Output"])(),
    unmatch_event_popup_component___metadata("design:type", Object)
], unmatch_event_popup_component_UnmatchEventPopupComponent.prototype, "closed", void 0);
unmatch_event_popup_component___decorate([
    Object(core_es5["ViewChild"])(ngx_bootstrap["b" /* ModalDirective */]),
    unmatch_event_popup_component___metadata("design:type", typeof (unmatch_event_popup_component__b = typeof ngx_bootstrap["b" /* ModalDirective */] !== "undefined" && ngx_bootstrap["b" /* ModalDirective */]) === "function" && unmatch_event_popup_component__b || Object)
], unmatch_event_popup_component_UnmatchEventPopupComponent.prototype, "unmatchEventModal", void 0);
unmatch_event_popup_component_UnmatchEventPopupComponent = unmatch_event_popup_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-unmatch-event-modal',
        template: __webpack_require__("WXh5")
    }),
    unmatch_event_popup_component___metadata("design:paramtypes", [])
], unmatch_event_popup_component_UnmatchEventPopupComponent);

var unmatch_event_popup_component__a, unmatch_event_popup_component__b;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/unmatch-event-popup.component.js.map
// EXTERNAL MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/node_modules/rxjs/observable/of.js
var of = __webpack_require__("+zVg");
var of_default = /*#__PURE__*/__webpack_require__.n(of);

// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/event-collision-modal-multiprompt/event-collision-modal-multiprompt.component.ts
var event_collision_modal_multiprompt_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var event_collision_modal_multiprompt_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};








var event_collision_modal_multiprompt_component_EventCollisionModalMultipromptComponent = (function () {
    function EventCollisionModalMultipromptComponent(authenticationStore) {
        this.authenticationStore = authenticationStore;
        this.EventCollisionModalResponse = EventCollisionModalResponse;
        this.match = [];
        this.config = {
            backdrop: 'static'
        };
        this.closed = new core_es5["EventEmitter"]();
        this.canceled = new core_es5["EventEmitter"]();
        this.selectedMatches = [];
    }
    EventCollisionModalMultipromptComponent.prototype.ngOnInit = function () {
    };
    Object.defineProperty(EventCollisionModalMultipromptComponent.prototype, "isPropertyUser", {
        get: function () {
            return this.authenticationStore.isPropertyUser();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EventCollisionModalMultipromptComponent.prototype, "isShown", {
        get: function () { return this.confirmationModal.isShown; },
        enumerable: true,
        configurable: true
    });
    EventCollisionModalMultipromptComponent.prototype.open = function (eventMatch, match) {
        var _this = this;
        this.response = undefined;
        this.eventMatch = eventMatch;
        this.match = match;
        this.content = 'EVENT_COLLISION.MODAL.MULTI.INSTRUCTION_TEXT';
        this.selectedMatches = [];
        match.forEach(function (item) {
            _this.selectedMatches.push(item.event_match_id);
        });
        this.confirmationModal.show();
    };
    EventCollisionModalMultipromptComponent.prototype.mergeSelectedEvent = function () {
        this.response = new EventCollisionModalResponse({
            selectedButton: EventCollisionModalResponseEnum.MergeEvents,
            selectedMatches: this.selectedMatches
        });
        this.confirmationModal.hide();
    };
    EventCollisionModalMultipromptComponent.prototype.doNotMerge = function () {
        this.selectedMatches = [];
        this.response = new EventCollisionModalResponse({
            selectedButton: EventCollisionModalResponseEnum.DoNotMergeEvents,
            selectedMatches: this.selectedMatches
        });
        this.confirmationModal.hide();
    };
    EventCollisionModalMultipromptComponent.prototype.cancelEventMatching = function () {
        this.selectedMatches = [];
        this.response = new EventCollisionModalResponse({
            selectedButton: undefined,
            selectedMatches: this.selectedMatches
        });
        this.confirmationModal.hide();
    };
    EventCollisionModalMultipromptComponent.prototype.changeSelection = function (event) {
        var value = Number(event.target.value);
        if (event.target.checked) {
            if (this.selectedMatches.indexOf(value) === -1) {
                this.selectedMatches.push(value);
            }
        }
        else {
            if (this.selectedMatches.indexOf(value) > -1) {
                var index = this.selectedMatches.indexOf(value);
                this.selectedMatches.splice(index, 1);
            }
        }
    };
    EventCollisionModalMultipromptComponent.prototype.completePropertyForEventMatched = function (match) {
        var output = '';
        if (match.name && match.name.length > 0) {
            output = output + '<strong>' + match.name + '</strong><br>';
        }
        if (match.property_name && match.property_name.length > 0) {
            output = output + match.property_name + '<br>';
        }
        if (match.property_address && match.property_address.length > 0) {
            output = output + match.property_address + '<br>';
        }
        var myDate = null;
        if (match.start_date && match.start_date.length > 0) {
            myDate = new Date(Date.parse(match.start_date));
            output = output + myDate.toLocaleDateString();
        }
        if (match.end_date && match.end_date.length > 0) {
            myDate = new Date(Date.parse(match.end_date));
            output = output + ' &minus; ' + myDate.toLocaleDateString();
        }
        return output;
    };
    EventCollisionModalMultipromptComponent.prototype.onHide = function () {
        if (this.response.selectedButton === undefined) {
            this.canceled.emit(this.response);
        }
        else {
            this.closed.emit(this.response);
        }
    };
    Object.defineProperty(EventCollisionModalMultipromptComponent.prototype, "isModalForMultiprompt", {
        get: function () {
            return Object(of["of"])(Boolean(this.match.length > 1));
        },
        enumerable: true,
        configurable: true
    });
    return EventCollisionModalMultipromptComponent;
}());
event_collision_modal_multiprompt_component___decorate([
    Object(core_es5["Input"])(),
    event_collision_modal_multiprompt_component___metadata("design:type", typeof (event_collision_modal_multiprompt_component__a = typeof EventCollisionMatch !== "undefined" && EventCollisionMatch) === "function" && event_collision_modal_multiprompt_component__a || Object)
], event_collision_modal_multiprompt_component_EventCollisionModalMultipromptComponent.prototype, "eventMatch", void 0);
event_collision_modal_multiprompt_component___decorate([
    Object(core_es5["Input"])(),
    event_collision_modal_multiprompt_component___metadata("design:type", Object)
], event_collision_modal_multiprompt_component_EventCollisionModalMultipromptComponent.prototype, "match", void 0);
event_collision_modal_multiprompt_component___decorate([
    Object(core_es5["Input"])(),
    event_collision_modal_multiprompt_component___metadata("design:type", Object)
], event_collision_modal_multiprompt_component_EventCollisionModalMultipromptComponent.prototype, "config", void 0);
event_collision_modal_multiprompt_component___decorate([
    Object(core_es5["Input"])(),
    event_collision_modal_multiprompt_component___metadata("design:type", typeof (event_collision_modal_multiprompt_component__b = typeof User !== "undefined" && User) === "function" && event_collision_modal_multiprompt_component__b || Object)
], event_collision_modal_multiprompt_component_EventCollisionModalMultipromptComponent.prototype, "user", void 0);
event_collision_modal_multiprompt_component___decorate([
    Object(core_es5["Input"])(),
    event_collision_modal_multiprompt_component___metadata("design:type", String)
], event_collision_modal_multiprompt_component_EventCollisionModalMultipromptComponent.prototype, "mode", void 0);
event_collision_modal_multiprompt_component___decorate([
    Object(core_es5["Output"])(),
    event_collision_modal_multiprompt_component___metadata("design:type", Object)
], event_collision_modal_multiprompt_component_EventCollisionModalMultipromptComponent.prototype, "closed", void 0);
event_collision_modal_multiprompt_component___decorate([
    Object(core_es5["Output"])(),
    event_collision_modal_multiprompt_component___metadata("design:type", Object)
], event_collision_modal_multiprompt_component_EventCollisionModalMultipromptComponent.prototype, "canceled", void 0);
event_collision_modal_multiprompt_component___decorate([
    Object(core_es5["ViewChild"])(modal["b" /* ModalDirective */]),
    event_collision_modal_multiprompt_component___metadata("design:type", typeof (event_collision_modal_multiprompt_component__c = typeof modal["b" /* ModalDirective */] !== "undefined" && modal["b" /* ModalDirective */]) === "function" && event_collision_modal_multiprompt_component__c || Object)
], event_collision_modal_multiprompt_component_EventCollisionModalMultipromptComponent.prototype, "confirmationModal", void 0);
event_collision_modal_multiprompt_component_EventCollisionModalMultipromptComponent = event_collision_modal_multiprompt_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-event-collision-modal-multiprompt',
        template: __webpack_require__("oIDS"),
        styles: [__webpack_require__("3EoA")]
    }),
    event_collision_modal_multiprompt_component___metadata("design:paramtypes", [typeof (event_collision_modal_multiprompt_component__d = typeof authentication_store_AuthenticationStore !== "undefined" && authentication_store_AuthenticationStore) === "function" && event_collision_modal_multiprompt_component__d || Object])
], event_collision_modal_multiprompt_component_EventCollisionModalMultipromptComponent);

var event_collision_modal_multiprompt_component__a, event_collision_modal_multiprompt_component__b, event_collision_modal_multiprompt_component__c, event_collision_modal_multiprompt_component__d;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/event-collision-modal-multiprompt.component.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/confirm/confirm.component.ts
var confirm_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var confirm_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var confirm_component_ConfirmComponent = (function () {
    function ConfirmComponent() {
        this.confirmed = new core_es5["EventEmitter"]();
        this.title = 'MESSAGES.CONFIRMATION.EXIT_TITLE';
        this.content = 'MESSAGES.CONFIRMATION.CONTINUE';
        this.cancel = 'COMMON.BUTTON.NO';
        this.confirm = 'COMMON.BUTTON.YES';
    }
    ConfirmComponent.prototype.cancelClick = function () {
        this.confirmed.emit(false);
    };
    ConfirmComponent.prototype.acceptClick = function () {
        this.confirmed.emit(true);
    };
    return ConfirmComponent;
}());
confirm_component___decorate([
    Object(core_es5["Output"])(),
    confirm_component___metadata("design:type", Object)
], confirm_component_ConfirmComponent.prototype, "confirmed", void 0);
confirm_component___decorate([
    Object(core_es5["Input"])(),
    confirm_component___metadata("design:type", Object)
], confirm_component_ConfirmComponent.prototype, "title", void 0);
confirm_component___decorate([
    Object(core_es5["Input"])(),
    confirm_component___metadata("design:type", Object)
], confirm_component_ConfirmComponent.prototype, "content", void 0);
confirm_component___decorate([
    Object(core_es5["Input"])(),
    confirm_component___metadata("design:type", Object)
], confirm_component_ConfirmComponent.prototype, "cancel", void 0);
confirm_component___decorate([
    Object(core_es5["Input"])(),
    confirm_component___metadata("design:type", Object)
], confirm_component_ConfirmComponent.prototype, "confirm", void 0);
confirm_component_ConfirmComponent = confirm_component___decorate([
    Object(core_es5["Component"])({
        template: __webpack_require__("qeIs"),
    })
], confirm_component_ConfirmComponent);

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/confirm.component.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/guards/unsaved-changes/unsaved-changes.guard.ts
var unsaved_changes_guard___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var unsaved_changes_guard___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};





var unsaved_changes_guard_UnsavedChangesGuard = (function () {
    function UnsavedChangesGuard(modalService, authenticationStore) {
        this.modalService = modalService;
        this.authenticationStore = authenticationStore;
    }
    UnsavedChangesGuard.prototype.canDeactivate = function (component) {
        if (!this.authenticationStore.isLoggedIn() || !this.authenticationStore.hasToken()) {
            return true;
        }
        if (component.isDirty) {
            var modal_1 = this.modalService.show(confirm_component_ConfirmComponent);
            var confirmComponent = modal_1.content;
            return confirmComponent.confirmed.asObservable().pipe(Object(operators["tap"])(function (confirmedValue) {
                modal_1.hide();
                if (component.reset && confirmedValue) {
                    component.reset();
                }
            }));
        }
        return true;
    };
    return UnsavedChangesGuard;
}());
unsaved_changes_guard_UnsavedChangesGuard = unsaved_changes_guard___decorate([
    Object(core_es5["Injectable"])(),
    unsaved_changes_guard___metadata("design:paramtypes", [typeof (unsaved_changes_guard__a = typeof ngx_bootstrap["a" /* BsModalService */] !== "undefined" && ngx_bootstrap["a" /* BsModalService */]) === "function" && unsaved_changes_guard__a || Object, typeof (unsaved_changes_guard__b = typeof authentication_store_AuthenticationStore !== "undefined" && authentication_store_AuthenticationStore) === "function" && unsaved_changes_guard__b || Object])
], unsaved_changes_guard_UnsavedChangesGuard);

var unsaved_changes_guard__a, unsaved_changes_guard__b;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/unsaved-changes.guard.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/pipes/safe-url.pipe.ts
var safe_url_pipe___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var safe_url_pipe___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};


var SafeUrlPipe = (function () {
    function SafeUrlPipe(sanitizer) {
        this.sanitizer = sanitizer;
    }
    SafeUrlPipe.prototype.transform = function (url) {
        return this.sanitizer.bypassSecurityTrustResourceUrl(url);
    };
    return SafeUrlPipe;
}());
SafeUrlPipe = safe_url_pipe___decorate([
    Object(core_es5["Pipe"])({
        name: 'safe'
    }),
    safe_url_pipe___metadata("design:paramtypes", [typeof (safe_url_pipe__a = typeof platform_browser_es5["DomSanitizer"] !== "undefined" && platform_browser_es5["DomSanitizer"]) === "function" && safe_url_pipe__a || Object])
], SafeUrlPipe);

var safe_url_pipe__a;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/safe-url.pipe.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/directives/currency.directive.ts
var currency_directive___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var currency_directive___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};



var currency_directive_CurrencyDirective = (function () {
    function CurrencyDirective(elementRef, control) {
        this.elementRef = elementRef;
        this.control = control;
        this.el = this.elementRef.nativeElement;
    }
    CurrencyDirective.prototype.onBlur = function (value) {
        var truncatedValue = pioneer_utils_PioneerUtils.formatDecimal(value);
        this.el.value = truncatedValue;
        this.control.control.setValue(truncatedValue);
    };
    return CurrencyDirective;
}());
currency_directive___decorate([
    Object(core_es5["HostListener"])('blur', ['$event.target.value']),
    currency_directive___metadata("design:type", Function),
    currency_directive___metadata("design:paramtypes", [String]),
    currency_directive___metadata("design:returntype", void 0)
], currency_directive_CurrencyDirective.prototype, "onBlur", null);
currency_directive_CurrencyDirective = currency_directive___decorate([
    Object(core_es5["Directive"])({
        selector: '[pioneerCurrency]'
    }),
    currency_directive___metadata("design:paramtypes", [typeof (currency_directive__a = typeof core_es5["ElementRef"] !== "undefined" && core_es5["ElementRef"]) === "function" && currency_directive__a || Object, typeof (currency_directive__b = typeof forms_es5["NgControl"] !== "undefined" && forms_es5["NgControl"]) === "function" && currency_directive__b || Object])
], currency_directive_CurrencyDirective);

var currency_directive__a, currency_directive__b;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/currency.directive.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/service/matching-agency.http.service.ts
var matching_agency_http_service___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var matching_agency_http_service___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};





var matching_agency_http_service_MatchingAgencyHttpService = (function () {
    function MatchingAgencyHttpService(http, environment, responseUtilService) {
        this.http = http;
        this.environment = environment;
        this.responseUtilService = responseUtilService;
        this.aggregateBaseURL = '/api/matching/agency';
        this.agencyMatchesSearchURL = this.environment.baseUrl + this.aggregateBaseURL + '/search';
        this.agencyMatchesAssignURL = this.environment.baseUrl + this.aggregateBaseURL + '/assign/candidate';
        this.agencyMatchesAddURL = this.environment.baseUrl + this.aggregateBaseURL + '/assign/new';
    }
    MatchingAgencyHttpService.prototype.search = function (taCode, chainCode) {
        var _this = this;
        var headers = new http_es5["Headers"]({ 'Content-Type': 'application/json' });
        var options = new http_es5["RequestOptions"]({ headers: headers }); // Create a request option
        return this.http.get(this.agencyMatchesSearchURL + "?taCode=" + taCode + "&chainCode=" + chainCode, options)
            .map(function (response) { return response.json(); })
            .catch(function (response) { return _this.responseUtilService.handleError(response); })
            .share();
    };
    MatchingAgencyHttpService.prototype.getMatches = function (page, size, sort) {
        var _this = this;
        var headers = new http_es5["Headers"]({ 'Content-Type': 'application/json' });
        var options = new http_es5["RequestOptions"]({ headers: headers }); // Create a request option
        return this.http.get(this.agencyMatchesSearchURL + "?page=" + page + "&size=" + size + "&" + sort, options)
            .map(function (response) { return response.json(); })
            .catch(function (response) { return _this.responseUtilService.handleError(response); })
            .share();
    };
    MatchingAgencyHttpService.prototype.assign = function (candidateAssign) {
        var _this = this;
        var headers = new http_es5["Headers"]({ 'Content-Type': 'application/json' });
        var options = new http_es5["RequestOptions"]({ headers: headers });
        return this.http.post(this.agencyMatchesAssignURL, JSON.stringify(candidateAssign.toJS()), options)
            .catch(function (response) { return _this.responseUtilService.handleError(response); })
            .share();
    };
    MatchingAgencyHttpService.prototype.add = function (newRec) {
        var _this = this;
        var headers = new http_es5["Headers"]({ 'Content-Type': 'application/json' });
        var options = new http_es5["RequestOptions"]({ headers: headers });
        return this.http.post(this.agencyMatchesAddURL, JSON.stringify(newRec.toJS()), options)
            .map(function (response) { return response.json(); })
            .catch(function (response) { return _this.responseUtilService.handleError(response); }).share();
    };
    return MatchingAgencyHttpService;
}());
matching_agency_http_service_MatchingAgencyHttpService = matching_agency_http_service___decorate([
    Object(core_es5["Injectable"])(),
    matching_agency_http_service___metadata("design:paramtypes", [typeof (matching_agency_http_service__a = typeof AppAuthHttpService !== "undefined" && AppAuthHttpService) === "function" && matching_agency_http_service__a || Object, typeof (matching_agency_http_service__b = typeof EnvironmentConfiguration !== "undefined" && EnvironmentConfiguration) === "function" && matching_agency_http_service__b || Object, typeof (matching_agency_http_service__c = typeof response_util_service_ResponseUtilService !== "undefined" && response_util_service_ResponseUtilService) === "function" && matching_agency_http_service__c || Object])
], matching_agency_http_service_MatchingAgencyHttpService);

var matching_agency_http_service__a, matching_agency_http_service__b, matching_agency_http_service__c;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/matching-agency.http.service.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/service/matching-agency.store.ts
var matching_agency_store___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var matching_agency_store___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};












var matching_agency_store_MatchingAgencyStore = (function () {
    function MatchingAgencyStore(matchingAgencyHttpService, flashMessagesService, logService, translateService, userLocalStorageService, authenticationStore) {
        this.matchingAgencyHttpService = matchingAgencyHttpService;
        this.flashMessagesService = flashMessagesService;
        this.logService = logService;
        this.translateService = translateService;
        this.userLocalStorageService = userLocalStorageService;
        this.authenticationStore = authenticationStore;
        this.matchingAgencySubject = new BehaviorSubject["BehaviorSubject"](page_Page.empty());
        this.init();
    }
    MatchingAgencyStore.prototype.init = function () {
        if (this.authenticationStore.isSupportUser()) {
            this.getMatches(Constants.SEARCH_DEFAULT_PAGE, this.userLocalStorageService.getPagesize(PagesizeType.MATCHING_AGENCY), Constants.DEFAULT_MATCHING_AGENCY_FIELD_SORT_FIELD, null, Constants.SORT_DIRECTION_ASC).take(1).subscribe();
        }
    };
    Object.defineProperty(MatchingAgencyStore.prototype, "matches", {
        get: function () {
            return this.matchingAgencySubject.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MatchingAgencyStore.prototype, "count", {
        get: function () {
            return this.matchingAgencySubject.asObservable().map(function (page) { return page.totalElements; });
        },
        enumerable: true,
        configurable: true
    });
    MatchingAgencyStore.prototype.getMatches = function (page, size, sortField, secondarySortField, sortDirection) {
        var _this = this;
        var sort = 'sort=' + sortField + ',' + sortDirection;
        if (secondarySortField) {
            sort = sort + '&sort=' + secondarySortField + ',' + sortDirection;
        }
        return this.matchingAgencyHttpService.getMatches(page, size, sort).catch(function (error) {
            _this.flashMessagesService.error(_this.translateService.instant('MESSAGES.ERROR.GET_MATCHING_AGENCIES'));
            _this.logService.error("Error getting Matching Agencies: " + error);
            return Observable["Observable"].throw(error);
        }).map(function (agencyMatches) {
            _this.matchingAgencySubject.next(agencyMatches);
            return agencyMatches;
        });
    };
    MatchingAgencyStore.prototype.assignCandidate = function (candidateAssign) {
        var _this = this;
        return this.matchingAgencyHttpService.assign(candidateAssign)
            .catch(function (error) {
            _this.flashMessagesService.error(_this.translateService.instant('MESSAGES.ERROR.ASSIGN_MATCHING_AGENCY'));
            _this.logService.error("Error assigning Matching Agency: " + error);
            return Observable["Observable"].throw(error);
        })
            .map(function (result) {
            _this.flashMessagesService.success('EVENT.AGENCY_REVIEW.CANDIDATE_ASSIGNED');
            return result;
        });
    };
    MatchingAgencyStore.prototype.addAgency = function (newRec) {
        var _this = this;
        return this.matchingAgencyHttpService.add(newRec)
            .catch(function (error) {
            _this.flashMessagesService.error('MESSAGES.ERROR.ADD_AGENCY', "Error adding agency: " + error);
            return Observable["Observable"].throw(error);
        })
            .map(function (res) {
            _this.flashMessagesService.success('MESSAGES.SUCCESS.ADD_AGENCY_MATCHING');
            return res;
        });
    };
    return MatchingAgencyStore;
}());
matching_agency_store_MatchingAgencyStore = matching_agency_store___decorate([
    Object(core_es5["Injectable"])(),
    matching_agency_store___metadata("design:paramtypes", [typeof (matching_agency_store__a = typeof matching_agency_http_service_MatchingAgencyHttpService !== "undefined" && matching_agency_http_service_MatchingAgencyHttpService) === "function" && matching_agency_store__a || Object, typeof (matching_agency_store__b = typeof flash_messages_service_FlashMessagesService !== "undefined" && flash_messages_service_FlashMessagesService) === "function" && matching_agency_store__b || Object, typeof (matching_agency_store__c = typeof log_service_LogService !== "undefined" && log_service_LogService) === "function" && matching_agency_store__c || Object, typeof (matching_agency_store__d = typeof core["c" /* TranslateService */] !== "undefined" && core["c" /* TranslateService */]) === "function" && matching_agency_store__d || Object, typeof (matching_agency_store__e = typeof user_local_storage_service_UserLocalStorageService !== "undefined" && user_local_storage_service_UserLocalStorageService) === "function" && matching_agency_store__e || Object, typeof (matching_agency_store__f = typeof authentication_store_AuthenticationStore !== "undefined" && authentication_store_AuthenticationStore) === "function" && matching_agency_store__f || Object])
], matching_agency_store_MatchingAgencyStore);

var matching_agency_store__a, matching_agency_store__b, matching_agency_store__c, matching_agency_store__d, matching_agency_store__e, matching_agency_store__f;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/matching-agency.store.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/matching-agency-field.ts
var MatchingAgencyField = (function () {
    function MatchingAgencyField() {
    }
    return MatchingAgencyField;
}());

MatchingAgencyField.MATCHING_AGENCY_ID = 'matchingAgencyId';
MatchingAgencyField.PROPERTY_NAME = 'propertyName';
MatchingAgencyField.PROPERTY_ID = 'propertyId';
MatchingAgencyField.CREATED_DATE = 'createdDate';
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/matching-agency-field.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/models/event-agency-status.enum.ts
var EventAgencyStatus;
(function (EventAgencyStatus) {
    EventAgencyStatus[EventAgencyStatus["CREATE_NEW_AGENCY"] = 'CREATE_NEW_AGENCY'] = "CREATE_NEW_AGENCY";
    EventAgencyStatus[EventAgencyStatus["AGENCY_MAPPED"] = 'AGENCY_MAPPED'] = "AGENCY_MAPPED";
    EventAgencyStatus[EventAgencyStatus["NONE"] = 'NONE'] = "NONE";
})(EventAgencyStatus || (EventAgencyStatus = {}));
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/event-agency-status.enum.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/matching-agency/matching-agency.service.ts
var matching_agency_service___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var matching_agency_service___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};












var matching_agency_service_MatchingAgencyService = (function () {
    function MatchingAgencyService(matchingAgencyStore, userLocalStorageService, matchingAgencyHttpService, logService) {
        this.matchingAgencyStore = matchingAgencyStore;
        this.userLocalStorageService = userLocalStorageService;
        this.matchingAgencyHttpService = matchingAgencyHttpService;
        this.logService = logService;
        this.selectedAgency = new BehaviorSubject["BehaviorSubject"](null);
        this.selectedSortField = new BehaviorSubject["BehaviorSubject"]({ field: Constants.DEFAULT_MATCHING_AGENCY_FIELD_SORT_FIELD, direction: Constants.SORT_DIRECTION_ASC });
        this.selectedPage = new BehaviorSubject["BehaviorSubject"](null);
        this.init();
    }
    MatchingAgencyService.prototype.init = function () {
        this.setDefaultSort();
        this.setDefaultPage();
    };
    MatchingAgencyService.prototype.setDefaultSort = function () {
        this.selectedSortField.next({ field: Constants.DEFAULT_MATCHING_AGENCY_FIELD_SORT_FIELD, direction: Constants.SORT_DIRECTION_ASC });
    };
    MatchingAgencyService.prototype.setDefaultPage = function () {
        this.selectedPage.next(Constants.SEARCH_DEFAULT_PAGE);
    };
    Object.defineProperty(MatchingAgencyService.prototype, "agencies", {
        get: function () {
            return this.matchingAgencyStore.matches;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MatchingAgencyService.prototype, "totalAgencyCount", {
        get: function () {
            return this.matchingAgencyStore.count;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MatchingAgencyService.prototype, "selectedAgency$", {
        get: function () {
            return this.selectedAgency.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MatchingAgencyService.prototype, "selectedSortField$", {
        get: function () {
            return this.selectedSortField.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MatchingAgencyService.prototype, "selectedPage$", {
        get: function () {
            return this.selectedPage.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    MatchingAgencyService.prototype.setSelectedAgency = function (agency) {
        this.selectedAgency.next(agency);
    };
    MatchingAgencyService.prototype.resetSelectedAgency = function () {
        this.selectedAgency.next(null);
    };
    MatchingAgencyService.prototype.setSelectedSortField = function (field_, direction_) {
        this.selectedSortField.next({ field: field_, direction: direction_ });
    };
    MatchingAgencyService.prototype.resetSelectedSortField = function () {
        this.setDefaultSort();
    };
    MatchingAgencyService.prototype.setSelectedPage = function (page) {
        this.selectedPage.next(page);
    };
    MatchingAgencyService.prototype.resetSelectedPage = function () {
        this.setDefaultPage();
    };
    MatchingAgencyService.prototype.assignMatchingCandidate = function (candidateAssign) {
        return this.matchingAgencyStore.assignCandidate(candidateAssign);
    };
    MatchingAgencyService.prototype.refreshMatchingAgencies = function (page, field, direction) {
        this.setSelectedPage(page);
        var selectedField = field ? field : Constants.DEFAULT_MATCHING_AGENCY_FIELD_SORT_FIELD;
        var selectedDirection = direction ? direction : Constants.SORT_DIRECTION_ASC;
        this.setSelectedSortField(selectedField, selectedDirection);
        return this.matchingAgencyStore.getMatches(page, this.userLocalStorageService.getPagesize(PagesizeType.MATCHING_AGENCY), selectedField, this.getSecondarySource(selectedField), selectedDirection);
    };
    MatchingAgencyService.prototype.addAgency = function (newRec) {
        return this.matchingAgencyStore.addAgency(newRec);
    };
    MatchingAgencyService.prototype.getSecondarySource = function (field) {
        if (field === MatchingAgencyField.CREATED_DATE) {
            return MatchingAgencyField.PROPERTY_NAME;
        }
        else if (field === MatchingAgencyField.PROPERTY_NAME) {
            return MatchingAgencyField.CREATED_DATE;
        }
        else if (field === MatchingAgencyField.PROPERTY_ID) {
            return MatchingAgencyField.CREATED_DATE;
        }
        else {
            return MatchingAgencyField.MATCHING_AGENCY_ID;
        }
    };
    MatchingAgencyService.prototype.matchingAgencyProcess = function (model, runMatchingAgency) {
        var _this = this;
        if (runMatchingAgency) {
            return this.matchingAgencyHttpService.search(model.eventAgency.code, model.eventProperty.chain).pipe(Object(operators["map"])(function (response) {
                if (response) {
                    _this.logService.debug('matchingAgencyProcess - Agency match found, mark Event Agency as MAPPED');
                    model.eventAgency.code = response.agencyId;
                    model.eventAgency.subscriber = response.subscriber;
                    model.eventAgency.eventAgencyStatus = EventAgencyStatus.AGENCY_MAPPED;
                    model.eventAgency.originalCode = response.pseudoAgencyId ? response.pseudoAgencyId : null;
                }
                else {
                    _this.logService.debug('matchingAgencyProcess - Agency match NOT found, mark Event Agency as CREATE NEW');
                    model.eventAgency.eventAgencyStatus = EventAgencyStatus.CREATE_NEW_AGENCY;
                }
                return model;
            }), Object(operators["catchError"])(function (error) {
                _this.logService.error("matchingAgencyProcess - Agency match returned an error, mark Event Agency as CREATE NEW: " + error);
                // model is returned without changes
                model.eventAgency.eventAgencyStatus = EventAgencyStatus.CREATE_NEW_AGENCY;
                return Object(of["of"])(model);
            }));
        }
        else {
            model.eventAgency.eventAgencyStatus = model.eventAgency && model.eventAgency.newTravelAgency ? EventAgencyStatus.CREATE_NEW_AGENCY
                : EventAgencyStatus.NONE;
            return Object(of["of"])(model);
        }
    };
    return MatchingAgencyService;
}());
matching_agency_service_MatchingAgencyService = matching_agency_service___decorate([
    Object(core_es5["Injectable"])(),
    matching_agency_service___metadata("design:paramtypes", [typeof (matching_agency_service__a = typeof matching_agency_store_MatchingAgencyStore !== "undefined" && matching_agency_store_MatchingAgencyStore) === "function" && matching_agency_service__a || Object, typeof (matching_agency_service__b = typeof user_local_storage_service_UserLocalStorageService !== "undefined" && user_local_storage_service_UserLocalStorageService) === "function" && matching_agency_service__b || Object, typeof (matching_agency_service__c = typeof matching_agency_http_service_MatchingAgencyHttpService !== "undefined" && matching_agency_http_service_MatchingAgencyHttpService) === "function" && matching_agency_service__c || Object, typeof (matching_agency_service__d = typeof log_service_LogService !== "undefined" && log_service_LogService) === "function" && matching_agency_service__d || Object])
], matching_agency_service_MatchingAgencyService);

var matching_agency_service__a, matching_agency_service__b, matching_agency_service__c, matching_agency_service__d;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/matching-agency.service.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/directives/lowercase.directive.ts
var lowercase_directive___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var lowercase_directive___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};


var LowercaseDirective = (function () {
    function LowercaseDirective(control) {
        this.control = control;
    }
    LowercaseDirective.prototype.onInput = function (value) {
        this.convertCase(value);
    };
    LowercaseDirective.prototype.convertCase = function (value) {
        this.control.control.patchValue(value.toLowerCase());
    };
    return LowercaseDirective;
}());
lowercase_directive___decorate([
    Object(core_es5["HostListener"])('input', ['$event.target.value']),
    lowercase_directive___metadata("design:type", Function),
    lowercase_directive___metadata("design:paramtypes", [String]),
    lowercase_directive___metadata("design:returntype", void 0)
], LowercaseDirective.prototype, "onInput", null);
LowercaseDirective = lowercase_directive___decorate([
    Object(core_es5["Directive"])({
        selector: '[pioneerLowercase]'
    }),
    lowercase_directive___metadata("design:paramtypes", [typeof (lowercase_directive__a = typeof forms_es5["NgControl"] !== "undefined" && forms_es5["NgControl"]) === "function" && lowercase_directive__a || Object])
], LowercaseDirective);

var lowercase_directive__a;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/lowercase.directive.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/shared.module.ts
var shared_module___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var shared_module___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};



























// Add RXJS operators so that they can be used throughout the app




























































var SharedModule = (function () {
    function SharedModule(consoleLogSubscriber, httpLogSubscriber, environment) {
        if (environment.logServices.consoleLogSubscriber) {
            consoleLogSubscriber.init(environment.logServices.consoleLogSubscriber.logLevel);
        }
        if (environment.logServices.httpLogSubscriber) {
            httpLogSubscriber.init(environment.logServices.httpLogSubscriber.logLevel);
        }
    }
    return SharedModule;
}());
SharedModule = shared_module___decorate([
    Object(core_es5["NgModule"])({
        imports: [
            common_es5["CommonModule"],
            BootstrapModule,
            core["b" /* TranslateModule */],
            forms_es5["FormsModule"],
            PermissionModule,
            EnvironmentModule,
            router_es5["RouterModule"].forChild(routes),
            ng2_page_scroll["a" /* Ng2PageScrollModule */].forRoot(),
            ngx_bootstrap["c" /* TypeaheadModule */].forRoot(),
            pagination["a" /* PaginationModule */].forRoot(),
            forms_es5["ReactiveFormsModule"]
        ],
        exports: [
            common_es5["CommonModule"],
            BootstrapModule,
            core["b" /* TranslateModule */],
            forms_es5["FormsModule"],
            forms_es5["ReactiveFormsModule"],
            inline_search_component_InlineSearchComponent,
            flash_messages_component_FlashMessagesComponent,
            FormInputComponent,
            ValidationMessageComponent,
            ng2_page_scroll["a" /* Ng2PageScrollModule */],
            confirmation_modal_component_ConfirmationModalComponent,
            event_collision_modal_component_EventCollisionModalComponent,
            event_collision_modal_multiprompt_component_EventCollisionModalMultipromptComponent,
            expiration_modal_component_ExpirationModalComponent,
            iata_by_default_modal_component_IataByDefaultModalComponent,
            VersionComponent,
            PermissionModule,
            EnvironmentModule,
            PaymentStatusPipe,
            MasterBillPipe,
            SafeUrlPipe,
            reservation_status_pipe_ReservationStatusPipe,
            absolute_value_pipe_AbsoluteValuePipe,
            date_format_pipe_DateFormatPipe,
            locale_date_format_pipe_LocaleDateFormatPipe,
            payment_type_pipe_PaymentTypePipe,
            ngx_bootstrap["c" /* TypeaheadModule */],
            abbreviate_amount_pipe_AbbreviateAmountPipe,
            pagination["a" /* PaginationModule */],
            dropdown_search_component_DropdownSearchComponent,
            pagination_component_PaginationComponent,
            pagination_refresh_component_PaginationRefreshComponent,
            pagination_sort_component_PaginationSortComponent,
            PaymentCalculationComponent,
            UppercaseDirective,
            LowercaseDirective,
            unmatch_event_popup_component_UnmatchEventPopupComponent,
            confirm_component_ConfirmComponent,
            currency_directive_CurrencyDirective,
        ],
        declarations: [
            confirmation_modal_component_ConfirmationModalComponent,
            event_collision_modal_component_EventCollisionModalComponent,
            event_collision_modal_multiprompt_component_EventCollisionModalMultipromptComponent,
            expiration_modal_component_ExpirationModalComponent,
            iata_by_default_modal_component_IataByDefaultModalComponent,
            RouteNotFoundComponent,
            inline_search_component_InlineSearchComponent,
            flash_messages_component_FlashMessagesComponent,
            FormInputComponent,
            ValidationMessageComponent,
            VersionComponent,
            GenericErrorComponent,
            PaymentStatusPipe,
            MasterBillPipe,
            SafeUrlPipe,
            reservation_status_pipe_ReservationStatusPipe,
            absolute_value_pipe_AbsoluteValuePipe,
            date_format_pipe_DateFormatPipe,
            locale_date_format_pipe_LocaleDateFormatPipe,
            payment_type_pipe_PaymentTypePipe,
            abbreviate_amount_pipe_AbbreviateAmountPipe,
            dropdown_search_component_DropdownSearchComponent,
            focus_outside_directive_FocusOutsideDirective,
            HighlightPipe,
            pagination_component_PaginationComponent,
            pagination_refresh_component_PaginationRefreshComponent,
            pagination_sort_component_PaginationSortComponent,
            PaymentCalculationComponent,
            UppercaseDirective,
            LowercaseDirective,
            unmatch_event_popup_component_UnmatchEventPopupComponent,
            confirm_component_ConfirmComponent,
            currency_directive_CurrencyDirective,
        ],
        providers: [
            agency_lookup_http_service_AgencyLookupHttpService,
            agency_lookup_store_AgencyLookupStore,
            error_handler_service_ErrorHandlerService,
            log_service_LogService,
            console_log_subscriber_service_ConsoleLogSubscriberService,
            flash_messages_service_FlashMessagesService,
            http_log_subscriber_service_HttpLogSubscriberService,
            property_lookup_http_service_PropertyLookupHttpService,
            property_lookup_store_PropertyLookupStore,
            version_store_VersionStore,
            VersionHttpService,
            SpinnerService,
            { provide: core_es5["ErrorHandler"], useClass: error_handler_LogErrorHandler },
            response_util_service_ResponseUtilService,
            pdf_service_PdfService,
            multi_agency_service_MultiAgencyService,
            matching_property_service_MatchingPropertyService,
            common_es5["DatePipe"],
            reservation_status_pipe_ReservationStatusPipe,
            common_es5["CurrencyPipe"],
            common_es5["DecimalPipe"],
            common_es5["PercentPipe"],
            common_es5["UpperCasePipe"],
            { provide: common_http_es5["a" /* HTTP_INTERCEPTORS */], useClass: spinner_interceptor_SpinnerInterceptor, multi: true },
            { provide: common_http_es5["a" /* HTTP_INTERCEPTORS */], useClass: CacheInterceptor, multi: true },
            report_service_ReportService,
            abbreviate_amount_pipe_AbbreviateAmountPipe,
            HighlightPipe,
            common_es5["TitleCasePipe"],
            event_match_log_http_service_EventMatchLogHttpService,
            unsaved_changes_guard_UnsavedChangesGuard,
            matching_agency_service_MatchingAgencyService,
        ],
        entryComponents: [
            confirm_component_ConfirmComponent,
        ]
    }),
    shared_module___metadata("design:paramtypes", [typeof (shared_module__a = typeof console_log_subscriber_service_ConsoleLogSubscriberService !== "undefined" && console_log_subscriber_service_ConsoleLogSubscriberService) === "function" && shared_module__a || Object, typeof (shared_module__b = typeof http_log_subscriber_service_HttpLogSubscriberService !== "undefined" && http_log_subscriber_service_HttpLogSubscriberService) === "function" && shared_module__b || Object, typeof (shared_module__c = typeof EnvironmentConfiguration !== "undefined" && EnvironmentConfiguration) === "function" && shared_module__c || Object])
], SharedModule);

var shared_module__a, shared_module__b, shared_module__c;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/shared.module.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/user/user.routes.ts
var user_routes_routes = [];
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/user.routes.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/user/user.module.ts
var user_module___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




var UserModule = (function () {
    function UserModule() {
    }
    return UserModule;
}());
UserModule = user_module___decorate([
    Object(core_es5["NgModule"])({
        imports: [
            SharedModule,
            router_es5["RouterModule"].forChild(user_routes_routes)
        ],
        declarations: []
    })
], UserModule);

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/user.module.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/confirmation-modal/confirmation-modal-config.ts
var ConfirmationModalConfig = (function () {
    function ConfirmationModalConfig(content, cancel, confirm, title, closed) {
        this.content = content;
        this.cancel = cancel;
        this.confirm = confirm;
        this.title = title;
        this.closed = closed;
    }
    return ConfirmationModalConfig;
}());

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/confirmation-modal-config.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/helper/unsubscriber.ts

var unsubscriber_Unsubscriber = (function () {
    function Unsubscriber() {
        this.subscriptions = [];
        this._destroyed$ = new Subject["Subject"]();
    }
    Unsubscriber.prototype.addSubscription = function (subscription) {
        if (Array.isArray(subscription)) {
            (_a = this.subscriptions).push.apply(_a, subscription);
        }
        else {
            this.subscriptions.push(subscription);
        }
        var _a;
    };
    Unsubscriber.prototype.unsubscribe = function () {
        this.subscriptions
            .filter(function (subscription) { return subscription; })
            .forEach(function (subscription) {
            subscription.unsubscribe();
        });
    };
    Unsubscriber.prototype.ngOnDestroy = function () {
        this.unsubscribe();
        this._destroyed$.next();
        this._destroyed$.complete();
    };
    return Unsubscriber;
}());

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/unsubscriber.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/payment/automatic-payment-toggle/automatic-payment-toggle.component.ts
var automatic_payment_toggle_component___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var automatic_payment_toggle_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var automatic_payment_toggle_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};








var automatic_payment_toggle_component_AutomaticPaymentToggleComponent = (function (_super) {
    automatic_payment_toggle_component___extends(AutomaticPaymentToggleComponent, _super);
    function AutomaticPaymentToggleComponent(errorHandlerService, translateService, eventStore) {
        var _this = _super.call(this) || this;
        _this.errorHandlerService = errorHandlerService;
        _this.translateService = translateService;
        _this.eventStore = eventStore;
        _this.confirmationModalConfig = new ConfirmationModalConfig();
        return _this;
    }
    Object.defineProperty(AutomaticPaymentToggleComponent.prototype, "event", {
        set: function (event) {
            this.onyxEvent = event;
        },
        enumerable: true,
        configurable: true
    });
    AutomaticPaymentToggleComponent.prototype.ngOnInit = function () {
        if (!this.onyxEvent) {
            var logMessage = 'Input property onyxEvent is null in AutomaticPaymentToggleComponent';
            var labelKey = 'MESSAGES.ERROR.INPUT_PROPERTY_NULL';
            var params = {
                property: 'onyxEvent',
                className: 'AutomaticPaymentToggleComponent'
            };
            var flashMessage = this.translateService.instant(labelKey, params);
            this.errorHandlerService.throw(logMessage, flashMessage);
        }
    };
    AutomaticPaymentToggleComponent.prototype.confirmBeforeTogglingAutoPayment = function () {
        this.confirmationModalConfig.content = this.translateService.instant('MESSAGES.CONFIRMATION.PROCEED');
        if (this.onyxEvent.autoPayment) {
            this.confirmationModalConfig.title = this.translateService.instant('EVENT.COMMISSION.AUTO_PAYMENT_CONFIRMATION_OFF_TITLE');
            this.confirmationModalConfig.confirm = this.translateService.instant('EVENT.COMMISSION.AUTO_PAYMENT_CONFIRMATION_OFF_CONFIRM');
        }
        else {
            this.confirmationModalConfig.title = this.translateService.instant('EVENT.COMMISSION.AUTO_PAYMENT_CONFIRMATION_ON_TITLE');
            this.confirmationModalConfig.confirm = this.translateService.instant('EVENT.COMMISSION.AUTO_PAYMENT_CONFIRMATION_ON_CONFIRM');
        }
        this.confirmationModal.open();
        return false;
    };
    AutomaticPaymentToggleComponent.prototype.confirmBeforeAutopaymentToggleHandler = function (value) {
        if (value) {
            this.toggleAutoPaymentSetting();
        }
    };
    AutomaticPaymentToggleComponent.prototype.toggleAutoPaymentSetting = function () {
        // https://facebook.github.io/immutable-js/docs/#/Map/merge
        var updatedModel = this.onyxEvent.merge({
            autoPayment: !this.onyxEvent.autoPayment,
        });
        this.addSubscription(this.eventStore.updateAutoPayment(updatedModel).subscribe());
    };
    return AutomaticPaymentToggleComponent;
}(unsubscriber_Unsubscriber));
automatic_payment_toggle_component___decorate([
    Object(core_es5["ViewChild"])(confirmation_modal_component_ConfirmationModalComponent),
    automatic_payment_toggle_component___metadata("design:type", typeof (automatic_payment_toggle_component__a = typeof confirmation_modal_component_ConfirmationModalComponent !== "undefined" && confirmation_modal_component_ConfirmationModalComponent) === "function" && automatic_payment_toggle_component__a || Object)
], automatic_payment_toggle_component_AutomaticPaymentToggleComponent.prototype, "confirmationModal", void 0);
automatic_payment_toggle_component___decorate([
    Object(core_es5["Input"])(),
    automatic_payment_toggle_component___metadata("design:type", typeof (automatic_payment_toggle_component__b = typeof OnyxEvent !== "undefined" && OnyxEvent) === "function" && automatic_payment_toggle_component__b || Object),
    automatic_payment_toggle_component___metadata("design:paramtypes", [typeof (automatic_payment_toggle_component__c = typeof OnyxEvent !== "undefined" && OnyxEvent) === "function" && automatic_payment_toggle_component__c || Object])
], automatic_payment_toggle_component_AutomaticPaymentToggleComponent.prototype, "event", null);
automatic_payment_toggle_component_AutomaticPaymentToggleComponent = automatic_payment_toggle_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-automatic-payment-toggle',
        template: __webpack_require__("f0B1")
    }),
    automatic_payment_toggle_component___metadata("design:paramtypes", [typeof (automatic_payment_toggle_component__d = typeof error_handler_service_ErrorHandlerService !== "undefined" && error_handler_service_ErrorHandlerService) === "function" && automatic_payment_toggle_component__d || Object, typeof (automatic_payment_toggle_component__e = typeof core["c" /* TranslateService */] !== "undefined" && core["c" /* TranslateService */]) === "function" && automatic_payment_toggle_component__e || Object, typeof (automatic_payment_toggle_component__f = typeof event_store_EventStore !== "undefined" && event_store_EventStore) === "function" && automatic_payment_toggle_component__f || Object])
], automatic_payment_toggle_component_AutomaticPaymentToggleComponent);

var automatic_payment_toggle_component__a, automatic_payment_toggle_component__b, automatic_payment_toggle_component__c, automatic_payment_toggle_component__d, automatic_payment_toggle_component__e, automatic_payment_toggle_component__f;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/automatic-payment-toggle.component.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/lookup/property-lookup/payor-type.resolver.ts
var payor_type_resolver___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var payor_type_resolver___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};



var PayorTypeResolver = (function () {
    function PayorTypeResolver(propertyLookupStore, authenticationStore) {
        this.propertyLookupStore = propertyLookupStore;
        this.authenticationStore = authenticationStore;
    }
    PayorTypeResolver.prototype.resolve = function () {
        if (this.authenticationStore.hasPermission('MultiVendor')) {
            return this.propertyLookupStore.loadPayorTypes();
        }
    };
    return PayorTypeResolver;
}());
PayorTypeResolver = payor_type_resolver___decorate([
    Object(core_es5["Injectable"])(),
    payor_type_resolver___metadata("design:paramtypes", [typeof (payor_type_resolver__a = typeof property_lookup_store_PropertyLookupStore !== "undefined" && property_lookup_store_PropertyLookupStore) === "function" && payor_type_resolver__a || Object, typeof (payor_type_resolver__b = typeof authentication_store_AuthenticationStore !== "undefined" && authentication_store_AuthenticationStore) === "function" && payor_type_resolver__b || Object])
], PayorTypeResolver);

var payor_type_resolver__a, payor_type_resolver__b;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/payor-type.resolver.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/event-filter-type-enum.ts
/**
 * Even search filter types
 */
/**
 * Even search filter types
 */ var EventFilterType;
(function (EventFilterType) {
    EventFilterType[EventFilterType["COMMISSION_ID"] = 'commissionId'] = "COMMISSION_ID";
    EventFilterType[EventFilterType["FUNDING_REFERENCE_ID"] = 'fundingReferenceId'] = "FUNDING_REFERENCE_ID";
    EventFilterType[EventFilterType["PAYMENT_REFERENCE_ID"] = 'paymentReferenceId'] = "PAYMENT_REFERENCE_ID";
    EventFilterType[EventFilterType["PAYMENT_TYPE"] = 'type'] = "PAYMENT_TYPE";
    EventFilterType[EventFilterType["DATE_RANGE_PROPERTY"] = 'dateRangeProperty'] = "DATE_RANGE_PROPERTY";
    EventFilterType[EventFilterType["DATE_AFTER_PROPERTY"] = 'dateAfterProperty'] = "DATE_AFTER_PROPERTY";
    EventFilterType[EventFilterType["DATE_BEFORE_PROPERTY"] = 'dateBeforeProperty'] = "DATE_BEFORE_PROPERTY";
    EventFilterType[EventFilterType["DATE_RANGE_AGENCY"] = 'dateRangeAgency'] = "DATE_RANGE_AGENCY";
    EventFilterType[EventFilterType["DATE_AFTER_AGENCY"] = 'dateAfterAgency'] = "DATE_AFTER_AGENCY";
    EventFilterType[EventFilterType["DATE_BEFORE_AGENCY"] = 'dateBeforeAgency'] = "DATE_BEFORE_AGENCY";
    EventFilterType[EventFilterType["GUEST_NAME"] = 'guestName'] = "GUEST_NAME";
    EventFilterType[EventFilterType["COMPLETED"] = 'eventStatusCompleted'] = "COMPLETED";
    EventFilterType[EventFilterType["MISSING_AGENCY"] = 'eventStatusMissingAgency'] = "MISSING_AGENCY";
    EventFilterType[EventFilterType["ARCHIVED"] = 'includeArchivedEvents'] = "ARCHIVED";
    EventFilterType[EventFilterType["DELETED"] = 'includeDeletedEvents'] = "DELETED";
    EventFilterType[EventFilterType["PAYMENT_STATUS"] = 'paymentStatus'] = "PAYMENT_STATUS";
    EventFilterType[EventFilterType["EVENT_PAYMENT_STATUS"] = 'eventPaymentStatus'] = "EVENT_PAYMENT_STATUS";
    EventFilterType[EventFilterType["COMM_RETENTION"] = 'includeCommRetentionEvents'] = "COMM_RETENTION";
    EventFilterType[EventFilterType["MISSING_EMAIL_CONTACT"] = 'missingContactEmail'] = "MISSING_EMAIL_CONTACT";
})(EventFilterType || (EventFilterType = {}));
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/event-filter-type-enum.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/event-filter.ts
var event_filter___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var EventSearchFilterRecord = Object(immutable["Record"])({
    filterField: null,
    filterValue: null
});
var EventSearchFilter = (function (_super) {
    event_filter___extends(EventSearchFilter, _super);
    function EventSearchFilter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return EventSearchFilter;
}(EventSearchFilterRecord));

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/event-filter.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/event-menu-search-filter.ts
var event_menu_search_filter___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var EventMenuSearchFilterPaymentStatusRecord = Object(immutable["Record"])({
    inProcess: true,
    unpaid: true,
    paid: true,
    cancelled: false,
});
var EventMenuSearchFilterPaymentStatus = (function (_super) {
    event_menu_search_filter___extends(EventMenuSearchFilterPaymentStatus, _super);
    function EventMenuSearchFilterPaymentStatus() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return EventMenuSearchFilterPaymentStatus;
}(EventMenuSearchFilterPaymentStatusRecord));

var EventMenuSearchFilterEventPaymentStatusRecord = Object(immutable["Record"])({
    paid: false,
    partial: false,
    unpaid: false
});
var EventMenuSearchFilterEventPaymentStatus = (function (_super) {
    event_menu_search_filter___extends(EventMenuSearchFilterEventPaymentStatus, _super);
    function EventMenuSearchFilterEventPaymentStatus() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return EventMenuSearchFilterEventPaymentStatus;
}(EventMenuSearchFilterEventPaymentStatusRecord));

var EventMenuSearchFilterRecord = Object(immutable["Record"])({
    commissionId: null,
    fundingReferenceId: null,
    paymentReferenceId: null,
    startDate: null,
    endDate: null,
    guestName: null,
    eventStatusCompleted: false,
    eventStatusMissingAgency: false,
    eventStatusArchived: false,
    paymentStatus: {
        inProcess: false,
        unpaid: false,
        paid: false,
        cancelled: false,
    },
    eventPaymentStatus: {
        paid: false,
        partial: false,
        unpaid: false
    },
    includeArchivedEvents: false,
    includeDeletedEvents: false,
    hasPrepayment: false,
    includeCommRetentionEvents: false,
    dashboardPaymentStatus: null,
    dashboardMissingContactEmail: null
});
var EventMenuSearchFilter = (function (_super) {
    event_menu_search_filter___extends(EventMenuSearchFilter, _super);
    function EventMenuSearchFilter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return EventMenuSearchFilter;
}(EventMenuSearchFilterRecord));

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/event-menu-search-filter.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/ui-search-status-mapping-enum.ts
// https://onyxpayments.atlassian.net/wiki/spaces/PION/pages/35160086/Payment+Statuses
// https://onyxpayments.atlassian.net/wiki/spaces/PION/pages/35160086/Payment+Statuses
var UISearchStatusMappingEnum;
(function (UISearchStatusMappingEnum) {
    UISearchStatusMappingEnum[UISearchStatusMappingEnum["PAYMENT_IN_PROCESS"] = 'paymentInProcess'] = "PAYMENT_IN_PROCESS";
    UISearchStatusMappingEnum[UISearchStatusMappingEnum["UNPAID"] = 'unpaid'] = "UNPAID";
    UISearchStatusMappingEnum[UISearchStatusMappingEnum["PAID"] = 'paid'] = "PAID";
    UISearchStatusMappingEnum[UISearchStatusMappingEnum["CANCELLED"] = 'cancelled'] = "CANCELLED";
    UISearchStatusMappingEnum[UISearchStatusMappingEnum["PARTIAL"] = 'partial'] = "PARTIAL";
    UISearchStatusMappingEnum[UISearchStatusMappingEnum["INVOICED"] = 'invoiced'] = "INVOICED";
    UISearchStatusMappingEnum[UISearchStatusMappingEnum["PAID_DIRECT"] = 'paidDirect'] = "PAID_DIRECT";
    UISearchStatusMappingEnum[UISearchStatusMappingEnum["PAY_SENT"] = 'paySent'] = "PAY_SENT";
    UISearchStatusMappingEnum[UISearchStatusMappingEnum["PENDING"] = 'pending'] = "PENDING";
    UISearchStatusMappingEnum[UISearchStatusMappingEnum["READY_TO_INITIATE"] = 'readyToInitiate'] = "READY_TO_INITIATE";
    UISearchStatusMappingEnum[UISearchStatusMappingEnum["REQUEST_REJECTED"] = 'requestRejected'] = "REQUEST_REJECTED";
    UISearchStatusMappingEnum[UISearchStatusMappingEnum["REQUESTED"] = 'requested'] = "REQUESTED";
    UISearchStatusMappingEnum[UISearchStatusMappingEnum["RESENT_REQUEST"] = 'resentRequest'] = "RESENT_REQUEST";
    UISearchStatusMappingEnum[UISearchStatusMappingEnum["FUNDED"] = 'funded'] = "FUNDED";
    UISearchStatusMappingEnum[UISearchStatusMappingEnum["PAY_CLEARED"] = 'payCleared'] = "PAY_CLEARED";
    UISearchStatusMappingEnum[UISearchStatusMappingEnum["CHECK_STOPPED"] = 'checkStopped'] = "CHECK_STOPPED";
    UISearchStatusMappingEnum[UISearchStatusMappingEnum["PAY_REISSUED"] = 'payReissued'] = "PAY_REISSUED";
    UISearchStatusMappingEnum[UISearchStatusMappingEnum["REJECTED_PAYMENT_REQUESTS"] = 'rejectedPaymentRequests'] = "REJECTED_PAYMENT_REQUESTS";
    UISearchStatusMappingEnum[UISearchStatusMappingEnum["REQUEST_PAYMENTS"] = 'requestPayments'] = "REQUEST_PAYMENTS";
    UISearchStatusMappingEnum[UISearchStatusMappingEnum["MISSING_PAYMENT_ITEMS"] = 'missingPaymentItems'] = "MISSING_PAYMENT_ITEMS";
    UISearchStatusMappingEnum[UISearchStatusMappingEnum["MISSING_CONTACT_EMAIL"] = 'MissingEmailContact'] = "MISSING_CONTACT_EMAIL";
})(UISearchStatusMappingEnum || (UISearchStatusMappingEnum = {}));
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/ui-search-status-mapping-enum.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/ui-search-type-mapping-enum.ts
// https://onyxpayments.atlassian.net/wiki/spaces/PION/pages/35160086/Payment+Statuses
// https://onyxpayments.atlassian.net/wiki/spaces/PION/pages/35160086/Payment+Statuses
var UISearchTypeMappingEnum;
(function (UISearchTypeMappingEnum) {
    UISearchTypeMappingEnum[UISearchTypeMappingEnum["HAS_PREPAYMENT"] = 'pre'] = "HAS_PREPAYMENT";
    UISearchTypeMappingEnum[UISearchTypeMappingEnum["FINAL"] = 'final'] = "FINAL";
})(UISearchTypeMappingEnum || (UISearchTypeMappingEnum = {}));
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/ui-search-type-mapping-enum.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/service/event-filter-util-service.ts
var event_filter_util_service___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var event_filter_util_service___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};






var event_filter_util_service_EventFilterUtilsService = EventFilterUtilsService_1 = (function () {
    function EventFilterUtilsService(translateService) {
        this.translateService = translateService;
    }
    /**
     * Parses 2 dates represented as strings and returns the value to store in the EventFilterType.DATE_RANGE filter
     * @param date1
     * @param date2
     * @returns {string}
     */
    EventFilterUtilsService.getDateRangeFilterValue = function (date1, date2) {
        return date_util_DateUtil.formatDate(date1) + this.dateRangeValueSeparator + date_util_DateUtil.formatDate(date2);
    };
    EventFilterUtilsService.parseFilterValueAsDateRange = function (dateRangeString) {
        return dateRangeString.split(this.dateRangeValueSeparator);
    };
    /**
     * This method returns a key to identify what kind of token to make.
     * This is useful to ensure that two filters with the same key can't be present at the same time.
     * @param filter
     * @returns string
     */
    EventFilterUtilsService.prototype.getUniqueTokenKey = function (filter) {
        // only 1 date filter is allowed at a time
        if (filter.filterField === EventFilterType.DATE_RANGE_PROPERTY.toString() ||
            filter.filterField === EventFilterType.DATE_BEFORE_PROPERTY.toString() ||
            filter.filterField === EventFilterType.DATE_AFTER_PROPERTY.toString()) {
            return EventFilterType.DATE_RANGE_PROPERTY.toString();
        }
        else if (filter.filterField === EventFilterType.DATE_RANGE_AGENCY.toString() ||
            filter.filterField === EventFilterType.DATE_BEFORE_AGENCY.toString() ||
            filter.filterField === EventFilterType.DATE_AFTER_AGENCY.toString()) {
            return EventFilterType.DATE_RANGE_AGENCY.toString();
        }
        else if (filter.filterField === EventFilterType.GUEST_NAME.toString() ||
            filter.filterField === EventFilterType.PAYMENT_STATUS.toString() ||
            filter.filterField === EventFilterType.EVENT_PAYMENT_STATUS.toString()) {
            // these filters allow for for multiple tokens
            return filter.filterField + ':' + filter.filterValue;
        }
        // by default, there can only be 1 instance of a filter token at a time
        return filter.filterField;
    };
    /**
     * Returns a string representation of a given Date that will be displayed in a search filter token
     * @param date
     * @returns {string}
     */
    EventFilterUtilsService.prototype.getDateStringForToken = function (date) {
        return (date.getMonth() + 1) + '/' + date.getDate() + '/' + date.getFullYear();
    };
    /**
     * This method will return the string used to display the value of the filter in a token
     * @param filter
     * @returns {string}
     */
    EventFilterUtilsService.prototype.getTokenDisplayString = function (filter) {
        if (filter.filterField === EventFilterType.COMPLETED.toString()) {
            return this.translateService.instant('EVENTS.EVENT_STATUS_COMPLETED');
        }
        else if (filter.filterField === EventFilterType.MISSING_AGENCY.toString()) {
            return this.translateService.instant('EVENTS.EVENT_STATUS_MISSING_AGENCY');
        }
        else if (filter.filterField === EventFilterType.ARCHIVED.toString()) {
            return this.translateService.instant('EVENTS.EVENT_STATUS_ARCHIVED');
        }
        else if (filter.filterField === EventFilterType.DELETED.toString()) {
            return this.translateService.instant('EVENTS.EVENT_STATUS_DELETED');
        }
        else if (filter.filterField === EventFilterType.COMM_RETENTION.toString()) {
            return this.translateService.instant('EVENTS.EVENT_STATUS_COMM_RETENTION');
        }
        else if (filter.filterField === EventFilterType.DATE_RANGE_PROPERTY.toString()
            || filter.filterField === EventFilterType.DATE_RANGE_AGENCY.toString()) {
            var strings = filter.filterValue.split(EventFilterUtilsService_1.dateRangeValueSeparator);
            if (strings.length === 2) {
                return this.getDateStringForToken(date_util_DateUtil.parseDate(strings[0])) + ' - ' +
                    this.getDateStringForToken(date_util_DateUtil.parseDate(strings[1]));
            }
            else {
                return 'error';
            }
        }
        else if (filter.filterField === EventFilterType.DATE_BEFORE_PROPERTY.toString()
            || filter.filterField === EventFilterType.DATE_AFTER_PROPERTY.toString()
            || filter.filterField === EventFilterType.DATE_BEFORE_AGENCY.toString()
            || filter.filterField === EventFilterType.DATE_AFTER_AGENCY.toString()) {
            return this.getDateStringForToken(date_util_DateUtil.parseDate(filter.filterValue));
        }
        else if (filter.filterField === EventFilterType.PAYMENT_STATUS.toString()) {
            return this.labelForPaymentStatusValue(filter.filterValue);
        }
        else if (filter.filterField === EventFilterType.EVENT_PAYMENT_STATUS.toString()) {
            return this.labelForEventPaymentStatusValue(filter.filterValue);
        }
        else if (filter.filterField === EventFilterType.PAYMENT_TYPE.toString()) {
            return this.labelForEventTypeValue(filter.filterValue);
        }
        else if (filter.filterField === EventFilterType.MISSING_EMAIL_CONTACT.toString()) {
            return this.labelForPaymentStatusValue(filter.filterValue);
        }
        else {
            return filter.filterValue;
        }
    };
    EventFilterUtilsService.prototype.labelForEventPaymentStatusValue = function (filterValue) {
        var label = filterValue;
        if (filterValue === UISearchStatusMappingEnum.PAID.toString()) {
            label = 'EVENTS.EVENT_PAYMENT_STATUS_FILTER_VALUE.PAID';
        }
        else if (filterValue === UISearchStatusMappingEnum.PARTIAL.toString()) {
            label = 'EVENTS.EVENT_PAYMENT_STATUS_FILTER_VALUE.PARTIAL';
        }
        else if (filterValue === UISearchStatusMappingEnum.UNPAID.toString()) {
            label = 'EVENTS.EVENT_PAYMENT_STATUS_FILTER_VALUE.UNPAID';
        }
        return this.translateService.instant(label);
    };
    EventFilterUtilsService.prototype.labelForPaymentStatusValue = function (filterValue) {
        var label = filterValue;
        if (filterValue === UISearchStatusMappingEnum.PAID.toString()) {
            label = 'EVENTS.PAYMENT_STATUS_FILTER_VALUE.PAID';
        }
        else if (filterValue === UISearchStatusMappingEnum.UNPAID.toString()) {
            label = 'EVENTS.PAYMENT_STATUS_FILTER_VALUE.UNPAID';
        }
        else if (filterValue === UISearchStatusMappingEnum.PAYMENT_IN_PROCESS.toString()) {
            label = 'EVENTS.PAYMENT_STATUS_FILTER_VALUE.PAYMENT_IN_PROCESS';
        }
        else if (filterValue === UISearchStatusMappingEnum.CANCELLED.toString()) {
            label = 'EVENTS.PAYMENT_STATUS_FILTER_VALUE.CANCELLED';
        }
        else if (filterValue === UISearchStatusMappingEnum.INVOICED.toString()) {
            label = 'EVENTS.PAYMENT_STATUS_FILTER_VALUE.INVOICED';
        }
        else if (filterValue === UISearchStatusMappingEnum.PAID_DIRECT.toString()) {
            label = 'EVENTS.PAYMENT_STATUS_FILTER_VALUE.PAID_DIRECT';
        }
        else if (filterValue === UISearchStatusMappingEnum.PAY_SENT.toString()) {
            label = 'EVENTS.PAYMENT_STATUS_FILTER_VALUE.PAY_SENT';
        }
        else if (filterValue === UISearchStatusMappingEnum.PENDING.toString()) {
            label = 'EVENTS.PAYMENT_STATUS_FILTER_VALUE.PENDING';
        }
        else if (filterValue === UISearchStatusMappingEnum.READY_TO_INITIATE.toString()) {
            label = 'EVENTS.PAYMENT_STATUS_FILTER_VALUE.READY_TO_INITIATE';
        }
        else if (filterValue === UISearchStatusMappingEnum.REQUEST_REJECTED.toString()) {
            label = 'EVENTS.PAYMENT_STATUS_FILTER_VALUE.REQUEST_REJECTED';
        }
        else if (filterValue === UISearchStatusMappingEnum.REQUESTED.toString()) {
            label = 'EVENTS.PAYMENT_STATUS_FILTER_VALUE.REQUESTED';
        }
        else if (filterValue === UISearchStatusMappingEnum.RESENT_REQUEST.toString()) {
            label = 'EVENTS.PAYMENT_STATUS_FILTER_VALUE.RESENT_REQUEST';
        }
        else if (filterValue === UISearchStatusMappingEnum.FUNDED.toString()) {
            label = 'EVENTS.PAYMENT_STATUS_FILTER_VALUE.FUNDED';
        }
        else if (filterValue === UISearchStatusMappingEnum.PAY_CLEARED.toString()) {
            label = 'EVENTS.PAYMENT_STATUS_FILTER_VALUE.PAY_CLEARED';
        }
        else if (filterValue === UISearchStatusMappingEnum.CHECK_STOPPED.toString()) {
            label = 'EVENTS.PAYMENT_STATUS_FILTER_VALUE.CHECK_STOPPED';
        }
        else if (filterValue === UISearchStatusMappingEnum.PAY_REISSUED.toString()) {
            label = 'EVENTS.PAYMENT_STATUS_FILTER_VALUE.PAY_REISSUED';
        }
        else if (filterValue === UISearchStatusMappingEnum.REJECTED_PAYMENT_REQUESTS.toString()) {
            label = 'EVENTS.PAYMENT_STATUS_FILTER_VALUE.REJECTED_PAYMENT_REQUESTS';
        }
        else if (filterValue === UISearchStatusMappingEnum.REQUEST_PAYMENTS.toString()) {
            label = 'EVENTS.PAYMENT_STATUS_FILTER_VALUE.REQUEST_PAYMENTS';
        }
        else if (filterValue === UISearchStatusMappingEnum.MISSING_PAYMENT_ITEMS.toString()) {
            label = 'EVENTS.PAYMENT_STATUS_FILTER_VALUE.MISSING_PAYMENT_ITEMS';
        }
        else if (filterValue === UISearchStatusMappingEnum.MISSING_CONTACT_EMAIL.toString()) {
            label = 'EVENTS.PAYMENT_STATUS_FILTER_VALUE.MISSING_CONTACT_EMAIL';
        }
        return this.translateService.instant(label);
    };
    EventFilterUtilsService.prototype.labelForEventTypeValue = function (filterValue) {
        var label = filterValue;
        if (filterValue === UISearchTypeMappingEnum.HAS_PREPAYMENT.toString()) {
            label = 'EVENTS.EVENT_TYPE_FILTER_VALUE.HAS_PREPAYMENT';
        }
        else if (filterValue === UISearchTypeMappingEnum.FINAL.toString()) {
            label = 'EVENTS.EVENT_TYPE_FILTER_VALUE.FINAL';
        }
        return this.translateService.instant(label);
    };
    return EventFilterUtilsService;
}());
event_filter_util_service_EventFilterUtilsService.dateRangeValueSeparator = ';';
event_filter_util_service_EventFilterUtilsService = EventFilterUtilsService_1 = event_filter_util_service___decorate([
    Object(core_es5["Injectable"])(),
    event_filter_util_service___metadata("design:paramtypes", [typeof (event_filter_util_service__a = typeof core["c" /* TranslateService */] !== "undefined" && core["c" /* TranslateService */]) === "function" && event_filter_util_service__a || Object])
], event_filter_util_service_EventFilterUtilsService);

var EventFilterUtilsService_1, event_filter_util_service__a;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/event-filter-util-service.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/menus/event-search-filter/event-menu-search-filter-mapper.ts
var event_menu_search_filter_mapper___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};








var event_menu_search_filter_mapper_EventMenuSearchFilterMapper = (function () {
    function EventMenuSearchFilterMapper() {
    }
    EventMenuSearchFilterMapper.prototype.toSearchFilterSet = function (filterRecord, isMultiVendor) {
        var filterSet = Object(immutable["OrderedSet"])([]);
        if (filterRecord.commissionId && filterRecord.commissionId !== '') {
            filterSet = filterSet.add(this.asSearchFilter(EventFilterType.COMMISSION_ID, filterRecord.commissionId));
        }
        if (filterRecord.fundingReferenceId && filterRecord.fundingReferenceId !== '') {
            filterSet = filterSet.add(this.asSearchFilter(EventFilterType.FUNDING_REFERENCE_ID, filterRecord.fundingReferenceId));
        }
        if (filterRecord.paymentReferenceId && filterRecord.paymentReferenceId !== '') {
            filterSet = filterSet.add(this.asSearchFilter(EventFilterType.PAYMENT_REFERENCE_ID, filterRecord.paymentReferenceId));
        }
        // Add prepayment type filter if hasPrepayment is checked
        if (filterRecord.hasPrepayment) {
            filterSet = filterSet.add(this.asSearchFilter(EventFilterType.PAYMENT_TYPE, PaymentType.PREPAYMENT));
        }
        if (isMultiVendor) {
            if ((filterRecord.endDate && filterRecord.endDate !== '') && (filterRecord.startDate && filterRecord.startDate !== '')) {
                filterSet = filterSet.add(this.asSearchFilter(EventFilterType.DATE_RANGE_AGENCY, event_filter_util_service_EventFilterUtilsService.getDateRangeFilterValue(filterRecord.startDate, filterRecord.endDate)));
            }
            else if (filterRecord.startDate && filterRecord.startDate !== '') {
                filterSet = filterSet.add(this.asSearchFilter(EventFilterType.DATE_AFTER_AGENCY, date_util_DateUtil.formatDate(filterRecord.startDate)));
            }
            else if (filterRecord.endDate && filterRecord.endDate !== '') {
                filterSet = filterSet.add(this.asSearchFilter(EventFilterType.DATE_BEFORE_AGENCY, date_util_DateUtil.formatDate(filterRecord.endDate)));
            }
        }
        else {
            if ((filterRecord.endDate && filterRecord.endDate !== '') && (filterRecord.startDate && filterRecord.startDate !== '')) {
                filterSet = filterSet.add(this.asSearchFilter(EventFilterType.DATE_RANGE_PROPERTY, event_filter_util_service_EventFilterUtilsService.getDateRangeFilterValue(filterRecord.startDate, filterRecord.endDate)));
            }
            else if (filterRecord.startDate && filterRecord.startDate !== '') {
                filterSet = filterSet.add(this.asSearchFilter(EventFilterType.DATE_AFTER_PROPERTY, date_util_DateUtil.formatDate(filterRecord.startDate)));
            }
            else if (filterRecord.endDate && filterRecord.endDate !== '') {
                filterSet = filterSet.add(this.asSearchFilter(EventFilterType.DATE_BEFORE_PROPERTY, date_util_DateUtil.formatDate(filterRecord.endDate)));
            }
        }
        if (filterRecord.eventStatusCompleted) {
            filterSet = filterSet.add(this.asSearchFilter(EventFilterType.COMPLETED, JSON.stringify(filterRecord.eventStatusCompleted)));
        }
        if (filterRecord.eventStatusMissingAgency) {
            filterSet = filterSet.add(this.asSearchFilter(EventFilterType.MISSING_AGENCY, JSON.stringify(filterRecord.eventStatusMissingAgency)));
        }
        if (filterRecord.includeArchivedEvents) {
            filterSet = filterSet.add(this.asSearchFilter(EventFilterType.ARCHIVED, JSON.stringify(filterRecord.includeArchivedEvents)));
        }
        if (filterRecord.includeCommRetentionEvents) {
            filterSet = filterSet.add(this.asSearchFilter(EventFilterType.COMM_RETENTION, JSON.stringify(filterRecord.includeCommRetentionEvents)));
        }
        if (filterRecord.includeDeletedEvents) {
            filterSet = filterSet.add(this.asSearchFilter(EventFilterType.DELETED, JSON.stringify(filterRecord.includeDeletedEvents)));
        }
        if (filterRecord.guestName) {
            filterSet = filterSet.add(this.asSearchFilter(EventFilterType.GUEST_NAME, filterRecord.guestName));
        }
        filterSet = this.buildPaymentFilters(filterRecord, filterSet);
        if (filterRecord.dashboardPaymentStatus && filterRecord.dashboardPaymentStatus !== '') {
            filterSet = this.buildDashboardPaymentFilter(filterRecord, filterSet);
        }
        if (filterRecord.dashboardMissingContactEmail) {
            filterSet = this.buildDashboardMissingEmailContact(filterRecord, filterSet);
        }
        // Event payment filters
        filterSet = this.buildEventPaymentFilters(filterRecord, filterSet);
        return filterSet;
    };
    EventMenuSearchFilterMapper.prototype.asSearchFilter = function (filterField, filterValue) {
        var filter = new EventSearchFilter({
            filterField: filterField.toString(),
            filterValue: filterValue ? filterValue.trim() : filterValue
        });
        return filter;
    };
    EventMenuSearchFilterMapper.prototype.buildPaymentFilters = function (filterRecord, filterSet) {
        var paymentStatusRecord = filterRecord.paymentStatus;
        // reapply selected filters
        if (paymentStatusRecord.paid) {
            filterSet = filterSet.add(this.asSearchFilter(EventFilterType.PAYMENT_STATUS, 'paid'));
        }
        if (paymentStatusRecord.inProcess) {
            filterSet = filterSet.add(this.asSearchFilter(EventFilterType.PAYMENT_STATUS, 'paymentInProcess'));
        }
        if (paymentStatusRecord.unpaid) {
            filterSet = filterSet.add(this.asSearchFilter(EventFilterType.PAYMENT_STATUS, 'unpaid'));
        }
        if (paymentStatusRecord.cancelled) {
            filterSet = filterSet.add(this.asSearchFilter(EventFilterType.PAYMENT_STATUS, 'cancelled'));
        }
        return filterSet;
    };
    EventMenuSearchFilterMapper.prototype.buildDashboardPaymentFilter = function (filterRecord, filterSet) {
        var paymentStatusName = filterRecord.dashboardPaymentStatus;
        if (paymentStatusName && paymentStatusName !== '') {
            filterSet = filterSet.add(this.asSearchFilter(EventFilterType.PAYMENT_STATUS, paymentStatusName));
        }
        return filterSet;
    };
    EventMenuSearchFilterMapper.prototype.buildDashboardMissingEmailContact = function (filterRecord, filterSet) {
        var missingContactEmail = filterRecord.dashboardMissingContactEmail;
        if (missingContactEmail && missingContactEmail !== '') {
            filterSet = filterSet.add(this.asSearchFilter(EventFilterType.MISSING_EMAIL_CONTACT, missingContactEmail));
        }
        return filterSet;
    };
    EventMenuSearchFilterMapper.prototype.buildEventPaymentFilters = function (filterRecord, filterSet) {
        var eventPaymentStatusRecord = filterRecord.eventPaymentStatus;
        // reapply selected filters
        if (eventPaymentStatusRecord.paid) {
            filterSet = filterSet.add(this.asSearchFilter(EventFilterType.EVENT_PAYMENT_STATUS, 'paid'));
        }
        if (eventPaymentStatusRecord.partial) {
            filterSet = filterSet.add(this.asSearchFilter(EventFilterType.EVENT_PAYMENT_STATUS, 'partial'));
        }
        if (eventPaymentStatusRecord.unpaid) {
            filterSet = filterSet.add(this.asSearchFilter(EventFilterType.EVENT_PAYMENT_STATUS, 'unpaid'));
        }
        return filterSet;
    };
    EventMenuSearchFilterMapper.prototype.toEventMenuSearchFilter = function (filterSet, isMultiVendor) {
        var filterRecord = {};
        filterRecord.eventStatusMissingAgency = this.hasSearchFilter(filterSet, EventFilterType.MISSING_AGENCY);
        filterRecord.eventStatusCompleted = this.hasSearchFilter(filterSet, EventFilterType.COMPLETED);
        filterRecord.includeArchivedEvents = this.hasSearchFilter(filterSet, EventFilterType.ARCHIVED);
        filterRecord.includeCommRetentionEvents = this.hasSearchFilter(filterSet, EventFilterType.COMM_RETENTION);
        filterRecord.includeDeletedEvents = this.hasSearchFilter(filterSet, EventFilterType.DELETED);
        filterRecord.guestName = this.getSearchFilterValue(filterSet, EventFilterType.GUEST_NAME);
        filterRecord.commissionId = this.getSearchFilterValue(filterSet, EventFilterType.COMMISSION_ID);
        filterRecord.paymentReferenceId = this.getSearchFilterValue(filterSet, EventFilterType.PAYMENT_REFERENCE_ID);
        filterRecord.fundingReferenceId = this.getSearchFilterValue(filterSet, EventFilterType.FUNDING_REFERENCE_ID);
        if (isMultiVendor) {
            filterRecord.startDate = this.getSearchFilterValue(filterSet, EventFilterType.DATE_AFTER_AGENCY);
            filterRecord.endDate = this.getSearchFilterValue(filterSet, EventFilterType.DATE_BEFORE_AGENCY);
        }
        else {
            filterRecord.startDate = this.getSearchFilterValue(filterSet, EventFilterType.DATE_AFTER_PROPERTY);
            filterRecord.endDate = this.getSearchFilterValue(filterSet, EventFilterType.DATE_BEFORE_PROPERTY);
        }
        filterRecord.hasPrepayment =
            this.hasSearchFilterByFieldAndValue(filterSet, EventFilterType.PAYMENT_TYPE, PaymentType.PREPAYMENT);
        if (isMultiVendor) {
            if (this.hasSearchFilter(filterSet, EventFilterType.DATE_RANGE_AGENCY)) {
                var dates = event_filter_util_service_EventFilterUtilsService.parseFilterValueAsDateRange(this.getSearchFilterValue(filterSet, EventFilterType.DATE_RANGE_AGENCY));
                filterRecord.startDate = dates[0];
                filterRecord.endDate = dates[1];
            }
        }
        else {
            if (this.hasSearchFilter(filterSet, EventFilterType.DATE_RANGE_PROPERTY)) {
                var dates = event_filter_util_service_EventFilterUtilsService.parseFilterValueAsDateRange(this.getSearchFilterValue(filterSet, EventFilterType.DATE_RANGE_PROPERTY));
                filterRecord.startDate = dates[0];
                filterRecord.endDate = dates[1];
            }
        }
        var paymentStatusRecord = {};
        paymentStatusRecord.unpaid =
            this.hasSearchFilterByFieldAndValue(filterSet, EventFilterType.PAYMENT_STATUS, 'unpaid');
        paymentStatusRecord.inProcess =
            this.hasSearchFilterByFieldAndValue(filterSet, EventFilterType.PAYMENT_STATUS, 'paymentInProcess');
        paymentStatusRecord.paid =
            this.hasSearchFilterByFieldAndValue(filterSet, EventFilterType.PAYMENT_STATUS, 'paid');
        paymentStatusRecord.cancelled =
            this.hasSearchFilterByFieldAndValue(filterSet, EventFilterType.PAYMENT_STATUS, 'cancelled');
        var allPaymentStatusFiltersAreFalse = !paymentStatusRecord.unpaid &&
            !paymentStatusRecord.inProcess &&
            !paymentStatusRecord.paid &&
            !paymentStatusRecord.cancelled;
        if (allPaymentStatusFiltersAreFalse) {
            // then they they all need to be enabled
            paymentStatusRecord.unpaid = true;
            paymentStatusRecord.inProcess = true;
            paymentStatusRecord.paid = true;
            paymentStatusRecord.cancelled = true;
        }
        filterRecord.paymentStatus = paymentStatusRecord;
        var eventPaymentStatusRecord = {};
        eventPaymentStatusRecord.paid =
            this.hasSearchFilterByFieldAndValue(filterSet, EventFilterType.EVENT_PAYMENT_STATUS, 'paid');
        eventPaymentStatusRecord.partial =
            this.hasSearchFilterByFieldAndValue(filterSet, EventFilterType.EVENT_PAYMENT_STATUS, 'partial');
        eventPaymentStatusRecord.unpaid =
            this.hasSearchFilterByFieldAndValue(filterSet, EventFilterType.EVENT_PAYMENT_STATUS, 'unpaid');
        filterRecord.eventPaymentStatus = eventPaymentStatusRecord;
        var updatedRecord = new EventMenuSearchFilter(filterRecord);
        return updatedRecord;
    };
    EventMenuSearchFilterMapper.prototype.hasSearchFilter = function (filterSet, filterField) {
        var isEmpty = filterSet.filter(function (filter) {
            return filterField.toString() === filter.filterField;
        }).isEmpty();
        return !isEmpty;
    };
    EventMenuSearchFilterMapper.prototype.getSearchFilterValue = function (filterSet, filterField) {
        return filterSet.filter(function (filter) {
            return filterField.toString() === filter.filterField;
        }).map(function (filter) { return filter.filterValue; }).first();
    };
    EventMenuSearchFilterMapper.prototype.hasSearchFilterByFieldAndValue = function (filterSet, filterField, filterValue) {
        var isEmpty = filterSet.filter(function (filter) {
            return filterField.toString() === filter.filterField && filterValue === filter.filterValue;
        }).isEmpty();
        return !isEmpty;
    };
    return EventMenuSearchFilterMapper;
}());
event_menu_search_filter_mapper_EventMenuSearchFilterMapper = event_menu_search_filter_mapper___decorate([
    Object(core_es5["Injectable"])()
], event_menu_search_filter_mapper_EventMenuSearchFilterMapper);

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/event-menu-search-filter-mapper.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/payment/model/payment-request.ts
var payment_request___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var PaymentRequestRecord = Object(immutable["Record"])({
    event: null,
    roomCommissions: null,
    adjustments: null,
    finalPayment: null,
    prepayment: null,
    approverType: null,
    estimatedTax: null,
    fundCurrency: null
});
var PaymentRequest = (function (_super) {
    payment_request___extends(PaymentRequest, _super);
    function PaymentRequest() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return PaymentRequest;
}(PaymentRequestRecord));

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/payment-request.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/config/agency-config-lookup.ts
var agency_config_lookup___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var AgencyConfigLookupRecord = Object(immutable["Record"])({
    agencyId: null,
});
var AgencyConfigLookup = (function (_super) {
    agency_config_lookup___extends(AgencyConfigLookup, _super);
    function AgencyConfigLookup() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return AgencyConfigLookup;
}(AgencyConfigLookupRecord));

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/agency-config-lookup.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/config/config-request.ts
var config_request___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var ConfigRequestRecord = Object(immutable["Record"])({
    config: null,
    property: null,
    agency: null,
    country: null
});
var ConfigRequest = (function (_super) {
    config_request___extends(ConfigRequest, _super);
    function ConfigRequest() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ConfigRequest;
}(ConfigRequestRecord));

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/config-request.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/config/country-config-lookup.ts
var country_config_lookup___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var CountryConfigLookupRecord = Object(immutable["Record"])({
    agencyCountry: null,
    vendorCountry: null
});
var CountryConfigLookup = (function (_super) {
    country_config_lookup___extends(CountryConfigLookup, _super);
    function CountryConfigLookup() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return CountryConfigLookup;
}(CountryConfigLookupRecord));

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/country-config-lookup.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/payment-request-action-data.ts
var payment_request_action_data___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var PaymentRequestActionDataRecord = Object(immutable["Record"])({
    email: null,
    reason: null,
    details: null,
    legalEntity: null,
    attachmentId: null,
});
var PaymentRequestActionData = (function (_super) {
    payment_request_action_data___extends(PaymentRequestActionData, _super);
    function PaymentRequestActionData() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return PaymentRequestActionData;
}(PaymentRequestActionDataRecord));

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/payment-request-action-data.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/payment/service/commission.service.ts
var commission_service___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var commission_service___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};













var commission_service_CommissionService = (function () {
    function CommissionService(httpClient, http, environment, userLocalStorageService, responseUtilService) {
        this.httpClient = httpClient;
        this.http = http;
        this.environment = environment;
        this.userLocalStorageService = userLocalStorageService;
        this.responseUtilService = responseUtilService;
        this.eventsGetUrl = this.environment.baseUrl + '/api/commissions/events';
        this.approvePostUrl = this.environment.baseUrl + '/api/commissions/approve';
        this.rejectPostUrl = this.environment.baseUrl + '/api/commissions/reject';
        this.commissionOoivUrl = this.environment.baseUrl + '/api/commissions/ooiv';
        this.legalEntityUrl = this.environment.baseUrl + '/api/commissions/legal';
        this.attachmentsGetUrl = this.environment.baseUrl + '/api/commissions/attachments';
        this.commissionsUrl = this.environment.baseUrl + '/api/commissions';
        this.isResendPaymentRequestAllowedUrl = this.environment.baseUrl + "/api/v1/payment-request/resend-allowed";
        this.resendPaymentRequestUrl = this.environment.baseUrl + "/api/v1/payment-request/resend";
    }
    CommissionService.prototype.getPaymentRequestDetails = function () {
        var options = this.buildHttpHeaders();
        return this.httpClient.get(this.eventsGetUrl, options)
            .pipe(Object(operators["retry"])(1));
    };
    CommissionService.prototype.approvePaymentRequest = function (email, legalEntity, attachmentId) {
        var _this = this;
        var options = this.buildHttpHeaders();
        var request = new PaymentRequestActionData({
            email: email,
            reason: null,
            details: null,
            legalEntity: legalEntity,
            attachmentId: attachmentId
        });
        var requestAsJSON = JSON.stringify(request);
        return this.httpClient.post(this.approvePostUrl, requestAsJSON, options)
            .pipe(Object(operators["retry"])(1), Object(operators["catchError"])(function (err) {
            return _this.responseUtilService.handleError(err);
        }));
    };
    CommissionService.prototype.rejectPaymentRequest = function (email, reason, details, attachmentId) {
        var _this = this;
        var options = this.buildHttpHeaders();
        var request = new PaymentRequestActionData({
            email: email,
            reason: reason,
            details: details,
            attachmentId: attachmentId
        });
        var requestAsJSON = JSON.stringify(request);
        return this.httpClient.post(this.rejectPostUrl, requestAsJSON, options)
            .pipe(Object(operators["retry"])(1), Object(operators["catchError"])(function (err) { return _this.responseUtilService.handleError(err); }));
    };
    CommissionService.prototype.buildHttpHeaders = function () {
        var token = localStorage.getItem(Constants.COMMISSION_TOKEN_KEY);
        var headers = new common_http_es5["d" /* HttpHeaders */]({
            'Content-Type': 'application/json',
            'Authorization': token
        });
        var options = { headers: headers };
        return options;
    };
    CommissionService.prototype.isOoivEnabled = function (agencyId, agencyCountry, vendorCountry) {
        return this.getCommissionOoivEnabled(this.buildConfigOoivRequest(agencyId, agencyCountry, vendorCountry))
            .map(function (response) {
            return response ? JSON.parse(response.value) : null;
        });
    };
    CommissionService.prototype.getCommissionOoivEnabled = function (request) {
        var _this = this;
        var options = this.buildHttpHeaders();
        return this.httpClient.post(this.commissionOoivUrl, JSON.stringify(request.toJS()), options)
            .pipe(Object(operators["retry"])(1), Object(operators["catchError"])(function (err) { return _this.responseUtilService.handleError(err); }));
    };
    CommissionService.prototype.buildConfigOoivRequest = function (agencyId, agencyCountry, vendorCountry) {
        var agencyConfigLookup = null;
        var countryConfigLookup = null;
        if (agencyId != null) {
            agencyConfigLookup = new AgencyConfigLookup({ agencyId: agencyId });
        }
        if (agencyCountry != null || vendorCountry != null) {
            countryConfigLookup = new CountryConfigLookup({ agencyCountry: agencyCountry, vendorCountry: vendorCountry });
        }
        return new ConfigRequest({
            config: null,
            property: null,
            agency: agencyConfigLookup,
            country: countryConfigLookup
        });
    };
    CommissionService.prototype.getLegalEntityInfo = function (legalEntitySearch) {
        var _this = this;
        var options = this.buildHttpHeaders();
        var requestAsJSON = JSON.stringify(legalEntitySearch);
        return this.httpClient.post(this.legalEntityUrl, requestAsJSON, options)
            .pipe(Object(operators["retry"])(1), Object(operators["catchError"])(function (err) { return _this.responseUtilService.handleError(err); }));
    };
    CommissionService.prototype.getAttachments = function () {
        var options = this.buildHttpHeaders();
        return this.httpClient.get(this.attachmentsGetUrl, options);
    };
    CommissionService.prototype.addAttachment = function (eventId, eventPartyId, file, multiVendor) {
        var _this = this;
        var formData = new FormData();
        formData.append('file', file);
        return this.buildHttpHeadersFile.post(this.commissionsUrl + '/' + eventId + '/' + eventPartyId + '/attachments', formData)
            .catch(function (response) { return _this.responseUtilService.handleError(response); }).share();
    };
    CommissionService.prototype.getAttachment = function (uniqueId) {
        var _this = this;
        return this.buildHttpHeadersFile.get(this.commissionsUrl + "/attachments/" + uniqueId)
            .map(function (resp) { return resp.text(); })
            .catch(function (response) { return _this.responseUtilService.handleError(response); }).share();
    };
    CommissionService.prototype.deleteAttachment = function (uniqueId) {
        var _this = this;
        return this.buildHttpHeadersFile.delete(this.commissionsUrl + "/attachments/" + uniqueId)
            .catch(function (response) { return _this.responseUtilService.handleError(response); }).share();
    };
    Object.defineProperty(CommissionService.prototype, "buildHttpHeadersFile", {
        get: function () {
            var token = localStorage.getItem(Constants.COMMISSION_TOKEN_KEY);
            var configPersonalizado = new angular2_jwt["AuthConfig"]({
                noTokenScheme: true,
                tokenName: Constants.COMMISSION_TOKEN_KEY,
                tokenGetter: (function () { return token; }),
                globalHeaders: [
                    { 'Cache-Control': 'no-cache, no-store, must-revalidate' },
                    { 'Pragma': 'no-cache' },
                    { 'Expires': 'Thu, 01 Jan 1970 00:00:00 GMT' },
                    { 'If-Modified-Since': '0' }
                ],
            });
            return new angular2_jwt["AuthHttp"](configPersonalizado, this.http);
        },
        enumerable: true,
        configurable: true
    });
    CommissionService.prototype.isResendPaymentRequestAllowed = function () {
        var body = this.userLocalStorageService.getItem(Constants.COMMISSION_TOKEN_KEY);
        var options = { headers: new common_http_es5["d" /* HttpHeaders */]({ 'Content-Type': 'application/json' }) };
        return this.httpClient.post(this.isResendPaymentRequestAllowedUrl, body, options);
    };
    CommissionService.prototype.resendPaymentRequest = function () {
        var body = this.userLocalStorageService.getItem(Constants.COMMISSION_TOKEN_KEY);
        var options = {
            headers: new common_http_es5["d" /* HttpHeaders */]({ 'Content-Type': 'application/json' }),
            responseType: 'text'
        };
        return this.httpClient.post(this.resendPaymentRequestUrl, body, options).pipe(Object(operators["mapTo"])({}));
    };
    return CommissionService;
}());
commission_service_CommissionService = commission_service___decorate([
    Object(core_es5["Injectable"])(),
    commission_service___metadata("design:paramtypes", [typeof (commission_service__a = typeof common_http_es5["b" /* HttpClient */] !== "undefined" && common_http_es5["b" /* HttpClient */]) === "function" && commission_service__a || Object, typeof (commission_service__b = typeof http_es5["Http"] !== "undefined" && http_es5["Http"]) === "function" && commission_service__b || Object, typeof (commission_service__c = typeof EnvironmentConfiguration !== "undefined" && EnvironmentConfiguration) === "function" && commission_service__c || Object, typeof (commission_service__d = typeof user_local_storage_service_UserLocalStorageService !== "undefined" && user_local_storage_service_UserLocalStorageService) === "function" && commission_service__d || Object, typeof (commission_service__e = typeof response_util_service_ResponseUtilService !== "undefined" && response_util_service_ResponseUtilService) === "function" && commission_service__e || Object])
], commission_service_CommissionService);

var commission_service__a, commission_service__b, commission_service__c, commission_service__d, commission_service__e;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/commission.service.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/payment/service/commission.store.ts
var commission_store___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var commission_store___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};








var commission_store_CommissionStore = (function () {
    function CommissionStore(commissionService, router) {
        this.commissionService = commissionService;
        this.router = router;
        this._paymentRequest = new BehaviorSubject["BehaviorSubject"](new PaymentRequest());
        this._attachments = new BehaviorSubject["BehaviorSubject"](Object(immutable["List"])([]));
        this._errorResponse = new BehaviorSubject["BehaviorSubject"](null);
    }
    Object.defineProperty(CommissionStore.prototype, "paymentRequest", {
        get: function () {
            return this._paymentRequest.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CommissionStore.prototype, "attachments", {
        get: function () {
            return this._attachments.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CommissionStore.prototype, "errorResponse", {
        get: function () {
            return this._errorResponse.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    CommissionStore.prototype.loadPaymentRequestDetails = function () {
        var _this = this;
        return this.commissionService.getPaymentRequestDetails()
            .catch(function (err) { return _this.handleError(err); })
            .pipe(Object(operators["map"])(function (res) { return _this._paymentRequest.next(res); }));
    };
    CommissionStore.prototype.handleError = function (error) {
        this._errorResponse.next(error);
        this.router.navigate(['payment/error']);
        return Observable["Observable"].empty();
    };
    CommissionStore.prototype.addAttachment = function (eventId, eventPartyId, file, multiVendor) {
        var _this = this;
        return this.commissionService.addAttachment(eventId, eventPartyId, file, multiVendor)
            .map(function (res) {
            _this._attachments.next(JSON.parse(res._body));
        });
    };
    CommissionStore.prototype.getAttachment = function (uniqueId) {
        return this.commissionService.getAttachment(uniqueId)
            .map(function (response) {
            window.open(response);
            return response;
        })
            .catch(function (error) { return Observable["Observable"].throw(error); }).share();
    };
    CommissionStore.prototype.deleteAttachment = function (eventId, eventPartyId, uniqueId, multiVendor) {
        var _this = this;
        return this.commissionService.deleteAttachment(uniqueId)
            .map(function (res) {
            _this._attachments.next(Object(immutable["List"])([]));
        });
    };
    CommissionStore.prototype.getFile = function (file, name) {
        return new File([file], name, { type: file.type });
    };
    CommissionStore.prototype.isResendPaymentRequestAllowed = function () {
        return this.commissionService.isResendPaymentRequestAllowed();
    };
    CommissionStore.prototype.resendPaymentRequest = function () {
        return this.commissionService.resendPaymentRequest();
    };
    return CommissionStore;
}());
commission_store_CommissionStore = commission_store___decorate([
    Object(core_es5["Injectable"])(),
    commission_store___metadata("design:paramtypes", [typeof (commission_store__a = typeof commission_service_CommissionService !== "undefined" && commission_service_CommissionService) === "function" && commission_store__a || Object, typeof (commission_store__b = typeof router_es5["Router"] !== "undefined" && router_es5["Router"]) === "function" && commission_store__b || Object])
], commission_store_CommissionStore);

var commission_store__a, commission_store__b;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/commission.store.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/payment/service/commission.resolver.ts
var commission_resolver___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var commission_resolver___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};


var CommissionResolver = (function () {
    function CommissionResolver(commissionStore) {
        this.commissionStore = commissionStore;
    }
    CommissionResolver.prototype.resolve = function () {
        return this.commissionStore.loadPaymentRequestDetails();
    };
    return CommissionResolver;
}());
CommissionResolver = commission_resolver___decorate([
    Object(core_es5["Injectable"])(),
    commission_resolver___metadata("design:paramtypes", [typeof (commission_resolver__a = typeof commission_store_CommissionStore !== "undefined" && commission_store_CommissionStore) === "function" && commission_resolver__a || Object])
], CommissionResolver);

var commission_resolver__a;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/commission.resolver.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/payment/service/payment.guard.ts
var payment_guard___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var payment_guard___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};



var payment_guard_PaymentGuard = (function () {
    function PaymentGuard(router) {
        this.router = router;
    }
    PaymentGuard.prototype.canActivate = function (next) {
        var queryParams = next.queryParams;
        var action = queryParams.action;
        var token = queryParams.token ? queryParams.token : localStorage.getItem(Constants.COMMISSION_TOKEN_KEY);
        if (action && token) {
            localStorage.setItem(Constants.COMMISSION_TOKEN_KEY, token);
            return true;
        }
        this.router.navigate(['payment/error']);
        return false;
    };
    return PaymentGuard;
}());
payment_guard_PaymentGuard = payment_guard___decorate([
    Object(core_es5["Injectable"])(),
    payment_guard___metadata("design:paramtypes", [typeof (payment_guard__a = typeof router_es5["Router"] !== "undefined" && router_es5["Router"]) === "function" && payment_guard__a || Object])
], payment_guard_PaymentGuard);

var payment_guard__a;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/payment.guard.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/payment/service/index.ts




//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/index.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/add-event-button-bar/add-event-button-bar.component.ts
var add_event_button_bar_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var add_event_button_bar_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};


var add_event_button_bar_component_AddEventButtonBarComponent = (function () {
    function AddEventButtonBarComponent() {
        this.cancel = new core_es5["EventEmitter"]();
        this.save = new core_es5["EventEmitter"]();
    }
    AddEventButtonBarComponent.prototype.cancelClick = function () {
        this.cancel.emit();
    };
    AddEventButtonBarComponent.prototype.saveClick = function () {
        this.save.emit();
    };
    return AddEventButtonBarComponent;
}());
add_event_button_bar_component___decorate([
    Object(core_es5["Input"])(),
    add_event_button_bar_component___metadata("design:type", typeof (add_event_button_bar_component__a = typeof forms_es5["FormGroup"] !== "undefined" && forms_es5["FormGroup"]) === "function" && add_event_button_bar_component__a || Object)
], add_event_button_bar_component_AddEventButtonBarComponent.prototype, "eventForm", void 0);
add_event_button_bar_component___decorate([
    Object(core_es5["Output"])(),
    add_event_button_bar_component___metadata("design:type", Object)
], add_event_button_bar_component_AddEventButtonBarComponent.prototype, "cancel", void 0);
add_event_button_bar_component___decorate([
    Object(core_es5["Output"])(),
    add_event_button_bar_component___metadata("design:type", Object)
], add_event_button_bar_component_AddEventButtonBarComponent.prototype, "save", void 0);
add_event_button_bar_component_AddEventButtonBarComponent = add_event_button_bar_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-add-event-button-bar',
        template: __webpack_require__("eyPP")
    }),
    add_event_button_bar_component___metadata("design:paramtypes", [])
], add_event_button_bar_component_AddEventButtonBarComponent);

var add_event_button_bar_component__a;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/add-event-button-bar.component.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/menus/service/menu.store.ts
var menu_store___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var menu_store___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};



var menu_store_MenuStore = (function () {
    function MenuStore(translateService) {
        this.translateService = translateService;
        this.currentPageTitle = new BehaviorSubject["BehaviorSubject"](null);
        this.currentIsPropertySubscribed = new BehaviorSubject["BehaviorSubject"](false);
        this.isPageReadOnly = new BehaviorSubject["BehaviorSubject"](true);
        this.isNavCollapsed = false;
    }
    Object.defineProperty(MenuStore.prototype, "pageTitle", {
        get: function () {
            return this.currentPageTitle.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MenuStore.prototype, "isReadOnly", {
        get: function () {
            return this.isPageReadOnly.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MenuStore.prototype, "isPropertySubscribed", {
        get: function () {
            return this.currentIsPropertySubscribed.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    MenuStore.prototype.setPageHeader = function (title, isPropertySubscribed) {
        var _this = this;
        this.translateService.get(title).subscribe(function (text) { return _this.currentPageTitle.next(text); });
        if (isPropertySubscribed !== undefined && isPropertySubscribed !== null) {
            this.currentIsPropertySubscribed.next(isPropertySubscribed);
        }
        else {
            this.currentIsPropertySubscribed.next(false);
        }
    };
    MenuStore.prototype.setIsReadOnly = function (readOnly) {
        this.isPageReadOnly.next(readOnly);
    };
    MenuStore.prototype.toggleIsNavCollapsed = function () {
        this.isNavCollapsed = !this.isNavCollapsed;
        return this.isNavCollapsed;
    };
    return MenuStore;
}());
menu_store_MenuStore = menu_store___decorate([
    Object(core_es5["Injectable"])(),
    menu_store___metadata("design:paramtypes", [typeof (menu_store__a = typeof core["c" /* TranslateService */] !== "undefined" && core["c" /* TranslateService */]) === "function" && menu_store__a || Object])
], menu_store_MenuStore);

var menu_store__a;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/menu.store.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/rate-plan-code.ts
var rate_plan_code___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var RatePlanCodeRecord = Object(immutable["Record"])({
    eventRatePlanCodeId: null,
    eventId: null,
    chain: null,
    brand: null,
    propertyId: null,
    ratePlanCode: null,
    createdDate: null,
    modifiedDate: null,
    createdBy: null,
    modifiedBy: null,
    canBeDeleted: true
});
var RatePlanCode = (function (_super) {
    rate_plan_code___extends(RatePlanCode, _super);
    function RatePlanCode() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return RatePlanCode;
}(RatePlanCodeRecord));

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/rate-plan-code.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/event-search-params.ts
var event_search_params___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var EventSearchParametersRecord = Object(immutable["Record"])({
    maxEvents: 0,
    searchText: Object(immutable["Set"])([]),
    filters: Object(immutable["Set"])([]),
    sorts: Object(immutable["Set"])([]),
    filterDescriptions: Object(immutable["Set"])([])
});
var EventSearchParameters = (function (_super) {
    event_search_params___extends(EventSearchParameters, _super);
    function EventSearchParameters() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return EventSearchParameters;
}(EventSearchParametersRecord));

var EventSearchParamsDesc = (function (_super) {
    event_search_params___extends(EventSearchParamsDesc, _super);
    function EventSearchParamsDesc() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return EventSearchParamsDesc;
}(EventSearchParameters));

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/event-search-params.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/utils/search-event-utils.ts


var search_event_utils_SearchEventUtils = (function () {
    function SearchEventUtils() {
    }
    SearchEventUtils.convertParamsToSearchTextSet = function (queryParams) {
        var searchQueryParams = queryParams['search'];
        if (searchQueryParams) {
            var searchTextArray = searchQueryParams instanceof Array ? searchQueryParams : [searchQueryParams];
            return Object(immutable["OrderedSet"])(searchTextArray);
        }
        else {
            return Object(immutable["OrderedSet"])([]);
        }
    };
    SearchEventUtils.convertParamsToSearchFilterSet = function (queryParams) {
        var filterParams = queryParams['filters'];
        return this.convertStringToSearchFilterSet(filterParams);
    };
    SearchEventUtils.convertStringToSearchFilterSet = function (filterParams) {
        var filterSet = Object(immutable["OrderedSet"])([]);
        var jsonParams;
        try {
            jsonParams = JSON.parse(filterParams);
        }
        catch (e) {
            return filterSet;
        }
        var searchFilterArray = jsonParams instanceof Array ? jsonParams : [jsonParams];
        searchFilterArray.forEach(function (eachFilter) {
            if (eachFilter.filterField && eachFilter.filterValue) {
                var filterField = eachFilter.filterField;
                var filterValue = eachFilter.filterValue;
                var filter = new EventSearchFilter({
                    filterField: filterField,
                    filterValue: filterValue
                });
                filterSet = filterSet.add(filter);
            }
        });
        return filterSet;
    };
    return SearchEventUtils;
}());

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/search-event-utils.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/service/event-search-parameters.store.ts
var event_search_parameters_store___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var event_search_parameters_store___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};














var event_search_parameters_store_EventSearchParametersStore = (function () {
    function EventSearchParametersStore(environment, router, eventFilterUtils, eventMenuMapper, logger, authStore) {
        this.environment = environment;
        this.router = router;
        this.eventFilterUtils = eventFilterUtils;
        this.eventMenuMapper = eventMenuMapper;
        this.logger = logger;
        this.authStore = authStore;
        this.searchTextSetSubject = new BehaviorSubject["BehaviorSubject"](Object(immutable["OrderedSet"])([]));
        this.searchFilterMapSubject = new BehaviorSubject["BehaviorSubject"](Object(immutable["OrderedMap"])());
        this.defaultViewSubject = new BehaviorSubject["BehaviorSubject"](true);
        this.setFilterSet(search_event_utils_SearchEventUtils.convertStringToSearchFilterSet(this.getInitialFilterParams()));
    }
    Object.defineProperty(EventSearchParametersStore.prototype, "searchTextSet", {
        get: function () {
            return this.searchTextSetSubject.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EventSearchParametersStore.prototype, "searchFilterSet", {
        get: function () {
            return this.searchFilterMapSubject
                .asObservable()
                .map(function (map) { return map.toOrderedSet(); });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EventSearchParametersStore.prototype, "searchFilter", {
        get: function () {
            return this.searchFilterMapSubject
                .asObservable()
                .map(function (map) { return map.toList(); });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EventSearchParametersStore.prototype, "searchFilterRecord", {
        get: function () {
            var _this = this;
            return this.searchFilterMapSubject
                .asObservable()
                .map(function (map) {
                return _this.eventMenuMapper.toEventMenuSearchFilter(map.toOrderedSet(), _this.isMultiVendor());
            });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EventSearchParametersStore.prototype, "searchTextSetSnapshot", {
        get: function () {
            return this.searchTextSetSubject.getValue();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EventSearchParametersStore.prototype, "searchFilterSetSnapshot", {
        get: function () {
            return this.searchFilterMapSubject.getValue().toOrderedSet();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EventSearchParametersStore.prototype, "eventSearchParametersSnapshot", {
        get: function () {
            return new EventSearchParameters({
                searchText: this.searchTextSetSnapshot,
                filters: this.searchFilterSetSnapshot,
                maxEvents: this.environment.events.maxEvents,
            });
        },
        enumerable: true,
        configurable: true
    });
    EventSearchParametersStore.prototype.getInitialFilterParams = function () {
        if (this.authStore.hasPermission('EventSearch')) {
            return this.authStore.hasPermission('AgencyEventLevelIndicators')
                ? Constants.INITIAL_FILTER_PARAMS_FUll_AGENCY
                : Constants.INITIAL_FILTER_PARAMS;
        }
        else {
            return Constants.INITIAL_FILTER_PARAMS_NO_SEARCH;
        }
    };
    EventSearchParametersStore.prototype.reset = function (updateUrl) {
        if (updateUrl === void 0) { updateUrl = false; }
        var filterSet = search_event_utils_SearchEventUtils.convertStringToSearchFilterSet(this.getInitialFilterParams());
        this.setFilterSet(filterSet, true);
        this.setSearchTextSetSubject(Object(immutable["OrderedSet"])([]));
        if (updateUrl) {
            this.updateUrl();
        }
    };
    EventSearchParametersStore.prototype.resetWithArchived = function (updateUrl) {
        if (updateUrl === void 0) { updateUrl = false; }
        var filterSet = search_event_utils_SearchEventUtils.convertStringToSearchFilterSet(Constants.INITIAL_FILTER_PARAMS_FUll_AGENCY_ARCHIVED);
        this.setFilterSet(filterSet, true);
        this.setSearchTextSetSubject(Object(immutable["OrderedSet"])([]));
        if (updateUrl) {
            this.updateUrl();
        }
    };
    EventSearchParametersStore.prototype.resetFilters = function (updateUrl) {
        if (updateUrl === void 0) { updateUrl = false; }
        var filterSet = search_event_utils_SearchEventUtils.convertStringToSearchFilterSet(this.getInitialFilterParams());
        this.setFilterSet(filterSet, true);
        if (updateUrl) {
            this.updateUrl();
        }
    };
    EventSearchParametersStore.prototype.setSearchTextSet = function (searchTextSet, updateUrl) {
        if (updateUrl === void 0) { updateUrl = false; }
        this.setSearchTextSetSubject(searchTextSet);
        if (updateUrl) {
            this.updateUrl();
        }
    };
    EventSearchParametersStore.prototype.setFilterSet = function (filterSet, updateUrl) {
        var _this = this;
        if (updateUrl === void 0) { updateUrl = false; }
        var map = Object(immutable["OrderedMap"])();
        filterSet.forEach(function (filter) {
            map = map.set(_this.eventFilterUtils.getUniqueTokenKey(filter), filter);
        });
        this.setSearchFilterMapSubject(map);
        if (updateUrl) {
            this.updateUrl();
        }
    };
    EventSearchParametersStore.prototype.addSearchText = function (searchText, updateUrl) {
        if (updateUrl === void 0) { updateUrl = false; }
        this.setSearchTextSetSubject(this.searchTextSetSubject
            .getValue()
            .add(searchText ? searchText.trim() : searchText));
        if (updateUrl) {
            this.updateUrl();
        }
    };
    EventSearchParametersStore.prototype.addSearchFilter = function (filterField, filterValue, updateUrl) {
        if (updateUrl === void 0) { updateUrl = false; }
        var filter = new EventSearchFilter({
            filterField: filterField,
            filterValue: filterValue ? filterValue.trim() : filterValue,
        });
        this.setSearchFilterMapSubject(this.searchFilterMapSubject
            .getValue()
            .set(this.eventFilterUtils.getUniqueTokenKey(filter), filter));
        if (updateUrl) {
            this.updateUrl();
        }
    };
    EventSearchParametersStore.prototype.removeSearchText = function (searchText, updateUrl) {
        if (updateUrl === void 0) { updateUrl = false; }
        this.setSearchTextSetSubject(this.searchTextSetSubject.getValue().delete(searchText));
        if (updateUrl) {
            this.updateUrl();
        }
    };
    EventSearchParametersStore.prototype.removeSearchFilterByFieldAndValue = function (filterField, filterValue, updateUrl) {
        if (updateUrl === void 0) { updateUrl = false; }
        var filter = new EventSearchFilter({
            filterField: filterField,
            filterValue: filterValue ? filterValue.trim() : filterValue,
        });
        this.removeSearchFilter(filter, updateUrl);
    };
    EventSearchParametersStore.prototype.removeSearchFilter = function (filter, updateUrl) {
        if (updateUrl === void 0) { updateUrl = false; }
        if (filter.filterField === EventFilterType.PAYMENT_STATUS.toString() &&
            this.countPaymentFilter() === 1) {
            return;
        }
        this.setSearchFilterMapSubject(this.searchFilterMapSubject
            .getValue()
            .delete(this.eventFilterUtils.getUniqueTokenKey(filter)));
        if (updateUrl) {
            this.updateUrl();
        }
    };
    EventSearchParametersStore.prototype.hasSearchFilter = function (filterField) {
        var filters = this.searchFilterSetSnapshot;
        var found = false;
        filters.map(function (filter) {
            if (filterField === filter.filterField) {
                found = true;
            }
        });
        return found;
    };
    EventSearchParametersStore.prototype.hasSearchFilterByFieldAndValue = function (filterField, filterValue) {
        var found = false;
        this.searchFilterSetSnapshot.map(function (filter) {
            if (filterField === filter.filterField &&
                filterValue === filter.filterValue) {
                found = true;
            }
        });
        return found;
    };
    EventSearchParametersStore.prototype.getQueryParams = function () {
        var queryParams = new Object();
        if (this.searchTextSetSnapshot &&
            this.searchTextSetSnapshot.toArray() &&
            this.searchTextSetSnapshot.toArray().length > 0) {
            queryParams['search'] = this.searchTextSetSnapshot.toArray();
        }
        if (this.searchFilterSetSnapshot &&
            this.searchFilterSetSnapshot.toArray() &&
            this.searchFilterSetSnapshot.toArray().length > 0) {
            queryParams['filters'] = JSON.stringify(this.searchFilterSetSnapshot.toArray());
        }
        return queryParams;
    };
    EventSearchParametersStore.prototype.updateUrl = function (fromMenu) {
        if (fromMenu === void 0) { fromMenu = false; }
        if (this.isDefaultViewSelectedSnapshot) {
            this.defaultViewUrl(fromMenu);
        }
        else {
            this.financialViewUrl(fromMenu);
        }
    };
    EventSearchParametersStore.prototype.defaultViewUrl = function (fromMenu) {
        if (fromMenu === void 0) { fromMenu = false; }
        this.logger.info('EventSearchParametersStore: Navigating to default');
        this.router.navigate(['/events'], {
            queryParams: this.getQueryParams()
        });
    };
    EventSearchParametersStore.prototype.financialViewUrl = function (fromMenu) {
        if (fromMenu === void 0) { fromMenu = false; }
        // this.logger.info('EventSearchParametersStore: Navigating to financial');
        this.router.navigate(['/events/financial'], {
            queryParams: this.getQueryParams(),
        });
    };
    Object.defineProperty(EventSearchParametersStore.prototype, "isDefaultViewSelected", {
        get: function () {
            return this.defaultViewSubject.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EventSearchParametersStore.prototype, "isDefaultViewSelectedSnapshot", {
        get: function () {
            return this.defaultViewSubject.getValue();
        },
        enumerable: true,
        configurable: true
    });
    EventSearchParametersStore.prototype.setDefaultViewSelected = function (showDefaultView) {
        if (showDefaultView === null) {
            throw new Error('showDefaultView must be true or false');
        }
        this.logger.debug("EventSearchParametersStore.setDefaultViewSelected: " + JSON.stringify(showDefaultView));
        this.defaultViewSubject.next(showDefaultView);
    };
    EventSearchParametersStore.prototype.setSearchTextSetSubject = function (value) {
        if (value === null) {
            throw new Error('searchText must exist');
        }
        this.logger.debug("EventSearchParametersStore.setSearchTextSetSubject: " + JSON.stringify(value));
        this.searchTextSetSubject.next(value);
    };
    EventSearchParametersStore.prototype.setSearchFilterMapSubject = function (value) {
        if (value === null) {
            throw new Error('searchFilter must exist');
        }
        this.logger.debug("EventSearchParametersStore.setSearchFilterMapSubject: " + JSON.stringify(value));
        this.searchFilterMapSubject.next(value);
    };
    EventSearchParametersStore.prototype.countPaymentFilter = function () {
        var paymentStatusFilters = this.searchFilterMapSubject
            .getValue()
            .toList()
            .filter(function (filter) {
            return filter.filterField === EventFilterType.PAYMENT_STATUS.toString();
        });
        return paymentStatusFilters.size;
    };
    EventSearchParametersStore.prototype.isMultiVendor = function () {
        return this.authStore.hasPermission('MultiVendor');
    };
    return EventSearchParametersStore;
}());
event_search_parameters_store_EventSearchParametersStore = event_search_parameters_store___decorate([
    Object(core_es5["Injectable"])(),
    event_search_parameters_store___metadata("design:paramtypes", [typeof (event_search_parameters_store__a = typeof EnvironmentConfiguration !== "undefined" && EnvironmentConfiguration) === "function" && event_search_parameters_store__a || Object, typeof (event_search_parameters_store__b = typeof router_es5["Router"] !== "undefined" && router_es5["Router"]) === "function" && event_search_parameters_store__b || Object, typeof (event_search_parameters_store__c = typeof event_filter_util_service_EventFilterUtilsService !== "undefined" && event_filter_util_service_EventFilterUtilsService) === "function" && event_search_parameters_store__c || Object, typeof (event_search_parameters_store__d = typeof event_menu_search_filter_mapper_EventMenuSearchFilterMapper !== "undefined" && event_menu_search_filter_mapper_EventMenuSearchFilterMapper) === "function" && event_search_parameters_store__d || Object, typeof (event_search_parameters_store__e = typeof log_service_LogService !== "undefined" && log_service_LogService) === "function" && event_search_parameters_store__e || Object, typeof (event_search_parameters_store__f = typeof authentication_store_AuthenticationStore !== "undefined" && authentication_store_AuthenticationStore) === "function" && event_search_parameters_store__f || Object])
], event_search_parameters_store_EventSearchParametersStore);

var event_search_parameters_store__a, event_search_parameters_store__b, event_search_parameters_store__c, event_search_parameters_store__d, event_search_parameters_store__e, event_search_parameters_store__f;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/event-search-parameters.store.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/event-collision-modal/event-collision-modal-config.ts
var EventCollisionModalConfig = (function () {
    function EventCollisionModalConfig(content, cancel, confirm, title, heading, closed) {
        this.content = content;
        this.cancel = cancel;
        this.confirm = confirm;
        this.title = title;
        this.heading = heading;
        this.closed = closed;
    }
    return EventCollisionModalConfig;
}());

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/event-collision-modal-config.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/merge-match-info.ts
var merge_match_info___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var MergeMatchInfoRecord = Object(immutable["Record"])({
    create_party: null,
    id: '0_0',
    merge_event: true,
    source: 'Manual input',
    event_match_id: null,
    matched_event_id: null,
    matched_agency_id: null,
    matched_vendor_code: null,
    edited_event_id: null,
    edited_agency_id: null,
    edited_vendor_code: null,
    action: null,
    user_id: null,
    ev_tmp_guid: null
});
var MergeMatchInfo = (function (_super) {
    merge_match_info___extends(MergeMatchInfo, _super);
    function MergeMatchInfo() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return MergeMatchInfo;
}(MergeMatchInfoRecord));

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/merge-match-info.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/merge-event-request.ts
var merge_event_request___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var MergeEventRequestRecord = Object(immutable["Record"])({
    action: null,
    user_id: null,
    party_initiator_type: null,
    party_initiator_code: null,
    merge_info: null,
    event: null,
    ev_tmp_guid: null,
    parties_for_unmatching: null
});
var MergeEventRequest = (function (_super) {
    merge_event_request___extends(MergeEventRequest, _super);
    function MergeEventRequest() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return MergeEventRequest;
}(MergeEventRequestRecord));

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/merge-event-request.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/party-type.ts
var PartyType;
(function (PartyType) {
    PartyType[PartyType["CLIENT"] = 'CLIENT'] = "CLIENT";
    PartyType[PartyType["PROPERTY"] = 'PROPERTY'] = "PROPERTY";
    PartyType[PartyType["AGENCY"] = 'AGENCY'] = "AGENCY";
})(PartyType || (PartyType = {}));
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/party-type.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/service/guid-generator.service.ts
var guid_generator_service___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var guid_generator_service___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};





var guid_generator_service_GuidGeneratorService = (function () {
    function GuidGeneratorService(http, environment, responseUtilService) {
        this.http = http;
        this.environment = environment;
        this.responseUtilService = responseUtilService;
        this.generateGuidUrl = this.environment.baseUrl + '/api/guid/generate/';
    }
    Object.defineProperty(GuidGeneratorService.prototype, "jsonOptions", {
        get: function () {
            var headers = new http_es5["Headers"]({ 'Content-Type': 'application/json' });
            var options = new http_es5["RequestOptions"]({ headers: headers });
            return options;
        },
        enumerable: true,
        configurable: true
    });
    GuidGeneratorService.prototype.generateGuid = function (recordType) {
        var _this = this;
        return this.http
            .get(this.generateGuidUrl + recordType)
            .map(function (response) { return response.json(); })
            .catch(function (response) { return _this.responseUtilService.handleError(response); })
            .share();
    };
    return GuidGeneratorService;
}());
guid_generator_service_GuidGeneratorService = guid_generator_service___decorate([
    Object(core_es5["Injectable"])(),
    guid_generator_service___metadata("design:paramtypes", [typeof (guid_generator_service__a = typeof AppAuthHttpService !== "undefined" && AppAuthHttpService) === "function" && guid_generator_service__a || Object, typeof (guid_generator_service__b = typeof EnvironmentConfiguration !== "undefined" && EnvironmentConfiguration) === "function" && guid_generator_service__b || Object, typeof (guid_generator_service__c = typeof response_util_service_ResponseUtilService !== "undefined" && response_util_service_ResponseUtilService) === "function" && guid_generator_service__c || Object])
], guid_generator_service_GuidGeneratorService);

var guid_generator_service__a, guid_generator_service__b, guid_generator_service__c;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/guid-generator.service.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/service/guid-generator.store.ts
var guid_generator_store___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var guid_generator_store___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};



var guid_generator_store_GuidGeneratorStore = (function () {
    function GuidGeneratorStore(guidGeneratorService) {
        this.guidGeneratorService = guidGeneratorService;
    }
    GuidGeneratorStore.prototype.generateGuid = function (recordType) {
        return this.guidGeneratorService.generateGuid(recordType)
            .catch(function (error) {
            return Observable["Observable"].throw(error);
        })
            .map(function (res) {
            return res.guid;
        });
    };
    return GuidGeneratorStore;
}());
guid_generator_store_GuidGeneratorStore = guid_generator_store___decorate([
    Object(core_es5["Injectable"])(),
    guid_generator_store___metadata("design:paramtypes", [typeof (guid_generator_store__a = typeof guid_generator_service_GuidGeneratorService !== "undefined" && guid_generator_service_GuidGeneratorService) === "function" && guid_generator_store__a || Object])
], guid_generator_store_GuidGeneratorStore);

var guid_generator_store__a;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/guid-generator.store.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/add-event/add-event.component.ts
var add_event_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var add_event_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};






























var add_event_component_AddEventComponent = (function () {
    function AddEventComponent(router, formBuilder, eventStore, logService, menuStore, flashMessagesService, eventSearchParametersStore, multiAgencyService, authenticationStore, userLocalStorageService, matchingPropertyStore, guidGeneratorStore, translateService, matchingAgencyService) {
        this.router = router;
        this.formBuilder = formBuilder;
        this.eventStore = eventStore;
        this.logService = logService;
        this.menuStore = menuStore;
        this.flashMessagesService = flashMessagesService;
        this.eventSearchParametersStore = eventSearchParametersStore;
        this.multiAgencyService = multiAgencyService;
        this.authenticationStore = authenticationStore;
        this.userLocalStorageService = userLocalStorageService;
        this.matchingPropertyStore = matchingPropertyStore;
        this.guidGeneratorStore = guidGeneratorStore;
        this.translateService = translateService;
        this.matchingAgencyService = matchingAgencyService;
        this.clientContactEditable = true;
        this.eventCollisionModalConfig = new EventCollisionModalConfig();
        this.focusEventNameSubject = new Subject["Subject"]();
        this.eventMatchInfo = [];
        this.eventCollisionMatches = new Map();
        this.isSelectedAgency = false;
    }
    Object.defineProperty(AddEventComponent.prototype, "isDirty", {
        get: function () {
            if (!this.eventForm) {
                return false;
            }
            if (this.eventForm.disabled) {
                return false;
            }
            if (this.eventForm.dirty) {
                return true;
            }
            if (EventUtils.serializeEvent(this.onyxEvent) !== EventUtils.serializeEvent(new OnyxEvent())) {
                return true;
            }
            return this.isSelectedAgency;
        },
        enumerable: true,
        configurable: true
    });
    AddEventComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.isReadOnly = false;
        this.authenticationStore.user.subscribe(function (user) {
            _this.user = user;
        });
        this.eventStore.resetSelectedEvent();
        this.onyxEvent = new OnyxEvent();
        this.onyxEvent.eventVendors.length = 0;
        this.eventForm = this.formBuilder.group({
            event: this.formBuilder.group({}),
        });
        this.menuStore.setPageHeader('EVENT.TITLE_ADD', false);
        this.multiAgencyService.setEventSelected(true);
        this.authenticationStore.clientContactEditable$.subscribe(function (value) {
            _this.clientContactEditable = value;
        });
        this.guidGeneratorStore.generateGuid('EV').subscribe(function (value) {
            _this.temporaryGuid = value;
        });
        this.eventMatchInfo = [];
        this.eventCollisionMatches = new Map();
    };
    AddEventComponent.prototype.onSaveBtn = function (model) {
        var _this = this;
        var isPropertyUser = this.authenticationStore.isPropertyUser();
        if (this.authenticationStore.isPropertyUser()) {
            // Return an error when property email is missing
            if (!model.eventProperty.contact.email) {
                var error = this.translateService.instant('MESSAGES.ERROR.MISSING_CONTACT_EMAIL');
                this.flashMessagesService.error(error);
                this.logService.error(error);
                return Observable["Observable"].empty();
            }
        }
        var runMatchingAgency = Boolean(this.authenticationStore.isPropertyUser()
            && model.eventAgency
            && model.eventAgency.code
            && model.eventProperty.chain
            && model.eventAgency.newTravelAgency);
        // Matching Agency result may update the current model
        var finalModel$ = this.matchingAgencyService.matchingAgencyProcess(model, runMatchingAgency);
        // Once the final model is resolved, event collision process is invoked.
        var eventCollision$ = finalModel$.pipe(Object(operators["map"])(function (finalModel) {
            var info = {
                event: finalModel.event,
                eventProperties: _this.authenticationStore.isPropertyUser() ? [finalModel.eventProperty] : _this.getPropertiesFromModel(finalModel),
                eventAgency: finalModel.eventAgency,
                eventClient: finalModel.eventClient
            };
            return info;
        }), Object(operators["switchMap"])(function (info) {
            return _this.eventCollisionProcess(info);
        }));
        eventCollision$.subscribe();
        return eventCollision$;
    };
    AddEventComponent.prototype.save = function (model) {
        model.eventProperty = this.getEventProperty(model);
        this.eventForm.disable();
        model.event.eventAgency = model.eventAgency;
        model.event.eventClient = model.eventClient;
        model.event.eventProperty = model.eventProperty;
        model.event.eventVendors = this.getVendorsFromModel(model);
        if (!this.isMultiVendor()) {
            if (!model.event.eventProperty.commRetention) {
                model.event.eventProperty.commRetention = model.event.commRetention;
            }
            if (!model.event.eventProperty.commissionRoomPercentage) {
                model.event.eventProperty.commissionRoomPercentage = model.event.commissionRoomPercentage;
            }
        }
        var formModel = new OnyxEvent(model.event);
        var updatedRefCodes = {};
        if (formModel.eventAgency) {
            if (this.authenticationStore.isAgencyUser()) {
                formModel.eventAgency.eventReferenceNumber =
                    model.event.eventReferenceNumber;
            }
        }
        if (formModel.eventProperty) {
            if (this.authenticationStore.isPropertyUser()) {
                formModel.eventProperty.eventReferenceNumber =
                    model.event.eventReferenceNumber;
                formModel.eventProperty.ratePlanCodes = model.event.ratePlanCodes;
            }
        }
        // It is creating a new event, so assigning start and end date to agency, property and vendors
        var _startDate;
        var _endDate;
        var _eventName;
        if (model.event.startDate) {
            _startDate = new Date(model.event.startDate).toISOString();
            formModel.eventAgency['startDate'] = _startDate;
            formModel.eventProperty['startDate'] = _startDate;
        }
        if (model.event.endDate) {
            _endDate = new Date(model.event.endDate).toISOString();
            formModel.eventAgency['endDate'] = _endDate;
            formModel.eventProperty['endDate'] = _endDate;
        }
        if (model.event.name) {
            _eventName = model.event.name;
            formModel.eventAgency['partyEventName'] = _eventName;
            formModel.eventProperty['partyEventName'] = _eventName;
        }
        if (formModel.eventVendors && formModel.eventVendors !== undefined) {
            for (var i = 0; i < formModel.eventVendors.length; i++) {
                if (formModel.eventVendors[i] && formModel.eventVendors[i] !== undefined) {
                    if (model.event.startDate) {
                        formModel.eventVendors[i]['startDate'] = _startDate;
                    }
                    if (model.event.endDate) {
                        formModel.eventVendors[i]['endDate'] = _endDate;
                    }
                    if (model.event.name) {
                        formModel.eventVendors[i]['partyEventName'] = _eventName;
                    }
                }
            }
        }
        // Set userRef fields
        this.buildUserRefFields(model, formModel);
        // checks if the user did not click the add button
        if (model.event.ratePlanCode) {
            formModel.ratePlanCodes.push(new RatePlanCode({ ratePlanCode: model.event.ratePlanCode }));
        }
        this.logService.debug("updatedRefCodes " + updatedRefCodes);
        var updatedModel = formModel.merge(updatedRefCodes);
        if (formModel.eventClient) {
            updatedModel.eventClient.code = formModel.eventClient.code;
        }
        var obs;
        if (this.eventCollisionMatches.size > 0) {
            var eventInfo_1 = [];
            this.eventCollisionMatches.forEach(function (value, key) {
                eventInfo_1.push(value);
            });
            var partyInitiatorType = null;
            var partyInitiatorCode = null;
            if (this.authenticationStore.isPropertyUser()) {
                partyInitiatorType = updatedModel.eventProperty.partyType.toString();
                partyInitiatorCode = updatedModel.eventProperty.code;
            }
            else {
                partyInitiatorType = updatedModel.eventAgency.partyType.toString();
                partyInitiatorCode = updatedModel.eventAgency.code;
            }
            var mergeRequest = new MergeEventRequest({
                action: 'ADD_EVENT',
                user_id: this.user.username,
                party_initiator_type: partyInitiatorType,
                party_initiator_code: partyInitiatorCode,
                merge_info: eventInfo_1,
                event: updatedModel,
                ev_tmp_guid: this.temporaryGuid
            });
            obs = this.sendMergeMatchingRequest(mergeRequest);
        }
        else {
            var finalUpdatedModel = updatedModel.merge({ 'evTmpGuid': this.temporaryGuid });
            if (this.authenticationStore.isPropertyUser()) {
                obs = this.sendAddEventRequest(finalUpdatedModel);
            }
            else {
                obs = this.sendAddAgencyEventRequest(finalUpdatedModel);
            }
        }
        obs.subscribe();
        return obs;
    };
    AddEventComponent.prototype.buildUserRefFields = function (model, formModel) {
        if (model.event.customFields) {
            if (model.event.customFields.userRef01) {
                this.authenticationStore.isAgencyUser() ?
                    formModel.eventAgency['userRef01'] = model.event.customFields.userRef01 :
                    formModel.eventProperty['userRef01'] = model.event.customFields.userRef01;
            }
            else {
                this.authenticationStore.isAgencyUser() ?
                    formModel.eventAgency['userRef01'] = null : formModel.eventProperty['userRef01'] = null;
            }
            if (model.event.customFields.userRef02) {
                this.authenticationStore.isAgencyUser() ?
                    formModel.eventAgency['userRef02'] = model.event.customFields.userRef02 :
                    formModel.eventProperty['userRef02'] = model.event.customFields.userRef02;
            }
            else {
                this.authenticationStore.isAgencyUser() ?
                    formModel.eventAgency['userRef02'] = null : formModel.eventProperty['userRef02'] = null;
            }
            if (model.event.customFields.userRef03) {
                this.authenticationStore.isAgencyUser() ?
                    formModel.eventAgency['userRef03'] = model.event.customFields.userRef03 :
                    formModel.eventProperty['userRef03'] = model.event.customFields.userRef03;
            }
            else {
                this.authenticationStore.isAgencyUser() ?
                    formModel.eventAgency['userRef03'] = null : formModel.eventProperty['userRef03'] = null;
            }
            if (model.event.customFields.userRef04) {
                this.authenticationStore.isAgencyUser() ?
                    formModel.eventAgency['userRef04'] = model.event.customFields.userRef04 :
                    formModel.eventProperty['userRef04'] = model.event.customFields.userRef04;
            }
            else {
                this.authenticationStore.isAgencyUser() ?
                    formModel.eventAgency['userRef04'] = null : formModel.eventProperty['userRef04'] = null;
            }
            if (model.event.customFields.userRef05) {
                this.authenticationStore.isAgencyUser() ?
                    formModel.eventAgency['userRef05'] = model.event.customFields.userRef05 :
                    formModel.eventProperty['userRef05'] = model.event.customFields.userRef05;
            }
            else {
                this.authenticationStore.isAgencyUser() ?
                    formModel.eventAgency['userRef05'] = null : formModel.eventProperty['userRef05'] = null;
            }
        }
    };
    AddEventComponent.prototype.sendAddEventRequest = function (originalEvent) {
        var _this = this;
        var returnedEvent = this.eventStore
            .addEvent(originalEvent)
            .catch(function (error) {
            _this.eventForm.enable();
            if (error.includes('Agency Event Reference Number already exists')) {
                _this.flashMessagesService.error('MESSAGES.ERROR.ADD_EVENT_DUPLICATED_AGENCY_REFERENCE_NUMBER', error);
            }
            else if (error.includes('Property Event Reference Number already exists')) {
                _this.flashMessagesService.error('MESSAGES.ERROR.ADD_EVENT_DUPLICATED_PROPERTY_REFERENCE_NUMBER', error);
            }
            else if (error.includes('The event must have one payor-type hotel')) {
                _this.flashMessagesService.error('MESSAGES.ERROR.ADD_EVENT_NO_PAYOR_TYPE_HOTEL', error);
            }
            else if (error.includes('The event must have only one payor-type hotel')) {
                _this.flashMessagesService.error('MESSAGES.ERROR.ADD_EVENT_ONLY_ONE_PAYOR_TYPE_HOTEL', error);
            }
            else if (error.includes('Legal Entity data is missing')) {
                _this.flashMessagesService.error('MESSAGES.ERROR.ADD_EVENT_LEGAL_ENTITY_DATA_IS_MISSING', error);
            }
            else if (error.includes('Invalid Tax ID')) {
                _this.flashMessagesService.error('MESSAGES.ERROR.INVALID_VAT_ID', error);
            }
            else {
                _this.flashMessagesService.error('MESSAGES.ERROR.ADD_EVENT', error);
            }
            return Observable["Observable"].throw(error);
        })
            .map(function (res) {
            return _this.refreshAfterAdding(res);
        });
        return returnedEvent;
    };
    AddEventComponent.prototype.sendAddAgencyEventRequest = function (originalEvent) {
        var _this = this;
        var returnedEvent = this.eventStore
            .addAgencyEvent(originalEvent)
            .catch(function (error) {
            _this.eventForm.enable();
            if (error.includes('Agency Event Reference Number already exists')) {
                _this.flashMessagesService.error('MESSAGES.ERROR.ADD_EVENT_DUPLICATED_AGENCY_REFERENCE_NUMBER', error);
            }
            else if (error.includes('Property Event Reference Number already exists')) {
                _this.flashMessagesService.error('MESSAGES.ERROR.ADD_EVENT_DUPLICATED_PROPERTY_REFERENCE_NUMBER', error);
            }
            else if (error.includes('The event must have one payor-type hotel')) {
                _this.flashMessagesService.error('MESSAGES.ERROR.ADD_EVENT_NO_PAYOR_TYPE_HOTEL', error);
            }
            else if (error.includes('The event must have only one payor-type hotel')) {
                _this.flashMessagesService.error('MESSAGES.ERROR.ADD_EVENT_ONLY_ONE_PAYOR_TYPE_HOTEL', error);
            }
            else if (error.includes('Legal Entity data is missing')) {
                _this.flashMessagesService.error('MESSAGES.ERROR.ADD_EVENT_LEGAL_ENTITY_DATA_IS_MISSING', error);
            }
            else if (error.includes('Invalid Tax ID')) {
                _this.flashMessagesService.error('MESSAGES.ERROR.INVALID_VAT_ID', error);
            }
            else {
                _this.flashMessagesService.error('MESSAGES.ERROR.ADD_EVENT', error);
            }
            return Observable["Observable"].throw(error);
        })
            .map(function (res) {
            return _this.refreshAfterAdding(res);
        });
        return returnedEvent;
    };
    AddEventComponent.prototype.refreshAfterAdding = function (res) {
        var _this = this;
        var changeIata = false;
        if (this.user &&
            this.user.allArcIatas &&
            this.user.customerInfo &&
            this.user.customerInfo.length >= 2) {
            var key = this.user.username.toUpperCase() +
                authentication_store_AuthenticationStore.CURRENT_AGENCY_STR;
            var currentAgency = JSON.parse(this.userLocalStorageService.getItem(key));
            if (currentAgency.agencyId !== res.eventAgency.code) {
                changeIata = true;
            }
        }
        if (changeIata) {
            var agency_1 = new MultiAgency({
                agencyId: res.eventAgency.code,
                agencyName: res.eventAgency.name,
            });
            this.authenticationStore
                .updateIataFromToken(agency_1.agencyId)
                .subscribe(function () {
                _this.multiAgencyService.setAgencySelectedUI(true);
                _this.multiAgencyService.setDefaultAgency(agency_1);
                _this.goToContractSummary(res.eventId, res.eventProperty.eventPartyId);
                return res;
            });
        }
        else {
            this.goToContractSummary(res.eventId, res.eventProperty.eventPartyId);
            return res;
        }
    };
    AddEventComponent.prototype.returnToSearchList = function () {
        this.eventForm.disable();
        this.eventSearchParametersStore.updateUrl();
    };
    AddEventComponent.prototype.goToContractSummary = function (eventId, eventPartyId) {
        if (this.isMultiVendor() || !eventPartyId) {
            this.router.navigate(['/event', eventId, 'summary']);
        }
        else {
            this.router.navigate(['/event', eventId, eventPartyId, 'summary']);
        }
    };
    AddEventComponent.prototype.setupPropertyEmail = function (email) {
        this.propertyEmail = email;
    };
    AddEventComponent.prototype.setupAgencyEmail = function (email) {
        this.agencyEmail = email;
    };
    AddEventComponent.prototype.confirmBeforeSaveEventHandler = function (response) {
        var _this = this;
        if (response.selectedButton === EventCollisionModalResponseEnum.MergeEvents) {
            this.eventMatchInfo.forEach(function (item) {
                if (response.selectedMatches.indexOf(item.event_match_id) > -1) {
                    var key = item['create_party'] === 'PROPERTY' ? item['matched_agency_id'] : item['matched_vendor_code'];
                    _this.eventCollisionMatches.set(key, item);
                }
            });
        }
        this.eventMatchInfo = [];
        this.save(this.eventForm.value);
    };
    AddEventComponent.prototype.cancelMatchingWizard = function (response) {
        var _this = this;
        var matchesToCancel = [];
        this.eventMatchInfo.forEach(function (item) {
            if (response.selectedMatches.indexOf(item.event_match_id) === -1) {
                matchesToCancel.push(item.event_match_id);
            }
        });
        var obs = this.matchingPropertyStore
            .cancelMatching(matchesToCancel)
            .take(1)
            .catch(function (error) {
            return Observable["Observable"].throw(error);
        }).finally(function () {
            _this.eventMatchInfo = [];
            _this.eventForm.enable();
            _this.focusEventNameSubject.next();
        });
        obs.subscribe();
        return obs;
    };
    AddEventComponent.prototype.eventCollisionProcess = function (info) {
        var _this = this;
        var obs = this.invokeEventCollisionMatching(info);
        obs.subscribe(function (match) {
            if (match) {
                if (_this.anyMatchFound(match)) {
                    var matchesForModalPanel_1 = [];
                    var propertiesFromModalPanel_1 = [];
                    match.forEach(function (item) {
                        if (item.result === 'fuzzy') {
                            _this.eventMatchInfo.push(new MergeMatchInfo({
                                create_party: item.create_party,
                                id: item.id,
                                merge_event: true,
                                source: 'Manual input',
                                event_match_id: item.event_match_id,
                                matched_event_id: item.matches[0].event_id,
                                matched_agency_id: item.matches[0].agency_id,
                                matched_vendor_code: item.matches[0].vendor_code,
                                edited_event_id: item['edited_event_id'],
                                edited_agency_id: item['edited_agency_id'],
                                edited_vendor_code: item['edited_vendor_code'],
                                action: item['action'],
                                user_id: item['user_id'],
                                ev_tmp_guid: item['ev_tmp_guid']
                            }));
                            matchesForModalPanel_1.push(item);
                            propertiesFromModalPanel_1.push(item.property_name + " " + item.property_address);
                        }
                    });
                    var eventMatch = new EventCollisionMatch({
                        createdBy: _this.authenticationStore.isPropertyUser() ? info.eventProperties[0].name :
                            info.eventAgency.name,
                        clientCompany: info.eventClient.name ? info.eventClient.name : '',
                        eventName: info.event.name,
                        groupCode: info.event.eventReferenceNumber,
                        startDate: info.event.startDate,
                        endDate: info.event.endDate,
                        property: matchesForModalPanel_1.length > 1 ? '' : propertiesFromModalPanel_1[0],
                        eventMatchId: matchesForModalPanel_1.length > 1 ? null : matchesForModalPanel_1[0].event_match_id,
                    });
                    if (matchesForModalPanel_1.length > 1) {
                        _this.eventCollisionModalMultiprompt.open(eventMatch, matchesForModalPanel_1);
                    }
                    else {
                        _this.eventCollisionModal.open(eventMatch, matchesForModalPanel_1[0].matches[0]);
                    }
                }
                else {
                    return _this.save(_this.eventForm.value);
                }
            }
            return match;
        });
        return obs;
    };
    AddEventComponent.prototype.invokeEventCollisionMatching = function (eventInfo) {
        var _this = this;
        var returnedEvent = this.matchingPropertyStore
            .getMatchingCollisionProperties(eventInfo, null, this.user.username, this.temporaryGuid)
            .catch(function (error) {
            _this.flashMessagesService.error('MESSAGES.ERROR.MATCHING_EVENT', error);
            return Observable["Observable"].throw(error);
        })
            .map(function (res) {
            return res;
        });
        return returnedEvent;
    };
    AddEventComponent.prototype.sendMergeMatchingRequest = function (eventInfo) {
        var _this = this;
        var returnedEvent = this.matchingPropertyStore
            .updateEventCollisionMatch(eventInfo)
            .catch(function (error) {
            _this.eventForm.enable();
            if (error.includes('Agency Event Reference Number already exists')) {
                _this.flashMessagesService.error('MESSAGES.ERROR.ADD_EVENT_DUPLICATED_AGENCY_REFERENCE_NUMBER', error);
            }
            else if (error.includes('Property Event Reference Number already exists')) {
                _this.flashMessagesService.error('MESSAGES.ERROR.ADD_EVENT_DUPLICATED_PROPERTY_REFERENCE_NUMBER', error);
            }
            else if (error.includes('The event must have one payor-type hotel')) {
                _this.flashMessagesService.error('MESSAGES.ERROR.ADD_EVENT_NO_PAYOR_TYPE_HOTEL', error);
            }
            else if (error.includes('The event must have only one payor-type hotel')) {
                _this.flashMessagesService.error('MESSAGES.ERROR.ADD_EVENT_ONLY_ONE_PAYOR_TYPE_HOTEL', error);
            }
            else {
                _this.flashMessagesService.error('MESSAGES.ERROR.MERGE_MATCHING_EVENT', error);
            }
            return Observable["Observable"].throw(error);
        })
            .map(function (res) {
            return _this.refreshAfterAdding(res);
        });
        return returnedEvent;
    };
    AddEventComponent.prototype.getVendorsFromModel = function (model) {
        var vendors = [];
        this.onyxEvent.eventVendors.forEach(function (vendor) {
            var vendorCode = vendor.code ? vendor.code : vendor.chain + '|' + vendor.brand + '|' + vendor.propertyId;
            var modelVendor = model['eventVendor-' + vendorCode];
            modelVendor.taxResponseList = vendor.taxResponseList;
            vendors.push(modelVendor);
        });
        return vendors;
    };
    AddEventComponent.prototype.getPropertiesFromModel = function (model) {
        var vendors = [];
        this.onyxEvent.eventVendors.forEach(function (vendor) {
            if (vendor.partyType === PartyType.PROPERTY && vendor.payorType === 'PROPERTY') {
                var vendorCode = vendor.code ? vendor.code : vendor.chain + '|' + vendor.brand + '|' + vendor.propertyId;
                vendors.push(model['eventVendor-' + vendorCode]);
            }
        });
        return vendors;
    };
    AddEventComponent.prototype.getEventProperty = function (model) {
        var property = {};
        if (this.isMultiVendor()) {
            this.onyxEvent.eventVendors.forEach(function (vendor) {
                if (vendor.partyType === PartyType.PROPERTY && vendor.payorType === 'PROPERTY') {
                    property = vendor;
                }
            });
        }
        else {
            return model.eventProperty;
        }
        return property;
    };
    AddEventComponent.prototype.isMultiVendor = function () {
        return this.authenticationStore.hasPermission('MultiVendor');
    };
    AddEventComponent.prototype.anyMatchFound = function (match) {
        var result = false;
        match.forEach(function (item) {
            if (item.result === 'fuzzy') {
                result = true;
            }
        });
        return result;
    };
    AddEventComponent.prototype.selectedAgency = function () {
        this.isSelectedAgency = true;
    };
    return AddEventComponent;
}());
add_event_component___decorate([
    Object(core_es5["ViewChild"])(event_collision_modal_component_EventCollisionModalComponent),
    add_event_component___metadata("design:type", typeof (add_event_component__a = typeof event_collision_modal_component_EventCollisionModalComponent !== "undefined" && event_collision_modal_component_EventCollisionModalComponent) === "function" && add_event_component__a || Object)
], add_event_component_AddEventComponent.prototype, "eventCollisionModal", void 0);
add_event_component___decorate([
    Object(core_es5["ViewChild"])(event_collision_modal_multiprompt_component_EventCollisionModalMultipromptComponent),
    add_event_component___metadata("design:type", typeof (add_event_component__b = typeof event_collision_modal_multiprompt_component_EventCollisionModalMultipromptComponent !== "undefined" && event_collision_modal_multiprompt_component_EventCollisionModalMultipromptComponent) === "function" && add_event_component__b || Object)
], add_event_component_AddEventComponent.prototype, "eventCollisionModalMultiprompt", void 0);
add_event_component_AddEventComponent = add_event_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-add-event',
        template: __webpack_require__("iC+n"),
    }),
    add_event_component___metadata("design:paramtypes", [typeof (add_event_component__c = typeof router_es5["Router"] !== "undefined" && router_es5["Router"]) === "function" && add_event_component__c || Object, typeof (add_event_component__d = typeof forms_es5["FormBuilder"] !== "undefined" && forms_es5["FormBuilder"]) === "function" && add_event_component__d || Object, typeof (add_event_component__e = typeof event_store_EventStore !== "undefined" && event_store_EventStore) === "function" && add_event_component__e || Object, typeof (add_event_component__f = typeof log_service_LogService !== "undefined" && log_service_LogService) === "function" && add_event_component__f || Object, typeof (add_event_component__g = typeof menu_store_MenuStore !== "undefined" && menu_store_MenuStore) === "function" && add_event_component__g || Object, typeof (add_event_component__h = typeof flash_messages_service_FlashMessagesService !== "undefined" && flash_messages_service_FlashMessagesService) === "function" && add_event_component__h || Object, typeof (_j = typeof event_search_parameters_store_EventSearchParametersStore !== "undefined" && event_search_parameters_store_EventSearchParametersStore) === "function" && _j || Object, typeof (_k = typeof multi_agency_service_MultiAgencyService !== "undefined" && multi_agency_service_MultiAgencyService) === "function" && _k || Object, typeof (_l = typeof authentication_store_AuthenticationStore !== "undefined" && authentication_store_AuthenticationStore) === "function" && _l || Object, typeof (_m = typeof user_local_storage_service_UserLocalStorageService !== "undefined" && user_local_storage_service_UserLocalStorageService) === "function" && _m || Object, typeof (_o = typeof matching_property_store_MatchingPropertyStore !== "undefined" && matching_property_store_MatchingPropertyStore) === "function" && _o || Object, typeof (_p = typeof guid_generator_store_GuidGeneratorStore !== "undefined" && guid_generator_store_GuidGeneratorStore) === "function" && _p || Object, typeof (_q = typeof core["c" /* TranslateService */] !== "undefined" && core["c" /* TranslateService */]) === "function" && _q || Object, typeof (_r = typeof matching_agency_service_MatchingAgencyService !== "undefined" && matching_agency_service_MatchingAgencyService) === "function" && _r || Object])
], add_event_component_AddEventComponent);

var add_event_component__a, add_event_component__b, add_event_component__c, add_event_component__d, add_event_component__e, add_event_component__f, add_event_component__g, add_event_component__h, _j, _k, _l, _m, _o, _p, _q, _r;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/add-event.component.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/utils/pioneer.validators.ts
var pioneer_validators___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var pioneer_validators___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};









var pioneer_validators_PioneerValidators = PioneerValidators_1 = (function () {
    function PioneerValidators(logService) {
        this.logService = logService;
        PioneerValidators_1.LOG_SERVICE = logService;
    }
    PioneerValidators.isInteger = function (formControl) {
        if (!formControl.value) {
            return null;
        }
        if (!Number.isInteger(formControl.value)) {
            return { 'not_integer': true };
        }
        return null;
    };
    PioneerValidators.isValidAmount = function (formControl) {
        // get the failure message from Validators.required instead
        if (forms_es5["Validators"].required(formControl)) {
            return null;
        }
        // regular expression to match 1 to 13 digits, optionally followed by a decimal and up to 2 more digits
        var format = /^\d{1,13}(\.\d\d?)?$/;
        if (!format.test(formControl.value)) {
            return { 'invalid_amount': true };
        }
        return null;
    };
    PioneerValidators.isValidAmountInclNegative = function (formControl) {
        // get the failure message from Validators.required instead
        if (forms_es5["Validators"].required(formControl)) {
            return null;
        }
        // regular expression to match 1 to 13 digits, optionally followed by a decimal and up to 2 more digits
        var format = /^-?\d{1,13}(\.\d\d?)?$/;
        if (!format.test(formControl.value)) {
            return { 'invalid_amount': true };
        }
        return null;
    };
    PioneerValidators.isDate = function (formControl) {
        if (!formControl.value) {
            return null;
        }
        var isValid = false;
        try {
            var dateWrapper = date_util_DateUtil.parseDate(formControl.value);
            isValid = !isNaN(dateWrapper.getDate());
        }
        catch (error) {
            PioneerValidators_1.LOG_SERVICE.error(error);
            isValid = false;
        }
        if (!isValid) {
            return { 'date': true };
        }
        return null;
    };
    PioneerValidators.isEndDateAfterStartDateCrossValidator = function (startDateControlName, endDateControlName) {
        return function (formGroup) {
            var validationErrors = null;
            try {
                var startDate = PioneerValidators_1.parseDate(formGroup.get(startDateControlName).value);
                var endDate = PioneerValidators_1.parseDate(formGroup.get(endDateControlName).value);
                if (!!startDate && !!endDate) {
                    if (endDate.getTime() <= startDate.getTime()) {
                        validationErrors = { 'end_date_after_start_date': true };
                        formGroup.get(endDateControlName).markAsTouched();
                    }
                }
            }
            catch (error) {
                PioneerValidators_1.LOG_SERVICE.error(error);
            }
            return validationErrors;
        };
    };
    PioneerValidators.isFirstNameOrLastNameRequiredCrossValidator = function (firstNameControlName, lastNameControlName) {
        return function (formGroup) {
            var validationErrors = null;
            try {
                var firstName = formGroup.get(firstNameControlName).value;
                var lastName = formGroup.get(lastNameControlName).value;
                if ((Object(util_util["isNullOrUndefined"])(firstName) || firstName.trim().length === 0)
                    && (Object(util_util["isNullOrUndefined"])(lastName) || lastName.trim().length === 0)) {
                    validationErrors = { 'first_name_or_last_name_required': true };
                }
            }
            catch (error) {
                PioneerValidators_1.LOG_SERVICE.error(error);
            }
            return validationErrors;
        };
    };
    PioneerValidators.isAmountEqualToSpendAmountByCommRate = function (amountControlName, spendAmountControlName, commRateControlName) {
        return function (formGroup) {
            var validationErrors = null;
            try {
                var controlErrors = formGroup.get(amountControlName).errors;
                if (controlErrors != null) {
                    return validationErrors;
                }
                var amount = formGroup.get(amountControlName).value;
                var spendAmount = formGroup.get(spendAmountControlName).value;
                var commRate = formGroup.get(commRateControlName).value;
                if (spendAmount != null || commRate != null) {
                    if (spendAmount == null) {
                        spendAmount = 0;
                    }
                    if (commRate == null) {
                        commRate = 0;
                    }
                }
                if (amount != null && spendAmount != null && commRate != null) {
                    var formula = Number(((spendAmount * commRate) / 100).toFixed(2));
                    if (amount !== formula) {
                        validationErrors = { 'amount_must_equal_spend_x_comm_rate': true };
                        formGroup.get(amountControlName).markAsTouched();
                    }
                }
            }
            catch (error) {
                PioneerValidators_1.LOG_SERVICE.error(error);
            }
            return validationErrors;
        };
    };
    PioneerValidators.isValidAmountInRange = function (minAmount, maxAmount) {
        return function (formControl) {
            var validationCurrency = PioneerValidators_1.isValidAmount(formControl);
            if (validationCurrency !== null) {
                return validationCurrency;
            }
            if (minAmount) {
                var validationMin = forms_es5["Validators"].min(minAmount).call(null, formControl);
                if (validationMin !== null) {
                    return validationMin;
                }
            }
            if (maxAmount) {
                var validationMax = forms_es5["Validators"].max(maxAmount).call(null, formControl);
                if (validationMax !== null) {
                    return validationMax;
                }
            }
            return null;
        };
    };
    PioneerValidators.isValidAmountInRangeInclNegative = function (minAmount, maxAmount) {
        return function (formControl) {
            var validationCurrency = PioneerValidators_1.isValidAmountInclNegative(formControl);
            if (validationCurrency !== null) {
                return validationCurrency;
            }
            if (minAmount) {
                var validationMin = forms_es5["Validators"].min(minAmount).call(null, formControl);
                if (validationMin !== null) {
                    return validationMin;
                }
            }
            if (maxAmount) {
                var validationMax = forms_es5["Validators"].max(maxAmount).call(null, formControl);
                if (validationMax !== null) {
                    return validationMax;
                }
            }
            return null;
        };
    };
    PioneerValidators.isValidEmail = function (formControl) {
        if (forms_es5["Validators"].required(formControl)) {
            // get the failure message from Validators.required instead
            return null;
        }
        else {
            // Validate the email
            var emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            if (!emailRegex.test(formControl.value)) {
                return { 'EMAIL': true };
            }
        }
    };
    PioneerValidators.isValidAgencyId = function (formControl) {
        // regular expression to match agency id starts with G@
        var format = /^([Gg]@)\w*/;
        if (format.test(formControl.value)) {
            return { 'invalid_agency_id': true };
        }
        return null;
    };
    PioneerValidators.isWhitespaceValidated = function (formControl) {
        if (formControl.value) {
            return (formControl.value).trim().length === 0 ? { 'whitespace': true } : null;
        }
        return null;
    };
    PioneerValidators.parseDate = function (value) {
        var result;
        if (!!value && value.trim().length > 0) {
            var date = date_util_DateUtil.parseDate(value.trim());
            if (date_util_DateUtil.isValidDate(date)) {
                result = date;
            }
        }
        return result;
    };
    PioneerValidators.postalCodeCountryCrossValidator = function (postalCodeControlName, countryFormControlName) {
        var _this = this;
        return function (formGroup) {
            var validationErrors = null;
            try {
                if (_this.isPostalCodeRequired(formGroup, countryFormControlName) && _this.isBlank(formGroup.get(postalCodeControlName))) {
                    validationErrors = { 'postal_code_country_cross_error': true };
                }
            }
            catch (error) {
                PioneerValidators_1.LOG_SERVICE.error(error);
            }
            return validationErrors;
        };
    };
    PioneerValidators.isPostalCodeRequired = function (formGroup, countryFormControlName) {
        return (Constants.COUNTRIES_WITH_POSTAL_CODE.indexOf(formGroup.get(countryFormControlName).value) >= 0);
    };
    PioneerValidators.countryStateCrossValidator = function (countryFormControlName, stateFormControlName) {
        var _this = this;
        return function (formGroup) {
            var validationErrors = null;
            if (_this.isStateRequired(formGroup, countryFormControlName)) {
                if (forms_es5["Validators"].required(formGroup.get(stateFormControlName))) {
                    validationErrors = { 'country_state_cross_error': true };
                }
            }
            return validationErrors;
        };
    };
    PioneerValidators.isStateRequired = function (formGroup, countryFormControlName) {
        return (Constants.COUNTRIES_WITH_STATES.indexOf(formGroup.get(countryFormControlName).value) >= 0);
    };
    PioneerValidators.oneIsRequiredValidator = function () {
        var _this = this;
        var formControlNames = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            formControlNames[_i] = arguments[_i];
        }
        return function (formGroup) {
            var validationErrors = null;
            if (formControlNames && formControlNames.findIndex(function (formControlName) { return !_this.isBlank(formGroup.get(formControlName)); }) < 0) {
                validationErrors = { 'one_is_required_error': true };
            }
            return validationErrors;
        };
    };
    PioneerValidators.isBlank = function (formControl) {
        var result;
        if (forms_es5["Validators"].required(formControl)) {
            result = true;
        }
        else if (!formControl.value || (formControl.value).trim().length === 0) {
            result = true;
        }
        else {
            result = false;
        }
        return result;
    };
    PioneerValidators.range = function (min, max) {
        var _this = this;
        return function (formControl) {
            var result;
            if (forms_es5["Validators"].required(formControl)) {
                result = null;
            }
            else if (_this.isInteger(formControl)) {
                result = null;
            }
            else if (forms_es5["Validators"].min(min).call(null, formControl) || forms_es5["Validators"].max(max).call(null, formControl)) {
                result = { 'range': true };
            }
            else {
                result = null;
            }
            return result;
        };
    };
    PioneerValidators.isAlphaNumeric = function (formControl) {
        // get the failure message from Validators.required instead
        if (forms_es5["Validators"].required(formControl)) {
            return null;
        }
        // regular expression to match 1 to 13 digits, optionally followed by a decimal and up to 2 more digits
        var format = /^[a-zA-Z0-9]+(_?|-?)[a-zA-Z0-9]+$/;
        if (!format.test(formControl.value)) {
            return { 'invalid_group_code': true };
        }
        return null;
    };
    PioneerValidators.isEmailFormatValid = function (email) {
        var emailControl = new forms_es5["FormControl"](email, PioneerValidators_1.isValidEmail);
        return !emailControl.errors;
    };
    PioneerValidators.commissionAmountAndTypeCrossValidator = function (calculatedPaymentWithTax) {
        var decimalPipe = PioneerValidators_1.injector.get(common_es5["DecimalPipe"]);
        return function (group) {
            var typeFormControl = group.get('type');
            var type = typeFormControl && typeFormControl.value && typeFormControl.value.key;
            if (type !== PaymentType.PAID_DIRECT) {
                return null;
            }
            if (PioneerValidators_1.isValidAmount(group.get('commissionAmount')) !== null) {
                return null;
            }
            var commissionAmountNumber = group.get('commissionAmount') && group.get('commissionAmount').value;
            if (!commissionAmountNumber && commissionAmountNumber !== 0) {
                return null;
            }
            else {
                var calculatedPaymentWithTaxFormatted = decimalPipe.transform(calculatedPaymentWithTax, '1.2-2');
                var commissionAmountString = decimalPipe.transform(commissionAmountNumber, '1.2-2');
                if (commissionAmountString !== calculatedPaymentWithTaxFormatted) {
                    return { 'amount_paid_not_equals_total_calculated_payment': true };
                }
                else {
                    return null;
                }
            }
        };
    };
    PioneerValidators.isPropertyError = function (group) {
        if (group.get('partyType').value === PartyType.PROPERTY.toString() &&
            (!group.get('propertyId').value || !group.get('chain').value || !group.get('brand').value)) {
            return { 'propertyRequired': true };
        }
        return null;
    };
    return PioneerValidators;
}());
pioneer_validators_PioneerValidators = PioneerValidators_1 = pioneer_validators___decorate([
    Object(core_es5["Injectable"])(),
    pioneer_validators___metadata("design:paramtypes", [typeof (pioneer_validators__a = typeof log_service_LogService !== "undefined" && log_service_LogService) === "function" && pioneer_validators__a || Object])
], pioneer_validators_PioneerValidators);

var PioneerValidators_1, pioneer_validators__a;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/pioneer.validators.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/service/common-data/common-data.http-service.ts
var common_data_http_service___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var common_data_http_service___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};




var CommonDataHttpService = (function () {
    function CommonDataHttpService(http, environment, responseUtilService) {
        this.http = http;
        this.environment = environment;
        this.responseUtilService = responseUtilService;
        this.baseUrl = this.environment.onyxCommonDataUrl;
        this.countryEndpoint = '/v1/country';
        this.currencyEndpoint = '/v1/currency/transaction';
        this.stateEndpoint = '/state';
    }
    CommonDataHttpService.prototype.getCountries = function () {
        var _this = this;
        return this.http.get("" + this.baseUrl + this.countryEndpoint)
            .catch(function (error) { return _this.responseUtilService.handleError(error); })
            .share();
    };
    CommonDataHttpService.prototype.getCurrencies = function () {
        var _this = this;
        return this.http.get("" + this.baseUrl + this.currencyEndpoint)
            .catch(function (error) { return _this.responseUtilService.handleError(error); })
            .share();
    };
    CommonDataHttpService.prototype.getStates = function (countryCode) {
        var _this = this;
        return this.http.get("" + this.baseUrl + this.countryEndpoint + "/" + countryCode + this.stateEndpoint)
            .catch(function (error) { return _this.responseUtilService.handleError(error); })
            .share();
    };
    return CommonDataHttpService;
}());
CommonDataHttpService = common_data_http_service___decorate([
    Object(core_es5["Injectable"])(),
    common_data_http_service___metadata("design:paramtypes", [typeof (common_data_http_service__a = typeof common_http_es5["b" /* HttpClient */] !== "undefined" && common_http_es5["b" /* HttpClient */]) === "function" && common_data_http_service__a || Object, typeof (common_data_http_service__b = typeof EnvironmentConfiguration !== "undefined" && EnvironmentConfiguration) === "function" && common_data_http_service__b || Object, typeof (common_data_http_service__c = typeof response_util_service_ResponseUtilService !== "undefined" && response_util_service_ResponseUtilService) === "function" && common_data_http_service__c || Object])
], CommonDataHttpService);

var common_data_http_service__a, common_data_http_service__b, common_data_http_service__c;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/common-data.http-service.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/utils/lru-cache.ts
/**
 * This class implements a Least Recently Used (LRU) cache with a fixed maximum size.
 * When the cache is full, it removes the least recently used key-value pair.
 */
var LRUCache = (function () {
    function LRUCache(maxSize) {
        this.cache = new Map();
        if (maxSize <= 0) {
            throw new Error('Cache size must be greater than 0');
        }
        this.maxSize = maxSize;
    }
    /**
     * Adds a key-value pair at the end of the cache.
     * If the cache is full, it removes the least recently used key-value pair.
     *
     * @param key
     * @param value
     */
    LRUCache.prototype.add = function (key, value) {
        if (this.cache.has(key)) {
            this.cache.delete(key);
        }
        this.cache.set(key, value);
        if (this.cache.size > this.maxSize) {
            var oldestKey = this.cache.keys().next().value;
            this.cache.delete(oldestKey);
        }
    };
    /**
     * Gets the value associated with the key.
     * If the key exists, it moves the key-value pair to the end of the cache
     * to indicate that it was the most recently used.
     *
     * @param key
     * @returns
     */
    LRUCache.prototype.get = function (key) {
        if (!this.cache.has(key)) {
            return undefined;
        }
        var value = this.cache.get(key);
        this.cache.delete(key);
        this.cache.set(key, value);
        return value;
    };
    LRUCache.prototype.forEach = function (callbackfn) {
        var _this = this;
        this.cache.forEach(function (value, key) {
            callbackfn(value, key, _this);
        });
    };
    LRUCache.prototype.has = function (key) {
        return this.cache.has(key);
    };
    return LRUCache;
}());

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/lru-cache.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/service/common-data/common-data.store.ts
var common_data_store___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var common_data_store___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};












var common_data_store_CommonDataStore = (function () {
    function CommonDataStore(_commonDataHttpService, flashMessagesService, logService) {
        this._commonDataHttpService = _commonDataHttpService;
        this.flashMessagesService = flashMessagesService;
        this.logService = logService;
        this.states$ = new BehaviorSubject["BehaviorSubject"]([]);
        this.countries$ = new BehaviorSubject["BehaviorSubject"]([]);
        this.currencies$ = new BehaviorSubject["BehaviorSubject"]([]);
        this.currenciesDrop$ = new BehaviorSubject["BehaviorSubject"]([]);
        this.statesCacheLimit = 3; // The cache will store a maximum of 3 arrays of states (from 3 countries)
        // Initialize LRU cache with a size limit of 3 behavior subjects to cache the states of 3 countries
        this.statesCache = new LRUCache(this.statesCacheLimit);
    }
    Object.defineProperty(CommonDataStore.prototype, "commonDataHttpService", {
        get: function () { return this._commonDataHttpService; },
        enumerable: true,
        configurable: true
    });
    CommonDataStore.prototype.loadCountries = function () {
        var _this = this;
        return this._commonDataHttpService.getCountries()
            .catch(function (error) {
            _this.flashMessagesService.error('MESSAGES.ERROR.COULD_NOT_GET_COUNTRIES', "Error retrieving countries: " + error);
            return Observable["Observable"].throw(error);
        })
            .map(function (countries) { return common_data_mapper_CommonDataMapper.convertCountriesToDropDownItem(countries); })
            .map(function (countries) {
            _this.countries$.next(countries);
            return countries;
        });
    };
    CommonDataStore.prototype.loadStatesFromCountry = function (countryCode) {
        var _this = this;
        return this.getStates(countryCode)
            .map(function (states) {
            return states.filter(function (state) { return common_data_mapper_CommonDataMapper.removeDuplicateStatesToDropDownItem(state); });
        })
            .map(function (states) { return common_data_mapper_CommonDataMapper.convertStatesToDropDownItem(states); })
            .map(function (states) {
            pioneer_utils_PioneerUtils.orderDropdownByValue(states);
            _this.states$.next(states);
            return states;
        });
    };
    Object.defineProperty(CommonDataStore.prototype, "states", {
        get: function () {
            return this.states$.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CommonDataStore.prototype, "countries", {
        get: function () {
            return this.countries$.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    CommonDataStore.prototype.getCountry = function (countryCode) {
        return this.countries$.flatMap(function (countries) {
            return countries.filter(function (country) { return country.key === countryCode; });
        });
    };
    CommonDataStore.prototype.getCurrency = function (currencyCode) {
        return this.currenciesDrop$.flatMap(function (currencies) {
            return currencies.filter(function (currency) { return currency.key === currencyCode; });
        });
    };
    CommonDataStore.prototype.getState = function (countryCode, stateCode) {
        stateCode = common_data_mapper_CommonDataMapper.fixDuplicateState(stateCode);
        return this.getStates(countryCode)
            .flatMap(function (states) {
            return states.filter(function (state) { return pioneer_utils_PioneerUtils.safeTrim(state.stateCode) === stateCode; });
        })
            .map(function (state) { return common_data_mapper_CommonDataMapper.convertStateToDropDownItem(state); });
    };
    CommonDataStore.prototype.getStatesFromApi = function (countryCode) {
        var _this = this;
        return this._commonDataHttpService.getStates(countryCode)
            .catch(function (error) {
            _this.flashMessagesService.error('MESSAGES.ERROR.COULD_NOT_GET_STATES', "Error retrieving states: " + error);
            return Observable["Observable"].throw(error);
        });
    };
    /**
     * This method fetches the states for a given country code from the API,
     * and caches the result to avoid redundant API calls.
     * It uses the LRU (Least Recently Used) cache eviction policy
     * to limit the cache size (max 3 arrays of states from 3 countries).
     * @param countryCode
     * @returns
     */
    CommonDataStore.prototype.getStates = function (countryCode) {
        var _this = this;
        this.logService.debug("getStates from country code: " + countryCode);
        if (!countryCode || (Constants.COUNTRIES_WITH_STATES.indexOf(countryCode) < 0)) {
            this.logService.debug("Country code " + countryCode + " does not have states");
            return Object(of["of"])([]);
        }
        var cachedEntry = this.statesCache.get(countryCode);
        if (cachedEntry) {
            // Return the existing cached states if they are available
            return cachedEntry.asObservable().pipe(Object(operators["filter"])(function (states) { return states !== null; }));
        }
        // If the cache does not contain the states,
        // fetch the states from the API and cache the result
        cachedEntry = new BehaviorSubject["BehaviorSubject"](null);
        this.statesCache.add(countryCode, cachedEntry);
        this.getStatesFromApi(countryCode).pipe(Object(operators["take"])(1), Object(operators["tap"])(function (states) {
            cachedEntry.next(states);
        }), Object(operators["catchError"])(function (error) {
            _this.logService.error("Error fetching states for " + countryCode + ": " + error);
            cachedEntry.error(error);
            return Object(of["of"])([]);
        })).subscribe();
        return cachedEntry.asObservable().pipe(Object(operators["filter"])(function (states) { return states !== null; }));
    };
    CommonDataStore.prototype.loadCurrencies = function () {
        var _this = this;
        return this._commonDataHttpService.getCurrencies()
            .catch(function (error) {
            _this.flashMessagesService.error('MESSAGES.ERROR.COULD_NOT_GET_CURRENCIES', "Error retrieving currencies: " + error);
            return Observable["Observable"].throw(error);
        })
            .map(function (currencies) {
            _this.currencies$.next(currencies);
            return currencies;
        });
    };
    CommonDataStore.prototype.loadCurrenciesDrop = function () {
        var _this = this;
        return this._commonDataHttpService.getCurrencies()
            .catch(function (error) {
            _this.flashMessagesService.error('MESSAGES.ERROR.COULD_NOT_GET_COUNTRIES', "Error retrieving countries: " + error);
            return Observable["Observable"].throw(error);
        })
            .map(function (currencies) { return common_data_mapper_CommonDataMapper.convertCurrenciesToDropDownItem(currencies); })
            .map(function (currencies) {
            _this.currenciesDrop$.next(currencies);
            return currencies;
        });
    };
    Object.defineProperty(CommonDataStore.prototype, "currencies", {
        get: function () {
            return this.currencies$.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CommonDataStore.prototype, "currenciesDrop", {
        get: function () {
            return this.currenciesDrop$.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    return CommonDataStore;
}());
common_data_store_CommonDataStore = common_data_store___decorate([
    Object(core_es5["Injectable"])(),
    common_data_store___metadata("design:paramtypes", [typeof (common_data_store__a = typeof CommonDataHttpService !== "undefined" && CommonDataHttpService) === "function" && common_data_store__a || Object, typeof (common_data_store__b = typeof flash_messages_service_FlashMessagesService !== "undefined" && flash_messages_service_FlashMessagesService) === "function" && common_data_store__b || Object, typeof (common_data_store__c = typeof log_service_LogService !== "undefined" && log_service_LogService) === "function" && common_data_store__c || Object])
], common_data_store_CommonDataStore);

var common_data_store__a, common_data_store__b, common_data_store__c;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/common-data.store.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/payment-status.enum.ts
/**
 * GroupPay Payment status codes
 * https://onyxpayments.atlassian.net/wiki/spaces/PION/pages/35160086/Payment+Statuses
 */
/**
 * GroupPay Payment status codes
 * https://onyxpayments.atlassian.net/wiki/spaces/PION/pages/35160086/Payment+Statuses
 */ var PaymentStatus;
(function (PaymentStatus) {
    PaymentStatus[PaymentStatus["READY"] = 'ready'] = "READY";
    PaymentStatus[PaymentStatus["PENDING"] = 'pending'] = "PENDING";
    PaymentStatus[PaymentStatus["INVOICED"] = 'invoiced'] = "INVOICED";
    PaymentStatus[PaymentStatus["INVOICE_REJECTED"] = 'invoice-rejected'] = "INVOICE_REJECTED";
    PaymentStatus[PaymentStatus["FUNDED"] = 'funded'] = "FUNDED";
    PaymentStatus[PaymentStatus["PAY_SENT"] = 'pay-sent'] = "PAY_SENT";
    PaymentStatus[PaymentStatus["PAY_REJECTED"] = 'pay-rejected'] = "PAY_REJECTED";
    PaymentStatus[PaymentStatus["REQUESTED"] = 'requested'] = "REQUESTED";
    PaymentStatus[PaymentStatus["ERROR"] = 'error'] = "ERROR";
    PaymentStatus[PaymentStatus["REQUEST_REJECTED"] = 'request-rejected'] = "REQUEST_REJECTED";
    PaymentStatus[PaymentStatus["RESENT_REQUEST"] = 'resent-request'] = "RESENT_REQUEST";
    PaymentStatus[PaymentStatus["PAID_DIRECT"] = 'paid-direct'] = "PAID_DIRECT";
    PaymentStatus[PaymentStatus["CANCELLED"] = 'cancelled'] = "CANCELLED";
    PaymentStatus[PaymentStatus["PENDING_WF_APPROVAL"] = 'pending-wf-approval'] = "PENDING_WF_APPROVAL";
    PaymentStatus[PaymentStatus["REJECTED_WF_APPROVAL"] = 'wf-rejected'] = "REJECTED_WF_APPROVAL";
    PaymentStatus[PaymentStatus["READY_TO_INITIATE"] = 'ready-to-initiate'] = "READY_TO_INITIATE";
    PaymentStatus[PaymentStatus["PAID"] = 'paid'] = "PAID";
    PaymentStatus[PaymentStatus["UNPAID"] = 'unpaid'] = "UNPAID";
    PaymentStatus[PaymentStatus["PARTIAL"] = 'partial'] = "PARTIAL";
    PaymentStatus[PaymentStatus["CHECK_STOPPED"] = 'check-stopped'] = "CHECK_STOPPED";
    PaymentStatus[PaymentStatus["PAY_CLEARED"] = 'pay-cleared'] = "PAY_CLEARED";
    PaymentStatus[PaymentStatus["PAY_REISSUED"] = 'pay-reissued'] = "PAY_REISSUED";
})(PaymentStatus || (PaymentStatus = {}));
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/payment-status.enum.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/payment.ts
var payment___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var PaymentRecord = Object(immutable["Record"])({
    eventPaymentId: 0,
    commissionAmount: 0,
    feeAmount: 0,
    commissionCurrency: null,
    description: null,
    commissionId: null,
    fundingReferenceId: null,
    paymentReferenceId: null,
    status: null,
    createdDate: null,
    modifiedDate: null,
    createdBy: null,
    modifiedBy: null,
    eventId: 0,
    type: null,
    eventPaymentModifiers: null,
    actionReason: null,
    actionDetails: null,
    resendPaymentRequestAvailable: null,
    eventPartyId: 0,
    totalTaxAmount: 0,
    eventPaymentTaxDetail: null,
    fundAmount: 0,
    fundCurrency: null,
    forecastedCommissionAmount: null,
    oldPaymentReferenceId: null
});
var Payment = (function (_super) {
    payment___extends(Payment, _super);
    function Payment() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Payment;
}(PaymentRecord));

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/payment.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/payment-summary/payment-summary.ts
var payment_summary___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var PaymentSummaryRecord = Object(immutable["Record"])({
    eventPartyId: null,
    roomCommissionSummary: null,
    adjustmentSummaryList: null,
    modifierSummaryList: null,
    prepayment: null,
    estimatedTax: null,
    calculatedPayment: null,
    paymentStatus: null,
    commissionAmount: null,
});
var PaymentSummary = (function (_super) {
    payment_summary___extends(PaymentSummary, _super);
    function PaymentSummary() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return PaymentSummary;
}(PaymentSummaryRecord));

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/payment-summary.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/adjustment-type.ts
var adjustment_type___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var AdjustmentTypeRecord = Object(immutable["Record"])({
    id: null,
    name: null,
    description: null,
    credit: null,
    debit: null
});
var AdjustmentType = (function (_super) {
    adjustment_type___extends(AdjustmentType, _super);
    function AdjustmentType() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return AdjustmentType;
}(AdjustmentTypeRecord));

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/adjustment-type.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/payment-summary/adjustment-summary.ts
var adjustment_summary___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var AdjustmentSummaryRecord = Object(immutable["Record"])({
    eventAdjustmentId: null,
    /**
     * Total Spend in the payment summary card does not consider if shoulder dates should be excluded.
     */
    totalSpend: null,
    /**
     * Comm Rate in the payment summary card is the commission percentage
     */
    commRate: null,
    /**
     * The result of applying the commission percentage to the commissionable revenue.
     * In the case of reservations and RSVPs, it considers if shoulder dates should be excluded.
     */
    amountDue: null,
    adjustmentType: null,
    description: null
});
var AdjustmentSummary = (function (_super) {
    adjustment_summary___extends(AdjustmentSummary, _super);
    function AdjustmentSummary() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return AdjustmentSummary;
}(AdjustmentSummaryRecord));

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/adjustment-summary.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/payment-summary/room-commission-summary.ts
var room_commission_summary___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var RoomCommissionSummaryRecord = Object(immutable["Record"])({
    /**
     * Total Spend in the payment summary card does not consider if shoulder dates should be excluded.
     */
    totalSpend: null,
    /**
     * Comm Rate in the payment summary card is the commission percentage
     */
    commRate: null,
    /**
     * The result of applying the commission percentage to the commissionable revenue.
     * In the case of reservations and RSVPs, it considers if shoulder dates should be excluded.
     */
    amountDue: null,
    roomCommissionType: null,
    shoulderDatesExcluded: null,
    totalNights: null,
    avgRoomRate: null
});
var RoomCommissionSummary = (function (_super) {
    room_commission_summary___extends(RoomCommissionSummary, _super);
    function RoomCommissionSummary() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return RoomCommissionSummary;
}(RoomCommissionSummaryRecord));

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/room-commission-summary.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/payment-summary/prepayment-summary.ts
var prepayment_summary___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var PrepaymentSummaryRecord = Object(immutable["Record"])({
    amount: null,
    description: null,
});
var PrepaymentSummary = (function (_super) {
    prepayment_summary___extends(PrepaymentSummary, _super);
    function PrepaymentSummary() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return PrepaymentSummary;
}(PrepaymentSummaryRecord));

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/prepayment-summary.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/service/payment.http.service.ts
var payment_http_service___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var payment_http_service___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};















var payment_http_service_PaymentHttpService = (function () {
    function PaymentHttpService(http, environment, responseUtilService, flashMessagesService) {
        var _this = this;
        this.http = http;
        this.environment = environment;
        this.responseUtilService = responseUtilService;
        this.flashMessagesService = flashMessagesService;
        this.eventsUrl = this.environment.baseUrl + '/api/events';
        this.paymentUrl = this.eventsUrl + '/payments';
        this.paymentBulkUrl = this.eventsUrl + '/payments/bulk';
        this.cancelUrl = this.eventsUrl + '/payments/cancel';
        this.paymentRequestUrl = this.paymentUrl + '/request';
        this.paymentSummaryUrl = this.paymentUrl + '/summary';
        this.deserializeAdjustmentSummary = function (json) {
            return new AdjustmentSummary({
                eventAdjustmentId: json.eventAdjustmentId,
                totalSpend: json.totalSpend,
                commRate: json.commRate,
                amountDue: json.amountDue,
                adjustmentType: _this.deserializeAdjustmentType(json.adjustmentType),
                description: json.description
            });
        };
    }
    PaymentHttpService.prototype.add = function (payment) {
        var _this = this;
        var headers = new http_es5["Headers"]({ 'Content-Type': 'application/json' });
        var options = new http_es5["RequestOptions"]({ headers: headers });
        return this.http.post(this.paymentUrl, JSON.stringify(payment.toJS()), options)
            .catch(function (response) {
            return _this.handleError(response);
        }).share();
    };
    PaymentHttpService.prototype.update = function (payment) {
        var _this = this;
        var headers = new http_es5["Headers"]({ 'Content-Type': 'application/json' });
        var options = new http_es5["RequestOptions"]({ headers: headers });
        return this.http.put(this.paymentUrl, JSON.stringify(payment.toJS()), options)
            .catch(function (response) {
            return _this.handleError(response);
        }).share();
    };
    PaymentHttpService.prototype.bulkPayments = function (payments) {
        var _this = this;
        var headers = new http_es5["Headers"]({ 'Content-Type': 'application/json' });
        var options = new http_es5["RequestOptions"]({ headers: headers });
        return this.http.post(this.paymentBulkUrl, JSON.stringify(payments), options)
            .map(function (res) { return res.json(); })
            .catch(function (response) {
            return _this.handleError(response);
        }).share();
    };
    PaymentHttpService.prototype.cancelNew = function (payment) {
        var _this = this;
        var headers = new http_es5["Headers"]({ 'Content-Type': 'application/json' });
        var options = new http_es5["RequestOptions"]({ headers: headers });
        return this.http.post(this.cancelUrl, JSON.stringify(payment.toJS()), options)
            .catch(function (response) {
            return _this.handleError(response);
        }).share();
    };
    PaymentHttpService.prototype.cancelExisting = function (payment) {
        var _this = this;
        var headers = new http_es5["Headers"]({ 'Content-Type': 'application/json' });
        var options = new http_es5["RequestOptions"]({ headers: headers });
        return this.http.put(this.cancelUrl, JSON.stringify(payment.toJS()), options)
            .catch(function (response) {
            return _this.handleError(response);
        }).share();
    };
    PaymentHttpService.prototype.getPayments = function (eventId) {
        var _this = this;
        return this.http.get(this.eventsUrl + "/" + eventId + "/payments")
            .map(function (response) { return Object(immutable["List"])(response.json().map(function (element) { return new Payment(element); })); })
            .catch(function (response) { return _this.responseUtilService.handleError(response); })
            .share();
    };
    PaymentHttpService.prototype.getPaymentsByParty = function (eventId, eventPartyId) {
        var _this = this;
        return this.http.get(this.eventsUrl + "/" + eventId + "/" + eventPartyId + "/payments")
            .map(function (response) { return Object(immutable["List"])(response.json().map(function (element) { return new Payment(element); })); })
            .catch(function (response) { return _this.responseUtilService.handleError(response); })
            .share();
    };
    PaymentHttpService.prototype.getLatestFinalPayment = function (eventId) {
        var _this = this;
        return this.http.get(this.eventsUrl + "/" + eventId + "/latestFinalPayment")
            .map(function (response) {
            return _this.mapPaymentResponse(response);
        })
            .catch(function (response) { return _this.responseUtilService.handleError(response); })
            .share();
    };
    PaymentHttpService.prototype.getLatestVendorFinalPayment = function (eventId) {
        var _this = this;
        return this.http.get(this.eventsUrl + "/" + eventId + "/latestVendorFinalPayments")
            .map(function (response) {
            return _this.mapPaymentArrayResponse(response);
        })
            .catch(function (response) { return _this.responseUtilService.handleError(response); })
            .share();
    };
    PaymentHttpService.prototype.getLatestVendorFinalPaymentByParty = function (eventId, eventPartyId) {
        var _this = this;
        return this.http.get(this.eventsUrl + "/" + eventId + "/" + eventPartyId + "/latestVendorFinalPayments")
            .map(function (response) {
            return _this.mapPaymentArrayResponse(response);
        })
            .catch(function (response) { return _this.responseUtilService.handleError(response); })
            .share();
    };
    PaymentHttpService.prototype.getLatestPrepayment = function (eventId) {
        var _this = this;
        return this.http.get(this.eventsUrl + "/" + eventId + "/latestPrepayment")
            .map(function (response) {
            return _this.mapPaymentResponse(response);
        })
            .catch(function (errorResponse) { return _this.responseUtilService.handleError(errorResponse); })
            .share();
    };
    PaymentHttpService.prototype.getLatestVendorPrepayments = function (eventId) {
        var _this = this;
        return this.http.get(this.eventsUrl + "/" + eventId + "/latestVendorPrepayments")
            .map(function (response) {
            return _this.mapPaymentArrayResponse(response);
        })
            .catch(function (errorResponse) { return _this.responseUtilService.handleError(errorResponse); })
            .share();
    };
    PaymentHttpService.prototype.getLatestVendorPrepaymentsByParty = function (eventId, eventPartyId) {
        var _this = this;
        return this.http.get(this.eventsUrl + "/" + eventId + "/" + eventPartyId + "/latestVendorPrepayments")
            .map(function (response) {
            return _this.mapPaymentArrayResponse(response);
        })
            .catch(function (errorResponse) { return _this.responseUtilService.handleError(errorResponse); })
            .share();
    };
    PaymentHttpService.prototype.getFinalPaymentStatusList = function (eventId) {
        var _this = this;
        return this.http.get(this.eventsUrl + "/" + eventId + "/finalPaymentStatusList")
            .map(function (response) {
            return _this.mapPaymentArrayResponse(response);
        })
            .catch(function (response) { return _this.responseUtilService.handleError(response); })
            .share();
    };
    PaymentHttpService.prototype.getFinalPaymentStatusListByParty = function (eventId, eventPartyId) {
        var _this = this;
        return this.http.get(this.eventsUrl + "/" + eventId + "/" + eventPartyId + "/finalPaymentStatusList")
            .map(function (response) {
            return _this.mapPaymentArrayResponse(response);
        })
            .catch(function (response) { return _this.responseUtilService.handleError(response); })
            .share();
    };
    PaymentHttpService.prototype.resendPaymentRequest = function (eventId) {
        var _this = this;
        var headers = new http_es5["Headers"]({ 'Content-Type': 'application/json' });
        var options = new http_es5["RequestOptions"]({ headers: headers });
        return this.http.put(this.eventsUrl + "/" + eventId + "/resendPaymentRequest", null, options)
            .catch(function (response) {
            return _this.handleError(response);
        }).share();
    };
    PaymentHttpService.prototype.getLatestInitialPaymentsByParty = function (eventId, eventPartyId) {
        var _this = this;
        return this.http.get(this.eventsUrl + "/" + eventId + "/" + eventPartyId + "/initialPayments")
            .map(function (response) {
            return _this.mapPaymentArrayResponse(response);
        })
            .catch(function (response) { return _this.responseUtilService.handleError(response); })
            .share();
    };
    PaymentHttpService.prototype.getLatestInitialPayments = function (eventId) {
        var _this = this;
        return this.http.get(this.eventsUrl + "/" + eventId + "/initialPayments")
            .map(function (response) {
            return _this.mapPaymentArrayResponse(response);
        })
            .catch(function (response) { return _this.responseUtilService.handleError(response); })
            .share();
    };
    PaymentHttpService.prototype.updateForecastedCommissionAmount = function (payment) {
        var _this = this;
        var headers = new http_es5["Headers"]({ 'Content-Type': 'application/json' });
        var options = new http_es5["RequestOptions"]({ headers: headers });
        return this.http.put(this.paymentUrl + "/forecasted/commission", JSON.stringify(payment.toJS()), options)
            .catch(function (response) {
            return _this.handleError(response);
        }).share();
    };
    PaymentHttpService.prototype.withdrawPaymentRequest = function (eventId, eventPartyId) {
        var _this = this;
        var headers = new http_es5["Headers"]({ 'Content-Type': 'application/json' });
        var options = new http_es5["RequestOptions"]({ headers: headers });
        return this.http.put(this.eventsUrl + "/" + eventId + "/" + eventPartyId + "/withdrawPayment", null, options)
            .catch(function (response) {
            return _this.handleError(response);
        }).share();
    };
    PaymentHttpService.prototype.handleError = function (response) {
        var result;
        var responseObject = response.json();
        if (responseObject && responseObject.error.indexOf(Constants.AGENCY_SERVICE_ERROR_RESPONSE) !== -1) {
            this.flashMessagesService.error('MESSAGES.ERROR.AGENCY_SERVICE_ADD_REQUEST');
            result = Observable["Observable"].empty();
        }
        else {
            result = this.responseUtilService.handleError(response);
        }
        return result;
    };
    /**
     * FIXME The status property is declared as PaymentStatus in the Payment model
     * but the string returned from the API is not converted to PaymentStatus,
     * so it is a string at runtime and comparing status and PaymentStatus with ===
     * is not working.
     */
    PaymentHttpService.prototype.mapPaymentResponse = function (response) {
        var payment = null;
        var jsonPayment = response.json();
        if (jsonPayment) {
            payment = new Payment(jsonPayment);
        }
        return payment;
    };
    /**
     * FIXME The status property is declared as PaymentStatus in the Payment model
     * but the string returned from the API is not converted to PaymentStatus,
     * so it is a string at runtime and comparing status and PaymentStatus with ===
     * is not working.
     */
    PaymentHttpService.prototype.mapPaymentArrayResponse = function (response) {
        return response.json();
    };
    PaymentHttpService.prototype.request = function (payment) {
        var _this = this;
        var headers = new http_es5["Headers"]({ 'Content-Type': 'application/json' });
        var options = new http_es5["RequestOptions"]({ headers: headers });
        return this.http.post(this.paymentRequestUrl, JSON.stringify(payment.toJS()), options)
            .catch(function (response) {
            return _this.handleError(response);
        }).share();
    };
    PaymentHttpService.prototype.fetchPaymentSummary = function (eventPartyIds) {
        var _this = this;
        var headers = new http_es5["Headers"]({ 'Content-Type': 'application/json' });
        var options = new http_es5["RequestOptions"]({ headers: headers });
        return this.http.post(this.paymentSummaryUrl, JSON.stringify(Array.from(eventPartyIds)), options)
            .map(function (response) {
            var json = response.json();
            var keys = Object.keys(json);
            if (!keys.length) {
                throw new Error('Payment summary response is empty or missing eventPartyIds');
            }
            return Object(immutable["Map"])(keys.map(Number).map(function (eventPartyId) { return [
                eventPartyId,
                _this.deserializePaymentSummary(json[eventPartyId])
            ]; }));
        })
            .share();
    };
    PaymentHttpService.prototype.deserializePaymentSummary = function (json) {
        return new PaymentSummary({
            eventPartyId: json.eventPartyId,
            roomCommissionSummary: this.deserializeRoomCommissionSummary(json.roomCommissionSummary),
            adjustmentSummaryList: Object(immutable["List"])((json.adjustmentSummaryList || []).map(this.deserializeAdjustmentSummary)),
            modifierSummaryList: Object(immutable["List"])((json.modifierSummaryList || []).map(this.deserializeAdjustmentSummary)),
            prepayment: this.deserializePrepaymentSummary(json.prepayment),
            estimatedTax: json.estimatedTax,
            calculatedPayment: json.calculatedPayment,
            paymentStatus: json.paymentStatus,
            commissionAmount: json.commissionAmount,
        });
    };
    PaymentHttpService.prototype.deserializeRoomCommissionSummary = function (json) {
        return new RoomCommissionSummary({
            totalSpend: json.totalSpend,
            commRate: json.commRate,
            amountDue: json.amountDue,
            roomCommissionType: json.roomCommissionType,
            shoulderDatesExcluded: json.shoulderDatesExcluded,
            totalNights: json.totalNights,
            avgRoomRate: json.avgRoomRate
        });
    };
    PaymentHttpService.prototype.deserializePrepaymentSummary = function (json) {
        if (!json) {
            return null;
        }
        return new PrepaymentSummary({
            amount: json.amount,
            description: json.description
        });
    };
    PaymentHttpService.prototype.deserializeAdjustmentType = function (json) {
        return new AdjustmentType({
            id: json.id,
            name: json.name,
            description: json.description,
            credit: json.credit,
            debit: json.debit
        });
    };
    return PaymentHttpService;
}());
payment_http_service_PaymentHttpService = payment_http_service___decorate([
    Object(core_es5["Injectable"])(),
    payment_http_service___metadata("design:paramtypes", [typeof (payment_http_service__a = typeof AppAuthHttpService !== "undefined" && AppAuthHttpService) === "function" && payment_http_service__a || Object, typeof (payment_http_service__b = typeof EnvironmentConfiguration !== "undefined" && EnvironmentConfiguration) === "function" && payment_http_service__b || Object, typeof (payment_http_service__c = typeof response_util_service_ResponseUtilService !== "undefined" && response_util_service_ResponseUtilService) === "function" && payment_http_service__c || Object, typeof (payment_http_service__d = typeof flash_messages_service_FlashMessagesService !== "undefined" && flash_messages_service_FlashMessagesService) === "function" && payment_http_service__d || Object])
], payment_http_service_PaymentHttpService);

var payment_http_service__a, payment_http_service__b, payment_http_service__c, payment_http_service__d;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/payment.http.service.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/utils/payment-status-utils.ts


var payment_status_utils_PaymentStatusUtils = (function () {
    function PaymentStatusUtils() {
    }
    PaymentStatusUtils.isError = function (paymentStatus) {
        return this.ERROR_CODES.contains(paymentStatus);
    };
    PaymentStatusUtils.isNoTotalPaid = function (paymentStatus) {
        return this.NO_TOTAL_PAID_CODES.contains(paymentStatus);
    };
    PaymentStatusUtils.isNoEstimatedDue = function (paymentStatus) {
        return this.NO_ESTIMATED_DUE_CODES.contains(paymentStatus);
    };
    PaymentStatusUtils.isEditable = function (paymentStatus) {
        return this.NOT_EDITABLE_CODES.contains(paymentStatus);
    };
    PaymentStatusUtils.getAwePaymentStatus = function (paymentStatus, isAgencyUser) {
        return isAgencyUser && paymentStatus === PaymentStatus.REJECTED_WF_APPROVAL ? PaymentStatus.PENDING_WF_APPROVAL : paymentStatus;
    };
    return PaymentStatusUtils;
}());

payment_status_utils_PaymentStatusUtils.ERROR_CODES = Object(immutable["List"])([
    PaymentStatus.INVOICE_REJECTED,
    PaymentStatus.PAY_REJECTED,
    PaymentStatus.ERROR
]);
payment_status_utils_PaymentStatusUtils.NO_TOTAL_PAID_CODES = Object(immutable["List"])([
    PaymentStatus.INVOICE_REJECTED,
    PaymentStatus.PAY_REJECTED,
    PaymentStatus.CHECK_STOPPED,
    PaymentStatus.REQUESTED,
    PaymentStatus.ERROR,
    PaymentStatus.REQUEST_REJECTED,
    PaymentStatus.RESENT_REQUEST,
    PaymentStatus.CANCELLED
]);
payment_status_utils_PaymentStatusUtils.NO_ESTIMATED_DUE_CODES = Object(immutable["List"])([
    PaymentStatus.READY,
    PaymentStatus.PENDING,
    PaymentStatus.INVOICED,
    PaymentStatus.FUNDED,
    PaymentStatus.PAY_SENT,
    PaymentStatus.PAID_DIRECT,
    PaymentStatus.CANCELLED,
    PaymentStatus.CHECK_STOPPED,
    PaymentStatus.PAY_CLEARED,
    PaymentStatus.PAY_REISSUED
]);
payment_status_utils_PaymentStatusUtils.NOT_EDITABLE_CODES = Object(immutable["List"])([
    PaymentStatus.READY,
    PaymentStatus.PENDING,
    PaymentStatus.INVOICED,
    PaymentStatus.FUNDED,
    PaymentStatus.PAY_SENT,
    PaymentStatus.REQUESTED,
    PaymentStatus.RESENT_REQUEST,
    PaymentStatus.PAID_DIRECT,
    PaymentStatus.CANCELLED,
    PaymentStatus.CHECK_STOPPED,
    PaymentStatus.PAY_CLEARED,
    PaymentStatus.PAY_REISSUED
]);
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/payment-status-utils.js.map
// EXTERNAL MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/node_modules/rxjs/observable/empty.js
var observable_empty = __webpack_require__("slZm");
var observable_empty_default = /*#__PURE__*/__webpack_require__.n(observable_empty);

// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/service/payment-summary/payment-summary.store.ts
var payment_summary_store___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var payment_summary_store___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};








var payment_summary_store_PaymentSummaryStore = (function () {
    function PaymentSummaryStore(paymentHttpService, flashMessagesService, translateService, logService) {
        this.paymentHttpService = paymentHttpService;
        this.flashMessagesService = flashMessagesService;
        this.translateService = translateService;
        this.logService = logService;
        this.paymentSummaryByVendorCache = new Map();
    }
    PaymentSummaryStore.prototype.resolveCache = function (eventPartyIds) {
        var _this = this;
        this.resetCache();
        return this.refreshCache(eventPartyIds).pipe(Object(operators["catchError"])(function (err) {
            _this.handleUserFacingError("Error resolving payment summary cache: " + (err.message || err));
            return Object(observable_empty["empty"])();
        }), Object(operators["mapTo"])(undefined));
    };
    PaymentSummaryStore.prototype.reloadPaymentSummary = function (eventPartyIdOrSet) {
        var _this = this;
        if (!eventPartyIdOrSet) {
            var errorMessage = 'eventPartyIdOrSet not provided';
            this.logService.error("Error getting Payment Summary: " + errorMessage);
            throw new Error(errorMessage);
        }
        var eventPartyIds = eventPartyIdOrSet instanceof Set ? eventPartyIdOrSet : new Set([eventPartyIdOrSet]);
        return this.refreshCache(eventPartyIds).pipe(Object(operators["catchError"])(function (err) {
            _this.handleUserFacingError("Error reloading payment summary cache item: " + (err.message || err));
            return Object(observable_empty["empty"])();
        }), Object(operators["mapTo"])(undefined));
    };
    PaymentSummaryStore.prototype.getPaymentSummary = function (eventPartyId) {
        var _this = this;
        if (!eventPartyId) {
            var errorMessage = 'eventPartyId not provided';
            this.logService.error("Error getting Payment Summary: " + errorMessage);
            throw new Error(errorMessage);
        }
        var subject = this.paymentSummaryByVendorCache.get(eventPartyId);
        if (!subject) {
            subject = this.initSubject(eventPartyId);
            this.paymentHttpService.fetchPaymentSummary(new Set([eventPartyId])).pipe(Object(operators["tap"])(function (paymentSummaryMap) {
                var summary = paymentSummaryMap.get(eventPartyId);
                if (summary) {
                    subject.next(summary);
                }
                else {
                    _this.logService.warn("No payment summary returned for eventPartyId " + eventPartyId);
                }
            }), Object(operators["catchError"])(function (err) {
                _this.handleSilentError("Error lazily loading payment summary for " + eventPartyId + ": " + (err.message || err));
                return Object(observable_empty["empty"])();
            })).subscribe();
        }
        return subject.asObservable().pipe(Object(operators["filter"])(function (summary) { return summary != null; }));
    };
    PaymentSummaryStore.prototype.refreshCache = function (eventPartyIds) {
        var _this = this;
        if (!eventPartyIds || eventPartyIds.has(null) || eventPartyIds.has(undefined)) {
            var errorMessage = 'eventPartyId not provided';
            this.logService.error("Error getting Payment Summary: " + errorMessage);
            throw new Error(errorMessage);
        }
        return this.paymentHttpService.fetchPaymentSummary(eventPartyIds).pipe(Object(operators["tap"])(function (paymentSummaryByVendor) {
            _this.populateCache(paymentSummaryByVendor);
        }), Object(operators["mapTo"])(undefined));
    };
    PaymentSummaryStore.prototype.resetCache = function () {
        this.paymentSummaryByVendorCache.forEach(function (vendorPaymentSummarySubject) {
            vendorPaymentSummarySubject.complete();
        });
        this.paymentSummaryByVendorCache = new Map();
    };
    PaymentSummaryStore.prototype.populateCache = function (paymentSummaryByVendor) {
        var _this = this;
        paymentSummaryByVendor.forEach(function (paymentSummary, eventPartyIdKey) {
            _this.upsertItem(eventPartyIdKey, paymentSummary);
        });
    };
    PaymentSummaryStore.prototype.upsertItem = function (eventPartyId, paymentSummary) {
        var vendorPaymentSummarySubject = this.paymentSummaryByVendorCache.get(eventPartyId);
        if (vendorPaymentSummarySubject) {
            vendorPaymentSummarySubject.next(paymentSummary);
        }
        else {
            vendorPaymentSummarySubject = new BehaviorSubject["BehaviorSubject"](paymentSummary);
            this.paymentSummaryByVendorCache.set(eventPartyId, vendorPaymentSummarySubject);
        }
        return vendorPaymentSummarySubject;
    };
    PaymentSummaryStore.prototype.initSubject = function (eventPartyId) {
        var vendorPaymentSummarySubject = new BehaviorSubject["BehaviorSubject"](null);
        this.paymentSummaryByVendorCache.set(eventPartyId, vendorPaymentSummarySubject);
        return vendorPaymentSummarySubject;
    };
    PaymentSummaryStore.prototype.handleUserFacingError = function (message) {
        this.logService.error(message);
        this.flashMessagesService.error(this.translateService.instant('MESSAGES.ERROR.COULD_NOT_GET_PAYMENT_SUMMARY'));
    };
    PaymentSummaryStore.prototype.handleSilentError = function (message) {
        this.logService.warn(message);
    };
    return PaymentSummaryStore;
}());
payment_summary_store_PaymentSummaryStore = payment_summary_store___decorate([
    Object(core_es5["Injectable"])(),
    payment_summary_store___metadata("design:paramtypes", [typeof (payment_summary_store__a = typeof payment_http_service_PaymentHttpService !== "undefined" && payment_http_service_PaymentHttpService) === "function" && payment_summary_store__a || Object, typeof (payment_summary_store__b = typeof flash_messages_service_FlashMessagesService !== "undefined" && flash_messages_service_FlashMessagesService) === "function" && payment_summary_store__b || Object, typeof (payment_summary_store__c = typeof core["c" /* TranslateService */] !== "undefined" && core["c" /* TranslateService */]) === "function" && payment_summary_store__c || Object, typeof (payment_summary_store__d = typeof log_service_LogService !== "undefined" && log_service_LogService) === "function" && payment_summary_store__d || Object])
], payment_summary_store_PaymentSummaryStore);

var payment_summary_store__a, payment_summary_store__b, payment_summary_store__c, payment_summary_store__d;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/payment-summary.store.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/service/payment.store.ts
var payment_store___assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var payment_store___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var payment_store___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};













var payment_store_PaymentStore = (function () {
    function PaymentStore(paymentHttpService, logService, flashMessagesService, translateService, paymentSummaryStore) {
        this.paymentHttpService = paymentHttpService;
        this.logService = logService;
        this.flashMessagesService = flashMessagesService;
        this.translateService = translateService;
        this.paymentSummaryStore = paymentSummaryStore;
        // This is the same as BehaviorSubject but without a default value
        this.paymentList = new ReplaySubject["ReplaySubject"](1);
        this.latestFinalPayment = new ReplaySubject["ReplaySubject"](1);
        this.latestVendorFinalPayments = new ReplaySubject["ReplaySubject"](1);
        this.latestPrepayment = new ReplaySubject["ReplaySubject"](1);
        this.latestVendorPrepayments = new ReplaySubject["ReplaySubject"](1);
        this.latestVendorPrepaymentsList = new ReplaySubject["ReplaySubject"](1);
        this.finalPaymentStatusList = new ReplaySubject["ReplaySubject"](1);
        this.latestVendorInitialPayment = new ReplaySubject["ReplaySubject"](1);
        this.latestInitialPayments = new ReplaySubject["ReplaySubject"](1);
        this._calculatedPaymentWithTaxByEventPartyId = new Map();
        this._calculatedPaymentWithTaxByEventPartyId$ = new BehaviorSubject["BehaviorSubject"](this._calculatedPaymentWithTaxByEventPartyId);
        this.addPaymentStatuses = [
            PaymentType.PREPAYMENT,
            PaymentType.PAID_DIRECT,
            PaymentType.EVENT_CANCELLED,
        ];
    }
    PaymentStore.prototype.addPayment = function (payment) {
        var _this = this;
        return this.addPaymentHelper(payment)
            .catch(function (error) {
            if (error.includes('Unable to request final payment')) {
                _this.flashMessagesService.error('MESSAGES.ERROR.OOIV_HEALTH', error);
            }
            else if (error.includes('Legal Entity data for agency')) {
                _this.flashMessagesService.error('MESSAGES.ERROR.MISSING_LEGAL_ENTITY_AGENCY', "Error adding Payment: " + error);
            }
            else if (error.includes('Legal Entity data for vendor')) {
                _this.flashMessagesService.error('MESSAGES.ERROR.MISSING_LEGAL_ENTITY_VENDOR', "Error adding Payment: " + error);
            }
            else if (error.includes('Missing information in legal entity table')) {
                _this.flashMessagesService.error('MESSAGES.ERROR.LEGAL_ENTITY_MISSING_INFO', "Error adding Payment: " + error);
            }
            else if (error.includes('Invalid Tax ID')) {
                _this.flashMessagesService.error('MESSAGES.ERROR.INVALID_VAT_ID', "Error adding Payment: " + error);
            }
            else if (error.includes('Invalid Tax ID')) {
                _this.flashMessagesService.error('MESSAGES.ERROR.INVALID_VAT_ID', error);
            }
            else {
                _this.flashMessagesService.error('MESSAGES.ERROR.ADD_PAYMENT', "Error adding Payment: " + error);
            }
            return Observable["Observable"].throw(error);
        })
            .map(function (result) {
            if (payment.type === PaymentType.PREPAYMENT) {
                _this.flashMessagesService.success('EVENT.PREPAYMENT.PREPAYMENT_SAVED');
            }
            else {
                _this.flashMessagesService.success('EVENT.COMMISSION.PAYMENT_SAVED');
            }
            return result;
        });
    };
    PaymentStore.prototype.updateFinalPayment = function (payment) {
        var _this = this;
        return this.updatePaymentHelper(payment)
            .catch(function (error) {
            _this.flashMessagesService.error('MESSAGES.ERROR.UPDATE_PAYMENT', "Error updating Payment: " + error);
            return Observable["Observable"].throw(error);
        })
            .map(function (result) {
            _this.flashMessagesService.success('EVENT.COMMISSION.PAYMENT_SAVED');
            return result;
        });
    };
    PaymentStore.prototype.addBulkActionPayment = function (payment) {
        var _this = this;
        return this.addPaymentHelper(payment)
            .catch(function (error) {
            if (error.includes('Unable to request final payment')) {
                _this.flashMessagesService.error('MESSAGES.ERROR.OOIV_HEALTH', error);
            }
            else if (error.includes('Legal Entity data for agency')) {
                _this.flashMessagesService.error('MESSAGES.ERROR.MISSING_LEGAL_ENTITY_AGENCY', "Error adding Payment: " + error);
            }
            else if (error.includes('Legal Entity data for vendor')) {
                _this.flashMessagesService.error('MESSAGES.ERROR.MISSING_LEGAL_ENTITY_VENDOR', "Error adding Payment: " + error);
            }
            else if (error.includes('Invalid Tax ID')) {
                _this.flashMessagesService.error('MESSAGES.ERROR.INVALID_VAT_ID', error);
            }
            else {
                _this.flashMessagesService.error('MESSAGES.ERROR.ADD_PAYMENT', "Error adding Payment: " + error);
            }
            return Observable["Observable"].throw(error);
        })
            .map(function (result) {
            return result;
        });
    };
    PaymentStore.prototype.updateBulkActionPayment = function (payment) {
        return this.updatePaymentHelper(payment)
            .catch(function (error) {
            return Observable["Observable"].throw(error);
        })
            .map(function (result) {
            return result;
        });
    };
    PaymentStore.prototype.cancelNewPayment = function (payment) {
        var _this = this;
        return this.paymentHttpService.cancelNew(payment)
            .catch(function (error) {
            _this.flashMessagesService.error('MESSAGES.ERROR.ADD_PAYMENT', "Error adding Payment: " + error);
            return Observable["Observable"].throw(error);
        })
            .map(function (result) {
            if (payment.type === PaymentType.PREPAYMENT) {
                _this.flashMessagesService.success('EVENT.PREPAYMENT.PREPAYMENT_SAVED');
            }
            else {
                _this.flashMessagesService.success('EVENT.COMMISSION.PAYMENT_SAVED');
            }
            return result;
        });
    };
    PaymentStore.prototype.cancelExistingPayment = function (payment) {
        var _this = this;
        return this.paymentHttpService.cancelExisting(payment)
            .catch(function (error) {
            _this.flashMessagesService.error('MESSAGES.ERROR.UPDATE_PAYMENT', "Error updating Payment: " + error);
            return Observable["Observable"].throw(error);
        })
            .map(function (result) {
            _this.flashMessagesService.success('EVENT.COMMISSION.PAYMENT_SAVED');
            return result;
        });
    };
    Object.defineProperty(PaymentStore.prototype, "payments", {
        get: function () {
            return this.paymentList.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    PaymentStore.prototype.getVendorPayments = function (eventPartyId) {
        return this.paymentList.map(function (filteredList) {
            if (filteredList == null) {
                return null;
            }
            return filteredList.filter(function (filtered) { return filtered.eventPartyId === eventPartyId; }).toList();
        });
    };
    /**
     *
     * @returns Observable of Payment[] without REQUEST_REJECTED payments
     */
    PaymentStore.prototype.getLatestFinalPayment = function () {
        return this.latestFinalPayment.asObservable();
    };
    /**
     *
     * @returns Observable of Payment[] without REQUEST_REJECTED payments
     */
    PaymentStore.prototype.getLatestVendorFinalPayments = function () {
        var _this = this;
        return this.latestVendorFinalPayments.asObservable().pipe(
        // Filter out REQUEST_REJECTED payments
        Object(operators["map"])(function (payments) { return _this.filterNonRequestRejectedPayments(payments); }));
    };
    /**
     *
     * @param eventPartyId
     * @returns Observable of Payment without REQUEST_REJECTED payments
     */
    PaymentStore.prototype.getVendorFinalPayment = function (eventPartyId) {
        var _this = this;
        return this.latestVendorFinalPayments
            .map(function (payments) {
            // Filter out REQUEST_REJECTED payments
            payments = _this.filterNonRequestRejectedPayments(payments);
            return payments != null ? payments.filter(function (payment) { return payment.eventPartyId === eventPartyId; })[0] : null;
        });
    };
    PaymentStore.prototype.filterNonRequestRejectedPayments = function (payments) {
        if (payments == null) {
            return null;
        }
        var filteredPayments = payments.filter(function (payment) { return payment.status !== PaymentStatus.REQUEST_REJECTED; });
        if (filteredPayments.length === 0) {
            return null;
        }
        return filteredPayments;
    };
    /**
     *
     * @param eventPartyId
     * @returns Observable of Payment that may be in REQUEST_REJECTED status
     */
    PaymentStore.prototype.getVendorFinalPaymentIncludeRequestRejected = function (eventPartyId) {
        return this.latestVendorFinalPayments
            .map(function (payments) {
            if (payments == null) {
                return null;
            }
            return payments.filter(function (payment) { return payment.eventPartyId === eventPartyId; })[0];
        });
    };
    PaymentStore.prototype.loadPayments = function (eventId) {
        var _this = this;
        return this.paymentHttpService.getPayments(eventId)
            .catch(function (error) {
            _this.flashMessagesService.error(_this.translateService.instant('MESSAGES.ERROR.GET_PAYMENTS'));
            _this.logService.error("Error adding Payment: " + error);
            return Observable["Observable"].throw(error);
        })
            .map(function (result) {
            _this.paymentList.next(result);
            return result;
        });
    };
    PaymentStore.prototype.loadPaymentsByParty = function (eventId, eventPartyId) {
        var _this = this;
        return this.paymentHttpService.getPaymentsByParty(eventId, eventPartyId)
            .catch(function (error) {
            _this.flashMessagesService.error(_this.translateService.instant('MESSAGES.ERROR.GET_PAYMENTS'));
            _this.logService.error("Error adding Payment: " + error);
            return Observable["Observable"].throw(error);
        })
            .map(function (result) {
            _this.paymentList.next(result);
            return result;
        });
    };
    PaymentStore.prototype.loadLatestFinalPayment = function (eventId) {
        var _this = this;
        return this.paymentHttpService.getLatestVendorFinalPayment(eventId).catch(function (error) {
            _this.flashMessagesService.error(_this.translateService.instant('MESSAGES.ERROR.GET_LATEST_PAYMENT'));
            _this.logService.error("Error getting last Payments: " + error);
            return Observable["Observable"].throw(error);
        }).map(function (payments) {
            // This subject may include REQUEST_REJECTED payments
            _this.latestVendorFinalPayments.next(payments);
            // Filter out REQUEST_REJECTED payments for latestFinalPayment
            var filteredPayments = _this.filterNonRequestRejectedPayments(payments);
            if (filteredPayments && filteredPayments.length === 1) {
                _this.latestFinalPayment.next(filteredPayments[0]);
            }
            else {
                _this.latestFinalPayment.next(null);
            }
            return payments;
        });
    };
    PaymentStore.prototype.loadLatestFinalPaymentByParty = function (eventId, eventPartyId) {
        var _this = this;
        return this.paymentHttpService.getLatestVendorFinalPaymentByParty(eventId, eventPartyId).catch(function (error) {
            _this.flashMessagesService.error(_this.translateService.instant('MESSAGES.ERROR.GET_LATEST_PAYMENT'));
            _this.logService.error("Error getting last Payments: " + error);
            return Observable["Observable"].throw(error);
        }).map(function (payments) {
            // This subject may include REQUEST_REJECTED payments
            _this.latestVendorFinalPayments.next(payments);
            // Filter out REQUEST_REJECTED payments for latestFinalPayment
            var filteredPayments = _this.filterNonRequestRejectedPayments(payments);
            _this.latestFinalPayment.next(null);
            if (filteredPayments && filteredPayments.length === 1) {
                _this.latestFinalPayment.next(filteredPayments[0]);
            }
            return payments;
        });
    };
    Object.defineProperty(PaymentStore.prototype, "commissionTotal", {
        get: function () {
            var _this = this;
            return this.payments.map(function (payments) {
                return payments
                    .filter(function (payment) { return !_this.isPaymentRejected(payment); })
                    .map(function (payment) { return payment.commissionAmount; })
                    .reduce(function (prev, current) { return !!current ? prev + current : prev; }, 0);
            });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PaymentStore.prototype, "containsRejectedPayments", {
        get: function () {
            var _this = this;
            return this.payments.map(function (payments) { return payments.some(_this.isPaymentRejected); });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PaymentStore.prototype, "currentPayment", {
        /**
         * Gets the payment with the latest created date
         */
        get: function () {
            return this.payments.map(function (list) {
                return list.max(function (payment1, payment2) {
                    if (payment1.createdDate < payment2.createdDate) {
                        return -1;
                    }
                    else if (payment1.createdDate > payment2.createdDate) {
                        return 1;
                    }
                    else {
                        return 0;
                    }
                });
            });
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Gets the payment with the latest created date
     */
    PaymentStore.prototype.getVendorCurrentPayment = function (eventPartyId) {
        return this.getVendorPayments(eventPartyId)
            .map(function (payments) { return payments.filter(function (payment) { return payment.eventPartyId === eventPartyId; }); })
            .map(function (list) {
            return list.max(function (payment1, payment2) {
                if (payment1.createdDate < payment2.createdDate) {
                    return -1;
                }
                else if (payment1.createdDate > payment2.createdDate) {
                    return 1;
                }
                else {
                    return 0;
                }
            });
        });
    };
    Object.defineProperty(PaymentStore.prototype, "isCurrentPaymentValid", {
        /**
         * Returns true if the current payment exists and does not have a rejected or error status
         * @returns {Observable<R>}
         */
        get: function () {
            var _this = this;
            return this.currentPayment.map(function (lastPayment) {
                return !!lastPayment && !_this.isPaymentRejected(lastPayment);
            });
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns true if the current vendor payment exists and does not have a rejected or error status
     * @returns {Observable<R>}
     */
    PaymentStore.prototype.isCurrentVendorPaymentValid = function (eventPartyId) {
        var _this = this;
        return this.getVendorCurrentPayment(eventPartyId).map(function (lastPayment) {
            return !!lastPayment && !_this.isPaymentRejected(lastPayment);
        });
    };
    PaymentStore.prototype.isVendorPaymentError = function (eventPartyId) {
        return this.getVendorCurrentPayment(eventPartyId).map(function (lastPayment) {
            return !!lastPayment && payment_status_utils_PaymentStatusUtils.isError(lastPayment.status);
        });
    };
    PaymentStore.prototype.isPaymentRejected = function (payment) {
        if (payment) {
            return payment_status_utils_PaymentStatusUtils.isError(payment.status) || payment.status === PaymentStatus.REQUEST_REJECTED;
        }
        else {
            return false;
        }
    };
    PaymentStore.prototype.isLastVendorPaymentRequested = function (eventPartyId) {
        var _this = this;
        return this.getVendorCurrentPayment(eventPartyId).map(function (lastPayment) {
            return lastPayment && _this.isPaymentRequested(lastPayment);
        });
    };
    PaymentStore.prototype.isLastVendorPaymentPayRejected = function (eventPartyId) {
        var _this = this;
        return this.getVendorCurrentPayment(eventPartyId).map(function (lastPayment) {
            return lastPayment && _this.isPaymentPayRejected(lastPayment);
        });
    };
    PaymentStore.prototype.isPaymentRequested = function (payment) {
        return payment_status_utils_PaymentStatusUtils.isError(payment.status) || payment.status === PaymentStatus.REQUESTED;
    };
    Object.defineProperty(PaymentStore.prototype, "isLastPaymentRequestedOrRequestResentOrRequestRejected", {
        get: function () {
            var _this = this;
            return this.currentPayment.map(function (lastPayment) {
                return lastPayment && (_this.isPaymentRequested(lastPayment)
                    || _this.isPaymentRequestResent(lastPayment)
                    || _this.isPaymentRejected(lastPayment));
            });
        },
        enumerable: true,
        configurable: true
    });
    PaymentStore.prototype.isLastVendorPaymentRequestedOrRequestResentOrRequestRejected = function (eventPartyId) {
        var _this = this;
        return this.getVendorCurrentPayment(eventPartyId).map(function (lastPayment) {
            return lastPayment && (_this.isPaymentRequested(lastPayment)
                || _this.isPaymentRequestResent(lastPayment)
                || _this.isPaymentRejected(lastPayment));
        });
    };
    PaymentStore.prototype.isRequestedOrResentRequestOrRequestRejectedOrError = function (paymentSummary) {
        var statuses = [
            PaymentStatus.REQUESTED,
            PaymentStatus.RESENT_REQUEST,
            PaymentStatus.REQUEST_REJECTED
        ];
        return paymentSummary && (payment_status_utils_PaymentStatusUtils.isError(paymentSummary.paymentStatus)
            || statuses.some(function (status) { return status === paymentSummary.paymentStatus; }));
    };
    Object.defineProperty(PaymentStore.prototype, "isEventLockdown", {
        get: function () {
            var _this = this;
            return this.currentPayment.map(function (lastPayment) {
                return lastPayment && _this.isThisEventLockdown(lastPayment);
            });
        },
        enumerable: true,
        configurable: true
    });
    PaymentStore.prototype.isEventPropertyLockdown = function (eventPartyId) {
        var _this = this;
        return this.getVendorCurrentPayment(eventPartyId).map(function (lastPayment) {
            return lastPayment && _this.isThisEventLockdown(lastPayment);
        });
    };
    PaymentStore.prototype.isPaymentRequestResent = function (payment) {
        return payment_status_utils_PaymentStatusUtils.isError(payment.status) || payment.status === PaymentStatus.RESENT_REQUEST;
    };
    PaymentStore.prototype.isThisEventLockdown = function (payment) {
        return payment_status_utils_PaymentStatusUtils.isEditable(payment.status);
    };
    PaymentStore.prototype.isPaymentRequestedOrRequestResent = function (payment) {
        return payment_status_utils_PaymentStatusUtils.isError(payment.status)
            || payment.status === PaymentStatus.REQUESTED
            || payment.status === PaymentStatus.RESENT_REQUEST;
    };
    PaymentStore.prototype.isPaymentPayRejected = function (payment) {
        return payment.status === PaymentStatus.PAY_REJECTED;
    };
    PaymentStore.prototype.getPrepayment = function () {
        return this.latestPrepayment.asObservable();
    };
    PaymentStore.prototype.getLatestVendorPrepayments = function () {
        return this.latestVendorPrepayments.asObservable();
    };
    PaymentStore.prototype.getLatestVendorPrepaymentsList = function () {
        return this.latestVendorPrepaymentsList.asObservable();
    };
    PaymentStore.prototype.getVendorPrepayment = function (eventPartyId) {
        return this.latestVendorPrepayments
            .map(function (payments) { return payments != null ? payments.filter(function (payment) { return payment.eventPartyId === eventPartyId; })[0] : null; });
    };
    PaymentStore.prototype.loadLatestPrepayment = function (eventId) {
        var _this = this;
        return this.paymentHttpService.getLatestVendorPrepayments(eventId)
            .catch(function (error) {
            _this.flashMessagesService.error(_this.translateService.instant('MESSAGES.ERROR.GET_PREPAYMENT'));
            _this.logService.error("Error getting Prepayments: " + error);
            return Observable["Observable"].throw(error);
        })
            .map(function (payments) {
            _this.latestVendorPrepayments.next(payments);
            if (!payments || payments.length === 0) {
                _this.latestPrepayment.next(null);
            }
            if (payments && payments.length === 1) {
                _this.latestPrepayment.next(payments[0]);
            }
            else {
                _this.latestPrepayment.next(null);
            }
            return payments;
        });
    };
    PaymentStore.prototype.loadLatestPrepaymentByParty = function (eventId, eventPartyId) {
        var _this = this;
        return this.paymentHttpService.getLatestVendorPrepaymentsByParty(eventId, eventPartyId)
            .catch(function (error) {
            _this.flashMessagesService.error(_this.translateService.instant('MESSAGES.ERROR.GET_PREPAYMENT'));
            _this.logService.error("Error getting Prepayments: " + error);
            return Observable["Observable"].throw(error);
        })
            .map(function (payments) {
            _this.latestVendorPrepayments.next(payments);
            if (!payments || payments.length === 0) {
                _this.latestPrepayment.next(null);
            }
            if (payments && payments.length === 1) {
                _this.latestPrepayment.next(payments[0]);
            }
            else {
                _this.latestPrepayment.next(null);
            }
            return payments;
        });
    };
    PaymentStore.prototype.loadLatestPrepaymentList = function (eventId) {
        var _this = this;
        return this.paymentHttpService.getLatestVendorPrepayments(eventId)
            .catch(function (error) {
            _this.flashMessagesService.error(_this.translateService.instant('MESSAGES.ERROR.GET_PREPAYMENT'));
            _this.logService.error("Error getting Prepayments: " + error);
            return Observable["Observable"].throw(error);
        })
            .map(function (payments) {
            _this.latestVendorPrepaymentsList.next(payments);
            return payments;
        });
    };
    PaymentStore.prototype.loadFinalPaymentStatusList = function (eventId) {
        var _this = this;
        return this.paymentHttpService.getFinalPaymentStatusList(eventId).catch(function (error) {
            _this.flashMessagesService.error(_this.translateService.instant('MESSAGES.ERROR.GET_FINAL_PAYMENT_STATUS'));
            _this.logService.error("Error getting list of final payment status: " + error);
            return Observable["Observable"].throw(error);
        }).map(function (result) {
            _this.finalPaymentStatusList.next(result);
            return result;
        });
    };
    PaymentStore.prototype.loadFinalPaymentStatusListByParty = function (eventId, eventPartyId) {
        var _this = this;
        return this.paymentHttpService.getFinalPaymentStatusListByParty(eventId, eventPartyId).catch(function (error) {
            _this.flashMessagesService.error(_this.translateService.instant('MESSAGES.ERROR.GET_FINAL_PAYMENT_STATUS'));
            _this.logService.error("Error getting list of final payment status: " + error);
            return Observable["Observable"].throw(error);
        }).map(function (result) {
            _this.finalPaymentStatusList.next(result);
            return result;
        });
    };
    PaymentStore.prototype.getFinalPaymentStatusList = function () {
        return this.finalPaymentStatusList.asObservable();
    };
    PaymentStore.prototype.getVendorFinalPaymentStatusList = function (eventPartyId) {
        return this.finalPaymentStatusList
            .map(function (payments) { return payments != null ? payments.filter(function (payment) { return payment.eventPartyId === eventPartyId; }) : null; });
    };
    PaymentStore.prototype.resendPaymentRequest = function (eventId) {
        var _this = this;
        return this.paymentHttpService.resendPaymentRequest(eventId).catch(function (error) {
            _this.logService.error("Error resending payment request: " + error);
            return Observable["Observable"].throw(error);
        }).map(function (result) {
            _this.loadLatestFinalPayment(eventId).take(1).subscribe();
            _this.loadFinalPaymentStatusList(eventId).take(1).subscribe();
            return result;
        });
    };
    PaymentStore.prototype.getCurrentPayment = function (eventPartyId) {
        var _this = this;
        return this.getVendorInitialPayment(eventPartyId).flatMap(function (initialPayment) {
            return _this.getVendorFinalPayment(eventPartyId).map(function (finalPayment) {
                return finalPayment ? finalPayment : (initialPayment ? initialPayment : null);
            });
        });
    };
    PaymentStore.prototype.loadLatestInitialPaymentByParty = function (eventId, eventPartyId) {
        var _this = this;
        return this.paymentHttpService.getLatestInitialPaymentsByParty(eventId, eventPartyId).catch(function (error) {
            _this.flashMessagesService.error(_this.translateService.instant('MESSAGES.ERROR.GET_LATEST_PAYMENT'));
            _this.logService.error("Error getting latest initial Payment by party: " + error);
            return Observable["Observable"].throw(error);
        }).map(function (payments) {
            _this.latestInitialPayments.next(payments);
            _this.latestVendorInitialPayment.next(null);
            if (payments && payments.length === 1) {
                _this.latestVendorInitialPayment.next(payments[0]);
            }
            return payments;
        });
    };
    PaymentStore.prototype.loadLatestInitialPayments = function (eventId) {
        var _this = this;
        return this.paymentHttpService.getLatestInitialPayments(eventId)
            .catch(function (error) {
            _this.flashMessagesService.error(_this.translateService.instant('MESSAGES.ERROR.GET_LATEST_PAYMENT'));
            _this.logService.error("Error getting latest initial payments: " + error);
            return Observable["Observable"].throw(error);
        })
            .map(function (payments) {
            _this.latestInitialPayments.next(payments);
            _this.latestVendorInitialPayment.next(null);
            if (payments && payments.length === 1) {
                _this.latestVendorInitialPayment.next(payments[0]);
            }
            return payments;
        });
    };
    PaymentStore.prototype.getVendorInitialPayment = function (eventPartyId) {
        return this.latestInitialPayments.pipe(Object(operators["map"])(function (payments) {
            if (payments) {
                return payments.find(function (payment) { return payment.eventPartyId === eventPartyId; });
            }
            return null;
        }));
    };
    PaymentStore.prototype.updateForecastedCommissionAmount = function (payment) {
        var _this = this;
        return this.paymentHttpService.updateForecastedCommissionAmount(payment).pipe(Object(operators["catchError"])(function (error) {
            _this.flashMessagesService.error('MESSAGES.ERROR.UPDATE_FORECASTED_COMMISSION_AMOUNT', "Error updating Forecasted Commission Amount: " + error);
            return Observable["Observable"].throw(error);
        }), Object(operators["tap"])(function () {
            _this.logService.info('Forecasted Commission Amount was updated successfully');
            _this.flashMessagesService.success('EVENT.COMMISSION.FORECASTED_COMMISSION_UPDATED');
        }));
    };
    PaymentStore.prototype.withdrawPaymentRequest = function (eventId, eventPartyId) {
        var _this = this;
        return this.paymentHttpService.withdrawPaymentRequest(eventId, eventPartyId)
            .catch(function (error) {
            _this.logService.error("Error withdrawing payment request. Event ID: " + eventId + ". Event Party ID: " + eventPartyId + ". Error: " + error);
            return Observable["Observable"].throw(error);
        });
    };
    PaymentStore.prototype.updateCalculatedPaymentWithTax = function (eventPartyId, calculatedPaymentWithTax) {
        this._calculatedPaymentWithTaxByEventPartyId.set(eventPartyId, calculatedPaymentWithTax);
        this._calculatedPaymentWithTaxByEventPartyId$.next(this._calculatedPaymentWithTaxByEventPartyId);
    };
    PaymentStore.prototype.getCalculatedPaymentWithTax = function (eventPartyId) {
        return this._calculatedPaymentWithTaxByEventPartyId$.map(function (calculatedPaymentWithTaxByEventPartyId) {
            return calculatedPaymentWithTaxByEventPartyId.get(eventPartyId);
        });
    };
    PaymentStore.prototype.resetCalculatedPaymentWithTaxByEventPartyId = function () {
        this._calculatedPaymentWithTaxByEventPartyId.clear();
        this._calculatedPaymentWithTaxByEventPartyId$.next(this._calculatedPaymentWithTaxByEventPartyId);
    };
    PaymentStore.prototype.bulkActionPayments = function (payments) {
        var _this = this;
        return this.paymentHttpService.bulkPayments(payments)
            .catch(function (error) {
            return Observable["Observable"].throw(error);
        }).pipe(Object(operators["tap"])(function () {
            var eventPartyIds = payments.map(function (p) { return p.eventPartyId; });
            var eventPartyIdSet = new Set(eventPartyIds.filter(function (id) { return !!id; }));
            _this.paymentSummaryStore.reloadPaymentSummary(eventPartyIdSet)
                .take(1)
                .subscribe();
        }), Object(operators["map"])(function (result) {
            var updatedResult = [];
            result.forEach(function (response) {
                if (response.error) {
                    _this.logService.info("Error processing payment: " + response.error);
                    if (response.error.includes('Unable to request final payment')) {
                        updatedResult.push(payment_store___assign({}, response, { error: _this.translateService.instant('MESSAGES.ERROR.OOIV_HEALTH') }));
                    }
                    else if (response.error.includes('Legal Entity data for agency')) {
                        updatedResult.push(payment_store___assign({}, response, { error: _this.translateService.instant('MESSAGES.ERROR.MISSING_LEGAL_ENTITY_AGENCY') }));
                    }
                    else if (response.error.includes('Legal Entity data for vendor')) {
                        updatedResult.push(payment_store___assign({}, response, { error: _this.translateService.instant('MESSAGES.ERROR.MISSING_LEGAL_ENTITY_VENDOR') }));
                    }
                    else if (response.error.includes('Invalid Tax ID')) {
                        updatedResult.push(payment_store___assign({}, response, { error: _this.translateService.instant('MESSAGES.ERROR.INVALID_VAT_ID') }));
                    }
                    else {
                        updatedResult.push(payment_store___assign({}, response, { error: _this.translateService.instant('MESSAGES.ERROR.ADD_PAYMENT') }));
                    }
                }
            });
            return updatedResult;
        }));
    };
    PaymentStore.prototype.addPaymentHelper = function (payment) {
        var obs;
        if (payment.type && this.addPaymentStatuses.some(function (type) { return type === payment.type; })) {
            obs = this.paymentHttpService.add(payment);
        }
        else {
            obs = this.paymentHttpService.request(payment);
        }
        return obs.pipe(this.reloadPaymentSummaryOnTap(payment));
    };
    PaymentStore.prototype.updatePaymentHelper = function (payment) {
        var obs;
        if (payment.type && this.addPaymentStatuses.some(function (type) { return type === payment.type; })) {
            obs = this.paymentHttpService.update(payment);
        }
        else {
            obs = this.paymentHttpService.request(payment);
        }
        return obs.pipe(this.reloadPaymentSummaryOnTap(payment));
    };
    PaymentStore.prototype.reloadPaymentSummaryOnTap = function (payment) {
        var _this = this;
        return Object(operators["tap"])(function () { return _this.paymentSummaryStore.reloadPaymentSummary(payment.eventPartyId)
            .take(1)
            .subscribe(); });
    };
    return PaymentStore;
}());
payment_store_PaymentStore = payment_store___decorate([
    Object(core_es5["Injectable"])(),
    payment_store___metadata("design:paramtypes", [typeof (payment_store__a = typeof payment_http_service_PaymentHttpService !== "undefined" && payment_http_service_PaymentHttpService) === "function" && payment_store__a || Object, typeof (payment_store__b = typeof log_service_LogService !== "undefined" && log_service_LogService) === "function" && payment_store__b || Object, typeof (payment_store__c = typeof flash_messages_service_FlashMessagesService !== "undefined" && flash_messages_service_FlashMessagesService) === "function" && payment_store__c || Object, typeof (payment_store__d = typeof core["c" /* TranslateService */] !== "undefined" && core["c" /* TranslateService */]) === "function" && payment_store__d || Object, typeof (payment_store__e = typeof payment_summary_store_PaymentSummaryStore !== "undefined" && payment_summary_store_PaymentSummaryStore) === "function" && payment_store__e || Object])
], payment_store_PaymentStore);

var payment_store__a, payment_store__b, payment_store__c, payment_store__d, payment_store__e;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/payment.store.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/service/reservation-http-service.ts
var reservation_http_service___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var reservation_http_service___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};








var reservation_http_service_ReservationService = (function () {
    function ReservationService(http, environment, responseUtilService) {
        this.http = http;
        this.environment = environment;
        this.responseUtilService = responseUtilService;
        this.eventUrl = this.environment.baseUrl + '/api/events';
    }
    ReservationService.prototype.get = function (eventId) {
        var _this = this;
        var reservationUrl = this.eventUrl + "/" + eventId + "/reservations/consumed";
        return this.http.get(reservationUrl)
            .map(function (res) { return Object(immutable["List"])(res.json()); })
            .catch(function (response) { return _this.responseUtilService.handleError(response); }).share();
    };
    ReservationService.prototype.getByParty = function (eventId, eventPartyId) {
        var _this = this;
        var reservationUrl = this.eventUrl + "/" + eventId + "/" + eventPartyId + "/reservations/consumed";
        return this.http.get(reservationUrl)
            .map(function (res) { return Object(immutable["List"])(res.json()); })
            .catch(function (response) { return _this.responseUtilService.handleError(response); }).share();
    };
    ReservationService.prototype.add = function (reservation, source) {
        var _this = this;
        var result;
        var headers = new http_es5["Headers"]({ 'Content-Type': 'application/json' });
        var options = new http_es5["RequestOptions"]({ headers: headers });
        var reservationAsJSON = JSON.stringify(reservation.toJS());
        var endpoint;
        switch (source) {
            case EventReservationSource.MANUAL:
                endpoint = this.eventUrl + "/reservations/add";
                break;
            case EventReservationSource.RSVP:
                endpoint = this.eventUrl + "/reservations/from-rsvp/add";
                break;
            default:
                break;
        }
        if (!endpoint) {
            result = Observable["Observable"].throw('The source received (' + source + ') is not supported.');
        }
        else {
            result = this.http.post(endpoint, reservationAsJSON, options)
                .catch(function (response) { return _this.responseUtilService.handleError(response); })
                .share();
        }
        return result;
    };
    ReservationService.prototype.delete = function (reservation) {
        var _this = this;
        return this.http.delete(this.eventUrl + "/reservations/" + reservation.eventReservationId)
            .catch(function (response) { return _this.responseUtilService.handleError(response); }).share();
    };
    ReservationService.prototype.update = function (reservation) {
        var _this = this;
        var result;
        var headers = new http_es5["Headers"]({ 'Content-Type': 'application/json' });
        var options = new http_es5["RequestOptions"]({ headers: headers });
        var reservationAsJSON = JSON.stringify(reservation.toJS());
        result = this.http.put(this.eventUrl + "/reservations/", reservationAsJSON, options)
            .catch(function (response) { return _this.responseUtilService.handleError(response); }).share();
        return result;
    };
    ReservationService.prototype.importReservationFile = function (eventId, eventPartyId, file) {
        var _this = this;
        var formData = new FormData();
        formData.append('file', file);
        return this.http.post(this.eventUrl + "/" + eventId + "/" + eventPartyId + "/reservations/import", formData)
            .catch(function (response) { return _this.responseUtilService.handleError(response); }).share();
    };
    ReservationService.prototype.getReservationsByStatus = function (eventId, statusCodes, page, size) {
        var url = this.eventUrl + "/" + eventId + "/reservations-by-status?page=" + page + "&size=" + size;
        var request = {
            eventId: eventId,
            statusCodes: Array.from(statusCodes)
        };
        return this.httpPost(url, request).map(function (reservationPage) {
            reservationPage.content = Object(immutable["List"])(reservationPage.content);
            return reservationPage;
        });
    };
    ReservationService.prototype.getReservationsByStatusByParty = function (eventId, eventPartyId, statusCodes, page, size) {
        var url = this.eventUrl + "/" + eventId + "/" + eventPartyId + "/reservations-by-status?page=" + page + "&size=" + size;
        var request = {
            eventId: eventId,
            eventPartyId: eventPartyId,
            statusCodes: Array.from(statusCodes)
        };
        return this.httpPost(url, request).map(function (reservationPage) {
            reservationPage.content = Object(immutable["List"])(reservationPage.content);
            return reservationPage;
        });
    };
    ReservationService.prototype.httpPost = function (url, request) {
        var _this = this;
        var options = new http_es5["RequestOptions"]({ headers: new http_es5["Headers"]({ 'Content-Type': 'application/json' }) });
        return this.http.post(url, JSON.stringify(request), options)
            .map(function (response) { return response.json(); })
            .catch(function (error) { return _this.responseUtilService.handleError(error); })
            .share();
    };
    return ReservationService;
}());
reservation_http_service_ReservationService = reservation_http_service___decorate([
    Object(core_es5["Injectable"])(),
    reservation_http_service___metadata("design:paramtypes", [typeof (reservation_http_service__a = typeof AppAuthHttpService !== "undefined" && AppAuthHttpService) === "function" && reservation_http_service__a || Object, typeof (reservation_http_service__b = typeof EnvironmentConfiguration !== "undefined" && EnvironmentConfiguration) === "function" && reservation_http_service__b || Object, typeof (reservation_http_service__c = typeof response_util_service_ResponseUtilService !== "undefined" && response_util_service_ResponseUtilService) === "function" && reservation_http_service__c || Object])
], reservation_http_service_ReservationService);

var reservation_http_service__a, reservation_http_service__b, reservation_http_service__c;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/reservation-http-service.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/transaction.ts
var transaction___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var TransactionRecord = Object(immutable["Record"])({
    eventId: null,
    firstName: null,
    lastName: null,
    roomRate: null,
    roomRateCurrency: null,
    checkInDate: null,
    checkOutDate: null,
    roomType: null,
    confirmation: null,
    nights: null,
    revenue: null,
    commission: null,
    commissionPercentage: null,
    eventReservationId: null,
    status: null,
    source: null,
    eventRsvpId: null,
    chainCode: null,
    brandCode: null,
    property: null,
    ratePlanCode: null,
    paymentRecordNumber: null,
    rooms: null,
    roomNights: null,
    groupCode: null,
    payViaGp: true,
    eventPaymentId: null,
    eventPartyId: null
});
var Transaction = (function (_super) {
    transaction___extends(Transaction, _super);
    function Transaction() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Transaction;
}(TransactionRecord));

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/transaction.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/reservation.ts
var reservation___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var Reservation = (function (_super) {
    reservation___extends(Reservation, _super);
    function Reservation() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Reservation;
}(Transaction));

var TransientReservation = (function (_super) {
    reservation___extends(TransientReservation, _super);
    function TransientReservation() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return TransientReservation;
}(Reservation));

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/reservation.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/link-reservation-request.ts
var link_reservation_request___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var LinkReservationRequestRecord = Object(immutable["Record"])({
    eventReservationIdList: null,
    payViaGp: true,
    eventPartyId: null
});
var LinkReservationRequest = (function (_super) {
    link_reservation_request___extends(LinkReservationRequest, _super);
    function LinkReservationRequest() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return LinkReservationRequest;
}(LinkReservationRequestRecord));

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/link-reservation-request.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/unlink-reservation-request.ts
var unlink_reservation_request___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var UnlinkReservationRequestRecord = Object(immutable["Record"])({
    eventReservationId: null,
    eventId: null,
});
var UnlinkReservationRequest = (function (_super) {
    unlink_reservation_request___extends(UnlinkReservationRequest, _super);
    function UnlinkReservationRequest() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return UnlinkReservationRequest;
}(UnlinkReservationRequestRecord));

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/unlink-reservation-request.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/service/transient-reservation-http-service.ts
var transient_reservation_http_service___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var transient_reservation_http_service___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};








var transient_reservation_http_service_TransientReservationService = (function () {
    function TransientReservationService(http, environment, responseUtilService) {
        this.http = http;
        this.environment = environment;
        this.responseUtilService = responseUtilService;
        this.eventUrl = this.environment.baseUrl + '/api/events';
    }
    TransientReservationService.prototype.search = function (searchParameters, page, size) {
        var _this = this;
        var headers = new http_es5["Headers"]({ 'Content-Type': 'application/json' });
        var options = new http_es5["RequestOptions"]({ headers: headers }); // Create a request option
        var reservationAsJSON = JSON.stringify(searchParameters.toJS());
        return this.http.post(this.eventUrl + "/transient/reservations/search?page=" + page + "&size=" + size, reservationAsJSON, options)
            .map(function (response) { return response.json(); })
            .catch(function (response) { return _this.responseUtilService.handleError(response); })
            .share();
    };
    TransientReservationService.prototype.linkTransientReservationsToEvent = function (eventReservationIdList, eventPartyId, doNotPay) {
        var _this = this;
        var headers = new http_es5["Headers"]({ 'Content-Type': 'application/json' });
        var options = new http_es5["RequestOptions"]({ headers: headers });
        var request = new LinkReservationRequest({
            eventReservationIdList: eventReservationIdList,
            payViaGp: doNotPay ? false : true,
            eventPartyId: eventPartyId
        });
        var requestAsJSON = JSON.stringify(request);
        var result = this.http.post(this.eventUrl + "/transient/reservations/link-to-event", requestAsJSON, options)
            .catch(function (response) { return _this.responseUtilService.handleError(response); })
            .share();
        return result;
    };
    TransientReservationService.prototype.unlinkTransientReservation = function (eventReservationId, eventId) {
        var _this = this;
        var result;
        var headers = new http_es5["Headers"]({ 'Content-Type': 'application/json' });
        var options = new http_es5["RequestOptions"]({ headers: headers });
        var request = new UnlinkReservationRequest({
            eventReservationId: eventReservationId,
            eventId: eventId
        });
        var requestAsJSON = JSON.stringify(request);
        result = this.http.post(this.eventUrl + "/transient/reservations/unlink", requestAsJSON, options)
            .map(function (response) { return new Reservation(response); })
            .catch(function (response) { return _this.responseUtilService.handleError(response); })
            .share();
        return result;
    };
    return TransientReservationService;
}());
transient_reservation_http_service_TransientReservationService = transient_reservation_http_service___decorate([
    Object(core_es5["Injectable"])(),
    transient_reservation_http_service___metadata("design:paramtypes", [typeof (transient_reservation_http_service__a = typeof AppAuthHttpService !== "undefined" && AppAuthHttpService) === "function" && transient_reservation_http_service__a || Object, typeof (transient_reservation_http_service__b = typeof EnvironmentConfiguration !== "undefined" && EnvironmentConfiguration) === "function" && transient_reservation_http_service__b || Object, typeof (transient_reservation_http_service__c = typeof response_util_service_ResponseUtilService !== "undefined" && response_util_service_ResponseUtilService) === "function" && transient_reservation_http_service__c || Object])
], transient_reservation_http_service_TransientReservationService);

var transient_reservation_http_service__a, transient_reservation_http_service__b, transient_reservation_http_service__c;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/transient-reservation-http-service.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/room-stay-summary.ts
var room_stay_summary___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var RoomStaySummaryRecord = Object(immutable["Record"])({
    roomTypeRateSummaryList: null,
    staySummary: null
});
var RoomStaySummary = (function (_super) {
    room_stay_summary___extends(RoomStaySummary, _super);
    function RoomStaySummary() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return RoomStaySummary;
}(RoomStaySummaryRecord));

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/room-stay-summary.js.map
// EXTERNAL MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/node_modules/decimal.js/decimal.js
var decimal = __webpack_require__("W0bb");
var decimal_default = /*#__PURE__*/__webpack_require__.n(decimal);

// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/room-type-rate-summary.ts
var room_type_rate_summary___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var RoomTypeRateSummaryRecord = Object(immutable["Record"])({
    roomType: null,
    roomRate: null,
    totalNights: 0,
    totalRevenue: 0,
    totalCommission: 0,
    totalCommissionableRevenue: new decimal_default.a(0),
    commissionPercentage: 0,
});
var RoomTypeRateSummary = (function (_super) {
    room_type_rate_summary___extends(RoomTypeRateSummary, _super);
    function RoomTypeRateSummary() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return RoomTypeRateSummary;
}(RoomTypeRateSummaryRecord));

/**
 * RoomTypeRateSummary has multiple fields
 * This method defines sort algorithm for List<RoomTypeRateSummary>
 *
 * 1. Sort by room type. e.g king, queen, etc
 * 2. If room types are equal:
 *    - Sort by room rate
 *
 * Returns a number bc that is what is used for immutable-js list sort
 *
 * immutable-js List sort()
 * https://facebook.github.io/immutable-js/docs/#/List/sort
 *
 * @param a {RoomTypeRateSummary}
 * @param b {RoomTypeRateSummary}
 * @returns number
 */
var RoomTypeRateSummarySort = function (a, b) {
    var aRoomType = a.roomType ? a.roomType : '';
    var otherRoomType = b.roomType ? b.roomType : '';
    // check if roomType is equal
    var result = aRoomType.localeCompare(otherRoomType);
    if (result !== 0) {
        return result;
    }
    // fallback: sort by roomRate and cast to number for
    // immutable-js sort
    return a.roomRate < b.roomRate ? -1 : 1;
};
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/room-type-rate-summary.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/stay-summary.ts
var stay_summary___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var StaySummaryRecord = Object(immutable["Record"])({
    totalNights: 0,
    totalRevenue: 0,
    avgRoomRate: 0,
    totalItems: 0,
    totalCommission: 0
});
var StaySummary = (function (_super) {
    stay_summary___extends(StaySummary, _super);
    function StaySummary() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return StaySummary;
}(StaySummaryRecord));

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/stay-summary.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/utils/math-utils.ts

var math_utils_MathUtils = (function () {
    function MathUtils() {
    }
    MathUtils.roundDecimalCurrencyToCents = function (amount) {
        if (amount === null || amount === undefined) {
            return new decimal_default.a(0);
        }
        return amount.toDecimalPlaces(2, decimal_default.a.ROUND_HALF_UP);
    };
    return MathUtils;
}());

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/math-utils.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/utils/transaction-utils.ts






var transaction_utils_TransactionUtils = (function () {
    function TransactionUtils() {
    }
    /**
     * Transforms a list of transactions (Reservation or RSVP) into a RoomStaySummary object
     * Contains a stay summary and a room summary
     *
     * Immutable JS doc on groupBy
     * https://facebook.github.io/immutable-js/docs/#/List/groupBy
     *
     * @param transactions {List}
     * @param translateService {TranslateService}
     * @returns RoomStaySummary
     */
    TransactionUtils.transformTransactionsToSummary = function (transactions, translateService) {
        var roomTypeRateSummaryList = Object(immutable["List"])([]);
        // create lists of Reservations grouped by type and rate
        var listOfTransactionsGroupedByTypeAndRate = Object(immutable["List"])([]);
        // this has to be re-created as a list or else groupBy is not available
        Object(immutable["List"])(transactions).groupBy(function (roomTypeGroup) { return roomTypeGroup.roomType; })
            .forEach(function (roomTypeGroup) {
            roomTypeGroup
                .groupBy(function (roomRateGroup) { return roomRateGroup.roomRate; })
                .forEach(function (roomRateGroup) {
                listOfTransactionsGroupedByTypeAndRate = listOfTransactionsGroupedByTypeAndRate.push(roomRateGroup.toList());
            });
        });
        // iterate through each list to calculate aggregations (grouped by type and rate)
        var totalNights = 0;
        var totalRevenue = new decimal_default.a(0);
        var totalCommission = new decimal_default.a(0);
        var totalCommissionableRevenue = new decimal_default.a(0);
        var commissionPercentage = undefined;
        listOfTransactionsGroupedByTypeAndRate.forEach(function (roomTypeAndRateGroup) {
            var roomTypeRateSummary = TransactionUtils.transformTransactionListToRoomSummary(roomTypeAndRateGroup, translateService);
            // sum total nights, total revenue and totalCommission
            totalNights = totalNights + roomTypeRateSummary.totalNights;
            totalRevenue = totalRevenue.add(roomTypeRateSummary.totalRevenue);
            totalCommission = totalCommission.add(roomTypeRateSummary.totalCommission);
            // adding room type and rate summary to list
            roomTypeRateSummaryList = roomTypeRateSummaryList.push(roomTypeRateSummary);
            totalCommissionableRevenue = totalCommissionableRevenue.add(roomTypeRateSummary.totalCommissionableRevenue);
            commissionPercentage = roomTypeRateSummary.commissionPercentage;
        });
        totalCommission = math_utils_MathUtils.roundDecimalCurrencyToCents(totalCommission);
        totalRevenue = math_utils_MathUtils.roundDecimalCurrencyToCents(totalRevenue);
        // Calculate avgRoomRate: totalRevenue / totalNights
        var avgRoomRate = new decimal_default.a(0);
        if (totalNights > 0) {
            avgRoomRate = totalRevenue.div(totalNights);
            avgRoomRate = math_utils_MathUtils.roundDecimalCurrencyToCents(avgRoomRate);
        }
        // Generate a room summary
        var staySummary = new StaySummary({
            totalNights: totalNights,
            totalRevenue: totalRevenue.toNumber(),
            avgRoomRate: avgRoomRate.toNumber(),
            totalItems: transactions.size,
            totalCommission: totalCommission.toNumber()
        });
        // build the room stay Summary
        return new RoomStaySummary({
            roomTypeRateSummaryList: roomTypeRateSummaryList.sort(RoomTypeRateSummarySort).toList(),
            staySummary: staySummary
        });
    };
    /**
     * Transforms a list of transactions into a RoomTypeRateSummary
     *
     * @param roomList {List}
     * @param translateService {TranslateService}
     * @returns RoomTypeRateSummary
     */
    TransactionUtils.transformTransactionListToRoomSummary = function (roomList, translateService) {
        var _this = this;
        var roomType = '';
        var roomRate = new decimal_default.a(0);
        var commissionPercentage = undefined;
        var totalNights = 0;
        var totalRevenue = new decimal_default.a(0);
        var totalCommission = new decimal_default.a(0);
        var totalCommissionableRevenue = new decimal_default.a(0); // totalCommissionableRevenue is the sum of all room revenues that are paid via GP
        roomList.forEach(function (room) {
            roomType = room.roomType ? room.roomType : translateService.instant('EVENT.OVERVIEW_CARDS.UNKNOWN_ROOM_TYPE');
            roomRate = new decimal_default.a(room.roomRate);
            commissionPercentage = room.commissionPercentage;
            var roomNights = room.nights * _this.getRooms(room);
            totalNights = totalNights + roomNights;
            var numberOfRooms = Math.max(1, _this.getRooms(room));
            var roomRevenue = roomRate.times(room.nights).times(numberOfRooms);
            totalRevenue = totalRevenue.add(roomRevenue);
            var roomCommission = room.payViaGp ? room.commission : 0;
            totalCommission = totalCommission.add(roomCommission || 0);
            if (room.payViaGp) {
                totalCommissionableRevenue = totalCommissionableRevenue.add(roomRevenue);
            }
        });
        return new RoomTypeRateSummary({
            roomType: roomType,
            roomRate: roomRate.toNumber(),
            totalNights: totalNights,
            totalRevenue: totalRevenue.toNumber(),
            totalCommission: totalCommission.toNumber(),
            totalCommissionableRevenue: totalCommissionableRevenue,
            commissionPercentage: commissionPercentage,
        });
    };
    /**
     * Returns the number of rooms
     * @param room
     */
    TransactionUtils.getRooms = function (room) {
        var rooms = 1;
        if (this.isReservation(room)) {
            rooms = room.rooms;
        }
        return rooms;
    };
    /**
     * Returns `true` if the room is of type Reservation and has the `rooms` property; `false` otherwise
     * @param {any} room
     */
    TransactionUtils.isReservation = function (room) {
        return room.rooms !== undefined;
    };
    return TransactionUtils;
}());

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/transaction-utils.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/service/abstract-event-has-items.store.ts



var abstract_event_has_items_store_AbstractEventHasItemsStore = (function () {
    function AbstractEventHasItemsStore() {
        this.hasItemsByVendorCache = new Map();
    }
    AbstractEventHasItemsStore.prototype.loadEventHasItemsCache = function (eventHasItemsByVendor) {
        var _this = this;
        this.resetHasItemsByVendorCache();
        Object.keys(eventHasItemsByVendor).forEach(function (key) {
            var eventPartyIdKey = +key;
            var hasItems = eventHasItemsByVendor[eventPartyIdKey];
            _this.upsertVendorHasItems(eventPartyIdKey, hasItems);
        });
    };
    AbstractEventHasItemsStore.prototype.upsertVendorHasItems = function (eventPartyId, hasItems) {
        var vendorHasItemsSubject = this.hasItemsByVendorCache.get(eventPartyId);
        if (!!vendorHasItemsSubject) {
            vendorHasItemsSubject.next(hasItems);
        }
        else {
            vendorHasItemsSubject = new BehaviorSubject["BehaviorSubject"](hasItems);
            this.hasItemsByVendorCache.set(eventPartyId, vendorHasItemsSubject);
        }
    };
    AbstractEventHasItemsStore.prototype.resetHasItemsByVendorCache = function () {
        this.hasItemsByVendorCache.forEach(function (vendorHasItemsSubject) {
            vendorHasItemsSubject.complete();
        });
        this.hasItemsByVendorCache = new Map();
    };
    AbstractEventHasItemsStore.prototype.getEventHasItems = function () {
        var observables = Array.from(this.hasItemsByVendorCache.values());
        if (observables.length === 0) {
            return Observable["Observable"].of(false);
        }
        return Observable["Observable"].combineLatest(observables)
            .map(function (values) { return values.some(function (value) { return value === true; }); });
    };
    AbstractEventHasItemsStore.prototype.getHasItemsByEventPartyId = function (eventPartyId) {
        if (!eventPartyId) {
            return Observable["Observable"].of(false);
        }
        var vendorHasItemsSubject = this.hasItemsByVendorCache.get(eventPartyId);
        if (!vendorHasItemsSubject) {
            vendorHasItemsSubject = new BehaviorSubject["BehaviorSubject"](null);
            this.hasItemsByVendorCache.set(eventPartyId, vendorHasItemsSubject);
        }
        return vendorHasItemsSubject.asObservable().pipe(Object(operators["filter"])(function (hasItems) { return hasItems != null; }));
    };
    return AbstractEventHasItemsStore;
}());

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/abstract-event-has-items.store.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/service/reservation-store.ts
var reservation_store___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var reservation_store___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var reservation_store___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};














var reservation_store_ReservationStore = (function (_super) {
    reservation_store___extends(ReservationStore, _super);
    function ReservationStore(flashMessagesService, reservationHttpService, eventStore, transientReservationService, translateService, eventHttpService) {
        var _this = _super.call(this) || this;
        _this.flashMessagesService = flashMessagesService;
        _this.reservationHttpService = reservationHttpService;
        _this.eventStore = eventStore;
        _this.transientReservationService = transientReservationService;
        _this.translateService = translateService;
        _this.eventHttpService = eventHttpService;
        _this.currentReservations = new BehaviorSubject["BehaviorSubject"](Object(immutable["List"])([]));
        return _this;
    }
    Object.defineProperty(ReservationStore.prototype, "reservations", {
        get: function () {
            return this.currentReservations.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Has to be called to retrieve reservations.
     * Is called by resolver.
     *
     * @param eventId
     * @returns RESERVATION_LIST
     */
    ReservationStore.prototype.loadReservations = function (eventId) {
        var _this = this;
        return this.reservationHttpService.get(eventId)
            .catch(function (error) {
            _this.flashMessagesService.error('MESSAGES.ERROR.COULD_NOT_GET_RESERVATIONS', "Error retrieving room details: " + error);
            return Observable["Observable"].throw(error);
        })
            .map(function (reservationList) {
            _this.currentReservations.next(reservationList);
            _this.reloadEventHasReservationsCache(eventId).pipe(Object(operators["take"])(1)).subscribe();
            return reservationList;
        });
    };
    /**
     * Has to be called to retrieve reservations.
     * Is called by resolver.
     *
     * @param eventId
     * @param eventPartyId
     * @returns RESERVATION_LIST
     */
    ReservationStore.prototype.loadReservationsByParty = function (eventId, eventPartyId) {
        var _this = this;
        return this.reservationHttpService.getByParty(eventId, eventPartyId)
            .catch(function (error) {
            _this.flashMessagesService.error('MESSAGES.ERROR.COULD_NOT_GET_RESERVATIONS', "Error retrieving room details: " + error);
            return Observable["Observable"].throw(error);
        })
            .map(function (reservationList) {
            _this.currentReservations.next(reservationList);
            _this.reloadEventHasReservationsCache(eventId, eventPartyId).pipe(Object(operators["take"])(1)).subscribe();
            return reservationList;
        });
    };
    /**
     * Gets the filtered reservation list by an array of status codes and transforms the list into a room stay summary
     *
     * @param statusCode{ReservationStatusCode[]}
     * @returns {Observable<StaySummary>}
     */
    ReservationStore.prototype.getRoomStaySummaryFilteredByStatus = function (statusCodes) {
        var _this = this;
        return this.getReservationListFilteredByStatus(statusCodes).map(function (reservationList) {
            return transaction_utils_TransactionUtils.transformTransactionsToSummary(reservationList, _this.translateService);
        });
    };
    ReservationStore.prototype.getVendorRoomStaySummaryFilteredByStatus = function (statusCodes, eventPartyId) {
        var _this = this;
        return this.getVendorReservationListFilteredByStatus(statusCodes, eventPartyId).map(function (reservationList) {
            return transaction_utils_TransactionUtils.transformTransactionsToSummary(reservationList, _this.translateService);
        });
    };
    /**
     * Filters reservation list by an array of status codes
     * e.g. checked out
     *
     * @param statusCode{ReservationStatusCode[]}
     * @returns {Observable<List<Reservation>>}
     */
    ReservationStore.prototype.getReservationListFilteredByStatus = function (statusCodes) {
        return this.currentReservations.asObservable().map(function (reservationList) {
            return reservationList.filter(function (reservation) {
                return statusCodes.find(function (statusCode) { return statusCode.toString() === reservation.status; }) != null;
            }).toList();
        });
    };
    ReservationStore.prototype.getVendorReservationListFilteredByStatus = function (statusCodes, eventPartyId) {
        return this.currentReservations.asObservable().map(function (reservationList) {
            return reservationList.filter(function (reservation) {
                return reservation.eventPartyId === eventPartyId
                    && statusCodes.find(function (statusCode) { return statusCode.toString() === reservation.status; }) != null;
            }).toList();
        });
    };
    ReservationStore.prototype.getTotalCommissions = function (reservationStatusCode) {
        var _this = this;
        return this.eventStore.selectedEvent.flatMap(function (event) {
            return _this.getRoomStaySummaryFilteredByStatus([reservationStatusCode]);
        }).map(function (summary) {
            return summary.staySummary.totalCommission;
        });
    };
    ReservationStore.prototype.getVendorTotalCommissions = function (reservationStatusCode, eventPartyId) {
        var _this = this;
        return this.eventStore.selectedEvent.flatMap(function (event) {
            return _this.getVendorRoomStaySummaryFilteredByStatus([reservationStatusCode], eventPartyId);
        }).map(function (summary) {
            return summary.staySummary.totalCommission;
        });
    };
    ReservationStore.prototype.getTotalRevenue = function (reservationStatusCode) {
        var _this = this;
        return this.eventStore.selectedEvent.flatMap(function (event) {
            return _this.getRoomStaySummaryFilteredByStatus([reservationStatusCode]);
        }).map(function (summary) {
            return summary.staySummary.totalRevenue;
        });
    };
    ReservationStore.prototype.getVendorTotalRevenue = function (reservationStatusCode, eventPartyId) {
        var _this = this;
        return this.eventStore.selectedEvent.flatMap(function (event) {
            return _this.getVendorRoomStaySummaryFilteredByStatus([reservationStatusCode], eventPartyId);
        }).map(function (summary) {
            return summary.staySummary.totalRevenue;
        });
    };
    ReservationStore.prototype.addReservation = function (reservation, source, isMultiVendor) {
        var _this = this;
        return this.reservationHttpService.add(reservation, source)
            .catch(function (error) {
            _this.flashMessagesService.error('MESSAGES.ERROR.ADD_RESERVATION', "Error adding reservation: " + error);
            return Observable["Observable"].throw(error);
        })
            .map(function (response) {
            _this.flashMessagesService.success('EVENT.RESERVATION.RESERVATION_ADDED', null, {
                lastName: String(reservation.lastName),
                firstName: !reservation.firstName ? '' : String(", " + reservation.firstName)
            });
            if (isMultiVendor) {
                _this.loadReservations(reservation.eventId).subscribe();
            }
            else {
                _this.loadReservationsByParty(reservation.eventId, reservation.eventPartyId).subscribe();
            }
            return response;
        });
    };
    /**
     * Delete a reservation
     *
     * @param reservation
     * @returns {Observable<R>}
     */
    ReservationStore.prototype.deleteReservation = function (reservation, isMultiVendor) {
        var _this = this;
        return this.reservationHttpService.delete(reservation)
            .catch(function (error) {
            _this.flashMessagesService.error('MESSAGES.ERROR.DELETE_RESERVATION', "Error deleting reservation: " + error);
            return Observable["Observable"].throw(error);
        })
            .map(function (response) {
            _this.flashMessagesService.success('EVENT.RESERVATION.RESERVATION_DELETED');
            if (isMultiVendor) {
                _this.loadReservations(reservation.eventId).subscribe();
            }
            else {
                _this.loadReservationsByParty(reservation.eventId, reservation.eventPartyId).subscribe();
            }
            return response;
        });
    };
    /**
     * Update a reservation
     *
     * @param reservation
     * @param source
     * @returns {OperatorFunction<T, R>}
     */
    ReservationStore.prototype.updateReservation = function (reservation, isMultiVendor) {
        var _this = this;
        return this.reservationHttpService.update(reservation)
            .catch(function (error) {
            _this.flashMessagesService.error('MESSAGES.ERROR.UPDATE_RESERVATION', "Error updating reservation: " + error);
            return Observable["Observable"].throw(error);
        })
            .map(function (response) {
            _this.flashMessagesService.success('EVENT.RESERVATION.RESERVATION_UPDATED', null, {
                lastName: String(reservation.lastName),
                firstName: !reservation.firstName ? '' : String(", " + reservation.firstName)
            });
            if (isMultiVendor) {
                _this.loadReservations(reservation.eventId).subscribe();
            }
            else {
                _this.loadReservationsByParty(reservation.eventId, reservation.eventPartyId).subscribe();
            }
            return response;
        });
    };
    /**
     * Import a file of reservations
     *
     * @param eventId
     * @param file
     * @returns {OperatorFunction<T, R>}
     */
    ReservationStore.prototype.importReservationFile = function (eventId, eventPartyId, file, isMultiVendor) {
        var _this = this;
        return this.reservationHttpService
            .importReservationFile(eventId, eventPartyId, file)
            .map(function (importResponse) {
            if (isMultiVendor) {
                _this.loadReservations(eventId).subscribe();
            }
            else {
                _this.loadReservationsByParty(eventId, eventPartyId).subscribe();
            }
            return importResponse;
        });
    };
    /**
     * Unlink an out-of-block reservation
     *
     * @param reservation
     * @returns {Observable<R>}
     */
    ReservationStore.prototype.unlinkReservation = function (eventReservationId, eventId, eventPartyId, isMultiVendor) {
        var _this = this;
        return this.transientReservationService.unlinkTransientReservation(eventReservationId, eventId)
            .catch(function (error) {
            _this.flashMessagesService.error('MESSAGES.ERROR.UNLINK_RESERVATION', "Error unlinking reservation: " + error);
            return Observable["Observable"].throw(error);
        })
            .map(function (response) {
            _this.flashMessagesService.success('EVENT.TRANSIENT_RESERVATION.RESERVATION_UNLINKED');
            if (isMultiVendor) {
                _this.loadReservations(eventId).subscribe();
            }
            else {
                _this.loadReservationsByParty(eventId, eventPartyId).subscribe();
            }
            return response;
        });
    };
    ReservationStore.prototype.getReservationsByStatus = function (eventId, statusCodes, pageNumber, size) {
        var _this = this;
        return this.reservationHttpService.getReservationsByStatus(eventId, statusCodes, pageNumber, size)
            .catch(function (error) {
            _this.flashMessagesService.error('MESSAGES.ERROR.COULD_NOT_GET_RESERVATIONS', "Error retrieving room details: " + error);
            return Observable["Observable"].throw(error);
        });
    };
    ReservationStore.prototype.getReservationsByStatusByParty = function (eventId, eventPartyId, statusCodes, pageNumber, size) {
        var _this = this;
        return this.reservationHttpService.getReservationsByStatusByParty(eventId, eventPartyId, statusCodes, pageNumber, size)
            .catch(function (error) {
            _this.flashMessagesService.error('MESSAGES.ERROR.COULD_NOT_GET_RESERVATIONS', "Error retrieving room details: " + error);
            return Observable["Observable"].throw(error);
        });
    };
    ReservationStore.prototype.getEventHasReservations = function () {
        return _super.prototype.getEventHasItems.call(this);
    };
    ReservationStore.prototype.getHasReservationsByEventPartyId = function (eventPartyId) {
        return _super.prototype.getHasItemsByEventPartyId.call(this, eventPartyId);
    };
    ReservationStore.prototype.loadEventHasReservationsCache = function (eventHasReservationsByVendor) {
        _super.prototype.loadEventHasItemsCache.call(this, eventHasReservationsByVendor);
    };
    ReservationStore.prototype.reloadEventHasReservationsCache = function (eventId, eventPartyId) {
        var _this = this;
        var serviceCall;
        if (!!eventPartyId) {
            serviceCall = this.eventHttpService.fetchHasItemsByParty(eventId, eventPartyId);
        }
        else {
            serviceCall = this.eventHttpService.fetchHasItems(eventId);
        }
        return serviceCall.pipe(Object(operators["catchError"])(function (error) {
            _this.flashMessagesService.error('MESSAGES.ERROR.COULD_NOT_CHECK_HAS_RESERVATIONS', "Error retrieving items: " + error);
            return Observable["Observable"].throw(error);
        }), Object(operators["filter"])(function (response) { return response instanceof EventHasItemsByVendor; }), Object(operators["tap"])(function (eventHasItemsByVendor) {
            _this.loadEventHasReservationsCache(eventHasItemsByVendor.hasReservationsByVendor);
        }));
    };
    return ReservationStore;
}(abstract_event_has_items_store_AbstractEventHasItemsStore));
reservation_store_ReservationStore = reservation_store___decorate([
    Object(core_es5["Injectable"])(),
    reservation_store___metadata("design:paramtypes", [typeof (reservation_store__a = typeof flash_messages_service_FlashMessagesService !== "undefined" && flash_messages_service_FlashMessagesService) === "function" && reservation_store__a || Object, typeof (reservation_store__b = typeof reservation_http_service_ReservationService !== "undefined" && reservation_http_service_ReservationService) === "function" && reservation_store__b || Object, typeof (reservation_store__c = typeof event_store_EventStore !== "undefined" && event_store_EventStore) === "function" && reservation_store__c || Object, typeof (reservation_store__d = typeof transient_reservation_http_service_TransientReservationService !== "undefined" && transient_reservation_http_service_TransientReservationService) === "function" && reservation_store__d || Object, typeof (reservation_store__e = typeof core["c" /* TranslateService */] !== "undefined" && core["c" /* TranslateService */]) === "function" && reservation_store__e || Object, typeof (reservation_store__f = typeof event_http_service_EventHttpService !== "undefined" && event_http_service_EventHttpService) === "function" && reservation_store__f || Object])
], reservation_store_ReservationStore);

var reservation_store__a, reservation_store__b, reservation_store__c, reservation_store__d, reservation_store__e, reservation_store__f;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/reservation-store.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/rsvp.ts
var rsvp___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var Rsvp = (function (_super) {
    rsvp___extends(Rsvp, _super);
    function Rsvp() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Rsvp;
}(Transaction));

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/rsvp.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/service/rsvp.http.service.ts
var rsvp_http_service___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var rsvp_http_service___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};







var rsvp_http_service_RsvpHttpService = (function () {
    function RsvpHttpService(http, environment, responseUtilService) {
        this.http = http;
        this.environment = environment;
        this.responseUtilService = responseUtilService;
        this.eventsUrl = this.environment.baseUrl + '/api/events';
    }
    RsvpHttpService.prototype.getRsvps = function (eventId) {
        var _this = this;
        return this.http.get(this.eventsUrl + "/" + eventId + "/rsvps")
            .map(function (response) { return Object(immutable["List"])(response.json().map(function (rsvpObject) { return new Rsvp(rsvpObject); })); })
            .catch(function (response) { return _this.responseUtilService.handleError(response); }).share();
    };
    RsvpHttpService.prototype.getRsvpsByParty = function (eventId, eventPartyId) {
        var _this = this;
        return this.http.get(this.eventsUrl + "/" + eventId + "/" + eventPartyId + "/rsvps")
            .map(function (response) { return Object(immutable["List"])(response.json().map(function (rsvpObject) { return new Rsvp(rsvpObject); })); })
            .catch(function (response) { return _this.responseUtilService.handleError(response); }).share();
    };
    RsvpHttpService.prototype.getRsvpsPaginated = function (eventId, page, size) {
        var _this = this;
        return this.http.get(this.eventsUrl + "/" + eventId + "/rsvps?page=" + page + "&size=" + size)
            .map(function (response) {
            var rsvpPage = response.json();
            rsvpPage.content = Object(immutable["List"])(rsvpPage.content);
            return rsvpPage;
        })
            .catch(function (response) { return _this.responseUtilService.handleError(response); })
            .share();
    };
    RsvpHttpService.prototype.getRsvpsByVendorPaginated = function (eventId, eventPartyId, page, size) {
        var _this = this;
        return this.http.get(this.eventsUrl + "/" + eventId + "/" + eventPartyId + "/rsvps/paginated?page=" + page + "&size=" + size)
            .map(function (response) {
            var rsvpPage = response.json();
            rsvpPage.content = Object(immutable["List"])(rsvpPage.content);
            return rsvpPage;
        })
            .catch(function (response) { return _this.responseUtilService.handleError(response); })
            .share();
    };
    RsvpHttpService.prototype.add = function (rsvp) {
        var _this = this;
        var headers = new http_es5["Headers"]({ 'Content-Type': 'application/json' });
        var options = new http_es5["RequestOptions"]({ headers: headers });
        var rsvpAsJSON = JSON.stringify(rsvp.toJS());
        return this.http.post(this.eventsUrl + "/rsvps", rsvpAsJSON, options)
            .catch(function (response) { return _this.responseUtilService.handleError(response); }).share();
    };
    RsvpHttpService.prototype.delete = function (rsvp) {
        var _this = this;
        return this.http.delete(this.eventsUrl + "/rsvps/" + rsvp.eventRsvpId)
            .catch(function (response) { return _this.responseUtilService.handleError(response); }).share();
    };
    RsvpHttpService.prototype.update = function (rsvp) {
        var _this = this;
        var headers = new http_es5["Headers"]({ 'Content-Type': 'application/json' });
        var options = new http_es5["RequestOptions"]({ headers: headers });
        var rsvpAsJSON = JSON.stringify(rsvp.toJS());
        return this.http.put(this.eventsUrl + "/rsvps", rsvpAsJSON, options)
            .catch(function (response) { return _this.responseUtilService.handleError(response); }).share();
    };
    RsvpHttpService.prototype.importRsvpFile = function (eventId, eventPartyId, file) {
        var _this = this;
        var formData = new FormData();
        formData.append('file', file);
        return this.http.post(this.eventsUrl + "/" + eventId + "/" + eventPartyId + "/rsvps/bulk", formData)
            .map(function (response) { return response.json(); })
            .catch(function (response) { return _this.responseUtilService.handleError(response); })
            .share();
    };
    return RsvpHttpService;
}());
rsvp_http_service_RsvpHttpService = rsvp_http_service___decorate([
    Object(core_es5["Injectable"])(),
    rsvp_http_service___metadata("design:paramtypes", [typeof (rsvp_http_service__a = typeof AppAuthHttpService !== "undefined" && AppAuthHttpService) === "function" && rsvp_http_service__a || Object, typeof (rsvp_http_service__b = typeof EnvironmentConfiguration !== "undefined" && EnvironmentConfiguration) === "function" && rsvp_http_service__b || Object, typeof (rsvp_http_service__c = typeof response_util_service_ResponseUtilService !== "undefined" && response_util_service_ResponseUtilService) === "function" && rsvp_http_service__c || Object])
], rsvp_http_service_RsvpHttpService);

var rsvp_http_service__a, rsvp_http_service__b, rsvp_http_service__c;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/rsvp.http.service.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/service/rsvp.store.ts
var rsvp_store___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var rsvp_store___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var rsvp_store___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

















var rsvp_store_RsvpStore = (function (_super) {
    rsvp_store___extends(RsvpStore, _super);
    function RsvpStore(rsvpHttpService, flashMessagesService, translateService, eventHttpService) {
        var _this = _super.call(this) || this;
        _this.rsvpHttpService = rsvpHttpService;
        _this.flashMessagesService = flashMessagesService;
        _this.translateService = translateService;
        _this.eventHttpService = eventHttpService;
        _this.rsvpSubject = new ReplaySubject["ReplaySubject"](1);
        _this.searchResultsPage = new BehaviorSubject["BehaviorSubject"](page_Page.empty());
        return _this;
    }
    Object.defineProperty(RsvpStore.prototype, "searchResults", {
        get: function () {
            return this.searchResultsPage.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RsvpStore.prototype, "rsvps", {
        get: function () {
            return this.rsvpSubject.asObservable().map(function (rsvpList) { return rsvpList.sort(function (rsvp1, rsvp2) { return ComparatorUtils.compareRsvps(rsvp1, rsvp2); }).toList(); });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RsvpStore.prototype, "totalNights", {
        get: function () {
            return this.rsvps.map(function (rsvpList) {
                return rsvpList
                    .map(function (rsvp) { return rsvp.nights; })
                    .reduce(function (sum, current) { return !!current ? sum + current : sum; }, 0);
            });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RsvpStore.prototype, "totalRevenue", {
        get: function () {
            return this.rsvps.map(function (rsvpList) {
                var totalRevenue = rsvpList
                    .map(function (rsvp) { return rsvp.revenue; })
                    .reduce(function (sum, currentRevenue) { return !!currentRevenue ? sum.add(currentRevenue) : sum; }, new decimal_default.a(0));
                return math_utils_MathUtils.roundDecimalCurrencyToCents(totalRevenue).toNumber();
            });
        },
        enumerable: true,
        configurable: true
    });
    RsvpStore.prototype.vendorTotalRevenue = function (eventPartyId) {
        return this.rsvps.map(function (filteredList) {
            return filteredList.filter(function (filtered) { return filtered.eventPartyId === eventPartyId; }).toList();
        }).map(function (rsvpList) {
            var totalRevenue = rsvpList
                .map(function (rsvp) { return rsvp.revenue; })
                .reduce(function (sum, currentRevenue) { return !!currentRevenue ? sum.add(currentRevenue) : sum; }, new decimal_default.a(0));
            return math_utils_MathUtils.roundDecimalCurrencyToCents(totalRevenue).toNumber();
        });
    };
    RsvpStore.prototype.vendorTotalCommission = function (eventPartyId) {
        return this.rsvps.map(function (filteredList) {
            return filteredList.filter(function (filtered) { return filtered.eventPartyId === eventPartyId; }).toList();
        }).map(function (rsvpList) {
            var totalCommission = rsvpList
                .map(function (rsvp) { return rsvp.commission; })
                .reduce(function (sum, current) { return !!current ? sum.add(current) : sum; }, new decimal_default.a(0));
            return math_utils_MathUtils.roundDecimalCurrencyToCents(totalCommission).toNumber();
        });
    };
    RsvpStore.prototype.addRsvp = function (rsvp) {
        var _this = this;
        return this.rsvpHttpService.add(rsvp)
            .catch(function (error) {
            _this.flashMessagesService.error('MESSAGES.ERROR.ADD_RSVP', "Error adding rsvp: " + error);
            return Observable["Observable"].throw(error);
        })
            .map(function (result) {
            _this.flashMessagesService.success('EVENT.RSVPS.RSVP_ADDED');
            return result;
        });
    };
    RsvpStore.prototype.importRsvpFile = function (eventId, eventPartyId, file) {
        return this.rsvpHttpService
            .importRsvpFile(eventId, eventPartyId, file);
    };
    RsvpStore.prototype.deleteRsvp = function (rsvp) {
        var _this = this;
        return this.rsvpHttpService.delete(rsvp)
            .catch(function (error) {
            _this.flashMessagesService.error('MESSAGES.ERROR.DELETE_RSVP', "Error adding rsvp: " + error);
            return Observable["Observable"].throw(error);
        })
            .map(function (result) {
            _this.flashMessagesService.success('EVENT.RSVPS.RSVP_DELETED');
            return result;
        });
    };
    RsvpStore.prototype.updateRsvp = function (rsvp) {
        var _this = this;
        return this.rsvpHttpService.update(rsvp)
            .catch(function (error) {
            _this.flashMessagesService.error('MESSAGES.ERROR.UPDATE_RSVP', "Error updating rsvp: " + error);
            return Observable["Observable"].throw(error);
        })
            .map(function (result) {
            _this.flashMessagesService.success('EVENT.RSVPS.RSVP_UPDATED', null, {
                lastName: String(rsvp.lastName),
                firstName: !rsvp.firstName ? '' : String(", " + rsvp.firstName)
            });
            return result;
        });
    };
    /**
     * Has to be called to retrieve RSVPs.
     * Is called by resolver.
     *
     * @param eventId
     * @returns RSVP list
     */
    RsvpStore.prototype.loadRsvps = function (eventId) {
        var _this = this;
        return this.rsvpHttpService.getRsvps(eventId)
            .catch(function (error) {
            _this.flashMessagesService.error('MESSAGES.ERROR.COULD_NOT_GET_RSVPS', "Error retrieving RSVPs: " + error);
            return Observable["Observable"].throw(error);
        })
            .map(function (rsvpList) {
            _this.rsvpSubject.next(rsvpList);
            _this.reloadEventHasRsvpsCache(eventId).pipe(Object(operators["take"])(1)).subscribe();
            return rsvpList;
        });
    };
    /**
     * Has to be called to retrieve RSVPs.
     * Is called by resolver.
     *
     * @param eventId
     * @param eventPartyId
     * @returns RSVP list
     */
    RsvpStore.prototype.loadRsvpsByParty = function (eventId, eventPartyId) {
        var _this = this;
        return this.rsvpHttpService.getRsvpsByParty(eventId, eventPartyId)
            .catch(function (error) {
            _this.flashMessagesService.error('MESSAGES.ERROR.COULD_NOT_GET_RSVPS', "Error retrieving RSVPs: " + error);
            return Observable["Observable"].throw(error);
        })
            .map(function (rsvpList) {
            _this.rsvpSubject.next(rsvpList);
            _this.reloadEventHasRsvpsCache(eventId, eventPartyId).pipe(Object(operators["take"])(1)).subscribe();
            return rsvpList;
        });
    };
    /**
     * Loads the RSVPs paginated
     *
     * @param eventId the id of the event
     * @param page the page to be load
     * @param size the number of RSVP to be load
     * @returns an `Page` of RSVP
     */
    RsvpStore.prototype.loadRsvpsPaginated = function (eventId, page, size) {
        var _this = this;
        return this.rsvpHttpService.getRsvpsPaginated(eventId, page, size)
            .catch(function (error) {
            _this.flashMessagesService.error('MESSAGES.ERROR.COULD_NOT_GET_RSVPS', "Error retrieving RSVPs: " + error);
            return Observable["Observable"].throw(error);
        })
            .map(function (rsvpPage) {
            _this.searchResultsPage.next(rsvpPage);
            return rsvpPage;
        });
    };
    RsvpStore.prototype.refreshRsvpsSummary = function (eventId, pagesize) {
        this.loadRsvpsPaginated(eventId, Constants.SEARCH_DEFAULT_PAGE, pagesize).take(1).subscribe();
    };
    /**
     * Transform the RSVP list into a room stay summary
     *
     * @param statusCode{ReservationStatusCode[]}
     * @returns {Observable<StaySummary>}
     */
    RsvpStore.prototype.getRoomStaySummary = function () {
        var _this = this;
        return this.rsvps.map(function (rsvpList) {
            return transaction_utils_TransactionUtils.transformTransactionsToSummary(rsvpList, _this.translateService);
        });
    };
    RsvpStore.prototype.getVendorRoomStaySummary = function (eventPartyId) {
        var _this = this;
        return this.rsvps.map(function (rsvpList) {
            return transaction_utils_TransactionUtils.transformTransactionsToSummary(rsvpList.filter(function (rsvp) { return rsvp.eventPartyId === eventPartyId; }).toList(), _this.translateService);
        });
    };
    RsvpStore.prototype.getRsvpsFromEvent = function (eventId, page, size) {
        var _this = this;
        return this.rsvpHttpService.getRsvpsPaginated(eventId, page, size)
            .catch(function (error) {
            _this.flashMessagesService.error('MESSAGES.ERROR.COULD_NOT_GET_RSVPS', "Error retrieving RSVPs: " + error);
            return Observable["Observable"].throw(error);
        });
    };
    RsvpStore.prototype.getRsvpsFromVendor = function (eventId, eventPartyId, page, size) {
        var _this = this;
        return this.rsvpHttpService.getRsvpsByVendorPaginated(eventId, eventPartyId, page, size)
            .catch(function (error) {
            _this.flashMessagesService.error('MESSAGES.ERROR.COULD_NOT_GET_RSVPS', "Error retrieving RSVPs: " + error);
            return Observable["Observable"].throw(error);
        });
    };
    RsvpStore.prototype.getEventHasRsvps = function () {
        return _super.prototype.getEventHasItems.call(this);
    };
    RsvpStore.prototype.getHasRsvpsByEventPartyId = function (eventPartyId) {
        return _super.prototype.getHasItemsByEventPartyId.call(this, eventPartyId);
    };
    RsvpStore.prototype.loadEventHasRsvpsCache = function (eventHasRsvpsByVendor) {
        _super.prototype.loadEventHasItemsCache.call(this, eventHasRsvpsByVendor);
    };
    RsvpStore.prototype.reloadEventHasRsvpsCache = function (eventId, eventPartyId) {
        var _this = this;
        var serviceCall;
        if (!!eventPartyId) {
            serviceCall = this.eventHttpService.fetchHasItemsByParty(eventId, eventPartyId);
        }
        else {
            serviceCall = this.eventHttpService.fetchHasItems(eventId);
        }
        return serviceCall.pipe(Object(operators["catchError"])(function (error) {
            _this.flashMessagesService.error('MESSAGES.ERROR.COULD_NOT_CHECK_HAS_RSVPS', "Error retrieving items: " + error);
            return Observable["Observable"].throw(error);
        }), Object(operators["filter"])(function (response) { return response instanceof EventHasItemsByVendor; }), Object(operators["tap"])(function (eventHasItemsByVendor) {
            _this.loadEventHasRsvpsCache(eventHasItemsByVendor.hasRsvpsByVendor);
        }));
    };
    return RsvpStore;
}(abstract_event_has_items_store_AbstractEventHasItemsStore));
rsvp_store_RsvpStore = rsvp_store___decorate([
    Object(core_es5["Injectable"])(),
    rsvp_store___metadata("design:paramtypes", [typeof (rsvp_store__a = typeof rsvp_http_service_RsvpHttpService !== "undefined" && rsvp_http_service_RsvpHttpService) === "function" && rsvp_store__a || Object, typeof (rsvp_store__b = typeof flash_messages_service_FlashMessagesService !== "undefined" && flash_messages_service_FlashMessagesService) === "function" && rsvp_store__b || Object, typeof (rsvp_store__c = typeof core["c" /* TranslateService */] !== "undefined" && core["c" /* TranslateService */]) === "function" && rsvp_store__c || Object, typeof (rsvp_store__d = typeof event_http_service_EventHttpService !== "undefined" && event_http_service_EventHttpService) === "function" && rsvp_store__d || Object])
], rsvp_store_RsvpStore);

var rsvp_store__a, rsvp_store__b, rsvp_store__c, rsvp_store__d;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/rsvp.store.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/service/attachment/attachment.http.service.ts
var attachment_http_service___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var attachment_http_service___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};




var AttachmentHttpService = (function () {
    function AttachmentHttpService(http, environment, responseUtilService) {
        this.http = http;
        this.environment = environment;
        this.responseUtilService = responseUtilService;
        this.eventsUrl = this.environment.baseUrl + '/api/events';
    }
    AttachmentHttpService.prototype.getForEvent = function (eventId) {
        var _this = this;
        return this.http.get(this.eventsUrl + "/" + eventId + "/attachments")
            .map(function (res) { return res.json(); })
            .catch(function (response) { return _this.responseUtilService.handleError(response); }).share();
    };
    AttachmentHttpService.prototype.getForEventByParty = function (eventId, eventPartyId) {
        var _this = this;
        return this.http.get(this.eventsUrl + "/" + eventId + "/" + eventPartyId + "/attachments")
            .map(function (res) { return res.json(); })
            .catch(function (response) { return _this.responseUtilService.handleError(response); }).share();
    };
    AttachmentHttpService.prototype.add = function (eventId, eventPartyId, file) {
        var _this = this;
        var formData = new FormData();
        formData.append('file', file);
        return this.http.post(this.eventsUrl + "/" + eventId + "/" + eventPartyId + "/attachments", formData)
            .catch(function (response) { return _this.responseUtilService.handleError(response); }).share();
    };
    AttachmentHttpService.prototype.get = function (uniqueId) {
        var _this = this;
        return this.http.get(this.eventsUrl + "/attachments/" + uniqueId)
            .map(function (resp) { return resp.text(); })
            .catch(function (response) { return _this.responseUtilService.handleError(response); }).share();
    };
    AttachmentHttpService.prototype.delete = function (uniqueId) {
        var _this = this;
        return this.http.delete(this.eventsUrl + "/attachments/" + uniqueId)
            .catch(function (response) { return _this.responseUtilService.handleError(response); }).share();
    };
    return AttachmentHttpService;
}());
AttachmentHttpService = attachment_http_service___decorate([
    Object(core_es5["Injectable"])(),
    attachment_http_service___metadata("design:paramtypes", [typeof (attachment_http_service__a = typeof AppAuthHttpService !== "undefined" && AppAuthHttpService) === "function" && attachment_http_service__a || Object, typeof (attachment_http_service__b = typeof EnvironmentConfiguration !== "undefined" && EnvironmentConfiguration) === "function" && attachment_http_service__b || Object, typeof (attachment_http_service__c = typeof response_util_service_ResponseUtilService !== "undefined" && response_util_service_ResponseUtilService) === "function" && attachment_http_service__c || Object])
], AttachmentHttpService);

var attachment_http_service__a, attachment_http_service__b, attachment_http_service__c;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/attachment.http.service.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/service/attachment/attachment.store.ts
var attachment_store___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var attachment_store___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};






var attachment_store_AttachmentStore = (function () {
    function AttachmentStore(attachmentHttpService, flashMessagesService) {
        this.attachmentHttpService = attachmentHttpService;
        this.flashMessagesService = flashMessagesService;
        this.currentAttachments = new BehaviorSubject["BehaviorSubject"](Object(immutable["List"])([]));
    }
    Object.defineProperty(AttachmentStore.prototype, "attachments", {
        get: function () {
            return this.currentAttachments.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    AttachmentStore.prototype.loadAttachments = function (eventId, eventPartyId, multiVendor) {
        if (multiVendor) {
            this.getAttachments(eventId).subscribe();
        }
        else {
            this.getAttachmentsByParty(eventId, eventPartyId).subscribe();
        }
    };
    AttachmentStore.prototype.getAttachments = function (eventId) {
        var _this = this;
        return this.attachmentHttpService.getForEvent(eventId)
            .catch(function (error) {
            // Catch error here so resolver also displays error.
            _this.flashMessagesService.error('MESSAGES.ERROR.GET_ATTACHMENTS', "Error retrieving attachments; " + error);
            return Observable["Observable"].throw(error);
        })
            .map(function (res) {
            _this.currentAttachments.next(Object(immutable["List"])(res));
            return res;
        });
    };
    AttachmentStore.prototype.getAttachmentsByParty = function (eventId, eventPartyId) {
        var _this = this;
        return this.attachmentHttpService.getForEventByParty(eventId, eventPartyId)
            .catch(function (error) {
            // Catch error here so resolver also displays error.
            _this.flashMessagesService.error('MESSAGES.ERROR.GET_ATTACHMENTS', "Error retrieving attachments; " + error);
            return Observable["Observable"].throw(error);
        })
            .map(function (res) {
            _this.currentAttachments.next(Object(immutable["List"])(res));
            return res;
        });
    };
    AttachmentStore.prototype.addAttachment = function (eventId, eventPartyId, file, multiVendor) {
        var _this = this;
        return this.attachmentHttpService.add(eventId, eventPartyId, file)
            .map(function (res) {
            _this.loadAttachments(eventId, eventPartyId, multiVendor);
            return res;
        });
    };
    AttachmentStore.prototype.deleteAttachment = function (eventId, eventPartyId, uniqueId, multiVendor) {
        var _this = this;
        return this.attachmentHttpService.delete(uniqueId)
            .map(function (res) {
            _this.loadAttachments(eventId, eventPartyId, multiVendor);
            return res;
        });
    };
    AttachmentStore.prototype.get = function (uniqueId) {
        return this.attachmentHttpService.get(uniqueId)
            .map(function (res) {
            window.open(res);
            return res;
        });
    };
    return AttachmentStore;
}());
attachment_store_AttachmentStore = attachment_store___decorate([
    Object(core_es5["Injectable"])(),
    attachment_store___metadata("design:paramtypes", [typeof (attachment_store__a = typeof AttachmentHttpService !== "undefined" && AttachmentHttpService) === "function" && attachment_store__a || Object, typeof (attachment_store__b = typeof flash_messages_service_FlashMessagesService !== "undefined" && flash_messages_service_FlashMessagesService) === "function" && attachment_store__b || Object])
], attachment_store_AttachmentStore);

var attachment_store__a, attachment_store__b;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/attachment.store.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/service/event-validation.service.ts
var event_validation_service___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var event_validation_service___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};













var event_validation_service_EventValidationService = EventValidationService_1 = (function () {
    function EventValidationService(paymentStore, reservationStore, authenticationStore, rsvpStore, attachmentStore, eventStore, agencyLookupStore) {
        this.paymentStore = paymentStore;
        this.reservationStore = reservationStore;
        this.authenticationStore = authenticationStore;
        this.rsvpStore = rsvpStore;
        this.attachmentStore = attachmentStore;
        this.eventStore = eventStore;
        this.agencyLookupStore = agencyLookupStore;
    }
    EventValidationService.prototype.canEditContractSummary = function () {
        var _this = this;
        return this.eventStore.selectedEvent.flatMap(function (selectedEvent) {
            if (!selectedEvent || !selectedEvent.eventId) {
                return Object(of["of"])(true);
            }
            return _this.paymentStore.getLatestVendorFinalPayments().map(function (payments) {
                if (_this.authenticationStore.hasPermission('MultiVendor')) {
                    if (!selectedEvent.eventVendors || selectedEvent.eventVendors.length === 0) {
                        return true;
                    }
                    return selectedEvent.eventVendors.some(function (vendor) {
                        var payment = payments != null ? payments.filter(function (pay) { return pay.eventPartyId === vendor.eventPartyId; })[0] : null;
                        return !payment || !EventValidationService_1.PAID_STATUS_LIST.some(function (status) { return status === payment.status; });
                    });
                }
                return _this.canChangeEvent();
            });
        });
    };
    EventValidationService.prototype.canChangeReservations = function () {
        return this.canChangeEvent();
    };
    EventValidationService.prototype.canChangeRsvps = function () {
        return this.canChangeEvent();
    };
    EventValidationService.prototype.canAddAdjustments = function () {
        return this.canChangeEvent();
    };
    EventValidationService.prototype.canEditGroupCode = function () {
        var _this = this;
        return this.eventStore.selectedEvent.flatMap(function (selectedEvent) {
            if (!selectedEvent || !selectedEvent.eventId) {
                return Object(of["of"])(true);
            }
            return _this.paymentStore.getLatestFinalPayment().flatMap(function (latestFinalPayment) {
                return _this.reservationStore.getEventHasReservations().flatMap(function (eventHasReservations) {
                    return _this.hasPrePayment().map(function (hasPrepayment) {
                        if (_this.authenticationStore.isPropertyUser()) {
                            if (latestFinalPayment && PaymentStatus.REJECTED_WF_APPROVAL !== latestFinalPayment.status) {
                                return false;
                            }
                            if (eventHasReservations) {
                                return false;
                            }
                            if (hasPrepayment) {
                                return false;
                            }
                        }
                        return true;
                    });
                });
            });
        });
    };
    EventValidationService.prototype.canEditEventDates = function () {
        var _this = this;
        return this.eventStore.selectedEvent.flatMap(function (selectedEvent) {
            if (!selectedEvent || !selectedEvent.eventId) {
                return Object(of["of"])(true);
            }
            return _this.paymentStore.getLatestFinalPayment().flatMap(function (latestFinalPayment) {
                return _this.reservationStore.getEventHasReservations().flatMap(function (eventHasReservations) {
                    return _this.rsvpStore.getEventHasRsvps().flatMap(function (eventHasRsvps) {
                        return _this.hasPrePayment().flatMap(function (hasPrepayment) {
                            var agencyCode = selectedEvent && selectedEvent.eventAgency ? selectedEvent.eventAgency.code : undefined;
                            if (!agencyCode) {
                                return Object(of["of"])(true);
                            }
                            return _this.agencyLookupStore.isSubscriberAgency(selectedEvent.eventAgency.code).take(1).map(function (isSubscriberAgency) {
                                if (_this.authenticationStore.isPropertyUser()) {
                                    if (!isSubscriberAgency) {
                                        return true;
                                    }
                                }
                                if (_this.authenticationStore.hasPermission('MultiVendor')) {
                                    if (selectedEvent.eventVendors && selectedEvent.eventVendors.some(function (vendor) {
                                        return PartyType.PROPERTY === vendor.partyType && 'Y' === vendor.createdEvent;
                                    }) &&
                                        selectedEvent.eventAgency && selectedEvent.eventAgency.createdEvent !== 'Y') {
                                        return false;
                                    }
                                }
                                if (eventHasReservations) {
                                    return false;
                                }
                                if (eventHasRsvps) {
                                    var hotelCreatedEvent = selectedEvent.eventProperty && 'Y' === selectedEvent.eventProperty.createdEvent;
                                    if (!_this.authenticationStore.isPropertyUser() && hotelCreatedEvent) {
                                        return false;
                                    }
                                }
                                if (latestFinalPayment && latestFinalPayment.status) {
                                    if (_this.authenticationStore.isPropertyUser()) {
                                        return PaymentStatus.REJECTED_WF_APPROVAL === latestFinalPayment.status;
                                    }
                                    else {
                                        if (!EventValidationService_1.EDITABLE_STATUS_LIST_FOR_AGENCY.some(function (status) { return status === latestFinalPayment.status; })) {
                                            return false;
                                        }
                                    }
                                }
                                if (hasPrepayment && _this.authenticationStore.isPropertyUser() && isSubscriberAgency) {
                                    return false;
                                }
                                return true;
                            });
                        });
                    });
                });
            });
        });
    };
    EventValidationService.prototype.canEditEventCurrency = function () {
        var _this = this;
        return Observable["Observable"].combineLatest(this.eventStore.selectedEvent, this.paymentStore.getLatestVendorFinalPayments(), this.reservationStore.getEventHasReservations(), this.rsvpStore.getEventHasRsvps(), this.hasVendorPrePayments()).pipe(Object(operators["map"])(function (_a) {
            var selectedEvent = _a[0], latestVendorFinalPayment = _a[1], eventHasReservations = _a[2], eventHasRsvps = _a[3], hasVendorPrepayment = _a[4];
            if (!selectedEvent || !selectedEvent.eventId) {
                return true;
            }
            if (_this.authenticationStore.hasPermission('MultiVendor')) {
                if (selectedEvent.eventVendors && selectedEvent.eventVendors.some(function (vendor) {
                    return PartyType.PROPERTY === vendor.partyType && 'Y' === vendor.createdEvent;
                })) {
                    return false;
                }
            }
            if (eventHasReservations === true) {
                return false;
            }
            if (eventHasRsvps) {
                return false;
            }
            if (hasVendorPrepayment) {
                return false;
            }
            if (_this.authenticationStore.isPropertyUser() && latestVendorFinalPayment
                && latestVendorFinalPayment.length && latestVendorFinalPayment.length > 0
                && PaymentStatus.REJECTED_WF_APPROVAL !== latestVendorFinalPayment[0].status) {
                return false;
            }
            if (!_this.authenticationStore.isPropertyUser() && latestVendorFinalPayment
                && latestVendorFinalPayment.length && latestVendorFinalPayment.length > 0) {
                if (_this.somePaymentIsNotRejected(latestVendorFinalPayment)) {
                    return false;
                }
            }
            return true;
        }));
    };
    EventValidationService.prototype.somePaymentIsNotRejected = function (latestVendorFinalPayment) {
        return latestVendorFinalPayment.some(function (payment) {
            var isRejectedPayment = EventValidationService_1.EDITABLE_CURRENCY_STATUS_LIST_FOR_AGENCY.some(function (status) {
                // Comparing with == because status is a PaymentStatus enum and payment.status is a string at runtime
                // (even though it is declared as PaymentStatus in the Payment model)
                // tslint:disable-next-line:triple-equals
                return status == payment.status;
            });
            return !isRejectedPayment;
        });
    };
    EventValidationService.prototype.canEditShoulderDates = function () {
        return this.canChangeEvent();
    };
    EventValidationService.prototype.canChangeEvent = function () {
        var _this = this;
        return this.paymentStore.getLatestFinalPayment().map(function (latestFinalPayment) {
            if (_this.authenticationStore.isPropertyUser() && latestFinalPayment && latestFinalPayment.status) {
                if (EventValidationService_1.NON_EDITABLE_STATUS_LIST.some(function (status) { return status === latestFinalPayment.status; })) {
                    return false;
                }
            }
            return true;
        });
    };
    EventValidationService.prototype.hasPrePayment = function () {
        return this.paymentStore.getPrepayment().map(function (prepayment) {
            if (prepayment) {
                return true;
            }
            return false;
        });
    };
    EventValidationService.prototype.hasVendorPrePayments = function () {
        return this.paymentStore.getLatestVendorPrepayments().map(function (prepayments) {
            if (prepayments && prepayments.length > 0) {
                return true;
            }
            return false;
        });
    };
    EventValidationService.prototype.canChangeProperty = function () {
        var _this = this;
        return this.eventStore.selectedEvent.flatMap(function (selectedEvent) {
            if (!selectedEvent || !selectedEvent.eventId) {
                return Object(of["of"])(true);
            }
            if (selectedEvent.eventProperty && selectedEvent.eventProperty.mergedEvent === 'Y') {
                return Object(of["of"])(false);
            }
            return _this.reservationStore.getEventHasReservations().flatMap(function (eventHasReservations) {
                return _this.rsvpStore.getEventHasRsvps().flatMap(function (eventHasRsvps) {
                    return _this.paymentStore.getLatestFinalPayment().flatMap(function (latestFinalPayment) {
                        return _this.paymentStore.getLatestVendorPrepayments().flatMap(function (prepayments) {
                            return _this.attachmentStore.attachments.map(function (attachments) {
                                if (eventHasReservations) {
                                    return false;
                                }
                                if (eventHasRsvps) {
                                    return false;
                                }
                                if (latestFinalPayment && latestFinalPayment.status) {
                                    return false;
                                }
                                if (prepayments && prepayments.length > 0) {
                                    return false;
                                }
                                if (attachments && attachments.size > 0) {
                                    return false;
                                }
                                return true;
                            });
                        });
                    });
                });
            });
        });
    };
    EventValidationService.prototype.canChangeAgency = function () {
        var _this = this;
        var finalPayments$ = this.authenticationStore.isMultiVendor()
            ? this.paymentStore.getLatestVendorFinalPayments()
            : this.paymentStore.getLatestFinalPayment();
        var hasPrepayment$ = this.authenticationStore.isMultiVendor()
            ? this.hasVendorPrePayments()
            : this.hasPrePayment();
        return this.eventStore.selectedEvent.flatMap(function (selectedEvent) {
            if (!selectedEvent || !selectedEvent.eventId) {
                return Object(of["of"])(true);
            }
            return Observable["Observable"].combineLatest(_this.reservationStore.getEventHasReservations(), finalPayments$, hasPrepayment$).pipe(Object(operators["map"])(function (_a) {
                var eventHasReservations = _a[0], latestFinalPayment = _a[1], hasPrepayment = _a[2];
                if (_this.authenticationStore.isPropertyUser()) {
                    var hotelCreatedEvent = selectedEvent.eventProperty && 'Y' === selectedEvent.eventProperty.createdEvent;
                    if (!hotelCreatedEvent) {
                        return false;
                    }
                }
                if (hasPrepayment) {
                    return false;
                }
                if (eventHasReservations) {
                    return false;
                }
                if (latestFinalPayment) {
                    if (Array.isArray(latestFinalPayment)) {
                        if (latestFinalPayment.length && latestFinalPayment.length > 0) {
                            if (latestFinalPayment.some(function (payment) { return payment && payment.status; })) {
                                return false;
                            }
                        }
                    }
                    else if (latestFinalPayment.status) {
                        return false;
                    }
                }
                return true;
            }));
        });
    };
    EventValidationService.prototype.canAddVendor = function () {
        var _this = this;
        return this.eventStore.selectedEvent.flatMap(function (selectedEvent) {
            if (!selectedEvent || !selectedEvent.eventId) {
                return Object(of["of"])(true);
            }
            if (!selectedEvent.eventVendors || selectedEvent.eventVendors.length === 0) {
                return Object(of["of"])(true);
            }
            return _this.paymentStore.getLatestVendorFinalPayments().map(function (payments) {
                return selectedEvent.eventVendors.some(function (vendor) {
                    var payment = payments != null ? payments.filter(function (pay) { return pay.eventPartyId === vendor.eventPartyId; })[0] : null;
                    return !payment || !EventValidationService_1.PAID_STATUS_LIST.some(function (status) { return status === payment.status; });
                });
            });
        });
    };
    EventValidationService.prototype.canRemoveVendor = function (vendor) {
        var _this = this;
        return this.eventStore.selectedEvent.flatMap(function (selectedEvent) {
            if (!selectedEvent || !selectedEvent.eventId) {
                return Object(of["of"])(true);
            }
            if (!vendor) {
                return Object(of["of"])(true);
            }
            // subscriber vendor created the event
            if (vendor.subscriber && vendor.createdEvent === 'Y' && vendor.mergedEvent !== 'Y') {
                return Object(of["of"])(false);
            }
            return _this.paymentStore.getLatestVendorPrepayments().flatMap(function (prepayments) {
                return _this.paymentStore.getLatestVendorFinalPayments().flatMap(function (payments) {
                    return _this.reservationStore.getHasReservationsByEventPartyId(vendor.eventPartyId).flatMap(function (hasReservationsByEventPartyId) {
                        return _this.rsvpStore.getHasRsvpsByEventPartyId(vendor.eventPartyId).map(function (hasRsvpsByEventPartyId) {
                            // vendor has NOT prepayments
                            var prepayment = prepayments && prepayments.length > 0 ?
                                prepayments.filter(function (prepay) { return prepay.eventPartyId === vendor.eventPartyId; })[0] : null;
                            if (prepayment) {
                                return false;
                            }
                            // vendor has NOT last final payment with status REQUEST_REJECTED and INVOICE_REJECTED
                            var latestFinalPayment = payments != null ? payments.filter(function (pay) { return pay.eventPartyId === vendor.eventPartyId; })[0] : null;
                            if (latestFinalPayment && latestFinalPayment.status
                                && !EventValidationService_1.EDITABLE_STATUS_LIST_FOR_AGENCY.some(function (status) { return status === latestFinalPayment.status; })) {
                                return false;
                            }
                            if (hasReservationsByEventPartyId) {
                                return false;
                            }
                            if (hasRsvpsByEventPartyId) {
                                return false;
                            }
                            return true;
                        });
                    });
                });
            });
        });
    };
    EventValidationService.prototype.canEditVendorContact = function (vendor) {
        var _this = this;
        return this.eventStore.selectedEvent.flatMap(function (selectedEvent) {
            if (!selectedEvent || !selectedEvent.eventId) {
                return Object(of["of"])(true);
            }
            if (!vendor) {
                return Object(of["of"])(true);
            }
            return _this.paymentStore.getLatestVendorFinalPayments().map(function (payments) {
                // vendor has NOT last final payment with status REQUEST_REJECTED and INVOICE_REJECTED
                var latestFinalPayment = payments != null ? payments.filter(function (pay) { return pay.eventPartyId === vendor.eventPartyId; })[0] : null;
                if (latestFinalPayment && latestFinalPayment.status
                    && !EventValidationService_1.CONTACT_EDITABLE_STATUS_LIST_FOR_AGENCY.some(function (status) { return status === latestFinalPayment.status; })) {
                    return false;
                }
                return true;
            });
        });
    };
    EventValidationService.prototype.canEditVendorCommRate = function (vendor) {
        var _this = this;
        return this.eventStore.selectedEvent.flatMap(function (selectedEvent) {
            if (!selectedEvent || !selectedEvent.eventId) {
                return Object(of["of"])(true);
            }
            if (!vendor) {
                return Object(of["of"])(true);
            }
            return _this.reservationStore.getHasReservationsByEventPartyId(vendor.eventPartyId).flatMap(function (hasReservationsByEventPartyId) {
                return _this.paymentStore.getLatestVendorPrepayments().flatMap(function (prepayments) {
                    return _this.paymentStore.getLatestVendorFinalPayments().map(function (payments) {
                        if (vendor.subscriber) {
                            if (hasReservationsByEventPartyId) {
                                return false;
                            }
                            // vendor has NOT prepayments
                            var prepayment = prepayments && prepayments.length > 0 ?
                                prepayments.filter(function (prepay) { return prepay.eventPartyId === vendor.eventPartyId; })[0] : null;
                            if (prepayment) {
                                return false;
                            }
                            // vendor has NOT final payments
                            var latestFinalPayment = payments != null ? payments.filter(function (pay) { return pay.eventPartyId === vendor.eventPartyId; })[0] : null;
                            if (latestFinalPayment && latestFinalPayment.status && PaymentStatus.REJECTED_WF_APPROVAL !== latestFinalPayment.status) {
                                return false;
                            }
                        }
                        else {
                            // vendor has NOT last final payment with status REQUEST_REJECTED and INVOICE_REJECTED
                            var latestFinalPayment_1 = payments != null ? payments.filter(function (pay) { return pay.eventPartyId === vendor.eventPartyId; })[0] : null;
                            if (latestFinalPayment_1 && latestFinalPayment_1.status
                                && !EventValidationService_1.EDITABLE_STATUS_LIST_FOR_AGENCY.some(function (status) { return status === latestFinalPayment_1.status; })) {
                                return false;
                            }
                        }
                        return true;
                    });
                });
            });
        });
    };
    EventValidationService.prototype.canEditAgencyContact = function () {
        return this.canEditContact();
    };
    EventValidationService.prototype.canEditClientContact = function () {
        return this.canEditContact();
    };
    EventValidationService.prototype.canEditContact = function () {
        var _this = this;
        return this.eventStore.selectedEvent.flatMap(function (selectedEvent) {
            if (!selectedEvent || !selectedEvent.eventId) {
                return Object(of["of"])(true);
            }
            return _this.paymentStore.getLatestVendorFinalPayments().map(function (payments) {
                if (!_this.authenticationStore.isPropertyUser()) {
                    return selectedEvent.eventVendors.some(function (vendor) {
                        var payment = payments != null ? payments.filter(function (pay) { return pay.eventPartyId === vendor.eventPartyId; })[0] : null;
                        return !payment || EventValidationService_1.CONTACT_EDITABLE_STATUS_LIST_FOR_AGENCY.some(function (status) { return status === payment.status; });
                    });
                }
                return true;
            });
        });
    };
    return EventValidationService;
}());
event_validation_service_EventValidationService.NON_EDITABLE_STATUS_LIST = [
    PaymentStatus.READY,
    PaymentStatus.PENDING,
    PaymentStatus.INVOICED,
    PaymentStatus.INVOICE_REJECTED,
    PaymentStatus.FUNDED,
    PaymentStatus.PAY_SENT,
    PaymentStatus.PAY_REJECTED,
    PaymentStatus.ERROR,
    PaymentStatus.CANCELLED,
    PaymentStatus.CHECK_STOPPED,
    PaymentStatus.PAY_CLEARED,
    PaymentStatus.PAY_REISSUED,
    PaymentStatus.PENDING_WF_APPROVAL
];
event_validation_service_EventValidationService.EDITABLE_STATUS_LIST_FOR_AGENCY = [
    PaymentStatus.REQUEST_REJECTED,
    PaymentStatus.INVOICE_REJECTED
];
event_validation_service_EventValidationService.EDITABLE_CURRENCY_STATUS_LIST_FOR_AGENCY = [
    PaymentStatus.REQUEST_REJECTED,
    PaymentStatus.INVOICE_REJECTED,
    PaymentStatus.PAY_REJECTED
];
event_validation_service_EventValidationService.CONTACT_EDITABLE_STATUS_LIST_FOR_AGENCY = [
    PaymentStatus.REQUESTED,
    PaymentStatus.RESENT_REQUEST,
    PaymentStatus.REQUEST_REJECTED,
    PaymentStatus.PENDING,
    PaymentStatus.READY,
    PaymentStatus.FUNDED,
    PaymentStatus.INVOICED,
    PaymentStatus.INVOICE_REJECTED
];
event_validation_service_EventValidationService.PAID_STATUS_LIST = [
    PaymentStatus.PAID_DIRECT,
    PaymentStatus.PAY_SENT,
    PaymentStatus.PAY_CLEARED,
    PaymentStatus.CHECK_STOPPED,
    PaymentStatus.PAY_REISSUED
];
event_validation_service_EventValidationService = EventValidationService_1 = event_validation_service___decorate([
    Object(core_es5["Injectable"])(),
    event_validation_service___metadata("design:paramtypes", [typeof (event_validation_service__a = typeof payment_store_PaymentStore !== "undefined" && payment_store_PaymentStore) === "function" && event_validation_service__a || Object, typeof (event_validation_service__b = typeof reservation_store_ReservationStore !== "undefined" && reservation_store_ReservationStore) === "function" && event_validation_service__b || Object, typeof (event_validation_service__c = typeof authentication_store_AuthenticationStore !== "undefined" && authentication_store_AuthenticationStore) === "function" && event_validation_service__c || Object, typeof (event_validation_service__d = typeof rsvp_store_RsvpStore !== "undefined" && rsvp_store_RsvpStore) === "function" && event_validation_service__d || Object, typeof (event_validation_service__e = typeof attachment_store_AttachmentStore !== "undefined" && attachment_store_AttachmentStore) === "function" && event_validation_service__e || Object, typeof (event_validation_service__f = typeof event_store_EventStore !== "undefined" && event_store_EventStore) === "function" && event_validation_service__f || Object, typeof (event_validation_service__g = typeof agency_lookup_store_AgencyLookupStore !== "undefined" && agency_lookup_store_AgencyLookupStore) === "function" && event_validation_service__g || Object])
], event_validation_service_EventValidationService);

var EventValidationService_1, event_validation_service__a, event_validation_service__b, event_validation_service__c, event_validation_service__d, event_validation_service__e, event_validation_service__f, event_validation_service__g;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/event-validation.service.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/utils/agency-lookup-converter.ts


var agency_lookup_converter_AgencyLookupConverter = (function () {
    function AgencyLookupConverter() {
    }
    AgencyLookupConverter.updateFormFields = function (detail, contactLookupForm, agencyLookupStore) {
        contactLookupForm.patchValue({
            name: detail.name,
            dbaName: detail.dbaName,
            line1: detail.address.line1,
            line2: detail.address.line2,
            line3: detail.address.line3,
            countryCode: detail.address.countryCode,
            city: detail.address.city,
            state: detail.address.state,
            postalCode: detail.address.postalCode,
            agencyId: detail.agencyId
        });
        contactLookupForm.controls['contact'].patchValue({
            firstName: detail.contact.firstName,
            lastName: detail.contact.lastName,
            email: detail.contact.email,
            phone: detail.contact.phone,
            fax: detail.contact.fax
        });
        agencyLookupStore.clearSearchResults();
    };
    AgencyLookupConverter.agencyLookupDetailToParty = function (detail) {
        return new Party({
            eventPartyId: null,
            version: null,
            createdDate: null,
            modifiedDate: null,
            brand: null,
            chain: null,
            propertyId: null,
            agencyId: detail.agencyId,
            partyType: PartyType.AGENCY,
            code: detail.agencyId,
            name: detail.name,
            dbaName: detail.dbaName,
            countryCode: detail.address.countryCode,
            eventId: null,
            line1: detail.address.line1,
            line2: detail.address.line2,
            line3: detail.address.line3,
            city: detail.address.city,
            state: detail.address.state,
            postalCode: detail.address.postalCode,
            eventReferenceNumber: null,
            autoGeneratedCode: detail.autoGeneratedCode,
            manuallyAdded: detail.manuallyAdded,
            contact: {
                eventContactId: null,
                version: null,
                createdDate: null,
                modifiedDate: null,
                partyType: PartyType.AGENCY,
                eventId: null,
                firstName: null,
                lastName: null,
                email: null,
                phone: null,
                fax: null
            }
        });
    };
    return AgencyLookupConverter;
}());

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/agency-lookup-converter.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/agency-form/agency-form.component.ts
var agency_form_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var agency_form_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};


















var agency_form_component_AgencyFormComponent = (function () {
    function AgencyFormComponent(formBuilder, agencyLookupStore, logService, paymentStore, _commonDataStore, authenticationStore, environment, eventValidationService) {
        this.formBuilder = formBuilder;
        this.agencyLookupStore = agencyLookupStore;
        this.logService = logService;
        this.paymentStore = paymentStore;
        this._commonDataStore = _commonDataStore;
        this.authenticationStore = authenticationStore;
        this.environment = environment;
        this.eventValidationService = eventValidationService;
        this.isReadOnly = false;
        this.outputEmail = new core_es5["EventEmitter"]();
        this.newTravelAgency = false;
        this.isAgencySelected = false;
        this.isStateRequired = pioneer_validators_PioneerValidators.isStateRequired;
        this.isPostalCodeRequired = pioneer_validators_PioneerValidators.isPostalCodeRequired;
        this.hasPayments = false;
        this.selectedAgency = new core_es5["EventEmitter"]();
        this.user = this.authenticationStore.getUserSync();
    }
    Object.defineProperty(AgencyFormComponent.prototype, "event", {
        set: function (event) {
            this.onyxEvent = event;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AgencyFormComponent.prototype, "agencyStore", {
        get: function () {
            return this.agencyLookupStore;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AgencyFormComponent.prototype, "commonDataStore", {
        get: function () {
            return this._commonDataStore;
        },
        enumerable: true,
        configurable: true
    });
    AgencyFormComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (!this.onyxEvent) {
            this.onyxEvent = new OnyxEvent();
        }
        this.authenticationStore.user.subscribe(function (user) {
            _this.user = user;
        });
        this.contactLookupForm = this.dataToFormGroup(this.onyxEvent.eventAgency);
        this.agencyLookupStore.selected.subscribe(function (details) {
            _this.logService.verbose("agency details " + JSON.stringify(details));
            var party = agency_lookup_converter_AgencyLookupConverter.agencyLookupDetailToParty(details);
            _this.agencyLookupStore.clearSearchResults();
            _this.dataToFormGroup(party);
        });
        if (this.onyxEvent.eventAgency && this.onyxEvent.eventAgency.eventPartyId) {
            this.isAgencySelected = true;
        }
        if (!this.onyxEvent.eventId) {
            this.hasPayments = false;
        }
        else {
            this.paymentStore.getLatestFinalPayment()
                .take(1)
                .subscribe(function (lastFinalPayment) {
                _this.hasPayments = Boolean(_this.hasPayments || (lastFinalPayment && lastFinalPayment.eventPaymentId));
            });
            this.paymentStore.getPrepayment()
                .take(1)
                .subscribe(function (prepayment) {
                _this.hasPayments = Boolean(_this.hasPayments || (prepayment && prepayment.eventPaymentId));
            });
        }
        this.states$ = this.commonDataStore.states;
        this.states$.subscribe(function (states) {
            if (states && states.length > 0) {
                var stateFormControl = _this.contactLookupForm ? _this.contactLookupForm.get('state') : undefined;
                if (stateFormControl) {
                    stateFormControl.enable();
                }
            }
        });
        if (this.user.allArcIatas && !(this.onyxEvent.eventAgency && this.onyxEvent.eventAgency.code)) {
            var agencyUser = new AgencyLookupSummary({
                agencyId: this.user.allArcIatas[0],
                name: '',
                address: null,
                manuallyAdded: false,
            });
            this.onSelectedAgency(agencyUser);
        }
        this.canChangeAgency$ = this.eventValidationService.canChangeAgency();
    };
    AgencyFormComponent.prototype.ngOnChanges = function (changes) {
        if (this.emailValidation() && changes.inputEmail && this.contactLookupForm) {
            this.checkDuplicatedEmailError(this.contactLookupForm.get('contact').get('email').value);
        }
        if (!changes['event']) {
            return;
        }
        this.logService.debug("user logged-in inside ngOnChanges: " + this.user);
        this.dataToFormGroup(this.onyxEvent.eventAgency);
    };
    AgencyFormComponent.prototype.inlineSearchTouched = function () {
        var _this = this;
        // Check for an error if the user has never tried to select an agency
        // A delay is required so that this logic is done after onSelectedProperty()
        setTimeout(function () {
            if (!_this.lookupSelected) {
                _this.agencyLookupStore.clearSearchResults();
            }
            else {
                _this.lookupSelected = false;
            }
        }, 100);
    };
    AgencyFormComponent.prototype.updateResults = function (results) {
        this.logService.verbose("results: " + results);
        this.summaryResults = results;
    };
    AgencyFormComponent.prototype.onSelectedAgency = function (summary) {
        this.lookupSelected = true;
        this.isAgencySelected = true;
        this.newTravelAgency = false;
        this.logService.debug("agencySummary " + JSON.stringify(summary));
        this.agencyLookupStore.getDetail(summary).subscribe();
        this.selectedAgency.emit();
    };
    AgencyFormComponent.prototype.dataToFormGroup = function (party) {
        if (!party) {
            party = new Party();
        }
        else {
            if (!party.contact) {
                party.contact = new Contact();
            }
            party = new Party(party);
        }
        /*
         * ME-17780 Set the user email as agency contact email by default when user has ViewOnlyUserEvents permission
         */
        this.agencyContactEmail = party.contact.email;
        if (this.authenticationStore.hasPermission(['ViewOnlyUserEvents'])) {
            this.agencyContactEmail = this.agencyContactEmail ? this.agencyContactEmail : this.user.email.toLowerCase();
        }
        this.createForm(party, this.newTravelAgency);
        if (!party.countryCode) {
            this.contactLookupForm.get('state').disable();
        }
        return this.contactLookupForm;
    };
    AgencyFormComponent.prototype.startCreatingAgency = function () {
        this.newTravelAgency = true;
        this.isAgencySelected = false;
        this.contactLookupForm = this.dataToFormGroup(null);
    };
    AgencyFormComponent.prototype.onCountryCodeChanged = function () {
        this.contactLookupForm.get('state').disable();
        this.contactLookupForm.get('state').reset();
        this.commonDataStore.loadStatesFromCountry(this.contactLookupForm.get('countryCode').value).take(1).subscribe();
    };
    AgencyFormComponent.prototype.createForm = function (party, withValidators) {
        var _this = this;
        this.commonDataStore.loadStatesFromCountry(party.countryCode).take(1).subscribe();
        this.contactLookupForm = this.formBuilder.group({
            newTravelAgency: [this.newTravelAgency, null],
            code: [party.code, withValidators ? [forms_es5["Validators"].maxLength(8), pioneer_validators_PioneerValidators.isValidAgencyId] : []],
            name: [
                party.name ? party.name.substring(0, 50) : party.name,
                withValidators ? [forms_es5["Validators"].required, forms_es5["Validators"].maxLength(50), pioneer_validators_PioneerValidators.isWhitespaceValidated] : []
            ],
            dbaName: [
                party.dbaName ? party.dbaName.substring(0, 50) : party.dbaName,
                withValidators ? [forms_es5["Validators"].maxLength(50)] : []
            ],
            countryCode: [party.countryCode, withValidators ? [forms_es5["Validators"].required, pioneer_validators_PioneerValidators.isWhitespaceValidated] : []],
            countryName: ['', null],
            line1: [party.line1, withValidators ? [forms_es5["Validators"].required, forms_es5["Validators"].maxLength(50), pioneer_validators_PioneerValidators.isWhitespaceValidated] : []],
            line2: [party.line2, withValidators ? [forms_es5["Validators"].maxLength(50)] : []],
            line3: [party.line3, withValidators ? [forms_es5["Validators"].maxLength(50)] : []],
            partyType: [PartyType.AGENCY, null],
            city: [party.city, withValidators ? [forms_es5["Validators"].required, forms_es5["Validators"].maxLength(50), pioneer_validators_PioneerValidators.isWhitespaceValidated] : []],
            state: [party.state, null],
            stateName: ['', null],
            postalCode: [party.postalCode, withValidators ? [forms_es5["Validators"].maxLength(15)] : []],
            agencyId: [party.code, null],
            autoGeneratedCode: [party.autoGeneratedCode, null],
            manuallyAdded: [party.manuallyAdded, null],
            contact: this.formBuilder.group({
                firstName: [party.contact.firstName, withValidators ? [forms_es5["Validators"].maxLength(50)] : []],
                lastName: [party.contact.lastName, withValidators ? [forms_es5["Validators"].maxLength(50)] : []],
                partyType: [PartyType.AGENCY, null],
                email: [this.agencyContactEmail,
                    [forms_es5["Validators"].required, forms_es5["Validators"].maxLength(75), pioneer_validators_PioneerValidators.isValidEmail]],
                phone: [party.contact.phone, withValidators ? [forms_es5["Validators"].maxLength(20)] : []],
                fax: [party.contact.fax, withValidators ? [forms_es5["Validators"].maxLength(20)] : []]
            }),
            subscriber: new forms_es5["FormControl"](),
            eventAgencyStatus: new forms_es5["FormControl"](),
            originalCode: new forms_es5["FormControl"]()
        }, {
            validator: forms_es5["Validators"].compose([
                pioneer_validators_PioneerValidators.postalCodeCountryCrossValidator('postalCode', 'countryCode'),
                pioneer_validators_PioneerValidators.countryStateCrossValidator('countryCode', 'state')
            ])
        });
        if (party.contact.email) {
            this.outputEmail.emit(party.contact.email);
        }
        if (this.emailValidation()) {
            this.contactLookupForm.get('contact').get('email').valueChanges.subscribe(function (value) {
                _this.outputEmail.emit(value);
                _this.checkDuplicatedEmailError(value);
            });
        }
        this.selectedCountry$ = this.commonDataStore.getCountry(party.countryCode);
        // Set countryName form control
        this.selectedCountry$.subscribe(function (country) {
            _this.contactLookupForm.controls['countryName'].setValue(country.value);
        });
        if (party.countryCode) {
            this.selectedState$ = this.commonDataStore.getState(party.countryCode, party.state);
        }
        else {
            this.selectedState$ = Observable["Observable"].of(new DropdownItem('', party.state));
        }
        this.parentForm.setControl('eventAgency', this.contactLookupForm);
    };
    AgencyFormComponent.prototype.checkDuplicatedEmailError = function (formEmailValue) {
        if (formEmailValue && this.inputEmail && formEmailValue.toLowerCase() === this.inputEmail.toLowerCase()) {
            this.contactLookupForm.get('contact').get('email').setErrors({ 'email_contact_property_agency_same': true });
        }
        else {
            if (this.contactLookupForm && this.contactLookupForm.get('contact').get('email').errors
                && this.contactLookupForm.get('contact').get('email').errors['email_contact_property_agency_same']) {
                this.contactLookupForm.get('contact').get('email').setErrors(null);
            }
        }
    };
    AgencyFormComponent.prototype.emailValidation = function () {
        return this.environment.emailValidation;
    };
    AgencyFormComponent.prototype.uiShowSystemGeneratedBadge = function () {
        if (!this.newTravelAgency && this.contactLookupForm.get('autoGeneratedCode').value) {
            return true;
        }
        else {
            return false;
        }
    };
    AgencyFormComponent.prototype.uiShowManualAgencyWarningMessage = function () {
        if (this.newTravelAgency || this.contactLookupForm.get('manuallyAdded').value) {
            return true;
        }
        else {
            return false;
        }
    };
    AgencyFormComponent.prototype.isAgencyInlineSearchVisible = function () {
        return !this.hasPayments &&
            !this.isReadOnly &&
            (!this.user.allArcIatas || (this.user.allArcIatas && this.user.customerInfo && this.user.customerInfo.length >= 2));
    };
    AgencyFormComponent.prototype.isCreateNewAgencyEnabled = function () {
        return !this.user.allArcIatas;
    };
    AgencyFormComponent.prototype.isAgencyInlineSearchEnabled = function () {
        if (this.onyxEvent.eventId === null) {
            return true;
        }
        if (this.authenticationStore.isAgencyUser()) {
            return (this.user.allArcIatas && this.user.customerInfo && this.user.customerInfo.length >= 2);
        }
        else {
            return (!this.onyxEvent.eventAgency || this.onyxEvent.eventAgency.createdEvent !== 'Y'
                || this.onyxEvent.eventProperty.mergedEvent === 'Y');
        }
    };
    AgencyFormComponent.prototype.isFieldEditable = function () {
        return (this.authenticationStore.isPropertyUser() || this.authenticationStore.isSupportUser())
            && !this.isReadOnly && !this.hasPayments && !(this.onyxEvent.eventAgency && this.onyxEvent.eventAgency.subscriber);
    };
    AgencyFormComponent.prototype.isNewAgency = function () {
        return this.newTravelAgency || !this.onyxEvent.eventAgency;
    };
    AgencyFormComponent.prototype.isEditableOnlyManuallyAdded = function () {
        if (this.isNewAgency()) {
            return true;
        }
        if (this.isFieldEditable() && this.onyxEvent.eventAgency && this.onyxEvent.eventAgency.manuallyAdded) {
            return true;
        }
        return false;
    };
    AgencyFormComponent.prototype.isEditableNonSubscriber = function () {
        if (this.isNewAgency()) {
            return true;
        }
        if (this.isFieldEditable()) {
            return true;
        }
        return false;
    };
    return AgencyFormComponent;
}());
agency_form_component___decorate([
    Object(core_es5["Input"])('parentForm'),
    agency_form_component___metadata("design:type", typeof (agency_form_component__a = typeof forms_es5["FormGroup"] !== "undefined" && forms_es5["FormGroup"]) === "function" && agency_form_component__a || Object)
], agency_form_component_AgencyFormComponent.prototype, "parentForm", void 0);
agency_form_component___decorate([
    Object(core_es5["Input"])('event'),
    agency_form_component___metadata("design:type", typeof (agency_form_component__b = typeof OnyxEvent !== "undefined" && OnyxEvent) === "function" && agency_form_component__b || Object),
    agency_form_component___metadata("design:paramtypes", [typeof (agency_form_component__c = typeof OnyxEvent !== "undefined" && OnyxEvent) === "function" && agency_form_component__c || Object])
], agency_form_component_AgencyFormComponent.prototype, "event", null);
agency_form_component___decorate([
    Object(core_es5["Input"])(),
    agency_form_component___metadata("design:type", Object)
], agency_form_component_AgencyFormComponent.prototype, "isReadOnly", void 0);
agency_form_component___decorate([
    Object(core_es5["Input"])(),
    agency_form_component___metadata("design:type", String)
], agency_form_component_AgencyFormComponent.prototype, "inputEmail", void 0);
agency_form_component___decorate([
    Object(core_es5["Output"])(),
    agency_form_component___metadata("design:type", typeof (agency_form_component__d = typeof core_es5["EventEmitter"] !== "undefined" && core_es5["EventEmitter"]) === "function" && agency_form_component__d || Object)
], agency_form_component_AgencyFormComponent.prototype, "outputEmail", void 0);
agency_form_component___decorate([
    Object(core_es5["Output"])(),
    agency_form_component___metadata("design:type", Object)
], agency_form_component_AgencyFormComponent.prototype, "selectedAgency", void 0);
agency_form_component_AgencyFormComponent = agency_form_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-agency-form',
        template: __webpack_require__("3Ng8")
    }),
    agency_form_component___metadata("design:paramtypes", [typeof (agency_form_component__e = typeof forms_es5["FormBuilder"] !== "undefined" && forms_es5["FormBuilder"]) === "function" && agency_form_component__e || Object, typeof (agency_form_component__f = typeof agency_lookup_store_AgencyLookupStore !== "undefined" && agency_lookup_store_AgencyLookupStore) === "function" && agency_form_component__f || Object, typeof (agency_form_component__g = typeof log_service_LogService !== "undefined" && log_service_LogService) === "function" && agency_form_component__g || Object, typeof (agency_form_component__h = typeof payment_store_PaymentStore !== "undefined" && payment_store_PaymentStore) === "function" && agency_form_component__h || Object, typeof (agency_form_component__j = typeof common_data_store_CommonDataStore !== "undefined" && common_data_store_CommonDataStore) === "function" && agency_form_component__j || Object, typeof (agency_form_component__k = typeof authentication_store_AuthenticationStore !== "undefined" && authentication_store_AuthenticationStore) === "function" && agency_form_component__k || Object, typeof (agency_form_component__l = typeof EnvironmentConfiguration !== "undefined" && EnvironmentConfiguration) === "function" && agency_form_component__l || Object, typeof (agency_form_component__m = typeof event_validation_service_EventValidationService !== "undefined" && event_validation_service_EventValidationService) === "function" && agency_form_component__m || Object])
], agency_form_component_AgencyFormComponent);

var agency_form_component__a, agency_form_component__b, agency_form_component__c, agency_form_component__d, agency_form_component__e, agency_form_component__f, agency_form_component__g, agency_form_component__h, agency_form_component__j, agency_form_component__k, agency_form_component__l, agency_form_component__m;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/agency-form.component.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/attachment/attachment.component.ts
var attachment_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var attachment_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};









var attachment_component_AttachmentComponent = (function () {
    function AttachmentComponent(attachmentStore, flashMessagesService, authStore, environment) {
        this.attachmentStore = attachmentStore;
        this.flashMessagesService = flashMessagesService;
        this.authStore = authStore;
        this.environment = environment;
        /**
         * Used to determine if the upload bar should be shown while an attachment is uploading.
         * Determines animation delay before attachment list is refreshed.
         * @type {boolean}
         */
        this.isUploadInProgress = false;
        /**
         * Set when attachment delete starts.
         * Determines animation length before attachment list is refreshed.
         * @type {boolean}
         */
        this.isDeleteInProgress = false;
        /**
         * Sets css class on newest item.
         * @type {boolean}
         */
        this.isNewAttachment = false;
        this.startDate = new Date();
        this.fileTypes = this.environment.events.acceptedFileTypes;
        this.maxFileSize = this.environment.events.maxFileSize * 1024 * 1024;
        this.attachments = Object(immutable["List"])([]);
    }
    Object.defineProperty(AttachmentComponent.prototype, "eventId", {
        set: function (eventId) {
            this._eventId = eventId;
        },
        enumerable: true,
        configurable: true
    });
    AttachmentComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.removedAttachments = new Set();
        if (!this._eventId) {
            throw new Error("An event ID is required to create the \"pioneer-attachement\" component");
        }
        if (!this.vendor) {
            throw new Error("A vendor is required to create the \"pioneer-attachement\" component");
        }
        this.attachmentStore.attachments.map(function (attachments) {
            return attachments.filter(function (attachment) {
                return attachment.eventPartyId && attachment.eventPartyId === _this.vendor.eventPartyId;
            });
        }).subscribe(function (attachments) {
            // No animation delay needed if we're not deleting or uploading an attachment.
            var animationDelay = 0;
            if (_this.isDeleteInProgress) {
                animationDelay = 500;
            }
            else if (_this.isUploadInProgress) {
                animationDelay = 1000;
            }
            setTimeout(function () {
                _this.attachments = attachments;
                _this.isNewAttachment = _this.isUploadInProgress;
                // When attachments are refreshed, "reset" page (nothing uploading or being deleted)
                _this.isUploadInProgress = false;
                _this.isDeleteInProgress = false;
                _this.removedAttachments = new Set();
            }, _this.getAnimationDelay(animationDelay, _this.startDate));
        });
        this.authStore.user.take(1).subscribe(function (user) {
            _this.user = user;
        });
    };
    AttachmentComponent.prototype.uploadFile = function (inputEvent) {
        var _this = this;
        this.startDate = new Date();
        this.isUploadInProgress = true;
        if (!inputEvent || !inputEvent.srcElement || !inputEvent.srcElement.files || inputEvent.srcElement.files.size === 0) {
            this.handleUploadError('MESSAGES.ERROR.UPLOAD_ATTACHMENT');
            return;
        }
        var file = inputEvent.srcElement.files[0];
        this.clearFileInput();
        if (file.size > this.maxFileSize) {
            this.handleUploadError('MESSAGES.ERROR.ATTACHMENT_TOO_LARGE');
            return;
        }
        if (this.environment.events.acceptedFileTypes.indexOf(file.type) < 0) {
            this.handleUploadError('MESSAGES.ERROR.ATTACHMENT_UNSUPPORTED_FILE_TYPE');
            return;
        }
        this.attachmentStore.addAttachment(this._eventId, this.vendor.eventPartyId, file, this.isMultiVendor())
            .catch(function (error) {
            _this.flashMessagesService.error('MESSAGES.ERROR.UPLOAD_ATTACHMENT', "Error uploading attachment: " + error);
            _this.isUploadInProgress = false;
            _this.isNewAttachment = false;
            return Observable["Observable"].throw(error);
        }).subscribe();
    };
    AttachmentComponent.prototype.openFile = function (attachment) {
        var _this = this;
        this.attachmentStore.get(attachment.uniqueId)
            .catch(function (error) {
            _this.flashMessagesService.error('MESSAGES.ERROR.DOWNLOAD_ATTACHMENT', "Error retrieving attachments; " + error);
            return Observable["Observable"].throw(error);
        }).subscribe();
    };
    /**
     * Deletes attachment as well as triggers deletion animation.
     * @param attachment
     * @returns {Observable<R|T>}
     */
    AttachmentComponent.prototype.deleteFile = function (attachment) {
        var _this = this;
        this.startDate = new Date();
        this.isDeleteInProgress = true;
        // This triggers the animation on the specific item.
        this.removedAttachments.add(attachment.uniqueId);
        this.attachmentStore.deleteAttachment(this._eventId, this.vendor.eventPartyId, attachment.uniqueId, this.isMultiVendor())
            .catch(function (error) {
            _this.flashMessagesService.error('MESSAGES.ERROR.DELETE_ATTACHMENT', error);
            _this.removedAttachments.delete(attachment.uniqueId);
            return Observable["Observable"].throw(error);
        }).subscribe();
    };
    AttachmentComponent.prototype.confirmBeforeDelete = function (attachment) {
        this.attachmentToRemove = attachment;
        this.confirmationModal.open();
    };
    AttachmentComponent.prototype.confirmHandler = function (value) {
        if (value) {
            this.deleteFile(this.attachmentToRemove);
        }
        this.attachmentToRemove = null;
    };
    AttachmentComponent.prototype.getAnimationDelay = function (delayMillis, startDate) {
        var animationDelay = delayMillis - (new Date().valueOf() - startDate.valueOf());
        return animationDelay > 0 ? animationDelay : 0;
    };
    AttachmentComponent.prototype.getFileExtension = function (filename) {
        if (!filename) {
            return '';
        }
        var filenameParts = filename.split('.');
        return filenameParts[filenameParts.length - 1];
    };
    AttachmentComponent.prototype.handleUploadError = function (errorMessage, logMessage) {
        if (logMessage === void 0) { logMessage = null; }
        this.isUploadInProgress = false;
        this.flashMessagesService.error(errorMessage, logMessage);
    };
    /**
     * Returns true if the user has permissions to delete the attachment
     *
     * @param attachment the file to check
     * @returns `true` if both conditions are met; `false` otherwise
     */
    AttachmentComponent.prototype.canDeleteFile = function (attachment) {
        if (!this.authStore.hasPermission('DeleteFiles')) {
            return false;
        }
        if (this.authStore.isSupportUser()) {
            return true;
        }
        if (this.isMultiVendor() && this.authStore.matchUserType(attachment.creatorType)) {
            return true;
        }
        if (this.authStore.isPropertyUser() && attachment.eventPartyCreatorId === this.vendor.eventPartyId) {
            return true;
        }
        return false;
    };
    AttachmentComponent.prototype.clearFileInput = function () {
        this.fileInput.nativeElement.value = null;
    };
    AttachmentComponent.prototype.isMultiVendor = function () {
        return this.authStore.hasPermission('MultiVendor');
    };
    return AttachmentComponent;
}());
attachment_component___decorate([
    Object(core_es5["HostBinding"])('class.margin-content'),
    attachment_component___metadata("design:type", Object)
], attachment_component_AttachmentComponent.prototype, "true", void 0);
attachment_component___decorate([
    Object(core_es5["ViewChild"])('file'),
    attachment_component___metadata("design:type", typeof (attachment_component__a = typeof core_es5["ElementRef"] !== "undefined" && core_es5["ElementRef"]) === "function" && attachment_component__a || Object)
], attachment_component_AttachmentComponent.prototype, "fileInput", void 0);
attachment_component___decorate([
    Object(core_es5["ViewChild"])(confirmation_modal_component_ConfirmationModalComponent),
    attachment_component___metadata("design:type", typeof (attachment_component__b = typeof confirmation_modal_component_ConfirmationModalComponent !== "undefined" && confirmation_modal_component_ConfirmationModalComponent) === "function" && attachment_component__b || Object)
], attachment_component_AttachmentComponent.prototype, "confirmationModal", void 0);
attachment_component___decorate([
    Object(core_es5["Input"])(),
    attachment_component___metadata("design:type", Number),
    attachment_component___metadata("design:paramtypes", [Number])
], attachment_component_AttachmentComponent.prototype, "eventId", null);
attachment_component___decorate([
    Object(core_es5["Input"])(),
    attachment_component___metadata("design:type", typeof (attachment_component__c = typeof Party !== "undefined" && Party) === "function" && attachment_component__c || Object)
], attachment_component_AttachmentComponent.prototype, "vendor", void 0);
attachment_component_AttachmentComponent = attachment_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-attachment',
        template: __webpack_require__("Jeo/"),
        styles: [__webpack_require__("z++b")]
    }),
    attachment_component___metadata("design:paramtypes", [typeof (attachment_component__d = typeof attachment_store_AttachmentStore !== "undefined" && attachment_store_AttachmentStore) === "function" && attachment_component__d || Object, typeof (attachment_component__e = typeof flash_messages_service_FlashMessagesService !== "undefined" && flash_messages_service_FlashMessagesService) === "function" && attachment_component__e || Object, typeof (attachment_component__f = typeof authentication_store_AuthenticationStore !== "undefined" && authentication_store_AuthenticationStore) === "function" && attachment_component__f || Object, typeof (attachment_component__g = typeof EnvironmentConfiguration !== "undefined" && EnvironmentConfiguration) === "function" && attachment_component__g || Object])
], attachment_component_AttachmentComponent);

var attachment_component__a, attachment_component__b, attachment_component__c, attachment_component__d, attachment_component__e, attachment_component__f, attachment_component__g;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/attachment.component.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/attachment/attachment.resolver.ts
var attachment_resolver___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var attachment_resolver___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};



var AttachmentResolver = (function () {
    function AttachmentResolver(attachmentStore, translateService) {
        this.attachmentStore = attachmentStore;
        this.translateService = translateService;
    }
    AttachmentResolver.prototype.resolve = function (route, state) {
        var id = route.params['id'];
        var eventPartyId = route.params['eventPartyId'];
        if (!id) {
            throw new Error(this.translateService.instant('MESSAGES.ERROR.GET_EVENT'));
        }
        if (eventPartyId) {
            return this.attachmentStore.getAttachmentsByParty(id, eventPartyId).first();
        }
        else {
            return this.attachmentStore.getAttachments(id).first();
        }
    };
    return AttachmentResolver;
}());
AttachmentResolver = attachment_resolver___decorate([
    Object(core_es5["Injectable"])(),
    attachment_resolver___metadata("design:paramtypes", [typeof (attachment_resolver__a = typeof attachment_store_AttachmentStore !== "undefined" && attachment_store_AttachmentStore) === "function" && attachment_resolver__a || Object, typeof (attachment_resolver__b = typeof core["c" /* TranslateService */] !== "undefined" && core["c" /* TranslateService */]) === "function" && attachment_resolver__b || Object])
], AttachmentResolver);

var attachment_resolver__a, attachment_resolver__b;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/attachment.resolver.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/rate-plan-code/rate-plan-code/displayed-rate-plan-code.ts
var DisplayedRatePlanCode = (function () {
    function DisplayedRatePlanCode(ratePlanCode, closeable) {
        this.ratePlanCode = ratePlanCode;
        this.closeable = closeable;
        this.ratePlanCode = ratePlanCode;
        this.closeable = closeable;
    }
    return DisplayedRatePlanCode;
}());

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/displayed-rate-plan-code.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/error-code.ts
var ErrorCode = (function () {
    function ErrorCode() {
    }
    return ErrorCode;
}());

ErrorCode.DUPLICATE = 'DUPLICATE';
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/error-code.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/rate-plan-code-validation-request.ts
var rate_plan_code_validation_request___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var RatePlanCodeValidationRequestRecord = Object(immutable["Record"])({
    eventId: null,
    eventPartyId: null,
    chain: null,
    brand: null,
    propertyId: null,
    ratePlanCodes: null,
    startDate: null,
    endDate: null
});
var RatePlanCodeValidationRequest = (function (_super) {
    rate_plan_code_validation_request___extends(RatePlanCodeValidationRequest, _super);
    function RatePlanCodeValidationRequest() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return RatePlanCodeValidationRequest;
}(RatePlanCodeValidationRequestRecord));

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/rate-plan-code-validation-request.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/basic-event-data/basic-event-data.validator.ts

var basic_event_data_validator_BasicEventDataValidator = (function () {
    function BasicEventDataValidator() {
    }
    BasicEventDataValidator.dateCompare = function (formControl) {
        var startDate = formControl.get('startDate').value;
        var endDate = formControl.get('endDate').value;
        if (!startDate || !endDate) {
            return null;
        }
        else {
            // Convert to string if object
            if (!Object(util_util["isString"])(startDate)) {
                startDate = startDate.toUTCString();
            }
            if (!Object(util_util["isString"])(endDate)) {
                endDate = endDate.toUTCString();
            }
        }
        var isInvalid = new Date(startDate) > new Date(endDate);
        if (isInvalid) {
            formControl.get('endDate').markAsTouched();
            return { 'greater': true };
        }
        return null;
    };
    return BasicEventDataValidator;
}());

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/basic-event-data.validator.js.map
// EXTERNAL MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/node_modules/ng2-validation/dist/index.js
var dist = __webpack_require__("+idH");
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);

// EXTERNAL MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/node_modules/rxjs/Subscription.js
var Subscription = __webpack_require__("xFbG");
var Subscription_default = /*#__PURE__*/__webpack_require__.n(Subscription);

// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/models/event-status-info.ts

var event_status_info_EventStatusInfo = (function () {
    function EventStatusInfo(status) {
        this.paymentStatus = PaymentStatus.READY.toString();
        if (status) {
            this.paymentStatus = status.toLowerCase().toString();
        }
    }
    EventStatusInfo.prototype.getStatus = function () {
        return this.paymentStatus;
    };
    EventStatusInfo.prototype.isCancelled = function () {
        return this.paymentStatus === PaymentStatus.CANCELLED.toString();
    };
    EventStatusInfo.prototype.isUnpaid = function () {
        return this.paymentStatus === PaymentStatus.ERROR.toString() ||
            this.paymentStatus === PaymentStatus.PAY_REJECTED.toString() ||
            this.paymentStatus === PaymentStatus.CHECK_STOPPED.toString() ||
            this.paymentStatus === PaymentStatus.INVOICE_REJECTED.toString() ||
            this.paymentStatus === PaymentStatus.REQUESTED.toString() ||
            this.paymentStatus === PaymentStatus.REQUEST_REJECTED.toString() ||
            this.paymentStatus === PaymentStatus.RESENT_REQUEST.toString() ||
            this.paymentStatus === PaymentStatus.CHECK_STOPPED.toString() ||
            this.paymentStatus === PaymentStatus.UNPAID.toString();
    };
    EventStatusInfo.prototype.isPaid = function () {
        return this.paymentStatus === PaymentStatus.PAID_DIRECT.toString() ||
            this.paymentStatus === PaymentStatus.PAY_SENT.toString() ||
            this.paymentStatus === PaymentStatus.PAY_CLEARED.toString() ||
            this.paymentStatus === PaymentStatus.PAY_REISSUED.toString() ||
            this.paymentStatus === PaymentStatus.PAID.toString();
    };
    EventStatusInfo.prototype.isProcessing = function () {
        return this.paymentStatus === PaymentStatus.READY.toString() ||
            this.paymentStatus === PaymentStatus.PENDING.toString() ||
            this.paymentStatus === PaymentStatus.PENDING.toString() ||
            this.paymentStatus === PaymentStatus.FUNDED.toString() ||
            this.paymentStatus === PaymentStatus.PAY_REISSUED.toString() ||
            this.paymentStatus === PaymentStatus.INVOICED.toString() ||
            this.paymentStatus === PaymentStatus.PARTIAL.toString();
    };
    return EventStatusInfo;
}());

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/event-status-info.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/basic-event-data/basic-event-data.component.ts
var basic_event_data_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var basic_event_data_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

































var basic_event_data_component_BasicEventDataComponent = (function () {
    function BasicEventDataComponent(formBuilder, translateService, propertyLookupStore, eventStore, environment, flashMessagesService, authenticationStore, reservationStore, rsvpStore, paymentStore, _commonDataStore, eventValidationService) {
        this.formBuilder = formBuilder;
        this.translateService = translateService;
        this.propertyLookupStore = propertyLookupStore;
        this.eventStore = eventStore;
        this.environment = environment;
        this.flashMessagesService = flashMessagesService;
        this.authenticationStore = authenticationStore;
        this.reservationStore = reservationStore;
        this.rsvpStore = rsvpStore;
        this.paymentStore = paymentStore;
        this._commonDataStore = _commonDataStore;
        this.eventValidationService = eventValidationService;
        this.isReadOnly = true;
        this.isNewEvent = false;
        this.isAgency = false;
        this.isMultiVendorPayments = false;
        this.isMultiVendorUserAndEventCreatedByProperty = false;
        this.confirmationModalConfig = new ConfirmationModalConfig();
        this.propertyLookupSubscription = new Subscription["Subscription"]();
        this.isEventReferenceNumberEditable = true;
        this.isMeetingIdEditable = true;
        this.isRatePlanCodeAdding = false;
        this.hasPayment = false;
        this.isStateRequired = pioneer_validators_PioneerValidators.isStateRequired;
        this.showState = true;
        this.agencyOrSupportUser = false;
        this._destroy$ = new Subject["Subject"]();
    }
    Object.defineProperty(BasicEventDataComponent.prototype, "event", {
        set: function (event) {
            this.onyxEvent = event;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BasicEventDataComponent.prototype, "commonDataStore", {
        get: function () {
            return this._commonDataStore;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BasicEventDataComponent.prototype, "chain", {
        get: function () {
            return this.parentForm.get('eventProperty') ? this.parentForm.get('eventProperty').get('chain').value : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BasicEventDataComponent.prototype, "brand", {
        get: function () {
            return this.parentForm.get('eventProperty') ? this.parentForm.get('eventProperty').get('brand').value : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BasicEventDataComponent.prototype, "propertyId", {
        get: function () {
            return this.parentForm.get('eventProperty') ? this.parentForm.get('eventProperty').get('propertyId').value : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BasicEventDataComponent.prototype, "startDateInput", {
        get: function () {
            return this.basicEventDataForm.get('startDate');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BasicEventDataComponent.prototype, "endDateInput", {
        get: function () {
            return this.basicEventDataForm.get('endDate');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BasicEventDataComponent.prototype, "formattedDuplicateRatePlanCodes", {
        get: function () {
            return this.duplicateRatePlanCodes ? this.duplicateRatePlanCodes.join(', ') : '';
        },
        enumerable: true,
        configurable: true
    });
    BasicEventDataComponent.prototype.dataToFormGroup = function (event) {
        var _this = this;
        var _eventReferenceNumber = this.getGroupCode(event);
        this.commonDataStore.loadStatesFromCountry(event.countryCode).take(1).subscribe();
        if (!this.basicEventDataForm) {
            if (this.isMultiVendor) {
                if (this.authenticationStore.isSupportUser()) {
                    this.basicEventDataForm = this.formBuilder.group({
                        'name': [EventUtils.getEventName(event, this.authenticationStore.isAgencyUser()), forms_es5["Validators"].required],
                        'eventId': event.eventId,
                        'commissionRoomPercentage': [event.eventProperty.commissionRoomPercentage,
                            [pioneer_validators_PioneerValidators.range(0, 100), pioneer_validators_PioneerValidators.isInteger]],
                        'startDate': [date_util_DateUtil.formatDate(this.getStartDate(event)), [forms_es5["Validators"].required, pioneer_validators_PioneerValidators.isDate]],
                        'endDate': [date_util_DateUtil.formatDate(this.getEndDate(event)), [forms_es5["Validators"].required, pioneer_validators_PioneerValidators.isDate]],
                        'eventAgency': this.formBuilder.group({}),
                        'eventClient': this.formBuilder.group({}),
                        'eventProperty': this.formBuilder.group({}),
                        'eventReferenceNumber': [_eventReferenceNumber, [forms_es5["Validators"].required, pioneer_validators_PioneerValidators.isAlphaNumeric]],
                        'meetingId': event.eventAgency ? event.eventAgency.eventReferenceNumber : null,
                        'currency': [event.currency, forms_es5["Validators"].required],
                        'currencyName': ['', null],
                        'ratePlanCode': [null, dist["CustomValidators"].rangeLength([3, 10])],
                        'ratePlanCodes': this.formBuilder.array(event.ratePlanCodes),
                        'commRetention': event.eventProperty.commRetention,
                        'shoulderDatesCommission': [event.shoulderDatesCommission, forms_es5["Validators"].required],
                        'countryCode': [event.countryCode],
                        'countryName': ['', null],
                        'state': [event.state],
                        'stateName': ['', null],
                        'city': [event.city],
                        'customFields': this.formBuilder.group({})
                    }, {
                        validator: forms_es5["Validators"].compose([
                            basic_event_data_validator_BasicEventDataValidator.dateCompare,
                            pioneer_validators_PioneerValidators.countryStateCrossValidator('countryCode', 'state')
                        ])
                    });
                }
                else {
                    this.basicEventDataForm = this.formBuilder.group({
                        'name': [EventUtils.getEventName(event, this.authenticationStore.isAgencyUser()), forms_es5["Validators"].required],
                        'eventId': event.eventId,
                        'commissionRoomPercentage': [event.eventProperty.commissionRoomPercentage,
                            [pioneer_validators_PioneerValidators.range(0, 100), pioneer_validators_PioneerValidators.isInteger]],
                        'startDate': [date_util_DateUtil.formatDate(this.getStartDate(event)), [forms_es5["Validators"].required, pioneer_validators_PioneerValidators.isDate]],
                        'endDate': [date_util_DateUtil.formatDate(this.getEndDate(event)), [forms_es5["Validators"].required, pioneer_validators_PioneerValidators.isDate]],
                        'eventAgency': this.formBuilder.group({}),
                        'eventClient': this.formBuilder.group({}),
                        'eventProperty': this.formBuilder.group({}),
                        'eventReferenceNumber': [_eventReferenceNumber, [forms_es5["Validators"].required, pioneer_validators_PioneerValidators.isAlphaNumeric]],
                        'currency': [event.currency, forms_es5["Validators"].required],
                        'currencyName': ['', null],
                        'ratePlanCode': [null, dist["CustomValidators"].rangeLength([3, 10])],
                        'ratePlanCodes': this.formBuilder.array(event.ratePlanCodes),
                        'commRetention': event.eventProperty.commRetention,
                        'countryCode': [event.countryCode],
                        'countryName': ['', null],
                        'state': [event.state],
                        'stateName': ['', null],
                        'city': [event.city],
                        'customFields': this.formBuilder.group({})
                    }, {
                        validator: forms_es5["Validators"].compose([
                            basic_event_data_validator_BasicEventDataValidator.dateCompare,
                            pioneer_validators_PioneerValidators.countryStateCrossValidator('countryCode', 'state')
                        ])
                    });
                }
            }
            else {
                this.basicEventDataForm = this.formBuilder.group({
                    'name': [EventUtils.getEventName(event, this.authenticationStore.isAgencyUser()), forms_es5["Validators"].required],
                    'eventId': event.eventId,
                    'commissionRoomPercentage': [event.eventProperty.commissionRoomPercentage,
                        [forms_es5["Validators"].required, pioneer_validators_PioneerValidators.range(0, 100), pioneer_validators_PioneerValidators.isInteger]],
                    'startDate': [date_util_DateUtil.formatDate(this.getStartDate(event)), [forms_es5["Validators"].required, pioneer_validators_PioneerValidators.isDate]],
                    'endDate': [date_util_DateUtil.formatDate(this.getEndDate(event)), [forms_es5["Validators"].required, pioneer_validators_PioneerValidators.isDate]],
                    'eventAgency': this.formBuilder.group({}),
                    'eventClient': this.formBuilder.group({}),
                    'eventProperty': this.formBuilder.group({}),
                    'eventReferenceNumber': [_eventReferenceNumber, [forms_es5["Validators"].required, pioneer_validators_PioneerValidators.isAlphaNumeric]],
                    'meetingId': event.eventAgency ? event.eventAgency.eventReferenceNumber : null,
                    'currency': [event.currency, forms_es5["Validators"].required],
                    'currencyName': ['', null],
                    'ratePlanCode': [null, dist["CustomValidators"].rangeLength([3, 10])],
                    'ratePlanCodes': this.formBuilder.array(event.eventProperty.ratePlanCodes),
                    'commRetention': [event.eventProperty.commRetention, forms_es5["Validators"].required],
                    'shoulderDatesCommission': [event.shoulderDatesCommission, forms_es5["Validators"].required],
                    'countryCode': [event.countryCode],
                    'countryName': ['', null],
                    'state': [event.state],
                    'stateName': ['', null],
                    'city': [event.city],
                    'customFields': this.formBuilder.group({})
                }, {
                    validator: forms_es5["Validators"].compose([
                        basic_event_data_validator_BasicEventDataValidator.dateCompare,
                        pioneer_validators_PioneerValidators.countryStateCrossValidator('countryCode', 'state')
                    ])
                });
            }
        }
        else {
            this.basicEventDataForm.patchValue({
                'name': EventUtils.getEventName(event, this.authenticationStore.isAgencyUser()),
                'eventId': event.eventId,
                'commissionRoomPercentage': event.eventProperty.commissionRoomPercentage,
                'startDate': date_util_DateUtil.formatDate(this.getStartDate(event)),
                'endDate': date_util_DateUtil.formatDate(this.getEndDate(event)),
                'eventReferenceNumber': _eventReferenceNumber,
                'currency': event.currency,
                'currencyName': ['', null],
                'commRetention': event.eventProperty.commRetention,
                'shoulderDatesCommission': event.shoulderDatesCommission,
                'countryCode': event.countryCode,
                'state': event.state,
                'city': event.city,
                'customFields': this.formBuilder.group({})
            });
        }
        this.selectedCurrency$ = this._commonDataStore.getCurrency(event.currency);
        // Set currencyName form control
        this.selectedCurrency$.subscribe(function (currency) {
            _this.basicEventDataForm.controls['currencyName'].setValue(currency.value);
        });
        this.selectedCountry$ = this.commonDataStore.getCountry(event.countryCode);
        if (event.countryCode) {
            this.selectedState$ = this.commonDataStore.getState(event.countryCode, event.state);
        }
        else {
            this.selectedState$ = Observable["Observable"].of(new DropdownItem('', event.state));
        }
    };
    BasicEventDataComponent.prototype.getGroupCode = function (event) {
        return EventUtils.getEventGroupCode(event, this.authenticationStore.isAgencyUser());
    };
    BasicEventDataComponent.prototype.getStartDate = function (event) {
        return EventUtils.getEventStartDate(event, this.authenticationStore.isAgencyUser());
    };
    BasicEventDataComponent.prototype.getEndDate = function (event) {
        return EventUtils.getEventEndDate(event, this.authenticationStore.isAgencyUser());
    };
    Object.defineProperty(BasicEventDataComponent.prototype, "ratePlanCodeInput", {
        get: function () {
            return this.basicEventDataForm.get('ratePlanCode');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BasicEventDataComponent.prototype, "commRetention", {
        get: function () {
            return this.basicEventDataForm.get('commRetention');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BasicEventDataComponent.prototype, "shoulderDatesCommission", {
        get: function () {
            return this.basicEventDataForm.get('shoulderDatesCommission');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BasicEventDataComponent.prototype, "ratePlanCodesApplied", {
        get: function () {
            return this.basicEventDataForm.get('ratePlanCodes');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BasicEventDataComponent.prototype, "displayedRatePlanCodes", {
        get: function () {
            var displayedRatePlanCodes = this.ratePlanCodesApplied.value.map(function (ratePlanCodeObj) {
                return new DisplayedRatePlanCode(ratePlanCodeObj.ratePlanCode, ratePlanCodeObj.canBeDeleted);
            });
            return displayedRatePlanCodes;
        },
        enumerable: true,
        configurable: true
    });
    BasicEventDataComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.dataToFormGroup(this.onyxEvent);
        this.parentForm.setControl('event', this.basicEventDataForm);
        this.isUploadInProgress = false;
        this.fileExtensions = this.environment.bulkEvents.acceptedFileExtensions;
        if (this.authenticationStore.isSinglePropertyUser()) {
            this.propertyLookupStore.selectedCached
                .take(1)
                .subscribe(function (details) {
                if (_this.isNewEvent && !_this.isEventCurrencyManuallyEntered()) {
                    _this.basicEventDataForm.patchValue({ 'currency': details.currency });
                }
            });
        }
        // this.commonDataStore.currencies.subscribe(currencies => this.currencies = currencies);
        this.isEventReferenceNumberEditable = true;
        if (!this.isNewEvent && !this.isReadOnly) {
            this.reservationStore.getEventHasReservations().take(1).subscribe(function (hasReservations) {
                if (hasReservations === true) {
                    _this.isEventReferenceNumberEditable = false;
                }
            });
            this.paymentStore.payments.take(1).subscribe(function (paymentList) {
                if (paymentList && paymentList.size > 0) {
                    _this.hasPayment = true;
                    if (_this.authenticationStore.isAgencyUser()) {
                        _this.isEventReferenceNumberEditable = false;
                    }
                }
            });
            if (this.authenticationStore.isPropertyUser()) {
                this.paymentStore.getLatestVendorFinalPayments().take(1).subscribe(function (payments) {
                    if (payments && payments.length > 0 && PaymentStatus.REJECTED_WF_APPROVAL !== payments[0].status) {
                        _this.isEventReferenceNumberEditable = false;
                    }
                });
            }
            this.paymentStore.getPrepayment().subscribe(function (prepayment) {
                if (prepayment && prepayment.eventPaymentId) {
                    _this.isEventReferenceNumberEditable = false;
                    _this.hasPayment = true;
                }
            });
            if (this.authenticationStore.isSupportUser()) {
                this.isEventReferenceNumberEditable = false;
            }
        }
        this.states$ = this.commonDataStore.states;
        this.states$.subscribe(function (states) {
            if (states && states.length > 0) {
                var stateFormControl = _this.basicEventDataForm ? _this.basicEventDataForm.get('state') : undefined;
                if (stateFormControl) {
                    stateFormControl.enable();
                }
            }
        });
        this.setUpCommRetention();
        this.isLocationRequired();
        this.isAgencyUserOrSupportUser();
        if (this.focusEventNameSubject) {
            this.focusEventNameSubject.pipe(Object(operators["takeUntil"])(this._destroy$), Object(operators["tap"])(function () { return _this.eventNameInputEl.nativeElement.focus(); })).subscribe();
        }
        this.canEditGroupCode$ = this.eventValidationService.canEditGroupCode();
        this.canEditEventDates$ = this.eventValidationService.canEditEventDates();
        this.canEditEventCurrency$ = this.eventValidationService.canEditEventCurrency();
        this.canEditShoulderDates$ = this.eventValidationService.canEditShoulderDates();
    };
    BasicEventDataComponent.prototype.ngOnDestroy = function () {
        this.propertyLookupSubscription.unsubscribe();
        this._destroy$.next(true);
        this._destroy$.complete();
    };
    BasicEventDataComponent.prototype.onCountryCodeChanged = function () {
        var _this = this;
        this.basicEventDataForm.get('state').reset();
        this.states$ = this.commonDataStore.loadStatesFromCountry(this.basicEventDataForm.get('countryCode').value);
        this.states$.take(1).subscribe(function (states) {
            _this.showState = states.length > 0;
        });
    };
    BasicEventDataComponent.prototype.ngOnChanges = function (changes) {
        /*
         * Since we're subscribed to the selectedEvent in the event store,
         * this will detect if something changes (or if loading finishes) and we need to update the form.
         */
        if (!changes['event']) {
            return;
        }
        this.dataToFormGroup(this.onyxEvent);
        this.setUpCommRetention();
    };
    BasicEventDataComponent.prototype.isAutoGenerated = function () {
        return this.onyxEvent.autoGenerated;
    };
    BasicEventDataComponent.prototype.isEventCurrencyManuallyEntered = function () {
        var currencyControl = this.basicEventDataForm.controls['currency'];
        return currencyControl.touched && currencyControl.dirty;
    };
    BasicEventDataComponent.prototype.handleUploadError = function (errorMessage, logMessage) {
        if (logMessage === void 0) { logMessage = null; }
        this.isUploadInProgress = false;
        this.flashMessagesService.error(errorMessage, logMessage);
    };
    BasicEventDataComponent.prototype.clearFileInput = function () {
        this.bulkEventFileInput.nativeElement.value = null;
    };
    BasicEventDataComponent.prototype.downloadInvalidEventsCsv = function (fileId) {
        this.eventStore.downloadInvalidEventsCsv(fileId);
    };
    BasicEventDataComponent.prototype.importEventsViaCsv = function (inputEvent) {
        var _this = this;
        this.isUploadInProgress = true;
        if (!inputEvent || !inputEvent.srcElement || !inputEvent.srcElement.files || inputEvent.srcElement.files.size === 0) {
            this.handleUploadError('MESSAGES.ERROR.UPLOAD_BULK_EVENTS');
            return;
        }
        var file = inputEvent.srcElement.files[0];
        this.clearFileInput();
        if (this.environment.bulkEvents.acceptedFileTypes.indexOf(file.type) < 0) {
            this.handleUploadError('MESSAGES.ERROR.UPLOAD_BULK_EVENTS');
            return;
        }
        if (file.size > Math.pow(2, 20)) {
            this.handleUploadError('MESSAGES.ERROR.BULK_UPLOAD_TOO_LARGE');
            return;
        }
        this.eventStore.importEventsViaCsv(file)
            .finally(function () {
            _this.isUploadInProgress = false;
        })
            .catch((function (error) {
            _this.showErrorMessage(error);
            return Observable["Observable"].throw(error);
        }))
            .subscribe(function (response) {
            if (response.successful && response.successful > 0) {
                _this.showSuccessfulRecordsMessage(response);
            }
            if (response.failed && response.failed > 0) {
                _this.showInvalidRecordsMessage(response);
            }
        });
    };
    BasicEventDataComponent.prototype.showErrorMessage = function (error) {
        this.flashMessagesService.error('MESSAGES.ERROR.UPLOAD_BULK_EVENTS', "Error uploading bulk events: " + error);
    };
    BasicEventDataComponent.prototype.showSuccessfulRecordsMessage = function (response) {
        this.flashMessagesService.success('MESSAGES.SUCCESS.UPLOAD_BULK_EVENTS', null, { eventCount: Number(response.successful) });
    };
    BasicEventDataComponent.prototype.showInvalidRecordsMessage = function (response) {
        this.flashMessagesService.warn('MESSAGES.SUCCESS.UPLOAD_BULK_EVENTS_INVALID', null, {
            eventCount: Number(response.failed),
            href: this.environment.baseUrl + '/api/events/bulkUpload/'
                + response.fileId + '?Authorization=' + this.authenticationStore.getToken()
        });
    };
    BasicEventDataComponent.prototype.select = function (currency) {
        this.basicEventDataForm.value.currency = currency.code;
    };
    BasicEventDataComponent.prototype.addRatePlanCode = function () {
        var _this = this;
        if (this.isValid(this.ratePlanCodeInput)
            && this.isRatePlanCodeAdding === false) {
            this.isRatePlanCodeAdding = true;
            this.isDuplicateRatePlanCode(this.ratePlanCodeInput.value)
                .map(function (isDuplicate) {
                if (!isDuplicate) {
                    _this.ratePlanCodesApplied.push(_this.formBuilder.control(new RatePlanCode({ ratePlanCode: _this.ratePlanCodeInput.value })));
                    _this.ratePlanCodeInput.reset();
                    _this.parentForm.markAsDirty();
                }
            })
                .take(1)
                .subscribe();
            setTimeout(function () {
                _this.isRatePlanCodeAdding = false;
            }, 1000);
        }
    };
    BasicEventDataComponent.prototype.confirmBeforeDeletingRatePlanCode = function (ratePlanCodeIndex) {
        var _this = this;
        if (this.isNewEvent) {
            this.deleteRatePlanCode(ratePlanCodeIndex);
        }
        else {
            this.selectedRatePlanIndex = ratePlanCodeIndex;
            this.selectedRatePlanCode = this.ratePlanCodesApplied.get([ratePlanCodeIndex]).value.ratePlanCode;
            this.eventStore.getReservationCountForRatePlanCode(this.onyxEvent.eventProperty.eventPartyId, this.selectedRatePlanCode)
                .subscribe(function (countObject) {
                // set up the title of the confirmation modal
                var titleLabel = 'EVENT.DELETE_RATE_PLAN_CODE';
                _this.confirmationModalConfig.title = _this.translateService.instant(titleLabel);
                // set up the content of the confirmation modal
                var contentLabel = 'EVENT.DELETE_RATE_PLAN_CODE_CONTENT';
                var params = {
                    ratePlanCode: _this.selectedRatePlanCode,
                    reservationCount: countObject.reservationCount
                };
                _this.confirmationModalConfig.content = _this.translateService.instant(contentLabel, params);
                _this.confirmationModal.open();
            });
        }
    };
    BasicEventDataComponent.prototype.confirmBeforeDeletingRatePlanCodeHandler = function (proceed) {
        if (proceed) {
            this.deleteRatePlanCode(this.selectedRatePlanIndex);
        }
    };
    BasicEventDataComponent.prototype.deleteRatePlanCode = function (ratePlanIndex) {
        this.ratePlanCodesApplied.removeAt(ratePlanIndex);
        this.parentForm.markAsDirty();
    };
    /**
     * Returns true if new Rate Plan Code is valid and not yet in the list
     *
     * @param newRatePlanCode the AbstractControl of the Rate Plan Code
     * @returns true if it is valid; false otherwise
     */
    BasicEventDataComponent.prototype.isValid = function (newRatePlanCode) {
        if (newRatePlanCode.value != null && newRatePlanCode.valid) {
            var filteredList = this.ratePlanCodesApplied.value.filter(function (ratePlanCode) {
                return ratePlanCode.ratePlanCode === newRatePlanCode.value;
            });
            return filteredList.length === 0;
        }
    };
    /**
     * Called in the (blur) event of the rate plan code input
     * to check if it contains a duplicate rate plan code.
     */
    BasicEventDataComponent.prototype.ratePlanCodeBlur = function () {
        if (this.ratePlanCodeInput.dirty && this.ratePlanCodeInput.valid) {
            this.ratePlanCodeInput.setValue(pioneer_utils_PioneerUtils.safeTrim(this.ratePlanCodeInput.value));
            this.checkDuplicateRatePlanCodeInput();
        }
    };
    /*
     * Adds a validation error to the rate plan code input
     * in case it contains a duplicate rate plan code.
     * It removes the error otherwise.
     */
    BasicEventDataComponent.prototype.checkDuplicateRatePlanCodeInput = function () {
        var _this = this;
        if (this.ratePlanCodeInput.value) {
            this.isDuplicateRatePlanCode(this.ratePlanCodeInput.value)
                .map(function (isDuplicate) {
                if (!isDuplicate) {
                    // The duplicate error is removed from the input
                    _this.ratePlanCodeInput.updateValueAndValidity();
                }
                else if (_this.ratePlanCodeInput.valid) {
                    // The duplicate error is added to the input if it doesn't have a validation error (the same error or a different one)
                    _this.ratePlanCodeInput.setErrors({ 'duplicate_rate_plan_code': true });
                }
            })
                .take(1)
                .subscribe();
        }
    };
    /**
     * Called in the (blur) event of startDate and endDate.
     * It validates rate plan codes to check if there are duplicates:
     * * It checks all the rate plan codes added to the event (this.ratePlanCodesApplied),
     * * it removes the duplication error from the other date input,
     * * and it checks the rate plan code input
     *
     * @param dateInputElement
     */
    BasicEventDataComponent.prototype.datesBlur = function (dateInputElement) {
        var _this = this;
        if (dateInputElement.dirty) {
            if (this.canCheckDuplicateRatePlanCode()) {
                var ratePlanCodes = this.extractAddedRatePlanCodes();
                if (ratePlanCodes.length > 0) {
                    this.getRatePlanCodeDuplicationErrors(ratePlanCodes)
                        .map(function (duplicationErrors) {
                        // Updates the attribute duplicateRatePlanCodes used to display the list of duplicates in an error message
                        _this.duplicateRatePlanCodes = duplicationErrors.map(function (duplicationError) { return duplicationError.fieldValue; });
                        if (_this.duplicateRatePlanCodes.length > 0) {
                            // Adds the error to the input element producing the (blur) event
                            dateInputElement.setErrors({ 'duplicate_rate_plan_codes_by_date': true });
                        }
                        // The duplicate error is removed from the other date input
                        if (dateInputElement === _this.startDateInput) {
                            _this.endDateInput.updateValueAndValidity();
                        }
                        else {
                            _this.startDateInput.updateValueAndValidity();
                        }
                    })
                        .take(1)
                        .subscribe();
                }
            }
            // If a date has changed, the rate plan code input is also checked
            this.checkDuplicateRatePlanCodeInput();
        }
    };
    /**
     * Called in the (change) event of startDate and endDate
     * to avoid displaying both validation errors at the same time
     * (duplication error and end date before start date)
     */
    BasicEventDataComponent.prototype.datesChange = function () {
        if (this.basicEventDataForm.hasError('greater')) {
            this.endDateInput.updateValueAndValidity();
            this.ratePlanCodeInput.updateValueAndValidity();
        }
    };
    /**
     * Returns true if the rate plan code provided is a duplicate.
     * Returns false otherwise (also in case the preconditions are not fulfilled).
     */
    BasicEventDataComponent.prototype.isDuplicateRatePlanCode = function (ratePlanCode) {
        var _this = this;
        var obs$ = new Observable["Observable"](function (observer) {
            if (!!ratePlanCode && ratePlanCode.length > 0 && _this.canCheckDuplicateRatePlanCode()) {
                // Removing white spaces
                var rpcNoSpace = ratePlanCode.replace(/\s/g, '');
                if (rpcNoSpace.length > 0) {
                    _this.getRatePlanCodeDuplicationErrors([ratePlanCode])
                        .map(function (duplicationErrors) {
                        var isDuplicate = duplicationErrors.length > 0;
                        observer.next(isDuplicate);
                    })
                        .take(1)
                        .subscribe();
                }
                else {
                    observer.next(false);
                }
            }
            else {
                observer.next(false);
            }
        });
        return obs$;
    };
    /**
     * Returns the duplication errors of an array of rate plan codes.
     *
     * @param ratePlanCodes
     */
    BasicEventDataComponent.prototype.getRatePlanCodeDuplicationErrors = function (ratePlanCodes) {
        var request = new RatePlanCodeValidationRequest({
            eventId: this.onyxEvent.eventId,
            eventPartyId: this.onyxEvent.eventProperty.eventPartyId,
            chain: this.chain,
            brand: this.brand,
            propertyId: this.propertyId,
            ratePlanCodes: ratePlanCodes,
            startDate: this.startDateInput.value,
            endDate: this.endDateInput.value
        });
        return this.eventStore.getRatePlanCodeValidation(request)
            .map(function (validationErrors) {
            return validationErrors.filter(function (validationError) { return validationError.errorCode === ErrorCode.DUPLICATE; });
        });
    };
    /**
     * Returns true if the preconditions required for checking rate plan code uniqueness are fulfilled,
     * namely startDate and endDate are populated with valid dates, and the event property is selected.
     */
    BasicEventDataComponent.prototype.canCheckDuplicateRatePlanCode = function () {
        var starDateIsValid = date_util_DateUtil.isValidDateString(this.startDateInput.value);
        var endDateIsValid = date_util_DateUtil.isValidDateString(this.endDateInput.value);
        var dateRangeIsValid = !this.basicEventDataForm.hasError('greater');
        var propertyIsValid = !!this.propertyId;
        return starDateIsValid && endDateIsValid && dateRangeIsValid && propertyIsValid;
    };
    BasicEventDataComponent.prototype.extractAddedRatePlanCodes = function () {
        return this.ratePlanCodesApplied.value.map(function (ratePlanCode) { return ratePlanCode.ratePlanCode; });
    };
    BasicEventDataComponent.prototype.datesHaveDuplicateRatePlanCodeError = function () {
        return this.startDateInput.hasError('duplicate_rate_plan_codes_by_date')
            || this.endDateInput.hasError('duplicate_rate_plan_codes_by_date');
    };
    BasicEventDataComponent.prototype.enableCommRetention = function () {
        this.commRetention.enable();
    };
    BasicEventDataComponent.prototype.disableCommRetention = function () {
        this.commRetention.disable();
    };
    BasicEventDataComponent.prototype.setUpCommRetention = function () {
        if (this.isReadOnly || this.hasPayment) {
            this.disableCommRetention();
        }
        else {
            this.enableCommRetention();
        }
    };
    Object.defineProperty(BasicEventDataComponent.prototype, "isMultiVendor", {
        get: function () {
            return this.authenticationStore.hasPermission('MultiVendor');
        },
        enumerable: true,
        configurable: true
    });
    BasicEventDataComponent.prototype.setUpShoulderDates = function () {
        if (this.isReadOnly || this.hasPayment) {
            this.shoulderDatesCommission.disable();
        }
        else {
            this.shoulderDatesCommission.enable();
        }
    };
    BasicEventDataComponent.prototype.isLocationRequired = function () {
        if (this.authenticationStore.isAgencyUser() || this.authenticationStore.isSupportUser()) {
            this.basicEventDataForm.get('countryCode').setValidators(forms_es5["Validators"].required);
            this.basicEventDataForm.get('city').setValidators(forms_es5["Validators"].required);
            this.basicEventDataForm.updateValueAndValidity();
        }
    };
    BasicEventDataComponent.prototype.isAgencyUserOrSupportUser = function () {
        if (this.authenticationStore.isAgencyUser() || this.authenticationStore.isSupportUser()) {
            this.agencyOrSupportUser = true;
        }
    };
    BasicEventDataComponent.prototype.getStatusClasses = function (status) {
        var eventStatusInfo = new event_status_info_EventStatusInfo(status);
        if (eventStatusInfo.isPaid()) {
            return 'badge-success';
        }
        else if (eventStatusInfo.isUnpaid()) {
            return 'badge-danger';
        }
        else if (eventStatusInfo.isProcessing()) {
            return 'badge-warning';
        }
        else if (eventStatusInfo.isCancelled()) {
            return 'badge-secondary';
        }
        else {
            return '';
        }
    };
    BasicEventDataComponent.prototype.canSeeShoulderDatesSection = function () {
        return this.authenticationStore.hasPermission('SingleVendor') || this.authenticationStore.isSupportUser();
    };
    BasicEventDataComponent.prototype.isAgencyUser = function () {
        return this.authenticationStore.isAgencyUser();
    };
    return BasicEventDataComponent;
}());
basic_event_data_component___decorate([
    Object(core_es5["Input"])('parentForm'),
    basic_event_data_component___metadata("design:type", typeof (basic_event_data_component__a = typeof forms_es5["FormGroup"] !== "undefined" && forms_es5["FormGroup"]) === "function" && basic_event_data_component__a || Object)
], basic_event_data_component_BasicEventDataComponent.prototype, "parentForm", void 0);
basic_event_data_component___decorate([
    Object(core_es5["Input"])(),
    basic_event_data_component___metadata("design:type", Object)
], basic_event_data_component_BasicEventDataComponent.prototype, "isReadOnly", void 0);
basic_event_data_component___decorate([
    Object(core_es5["Input"])(),
    basic_event_data_component___metadata("design:type", Object)
], basic_event_data_component_BasicEventDataComponent.prototype, "isNewEvent", void 0);
basic_event_data_component___decorate([
    Object(core_es5["Input"])(),
    basic_event_data_component___metadata("design:type", Object)
], basic_event_data_component_BasicEventDataComponent.prototype, "isAgency", void 0);
basic_event_data_component___decorate([
    Object(core_es5["Input"])(),
    basic_event_data_component___metadata("design:type", Object)
], basic_event_data_component_BasicEventDataComponent.prototype, "isMultiVendorPayments", void 0);
basic_event_data_component___decorate([
    Object(core_es5["Input"])(),
    basic_event_data_component___metadata("design:type", Object)
], basic_event_data_component_BasicEventDataComponent.prototype, "eventMultiVendorStatus", void 0);
basic_event_data_component___decorate([
    Object(core_es5["Input"])(),
    basic_event_data_component___metadata("design:type", Object)
], basic_event_data_component_BasicEventDataComponent.prototype, "isMultiVendorUserAndEventCreatedByProperty", void 0);
basic_event_data_component___decorate([
    Object(core_es5["ViewChild"])('bulkEventFile'),
    basic_event_data_component___metadata("design:type", typeof (basic_event_data_component__b = typeof core_es5["ElementRef"] !== "undefined" && core_es5["ElementRef"]) === "function" && basic_event_data_component__b || Object)
], basic_event_data_component_BasicEventDataComponent.prototype, "bulkEventFileInput", void 0);
basic_event_data_component___decorate([
    Object(core_es5["ViewChild"])(confirmation_modal_component_ConfirmationModalComponent),
    basic_event_data_component___metadata("design:type", typeof (basic_event_data_component__c = typeof confirmation_modal_component_ConfirmationModalComponent !== "undefined" && confirmation_modal_component_ConfirmationModalComponent) === "function" && basic_event_data_component__c || Object)
], basic_event_data_component_BasicEventDataComponent.prototype, "confirmationModal", void 0);
basic_event_data_component___decorate([
    Object(core_es5["Input"])('event'),
    basic_event_data_component___metadata("design:type", typeof (basic_event_data_component__d = typeof OnyxEvent !== "undefined" && OnyxEvent) === "function" && basic_event_data_component__d || Object),
    basic_event_data_component___metadata("design:paramtypes", [typeof (basic_event_data_component__e = typeof OnyxEvent !== "undefined" && OnyxEvent) === "function" && basic_event_data_component__e || Object])
], basic_event_data_component_BasicEventDataComponent.prototype, "event", null);
basic_event_data_component___decorate([
    Object(core_es5["ViewChild"])('eventNameInputEl'),
    basic_event_data_component___metadata("design:type", typeof (basic_event_data_component__f = typeof core_es5["ElementRef"] !== "undefined" && core_es5["ElementRef"]) === "function" && basic_event_data_component__f || Object)
], basic_event_data_component_BasicEventDataComponent.prototype, "eventNameInputEl", void 0);
basic_event_data_component___decorate([
    Object(core_es5["Input"])(),
    basic_event_data_component___metadata("design:type", typeof (basic_event_data_component__g = typeof Subject["Subject"] !== "undefined" && Subject["Subject"]) === "function" && basic_event_data_component__g || Object)
], basic_event_data_component_BasicEventDataComponent.prototype, "focusEventNameSubject", void 0);
basic_event_data_component_BasicEventDataComponent = basic_event_data_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-basic-event-data',
        template: __webpack_require__("pGxJ"),
        styles: [__webpack_require__("NM7u")]
    }),
    basic_event_data_component___metadata("design:paramtypes", [typeof (basic_event_data_component__h = typeof forms_es5["FormBuilder"] !== "undefined" && forms_es5["FormBuilder"]) === "function" && basic_event_data_component__h || Object, typeof (basic_event_data_component__j = typeof core["c" /* TranslateService */] !== "undefined" && core["c" /* TranslateService */]) === "function" && basic_event_data_component__j || Object, typeof (basic_event_data_component__k = typeof property_lookup_store_PropertyLookupStore !== "undefined" && property_lookup_store_PropertyLookupStore) === "function" && basic_event_data_component__k || Object, typeof (basic_event_data_component__l = typeof event_store_EventStore !== "undefined" && event_store_EventStore) === "function" && basic_event_data_component__l || Object, typeof (basic_event_data_component__m = typeof EnvironmentConfiguration !== "undefined" && EnvironmentConfiguration) === "function" && basic_event_data_component__m || Object, typeof (basic_event_data_component__o = typeof flash_messages_service_FlashMessagesService !== "undefined" && flash_messages_service_FlashMessagesService) === "function" && basic_event_data_component__o || Object, typeof (basic_event_data_component__p = typeof authentication_store_AuthenticationStore !== "undefined" && authentication_store_AuthenticationStore) === "function" && basic_event_data_component__p || Object, typeof (basic_event_data_component__q = typeof reservation_store_ReservationStore !== "undefined" && reservation_store_ReservationStore) === "function" && basic_event_data_component__q || Object, typeof (basic_event_data_component__r = typeof rsvp_store_RsvpStore !== "undefined" && rsvp_store_RsvpStore) === "function" && basic_event_data_component__r || Object, typeof (_s = typeof payment_store_PaymentStore !== "undefined" && payment_store_PaymentStore) === "function" && _s || Object, typeof (_t = typeof common_data_store_CommonDataStore !== "undefined" && common_data_store_CommonDataStore) === "function" && _t || Object, typeof (_u = typeof event_validation_service_EventValidationService !== "undefined" && event_validation_service_EventValidationService) === "function" && _u || Object])
], basic_event_data_component_BasicEventDataComponent);

var basic_event_data_component__a, basic_event_data_component__b, basic_event_data_component__c, basic_event_data_component__d, basic_event_data_component__e, basic_event_data_component__f, basic_event_data_component__g, basic_event_data_component__h, basic_event_data_component__j, basic_event_data_component__k, basic_event_data_component__l, basic_event_data_component__m, basic_event_data_component__o, basic_event_data_component__p, basic_event_data_component__q, basic_event_data_component__r, _s, _t, _u;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/basic-event-data.component.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/service/custom-label.http.service.ts
var custom_label_http_service___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var custom_label_http_service___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};






var custom_label_http_service_CustomLabelHttpService = (function () {
    function CustomLabelHttpService(http, eventStore, environment, responseUtilService) {
        var _this = this;
        this.http = http;
        this.eventStore = eventStore;
        this.environment = environment;
        this.responseUtilService = responseUtilService;
        this.customLabelUrl = this.environment.baseUrl + '/api/customer-config/customer-labels';
        eventStore.selectedEvent.map(function (event) { return _this.selectedEvent = event; });
    }
    CustomLabelHttpService.prototype.geCustomLabels = function (request) {
        var _this = this;
        return this.http.post("" + this.customLabelUrl, JSON.stringify(request.toJS()), this.jsonOptions)
            .map(function (response) { return response.json(); })
            .catch(function (response) { return _this.responseUtilService.handleError(response); }).share();
    };
    Object.defineProperty(CustomLabelHttpService.prototype, "jsonOptions", {
        get: function () {
            var headers = new http_es5["Headers"]({ 'Content-Type': 'application/json' });
            var options = new http_es5["RequestOptions"]({ headers: headers });
            return options;
        },
        enumerable: true,
        configurable: true
    });
    return CustomLabelHttpService;
}());
custom_label_http_service_CustomLabelHttpService = custom_label_http_service___decorate([
    Object(core_es5["Injectable"])(),
    custom_label_http_service___metadata("design:paramtypes", [typeof (custom_label_http_service__a = typeof AppAuthHttpService !== "undefined" && AppAuthHttpService) === "function" && custom_label_http_service__a || Object, typeof (custom_label_http_service__b = typeof event_store_EventStore !== "undefined" && event_store_EventStore) === "function" && custom_label_http_service__b || Object, typeof (custom_label_http_service__c = typeof EnvironmentConfiguration !== "undefined" && EnvironmentConfiguration) === "function" && custom_label_http_service__c || Object, typeof (custom_label_http_service__d = typeof response_util_service_ResponseUtilService !== "undefined" && response_util_service_ResponseUtilService) === "function" && custom_label_http_service__d || Object])
], custom_label_http_service_CustomLabelHttpService);

var custom_label_http_service__a, custom_label_http_service__b, custom_label_http_service__c, custom_label_http_service__d;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/custom-label.http.service.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/service/custom-label.store.ts
var custom_label_store___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var custom_label_store___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};





var custom_label_store_CustomLabelStore = (function () {
    function CustomLabelStore(flashMessagesService, customLabelHttpService) {
        this.flashMessagesService = flashMessagesService;
        this.customLabelHttpService = customLabelHttpService;
        this.currentCustomLabels = new BehaviorSubject["BehaviorSubject"](null);
    }
    Object.defineProperty(CustomLabelStore.prototype, "customLabels", {
        get: function () {
            return this.currentCustomLabels.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Has to be called to retrieve Custom Labels for a hotel or agency.
     * Is called by resolver.
     *
     * @param eventId
     * @returns CustomLabelResponse
     */
    CustomLabelStore.prototype.loadCustomLabels = function (request) {
        var _this = this;
        return this.customLabelHttpService.geCustomLabels(request)
            .catch(function (error) {
            _this.flashMessagesService.error('MESSAGES.ERROR.GET_CUSTOM_LABELS', "Could not retrieve the custom field labels: " + error);
            return Observable["Observable"].throw(error);
        })
            .map(function (res) {
            _this.currentCustomLabels.next(res);
            return res;
        });
    };
    return CustomLabelStore;
}());
custom_label_store_CustomLabelStore = custom_label_store___decorate([
    Object(core_es5["Injectable"])(),
    custom_label_store___metadata("design:paramtypes", [typeof (custom_label_store__a = typeof flash_messages_service_FlashMessagesService !== "undefined" && flash_messages_service_FlashMessagesService) === "function" && custom_label_store__a || Object, typeof (custom_label_store__b = typeof custom_label_http_service_CustomLabelHttpService !== "undefined" && custom_label_http_service_CustomLabelHttpService) === "function" && custom_label_store__b || Object])
], custom_label_store_CustomLabelStore);

var custom_label_store__a, custom_label_store__b;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/custom-label.store.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/custom-label-request.ts
var custom_label_request___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var CustomLabelRequestRecord = Object(immutable["Record"])({
    chainCode: null,
    brandCode: null,
    propertyId: null,
    customerNum: null,
    iata: null
});
var CustomLabelRequest = (function (_super) {
    custom_label_request___extends(CustomLabelRequest, _super);
    function CustomLabelRequest() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return CustomLabelRequest;
}(CustomLabelRequestRecord));

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/custom-label-request.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/event/event.resolver.ts
var event_resolver___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var event_resolver___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var event_resolver___awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var event_resolver___generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};



var EventResolver = (function () {
    function EventResolver(eventStore, translateService) {
        this.eventStore = eventStore;
        this.translateService = translateService;
    }
    EventResolver.prototype.resolve = function (route, state) {
        return event_resolver___awaiter(this, void 0, void 0, function () {
            var id, eventPartyId;
            return event_resolver___generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        id = route.params['id'];
                        eventPartyId = route.params['eventPartyId'];
                        if (!id) {
                            throw new Error(this.translateService.instant('MESSAGES.ERROR.GET_EVENT'));
                        }
                        if (!eventPartyId) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.eventStore.getEventByParty(route.params['id'], eventPartyId).toPromise()];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2: return [4 /*yield*/, this.eventStore.getEvent(route.params['id']).toPromise()];
                    case 3: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return EventResolver;
}());
EventResolver = event_resolver___decorate([
    Object(core_es5["Injectable"])(),
    event_resolver___metadata("design:paramtypes", [typeof (event_resolver__a = typeof event_store_EventStore !== "undefined" && event_store_EventStore) === "function" && event_resolver__a || Object, typeof (event_resolver__b = typeof core["c" /* TranslateService */] !== "undefined" && core["c" /* TranslateService */]) === "function" && event_resolver__b || Object])
], EventResolver);

var event_resolver__a, event_resolver__b;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/event.resolver.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/basic-event-data/custom-label.resolver.ts
var custom_label_resolver___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var custom_label_resolver___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};







var custom_label_resolver_CustomLabelResolver = (function () {
    function CustomLabelResolver(customLabelStore, eventStore, authenticationStore, multiAgencyService, eventResolver) {
        var _this = this;
        this.customLabelStore = customLabelStore;
        this.eventStore = eventStore;
        this.authenticationStore = authenticationStore;
        this.multiAgencyService = multiAgencyService;
        this.eventResolver = eventResolver;
        this.user = null;
        this.agencyId = null;
        this.authenticationStore.user.subscribe(function (user) {
            _this.user = user;
        });
        this.multiAgencyService.defaultAgencyId.subscribe(function (agencyId) {
            _this.agencyId = agencyId;
        });
    }
    CustomLabelResolver.prototype.resolve = function (route, state) {
        var _this = this;
        var eventPartyId = route.params['eventPartyId'];
        if (!eventPartyId) {
            // Preload labels when user is single property user or agency
            return this.loadDefaultLabels();
        }
        else {
            var eventId = route.params['id'];
            return this.eventStore.getEventByParty(eventId, eventPartyId).flatMap(function (event) {
                var request = new CustomLabelRequest({
                    chainCode: event.eventProperty.chain,
                    brandCode: event.eventProperty.brand,
                    propertyId: event.eventProperty.propertyId
                });
                return _this.customLabelStore.loadCustomLabels(request);
            });
        }
    };
    CustomLabelResolver.prototype.loadDefaultLabels = function () {
        var _this = this;
        if (this.authenticationStore.isPropertyUser()) {
            var request = new CustomLabelRequest({
                chainCode: this.user.allChains[0],
                brandCode: this.user.allBrands && this.user.allBrands.length > 0 ? this.user.allBrands[0] : null,
                propertyId: this.authenticationStore.isSinglePropertyUser() ? this.user.allProperties[0] : null
            });
            return this.customLabelStore.loadCustomLabels(request);
        }
        else if (this.authenticationStore.isAgencyUser()) {
            var customerInfo = this.user.customerInfo.filter(function (value) { return value.includes(_this.agencyId); });
            var request = new CustomLabelRequest({
                customerNum: customerInfo && customerInfo.length > 0 ? customerInfo[0].substring(0, customerInfo[0].indexOf('#')) : null,
                iata: this.agencyId
            });
            return this.customLabelStore.loadCustomLabels(request);
        }
    };
    return CustomLabelResolver;
}());
custom_label_resolver_CustomLabelResolver = custom_label_resolver___decorate([
    Object(core_es5["Injectable"])(),
    custom_label_resolver___metadata("design:paramtypes", [typeof (custom_label_resolver__a = typeof custom_label_store_CustomLabelStore !== "undefined" && custom_label_store_CustomLabelStore) === "function" && custom_label_resolver__a || Object, typeof (custom_label_resolver__b = typeof event_store_EventStore !== "undefined" && event_store_EventStore) === "function" && custom_label_resolver__b || Object, typeof (custom_label_resolver__c = typeof authentication_store_AuthenticationStore !== "undefined" && authentication_store_AuthenticationStore) === "function" && custom_label_resolver__c || Object, typeof (custom_label_resolver__d = typeof multi_agency_service_MultiAgencyService !== "undefined" && multi_agency_service_MultiAgencyService) === "function" && custom_label_resolver__d || Object, typeof (custom_label_resolver__e = typeof EventResolver !== "undefined" && EventResolver) === "function" && custom_label_resolver__e || Object])
], custom_label_resolver_CustomLabelResolver);

var custom_label_resolver__a, custom_label_resolver__b, custom_label_resolver__c, custom_label_resolver__d, custom_label_resolver__e;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/custom-label.resolver.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/bulk-action.ts
var BulkAction;
(function (BulkAction) {
    BulkAction[BulkAction["PAYMENT_REQUEST"] = 'PAYMENT_REQUEST'] = "PAYMENT_REQUEST";
    BulkAction[BulkAction["PAID_DIRECT"] = 'PAID_DIRECT'] = "PAID_DIRECT";
    BulkAction[BulkAction["CANCELLED"] = 'CANCELLED'] = "CANCELLED";
})(BulkAction || (BulkAction = {}));
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/bulk-action.js.map
// EXTERNAL MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/node_modules/file-saver/dist/FileSaver.min.js
var FileSaver_min = __webpack_require__("71dL");
var FileSaver_min_default = /*#__PURE__*/__webpack_require__.n(FileSaver_min);

// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/service/event-list.store.ts
var event_list_store___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var event_list_store___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
















var event_list_store_EventListStore = (function () {
    function EventListStore(eventHttpService, errorHandlerService, searchParametersStore, logService, flashMessagesService, eventFilterUtils, environment) {
        this.eventHttpService = eventHttpService;
        this.errorHandlerService = errorHandlerService;
        this.searchParametersStore = searchParametersStore;
        this.logService = logService;
        this.flashMessagesService = flashMessagesService;
        this.eventFilterUtils = eventFilterUtils;
        this.environment = environment;
        this.eventPage = new BehaviorSubject["BehaviorSubject"](page_Page.empty());
        this.bulkActionPageSubject = new BehaviorSubject["BehaviorSubject"](page_Page.empty());
    }
    Object.defineProperty(EventListStore.prototype, "events", {
        get: function () {
            return this.eventPage.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EventListStore.prototype, "eventsValue", {
        get: function () {
            return this.eventPage.value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EventListStore.prototype, "bulkActionPage", {
        get: function () {
            return this.bulkActionPageSubject.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EventListStore.prototype, "bulkActionPageValue", {
        get: function () {
            return this.bulkActionPageSubject.value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EventListStore.prototype, "totalEventCount", {
        get: function () {
            return this.eventPage.asObservable().map(function (page) { return page.totalElements; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EventListStore.prototype, "sortOptionsApplied", {
        get: function () {
            return this.eventPage.asObservable().map(function (page) { return page.sort; });
        },
        enumerable: true,
        configurable: true
    });
    EventListStore.prototype.loadBulkActionEvents = function (page, itemsPerPage, filters) {
        var _this = this;
        var pageNumber = (page || page === 0) ? page : Constants.SEARCH_DEFAULT_PAGE;
        // filter set
        var filtersSet = filters ? Object(immutable["OrderedSet"])(filters) : Object(immutable["OrderedSet"])([]);
        this.searchParametersStore.eventSearchParametersSnapshot.filters.forEach(function (filter) {
            filtersSet = filtersSet.add(filter);
        });
        // search params
        var searchParameters = new EventSearchParameters({
            searchText: this.searchParametersStore.eventSearchParametersSnapshot.searchText,
            filters: filtersSet,
            maxEvents: this.environment.events.maxEvents
        });
        return this.eventHttpService.search(searchParameters, pageNumber, itemsPerPage)
            .catch(function (error) {
            _this.flashMessagesService.error('MESSAGES.ERROR.SEARCH_EVENTS', "Error retrieving events: " + error);
            return Observable["Observable"].throw(error);
        })
            .map(function (res) {
            _this.bulkActionPageSubject.next(res);
            _this.logService.debug("loadEvents result: " + res);
            return res;
        });
    };
    EventListStore.prototype.loadEvents = function (page, itemsPerPage, isSpinner) {
        var _this = this;
        if (isSpinner === void 0) { isSpinner = true; }
        var pageNumber = (page || page === 0) ? page : Constants.SEARCH_DEFAULT_PAGE;
        this.logService.debug("searchParameters: " + this.searchParametersStore.eventSearchParametersSnapshot + ",\n       page: " + pageNumber + ",\n       size: " + itemsPerPage);
        return this.eventHttpService.search(this.searchParametersStore.eventSearchParametersSnapshot, pageNumber, itemsPerPage, isSpinner)
            .catch(function (error) {
            _this.flashMessagesService.error('MESSAGES.ERROR.SEARCH_EVENTS', "Error retrieving events: " + error);
            return Observable["Observable"].throw(error);
        })
            .map(function (res) {
            _this.eventPage.next(res);
            _this.logService.debug("loadEvents result: " + res);
            return res;
        });
    };
    EventListStore.prototype.loadRecentlyEvents = function (eventParameters) {
        return this.eventHttpService.getRecentlyEvents(eventParameters)
            .catch(this.errorHandlerService.handleObservable('Error retrieving events', 'Could not retrieve events!'))
            .map(function (page) {
            return page.content;
        });
    };
    EventListStore.prototype.exportEventExcel = function (searchParameters) {
        return this.eventHttpService.exportEventExcel(searchParameters).map(function (data) {
            Object(FileSaver_min["saveAs"])(data, 'event_list_' + date_util_DateUtil.formatDate(new Date(), 'YYYYMMDD') + '.xlsx');
        });
    };
    return EventListStore;
}());
event_list_store_EventListStore = event_list_store___decorate([
    Object(core_es5["Injectable"])(),
    event_list_store___metadata("design:paramtypes", [typeof (event_list_store__a = typeof event_http_service_EventHttpService !== "undefined" && event_http_service_EventHttpService) === "function" && event_list_store__a || Object, typeof (event_list_store__b = typeof error_handler_service_ErrorHandlerService !== "undefined" && error_handler_service_ErrorHandlerService) === "function" && event_list_store__b || Object, typeof (event_list_store__c = typeof event_search_parameters_store_EventSearchParametersStore !== "undefined" && event_search_parameters_store_EventSearchParametersStore) === "function" && event_list_store__c || Object, typeof (event_list_store__d = typeof log_service_LogService !== "undefined" && log_service_LogService) === "function" && event_list_store__d || Object, typeof (event_list_store__e = typeof flash_messages_service_FlashMessagesService !== "undefined" && flash_messages_service_FlashMessagesService) === "function" && event_list_store__e || Object, typeof (event_list_store__f = typeof event_filter_util_service_EventFilterUtilsService !== "undefined" && event_filter_util_service_EventFilterUtilsService) === "function" && event_list_store__f || Object, typeof (event_list_store__g = typeof EnvironmentConfiguration !== "undefined" && EnvironmentConfiguration) === "function" && event_list_store__g || Object])
], event_list_store_EventListStore);

var event_list_store__a, event_list_store__b, event_list_store__c, event_list_store__d, event_list_store__e, event_list_store__f, event_list_store__g;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/event-list.store.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/event-vendor-summary.ts

var EventVendorSummaryRecord = Object(immutable["Record"])({
    'eventId': null,
    'name': null,
    'startDate': null,
    'autoGenerated': false,
    'eventReferenceNumber': null,
    'endDate': null,
    'payStatus': null,
    'eventPartyId': null,
    'vendorName': null,
    'masterBillPaid': null,
    'currency': null,
    'dueAmount': null,
    'paymentAmount': null,
    'error': null
});
var EventVendorSummary = (function () {
    function EventVendorSummary() {
    }
    return EventVendorSummary;
}());

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/event-vendor-summary.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/bulk-action/bulk-action-popup/bulk-action-popup.component.ts
var bulk_action_popup_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var bulk_action_popup_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};




















var bulk_action_popup_component_BulkActionPopupComponent = (function () {
    function BulkActionPopupComponent(eventListStore, logService, paymentStore, flashMessagesService, translateService, environment, decimalPipe) {
        this.eventListStore = eventListStore;
        this.logService = logService;
        this.paymentStore = paymentStore;
        this.flashMessagesService = flashMessagesService;
        this.translateService = translateService;
        this.environment = environment;
        this.decimalPipe = decimalPipe;
        this.refreshEvents = new core_es5["EventEmitter"]();
        this.bulkAction = BulkAction.PAYMENT_REQUEST;
        this.selectedVendors = [];
        this.confirmationModalConfig = new ConfirmationModalConfig();
        this.config = {
            backdrop: 'static',
            keyboard: false
        };
        this.bulkActionInProcess = false;
    }
    BulkActionPopupComponent.prototype.ngOnInit = function () {
    };
    Object.defineProperty(BulkActionPopupComponent.prototype, "BulkAction", {
        get: function () {
            return BulkAction;
        },
        enumerable: true,
        configurable: true
    });
    BulkActionPopupComponent.prototype.open = function (action) {
        var _this = this;
        this.bulkActionInProcess = false;
        this.eventsProcessed = 0;
        this.bulkAction = action;
        // Load and filter events
        this.eventListStore.loadBulkActionEvents(0, this.environment.events.maxEvents, Object(immutable["OrderedSet"])([])).take(1)
            .subscribe(function (eventPage) {
            _this.eventVendorSummaryList = [];
            switch (_this.bulkAction) {
                case BulkAction.PAYMENT_REQUEST:
                    eventPage.content.filter(function (event) {
                        return !Object(util_util["isNullOrUndefined"])(event.eventVendors) && _this.hasEventFinished(event);
                    })
                        .map(function (event) {
                        event.eventVendors.filter(function (vendor) { return !vendor.subscriber
                            && vendor.paymentSummary
                            && vendor.paymentSummary.dueAmount
                            && Number(vendor.paymentSummary.dueAmount) > 0; })
                            .map(function (vendor) {
                            if (!Object(util_util["isNullOrUndefined"])(vendor.contact) && !Object(util_util["isNullOrUndefined"])(vendor.contact.email)
                                && vendor.contact.email.length > 1) {
                                _this.addEventVendor(event, vendor);
                            }
                        });
                    });
                    break;
                case BulkAction.PAID_DIRECT:
                    eventPage.content.filter(function (event) {
                        return !Object(util_util["isNullOrUndefined"])(event.eventVendors) && _this.hasEventFinished(event);
                    })
                        .map(function (event) {
                        event.eventVendors.filter(function (vendor) { return !vendor.subscriber
                            && vendor.paymentSummary && Number(vendor.paymentSummary.paymentAmount) > 0
                            && (!vendor.paymentSummary.payStatus
                                || vendor.paymentSummary.payStatus === PaymentStatus.REQUESTED.toString()
                                || vendor.paymentSummary.payStatus === PaymentStatus.RESENT_REQUEST.toString()
                                || vendor.paymentSummary.payStatus === PaymentStatus.REQUEST_REJECTED.toString()
                                || vendor.paymentSummary.payStatus === PaymentStatus.INVOICE_REJECTED.toString()); })
                            .map(function (vendor) {
                            _this.addEventVendor(event, vendor);
                        });
                    });
                    break;
                case BulkAction.CANCELLED:
                    eventPage.content.filter(function (event) {
                        return !Object(util_util["isNullOrUndefined"])(event.eventVendors);
                    })
                        .map(function (event) {
                        event.eventVendors.filter(function (vendor) { return !vendor.subscriber
                            && vendor.paymentSummary
                            && (!vendor.paymentSummary.payStatus
                                || vendor.paymentSummary.payStatus === PaymentStatus.REQUESTED.toString()
                                || vendor.paymentSummary.payStatus === PaymentStatus.RESENT_REQUEST.toString()
                                || vendor.paymentSummary.payStatus === PaymentStatus.REQUEST_REJECTED.toString()); })
                            .map(function (vendor) {
                            _this.addEventVendor(event, vendor);
                        });
                    });
                    break;
            }
            _this.eventVendorSummaryList.sort(function (vendorSummary1, avendorSummary2) {
                if (vendorSummary1.name < avendorSummary2.name) {
                    return -1;
                }
                else if (avendorSummary2.name > avendorSummary2.name) {
                    return 1;
                }
                else {
                    return 0;
                }
            });
            // Check number of events loaded
            if (!_this.eventVendorSummaryList || _this.eventVendorSummaryList.length === 0) {
                _this.noEventsFound = true;
            }
            else {
                _this.noEventsFound = false;
                _this.eventCountForTranslate = {
                    eventCount: _this.eventVendorSummaryList.length
                };
            }
            // Uncheck all events
            _this.allEventsChecked = false;
            _this.checkUncheckAll();
            _this.bulkActionModal.show();
        });
    };
    BulkActionPopupComponent.prototype.onCancel = function () {
        this.bulkActionModal.hide();
    };
    BulkActionPopupComponent.prototype.getEventNameLine1 = function (name) {
        if (name.length > Constants.EVENTS_NAME_MAX_SIZE) {
            return name.substring(0, Constants.EVENTS_NAME_MAX_SIZE);
        }
        else {
            return name;
        }
    };
    BulkActionPopupComponent.prototype.getEventNameLine2 = function (name) {
        if (name.length > Constants.EVENTS_NAME_MAX_SIZE) {
            var line2 = name.substring(Constants.EVENTS_NAME_MAX_SIZE);
            if (line2.length > Constants.EVENTS_NAME_MAX_SIZE) {
                return line2.substring(0, Constants.EVENTS_NAME_MAX_SIZE);
            }
            else {
                return line2;
            }
        }
        else {
            return null;
        }
    };
    BulkActionPopupComponent.prototype.hasEventFinished = function (event) {
        return date_util_DateUtil.differenceInCalendarDays(date_util_DateUtil.parseDate(event.endDate), new Date()) < 0;
    };
    BulkActionPopupComponent.prototype.hasEventStarted = function (event) {
        return date_util_DateUtil.differenceInCalendarDays(date_util_DateUtil.parseDate(event.startDate), new Date()) < 0;
    };
    BulkActionPopupComponent.prototype.checkUncheckAll = function () {
        var _this = this;
        this.eventVendorSummaryList.forEach(function (event) {
            event.isSelected = _this.allEventsChecked;
        });
        this.getCheckedItemList();
    };
    BulkActionPopupComponent.prototype.isAllSelected = function () {
        this.allEventsChecked = this.eventVendorSummaryList.every(function (item) {
            return item.isSelected === true;
        });
        this.getCheckedItemList();
    };
    BulkActionPopupComponent.prototype.getCheckedItemList = function () {
        var _this = this;
        this.selectedVendors = [];
        this.eventVendorSummaryList.forEach(function (event) {
            if (event.isSelected) {
                _this.selectedVendors.push(event);
            }
        });
    };
    BulkActionPopupComponent.prototype.disableBulkActionButton = function () {
        return !this.selectedVendors || this.selectedVendors.length === 0;
    };
    BulkActionPopupComponent.prototype.confirmBeforeBulkActionHandler = function (value) {
        if (value) {
            this.onBulkAction();
        }
        this.bulkActionModal.show();
    };
    BulkActionPopupComponent.prototype.confirmBeforeBulkAction = function () {
        var label = '';
        switch (this.bulkAction) {
            case BulkAction.PAYMENT_REQUEST:
                label = 'EVENTS.BULK_ACTION.CONFIRM_PAYMENT_REQUEST';
                break;
            case BulkAction.PAID_DIRECT:
                label = 'EVENTS.BULK_ACTION.CONFIRM_PAID_DIRECT';
                break;
            case BulkAction.CANCELLED:
                label = 'EVENTS.BULK_ACTION.CONFIRM_CANCELLED';
                break;
            default:
                label = 'EVENTS.BULK_ACTION.CONFIRM_PAYMENT_REQUEST';
        }
        this.confirmationModalConfig.confirm = this.translateService.instant('EVENTS.BULK_ACTION.CONFIRM_PROCEED');
        this.confirmationModalConfig.title = this.translateService.instant(label, { eventCount: this.selectedVendors.length });
        this.bulkActionModal.hide();
        this.confirmationModal.open();
    };
    BulkActionPopupComponent.prototype.onBulkAction = function () {
        this.logService.info(JSON.stringify(this.selectedVendors));
        switch (this.bulkAction) {
            case BulkAction.PAYMENT_REQUEST:
                this.processPaymentRequests();
                break;
            case BulkAction.PAID_DIRECT:
                this.processPaidDirect();
                break;
            case BulkAction.CANCELLED:
                this.processCancelled();
                break;
        }
    };
    BulkActionPopupComponent.prototype.processPaymentRequests = function () {
        var eventPayments = [];
        this.selectedVendors.forEach(function (vendor) {
            var payment = new Payment({
                commissionAmount: parseFloat(vendor.dueAmount.replace(/,/g, '')),
                description: '',
                commissionCurrency: vendor.currency,
                eventId: vendor.eventId,
                type: PaymentType.FINAL_PAYMENT,
                eventPartyId: vendor.eventPartyId
            });
            eventPayments.push(payment);
        });
        this.processPayments(eventPayments);
    };
    BulkActionPopupComponent.prototype.processPaidDirect = function () {
        var eventPayments = [];
        this.selectedVendors.forEach(function (vendor) {
            var payment = new Payment({
                commissionAmount: parseFloat(vendor.paymentAmount.replace(/,/g, '')),
                description: '',
                commissionCurrency: vendor.currency,
                eventId: vendor.eventId,
                type: PaymentType.PAID_DIRECT,
                eventPartyId: vendor.eventPartyId
            });
            eventPayments.push(payment);
        });
        this.processPayments(eventPayments);
    };
    BulkActionPopupComponent.prototype.processCancelled = function () {
        var eventPayments = [];
        this.selectedVendors.forEach(function (vendor) {
            var payment = new Payment({
                commissionAmount: null,
                description: '',
                commissionCurrency: vendor.currency,
                eventId: vendor.eventId,
                type: PaymentType.EVENT_CANCELLED,
                eventPartyId: vendor.eventPartyId
            });
            eventPayments.push(payment);
        });
        this.processPayments(eventPayments);
    };
    BulkActionPopupComponent.prototype.processPayments = function (payments) {
        var _this = this;
        this.bulkActionInProcess = true;
        var failedPaymentCounter = 0;
        this.bulkActionInfo = this.translateService.instant('EVENTS.BULK_ACTION.PROCESSING', { paymentCount: payments.length });
        this.paymentStore.bulkActionPayments(payments)
            .subscribe(function (res) {
            var failedPayments = res.filter(function (r) { return r.error; });
            failedPaymentCounter = failedPayments.length;
            // Retrieve failures
            if (failedPaymentCounter > 0) {
                _this.bulkActionInfo = _this.translateService
                    .instant('EVENTS.BULK_ACTION.FAILURES', { failedPaymentCount: failedPayments.length, paymentCount: payments.length });
                failedPayments.forEach(function (r) {
                    var vendor = _this.selectedVendors.find(function (v) { return v.eventPartyId === r.eventPartyId; });
                    _this.bulkActionInfo += _this.translateService
                        .instant('EVENTS.BULK_ACTION.PAYMENT_ERROR', { eventReferenceNumber: vendor.eventReferenceNumber, vendorName: vendor.vendorName, error: r.error });
                });
                _this.logService.info(_this.bulkActionInfo);
            }
            _this.flashMessagesService.success('EVENT.COMMISSION.PAYMENTS_SAVED');
        }, function (err) {
            _this.logService.error("Error processing Bulk Payments: " + err);
            if (typeof err === 'string' && err.includes('The provided bulk payments are greater than')) {
                _this.flashMessagesService.error('EVENTS.BULK_ACTION.MAX_NUMBER_PAYMENTS', "Error processing Payment: " + err);
            }
            else {
                _this.flashMessagesService.error('EVENTS.BULK_ACTION.ERROR', "Error processing Payment: " + err);
            }
        }, function () {
            _this.logService.info('Bulk Payments completed');
            if (failedPaymentCounter === 0) {
                _this.bulkActionModal.hide();
            }
            _this.refreshEvents.emit(true);
        });
    };
    BulkActionPopupComponent.prototype.addEventVendor = function (event, vendor) {
        var eventVendor = new EventVendorSummary();
        eventVendor.eventId = event.eventId,
            eventVendor.name = event.name,
            eventVendor.startDate = event.startDate,
            eventVendor.endDate = event.endDate,
            eventVendor.autoGenerated = event.autoGenerated,
            eventVendor.eventReferenceNumber = event.eventReferenceNumber,
            eventVendor.eventPartyId = vendor.eventPartyId,
            eventVendor.vendorName = vendor.name,
            eventVendor.masterBillPaid = vendor.masterBillPaid,
            eventVendor.currency = event.currency,
            eventVendor.dueAmount = this.decimalPipe.transform(vendor.paymentSummary.dueAmount, '1.2-2'),
            eventVendor.paymentAmount = this.decimalPipe.transform(vendor.paymentSummary.dueAmount, '1.2-2'),
            eventVendor.payStatus = vendor.paymentSummary.payStatus;
        this.eventVendorSummaryList.push(eventVendor);
    };
    return BulkActionPopupComponent;
}());
bulk_action_popup_component___decorate([
    Object(core_es5["ViewChild"])(confirmation_modal_component_ConfirmationModalComponent),
    bulk_action_popup_component___metadata("design:type", typeof (bulk_action_popup_component__a = typeof confirmation_modal_component_ConfirmationModalComponent !== "undefined" && confirmation_modal_component_ConfirmationModalComponent) === "function" && bulk_action_popup_component__a || Object)
], bulk_action_popup_component_BulkActionPopupComponent.prototype, "confirmationModal", void 0);
bulk_action_popup_component___decorate([
    Object(core_es5["Output"])(),
    bulk_action_popup_component___metadata("design:type", Object)
], bulk_action_popup_component_BulkActionPopupComponent.prototype, "refreshEvents", void 0);
bulk_action_popup_component___decorate([
    Object(core_es5["ViewChild"])(ngx_bootstrap["b" /* ModalDirective */]),
    bulk_action_popup_component___metadata("design:type", typeof (bulk_action_popup_component__b = typeof ngx_bootstrap["b" /* ModalDirective */] !== "undefined" && ngx_bootstrap["b" /* ModalDirective */]) === "function" && bulk_action_popup_component__b || Object)
], bulk_action_popup_component_BulkActionPopupComponent.prototype, "bulkActionModal", void 0);
bulk_action_popup_component_BulkActionPopupComponent = bulk_action_popup_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-bulk-action-popup',
        template: __webpack_require__("21j7"),
        styles: [__webpack_require__("ISUr")]
    }),
    bulk_action_popup_component___metadata("design:paramtypes", [typeof (bulk_action_popup_component__c = typeof event_list_store_EventListStore !== "undefined" && event_list_store_EventListStore) === "function" && bulk_action_popup_component__c || Object, typeof (bulk_action_popup_component__d = typeof log_service_LogService !== "undefined" && log_service_LogService) === "function" && bulk_action_popup_component__d || Object, typeof (bulk_action_popup_component__e = typeof payment_store_PaymentStore !== "undefined" && payment_store_PaymentStore) === "function" && bulk_action_popup_component__e || Object, typeof (bulk_action_popup_component__f = typeof flash_messages_service_FlashMessagesService !== "undefined" && flash_messages_service_FlashMessagesService) === "function" && bulk_action_popup_component__f || Object, typeof (bulk_action_popup_component__g = typeof core["c" /* TranslateService */] !== "undefined" && core["c" /* TranslateService */]) === "function" && bulk_action_popup_component__g || Object, typeof (bulk_action_popup_component__h = typeof EnvironmentConfiguration !== "undefined" && EnvironmentConfiguration) === "function" && bulk_action_popup_component__h || Object, typeof (bulk_action_popup_component__j = typeof common_es5["DecimalPipe"] !== "undefined" && common_es5["DecimalPipe"]) === "function" && bulk_action_popup_component__j || Object])
], bulk_action_popup_component_BulkActionPopupComponent);

var bulk_action_popup_component__a, bulk_action_popup_component__b, bulk_action_popup_component__c, bulk_action_popup_component__d, bulk_action_popup_component__e, bulk_action_popup_component__f, bulk_action_popup_component__g, bulk_action_popup_component__h, bulk_action_popup_component__j;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/bulk-action-popup.component.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/child-contact-form/child-contact-form.component.ts
var child_contact_form_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var child_contact_form_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};





var child_contact_form_component_ChildContactFormComponent = (function () {
    function ChildContactFormComponent(environment) {
        this.environment = environment;
        this.isReadOnly = true;
        this.showLongLabels = false;
        this.showSubscriberBadge = false;
        this.clientContactEditable = true;
        this.canEditVendorCommRate = true;
        this.outputEmail = new core_es5["EventEmitter"]();
    }
    Object.defineProperty(ChildContactFormComponent.prototype, "event", {
        set: function (event) {
            this.onyxEvent = event;
        },
        enumerable: true,
        configurable: true
    });
    ChildContactFormComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (this.emailValidation()) {
            this.contactForm.get('contact').get('email').valueChanges.subscribe(function (value) {
                if (_this.contactForm && _this.contactForm.get('partyType') && _this.contactForm.get('partyType').value === PartyType.PROPERTY) {
                    _this.outputEmail.emit(value);
                    _this.checkDuplicatedEmailError(value);
                }
            });
        }
        if (this.contactForm.get('commissionRoomPercentage') !== null && this.contactForm.get('commissionRoomPercentage') !== undefined) {
            this.contactForm.get('commissionRoomPercentage').setValidators(forms_es5["Validators"].required);
        }
    };
    ChildContactFormComponent.prototype.ngOnChanges = function (changes) {
        if (this.emailValidation() && changes.inputEmail && this.contactForm) {
            this.checkDuplicatedEmailError(this.contactForm.get('contact').get('email').value);
        }
        if (!changes['event']) {
            return;
        }
    };
    ChildContactFormComponent.prototype.checkDuplicatedEmailError = function (formValue) {
        if (formValue && this.inputEmail && formValue.toLowerCase() === this.inputEmail.toLowerCase()) {
            this.contactForm.get('contact').get('email').setErrors({ 'email_contact_property_agency_same': true });
        }
        else {
            if (this.contactForm && this.contactForm.get('contact').get('email').errors
                && this.contactForm.get('contact').get('email').errors['email_contact_property_agency_same']) {
                this.contactForm.get('contact').get('email').setErrors(null);
            }
        }
    };
    ChildContactFormComponent.prototype.emailValidation = function () {
        return this.environment.emailValidation;
    };
    ChildContactFormComponent.prototype.getReadOnly = function () {
        if (this.partyType === PartyType.CLIENT) {
            return this.isReadOnly || !this.clientContactEditable;
        }
        else {
            return this.isReadOnly;
        }
    };
    ChildContactFormComponent.prototype.getReadOnlyClient = function () {
        if (this.partyType === PartyType.CLIENT) {
            return this.isReadOnly || !this.clientContactEditable;
        }
        else {
            return true;
        }
    };
    Object.defineProperty(ChildContactFormComponent.prototype, "commRetention", {
        get: function () {
            return this.contactForm.get('commRetention').value;
        },
        enumerable: true,
        configurable: true
    });
    return ChildContactFormComponent;
}());
child_contact_form_component___decorate([
    Object(core_es5["Input"])('partyType'),
    child_contact_form_component___metadata("design:type", typeof (child_contact_form_component__a = typeof PartyType !== "undefined" && PartyType) === "function" && child_contact_form_component__a || Object)
], child_contact_form_component_ChildContactFormComponent.prototype, "partyType", void 0);
child_contact_form_component___decorate([
    Object(core_es5["Input"])('contactReferenceNumberTitle'),
    child_contact_form_component___metadata("design:type", Object)
], child_contact_form_component_ChildContactFormComponent.prototype, "contactReferenceNumberTitle", void 0);
child_contact_form_component___decorate([
    Object(core_es5["Input"])('contactForm'),
    child_contact_form_component___metadata("design:type", typeof (child_contact_form_component__b = typeof forms_es5["FormGroup"] !== "undefined" && forms_es5["FormGroup"]) === "function" && child_contact_form_component__b || Object)
], child_contact_form_component_ChildContactFormComponent.prototype, "contactForm", void 0);
child_contact_form_component___decorate([
    Object(core_es5["Input"])('event'),
    child_contact_form_component___metadata("design:type", typeof (child_contact_form_component__c = typeof OnyxEvent !== "undefined" && OnyxEvent) === "function" && child_contact_form_component__c || Object),
    child_contact_form_component___metadata("design:paramtypes", [typeof (child_contact_form_component__d = typeof OnyxEvent !== "undefined" && OnyxEvent) === "function" && child_contact_form_component__d || Object])
], child_contact_form_component_ChildContactFormComponent.prototype, "event", null);
child_contact_form_component___decorate([
    Object(core_es5["Input"])(),
    child_contact_form_component___metadata("design:type", Object)
], child_contact_form_component_ChildContactFormComponent.prototype, "isReadOnly", void 0);
child_contact_form_component___decorate([
    Object(core_es5["Input"])(),
    child_contact_form_component___metadata("design:type", Object)
], child_contact_form_component_ChildContactFormComponent.prototype, "showLongLabels", void 0);
child_contact_form_component___decorate([
    Object(core_es5["Input"])(),
    child_contact_form_component___metadata("design:type", Object)
], child_contact_form_component_ChildContactFormComponent.prototype, "showSubscriberBadge", void 0);
child_contact_form_component___decorate([
    Object(core_es5["Input"])(),
    child_contact_form_component___metadata("design:type", Object)
], child_contact_form_component_ChildContactFormComponent.prototype, "clientContactEditable", void 0);
child_contact_form_component___decorate([
    Object(core_es5["Input"])(),
    child_contact_form_component___metadata("design:type", Object)
], child_contact_form_component_ChildContactFormComponent.prototype, "canEditVendorCommRate", void 0);
child_contact_form_component___decorate([
    Object(core_es5["Input"])(),
    child_contact_form_component___metadata("design:type", String)
], child_contact_form_component_ChildContactFormComponent.prototype, "inputEmail", void 0);
child_contact_form_component___decorate([
    Object(core_es5["Output"])(),
    child_contact_form_component___metadata("design:type", typeof (child_contact_form_component__e = typeof core_es5["EventEmitter"] !== "undefined" && core_es5["EventEmitter"]) === "function" && child_contact_form_component__e || Object)
], child_contact_form_component_ChildContactFormComponent.prototype, "outputEmail", void 0);
child_contact_form_component_ChildContactFormComponent = child_contact_form_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-child-contact-form',
        template: __webpack_require__("9I5S")
    }),
    child_contact_form_component___metadata("design:paramtypes", [typeof (child_contact_form_component__f = typeof EnvironmentConfiguration !== "undefined" && EnvironmentConfiguration) === "function" && child_contact_form_component__f || Object])
], child_contact_form_component_ChildContactFormComponent);

var child_contact_form_component__a, child_contact_form_component__b, child_contact_form_component__c, child_contact_form_component__d, child_contact_form_component__e, child_contact_form_component__f;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/child-contact-form.component.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/contact-form/contact-form.component.ts
var contact_form_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var contact_form_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};








var contact_form_component_ContactFormComponent = (function () {
    function ContactFormComponent(formBuilder, translateService) {
        this.formBuilder = formBuilder;
        this.translateService = translateService;
        this.isReadOnly = true;
    }
    Object.defineProperty(ContactFormComponent.prototype, "event", {
        set: function (event) {
            this.onyxEvent = event;
        },
        enumerable: true,
        configurable: true
    });
    ContactFormComponent.prototype.dataToFormGroup = function (event) {
        var party = new Party();
        switch (this.partyType) {
            case PartyType.CLIENT:
                party = this.onyxEvent.eventClient;
                break;
            case PartyType.AGENCY:
                party = this.onyxEvent.eventAgency;
                break;
            case PartyType.PROPERTY:
                party = this.onyxEvent.eventProperty;
                break;
            default:
                throw Error("Invalid partyType " + this.partyType);
        }
        if (!party) {
            party = new Party({ contact: new Contact() });
        }
        else if (!party.contact) {
            party.contact = new Contact();
        }
        var refCodeValidator = [party.eventReferenceNumber, forms_es5["Validators"].nullValidator];
        if (this.partyType === PartyType.PROPERTY) {
            refCodeValidator = [party.eventReferenceNumber, forms_es5["Validators"].nullValidator];
        }
        if (!this.contactForm) {
            this.contactForm = this.formBuilder.group({
                name: party.name,
                line1: party.line1,
                line2: party.line2,
                partyType: this.partyType,
                city: party.city,
                state: party.state,
                postalCode: party.postalCode,
                agencyId: party.code,
                code: party.code,
                propertyId: party.propertyId,
                chain: party.chain,
                brand: party.brand,
                eventReferenceNumber: refCodeValidator,
                contact: this.formBuilder.group({
                    firstName: party.contact.firstName,
                    lastName: party.contact.lastName,
                    partyType: this.partyType,
                    email: [party.contact.email, dist["CustomValidators"].email],
                    phone: [party.contact.phone, dist["CustomValidators"].phone],
                    fax: [party.contact.fax, dist["CustomValidators"].phone]
                })
            });
        }
        else {
            this.contactForm.patchValue({
                name: party.name,
                line1: party.line1,
                line2: party.line2,
                partyType: this.partyType,
                city: party.city,
                state: party.state,
                postalCode: party.postalCode,
                agencyId: party.code,
                code: party.code,
                propertyId: party.propertyId,
                chain: party.chain,
                brand: party.brand,
                eventReferenceNumber: party.eventReferenceNumber,
            });
            this.contactForm.controls['contact'].patchValue({
                firstName: party.contact.firstName,
                lastName: party.contact.lastName,
                partyType: this.partyType,
                email: party.contact.email,
                phone: party.contact.phone,
                fax: party.contact.fax
            });
        }
    };
    ContactFormComponent.prototype.ngOnInit = function () {
        var _this = this;
        switch (this.partyType) {
            case PartyType.CLIENT:
                this.translateService.get('EVENT.CONTACT_CLIENT').subscribe(function (text) { return _this.contactTypeTitle = text; });
                this.translateService.get('EVENT.CONTACT_CLIENT_REF_CODE')
                    .subscribe(function (text) { return _this.contactReferenceNumberTitle = text; });
                this.dataToFormGroup(this.onyxEvent);
                this.parentForm.setControl('eventClient', this.contactForm);
                break;
            case PartyType.AGENCY:
                this.translateService.get('EVENT.CONTACT_AGENCY').subscribe(function (text) { return _this.contactTypeTitle = text; });
                this.translateService.get('EVENT.CONTACT_AGENCY_REF_CODE')
                    .subscribe(function (text) { return _this.contactReferenceNumberTitle = text; });
                this.dataToFormGroup(this.onyxEvent);
                this.parentForm.setControl('eventAgency', this.contactForm);
                break;
            case PartyType.PROPERTY:
                this.translateService.get('EVENT.CONTACT_PROPERTY').subscribe(function (text) { return _this.contactTypeTitle = text; });
                this.translateService.get('EVENT.CONTACT_PROPERTY_REF_CODE')
                    .subscribe(function (text) { return _this.contactReferenceNumberTitle = text; });
                this.dataToFormGroup(this.onyxEvent);
                this.parentForm.setControl('eventProperty', this.contactForm);
                break;
            default:
                throw Error("Invalid partyType " + this.partyType);
        }
    };
    ContactFormComponent.prototype.ngOnChanges = function (changes) {
        if (!changes['event']) {
            return;
        }
        this.dataToFormGroup(this.onyxEvent);
    };
    return ContactFormComponent;
}());
contact_form_component___decorate([
    Object(core_es5["Input"])('partyType'),
    contact_form_component___metadata("design:type", typeof (contact_form_component__a = typeof PartyType !== "undefined" && PartyType) === "function" && contact_form_component__a || Object)
], contact_form_component_ContactFormComponent.prototype, "partyType", void 0);
contact_form_component___decorate([
    Object(core_es5["Input"])('parentForm'),
    contact_form_component___metadata("design:type", typeof (contact_form_component__b = typeof forms_es5["FormGroup"] !== "undefined" && forms_es5["FormGroup"]) === "function" && contact_form_component__b || Object)
], contact_form_component_ContactFormComponent.prototype, "parentForm", void 0);
contact_form_component___decorate([
    Object(core_es5["Input"])('event'),
    contact_form_component___metadata("design:type", typeof (contact_form_component__c = typeof OnyxEvent !== "undefined" && OnyxEvent) === "function" && contact_form_component__c || Object),
    contact_form_component___metadata("design:paramtypes", [typeof (contact_form_component__d = typeof OnyxEvent !== "undefined" && OnyxEvent) === "function" && contact_form_component__d || Object])
], contact_form_component_ContactFormComponent.prototype, "event", null);
contact_form_component___decorate([
    Object(core_es5["Input"])(),
    contact_form_component___metadata("design:type", Object)
], contact_form_component_ContactFormComponent.prototype, "isReadOnly", void 0);
contact_form_component___decorate([
    Object(core_es5["Input"])(),
    contact_form_component___metadata("design:type", Object)
], contact_form_component_ContactFormComponent.prototype, "clientContactEditable", void 0);
contact_form_component_ContactFormComponent = contact_form_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-contact-form',
        template: __webpack_require__("F5Qg")
    }),
    contact_form_component___metadata("design:paramtypes", [typeof (contact_form_component__e = typeof forms_es5["FormBuilder"] !== "undefined" && forms_es5["FormBuilder"]) === "function" && contact_form_component__e || Object, typeof (contact_form_component__f = typeof core["c" /* TranslateService */] !== "undefined" && core["c" /* TranslateService */]) === "function" && contact_form_component__f || Object])
], contact_form_component_ContactFormComponent);

var contact_form_component__a, contact_form_component__b, contact_form_component__c, contact_form_component__d, contact_form_component__e, contact_form_component__f;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/contact-form.component.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/custom-fields-form/custom-fields-form.component.ts
var custom_fields_form_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var custom_fields_form_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};






var custom_fields_form_component_CustomFieldsFormComponent = (function () {
    function CustomFieldsFormComponent(formBuilder, authenticationStore, customLabelStore) {
        this.formBuilder = formBuilder;
        this.authenticationStore = authenticationStore;
        this.customLabelStore = customLabelStore;
        this.isNewEvent = false;
    }
    Object.defineProperty(CustomFieldsFormComponent.prototype, "event", {
        set: function (event) {
            this.onyxEvent = event;
        },
        enumerable: true,
        configurable: true
    });
    CustomFieldsFormComponent.prototype.ngOnInit = function () {
        this.customLabels$ = this.customLabelStore.customLabels;
        this.customEventFieldsForm = this.formBuilder.group({
            'userRef01': this.getUserRef(this.onyxEvent, 'userRef01'),
            'userRef02': this.getUserRef(this.onyxEvent, 'userRef02'),
            'userRef03': this.getUserRef(this.onyxEvent, 'userRef03'),
            'userRef04': this.getUserRef(this.onyxEvent, 'userRef04'),
            'userRef05': this.getUserRef(this.onyxEvent, 'userRef05')
        });
        this.parentForm.setControl('customFields', this.customEventFieldsForm);
    };
    CustomFieldsFormComponent.prototype.getUserRef = function (event, fieldName) {
        return EventUtils.getEventUserRef(event, this.authenticationStore.isAgencyUser(), fieldName);
    };
    return CustomFieldsFormComponent;
}());
custom_fields_form_component___decorate([
    Object(core_es5["Input"])('event'),
    custom_fields_form_component___metadata("design:type", typeof (custom_fields_form_component__a = typeof OnyxEvent !== "undefined" && OnyxEvent) === "function" && custom_fields_form_component__a || Object),
    custom_fields_form_component___metadata("design:paramtypes", [typeof (custom_fields_form_component__b = typeof OnyxEvent !== "undefined" && OnyxEvent) === "function" && custom_fields_form_component__b || Object])
], custom_fields_form_component_CustomFieldsFormComponent.prototype, "event", null);
custom_fields_form_component___decorate([
    Object(core_es5["Input"])(),
    custom_fields_form_component___metadata("design:type", typeof (custom_fields_form_component__c = typeof forms_es5["FormGroup"] !== "undefined" && forms_es5["FormGroup"]) === "function" && custom_fields_form_component__c || Object)
], custom_fields_form_component_CustomFieldsFormComponent.prototype, "parentForm", void 0);
custom_fields_form_component___decorate([
    Object(core_es5["Input"])(),
    custom_fields_form_component___metadata("design:type", Object)
], custom_fields_form_component_CustomFieldsFormComponent.prototype, "isNewEvent", void 0);
custom_fields_form_component_CustomFieldsFormComponent = custom_fields_form_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-custom-fields-form',
        template: __webpack_require__("8+hp"),
        styles: [__webpack_require__("hslH")]
    }),
    custom_fields_form_component___metadata("design:paramtypes", [typeof (custom_fields_form_component__d = typeof forms_es5["FormBuilder"] !== "undefined" && forms_es5["FormBuilder"]) === "function" && custom_fields_form_component__d || Object, typeof (custom_fields_form_component__e = typeof authentication_store_AuthenticationStore !== "undefined" && authentication_store_AuthenticationStore) === "function" && custom_fields_form_component__e || Object, typeof (custom_fields_form_component__f = typeof custom_label_store_CustomLabelStore !== "undefined" && custom_label_store_CustomLabelStore) === "function" && custom_fields_form_component__f || Object])
], custom_fields_form_component_CustomFieldsFormComponent);

var custom_fields_form_component__a, custom_fields_form_component__b, custom_fields_form_component__c, custom_fields_form_component__d, custom_fields_form_component__e, custom_fields_form_component__f;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/custom-fields-form.component.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/service/dashboard-totals.http.service.ts
var dashboard_totals_http_service___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var dashboard_totals_http_service___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};





var dashboard_totals_http_service_DashboardTotalsHttpService = (function () {
    function DashboardTotalsHttpService(http, environment, responseUtilService) {
        this.http = http;
        this.environment = environment;
        this.responseUtilService = responseUtilService;
        this.aggregateBaseURL = '/api/events/dashboard';
        this.missingAgencyCountURL = this.environment.baseUrl + this.aggregateBaseURL + '/missing-agency';
        this.completeAndUnpaidCountURL = this.environment.baseUrl + this.aggregateBaseURL + '/complete-and-unpaid';
    }
    DashboardTotalsHttpService.prototype.getCompletedAndUnpaidCounts = function () {
        var _this = this;
        return this.http.get(this.completeAndUnpaidCountURL)
            .map(function (res) { return Object(immutable["List"])(res.json()); })
            .catch(function (response) { return _this.responseUtilService.handleError(response); }).share();
    };
    DashboardTotalsHttpService.prototype.getMissingAgencyCount = function () {
        var _this = this;
        return this.http.get(this.missingAgencyCountURL)
            .map(function (response) { return Number(response.text()); })
            .catch(function (response) { return _this.responseUtilService.handleError(response); }).share();
    };
    return DashboardTotalsHttpService;
}());
dashboard_totals_http_service_DashboardTotalsHttpService = dashboard_totals_http_service___decorate([
    Object(core_es5["Injectable"])(),
    dashboard_totals_http_service___metadata("design:paramtypes", [typeof (dashboard_totals_http_service__a = typeof AppAuthHttpService !== "undefined" && AppAuthHttpService) === "function" && dashboard_totals_http_service__a || Object, typeof (dashboard_totals_http_service__b = typeof EnvironmentConfiguration !== "undefined" && EnvironmentConfiguration) === "function" && dashboard_totals_http_service__b || Object, typeof (dashboard_totals_http_service__c = typeof response_util_service_ResponseUtilService !== "undefined" && response_util_service_ResponseUtilService) === "function" && dashboard_totals_http_service__c || Object])
], dashboard_totals_http_service_DashboardTotalsHttpService);

var dashboard_totals_http_service__a, dashboard_totals_http_service__b, dashboard_totals_http_service__c;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/dashboard-totals.http.service.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/dashboard/dashboard-card-state.ts
var DashboardCardState;
(function (DashboardCardState) {
    DashboardCardState[DashboardCardState["LOADED"] = 0] = "LOADED";
    DashboardCardState[DashboardCardState["NOT_LOADED"] = 1] = "NOT_LOADED";
    DashboardCardState[DashboardCardState["STALE"] = 2] = "STALE";
})(DashboardCardState || (DashboardCardState = {}));
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/dashboard-card-state.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/service/abstract-dashboard.store.ts



var abstract_dashboard_store_AbstractDashboardStore = (function () {
    function AbstractDashboardStore() {
        this.cardStateSubject = new BehaviorSubject["BehaviorSubject"](DashboardCardState.NOT_LOADED);
    }
    AbstractDashboardStore.prototype.beginLoad = function () {
        if (this.cardStateSubject.getValue() !== DashboardCardState.NOT_LOADED) {
            this.cardStateSubject.next(DashboardCardState.STALE);
        }
    };
    AbstractDashboardStore.prototype.endLoad = function () {
        this.cardStateSubject.next(DashboardCardState.LOADED);
    };
    Object.defineProperty(AbstractDashboardStore.prototype, "cardState", {
        get: function () {
            return this.cardStateSubject.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    AbstractDashboardStore.prototype.isStale = function () {
        return this.cardState.map(function (state) {
            return Boolean(state === DashboardCardState.STALE);
        });
    };
    AbstractDashboardStore.prototype.isLoading = function () {
        return this.cardState.map(function (state) {
            return Boolean(state === DashboardCardState.NOT_LOADED);
        });
    };
    AbstractDashboardStore.prototype.cardStateCssClass = function () {
        return Observable["Observable"].combineLatest(this.isStale(), this.isLoading()).map(function (values) {
            var stale = values[0], loading = values[1];
            var newClasses = '';
            if (stale) {
                newClasses += ' stale';
            }
            if (loading) {
                newClasses += ' loading';
            }
            return newClasses;
        });
    };
    AbstractDashboardStore.prototype.loadTotals = function () {
        var _this = this;
        this.beginLoad();
        return this.loadTotalsWithCardStateHandled()
            .map(function (totals) {
            _this.endLoad();
            return totals;
        });
    };
    return AbstractDashboardStore;
}());

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/abstract-dashboard.store.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/service/completed-unpaid-dashboard.store.ts
var completed_unpaid_dashboard_store___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var completed_unpaid_dashboard_store___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var completed_unpaid_dashboard_store___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};








var completed_unpaid_dashboard_store_CompletedUnpaidDashboardStore = (function (_super) {
    completed_unpaid_dashboard_store___extends(CompletedUnpaidDashboardStore, _super);
    function CompletedUnpaidDashboardStore(dashboardTotalsHttpService, flashMessagesService, authenticationStore, userLocalStorageService) {
        var _this = _super.call(this) || this;
        _this.dashboardTotalsHttpService = dashboardTotalsHttpService;
        _this.flashMessagesService = flashMessagesService;
        _this.authenticationStore = authenticationStore;
        _this.userLocalStorageService = userLocalStorageService;
        _this.completedAndUnpaidLessThan15DaysTotalSubject = new BehaviorSubject["BehaviorSubject"](0);
        _this.completedAndUnpaidBetween15And28DaysTotalSubject = new BehaviorSubject["BehaviorSubject"](0);
        _this.completedAndUnpaidGreaterThan28DaysTotalSubject = new BehaviorSubject["BehaviorSubject"](0);
        return _this;
    }
    CompletedUnpaidDashboardStore.prototype.showCard = function () {
        var _this = this;
        return this.authenticationStore.user.map(function (user) {
            var dashboardFilterState = _this.userLocalStorageService.getDashboardFilterState(user.email);
            return dashboardFilterState.completedAndUnpaid;
        });
    };
    Object.defineProperty(CompletedUnpaidDashboardStore.prototype, "completedAndUnpaidTotal", {
        get: function () {
            return Observable["Observable"].combineLatest(this.lessThan15DaysTotal, this.between15And28DaysTotal, this.greaterThan28DaysTotal).map(function (latestValues) {
                return latestValues.reduce(function (previousTotal, currentTotal) { return previousTotal + currentTotal; }, 0);
            });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompletedUnpaidDashboardStore.prototype, "lessThan15DaysTotal", {
        get: function () {
            return this.completedAndUnpaidLessThan15DaysTotalSubject.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompletedUnpaidDashboardStore.prototype, "between15And28DaysTotal", {
        get: function () {
            return this.completedAndUnpaidBetween15And28DaysTotalSubject.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompletedUnpaidDashboardStore.prototype, "greaterThan28DaysTotal", {
        get: function () {
            return this.completedAndUnpaidGreaterThan28DaysTotalSubject.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    CompletedUnpaidDashboardStore.prototype.loadTotalsWithCardStateHandled = function () {
        var _this = this;
        return this.dashboardTotalsHttpService.getCompletedAndUnpaidCounts().catch(function (error) {
            _this.flashMessagesService.error('MESSAGES.ERROR.GET_COMPLETED_UNPAID_TOTALS', "Error retrieving completed and unpaid totals: " + error);
            return Observable["Observable"].throw(error);
        }).map(function (result) {
            result.map(function (eachBucket) {
                _this.setTotal(eachBucket);
            });
            return result;
        });
    };
    CompletedUnpaidDashboardStore.prototype.setTotal = function (bucket) {
        if (bucket.key === 'lessThan15DaysTotal') {
            this.completedAndUnpaidLessThan15DaysTotalSubject.next(bucket.totalEvents);
        }
        else if (bucket.key === 'between15And28DaysTotal') {
            this.completedAndUnpaidBetween15And28DaysTotalSubject.next(bucket.totalEvents);
        }
        else if (bucket.key === 'greaterThan28DaysTotal') {
            this.completedAndUnpaidGreaterThan28DaysTotalSubject.next(bucket.totalEvents);
        }
    };
    return CompletedUnpaidDashboardStore;
}(abstract_dashboard_store_AbstractDashboardStore));
completed_unpaid_dashboard_store_CompletedUnpaidDashboardStore = completed_unpaid_dashboard_store___decorate([
    Object(core_es5["Injectable"])(),
    completed_unpaid_dashboard_store___metadata("design:paramtypes", [typeof (completed_unpaid_dashboard_store__a = typeof dashboard_totals_http_service_DashboardTotalsHttpService !== "undefined" && dashboard_totals_http_service_DashboardTotalsHttpService) === "function" && completed_unpaid_dashboard_store__a || Object, typeof (completed_unpaid_dashboard_store__b = typeof flash_messages_service_FlashMessagesService !== "undefined" && flash_messages_service_FlashMessagesService) === "function" && completed_unpaid_dashboard_store__b || Object, typeof (completed_unpaid_dashboard_store__c = typeof authentication_store_AuthenticationStore !== "undefined" && authentication_store_AuthenticationStore) === "function" && completed_unpaid_dashboard_store__c || Object, typeof (completed_unpaid_dashboard_store__d = typeof user_local_storage_service_UserLocalStorageService !== "undefined" && user_local_storage_service_UserLocalStorageService) === "function" && completed_unpaid_dashboard_store__d || Object])
], completed_unpaid_dashboard_store_CompletedUnpaidDashboardStore);

var completed_unpaid_dashboard_store__a, completed_unpaid_dashboard_store__b, completed_unpaid_dashboard_store__c, completed_unpaid_dashboard_store__d;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/completed-unpaid-dashboard.store.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/utils/dashboard-util.ts
var DashboardUtils = (function () {
    function DashboardUtils() {
    }
    DashboardUtils.totalAsStringClampedTo99 = function (totalObs) {
        return totalObs.map(function (total) { return total >= 99 ? '99+' : String(total); });
    };
    return DashboardUtils;
}());

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/dashboard-util.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/service/predefined-search.service.ts
var predefined_search_service___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var predefined_search_service___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};





/**
 * This class is used to store the predefined searches such as "missing agency" and "completed and unpaid"
 */
var predefined_search_service_PredefinedSearchService = (function () {
    function PredefinedSearchService(eventSearchParametersStore, eventMenuSearchFilterMapper, authStore) {
        this.eventSearchParametersStore = eventSearchParametersStore;
        this.eventMenuSearchFilterMapper = eventMenuSearchFilterMapper;
        this.authStore = authStore;
    }
    PredefinedSearchService.prototype.missingAgencySearch = function () {
        var paymentStatus;
        if (this.authStore.hasPermission('AgencyEventLevelIndicators')) {
            paymentStatus = new EventMenuSearchFilterPaymentStatus({
                unpaid: true,
                inProcess: true,
                paid: true,
                cancelled: true
            });
        }
        else {
            paymentStatus = new EventMenuSearchFilterPaymentStatus({
                unpaid: true,
                inProcess: true,
                paid: true
            });
        }
        var eventMenuSearchFilter = new EventMenuSearchFilter({
            paymentStatus: paymentStatus,
            eventStatusMissingAgency: true
        });
        this.eventSearchParametersStore.setDefaultViewSelected(true);
        this.navigate(eventMenuSearchFilter);
    };
    PredefinedSearchService.prototype.completedAndUnpaid = function () {
        var paymentStatus;
        if (this.authStore.hasPermission('AgencyEventLevelIndicators')) {
            paymentStatus = new EventMenuSearchFilterPaymentStatus({
                unpaid: true,
                inProcess: false,
                paid: false,
                cancelled: false
            });
        }
        else {
            paymentStatus = new EventMenuSearchFilterPaymentStatus({
                unpaid: true,
                inProcess: false,
                paid: false
            });
        }
        var eventMenuSearchFilter = new EventMenuSearchFilter({
            paymentStatus: paymentStatus,
            eventStatusCompleted: true
        });
        this.eventSearchParametersStore.setDefaultViewSelected(false);
        this.navigate(eventMenuSearchFilter);
    };
    PredefinedSearchService.prototype.allCompleted = function () {
        var paymentStatus;
        if (this.authStore.hasPermission('AgencyEventLevelIndicators')) {
            paymentStatus = new EventMenuSearchFilterPaymentStatus({
                unpaid: true,
                inProcess: true,
                paid: true,
                cancelled: true
            });
        }
        else {
            paymentStatus = new EventMenuSearchFilterPaymentStatus({
                unpaid: true,
                inProcess: true,
                paid: true
            });
        }
        var eventMenuSearchFilter = new EventMenuSearchFilter({
            paymentStatus: paymentStatus,
            eventStatusCompleted: true
        });
        this.eventSearchParametersStore.setDefaultViewSelected(false);
        this.navigate(eventMenuSearchFilter);
    };
    PredefinedSearchService.prototype.paymentStatusSearch = function (statusName) {
        var paymentStatus;
        paymentStatus = new EventMenuSearchFilterPaymentStatus({
            unpaid: false,
            inProcess: false,
            paid: false
        });
        var eventMenuSearchFilter = new EventMenuSearchFilter({
            paymentStatus: paymentStatus,
            eventStatusCompleted: false,
            dashboardPaymentStatus: statusName,
            includeArchivedEvents: true
        });
        this.eventSearchParametersStore.setDefaultViewSelected(false);
        this.navigate(eventMenuSearchFilter);
    };
    PredefinedSearchService.prototype.missingVendorContactEmailSearch = function () {
        var paymentStatus;
        paymentStatus = new EventMenuSearchFilterPaymentStatus({
            unpaid: false,
            inProcess: false,
            paid: false
        });
        var eventMenuSearchFilter = new EventMenuSearchFilter({
            paymentStatus: paymentStatus,
            eventStatusCompleted: false,
            dashboardMissingContactEmail: 'MissingEmailContact',
            includeArchivedEvents: true
        });
        this.eventSearchParametersStore.setDefaultViewSelected(false);
        this.navigate(eventMenuSearchFilter);
    };
    /**
     * This method should be used by all predefined searches because it handles conversion and navigation
     *
     * @param {EventMenuSearchFilter} eventMenuSearchFilter
     */
    PredefinedSearchService.prototype.navigate = function (eventMenuSearchFilter) {
        // convert EventMenuSearchFilter to an OrderedSet
        var eventSearchFilterSet = this.eventMenuSearchFilterMapper.toSearchFilterSet(eventMenuSearchFilter, this.isMultiVendor());
        // update the search parameter store and navigate
        var updateUrl = true;
        this.eventSearchParametersStore.setFilterSet(eventSearchFilterSet, updateUrl);
    };
    PredefinedSearchService.prototype.isMultiVendor = function () {
        return this.authStore.hasPermission('MultiVendor');
    };
    return PredefinedSearchService;
}());
predefined_search_service_PredefinedSearchService = predefined_search_service___decorate([
    Object(core_es5["Injectable"])(),
    predefined_search_service___metadata("design:paramtypes", [typeof (predefined_search_service__a = typeof event_search_parameters_store_EventSearchParametersStore !== "undefined" && event_search_parameters_store_EventSearchParametersStore) === "function" && predefined_search_service__a || Object, typeof (predefined_search_service__b = typeof event_menu_search_filter_mapper_EventMenuSearchFilterMapper !== "undefined" && event_menu_search_filter_mapper_EventMenuSearchFilterMapper) === "function" && predefined_search_service__b || Object, typeof (predefined_search_service__c = typeof authentication_store_AuthenticationStore !== "undefined" && authentication_store_AuthenticationStore) === "function" && predefined_search_service__c || Object])
], predefined_search_service_PredefinedSearchService);

var predefined_search_service__a, predefined_search_service__b, predefined_search_service__c;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/predefined-search.service.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/dashboard/completed-unpaid/completed-unpaid.component.ts
var completed_unpaid_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var completed_unpaid_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};





var completed_unpaid_component_CompletedUnpaidComponent = (function () {
    function CompletedUnpaidComponent(completedUnpaidStore, predefinedSearchService) {
        this.completedUnpaidStore = completedUnpaidStore;
        this.predefinedSearchService = predefinedSearchService;
        this.defaultClasses = 'card collapse';
        this.id = 'card-1';
        this.dataSeId = 'completedAndUnpaidCard';
        this.classes = this.defaultClasses;
    }
    CompletedUnpaidComponent.prototype.ngOnInit = function () {
        var _this = this;
        var cardStateObs = this.completedUnpaidStore.cardStateCssClass().map(function (newClass) {
            return _this.defaultClasses + ' ' + newClass;
        });
        var combined = Observable["Observable"].combineLatest(cardStateObs, this.completedUnpaidStore.showCard());
        combined.subscribe(function (fromCombined) {
            var classes = fromCombined[0], show = fromCombined[1];
            if (show) {
                _this.classes = classes + " show";
            }
            else {
                _this.classes = classes;
            }
        });
    };
    Object.defineProperty(CompletedUnpaidComponent.prototype, "completedAndUnpaidLessThan15DaysTotal", {
        get: function () {
            return DashboardUtils.totalAsStringClampedTo99(this.completedUnpaidStore.lessThan15DaysTotal);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompletedUnpaidComponent.prototype, "completedAndUnpaidBetween15And28DaysTotal", {
        get: function () {
            return DashboardUtils.totalAsStringClampedTo99(this.completedUnpaidStore.between15And28DaysTotal);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompletedUnpaidComponent.prototype, "completedAndUnpaidGreaterThan28DaysTotal", {
        get: function () {
            return DashboardUtils.totalAsStringClampedTo99(this.completedUnpaidStore.greaterThan28DaysTotal);
        },
        enumerable: true,
        configurable: true
    });
    CompletedUnpaidComponent.prototype.completedAndUnpaidPredefinedSearch = function () {
        this.predefinedSearchService.completedAndUnpaid();
    };
    return CompletedUnpaidComponent;
}());
completed_unpaid_component___decorate([
    Object(core_es5["HostBinding"])('id'),
    completed_unpaid_component___metadata("design:type", Object)
], completed_unpaid_component_CompletedUnpaidComponent.prototype, "id", void 0);
completed_unpaid_component___decorate([
    Object(core_es5["HostBinding"])('attr.data-se-id'),
    completed_unpaid_component___metadata("design:type", Object)
], completed_unpaid_component_CompletedUnpaidComponent.prototype, "dataSeId", void 0);
completed_unpaid_component___decorate([
    Object(core_es5["HostBinding"])('class'),
    completed_unpaid_component___metadata("design:type", Object)
], completed_unpaid_component_CompletedUnpaidComponent.prototype, "classes", void 0);
completed_unpaid_component_CompletedUnpaidComponent = completed_unpaid_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-completed-unpaid',
        template: __webpack_require__("mwq9")
    }),
    completed_unpaid_component___metadata("design:paramtypes", [typeof (completed_unpaid_component__a = typeof completed_unpaid_dashboard_store_CompletedUnpaidDashboardStore !== "undefined" && completed_unpaid_dashboard_store_CompletedUnpaidDashboardStore) === "function" && completed_unpaid_component__a || Object, typeof (completed_unpaid_component__b = typeof predefined_search_service_PredefinedSearchService !== "undefined" && predefined_search_service_PredefinedSearchService) === "function" && completed_unpaid_component__b || Object])
], completed_unpaid_component_CompletedUnpaidComponent);

var completed_unpaid_component__a, completed_unpaid_component__b;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/completed-unpaid.component.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/service/missing-agency-dashboard.store.ts
var missing_agency_dashboard_store___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var missing_agency_dashboard_store___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var missing_agency_dashboard_store___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};








var missing_agency_dashboard_store_MissingAgencyDashboardStore = (function (_super) {
    missing_agency_dashboard_store___extends(MissingAgencyDashboardStore, _super);
    function MissingAgencyDashboardStore(dashboardTotalsHttpService, flashMessagesService, authenticationStore, userLocalStorageService) {
        var _this = _super.call(this) || this;
        _this.dashboardTotalsHttpService = dashboardTotalsHttpService;
        _this.flashMessagesService = flashMessagesService;
        _this.authenticationStore = authenticationStore;
        _this.userLocalStorageService = userLocalStorageService;
        _this.missingAgencyTotalSubject = new BehaviorSubject["BehaviorSubject"](0);
        return _this;
    }
    MissingAgencyDashboardStore.prototype.showCard = function () {
        var _this = this;
        return this.authenticationStore.user.map(function (user) {
            var dashboardFilterState = _this.userLocalStorageService.getDashboardFilterState(user.email);
            return dashboardFilterState.missingAgency;
        });
    };
    Object.defineProperty(MissingAgencyDashboardStore.prototype, "missingAgencyTotal", {
        get: function () {
            return this.missingAgencyTotalSubject.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    MissingAgencyDashboardStore.prototype.loadTotalsWithCardStateHandled = function () {
        var _this = this;
        return this.dashboardTotalsHttpService.getMissingAgencyCount().catch(function (error) {
            _this.flashMessagesService.error('MESSAGES.ERROR.GET_MISSING_AGENCY_TOTALS', "Error retrieving missing agency totals: " + error);
            return Observable["Observable"].throw(error);
        }).map(function (missingAgencyTotal) {
            _this.missingAgencyTotalSubject.next(missingAgencyTotal);
            return missingAgencyTotal;
        });
    };
    return MissingAgencyDashboardStore;
}(abstract_dashboard_store_AbstractDashboardStore));
missing_agency_dashboard_store_MissingAgencyDashboardStore = missing_agency_dashboard_store___decorate([
    Object(core_es5["Injectable"])(),
    missing_agency_dashboard_store___metadata("design:paramtypes", [typeof (missing_agency_dashboard_store__a = typeof dashboard_totals_http_service_DashboardTotalsHttpService !== "undefined" && dashboard_totals_http_service_DashboardTotalsHttpService) === "function" && missing_agency_dashboard_store__a || Object, typeof (missing_agency_dashboard_store__b = typeof flash_messages_service_FlashMessagesService !== "undefined" && flash_messages_service_FlashMessagesService) === "function" && missing_agency_dashboard_store__b || Object, typeof (missing_agency_dashboard_store__c = typeof authentication_store_AuthenticationStore !== "undefined" && authentication_store_AuthenticationStore) === "function" && missing_agency_dashboard_store__c || Object, typeof (missing_agency_dashboard_store__d = typeof user_local_storage_service_UserLocalStorageService !== "undefined" && user_local_storage_service_UserLocalStorageService) === "function" && missing_agency_dashboard_store__d || Object])
], missing_agency_dashboard_store_MissingAgencyDashboardStore);

var missing_agency_dashboard_store__a, missing_agency_dashboard_store__b, missing_agency_dashboard_store__c, missing_agency_dashboard_store__d;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/missing-agency-dashboard.store.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/dashboard/dashboard-page/dashboard.component.ts
var dashboard_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var dashboard_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};










var dashboard_component_DashboardComponent = (function () {
    function DashboardComponent(menuStore, completedUnpaidDashboardStore, missingAgencyDashboardStore, userLocalStorageService, authenticationStore, multiAgencyService, eventStore) {
        this.menuStore = menuStore;
        this.completedUnpaidDashboardStore = completedUnpaidDashboardStore;
        this.missingAgencyDashboardStore = missingAgencyDashboardStore;
        this.userLocalStorageService = userLocalStorageService;
        this.authenticationStore = authenticationStore;
        this.multiAgencyService = multiAgencyService;
        this.eventStore = eventStore;
        this.defaultAgency$ = this.multiAgencyService.defaultAgency$;
        this.agencySubscription$ = new Subscription["Subscription"]();
    }
    DashboardComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.menuStore.setPageHeader('DASHBOARD.TITLE', false);
        this.eventStore.resetSelectedEvent();
        this.showCompletedAndUnpaid = true;
        this.showMissingAgency = true;
        this.agencySubscription$ = this.defaultAgency$.subscribe(function () {
            _this.completedUnpaidDashboardStore.loadTotals().subscribe();
            _this.missingAgencyDashboardStore.loadTotals().subscribe();
        });
        this.authenticationStore.user.subscribe(function (user) {
            _this.user = user;
        });
        this.completedUnpaidDashboardStore.showCard().subscribe(function (bool) {
            _this.showCompletedAndUnpaid = bool;
        });
        this.missingAgencyDashboardStore.showCard().subscribe(function (bool) {
            _this.showMissingAgency = bool;
        });
    };
    DashboardComponent.prototype.toggleShowCompletedAndUnpaid = function () {
        this.showCompletedAndUnpaid = !this.showCompletedAndUnpaid;
        this.saveDashboardStateToLocalStorage();
    };
    DashboardComponent.prototype.toggleShowMissingAgency = function () {
        this.showMissingAgency = !this.showMissingAgency;
        this.saveDashboardStateToLocalStorage();
    };
    DashboardComponent.prototype.saveDashboardStateToLocalStorage = function () {
        var dashboardFilters = new DashboardFilterState({
            completedAndUnpaid: this.showCompletedAndUnpaid,
            missingAgency: this.showMissingAgency
        });
        var email = this.user.email;
        this.userLocalStorageService.setDashboardFilterState(email, dashboardFilters);
    };
    DashboardComponent.prototype.ngOnDestroy = function () {
        this.agencySubscription$.unsubscribe();
    };
    return DashboardComponent;
}());
dashboard_component_DashboardComponent = dashboard_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-dashboard',
        template: __webpack_require__("Cww6")
    }),
    dashboard_component___metadata("design:paramtypes", [typeof (dashboard_component__a = typeof menu_store_MenuStore !== "undefined" && menu_store_MenuStore) === "function" && dashboard_component__a || Object, typeof (dashboard_component__b = typeof completed_unpaid_dashboard_store_CompletedUnpaidDashboardStore !== "undefined" && completed_unpaid_dashboard_store_CompletedUnpaidDashboardStore) === "function" && dashboard_component__b || Object, typeof (dashboard_component__c = typeof missing_agency_dashboard_store_MissingAgencyDashboardStore !== "undefined" && missing_agency_dashboard_store_MissingAgencyDashboardStore) === "function" && dashboard_component__c || Object, typeof (dashboard_component__d = typeof user_local_storage_service_UserLocalStorageService !== "undefined" && user_local_storage_service_UserLocalStorageService) === "function" && dashboard_component__d || Object, typeof (dashboard_component__e = typeof authentication_store_AuthenticationStore !== "undefined" && authentication_store_AuthenticationStore) === "function" && dashboard_component__e || Object, typeof (dashboard_component__f = typeof multi_agency_service_MultiAgencyService !== "undefined" && multi_agency_service_MultiAgencyService) === "function" && dashboard_component__f || Object, typeof (dashboard_component__g = typeof event_store_EventStore !== "undefined" && event_store_EventStore) === "function" && dashboard_component__g || Object])
], dashboard_component_DashboardComponent);

var dashboard_component__a, dashboard_component__b, dashboard_component__c, dashboard_component__d, dashboard_component__e, dashboard_component__f, dashboard_component__g;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/dashboard.component.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/dashboard/missing-agency/missing-agency.component.ts
var missing_agency_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var missing_agency_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};





var missing_agency_component_MissingAgencyComponent = (function () {
    function MissingAgencyComponent(missingAgencyStore, predefinedSearchService) {
        this.missingAgencyStore = missingAgencyStore;
        this.predefinedSearchService = predefinedSearchService;
        this.defaultClasses = 'card collapse';
        this.id = 'card-2';
        this.dataSeId = 'missingAgencyCard';
        this.classes = this.defaultClasses;
    }
    MissingAgencyComponent.prototype.ngOnInit = function () {
        var _this = this;
        var obs1 = this.missingAgencyStore.cardStateCssClass().map(function (newClass) {
            return _this.defaultClasses + ' ' + newClass;
        });
        var combined = Observable["Observable"].combineLatest(obs1, this.missingAgencyStore.showCard());
        combined.subscribe(function (fromCombined) {
            var classes = fromCombined[0], show = fromCombined[1];
            if (show) {
                _this.classes = classes + " show";
            }
            else {
                _this.classes = classes;
            }
        });
    };
    Object.defineProperty(MissingAgencyComponent.prototype, "missingAgencyTotal", {
        get: function () {
            return DashboardUtils.totalAsStringClampedTo99(this.missingAgencyStore.missingAgencyTotal);
        },
        enumerable: true,
        configurable: true
    });
    MissingAgencyComponent.prototype.missingAgencyPredefinedSearch = function () {
        this.predefinedSearchService.missingAgencySearch();
    };
    return MissingAgencyComponent;
}());
missing_agency_component___decorate([
    Object(core_es5["HostBinding"])('id'),
    missing_agency_component___metadata("design:type", Object)
], missing_agency_component_MissingAgencyComponent.prototype, "id", void 0);
missing_agency_component___decorate([
    Object(core_es5["HostBinding"])('attr.data-se-id'),
    missing_agency_component___metadata("design:type", Object)
], missing_agency_component_MissingAgencyComponent.prototype, "dataSeId", void 0);
missing_agency_component___decorate([
    Object(core_es5["HostBinding"])('class'),
    missing_agency_component___metadata("design:type", Object)
], missing_agency_component_MissingAgencyComponent.prototype, "classes", void 0);
missing_agency_component_MissingAgencyComponent = missing_agency_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-missing-agency',
        template: __webpack_require__("P7oG")
    }),
    missing_agency_component___metadata("design:paramtypes", [typeof (missing_agency_component__a = typeof missing_agency_dashboard_store_MissingAgencyDashboardStore !== "undefined" && missing_agency_dashboard_store_MissingAgencyDashboardStore) === "function" && missing_agency_component__a || Object, typeof (missing_agency_component__b = typeof predefined_search_service_PredefinedSearchService !== "undefined" && predefined_search_service_PredefinedSearchService) === "function" && missing_agency_component__b || Object])
], missing_agency_component_MissingAgencyComponent);

var missing_agency_component__a, missing_agency_component__b;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/missing-agency.component.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/dashboard/event-search-sort-type-enum.ts
/**
 * Even search filter types
 */
/**
 * Even search filter types
 */ var EventSearchSortType;
(function (EventSearchSortType) {
    EventSearchSortType[EventSearchSortType["MODIFIED"] = 'MODIFIED'] = "MODIFIED";
    EventSearchSortType[EventSearchSortType["CREATED"] = 'CREATED'] = "CREATED";
    EventSearchSortType[EventSearchSortType["COMPLETED"] = 'COMPLETED'] = "COMPLETED";
})(EventSearchSortType || (EventSearchSortType = {}));
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/event-search-sort-type-enum.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/event-sort.ts
var event_sort___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var EventSortRecord = Object(immutable["Record"])({
    sortField: null,
    sortDirection: null
});
var EventSort = (function (_super) {
    event_sort___extends(EventSort, _super);
    function EventSort() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return EventSort;
}(EventSortRecord));

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/event-sort.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/dashboard/recent-events-card/event-list-card.component.ts
var event_list_card_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var event_list_card_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};











var event_list_card_component_EventListCardComponent = EventListCardComponent_1 = (function () {
    function EventListCardComponent(eventListStore, router, predefinedSearchService, multiAgencyService, authenticationStore) {
        this.eventListStore = eventListStore;
        this.router = router;
        this.predefinedSearchService = predefinedSearchService;
        this.multiAgencyService = multiAgencyService;
        this.authenticationStore = authenticationStore;
        this.defaultClasses = 'card collapse show';
        this.dataSeId = 'recentEventsCard_';
        this.classes = this.defaultClasses;
        this.id = '';
        this.agencySubscription$ = new Subscription["Subscription"]();
        this.defaultAgency$ = this.multiAgencyService.defaultAgency$;
    }
    EventListCardComponent.prototype.ngOnInit = function () {
        var _this = this;
        var sorts = new Array();
        var filters = new Array();
        var sort;
        var filter;
        this.dataSeId += this.eventSearchSortType;
        switch (this.eventSearchSortType) {
            case EventSearchSortType.MODIFIED:
                this.id = 'card-6';
                sort = new EventSort({
                    sortField: 'modifiedDate',
                    sortDirection: 'DESC'
                });
                sorts.push(sort);
                break;
            case EventSearchSortType.CREATED:
                this.id = 'card-7';
                sort = new EventSort({
                    sortField: 'createdDate',
                    sortDirection: 'DESC'
                });
                sorts.push(sort);
                break;
            case EventSearchSortType.COMPLETED:
                this.id = 'card-8';
                filter = new EventSearchFilter({
                    filterField: 'eventStatusCompleted',
                    filterValue: 'true'
                });
                sort = new EventSort({
                    sortField: 'modifiedDate',
                    sortDirection: 'DESC'
                });
                sorts.push(sort);
                filters.push(filter);
                break;
        }
        this.eventSearchRecentlyParameters = new EventSearchParameters({
            maxEvents: EventListCardComponent_1.MAX_EVENTS,
            filters: filters,
            sorts: sorts
        });
        this.agencySubscription$ = this.defaultAgency$.subscribe(function () {
            _this.data = _this.eventListStore.loadRecentlyEvents(_this.eventSearchRecentlyParameters);
        });
        this.isMultiPropertyUser = this.authenticationStore.isMultiPropertyUser();
    };
    Object.defineProperty(EventListCardComponent.prototype, "events", {
        get: function () {
            return this.data;
        },
        enumerable: true,
        configurable: true
    });
    // TODO hide the MODIFIED and CREATED footer links for now
    EventListCardComponent.prototype.isFooterLinkActive = function (eventType) {
        return eventType === EventSearchSortType.COMPLETED;
    };
    EventListCardComponent.prototype.onSelectFooter = function (eventType) {
        switch (this.eventSearchSortType) {
            case EventSearchSortType.MODIFIED:
                // TODO
                break;
            case EventSearchSortType.CREATED:
                // TODO
                break;
            case EventSearchSortType.COMPLETED:
                this.predefinedSearchService.allCompleted();
                break;
        }
    };
    EventListCardComponent.prototype.ngOnDestroy = function () {
        this.agencySubscription$.unsubscribe();
    };
    return EventListCardComponent;
}());
event_list_card_component_EventListCardComponent.MAX_EVENTS = 5;
event_list_card_component___decorate([
    Object(core_es5["HostBinding"])('attr.data-se-id'),
    event_list_card_component___metadata("design:type", Object)
], event_list_card_component_EventListCardComponent.prototype, "dataSeId", void 0);
event_list_card_component___decorate([
    Object(core_es5["HostBinding"])('class'),
    event_list_card_component___metadata("design:type", Object)
], event_list_card_component_EventListCardComponent.prototype, "classes", void 0);
event_list_card_component___decorate([
    Object(core_es5["HostBinding"])('id'),
    event_list_card_component___metadata("design:type", Object)
], event_list_card_component_EventListCardComponent.prototype, "id", void 0);
event_list_card_component___decorate([
    Object(core_es5["Input"])('eventSearchSortType'),
    event_list_card_component___metadata("design:type", typeof (event_list_card_component__a = typeof EventSearchSortType !== "undefined" && EventSearchSortType) === "function" && event_list_card_component__a || Object)
], event_list_card_component_EventListCardComponent.prototype, "eventSearchSortType", void 0);
event_list_card_component_EventListCardComponent = EventListCardComponent_1 = event_list_card_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-recent-events-card',
        template: __webpack_require__("0nqh")
    }),
    event_list_card_component___metadata("design:paramtypes", [typeof (event_list_card_component__b = typeof event_list_store_EventListStore !== "undefined" && event_list_store_EventListStore) === "function" && event_list_card_component__b || Object, typeof (event_list_card_component__c = typeof router_es5["Router"] !== "undefined" && router_es5["Router"]) === "function" && event_list_card_component__c || Object, typeof (event_list_card_component__d = typeof predefined_search_service_PredefinedSearchService !== "undefined" && predefined_search_service_PredefinedSearchService) === "function" && event_list_card_component__d || Object, typeof (event_list_card_component__e = typeof multi_agency_service_MultiAgencyService !== "undefined" && multi_agency_service_MultiAgencyService) === "function" && event_list_card_component__e || Object, typeof (event_list_card_component__f = typeof authentication_store_AuthenticationStore !== "undefined" && authentication_store_AuthenticationStore) === "function" && event_list_card_component__f || Object])
], event_list_card_component_EventListCardComponent);

var EventListCardComponent_1, event_list_card_component__a, event_list_card_component__b, event_list_card_component__c, event_list_card_component__d, event_list_card_component__e, event_list_card_component__f;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/event-list-card.component.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/edit-event-button-bar/edit-event-button-bar.component.ts
var edit_event_button_bar_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var edit_event_button_bar_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};



var edit_event_button_bar_component_EditEventButtonBarComponent = (function () {
    function EditEventButtonBarComponent(authenticationStore) {
        this.authenticationStore = authenticationStore;
        this.cancel = new core_es5["EventEmitter"]();
        this.save = new core_es5["EventEmitter"]();
        this.delete = new core_es5["EventEmitter"]();
        this.edit = new core_es5["EventEmitter"]();
        this.unmatch = new core_es5["EventEmitter"]();
    }
    EditEventButtonBarComponent.prototype.cancelClick = function () {
        this.cancel.emit();
    };
    EditEventButtonBarComponent.prototype.saveClick = function () {
        this.save.emit();
    };
    EditEventButtonBarComponent.prototype.deleteClick = function () {
        this.delete.emit();
    };
    EditEventButtonBarComponent.prototype.editClick = function () {
        this.edit.emit();
    };
    EditEventButtonBarComponent.prototype.unmatchClick = function () {
        this.unmatch.emit();
    };
    EditEventButtonBarComponent.prototype.isSupportUser = function () {
        return this.authenticationStore.isSupportUser();
    };
    return EditEventButtonBarComponent;
}());
edit_event_button_bar_component___decorate([
    Object(core_es5["Input"])(),
    edit_event_button_bar_component___metadata("design:type", typeof (edit_event_button_bar_component__a = typeof forms_es5["FormGroup"] !== "undefined" && forms_es5["FormGroup"]) === "function" && edit_event_button_bar_component__a || Object)
], edit_event_button_bar_component_EditEventButtonBarComponent.prototype, "eventForm", void 0);
edit_event_button_bar_component___decorate([
    Object(core_es5["Input"])(),
    edit_event_button_bar_component___metadata("design:type", Boolean)
], edit_event_button_bar_component_EditEventButtonBarComponent.prototype, "isEventLockdown", void 0);
edit_event_button_bar_component___decorate([
    Object(core_es5["Input"])(),
    edit_event_button_bar_component___metadata("design:type", Boolean)
], edit_event_button_bar_component_EditEventButtonBarComponent.prototype, "isReadOnly", void 0);
edit_event_button_bar_component___decorate([
    Object(core_es5["Input"])(),
    edit_event_button_bar_component___metadata("design:type", Boolean)
], edit_event_button_bar_component_EditEventButtonBarComponent.prototype, "canBeDeleted", void 0);
edit_event_button_bar_component___decorate([
    Object(core_es5["Input"])(),
    edit_event_button_bar_component___metadata("design:type", Boolean)
], edit_event_button_bar_component_EditEventButtonBarComponent.prototype, "isMultiVendor", void 0);
edit_event_button_bar_component___decorate([
    Object(core_es5["Input"])(),
    edit_event_button_bar_component___metadata("design:type", Boolean)
], edit_event_button_bar_component_EditEventButtonBarComponent.prototype, "canBeUnmatched", void 0);
edit_event_button_bar_component___decorate([
    Object(core_es5["Input"])(),
    edit_event_button_bar_component___metadata("design:type", Boolean)
], edit_event_button_bar_component_EditEventButtonBarComponent.prototype, "isNotEditable", void 0);
edit_event_button_bar_component___decorate([
    Object(core_es5["Output"])(),
    edit_event_button_bar_component___metadata("design:type", Object)
], edit_event_button_bar_component_EditEventButtonBarComponent.prototype, "cancel", void 0);
edit_event_button_bar_component___decorate([
    Object(core_es5["Output"])(),
    edit_event_button_bar_component___metadata("design:type", Object)
], edit_event_button_bar_component_EditEventButtonBarComponent.prototype, "save", void 0);
edit_event_button_bar_component___decorate([
    Object(core_es5["Output"])(),
    edit_event_button_bar_component___metadata("design:type", Object)
], edit_event_button_bar_component_EditEventButtonBarComponent.prototype, "delete", void 0);
edit_event_button_bar_component___decorate([
    Object(core_es5["Output"])(),
    edit_event_button_bar_component___metadata("design:type", Object)
], edit_event_button_bar_component_EditEventButtonBarComponent.prototype, "edit", void 0);
edit_event_button_bar_component___decorate([
    Object(core_es5["Output"])(),
    edit_event_button_bar_component___metadata("design:type", Object)
], edit_event_button_bar_component_EditEventButtonBarComponent.prototype, "unmatch", void 0);
edit_event_button_bar_component_EditEventButtonBarComponent = edit_event_button_bar_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-event-button-bar',
        template: __webpack_require__("Twnd")
    }),
    edit_event_button_bar_component___metadata("design:paramtypes", [typeof (edit_event_button_bar_component__b = typeof authentication_store_AuthenticationStore !== "undefined" && authentication_store_AuthenticationStore) === "function" && edit_event_button_bar_component__b || Object])
], edit_event_button_bar_component_EditEventButtonBarComponent);

var edit_event_button_bar_component__a, edit_event_button_bar_component__b;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/edit-event-button-bar.component.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/event-list/event-list-default-table/event-list-default-table.component.ts
var event_list_default_table_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var event_list_default_table_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};




var event_list_default_table_component_EventListDefaultTableComponent = (function () {
    function EventListDefaultTableComponent(environment) {
        this.environment = environment;
    }
    EventListDefaultTableComponent.prototype.ngOnInit = function () {
    };
    Object.defineProperty(EventListDefaultTableComponent.prototype, "eventCount", {
        get: function () {
            return this.events.totalElements;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EventListDefaultTableComponent.prototype, "eventCountForTranslate", {
        get: function () {
            return {
                eventCount: this.eventCount
            };
        },
        enumerable: true,
        configurable: true
    });
    EventListDefaultTableComponent.prototype.getEventNameLine1 = function (name) {
        if (name.length > Constants.EVENTS_NAME_MAX_SIZE) {
            return name.substring(0, Constants.EVENTS_NAME_MAX_SIZE);
        }
        else {
            return name;
        }
    };
    EventListDefaultTableComponent.prototype.getEventNameLine2 = function (name) {
        if (name.length > Constants.EVENTS_NAME_MAX_SIZE) {
            var line2 = name.substring(Constants.EVENTS_NAME_MAX_SIZE);
            if (line2.length > Constants.EVENTS_NAME_MAX_SIZE) {
                return line2.substring(0, Constants.EVENTS_NAME_MAX_SIZE);
            }
            else {
                return line2;
            }
        }
        else {
            return null;
        }
    };
    return EventListDefaultTableComponent;
}());
event_list_default_table_component___decorate([
    Object(core_es5["Input"])(),
    event_list_default_table_component___metadata("design:type", typeof (event_list_default_table_component__a = typeof page_Page !== "undefined" && page_Page) === "function" && event_list_default_table_component__a || Object)
], event_list_default_table_component_EventListDefaultTableComponent.prototype, "events", void 0);
event_list_default_table_component_EventListDefaultTableComponent = event_list_default_table_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-event-list-default-table',
        template: __webpack_require__("lOyP")
    }),
    event_list_default_table_component___metadata("design:paramtypes", [typeof (event_list_default_table_component__b = typeof EnvironmentConfiguration !== "undefined" && EnvironmentConfiguration) === "function" && event_list_default_table_component__b || Object])
], event_list_default_table_component_EventListDefaultTableComponent);

var event_list_default_table_component__a, event_list_default_table_component__b;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/event-list-default-table.component.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/config/config-lookup-type.ts
var ConfigLookupType;
(function (ConfigLookupType) {
    ConfigLookupType[ConfigLookupType["AUTO_PAY"] = 'AUTO_PAY'] = "AUTO_PAY";
    ConfigLookupType[ConfigLookupType["DEFAULT_END_DATE_PLUS_DAYS"] = 'DEFAULT_END_DATE_PLUS_DAYS'] = "DEFAULT_END_DATE_PLUS_DAYS";
    ConfigLookupType[ConfigLookupType["TRANSIENT_RESERVATIONS_MAX_RESULT"] = 'TRANSIENT_RESERVATIONS_MAX_RESULT'] = "TRANSIENT_RESERVATIONS_MAX_RESULT";
    ConfigLookupType[ConfigLookupType["PREPAYMENT_MIN_AMOUNT"] = 'PREPAYMENT_MIN_AMOUNT'] = "PREPAYMENT_MIN_AMOUNT";
    ConfigLookupType[ConfigLookupType["ALL"] = 'ALL'] = "ALL";
})(ConfigLookupType || (ConfigLookupType = {}));
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/config-lookup-type.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/config/config-response.ts
var config_response___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var ConfigResponseRecord = Object(immutable["Record"])({
    config: null,
    value: null,
    level: null,
    propertyId: null
});
var ConfigResponse = (function (_super) {
    config_response___extends(ConfigResponse, _super);
    function ConfigResponse() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ConfigResponse;
}(ConfigResponseRecord));

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/config-response.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/config/property-config-lookup.ts
var property_config_lookup___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var PropertyConfigLookupRecord = Object(immutable["Record"])({
    chain: null,
    brand: null,
    propertyId: null
});
var PropertyConfigLookup = (function (_super) {
    property_config_lookup___extends(PropertyConfigLookup, _super);
    function PropertyConfigLookup() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return PropertyConfigLookup;
}(PropertyConfigLookupRecord));

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/property-config-lookup.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/config/config-level-type.ts
var ConfigLevelType;
(function (ConfigLevelType) {
    ConfigLevelType[ConfigLevelType["AGENCY"] = 'AGENCY'] = "AGENCY";
    ConfigLevelType[ConfigLevelType["BRAND"] = 'BRAND'] = "BRAND";
    ConfigLevelType[ConfigLevelType["CHAIN"] = 'CHAIN'] = "CHAIN";
    ConfigLevelType[ConfigLevelType["PROPERTY"] = 'PROPERTY'] = "PROPERTY";
    ConfigLevelType[ConfigLevelType["SYSTEM"] = 'SYSTEM'] = "SYSTEM";
    ConfigLevelType[ConfigLevelType["UNKNOWN"] = 'UNKNOWN'] = "UNKNOWN";
})(ConfigLevelType || (ConfigLevelType = {}));
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/config-level-type.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/service/grouppay-config.http.service.ts
var grouppay_config_http_service___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var grouppay_config_http_service___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};















var grouppay_config_http_service_GroupPayConfigHttpService = (function () {
    function GroupPayConfigHttpService(http, environment, responseUtilService, consoleLogSubscriber) {
        this.http = http;
        this.environment = environment;
        this.responseUtilService = responseUtilService;
        this.consoleLogSubscriber = consoleLogSubscriber;
        this.configLookupUrl = this.environment.baseUrl + '/api/lookup/config';
        this.configLookupOoivUrl = this.environment.baseUrl + '/api/lookup/config/ooiv';
    }
    GroupPayConfigHttpService.prototype.getGroupPayConfig = function (request) {
        var _this = this;
        var headers = new http_es5["Headers"]({ 'Content-Type': 'application/json' });
        var options = new http_es5["RequestOptions"]({ headers: headers });
        return this.http.post(this.configLookupUrl, JSON.stringify(request.toJS()), options)
            .map(function (response) {
            var json = null;
            try {
                json = response.json();
            }
            catch (error) {
                _this.consoleLogSubscriber.log(new LogMessage(LogLevel.DEBUG, error));
            }
            return new ConfigResponse(json);
        })
            .catch(function (response) { return _this.responseUtilService.handleError(response); })
            .share();
    };
    GroupPayConfigHttpService.prototype.getGroupPayConfigBulk = function (requests) {
        var _this = this;
        var headers = new http_es5["Headers"]({ 'Content-Type': 'application/json' });
        var options = new http_es5["RequestOptions"]({ headers: headers });
        return this.http.post(this.configLookupUrl + '/bulk', JSON.stringify(requests), options)
            .map(function (response) {
            var json = null;
            try {
                json = response.json();
            }
            catch (error) {
                _this.consoleLogSubscriber.log(new LogMessage(LogLevel.DEBUG, error));
            }
            return json;
        })
            .catch(function (response) { return _this.responseUtilService.handleError(response); })
            .share();
    };
    GroupPayConfigHttpService.prototype.getGroupPayOoivConfig = function (request) {
        var _this = this;
        var headers = new http_es5["Headers"]({ 'Content-Type': 'application/json' });
        var options = new http_es5["RequestOptions"]({ headers: headers });
        return this.http.post(this.configLookupOoivUrl, JSON.stringify(request.toJS()), options)
            .map(function (response) {
            var json = null;
            try {
                json = response.json();
            }
            catch (error) {
                _this.consoleLogSubscriber.log(new LogMessage(LogLevel.DEBUG, error));
            }
            return new ConfigResponse(json);
        })
            .catch(function (response) { return _this.responseUtilService.handleError(response); })
            .share();
    };
    GroupPayConfigHttpService.prototype.getGroupPayConfigByValues = function (key, chain, brand, propertyId, agencyId) {
        return this.getGroupPayConfig(this.buildConfigRequest(key, chain, brand, propertyId, agencyId));
    };
    GroupPayConfigHttpService.prototype.getGroupPayConfigByValuesBulk = function (requests) {
        var _this = this;
        var configRequests = [];
        requests.forEach(function (request) {
            configRequests.push(_this.buildConfigRequest(request.key, request.chain, request.brand, request.propertyId, request.agencyId));
        });
        return this.getGroupPayConfigBulk(configRequests);
    };
    GroupPayConfigHttpService.prototype.getGroupPayOoivConfigByValues = function (key, agencyId, agencyCountry, vendorCountry) {
        return this.getGroupPayOoivConfig(this.buildConfigOoivRequest(key, agencyId, agencyCountry, vendorCountry));
    };
    GroupPayConfigHttpService.prototype.getAllGroupPayConfig = function (request) {
        var _this = this;
        var headers = new http_es5["Headers"]({ 'Content-Type': 'application/json' });
        var options = new http_es5["RequestOptions"]({ headers: headers });
        return this.http.post(this.configLookupUrl + '/all', JSON.stringify(request.toJS()), options)
            .map(function (response) {
            var result = [];
            var json = response.json();
            for (var property in json) {
                if (json.hasOwnProperty(property)) {
                    var key = ConfigLookupType[property];
                    var value = new ConfigResponse({
                        config: ConfigLookupType[json[property].config],
                        value: json[property].value,
                        level: ConfigLevelType[json[property].level]
                    });
                    result.push([key, value]);
                }
            }
            return Object(immutable["Map"])(result);
        })
            .catch(function (response) { return _this.responseUtilService.handleError(response); })
            .share();
    };
    GroupPayConfigHttpService.prototype.getAllGroupPayConfigByValues = function (chain, brand, propertyId, agencyId) {
        return this.getAllGroupPayConfig(this.buildConfigRequest(ConfigLookupType.ALL, chain, brand, propertyId, agencyId));
    };
    GroupPayConfigHttpService.prototype.buildConfigRequest = function (key, chain, brand, propertyId, agencyId) {
        var propertyConfigLookup = null;
        var agencyConfigLookup = null;
        var countryConfigLookup = null;
        if (chain != null || brand != null || propertyId != null) {
            propertyConfigLookup = new PropertyConfigLookup({
                chain: chain,
                brand: brand,
                propertyId: propertyId
            });
        }
        if (agencyId != null) {
            agencyConfigLookup = new AgencyConfigLookup({ agencyId: agencyId });
        }
        return new ConfigRequest({
            config: key,
            property: propertyConfigLookup,
            agency: agencyConfigLookup,
            country: countryConfigLookup
        });
    };
    GroupPayConfigHttpService.prototype.buildConfigOoivRequest = function (key, agencyId, agencyCountry, vendorCountry) {
        var propertyConfigLookup = null;
        var agencyConfigLookup = null;
        var countryConfigLookup = null;
        if (agencyId != null) {
            agencyConfigLookup = new AgencyConfigLookup({ agencyId: agencyId });
        }
        if (agencyCountry != null || vendorCountry != null) {
            countryConfigLookup = new CountryConfigLookup({ agencyCountry: agencyCountry, vendorCountry: vendorCountry });
        }
        return new ConfigRequest({
            config: key,
            property: propertyConfigLookup,
            agency: agencyConfigLookup,
            country: countryConfigLookup
        });
    };
    return GroupPayConfigHttpService;
}());
grouppay_config_http_service_GroupPayConfigHttpService = grouppay_config_http_service___decorate([
    Object(core_es5["Injectable"])(),
    grouppay_config_http_service___metadata("design:paramtypes", [typeof (grouppay_config_http_service__a = typeof AppAuthHttpService !== "undefined" && AppAuthHttpService) === "function" && grouppay_config_http_service__a || Object, typeof (grouppay_config_http_service__b = typeof EnvironmentConfiguration !== "undefined" && EnvironmentConfiguration) === "function" && grouppay_config_http_service__b || Object, typeof (grouppay_config_http_service__c = typeof response_util_service_ResponseUtilService !== "undefined" && response_util_service_ResponseUtilService) === "function" && grouppay_config_http_service__c || Object, typeof (grouppay_config_http_service__d = typeof console_log_subscriber_service_ConsoleLogSubscriberService !== "undefined" && console_log_subscriber_service_ConsoleLogSubscriberService) === "function" && grouppay_config_http_service__d || Object])
], grouppay_config_http_service_GroupPayConfigHttpService);

var grouppay_config_http_service__a, grouppay_config_http_service__b, grouppay_config_http_service__c, grouppay_config_http_service__d;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/grouppay-config.http.service.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/service/grouppay-config.store.ts
var grouppay_config_store___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var grouppay_config_store___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};











var CACHE_EXP_TIME = 60 * 60 * 1000; // 1 hour in milliseconds
var grouppay_config_store_GroupPayConfigStore = (function () {
    function GroupPayConfigStore(groupPayConfigHttpService, logService, flashMessagesService, translateService) {
        this.groupPayConfigHttpService = groupPayConfigHttpService;
        this.logService = logService;
        this.flashMessagesService = flashMessagesService;
        this.translateService = translateService;
        this.defaultEndDateDelayDaysSubject = new ReplaySubject["ReplaySubject"](1);
        this.allSubject = new BehaviorSubject["BehaviorSubject"](Object(immutable["Map"])([]));
        this.ooivCache = new Map();
    }
    Object.defineProperty(GroupPayConfigStore.prototype, "defaultEndDateDelayDays", {
        get: function () {
            return this.defaultEndDateDelayDaysSubject.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GroupPayConfigStore.prototype, "defaultEndDateDelayDaysValue", {
        get: function () {
            return this.defaultEndDateDelayDays.map(function (configResponse) { return Number(configResponse.value); });
        },
        enumerable: true,
        configurable: true
    });
    GroupPayConfigStore.prototype.setDefaultEndDateDelayDays = function (configResponse) {
        this.defaultEndDateDelayDaysSubject.next(configResponse);
    };
    Object.defineProperty(GroupPayConfigStore.prototype, "allConfigurations", {
        get: function () {
            return this.allSubject.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    GroupPayConfigStore.prototype.loadConfig = function (key, chain, brand, propertyId, agencyId) {
        var _this = this;
        var response = this.groupPayConfigHttpService.getGroupPayConfigByValues(key, chain, brand, propertyId, agencyId)
            .catch(function (error) {
            _this.flashMessagesService.error(_this.translateService.instant('MESSAGES.ERROR.GROUPPAY_CONFIG_SINGLE', {
                configValue: key.toString()
            }));
            _this.logService.error("Error retrieving configuration value (" + key.toString() + "): " + error);
            return Observable["Observable"].throw(error);
        })
            .map(function (configResponse) {
            _this.updateOneConfig(key, configResponse);
            return configResponse;
        });
        return response;
    };
    GroupPayConfigStore.prototype.loadConfigBulk = function (requests, key) {
        var _this = this;
        var response = this.groupPayConfigHttpService.getGroupPayConfigByValuesBulk(requests)
            .catch(function (error) {
            _this.flashMessagesService.error(_this.translateService.instant('MESSAGES.ERROR.GROUPPAY_CONFIG_SINGLE', {
                configValue: key.toString()
            }));
            _this.logService.error("Error retrieving configuration value (" + key.toString() + "): " + error);
            return Observable["Observable"].throw(error);
        })
            .map(function (configResponses) {
            configResponses.forEach(function (configResponse) {
                _this.updateOneConfig(key, configResponse);
            });
            return configResponses;
        });
        return response;
    };
    GroupPayConfigStore.prototype.loadAllConfig = function (chain, brand, propertyId, agencyId) {
        var _this = this;
        var response = this.groupPayConfigHttpService.getAllGroupPayConfigByValues(chain, brand, propertyId, agencyId)
            .catch(function (error) {
            _this.flashMessagesService.error(_this.translateService.instant('MESSAGES.ERROR.GROUPPAY_CONFIG_ALL'));
            _this.logService.error("Error retrieveing all configuration values: " + error);
            return Observable["Observable"].throw(error);
        })
            .map(function (responseMap) {
            _this.updateAllConfig(responseMap);
            return responseMap;
        });
        return response;
    };
    GroupPayConfigStore.prototype.updateOneConfig = function (key, configResponse) {
        var mapConfig = this.allSubject.getValue();
        this.allSubject.next(mapConfig.set(key, configResponse));
        if (key === ConfigLookupType.DEFAULT_END_DATE_PLUS_DAYS) {
            this.setDefaultEndDateDelayDays(configResponse);
        }
    };
    GroupPayConfigStore.prototype.updateAllConfig = function (configMap) {
        this.allSubject.next(configMap);
        if (configMap.has(ConfigLookupType.DEFAULT_END_DATE_PLUS_DAYS)) {
            this.setDefaultEndDateDelayDays(configMap.get(ConfigLookupType.DEFAULT_END_DATE_PLUS_DAYS));
        }
        if (configMap.has(ConfigLookupType.AUTO_PAY)) {
            // TODO add this later
        }
    };
    GroupPayConfigStore.prototype.isOoivEnabled = function (agencyId, agencyCountry, vendorCountry) {
        var _this = this;
        this.logService.debug("isOoivEnabled - agencyId: " + agencyId + ", agencyCountry: " + agencyCountry + ", vendorCountry: " + vendorCountry);
        var key = this.getOoivKey(agencyId, agencyCountry, vendorCountry);
        var cachedEntry = this.ooivCache.get(key);
        var entryExists = !!cachedEntry;
        var entryExpired = !!cachedEntry && !!cachedEntry.value && cachedEntry.value.expiry < Date.now();
        if (!entryExists) {
            cachedEntry = new BehaviorSubject["BehaviorSubject"](null);
            this.ooivCache.set(key, cachedEntry);
        }
        if (!entryExists || entryExpired) {
            this.loadOoivConfig(null, agencyId, agencyCountry, vendorCountry).pipe(Object(operators["take"])(1), Object(operators["tap"])(function (response) {
                var newEntry = { value: response ? JSON.parse(response.value) : null, expiry: Date.now() + CACHE_EXP_TIME };
                cachedEntry.next(newEntry);
            }), Object(operators["catchError"])(function (error) {
                _this.flashMessagesService.error('MESSAGES.ERROR.OOIV_CONFIG_VERIFICATION', "Error checking OOIV Config: " + error);
                return Observable["Observable"].throw(error);
            })).subscribe();
        }
        return cachedEntry.asObservable().pipe(Object(operators["filter"])(function (entry) { return !!entry; }), Object(operators["map"])(function (entry) { return entry.value; }));
    };
    GroupPayConfigStore.prototype.getOoivKey = function (agencyId, agencyCountry, vendorCountry) {
        var key = '';
        key += !!agencyId ? agencyId : '';
        key += !!agencyCountry ? agencyCountry : '';
        key += !!vendorCountry ? vendorCountry : '';
        if (key && key.length > 0) {
            return key;
        }
        else {
            return 'null';
        }
    };
    GroupPayConfigStore.prototype.loadOoivConfig = function (key, agencyId, agencyCountry, vendorCountry) {
        var _this = this;
        var response = this.groupPayConfigHttpService.getGroupPayOoivConfigByValues(key, agencyId, agencyCountry, vendorCountry)
            .catch(function (error) {
            _this.flashMessagesService.error(_this.translateService.instant('MESSAGES.ERROR.GROUPPAY_CONFIG_SINGLE', {
                configValue: key.toString()
            }));
            _this.logService.error("Error retrieving configuration value (" + key.toString() + "): " + error);
            return Observable["Observable"].throw(error);
        })
            .map(function (configResponse) {
            _this.updateOneConfig(key, configResponse);
            return configResponse;
        });
        return response;
    };
    return GroupPayConfigStore;
}());
grouppay_config_store_GroupPayConfigStore = grouppay_config_store___decorate([
    Object(core_es5["Injectable"])(),
    grouppay_config_store___metadata("design:paramtypes", [typeof (grouppay_config_store__a = typeof grouppay_config_http_service_GroupPayConfigHttpService !== "undefined" && grouppay_config_http_service_GroupPayConfigHttpService) === "function" && grouppay_config_store__a || Object, typeof (grouppay_config_store__b = typeof log_service_LogService !== "undefined" && log_service_LogService) === "function" && grouppay_config_store__b || Object, typeof (grouppay_config_store__c = typeof flash_messages_service_FlashMessagesService !== "undefined" && flash_messages_service_FlashMessagesService) === "function" && grouppay_config_store__c || Object, typeof (grouppay_config_store__d = typeof core["c" /* TranslateService */] !== "undefined" && core["c" /* TranslateService */]) === "function" && grouppay_config_store__d || Object])
], grouppay_config_store_GroupPayConfigStore);

var grouppay_config_store__a, grouppay_config_store__b, grouppay_config_store__c, grouppay_config_store__d;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/grouppay-config.store.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/event-list/event-list-financial-table/event-list-financial.component.ts
var event_list_financial_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var event_list_financial_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};








var event_list_financial_component_EventListFinancialComponent = (function () {
    function EventListFinancialComponent(environment, menuStore, groupPayConfigStore, authenticationStore) {
        this.environment = environment;
        this.menuStore = menuStore;
        this.groupPayConfigStore = groupPayConfigStore;
        this.authenticationStore = authenticationStore;
    }
    EventListFinancialComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.menuStore.setPageHeader('EVENTS.TITLE', false);
        this.searchText = '';
        this.groupPayConfigStore.isOoivEnabled(null, null, null)
            .subscribe(function (ooivEnabled) {
            _this.isOoivEnabled = ooivEnabled;
        });
        this.isAgencyUser = this.authenticationStore.isAgencyUser();
    };
    Object.defineProperty(EventListFinancialComponent.prototype, "eventCount", {
        get: function () {
            return this.events.totalElements;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EventListFinancialComponent.prototype, "eventCountForTranslate", {
        get: function () {
            return {
                eventCount: this.eventCount
            };
        },
        enumerable: true,
        configurable: true
    });
    EventListFinancialComponent.prototype.getPaymentAmount = function (eventSummary) {
        if (payment_status_utils_PaymentStatusUtils.isError(eventSummary.payStatus)) {
            return 0;
        }
        else {
            return Number(eventSummary.paymentAmount);
        }
    };
    EventListFinancialComponent.prototype.getTaxAmount = function (eventSummary) {
        if (payment_status_utils_PaymentStatusUtils.isError(eventSummary.payStatus)) {
            return 0;
        }
        else {
            return Number(eventSummary.taxAmount);
        }
    };
    EventListFinancialComponent.prototype.getPrepaymentAmount = function (eventSummary) {
        if (payment_status_utils_PaymentStatusUtils.isError(eventSummary.prepayStatus)) {
            return 0;
        }
        else {
            return Number(eventSummary.prepaymentAmount);
        }
    };
    EventListFinancialComponent.prototype.getTotalPaymentAmount = function (eventSummary) {
        return this.getPrepaymentAmount(eventSummary) + this.getPaymentAmount(eventSummary) + this.getTaxAmount(eventSummary);
    };
    EventListFinancialComponent.prototype.getEstimatedDue = function (eventSummary) {
        var estimatedDue = Number(eventSummary.dueAmount);
        estimatedDue = Math.max(estimatedDue, 0);
        return estimatedDue;
    };
    EventListFinancialComponent.prototype.getTotalPaymentAmountByStatus = function (eventSummary) {
        if (payment_status_utils_PaymentStatusUtils.isNoTotalPaid(eventSummary.payStatus)) {
            return this.getPrepaymentAmount(eventSummary);
        }
        else {
            return this.getTotalPaymentAmount(eventSummary);
        }
    };
    EventListFinancialComponent.prototype.getEstimatedDueByStatus = function (eventSummary) {
        if (payment_status_utils_PaymentStatusUtils.isNoEstimatedDue(eventSummary.payStatus)) {
            return 0;
        }
        else {
            return this.getEstimatedDue(eventSummary);
        }
    };
    EventListFinancialComponent.prototype.getEventNameLine1 = function (name) {
        if (name.length > Constants.EVENTS_NAME_MAX_SIZE) {
            return name.substring(0, Constants.EVENTS_NAME_MAX_SIZE);
        }
        else {
            return name;
        }
    };
    EventListFinancialComponent.prototype.getEventNameLine2 = function (name) {
        if (name.length > Constants.EVENTS_NAME_MAX_SIZE) {
            var line2 = name.substring(Constants.EVENTS_NAME_MAX_SIZE);
            if (line2.length > Constants.EVENTS_NAME_MAX_SIZE) {
                return line2.substring(0, Constants.EVENTS_NAME_MAX_SIZE);
            }
            else {
                return line2;
            }
        }
        else {
            return null;
        }
    };
    EventListFinancialComponent.prototype.getPaymentStatus = function (status) {
        return payment_status_utils_PaymentStatusUtils.getAwePaymentStatus(status, this.authenticationStore.isAgencyUser());
    };
    return EventListFinancialComponent;
}());
event_list_financial_component___decorate([
    Object(core_es5["Input"])(),
    event_list_financial_component___metadata("design:type", typeof (event_list_financial_component__a = typeof page_Page !== "undefined" && page_Page) === "function" && event_list_financial_component__a || Object)
], event_list_financial_component_EventListFinancialComponent.prototype, "events", void 0);
event_list_financial_component_EventListFinancialComponent = event_list_financial_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-event-list-financial-table',
        template: __webpack_require__("qwMY"),
        styles: [__webpack_require__("8mhJ")]
    }),
    event_list_financial_component___metadata("design:paramtypes", [typeof (event_list_financial_component__b = typeof EnvironmentConfiguration !== "undefined" && EnvironmentConfiguration) === "function" && event_list_financial_component__b || Object, typeof (event_list_financial_component__c = typeof menu_store_MenuStore !== "undefined" && menu_store_MenuStore) === "function" && event_list_financial_component__c || Object, typeof (event_list_financial_component__d = typeof grouppay_config_store_GroupPayConfigStore !== "undefined" && grouppay_config_store_GroupPayConfigStore) === "function" && event_list_financial_component__d || Object, typeof (event_list_financial_component__e = typeof authentication_store_AuthenticationStore !== "undefined" && authentication_store_AuthenticationStore) === "function" && event_list_financial_component__e || Object])
], event_list_financial_component_EventListFinancialComponent);

var event_list_financial_component__a, event_list_financial_component__b, event_list_financial_component__c, event_list_financial_component__d, event_list_financial_component__e;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/event-list-financial.component.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/event-list/event-list-multi-vendor-table/event-list-multi-vendor.component.ts
var event_list_multi_vendor_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var event_list_multi_vendor_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};










var event_list_multi_vendor_component_EventListMultiVendorComponent = (function () {
    function EventListMultiVendorComponent(environment, menuStore, _commonDataStore, groupPayConfigStore, authenticationStore) {
        this.environment = environment;
        this.menuStore = menuStore;
        this._commonDataStore = _commonDataStore;
        this.groupPayConfigStore = groupPayConfigStore;
        this.authenticationStore = authenticationStore;
        this.imagesUrl = '';
        this._isCollapsed = false;
    }
    EventListMultiVendorComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.menuStore.setPageHeader('EVENTS.TITLE', false);
        this.searchText = '';
        this.imagesUrl = this.environment.onyxGPImagesCommonDataUrl;
        this.groupPayConfigStore.isOoivEnabled(null, null, null)
            .subscribe(function (ooivEnabled) {
            _this.isOoivEnabled = ooivEnabled;
        });
        this.isAgencyUser = this.authenticationStore.isAgencyUser();
    };
    Object.defineProperty(EventListMultiVendorComponent.prototype, "commonDataStore", {
        get: function () {
            return this._commonDataStore;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EventListMultiVendorComponent.prototype, "eventCount", {
        get: function () {
            return this.events.totalElements;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EventListMultiVendorComponent.prototype, "eventCountForTranslate", {
        get: function () {
            return {
                eventCount: this.eventCount
            };
        },
        enumerable: true,
        configurable: true
    });
    EventListMultiVendorComponent.prototype.getPaymentAmount = function (status, amount) {
        if (payment_status_utils_PaymentStatusUtils.isError(status)) {
            return 0;
        }
        else {
            return Number(amount);
        }
    };
    EventListMultiVendorComponent.prototype.getTotalEventPaymentAmount = function (eventSummary) {
        return this.getPaymentAmount(eventSummary.prepayStatus, eventSummary.prepaymentAmount)
            + this.getPaymentAmount(eventSummary.payStatus, eventSummary.paymentAmount)
            + this.getPaymentAmount(eventSummary.payStatus, eventSummary.taxAmount);
    };
    EventListMultiVendorComponent.prototype.getTotalVendorPaymentAmountByStatus = function (paymentSummary) {
        if (payment_status_utils_PaymentStatusUtils.isNoTotalPaid(paymentSummary.payStatus)) {
            return this.getPaymentAmount(paymentSummary.prepayStatus, paymentSummary.prepaymentAmount);
        }
        else {
            return this.getTotalVendorPaymentAmount(paymentSummary);
        }
    };
    EventListMultiVendorComponent.prototype.getTotalVendorPaymentAmount = function (paymentSummary) {
        return this.getPaymentAmount(paymentSummary.prepayStatus, paymentSummary.prepaymentAmount)
            + this.getPaymentAmount(paymentSummary.payStatus, paymentSummary.paymentAmount)
            + this.getPaymentAmount(paymentSummary.payStatus, paymentSummary.taxAmount);
    };
    EventListMultiVendorComponent.prototype.getEstimatedDue = function (dueAmount) {
        return Math.max(Number(dueAmount), 0);
    };
    EventListMultiVendorComponent.prototype.getEventNameLine1 = function (name) {
        if (name.length > Constants.EVENTS_NAME_MAX_SIZE) {
            return name.substring(0, Constants.EVENTS_NAME_MAX_SIZE);
        }
        else {
            return name;
        }
    };
    EventListMultiVendorComponent.prototype.getEventNameLine2 = function (name) {
        if (name.length > Constants.EVENTS_NAME_MAX_SIZE) {
            var line2 = name.substring(Constants.EVENTS_NAME_MAX_SIZE);
            if (line2.length > Constants.EVENTS_NAME_MAX_SIZE) {
                return line2.substring(0, Constants.EVENTS_NAME_MAX_SIZE);
            }
            else {
                return line2;
            }
        }
        else {
            return null;
        }
    };
    EventListMultiVendorComponent.prototype.getCountryName = function (countryCode) {
        return this.commonDataStore.getCountry(countryCode);
    };
    EventListMultiVendorComponent.prototype.onCardExpandClicked = function (event, eventId, expanded) {
        event.preventDefault();
        this.events.content.filter(function (ev) { return ev.eventId === eventId; }).forEach(function (x) {
            x.isExpanded = expanded;
        });
    };
    EventListMultiVendorComponent.prototype.getStatusClasses = function (status) {
        var eventStatusInfo = new event_status_info_EventStatusInfo(status);
        if (eventStatusInfo.isPaid()) {
            return 'badge-success';
        }
        else if (eventStatusInfo.isUnpaid()) {
            return 'badge-danger';
        }
        else if (eventStatusInfo.isProcessing()) {
            return 'badge-warning';
        }
        else if (eventStatusInfo.isCancelled()) {
            return 'badge-secondary';
        }
        else {
            return '';
        }
    };
    EventListMultiVendorComponent.prototype.getPaymentStatus = function (status) {
        return payment_status_utils_PaymentStatusUtils.getAwePaymentStatus(status, this.authenticationStore.isAgencyUser());
    };
    return EventListMultiVendorComponent;
}());
event_list_multi_vendor_component___decorate([
    Object(core_es5["Input"])(),
    event_list_multi_vendor_component___metadata("design:type", typeof (event_list_multi_vendor_component__a = typeof page_Page !== "undefined" && page_Page) === "function" && event_list_multi_vendor_component__a || Object)
], event_list_multi_vendor_component_EventListMultiVendorComponent.prototype, "events", void 0);
event_list_multi_vendor_component_EventListMultiVendorComponent = event_list_multi_vendor_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-event-list-multi-vendor-table',
        template: __webpack_require__("5cmY"),
        styles: [__webpack_require__("O49O")]
    }),
    event_list_multi_vendor_component___metadata("design:paramtypes", [typeof (event_list_multi_vendor_component__b = typeof EnvironmentConfiguration !== "undefined" && EnvironmentConfiguration) === "function" && event_list_multi_vendor_component__b || Object, typeof (event_list_multi_vendor_component__c = typeof menu_store_MenuStore !== "undefined" && menu_store_MenuStore) === "function" && event_list_multi_vendor_component__c || Object, typeof (event_list_multi_vendor_component__d = typeof common_data_store_CommonDataStore !== "undefined" && common_data_store_CommonDataStore) === "function" && event_list_multi_vendor_component__d || Object, typeof (event_list_multi_vendor_component__e = typeof grouppay_config_store_GroupPayConfigStore !== "undefined" && grouppay_config_store_GroupPayConfigStore) === "function" && event_list_multi_vendor_component__e || Object, typeof (event_list_multi_vendor_component__f = typeof authentication_store_AuthenticationStore !== "undefined" && authentication_store_AuthenticationStore) === "function" && event_list_multi_vendor_component__f || Object])
], event_list_multi_vendor_component_EventListMultiVendorComponent);

var event_list_multi_vendor_component__a, event_list_multi_vendor_component__b, event_list_multi_vendor_component__c, event_list_multi_vendor_component__d, event_list_multi_vendor_component__e, event_list_multi_vendor_component__f;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/event-list-multi-vendor.component.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/menus/event-search-filter/event-search-filter.validator.ts


var event_search_filter_validator_EventSearchFilterValidator = (function () {
    function EventSearchFilterValidator() {
    }
    EventSearchFilterValidator.validate = function (formGroup) {
        var payStatus = EventSearchFilterValidator.validatePaymentStatus(formGroup);
        var dateCompare = EventSearchFilterValidator.dateCompare(formGroup);
        if (payStatus && dateCompare) {
            return Object.assign({}, payStatus, dateCompare);
        }
        else if (payStatus) {
            return payStatus;
        }
        else if (dateCompare) {
            return dateCompare;
        }
        else {
            return null;
        }
    };
    EventSearchFilterValidator.validatePaymentStatus = function (formGroup) {
        var paymentStatusGroup = formGroup.get('paymentStatus');
        var unpaid = paymentStatusGroup.get('unpaid').value;
        var paid = paymentStatusGroup.get('paid').value;
        var inProcess = paymentStatusGroup.get('inProcess').value;
        var cancelled = paymentStatusGroup.get('cancelled').value;
        var paymentArray = immutable["List"].of({ name: 'unpaid', value: unpaid }, { name: 'paid', value: paid }, { name: 'inProcess', value: inProcess }, { name: 'cancelled', value: cancelled });
        var isSelected = paymentArray.filter(function (obj) { return obj.value === true; }).toList();
        if (isSelected.isEmpty()) {
            paymentStatusGroup.get('paid').markAsTouched();
            var obj = {};
            obj[EventSearchFilterValidator.PAYMENT_STATUS_ERROR] = true;
            return obj;
        }
        return null;
    };
    EventSearchFilterValidator.dateCompare = function (formGroup) {
        var startDate = formGroup.get('startDate').value;
        var endDate = formGroup.get('endDate').value;
        if (!startDate || !endDate) {
            return null;
        }
        else {
            // Convert to string if object
            if (!Object(util_util["isString"])(startDate)) {
                startDate = startDate.toUTCString();
            }
            if (!Object(util_util["isString"])(endDate)) {
                endDate = endDate.toUTCString();
            }
        }
        var isInvalid = new Date(startDate) >= new Date(endDate);
        if (isInvalid) {
            formGroup.get('endDate').markAsTouched();
            var obj = {};
            obj[EventSearchFilterValidator.DATE_ERROR] = true;
            return obj;
        }
        return null;
    };
    return EventSearchFilterValidator;
}());

event_search_filter_validator_EventSearchFilterValidator.PAYMENT_STATUS_ERROR = 'validatePaymentStatus';
event_search_filter_validator_EventSearchFilterValidator.DATE_ERROR = 'greater';
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/event-search-filter.validator.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/event-search-text.ts
var event_search_text___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var EventSearchTextRecord = Object(immutable["Record"])({
    searchText: ''
});
var EventSearchText = (function (_super) {
    event_search_text___extends(EventSearchText, _super);
    function EventSearchText() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return EventSearchText;
}(EventSearchTextRecord));

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/event-search-text.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/service/event-search-forms.store.ts
var event_search_forms_store___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var event_search_forms_store___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};













var event_search_forms_store_EventSearchFormsStore = (function () {
    function EventSearchFormsStore(formBuilder, logger, eventSearchParametersStore, eventMenuMapper, authenticationStore) {
        this.formBuilder = formBuilder;
        this.logger = logger;
        this.eventSearchParametersStore = eventSearchParametersStore;
        this.eventMenuMapper = eventMenuMapper;
        this.authenticationStore = authenticationStore;
        this.filterMenuErrorSubject = new BehaviorSubject["BehaviorSubject"](null);
        this.filterEventMenuSearchFilterSubject = new BehaviorSubject["BehaviorSubject"](null);
        this.filterSearchTextSubject = new BehaviorSubject["BehaviorSubject"](null);
        this.init();
    }
    /**
     * Both the searchFilterRecord and valueChanges subscriptions take the populated form and set the
     *   EventMenuSearchFilter business subject.
     *
     * This allows the store to correctly initialize the EventMenuSearchFilter subject from
     *   the EventSearchParametersStore OR the eventFilterForm FormGroup.
     */
    EventSearchFormsStore.prototype.init = function () {
        var _this = this;
        this.logger.debug('EventSearchFormsStore.init');
        this.filterRecord = new EventMenuSearchFilter();
        this.searchText = new EventSearchText();
        this.populateSearchTextForm('');
        this.populateSearchFilterForm(this.filterRecord);
        this.eventSearchTextForm.valueChanges.debounceTime(250).subscribe(function (value) {
            _this.logger.info("EventSearchFormsStore: ngOnInit: eventSearchTextForm.valueChanges: " + JSON.stringify(value));
            _this.setFilterSearchText(new EventSearchText(value));
        });
        this.eventSearchParametersStore.searchFilterRecord.subscribe(function (searchFilterRecord) {
            // tslint:disable-next-line:max-line-length
            _this.logger.info("EventSearchFormsStore: ngOnInit: eventSearchParametersStore.searchFilterRecord: " + JSON.stringify(searchFilterRecord));
            _this.populateSearchFilterForm(searchFilterRecord);
            var formValue = _this.eventFilterForm.value;
            _this.formValueToEventMenuSearchFilter(formValue);
        });
        this.eventFilterForm.valueChanges.subscribe(function (formValue) {
            _this.logger.info("EventSearchFormsStore: ngOnInit: eventFilterForm.valueChanges: " + JSON.stringify(formValue));
            _this.formValueToEventMenuSearchFilter(formValue);
        });
        this.eventFilterForm.statusChanges.subscribe(function (value) {
            _this.setFilterMenuErrors(_this.eventFilterForm.errors);
            _this.logger.info("EventSearchFormsStore: statusChanges: " + JSON.stringify(_this.eventFilterForm.errors) + " ");
        });
    };
    EventSearchFormsStore.prototype.formValueToEventMenuSearchFilter = function (formValue) {
        var eventMenuSearchFilter = this.createFilterRecord(formValue);
        this.setFilterEventMenuSearchFilter(eventMenuSearchFilter);
        this.updatePaymentStatusGroup();
    };
    EventSearchFormsStore.prototype.populateSearchFilterForm = function (filterRecord) {
        if (!this.eventFilterForm) {
            this.eventFilterForm = this.formBuilder.group({
                'commissionId': [filterRecord.commissionId],
                'fundingReferenceId': [filterRecord.fundingReferenceId],
                'paymentReferenceId': [filterRecord.paymentReferenceId],
                'hasPrepayment': filterRecord.hasPrepayment,
                'startDate': [date_util_DateUtil.formatDate(filterRecord.startDate), [pioneer_validators_PioneerValidators.isDate]],
                'endDate': [date_util_DateUtil.formatDate(filterRecord.endDate), [pioneer_validators_PioneerValidators.isDate]],
                'guestName': [filterRecord.guestName],
                'eventStatusMissingAgency': [filterRecord.eventStatusMissingAgency],
                'eventStatusCompleted': [filterRecord.eventStatusCompleted],
                'includeArchivedEvents': [filterRecord.includeArchivedEvents],
                'includeCommRetentionEvents': [filterRecord.includeCommRetentionEvents],
                'includeDeletedEvents': [filterRecord.includeDeletedEvents],
                'paymentStatus': this.formBuilder.group({
                    'unpaid': [filterRecord.paymentStatus.unpaid],
                    'paid': [filterRecord.paymentStatus.paid],
                    'inProcess': [filterRecord.paymentStatus.inProcess],
                    'cancelled': [filterRecord.paymentStatus.cancelled]
                }),
                'eventPaymentStatus': this.formBuilder.group({
                    'paid': [filterRecord.eventPaymentStatus.paid],
                    'partial': [filterRecord.eventPaymentStatus.partial],
                    'unpaid': [filterRecord.eventPaymentStatus.unpaid]
                })
            }, { validator: event_search_filter_validator_EventSearchFilterValidator.validate });
        }
        else {
            this.eventFilterForm.patchValue({
                'commissionId': filterRecord.commissionId,
                'fundingReferenceId': filterRecord.fundingReferenceId,
                'paymentReferenceId': filterRecord.paymentReferenceId,
                'hasPrepayment': filterRecord.hasPrepayment,
                'startDate': date_util_DateUtil.formatDate(filterRecord.startDate),
                'endDate': date_util_DateUtil.formatDate(filterRecord.endDate),
                'guestName': filterRecord.guestName,
                'eventStatusMissingAgency': filterRecord.eventStatusMissingAgency,
                'eventStatusCompleted': filterRecord.eventStatusCompleted,
                'includeArchivedEvents': filterRecord.includeArchivedEvents,
                'includeCommRetentionEvents': filterRecord.includeCommRetentionEvents,
                'includeDeletedEvents': filterRecord.includeDeletedEvents
            });
            this.eventFilterForm.get('paymentStatus').patchValue({
                'unpaid': filterRecord.paymentStatus.unpaid,
                'paid': filterRecord.paymentStatus.paid,
                'inProcess': filterRecord.paymentStatus.inProcess,
                'cancelled': filterRecord.paymentStatus.cancelled
            });
            this.eventFilterForm.get('eventPaymentStatus').patchValue({
                'paid': filterRecord.eventPaymentStatus.paid,
                'partial': filterRecord.eventPaymentStatus.partial,
                'unpaid': filterRecord.eventPaymentStatus.unpaid
            });
        }
    };
    EventSearchFormsStore.prototype.populateSearchTextForm = function (searchText) {
        if (!this.eventSearchTextForm) {
            this.eventSearchTextForm = this.formBuilder.group({
                'searchText': [searchText, [forms_es5["Validators"].required]]
            });
        }
        else {
            this.eventSearchTextForm.patchValue({
                'searchText': searchText
            });
        }
    };
    Object.defineProperty(EventSearchFormsStore.prototype, "searchTextForm", {
        get: function () {
            return this.eventSearchTextForm;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EventSearchFormsStore.prototype, "filterForm", {
        get: function () {
            return this.eventFilterForm;
        },
        enumerable: true,
        configurable: true
    });
    EventSearchFormsStore.prototype.searchFromSearchText = function (searchText, updateUrl) {
        if (updateUrl === void 0) { updateUrl = true; }
        var filterRecord = this.filterEventMenuSearchFilterSnapshot;
        if (filterRecord !== null) {
            var filterOptionsSet = this.eventMenuMapper.toSearchFilterSet(filterRecord, this.isMultiVendor());
            this.eventSearchParametersStore.setFilterSet(filterOptionsSet);
        }
        this.eventSearchParametersStore.addSearchText(searchText.searchText);
        if (updateUrl) {
            this.eventSearchParametersStore.updateUrl();
        }
        this.populateSearchTextForm('');
    };
    EventSearchFormsStore.prototype.searchFromFilter = function (record) {
        this.filterRecord = record;
        var filterOptionsSet = this.eventMenuMapper.toSearchFilterSet(this.filterRecord, this.isMultiVendor());
        this.eventSearchParametersStore.setFilterSet(filterOptionsSet);
        var filterText = this.filterSearchTextSnapshot;
        if (filterText && filterText.searchText) {
            this.eventSearchParametersStore.addSearchText(filterText.searchText);
            this.populateSearchTextForm('');
        }
        this.eventSearchParametersStore.updateUrl();
    };
    EventSearchFormsStore.prototype.updatePaymentStatusGroup = function () {
        var paymentStatusGroup = this.eventFilterForm.get('paymentStatus');
        var unpaid = paymentStatusGroup.get('unpaid').value;
        var paid = paymentStatusGroup.get('paid').value;
        var inProcess = paymentStatusGroup.get('inProcess').value;
        var cancelled = paymentStatusGroup.get('cancelled').value;
        var paymentArray = immutable["List"].of({ name: 'unpaid', value: unpaid }, { name: 'paid', value: paid }, { name: 'inProcess', value: inProcess }, { name: 'cancelled', value: cancelled });
        // Returns only those records where the value is true
        var selectedOptionsList = paymentArray.filter(function (obj) { return obj.value === true; }).toList();
        this.logger.verbose("updatePaymentStatusGroup: is Selected count: " + selectedOptionsList.size);
        if (selectedOptionsList.size === 1) {
            // The other 2 options have been unchecked, disable the last option so that it cannot be
            // unchecked
            if (paymentStatusGroup.get(selectedOptionsList.first().name).enabled) {
                paymentStatusGroup.get(selectedOptionsList.first().name).disable();
            }
        }
        else {
            paymentArray.forEach(function (opt) {
                if (paymentStatusGroup.get(opt.name).disabled) {
                    paymentStatusGroup.get(opt.name).enable();
                }
            });
        }
    };
    Object.defineProperty(EventSearchFormsStore.prototype, "filterMenuErrors", {
        get: function () {
            return this.filterMenuErrorSubject.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EventSearchFormsStore.prototype, "filterMenuErrorsSnapshot", {
        get: function () {
            return this.filterMenuErrorSubject.getValue();
        },
        enumerable: true,
        configurable: true
    });
    EventSearchFormsStore.prototype.setFilterMenuErrors = function (value) {
        this.logger.debug("EventSearchFormsStore.setFilterMenuErrors: " + JSON.stringify(value));
        this.filterMenuErrorSubject.next(value);
    };
    Object.defineProperty(EventSearchFormsStore.prototype, "filterEventMenuSearchFilter", {
        get: function () {
            return this.filterEventMenuSearchFilterSubject.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EventSearchFormsStore.prototype, "filterEventMenuSearchFilterSnapshot", {
        get: function () {
            return this.filterEventMenuSearchFilterSubject.getValue();
        },
        enumerable: true,
        configurable: true
    });
    EventSearchFormsStore.prototype.setFilterEventMenuSearchFilter = function (value) {
        this.logger.debug("EventSearchFormsStore.setFilterEventMenuSearchFilter: " + JSON.stringify(value));
        this.filterEventMenuSearchFilterSubject.next(value);
    };
    Object.defineProperty(EventSearchFormsStore.prototype, "filterSearchText", {
        get: function () {
            return this.filterSearchTextSubject.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EventSearchFormsStore.prototype, "filterSearchTextSnapshot", {
        get: function () {
            return this.filterSearchTextSubject.getValue();
        },
        enumerable: true,
        configurable: true
    });
    EventSearchFormsStore.prototype.setFilterSearchText = function (value) {
        this.logger.debug("EventSearchFormsStore.setFilterSearchText: " + JSON.stringify(value));
        this.filterSearchTextSubject.next(value);
    };
    EventSearchFormsStore.prototype.createFilterRecord = function (model) {
        this.logger.debug("createFilterRecord: model: " + JSON.stringify(model));
        /*
         * The last payment status can get disabled so we read the value directly from the form rather
         * than what comes in with the form submission for paymentStatus
         */
        var paymentStatusGroup = this.eventFilterForm.get('paymentStatus');
        var unpaid = paymentStatusGroup.get('unpaid').value;
        var paid = paymentStatusGroup.get('paid').value;
        var inProcess = paymentStatusGroup.get('inProcess').value;
        var cancelled = paymentStatusGroup.get('cancelled').value;
        model.paymentStatus = {
            unpaid: unpaid,
            paid: paid,
            inProcess: inProcess,
            cancelled: cancelled
        };
        return new EventMenuSearchFilter(model);
    };
    EventSearchFormsStore.prototype.isEventFilterOptionSelected = function () {
        var eventMenuSearchFilter = this.filterEventMenuSearchFilterSnapshot;
        if (eventMenuSearchFilter === null) {
            // this should be setup during the initialization of this store
            throw new Error('eventMenuSearchFilter can not be null');
        }
        this.logger.debug("EventSearchFormsStore: isEventFilterOptionSelected: " + JSON.stringify(eventMenuSearchFilter));
        var isExpanded = eventMenuSearchFilter.eventStatusCompleted ||
            eventMenuSearchFilter.eventStatusMissingAgency ||
            eventMenuSearchFilter.eventStatusArchived ||
            eventMenuSearchFilter.includeArchivedEvents ||
            eventMenuSearchFilter.includeCommRetentionEvents ||
            eventMenuSearchFilter.includeDeletedEvents ||
            eventMenuSearchFilter.eventPaymentStatus.paid ||
            eventMenuSearchFilter.eventPaymentStatus.partial ||
            eventMenuSearchFilter.eventPaymentStatus.unpaid ||
            Boolean(eventMenuSearchFilter.startDate) ||
            Boolean(eventMenuSearchFilter.endDate) ||
            Boolean(eventMenuSearchFilter.guestName);
        this.logger.debug("EventSearchFormsStore: isEventFilterOptionSelected: isExpanded " + JSON.stringify(isExpanded));
        return isExpanded;
    };
    EventSearchFormsStore.prototype.isMultiVendor = function () {
        return this.authenticationStore.hasPermission('MultiVendor');
    };
    return EventSearchFormsStore;
}());
event_search_forms_store_EventSearchFormsStore = event_search_forms_store___decorate([
    Object(core_es5["Injectable"])(),
    event_search_forms_store___metadata("design:paramtypes", [typeof (event_search_forms_store__a = typeof forms_es5["FormBuilder"] !== "undefined" && forms_es5["FormBuilder"]) === "function" && event_search_forms_store__a || Object, typeof (event_search_forms_store__b = typeof log_service_LogService !== "undefined" && log_service_LogService) === "function" && event_search_forms_store__b || Object, typeof (event_search_forms_store__c = typeof event_search_parameters_store_EventSearchParametersStore !== "undefined" && event_search_parameters_store_EventSearchParametersStore) === "function" && event_search_forms_store__c || Object, typeof (event_search_forms_store__d = typeof event_menu_search_filter_mapper_EventMenuSearchFilterMapper !== "undefined" && event_menu_search_filter_mapper_EventMenuSearchFilterMapper) === "function" && event_search_forms_store__d || Object, typeof (event_search_forms_store__e = typeof authentication_store_AuthenticationStore !== "undefined" && authentication_store_AuthenticationStore) === "function" && event_search_forms_store__e || Object])
], event_search_forms_store_EventSearchFormsStore);

var event_search_forms_store__a, event_search_forms_store__b, event_search_forms_store__c, event_search_forms_store__d, event_search_forms_store__e;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/event-search-forms.store.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/event-list/event-list.component.ts
var event_list_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var event_list_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};


























var event_list_component_EventListComponent = (function () {
    function EventListComponent(eventListStore, environment, menuStore, logger, flashMessagesService, eventSearchParametersStore, eventFilterUtils, eventSearchFormsStore, translateService, userLocalStorageService, multiAgencyService, activatedRoute, eventStore, spinnerService) {
        var _this = this;
        this.eventListStore = eventListStore;
        this.environment = environment;
        this.menuStore = menuStore;
        this.logger = logger;
        this.flashMessagesService = flashMessagesService;
        this.eventSearchParametersStore = eventSearchParametersStore;
        this.eventFilterUtils = eventFilterUtils;
        this.eventSearchFormsStore = eventSearchFormsStore;
        this.translateService = translateService;
        this.userLocalStorageService = userLocalStorageService;
        this.multiAgencyService = multiAgencyService;
        this.activatedRoute = activatedRoute;
        this.eventStore = eventStore;
        this.spinnerService = spinnerService;
        this.pagesizeType = PagesizeType.EVENTS;
        this.defaultAgency$ = this.multiAgencyService.defaultAgency$;
        this.elementsPerPage = [10, 25, 50];
        this.agencySubscription$ = new Subscription["Subscription"]();
        this.eventList = {
            original: null,
            filtered: null,
            firstLoading: true,
            isUserSearching: {
                searching: false,
                resetTable: false
            }
        };
        this.showEventListControl = false;
        this.eventSubs = new Subscription["Subscription"]();
        this.activatedRoute.data.subscribe(function (resource) {
            if (!_this.eventList.firstLoading && resource['eventListData'] && resource['eventListData'].status) {
                _this.resetTable();
                _this.loadEvenList(0);
            }
        });
    }
    EventListComponent.prototype.ngOnInit = function () {
        this.menuStore.setPageHeader('EVENTS.TITLE', false);
        this.eventSearchFormsStore.populateSearchTextForm('');
        this.eventSearchTextForm = this.eventSearchFormsStore.searchTextForm;
        this.eventStore.resetSelectedEvent();
        this.createSubscriptions();
    };
    EventListComponent.prototype.ngOnDestroy = function () {
        this.agencySubscription$.unsubscribe();
        this.eventSubs.unsubscribe();
    };
    EventListComponent.prototype.createSubscriptions = function () {
        var _this = this;
        this.loadEvenList(0);
        this.eventSubs.add(this.defaultAgency$.subscribe(function () {
            if (!_this.eventList.firstLoading) {
                _this.eventList.firstLoading = true;
                _this.loadEvenList(0);
            }
        }));
        this.eventSubs.add(this.eventListStore.events.subscribe(function (ev) {
            _this.eventList.original = ev;
            _this.eventList.filtered = ev;
            _this.resetTable(false);
        }));
    };
    EventListComponent.prototype.resetSearch = function () {
        this.eventSearchParametersStore.reset(true);
        this.eventSearchFormsStore.populateSearchTextForm('');
    };
    EventListComponent.prototype.addSearchText = function (models) {
        var eventSearchText = new EventSearchText(models);
        this.logger.info("addSearchText: " + JSON.stringify(models));
        if (!eventSearchText.searchText) {
            return;
        }
        var filterErrors = this.eventSearchFormsStore.filterMenuErrorsSnapshot;
        if (filterErrors != null) {
            if (filterErrors[event_search_filter_validator_EventSearchFilterValidator.DATE_ERROR]) {
                this.flashMessagesService.error('MESSAGES.ERROR.INVALID_DATE_RANGE');
            }
            if (filterErrors[event_search_filter_validator_EventSearchFilterValidator.PAYMENT_STATUS_ERROR]) {
                this.flashMessagesService.error('MESSAGES.ERROR.NO_PAYMENT_STATUS_SELECTED');
            }
            return;
        }
        this.eventSearchFormsStore.searchFromSearchText(eventSearchText);
    };
    EventListComponent.prototype.addSearchFilter = function (filterField, filterValue) {
        this.eventSearchParametersStore.addSearchFilter(filterField, filterValue, true);
    };
    EventListComponent.prototype.removeSearchText = function (event) {
        var element = (event.target || event.srcElement);
        var searchText = element.innerHTML.trim();
        this.eventSearchParametersStore.removeSearchText(searchText, true);
    };
    EventListComponent.prototype.removeSearchFilter = function (event, filter) {
        this.eventSearchParametersStore.removeSearchFilter(filter, true);
        var element = (event.target || event.srcElement);
        element.innerHTML.trim();
    };
    EventListComponent.prototype.loadEvenList = function (page) {
        var _this = this;
        this.loadingRequestData();
        this.onRefreshList(page).take(1).catch(function (error) {
            _this.loadingRequestData(false);
            _this.cleanTable();
            return Observable["Observable"].throw(error);
        }).subscribe(function (ev) {
            _this.loadingRequestData(false);
            _this.eventList.firstLoading = false;
        });
    };
    EventListComponent.prototype.onRefreshList = function (page) {
        return this.eventListStore.loadEvents(page, this.userLocalStorageService.getPagesize(PagesizeType.EVENTS), this.eventList.firstLoading);
    };
    EventListComponent.prototype.loadingRequestData = function (statusLoading) {
        if (statusLoading === void 0) { statusLoading = true; }
        this.showEventListControl = true;
        if (statusLoading) {
            this.eventList.original = null;
            this.spinnerService.start();
            this.disableTable();
        }
        else {
            this.spinnerService.finish();
            this.disableTable(false);
        }
    };
    EventListComponent.prototype.resetTable = function (reset) {
        if (reset === void 0) { reset = true; }
        this.eventList.isUserSearching.resetTable = reset;
    };
    EventListComponent.prototype.disableTable = function (disable) {
        if (disable === void 0) { disable = true; }
        this.eventList.isUserSearching.searching = disable;
        this.disableSearchBar(disable);
    };
    EventListComponent.prototype.updateToDefaultURL = function () {
        this.eventSearchParametersStore.defaultViewUrl();
    };
    EventListComponent.prototype.updateToFinancialURL = function () {
        this.eventSearchParametersStore.financialViewUrl();
    };
    EventListComponent.prototype.getTokenFilterFieldTranslationKey = function (filterField) {
        switch (filterField) {
            case EventFilterType.COMPLETED.toString():
            case EventFilterType.MISSING_AGENCY.toString():
            case EventFilterType.ARCHIVED.toString():
                return 'EVENTS.FILTER_LABEL.EVENT_STATUS';
            case EventFilterType.COMM_RETENTION.toString():
                return 'EVENTS.FILTER_LABEL.EVENT_STATUS';
            case EventFilterType.DELETED.toString():
                return 'EVENTS.FILTER_LABEL.EVENT_STATUS';
            case EventFilterType.MISSING_EMAIL_CONTACT.toString():
                return '';
            default:
                return 'EVENTS.FILTER_LABEL.' + filterField;
        }
    };
    EventListComponent.prototype.getTokenValue = function (filter) {
        return this.eventFilterUtils.getTokenDisplayString(filter);
    };
    EventListComponent.prototype.exportEventExcel = function () {
        var _this = this;
        var filterDescriptions = Object(immutable["Set"])([]);
        this.eventSearchParametersStore.eventSearchParametersSnapshot.filters.forEach(function (element) {
            filterDescriptions = filterDescriptions.add(_this.translateService.instant(_this.getTokenFilterFieldTranslationKey(element.filterField)) +
                ' ' +
                _this.getTokenValue(element));
        });
        var eventSearchParamsDesc = new EventSearchParamsDesc({
            maxEvents: 0,
            searchText: this.eventSearchParametersStore.eventSearchParametersSnapshot.searchText,
            filters: this.eventSearchParametersStore.eventSearchParametersSnapshot.filters,
            sorts: this.eventSearchParametersStore.eventSearchParametersSnapshot.sorts,
            filterDescriptions: filterDescriptions
        });
        this.eventListStore.exportEventExcel(eventSearchParamsDesc).subscribe();
    };
    EventListComponent.prototype.openBulkActionModal = function (action) {
        this.bulkActionPopup.open(action);
    };
    EventListComponent.prototype.disableSearchBar = function (isSearching) {
        if (this.eventSearchTextForm) {
            if (isSearching) {
                this.eventSearchTextForm.get('searchText').disable();
            }
            else {
                this.eventSearchTextForm.get('searchText').enable();
            }
        }
    };
    EventListComponent.prototype.cleanTable = function () {
        this.eventList.original = page_Page.empty();
        this.eventList.filtered = page_Page.empty();
        this.resetTable(false);
    };
    Object.defineProperty(EventListComponent.prototype, "searchTextSet", {
        get: function () {
            return this.eventSearchParametersStore.searchTextSet;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EventListComponent.prototype, "searchFilterSet", {
        get: function () {
            return this.eventSearchParametersStore.searchFilterSet;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EventListComponent.prototype, "eventCount", {
        get: function () {
            return this.eventListStore.totalEventCount;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EventListComponent.prototype, "eventsPresent", {
        get: function () {
            return this.eventCount.map(function (eventCount) {
                return eventCount > 0;
            });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EventListComponent.prototype, "maxEvents", {
        get: function () {
            return this.environment.events.maxEvents;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EventListComponent.prototype, "events", {
        get: function () {
            return this.eventListStore.events;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EventListComponent.prototype, "isDefaultViewSelected", {
        get: function () {
            return this.eventSearchParametersStore.isDefaultViewSelected;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EventListComponent.prototype, "BulkAction", {
        get: function () {
            return BulkAction;
        },
        enumerable: true,
        configurable: true
    });
    return EventListComponent;
}());
event_list_component___decorate([
    Object(core_es5["ViewChild"])(bulk_action_popup_component_BulkActionPopupComponent),
    event_list_component___metadata("design:type", typeof (event_list_component__a = typeof bulk_action_popup_component_BulkActionPopupComponent !== "undefined" && bulk_action_popup_component_BulkActionPopupComponent) === "function" && event_list_component__a || Object)
], event_list_component_EventListComponent.prototype, "bulkActionPopup", void 0);
event_list_component_EventListComponent = event_list_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-event-list',
        template: __webpack_require__("KTxh"),
        styles: [__webpack_require__("iEAM")]
    }),
    event_list_component___metadata("design:paramtypes", [typeof (event_list_component__b = typeof event_list_store_EventListStore !== "undefined" && event_list_store_EventListStore) === "function" && event_list_component__b || Object, typeof (event_list_component__c = typeof EnvironmentConfiguration !== "undefined" && EnvironmentConfiguration) === "function" && event_list_component__c || Object, typeof (event_list_component__d = typeof menu_store_MenuStore !== "undefined" && menu_store_MenuStore) === "function" && event_list_component__d || Object, typeof (event_list_component__e = typeof log_service_LogService !== "undefined" && log_service_LogService) === "function" && event_list_component__e || Object, typeof (event_list_component__f = typeof flash_messages_service_FlashMessagesService !== "undefined" && flash_messages_service_FlashMessagesService) === "function" && event_list_component__f || Object, typeof (event_list_component__g = typeof event_search_parameters_store_EventSearchParametersStore !== "undefined" && event_search_parameters_store_EventSearchParametersStore) === "function" && event_list_component__g || Object, typeof (event_list_component__h = typeof event_filter_util_service_EventFilterUtilsService !== "undefined" && event_filter_util_service_EventFilterUtilsService) === "function" && event_list_component__h || Object, typeof (event_list_component__j = typeof event_search_forms_store_EventSearchFormsStore !== "undefined" && event_search_forms_store_EventSearchFormsStore) === "function" && event_list_component__j || Object, typeof (event_list_component__k = typeof core["c" /* TranslateService */] !== "undefined" && core["c" /* TranslateService */]) === "function" && event_list_component__k || Object, typeof (event_list_component__l = typeof user_local_storage_service_UserLocalStorageService !== "undefined" && user_local_storage_service_UserLocalStorageService) === "function" && event_list_component__l || Object, typeof (event_list_component__m = typeof multi_agency_service_MultiAgencyService !== "undefined" && multi_agency_service_MultiAgencyService) === "function" && event_list_component__m || Object, typeof (event_list_component__o = typeof router_es5["ActivatedRoute"] !== "undefined" && router_es5["ActivatedRoute"]) === "function" && event_list_component__o || Object, typeof (event_list_component__p = typeof event_store_EventStore !== "undefined" && event_store_EventStore) === "function" && event_list_component__p || Object, typeof (event_list_component__q = typeof SpinnerService !== "undefined" && SpinnerService) === "function" && event_list_component__q || Object])
], event_list_component_EventListComponent);

var event_list_component__a, event_list_component__b, event_list_component__c, event_list_component__d, event_list_component__e, event_list_component__f, event_list_component__g, event_list_component__h, event_list_component__j, event_list_component__k, event_list_component__l, event_list_component__m, event_list_component__o, event_list_component__p, event_list_component__q;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/event-list.component.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/service/event-match-log.store.ts
var event_match_log_store___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var event_match_log_store___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};








var event_match_log_store_EventMatchLogStore = (function () {
    function EventMatchLogStore(flashMessagesService, logService, translateService, eventCollisionService, eventMatchLogHttpService) {
        this.flashMessagesService = flashMessagesService;
        this.logService = logService;
        this.translateService = translateService;
        this.eventCollisionService = eventCollisionService;
        this.eventMatchLogHttpService = eventMatchLogHttpService;
        this.init();
    }
    EventMatchLogStore.prototype.init = function () {
    };
    EventMatchLogStore.prototype.getEventMatchLog = function (page, size, sortField, secondarySortField, sortDirection) {
        var _this = this;
        var sort = 'sort=' + sortField + ',' + sortDirection;
        if (secondarySortField) {
            sort = sort + '&sort=' + secondarySortField + ',' + sortDirection;
        }
        return this.eventMatchLogHttpService.getEventMatchLog(page, size, sort).catch(function (error) {
            _this.flashMessagesService.error(_this.translateService.instant('MESSAGES.ERROR.GET_MATCHING_PROPERTIES'));
            _this.logService.error("Error getting Matching Properties: " + error);
            return Observable["Observable"].throw(error);
        }).map(function (propertyMatches) {
            return propertyMatches;
        });
    };
    EventMatchLogStore.prototype.exportEventMatchLogExcel = function () {
        return this.eventMatchLogHttpService.exportEventMatchLogExcel().map(function (data) {
            saveAs(data, 'event_match_log_' + date_util_DateUtil.formatDate(new Date(), 'YYYYMMDD') + '.xlsx');
        });
    };
    EventMatchLogStore.prototype.getMatchesByEvent = function (eventId) {
        var _this = this;
        return this.eventMatchLogHttpService.getMatchesByEvent(eventId).catch(function (error) {
            _this.flashMessagesService.error(_this.translateService.instant('MESSAGES.ERROR.GET_MATCHING_PROPERTIES'));
            _this.logService.error("Error getting matches by event : " + error);
            return Observable["Observable"].throw(error);
        }).map(function (matches) {
            return matches;
        });
    };
    return EventMatchLogStore;
}());
event_match_log_store_EventMatchLogStore = event_match_log_store___decorate([
    Object(core_es5["Injectable"])(),
    event_match_log_store___metadata("design:paramtypes", [typeof (event_match_log_store__a = typeof flash_messages_service_FlashMessagesService !== "undefined" && flash_messages_service_FlashMessagesService) === "function" && event_match_log_store__a || Object, typeof (event_match_log_store__b = typeof log_service_LogService !== "undefined" && log_service_LogService) === "function" && event_match_log_store__b || Object, typeof (event_match_log_store__c = typeof core["c" /* TranslateService */] !== "undefined" && core["c" /* TranslateService */]) === "function" && event_match_log_store__c || Object, typeof (event_match_log_store__d = typeof event_collision_service_EventCollisionService !== "undefined" && event_collision_service_EventCollisionService) === "function" && event_match_log_store__d || Object, typeof (event_match_log_store__e = typeof event_match_log_http_service_EventMatchLogHttpService !== "undefined" && event_match_log_http_service_EventMatchLogHttpService) === "function" && event_match_log_store__e || Object])
], event_match_log_store_EventMatchLogStore);

var event_match_log_store__a, event_match_log_store__b, event_match_log_store__c, event_match_log_store__d, event_match_log_store__e;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/event-match-log.store.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/event-match/event-match.component.ts
var event_match_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var event_match_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};










var event_match_component_EventMatchComponent = (function () {
    function EventMatchComponent(eventMatchLogStore, userLocalStorageService, formBuilder, authenticationStore, multiAgencyService) {
        this.eventMatchLogStore = eventMatchLogStore;
        this.userLocalStorageService = userLocalStorageService;
        this.formBuilder = formBuilder;
        this.authenticationStore = authenticationStore;
        this.multiAgencyService = multiAgencyService;
        this.pagesizeType = PagesizeType.EVENTS;
        this.defaultAgency$ = this.multiAgencyService.defaultAgency$;
        this.agencySubscription$ = new Subscription["Subscription"]();
    }
    EventMatchComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.populateSearchTextForm('');
        this.matchingSearchTextForm = this.searchTextForm;
        this.matchingPage = page_Page.empty();
        this.matchingPage.size = this.userLocalStorageService.getPagesize(PagesizeType.EVENT_MATCHING);
        this.agencySubscription$ = this.defaultAgency$.subscribe(function () {
            _this.eventMatchLogStore.getEventMatchLog(0, 5, 'date', '', '').subscribe(function (data) {
                _this.originalDataList = data.content;
                _this.filteredDataList = _this.originalDataList;
                var page = _this.matchingPage.number;
                var itemsPerPage = _this.matchingPage.size;
                _this.matchingPage.content = Object(immutable["List"])(_this.filteredDataList.slice(page * itemsPerPage, (page + 1) * itemsPerPage));
                _this.matchingPage.totalElements = _this.filteredDataList.length;
                _this.matchingPage.numberOfElements = _this.matchingPage.content.size;
            });
        });
    };
    EventMatchComponent.prototype.exportEventMatchLogExcel = function () {
        this.eventMatchLogStore.exportEventMatchLogExcel().subscribe();
    };
    EventMatchComponent.prototype.onRefreshMatchingList = function (pageNumber, itemsPerPage) {
        if ((pageNumber * itemsPerPage) >= this.filteredDataList.length) {
            pageNumber = Math.floor(this.filteredDataList.length / itemsPerPage);
        }
        this.matchingPage.content = Object(immutable["List"])(this.filteredDataList.slice(pageNumber * itemsPerPage, (pageNumber + 1) * itemsPerPage));
        this.matchingPage.number = pageNumber;
        this.matchingPage.size = itemsPerPage;
        this.matchingPage.totalElements = this.filteredDataList.length;
        this.matchingPage.numberOfElements = this.matchingPage.content.size;
    };
    EventMatchComponent.prototype.populateSearchTextForm = function (searchText) {
        if (!this.matchingSearchTextForm) {
            this.matchingSearchTextForm = this.formBuilder.group({
                'searchText': [searchText, [forms_es5["Validators"].required]]
            });
        }
        else {
            this.matchingSearchTextForm.patchValue({
                'searchText': searchText
            });
        }
    };
    Object.defineProperty(EventMatchComponent.prototype, "searchTextForm", {
        get: function () {
            return this.matchingSearchTextForm;
        },
        enumerable: true,
        configurable: true
    });
    EventMatchComponent.prototype.searchByText = function (models) {
        var _this = this;
        this.filteredDataList = [];
        this.originalDataList.forEach(function (item) {
            var property = '';
            if (item.propertyAddressLine1) {
                property = property + item.propertyAddressLine1 + ' ';
            }
            if (item.propertyAddressLine2) {
                property = property + item.propertyAddressLine2 + ' ';
            }
            if (item.propertyAddressLine3) {
                property = property + item.propertyAddressLine3 + ' ';
            }
            if (item.propertyState) {
                property = property + item.propertyState + ' ';
            }
            if (item.propertyZip) {
                property = property + item.propertyZip + ' ';
            }
            property = property.trim();
            if ((item.createdDate && item.createdDate.includes(models['searchText'])) ||
                (item.source && item.source.includes(models['searchText'])) ||
                (property && property.includes(models['searchText'])) ||
                (item.startDate && item.startDate.includes(models['searchText'])) ||
                (item.endDate && item.endDate.includes(models['searchText'])) ||
                (item['createdBy'] && item['createdBy'].includes(models['searchText'])) ||
                (item.description && item.description.includes(models['searchText']))) {
                _this.filteredDataList.push(item);
            }
        });
        this.matchingPage = page_Page.empty();
        this.matchingPage.size = this.userLocalStorageService.getPagesize(PagesizeType.EVENT_MATCHING);
        var page = this.matchingPage.number;
        var itemsPerPage = this.matchingPage.size;
        this.matchingPage.content = Object(immutable["List"])(this.filteredDataList.slice(page * itemsPerPage, (page + 1) * itemsPerPage));
        this.matchingPage.totalElements = this.filteredDataList.length;
        this.matchingPage.numberOfElements = this.matchingPage.content.size;
    };
    EventMatchComponent.prototype.isPropertyUser = function () {
        return this.authenticationStore.isPropertyUser();
    };
    EventMatchComponent.prototype.isAgencyUser = function () {
        return this.authenticationStore.isAgencyUser();
    };
    EventMatchComponent.prototype.isSupportUser = function () {
        return this.authenticationStore.isSupportUser();
    };
    return EventMatchComponent;
}());
event_match_component_EventMatchComponent = event_match_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-event-match',
        template: __webpack_require__("rF25"),
        styles: [__webpack_require__("auuo")]
    }),
    event_match_component___metadata("design:paramtypes", [typeof (event_match_component__a = typeof event_match_log_store_EventMatchLogStore !== "undefined" && event_match_log_store_EventMatchLogStore) === "function" && event_match_component__a || Object, typeof (event_match_component__b = typeof user_local_storage_service_UserLocalStorageService !== "undefined" && user_local_storage_service_UserLocalStorageService) === "function" && event_match_component__b || Object, typeof (event_match_component__c = typeof forms_es5["FormBuilder"] !== "undefined" && forms_es5["FormBuilder"]) === "function" && event_match_component__c || Object, typeof (event_match_component__d = typeof authentication_store_AuthenticationStore !== "undefined" && authentication_store_AuthenticationStore) === "function" && event_match_component__d || Object, typeof (event_match_component__e = typeof multi_agency_service_MultiAgencyService !== "undefined" && multi_agency_service_MultiAgencyService) === "function" && event_match_component__e || Object])
], event_match_component_EventMatchComponent);

var event_match_component__a, event_match_component__b, event_match_component__c, event_match_component__d, event_match_component__e;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/event-match.component.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/guards/vendor-overview-redirect-guard.ts
var vendor_overview_redirect_guard___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var vendor_overview_redirect_guard___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};




var VendorOverviewRedirectGuard = (function () {
    function VendorOverviewRedirectGuard(router, authStore, logService) {
        this.router = router;
        this.authStore = authStore;
        this.logService = logService;
    }
    VendorOverviewRedirectGuard.prototype.canActivate = function (route, state) {
        if (this.authStore.hasPermission('ViewOverview')) {
            if (this.isMultiVendor()) {
                return true;
            }
            else {
                return false;
            }
        }
        else {
            this.logService.debug('Redirecting to payment page since user has no permission to see the Overview page');
            var navigateCommands = route.parent.url.map(function (segment) { return segment.path; });
            navigateCommands.push('commission');
            this.router.navigate(navigateCommands);
            return false;
        }
    };
    VendorOverviewRedirectGuard.prototype.isMultiVendor = function () {
        return this.authStore.hasPermission('MultiVendor');
    };
    return VendorOverviewRedirectGuard;
}());
VendorOverviewRedirectGuard = vendor_overview_redirect_guard___decorate([
    Object(core_es5["Injectable"])(),
    vendor_overview_redirect_guard___metadata("design:paramtypes", [typeof (vendor_overview_redirect_guard__a = typeof router_es5["Router"] !== "undefined" && router_es5["Router"]) === "function" && vendor_overview_redirect_guard__a || Object, typeof (vendor_overview_redirect_guard__b = typeof authentication_store_AuthenticationStore !== "undefined" && authentication_store_AuthenticationStore) === "function" && vendor_overview_redirect_guard__b || Object, typeof (vendor_overview_redirect_guard__c = typeof log_service_LogService !== "undefined" && log_service_LogService) === "function" && vendor_overview_redirect_guard__c || Object])
], VendorOverviewRedirectGuard);

var vendor_overview_redirect_guard__a, vendor_overview_redirect_guard__b, vendor_overview_redirect_guard__c;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/vendor-overview-redirect-guard.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/service/mstr.http.service.ts
var mstr_http_service___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var mstr_http_service___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};






var mstr_http_service_MSTRHttpService = (function () {
    function MSTRHttpService(http, http2, environment, responseUtilService) {
        this.http = http;
        this.http2 = http2;
        this.environment = environment;
        this.responseUtilService = responseUtilService;
        this.mstrPostUrl = this.environment.baseUrl + '/api/mstr';
        this.mstrRedirectPostUrl = this.environment.baseUrl + '/api/mstr/redirect';
        this.mstrCallPostUrl = this.environment.baseUrl + '/api/mstr/call';
        this.mstrGetHtml = this.environment.baseUrl + '/api/mstr/getHtml';
    }
    Object.defineProperty(MSTRHttpService.prototype, "jsonOptions", {
        get: function () {
            var headers = new http_es5["Headers"]({ 'Content-Type': 'application/json' });
            var options = new http_es5["RequestOptions"]({ headers: headers });
            return options;
        },
        enumerable: true,
        configurable: true
    });
    MSTRHttpService.prototype.getLink = function () {
        var _this = this;
        return this.http.post("" + this.mstrPostUrl, this.jsonOptions)
            .map(function (response) { return response.json(); })
            .catch(function (response) { return _this.responseUtilService.handleError(response); }).share();
    };
    return MSTRHttpService;
}());
mstr_http_service_MSTRHttpService = mstr_http_service___decorate([
    Object(core_es5["Injectable"])(),
    mstr_http_service___metadata("design:paramtypes", [typeof (mstr_http_service__a = typeof AppAuthHttpService !== "undefined" && AppAuthHttpService) === "function" && mstr_http_service__a || Object, typeof (mstr_http_service__b = typeof common_http_es5["b" /* HttpClient */] !== "undefined" && common_http_es5["b" /* HttpClient */]) === "function" && mstr_http_service__b || Object, typeof (mstr_http_service__c = typeof EnvironmentConfiguration !== "undefined" && EnvironmentConfiguration) === "function" && mstr_http_service__c || Object, typeof (mstr_http_service__d = typeof response_util_service_ResponseUtilService !== "undefined" && response_util_service_ResponseUtilService) === "function" && mstr_http_service__d || Object])
], mstr_http_service_MSTRHttpService);

var mstr_http_service__a, mstr_http_service__b, mstr_http_service__c, mstr_http_service__d;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/mstr.http.service.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/service/invoice-history.http.service.ts
var invoice_history_http_service___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var invoice_history_http_service___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};





var invoice_history_http_service_InvoiceHistoryHttpService = (function () {
    function InvoiceHistoryHttpService(http, environment, responseUtilService) {
        this.http = http;
        this.environment = environment;
        this.responseUtilService = responseUtilService;
        this.invoiceUrl = this.environment.baseUrl + '/api/invoice-history';
        this.agencyUrl = this.invoiceUrl + '/auth/agency';
        this.agencyVendorUrl = this.invoiceUrl + '/auth/agency/vendor';
        this.propertyUrl = this.invoiceUrl + '/auth/property';
        this.enabledUrl = this.invoiceUrl + '/enabled';
    }
    InvoiceHistoryHttpService.prototype.getInvoiceHistoryAgencyAuth = function () {
        var _this = this;
        var headers = new http_es5["Headers"]({ 'Content-Type': 'application/json' });
        var options = new http_es5["RequestOptions"]({ headers: headers });
        return this.http.get("" + this.agencyUrl, options)
            .map(function (response) { return response.json(); })
            .catch(function (response) { return _this.responseUtilService.handleError(response); })
            .share();
    };
    InvoiceHistoryHttpService.prototype.getInvoiceHistoryPropertyAuth = function () {
        var _this = this;
        var headers = new http_es5["Headers"]({ 'Content-Type': 'application/json' });
        var options = new http_es5["RequestOptions"]({ headers: headers });
        return this.http.get("" + this.propertyUrl, options)
            .map(function (response) { return response.json(); })
            .catch(function (response) { return _this.responseUtilService.handleError(response); })
            .share();
    };
    InvoiceHistoryHttpService.prototype.getInvoiceHistoryEventAgencyAuth = function (eventId) {
        var _this = this;
        var headers = new http_es5["Headers"]({ 'Content-Type': 'application/json' });
        var options = new http_es5["RequestOptions"]({ headers: headers });
        return this.http.get(this.agencyUrl + "/" + eventId, options)
            .map(function (response) { return response.json(); })
            .catch(function (response) { return _this.responseUtilService.handleError(response); })
            .share();
    };
    InvoiceHistoryHttpService.prototype.getInvoiceHistoryEventAgencyVendorAuth = function (eventId, vendor) {
        var _this = this;
        var headers = new http_es5["Headers"]({ 'Content-Type': 'application/json' });
        var options = new http_es5["RequestOptions"]({ headers: headers });
        return this.http.post(this.agencyVendorUrl + "/" + eventId, JSON.stringify(vendor.toJS()), options)
            .map(function (response) { return response.json(); })
            .catch(function (response) { return _this.responseUtilService.handleError(response); })
            .share();
    };
    InvoiceHistoryHttpService.prototype.getInvoiceHistoryEventPropertyAuth = function (eventId) {
        var _this = this;
        var headers = new http_es5["Headers"]({ 'Content-Type': 'application/json' });
        var options = new http_es5["RequestOptions"]({ headers: headers });
        return this.http.get(this.propertyUrl + "/" + eventId, options)
            .map(function (response) { return response.json(); })
            .catch(function (response) { return _this.responseUtilService.handleError(response); })
            .share();
    };
    InvoiceHistoryHttpService.prototype.getInvoiceHistoryEnabled = function () {
        var _this = this;
        var headers = new http_es5["Headers"]({ 'Content-Type': 'application/json' });
        var options = new http_es5["RequestOptions"]({ headers: headers });
        return this.http.get("" + this.enabledUrl, options)
            .map(function (response) { return response.json(); })
            .catch(function (response) { return _this.responseUtilService.handleError(response); })
            .share();
    };
    return InvoiceHistoryHttpService;
}());
invoice_history_http_service_InvoiceHistoryHttpService = invoice_history_http_service___decorate([
    Object(core_es5["Injectable"])(),
    invoice_history_http_service___metadata("design:paramtypes", [typeof (invoice_history_http_service__a = typeof AppAuthHttpService !== "undefined" && AppAuthHttpService) === "function" && invoice_history_http_service__a || Object, typeof (invoice_history_http_service__b = typeof EnvironmentConfiguration !== "undefined" && EnvironmentConfiguration) === "function" && invoice_history_http_service__b || Object, typeof (invoice_history_http_service__c = typeof response_util_service_ResponseUtilService !== "undefined" && response_util_service_ResponseUtilService) === "function" && invoice_history_http_service__c || Object])
], invoice_history_http_service_InvoiceHistoryHttpService);

var invoice_history_http_service__a, invoice_history_http_service__b, invoice_history_http_service__c;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/invoice-history.http.service.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/service/invoice-history.store.ts
var invoice_history_store___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var invoice_history_store___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};







var invoice_history_store_InvoiceHistoryStore = (function () {
    function InvoiceHistoryStore(flashMessagesService, logService, translateService, invoiceHistoryHttpService) {
        this.flashMessagesService = flashMessagesService;
        this.logService = logService;
        this.translateService = translateService;
        this.invoiceHistoryHttpService = invoiceHistoryHttpService;
        this.invoiceEnabled = new BehaviorSubject["BehaviorSubject"](null);
        this.init();
    }
    InvoiceHistoryStore.prototype.init = function () {
    };
    InvoiceHistoryStore.prototype.getInvoiceHistoryAgencyAuth = function () {
        var _this = this;
        return this.invoiceHistoryHttpService.getInvoiceHistoryAgencyAuth().catch(function (error) {
            _this.flashMessagesService.error(_this.translateService.instant('MESSAGES.ERROR.GET_INVOICE_HISTORY_AUTH'));
            _this.logService.error("Error getting Invoice History Agency: " + error);
            return Observable["Observable"].throw(error);
        }).map(function (auth) {
            return auth.auth;
        });
    };
    InvoiceHistoryStore.prototype.getInvoiceHistoryPropertyAuth = function () {
        var _this = this;
        return this.invoiceHistoryHttpService.getInvoiceHistoryPropertyAuth().catch(function (error) {
            _this.flashMessagesService.error(_this.translateService.instant('MESSAGES.ERROR.GET_INVOICE_HISTORY_AUTH'));
            _this.logService.error("Error getting Invoice History Property: " + error);
            return Observable["Observable"].throw(error);
        }).map(function (auth) {
            return auth.auth;
        });
    };
    InvoiceHistoryStore.prototype.getInvoiceHistoryEventAgencyAuth = function (eventId) {
        var _this = this;
        return this.invoiceHistoryHttpService.getInvoiceHistoryEventAgencyAuth(eventId).catch(function (error) {
            _this.flashMessagesService.error(_this.translateService.instant('MESSAGES.ERROR.GET_INVOICE_HISTORY_AUTH'));
            _this.logService.error("Error getting Invoice History Event Agency: " + error);
            return Observable["Observable"].throw(error);
        }).map(function (auth) {
            return auth.auth;
        });
    };
    InvoiceHistoryStore.prototype.getInvoiceHistoryEventAgencyVendorAuth = function (eventId, vendor) {
        var _this = this;
        return this.invoiceHistoryHttpService.getInvoiceHistoryEventAgencyVendorAuth(eventId, vendor).catch(function (error) {
            _this.flashMessagesService.error(_this.translateService.instant('MESSAGES.ERROR.GET_INVOICE_HISTORY_AUTH'));
            _this.logService.error("Error getting Invoice History Event Agency Vendor: " + error);
            return Observable["Observable"].throw(error);
        }).map(function (auth) {
            return auth.auth;
        });
    };
    InvoiceHistoryStore.prototype.getInvoiceHistoryEventPropertyAuth = function (eventId) {
        var _this = this;
        return this.invoiceHistoryHttpService.getInvoiceHistoryEventPropertyAuth(eventId).catch(function (error) {
            _this.flashMessagesService.error(_this.translateService.instant('MESSAGES.ERROR.GET_INVOICE_HISTORY_AUTH'));
            _this.logService.error("Error getting Invoice History Event Property: " + error);
            return Observable["Observable"].throw(error);
        }).map(function (auth) {
            return auth.auth;
        });
    };
    InvoiceHistoryStore.prototype.loadInvoiceHistoryEnabled = function () {
        var _this = this;
        return this.invoiceHistoryHttpService.getInvoiceHistoryEnabled().catch(function (error) {
            _this.flashMessagesService.error(_this.translateService.instant('MESSAGES.ERROR.GET_INVOICE_HISTORY_ENABLED'));
            _this.logService.error("Error getting Invoice History Enabled: " + error);
            return Observable["Observable"].throw(error);
        }).map(function (enabled) {
            _this.invoiceEnabled.next(enabled);
            return enabled;
        });
    };
    InvoiceHistoryStore.prototype.getInvoiceHistoryEnabled = function () {
        if (this.invoiceEnabled.getValue()) {
            return this.invoiceEnabled.asObservable();
        }
        else {
            return this.loadInvoiceHistoryEnabled();
        }
    };
    return InvoiceHistoryStore;
}());
invoice_history_store_InvoiceHistoryStore = invoice_history_store___decorate([
    Object(core_es5["Injectable"])(),
    invoice_history_store___metadata("design:paramtypes", [typeof (invoice_history_store__a = typeof flash_messages_service_FlashMessagesService !== "undefined" && flash_messages_service_FlashMessagesService) === "function" && invoice_history_store__a || Object, typeof (invoice_history_store__b = typeof log_service_LogService !== "undefined" && log_service_LogService) === "function" && invoice_history_store__b || Object, typeof (invoice_history_store__c = typeof core["c" /* TranslateService */] !== "undefined" && core["c" /* TranslateService */]) === "function" && invoice_history_store__c || Object, typeof (invoice_history_store__d = typeof invoice_history_http_service_InvoiceHistoryHttpService !== "undefined" && invoice_history_http_service_InvoiceHistoryHttpService) === "function" && invoice_history_store__d || Object])
], invoice_history_store_InvoiceHistoryStore);

var invoice_history_store__a, invoice_history_store__b, invoice_history_store__c, invoice_history_store__d;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/invoice-history.store.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/menus/app-menu/app-menu.component.ts
var app_menu_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var app_menu_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
















var app_menu_component_AppMenuComponent = (function () {
    function AppMenuComponent(menuStore, router, eventSearchParametersStore, completedUnpaidStore, missingAgencyStore, predefinedSearchService, matchingPropertyStore, matchingAgencyStore, mstrHttpService, invoiceHistoryStore, authenticationStore) {
        this.menuStore = menuStore;
        this.router = router;
        this.eventSearchParametersStore = eventSearchParametersStore;
        this.completedUnpaidStore = completedUnpaidStore;
        this.missingAgencyStore = missingAgencyStore;
        this.predefinedSearchService = predefinedSearchService;
        this.matchingPropertyStore = matchingPropertyStore;
        this.matchingAgencyStore = matchingAgencyStore;
        this.mstrHttpService = mstrHttpService;
        this.invoiceHistoryStore = invoiceHistoryStore;
        this.authenticationStore = authenticationStore;
        this.showInvoiceHistory = false;
        this._destroyed$ = new Subject["Subject"]();
    }
    AppMenuComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.isNavCollapsed = this.menuStore.isNavCollapsed;
        if (!this.authenticationStore.isSupportUser() &&
            // ME-17394 - hide Invoice History for permission ViewOnlyUserEvents (Agency Planner)
            !this.authenticationStore.hasPermission(['ViewOnlyUserEvents'])) {
            this.invoiceHistoryStore.getInvoiceHistoryEnabled().pipe(Object(operators["takeUntil"])(this._destroyed$)).subscribe(function (enabled) {
                _this.showInvoiceHistory = enabled;
            });
        }
    };
    AppMenuComponent.prototype.ngOnDestroy = function () {
        this._destroyed$.next();
        this._destroyed$.complete();
    };
    AppMenuComponent.prototype.toggleNavCollapsed = function () {
        this.isNavCollapsed = this.menuStore.toggleIsNavCollapsed();
    };
    /**
     * Matches the '/events' route
     * Matches the '/events?...' route
     * Does NOT match the '/events/add' route
     * @return {boolean}
     */
    AppMenuComponent.prototype.isOnSearchEvents = function () {
        return this.isUrlOnPath('/events') || this.isUrlOnPath('/events/financial');
    };
    AppMenuComponent.prototype.isOnDashboard = function () {
        return this.isUrlOnPath('/dashboard');
    };
    AppMenuComponent.prototype.isUrlOnPath = function (path) {
        var url = this.router.url;
        var indexOfQuestionMark = url.indexOf('?');
        // if there is a question mark in the url,
        //   then get the url up to the question mark
        if (indexOfQuestionMark >= 0) {
            url = url.substr(0, indexOfQuestionMark);
        }
        // check to see if on the events route
        return !!(url && url === (path));
    };
    AppMenuComponent.prototype.navigateToSearch = function () {
        this.eventSearchParametersStore.updateUrl(true);
    };
    Object.defineProperty(AppMenuComponent.prototype, "completedAndUnpaidTotal", {
        get: function () {
            return DashboardUtils.totalAsStringClampedTo99(this.completedUnpaidStore.completedAndUnpaidTotal);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppMenuComponent.prototype, "missingAgencyTotal", {
        get: function () {
            return DashboardUtils.totalAsStringClampedTo99(this.missingAgencyStore.missingAgencyTotal);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppMenuComponent.prototype, "propertyMatchesTotal", {
        get: function () {
            return DashboardUtils.totalAsStringClampedTo99(this.matchingPropertyStore.totalPropertyCount);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppMenuComponent.prototype, "agencyMatchesTotal", {
        get: function () {
            return DashboardUtils.totalAsStringClampedTo99(this.matchingAgencyStore.count);
        },
        enumerable: true,
        configurable: true
    });
    AppMenuComponent.prototype.showCompletedAndUnpaidTotals = function () {
        return Observable["Observable"].combineLatest(this.completedUnpaidStore.isLoading(), this.completedUnpaidStore.isStale()).map(function (values) {
            var loading = values[0], stale = values[1];
            return !Boolean(loading || stale);
        });
    };
    AppMenuComponent.prototype.showMissingAgencyTotals = function () {
        return Observable["Observable"].combineLatest(this.missingAgencyStore.isLoading(), this.missingAgencyStore.isStale()).map(function (values) {
            var loading = values[0], stale = values[1];
            return !Boolean(loading || stale);
        });
    };
    AppMenuComponent.prototype.missingAgencyPredefinedSearch = function () {
        this.predefinedSearchService.missingAgencySearch();
    };
    AppMenuComponent.prototype.completedAndUnpaidPredefinedSearch = function () {
        this.predefinedSearchService.completedAndUnpaid();
    };
    AppMenuComponent.prototype.callMicrostrategy = function () {
        this.mstrHttpService.getLink().subscribe(function (res) {
            window.open(res.url, '_blank');
        });
    };
    return AppMenuComponent;
}());
app_menu_component___decorate([
    Object(core_es5["HostBinding"])('class.left-nav'),
    app_menu_component___metadata("design:type", Object)
], app_menu_component_AppMenuComponent.prototype, "true", void 0);
app_menu_component___decorate([
    Object(core_es5["HostBinding"])('class.nav-collapsed'),
    app_menu_component___metadata("design:type", Object)
], app_menu_component_AppMenuComponent.prototype, "isNavCollapsed", void 0);
app_menu_component_AppMenuComponent = app_menu_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-app-menu',
        template: __webpack_require__("EqCs")
    }),
    app_menu_component___metadata("design:paramtypes", [typeof (app_menu_component__a = typeof menu_store_MenuStore !== "undefined" && menu_store_MenuStore) === "function" && app_menu_component__a || Object, typeof (app_menu_component__b = typeof router_es5["Router"] !== "undefined" && router_es5["Router"]) === "function" && app_menu_component__b || Object, typeof (app_menu_component__c = typeof event_search_parameters_store_EventSearchParametersStore !== "undefined" && event_search_parameters_store_EventSearchParametersStore) === "function" && app_menu_component__c || Object, typeof (app_menu_component__d = typeof completed_unpaid_dashboard_store_CompletedUnpaidDashboardStore !== "undefined" && completed_unpaid_dashboard_store_CompletedUnpaidDashboardStore) === "function" && app_menu_component__d || Object, typeof (app_menu_component__e = typeof missing_agency_dashboard_store_MissingAgencyDashboardStore !== "undefined" && missing_agency_dashboard_store_MissingAgencyDashboardStore) === "function" && app_menu_component__e || Object, typeof (app_menu_component__f = typeof predefined_search_service_PredefinedSearchService !== "undefined" && predefined_search_service_PredefinedSearchService) === "function" && app_menu_component__f || Object, typeof (app_menu_component__g = typeof matching_property_store_MatchingPropertyStore !== "undefined" && matching_property_store_MatchingPropertyStore) === "function" && app_menu_component__g || Object, typeof (app_menu_component__h = typeof matching_agency_store_MatchingAgencyStore !== "undefined" && matching_agency_store_MatchingAgencyStore) === "function" && app_menu_component__h || Object, typeof (app_menu_component__j = typeof mstr_http_service_MSTRHttpService !== "undefined" && mstr_http_service_MSTRHttpService) === "function" && app_menu_component__j || Object, typeof (app_menu_component__k = typeof invoice_history_store_InvoiceHistoryStore !== "undefined" && invoice_history_store_InvoiceHistoryStore) === "function" && app_menu_component__k || Object, typeof (app_menu_component__l = typeof authentication_store_AuthenticationStore !== "undefined" && authentication_store_AuthenticationStore) === "function" && app_menu_component__l || Object])
], app_menu_component_AppMenuComponent);

var app_menu_component__a, app_menu_component__b, app_menu_component__c, app_menu_component__d, app_menu_component__e, app_menu_component__f, app_menu_component__g, app_menu_component__h, app_menu_component__j, app_menu_component__k, app_menu_component__l;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app-menu.component.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/menus/event-menu/event-menu.component.ts
var event_menu_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var event_menu_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};









var event_menu_component_EventMenuComponent = (function () {
    function EventMenuComponent(eventStore, menuStore, eventSearchParameterStore, authenticationStore, cdRef, invoiceHistoryStore) {
        this.eventStore = eventStore;
        this.menuStore = menuStore;
        this.eventSearchParameterStore = eventSearchParameterStore;
        this.authenticationStore = authenticationStore;
        this.cdRef = cdRef;
        this.invoiceHistoryStore = invoiceHistoryStore;
        this.eventTitle = 'COMMON.NAV.EVENT_INFORMATION';
        this.includeSubNav = true;
        this.showInvoiceHistory = false;
        this._destroyed$ = new Subject["Subject"]();
        this._links$ = new BehaviorSubject["BehaviorSubject"](undefined);
        this.links$ = this._links$.asObservable();
    }
    EventMenuComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.menuStore.isReadOnly.pipe(Object(operators["takeUntil"])(this._destroyed$), Object(operators["tap"])(function (isReadOnly) {
            _this.includeSubNav = isReadOnly;
            _this.eventTitle = isReadOnly ? 'COMMON.NAV.EVENT_INFORMATION' : 'COMMON.NAV.EDIT_EVENT';
            _this.cdRef.detectChanges();
        })).subscribe();
        this.invoiceHistoryStore.getInvoiceHistoryEnabled().pipe(Object(operators["takeUntil"])(this._destroyed$)).subscribe(function (enabled) {
            _this.showInvoiceHistory = enabled;
        });
        this.eventStore.selectedEvent.pipe(Object(operators["takeUntil"])(this._destroyed$), Object(operators["tap"])(function (onyxEvent) {
            _this._links$.next(_this.getLinks(onyxEvent));
        })).subscribe();
    };
    EventMenuComponent.prototype.ngOnDestroy = function () {
        this._destroyed$.next();
        this._destroyed$.complete();
    };
    EventMenuComponent.prototype.navigateToSearch = function () {
        this.eventSearchParameterStore.updateUrl();
    };
    EventMenuComponent.prototype.getLinks = function (onyxEvent) {
        var links = undefined;
        if (onyxEvent) {
            var eventLink = void 0;
            if (this.authenticationStore.isMultiVendor()) {
                eventLink = '' + onyxEvent.eventId;
            }
            else if (onyxEvent.eventProperty) {
                eventLink = onyxEvent.eventId + '/' + onyxEvent.eventProperty.eventPartyId;
            }
            if (eventLink) {
                links = {
                    overview: '/event/' + eventLink + '/overview',
                    summary: '/event/' + eventLink + '/summary',
                    rsvps: '/event/' + eventLink + '/rsvp',
                    transientReservations: '/event/' + eventLink + '/transient-reservations',
                    commission: '/event/' + eventLink + '/commission',
                    invoiceHistory: '/event/' + eventLink + '/invoice-history'
                };
                if (onyxEvent.eventProperty && onyxEvent.eventProperty.subscriber) {
                    links.reservations = '/event/' + eventLink + '/reservations';
                }
            }
        }
        return links;
    };
    return EventMenuComponent;
}());
event_menu_component_EventMenuComponent = event_menu_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-event-menu',
        template: __webpack_require__("tzTa")
    }),
    event_menu_component___metadata("design:paramtypes", [typeof (event_menu_component__a = typeof event_store_EventStore !== "undefined" && event_store_EventStore) === "function" && event_menu_component__a || Object, typeof (event_menu_component__b = typeof menu_store_MenuStore !== "undefined" && menu_store_MenuStore) === "function" && event_menu_component__b || Object, typeof (event_menu_component__c = typeof event_search_parameters_store_EventSearchParametersStore !== "undefined" && event_search_parameters_store_EventSearchParametersStore) === "function" && event_menu_component__c || Object, typeof (event_menu_component__d = typeof authentication_store_AuthenticationStore !== "undefined" && authentication_store_AuthenticationStore) === "function" && event_menu_component__d || Object, typeof (event_menu_component__e = typeof core_es5["ChangeDetectorRef"] !== "undefined" && core_es5["ChangeDetectorRef"]) === "function" && event_menu_component__e || Object, typeof (event_menu_component__f = typeof invoice_history_store_InvoiceHistoryStore !== "undefined" && invoice_history_store_InvoiceHistoryStore) === "function" && event_menu_component__f || Object])
], event_menu_component_EventMenuComponent);

var event_menu_component__a, event_menu_component__b, event_menu_component__c, event_menu_component__d, event_menu_component__e, event_menu_component__f;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/event-menu.component.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/guards/can-activate-via-auth-guard.ts
var can_activate_via_auth_guard___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var can_activate_via_auth_guard___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};





var CanActivateViaAuthGuard = (function () {
    function CanActivateViaAuthGuard(router, authService, logService, environment) {
        this.router = router;
        this.authService = authService;
        this.logService = logService;
        this.environment = environment;
    }
    CanActivateViaAuthGuard.prototype.canActivate = function () {
        var _this = this;
        return this.authService.isLoggedIn().map(function (isLoggedIn) {
            if (!isLoggedIn) {
                _this.router.navigate([_this.environment.logout], { queryParams: { 'redirect': true } });
            }
            return isLoggedIn;
        });
    };
    return CanActivateViaAuthGuard;
}());
CanActivateViaAuthGuard = can_activate_via_auth_guard___decorate([
    Object(core_es5["Injectable"])(),
    can_activate_via_auth_guard___metadata("design:paramtypes", [typeof (can_activate_via_auth_guard__a = typeof router_es5["Router"] !== "undefined" && router_es5["Router"]) === "function" && can_activate_via_auth_guard__a || Object, typeof (can_activate_via_auth_guard__b = typeof authentication_store_AuthenticationStore !== "undefined" && authentication_store_AuthenticationStore) === "function" && can_activate_via_auth_guard__b || Object, typeof (can_activate_via_auth_guard__c = typeof log_service_LogService !== "undefined" && log_service_LogService) === "function" && can_activate_via_auth_guard__c || Object, typeof (can_activate_via_auth_guard__d = typeof EnvironmentConfiguration !== "undefined" && EnvironmentConfiguration) === "function" && can_activate_via_auth_guard__d || Object])
], CanActivateViaAuthGuard);

var can_activate_via_auth_guard__a, can_activate_via_auth_guard__b, can_activate_via_auth_guard__c, can_activate_via_auth_guard__d;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/can-activate-via-auth-guard.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/guards/dashboard-redirect-guard.ts
var dashboard_redirect_guard___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var dashboard_redirect_guard___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};




var DashboardRedirectGuard = (function () {
    function DashboardRedirectGuard(router, authStore, logService) {
        this.router = router;
        this.authStore = authStore;
        this.logService = logService;
    }
    DashboardRedirectGuard.prototype.canActivate = function (route, state) {
        var gpWindow = window;
        if (this.authStore.hasPermission('ViewDashboard')) {
            if (gpWindow.configGroupPay && gpWindow.configGroupPay.showAgencyDashboard && this.authStore.isAgencyUser()) {
                this.router.navigate(['/dashboard-agency']);
                return false;
            }
            return true;
        }
        else {
            this.logService.debug('Redirecting to /events since user has no permission to see Dashboard');
            this.router.navigate(['/events']);
            return false;
        }
    };
    return DashboardRedirectGuard;
}());
DashboardRedirectGuard = dashboard_redirect_guard___decorate([
    Object(core_es5["Injectable"])(),
    dashboard_redirect_guard___metadata("design:paramtypes", [typeof (dashboard_redirect_guard__a = typeof router_es5["Router"] !== "undefined" && router_es5["Router"]) === "function" && dashboard_redirect_guard__a || Object, typeof (dashboard_redirect_guard__b = typeof authentication_store_AuthenticationStore !== "undefined" && authentication_store_AuthenticationStore) === "function" && dashboard_redirect_guard__b || Object, typeof (dashboard_redirect_guard__c = typeof log_service_LogService !== "undefined" && log_service_LogService) === "function" && dashboard_redirect_guard__c || Object])
], DashboardRedirectGuard);

var dashboard_redirect_guard__a, dashboard_redirect_guard__b, dashboard_redirect_guard__c;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/dashboard-redirect-guard.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/guards/final-payment-authorized.guard.ts
var final_payment_authorized_guard___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var final_payment_authorized_guard___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};







var final_payment_authorized_guard_FinalPaymentAuthorizedGuard = (function () {
    function FinalPaymentAuthorizedGuard(paymentStore, flashMessagesService, authenticationStore, eventStore) {
        this.paymentStore = paymentStore;
        this.flashMessagesService = flashMessagesService;
        this.authenticationStore = authenticationStore;
        this.eventStore = eventStore;
    }
    FinalPaymentAuthorizedGuard.prototype.canActivate = function (next, state) {
        var _this = this;
        var activate = true;
        if (!this.isMultiVendor()) {
            var onyxEvent_1 = new OnyxEvent();
            this.eventStore.selectedEvent.subscribe(function (value) {
                onyxEvent_1 = new OnyxEvent(value);
            });
            this.paymentStore.getVendorFinalPayment(onyxEvent_1.eventProperty.eventPartyId).take(1).subscribe(function (lastFinalPayment) {
                if (Boolean(lastFinalPayment && lastFinalPayment.eventPaymentId
                    && !_this.paymentStore.isPaymentRequestedOrRequestResent(lastFinalPayment))
                    && !_this.paymentStore.isPaymentRejected(lastFinalPayment)
                    && lastFinalPayment.status !== PaymentStatus.REJECTED_WF_APPROVAL) {
                    _this.flashMessagesService.error('MESSAGES.ERROR.UNABLE_TO_NAVIGATE', 'Cannot edit an event with a final payment already authorized');
                    activate = false;
                }
            });
        }
        return activate;
    };
    FinalPaymentAuthorizedGuard.prototype.isMultiVendor = function () {
        return this.authenticationStore.hasPermission('MultiVendor');
    };
    return FinalPaymentAuthorizedGuard;
}());
final_payment_authorized_guard_FinalPaymentAuthorizedGuard = final_payment_authorized_guard___decorate([
    Object(core_es5["Injectable"])(),
    final_payment_authorized_guard___metadata("design:paramtypes", [typeof (final_payment_authorized_guard__a = typeof payment_store_PaymentStore !== "undefined" && payment_store_PaymentStore) === "function" && final_payment_authorized_guard__a || Object, typeof (final_payment_authorized_guard__b = typeof flash_messages_service_FlashMessagesService !== "undefined" && flash_messages_service_FlashMessagesService) === "function" && final_payment_authorized_guard__b || Object, typeof (final_payment_authorized_guard__c = typeof authentication_store_AuthenticationStore !== "undefined" && authentication_store_AuthenticationStore) === "function" && final_payment_authorized_guard__c || Object, typeof (final_payment_authorized_guard__d = typeof event_store_EventStore !== "undefined" && event_store_EventStore) === "function" && final_payment_authorized_guard__d || Object])
], final_payment_authorized_guard_FinalPaymentAuthorizedGuard);

var final_payment_authorized_guard__a, final_payment_authorized_guard__b, final_payment_authorized_guard__c, final_payment_authorized_guard__d;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/final-payment-authorized.guard.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/guards/overview-redirect-guard.ts
var overview_redirect_guard___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var overview_redirect_guard___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};




var OverviewRedirectGuard = (function () {
    function OverviewRedirectGuard(router, authStore, logService) {
        this.router = router;
        this.authStore = authStore;
        this.logService = logService;
    }
    OverviewRedirectGuard.prototype.canActivate = function (route, state) {
        if (this.authStore.hasPermission('ViewOverview')) {
            if (this.isMultiVendor()) {
                return false;
            }
            else {
                return true;
            }
        }
        else {
            this.logService.debug('Redirecting to payment page since user has no permission to see the Overview page');
            var navigateCommands = route.parent.url.map(function (segment) { return segment.path; });
            navigateCommands.push('commission');
            this.router.navigate(navigateCommands);
            return false;
        }
    };
    OverviewRedirectGuard.prototype.isMultiVendor = function () {
        return this.authStore.hasPermission('MultiVendor');
    };
    return OverviewRedirectGuard;
}());
OverviewRedirectGuard = overview_redirect_guard___decorate([
    Object(core_es5["Injectable"])(),
    overview_redirect_guard___metadata("design:paramtypes", [typeof (overview_redirect_guard__a = typeof router_es5["Router"] !== "undefined" && router_es5["Router"]) === "function" && overview_redirect_guard__a || Object, typeof (overview_redirect_guard__b = typeof authentication_store_AuthenticationStore !== "undefined" && authentication_store_AuthenticationStore) === "function" && overview_redirect_guard__b || Object, typeof (overview_redirect_guard__c = typeof log_service_LogService !== "undefined" && log_service_LogService) === "function" && overview_redirect_guard__c || Object])
], OverviewRedirectGuard);

var overview_redirect_guard__a, overview_redirect_guard__b, overview_redirect_guard__c;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/overview-redirect-guard.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/guards/permission-guard.ts
var permission_guard___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var permission_guard___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};



var PermissionGuard = (function () {
    function PermissionGuard(authStore, flashMessagesService) {
        this.authStore = authStore;
        this.flashMessagesService = flashMessagesService;
    }
    PermissionGuard.prototype.canActivate = function (route, state) {
        if (route.data && route.data['allowedPermissions']) {
            return this.authStore.hasPermission(route.data['allowedPermissions']);
        }
        else {
            this.flashMessagesService.error('MESSAGES.ERROR.UNABLE_TO_NAVIGATE', "The route [" + route.toString() + "] was not given data specifying allowed permissions");
            return false;
        }
    };
    return PermissionGuard;
}());
PermissionGuard = permission_guard___decorate([
    Object(core_es5["Injectable"])(),
    permission_guard___metadata("design:paramtypes", [typeof (permission_guard__a = typeof authentication_store_AuthenticationStore !== "undefined" && authentication_store_AuthenticationStore) === "function" && permission_guard__a || Object, typeof (permission_guard__b = typeof flash_messages_service_FlashMessagesService !== "undefined" && flash_messages_service_FlashMessagesService) === "function" && permission_guard__b || Object])
], PermissionGuard);

var permission_guard__a, permission_guard__b;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/permission-guard.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/utils/route-utils.ts

var route_utils_RouteUtils = (function () {
    function RouteUtils() {
    }
    RouteUtils.getLastUrlSegment = function (route) {
        return route.url.map(function (segments) {
            return pioneer_utils_PioneerUtils.getLastElement(segments);
        });
    };
    RouteUtils.getLastUrlSegmentSnapshot = function (route) {
        var segments = route.snapshot.url;
        return pioneer_utils_PioneerUtils.getLastElement(segments);
    };
    return RouteUtils;
}());

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/route-utils.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/event/event.component.ts
var event_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var event_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};















































var event_component_EventComponent = (function () {
    function EventComponent(router, eventStore, formBuilder, menuStore, flashMessagesService, translateService, route, eventSearchParametersStore, paymentStore, authenticationStore, userLocalStorageService, multiAgencyService, matchingPropertyStore, eventMatchLogStore, rsvpStore, reservationStore, eventValidationService, agencyLookupStore, guidGeneratorStore, matchingAgencyService, logService) {
        this.router = router;
        this.eventStore = eventStore;
        this.formBuilder = formBuilder;
        this.menuStore = menuStore;
        this.flashMessagesService = flashMessagesService;
        this.translateService = translateService;
        this.route = route;
        this.eventSearchParametersStore = eventSearchParametersStore;
        this.paymentStore = paymentStore;
        this.authenticationStore = authenticationStore;
        this.userLocalStorageService = userLocalStorageService;
        this.multiAgencyService = multiAgencyService;
        this.matchingPropertyStore = matchingPropertyStore;
        this.eventMatchLogStore = eventMatchLogStore;
        this.rsvpStore = rsvpStore;
        this.reservationStore = reservationStore;
        this.eventValidationService = eventValidationService;
        this.agencyLookupStore = agencyLookupStore;
        this.guidGeneratorStore = guidGeneratorStore;
        this.matchingAgencyService = matchingAgencyService;
        this.logService = logService;
        this.isReadOnly = true;
        this.clientContactEditable = true;
        this.eventMatches = [];
        this.eventMatchInfo = [];
        this.eventCollisionMatches = new Map();
        this.focusEventNameSubject = new Subject["Subject"]();
        this.eventCollisionModalConfig = new EventCollisionModalConfig();
        this.confirmationModalConfig = new ConfirmationModalConfig();
        this.removedVendors = [];
        this.isSelectedAgency = false;
    }
    Object.defineProperty(EventComponent.prototype, "propertyUserEventParty", {
        get: function () {
            return this.authenticationStore.isPropertyUser() ? this.onyxEvent.eventProperty : undefined;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EventComponent.prototype, "isDirty", {
        get: function () {
            if (!this.eventForm) {
                return false;
            }
            if (this.eventForm.disabled) {
                return false;
            }
            if (this.eventForm.dirty) {
                return true;
            }
            if (EventUtils.serializeEvent(this.onyxEvent) !== this.savedEventSerialized) {
                return true;
            }
            return this.isSelectedAgency;
        },
        enumerable: true,
        configurable: true
    });
    EventComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.menuStore.setPageHeader('EVENT.EVENT_INFO_TITLE', false);
        this.menuStore.setIsReadOnly(true);
        this.authenticationStore.user.subscribe(function (user) {
            _this.user = user;
        });
        this.onyxEvent = new OnyxEvent();
        this.eventStore.selectedEvent.subscribe(function (value) {
            _this.onyxEvent = new OnyxEvent(value);
            if (!_this.savedEventSerialized) {
                _this.savedEventSerialized = EventUtils.serializeEvent(_this.onyxEvent);
            }
            if (_this.authenticationStore.isSupportUser() && _this.onyxEvent.eventId) {
                _this.eventMatchLogStore.getMatchesByEvent(_this.onyxEvent.eventId).subscribe(function (data) {
                    _this.eventMatches = data;
                });
            }
            else {
                _this.eventMatches = [];
            }
        });
        this.menuStore.isReadOnly.subscribe(function (isReadOnly) {
            _this.isReadOnly = isReadOnly;
        });
        if (EventUtils.getEventName(this.onyxEvent, this.authenticationStore.isAgencyUser())) {
            this.menuStore.setPageHeader(EventUtils.getEventName(this.onyxEvent, this.authenticationStore.isAgencyUser()), this.onyxEvent.eventProperty.subscriber);
        }
        if (!Object(util_util["isNullOrUndefined"])(this.onyxEvent.eventProperty)
            && !Object(util_util["isNullOrUndefined"])(this.onyxEvent.eventProperty.contact)
            && !Object(util_util["isNullOrUndefined"])(this.onyxEvent.eventProperty.contact.email)) {
            this.propertyEmail = this.onyxEvent.eventProperty.contact.email;
        }
        if (!Object(util_util["isNullOrUndefined"])(this.onyxEvent.eventAgency)
            && !Object(util_util["isNullOrUndefined"])(this.onyxEvent.eventAgency.contact)
            && !Object(util_util["isNullOrUndefined"])(this.onyxEvent.eventAgency.contact.email)) {
            this.agencyEmail = this.onyxEvent.eventAgency.contact.email;
        }
        this.eventForm = this.formBuilder.group({
            'event': this.formBuilder.group({
                'eventAgency': this.formBuilder.group({}),
                'eventClient': this.formBuilder.group({}),
                'eventProperty': this.formBuilder.group({}),
                'eventVendors': this.formBuilder.array([])
            })
        });
        // toggle page to editable if the URL ends with "edit" (it will default to read only)
        // otherwise, check if we need to show a warning flash message when in view modeFD
        route_utils_RouteUtils.getLastUrlSegment(this.route)
            .subscribe(function (lastSegment) {
            if (lastSegment && lastSegment.path === 'edit') {
                _this.togglePageToReadOnly(false);
            }
        });
        if (!this.onyxEvent.eventId || Object(util_util["isNullOrUndefined"])(this.onyxEvent.eventProperty.eventPartyId)) {
            this.hasFinalPayment = false;
            this.isRequestedOrRequestResentOrRejected = false;
            this.isEventLockdown = false;
        }
        else {
            this.paymentStore.getLatestVendorFinalPayments().take(1).subscribe(function (lastFinalPayment) {
                _this.hasFinalPayment = Boolean(_this.hasFinalPayment || (lastFinalPayment && lastFinalPayment.length > 0));
                if (_this.hasFinalPayment) {
                    _this.paymentStatus = lastFinalPayment[0].status;
                }
            });
            this.paymentStore.isLastVendorPaymentRequestedOrRequestResentOrRequestRejected(this.onyxEvent.eventProperty.eventPartyId)
                .subscribe(function (isReqOrReqResentOrRej) {
                _this.isRequestedOrRequestResentOrRejected = isReqOrReqResentOrRej;
            });
            this.paymentStore.isEventPropertyLockdown(this.onyxEvent.eventProperty.eventPartyId).subscribe(function (isEventLockdown) {
                if (!isEventLockdown) {
                    _this.isEventLockdown = false;
                }
                else {
                    _this.isEventLockdown = isEventLockdown;
                }
            });
        }
        this.authenticationStore.clientContactEditable$.subscribe(function (value) {
            _this.clientContactEditable = value;
        });
        this.hasEventRsvpSubscribe();
        this.hasEventReservationSubscribe();
        this.hasEventPaymentSubscribe();
        this.hasSubscriberAgencySubscribe();
        this.canEditContractSummary$ = this.eventValidationService.canEditContractSummary();
        this.canEditAgencyContact$ = this.eventValidationService.canEditAgencyContact();
        this.canEditClientContact$ = this.eventValidationService.canEditClientContact();
        this.guidGeneratorStore.generateGuid('EV').subscribe(function (value) {
            _this.temporaryGuid = value;
        });
        this.eventMatchInfo = [];
        this.eventCollisionMatches = new Map();
    };
    EventComponent.prototype.onSaveBtn = function (model) {
        var _this = this;
        var runMatchingAgency = Boolean(this.authenticationStore.isPropertyUser()
            && model.eventAgency
            && model.eventAgency.code
            && model.eventProperty.chain
            && model.eventAgency.newTravelAgency);
        // Matching Agency result may update the current model
        var finalModel$ = this.matchingAgencyService.matchingAgencyProcess(model, runMatchingAgency);
        // Once the final model is resolved, event collision process is invoked.
        var eventCollision$ = finalModel$.pipe(Object(operators["map"])(function (finalModel) {
            var info = {
                event: finalModel.event,
                eventProperties: _this.authenticationStore.isPropertyUser() ? [finalModel.eventProperty] : _this.getPropertiesFromModel(finalModel),
                eventAgency: finalModel.eventAgency,
                eventClient: finalModel.eventClient
            };
            return info;
        }), Object(operators["switchMap"])(function (info) {
            return _this.eventCollisionProcess(info);
        }));
        eventCollision$.subscribe();
        return eventCollision$;
    };
    EventComponent.prototype.save = function (model) {
        var _this = this;
        this.eventForm.disable();
        model.eventProperty = this.getEventProperty(model);
        model.event.propertyId = model.eventProperty.propertyId;
        model.event.eventAgency = model.eventAgency;
        model.event.eventClient = model.eventClient;
        model.event.eventProperty = model.eventProperty;
        model.event.eventVendors = this.getVendorsFromModel(model);
        if (!this.isMultiVendor()) {
            if (!model.event.eventProperty.commRetention) {
                model.event.eventProperty.commRetention = model.event.commRetention;
            }
            if (!this.hasFinalPayment || this.paymentStatus === PaymentStatus.REJECTED_WF_APPROVAL) {
                model.event.eventProperty.commissionRoomPercentage = model.event.commissionRoomPercentage;
            }
        }
        var formModel = Object.assign({}, this.onyxEvent.toJS(), model.event);
        var updatedFields = {};
        if (formModel.eventAgency) {
            var eventAgency = this.onyxEvent.eventAgency || new Party({ contact: new Contact() });
            updatedFields['eventAgency'] = Object.assign({}, eventAgency, model['eventAgency']);
            updatedFields['eventAgency']['contact'] = Object.assign({}, eventAgency.contact, model['eventAgency']['contact']);
        }
        if (formModel.eventClient) {
            var eventClient = this.onyxEvent.eventClient || new Party({ contact: new Contact() });
            updatedFields['eventClient'] = Object.assign({}, eventClient, model['eventClient']);
            updatedFields['eventClient']['contact'] = Object.assign({}, eventClient.contact, model['eventClient']['contact']);
        }
        if (formModel.eventProperty) {
            var eventProperty = this.onyxEvent.eventProperty || new Party({ contact: new Contact() });
            updatedFields['eventProperty'] = Object.assign({}, eventProperty, model['eventProperty']);
            updatedFields['eventProperty']['contact'] = Object.assign({}, eventProperty.contact, model['eventProperty']['contact']);
        }
        var _startDate;
        var _endDate;
        var _eventName;
        if (model.event.startDate) {
            _startDate = new Date(model.event.startDate).toISOString();
            if (this.authenticationStore.isAgencyUser()) {
                updatedFields['eventAgency']['startDate'] = _startDate;
            }
            else {
                updatedFields['eventProperty']['startDate'] = _startDate;
            }
            this.updatePartyDate(updatedFields, 'eventProperty', 'startDate', _startDate);
            this.updatePartyDate(updatedFields, 'eventAgency', 'startDate', _startDate);
        }
        if (model.event.endDate) {
            _endDate = new Date(model.event.endDate).toISOString();
            if (this.authenticationStore.isAgencyUser()) {
                updatedFields['eventAgency']['endDate'] = _endDate;
            }
            else {
                updatedFields['eventProperty']['endDate'] = _endDate;
            }
            this.updatePartyDate(updatedFields, 'eventProperty', 'endDate', _endDate);
            this.updatePartyDate(updatedFields, 'eventAgency', 'endDate', _endDate);
        }
        if (model.event.name) {
            _eventName = model.event.name;
            if (this.authenticationStore.isAgencyUser()) {
                updatedFields['eventAgency']['partyEventName'] = _eventName;
            }
            else {
                updatedFields['eventProperty']['partyEventName'] = _eventName;
            }
            this.updatePartyDate(updatedFields, 'eventProperty', 'partyEventName', _eventName);
            this.updatePartyDate(updatedFields, 'eventAgency', 'partyEventName', _eventName);
        }
        if (formModel.eventVendors && formModel.eventVendors !== undefined) {
            var updatedVendors = [];
            for (var i = 0; i < formModel.eventVendors.length; i++) {
                if (formModel.eventVendors[i] && formModel.eventVendors[i] !== undefined) {
                    var updatedVendor = void 0;
                    var eventVendor = this.onyxEvent.eventVendors[i] || new Party({ contact: new Contact() });
                    if (formModel.eventVendors[i].partyType === PartyType.PROPERTY && formModel.eventVendors[i].payorType === 'PROPERTY') {
                        updatedFields['brand'] = formModel.eventVendors[i].brand;
                        updatedFields['chain'] = formModel.eventVendors[i].chain;
                        updatedFields['propertyId'] = formModel.eventVendors[i].propertyId;
                    }
                    var formName = 'eventVendor-' + this.getVendorCode(eventVendor);
                    updatedVendor = Object.assign({}, eventVendor, model[formName]);
                    updatedVendor['contact'] = Object.assign({}, eventVendor.contact, model[formName]['contact']);
                    if (!updatedVendor.startDate && model.event.startDate) {
                        updatedVendor.startDate = _startDate;
                    }
                    if (!updatedVendor.endDate && model.event.endDate) {
                        updatedVendor.endDate = _endDate;
                    }
                    if (!updatedVendor.partyEventName && model.event.name) {
                        updatedVendor.partyEventName = _eventName;
                    }
                    updatedVendors.push(updatedVendor);
                }
            }
            updatedFields['eventVendors'] = updatedVendors;
        }
        // checks if the user did not click the add button
        if (model.event.ratePlanCode) {
            formModel.ratePlanCodes.push(new RatePlanCode({ ratePlanCode: model.event.ratePlanCode }));
        }
        var updatedModel = new OnyxEvent(Object.assign({}, formModel, updatedFields));
        if (formModel.eventClient) {
            updatedModel.eventClient.code = formModel.eventClient.code;
        }
        var partiesForUnmatching = [];
        if (this.authenticationStore.isAgencyUser() && this.removedVendors && this.removedVendors.length > 0) {
            this.removedVendors.forEach(function (vendor) {
                if (_this.isRemovedVendor(vendor, updatedModel.eventVendors) && vendor.mergedEvent === 'Y') {
                    partiesForUnmatching.push(vendor);
                }
            });
        }
        var returnedEvent;
        if (this.eventCollisionMatches.size > 0 || partiesForUnmatching.length > 0) {
            var eventInfo_1 = [];
            this.eventCollisionMatches.forEach(function (value, key) {
                eventInfo_1.push(value);
            });
            var partyInitiatorType = null;
            var partyInitiatorCode = null;
            if (this.authenticationStore.isPropertyUser()) {
                partyInitiatorType = updatedModel.eventProperty.partyType.toString();
                partyInitiatorCode = updatedModel.eventProperty.code;
            }
            else {
                partyInitiatorType = updatedModel.eventAgency.partyType.toString();
                partyInitiatorCode = updatedModel.eventAgency.code;
            }
            var mergeRequest = new MergeEventRequest({
                action: 'ADD_EVENT',
                user_id: this.user.username,
                party_initiator_type: partyInitiatorType,
                party_initiator_code: partyInitiatorCode,
                merge_info: eventInfo_1,
                event: updatedModel,
                ev_tmp_guid: this.temporaryGuid,
                parties_for_unmatching: partiesForUnmatching
            });
            returnedEvent = this.sendMergeMatchingRequest(mergeRequest);
        }
        else {
            var finalUpdatedModel = updatedModel.merge({ 'evTmpGuid': this.temporaryGuid });
            if (this.authenticationStore.isPropertyUser()) {
                finalUpdatedModel.eventProperty.eventReferenceNumber = formModel.eventReferenceNumber;
                if (finalUpdatedModel.eventProperty) {
                    finalUpdatedModel.eventProperty.ratePlanCodes = finalUpdatedModel.ratePlanCodes;
                }
                returnedEvent = this.eventStore.updateEvent(finalUpdatedModel);
            }
            else {
                finalUpdatedModel.eventAgency.eventReferenceNumber = formModel.eventReferenceNumber;
                returnedEvent = this.eventStore.updateAgencyEvent(finalUpdatedModel);
            }
        }
        returnedEvent.subscribe(function (res) {
            var changeIata = false;
            if (_this.user && _this.user.allArcIatas && _this.user.customerInfo && _this.user.customerInfo.length >= 2) {
                var key = _this.user.username.toUpperCase() + authentication_store_AuthenticationStore.CURRENT_AGENCY_STR;
                var currentAgency = JSON.parse(_this.userLocalStorageService.getItem(key));
                if (currentAgency.agencyId !== updatedModel.eventAgency.code) {
                    changeIata = true;
                }
            }
            if (changeIata) {
                var agency_1 = new MultiAgency({
                    agencyId: updatedModel.eventAgency.code,
                    agencyName: updatedModel.eventAgency.name
                });
                _this.authenticationStore.updateIataFromToken(agency_1.agencyId).subscribe(function () {
                    _this.multiAgencyService.setAgencySelectedUI(true);
                    _this.multiAgencyService.setDefaultAgency(agency_1);
                    if (_this.isMultiVendor()) {
                        _this.router.navigate(['/event', res.eventId, 'summary']);
                    }
                    else {
                        _this.router.navigate(['/event', res.eventId, res.eventProperty.eventPartyId, 'summary']);
                    }
                });
            }
            else {
                if (_this.isMultiVendor()) {
                    _this.router.navigate(['/event', res.eventId, 'summary']);
                }
                else {
                    _this.router.navigate(['/event', res.eventId, res.eventProperty.eventPartyId, 'summary']);
                }
            }
        }, function (error) {
            _this.eventForm.enable();
            if (error.includes('Agency Event Reference Number already exists')) {
                _this.flashMessagesService.error('MESSAGES.ERROR.ADD_EVENT_DUPLICATED_AGENCY_REFERENCE_NUMBER', error);
            }
            else if (error.includes('Property Event Reference Number already exists')) {
                _this.flashMessagesService.error('MESSAGES.ERROR.ADD_EVENT_DUPLICATED_PROPERTY_REFERENCE_NUMBER', error);
            }
            else if (error.includes('The event must have one payor-type hotel')) {
                _this.flashMessagesService.error('MESSAGES.ERROR.ADD_EVENT_NO_PAYOR_TYPE_HOTEL', error);
            }
            else if (error.includes('The event must have only one payor-type hotel')) {
                _this.flashMessagesService.error('MESSAGES.ERROR.ADD_EVENT_ONLY_ONE_PAYOR_TYPE_HOTEL', error);
            }
            else if (error.includes('Legal Entity data is missing')) {
                _this.flashMessagesService.error('MESSAGES.ERROR.ADD_EVENT_LEGAL_ENTITY_DATA_IS_MISSING', error);
            }
            else if (error.includes('Invalid Tax ID')) {
                _this.flashMessagesService.error('MESSAGES.ERROR.INVALID_VAT_ID', error);
            }
            else {
                _this.flashMessagesService.error('MESSAGES.ERROR.UPDATE_EVENT', error);
            }
        });
        return returnedEvent;
    };
    EventComponent.prototype.edit = function () {
        this.savedEventSerialized = undefined;
        if (this.isMultiVendor()) {
            this.router.navigate(['/event', this.onyxEvent.eventId, 'summary', 'edit']);
        }
        else {
            this.router.navigate(['/event', this.onyxEvent.eventId, this.onyxEvent.eventProperty.eventPartyId, 'summary', 'edit']);
        }
    };
    EventComponent.prototype.confirmBeforeDeleting = function () {
        // set up the title of the confirmation modal
        var label = 'EVENT.DELETE_EVENT';
        this.confirmationModalConfig.title = this.translateService.instant(label);
        this.confirmDeleteModal.open();
    };
    EventComponent.prototype.confirmBeforeDeletingHandler = function (value) {
        if (value) {
            var eventId = this.onyxEvent.eventId;
            this.delete();
        }
    };
    Object.defineProperty(EventComponent.prototype, "canBeDeleted", {
        get: function () {
            return this.onyxEvent.canBeDeleted;
        },
        enumerable: true,
        configurable: true
    });
    EventComponent.prototype.delete = function () {
        var _this = this;
        this.eventForm.disable();
        this.eventStore.deleteEvent(this.onyxEvent.eventId).subscribe(function () {
            _this.eventSearchParametersStore.updateUrl();
        }, function () {
            _this.eventForm.enable();
        });
    };
    EventComponent.prototype.cancel = function () {
        this.eventForm.disable();
        if (this.isMultiVendor()) {
            this.router.navigate(['/event', this.onyxEvent.eventId, 'summary']);
        }
        else {
            this.router.navigate(['/event', this.onyxEvent.eventId, this.onyxEvent.eventProperty.eventPartyId, 'summary']);
        }
        this.reset();
    };
    EventComponent.prototype.reset = function () {
        var _this = this;
        if (this.isMultiVendor()) {
            this.eventStore.getEvent(this.onyxEvent.eventId)
                .take(1)
                .subscribe(function (event) {
                _this.onyxEvent = new OnyxEvent(event);
            });
        }
        else {
            this.eventStore.getEventByParty(this.onyxEvent.eventId, this.onyxEvent.eventProperty.eventPartyId)
                .take(1)
                .subscribe(function (event) {
                _this.onyxEvent = new OnyxEvent(event);
            });
        }
    };
    EventComponent.prototype.togglePageToReadOnly = function (readOnly) {
        var name = EventUtils.getEventName(this.onyxEvent, this.authenticationStore.isAgencyUser());
        if (name) {
            this.menuStore.setPageHeader(readOnly ? name : 'Edit - ' + name, this.onyxEvent.eventProperty.subscriber);
        }
        else {
            this.menuStore.setPageHeader(readOnly ? 'EVENT.EVENT_INFO_TITLE' : 'EVENT.TITLE_EDIT', false);
        }
        this.menuStore.setIsReadOnly(readOnly);
    };
    EventComponent.prototype.setupPropertyEmail = function (email) {
        this.propertyEmail = email;
    };
    EventComponent.prototype.setupAgencyEmail = function (email) {
        this.agencyEmail = email;
    };
    Object.defineProperty(EventComponent.prototype, "hideEditButton", {
        get: function () {
            return !this.showEditButton();
        },
        enumerable: true,
        configurable: true
    });
    EventComponent.prototype.showEditButton = function () {
        if (this.isMultiVendor()) {
            return true;
        }
        if (this.authenticationStore.isPropertyUser()) {
            if (!this.hasFinalPayment || this.paymentStatus === PaymentStatus.REJECTED_WF_APPROVAL) {
                return true;
            }
        }
        return false;
    };
    EventComponent.prototype.getVendorsFromModel = function (model) {
        var vendors = [];
        this.onyxEvent.eventVendors.forEach(function (vendor) {
            var vendorCode = vendor.code ? vendor.code : vendor.chain + '|' + vendor.brand + '|' + vendor.propertyId;
            vendors.push(model['eventVendor-' + vendorCode]);
        });
        return vendors;
    };
    EventComponent.prototype.getEventProperty = function (model) {
        var property = {};
        if (this.isMultiVendor()) {
            this.onyxEvent.eventVendors.forEach(function (vendor) {
                if (vendor.partyType === PartyType.PROPERTY && vendor.payorType === 'PROPERTY') {
                    property = vendor;
                }
            });
        }
        else {
            return model.eventProperty;
        }
        return property;
    };
    EventComponent.prototype.getVendorCode = function (vendor) {
        return vendor.code ? vendor.code : vendor.chain + '|' + vendor.brand + '|' + vendor.propertyId;
    };
    EventComponent.prototype.isMultiVendor = function () {
        return this.authenticationStore.hasPermission('MultiVendor');
    };
    Object.defineProperty(EventComponent.prototype, "isSingleVendor", {
        get: function () {
            return this.authenticationStore.hasPermission('SingleVendor');
        },
        enumerable: true,
        configurable: true
    });
    EventComponent.prototype.confirmBeforeSaveEventHandler = function (response) {
        var _this = this;
        if (response.selectedButton === EventCollisionModalResponseEnum.MergeEvents) {
            this.eventMatchInfo.forEach(function (item) {
                if (response.selectedMatches.indexOf(item.event_match_id) > -1) {
                    var key = item['create_party'] === 'PROPERTY' ? item['matched_agency_id'] : item['matched_vendor_code'];
                    _this.eventCollisionMatches.set(key, item);
                }
            });
        }
        this.eventMatchInfo = [];
        this.save(this.eventForm.value);
    };
    EventComponent.prototype.cancelMatchingWizard = function (response) {
        var _this = this;
        var matchesToCancel = [];
        this.eventMatchInfo.forEach(function (item) {
            if (response.selectedMatches.indexOf(item.event_match_id) === -1) {
                matchesToCancel.push(item.event_match_id);
            }
        });
        var obs = this.matchingPropertyStore
            .cancelMatching(matchesToCancel)
            .take(1)
            .catch(function (error) {
            return Observable["Observable"].throw(error);
        }).finally(function () {
            _this.eventMatchInfo = [];
            _this.eventForm.enable();
            _this.focusEventNameSubject.next();
        });
        obs.subscribe();
        return obs;
    };
    EventComponent.prototype.eventCollisionProcess = function (info) {
        var _this = this;
        var obs = this.invokeEventCollisionMatching(info);
        obs.subscribe(function (match) {
            if (match) {
                if (_this.anyMatchFound(match)) {
                    var matchesForModalPanel_1 = [];
                    var propertiesFromModalPanel_1 = [];
                    match.forEach(function (item) {
                        if (item.result === 'fuzzy') {
                            _this.eventMatchInfo.push(new MergeMatchInfo({
                                create_party: item.create_party,
                                id: item.id,
                                merge_event: true,
                                source: 'Manual input',
                                event_match_id: item.event_match_id,
                                matched_event_id: item.matches[0].event_id,
                                matched_agency_id: item.matches[0].agency_id,
                                matched_vendor_code: item.matches[0].vendor_code,
                                edited_event_id: item['edited_event_id'],
                                edited_agency_id: item['edited_agency_id'],
                                edited_vendor_code: item['edited_vendor_code'],
                                action: item['action'],
                                user_id: item['user_id'],
                                ev_tmp_guid: item['ev_tmp_guid']
                            }));
                            matchesForModalPanel_1.push(item);
                            propertiesFromModalPanel_1.push(item.property_name + " " + item.property_address);
                        }
                    });
                    var eventMatch = new EventCollisionMatch({
                        createdBy: _this.authenticationStore.isPropertyUser() ? info.eventProperties[0].name :
                            info.eventAgency.name,
                        clientCompany: info.eventClient.name ? info.eventClient.name : '',
                        eventName: info.event.name,
                        groupCode: info.event.eventReferenceNumber,
                        startDate: info.event.startDate,
                        endDate: info.event.endDate,
                        property: matchesForModalPanel_1.length > 1 ? '' : propertiesFromModalPanel_1[0],
                        eventMatchId: matchesForModalPanel_1.length > 1 ? null : matchesForModalPanel_1[0].event_match_id,
                    });
                    if (matchesForModalPanel_1.length > 1) {
                        _this.eventCollisionModalMultiprompt.open(eventMatch, matchesForModalPanel_1);
                    }
                    else {
                        _this.eventCollisionModal.open(eventMatch, matchesForModalPanel_1[0].matches[0]);
                    }
                }
                else {
                    return _this.save(_this.eventForm.value);
                }
            }
            return match;
        });
        return obs;
    };
    EventComponent.prototype.invokeEventCollisionMatching = function (info) {
        var _this = this;
        var returnedEvent = this.matchingPropertyStore
            .getMatchingCollisionProperties(info, info.event.eventId, this.user.username, this.temporaryGuid)
            .catch(function (error) {
            _this.flashMessagesService.error('MESSAGES.ERROR.MATCHING_EVENT', error);
            return Observable["Observable"].throw(error);
        })
            .map(function (res) {
            return res;
        });
        return returnedEvent;
    };
    EventComponent.prototype.sendMergeMatchingRequest = function (eventInfo) {
        var _this = this;
        var returnedEvent = this.matchingPropertyStore
            .updateEventCollisionMatch(eventInfo)
            .catch(function (error) {
            _this.eventForm.enable();
            if (error.includes('Agency Event Reference Number already exists')) {
                _this.flashMessagesService.error('MESSAGES.ERROR.ADD_EVENT_DUPLICATED_AGENCY_REFERENCE_NUMBER', error);
            }
            else if (error.includes('Property Event Reference Number already exists')) {
                _this.flashMessagesService.error('MESSAGES.ERROR.ADD_EVENT_DUPLICATED_PROPERTY_REFERENCE_NUMBER', error);
            }
            else if (error.includes('The event must have one payor-type hotel')) {
                _this.flashMessagesService.error('MESSAGES.ERROR.ADD_EVENT_NO_PAYOR_TYPE_HOTEL', error);
            }
            else if (error.includes('The event must have only one payor-type hotel')) {
                _this.flashMessagesService.error('MESSAGES.ERROR.ADD_EVENT_ONLY_ONE_PAYOR_TYPE_HOTEL', error);
            }
            else {
                _this.flashMessagesService.error('MESSAGES.ERROR.MERGE_MATCHING_EVENT', error);
            }
            return Observable["Observable"].throw(error);
        })
            .map(function (res) {
            _this.eventStore.setEvent(res);
            return res;
        });
        return returnedEvent;
    };
    EventComponent.prototype.getEventName = function (event) {
        return EventUtils.getEventName(event, this.authenticationStore.isAgencyUser());
    };
    EventComponent.prototype.getStartDate = function (event) {
        return EventUtils.getEventStartDate(event, this.authenticationStore.isAgencyUser());
    };
    EventComponent.prototype.getEndDate = function (event) {
        return EventUtils.getEventEndDate(event, this.authenticationStore.isAgencyUser());
    };
    EventComponent.prototype.updatePartyDate = function (updatedFields, partyType, dateType, date) {
        if (updatedFields[partyType] && !updatedFields[partyType][dateType]) {
            updatedFields[partyType][dateType] = date;
        }
    };
    Object.defineProperty(EventComponent.prototype, "canBeUnmatched", {
        get: function () {
            // ME-13128: Hide "Unmatch" button for Support users
            return Observable["Observable"].of(false);
            // ME-10716: Rollback a match - Support user button
            // return of(Boolean(this.authenticationStore.isSupportUser() && this.onyxEvent.canBeUnmatched));
        },
        enumerable: true,
        configurable: true
    });
    EventComponent.prototype.unmatch = function () {
        if (this.authenticationStore.isSupportUser() && this.eventMatches.length > 0) {
            if (this.eventMatches.length === 1) {
                var label = 'EVENT.UNMATCH_EVENT';
                this.confirmationModalConfig.title = this.translateService.instant(label);
                this.confirmUnmatchModal.open();
            }
            else {
                this.unmatchEventModal.open();
            }
        }
    };
    EventComponent.prototype.confirmBeforeUnmatchingHandler = function (value) {
        if (value) {
            var parties = [];
            var party = new UnmatchEventPartyRequest({
                type: this.eventMatches[0].matchPartyType,
                code: this.eventMatches[0].matchPartyCode
            });
            parties.push(party);
            var unmatchEventRequest = new UnmatchEventRequest({
                action: (parties[0].type === 'AGENCY' ? 'UNMATCH_AGENCY' : 'UNMATCH_VENDOR'),
                event_id: this.onyxEvent.eventId,
                parties: parties,
                reason: '',
                unmatched_by: null,
                party_initiator_type: null,
                party_initiator_code: null,
                event_info: null,
            });
            this.invokeUnmatchEvent(unmatchEventRequest);
        }
    };
    EventComponent.prototype.confirmUnmatchPopupHandler = function (unmatchInfo) {
        this.invokeUnmatchEvent(unmatchInfo);
    };
    EventComponent.prototype.invokeUnmatchEvent = function (unmatchEventRequest) {
        var _this = this;
        var returnedEvent = this.matchingPropertyStore.unmatchEvent(unmatchEventRequest);
        this.eventForm.disable();
        returnedEvent.subscribe(function (response) {
            _this.router.navigate(['/event', response['new_event_id'], 'summary']);
        }, function (error) {
            _this.eventForm.enable();
            _this.flashMessagesService.error('MESSAGES.ERROR.UNMATCH_EVENT', error);
        });
    };
    Object.defineProperty(EventComponent.prototype, "isNotEventEditable", {
        get: function () {
            var isMultiVendorUserOrAgencyCreatedEvent = (this.isMultiVendor() || (this.onyxEvent.eventAgency && this.onyxEvent.eventAgency.createdEvent === 'Y'));
            var hasRsvpOrReservationOrPayment = this.hasEventRsvp || this.hasEventReservation || this.hasEventPayment;
            var isSubscriberAgencyCase = !this.isMultiVendor() && this.hasSubscriberAgency && !this.hasEventPayment;
            return Object(of["of"])(Boolean(isMultiVendorUserOrAgencyCreatedEvent && hasRsvpOrReservationOrPayment && !isSubscriberAgencyCase));
        },
        enumerable: true,
        configurable: true
    });
    EventComponent.prototype.hasEventRsvpSubscribe = function () {
        var _this = this;
        this.rsvpStore.getEventHasRsvps().take(1).subscribe(function (eventHasRsvps) {
            _this.hasEventRsvp = eventHasRsvps;
        });
    };
    EventComponent.prototype.hasEventReservationSubscribe = function () {
        var _this = this;
        this.reservationStore.getEventHasReservations().take(1).subscribe(function (hasReservations) {
            _this.hasEventReservation = hasReservations;
        });
    };
    EventComponent.prototype.hasEventPaymentSubscribe = function () {
        var _this = this;
        this.paymentStore.payments.take(1).subscribe(function (payments) {
            _this.hasEventPayment = Boolean(payments && payments.size > 0);
        });
    };
    EventComponent.prototype.hasSubscriberAgencySubscribe = function () {
        var _this = this;
        if (this.onyxEvent.eventAgency) {
            this.agencyLookupStore.isSubscriberAgency(this.onyxEvent.eventAgency.code).take(1).subscribe(function (isSubscriber) {
                _this.hasSubscriberAgency = Boolean(isSubscriber);
            });
        }
    };
    Object.defineProperty(EventComponent.prototype, "isMultiVendorUserAndEventCreatedByProperty", {
        get: function () {
            return this.isMultiVendor()
                && this.onyxEvent.eventVendors
                && this.onyxEvent.eventVendors
                    .find(function (vendor) { return vendor.payorType === 'PROPERTY' && vendor.subscriber && vendor.createdEvent === 'Y'; }) != null
                && this.onyxEvent.eventAgency
                && this.onyxEvent.eventAgency.createdEvent !== 'Y';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EventComponent.prototype, "isSingleVendorUserAndEventCreatedByAgency", {
        get: function () {
            return this.isSingleVendor
                && this.onyxEvent.eventAgency
                && this.onyxEvent.eventAgency.createdEvent !== 'Y';
        },
        enumerable: true,
        configurable: true
    });
    EventComponent.prototype.getPropertiesFromModel = function (model) {
        var vendors = [];
        this.onyxEvent.eventVendors.forEach(function (vendor) {
            if (vendor.partyType === PartyType.PROPERTY && vendor.payorType === 'PROPERTY') {
                var vendorCode = vendor.code ? vendor.code : vendor.chain + '|' + vendor.brand + '|' + vendor.propertyId;
                vendors.push(model['eventVendor-' + vendorCode]);
            }
        });
        return vendors;
    };
    EventComponent.prototype.anyMatchFound = function (match) {
        var result = false;
        match.forEach(function (item) {
            if (item.result === 'fuzzy') {
                result = true;
            }
        });
        return result;
    };
    EventComponent.prototype.isRemovedVendor = function (vendor, finalEventVendors) {
        var result = true;
        finalEventVendors.forEach(function (item) {
            if (vendor.payorType === item.payorType &&
                vendor.chain === item.chain &&
                vendor.brand === item.brand &&
                vendor.propertyId === item.propertyId) {
                result = false;
            }
        });
        return result;
    };
    EventComponent.prototype.removeVendorProcess = function (vendor) {
        if (vendor.payorType === 'PROPERTY' &&
            vendor.mergedEvent === 'Y') {
            this.removedVendors.push(JSON.parse(JSON.stringify(vendor)));
        }
    };
    EventComponent.prototype.selectedAgency = function () {
        this.isSelectedAgency = true;
    };
    return EventComponent;
}());
event_component___decorate([
    Object(core_es5["ViewChild"])(event_collision_modal_component_EventCollisionModalComponent),
    event_component___metadata("design:type", typeof (event_component__a = typeof event_collision_modal_component_EventCollisionModalComponent !== "undefined" && event_collision_modal_component_EventCollisionModalComponent) === "function" && event_component__a || Object)
], event_component_EventComponent.prototype, "eventCollisionModal", void 0);
event_component___decorate([
    Object(core_es5["ViewChild"])(event_collision_modal_multiprompt_component_EventCollisionModalMultipromptComponent),
    event_component___metadata("design:type", typeof (event_component__b = typeof event_collision_modal_multiprompt_component_EventCollisionModalMultipromptComponent !== "undefined" && event_collision_modal_multiprompt_component_EventCollisionModalMultipromptComponent) === "function" && event_component__b || Object)
], event_component_EventComponent.prototype, "eventCollisionModalMultiprompt", void 0);
event_component___decorate([
    Object(core_es5["ViewChild"])('confirmDeleteModal'),
    event_component___metadata("design:type", typeof (event_component__c = typeof confirmation_modal_component_ConfirmationModalComponent !== "undefined" && confirmation_modal_component_ConfirmationModalComponent) === "function" && event_component__c || Object)
], event_component_EventComponent.prototype, "confirmDeleteModal", void 0);
event_component___decorate([
    Object(core_es5["ViewChild"])('confirmUnmatchModal'),
    event_component___metadata("design:type", typeof (event_component__d = typeof confirmation_modal_component_ConfirmationModalComponent !== "undefined" && confirmation_modal_component_ConfirmationModalComponent) === "function" && event_component__d || Object)
], event_component_EventComponent.prototype, "confirmUnmatchModal", void 0);
event_component___decorate([
    Object(core_es5["ViewChild"])(unmatch_event_popup_component_UnmatchEventPopupComponent),
    event_component___metadata("design:type", typeof (event_component__e = typeof unmatch_event_popup_component_UnmatchEventPopupComponent !== "undefined" && unmatch_event_popup_component_UnmatchEventPopupComponent) === "function" && event_component__e || Object)
], event_component_EventComponent.prototype, "unmatchEventModal", void 0);
event_component_EventComponent = event_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-event',
        template: __webpack_require__("PUE1")
    }),
    event_component___metadata("design:paramtypes", [typeof (event_component__f = typeof router_es5["Router"] !== "undefined" && router_es5["Router"]) === "function" && event_component__f || Object, typeof (event_component__g = typeof event_store_EventStore !== "undefined" && event_store_EventStore) === "function" && event_component__g || Object, typeof (event_component__h = typeof forms_es5["FormBuilder"] !== "undefined" && forms_es5["FormBuilder"]) === "function" && event_component__h || Object, typeof (event_component__j = typeof menu_store_MenuStore !== "undefined" && menu_store_MenuStore) === "function" && event_component__j || Object, typeof (event_component__k = typeof flash_messages_service_FlashMessagesService !== "undefined" && flash_messages_service_FlashMessagesService) === "function" && event_component__k || Object, typeof (event_component__l = typeof core["c" /* TranslateService */] !== "undefined" && core["c" /* TranslateService */]) === "function" && event_component__l || Object, typeof (event_component__m = typeof router_es5["ActivatedRoute"] !== "undefined" && router_es5["ActivatedRoute"]) === "function" && event_component__m || Object, typeof (event_component__o = typeof event_search_parameters_store_EventSearchParametersStore !== "undefined" && event_search_parameters_store_EventSearchParametersStore) === "function" && event_component__o || Object, typeof (event_component__p = typeof payment_store_PaymentStore !== "undefined" && payment_store_PaymentStore) === "function" && event_component__p || Object, typeof (event_component__q = typeof authentication_store_AuthenticationStore !== "undefined" && authentication_store_AuthenticationStore) === "function" && event_component__q || Object, typeof (event_component__r = typeof user_local_storage_service_UserLocalStorageService !== "undefined" && user_local_storage_service_UserLocalStorageService) === "function" && event_component__r || Object, typeof (event_component__s = typeof multi_agency_service_MultiAgencyService !== "undefined" && multi_agency_service_MultiAgencyService) === "function" && event_component__s || Object, typeof (event_component__t = typeof matching_property_store_MatchingPropertyStore !== "undefined" && matching_property_store_MatchingPropertyStore) === "function" && event_component__t || Object, typeof (event_component__u = typeof event_match_log_store_EventMatchLogStore !== "undefined" && event_match_log_store_EventMatchLogStore) === "function" && event_component__u || Object, typeof (_v = typeof rsvp_store_RsvpStore !== "undefined" && rsvp_store_RsvpStore) === "function" && _v || Object, typeof (_w = typeof reservation_store_ReservationStore !== "undefined" && reservation_store_ReservationStore) === "function" && _w || Object, typeof (_x = typeof event_validation_service_EventValidationService !== "undefined" && event_validation_service_EventValidationService) === "function" && _x || Object, typeof (_y = typeof agency_lookup_store_AgencyLookupStore !== "undefined" && agency_lookup_store_AgencyLookupStore) === "function" && _y || Object, typeof (_z = typeof guid_generator_store_GuidGeneratorStore !== "undefined" && guid_generator_store_GuidGeneratorStore) === "function" && _z || Object, typeof (_0 = typeof matching_agency_service_MatchingAgencyService !== "undefined" && matching_agency_service_MatchingAgencyService) === "function" && _0 || Object, typeof (_1 = typeof log_service_LogService !== "undefined" && log_service_LogService) === "function" && _1 || Object])
], event_component_EventComponent);

var event_component__a, event_component__b, event_component__c, event_component__d, event_component__e, event_component__f, event_component__g, event_component__h, event_component__j, event_component__k, event_component__l, event_component__m, event_component__o, event_component__p, event_component__q, event_component__r, event_component__s, event_component__t, event_component__u, _v, _w, _x, _y, _z, _0, _1;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/event.component.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/matching-property-assign.ts
var matching_property_assign___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var MatchingPropertyAssignRecord = Object(immutable["Record"])({
    'matchingPropertyId': null,
    'vendorSource': null,
    'vendorId': null,
    'chain': null,
    'brand': null,
    'pid': null,
    'name': null
});
var MatchingPropertyAssign = (function (_super) {
    matching_property_assign___extends(MatchingPropertyAssign, _super);
    function MatchingPropertyAssign() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return MatchingPropertyAssign;
}(MatchingPropertyAssignRecord));

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/matching-property-assign.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/property-match.ts
var property_match___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var PropertyMatchRecord = Object(immutable["Record"])({
    matchingPropertyId: 0,
    vendorSource: null,
    vendorId: null,
    name: null,
    address1: null,
    address2: null,
    address3: null,
    city: null,
    stateProvinceCode: null,
    countryCode: null,
    postalCode: null,
    contactFirstName: null,
    contactLastName: null,
    contactEmail: null,
    contactPhone: null,
    contactFax: null
});
var PropertyMatch = (function (_super) {
    property_match___extends(PropertyMatch, _super);
    function PropertyMatch() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return PropertyMatch;
}(PropertyMatchRecord));

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/property-match.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/matching-candidate.ts
var matching_candidate___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var MatchingCandidateRecord = Object(immutable["Record"])({
    'matchingCandidateId': null,
    'chain': null,
    'brand': null,
    'pid': null,
    'name': null,
    'address1': null,
    'address2': null,
    'address3': null,
    'city': null,
    'countryCode': null,
    'stateProvinceCode': null,
    'postalCode': null,
    'matchRate': null
});
var MatchingCandidate = (function (_super) {
    matching_candidate___extends(MatchingCandidate, _super);
    function MatchingCandidate() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return MatchingCandidate;
}(MatchingCandidateRecord));

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/matching-candidate.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/matching-property/matching-property-candicate/matching-property-candidate.component.ts
var matching_property_candidate_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var matching_property_candidate_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};














var matching_property_candidate_component_MatchingPropertyCandidateComponent = (function () {
    function MatchingPropertyCandidateComponent(formBuilder, matchingPropertyService, router, menuStore, translateService) {
        this.formBuilder = formBuilder;
        this.matchingPropertyService = matchingPropertyService;
        this.router = router;
        this.menuStore = menuStore;
        this.translateService = translateService;
        this.confirmationModalConfig = new ConfirmationModalConfig();
    }
    MatchingPropertyCandidateComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.menuStore.setPageHeader('EVENT.PROPERTY_REVIEW.CANDIDATE_PAGE_TITLE', false);
        this.candidatesForm = this.formBuilder.group({
            'matchingOption': [null,]
        });
        this.matchingPropertyService.selectedProperty$.subscribe(function (property) {
            _this.property = property;
        });
        this.matchingPropertyService.selectedPage$.subscribe(function (page) {
            _this.currentPage = page;
        });
    };
    Object.defineProperty(MatchingPropertyCandidateComponent.prototype, "matchingOption", {
        get: function () {
            return this.getFormControlValue('matchingOption');
        },
        enumerable: true,
        configurable: true
    });
    MatchingPropertyCandidateComponent.prototype.getFormControlValue = function (name) {
        return this.candidatesForm ? this.candidatesForm.get(name).value : null;
    };
    MatchingPropertyCandidateComponent.prototype.noOptionSelected = function () {
        return !this.matchingOption;
    };
    MatchingPropertyCandidateComponent.prototype.cancelMatch = function () {
        this.resetForm();
        this.matchingPropertyService.resetSelectedProperty();
        // this.matchingPropertyService.resetSelectedField();
        this.router.navigate(['/events/matching/property'], {});
    };
    MatchingPropertyCandidateComponent.prototype.resetForm = function () {
        this.candidatesForm = this.formBuilder.group({
            'matchingOption': [null,]
        });
    };
    MatchingPropertyCandidateComponent.prototype.matchCandidate = function () {
        var candidate = this.getAssingCandidate(this.matchingOption);
        var propertyAssign = new MatchingPropertyAssign({
            matchingPropertyId: this.property.matchingPropertyId,
            vendorSource: this.property.vendorSource,
            vendorId: this.property.vendorId,
            chain: candidate.chain,
            brand: candidate.brand,
            pid: candidate.pid,
            name: candidate.name
        });
        this.assignCandidate(propertyAssign);
    };
    MatchingPropertyCandidateComponent.prototype.getAssingCandidate = function (candidateId) {
        var assign = new MatchingCandidate();
        this.property.candidates.forEach(function (candidate) {
            if (candidate.matchingCandidateId === Number(candidateId)) {
                assign = candidate;
            }
        });
        return assign;
    };
    MatchingPropertyCandidateComponent.prototype.assignCandidate = function (property) {
        var _this = this;
        this.candidatesForm.disable();
        this.matchingPropertyService.assignMatchingCandidate(property).pipe(Object(operators["take"])(1), Object(operators["tap"])(function () {
            _this.refreshProperties(_this.currentPage);
        }), Object(operators["catchError"])(function () {
            return Observable["Observable"].of(null);
        }), Object(operators["finalize"])(function () {
            _this.candidatesForm.enable();
        })).subscribe();
    };
    MatchingPropertyCandidateComponent.prototype.refreshProperties = function (page) {
        var _this = this;
        this.matchingPropertyService.refreshMatchingProperties(page)
            .pipe(Object(operators["take"])(1))
            .subscribe(function () {
            _this.cancelMatch();
        });
    };
    MatchingPropertyCandidateComponent.prototype.addNewProperty = function () {
        var _this = this;
        var propertyAddRequest = this.extractProperty();
        try {
            this.matchingPropertyService.addProperty(propertyAddRequest)
                .pipe(Object(operators["take"])(1))
                .subscribe(function () {
                _this.refreshProperties(_this.currentPage);
            });
        }
        catch (error) {
            Observable["Observable"].throw(error);
        }
    };
    MatchingPropertyCandidateComponent.prototype.extractProperty = function () {
        return new PropertyMatch({
            matchingPropertyId: this.property.matchingPropertyId,
            vendorSource: this.property.vendorSource,
            vendorId: this.property.vendorId,
            name: this.property.name,
            address1: this.property.address1,
            address2: this.property.address2,
            address3: this.property.address3,
            city: this.property.city,
            stateProvinceCode: this.property.stateProvinceCode,
            countryCode: this.property.countryCode,
            postalCode: this.property.postalCode
        });
    };
    MatchingPropertyCandidateComponent.prototype.confirmBeforeAddProperty = function () {
        // set up the title of the confirmation modal
        var label = 'EVENT.PROPERTY_REVIEW.ADD_PROPERTY_CONFIRMATION_TITLE';
        var confirmLabel = 'EVENT.PROPERTY_REVIEW.CONFIRMATION_ADD';
        var params = {};
        var title = this.translateService.instant(label, params);
        var confirmTitle = this.translateService.instant(confirmLabel);
        this.confirmationModalConfig.title = title;
        this.confirmationModalConfig.confirm = confirmTitle;
        this.confirmationModal.open();
    };
    MatchingPropertyCandidateComponent.prototype.confirmBeforeAddPropertyHandler = function (value) {
        if (value) {
            this.addNewProperty();
        }
    };
    MatchingPropertyCandidateComponent.prototype.isNotProvided = function (vendorId) {
        var searchPattern = new RegExp('^' + Constants.NOT_PROVIDED_VENDOR_ID_PREFIX);
        return searchPattern.test(vendorId);
    };
    return MatchingPropertyCandidateComponent;
}());
matching_property_candidate_component___decorate([
    Object(core_es5["ViewChild"])(confirmation_modal_component_ConfirmationModalComponent),
    matching_property_candidate_component___metadata("design:type", typeof (matching_property_candidate_component__a = typeof confirmation_modal_component_ConfirmationModalComponent !== "undefined" && confirmation_modal_component_ConfirmationModalComponent) === "function" && matching_property_candidate_component__a || Object)
], matching_property_candidate_component_MatchingPropertyCandidateComponent.prototype, "confirmationModal", void 0);
matching_property_candidate_component_MatchingPropertyCandidateComponent = matching_property_candidate_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-matching-property-candidate',
        template: __webpack_require__("JWMH")
    }),
    matching_property_candidate_component___metadata("design:paramtypes", [typeof (matching_property_candidate_component__b = typeof forms_es5["FormBuilder"] !== "undefined" && forms_es5["FormBuilder"]) === "function" && matching_property_candidate_component__b || Object, typeof (matching_property_candidate_component__c = typeof matching_property_service_MatchingPropertyService !== "undefined" && matching_property_service_MatchingPropertyService) === "function" && matching_property_candidate_component__c || Object, typeof (matching_property_candidate_component__d = typeof router_es5["Router"] !== "undefined" && router_es5["Router"]) === "function" && matching_property_candidate_component__d || Object, typeof (matching_property_candidate_component__e = typeof menu_store_MenuStore !== "undefined" && menu_store_MenuStore) === "function" && matching_property_candidate_component__e || Object, typeof (matching_property_candidate_component__f = typeof core["c" /* TranslateService */] !== "undefined" && core["c" /* TranslateService */]) === "function" && matching_property_candidate_component__f || Object])
], matching_property_candidate_component_MatchingPropertyCandidateComponent);

var matching_property_candidate_component__a, matching_property_candidate_component__b, matching_property_candidate_component__c, matching_property_candidate_component__d, matching_property_candidate_component__e, matching_property_candidate_component__f;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/matching-property-candidate.component.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/matching-property/matching-property.component.ts
var matching_property_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var matching_property_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};





var matching_property_component_MatchingPropertyComponent = (function () {
    function MatchingPropertyComponent(matchingPropertyService, menuStore) {
        this.matchingPropertyService = matchingPropertyService;
        this.menuStore = menuStore;
        this.pagesizeType = PagesizeType.MATCHING_PROPERTY;
    }
    MatchingPropertyComponent.prototype.ngOnInit = function () {
        this.menuStore.setPageHeader('EVENT.PROPERTY_REVIEW.LIST_PAGE_TITLE', false);
        this.currentPage = Constants.SEARCH_DEFAULT_PAGE;
    };
    Object.defineProperty(MatchingPropertyComponent.prototype, "propertiesPresent", {
        get: function () {
            return this.propertyCount.map(function (propertyCount) {
                return propertyCount > 0;
            });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MatchingPropertyComponent.prototype, "propertyCount", {
        get: function () {
            return this.matchingPropertyService.totalPropertyCount;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MatchingPropertyComponent.prototype, "propertyCountForTranslate", {
        get: function () {
            return {
                propertyCount: this.propertyCount
            };
        },
        enumerable: true,
        configurable: true
    });
    MatchingPropertyComponent.prototype.onRefreshList = function (page) {
        this.currentPage = page;
        this.matchingPropertyService
            .refreshMatchingProperties(page)
            .take(1).subscribe();
    };
    Object.defineProperty(MatchingPropertyComponent.prototype, "properties", {
        get: function () {
            return this.matchingPropertyService.properties;
        },
        enumerable: true,
        configurable: true
    });
    MatchingPropertyComponent.prototype.sortList = function (field, direction) {
        this.matchingPropertyService.setCurrentField(field);
        this.matchingPropertyService.setCurrentDirection(direction);
        this.onRefreshList(this.currentPage);
    };
    return MatchingPropertyComponent;
}());
matching_property_component_MatchingPropertyComponent = matching_property_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-matching-property',
        template: __webpack_require__("B/30")
    }),
    matching_property_component___metadata("design:paramtypes", [typeof (matching_property_component__a = typeof matching_property_service_MatchingPropertyService !== "undefined" && matching_property_service_MatchingPropertyService) === "function" && matching_property_component__a || Object, typeof (matching_property_component__b = typeof menu_store_MenuStore !== "undefined" && menu_store_MenuStore) === "function" && matching_property_component__b || Object])
], matching_property_component_MatchingPropertyComponent);

var matching_property_component__a, matching_property_component__b;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/matching-property.component.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/summary-record-type.enum.ts
/**
 * Rsvp or Reservation
 */
/**
 * Rsvp or Reservation
 */ var SummaryRecordTypeEnum;
(function (SummaryRecordTypeEnum) {
    SummaryRecordTypeEnum[SummaryRecordTypeEnum["RSVP"] = 'RSVPs'] = "RSVP";
    SummaryRecordTypeEnum[SummaryRecordTypeEnum["RESERVATION"] = 'Reservations'] = "RESERVATION";
    SummaryRecordTypeEnum[SummaryRecordTypeEnum["RESERVATION_RSVP"] = 'Reservations & RSVPs'] = "RESERVATION_RSVP";
    SummaryRecordTypeEnum[SummaryRecordTypeEnum["ERROR"] = 'error'] = "ERROR";
})(SummaryRecordTypeEnum || (SummaryRecordTypeEnum = {}));
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/summary-record-type.enum.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/overview/overview-page/overview-page.component.ts
var overview_page_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var overview_page_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};









var overview_page_component_OverviewPageComponent = (function () {
    function OverviewPageComponent(eventStore, menuStore, route, authenticationSore, flashMessagesService) {
        this.eventStore = eventStore;
        this.menuStore = menuStore;
        this.route = route;
        this.authenticationSore = authenticationSore;
        this.flashMessagesService = flashMessagesService;
    }
    OverviewPageComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.eventStore.selectedEvent.subscribe(function (event) { return _this.onyxEvent = event; });
        if (this.onyxEvent) {
            this.menuStore.setPageHeader(EventUtils.getEventName(this.onyxEvent, this.authenticationSore.isAgencyUser()), this.onyxEvent.eventProperty.subscriber);
        }
        // If the event property is subscribed, reservations are retrieved to build the overview.
        // Otherwise, RSVPs are
        if (this.onyxEvent && this.onyxEvent.eventProperty.subscriber) {
            this.headerRecordType = SummaryRecordTypeEnum.RESERVATION;
        }
        else {
            this.headerRecordType = SummaryRecordTypeEnum.RSVP;
        }
        this.vendor = this.onyxEvent.eventProperty;
        // toggle page to editable if the URL ends with "edit" (it will default to read only)
        // otherwise, check if we need to show a warning flash message when in view modeFD
        route_utils_RouteUtils.getLastUrlSegment(this.route)
            .subscribe(function (lastSegment) {
            if (_this.authenticationSore.hasPermission('EditEvent') && !_this.isEventValid()) {
                _this.flashMessagesService.warn('EVENT.EVENT_MISSING_INFO', null, { hrefValue: "/#/event/" + _this.onyxEvent.eventId + "/" + _this.vendor.eventPartyId + "/summary/edit" });
            }
        });
    };
    OverviewPageComponent.prototype.isEventValid = function () {
        return EventUtils.isEventValid(this.onyxEvent, this.authenticationSore.isAgencyUser());
    };
    return OverviewPageComponent;
}());
overview_page_component_OverviewPageComponent = overview_page_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-overview-page',
        template: __webpack_require__("1EdF")
    }),
    overview_page_component___metadata("design:paramtypes", [typeof (overview_page_component__a = typeof event_store_EventStore !== "undefined" && event_store_EventStore) === "function" && overview_page_component__a || Object, typeof (overview_page_component__b = typeof menu_store_MenuStore !== "undefined" && menu_store_MenuStore) === "function" && overview_page_component__b || Object, typeof (overview_page_component__c = typeof router_es5["ActivatedRoute"] !== "undefined" && router_es5["ActivatedRoute"]) === "function" && overview_page_component__c || Object, typeof (overview_page_component__d = typeof authentication_store_AuthenticationStore !== "undefined" && authentication_store_AuthenticationStore) === "function" && overview_page_component__d || Object, typeof (overview_page_component__e = typeof flash_messages_service_FlashMessagesService !== "undefined" && flash_messages_service_FlashMessagesService) === "function" && overview_page_component__e || Object])
], overview_page_component_OverviewPageComponent);

var overview_page_component__a, overview_page_component__b, overview_page_component__c, overview_page_component__d, overview_page_component__e;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/overview-page.component.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/service/overview.http.service.ts
var overview_http_service___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var overview_http_service___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};





var OverviewHttpService = (function () {
    function OverviewHttpService(http, eventStore, environment, responseUtilService) {
        var _this = this;
        this.http = http;
        this.eventStore = eventStore;
        this.environment = environment;
        this.responseUtilService = responseUtilService;
        this.eventUrl = this.environment.baseUrl + '/api/events';
        eventStore.selectedEvent.map(function (event) { return _this.selectedEvent = event; });
    }
    OverviewHttpService.prototype.getDateRoomTypeSummary = function (eventId) {
        var _this = this;
        var reservationUrl = this.eventUrl + "/" + eventId + "/overview/date-room-type-summary";
        return this.http.get(reservationUrl)
            .map(function (res) { return res.json(); })
            .catch(function (response) { return _this.responseUtilService.handleError(response); }).share();
    };
    OverviewHttpService.prototype.getDateRoomTypeSummaryByParty = function (eventId, eventPartyId) {
        var _this = this;
        var reservationUrl = this.eventUrl + "/" + eventId + "/" + eventPartyId + "/overview/date-room-type-summary";
        return this.http.get(reservationUrl)
            .map(function (res) { return res.json(); })
            .catch(function (response) { return _this.responseUtilService.handleError(response); }).share();
    };
    return OverviewHttpService;
}());
OverviewHttpService = overview_http_service___decorate([
    Object(core_es5["Injectable"])(),
    overview_http_service___metadata("design:paramtypes", [typeof (overview_http_service__a = typeof AppAuthHttpService !== "undefined" && AppAuthHttpService) === "function" && overview_http_service__a || Object, typeof (overview_http_service__b = typeof event_store_EventStore !== "undefined" && event_store_EventStore) === "function" && overview_http_service__b || Object, typeof (overview_http_service__c = typeof EnvironmentConfiguration !== "undefined" && EnvironmentConfiguration) === "function" && overview_http_service__c || Object, typeof (overview_http_service__d = typeof response_util_service_ResponseUtilService !== "undefined" && response_util_service_ResponseUtilService) === "function" && overview_http_service__d || Object])
], OverviewHttpService);

var overview_http_service__a, overview_http_service__b, overview_http_service__c, overview_http_service__d;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/overview.http.service.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/service/overview.store.ts
var overview_store___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var overview_store___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};





var overview_store_OverviewStore = (function () {
    function OverviewStore(flashMessagesService, overviewHttpService) {
        this.flashMessagesService = flashMessagesService;
        this.overviewHttpService = overviewHttpService;
        this.currentDateRoomTypeSummaryList = new BehaviorSubject["BehaviorSubject"](null);
    }
    Object.defineProperty(OverviewStore.prototype, "dateStaySummary", {
        get: function () {
            return this.currentDateRoomTypeSummaryList.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    OverviewStore.prototype.vendorDateStaySummary = function (eventPartyId) {
        return this.currentDateRoomTypeSummaryList
            .map(function (dateRoomTypeSummaries) { return dateRoomTypeSummaries != null ?
            dateRoomTypeSummaries.filter(function (dateRoomTypeSummary) { return dateRoomTypeSummary.eventPartyId === eventPartyId; })[0] : null; });
    };
    /**
     * Has to be called to retrieve Date Room Type Summary.
     * Is called by resolver.
     *
     * @param eventId
     * @returns DateRoomTypeDetail list
     */
    OverviewStore.prototype.loadDateRoomTypeSummary = function (eventId) {
        var _this = this;
        return this.overviewHttpService.getDateRoomTypeSummary(eventId)
            .catch(function (error) {
            _this.flashMessagesService.error('MESSAGES.ERROR.COULD_NOT_GET_DATE_ROOM_TYPE_SUMMARY', "Error retrieving summary: Total Rooms By Date & Room Type: " + error);
            return Observable["Observable"].throw(error);
        })
            .map(function (res) {
            _this.currentDateRoomTypeSummaryList.next(res);
            return res;
        });
    };
    /**
     * Has to be called to retrieve Date Room Type Summary.
     * Is called by resolver.
     *
     * @param eventId
     * @param eventPartyId
     * @returns DateRoomTypeDetail list
     */
    OverviewStore.prototype.loadDateRoomTypeSummaryByParty = function (eventId, eventPartyId) {
        var _this = this;
        return this.overviewHttpService.getDateRoomTypeSummaryByParty(eventId, eventPartyId)
            .catch(function (error) {
            _this.flashMessagesService.error('MESSAGES.ERROR.COULD_NOT_GET_DATE_ROOM_TYPE_SUMMARY', "Error retrieving summary: Total Rooms By Date & Room Type: " + error);
            return Observable["Observable"].throw(error);
        })
            .map(function (res) {
            _this.currentDateRoomTypeSummaryList.next(res);
            return res;
        });
    };
    return OverviewStore;
}());
overview_store_OverviewStore = overview_store___decorate([
    Object(core_es5["Injectable"])(),
    overview_store___metadata("design:paramtypes", [typeof (overview_store__a = typeof flash_messages_service_FlashMessagesService !== "undefined" && flash_messages_service_FlashMessagesService) === "function" && overview_store__a || Object, typeof (overview_store__b = typeof OverviewHttpService !== "undefined" && OverviewHttpService) === "function" && overview_store__b || Object])
], overview_store_OverviewStore);

var overview_store__a, overview_store__b;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/overview.store.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/overview/overview.resolver.ts
var overview_resolver___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var overview_resolver___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};



var OverviewResolver = (function () {
    function OverviewResolver(overviewStore, translateService) {
        this.overviewStore = overviewStore;
        this.translateService = translateService;
    }
    OverviewResolver.prototype.resolve = function (route, state) {
        var id = route.params['id'];
        var eventPartyId = route.params['eventPartyId'];
        if (!id) {
            throw new Error(this.translateService.instant('MESSAGES.ERROR.COULD_NOT_GET_OVERVIEW'));
        }
        if (eventPartyId) {
            return this.overviewStore.loadDateRoomTypeSummaryByParty(id, eventPartyId);
        }
        else {
            return this.overviewStore.loadDateRoomTypeSummary(id);
        }
    };
    return OverviewResolver;
}());
OverviewResolver = overview_resolver___decorate([
    Object(core_es5["Injectable"])(),
    overview_resolver___metadata("design:paramtypes", [typeof (overview_resolver__a = typeof overview_store_OverviewStore !== "undefined" && overview_store_OverviewStore) === "function" && overview_resolver__a || Object, typeof (overview_resolver__b = typeof core["c" /* TranslateService */] !== "undefined" && core["c" /* TranslateService */]) === "function" && overview_resolver__b || Object])
], OverviewResolver);

var overview_resolver__a, overview_resolver__b;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/overview.resolver.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/service/reservation-compare-http-service.ts
var reservation_compare_http_service___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var reservation_compare_http_service___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};





var reservation_compare_http_service_ReservationCompareService = (function () {
    function ReservationCompareService(http, environment, responseUtilService) {
        this.http = http;
        this.environment = environment;
        this.responseUtilService = responseUtilService;
        this.eventUrl = this.environment.baseUrl + '/api/events';
    }
    ReservationCompareService.prototype.get = function (eventId) {
        var _this = this;
        var reservationUrl = this.eventUrl + "/" + eventId + "/compare";
        return this.http.get(reservationUrl)
            .map(function (res) { return Object(immutable["List"])(res.json()); })
            .catch(function (response) { return _this.responseUtilService.handleError(response); }).share();
    };
    ReservationCompareService.prototype.getReservations = function (eventId) {
        var _this = this;
        var reservationUrl = this.eventUrl + "/" + eventId + "/reservations/compare";
        return this.http.get(reservationUrl)
            .map(function (res) { return Object(immutable["List"])(res.json()); })
            .catch(function (response) { return _this.responseUtilService.handleError(response); }).share();
    };
    ReservationCompareService.prototype.getReservationsByParty = function (eventId, eventPartyId) {
        var _this = this;
        var reservationUrl = this.eventUrl + "/" + eventId + "/" + eventPartyId + "/reservations/compare";
        return this.http.get(reservationUrl)
            .map(function (res) { return Object(immutable["List"])(res.json()); })
            .catch(function (response) { return _this.responseUtilService.handleError(response); }).share();
    };
    ReservationCompareService.prototype.getRsvps = function (eventId) {
        var _this = this;
        var reservationUrl = this.eventUrl + "/" + eventId + "/rsvps/compare";
        return this.http.get(reservationUrl)
            .map(function (res) { return Object(immutable["List"])(res.json()); })
            .catch(function (response) { return _this.responseUtilService.handleError(response); }).share();
    };
    ReservationCompareService.prototype.getRsvpsByParty = function (eventId, eventPartyId) {
        var _this = this;
        var reservationUrl = this.eventUrl + "/" + eventId + "/" + eventPartyId + "/rsvps/compare";
        return this.http.get(reservationUrl)
            .map(function (res) { return Object(immutable["List"])(res.json()); })
            .catch(function (response) { return _this.responseUtilService.handleError(response); }).share();
    };
    ReservationCompareService.prototype.getReservationsAndRsvps = function (eventId) {
        var _this = this;
        var reservationUrl = this.eventUrl + "/" + eventId + "/reservations/rsvps/compare";
        return this.http.get(reservationUrl)
            .map(function (res) { return Object(immutable["List"])(res.json()); })
            .catch(function (response) { return _this.responseUtilService.handleError(response); }).share();
    };
    ReservationCompareService.prototype.getReservationsAndRsvpsByParty = function (eventId, eventPartyId) {
        var _this = this;
        var reservationUrl = this.eventUrl + "/" + eventId + "/" + eventPartyId + "/reservations/rsvps/compare";
        return this.http.get(reservationUrl)
            .map(function (res) { return Object(immutable["List"])(res.json()); })
            .catch(function (response) { return _this.responseUtilService.handleError(response); }).share();
    };
    return ReservationCompareService;
}());
reservation_compare_http_service_ReservationCompareService = reservation_compare_http_service___decorate([
    Object(core_es5["Injectable"])(),
    reservation_compare_http_service___metadata("design:paramtypes", [typeof (reservation_compare_http_service__a = typeof AppAuthHttpService !== "undefined" && AppAuthHttpService) === "function" && reservation_compare_http_service__a || Object, typeof (reservation_compare_http_service__b = typeof EnvironmentConfiguration !== "undefined" && EnvironmentConfiguration) === "function" && reservation_compare_http_service__b || Object, typeof (reservation_compare_http_service__c = typeof response_util_service_ResponseUtilService !== "undefined" && response_util_service_ResponseUtilService) === "function" && reservation_compare_http_service__c || Object])
], reservation_compare_http_service_ReservationCompareService);

var reservation_compare_http_service__a, reservation_compare_http_service__b, reservation_compare_http_service__c;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/reservation-compare-http-service.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/utils/reservation-utils.ts




var reservation_utils_ReservationUtils = (function () {
    function ReservationUtils() {
    }
    /**
     * Do not include reservation value when the reservation no longer has possible value.
     *
     * If the record has a status of No Show or Cancelled exclude reservations from the calculations.
     *
     * @param reservation
     * @returns {boolean}
     */
    ReservationUtils.hasReservationValue = function (reservation) {
        var value = reservation.status;
        if (value) {
            value = value.toUpperCase();
        }
        var returnValue = false;
        switch (value) {
            case ReservationStatusCode.CANCELLED.toString():
                returnValue = false;
                break;
            case ReservationStatusCode.NO_SHOW.toString():
                returnValue = false;
                break;
            default:
                returnValue = true;
        }
        return returnValue;
    };
    ReservationUtils.getCommissionRate = function (vendor) {
        if (vendor) {
            return vendor.commissionRoomPercentage;
        }
        else {
            return 0;
        }
    };
    ReservationUtils.getRevenue = function (reservation) {
        if (this.hasReservationValue(reservation)) {
            return reservation.nights * reservation.roomRate * (reservation.rooms > 0 ? reservation.rooms : 1);
        }
        else {
            return 0;
        }
    };
    ReservationUtils.getCommission = function (reservation, vendor) {
        if (!this.hasReservationValue(reservation)) {
            return 0;
        }
        var revenue = reservation.revenue;
        if (!revenue) {
            revenue = this.getRevenue(reservation);
        }
        return (revenue * this.getCommissionRate(vendor)) / 100;
    };
    ReservationUtils.reservationCompareComparator = function (obj1, obj2) {
        var compareValue = ComparatorUtils.compareNullable(obj1, obj2);
        if (compareValue !== 0 || (Object(util_util["isNullOrUndefined"])(obj1) && Object(util_util["isNullOrUndefined"])(obj2))) {
            return compareValue;
        }
        compareValue = ComparatorUtils.compareNullable(obj1.reservation, obj2.reservation);
        if (compareValue !== 0 || (Object(util_util["isNullOrUndefined"])(obj1.reservation) && Object(util_util["isNullOrUndefined"])(obj2.reservation))) {
            return compareValue;
        }
        return ComparatorUtils.compareLastNameFirstName({ firstName: obj1.reservation.firstName, lastName: obj1.reservation.lastName }, { firstName: obj2.reservation.firstName, lastName: obj2.reservation.lastName });
    };
    ReservationUtils.rsvpCompareComparator = function (obj1, obj2) {
        var compareValue = ComparatorUtils.compareNullable(obj1, obj2);
        if (compareValue !== 0 || (Object(util_util["isNullOrUndefined"])(obj1) && Object(util_util["isNullOrUndefined"])(obj2))) {
            return compareValue;
        }
        compareValue = ComparatorUtils.compareNullable(obj1.rsvp, obj2.rsvp);
        if (compareValue !== 0 || (Object(util_util["isNullOrUndefined"])(obj1.rsvp) && Object(util_util["isNullOrUndefined"])(obj2.rsvp))) {
            return compareValue;
        }
        return ComparatorUtils.compareLastNameFirstName({ firstName: obj1.rsvp.firstName, lastName: obj1.rsvp.lastName }, { firstName: obj2.rsvp.firstName, lastName: obj2.rsvp.lastName });
    };
    ReservationUtils.calculateRevenueTotal = function (obsReservationList) {
        return obsReservationList.map(function (compareList) {
            return compareList
                .filter(function (compare) { return !Object(util_util["isNullOrUndefined"])(compare.reservation) && !Object(util_util["isNullOrUndefined"])(compare.reservation.revenue); })
                .map(function (compare) { return compare.reservation.revenue; })
                .reduce(function (prev, current) { return prev + current; }, 0);
        }).map(function (total) { return NumberUtils.round2Fixed(total); });
    };
    ReservationUtils.calculateCommissionTotal = function (obsReservationList) {
        return obsReservationList.map(function (compareList) {
            return compareList
                .filter(function (compare) { return !Object(util_util["isNullOrUndefined"])(compare.reservation) && !Object(util_util["isNullOrUndefined"])(compare.reservation.commission); })
                .map(function (compare) { return compare.reservation.commission; })
                .reduce(function (prev, current) { return prev + current; }, 0);
        }).map(function (total) { return NumberUtils.round2Fixed(total); });
    };
    ReservationUtils.calculateRsvpCommissionTotal = function (obsReservationList) {
        return obsReservationList.map(function (compareList) {
            return compareList
                .filter(function (compare) { return !Object(util_util["isNullOrUndefined"])(compare.rsvp) && !Object(util_util["isNullOrUndefined"])(compare.rsvp.commission); })
                .map(function (compare) { return compare.rsvp.commission; })
                .reduce(function (prev, current) { return prev + current; }, 0);
        }).map(function (total) { return NumberUtils.round2Fixed(total); });
    };
    ReservationUtils.calculateReservationTotalNights = function (obsReservationList) {
        return obsReservationList.map(function (compareList) {
            return compareList
                .filter(function (compare) { return !Object(util_util["isNullOrUndefined"])(compare.reservation) && !Object(util_util["isNullOrUndefined"])(compare.reservation.nights); })
                .map(function (compare) { return compare.reservation.nights; })
                .reduce(function (prev, current) { return prev + current; }, 0);
        });
    };
    ReservationUtils.isListEmpty = function (obsReservationList) {
        return ReservationUtils.getListSize(obsReservationList).map(function (compareListSize) { return compareListSize === 0; });
    };
    ReservationUtils.isTransientListEmpty = function (obsReservationList) {
        return ReservationUtils.getTransientListSize(obsReservationList).map(function (compareListSize) { return compareListSize === 0; });
    };
    ReservationUtils.getListSize = function (obsReservationList) {
        return obsReservationList.map(function (compareList) { return compareList.size; });
    };
    ReservationUtils.getTransientListSize = function (obsReservationList) {
        return obsReservationList.map(function (compareList) {
            return compareList.size;
        });
    };
    ReservationUtils.onlyReservationsFilter = function (reservationList) {
        return reservationList.filter(function (compare) { return compare.reservation ? true : false; }).toList();
    };
    ReservationUtils.onlyRsvpFilter = function (reservationList) {
        return reservationList.filter(function (compare) { return compare.rsvp ? true : false; }).toList();
    };
    ReservationUtils.getCompareByVendor = function (reservationList, eventPartyId) {
        return reservationList.filter(function (compare) { return compare.eventPartyId === eventPartyId; }).toList();
    };
    ReservationUtils.getNumberOfRsvps = function (obsReservationList) {
        var _this = this;
        return obsReservationList.map(function (compareList) {
            return (compareList ? _this.onlyRsvpFilter(compareList).size : 0);
        });
    };
    ReservationUtils.getNumberOfReservations = function (obsReservationList) {
        var _this = this;
        return obsReservationList.map(function (compareList) {
            return (compareList ? _this.onlyReservationsFilter(compareList).size : 0);
        });
    };
    return ReservationUtils;
}());

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/reservation-utils.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/service/reservation-compare-store.ts
var reservation_compare_store___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var reservation_compare_store___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};













var reservation_compare_store_ReservationCompareStore = ReservationCompareStore_1 = (function () {
    function ReservationCompareStore(flashMessagesService, reservationCompareService) {
        this.flashMessagesService = flashMessagesService;
        this.reservationCompareService = reservationCompareService;
        this.currentReservationList = new BehaviorSubject["BehaviorSubject"](Object(immutable["List"])([]));
        this.currentActiveStatusCodes = new BehaviorSubject["BehaviorSubject"](ReservationCompareStore_1.STATUS_CODES);
        this.currentReservationSummaryState = new BehaviorSubject["BehaviorSubject"](true);
        this.selectedRsvpId = null;
        this.selectedReservationId = null;
    }
    ReservationCompareStore.prototype.setActiveStatusCodes = function (statusCodes) {
        this.currentActiveStatusCodes.next(statusCodes);
    };
    ReservationCompareStore.prototype.getActiveStatusCodes = function () {
        return this.currentActiveStatusCodes.asObservable().share();
    };
    ReservationCompareStore.prototype.getInstantActiveStatusCodes = function () {
        return this.currentActiveStatusCodes.getValue();
    };
    ReservationCompareStore.prototype.getReservationList = function () {
        return this.currentReservationList.asObservable();
    };
    ReservationCompareStore.prototype.getVendorCompareList = function (eventPartyId) {
        return this.currentReservationList.map(function (filteredList) {
            return filteredList.filter(function (filtered) { return filtered.eventPartyId === eventPartyId; });
        });
    };
    ReservationCompareStore.prototype.getShowReservationCompareSummary = function () {
        return this.currentReservationSummaryState.asObservable();
    };
    ReservationCompareStore.prototype.setShowReservationCompareSummary = function (showSummary) {
        return this.currentReservationSummaryState.next(showSummary);
    };
    ReservationCompareStore.prototype.getReservations = function (eventId) {
        var _this = this;
        return this.reservationCompareService.getReservations(eventId)
            .catch(function (error) {
            _this.flashMessagesService.error('MESSAGES.ERROR.RESERVATION_COMPARE', "Error retrieving room details: " + error);
            return Observable["Observable"].throw(error);
        })
            .map(function (reservationList) {
            reservationList = reservationList.sort(reservation_utils_ReservationUtils.reservationCompareComparator).toList();
            _this.currentReservationList.next(reservationList);
            return reservationList;
        });
    };
    ReservationCompareStore.prototype.getReservationsByParty = function (eventId, eventPartyId) {
        var _this = this;
        return this.reservationCompareService.getReservationsByParty(eventId, eventPartyId)
            .catch(function (error) {
            _this.flashMessagesService.error('MESSAGES.ERROR.RESERVATION_COMPARE', "Error retrieving room details: " + error);
            return Observable["Observable"].throw(error);
        })
            .map(function (reservationList) {
            reservationList = reservationList.sort(reservation_utils_ReservationUtils.reservationCompareComparator).toList();
            _this.currentReservationList.next(reservationList);
            return reservationList;
        });
    };
    ReservationCompareStore.prototype.getFilteredReservations = function (eventId) {
        var _this = this;
        return this.getActiveStatusCodes().flatMap(function (statusCodes) {
            return _this.getReservations(eventId).map(function (reservationList) {
                return _this.getReservationListFilteredByStatus(reservationList, statusCodes);
            });
        });
    };
    ReservationCompareStore.prototype.getCurrentFilteredReservations = function () {
        var _this = this;
        return this.getActiveStatusCodes().flatMap(function (statusCodes) {
            return _this.getReservationList().map(function (reservationList) {
                return _this.getReservationListFilteredByStatus(reservationList, statusCodes);
            });
        });
    };
    ReservationCompareStore.prototype.getVendorCurrentFilteredReservations = function (eventPartyId) {
        var _this = this;
        return this.getActiveStatusCodes().flatMap(function (statusCodes) {
            return _this.getVendorCompareList(eventPartyId).map(function (reservationList) {
                return _this.getReservationListFilteredByStatus(reservationList, statusCodes);
            });
        });
    };
    ReservationCompareStore.prototype.getReservationListFilteredByStatus = function (reservationList, statusCodes) {
        return reservationList.filter(function (reservation) {
            return statusCodes.find(function (statusCode) { return statusCode.toString() === reservation.status; }) != null;
        }).toList();
    };
    ReservationCompareStore.prototype.resetStatusCodes = function () {
        this.setActiveStatusCodes(ReservationCompareStore_1.STATUS_CODES);
    };
    ReservationCompareStore.prototype.resetReservationList = function () {
        this.setReservationList(Object(immutable["List"])([]));
    };
    ReservationCompareStore.prototype.setReservationList = function (list) {
        this.currentReservationList.next(list);
    };
    ReservationCompareStore.prototype.isCompareListEmpty = function () {
        return reservation_utils_ReservationUtils.isListEmpty(this.currentReservationList);
    };
    ReservationCompareStore.prototype.isVendorCompareListEmpty = function (eventPartyId) {
        return reservation_utils_ReservationUtils.isListEmpty(this.getVendorCompareList(eventPartyId));
    };
    ReservationCompareStore.prototype.isFilteredMatchListEmpty = function (matchType) {
        return reservation_utils_ReservationUtils.isListEmpty(this.getCurrentFilteredReservations().map(function (comparisonList) {
            return comparisonList.filter(function (comparison) { return comparison.matchType === matchType.toString(); }).toList();
        }));
    };
    ReservationCompareStore.prototype.isVendorFilteredMatchListEmpty = function (matchType, eventPartyId) {
        return reservation_utils_ReservationUtils
            .isListEmpty(this.getVendorCurrentFilteredReservations(eventPartyId).map(function (comparisonList) {
            return comparisonList.filter(function (comparison) { return comparison.matchType === matchType.toString(); }).toList();
        }));
    };
    ReservationCompareStore.prototype.isMatchListEmpty = function (matchType) {
        return reservation_utils_ReservationUtils.isListEmpty(this.getReservationList().map(function (comparisonList) {
            return comparisonList.filter(function (comparison) { return comparison.matchType === matchType.toString(); }).toList();
        }));
    };
    ReservationCompareStore.prototype.areRsvpsPresent = function () {
        return reservation_utils_ReservationUtils.getNumberOfRsvps(this.getReservationList()).map(function (size) {
            return size > 0;
        });
    };
    ReservationCompareStore.prototype.areVendorRsvpsPresent = function (eventPartyId) {
        return reservation_utils_ReservationUtils.getNumberOfRsvps(this.getVendorCompareList(eventPartyId)).map(function (size) {
            return size > 0;
        });
    };
    ReservationCompareStore.prototype.areVendorReservationPresent = function (eventPartyId) {
        return reservation_utils_ReservationUtils.getNumberOfReservations(this.getVendorCompareList(eventPartyId)).map(function (size) {
            return size > 0;
        });
    };
    ReservationCompareStore.prototype.refreshCurrentReservationList = function (eventId) {
        var _this = this;
        this.reservationCompareService.getReservations(eventId)
            .pipe(Object(operators["take"])(1), Object(operators["catchError"])(function (error) {
            _this.flashMessagesService.error('MESSAGES.ERROR.RESERVATION_COMPARE', "Error retrieving room details: " + error);
            return Observable["Observable"].throw(error);
        }), Object(operators["map"])(function (reservationList) {
            return reservationList.sort(reservation_utils_ReservationUtils.reservationCompareComparator).toList();
        })).subscribe(function (reservationList) {
            _this.setReservationList(reservationList);
        });
    };
    ReservationCompareStore.prototype.refreshCurrentReservationListByParty = function (eventId, eventPartyId) {
        var _this = this;
        this.reservationCompareService.getReservationsByParty(eventId, eventPartyId)
            .pipe(Object(operators["take"])(1), Object(operators["catchError"])(function (error) {
            _this.flashMessagesService.error('MESSAGES.ERROR.RESERVATION_COMPARE', "Error retrieving room details: " + error);
            return Observable["Observable"].throw(error);
        }), Object(operators["map"])(function (reservationList) {
            return reservationList.sort(reservation_utils_ReservationUtils.reservationCompareComparator).toList();
        })).subscribe(function (reservationList) {
            _this.setReservationList(reservationList);
        });
    };
    ReservationCompareStore.prototype.getRsvps = function (eventId) {
        var _this = this;
        return this.reservationCompareService.getRsvps(eventId)
            .catch(function (error) {
            _this.flashMessagesService.error('MESSAGES.ERROR.RESERVATION_COMPARE', "Error retrieving room details: " + error);
            return Observable["Observable"].throw(error);
        })
            .map(function (reservationList) {
            reservationList = reservationList.sort(reservation_utils_ReservationUtils.rsvpCompareComparator).toList();
            _this.currentReservationList.next(reservationList);
            return reservationList;
        });
    };
    ReservationCompareStore.prototype.getRsvpsByParty = function (eventId, eventPartyId) {
        var _this = this;
        return this.reservationCompareService.getRsvpsByParty(eventId, eventPartyId)
            .catch(function (error) {
            _this.flashMessagesService.error('MESSAGES.ERROR.RESERVATION_COMPARE', "Error retrieving room details: " + error);
            return Observable["Observable"].throw(error);
        })
            .map(function (reservationList) {
            reservationList = reservationList.sort(reservation_utils_ReservationUtils.rsvpCompareComparator).toList();
            _this.currentReservationList.next(reservationList);
            return reservationList;
        });
    };
    ReservationCompareStore.prototype.refreshCurrentRsvpList = function (eventId) {
        var _this = this;
        this.reservationCompareService.getRsvps(eventId)
            .pipe(Object(operators["take"])(1), Object(operators["catchError"])(function (error) {
            _this.flashMessagesService.error('MESSAGES.ERROR.RESERVATION_COMPARE', "Error retrieving room details: " + error);
            return Observable["Observable"].throw(error);
        }), Object(operators["map"])(function (rsvpList) {
            return rsvpList.sort(reservation_utils_ReservationUtils.rsvpCompareComparator).toList();
        })).subscribe(function (reservationList) {
            _this.setReservationList(reservationList);
        });
    };
    ReservationCompareStore.prototype.refreshCurrentRsvpListByParty = function (eventId, eventPartyId) {
        var _this = this;
        this.reservationCompareService.getRsvpsByParty(eventId, eventPartyId)
            .pipe(Object(operators["take"])(1), Object(operators["catchError"])(function (error) {
            _this.flashMessagesService.error('MESSAGES.ERROR.RESERVATION_COMPARE', "Error retrieving room details: " + error);
            return Observable["Observable"].throw(error);
        }), Object(operators["map"])(function (rsvpList) {
            return rsvpList.sort(reservation_utils_ReservationUtils.rsvpCompareComparator).toList();
        })).subscribe(function (reservationList) {
            _this.setReservationList(reservationList);
        });
    };
    ReservationCompareStore.prototype.getReservationsAndRsvps = function (eventId) {
        var _this = this;
        return this.reservationCompareService.getReservationsAndRsvps(eventId)
            .catch(function (error) {
            _this.flashMessagesService.error('MESSAGES.ERROR.RESERVATION_COMPARE', "Error retrieving room details: " + error);
            return Observable["Observable"].throw(error);
        })
            .map(function (reservationList) {
            reservationList = reservationList.sort(reservation_utils_ReservationUtils.rsvpCompareComparator).toList();
            _this.currentReservationList.next(reservationList);
            return reservationList;
        });
    };
    ReservationCompareStore.prototype.getReservationsAndRsvpsByParty = function (eventId, eventPartyId) {
        var _this = this;
        return this.reservationCompareService.getReservationsAndRsvpsByParty(eventId, eventPartyId)
            .catch(function (error) {
            _this.flashMessagesService.error('MESSAGES.ERROR.RESERVATION_COMPARE', "Error retrieving room details: " + error);
            return Observable["Observable"].throw(error);
        })
            .map(function (reservationList) {
            reservationList = reservationList.sort(reservation_utils_ReservationUtils.rsvpCompareComparator).toList();
            _this.currentReservationList.next(reservationList);
            return reservationList;
        });
    };
    ReservationCompareStore.prototype.getHeaderSummary = function (recordType, matchType) {
        var _this = this;
        return this.getReservationList().flatMap(function (reservationList) {
            return _this.getActiveStatusCodes().map(function (statusCodes) {
                return _this.getHeaderSummaryData(_this.getReservationListFilteredByStatus(reservationList, statusCodes), recordType, matchType);
            });
        });
    };
    ReservationCompareStore.prototype.getVendorHeaderSummary = function (eventPartyId, recordType, matchType) {
        var _this = this;
        return this.getVendorCompareList(eventPartyId).flatMap(function (reservationList) {
            return _this.getActiveStatusCodes().map(function (statusCodes) {
                return _this.getHeaderSummaryData(_this.getReservationListFilteredByStatus(reservationList, statusCodes), recordType, matchType);
            });
        });
    };
    ReservationCompareStore.prototype.getHeaderSummaryData = function (dataList, recordType, matchType) {
        var totalNights = 0;
        var totalRevenue = 0;
        var avgRoomRate = 0;
        var totalItems = 0;
        var totalCommission = 0;
        var totalNightsReservations = 0;
        var totalRevenueReservations = 0;
        var totalItemsReservations = 0;
        var totalCommissionReservations = 0;
        var totalNightsRSVPs = 0;
        var totalRevenueRSVPs = 0;
        var totalItemsRSVPs = 0;
        var totalCommissionRSVPs = 0;
        if (recordType === SummaryRecordTypeEnum.RESERVATION) {
            totalNights = dataList
                .filter(function (compare) { return !Object(util_util["isNullOrUndefined"])(compare.reservation) && !Object(util_util["isNullOrUndefined"])(compare.reservation.roomNights); })
                .filter(function (compare) { return OVERVIEW_STATUS_CODES.find(function (statusCode) { return statusCode.toString() === compare.reservation.status; }) != null; })
                .filter(function (compare) { return matchType && compare.matchType === matchType.toString() || !matchType; })
                .map(function (compare) { return compare.reservation.roomNights; })
                .reduce(function (prev, current) { return prev + current; }, 0);
            totalRevenue = dataList
                .filter(function (compare) { return !Object(util_util["isNullOrUndefined"])(compare.reservation) && !Object(util_util["isNullOrUndefined"])(compare.reservation.revenue); })
                .filter(function (compare) { return OVERVIEW_STATUS_CODES.find(function (statusCode) { return statusCode.toString() === compare.reservation.status; }) != null; })
                .filter(function (compare) { return matchType && compare.matchType === matchType.toString() || !matchType; })
                .map(function (compare) { return compare.reservation.revenue; })
                .reduce(function (prev, current) { return prev + current; }, 0);
            totalItems = dataList
                .filter(function (compare) { return !Object(util_util["isNullOrUndefined"])(compare.reservation); })
                .filter(function (compare) { return OVERVIEW_STATUS_CODES.find(function (statusCode) { return statusCode.toString() === compare.reservation.status; }) != null; })
                .filter(function (compare) { return matchType && compare.matchType === matchType.toString() || !matchType; })
                .count();
            totalCommission = dataList
                .filter(function (compare) { return !Object(util_util["isNullOrUndefined"])(compare.reservation) && !Object(util_util["isNullOrUndefined"])(compare.reservation.commission); })
                .filter(function (compare) { return OVERVIEW_STATUS_CODES.find(function (statusCode) { return statusCode.toString() === compare.reservation.status; }) != null; })
                .filter(function (compare) { return matchType && compare.matchType === matchType.toString() || !matchType; })
                .map(function (compare) { return compare.reservation.commission; })
                .reduce(function (prev, current) { return prev + current; }, 0);
        }
        else if (recordType === SummaryRecordTypeEnum.RSVP) {
            totalNights = dataList
                .filter(function (compare) { return !Object(util_util["isNullOrUndefined"])(compare.rsvp) && !Object(util_util["isNullOrUndefined"])(compare.rsvp.nights); })
                .filter(function (compare) { return matchType && compare.matchType === matchType.toString() || !matchType; })
                .map(function (compare) { return compare.rsvp.nights; })
                .reduce(function (prev, current) { return prev + current; }, 0);
            totalRevenue = dataList
                .filter(function (compare) { return !Object(util_util["isNullOrUndefined"])(compare.rsvp) && !Object(util_util["isNullOrUndefined"])(compare.rsvp.revenue); })
                .filter(function (compare) { return matchType && compare.matchType === matchType.toString() || !matchType; })
                .map(function (compare) { return compare.rsvp.revenue; })
                .reduce(function (prev, current) { return prev + current; }, 0);
            totalItems = dataList
                .filter(function (compare) { return !Object(util_util["isNullOrUndefined"])(compare.rsvp); })
                .filter(function (compare) { return matchType && compare.matchType === matchType.toString() || !matchType; })
                .count();
            totalCommission = dataList
                .filter(function (compare) { return !Object(util_util["isNullOrUndefined"])(compare.rsvp) && !Object(util_util["isNullOrUndefined"])(compare.rsvp.commission); })
                .filter(function (compare) { return matchType && compare.matchType === matchType.toString() || !matchType; })
                .map(function (compare) { return compare.rsvp.commission; })
                .reduce(function (prev, current) { return prev + current; }, 0);
        }
        else if (recordType === SummaryRecordTypeEnum.RESERVATION_RSVP) {
            totalNightsReservations = dataList
                .filter(function (compare) { return !Object(util_util["isNullOrUndefined"])(compare.reservation) && !Object(util_util["isNullOrUndefined"])(compare.reservation.roomNights); })
                .filter(function (compare) { return OVERVIEW_STATUS_CODES.find(function (statusCode) { return statusCode.toString() === compare.reservation.status; }) != null; })
                .filter(function (compare) { return matchType && compare.matchType === matchType.toString() || !matchType; })
                .map(function (compare) { return compare.reservation.roomNights; })
                .reduce(function (prev, current) { return prev + current; }, 0);
            totalRevenueReservations = dataList
                .filter(function (compare) { return !Object(util_util["isNullOrUndefined"])(compare.reservation) && !Object(util_util["isNullOrUndefined"])(compare.reservation.revenue); })
                .filter(function (compare) { return OVERVIEW_STATUS_CODES.find(function (statusCode) { return statusCode.toString() === compare.reservation.status; }) != null; })
                .filter(function (compare) { return matchType && compare.matchType === matchType.toString() || !matchType; })
                .map(function (compare) { return compare.reservation.revenue; })
                .reduce(function (prev, current) { return prev + current; }, 0);
            totalItemsReservations = dataList
                .filter(function (compare) { return !Object(util_util["isNullOrUndefined"])(compare.reservation); })
                .filter(function (compare) { return OVERVIEW_STATUS_CODES.find(function (statusCode) { return statusCode.toString() === compare.reservation.status; }) != null; })
                .filter(function (compare) { return matchType && compare.matchType === matchType.toString() || !matchType; })
                .count();
            totalCommissionReservations = dataList
                .filter(function (compare) { return !Object(util_util["isNullOrUndefined"])(compare.reservation) && !Object(util_util["isNullOrUndefined"])(compare.reservation.commission); })
                .filter(function (compare) { return OVERVIEW_STATUS_CODES.find(function (statusCode) { return statusCode.toString() === compare.reservation.status; }) != null; })
                .filter(function (compare) { return matchType && compare.matchType === matchType.toString() || !matchType; })
                .map(function (compare) { return compare.reservation.commission; })
                .reduce(function (prev, current) { return prev + current; }, 0);
            totalNightsRSVPs = dataList
                .filter(function (compare) { return !Object(util_util["isNullOrUndefined"])(compare.rsvp) && !Object(util_util["isNullOrUndefined"])(compare.rsvp.nights); })
                .filter(function (compare) { return matchType && compare.matchType === matchType.toString() || !matchType; })
                .filter(function (compare) { return !compare.subscriber; })
                .map(function (compare) { return compare.rsvp.nights; })
                .reduce(function (prev, current) { return prev + current; }, 0);
            totalRevenueRSVPs = dataList
                .filter(function (compare) { return !Object(util_util["isNullOrUndefined"])(compare.rsvp) && !Object(util_util["isNullOrUndefined"])(compare.rsvp.revenue); })
                .filter(function (compare) { return matchType && compare.matchType === matchType.toString() || !matchType; })
                .filter(function (compare) { return !compare.subscriber; })
                .map(function (compare) { return compare.rsvp.revenue; })
                .reduce(function (prev, current) { return prev + current; }, 0);
            totalItemsRSVPs = dataList
                .filter(function (compare) { return !Object(util_util["isNullOrUndefined"])(compare.rsvp); })
                .filter(function (compare) { return matchType && compare.matchType === matchType.toString() || !matchType; })
                .filter(function (compare) { return !compare.subscriber; })
                .count();
            totalCommissionRSVPs = dataList
                .filter(function (compare) { return !Object(util_util["isNullOrUndefined"])(compare.rsvp) && !Object(util_util["isNullOrUndefined"])(compare.rsvp.commission); })
                .filter(function (compare) { return matchType && compare.matchType === matchType.toString() || !matchType; })
                .filter(function (compare) { return !compare.subscriber; })
                .map(function (compare) { return compare.rsvp.commission; })
                .reduce(function (prev, current) { return prev + current; }, 0);
            totalNights = totalNightsReservations + totalNightsRSVPs;
            totalRevenue = totalRevenueReservations + totalRevenueRSVPs;
            totalItems = totalItemsReservations + totalItemsRSVPs;
            totalCommission = totalCommissionReservations + totalCommissionRSVPs;
        }
        if (totalNights > 0) {
            avgRoomRate = totalRevenue / totalNights;
        }
        // Generate a room summary
        var staySummary = new StaySummary({
            totalNights: totalNights,
            totalCommission: totalCommission,
            totalRevenue: totalRevenue,
            avgRoomRate: avgRoomRate,
            totalItems: totalItems
        });
        return staySummary;
    };
    return ReservationCompareStore;
}());
reservation_compare_store_ReservationCompareStore.STATUS_CODES = [
    STATUS_CODE_RSVP,
    ReservationStatusCode.RESERVED,
    ReservationStatusCode.NO_SHOW,
    ReservationStatusCode.CANCELLED,
    ReservationStatusCode.CHECKED_OUT,
    ReservationStatusCode.CHECKED_IN
];
reservation_compare_store_ReservationCompareStore = ReservationCompareStore_1 = reservation_compare_store___decorate([
    Object(core_es5["Injectable"])(),
    reservation_compare_store___metadata("design:paramtypes", [typeof (reservation_compare_store__a = typeof flash_messages_service_FlashMessagesService !== "undefined" && flash_messages_service_FlashMessagesService) === "function" && reservation_compare_store__a || Object, typeof (reservation_compare_store__b = typeof reservation_compare_http_service_ReservationCompareService !== "undefined" && reservation_compare_http_service_ReservationCompareService) === "function" && reservation_compare_store__b || Object])
], reservation_compare_store_ReservationCompareStore);

var ReservationCompareStore_1, reservation_compare_store__a, reservation_compare_store__b;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/reservation-compare-store.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/overview/transaction.resolver.ts
var transaction_resolver___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var transaction_resolver___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};








var transaction_resolver_TransactionResolver = (function () {
    function TransactionResolver(reservationCompareStore, eventStore, translateService, flashMessagesService, logService, router) {
        var _this = this;
        this.reservationCompareStore = reservationCompareStore;
        this.eventStore = eventStore;
        this.translateService = translateService;
        this.flashMessagesService = flashMessagesService;
        this.logService = logService;
        this.router = router;
        this.previousRoute = null;
        // This code is required in order to know the previous route in resolve.
        // Note that first the NavigationStart event will happen, then resolve() is called if the resolver is attached
        // to the route, then NavigationEnd happens.
        this.router.events
            .filter(function (e) { return e instanceof router_es5["NavigationEnd"]; })
            .subscribe(function (e) {
            _this.previousRoute = e.url;
        });
    }
    TransactionResolver.prototype.resolve = function (route, state) {
        var _this = this;
        var id = route.params['id'];
        var eventPartyId = route.params['eventPartyId'];
        if (!id) {
            throw new Error(this.translateService.instant('MESSAGES.ERROR.COULD_NOT_GET_TRANSACTIONS'));
        }
        if (eventPartyId) {
            return this.eventStore.getEventByParty(id, eventPartyId).catch(function (error) {
                _this.flashMessagesService.error('MESSAGES.ERROR.COULD_NOT_GET_TRANSACTIONS', "Error retrieving transactions: " + error);
                return Observable["Observable"].throw(error);
            }).switchMap(function (event) {
                if (event.eventProperty && event.eventProperty.subscriber) {
                    return _this.reservationCompareStore.getReservationsByParty(id, eventPartyId).first();
                }
                else {
                    return _this.reservationCompareStore.getRsvpsByParty(id, eventPartyId).first();
                }
            });
        }
        else {
            return this.eventStore.getEvent(id).catch(function (error) {
                _this.flashMessagesService.error('MESSAGES.ERROR.COULD_NOT_GET_TRANSACTIONS', "Error retrieving transactions: " + error);
                return Observable["Observable"].throw(error);
            }).switchMap(function (event) {
                if (event.eventProperty && event.eventProperty.subscriber) {
                    return _this.reservationCompareStore.getReservations(id).first();
                }
                else {
                    return _this.reservationCompareStore.getRsvps(id).first();
                }
            });
        }
    };
    return TransactionResolver;
}());
transaction_resolver_TransactionResolver = transaction_resolver___decorate([
    Object(core_es5["Injectable"])(),
    transaction_resolver___metadata("design:paramtypes", [typeof (transaction_resolver__a = typeof reservation_compare_store_ReservationCompareStore !== "undefined" && reservation_compare_store_ReservationCompareStore) === "function" && transaction_resolver__a || Object, typeof (transaction_resolver__b = typeof event_store_EventStore !== "undefined" && event_store_EventStore) === "function" && transaction_resolver__b || Object, typeof (transaction_resolver__c = typeof core["c" /* TranslateService */] !== "undefined" && core["c" /* TranslateService */]) === "function" && transaction_resolver__c || Object, typeof (transaction_resolver__d = typeof flash_messages_service_FlashMessagesService !== "undefined" && flash_messages_service_FlashMessagesService) === "function" && transaction_resolver__d || Object, typeof (transaction_resolver__e = typeof log_service_LogService !== "undefined" && log_service_LogService) === "function" && transaction_resolver__e || Object, typeof (transaction_resolver__f = typeof router_es5["Router"] !== "undefined" && router_es5["Router"]) === "function" && transaction_resolver__f || Object])
], transaction_resolver_TransactionResolver);

var transaction_resolver__a, transaction_resolver__b, transaction_resolver__c, transaction_resolver__d, transaction_resolver__e, transaction_resolver__f;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/transaction.resolver.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/overview/vendor-overview-page/vendor-overview-page.component.ts
var vendor_overview_page_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var vendor_overview_page_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};










var vendor_overview_page_component_VendorOverviewComponent = (function () {
    function VendorOverviewComponent(eventStore, menuStore, route, authenticationSore, flashMessagesService) {
        this.eventStore = eventStore;
        this.menuStore = menuStore;
        this.route = route;
        this.authenticationSore = authenticationSore;
        this.flashMessagesService = flashMessagesService;
    }
    VendorOverviewComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.eventStore.selectedEvent.subscribe(function (event) { return _this.onyxEvent = event; });
        if (this.onyxEvent) {
            this.menuStore.setPageHeader(EventUtils.getEventName(this.onyxEvent, this.authenticationSore.isAgencyUser()), this.onyxEvent.eventProperty.subscriber);
        }
        // If the event property is subscribed, reservations are retrieved to build the overview.
        // Otherwise, RSVPs are
        if (this.onlySubscribers(this.onyxEvent)) {
            this.headerRecordType = SummaryRecordTypeEnum.RESERVATION;
        }
        else if (this.onlyNonSubscriber(this.onyxEvent)) {
            this.headerRecordType = SummaryRecordTypeEnum.RSVP;
        }
        else {
            this.headerRecordType = SummaryRecordTypeEnum.RESERVATION_RSVP;
        }
        this.total = 'total';
        // toggle page to editable if the URL ends with "edit" (it will default to read only)
        // otherwise, check if we need to show a warning flash message when in view modeFD
        route_utils_RouteUtils.getLastUrlSegment(this.route)
            .subscribe(function (lastSegment) {
            if (_this.authenticationSore.hasPermission('EditEvent') && !_this.isEventValid()) {
                _this.flashMessagesService.warn('EVENT.EVENT_MISSING_INFO', null, { hrefValue: "/#/event/" + _this.onyxEvent.eventId + "/summary/edit" });
            }
        });
    };
    VendorOverviewComponent.prototype.isEventValid = function () {
        return EventUtils.isEventValid(this.onyxEvent, this.authenticationSore.isAgencyUser());
    };
    VendorOverviewComponent.prototype.getEventProperties = function () {
        return this.onyxEvent.eventVendors.filter(function (vendor) { return vendor.partyType === PartyType.PROPERTY && vendor.payorType === 'PROPERTY'; });
    };
    VendorOverviewComponent.prototype.showTotalSummary = function () {
        return this.getEventProperties().length > 1;
    };
    VendorOverviewComponent.prototype.checkMoreThanOneVendorExpanded = function () {
        var expanded = false;
        this.getEventProperties().forEach(function (party) {
            if (!expanded && party.isExpanded) {
                expanded = true;
            }
            else if (expanded) {
                party.isExpanded = false;
            }
        });
    };
    VendorOverviewComponent.prototype.onlySubscribers = function (event) {
        var subscriberProperties = this.getSubscribers(event);
        var nonSubscriberProperties = this.getNonSubscribers(event);
        return subscriberProperties && subscriberProperties.length > 0 && (!nonSubscriberProperties || nonSubscriberProperties.length === 0);
    };
    VendorOverviewComponent.prototype.onlyNonSubscriber = function (event) {
        var subscriberProperties = this.getSubscribers(event);
        var nonSubscriberProperties = this.getNonSubscribers(event);
        return nonSubscriberProperties && nonSubscriberProperties.length > 0 && (!subscriberProperties || subscriberProperties.length === 0);
    };
    VendorOverviewComponent.prototype.getSubscribers = function (event) {
        return event.eventVendors
            .filter(function (vendor) { return vendor.partyType === PartyType.PROPERTY && vendor.payorType === 'PROPERTY' && vendor.subscriber; });
    };
    VendorOverviewComponent.prototype.getNonSubscribers = function (event) {
        return event.eventVendors
            .filter(function (vendor) { return vendor.partyType === PartyType.PROPERTY && vendor.payorType === 'PROPERTY' && !vendor.subscriber; });
    };
    return VendorOverviewComponent;
}());
vendor_overview_page_component_VendorOverviewComponent = vendor_overview_page_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-vendor-overview-page',
        template: __webpack_require__("32Uq")
    }),
    vendor_overview_page_component___metadata("design:paramtypes", [typeof (vendor_overview_page_component__a = typeof event_store_EventStore !== "undefined" && event_store_EventStore) === "function" && vendor_overview_page_component__a || Object, typeof (vendor_overview_page_component__b = typeof menu_store_MenuStore !== "undefined" && menu_store_MenuStore) === "function" && vendor_overview_page_component__b || Object, typeof (vendor_overview_page_component__c = typeof router_es5["ActivatedRoute"] !== "undefined" && router_es5["ActivatedRoute"]) === "function" && vendor_overview_page_component__c || Object, typeof (vendor_overview_page_component__d = typeof authentication_store_AuthenticationStore !== "undefined" && authentication_store_AuthenticationStore) === "function" && vendor_overview_page_component__d || Object, typeof (vendor_overview_page_component__e = typeof flash_messages_service_FlashMessagesService !== "undefined" && flash_messages_service_FlashMessagesService) === "function" && vendor_overview_page_component__e || Object])
], vendor_overview_page_component_VendorOverviewComponent);

var vendor_overview_page_component__a, vendor_overview_page_component__b, vendor_overview_page_component__c, vendor_overview_page_component__d, vendor_overview_page_component__e;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/vendor-overview-page.component.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/overview/vendor-transaction.resolver.ts
var vendor_transaction_resolver___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var vendor_transaction_resolver___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};









var vendor_transaction_resolver_VendorTransactionResolver = (function () {
    function VendorTransactionResolver(reservationCompareStore, eventStore, translateService, flashMessagesService, logService, router) {
        var _this = this;
        this.reservationCompareStore = reservationCompareStore;
        this.eventStore = eventStore;
        this.translateService = translateService;
        this.flashMessagesService = flashMessagesService;
        this.logService = logService;
        this.router = router;
        this.previousRoute = null;
        // This code is required in order to know the previous route in resolve.
        // Note that first the NavigationStart event will happen, then resolve() is called if the resolver is attached
        // to the route, then NavigationEnd happens.
        this.router.events
            .filter(function (e) { return e instanceof router_es5["NavigationEnd"]; })
            .subscribe(function (e) {
            _this.previousRoute = e.url;
        });
    }
    VendorTransactionResolver.prototype.resolve = function (route, state) {
        var _this = this;
        var id = route.params['id'];
        var eventPartyId = route.params['eventPartyId'];
        if (!id) {
            throw new Error(this.translateService.instant('MESSAGES.ERROR.COULD_NOT_GET_TRANSACTIONS'));
        }
        if (eventPartyId) {
            return this.eventStore.getEvent(id).catch(function (error) {
                _this.flashMessagesService.error('MESSAGES.ERROR.COULD_NOT_GET_TRANSACTIONS', "Error retrieving transactions: " + error);
                return Observable["Observable"].throw(error);
            }).switchMap(function (event) {
                if (_this.onlySubscribers(event)) {
                    return _this.reservationCompareStore.getReservationsByParty(id, eventPartyId).first();
                }
                else if (_this.onlyNonSubscriber(event)) {
                    return _this.reservationCompareStore.getRsvpsByParty(id, eventPartyId).first();
                }
                else {
                    return _this.reservationCompareStore.getReservationsAndRsvpsByParty(id, eventPartyId).first();
                }
            });
        }
        else {
            return this.eventStore.getEvent(id).catch(function (error) {
                _this.flashMessagesService.error('MESSAGES.ERROR.COULD_NOT_GET_TRANSACTIONS', "Error retrieving transactions: " + error);
                return Observable["Observable"].throw(error);
            }).switchMap(function (event) {
                if (_this.onlySubscribers(event)) {
                    return _this.reservationCompareStore.getReservations(id).first();
                }
                else if (_this.onlyNonSubscriber(event)) {
                    return _this.reservationCompareStore.getRsvps(id).first();
                }
                else {
                    return _this.reservationCompareStore.getReservationsAndRsvps(id).first();
                }
            });
        }
    };
    VendorTransactionResolver.prototype.onlySubscribers = function (event) {
        var subscriberProperties = this.getSubscribers(event);
        var nonSubscriberProperties = this.getNonSubscribers(event);
        return subscriberProperties && subscriberProperties.length > 0 && (!nonSubscriberProperties || nonSubscriberProperties.length === 0);
    };
    VendorTransactionResolver.prototype.onlyNonSubscriber = function (event) {
        var subscriberProperties = this.getSubscribers(event);
        var nonSubscriberProperties = this.getNonSubscribers(event);
        return nonSubscriberProperties && nonSubscriberProperties.length > 0 && (!subscriberProperties || subscriberProperties.length === 0);
    };
    VendorTransactionResolver.prototype.getSubscribers = function (event) {
        return event.eventVendors
            .filter(function (vendor) { return vendor.partyType === PartyType.PROPERTY && vendor.payorType === 'PROPERTY' && vendor.subscriber; });
    };
    VendorTransactionResolver.prototype.getNonSubscribers = function (event) {
        return event.eventVendors
            .filter(function (vendor) { return vendor.partyType === PartyType.PROPERTY && vendor.payorType === 'PROPERTY' && !vendor.subscriber; });
    };
    return VendorTransactionResolver;
}());
vendor_transaction_resolver_VendorTransactionResolver = vendor_transaction_resolver___decorate([
    Object(core_es5["Injectable"])(),
    vendor_transaction_resolver___metadata("design:paramtypes", [typeof (vendor_transaction_resolver__a = typeof reservation_compare_store_ReservationCompareStore !== "undefined" && reservation_compare_store_ReservationCompareStore) === "function" && vendor_transaction_resolver__a || Object, typeof (vendor_transaction_resolver__b = typeof event_store_EventStore !== "undefined" && event_store_EventStore) === "function" && vendor_transaction_resolver__b || Object, typeof (vendor_transaction_resolver__c = typeof core["c" /* TranslateService */] !== "undefined" && core["c" /* TranslateService */]) === "function" && vendor_transaction_resolver__c || Object, typeof (vendor_transaction_resolver__d = typeof flash_messages_service_FlashMessagesService !== "undefined" && flash_messages_service_FlashMessagesService) === "function" && vendor_transaction_resolver__d || Object, typeof (vendor_transaction_resolver__e = typeof log_service_LogService !== "undefined" && log_service_LogService) === "function" && vendor_transaction_resolver__e || Object, typeof (vendor_transaction_resolver__f = typeof router_es5["Router"] !== "undefined" && router_es5["Router"]) === "function" && vendor_transaction_resolver__f || Object])
], vendor_transaction_resolver_VendorTransactionResolver);

var vendor_transaction_resolver__a, vendor_transaction_resolver__b, vendor_transaction_resolver__c, vendor_transaction_resolver__d, vendor_transaction_resolver__e, vendor_transaction_resolver__f;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/vendor-transaction.resolver.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/service/adjustment-type/adjustment-type.http-service.ts
var adjustment_type_http_service___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var adjustment_type_http_service___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};





var adjustment_type_http_service_AdjustmentTypeHttpService = (function () {
    function AdjustmentTypeHttpService(http, environment, responseUtilService) {
        this.http = http;
        this.environment = environment;
        this.responseUtilService = responseUtilService;
        this.adjustmentTypesUrl = this.environment.baseUrl + '/api/adjustment-type';
    }
    AdjustmentTypeHttpService.prototype.getAllAdjustmentTypes = function () {
        return this.get('/all');
    };
    AdjustmentTypeHttpService.prototype.getCreditAdjustmentTypes = function () {
        return this.get('/credit');
    };
    AdjustmentTypeHttpService.prototype.getDebitAdjustmentTypes = function () {
        return this.get('/debit');
    };
    AdjustmentTypeHttpService.prototype.get = function (endpoint) {
        var _this = this;
        return this.http.get("" + this.adjustmentTypesUrl + endpoint)
            .catch(function (error) {
            _this.responseUtilService.handleError(error);
            return Observable["Observable"].throw(error);
        })
            .map(function (response) {
            return response.json();
        })
            .share();
    };
    return AdjustmentTypeHttpService;
}());
adjustment_type_http_service_AdjustmentTypeHttpService = adjustment_type_http_service___decorate([
    Object(core_es5["Injectable"])(),
    adjustment_type_http_service___metadata("design:paramtypes", [typeof (adjustment_type_http_service__a = typeof AppAuthHttpService !== "undefined" && AppAuthHttpService) === "function" && adjustment_type_http_service__a || Object, typeof (adjustment_type_http_service__b = typeof EnvironmentConfiguration !== "undefined" && EnvironmentConfiguration) === "function" && adjustment_type_http_service__b || Object, typeof (adjustment_type_http_service__c = typeof response_util_service_ResponseUtilService !== "undefined" && response_util_service_ResponseUtilService) === "function" && adjustment_type_http_service__c || Object])
], adjustment_type_http_service_AdjustmentTypeHttpService);

var adjustment_type_http_service__a, adjustment_type_http_service__b, adjustment_type_http_service__c;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/adjustment-type.http-service.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/adjustment-sign.enum.ts
var AdjustmentSign;
(function (AdjustmentSign) {
    AdjustmentSign[AdjustmentSign["CREDIT"] = 'CREDIT'] = "CREDIT";
    AdjustmentSign[AdjustmentSign["DEBIT"] = 'DEBIT'] = "DEBIT";
})(AdjustmentSign || (AdjustmentSign = {}));
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/adjustment-sign.enum.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/service/adjustment-type/adjustment-type.store.ts
var adjustment_type_store___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var adjustment_type_store___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};








var adjustment_type_store_AdjustmentTypeStore = (function () {
    function AdjustmentTypeStore(adjustmentTypeHttpService, flashMessagesService, translateService) {
        this.adjustmentTypeHttpService = adjustmentTypeHttpService;
        this.flashMessagesService = flashMessagesService;
        this.translateService = translateService;
        this.creditAdjustmentTypes = new ReplaySubject["ReplaySubject"](1);
        this.debitAdjustmentTypes = new ReplaySubject["ReplaySubject"](1);
    }
    AdjustmentTypeStore.prototype.loadCreditAdjustmentTypes = function () {
        return this.loadAdjustmentTypes(AdjustmentSign.CREDIT);
    };
    AdjustmentTypeStore.prototype.loadDebitAdjustmentTypes = function () {
        return this.loadAdjustmentTypes(AdjustmentSign.DEBIT);
    };
    AdjustmentTypeStore.prototype.getCreditAdjustmentTypes = function () {
        return this.creditAdjustmentTypes.asObservable();
    };
    AdjustmentTypeStore.prototype.getDebitAdjustmentTypes = function () {
        return this.debitAdjustmentTypes.asObservable();
    };
    AdjustmentTypeStore.prototype.getAdjustmentType = function (id, adjustmentSign) {
        var adjustmentTypesSubject = AdjustmentSign.CREDIT === adjustmentSign ? this.creditAdjustmentTypes : this.debitAdjustmentTypes;
        return adjustmentTypesSubject.map(function (adjustmentTypes) { return adjustmentTypes.find(function (adjustmentType) { return adjustmentType.id === id; }); });
    };
    AdjustmentTypeStore.prototype.loadAdjustmentTypes = function (adjustmentSign) {
        var _this = this;
        return (AdjustmentSign.CREDIT === adjustmentSign
            ? this.adjustmentTypeHttpService.getCreditAdjustmentTypes()
            : this.adjustmentTypeHttpService.getDebitAdjustmentTypes())
            .catch(function (error) {
            _this.flashMessagesService.error(_this.translateService.instant('MESSAGES.ERROR.COULD_NOT_GET_ADJUSTMENTS'));
            return Observable["Observable"].throw(error);
        })
            .pipe(Object(operators["tap"])(function (result) {
            AdjustmentSign.CREDIT === adjustmentSign ? _this.creditAdjustmentTypes.next(result) : _this.debitAdjustmentTypes.next(result);
        }));
    };
    return AdjustmentTypeStore;
}());
adjustment_type_store_AdjustmentTypeStore = adjustment_type_store___decorate([
    Object(core_es5["Injectable"])(),
    adjustment_type_store___metadata("design:paramtypes", [typeof (adjustment_type_store__a = typeof adjustment_type_http_service_AdjustmentTypeHttpService !== "undefined" && adjustment_type_http_service_AdjustmentTypeHttpService) === "function" && adjustment_type_store__a || Object, typeof (adjustment_type_store__b = typeof flash_messages_service_FlashMessagesService !== "undefined" && flash_messages_service_FlashMessagesService) === "function" && adjustment_type_store__b || Object, typeof (adjustment_type_store__c = typeof core["c" /* TranslateService */] !== "undefined" && core["c" /* TranslateService */]) === "function" && adjustment_type_store__c || Object])
], adjustment_type_store_AdjustmentTypeStore);

var adjustment_type_store__a, adjustment_type_store__b, adjustment_type_store__c;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/adjustment-type.store.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/payment/adjustment-type-credit.resolver.ts
var adjustment_type_credit_resolver___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var adjustment_type_credit_resolver___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};


var AdjustmentTypeCreditResolver = (function () {
    function AdjustmentTypeCreditResolver(adjustmentTypeStore) {
        this.adjustmentTypeStore = adjustmentTypeStore;
    }
    AdjustmentTypeCreditResolver.prototype.resolve = function () {
        return this.adjustmentTypeStore.loadCreditAdjustmentTypes();
    };
    return AdjustmentTypeCreditResolver;
}());
AdjustmentTypeCreditResolver = adjustment_type_credit_resolver___decorate([
    Object(core_es5["Injectable"])(),
    adjustment_type_credit_resolver___metadata("design:paramtypes", [typeof (adjustment_type_credit_resolver__a = typeof adjustment_type_store_AdjustmentTypeStore !== "undefined" && adjustment_type_store_AdjustmentTypeStore) === "function" && adjustment_type_credit_resolver__a || Object])
], AdjustmentTypeCreditResolver);

var adjustment_type_credit_resolver__a;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/adjustment-type-credit.resolver.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/payment/adjustment-type-debit.resolver.ts
var adjustment_type_debit_resolver___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var adjustment_type_debit_resolver___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};


var AdjustmentTypeDebitResolver = (function () {
    function AdjustmentTypeDebitResolver(adjustmentTypeStore) {
        this.adjustmentTypeStore = adjustmentTypeStore;
    }
    AdjustmentTypeDebitResolver.prototype.resolve = function () {
        return this.adjustmentTypeStore.loadDebitAdjustmentTypes();
    };
    return AdjustmentTypeDebitResolver;
}());
AdjustmentTypeDebitResolver = adjustment_type_debit_resolver___decorate([
    Object(core_es5["Injectable"])(),
    adjustment_type_debit_resolver___metadata("design:paramtypes", [typeof (adjustment_type_debit_resolver__a = typeof adjustment_type_store_AdjustmentTypeStore !== "undefined" && adjustment_type_store_AdjustmentTypeStore) === "function" && adjustment_type_debit_resolver__a || Object])
], AdjustmentTypeDebitResolver);

var adjustment_type_debit_resolver__a;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/adjustment-type-debit.resolver.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/service/ooiv-rules.http.service.ts
var ooiv_rules_http_service___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var ooiv_rules_http_service___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};




var OoivRulesHttpService = (function () {
    function OoivRulesHttpService(http, environment, responseUtilService) {
        this.http = http;
        this.environment = environment;
        this.responseUtilService = responseUtilService;
        this.eventsOOIVGetUrl = this.environment.baseUrl + '/api/events/ooiv';
    }
    OoivRulesHttpService.prototype.getOoivRules = function (eventId) {
        var _this = this;
        return this.http.get(this.eventsOOIVGetUrl + "/" + eventId + "/rules")
            .map(function (response) { return response.json(); })
            .catch(function (response) { return _this.responseUtilService.handleError(response); }).share();
    };
    return OoivRulesHttpService;
}());
OoivRulesHttpService = ooiv_rules_http_service___decorate([
    Object(core_es5["Injectable"])(),
    ooiv_rules_http_service___metadata("design:paramtypes", [typeof (ooiv_rules_http_service__a = typeof AppAuthHttpService !== "undefined" && AppAuthHttpService) === "function" && ooiv_rules_http_service__a || Object, typeof (ooiv_rules_http_service__b = typeof EnvironmentConfiguration !== "undefined" && EnvironmentConfiguration) === "function" && ooiv_rules_http_service__b || Object, typeof (ooiv_rules_http_service__c = typeof response_util_service_ResponseUtilService !== "undefined" && response_util_service_ResponseUtilService) === "function" && ooiv_rules_http_service__c || Object])
], OoivRulesHttpService);

var ooiv_rules_http_service__a, ooiv_rules_http_service__b, ooiv_rules_http_service__c;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/ooiv-rules.http.service.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/service/ooiv-rules.store.ts
var ooiv_rules_store___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var ooiv_rules_store___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};







var ooiv_rules_store_OoivRulesStore = (function () {
    function OoivRulesStore(ooivRulesHttpService, logService, flashMessagesService, translateService) {
        this.ooivRulesHttpService = ooivRulesHttpService;
        this.logService = logService;
        this.flashMessagesService = flashMessagesService;
        this.translateService = translateService;
        // This is the same as BehaviorSubject but without a default value
        this.ooivRulesList = new ReplaySubject["ReplaySubject"](1);
    }
    OoivRulesStore.prototype.getVendorOoivExceptionRules = function (eventPartyId) {
        return this.ooivRulesList
            .map(function (rules) { return rules != null ? rules.filter(function (rule) { return rule.eventPartyId === eventPartyId; })[0] : null; });
    };
    OoivRulesStore.prototype.getAnyOoivExceptionRule = function () {
        return this.ooivRulesList
            .map(function (rules) { return rules != null ? rules.filter(function (rule) { return rule.ooivExceptionsIsValid === false && rule.isAgency === false; })[0] : null; });
    };
    OoivRulesStore.prototype.getAgencyOoivExceptionRule = function () {
        return this.ooivRulesList
            .map(function (rules) { return rules != null ? rules.filter(function (rule) { return rule.ooivExceptionsIsValid === false && rule.isAgency === true; })[0] : null; });
    };
    OoivRulesStore.prototype.loadOoivExceptionRules = function (eventId) {
        var _this = this;
        return this.ooivRulesHttpService.getOoivRules(eventId)
            .catch(function (error) {
            _this.flashMessagesService.error(_this.translateService.instant('MESSAGES.ERROR.GET_OOIV_RULES'));
            _this.logService.error("Error fetching OOIV rules: " + error);
            return Observable["Observable"].throw(error);
        })
            .map(function (result) {
            _this.ooivRulesList.next(result);
            return result;
        });
    };
    return OoivRulesStore;
}());
ooiv_rules_store_OoivRulesStore = ooiv_rules_store___decorate([
    Object(core_es5["Injectable"])(),
    ooiv_rules_store___metadata("design:paramtypes", [typeof (ooiv_rules_store__a = typeof OoivRulesHttpService !== "undefined" && OoivRulesHttpService) === "function" && ooiv_rules_store__a || Object, typeof (ooiv_rules_store__b = typeof log_service_LogService !== "undefined" && log_service_LogService) === "function" && ooiv_rules_store__b || Object, typeof (ooiv_rules_store__c = typeof flash_messages_service_FlashMessagesService !== "undefined" && flash_messages_service_FlashMessagesService) === "function" && ooiv_rules_store__c || Object, typeof (ooiv_rules_store__d = typeof core["c" /* TranslateService */] !== "undefined" && core["c" /* TranslateService */]) === "function" && ooiv_rules_store__d || Object])
], ooiv_rules_store_OoivRulesStore);

var ooiv_rules_store__a, ooiv_rules_store__b, ooiv_rules_store__c, ooiv_rules_store__d;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/ooiv-rules.store.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/payment/commission/commission.component.ts
var commission_component___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var commission_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var commission_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};





















var commission_component_CommissionComponent = (function (_super) {
    commission_component___extends(CommissionComponent, _super);
    function CommissionComponent(formBuilder, menuStore, eventStore, paymentStore, authenticationStore, groupPayConfigStore, reportService, eventValidationService, flashMessagesService, translateService, ooivRulesStore, router) {
        var _this = _super.call(this) || this;
        _this.formBuilder = formBuilder;
        _this.menuStore = menuStore;
        _this.eventStore = eventStore;
        _this.paymentStore = paymentStore;
        _this.authenticationStore = authenticationStore;
        _this.groupPayConfigStore = groupPayConfigStore;
        _this.reportService = reportService;
        _this.eventValidationService = eventValidationService;
        _this.flashMessagesService = flashMessagesService;
        _this.translateService = translateService;
        _this.ooivRulesStore = ooivRulesStore;
        _this.router = router;
        _this.displayedPrepayment = false;
        _this.isCollapsedAddAdjustment = true;
        _this.canMakePrepayment = false;
        _this.showPrepaymentHintText = true;
        _this.ui = {
            showAddPayment: false,
            showPaymentRecord: false,
            showPaymentSummary: false,
            showDownloadDropdown: false
        };
        _this.ooivRulesValidation = true;
        _this.ooivEntityReady = true;
        return _this;
    }
    CommissionComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.addSubscription(this.eventStore.selectedEvent.subscribe(function (event) {
            _this.onyxEvent = new OnyxEvent(event);
        }));
        this.addSubscription(this.paymentStore.getVendorFinalPaymentStatusList(this.onyxEvent.eventProperty.eventPartyId).subscribe(function (finalPaymentStatusList) {
            _this.finalPaymentStatusList = finalPaymentStatusList;
        }));
        this.addSubscription(this.paymentStore.getLatestVendorFinalPayments().subscribe(function (latestPayments) {
            _this.latestPayment = latestPayments != null && latestPayments.length > 0 ? latestPayments[0] : undefined;
            var latestFinalPaymentStatus = _this.latestPayment ? _this.latestPayment.status : undefined;
            if (latestFinalPaymentStatus) {
                _this.ui.showPaymentSummary = [PaymentStatus.REQUEST_REJECTED, PaymentStatus.REJECTED_WF_APPROVAL]
                    .every(function (status) { return status !== latestFinalPaymentStatus; });
                _this.ui.showAddPayment = !_this.ui.showPaymentSummary;
                _this.ui.showDownloadDropdown = true;
                _this.isFinalPaymentAuthorized = latestFinalPaymentStatus !== PaymentStatus.REJECTED_WF_APPROVAL;
            }
            else {
                _this.ui.showPaymentSummary = false;
                _this.ui.showAddPayment = true;
                _this.ui.showDownloadDropdown = false;
                _this.isFinalPaymentAuthorized = false;
            }
            _this.addSubscription(_this.getPrepayment().subscribe(function (prepayment) {
                _this.prepayment = prepayment;
                _this.hasPrepayment = prepayment ? true : false;
                if (latestFinalPaymentStatus || _this.hasPrepayment) {
                    _this.ui.showPaymentRecord = true;
                }
                else {
                    _this.ui.showPaymentRecord = false;
                }
            }));
            _this.addSubscription(_this.flashMessagesService.closeMessageStream.subscribe(function (flashMessage) {
                if (flashMessage && flashMessage.message
                    && flashMessage.message.includes('Unable to determine Tax. Please try again in few minutes.')) {
                    _this.router.navigate(['/event', _this.onyxEvent.eventId, _this.onyxEvent.eventProperty.eventPartyId, 'summary']);
                }
            }));
        }));
        this.commissionForm = this.formBuilder.group({});
        if (this.onyxEvent && EventUtils.getEventName(this.onyxEvent, this.authenticationStore.isAgencyUser())) {
            this.menuStore.setPageHeader(EventUtils.getEventName(this.onyxEvent, this.authenticationStore.isAgencyUser()), this.onyxEvent.eventProperty.subscriber);
        }
        else {
            this.menuStore.setPageHeader('EVENT.EVENT_INFO_TITLE', false);
        }
        this.addSubscription(this.getMinAmount().subscribe(function (minAmount) {
            _this.minAmountPrepayment = minAmount;
        }));
        this.checkPrepaymentPermissions();
        this.canAddAdjustment$ = this.eventValidationService.canAddAdjustments();
        this.addSubscription(this.ooivRulesStore.getVendorOoivExceptionRules(this.onyxEvent.eventProperty.eventPartyId)
            .subscribe(function (rule) {
            if (rule) {
                _this.ooivRulesValidation = rule.ooivExceptionsIsValid;
            }
            if (_this.ooivRulesValidation) {
                _this.addSubscription(_this.ooivRulesStore.getAgencyOoivExceptionRule().subscribe(function (agencyRule) {
                    if (agencyRule) {
                        _this.ooivEntityReady = agencyRule.ooivExceptionsIsValid;
                    }
                }));
            }
        }));
        if (!this.ooivRulesValidation) {
            // this.flashMessagesService.error(this.translateService.instant('MESSAGES.ERROR.ADDITIONAL_TAX_INFO_PROMPT',
            //   {'role': this.authenticationStore.isPropertyUser() ? 'Agency' : 'Property'}));
            this.flashMessagesService.error(this.translateService.instant('MESSAGES.ERROR.ADDITIONAL_TAX_INFO_PROMPT', { 'role': 'Agency' }));
        }
        if (!this.ooivEntityReady) {
            this.flashMessagesService.error(this.translateService.instant('MESSAGES.ERROR.ENROLLMENT_NOT_COMPLETED_PROMPT'));
        }
    };
    CommissionComponent.prototype.displayPrepaymentClick = function () {
        this.displayedPrepayment = true;
    };
    CommissionComponent.prototype.onAddPrepayment = function () {
        this.displayedPrepayment = false;
        this.hasPrepayment = true;
    };
    CommissionComponent.prototype.onCancelPrepayment = function () {
        this.displayedPrepayment = false;
    };
    CommissionComponent.prototype.isUserApprover = function () {
        return this.authenticationStore.hasPermission('AuthorizePayment');
    };
    CommissionComponent.prototype.displayAddPrepaymentButton = function () {
        return !this.displayedPrepayment && !this.hasPrepayment && !this.isEventStarted() && !this.isFinalPaymentAuthorized
            && !this.authenticationStore.isAgencyUser();
    };
    CommissionComponent.prototype.isEventStarted = function () {
        var _startDate = EventUtils.getEventStartDate(this.onyxEvent, this.authenticationStore.isAgencyUser());
        var eventStartDate = date_util_DateUtil.parseDate(_startDate).getTime();
        return (eventStartDate < Date.now());
    };
    CommissionComponent.prototype.getPrepayment = function () {
        return this.paymentStore.getVendorPrepayment(this.onyxEvent.eventProperty.eventPartyId).map(function (prepayment) {
            return prepayment && prepayment.status ? prepayment : null;
        }).share();
    };
    CommissionComponent.prototype.getMinAmount = function () {
        return this.groupPayConfigStore.loadConfig(ConfigLookupType.PREPAYMENT_MIN_AMOUNT, this.onyxEvent.eventProperty.chain, this.onyxEvent.eventProperty.brand, this.onyxEvent.eventProperty.propertyId, this.onyxEvent.eventAgency.code)
            .map(function (response) {
            return response ? JSON.parse(response.value) : null;
        });
    };
    CommissionComponent.prototype.checkPrepaymentPermissions = function () {
        this.showPrepaymentHintText = this.displayAddPrepaymentButton() && !EventUtils.doesEventHaveAgency(this.onyxEvent);
        this.canMakePrepayment = this.isUserApprover() && EventUtils.doesEventHaveAgency(this.onyxEvent);
    };
    CommissionComponent.prototype.addAdjustmentClick = function () {
        this.isCollapsedAddAdjustment = false;
    };
    CommissionComponent.prototype.displayAddAdjustmentButton = function () {
        return this.ui.showAddPayment && this.isCollapsedAddAdjustment;
    };
    /**
     *  If it is an agency user and the event property is subscriber,
     *  the addAdjustment button must be disabled
     * @returns {boolean}
     */
    CommissionComponent.prototype.disableAddAdjustmentButton = function () {
        var disable;
        if (this.authenticationStore.isAgencyUser() && this.onyxEvent.eventProperty.subscriber) {
            disable = true;
        }
        else {
            disable = false;
        }
        return disable;
    };
    CommissionComponent.prototype.onAddAdjustment = function () {
        this.isCollapsedAddAdjustment = true;
    };
    CommissionComponent.prototype.onCancelAdjustment = function () {
        this.isCollapsedAddAdjustment = true;
    };
    CommissionComponent.prototype.getPaymentsReport = function (fileType) {
        var _this = this;
        this.addSubscription(this.reportService.getPaymentsReport(this.onyxEvent.eventId, this.onyxEvent.eventProperty.eventPartyId, fileType)
            .subscribe(function (blob) {
            var filename = response_util_ResponseUtil.getFileNameFromHttpResponse(blob);
            if (!filename) {
                filename = _this.reportService.buildReportFileName(ReportType.PAYMENT_SUMMARY, _this.onyxEvent, fileType);
            }
            saveAs(blob.body, filename);
        }));
    };
    return CommissionComponent;
}(unsubscriber_Unsubscriber));
commission_component_CommissionComponent = commission_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-commission',
        template: __webpack_require__("Xi0/"),
        styles: [__webpack_require__("DxtM")]
    }),
    commission_component___metadata("design:paramtypes", [typeof (commission_component__a = typeof forms_es5["FormBuilder"] !== "undefined" && forms_es5["FormBuilder"]) === "function" && commission_component__a || Object, typeof (commission_component__b = typeof menu_store_MenuStore !== "undefined" && menu_store_MenuStore) === "function" && commission_component__b || Object, typeof (commission_component__c = typeof event_store_EventStore !== "undefined" && event_store_EventStore) === "function" && commission_component__c || Object, typeof (commission_component__d = typeof payment_store_PaymentStore !== "undefined" && payment_store_PaymentStore) === "function" && commission_component__d || Object, typeof (commission_component__e = typeof authentication_store_AuthenticationStore !== "undefined" && authentication_store_AuthenticationStore) === "function" && commission_component__e || Object, typeof (commission_component__f = typeof grouppay_config_store_GroupPayConfigStore !== "undefined" && grouppay_config_store_GroupPayConfigStore) === "function" && commission_component__f || Object, typeof (commission_component__g = typeof report_service_ReportService !== "undefined" && report_service_ReportService) === "function" && commission_component__g || Object, typeof (commission_component__h = typeof event_validation_service_EventValidationService !== "undefined" && event_validation_service_EventValidationService) === "function" && commission_component__h || Object, typeof (commission_component__j = typeof flash_messages_service_FlashMessagesService !== "undefined" && flash_messages_service_FlashMessagesService) === "function" && commission_component__j || Object, typeof (commission_component__k = typeof core["c" /* TranslateService */] !== "undefined" && core["c" /* TranslateService */]) === "function" && commission_component__k || Object, typeof (commission_component__l = typeof ooiv_rules_store_OoivRulesStore !== "undefined" && ooiv_rules_store_OoivRulesStore) === "function" && commission_component__l || Object, typeof (commission_component__m = typeof router_es5["Router"] !== "undefined" && router_es5["Router"]) === "function" && commission_component__m || Object])
], commission_component_CommissionComponent);

var commission_component__a, commission_component__b, commission_component__c, commission_component__d, commission_component__e, commission_component__f, commission_component__g, commission_component__h, commission_component__j, commission_component__k, commission_component__l, commission_component__m;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/commission.component.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/payment/final-payment-status.resolver.ts
var final_payment_status_resolver___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var final_payment_status_resolver___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};



var FinalPaymentStatusResolver = (function () {
    function FinalPaymentStatusResolver(translateService, paymentStore) {
        this.translateService = translateService;
        this.paymentStore = paymentStore;
    }
    FinalPaymentStatusResolver.prototype.resolve = function (route, state) {
        var eventId = route.params['id'];
        var eventPartyId = route.params['eventPartyId'];
        if (!eventId) {
            throw new Error(this.translateService.instant('MESSAGES.ERROR.GET_FINAL_PAYMENT_STATUS'));
        }
        if (eventPartyId) {
            return this.paymentStore.loadFinalPaymentStatusListByParty(eventId, eventPartyId);
        }
        else {
            return this.paymentStore.loadFinalPaymentStatusList(eventId);
        }
    };
    return FinalPaymentStatusResolver;
}());
FinalPaymentStatusResolver = final_payment_status_resolver___decorate([
    Object(core_es5["Injectable"])(),
    final_payment_status_resolver___metadata("design:paramtypes", [typeof (final_payment_status_resolver__a = typeof core["c" /* TranslateService */] !== "undefined" && core["c" /* TranslateService */]) === "function" && final_payment_status_resolver__a || Object, typeof (final_payment_status_resolver__b = typeof payment_store_PaymentStore !== "undefined" && payment_store_PaymentStore) === "function" && final_payment_status_resolver__b || Object])
], FinalPaymentStatusResolver);

var final_payment_status_resolver__a, final_payment_status_resolver__b;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/final-payment-status.resolver.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/payment/latest-payment.resolver.ts
var latest_payment_resolver___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var latest_payment_resolver___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};



var LatestPaymentResolver = (function () {
    function LatestPaymentResolver(translateService, paymentStore) {
        this.translateService = translateService;
        this.paymentStore = paymentStore;
    }
    LatestPaymentResolver.prototype.resolve = function (route, state) {
        var id = route.params['id'];
        var eventPartyId = route.params['eventPartyId'];
        if (!id) {
            throw new Error(this.translateService.instant('MESSAGES.ERROR.GET_LATEST_PAYMENT'));
        }
        if (eventPartyId) {
            return this.paymentStore.loadLatestFinalPaymentByParty(id, eventPartyId);
        }
        else {
            return this.paymentStore.loadLatestFinalPayment(id);
        }
    };
    return LatestPaymentResolver;
}());
LatestPaymentResolver = latest_payment_resolver___decorate([
    Object(core_es5["Injectable"])(),
    latest_payment_resolver___metadata("design:paramtypes", [typeof (latest_payment_resolver__a = typeof core["c" /* TranslateService */] !== "undefined" && core["c" /* TranslateService */]) === "function" && latest_payment_resolver__a || Object, typeof (latest_payment_resolver__b = typeof payment_store_PaymentStore !== "undefined" && payment_store_PaymentStore) === "function" && latest_payment_resolver__b || Object])
], LatestPaymentResolver);

var latest_payment_resolver__a, latest_payment_resolver__b;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/latest-payment.resolver.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/payment/payments.resolver.ts
var payments_resolver___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var payments_resolver___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};



var PaymentsResolver = (function () {
    function PaymentsResolver(paymentStore, translateService) {
        this.paymentStore = paymentStore;
        this.translateService = translateService;
    }
    PaymentsResolver.prototype.resolve = function (route, state) {
        var id = route.params['id'];
        var eventPartyId = route.params['eventPartyId'];
        var allPayments = route.data['allPayments'];
        this.paymentStore.resetCalculatedPaymentWithTaxByEventPartyId();
        if (!id) {
            throw new Error(this.translateService.instant('MESSAGES.ERROR.COULD_NOT_GET_ADJUSTMENTS'));
        }
        if (eventPartyId && !allPayments) {
            return this.paymentStore.loadPaymentsByParty(id, eventPartyId).first();
        }
        else {
            return this.paymentStore.loadPayments(id).first();
        }
    };
    return PaymentsResolver;
}());
PaymentsResolver = payments_resolver___decorate([
    Object(core_es5["Injectable"])(),
    payments_resolver___metadata("design:paramtypes", [typeof (payments_resolver__a = typeof payment_store_PaymentStore !== "undefined" && payment_store_PaymentStore) === "function" && payments_resolver__a || Object, typeof (payments_resolver__b = typeof core["c" /* TranslateService */] !== "undefined" && core["c" /* TranslateService */]) === "function" && payments_resolver__b || Object])
], PaymentsResolver);

var payments_resolver__a, payments_resolver__b;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/payments.resolver.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/payment/prepayment.resolver.ts
var prepayment_resolver___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var prepayment_resolver___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};



var LatestPrepaymentResolver = (function () {
    function LatestPrepaymentResolver(translateService, paymentStore) {
        this.translateService = translateService;
        this.paymentStore = paymentStore;
    }
    LatestPrepaymentResolver.prototype.resolve = function (route, state) {
        var id = route.params['id'];
        var eventPartyId = route.params['eventPartyId'];
        if (!id) {
            throw new Error(this.translateService.instant('MESSAGES.ERROR.GET_PREPAYMENT'));
        }
        if (eventPartyId) {
            return this.paymentStore.loadLatestPrepaymentByParty(id, eventPartyId);
        }
        else {
            return this.paymentStore.loadLatestPrepayment(id);
        }
    };
    return LatestPrepaymentResolver;
}());
LatestPrepaymentResolver = prepayment_resolver___decorate([
    Object(core_es5["Injectable"])(),
    prepayment_resolver___metadata("design:paramtypes", [typeof (prepayment_resolver__a = typeof core["c" /* TranslateService */] !== "undefined" && core["c" /* TranslateService */]) === "function" && prepayment_resolver__a || Object, typeof (prepayment_resolver__b = typeof payment_store_PaymentStore !== "undefined" && payment_store_PaymentStore) === "function" && prepayment_resolver__b || Object])
], LatestPrepaymentResolver);

var prepayment_resolver__a, prepayment_resolver__b;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/prepayment.resolver.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/service/tax-determination.http.service.ts
var tax_determination_http_service___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var tax_determination_http_service___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};






var tax_determination_http_service_TaxDeterminationService = (function () {
    function TaxDeterminationService(http, environment, responseUtilService) {
        this.http = http;
        this.environment = environment;
        this.responseUtilService = responseUtilService;
        this.baseUrl = this.environment.baseUrl + '/api/tax-determination';
    }
    TaxDeterminationService.prototype.healthTDS = function () {
        var _this = this;
        var url = this.baseUrl + "/health?type=TAX";
        return this.http.get(url)
            .map(function (response) {
            return response.json();
        })
            .catch(function (error) {
            _this.responseUtilService.handleError(error);
            return Observable["Observable"].throw(error);
        });
    };
    TaxDeterminationService.prototype.getTaxRate = function (eventId) {
        var _this = this;
        var url = this.baseUrl + "/" + eventId + "/taxrate";
        return this.http.get(url)
            .map(function (response) {
            return response.json();
        })
            .catch(function (error) {
            _this.responseUtilService.handleError(error);
            return Observable["Observable"].throw(error);
        });
    };
    TaxDeterminationService.prototype.verifyTaxRate = function (taxRequest) {
        var _this = this;
        var options = new http_es5["RequestOptions"]({ headers: new http_es5["Headers"]({ 'Content-Type': 'application/json' }) });
        var url = this.baseUrl + "/taxrate/verify";
        return this.http.post(url, taxRequest, options)
            .map(function (response) {
            return response.json();
        })
            .catch(function (error) {
            _this.responseUtilService.handleError(error);
            return Observable["Observable"].throw(error);
        });
    };
    TaxDeterminationService.prototype.getTaxRateByParty = function (eventId, eventPartyId) {
        var _this = this;
        var url = this.baseUrl + "/" + eventId + "/" + eventPartyId + "/taxrate";
        return this.http.get(url)
            .map(function (response) {
            return response.json();
        })
            .catch(function (error) {
            _this.responseUtilService.handleError(error);
            return Observable["Observable"].throw(error);
        });
    };
    return TaxDeterminationService;
}());
tax_determination_http_service_TaxDeterminationService = tax_determination_http_service___decorate([
    Object(core_es5["Injectable"])(),
    tax_determination_http_service___metadata("design:paramtypes", [typeof (tax_determination_http_service__a = typeof AppAuthHttpService !== "undefined" && AppAuthHttpService) === "function" && tax_determination_http_service__a || Object, typeof (tax_determination_http_service__b = typeof EnvironmentConfiguration !== "undefined" && EnvironmentConfiguration) === "function" && tax_determination_http_service__b || Object, typeof (tax_determination_http_service__c = typeof response_util_service_ResponseUtilService !== "undefined" && response_util_service_ResponseUtilService) === "function" && tax_determination_http_service__c || Object])
], tax_determination_http_service_TaxDeterminationService);

var tax_determination_http_service__a, tax_determination_http_service__b, tax_determination_http_service__c;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/tax-determination.http.service.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/service/tax-determination.store.ts
var tax_determination_store___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var tax_determination_store___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};






var tax_determination_store_TaxDeterminationStore = (function () {
    function TaxDeterminationStore(flashMessagesService, taxDeterminationService) {
        this.flashMessagesService = flashMessagesService;
        this.taxDeterminationService = taxDeterminationService;
        this.taxesList = new ReplaySubject["ReplaySubject"](1);
        this.taxesVerified = new ReplaySubject["ReplaySubject"](1);
        this.globalResponseTaxesList = new ReplaySubject["ReplaySubject"](1);
    }
    TaxDeterminationStore.prototype.healthTDS = function () {
        var _this = this;
        return this.taxDeterminationService.healthTDS()
            .catch(function (error) {
            _this.flashMessagesService.error('MESSAGES.ERROR.TDS_HEALTH', "Error TDS Health: " + error);
            return Observable["Observable"].throw(error);
        })
            .map(function (res) {
            return res;
        });
    };
    TaxDeterminationStore.prototype.loadTaxRates = function (eventId) {
        var _this = this;
        return this.taxDeterminationService.getTaxRate(eventId)
            .catch(function (error) {
            if (error._body.includes('Unable to view Payment Page')) {
                _this.flashMessagesService.error('MESSAGES.ERROR.TDS_HEALTH', "Error in TaxRate  Health: " + error);
            }
            else {
                _this.flashMessagesService.error('MESSAGES.ERROR.GET_TAX_RATE', "Error getting TaxRate: " + error);
            }
            return Observable["Observable"].throw(error);
        })
            .map(function (res) {
            var validTax = true;
            if (res.taxResponses === null) {
                _this.taxesList.next(Object(immutable["List"])());
            }
            else {
                validTax = _this.checkTaxResponseWithError(res.taxResponses);
                if (validTax) {
                    _this.taxesList.next(res.taxResponses);
                }
                else {
                    // TODO: This is a temporary solution since the taxResponse should always be valid
                    res.isValidTax = false;
                    _this.taxesList.next(Object(immutable["List"])());
                }
            }
            _this.globalResponseTaxesList.next(res);
            return res;
        });
    };
    // TODO: This is a temporary solution since the taxResponse should always be valid
    TaxDeterminationStore.prototype.checkTaxResponseWithError = function (taxResponse) {
        var validTax = true;
        taxResponse.map(function (tax) {
            if (Boolean(tax.status) === Boolean(0)
                || (tax.supplier !== null
                    && tax.supplier !== undefined
                    && tax.supplier.countryCode !== 'US'
                    && (tax.taxes === null || tax.taxes === undefined || tax.taxes.length === 0))) {
                validTax = false;
            }
        });
        return validTax;
    };
    TaxDeterminationStore.prototype.loadTaxRatesByParty = function (eventId, eventPartyId) {
        var _this = this;
        return this.taxDeterminationService.getTaxRateByParty(eventId, eventPartyId)
            .catch(function (error) {
            if (error._body.includes('Unable to view Payment Page')) {
                _this.flashMessagesService.error('MESSAGES.ERROR.TDS_HEALTH', "Error in TaxRate  Health: " + error);
            }
            else {
                _this.flashMessagesService.error('MESSAGES.ERROR.GET_TAX_RATE', "Error getting TaxRate: " + error);
            }
            return Observable["Observable"].throw(error);
        })
            .map(function (res) {
            if (res.taxResponses === null) {
                _this.taxesList.next(Object(immutable["List"])());
            }
            else {
                _this.taxesList.next(res.taxResponses);
            }
            _this.globalResponseTaxesList.next(res);
            return res;
        });
    };
    TaxDeterminationStore.prototype.verifyTaxRatesByParty = function (taxRequest) {
        var _this = this;
        return this.taxDeterminationService.verifyTaxRate(taxRequest)
            .catch(function (error) {
            if (error._body.includes('Unable to view Payment Page')) {
                _this.flashMessagesService.error('MESSAGES.ERROR.TDS_HEALTH', "Error in TaxRate  Health: " + error);
            }
            else {
                _this.flashMessagesService.error('MESSAGES.ERROR.GET_TAX_RATE', "Error getting TaxRate: " + error);
            }
            return Observable["Observable"].throw(error);
        })
            .map(function (res) {
            if (res.taxResponses === null) {
                _this.taxesVerified.next(Object(immutable["List"])());
            }
            else {
                _this.taxesVerified.next(res.taxResponses);
            }
            _this.globalResponseTaxesList.next(res);
            return res;
        });
    };
    TaxDeterminationStore.prototype.getTaxRates = function () {
        return this.taxesList.asObservable();
    };
    TaxDeterminationStore.prototype.getGlobalResponseTaxesList = function () {
        return this.globalResponseTaxesList.asObservable();
    };
    TaxDeterminationStore.prototype.vendorTaxRates = function (eventPartyId, applyOoiv) {
        if (applyOoiv) {
            return this.taxesList.map(function (filteredList) {
                var filterReult = filteredList.filter(function (filtered) {
                    return filtered.eventPartyId === eventPartyId;
                });
                return filterReult;
            });
        }
        else {
            var taxes = Object(immutable["List"])([]);
            return Observable["Observable"].of(taxes);
        }
    };
    TaxDeterminationStore.prototype.getVendorCalculatedTaxes = function (eventPartyId, calculatedPaymentParty, applyOoiv) {
        var obs$ = this.vendorTaxRates(eventPartyId, applyOoiv);
        return obs$.map(function (list) {
            var taxTotal = list.reduce(function (sum, vendorTax) {
                return sum + vendorTax.taxes.reduce(function (sumTax, vtax) {
                    return sumTax + (vtax.rate * calculatedPaymentParty) / 100;
                }, 0);
            }, 0);
            return taxTotal;
        });
    };
    return TaxDeterminationStore;
}());
tax_determination_store_TaxDeterminationStore = tax_determination_store___decorate([
    Object(core_es5["Injectable"])(),
    tax_determination_store___metadata("design:paramtypes", [typeof (tax_determination_store__a = typeof flash_messages_service_FlashMessagesService !== "undefined" && flash_messages_service_FlashMessagesService) === "function" && tax_determination_store__a || Object, typeof (tax_determination_store__b = typeof tax_determination_http_service_TaxDeterminationService !== "undefined" && tax_determination_http_service_TaxDeterminationService) === "function" && tax_determination_store__b || Object])
], tax_determination_store_TaxDeterminationStore);

var tax_determination_store__a, tax_determination_store__b;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/tax-determination.store.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/payment/tax-determination.resolver.ts
var tax_determination_resolver___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var tax_determination_resolver___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};



var TaxDeterminationResolver = (function () {
    function TaxDeterminationResolver(taxDeterminationStore, translateService) {
        this.taxDeterminationStore = taxDeterminationStore;
        this.translateService = translateService;
    }
    TaxDeterminationResolver.prototype.resolve = function (route, state) {
        var id = route.params['id'];
        var eventPartyId = route.params['eventPartyId'];
        if (!id) {
            throw new Error(this.translateService.instant('MESSAGES.ERROR.GET_TAX_RATE'));
        }
        if (eventPartyId) {
            return this.taxDeterminationStore.loadTaxRatesByParty(id, eventPartyId);
        }
        else {
            return this.taxDeterminationStore.loadTaxRates(id);
        }
    };
    return TaxDeterminationResolver;
}());
TaxDeterminationResolver = tax_determination_resolver___decorate([
    Object(core_es5["Injectable"])(),
    tax_determination_resolver___metadata("design:paramtypes", [typeof (tax_determination_resolver__a = typeof tax_determination_store_TaxDeterminationStore !== "undefined" && tax_determination_store_TaxDeterminationStore) === "function" && tax_determination_resolver__a || Object, typeof (tax_determination_resolver__b = typeof core["c" /* TranslateService */] !== "undefined" && core["c" /* TranslateService */]) === "function" && tax_determination_resolver__b || Object])
], TaxDeterminationResolver);

var tax_determination_resolver__a, tax_determination_resolver__b;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/tax-determination.resolver.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/payment/vendor-commission/vendor-commission.component.ts
var vendor_commission_component___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var vendor_commission_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var vendor_commission_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};















var vendor_commission_component_VendorCommissionComponent = (function (_super) {
    vendor_commission_component___extends(VendorCommissionComponent, _super);
    function VendorCommissionComponent(formBuilder, menuStore, eventStore, authenticationStore, flashMessagesService, translateService, ooivRulesStore, taxDeterminationStore, router, groupPayConfigStore) {
        var _this = _super.call(this) || this;
        _this.formBuilder = formBuilder;
        _this.menuStore = menuStore;
        _this.eventStore = eventStore;
        _this.authenticationStore = authenticationStore;
        _this.flashMessagesService = flashMessagesService;
        _this.translateService = translateService;
        _this.ooivRulesStore = ooivRulesStore;
        _this.taxDeterminationStore = taxDeterminationStore;
        _this.router = router;
        _this.groupPayConfigStore = groupPayConfigStore;
        _this.eventParties = [];
        _this.ooivRulesValidation = true;
        _this.ooivEntityReady = true;
        _this.configLoaded = false;
        _this.statusLoaded = false;
        _this.openedCardIndex = 0;
        return _this;
    }
    VendorCommissionComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.addSubscription(this.eventStore.selectedEvent.subscribe(function (event) {
            _this.onyxEvent = new OnyxEvent(event);
            if (_this.onyxEvent.eventVendors !== undefined &&
                _this.onyxEvent.eventVendors.length < 5) {
                _this.onyxEvent.eventVendors[0].isExpanded = true;
            }
            _this.eventParties = _this.onyxEvent.eventVendors;
            _this.addSubscription(_this.eventStore
                .getEventStatus(_this.onyxEvent.eventId)
                .subscribe(function (eventStatus) {
                _this.eventStatus = eventStatus;
                _this.statusLoaded = true;
            }, function (err) {
            }, function () {
                _this.statusLoaded = true;
            }));
        }));
        this.commissionForm = this.formBuilder.group({});
        if (this.onyxEvent && EventUtils.getEventName(this.onyxEvent, this.authenticationStore.isAgencyUser())) {
            this.menuStore.setPageHeader(EventUtils.getEventName(this.onyxEvent, this.authenticationStore.isAgencyUser()), this.onyxEvent.eventProperty.subscriber);
        }
        else {
            this.menuStore.setPageHeader('EVENT.EVENT_INFO_TITLE', false);
        }
        this.addSubscription(this.ooivRulesStore.getAnyOoivExceptionRule()
            .subscribe(function (rule) {
            if (rule) {
                _this.ooivRulesValidation = rule.ooivExceptionsIsValid;
            }
            if (_this.ooivRulesValidation) {
                _this.addSubscription(_this.ooivRulesStore.getAgencyOoivExceptionRule().subscribe(function (agencyRule) {
                    if (agencyRule) {
                        _this.ooivEntityReady = agencyRule.ooivExceptionsIsValid;
                    }
                }));
            }
        }));
        if (!this.ooivRulesValidation) {
            // this.flashMessagesService.error(this.translateService.instant('MESSAGES.ERROR.ADDITIONAL_TAX_INFO_PROMPT',
            //   {'role': this.authenticationStore.isPropertyUser() ? 'Property' : 'Agency'}));
            this.flashMessagesService.error(this.translateService.instant('MESSAGES.ERROR.ADDITIONAL_TAX_INFO_PROMPT', { 'role': 'Agency' }));
        }
        if (!this.ooivEntityReady) {
            this.flashMessagesService.error(this.translateService.instant('MESSAGES.ERROR.ENROLLMENT_NOT_COMPLETED_PROMPT'));
        }
        this.addSubscription(this.taxDeterminationStore.getGlobalResponseTaxesList().subscribe(function (taxes) {
            if (!taxes.isValidTax) {
                _this.flashMessagesService.error(_this.translateService.instant('EVENT.COMMISSION.PENDING_TAX_ESTIMATED_ERROR_MSG'));
            }
        }));
        this.addSubscription(this.flashMessagesService.closeMessageStream.subscribe(function (flashMessage) {
            if (flashMessage && flashMessage.message
                && flashMessage.message.includes('Unable to determine Tax. Please try again in few minutes.')) {
                _this.router.navigate(['/event', _this.onyxEvent.eventId, 'summary']);
            }
        }));
        var configRequests = [];
        this.onyxEvent.eventVendors.forEach(function (vendor) {
            var request = {
                key: ConfigLookupType.PREPAYMENT_MIN_AMOUNT,
                chain: vendor.chain,
                brand: vendor.brand,
                propertyId: vendor.propertyId,
                agencyId: _this.onyxEvent.eventAgency.code,
            };
            configRequests.push(request);
        });
        this.addSubscription(this.groupPayConfigStore
            .loadConfigBulk(configRequests, ConfigLookupType.PREPAYMENT_MIN_AMOUNT)
            .subscribe(function (response) {
            var configResponses = response;
            _this.onyxEvent.eventVendors.forEach(function (vendor) {
                vendor.config = configResponses.find(function (x) { return x.propertyId === vendor.propertyId; });
            });
            _this.configLoaded = true;
        }, function (err) {
        }, function () {
            _this.configLoaded = true;
        }));
    };
    VendorCommissionComponent.prototype.trackVendorByFn = function (index, vendor) {
        return vendor.eventPartyId;
    };
    VendorCommissionComponent.prototype.onToggle = function (index, card) {
        if (this.openedCardIndex === index) {
            // Toggling the card that was open. By setting the index to -1, all cards will be closed.
            this.openedCardIndex = -1;
        }
        else {
            // Open the vendor card in the provided index.
            this.openedCardIndex = index;
            // Scroll to the card
            setTimeout(function () {
                card.cardWrapper.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }, 100);
        }
    };
    return VendorCommissionComponent;
}(unsubscriber_Unsubscriber));
vendor_commission_component_VendorCommissionComponent = vendor_commission_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-vendor-commission',
        template: __webpack_require__("0cpp"),
        styles: [__webpack_require__("0T9V")]
    }),
    vendor_commission_component___metadata("design:paramtypes", [typeof (vendor_commission_component__a = typeof forms_es5["FormBuilder"] !== "undefined" && forms_es5["FormBuilder"]) === "function" && vendor_commission_component__a || Object, typeof (vendor_commission_component__b = typeof menu_store_MenuStore !== "undefined" && menu_store_MenuStore) === "function" && vendor_commission_component__b || Object, typeof (vendor_commission_component__c = typeof event_store_EventStore !== "undefined" && event_store_EventStore) === "function" && vendor_commission_component__c || Object, typeof (vendor_commission_component__d = typeof authentication_store_AuthenticationStore !== "undefined" && authentication_store_AuthenticationStore) === "function" && vendor_commission_component__d || Object, typeof (vendor_commission_component__e = typeof flash_messages_service_FlashMessagesService !== "undefined" && flash_messages_service_FlashMessagesService) === "function" && vendor_commission_component__e || Object, typeof (vendor_commission_component__f = typeof core["c" /* TranslateService */] !== "undefined" && core["c" /* TranslateService */]) === "function" && vendor_commission_component__f || Object, typeof (vendor_commission_component__g = typeof ooiv_rules_store_OoivRulesStore !== "undefined" && ooiv_rules_store_OoivRulesStore) === "function" && vendor_commission_component__g || Object, typeof (vendor_commission_component__h = typeof tax_determination_store_TaxDeterminationStore !== "undefined" && tax_determination_store_TaxDeterminationStore) === "function" && vendor_commission_component__h || Object, typeof (vendor_commission_component__j = typeof router_es5["Router"] !== "undefined" && router_es5["Router"]) === "function" && vendor_commission_component__j || Object, typeof (vendor_commission_component__k = typeof grouppay_config_store_GroupPayConfigStore !== "undefined" && grouppay_config_store_GroupPayConfigStore) === "function" && vendor_commission_component__k || Object])
], vendor_commission_component_VendorCommissionComponent);

var vendor_commission_component__a, vendor_commission_component__b, vendor_commission_component__c, vendor_commission_component__d, vendor_commission_component__e, vendor_commission_component__f, vendor_commission_component__g, vendor_commission_component__h, vendor_commission_component__j, vendor_commission_component__k;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/vendor-commission.component.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/adjustment.ts
var adjustment___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var AdjustmentRecord = Object(immutable["Record"])({
    eventAdjustmentId: null,
    eventId: null,
    adjustmentAmount: 0,
    adjustmentSpendAmount: 0,
    adjustmentCommRate: 0,
    adjustmentType: null,
    description: null,
    createdDate: null,
    eventPartyId: 0
});
var Adjustment = (function (_super) {
    adjustment___extends(Adjustment, _super);
    function Adjustment() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Adjustment;
}(AdjustmentRecord));

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/adjustment.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/service/adjustment.http.service.ts
var adjustment_http_service___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var adjustment_http_service___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};








var adjustment_http_service_AdjustmentHttpService = (function () {
    function AdjustmentHttpService(http, environment, responseUtilService) {
        this.http = http;
        this.environment = environment;
        this.responseUtilService = responseUtilService;
        this.eventsUrl = this.environment.baseUrl + '/api/events';
        this.adjustmentUrl = this.eventsUrl + '/adjustments';
    }
    AdjustmentHttpService.prototype.addAdjustment = function (adjustment) {
        var _this = this;
        var headers = new http_es5["Headers"]({ 'Content-Type': 'application/json' });
        var options = new http_es5["RequestOptions"]({ headers: headers });
        return this.http.post(this.adjustmentUrl, JSON.stringify(adjustment.toJS()), options)
            .map(function (response) {
            return response.json();
        })
            .catch(function (error) {
            _this.responseUtilService.handleError(error);
            return Observable["Observable"].throw(error);
        })
            .share();
    };
    AdjustmentHttpService.prototype.getAdjustments = function (eventId) {
        var _this = this;
        return this.http.get(this.eventsUrl + "/" + eventId + "/adjustments")
            .map(function (response) { return Object(immutable["List"])(response.json().map(function (element) { return new Adjustment(element); })); })
            .catch(function (response) { return _this.responseUtilService.handleError(response); }).share();
    };
    AdjustmentHttpService.prototype.getAdjustmentsByParty = function (eventId, eventPartyId) {
        var _this = this;
        return this.http.get(this.eventsUrl + "/" + eventId + "/" + eventPartyId + "/adjustments")
            .map(function (response) { return Object(immutable["List"])(response.json().map(function (element) { return new Adjustment(element); })); })
            .catch(function (response) { return _this.responseUtilService.handleError(response); }).share();
    };
    AdjustmentHttpService.prototype.getVendorsTotalPayments = function (eventId) {
        var _this = this;
        return this.http.get(this.eventsUrl + "/" + eventId + "/vendors-total-payments")
            .map(function (response) { return response.json(); }).
            catch(function (response) { return _this.responseUtilService.handleError(response); }).share();
    };
    AdjustmentHttpService.prototype.getVendorsTotalPaymentsByParty = function (eventId, eventPartyId) {
        var _this = this;
        return this.http.get(this.eventsUrl + "/" + eventId + "/" + eventPartyId + "/vendors-total-payments")
            .map(function (response) { return response.json(); }).
            catch(function (response) { return _this.responseUtilService.handleError(response); }).share();
    };
    AdjustmentHttpService.prototype.deleteAdjustment = function (adjustmentId) {
        var _this = this;
        var url = this.adjustmentUrl + "/" + adjustmentId;
        return this.http.delete(url)
            .catch(function (response) { return _this.responseUtilService.handleError(response); }).share();
    };
    return AdjustmentHttpService;
}());
adjustment_http_service_AdjustmentHttpService = adjustment_http_service___decorate([
    Object(core_es5["Injectable"])(),
    adjustment_http_service___metadata("design:paramtypes", [typeof (adjustment_http_service__a = typeof AppAuthHttpService !== "undefined" && AppAuthHttpService) === "function" && adjustment_http_service__a || Object, typeof (adjustment_http_service__b = typeof EnvironmentConfiguration !== "undefined" && EnvironmentConfiguration) === "function" && adjustment_http_service__b || Object, typeof (adjustment_http_service__c = typeof response_util_service_ResponseUtilService !== "undefined" && response_util_service_ResponseUtilService) === "function" && adjustment_http_service__c || Object])
], adjustment_http_service_AdjustmentHttpService);

var adjustment_http_service__a, adjustment_http_service__b, adjustment_http_service__c;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/adjustment.http.service.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/service/adjustment.store.ts
var adjustment_store___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var adjustment_store___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};












var adjustment_store_AdjustmentStore = (function () {
    function AdjustmentStore(adjustmentHttpService, flashMessagesService, reservationStore, rsvpStore, adjustmentTypeStore, paymentSummaryStore) {
        this.adjustmentHttpService = adjustmentHttpService;
        this.flashMessagesService = flashMessagesService;
        this.reservationStore = reservationStore;
        this.rsvpStore = rsvpStore;
        this.adjustmentTypeStore = adjustmentTypeStore;
        this.paymentSummaryStore = paymentSummaryStore;
        this.adjustmentList = new ReplaySubject["ReplaySubject"](1);
        this.adjustmentArray = new ReplaySubject["ReplaySubject"](1);
        this.vendorsTotalPayments = new ReplaySubject["ReplaySubject"](1);
    }
    AdjustmentStore.prototype.addAdjustment = function (adjustment) {
        var _this = this;
        return this.adjustmentHttpService.addAdjustment(adjustment).pipe(Object(operators["tap"])(function (addedAdjustment) {
            _this.paymentSummaryStore.reloadPaymentSummary(adjustment.eventPartyId).take(1).subscribe();
            var adjustmentSign = adjustment.adjustmentType.credit ? AdjustmentSign.CREDIT : AdjustmentSign.DEBIT;
            _this.adjustmentTypeStore.getAdjustmentType(addedAdjustment.adjustmentType.id, adjustmentSign)
                .take(1)
                .subscribe(function (adjustmentType) {
                _this.flashMessagesService.success('EVENT.ADJUSTMENT.ADJUSTMENT_SAVED', null, {
                    'type': adjustmentType.name,
                    'description': addedAdjustment.description ? addedAdjustment.description : ''
                });
            });
        }))
            .catch(function (error) {
            _this.flashMessagesService.error('MESSAGES.ERROR.ADD_ADJUSTMENT', "Error adding adjustment: " + error);
            return Observable["Observable"].throw(error);
        });
    };
    Object.defineProperty(AdjustmentStore.prototype, "vendorsTotalPaymentsSummary", {
        get: function () {
            return this.vendorsTotalPayments.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    AdjustmentStore.prototype.vendorAdjustments = function (eventPartyId) {
        return this.adjustmentList.map(function (filteredList) {
            return filteredList.filter(function (filtered) { return filtered.eventPartyId === eventPartyId; }).toList();
        });
    };
    AdjustmentStore.prototype.vendorAdjustmentsAsArray = function (eventPartyId) {
        return this.adjustmentArray
            .map(function (payments) { return payments != null ? payments.filter(function (payment) { return payment.eventPartyId === eventPartyId; }) : null; });
    };
    AdjustmentStore.prototype.loadAdjustments = function (eventId) {
        var _this = this;
        return this.adjustmentHttpService.getAdjustments(eventId)
            .catch(function (error) {
            _this.flashMessagesService.error('MESSAGES.ERROR.COULD_NOT_GET_PAYMENTS', "Error getting adjustments: " + error);
            return Observable["Observable"].throw(error);
        })
            .map(function (result) {
            var sortedIterable = result.sort(function (adjustment1, adjustment2) {
                if (adjustment1.createdDate < adjustment2.createdDate) {
                    return -1;
                }
                else if (adjustment1.createdDate > adjustment2.createdDate) {
                    return 1;
                }
                else {
                    return 0;
                }
            });
            _this.adjustmentList.next(sortedIterable.toList());
            _this.adjustmentArray.next(sortedIterable.toArray());
            return result;
        });
    };
    AdjustmentStore.prototype.loadAdjustmentsByParty = function (eventId, eventPartyId) {
        var _this = this;
        return this.adjustmentHttpService.getAdjustmentsByParty(eventId, eventPartyId)
            .catch(function (error) {
            _this.flashMessagesService.error('MESSAGES.ERROR.COULD_NOT_GET_PAYMENTS', "Error getting adjustments: " + error);
            return Observable["Observable"].throw(error);
        })
            .map(function (result) {
            var sortedIterable = result.sort(function (adjustment1, adjustment2) {
                if (adjustment1.createdDate < adjustment2.createdDate) {
                    return -1;
                }
                else if (adjustment1.createdDate > adjustment2.createdDate) {
                    return 1;
                }
                else {
                    return 0;
                }
            });
            _this.adjustmentList.next(sortedIterable.toList());
            _this.adjustmentArray.next(sortedIterable.toArray());
            return result;
        });
    };
    AdjustmentStore.prototype.loadVendorsTotalPaymentsSummary = function (eventId) {
        var _this = this;
        return this.adjustmentHttpService.getVendorsTotalPayments(eventId)
            .catch(function (error) {
            if (error.includes('Unable to determine Tax')) {
                _this.flashMessagesService.error('MESSAGES.ERROR.GET_TAX_RATE', "Error getting TaxRate: " + error);
            }
            else if (error.includes('Unable to view Payment Page')) {
                _this.flashMessagesService.error('MESSAGES.ERROR.TDS_HEALTH', "Error in TaxRate  Health: " + error);
            }
            else {
                // Catch error here so resolver also displays error.
                _this.flashMessagesService.error('MESSAGES.ERROR.COULD_NOT_GET_VENDORS_TOTAL_PAYMENTS', "Error retrieving Vendors Total Payments: " + error);
            }
            return Observable["Observable"].throw(error);
        })
            .map(function (res) {
            _this.vendorsTotalPayments.next(res);
            return res;
        });
    };
    AdjustmentStore.prototype.loadVendorsTotalPaymentsSummaryByParty = function (eventId, eventPartyId) {
        var _this = this;
        return this.adjustmentHttpService.getVendorsTotalPaymentsByParty(eventId, eventPartyId)
            .catch(function (error) {
            // Catch error here so resolver also displays error.
            _this.flashMessagesService.error('MESSAGES.ERROR.COULD_NOT_GET_VENDORS_TOTAL_PAYMENTS', "Error retrieving Vendors Total Payments: " + error);
            return Observable["Observable"].throw(error);
        })
            .map(function (res) {
            _this.vendorsTotalPayments.next(res);
            return res;
        });
    };
    AdjustmentStore.prototype.deleteAdjustment = function (adjustmentId, eventId, eventPartyId) {
        var _this = this;
        return this.adjustmentHttpService.deleteAdjustment(adjustmentId)
            .catch(function (error) {
            _this.flashMessagesService.error('MESSAGES.ERROR.DELETE_ADJUSTMENT', "Error deleting adjustment: " + error);
            return Observable["Observable"].of(error);
        })
            .map(function (res) {
            _this.paymentSummaryStore.reloadPaymentSummary(eventPartyId).take(1).subscribe();
            _this.loadAdjustments(eventId).subscribe();
            _this.loadVendorsTotalPaymentsSummary(eventId).pipe(Object(operators["take"])(1)).subscribe();
            return res;
        });
    };
    AdjustmentStore.prototype.getVendorCalculatedPayment = function (eventPartyId, reservationStatusCode, subscriber, tax) {
        var _this = this;
        var totalCommissions = new decimal_default.a(0);
        var obs$ = subscriber ?
            this.reservationStore.getVendorTotalCommissions(reservationStatusCode, eventPartyId) :
            this.rsvpStore.vendorTotalCommission(eventPartyId);
        return obs$.flatMap(function (total) {
            totalCommissions = new decimal_default.a(total);
            return _this.vendorAdjustments(eventPartyId);
        }).map(function (list) {
            var adjustmentTotal = list.reduce(function (sum, adjustment) {
                return sum.add(adjustment.adjustmentAmount);
            }, new decimal_default.a(0));
            var calculatedPayment = adjustmentTotal.plus(totalCommissions);
            if (!calculatedPayment.isZero() && tax) {
                calculatedPayment = calculatedPayment.plus(new decimal_default.a(tax));
            }
            return Number(calculatedPayment);
        });
    };
    return AdjustmentStore;
}());
adjustment_store_AdjustmentStore = adjustment_store___decorate([
    Object(core_es5["Injectable"])(),
    adjustment_store___metadata("design:paramtypes", [typeof (adjustment_store__a = typeof adjustment_http_service_AdjustmentHttpService !== "undefined" && adjustment_http_service_AdjustmentHttpService) === "function" && adjustment_store__a || Object, typeof (adjustment_store__b = typeof flash_messages_service_FlashMessagesService !== "undefined" && flash_messages_service_FlashMessagesService) === "function" && adjustment_store__b || Object, typeof (adjustment_store__c = typeof reservation_store_ReservationStore !== "undefined" && reservation_store_ReservationStore) === "function" && adjustment_store__c || Object, typeof (adjustment_store__d = typeof rsvp_store_RsvpStore !== "undefined" && rsvp_store_RsvpStore) === "function" && adjustment_store__d || Object, typeof (adjustment_store__e = typeof adjustment_type_store_AdjustmentTypeStore !== "undefined" && adjustment_type_store_AdjustmentTypeStore) === "function" && adjustment_store__e || Object, typeof (adjustment_store__f = typeof payment_summary_store_PaymentSummaryStore !== "undefined" && payment_summary_store_PaymentSummaryStore) === "function" && adjustment_store__f || Object])
], adjustment_store_AdjustmentStore);

var adjustment_store__a, adjustment_store__b, adjustment_store__c, adjustment_store__d, adjustment_store__e, adjustment_store__f;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/adjustment.store.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/payment/vendorsTotalPayments.resolver.ts
var vendorsTotalPayments_resolver___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var vendorsTotalPayments_resolver___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};



var VendorsTotalPaymentsResolver = (function () {
    function VendorsTotalPaymentsResolver(adjustmentStore, translateService) {
        this.adjustmentStore = adjustmentStore;
        this.translateService = translateService;
    }
    VendorsTotalPaymentsResolver.prototype.resolve = function (route, state) {
        var id = route.params['id'];
        var eventPartyId = route.params['eventPartyId'];
        if (!id) {
            throw new Error(this.translateService.instant('MESSAGES.ERROR.COULD_NOT_GET_VENDORS_TOTAL_PAYMENTS'));
        }
        if (eventPartyId) {
            return this.adjustmentStore.loadVendorsTotalPaymentsSummaryByParty(route.params['id'], eventPartyId).first();
        }
        else {
            return this.adjustmentStore.loadVendorsTotalPaymentsSummary(route.params['id']).first();
        }
    };
    return VendorsTotalPaymentsResolver;
}());
VendorsTotalPaymentsResolver = vendorsTotalPayments_resolver___decorate([
    Object(core_es5["Injectable"])(),
    vendorsTotalPayments_resolver___metadata("design:paramtypes", [typeof (vendorsTotalPayments_resolver__a = typeof adjustment_store_AdjustmentStore !== "undefined" && adjustment_store_AdjustmentStore) === "function" && vendorsTotalPayments_resolver__a || Object, typeof (vendorsTotalPayments_resolver__b = typeof core["c" /* TranslateService */] !== "undefined" && core["c" /* TranslateService */]) === "function" && vendorsTotalPayments_resolver__b || Object])
], VendorsTotalPaymentsResolver);

var vendorsTotalPayments_resolver__a, vendorsTotalPayments_resolver__b;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/vendorsTotalPayments.resolver.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/reservations/reservation-detail-table/reservation-detail-can-deactive.ts
var reservation_detail_can_deactive___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var reservation_detail_can_deactive___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};


var CanDeactiveReservationDetailTable = (function () {
    function CanDeactiveReservationDetailTable(reservationCompareStore) {
        this.reservationCompareStore = reservationCompareStore;
    }
    CanDeactiveReservationDetailTable.prototype.canDeactivate = function (component, currentRoute, currentState, nextState) {
        this.reservationCompareStore.setShowReservationCompareSummary(true);
        return true;
    };
    return CanDeactiveReservationDetailTable;
}());
CanDeactiveReservationDetailTable = reservation_detail_can_deactive___decorate([
    Object(core_es5["Injectable"])(),
    reservation_detail_can_deactive___metadata("design:paramtypes", [typeof (reservation_detail_can_deactive__a = typeof reservation_compare_store_ReservationCompareStore !== "undefined" && reservation_compare_store_ReservationCompareStore) === "function" && reservation_detail_can_deactive__a || Object])
], CanDeactiveReservationDetailTable);

var reservation_detail_can_deactive__a;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/reservation-detail-can-deactive.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/reservations/reservation-detail.resolver.ts
var reservation_detail_resolver___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var reservation_detail_resolver___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};





var ReservationDetailResolver = (function () {
    function ReservationDetailResolver(reservationCompareStore, flashMessagesService, router, logService) {
        this.reservationCompareStore = reservationCompareStore;
        this.flashMessagesService = flashMessagesService;
        this.router = router;
        this.logService = logService;
    }
    ReservationDetailResolver.prototype.resolve = function (route, state) {
        var _this = this;
        var obs$;
        var id = route.params['id'];
        var eventPartyId = route.params['eventPartyId'];
        if (eventPartyId) {
            this.reservationCompareStore.getReservationsByParty(id, eventPartyId).subscribe(function () {
                obs$ = _this.reservationCompareStore.isCompareListEmpty();
                obs$.take(1).subscribe(function (isEmpty) {
                    if (!isEmpty) {
                        _this.reservationCompareStore.selectedRsvpId = Number(route.queryParams['rsvp']);
                        _this.reservationCompareStore.selectedReservationId = Number(route.queryParams['reservation']);
                        var path = route.url.map(function (urlSegment) { return urlSegment.path; }).join('/');
                        _this.logService.info('router URL path ends with /detail: ' + path.endsWith('/detail'));
                        _this.reservationCompareStore.setShowReservationCompareSummary(!path.endsWith('/detail'));
                    }
                    else {
                        _this.router.navigate(['event/' + id + '/' + eventPartyId + '/reservations']).then(function () {
                            _this.flashMessagesService.error('MESSAGES.ERROR.UNABLE_TO_NAVIGATE');
                        });
                    }
                });
            });
        }
        else {
            this.reservationCompareStore.getReservations(id).subscribe(function () {
                obs$ = _this.reservationCompareStore.isCompareListEmpty();
                obs$.take(1).subscribe(function (isEmpty) {
                    if (!isEmpty) {
                        _this.reservationCompareStore.selectedRsvpId = Number(route.queryParams['rsvp']);
                        _this.reservationCompareStore.selectedReservationId = Number(route.queryParams['reservation']);
                        var path = route.url.map(function (urlSegment) { return urlSegment.path; }).join('/');
                        _this.logService.info('router URL path ends with /detail: ' + path.endsWith('/detail'));
                        _this.reservationCompareStore.setShowReservationCompareSummary(!path.endsWith('/detail'));
                    }
                    else {
                        _this.router.navigate(['event/' + id + '/reservations']).then(function () {
                            _this.flashMessagesService.error('MESSAGES.ERROR.UNABLE_TO_NAVIGATE');
                        });
                    }
                });
            });
        }
        return obs$;
    };
    return ReservationDetailResolver;
}());
ReservationDetailResolver = reservation_detail_resolver___decorate([
    Object(core_es5["Injectable"])(),
    reservation_detail_resolver___metadata("design:paramtypes", [typeof (reservation_detail_resolver__a = typeof reservation_compare_store_ReservationCompareStore !== "undefined" && reservation_compare_store_ReservationCompareStore) === "function" && reservation_detail_resolver__a || Object, typeof (reservation_detail_resolver__b = typeof flash_messages_service_FlashMessagesService !== "undefined" && flash_messages_service_FlashMessagesService) === "function" && reservation_detail_resolver__b || Object, typeof (reservation_detail_resolver__c = typeof router_es5["Router"] !== "undefined" && router_es5["Router"]) === "function" && reservation_detail_resolver__c || Object, typeof (reservation_detail_resolver__d = typeof log_service_LogService !== "undefined" && log_service_LogService) === "function" && reservation_detail_resolver__d || Object])
], ReservationDetailResolver);

var reservation_detail_resolver__a, reservation_detail_resolver__b, reservation_detail_resolver__c, reservation_detail_resolver__d;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/reservation-detail.resolver.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/reservations/reservation-page/reservation-page.component.ts
var reservation_page_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var reservation_page_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};









var reservation_page_component_ReservationPageComponent = (function () {
    function ReservationPageComponent(eventStore, reservationCompareStore, menuStore, paymentStore, authenticationStore) {
        this.eventStore = eventStore;
        this.reservationCompareStore = reservationCompareStore;
        this.menuStore = menuStore;
        this.paymentStore = paymentStore;
        this.authenticationStore = authenticationStore;
    }
    ReservationPageComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.eventStore.selectedEvent.subscribe(function (event) { return _this.onyxEvent = event; });
        if (this.onyxEvent) {
            this.menuStore.setPageHeader(EventUtils.getEventName(this.onyxEvent, this.authenticationStore.isAgencyUser()), this.onyxEvent.eventProperty.subscriber);
        }
        if (!this.onyxEvent.eventId) {
            this.canManageReservations = true;
        }
        else {
            this.paymentStore.getVendorFinalPayment(this.onyxEvent.eventProperty.eventPartyId).take(1).subscribe(function (lastFinalPayment) {
                var hasFinalPayment = Boolean(lastFinalPayment && lastFinalPayment.eventPaymentId);
                _this.canManageReservations = !hasFinalPayment || PaymentStatus.REJECTED_WF_APPROVAL === lastFinalPayment.status;
            });
        }
    };
    ReservationPageComponent.prototype.getSummarySelected = function () {
        return this.reservationCompareStore.getShowReservationCompareSummary();
    };
    ReservationPageComponent.prototype.showDownloadDropdown = function () {
        return this.getFilteredReservations().map(function (list) {
            return list && list.size > 0;
        });
    };
    ReservationPageComponent.prototype.getFilteredReservations = function () {
        return this.reservationCompareStore.getCurrentFilteredReservations()
            .map(function (reservationList) { return reservation_utils_ReservationUtils.onlyReservationsFilter(reservationList); });
    };
    return ReservationPageComponent;
}());
reservation_page_component_ReservationPageComponent = reservation_page_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-reservation-page',
        template: __webpack_require__("Mz5u")
    }),
    reservation_page_component___metadata("design:paramtypes", [typeof (reservation_page_component__a = typeof event_store_EventStore !== "undefined" && event_store_EventStore) === "function" && reservation_page_component__a || Object, typeof (reservation_page_component__b = typeof reservation_compare_store_ReservationCompareStore !== "undefined" && reservation_compare_store_ReservationCompareStore) === "function" && reservation_page_component__b || Object, typeof (reservation_page_component__c = typeof menu_store_MenuStore !== "undefined" && menu_store_MenuStore) === "function" && reservation_page_component__c || Object, typeof (reservation_page_component__d = typeof payment_store_PaymentStore !== "undefined" && payment_store_PaymentStore) === "function" && reservation_page_component__d || Object, typeof (reservation_page_component__e = typeof authentication_store_AuthenticationStore !== "undefined" && authentication_store_AuthenticationStore) === "function" && reservation_page_component__e || Object])
], reservation_page_component_ReservationPageComponent);

var reservation_page_component__a, reservation_page_component__b, reservation_page_component__c, reservation_page_component__d, reservation_page_component__e;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/reservation-page.component.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/reservations/reservation.compare.resolver.ts
var reservation_compare_resolver___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var reservation_compare_resolver___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};





var reservation_compare_resolver_ReservationCompareResolver = (function () {
    function ReservationCompareResolver(reservationCompareStore, translateService, logService, router) {
        var _this = this;
        this.reservationCompareStore = reservationCompareStore;
        this.translateService = translateService;
        this.logService = logService;
        this.router = router;
        this.previousRoute = null;
        // This code is required in order to know the previous route in resolve.
        // Note that first the NavigationStart event will happen, then resolve() is called if the resolver is attached
        // to the route, then NavigationEnd happens.
        this.router.events
            .filter(function (e) { return e instanceof router_es5["NavigationEnd"]; })
            .subscribe(function (e) {
            _this.previousRoute = e.url;
        });
    }
    ReservationCompareResolver.prototype.resolve = function (route, state) {
        var id = route.params['id'];
        var eventPartyId = route.params['eventPartyId'];
        if (!id) {
            throw new Error(this.translateService.instant('MESSAGES.ERROR.RESERVATION_COMPARE'));
        }
        // Reset the filters unless the last route was reservations summary or detail
        // Note that this resolve happens before the NavigationEnd event for the route we're about to go to,
        // so we can find the last route that was navigated to successfully by checking the last NavigationEnd event.
        if (this.previousRoute && !this.previousRoute.includes("/" + id + "/reservations")) {
            this.reservationCompareStore.resetStatusCodes();
        }
        if (eventPartyId) {
            return this.reservationCompareStore.getReservationsByParty(route.params['id'], eventPartyId);
        }
        else {
            return this.reservationCompareStore.getReservations(route.params['id']);
        }
    };
    return ReservationCompareResolver;
}());
reservation_compare_resolver_ReservationCompareResolver = reservation_compare_resolver___decorate([
    Object(core_es5["Injectable"])(),
    reservation_compare_resolver___metadata("design:paramtypes", [typeof (reservation_compare_resolver__a = typeof reservation_compare_store_ReservationCompareStore !== "undefined" && reservation_compare_store_ReservationCompareStore) === "function" && reservation_compare_resolver__a || Object, typeof (reservation_compare_resolver__b = typeof core["c" /* TranslateService */] !== "undefined" && core["c" /* TranslateService */]) === "function" && reservation_compare_resolver__b || Object, typeof (reservation_compare_resolver__c = typeof log_service_LogService !== "undefined" && log_service_LogService) === "function" && reservation_compare_resolver__c || Object, typeof (reservation_compare_resolver__d = typeof router_es5["Router"] !== "undefined" && router_es5["Router"]) === "function" && reservation_compare_resolver__d || Object])
], reservation_compare_resolver_ReservationCompareResolver);

var reservation_compare_resolver__a, reservation_compare_resolver__b, reservation_compare_resolver__c, reservation_compare_resolver__d;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/reservation.compare.resolver.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/reservations/reservation.resolver.ts
var reservation_resolver___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var reservation_resolver___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};



var ReservationResolver = (function () {
    function ReservationResolver(reservationStore, translateService) {
        this.reservationStore = reservationStore;
        this.translateService = translateService;
    }
    ReservationResolver.prototype.resolve = function (route, state) {
        var id = route.params['id'];
        var eventPartyId = route.params['eventPartyId'];
        if (!id) {
            throw new Error(this.translateService.instant('MESSAGES.ERROR.COULD_NOT_GET_RESERVATIONS'));
        }
        if (eventPartyId) {
            return this.reservationStore.loadReservationsByParty(id, eventPartyId);
        }
        else {
            return this.reservationStore.loadReservations(id);
        }
    };
    return ReservationResolver;
}());
ReservationResolver = reservation_resolver___decorate([
    Object(core_es5["Injectable"])(),
    reservation_resolver___metadata("design:paramtypes", [typeof (reservation_resolver__a = typeof reservation_store_ReservationStore !== "undefined" && reservation_store_ReservationStore) === "function" && reservation_resolver__a || Object, typeof (reservation_resolver__b = typeof core["c" /* TranslateService */] !== "undefined" && core["c" /* TranslateService */]) === "function" && reservation_resolver__b || Object])
], ReservationResolver);

var reservation_resolver__a, reservation_resolver__b;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/reservation.resolver.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/service/transient-reservation-store.ts
var transient_reservation_store___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var transient_reservation_store___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};








var transient_reservation_store_TransientReservationStore = (function () {
    function TransientReservationStore(flashMessagesService, transientReservationHttpService, logService) {
        this.flashMessagesService = flashMessagesService;
        this.transientReservationHttpService = transientReservationHttpService;
        this.logService = logService;
        this.searchResultsPage = new BehaviorSubject["BehaviorSubject"](page_Page.empty());
        this._selectedReservations = new Map();
    }
    TransientReservationStore.prototype.setTransientReservationPage = function (page) {
        this.searchResultsPage.next(page);
    };
    TransientReservationStore.prototype.linkTransientReservationsToEvent = function (eventReservationIdList, eventPartyId, doNotPay) {
        var _this = this;
        return this.transientReservationHttpService.linkTransientReservationsToEvent(eventReservationIdList, eventPartyId, doNotPay)
            .pipe(Object(operators["take"])(1), Object(operators["catchError"])(function (error) {
            _this.flashMessagesService.error('MESSAGES.ERROR.LINK_TRANSIENT_RESERVATION', "Error linking a transient reservation to an event: " + error);
            return Observable["Observable"].throw(error);
        }));
    };
    TransientReservationStore.prototype.searchTransientReservations = function (searchParameters, page, size) {
        var _this = this;
        this.logService.debug("searchParameters: " + searchParameters);
        return this.transientReservationHttpService.search(searchParameters, page, size)
            .catch(function (error) {
            _this.flashMessagesService.error('MESSAGES.ERROR.SEARCH_TRANSIENT_RESERVATION', "Error retrieving transient reservations: " + error);
            return Observable["Observable"].throw(error);
        })
            .map(function (res) {
            _this.searchResultsPage.next(res);
            _this.logService.debug("searchResult: " + res);
            return res;
        });
    };
    Object.defineProperty(TransientReservationStore.prototype, "searchResults", {
        get: function () {
            return this.searchResultsPage.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TransientReservationStore.prototype, "selectedReservations", {
        get: function () {
            return Array.from(this._selectedReservations.values());
        },
        enumerable: true,
        configurable: true
    });
    TransientReservationStore.prototype.clearSelectedReservations = function () {
        this._selectedReservations = new Map();
    };
    TransientReservationStore.prototype.pushToSelectedReservations = function (transientReservation) {
        this._selectedReservations.set(transientReservation.eventReservationId, transientReservation);
    };
    TransientReservationStore.prototype.removeFromSelectedReservations = function (transientReservation) {
        this._selectedReservations.delete(transientReservation.eventReservationId);
    };
    TransientReservationStore.prototype.isReservationSelected = function (transientReservation) {
        return this._selectedReservations.has(transientReservation.eventReservationId);
    };
    return TransientReservationStore;
}());
transient_reservation_store_TransientReservationStore = transient_reservation_store___decorate([
    Object(core_es5["Injectable"])(),
    transient_reservation_store___metadata("design:paramtypes", [typeof (transient_reservation_store__a = typeof flash_messages_service_FlashMessagesService !== "undefined" && flash_messages_service_FlashMessagesService) === "function" && transient_reservation_store__a || Object, typeof (transient_reservation_store__b = typeof transient_reservation_http_service_TransientReservationService !== "undefined" && transient_reservation_http_service_TransientReservationService) === "function" && transient_reservation_store__b || Object, typeof (transient_reservation_store__c = typeof log_service_LogService !== "undefined" && log_service_LogService) === "function" && transient_reservation_store__c || Object])
], transient_reservation_store_TransientReservationStore);

var transient_reservation_store__a, transient_reservation_store__b, transient_reservation_store__c;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/transient-reservation-store.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/reservations/transient-table/TransientReservationLinkAction.ts
var TransientReservationLinkAction;
(function (TransientReservationLinkAction) {
    TransientReservationLinkAction[TransientReservationLinkAction["LINK_AND_DO_NOT_PAY_VIA_GP"] = 'LINK_AND_DO_NOT_PAY_VIA_GP'] = "LINK_AND_DO_NOT_PAY_VIA_GP";
    TransientReservationLinkAction[TransientReservationLinkAction["LINK_AND_PAY_VIA_GP"] = 'LINK_AND_PAY_VIA_GP'] = "LINK_AND_PAY_VIA_GP";
})(TransientReservationLinkAction || (TransientReservationLinkAction = {}));
(function (TransientReservationLinkAction) {
    function getValue(key) {
        return TransientReservationLinkAction[key];
    }
    TransientReservationLinkAction.getValue = getValue;
    function fromString(value) {
        return TransientReservationLinkAction[value];
    }
    TransientReservationLinkAction.fromString = fromString;
})(TransientReservationLinkAction || (TransientReservationLinkAction = {}));
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/TransientReservationLinkAction.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/reservations/transient-table/transient-table.component.ts
var transient_table_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var transient_table_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};














var transient_table_component_TransientTableComponent = (function () {
    function TransientTableComponent(logService, transientReservationStore, flashMessagesService, translateService, eventValidationService) {
        this.logService = logService;
        this.transientReservationStore = transientReservationStore;
        this.flashMessagesService = flashMessagesService;
        this.translateService = translateService;
        this.eventValidationService = eventValidationService;
        this.selectorType = 'radio';
        this.confirmationModalConfig = new ConfirmationModalConfig();
        this.updatePage = new core_es5["EventEmitter"]();
        this.noRecords = false;
        this.allReservationsChecked = false;
    }
    Object.defineProperty(TransientTableComponent.prototype, "searchResults", {
        get: function () {
            return this._searchResults;
        },
        set: function (searchResults) {
            this._searchResults = searchResults;
            if (this.searchResults && this.searchResults.content) {
                // searchResults.content is declared as a List<T> in the Page model but it is actually an array
                this.noRecords = this.searchResults.content.size === 0 || this.searchResults.content['length'] === 0;
                this.synchronizeSelectedReservations();
            }
            this.synchronizeAllReservationsChecked();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TransientTableComponent.prototype, "confirmLinkingMessage", {
        get: function () {
            if (this.selectorType !== 'checkbox') {
                return 'EVENT.TRANSIENT_RESERVATION.CONFIRM_LINK_RESERVATION';
            }
            else {
                return this.translateService.instant('EVENT.TRANSIENT_RESERVATION.CONFIRM_LINK_MULTIPLE_RESERVATIONS', { selectedReservations: this.transientReservationStore.selectedReservations.length });
            }
        },
        enumerable: true,
        configurable: true
    });
    TransientTableComponent.prototype.ngOnInit = function () {
        this.canChangeReservations$ = this.eventValidationService.canChangeReservations();
    };
    TransientTableComponent.prototype.obtainTransientReservationSelected = function () {
        var result$ = new Observable["Observable"]();
        if (this.transientReservationSelected) {
            result$ = Object(of["of"])(this.transientReservationSelected);
        }
        else {
            result$ = Object(of["of"])(this.searchResults.content[0]);
        }
        return result$;
    };
    TransientTableComponent.prototype.onSelect = function (selectedItem) {
        this.logService.log(new LogMessage(LogLevel.DEBUG, "Selected item Id: " + selectedItem.confirmation));
        if (this.transientReservationSelected) {
            this.transientReservationSelected.selected = false;
        }
        this.transientReservationSelected = selectedItem;
        this.transientReservationSelected.selected = true;
    };
    TransientTableComponent.prototype.cleanSelected = function () {
        this.transientReservationSelected = undefined;
    };
    TransientTableComponent.prototype.confirmLinkingAndPayViaGP = function () {
        this.confirmLinkAction = TransientReservationLinkAction.LINK_AND_PAY_VIA_GP.toString();
        this.confirmationModalConfig.confirm = 'EVENT.TRANSIENT_RESERVATION.LINK_SELECTED_AND_PAY_VIA_GROUPPAY_CONFIRMATION_BTN';
        this.confirmLinkModal.open();
    };
    TransientTableComponent.prototype.confirmLinkingAndDoNotPayViaGP = function () {
        this.confirmLinkAction = TransientReservationLinkAction.LINK_AND_DO_NOT_PAY_VIA_GP.toString();
        this.confirmationModalConfig.confirm = 'EVENT.TRANSIENT_RESERVATION.LINK_SELECTED_AND_DO_NOT_PAY_VIA_GROUPPAY_CONFIRMATION_BTN';
        this.confirmLinkModal.open();
    };
    TransientTableComponent.prototype.confirmLinkHandler = function (linkConfirmed) {
        if (linkConfirmed) {
            var transientReservationIdListToLink = void 0;
            if (this.selectorType !== 'checkbox') {
                transientReservationIdListToLink = [this.transientReservationSelected.eventReservationId];
            }
            else {
                transientReservationIdListToLink = this.transientReservationStore.selectedReservations.map(function (r) { return r.eventReservationId; });
            }
            var action = TransientReservationLinkAction.fromString(linkConfirmed);
            var doNotPay = action === TransientReservationLinkAction.LINK_AND_DO_NOT_PAY_VIA_GP;
            this.logService.log(new LogMessage(LogLevel.DEBUG, "Linking transient reservation IDs: " + transientReservationIdListToLink + " - Not pay: " + doNotPay));
            this.linkReservation(transientReservationIdListToLink, doNotPay);
        }
        this.transientReservationSelected = null;
    };
    TransientTableComponent.prototype.linkReservation = function (transientReservationIdListToLink, doNotPay) {
        var _this = this;
        var page = this.searchResults.number;
        var itemsPerPage = this.searchResults.size;
        var $obs = this.transientReservationStore.linkTransientReservationsToEvent(transientReservationIdListToLink, this.event.eventProperty.eventPartyId, doNotPay);
        $obs.subscribe(function () {
            _this.flashMessagesService.success('MESSAGES.SUCCESS.TRANSIENT_RESERVATIONS_LINKED');
            _this.transientReservationStore.clearSelectedReservations();
            _this.updatePage.emit({ page: page, itemsPerPage: itemsPerPage });
            _this.synchronizeSelectedReservations();
            _this.synchronizeAllReservationsChecked();
        });
        return $obs;
    };
    TransientTableComponent.prototype.onCheckboxChange = function (searchResult) {
        searchResult.selected = !searchResult.selected;
        if (!searchResult.selected) {
            this.transientReservationStore.removeFromSelectedReservations(searchResult);
        }
        else {
            this.transientReservationStore.pushToSelectedReservations(searchResult);
        }
        this.synchronizeAllReservationsChecked();
    };
    TransientTableComponent.prototype.onAllCheckboxChange = function (event) {
        var _this = this;
        this.searchResults.content.forEach(function (reservation) {
            reservation.selected = event.target.checked;
            if (event.target.checked) {
                _this.transientReservationStore.pushToSelectedReservations(reservation);
            }
            else {
                _this.transientReservationStore.removeFromSelectedReservations(reservation);
            }
        });
        this.allReservationsChecked = event.target.checked;
    };
    TransientTableComponent.prototype.synchronizeAllReservationsChecked = function () {
        if (this.searchResults && this.searchResults.content) {
            this.allReservationsChecked = this.searchResults.content.every(function (reservation) { return reservation.selected; });
        }
        else {
            this.allReservationsChecked = false;
        }
    };
    TransientTableComponent.prototype.hasSelectedReservations = function () {
        return this.transientReservationStore.selectedReservations.length > 0;
    };
    TransientTableComponent.prototype.synchronizeSelectedReservations = function () {
        var _this = this;
        this._searchResults.content.forEach(function (reservation) {
            reservation.selected = _this.transientReservationStore.isReservationSelected(reservation);
        });
    };
    return TransientTableComponent;
}());
transient_table_component___decorate([
    Object(core_es5["Input"])(),
    transient_table_component___metadata("design:type", typeof (transient_table_component__a = typeof OnyxEvent !== "undefined" && OnyxEvent) === "function" && transient_table_component__a || Object)
], transient_table_component_TransientTableComponent.prototype, "event", void 0);
transient_table_component___decorate([
    Object(core_es5["Input"])(),
    transient_table_component___metadata("design:type", typeof (transient_table_component__b = typeof Rsvp !== "undefined" && Rsvp) === "function" && transient_table_component__b || Object)
], transient_table_component_TransientTableComponent.prototype, "rsvp", void 0);
transient_table_component___decorate([
    Object(core_es5["Input"])(),
    transient_table_component___metadata("design:type", Object)
], transient_table_component_TransientTableComponent.prototype, "selectorType", void 0);
transient_table_component___decorate([
    Object(core_es5["ViewChild"])('confirmLinkModal'),
    transient_table_component___metadata("design:type", typeof (transient_table_component__c = typeof confirmation_modal_component_ConfirmationModalComponent !== "undefined" && confirmation_modal_component_ConfirmationModalComponent) === "function" && transient_table_component__c || Object)
], transient_table_component_TransientTableComponent.prototype, "confirmLinkModal", void 0);
transient_table_component___decorate([
    Object(core_es5["Output"])(),
    transient_table_component___metadata("design:type", typeof (transient_table_component__d = typeof core_es5["EventEmitter"] !== "undefined" && core_es5["EventEmitter"]) === "function" && transient_table_component__d || Object)
], transient_table_component_TransientTableComponent.prototype, "updatePage", void 0);
transient_table_component___decorate([
    Object(core_es5["Input"])(),
    transient_table_component___metadata("design:type", typeof (transient_table_component__e = typeof page_Page !== "undefined" && page_Page) === "function" && transient_table_component__e || Object),
    transient_table_component___metadata("design:paramtypes", [typeof (transient_table_component__f = typeof page_Page !== "undefined" && page_Page) === "function" && transient_table_component__f || Object])
], transient_table_component_TransientTableComponent.prototype, "searchResults", null);
transient_table_component_TransientTableComponent = transient_table_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-transient-table',
        styles: [__webpack_require__("fWfk")],
        template: __webpack_require__("vgM6")
    }),
    transient_table_component___metadata("design:paramtypes", [typeof (transient_table_component__g = typeof log_service_LogService !== "undefined" && log_service_LogService) === "function" && transient_table_component__g || Object, typeof (transient_table_component__h = typeof transient_reservation_store_TransientReservationStore !== "undefined" && transient_reservation_store_TransientReservationStore) === "function" && transient_table_component__h || Object, typeof (transient_table_component__j = typeof flash_messages_service_FlashMessagesService !== "undefined" && flash_messages_service_FlashMessagesService) === "function" && transient_table_component__j || Object, typeof (transient_table_component__k = typeof core["c" /* TranslateService */] !== "undefined" && core["c" /* TranslateService */]) === "function" && transient_table_component__k || Object, typeof (transient_table_component__l = typeof event_validation_service_EventValidationService !== "undefined" && event_validation_service_EventValidationService) === "function" && transient_table_component__l || Object])
], transient_table_component_TransientTableComponent);

var transient_table_component__a, transient_table_component__b, transient_table_component__c, transient_table_component__d, transient_table_component__e, transient_table_component__f, transient_table_component__g, transient_table_component__h, transient_table_component__j, transient_table_component__k, transient_table_component__l;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/transient-table.component.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/transient-reservation-search-params.ts
var transient_reservation_search_params___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var TransientReservationSearchParametersRecord = Object(immutable["Record"])({
    eventId: null,
    eventPartyId: null,
    firstName: null,
    lastName: null,
    minCheckInDate: null,
    maxCheckOutDate: null,
    ratePlanCode: null,
    confirmation: null
});
var TransientReservationSearchParameters = (function (_super) {
    transient_reservation_search_params___extends(TransientReservationSearchParameters, _super);
    function TransientReservationSearchParameters() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return TransientReservationSearchParameters;
}(TransientReservationSearchParametersRecord));

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/transient-reservation-search-params.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/reservations/transient-search/transient-search.component.ts
var transient_search_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var transient_search_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};














var transient_search_component_TransientSearchComponent = (function () {
    function TransientSearchComponent(formBuilder, transientReservationStore, userLocalStorageService, authenticationStore) {
        this.formBuilder = formBuilder;
        this.transientReservationStore = transientReservationStore;
        this.userLocalStorageService = userLocalStorageService;
        this.authenticationStore = authenticationStore;
        this.hasSearched = new core_es5["EventEmitter"]();
        this._validateNameFilters = true;
        this.searchClicked = new core_es5["EventEmitter"]();
        this.isRatePlanCodeFilterVisible = false;
        this.isConfirmationFilterVisible = false;
    }
    Object.defineProperty(TransientSearchComponent.prototype, "event", {
        get: function () {
            return this._event;
        },
        set: function (event) {
            this._event = event;
            if (event) {
                if (this.currentEventId && (this.currentEventId !== event.eventId)) {
                    this.resetForm();
                }
                this.currentEventId = event.eventId;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TransientSearchComponent.prototype, "validateNameFilters", {
        set: function (validateNameFilters) { this._validateNameFilters = validateNameFilters; },
        enumerable: true,
        configurable: true
    });
    TransientSearchComponent.prototype.ngOnInit = function () {
        if (!this.event) {
            throw new Error('The "event" attribute must be specified to use the TransientSearchComponent component');
        }
        this.initSearchForm(null);
    };
    TransientSearchComponent.prototype.resetForm = function () {
        this.initSearchForm(null);
        this.transientReservationStore.setTransientReservationPage(new page_Page());
        this.hasSearched.emit(false);
    };
    TransientSearchComponent.prototype.initSearchForm = function (rsvp) {
        var _startDate = EventUtils.getEventStartDate(this.event, this.authenticationStore.isAgencyUser());
        var _endDate = EventUtils.getEventEndDate(this.event, this.authenticationStore.isAgencyUser());
        // Calculate 3 days prior to the event start date
        this.checkInDates = [
            _startDate,
            date_util_DateUtil.subtractDaysFromDate(_startDate, 1),
            date_util_DateUtil.subtractDaysFromDate(_startDate, 2),
            date_util_DateUtil.subtractDaysFromDate(_startDate, 3)
        ];
        // Calculate 3 days after the event end date
        this.checkOutDates = [
            _endDate,
            date_util_DateUtil.addDaysToDate(_endDate, 1),
            date_util_DateUtil.addDaysToDate(_endDate, 2),
            date_util_DateUtil.addDaysToDate(_endDate, 3)
        ];
        this.transientSearchForm = this.formBuilder.group({
            firstName: [rsvp ? rsvp.firstName : null,
                [forms_es5["Validators"].maxLength(50)]],
            lastName: [rsvp ? rsvp.lastName : null,
                [forms_es5["Validators"].maxLength(50)]],
            minCheckInDate: [_startDate, [pioneer_validators_PioneerValidators.isDate]],
            maxCheckOutDate: [_endDate, [pioneer_validators_PioneerValidators.isDate]],
            ratePlanCode: [null, [forms_es5["Validators"].maxLength(10)]],
            confirmation: [null, [forms_es5["Validators"].maxLength(32)]]
        }, {
            validator: this._validateNameFilters ? pioneer_validators_PioneerValidators.isFirstNameOrLastNameRequiredCrossValidator('firstName', 'lastName') : null
        });
    };
    TransientSearchComponent.prototype.searchTransientReservations = function (event) {
        event.preventDefault();
        this.refreshTransientReservations(Constants.SEARCH_DEFAULT_PAGE);
        this.searchClicked.emit();
    };
    TransientSearchComponent.prototype.refreshTransientReservations = function (page, searchParams) {
        var _this = this;
        if (searchParams) {
            this.transientReservationSearch = searchParams;
        }
        else {
            this.transientReservationSearch = new TransientReservationSearchParameters({
                eventId: this.event.eventId,
                eventPartyId: this.event.eventProperty.eventPartyId,
                firstName: this.parseString(this.transientSearchForm.get('firstName').value),
                lastName: this.parseString(this.transientSearchForm.get('lastName').value),
                minCheckInDate: date_util_DateUtil.formatDate(this.transientSearchForm.get('minCheckInDate').value),
                maxCheckOutDate: date_util_DateUtil.formatDate(this.transientSearchForm.get('maxCheckOutDate').value),
                ratePlanCode: this.parseString(this.transientSearchForm.get('ratePlanCode').value),
                confirmation: this.parseString(this.transientSearchForm.get('confirmation').value)
            });
        }
        this.transientReservationStore.searchTransientReservations(this.transientReservationSearch, page, this.userLocalStorageService.getPagesize(PagesizeType.TRANSIENT_RESERVATIONS)).subscribe(function (result) {
            _this.hasSearched.emit(true);
        });
    };
    TransientSearchComponent.prototype.parseString = function (value) {
        if (Object(util_util["isNullOrUndefined"])(value) || value.trim().length === 0) {
            return null;
        }
        return value;
    };
    TransientSearchComponent.prototype.disableSearch = function () {
        var disable;
        if (this.transientSearchForm) {
            disable = !this.transientSearchForm.valid;
        }
        else {
            disable = true;
        }
        return disable;
    };
    return TransientSearchComponent;
}());
transient_search_component___decorate([
    Object(core_es5["Input"])(),
    transient_search_component___metadata("design:type", typeof (transient_search_component__a = typeof OnyxEvent !== "undefined" && OnyxEvent) === "function" && transient_search_component__a || Object),
    transient_search_component___metadata("design:paramtypes", [typeof (transient_search_component__b = typeof OnyxEvent !== "undefined" && OnyxEvent) === "function" && transient_search_component__b || Object])
], transient_search_component_TransientSearchComponent.prototype, "event", null);
transient_search_component___decorate([
    Object(core_es5["Output"])(),
    transient_search_component___metadata("design:type", typeof (transient_search_component__c = typeof core_es5["EventEmitter"] !== "undefined" && core_es5["EventEmitter"]) === "function" && transient_search_component__c || Object)
], transient_search_component_TransientSearchComponent.prototype, "hasSearched", void 0);
transient_search_component___decorate([
    Object(core_es5["Input"])(),
    transient_search_component___metadata("design:type", typeof (transient_search_component__d = typeof page_Page !== "undefined" && page_Page) === "function" && transient_search_component__d || Object)
], transient_search_component_TransientSearchComponent.prototype, "searchResults", void 0);
transient_search_component___decorate([
    Object(core_es5["Input"])(),
    transient_search_component___metadata("design:type", Boolean),
    transient_search_component___metadata("design:paramtypes", [Boolean])
], transient_search_component_TransientSearchComponent.prototype, "validateNameFilters", null);
transient_search_component___decorate([
    Object(core_es5["Output"])(),
    transient_search_component___metadata("design:type", typeof (transient_search_component__e = typeof core_es5["EventEmitter"] !== "undefined" && core_es5["EventEmitter"]) === "function" && transient_search_component__e || Object)
], transient_search_component_TransientSearchComponent.prototype, "searchClicked", void 0);
transient_search_component___decorate([
    Object(core_es5["Input"])(),
    transient_search_component___metadata("design:type", Object)
], transient_search_component_TransientSearchComponent.prototype, "isRatePlanCodeFilterVisible", void 0);
transient_search_component___decorate([
    Object(core_es5["Input"])(),
    transient_search_component___metadata("design:type", Object)
], transient_search_component_TransientSearchComponent.prototype, "isConfirmationFilterVisible", void 0);
transient_search_component_TransientSearchComponent = transient_search_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-transient-search',
        template: __webpack_require__("/JMp")
    }),
    transient_search_component___metadata("design:paramtypes", [typeof (transient_search_component__f = typeof forms_es5["FormBuilder"] !== "undefined" && forms_es5["FormBuilder"]) === "function" && transient_search_component__f || Object, typeof (transient_search_component__g = typeof transient_reservation_store_TransientReservationStore !== "undefined" && transient_reservation_store_TransientReservationStore) === "function" && transient_search_component__g || Object, typeof (transient_search_component__h = typeof user_local_storage_service_UserLocalStorageService !== "undefined" && user_local_storage_service_UserLocalStorageService) === "function" && transient_search_component__h || Object, typeof (transient_search_component__j = typeof authentication_store_AuthenticationStore !== "undefined" && authentication_store_AuthenticationStore) === "function" && transient_search_component__j || Object])
], transient_search_component_TransientSearchComponent);

var transient_search_component__a, transient_search_component__b, transient_search_component__c, transient_search_component__d, transient_search_component__e, transient_search_component__f, transient_search_component__g, transient_search_component__h, transient_search_component__j;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/transient-search.component.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/reservations/transient-reservation/transient-reservation.component.ts
var transient_reservation_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var transient_reservation_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};








var transient_reservation_component_TransientReservationComponent = (function () {
    function TransientReservationComponent(eventStore, transientReservationStore, menuStore) {
        this.eventStore = eventStore;
        this.transientReservationStore = transientReservationStore;
        this.menuStore = menuStore;
        this.pagesizeType = PagesizeType.TRANSIENT_RESERVATIONS;
    }
    TransientReservationComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.eventStore.selectedEvent.subscribe(function (ev) { return _this.onyxEvent = ev; });
        this.hasSearched = false;
        if (this.onyxEvent) {
            this.menuStore.setPageHeader(EventUtils.getEventName(this.onyxEvent, false), this.onyxEvent.eventProperty.subscriber);
        }
        else {
            throw new Error('The "event" attribute must be specified to use the TransientReservationComponent component');
        }
    };
    TransientReservationComponent.prototype.onHasSearched = function () {
        var _this = this;
        this.hasSearched = true;
        var obs$ = this.transientReservationStore.searchResults.take(1);
        obs$.subscribe(function (page) {
            _this.searchResults = page;
        });
    };
    TransientReservationComponent.prototype.onRefreshList = function (page) {
        this.transientSearchComponent.refreshTransientReservations(page);
    };
    TransientReservationComponent.prototype.onSearchClicked = function () {
        this.transientReservationStore.clearSelectedReservations();
    };
    return TransientReservationComponent;
}());
transient_reservation_component___decorate([
    Object(core_es5["ViewChild"])(transient_table_component_TransientTableComponent),
    transient_reservation_component___metadata("design:type", typeof (transient_reservation_component__a = typeof transient_table_component_TransientTableComponent !== "undefined" && transient_table_component_TransientTableComponent) === "function" && transient_reservation_component__a || Object)
], transient_reservation_component_TransientReservationComponent.prototype, "transientTableComponent", void 0);
transient_reservation_component___decorate([
    Object(core_es5["ViewChild"])(transient_search_component_TransientSearchComponent),
    transient_reservation_component___metadata("design:type", typeof (transient_reservation_component__b = typeof transient_search_component_TransientSearchComponent !== "undefined" && transient_search_component_TransientSearchComponent) === "function" && transient_reservation_component__b || Object)
], transient_reservation_component_TransientReservationComponent.prototype, "transientSearchComponent", void 0);
transient_reservation_component_TransientReservationComponent = transient_reservation_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-transient-reservation',
        template: __webpack_require__("JVpk")
    }),
    transient_reservation_component___metadata("design:paramtypes", [typeof (transient_reservation_component__c = typeof event_store_EventStore !== "undefined" && event_store_EventStore) === "function" && transient_reservation_component__c || Object, typeof (transient_reservation_component__d = typeof transient_reservation_store_TransientReservationStore !== "undefined" && transient_reservation_store_TransientReservationStore) === "function" && transient_reservation_component__d || Object, typeof (transient_reservation_component__e = typeof menu_store_MenuStore !== "undefined" && menu_store_MenuStore) === "function" && transient_reservation_component__e || Object])
], transient_reservation_component_TransientReservationComponent);

var transient_reservation_component__a, transient_reservation_component__b, transient_reservation_component__c, transient_reservation_component__d, transient_reservation_component__e;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/transient-reservation.component.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/rsvp/rsvp-compare.resolver.ts
var rsvp_compare_resolver___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var rsvp_compare_resolver___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};





var rsvp_compare_resolver_RsvpCompareResolver = (function () {
    function RsvpCompareResolver(reservationCompareStore, translateService, logService, router) {
        var _this = this;
        this.reservationCompareStore = reservationCompareStore;
        this.translateService = translateService;
        this.logService = logService;
        this.router = router;
        this.previousRoute = null;
        // This code is required in order to know the previous route in resolve.
        // Note that first the NavigationStart event will happen, then resolve() is called if the resolver is attached
        // to the route, then NavigationEnd happens.
        this.router.events
            .filter(function (e) { return e instanceof router_es5["NavigationEnd"]; })
            .subscribe(function (e) {
            _this.previousRoute = e.url;
        });
    }
    RsvpCompareResolver.prototype.resolve = function (route, state) {
        var id = route.params['id'];
        var eventPartyId = route.params['eventPartyId'];
        if (!id) {
            throw new Error(this.translateService.instant('MESSAGES.ERROR.COULD_NOT_GET_RSVPS'));
        }
        if (eventPartyId) {
            return this.reservationCompareStore.getRsvpsByParty(route.params['id'], eventPartyId).first();
        }
        else {
            return this.reservationCompareStore.getRsvps(route.params['id']).first();
        }
    };
    return RsvpCompareResolver;
}());
rsvp_compare_resolver_RsvpCompareResolver = rsvp_compare_resolver___decorate([
    Object(core_es5["Injectable"])(),
    rsvp_compare_resolver___metadata("design:paramtypes", [typeof (rsvp_compare_resolver__a = typeof reservation_compare_store_ReservationCompareStore !== "undefined" && reservation_compare_store_ReservationCompareStore) === "function" && rsvp_compare_resolver__a || Object, typeof (rsvp_compare_resolver__b = typeof core["c" /* TranslateService */] !== "undefined" && core["c" /* TranslateService */]) === "function" && rsvp_compare_resolver__b || Object, typeof (rsvp_compare_resolver__c = typeof log_service_LogService !== "undefined" && log_service_LogService) === "function" && rsvp_compare_resolver__c || Object, typeof (rsvp_compare_resolver__d = typeof router_es5["Router"] !== "undefined" && router_es5["Router"]) === "function" && rsvp_compare_resolver__d || Object])
], rsvp_compare_resolver_RsvpCompareResolver);

var rsvp_compare_resolver__a, rsvp_compare_resolver__b, rsvp_compare_resolver__c, rsvp_compare_resolver__d;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/rsvp-compare.resolver.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/rsvp/rsvp-detail.resolver.ts
var rsvp_detail_resolver___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var rsvp_detail_resolver___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};





var RsvpDetailResolver = (function () {
    function RsvpDetailResolver(reservationCompareStore, flashMessagesService, router, logService) {
        this.reservationCompareStore = reservationCompareStore;
        this.flashMessagesService = flashMessagesService;
        this.router = router;
        this.logService = logService;
    }
    RsvpDetailResolver.prototype.resolve = function (route, state) {
        var _this = this;
        var obs$;
        var id = route.params['id'];
        var eventPartyId = route.params['eventPartyId'];
        if (eventPartyId) {
            this.reservationCompareStore.getRsvpsByParty(id, eventPartyId).subscribe(function () {
                obs$ = _this.reservationCompareStore.isCompareListEmpty();
                obs$.take(1).subscribe(function (isEmpty) {
                    if (!isEmpty) {
                        _this.reservationCompareStore.selectedRsvpId = Number(route.queryParams['rsvp']);
                        var path = route.url.map(function (urlSegment) { return urlSegment.path; }).join('/');
                        _this.logService.info('router URL path ends with /detail: ' + path.endsWith('/detail'));
                        _this.reservationCompareStore.setShowReservationCompareSummary(!path.endsWith('/detail'));
                    }
                    else {
                        _this.router.navigate(['event/' + id + '/' + eventPartyId + '/rsvp']).then(function () {
                            _this.flashMessagesService.error('MESSAGES.ERROR.UNABLE_TO_NAVIGATE');
                        });
                    }
                });
            });
        }
        else {
            this.reservationCompareStore.getRsvps(id).subscribe(function () {
                obs$ = _this.reservationCompareStore.isCompareListEmpty();
                obs$.take(1).subscribe(function (isEmpty) {
                    if (!isEmpty) {
                        _this.reservationCompareStore.selectedRsvpId = Number(route.queryParams['rsvp']);
                        var path = route.url.map(function (urlSegment) { return urlSegment.path; }).join('/');
                        _this.logService.info('router URL path ends with /detail: ' + path.endsWith('/detail'));
                        _this.reservationCompareStore.setShowReservationCompareSummary(!path.endsWith('/detail'));
                    }
                    else {
                        _this.router.navigate(['event/' + id + '/rsvp']).then(function () {
                            _this.flashMessagesService.error('MESSAGES.ERROR.UNABLE_TO_NAVIGATE');
                        });
                    }
                });
            });
        }
        return obs$;
    };
    return RsvpDetailResolver;
}());
RsvpDetailResolver = rsvp_detail_resolver___decorate([
    Object(core_es5["Injectable"])(),
    rsvp_detail_resolver___metadata("design:paramtypes", [typeof (rsvp_detail_resolver__a = typeof reservation_compare_store_ReservationCompareStore !== "undefined" && reservation_compare_store_ReservationCompareStore) === "function" && rsvp_detail_resolver__a || Object, typeof (rsvp_detail_resolver__b = typeof flash_messages_service_FlashMessagesService !== "undefined" && flash_messages_service_FlashMessagesService) === "function" && rsvp_detail_resolver__b || Object, typeof (rsvp_detail_resolver__c = typeof router_es5["Router"] !== "undefined" && router_es5["Router"]) === "function" && rsvp_detail_resolver__c || Object, typeof (rsvp_detail_resolver__d = typeof log_service_LogService !== "undefined" && log_service_LogService) === "function" && rsvp_detail_resolver__d || Object])
], RsvpDetailResolver);

var rsvp_detail_resolver__a, rsvp_detail_resolver__b, rsvp_detail_resolver__c, rsvp_detail_resolver__d;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/rsvp-detail.resolver.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/rsvp/rsvp-page/rsvp-page.component.ts
var rsvp_page_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var rsvp_page_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};







var rsvp_page_component_RsvpComponent = (function () {
    function RsvpComponent(eventStore, reservationCompareStore, menuStore, router, authStore) {
        this.eventStore = eventStore;
        this.reservationCompareStore = reservationCompareStore;
        this.menuStore = menuStore;
        this.router = router;
        this.authStore = authStore;
    }
    RsvpComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.eventStore.selectedEvent.subscribe(function (event) { return _this.onyxEvent = event; });
        if (this.onyxEvent) {
            this.menuStore.setPageHeader(EventUtils.getEventName(this.onyxEvent, this.authStore.isAgencyUser()), this.onyxEvent.eventProperty.subscriber);
            this.vendor = this.onyxEvent.eventProperty;
        }
        this.disableCompareButton$ = this.reservationCompareStore.isCompareListEmpty();
        this.showReservationCompareSummary$ = this.reservationCompareStore.getShowReservationCompareSummary();
        this.areRsvpsPresent$ = this.reservationCompareStore.areRsvpsPresent();
        this.checkDetailPath(this.router.url);
        if (this.isMultiVendor()) {
            this.eventLink = this.onyxEvent.eventId + '';
        }
        else {
            this.eventLink = this.onyxEvent.eventId + '/' + this.onyxEvent.eventProperty.eventPartyId;
        }
    };
    RsvpComponent.prototype.navigateTo = function (path) {
        this.checkDetailPath(path);
        this.router.navigate([path]);
    };
    RsvpComponent.prototype.checkDetailPath = function (path) {
        this.isInDetail = path.indexOf('/detail') !== -1;
    };
    RsvpComponent.prototype.isMultiVendor = function () {
        return this.authStore.hasPermission('MultiVendor');
    };
    return RsvpComponent;
}());
rsvp_page_component_RsvpComponent = rsvp_page_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-rsvp',
        template: __webpack_require__("UxNZ")
    }),
    rsvp_page_component___metadata("design:paramtypes", [typeof (rsvp_page_component__a = typeof event_store_EventStore !== "undefined" && event_store_EventStore) === "function" && rsvp_page_component__a || Object, typeof (rsvp_page_component__b = typeof reservation_compare_store_ReservationCompareStore !== "undefined" && reservation_compare_store_ReservationCompareStore) === "function" && rsvp_page_component__b || Object, typeof (rsvp_page_component__c = typeof menu_store_MenuStore !== "undefined" && menu_store_MenuStore) === "function" && rsvp_page_component__c || Object, typeof (rsvp_page_component__d = typeof router_es5["Router"] !== "undefined" && router_es5["Router"]) === "function" && rsvp_page_component__d || Object, typeof (rsvp_page_component__e = typeof authentication_store_AuthenticationStore !== "undefined" && authentication_store_AuthenticationStore) === "function" && rsvp_page_component__e || Object])
], rsvp_page_component_RsvpComponent);

var rsvp_page_component__a, rsvp_page_component__b, rsvp_page_component__c, rsvp_page_component__d, rsvp_page_component__e;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/rsvp-page.component.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/rsvp/rsvp.resolver.ts
var rsvp_resolver___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var rsvp_resolver___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};



var RsvpResolver = (function () {
    function RsvpResolver(rsvpStore, translateService) {
        this.rsvpStore = rsvpStore;
        this.translateService = translateService;
    }
    RsvpResolver.prototype.resolve = function (route, state) {
        var id = route.params['id'];
        var eventPartyId = route.params['eventPartyId'];
        if (!id) {
            throw new Error(this.translateService.instant('MESSAGES.ERROR.COULD_NOT_GET_RSVPS'));
        }
        if (eventPartyId) {
            return this.rsvpStore.loadRsvpsByParty(id, eventPartyId);
        }
        else {
            return this.rsvpStore.loadRsvps(id);
        }
    };
    return RsvpResolver;
}());
RsvpResolver = rsvp_resolver___decorate([
    Object(core_es5["Injectable"])(),
    rsvp_resolver___metadata("design:paramtypes", [typeof (rsvp_resolver__a = typeof rsvp_store_RsvpStore !== "undefined" && rsvp_store_RsvpStore) === "function" && rsvp_resolver__a || Object, typeof (rsvp_resolver__b = typeof core["c" /* TranslateService */] !== "undefined" && core["c" /* TranslateService */]) === "function" && rsvp_resolver__b || Object])
], RsvpResolver);

var rsvp_resolver__a, rsvp_resolver__b;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/rsvp.resolver.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/rsvp/vendor-rsvp-page/vendor-rsvp-page.component.ts
var vendor_rsvp_page_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var vendor_rsvp_page_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};









var vendor_rsvp_page_component_VendorRsvpComponent = (function () {
    function VendorRsvpComponent(menuStore, eventStore, authenticationStore) {
        this.menuStore = menuStore;
        this.eventStore = eventStore;
        this.authenticationStore = authenticationStore;
        this.eventSubscription$ = new Subscription["Subscription"]();
    }
    VendorRsvpComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.eventSubscription$ = this.eventStore.selectedEvent.subscribe(function (event) {
            _this.onyxEvent = new OnyxEvent(event);
            _this.menuStore.setPageHeader(EventUtils.getEventName(_this.onyxEvent, _this.authenticationStore.isAgencyUser()), _this.onyxEvent.eventProperty.subscriber);
        });
        this.headerRecordType = SummaryRecordTypeEnum.RSVP;
        this.total = 'total';
        this.checkMoreThanOneVendorExpanded();
    };
    VendorRsvpComponent.prototype.ngOnDestroy = function () {
        this.eventSubscription$.unsubscribe();
    };
    VendorRsvpComponent.prototype.getEventProperties = function () {
        return this.onyxEvent.eventVendors.filter(function (vendor) { return vendor.partyType === PartyType.PROPERTY && vendor.payorType === 'PROPERTY'; });
    };
    VendorRsvpComponent.prototype.showTotalSummary = function () {
        return this.getEventProperties().length > 1;
    };
    VendorRsvpComponent.prototype.checkMoreThanOneVendorExpanded = function () {
        var expanded = false;
        this.getEventProperties().forEach(function (party) {
            if (!expanded && party.isExpanded) {
                expanded = true;
            }
            else if (expanded) {
                party.isExpanded = false;
            }
        });
    };
    return VendorRsvpComponent;
}());
vendor_rsvp_page_component_VendorRsvpComponent = vendor_rsvp_page_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-vendor-rsvp-page',
        template: __webpack_require__("MgpT"),
        styles: [__webpack_require__("8aQ7")]
    }),
    vendor_rsvp_page_component___metadata("design:paramtypes", [typeof (vendor_rsvp_page_component__a = typeof menu_store_MenuStore !== "undefined" && menu_store_MenuStore) === "function" && vendor_rsvp_page_component__a || Object, typeof (vendor_rsvp_page_component__b = typeof event_store_EventStore !== "undefined" && event_store_EventStore) === "function" && vendor_rsvp_page_component__b || Object, typeof (vendor_rsvp_page_component__c = typeof authentication_store_AuthenticationStore !== "undefined" && authentication_store_AuthenticationStore) === "function" && vendor_rsvp_page_component__c || Object])
], vendor_rsvp_page_component_VendorRsvpComponent);

var vendor_rsvp_page_component__a, vendor_rsvp_page_component__b, vendor_rsvp_page_component__c;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/vendor-rsvp-page.component.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/chain-brand/chain.ts
var chain___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var ChainRecord = Object(immutable["Record"])({
    chainCode: null,
    name: null
});
var Chain = (function (_super) {
    chain___extends(Chain, _super);
    function Chain() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Chain;
}(ChainRecord));

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/chain.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/chain-brand/brand.ts
var brand___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var BrandRecord = Object(immutable["Record"])({
    brandCode: null,
    name: null
});
var Brand = (function (_super) {
    brand___extends(Brand, _super);
    function Brand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Brand;
}(BrandRecord));

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/brand.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/service/chainbrand/chain-brand.http-service.ts
var chain_brand_http_service___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var chain_brand_http_service___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};






var chain_brand_http_service_ChainBrandHttpService = (function () {
    function ChainBrandHttpService(http, environment, responseUtilService) {
        this.http = http;
        this.environment = environment;
        this.responseUtilService = responseUtilService;
        this.chainsEndpoint = this.environment.baseUrl + "/api/lookup/chains";
        this.brandsEndpoint = '/brands';
    }
    ChainBrandHttpService.prototype.getChains = function () {
        var _this = this;
        return this.http.get("" + this.chainsEndpoint)
            .map(function (response) { return response.json().map(function (chain) { return new Chain(chain); }); })
            .catch(function (error) { return _this.responseUtilService.handleError(error); })
            .share();
    };
    ChainBrandHttpService.prototype.getBrands = function (chainCode) {
        var _this = this;
        return this.http.get(this.chainsEndpoint + "/" + chainCode + this.brandsEndpoint)
            .map(function (response) { return response.json().map(function (brand) { return new Brand(brand); }); })
            .catch(function (error) { return _this.responseUtilService.handleError(error); })
            .share();
    };
    return ChainBrandHttpService;
}());
chain_brand_http_service_ChainBrandHttpService = chain_brand_http_service___decorate([
    Object(core_es5["Injectable"])(),
    chain_brand_http_service___metadata("design:paramtypes", [typeof (chain_brand_http_service__a = typeof AppAuthHttpService !== "undefined" && AppAuthHttpService) === "function" && chain_brand_http_service__a || Object, typeof (chain_brand_http_service__b = typeof EnvironmentConfiguration !== "undefined" && EnvironmentConfiguration) === "function" && chain_brand_http_service__b || Object, typeof (chain_brand_http_service__c = typeof response_util_service_ResponseUtilService !== "undefined" && response_util_service_ResponseUtilService) === "function" && chain_brand_http_service__c || Object])
], chain_brand_http_service_ChainBrandHttpService);

var chain_brand_http_service__a, chain_brand_http_service__b, chain_brand_http_service__c;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/chain-brand.http-service.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/service/chainbrand/chain-brand.mapper.ts


var chain_brand_mapper_ChainBrandMapper = (function () {
    function ChainBrandMapper() {
    }
    ChainBrandMapper.convertChainsToDropDownItem = function (chains) {
        return chains.map(function (chain) { return ChainBrandMapper.convertChainToDropDownItem(chain); });
    };
    ChainBrandMapper.convertBrandsToDropDownItem = function (brands) {
        return brands.map(function (brand) { return ChainBrandMapper.convertBrandToDropDownItem(brand); });
    };
    ChainBrandMapper.convertChainToDropDownItem = function (chain) {
        return new DropdownItem(pioneer_utils_PioneerUtils.safeTrim(chain.chainCode), pioneer_utils_PioneerUtils.safeTrim(chain.name));
    };
    ChainBrandMapper.convertBrandToDropDownItem = function (brand) {
        return new DropdownItem(pioneer_utils_PioneerUtils.safeTrim(brand.brandCode), pioneer_utils_PioneerUtils.safeTrim(brand.name));
    };
    return ChainBrandMapper;
}());

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/chain-brand.mapper.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/service/chainbrand/chain-brand.store.ts
var chain_brand_store___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var chain_brand_store___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};






var chain_brand_store_ChainBrandStore = (function () {
    function ChainBrandStore(_chainBrandHttpService, flashMessagesService) {
        this._chainBrandHttpService = _chainBrandHttpService;
        this.flashMessagesService = flashMessagesService;
        this.brands$ = new BehaviorSubject["BehaviorSubject"]([]);
        this.chains$ = new BehaviorSubject["BehaviorSubject"]([]);
    }
    Object.defineProperty(ChainBrandStore.prototype, "chainBrandHttpService", {
        get: function () { return this._chainBrandHttpService; },
        enumerable: true,
        configurable: true
    });
    ChainBrandStore.prototype.loadChains = function () {
        var _this = this;
        return this._chainBrandHttpService.getChains()
            .catch(function (error) {
            _this.flashMessagesService.error('MESSAGES.ERROR.COULD_NOT_GET_CHAINS', "Error retrieving chains: " + error);
            return Observable["Observable"].throw(error);
        })
            .map(function (chains) { return chain_brand_mapper_ChainBrandMapper.convertChainsToDropDownItem(chains); })
            .map(function (chains) {
            _this.chains$.next(chains);
            return chains;
        });
    };
    ChainBrandStore.prototype.loadBrandsFromChain = function (chainCode) {
        var _this = this;
        return this.getBrandsFromChain(chainCode)
            .map(function (brands) { return chain_brand_mapper_ChainBrandMapper.convertBrandsToDropDownItem(brands); })
            .map(function (brands) {
            _this.brands$.next(brands);
            return brands;
        });
    };
    Object.defineProperty(ChainBrandStore.prototype, "brands", {
        get: function () {
            return this.brands$.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ChainBrandStore.prototype, "chains", {
        get: function () {
            return this.chains$.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    ChainBrandStore.prototype.getBrandsFromChain = function (chainCode) {
        var _this = this;
        if (!chainCode) {
            return Observable["Observable"].of([]);
        }
        else {
            return this._chainBrandHttpService.getBrands(chainCode)
                .catch(function (error) {
                _this.flashMessagesService.error('MESSAGES.ERROR.COULD_NOT_GET_BRANDS', "Error retrieving brands: " + error);
                return Observable["Observable"].throw(error);
            });
        }
    };
    return ChainBrandStore;
}());
chain_brand_store_ChainBrandStore = chain_brand_store___decorate([
    Object(core_es5["Injectable"])(),
    chain_brand_store___metadata("design:paramtypes", [typeof (chain_brand_store__a = typeof chain_brand_http_service_ChainBrandHttpService !== "undefined" && chain_brand_http_service_ChainBrandHttpService) === "function" && chain_brand_store__a || Object, typeof (chain_brand_store__b = typeof flash_messages_service_FlashMessagesService !== "undefined" && flash_messages_service_FlashMessagesService) === "function" && chain_brand_store__b || Object])
], chain_brand_store_ChainBrandStore);

var chain_brand_store__a, chain_brand_store__b;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/chain-brand.store.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/service/chainbrand/chain.resolver.ts
var chain_resolver___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var chain_resolver___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};



var ChainResolver = (function () {
    function ChainResolver(chainStore, authStore) {
        this.chainStore = chainStore;
        this.authStore = authStore;
    }
    ChainResolver.prototype.resolve = function () {
        var chains$;
        if (this.authStore.hasPermission('ViewAllChains')) {
            chains$ = this.chainStore.loadChains();
        }
        return chains$;
    };
    return ChainResolver;
}());
ChainResolver = chain_resolver___decorate([
    Object(core_es5["Injectable"])(),
    chain_resolver___metadata("design:paramtypes", [typeof (chain_resolver__a = typeof chain_brand_store_ChainBrandStore !== "undefined" && chain_brand_store_ChainBrandStore) === "function" && chain_resolver__a || Object, typeof (chain_resolver__b = typeof authentication_store_AuthenticationStore !== "undefined" && authentication_store_AuthenticationStore) === "function" && chain_resolver__b || Object])
], ChainResolver);

var chain_resolver__a, chain_resolver__b;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/chain.resolver.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/service/common-data/country.resolver.ts
var country_resolver___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var country_resolver___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};


var CountryResolver = (function () {
    function CountryResolver(commonDataStore) {
        this.commonDataStore = commonDataStore;
    }
    CountryResolver.prototype.resolve = function () {
        return this.commonDataStore.loadCountries();
    };
    return CountryResolver;
}());
CountryResolver = country_resolver___decorate([
    Object(core_es5["Injectable"])(),
    country_resolver___metadata("design:paramtypes", [typeof (country_resolver__a = typeof common_data_store_CommonDataStore !== "undefined" && common_data_store_CommonDataStore) === "function" && country_resolver__a || Object])
], CountryResolver);

var country_resolver__a;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/country.resolver.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/service/common-data/currency.resolver.ts
var currency_resolver___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var currency_resolver___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};


var CurrencyResolver = (function () {
    function CurrencyResolver(commonDataStore) {
        this.commonDataStore = commonDataStore;
    }
    // resolve(): Observable<Currency[]> {
    //   return this.commonDataStore.loadCurrencies();
    // }
    CurrencyResolver.prototype.resolve = function () {
        return this.commonDataStore.loadCurrenciesDrop();
    };
    return CurrencyResolver;
}());
CurrencyResolver = currency_resolver___decorate([
    Object(core_es5["Injectable"])(),
    currency_resolver___metadata("design:paramtypes", [typeof (currency_resolver__a = typeof common_data_store_CommonDataStore !== "undefined" && common_data_store_CommonDataStore) === "function" && currency_resolver__a || Object])
], CurrencyResolver);

var currency_resolver__a;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/currency.resolver.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/reservations/vendor-reservation-page/vendor-reservation-page.component.ts
var vendor_reservation_page_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var vendor_reservation_page_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};









var vendor_reservation_page_component_VendorReservationComponent = (function () {
    function VendorReservationComponent(eventStore, menuStore, authenticationStore) {
        this.eventStore = eventStore;
        this.menuStore = menuStore;
        this.authenticationStore = authenticationStore;
        this.eventSubscription$ = new Subscription["Subscription"]();
    }
    VendorReservationComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.eventSubscription$ = this.eventStore.selectedEvent.subscribe(function (event) {
            _this.onyxEvent = new OnyxEvent(event);
            _this.menuStore.setPageHeader(EventUtils.getEventName(_this.onyxEvent, _this.authenticationStore.isAgencyUser()), _this.onyxEvent.eventProperty.subscriber);
        });
        this.headerRecordType = SummaryRecordTypeEnum.RESERVATION;
        this.total = 'total';
        this.checkMoreThanOneVendorExpanded();
    };
    VendorReservationComponent.prototype.ngOnDestroy = function () {
        this.eventSubscription$.unsubscribe();
    };
    VendorReservationComponent.prototype.getEventSubscriberProperties = function () {
        return this.onyxEvent.eventVendors
            .filter(function (vendor) { return vendor.partyType === PartyType.PROPERTY && vendor.payorType === 'PROPERTY' && vendor.subscriber; });
    };
    VendorReservationComponent.prototype.showTotalSummary = function () {
        return this.getEventSubscriberProperties().length > 1;
    };
    VendorReservationComponent.prototype.checkMoreThanOneVendorExpanded = function () {
        var expanded = false;
        this.getEventSubscriberProperties().forEach(function (party) {
            if (!expanded && party.isExpanded) {
                expanded = true;
            }
            else if (expanded) {
                party.isExpanded = false;
            }
        });
    };
    return VendorReservationComponent;
}());
vendor_reservation_page_component_VendorReservationComponent = vendor_reservation_page_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-vendor-reservation-page',
        template: __webpack_require__("O2zu"),
        styles: [__webpack_require__("4VeM")]
    }),
    vendor_reservation_page_component___metadata("design:paramtypes", [typeof (vendor_reservation_page_component__a = typeof event_store_EventStore !== "undefined" && event_store_EventStore) === "function" && vendor_reservation_page_component__a || Object, typeof (vendor_reservation_page_component__b = typeof menu_store_MenuStore !== "undefined" && menu_store_MenuStore) === "function" && vendor_reservation_page_component__b || Object, typeof (vendor_reservation_page_component__c = typeof authentication_store_AuthenticationStore !== "undefined" && authentication_store_AuthenticationStore) === "function" && vendor_reservation_page_component__c || Object])
], vendor_reservation_page_component_VendorReservationComponent);

var vendor_reservation_page_component__a, vendor_reservation_page_component__b, vendor_reservation_page_component__c;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/vendor-reservation-page.component.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/payment/ooiv-rules-validation.resolver.ts
var ooiv_rules_validation_resolver___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var ooiv_rules_validation_resolver___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};



var OoivRulesValidationResolver = (function () {
    function OoivRulesValidationResolver(ooivRulesStore, translateService) {
        this.ooivRulesStore = ooivRulesStore;
        this.translateService = translateService;
    }
    OoivRulesValidationResolver.prototype.resolve = function (route, state) {
        var id = route.params['id'];
        if (!id) {
            throw new Error(this.translateService.instant('MESSAGES.ERROR.OOIV_HEALTH'));
        }
        return this.ooivRulesStore.loadOoivExceptionRules(id);
    };
    return OoivRulesValidationResolver;
}());
OoivRulesValidationResolver = ooiv_rules_validation_resolver___decorate([
    Object(core_es5["Injectable"])(),
    ooiv_rules_validation_resolver___metadata("design:paramtypes", [typeof (ooiv_rules_validation_resolver__a = typeof ooiv_rules_store_OoivRulesStore !== "undefined" && ooiv_rules_store_OoivRulesStore) === "function" && ooiv_rules_validation_resolver__a || Object, typeof (ooiv_rules_validation_resolver__b = typeof core["c" /* TranslateService */] !== "undefined" && core["c" /* TranslateService */]) === "function" && ooiv_rules_validation_resolver__b || Object])
], OoivRulesValidationResolver);

var ooiv_rules_validation_resolver__a, ooiv_rules_validation_resolver__b;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/ooiv-rules-validation.resolver.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/payment/initial-payment.resolver.ts
var initial_payment_resolver___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var initial_payment_resolver___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};



var InitialPaymentResolver = (function () {
    function InitialPaymentResolver(translateService, paymentStore) {
        this.translateService = translateService;
        this.paymentStore = paymentStore;
    }
    InitialPaymentResolver.prototype.resolve = function (route, state) {
        var id = route.params['id'];
        var eventPartyId = route.params['eventPartyId'];
        if (!id) {
            throw new Error(this.translateService.instant('MESSAGES.ERROR.GET_LATEST_PAYMENT'));
        }
        if (eventPartyId) {
            return this.paymentStore.loadLatestInitialPaymentByParty(id, eventPartyId);
        }
        else {
            return this.paymentStore.loadLatestInitialPayments(id);
        }
    };
    return InitialPaymentResolver;
}());
InitialPaymentResolver = initial_payment_resolver___decorate([
    Object(core_es5["Injectable"])(),
    initial_payment_resolver___metadata("design:paramtypes", [typeof (initial_payment_resolver__a = typeof core["c" /* TranslateService */] !== "undefined" && core["c" /* TranslateService */]) === "function" && initial_payment_resolver__a || Object, typeof (initial_payment_resolver__b = typeof payment_store_PaymentStore !== "undefined" && payment_store_PaymentStore) === "function" && initial_payment_resolver__b || Object])
], InitialPaymentResolver);

var initial_payment_resolver__a, initial_payment_resolver__b;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/initial-payment.resolver.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/service/event-list.resolver.ts
var event_list_resolver___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var event_list_resolver___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};





var event_list_resolver_EventListResolver = (function () {
    function EventListResolver(searchParametersStore, logService) {
        this.searchParametersStore = searchParametersStore;
        this.logService = logService;
    }
    EventListResolver.prototype.resolve = function (route, state) {
        var searchTextList = search_event_utils_SearchEventUtils.convertParamsToSearchTextSet(route.queryParams);
        var searchFilterList = search_event_utils_SearchEventUtils.convertParamsToSearchFilterSet(route.queryParams);
        if (searchTextList.isEmpty() && searchFilterList.isEmpty()) {
            this.searchParametersStore.reset(true);
        }
        else {
            if (searchTextList) {
                this.searchParametersStore.setSearchTextSet(searchTextList);
            }
            if (searchFilterList) {
                this.searchParametersStore.setFilterSet(searchFilterList);
            }
        }
        this.logService.debug('route.url: ' + route.url);
        this.logService.debug('state.url: ' + state.url);
        if (route.data && route.data['view']) {
            this.logService.debug('route.data[ \'view\' ]: ' + route.data['view']);
            var showDefaultView = route.data['view'];
            this.logService.debug('showDefaultView: ' + showDefaultView);
            this.searchParametersStore.setDefaultViewSelected(showDefaultView === 'default');
        }
        return Object(of["of"])({ status: 'event-resolver' });
    };
    return EventListResolver;
}());
event_list_resolver_EventListResolver = event_list_resolver___decorate([
    Object(core_es5["Injectable"])(),
    event_list_resolver___metadata("design:paramtypes", [typeof (event_list_resolver__a = typeof event_search_parameters_store_EventSearchParametersStore !== "undefined" && event_search_parameters_store_EventSearchParametersStore) === "function" && event_list_resolver__a || Object, typeof (event_list_resolver__b = typeof log_service_LogService !== "undefined" && log_service_LogService) === "function" && event_list_resolver__b || Object])
], event_list_resolver_EventListResolver);

var event_list_resolver__a, event_list_resolver__b;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/event-list.resolver.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/service/agency-dashboard.http.service.ts
var agency_dashboard_http_service___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var agency_dashboard_http_service___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};




var agency_dashboard_http_service_AgencyDashboardService = (function () {
    function AgencyDashboardService(http, environment, userLocalStorageService) {
        this.http = http;
        this.environment = environment;
        this.userLocalStorageService = userLocalStorageService;
        this.agencyDashboardUrl = this.environment.agencyDashboardUrl + '/rest/private/dashboard';
    }
    // getall method with a http POST request with a json payload
    AgencyDashboardService.prototype.getAll = function (agencyCode) {
        var headers = new common_http_es5["d" /* HttpHeaders */]({
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + this.userLocalStorageService.getToken()
        });
        var options = {
            headers: headers
        };
        var bodyContent = JSON.stringify({
            section: 'all',
            timeframe: 'all',
            type: 'agency',
            code: agencyCode,
        });
        return this.http.post(this.agencyDashboardUrl, bodyContent, options);
    };
    AgencyDashboardService.prototype.getStatus = function (agencyCode, timeframe) {
        var headers = new common_http_es5["d" /* HttpHeaders */]({
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + this.userLocalStorageService.getToken()
        });
        var options = {
            headers: headers
        };
        var bodyContent = JSON.stringify({
            section: 'status',
            timeframe: timeframe,
            type: 'agency',
            code: agencyCode,
        });
        return this.http.post(this.agencyDashboardUrl, bodyContent, options);
    };
    AgencyDashboardService.prototype.getOverview = function (agencyCode, timeframe) {
        var headers = new common_http_es5["d" /* HttpHeaders */]({
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + this.userLocalStorageService.getToken()
        });
        var options = {
            headers: headers
        };
        var bodyContent = JSON.stringify({
            section: 'overview',
            timeframe: timeframe,
            type: 'agency',
            code: agencyCode,
        });
        return this.http.post(this.agencyDashboardUrl, bodyContent, options);
    };
    AgencyDashboardService.prototype.getTodoList = function (agencyCode, timeframe) {
        var headers = new common_http_es5["d" /* HttpHeaders */]({
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + this.userLocalStorageService.getToken()
        });
        var options = {
            headers: headers
        };
        var bodyContent = JSON.stringify({
            section: 'todolist',
            timeframe: timeframe,
            type: 'agency',
            code: agencyCode,
        });
        return this.http.post(this.agencyDashboardUrl, bodyContent, options);
    };
    return AgencyDashboardService;
}());
agency_dashboard_http_service_AgencyDashboardService = agency_dashboard_http_service___decorate([
    Object(core_es5["Injectable"])(),
    agency_dashboard_http_service___metadata("design:paramtypes", [typeof (agency_dashboard_http_service__a = typeof common_http_es5["b" /* HttpClient */] !== "undefined" && common_http_es5["b" /* HttpClient */]) === "function" && agency_dashboard_http_service__a || Object, typeof (agency_dashboard_http_service__b = typeof EnvironmentConfiguration !== "undefined" && EnvironmentConfiguration) === "function" && agency_dashboard_http_service__b || Object, typeof (agency_dashboard_http_service__c = typeof user_local_storage_service_UserLocalStorageService !== "undefined" && user_local_storage_service_UserLocalStorageService) === "function" && agency_dashboard_http_service__c || Object])
], agency_dashboard_http_service_AgencyDashboardService);

var agency_dashboard_http_service__a, agency_dashboard_http_service__b, agency_dashboard_http_service__c;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/agency-dashboard.http.service.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/agency-dashboard/agency-dashboard.component.ts
var agency_dashboard_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var agency_dashboard_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};












var agency_dashboard_component_AgencyDashboardComponent = (function () {
    function AgencyDashboardComponent(menuStore, userLocalStorageService, authenticationStore, eventStore, agencyDashboardService, multiAgencyService, eventSearchParametersStore, flashMessagesService, route) {
        this.menuStore = menuStore;
        this.userLocalStorageService = userLocalStorageService;
        this.authenticationStore = authenticationStore;
        this.eventStore = eventStore;
        this.agencyDashboardService = agencyDashboardService;
        this.multiAgencyService = multiAgencyService;
        this.eventSearchParametersStore = eventSearchParametersStore;
        this.flashMessagesService = flashMessagesService;
        this.route = route;
        this.statusSelected = 'all';
        this.headerSelected = 'all';
        this.agencyCode = '';
        this.showOverviewCard = '';
        this.defaultAgency$ = this.multiAgencyService.defaultAgency$;
        this.agencySubscription$ = new Subscription["Subscription"]();
    }
    Object.defineProperty(AgencyDashboardComponent.prototype, "username", {
        get: function () {
            return {
                username: this.user.firstName,
            };
        },
        enumerable: true,
        configurable: true
    });
    AgencyDashboardComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.updateDate = new Date();
        this.menuStore.setPageHeader('DASHBOARD.TITLE', false);
        this.eventStore.resetSelectedEvent();
        this.authenticationStore.user.subscribe(function (user) {
            _this.user = user;
        });
        this.multiAgencyService.defaultAgencyId.subscribe(function (agencyId) {
            _this.agencyCode = agencyId;
        });
        this.agencySubscription$ = this.defaultAgency$.subscribe(function () {
            _this.resetDashboard();
        });
        this.showOverviewCard = this.route.snapshot.queryParams['showOverviewCard'];
        // this.initDashboard();
    };
    AgencyDashboardComponent.prototype.initDashboard = function () {
        var _this = this;
        this.agencyDashboardService.getAll(this.agencyCode).subscribe(function (result) {
            if (result != null) {
                _this.updateDate = new Date();
                _this.dataAll = result;
                _this.messages = _this.dataAll.body.messages;
                _this.messages.forEach(function (element) {
                    element.closed = false;
                });
                _this.overview = _this.dataAll.body.overview;
                _this.overview.tot_comm_amt_str = _this.roundAmounts(_this.overview.tot_comm_amt);
                _this.overview.tot_pmt_amt_str = _this.roundAmounts(_this.overview.tot_pmt_amt);
                _this.todolist = _this.dataAll.body.todolist;
                _this.lastmodified = _this.dataAll.body.lastmodified;
                _this.status = _this.dataAll.body.status;
            }
        }, function (err) {
            _this.flashMessagesService.error('MESSAGES.ERROR.AGENCY_DASHBOARD_API_ERROR', "Error code: " + err.status);
        });
    };
    AgencyDashboardComponent.prototype.roundAmounts = function (amount) {
        if (amount > 1000000) {
            var rounded = this.round(amount / 1000000, 2);
            return rounded + 'M';
        }
        if (amount > 1000) {
            var rounded = this.round(amount / 1000, 2);
            return rounded + 'K';
        }
        return '' + amount;
    };
    AgencyDashboardComponent.prototype.round = function (num, fractionDigits) {
        return Number(num.toFixed(fractionDigits));
    };
    AgencyDashboardComponent.prototype.onStatusSelectChange = function (timeframe) {
        var _this = this;
        this.status = undefined;
        this.agencyDashboardService.getStatus(this.agencyCode, timeframe).subscribe(function (result) {
            if (result != null) {
                _this.status = result.body;
            }
        }, function (err) {
            _this.flashMessagesService.error('MESSAGES.ERROR.AGENCY_DASHBOARD_API_ERROR', "Error code: " + err.status);
        });
    };
    AgencyDashboardComponent.prototype.onHeaderSelectChange = function (timeframe) {
        var _this = this;
        this.overview = undefined;
        // this.todolist = undefined;
        this.agencyDashboardService
            .getOverview(this.agencyCode, timeframe)
            .subscribe(function (result) {
            if (result != null) {
                _this.overview = result.body;
                _this.overview.tot_comm_amt_str = _this.roundAmounts(_this.overview.tot_comm_amt);
                _this.overview.tot_pmt_amt_str = _this.roundAmounts(_this.overview.tot_pmt_amt);
            }
        }, function (err) {
            _this.flashMessagesService.error('MESSAGES.ERROR.AGENCY_DASHBOARD_API_ERROR', "Error code: " + err.status);
        });
    };
    AgencyDashboardComponent.prototype.onAgencyChange = function (code) {
        this.overview = undefined;
        this.todolist = undefined;
        this.status = undefined;
        this.dataAll = undefined;
        this.lastmodified = undefined;
        this.messages = undefined;
        this.agencyCode = code;
        this.statusSelected = 'all';
        this.headerSelected = 'all';
        this.initDashboard();
    };
    AgencyDashboardComponent.prototype.closedBulkActionModal = function (event) {
        this.resetDashboard();
    };
    AgencyDashboardComponent.prototype.resetDashboard = function () {
        this.overview = undefined;
        this.todolist = undefined;
        this.status = undefined;
        this.dataAll = undefined;
        this.lastmodified = undefined;
        this.messages = undefined;
        this.initDashboard();
    };
    Object.defineProperty(AgencyDashboardComponent.prototype, "BulkAction", {
        get: function () {
            return BulkAction;
        },
        enumerable: true,
        configurable: true
    });
    AgencyDashboardComponent.prototype.navigateToSearch = function () {
        this.eventSearchParametersStore.resetWithArchived(true);
        this.eventSearchParametersStore.updateUrl(true);
    };
    AgencyDashboardComponent.prototype.ngOnDestroy = function () {
        this.agencySubscription$.unsubscribe();
    };
    AgencyDashboardComponent.prototype.showOverview = function () {
        if (this.showOverviewCard === 'true') {
            return true;
        }
        return false;
    };
    return AgencyDashboardComponent;
}());
agency_dashboard_component_AgencyDashboardComponent = agency_dashboard_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-agency-dashboard',
        template: __webpack_require__("EK+0"),
        styles: [__webpack_require__("doUx")],
    }),
    agency_dashboard_component___metadata("design:paramtypes", [typeof (agency_dashboard_component__a = typeof menu_store_MenuStore !== "undefined" && menu_store_MenuStore) === "function" && agency_dashboard_component__a || Object, typeof (agency_dashboard_component__b = typeof user_local_storage_service_UserLocalStorageService !== "undefined" && user_local_storage_service_UserLocalStorageService) === "function" && agency_dashboard_component__b || Object, typeof (agency_dashboard_component__c = typeof authentication_store_AuthenticationStore !== "undefined" && authentication_store_AuthenticationStore) === "function" && agency_dashboard_component__c || Object, typeof (agency_dashboard_component__d = typeof event_store_EventStore !== "undefined" && event_store_EventStore) === "function" && agency_dashboard_component__d || Object, typeof (agency_dashboard_component__e = typeof agency_dashboard_http_service_AgencyDashboardService !== "undefined" && agency_dashboard_http_service_AgencyDashboardService) === "function" && agency_dashboard_component__e || Object, typeof (agency_dashboard_component__f = typeof multi_agency_service_MultiAgencyService !== "undefined" && multi_agency_service_MultiAgencyService) === "function" && agency_dashboard_component__f || Object, typeof (agency_dashboard_component__g = typeof event_search_parameters_store_EventSearchParametersStore !== "undefined" && event_search_parameters_store_EventSearchParametersStore) === "function" && agency_dashboard_component__g || Object, typeof (agency_dashboard_component__h = typeof flash_messages_service_FlashMessagesService !== "undefined" && flash_messages_service_FlashMessagesService) === "function" && agency_dashboard_component__h || Object, typeof (agency_dashboard_component__j = typeof router_es5["ActivatedRoute"] !== "undefined" && router_es5["ActivatedRoute"]) === "function" && agency_dashboard_component__j || Object])
], agency_dashboard_component_AgencyDashboardComponent);

var agency_dashboard_component__a, agency_dashboard_component__b, agency_dashboard_component__c, agency_dashboard_component__d, agency_dashboard_component__e, agency_dashboard_component__f, agency_dashboard_component__g, agency_dashboard_component__h, agency_dashboard_component__j;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/agency-dashboard.component.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/invoice-history/invoice-history.component.ts
var invoice_history_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var invoice_history_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};








var invoice_history_component_InvoiceHistoryComponent = (function () {
    function InvoiceHistoryComponent(environment, invoiceHistoryStore, eventStore, authenticationStore, multiAgencyService) {
        this.environment = environment;
        this.invoiceHistoryStore = invoiceHistoryStore;
        this.eventStore = eventStore;
        this.authenticationStore = authenticationStore;
        this.multiAgencyService = multiAgencyService;
        this.userUrl = '/secure/invoice-history/user';
        this.defaultAgency$ = this.multiAgencyService.defaultAgency$;
        this._destroyed$ = new Subject["Subject"]();
    }
    InvoiceHistoryComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.invoiceUrl = this.getDefaultUrl();
        if (this.auth) {
            this.invoiceUrl = this.invoiceUrl + '&authorization=' + this.auth;
        }
        else {
            this.defaultAgency$.pipe(Object(operators["takeUntil"])(this._destroyed$), Object(operators["switchMap"])(function (agency) {
                return _this.eventStore.selectedEvent;
            }), Object(operators["switchMap"])(function (event) {
                if (!event || !event.eventId) {
                    _this.invoiceUrl = _this.getDefaultUserUrl();
                }
                return _this.getInvoiceHistory(event);
            }), Object(operators["tap"])(function (token) {
                _this.invoiceUrl = _this.invoiceUrl + '&authorization=' + token;
            })).subscribe();
        }
    };
    InvoiceHistoryComponent.prototype.getInvoiceHistory = function (event) {
        var invoiceHistoryAuth$;
        if (event && event.eventId) {
            if (this.authenticationStore.isAgencyUser()) {
                invoiceHistoryAuth$ = this.invoiceHistoryStore.getInvoiceHistoryEventAgencyAuth(event.eventId);
            }
            else {
                invoiceHistoryAuth$ = this.invoiceHistoryStore.getInvoiceHistoryEventPropertyAuth(event.eventId);
            }
        }
        else {
            if (this.authenticationStore.isAgencyUser()) {
                invoiceHistoryAuth$ = this.invoiceHistoryStore.getInvoiceHistoryAgencyAuth();
            }
            else {
                invoiceHistoryAuth$ = this.invoiceHistoryStore.getInvoiceHistoryPropertyAuth();
            }
        }
        return invoiceHistoryAuth$;
    };
    InvoiceHistoryComponent.prototype.getDefaultUrl = function () {
        return this.environment.invoiceHistoryUrl + '?dt=' + this.getRandomNumber();
    };
    InvoiceHistoryComponent.prototype.getDefaultUserUrl = function () {
        return this.environment.invoiceHistoryUrl + this.userUrl + '?dt=' + this.getRandomNumber();
    };
    InvoiceHistoryComponent.prototype.getRandomNumber = function () {
        return Math.floor(Math.random() * (999999 - 100000 + 1)) + 100000;
    };
    InvoiceHistoryComponent.prototype.isMultiVendor = function () {
        return this.authenticationStore.hasPermission('MultiVendor');
    };
    InvoiceHistoryComponent.prototype.ngOnDestroy = function () {
        this._destroyed$.next();
        this._destroyed$.complete();
    };
    return InvoiceHistoryComponent;
}());
invoice_history_component___decorate([
    Object(core_es5["Input"])(),
    invoice_history_component___metadata("design:type", String)
], invoice_history_component_InvoiceHistoryComponent.prototype, "auth", void 0);
invoice_history_component_InvoiceHistoryComponent = invoice_history_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-invoice-history',
        template: __webpack_require__("Cxda"),
        styles: [__webpack_require__("7twq")]
    }),
    invoice_history_component___metadata("design:paramtypes", [typeof (invoice_history_component__a = typeof EnvironmentConfiguration !== "undefined" && EnvironmentConfiguration) === "function" && invoice_history_component__a || Object, typeof (invoice_history_component__b = typeof invoice_history_store_InvoiceHistoryStore !== "undefined" && invoice_history_store_InvoiceHistoryStore) === "function" && invoice_history_component__b || Object, typeof (invoice_history_component__c = typeof event_store_EventStore !== "undefined" && event_store_EventStore) === "function" && invoice_history_component__c || Object, typeof (invoice_history_component__d = typeof authentication_store_AuthenticationStore !== "undefined" && authentication_store_AuthenticationStore) === "function" && invoice_history_component__d || Object, typeof (invoice_history_component__e = typeof multi_agency_service_MultiAgencyService !== "undefined" && multi_agency_service_MultiAgencyService) === "function" && invoice_history_component__e || Object])
], invoice_history_component_InvoiceHistoryComponent);

var invoice_history_component__a, invoice_history_component__b, invoice_history_component__c, invoice_history_component__d, invoice_history_component__e;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/invoice-history.component.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/invoice-history-vendor/invoice-history-vendor.component.ts
var invoice_history_vendor_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var invoice_history_vendor_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};




var invoice_history_vendor_component_InvoiceHistoryVendorComponent = (function () {
    function InvoiceHistoryVendorComponent(eventStore) {
        this.eventStore = eventStore;
        this.eventSubscription$ = new Subscription["Subscription"]();
    }
    InvoiceHistoryVendorComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.eventSubscription$ = this.eventStore.selectedEvent.subscribe(function (event) {
            _this.onyxEvent = new OnyxEvent(event);
        });
    };
    return InvoiceHistoryVendorComponent;
}());
invoice_history_vendor_component_InvoiceHistoryVendorComponent = invoice_history_vendor_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-invoice-history-vendor',
        template: __webpack_require__("cmeK"),
        styles: [__webpack_require__("FEP9")]
    }),
    invoice_history_vendor_component___metadata("design:paramtypes", [typeof (invoice_history_vendor_component__a = typeof event_store_EventStore !== "undefined" && event_store_EventStore) === "function" && invoice_history_vendor_component__a || Object])
], invoice_history_vendor_component_InvoiceHistoryVendorComponent);

var invoice_history_vendor_component__a;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/invoice-history-vendor.component.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/invoice-history-user/invoice-history-user.component.ts
var invoice_history_user_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var invoice_history_user_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};


var InvoiceHistoryUserComponent = (function () {
    function InvoiceHistoryUserComponent(eventStore) {
        this.eventStore = eventStore;
    }
    InvoiceHistoryUserComponent.prototype.ngOnInit = function () {
        this.eventStore.resetSelectedEvent();
    };
    return InvoiceHistoryUserComponent;
}());
InvoiceHistoryUserComponent = invoice_history_user_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-invoice-history-user',
        template: __webpack_require__("LhFe")
    }),
    invoice_history_user_component___metadata("design:paramtypes", [typeof (invoice_history_user_component__a = typeof event_store_EventStore !== "undefined" && event_store_EventStore) === "function" && invoice_history_user_component__a || Object])
], InvoiceHistoryUserComponent);

var invoice_history_user_component__a;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/invoice-history-user.component.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/service/invoice-history.resolver.ts
var invoice_history_resolver___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var invoice_history_resolver___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};



var invoice_history_resolver_InvoiceHistoryResolver = (function () {
    function InvoiceHistoryResolver(invoiceHistoryStore) {
        this.invoiceHistoryStore = invoiceHistoryStore;
    }
    InvoiceHistoryResolver.prototype.resolve = function (route, state) {
        this.invoiceHistoryStore.loadInvoiceHistoryEnabled();
        return Object(of["of"])({ status: 'invoice-history-resolver' });
    };
    return InvoiceHistoryResolver;
}());
invoice_history_resolver_InvoiceHistoryResolver = invoice_history_resolver___decorate([
    Object(core_es5["Injectable"])(),
    invoice_history_resolver___metadata("design:paramtypes", [typeof (invoice_history_resolver__a = typeof invoice_history_store_InvoiceHistoryStore !== "undefined" && invoice_history_store_InvoiceHistoryStore) === "function" && invoice_history_resolver__a || Object])
], invoice_history_resolver_InvoiceHistoryResolver);

var invoice_history_resolver__a;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/invoice-history.resolver.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/service/event-has-items.resolver.ts
var event_has_items_resolver___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var event_has_items_resolver___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};









var event_has_items_resolver_EventHasItemsResolver = (function () {
    function EventHasItemsResolver(eventHttpService, reservationStore, rsvpStore, flashMessagesService, translateService) {
        this.eventHttpService = eventHttpService;
        this.reservationStore = reservationStore;
        this.rsvpStore = rsvpStore;
        this.flashMessagesService = flashMessagesService;
        this.translateService = translateService;
    }
    EventHasItemsResolver.prototype.resolve = function (route, state) {
        var _this = this;
        var eventId = route.params['id'];
        if (!eventId) {
            throw new Error(this.translateService.instant('MESSAGES.ERROR.COULD_NOT_CHECK_EVENT_HAS_ITEMS'));
        }
        var eventPartyId = route.params['eventPartyId'];
        var serviceCall;
        if (!!eventPartyId) {
            serviceCall = this.eventHttpService.fetchHasItemsByParty(eventId, eventPartyId);
        }
        else {
            serviceCall = this.eventHttpService.fetchHasItems(eventId);
        }
        return serviceCall.pipe(Object(operators["take"])(1), Object(operators["catchError"])(function (error) {
            _this.flashMessagesService.error('MESSAGES.ERROR.COULD_NOT_CHECK_EVENT_HAS_ITEMS', "Error retrieving items: " + error);
            return Observable["Observable"].throw(error);
        }), Object(operators["filter"])(function (response) { return response instanceof EventHasItemsByVendor; }), Object(operators["tap"])(function (eventHasItemsByVendor) {
            _this.reservationStore.loadEventHasReservationsCache(eventHasItemsByVendor.hasReservationsByVendor);
            _this.rsvpStore.loadEventHasRsvpsCache(eventHasItemsByVendor.hasRsvpsByVendor);
        }), Object(operators["map"])(function () {
            return;
        }));
    };
    return EventHasItemsResolver;
}());
event_has_items_resolver_EventHasItemsResolver = event_has_items_resolver___decorate([
    Object(core_es5["Injectable"])(),
    event_has_items_resolver___metadata("design:paramtypes", [typeof (event_has_items_resolver__a = typeof event_http_service_EventHttpService !== "undefined" && event_http_service_EventHttpService) === "function" && event_has_items_resolver__a || Object, typeof (event_has_items_resolver__b = typeof reservation_store_ReservationStore !== "undefined" && reservation_store_ReservationStore) === "function" && event_has_items_resolver__b || Object, typeof (event_has_items_resolver__c = typeof rsvp_store_RsvpStore !== "undefined" && rsvp_store_RsvpStore) === "function" && event_has_items_resolver__c || Object, typeof (event_has_items_resolver__d = typeof flash_messages_service_FlashMessagesService !== "undefined" && flash_messages_service_FlashMessagesService) === "function" && event_has_items_resolver__d || Object, typeof (event_has_items_resolver__e = typeof core["c" /* TranslateService */] !== "undefined" && core["c" /* TranslateService */]) === "function" && event_has_items_resolver__e || Object])
], event_has_items_resolver_EventHasItemsResolver);

var event_has_items_resolver__a, event_has_items_resolver__b, event_has_items_resolver__c, event_has_items_resolver__d, event_has_items_resolver__e;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/event-has-items.resolver.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/matching-agency/matching-agency.component.ts
var matching_agency_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var matching_agency_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};





var matching_agency_component_MatchingAgencyComponent = (function () {
    function MatchingAgencyComponent(matchingAgencyService, menuStore) {
        this.matchingAgencyService = matchingAgencyService;
        this.menuStore = menuStore;
        this.pagesizeType = PagesizeType.MATCHING_AGENCY;
    }
    MatchingAgencyComponent.prototype.ngOnInit = function () {
        this.menuStore.setPageHeader('EVENT.AGENCY_REVIEW.LIST_PAGE_TITLE', false);
        this.currentPage = Constants.SEARCH_DEFAULT_PAGE;
    };
    Object.defineProperty(MatchingAgencyComponent.prototype, "agenciesPresent", {
        get: function () {
            return this.agencyCount.map(function (agencyCount) {
                return agencyCount > 0;
            });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MatchingAgencyComponent.prototype, "agencyCount", {
        get: function () {
            return this.matchingAgencyService.totalAgencyCount;
        },
        enumerable: true,
        configurable: true
    });
    MatchingAgencyComponent.prototype.onRefreshList = function (page, field, direction) {
        this.currentPage = page;
        this.matchingAgencyService
            .refreshMatchingAgencies(page, field, direction)
            .take(1).subscribe();
    };
    Object.defineProperty(MatchingAgencyComponent.prototype, "agencies", {
        get: function () {
            return this.matchingAgencyService.agencies;
        },
        enumerable: true,
        configurable: true
    });
    return MatchingAgencyComponent;
}());
matching_agency_component_MatchingAgencyComponent = matching_agency_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-matching-agency',
        template: __webpack_require__("unYk"),
        styles: []
    }),
    matching_agency_component___metadata("design:paramtypes", [typeof (matching_agency_component__a = typeof matching_agency_service_MatchingAgencyService !== "undefined" && matching_agency_service_MatchingAgencyService) === "function" && matching_agency_component__a || Object, typeof (matching_agency_component__b = typeof menu_store_MenuStore !== "undefined" && menu_store_MenuStore) === "function" && matching_agency_component__b || Object])
], matching_agency_component_MatchingAgencyComponent);

var matching_agency_component__a, matching_agency_component__b;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/matching-agency.component.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/matching-agency-candidate-assign.ts
var matching_agency_candidate_assign___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var MatchingAgencyCandidateAssignRecord = Object(immutable["Record"])({
    'matchingAgencyId': null,
    'matchingAgencyCandidateId': null
});
var MatchingAgencyCandidateAssign = (function (_super) {
    matching_agency_candidate_assign___extends(MatchingAgencyCandidateAssign, _super);
    function MatchingAgencyCandidateAssign() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return MatchingAgencyCandidateAssign;
}(MatchingAgencyCandidateAssignRecord));

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/matching-agency-candidate-assign.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/matching-agency-add.ts
var matching_agency_add___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var MatchingAgencyAddRecord = Object(immutable["Record"])({
    'matchingAgencyId': null,
    'taCode': null,
    'eventId': null
});
var MatchingAgencyAdd = (function (_super) {
    matching_agency_add___extends(MatchingAgencyAdd, _super);
    function MatchingAgencyAdd() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return MatchingAgencyAdd;
}(MatchingAgencyAddRecord));

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/matching-agency-add.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/matching-agency/matching-agency-candidate/matching-agency-candidate.component.ts
var matching_agency_candidate_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var matching_agency_candidate_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};














var matching_agency_candidate_component_MatchingAgencyCandidateComponent = (function () {
    function MatchingAgencyCandidateComponent(formBuilder, matchingAgencyService, router, menuStore, translateService, flashMessagesService) {
        this.formBuilder = formBuilder;
        this.matchingAgencyService = matchingAgencyService;
        this.router = router;
        this.menuStore = menuStore;
        this.translateService = translateService;
        this.flashMessagesService = flashMessagesService;
        this.confirmationModalConfig = new ConfirmationModalConfig();
        this._destroy$ = new Subject["Subject"]();
    }
    MatchingAgencyCandidateComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.menuStore.setPageHeader('EVENT.AGENCY_REVIEW.CANDIDATE_PAGE_TITLE', false);
        this.candidatesForm = this.formBuilder.group({
            'matchingOption': [null,]
        });
        this.matchingAgencyService.selectedAgency$
            .pipe(Object(operators["takeUntil"])(this._destroy$))
            .subscribe(function (agency) {
            _this.agency = agency;
        });
        this.matchingAgencyService.selectedPage$
            .pipe(Object(operators["takeUntil"])(this._destroy$))
            .subscribe(function (page) {
            _this.currentPage = page;
        });
    };
    MatchingAgencyCandidateComponent.prototype.ngOnDestroy = function () {
        this._destroy$.next();
        this._destroy$.complete();
    };
    Object.defineProperty(MatchingAgencyCandidateComponent.prototype, "matchingOption", {
        get: function () {
            return this.getFormControlValue('matchingOption');
        },
        enumerable: true,
        configurable: true
    });
    MatchingAgencyCandidateComponent.prototype.getFormControlValue = function (name) {
        return this.candidatesForm ? this.candidatesForm.get(name).value : null;
    };
    MatchingAgencyCandidateComponent.prototype.noOptionSelected = function () {
        return !this.matchingOption;
    };
    MatchingAgencyCandidateComponent.prototype.cancelMatch = function () {
        this.resetForm();
        this.matchingAgencyService.resetSelectedAgency();
        this.router.navigate(['/events/matching/agency'], {});
    };
    MatchingAgencyCandidateComponent.prototype.resetForm = function () {
        this.candidatesForm = this.formBuilder.group({
            'matchingOption': [null,]
        });
    };
    MatchingAgencyCandidateComponent.prototype.matchCandidate = function () {
        var _this = this;
        var assign = this.agency.candidates.find(function (candidate) {
            return candidate.matchingAgencyCandidateId === Number(_this.matchingOption);
        });
        this.assignCandidate(assign);
    };
    MatchingAgencyCandidateComponent.prototype.assignCandidate = function (candidate) {
        var _this = this;
        this.candidatesForm.disable();
        var request = new MatchingAgencyCandidateAssign({
            matchingAgencyId: this.agency.matchingAgencyId,
            matchingAgencyCandidateId: candidate.matchingAgencyCandidateId
        });
        this.matchingAgencyService.assignMatchingCandidate(request).pipe(Object(operators["take"])(1), Object(operators["tap"])(function () {
            _this.refreshAgencies(_this.currentPage);
        }), Object(operators["catchError"])(function () {
            return Observable["Observable"].of(null);
        }), Object(operators["finalize"])(function () {
            _this.candidatesForm.enable();
        })).subscribe();
    };
    MatchingAgencyCandidateComponent.prototype.refreshAgencies = function (page) {
        var _this = this;
        this.matchingAgencyService.refreshMatchingAgencies(page)
            .pipe(Object(operators["take"])(1))
            .subscribe(function () {
            _this.cancelMatch();
        });
    };
    MatchingAgencyCandidateComponent.prototype.addNewAgency = function () {
        var _this = this;
        var request = new MatchingAgencyAdd({
            matchingAgencyId: this.agency.matchingAgencyId,
            taCode: this.agency.taCode,
            eventId: this.agency.eventId
        });
        try {
            this.matchingAgencyService.addAgency(request)
                .pipe(Object(operators["take"])(1))
                .subscribe(function () {
                _this.refreshAgencies(_this.currentPage);
            });
        }
        catch (error) {
            Observable["Observable"].throw(error);
        }
    };
    MatchingAgencyCandidateComponent.prototype.confirmBeforeAddAgency = function () {
        // set up the title of the confirmation modal
        var label = 'EVENT.AGENCY_REVIEW.ADD_AGENCY_CONFIRMATION_TITLE';
        var confirmLabel = 'EVENT.AGENCY_REVIEW.CONFIRMATION_ADD';
        var params = {};
        var title = this.translateService.instant(label, params);
        var confirmTitle = this.translateService.instant(confirmLabel);
        this.confirmationModalConfig.title = title;
        this.confirmationModalConfig.confirm = confirmTitle;
        this.confirmationModal.open();
    };
    MatchingAgencyCandidateComponent.prototype.confirmBeforeAddAgencyHandler = function (value) {
        if (value) {
            this.addNewAgency();
        }
    };
    return MatchingAgencyCandidateComponent;
}());
matching_agency_candidate_component___decorate([
    Object(core_es5["ViewChild"])(confirmation_modal_component_ConfirmationModalComponent),
    matching_agency_candidate_component___metadata("design:type", typeof (matching_agency_candidate_component__a = typeof confirmation_modal_component_ConfirmationModalComponent !== "undefined" && confirmation_modal_component_ConfirmationModalComponent) === "function" && matching_agency_candidate_component__a || Object)
], matching_agency_candidate_component_MatchingAgencyCandidateComponent.prototype, "confirmationModal", void 0);
matching_agency_candidate_component_MatchingAgencyCandidateComponent = matching_agency_candidate_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-matching-agency-candidate',
        template: __webpack_require__("3v0A"),
        styles: []
    }),
    matching_agency_candidate_component___metadata("design:paramtypes", [typeof (matching_agency_candidate_component__b = typeof forms_es5["FormBuilder"] !== "undefined" && forms_es5["FormBuilder"]) === "function" && matching_agency_candidate_component__b || Object, typeof (matching_agency_candidate_component__c = typeof matching_agency_service_MatchingAgencyService !== "undefined" && matching_agency_service_MatchingAgencyService) === "function" && matching_agency_candidate_component__c || Object, typeof (matching_agency_candidate_component__d = typeof router_es5["Router"] !== "undefined" && router_es5["Router"]) === "function" && matching_agency_candidate_component__d || Object, typeof (matching_agency_candidate_component__e = typeof menu_store_MenuStore !== "undefined" && menu_store_MenuStore) === "function" && matching_agency_candidate_component__e || Object, typeof (matching_agency_candidate_component__f = typeof core["c" /* TranslateService */] !== "undefined" && core["c" /* TranslateService */]) === "function" && matching_agency_candidate_component__f || Object, typeof (matching_agency_candidate_component__g = typeof flash_messages_service_FlashMessagesService !== "undefined" && flash_messages_service_FlashMessagesService) === "function" && matching_agency_candidate_component__g || Object])
], matching_agency_candidate_component_MatchingAgencyCandidateComponent);

var matching_agency_candidate_component__a, matching_agency_candidate_component__b, matching_agency_candidate_component__c, matching_agency_candidate_component__d, matching_agency_candidate_component__e, matching_agency_candidate_component__f, matching_agency_candidate_component__g;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/matching-agency-candidate.component.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/guards/agency-dashboard-redirect-guard.ts
var agency_dashboard_redirect_guard___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var agency_dashboard_redirect_guard___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};




var AgencyDashboardRedirectGuard = (function () {
    function AgencyDashboardRedirectGuard(router, authStore, logService) {
        this.router = router;
        this.authStore = authStore;
        this.logService = logService;
    }
    AgencyDashboardRedirectGuard.prototype.canActivate = function (route, state) {
        var gpWindow = window;
        if (this.authStore.hasPermission('ViewDashboard')) {
            if (this.authStore.isAgencyUser()) {
                // if (gpWindow.configGroupPay && gpWindow.configGroupPay.showAgencyDashboard) {
                //   return true;
                // }
                return true;
            }
            this.router.navigate(['/dashboard']);
            return false;
        }
        else {
            this.logService.debug('Redirecting to /events since user has no permission to see Dashboard');
            this.router.navigate(['/events']);
            return false;
        }
    };
    return AgencyDashboardRedirectGuard;
}());
AgencyDashboardRedirectGuard = agency_dashboard_redirect_guard___decorate([
    Object(core_es5["Injectable"])(),
    agency_dashboard_redirect_guard___metadata("design:paramtypes", [typeof (agency_dashboard_redirect_guard__a = typeof router_es5["Router"] !== "undefined" && router_es5["Router"]) === "function" && agency_dashboard_redirect_guard__a || Object, typeof (agency_dashboard_redirect_guard__b = typeof authentication_store_AuthenticationStore !== "undefined" && authentication_store_AuthenticationStore) === "function" && agency_dashboard_redirect_guard__b || Object, typeof (agency_dashboard_redirect_guard__c = typeof log_service_LogService !== "undefined" && log_service_LogService) === "function" && agency_dashboard_redirect_guard__c || Object])
], AgencyDashboardRedirectGuard);

var agency_dashboard_redirect_guard__a, agency_dashboard_redirect_guard__b, agency_dashboard_redirect_guard__c;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/agency-dashboard-redirect-guard.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/service/payment-summary/payment-summary.resolver.ts
var payment_summary_resolver___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var payment_summary_resolver___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};




var payment_summary_resolver_PaymentSummaryResolver = (function () {
    function PaymentSummaryResolver(paymentSummaryStore, eventStore) {
        this.paymentSummaryStore = paymentSummaryStore;
        this.eventStore = eventStore;
    }
    PaymentSummaryResolver.prototype.resolve = function (route, state) {
        var _this = this;
        return this.extractEventPartyIds().pipe(Object(operators["mergeMap"])(function (eventPartyIdSet) { return _this.paymentSummaryStore.resolveCache(eventPartyIdSet); }));
    };
    PaymentSummaryResolver.prototype.extractEventPartyIds = function () {
        return this.eventStore.selectedEvent.pipe(Object(operators["take"])(1), Object(operators["defaultIfEmpty"])(null), Object(operators["map"])(function (event) {
            if (!event) {
                throw new Error('Could not obtain selected event');
            }
            var eventPartyIds = [];
            if (event.eventProperty) {
                eventPartyIds.push(event.eventProperty.eventPartyId);
            }
            if (event.eventVendors) {
                event.eventVendors.forEach(function (v) { return eventPartyIds.push(v.eventPartyId); });
            }
            var uniqueValidIds = new Set(eventPartyIds.filter(function (id) { return !!id; }));
            if (uniqueValidIds.size === 0) {
                throw new Error('Could not identify vendors');
            }
            return uniqueValidIds;
        }));
    };
    return PaymentSummaryResolver;
}());
payment_summary_resolver_PaymentSummaryResolver = payment_summary_resolver___decorate([
    Object(core_es5["Injectable"])(),
    payment_summary_resolver___metadata("design:paramtypes", [typeof (payment_summary_resolver__a = typeof payment_summary_store_PaymentSummaryStore !== "undefined" && payment_summary_store_PaymentSummaryStore) === "function" && payment_summary_resolver__a || Object, typeof (payment_summary_resolver__b = typeof event_store_EventStore !== "undefined" && event_store_EventStore) === "function" && payment_summary_resolver__b || Object])
], payment_summary_resolver_PaymentSummaryResolver);

var payment_summary_resolver__a, payment_summary_resolver__b;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/payment-summary.resolver.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/event.routes.ts































































var event_routes_routes = [
    {
        path: '',
        redirectTo: '/dashboard',
        pathMatch: 'full',
        resolve: {
            invoiceHistoryData: invoice_history_resolver_InvoiceHistoryResolver
        }
    },
    {
        path: 'dashboard',
        canActivate: [DashboardRedirectGuard, CanActivateViaAuthGuard],
        children: [
            {
                path: '',
                outlet: 'navigation',
                component: app_menu_component_AppMenuComponent
            },
            {
                path: '',
                component: dashboard_component_DashboardComponent
            }
        ]
    },
    {
        path: 'dashboard-agency',
        canActivate: [AgencyDashboardRedirectGuard, CanActivateViaAuthGuard],
        children: [
            {
                path: '',
                outlet: 'navigation',
                component: app_menu_component_AppMenuComponent
            },
            {
                path: '',
                component: agency_dashboard_component_AgencyDashboardComponent
            }
        ]
    },
    {
        path: 'events',
        canActivate: [CanActivateViaAuthGuard],
        children: [
            {
                path: '',
                outlet: 'navigation',
                component: app_menu_component_AppMenuComponent
            },
            {
                path: '',
                component: event_list_component_EventListComponent,
                resolve: {
                    countriesData: CountryResolver,
                    eventListData: event_list_resolver_EventListResolver
                },
                runGuardsAndResolvers: 'paramsOrQueryParamsChange',
                data: { view: 'default' }
            },
            {
                path: 'financial',
                component: event_list_component_EventListComponent,
                resolve: {
                    eventListData: event_list_resolver_EventListResolver
                },
                runGuardsAndResolvers: 'paramsOrQueryParamsChange',
                data: { view: 'financial' }
            },
            {
                path: 'add',
                component: add_event_component_AddEventComponent,
                canActivate: [PermissionGuard],
                canDeactivate: [unsaved_changes_guard_UnsavedChangesGuard],
                data: { allowedPermissions: ['addevent'] },
                resolve: {
                    countriesData: CountryResolver,
                    currenciesData: CurrencyResolver,
                    chainsData: ChainResolver,
                    payorTypesData: PayorTypeResolver,
                    customLabelData: custom_label_resolver_CustomLabelResolver
                }
            },
            {
                path: 'matching/property',
                component: matching_property_component_MatchingPropertyComponent,
                canActivate: [PermissionGuard],
                data: { allowedPermissions: ['viewInternalReview'] },
                resolve: {}
            },
            {
                path: 'matching/property/candidates',
                component: matching_property_candidate_component_MatchingPropertyCandidateComponent,
                canActivate: [PermissionGuard],
                data: { allowedPermissions: ['viewInternalReview'] },
                resolve: {}
            },
            {
                path: 'matching/agency',
                component: matching_agency_component_MatchingAgencyComponent,
                canActivate: [PermissionGuard],
                data: { allowedPermissions: ['viewInternalReview'] },
                resolve: {}
            },
            {
                path: 'matching/agency/candidates',
                component: matching_agency_candidate_component_MatchingAgencyCandidateComponent,
                canActivate: [PermissionGuard],
                data: { allowedPermissions: ['viewInternalReview'] },
                resolve: {}
            },
            {
                path: 'event-match',
                component: event_match_component_EventMatchComponent,
            },
            {
                path: 'invoice-history',
                component: InvoiceHistoryUserComponent
            }
        ]
    },
    {
        path: 'event/:id',
        canActivate: [CanActivateViaAuthGuard],
        resolve: {
            eventsData: EventResolver,
            countriesData: CountryResolver,
            currenciesData: CurrencyResolver,
            latestPaymentData: LatestPaymentResolver,
            finalPaymentStatusData: FinalPaymentStatusResolver,
            payorTypesData: PayorTypeResolver,
            customLabelData: custom_label_resolver_CustomLabelResolver
        },
        children: [
            {
                path: '',
                outlet: 'navigation',
                component: app_menu_component_AppMenuComponent,
                children: [
                    {
                        path: '',
                        component: event_menu_component_EventMenuComponent,
                        outlet: 'event'
                    }
                ]
            },
            {
                path: '',
                redirectTo: 'overview',
                pathMatch: 'full'
            },
            {
                path: 'overview',
                component: vendor_overview_page_component_VendorOverviewComponent,
                canActivate: [VendorOverviewRedirectGuard],
                resolve: {
                    overviewData: OverviewResolver,
                    transactions: vendor_transaction_resolver_VendorTransactionResolver,
                    reservationData: ReservationResolver,
                    rsvpData: RsvpResolver
                }
            },
            {
                path: 'summary',
                component: event_component_EventComponent,
                resolve: {
                    attachmentData: AttachmentResolver,
                    paymentsData: PaymentsResolver,
                    eventHasItemsData: event_has_items_resolver_EventHasItemsResolver
                }
            },
            {
                path: 'summary/edit',
                component: event_component_EventComponent,
                resolve: {
                    attachmentData: AttachmentResolver,
                    paymentsData: PaymentsResolver,
                    latestPrepaymentData: LatestPrepaymentResolver,
                    latestPaymentData: LatestPaymentResolver,
                    chainsData: ChainResolver,
                    eventHasItemsData: event_has_items_resolver_EventHasItemsResolver
                },
                canActivate: [PermissionGuard, final_payment_authorized_guard_FinalPaymentAuthorizedGuard],
                canDeactivate: [unsaved_changes_guard_UnsavedChangesGuard],
                data: { allowedPermissions: ['editevent'] }
            },
            {
                path: 'commission',
                component: vendor_commission_component_VendorCommissionComponent,
                resolve: {
                    taxDeterminationData: TaxDeterminationResolver,
                    vendorsTotalPaymentsData: VendorsTotalPaymentsResolver,
                    paymentsData: PaymentsResolver,
                    latestPrepaymentData: LatestPrepaymentResolver,
                    adjustmentTypeCreditData: AdjustmentTypeCreditResolver,
                    adjustmentTypeDebitData: AdjustmentTypeDebitResolver,
                    ooivRulesValidation: OoivRulesValidationResolver,
                    initialPaymentData: InitialPaymentResolver,
                    PaymentSummaryResolver: payment_summary_resolver_PaymentSummaryResolver
                },
                canActivate: [PermissionGuard],
                data: { allowedPermissions: ['multivendor'] }
            },
            {
                path: 'invoice-history',
                component: invoice_history_vendor_component_InvoiceHistoryVendorComponent,
            },
            {
                path: 'rsvp',
                component: vendor_rsvp_page_component_VendorRsvpComponent,
                resolve: {
                    rsvpData: rsvp_compare_resolver_RsvpCompareResolver
                }
            },
            {
                path: 'rsvp/detail',
                component: vendor_rsvp_page_component_VendorRsvpComponent,
                resolve: {
                    rsvpDetail: RsvpDetailResolver
                },
                canDeactivate: [CanDeactiveReservationDetailTable]
            },
            {
                path: 'reservations',
                component: vendor_reservation_page_component_VendorReservationComponent,
                resolve: {
                    reservations: reservation_compare_resolver_ReservationCompareResolver,
                    reservationData: ReservationResolver
                }
            },
            {
                path: 'reservations/detail',
                component: vendor_reservation_page_component_VendorReservationComponent,
                resolve: {
                    reservationsDetail: ReservationDetailResolver
                },
                canDeactivate: [CanDeactiveReservationDetailTable]
            },
            {
                path: 'transient-reservations',
                component: transient_reservation_component_TransientReservationComponent,
                canActivate: [PermissionGuard],
                data: { allowedPermissions: ['linkreservation'] }
            }
        ]
    },
    {
        path: 'event/:id/:eventPartyId',
        canActivate: [CanActivateViaAuthGuard],
        resolve: {
            eventsData: EventResolver,
            countriesData: CountryResolver,
            currenciesData: CurrencyResolver,
            latestPaymentData: LatestPaymentResolver,
            finalPaymentStatusData: FinalPaymentStatusResolver,
            payorTypesData: PayorTypeResolver,
            customLabelData: custom_label_resolver_CustomLabelResolver,
            initialPaymentData: InitialPaymentResolver
        },
        children: [
            {
                path: '',
                outlet: 'navigation',
                component: app_menu_component_AppMenuComponent,
                children: [
                    {
                        path: '',
                        component: event_menu_component_EventMenuComponent,
                        outlet: 'event'
                    }
                ]
            },
            {
                path: '',
                redirectTo: 'overview',
                pathMatch: 'full'
            },
            {
                path: 'overview',
                component: overview_page_component_OverviewPageComponent,
                canActivate: [OverviewRedirectGuard],
                resolve: {
                    overviewData: OverviewResolver,
                    transactions: transaction_resolver_TransactionResolver,
                    reservationData: ReservationResolver,
                    rsvpData: RsvpResolver
                }
            },
            {
                path: 'summary',
                component: event_component_EventComponent,
                resolve: {
                    attachmentData: AttachmentResolver,
                    paymentsData: PaymentsResolver,
                    eventHasItemsData: event_has_items_resolver_EventHasItemsResolver
                },
                data: { allPayments: true }
            },
            {
                path: 'summary/edit',
                component: event_component_EventComponent,
                resolve: {
                    attachmentData: AttachmentResolver,
                    paymentsData: PaymentsResolver,
                    latestPrepaymentData: LatestPrepaymentResolver,
                    chainsData: ChainResolver,
                    eventHasItemsData: event_has_items_resolver_EventHasItemsResolver
                },
                canActivate: [PermissionGuard, final_payment_authorized_guard_FinalPaymentAuthorizedGuard],
                canDeactivate: [unsaved_changes_guard_UnsavedChangesGuard],
                data: { allowedPermissions: ['editevent'] }
            },
            {
                path: 'commission',
                component: commission_component_CommissionComponent,
                resolve: {
                    paymentsData: PaymentsResolver,
                    latestPrepaymentData: LatestPrepaymentResolver,
                    adjustmentTypeCreditData: AdjustmentTypeCreditResolver,
                    adjustmentTypeDebitData: AdjustmentTypeDebitResolver,
                    taxDeterminationData: TaxDeterminationResolver,
                    ooivRulesValidation: OoivRulesValidationResolver,
                    initialPaymentData: InitialPaymentResolver,
                    PaymentSummaryResolver: payment_summary_resolver_PaymentSummaryResolver
                },
                canActivate: [PermissionGuard],
                data: { allowedPermissions: ['singlevendor'] }
            },
            {
                path: 'invoice-history',
                component: invoice_history_component_InvoiceHistoryComponent,
            },
            {
                path: 'rsvp',
                component: rsvp_page_component_RsvpComponent,
                resolve: {
                    rsvpData: rsvp_compare_resolver_RsvpCompareResolver
                }
            },
            {
                path: 'rsvp/detail',
                component: rsvp_page_component_RsvpComponent,
                resolve: {
                    rsvpDetail: RsvpDetailResolver
                },
                canDeactivate: [CanDeactiveReservationDetailTable]
            },
            {
                path: 'reservations',
                component: reservation_page_component_ReservationPageComponent,
                resolve: {
                    reservations: reservation_compare_resolver_ReservationCompareResolver,
                    reservationData: ReservationResolver
                }
            },
            {
                path: 'reservations/detail',
                component: reservation_page_component_ReservationPageComponent,
                resolve: {
                    reservationsDetail: ReservationDetailResolver
                },
                canDeactivate: [CanDeactiveReservationDetailTable]
            },
            {
                path: 'transient-reservations',
                component: transient_reservation_component_TransientReservationComponent,
                canActivate: [PermissionGuard],
                data: { allowedPermissions: ['linkreservation'] }
            }
        ]
    }
];
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/event.routes.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/invoice-history-vendor.ts
var invoice_history_vendor___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var InvoiceHistoryVendorRecord = Object(immutable["Record"])({
    chain: null,
    brand: null,
    pid: null
});
var InvoiceHistoryVendor = (function (_super) {
    invoice_history_vendor___extends(InvoiceHistoryVendor, _super);
    function InvoiceHistoryVendor() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return InvoiceHistoryVendor;
}(InvoiceHistoryVendorRecord));

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/invoice-history-vendor.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/invoice-history-vendor-card/invoice-history-vendor-card.component.ts
var invoice_history_vendor_card_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var invoice_history_vendor_card_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};






var invoice_history_vendor_card_component_InvoiceHistoryVendorCardComponent = (function () {
    function InvoiceHistoryVendorCardComponent(invoiceHistoryStore, environment) {
        this.invoiceHistoryStore = invoiceHistoryStore;
        this.environment = environment;
        this.imagesUrl = '';
    }
    InvoiceHistoryVendorCardComponent.prototype.ngOnInit = function () {
        this.imagesUrl = this.environment.onyxGPImagesCommonDataUrl;
        this.disableAll();
    };
    InvoiceHistoryVendorCardComponent.prototype.onCardExpandClicked = function (event, eventPartyId, chain, brand, propertyId, expanded) {
        var _this = this;
        event.preventDefault();
        if (eventPartyId) {
            this.vendors.filter(function (ve) { return ve.eventPartyId === eventPartyId; }).forEach(function (x) {
                x.isExpanded = expanded;
                if (x.isExpanded) {
                    _this.getVendorToken();
                }
            });
        }
        else {
            this.vendors.filter(function (ve) { return ve.chain === chain && ve.brand === brand && ve.propertyId === propertyId; }).forEach(function (x) {
                x.isExpanded = expanded;
                if (x.isExpanded) {
                    _this.getVendorToken();
                }
            });
        }
        if (expanded && this.vendors.length > 1) {
            this.disableOthers(eventPartyId, chain, brand, propertyId);
        }
    };
    InvoiceHistoryVendorCardComponent.prototype.getVendorToken = function () {
        var _this = this;
        this.invoiceVendor = new InvoiceHistoryVendor({
            'chain': this.vendor.chain,
            'brand': this.vendor.brand,
            'pid': this.vendor.propertyId
        });
        this.invoiceHistoryStore.getInvoiceHistoryEventAgencyVendorAuth(this.event.eventId, this.invoiceVendor).subscribe(function (token) {
            _this.token = token;
        });
    };
    InvoiceHistoryVendorCardComponent.prototype.disableOthers = function (eventPartyId, chain, brand, propertyId) {
        if (eventPartyId) {
            this.vendors.filter(function (ve) { return ve.eventPartyId !== eventPartyId; }).forEach(function (x) {
                x.isExpanded = false;
            });
        }
        else {
            this.vendors.filter(function (ve) { return ve.chain !== chain || ve.brand !== brand || ve.propertyId !== propertyId; }).forEach(function (x) {
                x.isExpanded = false;
            });
        }
    };
    InvoiceHistoryVendorCardComponent.prototype.disableAll = function () {
        this.vendors.forEach(function (x) {
            x.isExpanded = false;
        });
    };
    return InvoiceHistoryVendorCardComponent;
}());
invoice_history_vendor_card_component___decorate([
    Object(core_es5["Input"])(),
    invoice_history_vendor_card_component___metadata("design:type", Array)
], invoice_history_vendor_card_component_InvoiceHistoryVendorCardComponent.prototype, "vendors", void 0);
invoice_history_vendor_card_component___decorate([
    Object(core_es5["Input"])(),
    invoice_history_vendor_card_component___metadata("design:type", typeof (invoice_history_vendor_card_component__a = typeof Party !== "undefined" && Party) === "function" && invoice_history_vendor_card_component__a || Object)
], invoice_history_vendor_card_component_InvoiceHistoryVendorCardComponent.prototype, "vendor", void 0);
invoice_history_vendor_card_component___decorate([
    Object(core_es5["Input"])(),
    invoice_history_vendor_card_component___metadata("design:type", typeof (invoice_history_vendor_card_component__b = typeof OnyxEvent !== "undefined" && OnyxEvent) === "function" && invoice_history_vendor_card_component__b || Object)
], invoice_history_vendor_card_component_InvoiceHistoryVendorCardComponent.prototype, "event", void 0);
invoice_history_vendor_card_component_InvoiceHistoryVendorCardComponent = invoice_history_vendor_card_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-invoice-history-vendor-card',
        template: __webpack_require__("LrqM"),
        styles: [__webpack_require__("mUMJ")]
    }),
    invoice_history_vendor_card_component___metadata("design:paramtypes", [typeof (invoice_history_vendor_card_component__c = typeof invoice_history_store_InvoiceHistoryStore !== "undefined" && invoice_history_store_InvoiceHistoryStore) === "function" && invoice_history_vendor_card_component__c || Object, typeof (invoice_history_vendor_card_component__d = typeof EnvironmentConfiguration !== "undefined" && EnvironmentConfiguration) === "function" && invoice_history_vendor_card_component__d || Object])
], invoice_history_vendor_card_component_InvoiceHistoryVendorCardComponent);

var invoice_history_vendor_card_component__a, invoice_history_vendor_card_component__b, invoice_history_vendor_card_component__c, invoice_history_vendor_card_component__d;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/invoice-history-vendor-card.component.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/matching-property/matching-property-list/matching-property-list.component.ts
var matching_property_list_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var matching_property_list_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};






var matching_property_list_component_MatchingPropertyListComponent = (function () {
    function MatchingPropertyListComponent(environment, matchingPropertyService, router) {
        this.environment = environment;
        this.matchingPropertyService = matchingPropertyService;
        this.router = router;
        this.sortPage = new core_es5["EventEmitter"]();
    }
    MatchingPropertyListComponent.prototype.ngOnInit = function () {
    };
    Object.defineProperty(MatchingPropertyListComponent.prototype, "propertyCount", {
        get: function () {
            return this.properties.totalElements;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MatchingPropertyListComponent.prototype, "propertyCountForTranslate", {
        get: function () {
            return {
                propertyCount: this.propertyCount
            };
        },
        enumerable: true,
        configurable: true
    });
    MatchingPropertyListComponent.prototype.isNotProvided = function (vendorId) {
        var searchPattern = new RegExp('^' + Constants.NOT_PROVIDED_VENDOR_ID_PREFIX);
        return searchPattern.test(vendorId);
    };
    MatchingPropertyListComponent.prototype.selectProperty = function (property) {
        this.matchingPropertyService.setSelectedProperty(property);
        this.matchingPropertyService.setSelectedPage(this.currentPage);
        this.router.navigate(['/events/matching/property/candidates'], {});
    };
    MatchingPropertyListComponent.prototype.sortList = function (field, direction) {
        this.sortPage.emit({ field: field, direction: direction });
    };
    return MatchingPropertyListComponent;
}());
matching_property_list_component___decorate([
    Object(core_es5["Input"])(),
    matching_property_list_component___metadata("design:type", typeof (matching_property_list_component__a = typeof page_Page !== "undefined" && page_Page) === "function" && matching_property_list_component__a || Object)
], matching_property_list_component_MatchingPropertyListComponent.prototype, "properties", void 0);
matching_property_list_component___decorate([
    Object(core_es5["Input"])(),
    matching_property_list_component___metadata("design:type", Number)
], matching_property_list_component_MatchingPropertyListComponent.prototype, "currentPage", void 0);
matching_property_list_component___decorate([
    Object(core_es5["Output"])(),
    matching_property_list_component___metadata("design:type", typeof (matching_property_list_component__b = typeof core_es5["EventEmitter"] !== "undefined" && core_es5["EventEmitter"]) === "function" && matching_property_list_component__b || Object)
], matching_property_list_component_MatchingPropertyListComponent.prototype, "sortPage", void 0);
matching_property_list_component_MatchingPropertyListComponent = matching_property_list_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-matching-property-list',
        template: __webpack_require__("ME4C")
    }),
    matching_property_list_component___metadata("design:paramtypes", [typeof (matching_property_list_component__c = typeof EnvironmentConfiguration !== "undefined" && EnvironmentConfiguration) === "function" && matching_property_list_component__c || Object, typeof (matching_property_list_component__d = typeof matching_property_service_MatchingPropertyService !== "undefined" && matching_property_service_MatchingPropertyService) === "function" && matching_property_list_component__d || Object, typeof (matching_property_list_component__e = typeof router_es5["Router"] !== "undefined" && router_es5["Router"]) === "function" && matching_property_list_component__e || Object])
], matching_property_list_component_MatchingPropertyListComponent);

var matching_property_list_component__a, matching_property_list_component__b, matching_property_list_component__c, matching_property_list_component__d, matching_property_list_component__e;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/matching-property-list.component.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/overview/date-room-type-summary/date-room-type-summary.component.ts
var date_room_type_summary_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var date_room_type_summary_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};





var DateRoomTypeSummaryComponent = (function () {
    function DateRoomTypeSummaryComponent(overviewStore, translateService) {
        this.overviewStore = overviewStore;
        this.translateService = translateService;
    }
    Object.defineProperty(DateRoomTypeSummaryComponent.prototype, "event", {
        set: function (event) {
            this.onyxEvent = event;
        },
        enumerable: true,
        configurable: true
    });
    DateRoomTypeSummaryComponent.prototype.ngOnInit = function () {
        this.dateRoomTypeDetail$ = this.overviewStore.vendorDateStaySummary(this.vendor.eventPartyId).map(function (dateRoomType) {
            if (dateRoomType && dateRoomType.dateRoomTypeNightDetail) {
                return dateRoomType.dateRoomTypeNightDetail.dateRoomTypeNights;
            }
            else {
                return null;
            }
        });
        this.dateRoomTypeTotal$ = this.overviewStore.vendorDateStaySummary(this.vendor.eventPartyId).map(function (dateRoomType) {
            if (dateRoomType && dateRoomType.dateRoomTypeNightTotal) {
                return dateRoomType.dateRoomTypeNightTotal.nightsByRoomType;
            }
            else {
                return null;
            }
        });
        this.totalRoomNights$ = this.calculateTotalRoomNights();
    };
    DateRoomTypeSummaryComponent.prototype.translateUnknownRoomType = function (roomType) {
        if ('UNKNOWN_ROOM_TYPE' === roomType) {
            return this.translateService.instant('EVENT.OVERVIEW_CARDS.UNKNOWN_ROOM_TYPE');
        }
        else {
            return roomType;
        }
    };
    DateRoomTypeSummaryComponent.prototype.calculateTotalRoomNights = function () {
        // Calculate the total room nights for the event party
        return this.dateRoomTypeTotal$.map(function (arrayInput) {
            return arrayInput.reduce(function (accum, current) { return accum + current.nights; }, 0);
        });
    };
    return DateRoomTypeSummaryComponent;
}());
date_room_type_summary_component___decorate([
    Object(core_es5["Input"])(),
    date_room_type_summary_component___metadata("design:type", typeof (date_room_type_summary_component__a = typeof Party !== "undefined" && Party) === "function" && date_room_type_summary_component__a || Object)
], DateRoomTypeSummaryComponent.prototype, "vendor", void 0);
date_room_type_summary_component___decorate([
    Object(core_es5["Input"])('event'),
    date_room_type_summary_component___metadata("design:type", typeof (date_room_type_summary_component__b = typeof OnyxEvent !== "undefined" && OnyxEvent) === "function" && date_room_type_summary_component__b || Object),
    date_room_type_summary_component___metadata("design:paramtypes", [typeof (date_room_type_summary_component__c = typeof OnyxEvent !== "undefined" && OnyxEvent) === "function" && date_room_type_summary_component__c || Object])
], DateRoomTypeSummaryComponent.prototype, "event", null);
DateRoomTypeSummaryComponent = date_room_type_summary_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-date-room-type-summary',
        template: __webpack_require__("DCrO")
    }),
    date_room_type_summary_component___metadata("design:paramtypes", [typeof (date_room_type_summary_component__d = typeof overview_store_OverviewStore !== "undefined" && overview_store_OverviewStore) === "function" && date_room_type_summary_component__d || Object, typeof (date_room_type_summary_component__e = typeof core["c" /* TranslateService */] !== "undefined" && core["c" /* TranslateService */]) === "function" && date_room_type_summary_component__e || Object])
], DateRoomTypeSummaryComponent);

var date_room_type_summary_component__a, date_room_type_summary_component__b, date_room_type_summary_component__c, date_room_type_summary_component__d, date_room_type_summary_component__e;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/date-room-type-summary.component.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/overview/header-summary/header-summary.component.ts
var header_summary_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var header_summary_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};








var HeaderSummaryComponent = (function () {
    function HeaderSummaryComponent(compareStore, decimalPipe, abbreviateAmountPipe) {
        this.compareStore = compareStore;
        this.decimalPipe = decimalPipe;
        this.abbreviateAmountPipe = abbreviateAmountPipe;
    }
    Object.defineProperty(HeaderSummaryComponent.prototype, "event", {
        set: function (event) {
            this.onyxEvent = event;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HeaderSummaryComponent.prototype, "title", {
        set: function (title) {
            this.headerTitle = title;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HeaderSummaryComponent.prototype, "tooltip", {
        set: function (tooltip) {
            this.headerTooltip = tooltip;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HeaderSummaryComponent.prototype, "type", {
        set: function (type) {
            this.recordType = type;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HeaderSummaryComponent.prototype, "compareMatchType", {
        set: function (matchType) {
            this.matchType = matchType;
        },
        enumerable: true,
        configurable: true
    });
    HeaderSummaryComponent.prototype.ngOnInit = function () {
        if (this.vendor) {
            this.staySummary = this.compareStore.getVendorHeaderSummary(this.vendor.eventPartyId, this.recordType, this.matchType);
        }
        else {
            this.staySummary = this.compareStore.getHeaderSummary(this.recordType, this.matchType);
        }
    };
    HeaderSummaryComponent.prototype.getCommission = function (revenue) {
        return revenue * this.onyxEvent.eventProperty.commissionRoomPercentage / 100;
    };
    HeaderSummaryComponent.prototype.isAbbreviated = function (amount) {
        var decimalFormattedAmount = this.decimalPipe.transform(amount, '1.2-2');
        var abbreviatedAmount = this.abbreviateAmountPipe.transform(amount);
        return decimalFormattedAmount !== abbreviatedAmount;
    };
    return HeaderSummaryComponent;
}());
header_summary_component___decorate([
    Object(core_es5["Input"])(),
    header_summary_component___metadata("design:type", typeof (header_summary_component__a = typeof Party !== "undefined" && Party) === "function" && header_summary_component__a || Object)
], HeaderSummaryComponent.prototype, "vendor", void 0);
header_summary_component___decorate([
    Object(core_es5["Input"])('event'),
    header_summary_component___metadata("design:type", typeof (header_summary_component__b = typeof OnyxEvent !== "undefined" && OnyxEvent) === "function" && header_summary_component__b || Object),
    header_summary_component___metadata("design:paramtypes", [typeof (header_summary_component__c = typeof OnyxEvent !== "undefined" && OnyxEvent) === "function" && header_summary_component__c || Object])
], HeaderSummaryComponent.prototype, "event", null);
header_summary_component___decorate([
    Object(core_es5["Input"])('title'),
    header_summary_component___metadata("design:type", String),
    header_summary_component___metadata("design:paramtypes", [String])
], HeaderSummaryComponent.prototype, "title", null);
header_summary_component___decorate([
    Object(core_es5["Input"])('tooltipText'),
    header_summary_component___metadata("design:type", String),
    header_summary_component___metadata("design:paramtypes", [String])
], HeaderSummaryComponent.prototype, "tooltip", null);
header_summary_component___decorate([
    Object(core_es5["Input"])('type'),
    header_summary_component___metadata("design:type", typeof (header_summary_component__d = typeof SummaryRecordTypeEnum !== "undefined" && SummaryRecordTypeEnum) === "function" && header_summary_component__d || Object),
    header_summary_component___metadata("design:paramtypes", [typeof (header_summary_component__e = typeof SummaryRecordTypeEnum !== "undefined" && SummaryRecordTypeEnum) === "function" && header_summary_component__e || Object])
], HeaderSummaryComponent.prototype, "type", null);
header_summary_component___decorate([
    Object(core_es5["Input"])('matchType'),
    header_summary_component___metadata("design:type", typeof (header_summary_component__f = typeof MatchTypeEnum !== "undefined" && MatchTypeEnum) === "function" && header_summary_component__f || Object),
    header_summary_component___metadata("design:paramtypes", [typeof (header_summary_component__g = typeof MatchTypeEnum !== "undefined" && MatchTypeEnum) === "function" && header_summary_component__g || Object])
], HeaderSummaryComponent.prototype, "compareMatchType", null);
HeaderSummaryComponent = header_summary_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-header-summary',
        template: __webpack_require__("K4wc"),
        styles: [__webpack_require__("ISFW")]
    }),
    header_summary_component___metadata("design:paramtypes", [typeof (header_summary_component__h = typeof reservation_compare_store_ReservationCompareStore !== "undefined" && reservation_compare_store_ReservationCompareStore) === "function" && header_summary_component__h || Object, typeof (header_summary_component__j = typeof common_es5["DecimalPipe"] !== "undefined" && common_es5["DecimalPipe"]) === "function" && header_summary_component__j || Object, typeof (header_summary_component__k = typeof abbreviate_amount_pipe_AbbreviateAmountPipe !== "undefined" && abbreviate_amount_pipe_AbbreviateAmountPipe) === "function" && header_summary_component__k || Object])
], HeaderSummaryComponent);

var header_summary_component__a, header_summary_component__b, header_summary_component__c, header_summary_component__d, header_summary_component__e, header_summary_component__f, header_summary_component__g, header_summary_component__h, header_summary_component__j, header_summary_component__k;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/header-summary.component.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/overview/stay-summary/stay-summary.component.ts
var stay_summary_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var stay_summary_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};







var stay_summary_component_StaySummaryComponent = (function () {
    function StaySummaryComponent(reservationStore, rsvpStore) {
        this.reservationStore = reservationStore;
        this.rsvpStore = rsvpStore;
    }
    Object.defineProperty(StaySummaryComponent.prototype, "event", {
        set: function (event) {
            this.onyxEvent = event;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StaySummaryComponent.prototype, "type", {
        set: function (type) {
            this.recordType = type;
        },
        enumerable: true,
        configurable: true
    });
    StaySummaryComponent.prototype.ngOnInit = function () {
        if (this.recordType === SummaryRecordTypeEnum.RESERVATION) {
            this.roomTypeRateSummaryList =
                this.reservationStore.getVendorRoomStaySummaryFilteredByStatus(OVERVIEW_STATUS_CODES, this.vendor.eventPartyId)
                    .map(function (roomStaySummary) {
                    return roomStaySummary.roomTypeRateSummaryList;
                });
        }
        else if (this.recordType === SummaryRecordTypeEnum.RSVP) {
            this.roomTypeRateSummaryList = this.rsvpStore.getVendorRoomStaySummary(this.vendor.eventPartyId)
                .map(function (roomStaySummary) {
                return roomStaySummary.roomTypeRateSummaryList;
            });
        }
    };
    StaySummaryComponent.prototype.getCommission = function (revenue) {
        return revenue * this.vendor.commissionRoomPercentage / 100;
    };
    return StaySummaryComponent;
}());
stay_summary_component___decorate([
    Object(core_es5["Input"])(),
    stay_summary_component___metadata("design:type", typeof (stay_summary_component__a = typeof Party !== "undefined" && Party) === "function" && stay_summary_component__a || Object)
], stay_summary_component_StaySummaryComponent.prototype, "vendor", void 0);
stay_summary_component___decorate([
    Object(core_es5["Input"])('event'),
    stay_summary_component___metadata("design:type", typeof (stay_summary_component__b = typeof OnyxEvent !== "undefined" && OnyxEvent) === "function" && stay_summary_component__b || Object),
    stay_summary_component___metadata("design:paramtypes", [typeof (stay_summary_component__c = typeof OnyxEvent !== "undefined" && OnyxEvent) === "function" && stay_summary_component__c || Object])
], stay_summary_component_StaySummaryComponent.prototype, "event", null);
stay_summary_component___decorate([
    Object(core_es5["Input"])('type'),
    stay_summary_component___metadata("design:type", typeof (stay_summary_component__d = typeof SummaryRecordTypeEnum !== "undefined" && SummaryRecordTypeEnum) === "function" && stay_summary_component__d || Object),
    stay_summary_component___metadata("design:paramtypes", [typeof (stay_summary_component__e = typeof SummaryRecordTypeEnum !== "undefined" && SummaryRecordTypeEnum) === "function" && stay_summary_component__e || Object])
], stay_summary_component_StaySummaryComponent.prototype, "type", null);
stay_summary_component_StaySummaryComponent = stay_summary_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-stay-summary',
        template: __webpack_require__("yKfN")
    }),
    stay_summary_component___metadata("design:paramtypes", [typeof (stay_summary_component__f = typeof reservation_store_ReservationStore !== "undefined" && reservation_store_ReservationStore) === "function" && stay_summary_component__f || Object, typeof (stay_summary_component__g = typeof rsvp_store_RsvpStore !== "undefined" && rsvp_store_RsvpStore) === "function" && stay_summary_component__g || Object])
], stay_summary_component_StaySummaryComponent);

var stay_summary_component__a, stay_summary_component__b, stay_summary_component__c, stay_summary_component__d, stay_summary_component__e, stay_summary_component__f, stay_summary_component__g;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/stay-summary.component.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/overview/vendor-header-summary/vendor-header-summary.component.ts
var vendor_header_summary_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var vendor_header_summary_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};








var VendorHeaderSummaryComponent = (function () {
    function VendorHeaderSummaryComponent(compareStore, decimalPipe, abbreviateAmountPipe) {
        this.compareStore = compareStore;
        this.decimalPipe = decimalPipe;
        this.abbreviateAmountPipe = abbreviateAmountPipe;
    }
    Object.defineProperty(VendorHeaderSummaryComponent.prototype, "event", {
        set: function (event) {
            this.onyxEvent = event;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VendorHeaderSummaryComponent.prototype, "title", {
        set: function (title) {
            this.headerTitle = title;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VendorHeaderSummaryComponent.prototype, "tooltip", {
        set: function (tooltip) {
            this.headerTooltip = tooltip;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VendorHeaderSummaryComponent.prototype, "type", {
        set: function (type) {
            this.recordType = type;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VendorHeaderSummaryComponent.prototype, "isTotal", {
        set: function (total) {
            this.total = total;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VendorHeaderSummaryComponent.prototype, "compareMatchType", {
        set: function (matchType) {
            this.matchType = matchType;
        },
        enumerable: true,
        configurable: true
    });
    VendorHeaderSummaryComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (this.vendor) {
            this.staySummary = this.compareStore.getVendorHeaderSummary(this.vendor.eventPartyId, this.recordType, this.matchType);
        }
        else {
            this.staySummary = this.compareStore.getHeaderSummary(this.recordType, this.matchType);
        }
        if (this.total) {
            this.tableStyle = 'table-multi-prop-total';
            this.divTableStyle = 'col flex55';
        }
        else {
            this.tableStyle = 'table-multi-prop';
            this.divTableStyle = 'col';
        }
        this.staySummary.subscribe(function (stay) {
            _this.existItems = stay.totalItems > 0;
        });
    };
    VendorHeaderSummaryComponent.prototype.getCommission = function (revenue) {
        return revenue * this.onyxEvent.eventProperty.commissionRoomPercentage / 100;
    };
    VendorHeaderSummaryComponent.prototype.isAbbreviated = function (amount) {
        var decimalFormattedAmount = this.decimalPipe.transform(amount, '1.2-2');
        var abbreviatedAmount = this.abbreviateAmountPipe.transform(amount);
        return decimalFormattedAmount !== abbreviatedAmount;
    };
    return VendorHeaderSummaryComponent;
}());
vendor_header_summary_component___decorate([
    Object(core_es5["Input"])(),
    vendor_header_summary_component___metadata("design:type", typeof (vendor_header_summary_component__a = typeof Party !== "undefined" && Party) === "function" && vendor_header_summary_component__a || Object)
], VendorHeaderSummaryComponent.prototype, "vendor", void 0);
vendor_header_summary_component___decorate([
    Object(core_es5["Input"])(),
    vendor_header_summary_component___metadata("design:type", String)
], VendorHeaderSummaryComponent.prototype, "totals", void 0);
vendor_header_summary_component___decorate([
    Object(core_es5["Input"])('event'),
    vendor_header_summary_component___metadata("design:type", typeof (vendor_header_summary_component__b = typeof OnyxEvent !== "undefined" && OnyxEvent) === "function" && vendor_header_summary_component__b || Object),
    vendor_header_summary_component___metadata("design:paramtypes", [typeof (vendor_header_summary_component__c = typeof OnyxEvent !== "undefined" && OnyxEvent) === "function" && vendor_header_summary_component__c || Object])
], VendorHeaderSummaryComponent.prototype, "event", null);
vendor_header_summary_component___decorate([
    Object(core_es5["Input"])('title'),
    vendor_header_summary_component___metadata("design:type", String),
    vendor_header_summary_component___metadata("design:paramtypes", [String])
], VendorHeaderSummaryComponent.prototype, "title", null);
vendor_header_summary_component___decorate([
    Object(core_es5["Input"])('tooltipText'),
    vendor_header_summary_component___metadata("design:type", String),
    vendor_header_summary_component___metadata("design:paramtypes", [String])
], VendorHeaderSummaryComponent.prototype, "tooltip", null);
vendor_header_summary_component___decorate([
    Object(core_es5["Input"])('type'),
    vendor_header_summary_component___metadata("design:type", typeof (vendor_header_summary_component__d = typeof SummaryRecordTypeEnum !== "undefined" && SummaryRecordTypeEnum) === "function" && vendor_header_summary_component__d || Object),
    vendor_header_summary_component___metadata("design:paramtypes", [typeof (vendor_header_summary_component__e = typeof SummaryRecordTypeEnum !== "undefined" && SummaryRecordTypeEnum) === "function" && vendor_header_summary_component__e || Object])
], VendorHeaderSummaryComponent.prototype, "type", null);
vendor_header_summary_component___decorate([
    Object(core_es5["Input"])('total'),
    vendor_header_summary_component___metadata("design:type", String),
    vendor_header_summary_component___metadata("design:paramtypes", [String])
], VendorHeaderSummaryComponent.prototype, "isTotal", null);
vendor_header_summary_component___decorate([
    Object(core_es5["Input"])('matchType'),
    vendor_header_summary_component___metadata("design:type", typeof (vendor_header_summary_component__f = typeof MatchTypeEnum !== "undefined" && MatchTypeEnum) === "function" && vendor_header_summary_component__f || Object),
    vendor_header_summary_component___metadata("design:paramtypes", [typeof (vendor_header_summary_component__g = typeof MatchTypeEnum !== "undefined" && MatchTypeEnum) === "function" && vendor_header_summary_component__g || Object])
], VendorHeaderSummaryComponent.prototype, "compareMatchType", null);
VendorHeaderSummaryComponent = vendor_header_summary_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-vendor-header-summary',
        template: __webpack_require__("GQMu"),
        styles: [__webpack_require__("eWFu")]
    }),
    vendor_header_summary_component___metadata("design:paramtypes", [typeof (vendor_header_summary_component__h = typeof reservation_compare_store_ReservationCompareStore !== "undefined" && reservation_compare_store_ReservationCompareStore) === "function" && vendor_header_summary_component__h || Object, typeof (vendor_header_summary_component__j = typeof common_es5["DecimalPipe"] !== "undefined" && common_es5["DecimalPipe"]) === "function" && vendor_header_summary_component__j || Object, typeof (vendor_header_summary_component__k = typeof abbreviate_amount_pipe_AbbreviateAmountPipe !== "undefined" && abbreviate_amount_pipe_AbbreviateAmountPipe) === "function" && vendor_header_summary_component__k || Object])
], VendorHeaderSummaryComponent);

var vendor_header_summary_component__a, vendor_header_summary_component__b, vendor_header_summary_component__c, vendor_header_summary_component__d, vendor_header_summary_component__e, vendor_header_summary_component__f, vendor_header_summary_component__g, vendor_header_summary_component__h, vendor_header_summary_component__j, vendor_header_summary_component__k;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/vendor-header-summary.component.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/overview/vendor-overview-card/vendor-overview-card.component.ts
var vendor_overview_card_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var vendor_overview_card_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};











var vendor_overview_card_component_VendorOverviewCardComponent = (function () {
    function VendorOverviewCardComponent(eventStore, menuStore, route, authenticationSore, flashMessagesService, environment) {
        this.eventStore = eventStore;
        this.menuStore = menuStore;
        this.route = route;
        this.authenticationSore = authenticationSore;
        this.flashMessagesService = flashMessagesService;
        this.environment = environment;
        this.imagesUrl = '';
    }
    VendorOverviewCardComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.imagesUrl = this.environment.onyxGPImagesCommonDataUrl;
        this.eventStore.selectedEvent.subscribe(function (event) { return _this.onyxEvent = event; });
        if (this.onyxEvent) {
            this.menuStore.setPageHeader(EventUtils.getEventName(this.onyxEvent, this.authenticationSore.isAgencyUser()), this.onyxEvent.eventProperty.subscriber);
        }
        // If the event property is subscribed, reservations are retrieved to build the overview.
        // Otherwise, RSVPs are
        if (this.onyxEvent && this.vendor.subscriber) {
            this.headerRecordType = SummaryRecordTypeEnum.RESERVATION;
        }
        else {
            this.headerRecordType = SummaryRecordTypeEnum.RSVP;
        }
        if (this.vendors) {
            if (this.vendors.length === 1) {
                this.vendor.isExpanded = true;
            }
        }
        // toggle page to editable if the URL ends with "edit" (it will default to read only)
        // otherwise, check if we need to show a warning flash message when in view modeFD
        route_utils_RouteUtils.getLastUrlSegment(this.route)
            .subscribe(function (lastSegment) {
            if (_this.authenticationSore.hasPermission('EditEvent') && !_this.isEventValid()) {
                _this.flashMessagesService.warn('EVENT.EVENT_MISSING_INFO', null, { hrefValue: "/#/event/" + _this.onyxEvent.eventId + "/summary/edit" });
            }
        });
    };
    VendorOverviewCardComponent.prototype.isEventValid = function () {
        return EventUtils.isEventValid(this.onyxEvent, this.authenticationSore.isAgencyUser());
    };
    VendorOverviewCardComponent.prototype.onCardExpandClicked = function (event, eventPartyId, chain, brand, propertyId, expanded) {
        event.preventDefault();
        if (eventPartyId) {
            this.vendors.filter(function (ve) { return ve.eventPartyId === eventPartyId; }).forEach(function (x) {
                x.isExpanded = expanded;
            });
        }
        else {
            this.vendors.filter(function (ve) { return ve.chain === chain && ve.brand === brand && ve.propertyId === propertyId; }).forEach(function (x) {
                x.isExpanded = expanded;
            });
        }
        if (expanded && this.vendors.length > 1) {
            this.disableOthers(eventPartyId, chain, brand, propertyId);
        }
    };
    VendorOverviewCardComponent.prototype.disableOthers = function (eventPartyId, chain, brand, propertyId) {
        if (eventPartyId) {
            this.vendors.filter(function (ve) { return ve.eventPartyId !== eventPartyId; }).forEach(function (x) {
                x.isExpanded = false;
            });
        }
        else {
            this.vendors.filter(function (ve) { return ve.chain !== chain || ve.brand !== brand || ve.propertyId !== propertyId; }).forEach(function (x) {
                x.isExpanded = false;
            });
        }
    };
    return VendorOverviewCardComponent;
}());
vendor_overview_card_component___decorate([
    Object(core_es5["Input"])(),
    vendor_overview_card_component___metadata("design:type", Array)
], vendor_overview_card_component_VendorOverviewCardComponent.prototype, "vendors", void 0);
vendor_overview_card_component___decorate([
    Object(core_es5["Input"])(),
    vendor_overview_card_component___metadata("design:type", typeof (vendor_overview_card_component__a = typeof Party !== "undefined" && Party) === "function" && vendor_overview_card_component__a || Object)
], vendor_overview_card_component_VendorOverviewCardComponent.prototype, "vendor", void 0);
vendor_overview_card_component_VendorOverviewCardComponent = vendor_overview_card_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-vendor-overview-card',
        template: __webpack_require__("ZGDz"),
        styles: [__webpack_require__("j4M3")]
    }),
    vendor_overview_card_component___metadata("design:paramtypes", [typeof (vendor_overview_card_component__b = typeof event_store_EventStore !== "undefined" && event_store_EventStore) === "function" && vendor_overview_card_component__b || Object, typeof (vendor_overview_card_component__c = typeof menu_store_MenuStore !== "undefined" && menu_store_MenuStore) === "function" && vendor_overview_card_component__c || Object, typeof (vendor_overview_card_component__d = typeof router_es5["ActivatedRoute"] !== "undefined" && router_es5["ActivatedRoute"]) === "function" && vendor_overview_card_component__d || Object, typeof (vendor_overview_card_component__e = typeof authentication_store_AuthenticationStore !== "undefined" && authentication_store_AuthenticationStore) === "function" && vendor_overview_card_component__e || Object, typeof (vendor_overview_card_component__f = typeof flash_messages_service_FlashMessagesService !== "undefined" && flash_messages_service_FlashMessagesService) === "function" && vendor_overview_card_component__f || Object, typeof (vendor_overview_card_component__g = typeof EnvironmentConfiguration !== "undefined" && EnvironmentConfiguration) === "function" && vendor_overview_card_component__g || Object])
], vendor_overview_card_component_VendorOverviewCardComponent);

var vendor_overview_card_component__a, vendor_overview_card_component__b, vendor_overview_card_component__c, vendor_overview_card_component__d, vendor_overview_card_component__e, vendor_overview_card_component__f, vendor_overview_card_component__g;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/vendor-overview-card.component.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/payment/add-adjustment/add-adjustment.component.ts
var add_adjustment_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var add_adjustment_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};











var add_adjustment_component_AddAdjustmentComponent = (function () {
    function AddAdjustmentComponent(formBuilder, _adjustmentStore, _adjustmentTypeStore, authenticationStore) {
        this.formBuilder = formBuilder;
        this._adjustmentStore = _adjustmentStore;
        this._adjustmentTypeStore = _adjustmentTypeStore;
        this.authenticationStore = authenticationStore;
        this.cancel = new core_es5["EventEmitter"]();
        this.save = new core_es5["EventEmitter"]();
        this.adjustmentFormList = [];
    }
    Object.defineProperty(AddAdjustmentComponent.prototype, "adjustmentStore", {
        get: function () {
            return this._adjustmentStore;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AddAdjustmentComponent.prototype, "adjustmentTypeStore", {
        get: function () {
            return this._adjustmentTypeStore;
        },
        enumerable: true,
        configurable: true
    });
    AddAdjustmentComponent.prototype.getFormControlValue = function (adjustmentForm, name) {
        return adjustmentForm ? adjustmentForm.get(name).value : null;
    };
    AddAdjustmentComponent.prototype.ngOnInit = function () {
        if (!this.event) {
            throw new Error('The "event" attribute must be specified to use the AddAdjustmentComponent component');
        }
        if (!this.vendor) {
            throw new Error('The "vendor" attribute must be specified to use the AddAdjustmentComponent component');
        }
        this.initForm();
    };
    AddAdjustmentComponent.prototype.saveClick = function () {
        var _this = this;
        var obs$;
        this.adjustmentFormList.forEach(function (adjustmentForm) {
            obs$ = _this.saveForm(adjustmentForm);
        });
        return obs$;
    };
    AddAdjustmentComponent.prototype.saveForm = function (adjustmentForm) {
        var _this = this;
        adjustmentForm.disable();
        var adjustment = new Adjustment({
            eventId: this.event.eventId,
            adjustmentAmount: this.getFormControlValue(adjustmentForm, 'amount'),
            adjustmentType: this.getFormControlValue(adjustmentForm, 'type'),
            description: this.getFormControlValue(adjustmentForm, 'description'),
            adjustmentSpendAmount: this.getFormControlValue(adjustmentForm, 'spendAmount'),
            adjustmentCommRate: this.getFormControlValue(adjustmentForm, 'commRate'),
            eventPartyId: this.vendor.eventPartyId
        });
        var obs$ = this.adjustmentStore.addAdjustment(adjustment).pipe(Object(operators["tap"])(function () {
            adjustmentForm.reset();
            if (_this.isMultiVendor()) {
                _this.adjustmentStore.loadAdjustments(_this.event.eventId).subscribe();
            }
            else {
                _this.adjustmentStore.loadAdjustmentsByParty(_this.event.eventId, _this.vendor.eventPartyId).subscribe();
            }
            _this.save.emit();
            if (_this.isMultiVendor()) {
                _this.adjustmentStore.loadVendorsTotalPaymentsSummary(_this.event.eventId).subscribe();
            }
            else {
                _this.adjustmentStore.loadVendorsTotalPaymentsSummaryByParty(_this.event.eventId, _this.vendor.eventPartyId).subscribe();
            }
        }), Object(operators["catchError"])(function () {
            return Observable["Observable"].of(null);
        }), Object(operators["finalize"])(function () {
            adjustmentForm.enable();
        }));
        obs$.subscribe();
        return obs$;
    };
    AddAdjustmentComponent.prototype.cancelClick = function () {
        this.adjustmentFormList.forEach(function (adjustmentForm) {
            adjustmentForm.reset();
        });
        this.cancel.emit();
    };
    AddAdjustmentComponent.prototype.disableSave = function () {
        var _this = this;
        var disable = false;
        this.adjustmentFormList.forEach(function (adjustmentForm) {
            if (_this.disableSaveForm(adjustmentForm)) {
                disable = true;
                return;
            }
        });
        return disable;
    };
    AddAdjustmentComponent.prototype.disableSaveForm = function (adjustmentForm) {
        var disable;
        if (adjustmentForm) {
            disable = !adjustmentForm.valid;
        }
        else {
            disable = true;
        }
        return disable;
    };
    AddAdjustmentComponent.prototype.isCredit = function () {
        return true;
    };
    AddAdjustmentComponent.prototype.initForm = function () {
        var newAdjustmentForm = this.getNewAdjustmentForm();
        this.adjustmentFormList.push(newAdjustmentForm);
    };
    AddAdjustmentComponent.prototype.getNewAdjustmentForm = function () {
        var newForm = this.formBuilder.group({
            'amount': [null, [forms_es5["Validators"].required, pioneer_validators_PioneerValidators.isValidAmountInRangeInclNegative(-9999999999999.99, 9999999999999.99)]],
            'type': [null, [forms_es5["Validators"].required]],
            'description': [null, [forms_es5["Validators"].maxLength(255)]],
            'spendAmount': [null, [pioneer_validators_PioneerValidators.isValidAmountInRangeInclNegative(-9999999999999.99, 9999999999999.99)]],
            'commRate': [null, [pioneer_validators_PioneerValidators.range(0, 100), pioneer_validators_PioneerValidators.isInteger]]
        }, {
            validator: pioneer_validators_PioneerValidators.isAmountEqualToSpendAmountByCommRate('amount', 'spendAmount', 'commRate')
        });
        newForm = this.addEvent(newForm, 'spendAmount');
        newForm = this.addEvent(newForm, 'commRate');
        return newForm;
    };
    AddAdjustmentComponent.prototype.addEvent = function (currentForm, fieldName) {
        var _this = this;
        currentForm.controls[fieldName].valueChanges.subscribe(function (value) {
            if (value) {
                _this.calculateAmount(currentForm);
            }
        });
        return currentForm;
    };
    AddAdjustmentComponent.prototype.addRow = function () {
        this.newAdjustmentForm = this.getNewAdjustmentForm();
        this.adjustmentFormList.push(this.newAdjustmentForm);
    };
    AddAdjustmentComponent.prototype.deleteRow = function (index) {
        if (this.adjustmentFormList.length === 1) {
            return false;
        }
        else {
            this.adjustmentFormList.splice(index, 1);
            return true;
        }
    };
    AddAdjustmentComponent.prototype.calculateAmount = function (currentForm) {
        if (currentForm && currentForm instanceof forms_es5["FormGroup"]) {
            if (currentForm.get('spendAmount').value && currentForm.get('commRate').value) {
                var spend = currentForm.get('spendAmount').value;
                var rate = currentForm.get('commRate').value;
                if (spend && rate) {
                    var amount = Number((spend * rate / 100).toFixed(2));
                    currentForm.get('amount').setValue(amount);
                }
            }
        }
    };
    AddAdjustmentComponent.prototype.isMultiVendor = function () {
        return this.authenticationStore.hasPermission('MultiVendor');
    };
    return AddAdjustmentComponent;
}());
add_adjustment_component___decorate([
    Object(core_es5["Input"])(),
    add_adjustment_component___metadata("design:type", typeof (add_adjustment_component__a = typeof OnyxEvent !== "undefined" && OnyxEvent) === "function" && add_adjustment_component__a || Object)
], add_adjustment_component_AddAdjustmentComponent.prototype, "event", void 0);
add_adjustment_component___decorate([
    Object(core_es5["Input"])(),
    add_adjustment_component___metadata("design:type", typeof (add_adjustment_component__b = typeof Party !== "undefined" && Party) === "function" && add_adjustment_component__b || Object)
], add_adjustment_component_AddAdjustmentComponent.prototype, "vendor", void 0);
add_adjustment_component___decorate([
    Object(core_es5["Output"])(),
    add_adjustment_component___metadata("design:type", Object)
], add_adjustment_component_AddAdjustmentComponent.prototype, "cancel", void 0);
add_adjustment_component___decorate([
    Object(core_es5["Output"])(),
    add_adjustment_component___metadata("design:type", Object)
], add_adjustment_component_AddAdjustmentComponent.prototype, "save", void 0);
add_adjustment_component_AddAdjustmentComponent = add_adjustment_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-add-adjustment',
        template: __webpack_require__("gAE3"),
        styles: [__webpack_require__("Evt2")]
    }),
    add_adjustment_component___metadata("design:paramtypes", [typeof (add_adjustment_component__c = typeof forms_es5["FormBuilder"] !== "undefined" && forms_es5["FormBuilder"]) === "function" && add_adjustment_component__c || Object, typeof (add_adjustment_component__d = typeof adjustment_store_AdjustmentStore !== "undefined" && adjustment_store_AdjustmentStore) === "function" && add_adjustment_component__d || Object, typeof (add_adjustment_component__e = typeof adjustment_type_store_AdjustmentTypeStore !== "undefined" && adjustment_type_store_AdjustmentTypeStore) === "function" && add_adjustment_component__e || Object, typeof (add_adjustment_component__f = typeof authentication_store_AuthenticationStore !== "undefined" && authentication_store_AuthenticationStore) === "function" && add_adjustment_component__f || Object])
], add_adjustment_component_AddAdjustmentComponent);

var add_adjustment_component__a, add_adjustment_component__b, add_adjustment_component__c, add_adjustment_component__d, add_adjustment_component__e, add_adjustment_component__f;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/add-adjustment.component.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/non-commission-type.ts
var NonCommissionType = (function () {
    function NonCommissionType() {
    }
    return NonCommissionType;
}());

NonCommissionType.PAID_DIRECT = 'Commission Paid Direct';
NonCommissionType.EVENT_CANCELLED = 'Event Cancelled';
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/non-commission-type.js.map
// EXTERNAL MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/node_modules/rxjs/observable/forkJoin.js
var forkJoin = __webpack_require__("Fhmd");
var forkJoin_default = /*#__PURE__*/__webpack_require__.n(forkJoin);

// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/service/awe.http.service.ts
var awe_http_service___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var awe_http_service___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};





var awe_http_service_AweHttpService = (function () {
    function AweHttpService(http, environment, responseUtilService) {
        this.http = http;
        this.environment = environment;
        this.responseUtilService = responseUtilService;
        this.aweApproversUrl = this.environment.baseUrl + '/api/events/awe/approvers';
        this.aweWorkflowUrl = this.environment.baseUrl + '/api/events/awe/workflow';
    }
    AweHttpService.prototype.getAweApprovers = function (eventId, eventPartyId) {
        var _this = this;
        return this.http.get(this.aweApproversUrl + "/" + eventId + "/" + eventPartyId)
            .map(function (response) { return response.json(); })
            .catch(function (response) { return _this.responseUtilService.handleError(response); }).share();
    };
    AweHttpService.prototype.executeAweWorkflow = function (aweRequest) {
        var _this = this;
        var headers = new http_es5["Headers"]({ 'Content-Type': 'application/json' });
        var options = new http_es5["RequestOptions"]({ headers: headers });
        return this.http.post(this.aweWorkflowUrl, JSON.stringify(aweRequest.toJS()), options)
            .catch(function (response) { return _this.responseUtilService.handleError(response); })
            .share();
    };
    return AweHttpService;
}());
awe_http_service_AweHttpService = awe_http_service___decorate([
    Object(core_es5["Injectable"])(),
    awe_http_service___metadata("design:paramtypes", [typeof (awe_http_service__a = typeof AppAuthHttpService !== "undefined" && AppAuthHttpService) === "function" && awe_http_service__a || Object, typeof (awe_http_service__b = typeof EnvironmentConfiguration !== "undefined" && EnvironmentConfiguration) === "function" && awe_http_service__b || Object, typeof (awe_http_service__c = typeof response_util_service_ResponseUtilService !== "undefined" && response_util_service_ResponseUtilService) === "function" && awe_http_service__c || Object])
], awe_http_service_AweHttpService);

var awe_http_service__a, awe_http_service__b, awe_http_service__c;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/awe.http.service.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/service/awe.store.ts
var awe_store___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var awe_store___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};






var awe_store_AweStore = (function () {
    function AweStore(aweHttpService, logService, flashMessagesService, translateService) {
        this.aweHttpService = aweHttpService;
        this.logService = logService;
        this.flashMessagesService = flashMessagesService;
        this.translateService = translateService;
    }
    AweStore.prototype.getAweApprovers = function (eventId, eventPartyId) {
        var _this = this;
        return this.aweHttpService.getAweApprovers(eventId, eventPartyId)
            .catch(function (error) {
            _this.flashMessagesService.error(_this.translateService.instant('MESSAGES.ERROR.GET_AWE_APPROVERS'));
            _this.logService.error("Error fetching AWE approvers: " + error);
            return Observable["Observable"].throw(error);
        })
            .map(function (result) {
            return result;
        });
    };
    AweStore.prototype.startWorkflow = function (aweRequest) {
        var _this = this;
        return this.aweHttpService.executeAweWorkflow(aweRequest)
            .catch(function (error) {
            _this.flashMessagesService.error(_this.translateService.instant('MESSAGES.ERROR.START_AWE_WORKFLOW'));
            _this.logService.error("Error starting AWE workflow: " + error);
            return Observable["Observable"].throw(error);
        })
            .map(function (result) {
            _this.flashMessagesService.success('EVENT.COMMISSION.PAYMENT_SAVED');
            return result;
        });
    };
    return AweStore;
}());
awe_store_AweStore = awe_store___decorate([
    Object(core_es5["Injectable"])(),
    awe_store___metadata("design:paramtypes", [typeof (awe_store__a = typeof awe_http_service_AweHttpService !== "undefined" && awe_http_service_AweHttpService) === "function" && awe_store__a || Object, typeof (awe_store__b = typeof log_service_LogService !== "undefined" && log_service_LogService) === "function" && awe_store__b || Object, typeof (awe_store__c = typeof flash_messages_service_FlashMessagesService !== "undefined" && flash_messages_service_FlashMessagesService) === "function" && awe_store__c || Object, typeof (awe_store__d = typeof core["c" /* TranslateService */] !== "undefined" && core["c" /* TranslateService */]) === "function" && awe_store__d || Object])
], awe_store_AweStore);

var awe_store__a, awe_store__b, awe_store__c, awe_store__d;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/awe.store.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/payment/add-payment/add-payment.component.ts
var add_payment_component___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var add_payment_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var add_payment_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};




































var add_payment_component_AddPaymentComponent = (function (_super) {
    add_payment_component___extends(AddPaymentComponent, _super);
    function AddPaymentComponent(formBuilder, paymentStore, aweStore, adjustmentStore, translateService, environment, errorHandlerService, logService, decimalPipe, uppercasePipe, eventStore, authenticationStore, ngZone, taxDeterminationStore, groupPayConfigStore, ooivRulesStore, route, flashMessagesService, paymentSummaryStore, agencyLookupStore) {
        var _this = _super.call(this) || this;
        _this.formBuilder = formBuilder;
        _this.paymentStore = paymentStore;
        _this.aweStore = aweStore;
        _this.adjustmentStore = adjustmentStore;
        _this.translateService = translateService;
        _this.environment = environment;
        _this.errorHandlerService = errorHandlerService;
        _this.logService = logService;
        _this.decimalPipe = decimalPipe;
        _this.uppercasePipe = uppercasePipe;
        _this.eventStore = eventStore;
        _this.authenticationStore = authenticationStore;
        _this.ngZone = ngZone;
        _this.taxDeterminationStore = taxDeterminationStore;
        _this.groupPayConfigStore = groupPayConfigStore;
        _this.ooivRulesStore = ooivRulesStore;
        _this.route = route;
        _this.flashMessagesService = flashMessagesService;
        _this.paymentSummaryStore = paymentSummaryStore;
        _this.agencyLookupStore = agencyLookupStore;
        _this.addPaymentEnabled = true;
        _this.addPaymentError = false;
        _this.isEventFinished = false;
        _this.ooivRulesValidation = true;
        _this.ooivEntityReady = true;
        _this.confirmationModalConfig = new ConfirmationModalConfig();
        _this.approversModalConfig = new ConfirmationModalConfig();
        _this.strikeThroughPrepayment = false;
        _this.numberOfApprovers = 0;
        _this.isSubscriberAgency = false;
        _this.prepayment = null;
        _this.applyOoiv = false;
        _this.isNotPendingTaxEstimated = true;
        return _this;
    }
    Object.defineProperty(AddPaymentComponent.prototype, "event", {
        set: function (event) {
            this.onyxEvent = event;
        },
        enumerable: true,
        configurable: true
    });
    AddPaymentComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.isPropertyUser = this.authenticationStore.isPropertyUser();
        this.isLastPaymentPayRejected = false;
        this.paymentForm = this.formBuilder.group({
            'description': ['', forms_es5["Validators"].maxLength(255)],
            'type': [null],
            'cancelType': [null],
            'commissionAmount': [null, [pioneer_validators_PioneerValidators.isValidAmount]]
        });
        this.adjustmentForm = this.formBuilder.group({
            // defaults to undefined so that someone is required to enter an amount before submitting
            'adjustmentAmount': [undefined, [forms_es5["Validators"].required, pioneer_validators_PioneerValidators.isValidAmount]]
        });
        this.eventForm = this.formBuilder.group({
            'masterBillPaid': ['']
        });
        if (!this.onyxEvent) {
            this.errorHandlerService.throw('Input property onyxEvent is null in AddPaymentComponent', this.translateService.instant('MESSAGES.ERROR.INPUT_PROPERTY_NULL', {
                property: 'onyxEvent',
                className: 'AddPaymentComponent'
            }));
        }
        if (!this.vendor || !this.vendor.eventPartyId) {
            var message = this.translateService.instant('MESSAGES.ERROR.INPUT_PROPERTY_NULL', {
                property: 'vendor.eventPartyId',
                className: 'AddPaymentComponent'
            });
            this.errorHandlerService.throw('vendor.eventPartyId is null or undefined', message);
            return;
        }
        if (this.isPropertyUser) {
            // Get approvers count from AWE
            this.addSubscription(this.aweStore.getAweApprovers(this.onyxEvent.eventId, this.vendor.eventPartyId)
                .pipe(Object(operators["takeUntil"])(this._destroyed$))
                .subscribe(function (approvers) {
                if (approvers) {
                    _this.numberOfApprovers = approvers.length;
                    _this.approversList = approvers;
                }
            }));
            this.addSubscription(this.agencyLookupStore
                .isSubscriberAgency(this.onyxEvent.eventAgency.code)
                .pipe(Object(operators["takeUntil"])(this._destroyed$))
                .subscribe(function (isSubscriber) {
                _this.isSubscriberAgency = !!isSubscriber;
            }));
        }
        this.paymentSummaryStore.getPaymentSummary(this.vendor.eventPartyId)
            .pipe(Object(operators["takeUntil"])(this._destroyed$), Object(operators["catchError"])(function (err) {
            _this.errorHandlerService.throw(err.message, _this.translateService.instant('MESSAGES.ERROR.COULD_NOT_GET_PAYMENT_SUMMARY'));
            return Observable["Observable"].empty();
        })).subscribe(function (paymentSummary) {
            _this.paymentSummary = paymentSummary;
            _this.calculatedPaymentWithTax = paymentSummary.calculatedPayment;
            _this.paymentForm.setValidators([pioneer_validators_PioneerValidators.commissionAmountAndTypeCrossValidator(_this.calculatedPaymentWithTax)]);
            _this.paymentForm.updateValueAndValidity();
            _this.isLastPaymentRequestedOrRequestResentOrRequestRejected =
                _this.paymentStore.isRequestedOrResentRequestOrRequestRejectedOrError(paymentSummary);
        });
        if (this.prepayment) {
            if (payment_status_utils_PaymentStatusUtils.isError(this.prepayment.status)) {
                this.strikeThroughPrepayment = true;
            }
            this.hasPayment = true;
        }
        this.checkEventDates();
        this.retrieveFinalPaymentHint();
        this.paymentStore.getVendorPayments(this.vendor.eventPartyId).take(1).subscribe(function (paymentList) {
            if (paymentList.size > 0) {
                _this.hasPayment = true;
            }
        });
        this.addNonCommissionDueTypes();
        this.addCancelTypes();
        this.addPaidDirectTypes();
        this.addSubscription(this.paymentStore.isLastVendorPaymentPayRejected(this.vendor.eventPartyId).subscribe(function (isPayRejected) {
            _this.isLastPaymentPayRejected = isPayRejected;
        }));
        this.prePaymentSubscription();
        this.groupPayConfigStore.isOoivEnabled(this.onyxEvent.eventAgency.code, this.onyxEvent.eventAgency.countryCode, this.vendor.countryCode).pipe(Object(operators["takeUntil"])(this._destroyed$), Object(operators["tap"])(function (ooivEnabled) { return _this.applyOoiv = ooivEnabled; }))
            .subscribe();
        this.addSubscription(this.ooivRulesStore.getVendorOoivExceptionRules(this.vendor.eventPartyId)
            .subscribe(function (rule) {
            if (rule) {
                _this.ooivRulesValidation = rule.ooivExceptionsIsValid;
            }
            if (_this.ooivRulesValidation) {
                _this.ooivRulesStore.getAgencyOoivExceptionRule().subscribe(function (agencyRule) {
                    if (agencyRule) {
                        _this.ooivEntityReady = agencyRule.ooivExceptionsIsValid;
                    }
                });
            }
        }));
        this.addSubscription(this.taxDeterminationStore.getGlobalResponseTaxesList().subscribe(function (taxes) {
            _this.isNotPendingTaxEstimated = taxes.isValidTax;
        }));
        if (this.isInvalidNonSubscriberVendorEmailContact()) {
            this.flashMessagesService.warn('EVENT.VENDOR_INVALID_EMAIL', null, null);
        }
    };
    AddPaymentComponent.prototype.ngOnChanges = function (changes) {
        if (!changes['event']) {
            return;
        }
        else {
            this.retrieveFinalPaymentHint();
        }
    };
    AddPaymentComponent.prototype.isValidPaymentDate = function () {
        if (!this.onyxEvent || !this.getEventEndDate()) {
            return false;
        }
        var firstPayDate = new Date(this.getEventEndDate());
        firstPayDate.setDate(firstPayDate.getDate() + this.environment.payments.paymentDelayDaysAfterEventEnd + 1);
        var firstPayDateUtcSeconds = firstPayDate.getTime();
        var currentUtcSeconds = new Date().getTime();
        var isValid = currentUtcSeconds >= firstPayDateUtcSeconds;
        this.logService.verbose("allow: " + firstPayDateUtcSeconds + ", current: " + currentUtcSeconds + ", isValid: " + isValid);
        return isValid;
    };
    Object.defineProperty(AddPaymentComponent.prototype, "approvalButtonLabel", {
        get: function () {
            var isSubscriber = this.isSubscriberAgency;
            var hasApprovers = this.numberOfApprovers > 0;
            if (this.authenticationStore.isAgencyUser()) {
                return this.translateService.instant('EVENT.COMMISSION.REQUEST_APPROVAL_PAYMENT');
            }
            if (!isSubscriber && hasApprovers) {
                return this.translateService.instant('EVENT.COMMISSION.REQUEST_APPROVAL_PAYMENT');
            }
            if (!isSubscriber && !hasApprovers) {
                return this.translateService.instant('EVENT.COMMISSION.AUTHORIZE_FINAL_PAYMENT');
            }
            if (isSubscriber) {
                return this.translateService.instant('EVENT.COMMISSION.REQUEST_APPROVAL_PAYMENT');
            }
            return this.translateService.instant('EVENT.COMMISSION.AUTHORIZE_FINAL_PAYMENT');
        },
        enumerable: true,
        configurable: true
    });
    AddPaymentComponent.prototype.confirmBeforeApprovalWorkflow = function () {
        if (this.isMultiVendor()) {
            this.confirmBeforeAuthorizingPayment();
            return;
        }
        if (this.numberOfApprovers > 0) {
            this.openApprovalWorkflowModal(this.approversList);
        }
        else {
            this.confirmBeforeAuthorizingPayment();
        }
    };
    AddPaymentComponent.prototype.openApprovalWorkflowModal = function (approvers) {
        // set up the title of the confirmation modal
        var titleLabel = 'EVENT.COMMISSION.REQUEST_PAYMENT_APPROVERS_TITLE';
        var contentLabel = 'EVENT.COMMISSION.REQUEST_PAYMENT_APPROVERS_CONTENT';
        var confirmLabel = 'EVENT.COMMISSION.REQUEST_PAYMENT_APPROVERS_CONFIRM';
        var params = {
            approvers: this.formatApprovers(approvers)
        };
        var title = this.translateService.instant(titleLabel);
        var content = this.translateService.instant(contentLabel, params);
        var confirmTitle = this.translateService.instant(confirmLabel);
        this.approversModalConfig.title = title;
        this.approversModalConfig.content = content;
        this.approversModalConfig.confirm = confirmTitle;
        this.approversModal.open();
    };
    AddPaymentComponent.prototype.formatApprovers = function (arr) {
        return arr.map(function (item) { return '<li>' + item + '</li>'; }).join('');
    };
    AddPaymentComponent.prototype.confirmBeforeAuthorizingPayment = function () {
        // set up the title of the confirmation modal
        var label = this.showRequestPayment()
            ? 'EVENT.COMMISSION.REQUEST_PAYMENT_CONFIRMATION_TITLE' : 'EVENT.COMMISSION.AUTHORIZE_PAYMENT_CONFIRMATION_TITLE';
        var confirmLabel = this.showRequestPayment()
            ? 'EVENT.COMMISSION.CONFIRMATION_REQUEST' : 'EVENT.COMMISSION.CONFIRMATION_CONFIRM';
        var params = {
            paymentAmount: this.decimalPipe.transform(this.calculatedPaymentWithTax, '1.2-2'),
            currency: this.uppercasePipe.transform(this.onyxEvent.currency)
        };
        var title = this.translateService.instant(label, params);
        var confirmTitle = this.translateService.instant(confirmLabel);
        this.confirmationModalConfig.title = title;
        this.confirmationModalConfig.confirm = confirmTitle;
        this.confirmationModal.open();
    };
    AddPaymentComponent.prototype.savePayment = function (pendingApproval) {
        var _this = this;
        if (pendingApproval === void 0) { pendingApproval = false; }
        var description = this.paymentForm.value.description;
        var totalVendorTaxes = 0;
        var eventPaymentTaxDetail;
        if (this.applyOoiv) {
            totalVendorTaxes = this.paymentSummary.estimatedTax;
            this.taxDeterminationStore.vendorTaxRates(this.vendor.eventPartyId, this.applyOoiv)
                .pipe(Object(operators["take"])(1))
                .subscribe(function (listRaxReponse) { return eventPaymentTaxDetail = listRaxReponse; });
        }
        var payment = new Payment({
            commissionAmount: this.paymentSummary.commissionAmount,
            description: description,
            commissionCurrency: this.onyxEvent.currency,
            eventId: this.onyxEvent.eventId,
            type: PaymentType.FINAL_PAYMENT,
            eventPartyId: this.vendor.eventPartyId,
            totalTaxAmount: totalVendorTaxes,
            eventPaymentTaxDetail: eventPaymentTaxDetail,
            status: pendingApproval ? PaymentStatus.PENDING_WF_APPROVAL : undefined
        });
        this.addPaymentEnabled = false;
        var obs$;
        if (this.paymentSummary
            && [PaymentStatus.REQUEST_REJECTED, PaymentStatus.REJECTED_WF_APPROVAL].some(function (status) { return status === _this.paymentSummary.paymentStatus; })) {
            obs$ = this.paymentStore.updateFinalPayment(payment);
        }
        else {
            obs$ = this.paymentStore.addPayment(payment);
        }
        obs$.pipe(Object(operators["take"])(1), Object(operators["catchError"])(function (error) {
            _this.addPaymentError = true;
            return Observable["Observable"].throw(error);
        }), Object(operators["tap"])(function () {
            _this.refreshPaymentData();
            if (!_this.addPaymentError) {
                _this.addPaymentEnabled = true;
            }
        })).subscribe();
        return obs$;
    };
    AddPaymentComponent.prototype.startWorkflow = function () {
        this.savePayment(true);
    };
    AddPaymentComponent.prototype.isAddPaymentEnabled = function () {
        var _this = this;
        return this.canAddPayment().map(function (canAddPayment) {
            return canAddPayment && _this.paymentForm && _this.paymentForm.valid;
        });
    };
    AddPaymentComponent.prototype.canAddPayment = function () {
        var _this = this;
        return this.eventStore.selectedEvent.flatMap(function (event) {
            return _this.paymentStore.isCurrentVendorPaymentValid(_this.vendor.eventPartyId).map(function (currentPaymentValid) {
                return _this.addPaymentEnabled &&
                    _this.calculatedPayment > 0 &&
                    !currentPaymentValid &&
                    _this.isValidPaymentDate() &&
                    EventUtils.doesEventHaveAgency(event) &&
                    _this.ooivRulesValidation &&
                    _this.ooivEntityReady;
            });
        });
    };
    AddPaymentComponent.prototype.resetPaymentForm = function () {
        this.paymentForm.reset({
            description: '',
            type: null,
            commissionAmount: undefined
        });
    };
    AddPaymentComponent.prototype.confirmBeforeAddPaymentHandler = function (value) {
        if (value) {
            this.savePayment();
        }
    };
    AddPaymentComponent.prototype.confirmBeforeApprovalWorkflowHandler = function (value) {
        if (value) {
            this.startWorkflow();
        }
    };
    Object.defineProperty(AddPaymentComponent.prototype, "calculatedPayment", {
        get: function () {
            return this.paymentSummary ? this.paymentSummary.calculatedPayment : 0;
        },
        enumerable: true,
        configurable: true
    });
    AddPaymentComponent.prototype.isAuthorizedPayment = function () {
        return this.authenticationStore.hasPermission('AuthorizePayment') && this.isEventControlledByThisUserType();
    };
    AddPaymentComponent.prototype.disablePaymentDescription = function () {
        return !this.isAuthorizedPayment() && !this.canCancelEvent();
    };
    AddPaymentComponent.prototype.isEventControlledByThisUserType = function () {
        return (this.authenticationStore.isAgencyUser() && !this.vendor.subscriber) ||
            (this.isPropertyUser && this.vendor.subscriber);
    };
    AddPaymentComponent.prototype.isEditAutoPayEnabled = function () {
        return this.authenticationStore.hasPermission('EditAutoPay') &&
            this.isPropertyUser && this.vendor.subscriber;
    };
    AddPaymentComponent.prototype.isAutopayOn = function () {
        return this.onyxEvent.autoPayment;
    };
    AddPaymentComponent.prototype.checkEventDates = function () {
        var _endDate = EventUtils.getEventEndDate(this.onyxEvent, this.authenticationStore.isAgencyUser());
        this.isEventFinished = date_util_DateUtil.differenceInCalendarDays(date_util_DateUtil.parseDate(_endDate), new Date()) < 0;
    };
    AddPaymentComponent.prototype.showRequestPayment = function () {
        if (this.isPropertyUser) {
            return true;
        }
        else {
            return this.authenticationStore.isAgencyUser() && !this.vendor.subscriber;
        }
    };
    AddPaymentComponent.prototype.isNotMissingVendorEmailContact = function () {
        return (this.vendor.contact && this.vendor.contact.email && this.vendor.contact.email.trim().length > 0);
    };
    AddPaymentComponent.prototype.retrieveFinalPaymentHint = function () {
        var _this = this;
        this.addSubscription(this.isAddPaymentEnabled().subscribe(function (isAddPayEnabled) {
            if (!_this.isNotMissingVendorEmailContact()) {
                _this.finalPaymentHint = _this.translateService.instant('MESSAGES.ERROR.VENDOR_EMAIL_MISSING');
            }
            else if (_this.isInvalidNonSubscriberVendorEmailContact()) {
                _this.finalPaymentHint = _this.translateService.instant('MESSAGES.ERROR.VENDOR_EMAIL_INVALID');
            }
            else if (_this.isAutopayOn()) {
                _this.finalPaymentHint = _this.translateService.instant('EVENT.COMMISSION.AUTO_PAY_ENABLED');
            }
            else if (_this.isAuthorizedPayment() && isAddPayEnabled) {
                _this.finalPaymentHint = _this.translateService.instant('EVENT.COMMISSION.PAYMENTS_WILL_BE_PROCESSED');
            }
            else if (_this.isAuthorizedPayment() && !isAddPayEnabled && !_this.isEventFinished && !_this.showRequestPayment()) {
                _this.finalPaymentHint = _this.translateService.instant('EVENT.COMMISSION.PAYMENT_OPTION_DISABLED');
            }
            else if (_this.isAuthorizedPayment() && !isAddPayEnabled && !_this.isEventFinished && _this.showRequestPayment()) {
                _this.finalPaymentHint = _this.translateService.instant('EVENT.COMMISSION.PAYMENT_AFTER_EVENT_END_DATE');
            }
            else if (!_this.isAuthorizedPayment()) {
                _this.finalPaymentHint = _this.translateService.instant('EVENT.COMMISSION.PAYMENT_OPTION_NOT_AUTHORIZED');
            }
            else {
                _this.finalPaymentHint = null;
            }
        }));
    };
    AddPaymentComponent.prototype.showPaymentForm = function () {
        var _this = this;
        return this.canAddPayment().map(function (canAddPayment) {
            var showForm = !_this.isAutopayOn() && _this.isAuthorizedPayment() && canAddPayment;
            showForm = showForm || _this.canCancelEvent();
            showForm = showForm || !_this.hasPayment;
            showForm = showForm && _this.showPayRejected() && !(_this.isMultiVendor() && _this.vendor.subscriber);
            if (!showForm) {
                _this.unSelectNonCommType();
            }
            return showForm;
        });
    };
    AddPaymentComponent.prototype.canCancelEvent = function () {
        if (this.isPropertyUser) {
            return !this.hasPrePayment;
        }
        else {
            return !this.vendor.subscriber;
        }
    };
    AddPaymentComponent.prototype.canPaidDirectAndCancel = function () {
        return this.isLastPaymentRequestedOrRequestResentOrRequestRejected || !this.hasPayment;
    };
    AddPaymentComponent.prototype.showPayRejected = function () {
        return !this.isLastPaymentPayRejected;
    };
    AddPaymentComponent.prototype.isSubscriber = function () {
        return this.vendor.subscriber;
    };
    AddPaymentComponent.prototype.showPaidDirectCancel = function () {
        if ((this.canCancelEvent() || !this.isPropertyUser) && !this.hasPayment) {
            return true;
        }
        return false;
    };
    AddPaymentComponent.prototype.toggleMasterBillPaidSetting = function () {
        for (var i = 0; i < this.onyxEvent.eventVendors.length; i++) {
            var vendor = this.onyxEvent.eventVendors[i];
            var vendorCode = vendor.code ? vendor.code : vendor.chain + '|' + vendor.brand + '|' + vendor.propertyId;
            if (this.getVendorCode() === vendorCode) {
                vendor.masterBillPaid = !vendor.masterBillPaid;
            }
        }
        this.addSubscription(this.eventStore.updateEventIndicators(this.onyxEvent).subscribe());
    };
    AddPaymentComponent.prototype.getVendorCode = function () {
        return this.vendor.code ? this.vendor.code : this.vendor.chain + '|' + this.vendor.brand + '|' + this.vendor.propertyId;
    };
    AddPaymentComponent.prototype.addNonCommissionDueTypes = function () {
        if (this.authenticationStore.hasPermission('EditAutoPay') || this.authenticationStore.hasPermission('AuthorizePayment')) {
            this.nonCommissionTypes = [
                new DropdownItem(PaymentType.PAID_DIRECT, NonCommissionType.PAID_DIRECT),
                new DropdownItem(PaymentType.EVENT_CANCELLED, NonCommissionType.EVENT_CANCELLED)
            ];
        }
        else {
            this.nonCommissionTypes = [
                new DropdownItem(PaymentType.EVENT_CANCELLED, NonCommissionType.EVENT_CANCELLED)
            ];
        }
    };
    AddPaymentComponent.prototype.addCancelTypes = function () {
        this.cancelTypes = [
            new DropdownItem(PaymentType.EVENT_CANCELLED, NonCommissionType.EVENT_CANCELLED)
        ];
    };
    AddPaymentComponent.prototype.addPaidDirectTypes = function () {
        this.paidDirectTypes = [
            new DropdownItem(PaymentType.PAID_DIRECT, NonCommissionType.PAID_DIRECT)
        ];
    };
    AddPaymentComponent.prototype.isPayDirect = function () {
        return this.nonCommType && this.nonCommType.key === PaymentType.PAID_DIRECT;
    };
    Object.defineProperty(AddPaymentComponent.prototype, "nonCommType", {
        get: function () {
            return this.getFormControlValue('type');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AddPaymentComponent.prototype, "cancelType", {
        get: function () {
            return this.getFormControlValue('cancelType');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AddPaymentComponent.prototype, "nonCommAmountPaid", {
        get: function () {
            return this.getFormControlValue('commissionAmount');
        },
        enumerable: true,
        configurable: true
    });
    AddPaymentComponent.prototype.getFormControlValue = function (name) {
        return this.paymentForm ? this.paymentForm.get(name).value : null;
    };
    AddPaymentComponent.prototype.isNonCommTypeSelected = function () {
        return this.nonCommType != null;
    };
    AddPaymentComponent.prototype.isCancelTypeSelected = function () {
        return this.cancelType != null;
    };
    AddPaymentComponent.prototype.unSelectNonCommType = function () {
        this.paymentForm.reset({
            description: this.paymentForm.get('description').value,
            type: null,
            cancelType: null,
            commissionAmount: null
        });
    };
    AddPaymentComponent.prototype.saveNonCommPaymentType = function () {
        var _this = this;
        this.paymentForm.disable();
        var description = this.paymentForm.value.description;
        var paymentType = this.nonCommType.key;
        var commAmount = this.nonCommAmountPaid;
        var payment = this.createPayment(commAmount, description, paymentType);
        var obs$ = this.modifyPayment(payment).pipe(Object(operators["tap"])(function () { return _this.refreshPaymentData(); }), Object(operators["catchError"])(function () {
            return Observable["Observable"].of(null);
        }), Object(operators["finalize"])(function () {
            _this.paymentForm.enable();
        }));
        obs$.subscribe();
        return obs$;
    };
    AddPaymentComponent.prototype.saveCancelPaymentType = function () {
        var _this = this;
        this.paymentForm.disable();
        var description = this.paymentForm.value.description;
        var paymentType = this.cancelType.key;
        var commAmount = null;
        var payment = this.createPayment(commAmount, description, paymentType);
        var obs$ = this.modifyCancelPayment(payment).pipe(Object(operators["tap"])(function () { return _this.refreshPaymentData(); }), Object(operators["catchError"])(function () {
            return Observable["Observable"].of(null);
        }), Object(operators["finalize"])(function () {
            _this.paymentForm.enable();
        }));
        obs$.subscribe();
        return obs$;
    };
    AddPaymentComponent.prototype.createPayment = function (commAmount, description, paymentType) {
        return new Payment({
            commissionAmount: commAmount,
            description: description,
            commissionCurrency: this.onyxEvent.currency,
            eventId: this.onyxEvent.eventId,
            eventPartyId: this.vendor.eventPartyId,
            type: paymentType
        });
    };
    AddPaymentComponent.prototype.refreshPaymentData = function () {
        this.resetPaymentForm();
        var eventId = this.onyxEvent.eventId;
        if (this.isMultiVendor()) {
            this.paymentStore.loadPayments(eventId).pipe(Object(operators["take"])(1)).subscribe();
            this.paymentStore.loadLatestFinalPayment(eventId).pipe(Object(operators["take"])(1)).subscribe();
            this.paymentStore.loadFinalPaymentStatusList(eventId).pipe(Object(operators["take"])(1)).subscribe();
            this.eventStore.getEvent(eventId).pipe(Object(operators["take"])(1)).subscribe();
            this.adjustmentStore.loadVendorsTotalPaymentsSummary(eventId).pipe(Object(operators["take"])(1)).subscribe();
        }
        else {
            var eventPartyId = this.vendor.eventPartyId;
            this.paymentStore.loadPaymentsByParty(eventId, eventPartyId).pipe(Object(operators["take"])(1)).subscribe();
            this.paymentStore.loadLatestFinalPaymentByParty(eventId, eventPartyId).pipe(Object(operators["take"])(1)).subscribe();
            this.paymentStore.loadFinalPaymentStatusListByParty(eventId, eventPartyId).pipe(Object(operators["take"])(1)).subscribe();
            this.eventStore.getEventByParty(eventId, eventPartyId).pipe(Object(operators["take"])(1)).subscribe();
            this.adjustmentStore.loadVendorsTotalPaymentsSummaryByParty(eventId, eventPartyId).pipe(Object(operators["take"])(1)).subscribe();
        }
    };
    AddPaymentComponent.prototype.modifyPayment = function (payment) {
        var _this = this;
        this.addPaymentEnabled = false;
        var updatableStatuses = [
            PaymentStatus.REQUESTED,
            PaymentStatus.REQUEST_REJECTED,
            PaymentStatus.RESENT_REQUEST,
            PaymentStatus.REJECTED_WF_APPROVAL
        ];
        if (this.paymentSummary && updatableStatuses.some(function (status) { return status === _this.paymentSummary.paymentStatus; })) {
            return this.paymentStore.updateFinalPayment(payment).finally(function () {
                _this.addPaymentEnabled = true;
            });
        }
        else {
            return this.paymentStore.addPayment(payment).finally(function () {
                _this.addPaymentEnabled = true;
            });
        }
    };
    AddPaymentComponent.prototype.modifyCancelPayment = function (payment) {
        var _this = this;
        this.addPaymentEnabled = false;
        var cancelExistingStatuses = [PaymentStatus.REQUEST_REJECTED, PaymentStatus.REJECTED_WF_APPROVAL];
        if (this.paymentSummary && cancelExistingStatuses.some(function (status) { return status === _this.paymentSummary.paymentStatus; })) {
            return this.paymentStore.cancelExistingPayment(payment).finally(function () {
                _this.addPaymentEnabled = true;
            });
        }
        else {
            return this.paymentStore.cancelNewPayment(payment).finally(function () {
                _this.addPaymentEnabled = true;
            });
        }
    };
    AddPaymentComponent.prototype.getAmountPaidLabel = function () {
        var label = 'EVENT.COMMISSION.NON_COMM_AMOUNT_PAID';
        var params = {
            currency: this.uppercasePipe.transform(this.onyxEvent.currency)
        };
        return this.translateService.instant(label, params);
    };
    AddPaymentComponent.prototype.disablePaidDirect = function () {
        if (this.isPayDirect() && (!this.nonCommAmountPaid || (this.nonCommAmountPaid && this.nonCommAmountPaid < 0))) {
            return true;
        }
        if (!this.paymentForm.valid) {
            return true;
        }
        if (!this.paymentForm.get('commissionAmount').valid) {
            return true;
        }
        return false;
    };
    AddPaymentComponent.prototype.getNonCommDescriptionLabel = function () {
        var label = '';
        if (this.isMultiVendor()) {
            label = 'EVENT.COMMISSION.NON_COMM_DESCRIPTION_VENDOR';
        }
        else {
            label = 'EVENT.COMMISSION.NON_COMM_DESCRIPTION';
        }
        return this.translateService.instant(label);
    };
    AddPaymentComponent.prototype.isMultiVendor = function () {
        return this.authenticationStore.hasPermission('MultiVendor');
    };
    AddPaymentComponent.prototype.isCommissionGreaterThanZero = function () {
        return this.calculatedPayment > 0;
    };
    AddPaymentComponent.prototype.getEventEndDate = function () {
        return EventUtils.getEventEndDate(this.onyxEvent, this.authenticationStore.isAgencyUser());
    };
    AddPaymentComponent.prototype.prePaymentSubscription = function () {
        var _this = this;
        this.addSubscription(this.paymentStore.getPrepayment().subscribe(function (prepayment) {
            _this.hasPrePayment = Boolean(prepayment);
        }));
    };
    AddPaymentComponent.prototype.disableConfirmBeforeAuthorizingPayment = function () {
        var _this = this;
        var conditions = [
            this.isMissingVendorEmailContact(),
            this.isInvalidNonSubscriberVendorEmailContact(),
            this.isAutopayOn(),
            !this.isAuthorizedPayment(),
            !this.addPaymentEnabled,
            !this.isValidPaymentDate(),
            this.applyOoiv && this.isPendingTaxEstimated(),
            this.applyOoiv && !this.ooivRulesValidation,
            this.applyOoiv && !this.ooivEntityReady
        ];
        if (conditions.some(function (condition) { return condition; })) {
            return Observable["Observable"].of(true);
        }
        else {
            return Object(forkJoin["forkJoin"])(this.eventStore.selectedEvent.take(1), this.paymentStore.isVendorPaymentError(this.vendor.eventPartyId).take(1)).pipe(Object(operators["map"])(function (_a) {
                var selectedEvent = _a[0], vendorPaymentError = _a[1];
                if (_this.calculatedPayment <= 0) {
                    return true;
                }
                else if (!EventUtils.doesEventHaveAgency(selectedEvent)) {
                    return true;
                }
                else if (vendorPaymentError) {
                    return true;
                }
                else {
                    return false;
                }
            }));
        }
    };
    AddPaymentComponent.prototype.isMissingVendorEmailContact = function () {
        return !this.isNotMissingVendorEmailContact();
    };
    AddPaymentComponent.prototype.isInvalidNonSubscriberVendorEmailContact = function () {
        return this.authenticationStore.hasPermission('EditEvent') && !this.vendor.subscriber
            && !pioneer_validators_PioneerValidators.isEmailFormatValid(this.vendor.contact.email);
    };
    AddPaymentComponent.prototype.isPendingTaxEstimated = function () {
        return !this.isNotPendingTaxEstimated;
    };
    AddPaymentComponent.prototype.onNonCommissionTypeChange = function () {
        if (this.paymentForm && this.paymentForm.get('commissionAmount')) {
            if (this.isPayDirect()) {
                this.paymentForm.get('commissionAmount').setValue(this.calculatedPaymentWithTax.toFixed(2));
                this.paymentForm.get('commissionAmount').markAsTouched();
            }
            else {
                this.paymentForm.get('commissionAmount').setValue(null);
                this.paymentForm.get('commissionAmount').markAsUntouched();
            }
        }
    };
    return AddPaymentComponent;
}(unsubscriber_Unsubscriber));
add_payment_component___decorate([
    Object(core_es5["ViewChild"])('confirmationModal'),
    add_payment_component___metadata("design:type", typeof (add_payment_component__a = typeof confirmation_modal_component_ConfirmationModalComponent !== "undefined" && confirmation_modal_component_ConfirmationModalComponent) === "function" && add_payment_component__a || Object)
], add_payment_component_AddPaymentComponent.prototype, "confirmationModal", void 0);
add_payment_component___decorate([
    Object(core_es5["ViewChild"])('approversModal'),
    add_payment_component___metadata("design:type", typeof (add_payment_component__b = typeof confirmation_modal_component_ConfirmationModalComponent !== "undefined" && confirmation_modal_component_ConfirmationModalComponent) === "function" && add_payment_component__b || Object)
], add_payment_component_AddPaymentComponent.prototype, "approversModal", void 0);
add_payment_component___decorate([
    Object(core_es5["Input"])(),
    add_payment_component___metadata("design:type", typeof (add_payment_component__c = typeof Payment !== "undefined" && Payment) === "function" && add_payment_component__c || Object)
], add_payment_component_AddPaymentComponent.prototype, "prepayment", void 0);
add_payment_component___decorate([
    Object(core_es5["Input"])(),
    add_payment_component___metadata("design:type", typeof (add_payment_component__d = typeof Party !== "undefined" && Party) === "function" && add_payment_component__d || Object)
], add_payment_component_AddPaymentComponent.prototype, "vendor", void 0);
add_payment_component___decorate([
    Object(core_es5["Input"])('event'),
    add_payment_component___metadata("design:type", typeof (add_payment_component__e = typeof OnyxEvent !== "undefined" && OnyxEvent) === "function" && add_payment_component__e || Object),
    add_payment_component___metadata("design:paramtypes", [typeof (add_payment_component__f = typeof OnyxEvent !== "undefined" && OnyxEvent) === "function" && add_payment_component__f || Object])
], add_payment_component_AddPaymentComponent.prototype, "event", null);
add_payment_component_AddPaymentComponent = add_payment_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-add-payment',
        template: __webpack_require__("vWpv")
    }),
    add_payment_component___metadata("design:paramtypes", [typeof (add_payment_component__g = typeof forms_es5["FormBuilder"] !== "undefined" && forms_es5["FormBuilder"]) === "function" && add_payment_component__g || Object, typeof (add_payment_component__h = typeof payment_store_PaymentStore !== "undefined" && payment_store_PaymentStore) === "function" && add_payment_component__h || Object, typeof (add_payment_component__j = typeof awe_store_AweStore !== "undefined" && awe_store_AweStore) === "function" && add_payment_component__j || Object, typeof (add_payment_component__k = typeof adjustment_store_AdjustmentStore !== "undefined" && adjustment_store_AdjustmentStore) === "function" && add_payment_component__k || Object, typeof (add_payment_component__l = typeof core["c" /* TranslateService */] !== "undefined" && core["c" /* TranslateService */]) === "function" && add_payment_component__l || Object, typeof (add_payment_component__m = typeof EnvironmentConfiguration !== "undefined" && EnvironmentConfiguration) === "function" && add_payment_component__m || Object, typeof (add_payment_component__o = typeof error_handler_service_ErrorHandlerService !== "undefined" && error_handler_service_ErrorHandlerService) === "function" && add_payment_component__o || Object, typeof (add_payment_component__p = typeof log_service_LogService !== "undefined" && log_service_LogService) === "function" && add_payment_component__p || Object, typeof (add_payment_component__q = typeof common_es5["DecimalPipe"] !== "undefined" && common_es5["DecimalPipe"]) === "function" && add_payment_component__q || Object, typeof (add_payment_component__r = typeof common_es5["UpperCasePipe"] !== "undefined" && common_es5["UpperCasePipe"]) === "function" && add_payment_component__r || Object, typeof (add_payment_component__s = typeof event_store_EventStore !== "undefined" && event_store_EventStore) === "function" && add_payment_component__s || Object, typeof (add_payment_component__t = typeof authentication_store_AuthenticationStore !== "undefined" && authentication_store_AuthenticationStore) === "function" && add_payment_component__t || Object, typeof (add_payment_component__u = typeof core_es5["NgZone"] !== "undefined" && core_es5["NgZone"]) === "function" && add_payment_component__u || Object, typeof (add_payment_component__v = typeof tax_determination_store_TaxDeterminationStore !== "undefined" && tax_determination_store_TaxDeterminationStore) === "function" && add_payment_component__v || Object, typeof (add_payment_component__w = typeof grouppay_config_store_GroupPayConfigStore !== "undefined" && grouppay_config_store_GroupPayConfigStore) === "function" && add_payment_component__w || Object, typeof (add_payment_component__x = typeof ooiv_rules_store_OoivRulesStore !== "undefined" && ooiv_rules_store_OoivRulesStore) === "function" && add_payment_component__x || Object, typeof (add_payment_component__y = typeof router_es5["ActivatedRoute"] !== "undefined" && router_es5["ActivatedRoute"]) === "function" && add_payment_component__y || Object, typeof (add_payment_component__z = typeof flash_messages_service_FlashMessagesService !== "undefined" && flash_messages_service_FlashMessagesService) === "function" && add_payment_component__z || Object, typeof (add_payment_component__0 = typeof payment_summary_store_PaymentSummaryStore !== "undefined" && payment_summary_store_PaymentSummaryStore) === "function" && add_payment_component__0 || Object, typeof (add_payment_component__1 = typeof agency_lookup_store_AgencyLookupStore !== "undefined" && agency_lookup_store_AgencyLookupStore) === "function" && add_payment_component__1 || Object])
], add_payment_component_AddPaymentComponent);

var add_payment_component__a, add_payment_component__b, add_payment_component__c, add_payment_component__d, add_payment_component__e, add_payment_component__f, add_payment_component__g, add_payment_component__h, add_payment_component__j, add_payment_component__k, add_payment_component__l, add_payment_component__m, add_payment_component__o, add_payment_component__p, add_payment_component__q, add_payment_component__r, add_payment_component__s, add_payment_component__t, add_payment_component__u, add_payment_component__v, add_payment_component__w, add_payment_component__x, add_payment_component__y, add_payment_component__z, add_payment_component__0, add_payment_component__1;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/add-payment.component.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/payment/add-prepayment/add-prepayment.component.ts
var add_prepayment_component___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var add_prepayment_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var add_prepayment_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};















var add_prepayment_component_AddPrepaymentComponent = (function (_super) {
    add_prepayment_component___extends(AddPrepaymentComponent, _super);
    function AddPrepaymentComponent(formBuilder, paymentStore, translateService, decimalPipe, uppercasePipe, authenticationStore) {
        var _this = _super.call(this) || this;
        _this.formBuilder = formBuilder;
        _this.paymentStore = paymentStore;
        _this.translateService = translateService;
        _this.decimalPipe = decimalPipe;
        _this.uppercasePipe = uppercasePipe;
        _this.authenticationStore = authenticationStore;
        _this.cancel = new core_es5["EventEmitter"]();
        _this.save = new core_es5["EventEmitter"]();
        _this.confirmationModalConfig = new ConfirmationModalConfig();
        return _this;
    }
    Object.defineProperty(AddPrepaymentComponent.prototype, "prepaymentAmount", {
        get: function () {
            return this.prepaymentForm ? this.prepaymentForm.get('prepaymentAmount').value : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AddPrepaymentComponent.prototype, "description", {
        get: function () {
            return this.prepaymentForm ? this.prepaymentForm.get('description').value : null;
        },
        enumerable: true,
        configurable: true
    });
    AddPrepaymentComponent.prototype.ngOnInit = function () {
        if (!this.event) {
            throw new Error('The "event" attribute must be specified to use the ReservationButtonBarComponent component');
        }
        if (!this.vendor) {
            throw new Error('The "vendor" attribute must be specified');
        }
        if (!this.minAmount) {
            throw new Error('The "PREPAYMENT_MIN_AMOUNT" configuration parameter must be set');
        }
        this.initForm();
    };
    AddPrepaymentComponent.prototype.cancelClick = function () {
        this.resetForm();
        this.cancel.emit();
    };
    AddPrepaymentComponent.prototype.disableSave = function () {
        var disable;
        if (this.prepaymentForm) {
            disable = !this.prepaymentForm.valid;
        }
        else {
            disable = true;
        }
        return disable;
    };
    AddPrepaymentComponent.prototype.saveClick = function () {
        this.confirmationModalConfig.title = this.translateService.instant('EVENT.PREPAYMENT.PREPAYMENT_CONFIRMATION_TITLE', {
            amount: this.decimalPipe.transform(this.prepaymentAmount, '1.2-2'),
            currency: this.uppercasePipe.transform(this.event.currency)
        });
        this.confirmationModal.open();
    };
    AddPrepaymentComponent.prototype.prepaymentConfirmationClosed = function (value) {
        if (value) {
            this.savePrepayment();
        }
    };
    AddPrepaymentComponent.prototype.initForm = function () {
        this.prepaymentForm = this.formBuilder.group({
            'prepaymentAmount': [
                null,
                [forms_es5["Validators"].required, pioneer_validators_PioneerValidators.isValidAmountInRange(this.minAmount), forms_es5["Validators"].maxLength(11)]
            ],
            'description': [null, [forms_es5["Validators"].maxLength(255)]]
        });
    };
    AddPrepaymentComponent.prototype.savePrepayment = function () {
        var _this = this;
        this.prepaymentForm.disable();
        var prepayment = new Payment({
            commissionAmount: this.prepaymentAmount,
            commissionCurrency: this.event.currency,
            description: this.description,
            eventId: this.event.eventId,
            type: PaymentType.PREPAYMENT,
            eventPartyId: this.vendor.eventPartyId
        });
        this.paymentStore.addPayment(prepayment).pipe(Object(operators["tap"])(function () {
            if (_this.isMultiVendor()) {
                _this.paymentStore.loadPayments(_this.event.eventId).subscribe();
                _this.paymentStore.loadLatestPrepayment(_this.event.eventId).subscribe();
            }
            else {
                _this.paymentStore.loadPaymentsByParty(_this.event.eventId, _this.vendor.eventPartyId).subscribe();
                _this.paymentStore.loadLatestPrepaymentByParty(_this.event.eventId, _this.vendor.eventPartyId).subscribe();
            }
            _this.save.emit();
        }), Object(operators["finalize"])(function () {
            _this.prepaymentForm.enable();
        })).subscribe();
    };
    AddPrepaymentComponent.prototype.resetForm = function () {
        this.prepaymentForm.reset({
            amount: { value: null, disabled: false },
            description: { value: null, disabled: false }
        });
    };
    AddPrepaymentComponent.prototype.isMultiVendor = function () {
        return this.authenticationStore.hasPermission('MultiVendor');
    };
    return AddPrepaymentComponent;
}(unsubscriber_Unsubscriber));
add_prepayment_component___decorate([
    Object(core_es5["Input"])(),
    add_prepayment_component___metadata("design:type", typeof (add_prepayment_component__a = typeof OnyxEvent !== "undefined" && OnyxEvent) === "function" && add_prepayment_component__a || Object)
], add_prepayment_component_AddPrepaymentComponent.prototype, "event", void 0);
add_prepayment_component___decorate([
    Object(core_es5["Input"])(),
    add_prepayment_component___metadata("design:type", typeof (add_prepayment_component__b = typeof Party !== "undefined" && Party) === "function" && add_prepayment_component__b || Object)
], add_prepayment_component_AddPrepaymentComponent.prototype, "vendor", void 0);
add_prepayment_component___decorate([
    Object(core_es5["Output"])(),
    add_prepayment_component___metadata("design:type", Object)
], add_prepayment_component_AddPrepaymentComponent.prototype, "cancel", void 0);
add_prepayment_component___decorate([
    Object(core_es5["Output"])(),
    add_prepayment_component___metadata("design:type", Object)
], add_prepayment_component_AddPrepaymentComponent.prototype, "save", void 0);
add_prepayment_component___decorate([
    Object(core_es5["ViewChild"])(confirmation_modal_component_ConfirmationModalComponent),
    add_prepayment_component___metadata("design:type", typeof (add_prepayment_component__c = typeof confirmation_modal_component_ConfirmationModalComponent !== "undefined" && confirmation_modal_component_ConfirmationModalComponent) === "function" && add_prepayment_component__c || Object)
], add_prepayment_component_AddPrepaymentComponent.prototype, "confirmationModal", void 0);
add_prepayment_component___decorate([
    Object(core_es5["Input"])(),
    add_prepayment_component___metadata("design:type", Number)
], add_prepayment_component_AddPrepaymentComponent.prototype, "minAmount", void 0);
add_prepayment_component_AddPrepaymentComponent = add_prepayment_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-add-prepayment',
        template: __webpack_require__("VmT3")
    }),
    add_prepayment_component___metadata("design:paramtypes", [typeof (add_prepayment_component__d = typeof forms_es5["FormBuilder"] !== "undefined" && forms_es5["FormBuilder"]) === "function" && add_prepayment_component__d || Object, typeof (add_prepayment_component__e = typeof payment_store_PaymentStore !== "undefined" && payment_store_PaymentStore) === "function" && add_prepayment_component__e || Object, typeof (add_prepayment_component__f = typeof core["c" /* TranslateService */] !== "undefined" && core["c" /* TranslateService */]) === "function" && add_prepayment_component__f || Object, typeof (add_prepayment_component__g = typeof common_es5["DecimalPipe"] !== "undefined" && common_es5["DecimalPipe"]) === "function" && add_prepayment_component__g || Object, typeof (add_prepayment_component__h = typeof common_es5["UpperCasePipe"] !== "undefined" && common_es5["UpperCasePipe"]) === "function" && add_prepayment_component__h || Object, typeof (add_prepayment_component__j = typeof authentication_store_AuthenticationStore !== "undefined" && authentication_store_AuthenticationStore) === "function" && add_prepayment_component__j || Object])
], add_prepayment_component_AddPrepaymentComponent);

var add_prepayment_component__a, add_prepayment_component__b, add_prepayment_component__c, add_prepayment_component__d, add_prepayment_component__e, add_prepayment_component__f, add_prepayment_component__g, add_prepayment_component__h, add_prepayment_component__j;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/add-prepayment.component.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/payment/adjustment.resolver.ts
var adjustment_resolver___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var adjustment_resolver___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};



var AdjustmentResolver = (function () {
    function AdjustmentResolver(adjustmentStore, translateService) {
        this.adjustmentStore = adjustmentStore;
        this.translateService = translateService;
    }
    AdjustmentResolver.prototype.resolve = function (route, state) {
        var id = route.params['id'];
        var eventPartyId = route.params['eventPartyId'];
        if (!id) {
            throw new Error(this.translateService.instant('MESSAGES.ERROR.COULD_NOT_GET_ADJUSTMENTS'));
        }
        if (eventPartyId) {
            return this.adjustmentStore.loadAdjustmentsByParty(route.params['id'], eventPartyId).first();
        }
        else {
            return this.adjustmentStore.loadAdjustments(route.params['id']).first();
        }
    };
    return AdjustmentResolver;
}());
AdjustmentResolver = adjustment_resolver___decorate([
    Object(core_es5["Injectable"])(),
    adjustment_resolver___metadata("design:paramtypes", [typeof (adjustment_resolver__a = typeof adjustment_store_AdjustmentStore !== "undefined" && adjustment_store_AdjustmentStore) === "function" && adjustment_resolver__a || Object, typeof (adjustment_resolver__b = typeof core["c" /* TranslateService */] !== "undefined" && core["c" /* TranslateService */]) === "function" && adjustment_resolver__b || Object])
], AdjustmentResolver);

var adjustment_resolver__a, adjustment_resolver__b;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/adjustment.resolver.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/payment/forecasted-commission/forecasted-commission.component.ts
var forecasted_commission_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var forecasted_commission_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};














var forecasted_commission_component_ForecastedCommissionComponent = (function () {
    function ForecastedCommissionComponent(authenticationStore, formBuilder, paymentStore, logService, flashMessagesService) {
        this.authenticationStore = authenticationStore;
        this.formBuilder = formBuilder;
        this.paymentStore = paymentStore;
        this.logService = logService;
        this.flashMessagesService = flashMessagesService;
        this._destroy$ = new Subject["Subject"]();
    }
    Object.defineProperty(ForecastedCommissionComponent.prototype, "event", {
        set: function (event) {
            this.onyxEvent = event;
        },
        enumerable: true,
        configurable: true
    });
    ForecastedCommissionComponent.prototype.ngOnInit = function () {
        this.subscribeForecastedCommAmount();
    };
    ForecastedCommissionComponent.prototype.ngOnDestroy = function () {
        this._destroy$.next(true);
        this._destroy$.complete();
    };
    ForecastedCommissionComponent.prototype.isMultiVendor = function () {
        return this.authenticationStore.hasPermission('MultiVendor');
    };
    ForecastedCommissionComponent.prototype.showForecastedCommissionForm = function () {
        if (!this.authenticationStore.hasPermission('PayCommission') && !this.authenticationStore.isSupportUser()) {
            return false;
        }
        if (this.isMultiVendor()) {
            return true;
        }
        if (this.forecastedCommAmount && parseFloat(this.forecastedCommAmount) > 0) {
            return true;
        }
        return false;
    };
    ForecastedCommissionComponent.prototype.onFocusOutForecastedCommission = function (event) {
        try {
            var newValue = void 0;
            if (event.target.value === '') {
                newValue = null;
            }
            else {
                newValue = parseFloat(event.target.value);
                if (Number.isNaN(newValue)) {
                    return;
                }
            }
            newValue = pioneer_utils_PioneerUtils.addTrailingZeros(newValue);
            this.forecastedCommissionForm.controls['forecastedCommissionAmount'].setValue(newValue);
            this.logService.debug("Request for change of forecastedCommAmount -> current: " + this.forecastedCommAmount + ", new: " + newValue);
            if (this.isMultiVendor() && this.forecastedCommissionForm.valid && this.forecastedCommAmount !== newValue) {
                this.logService.info("Saving new forecasted commission amount value: " + newValue);
                var payment = new Payment({
                    eventPaymentId: this.currentPayment.eventPaymentId,
                    commissionCurrency: this.onyxEvent.currency,
                    eventId: this.currentPayment.eventId,
                    eventPartyId: this.currentPayment.eventPartyId,
                    forecastedCommissionAmount: newValue
                });
                var obs$ = this.updateForecastedCommissionAmount(payment);
                obs$.pipe(Object(operators["takeUntil"])(this._destroy$)).subscribe();
            }
        }
        catch (error) {
            this.logService.error("Error saving new forecasted commission amount value: " + error);
            this.flashMessagesService.error('MESSAGES.ERROR.UPDATE_FORECASTED_COMMISSION_AMOUNT');
        }
    };
    ForecastedCommissionComponent.prototype.updateForecastedCommissionAmount = function (payment) {
        var _this = this;
        return this.paymentStore.updateForecastedCommissionAmount(payment).pipe(Object(operators["tap"])(function () {
            var eventId = _this.onyxEvent.eventId;
            _this.paymentStore.loadLatestFinalPayment(eventId).pipe(Object(operators["takeUntil"])(_this._destroy$)).subscribe();
            _this.paymentStore.loadLatestInitialPayments(eventId).pipe(Object(operators["takeUntil"])(_this._destroy$)).subscribe();
        }), Object(operators["catchError"])(function (error) {
            _this.logService.error("Error saving new forecasted commission amount value: " + error);
            return Observable["Observable"].of(error);
        }));
    };
    ForecastedCommissionComponent.prototype.subscribeForecastedCommAmount = function () {
        var _this = this;
        this.paymentStore.getCurrentPayment(this.vendor.eventPartyId).pipe(Object(operators["takeUntil"])(this._destroy$)).subscribe(function (currentPayment) {
            _this.currentPayment = currentPayment;
            _this.forecastedCommAmount = pioneer_utils_PioneerUtils.addTrailingZeros(currentPayment ? currentPayment.forecastedCommissionAmount : 0.0);
            _this.forecastedCommissionForm = _this.formBuilder.group({
                'forecastedCommissionAmount': [_this.forecastedCommAmount, [pioneer_validators_PioneerValidators.isValidAmountInRange(0.01, 99999999.99)]]
            });
        });
    };
    return ForecastedCommissionComponent;
}());
forecasted_commission_component___decorate([
    Object(core_es5["Input"])(),
    forecasted_commission_component___metadata("design:type", typeof (forecasted_commission_component__a = typeof Party !== "undefined" && Party) === "function" && forecasted_commission_component__a || Object)
], forecasted_commission_component_ForecastedCommissionComponent.prototype, "vendor", void 0);
forecasted_commission_component___decorate([
    Object(core_es5["Input"])(),
    forecasted_commission_component___metadata("design:type", typeof (forecasted_commission_component__b = typeof OnyxEvent !== "undefined" && OnyxEvent) === "function" && forecasted_commission_component__b || Object),
    forecasted_commission_component___metadata("design:paramtypes", [typeof (forecasted_commission_component__c = typeof OnyxEvent !== "undefined" && OnyxEvent) === "function" && forecasted_commission_component__c || Object])
], forecasted_commission_component_ForecastedCommissionComponent.prototype, "event", null);
forecasted_commission_component_ForecastedCommissionComponent = forecasted_commission_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-forecasted-commission',
        template: __webpack_require__("cAE2"),
        styles: [__webpack_require__("Zod0")]
    }),
    forecasted_commission_component___metadata("design:paramtypes", [typeof (forecasted_commission_component__d = typeof authentication_store_AuthenticationStore !== "undefined" && authentication_store_AuthenticationStore) === "function" && forecasted_commission_component__d || Object, typeof (forecasted_commission_component__e = typeof forms_es5["FormBuilder"] !== "undefined" && forms_es5["FormBuilder"]) === "function" && forecasted_commission_component__e || Object, typeof (forecasted_commission_component__f = typeof payment_store_PaymentStore !== "undefined" && payment_store_PaymentStore) === "function" && forecasted_commission_component__f || Object, typeof (forecasted_commission_component__g = typeof log_service_LogService !== "undefined" && log_service_LogService) === "function" && forecasted_commission_component__g || Object, typeof (forecasted_commission_component__h = typeof flash_messages_service_FlashMessagesService !== "undefined" && flash_messages_service_FlashMessagesService) === "function" && forecasted_commission_component__h || Object])
], forecasted_commission_component_ForecastedCommissionComponent);

var forecasted_commission_component__a, forecasted_commission_component__b, forecasted_commission_component__c, forecasted_commission_component__d, forecasted_commission_component__e, forecasted_commission_component__f, forecasted_commission_component__g, forecasted_commission_component__h;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/forecasted-commission.component.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/payment-summary/room-commission-type.ts
var RoomCommissionType;
(function (RoomCommissionType) {
    RoomCommissionType[RoomCommissionType["RSVP"] = 'RSVP'] = "RSVP";
    RoomCommissionType[RoomCommissionType["RESERVATION"] = 'RESERVATION'] = "RESERVATION";
})(RoomCommissionType || (RoomCommissionType = {}));
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/room-commission-type.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/payment/payment-equation/payment-equation.component.ts
var payment_equation_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var payment_equation_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};





















var payment_equation_component_PaymentEquationComponent = (function () {
    function PaymentEquationComponent(paymentSummaryStore, translateService, errorHandlerService, taxDeterminationStore, groupPayConfigStore, paymentStore, adjustmentStore, authenticationStore, ooivRulesStore, decimalPipe, uppercasePipe) {
        this.paymentSummaryStore = paymentSummaryStore;
        this.translateService = translateService;
        this.errorHandlerService = errorHandlerService;
        this.taxDeterminationStore = taxDeterminationStore;
        this.groupPayConfigStore = groupPayConfigStore;
        this.paymentStore = paymentStore;
        this.adjustmentStore = adjustmentStore;
        this.authenticationStore = authenticationStore;
        this.ooivRulesStore = ooivRulesStore;
        this.decimalPipe = decimalPipe;
        this.uppercasePipe = uppercasePipe;
        this.defaultClasses = 'col form-container due-amount';
        this.hasAdjustClass = false;
        this.strikeThroughPaymentLines = false;
        this.confirmationModalConfig = new ConfirmationModalConfig();
        this.strikeThroughFinalPayment = false;
        this.strikeThroughPrepayment = false;
        this.isEditMode = false;
        this.useModifiersMode = false;
        this.isNotPendingTaxEstimated = true;
        this.applyOoiv = true;
        this.ooivRulesValidation = true;
        this.RoomCommissionType = RoomCommissionType;
        this.adjustmentToRemove = null;
        this._destroyed$ = new Subject["Subject"]();
    }
    Object.defineProperty(PaymentEquationComponent.prototype, "event", {
        set: function (event) {
            this.onyxEvent = event;
        },
        enumerable: true,
        configurable: true
    });
    PaymentEquationComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (!this.onyxEvent) {
            var message = this.translateService.instant('MESSAGES.ERROR.INPUT_PROPERTY_NULL', {
                property: 'onyxEvent',
                className: 'PaymentEquationComponent'
            });
            this.errorHandlerService.throw('Input property onyxEvent is null in PaymentEquationComponent', message);
            return;
        }
        if (!this.vendor || !this.vendor.eventPartyId) {
            var message = this.translateService.instant('MESSAGES.ERROR.INPUT_PROPERTY_NULL', {
                property: 'vendor.eventPartyId',
                className: 'PaymentEquationComponent'
            });
            this.errorHandlerService.throw('vendor.eventPartyId is null or undefined', message);
            return;
        }
        this.paymentSummaryStore.getPaymentSummary(this.vendor.eventPartyId)
            .pipe(Object(operators["takeUntil"])(this._destroyed$), Object(operators["catchError"])(function (err) {
            _this.errorHandlerService.throw(err.message, _this.translateService.instant('MESSAGES.ERROR.COULD_NOT_GET_PAYMENT_SUMMARY'));
            return Observable["Observable"].empty();
        }))
            .subscribe(function (paymentSummary) {
            _this.paymentSummary = paymentSummary;
            _this.showModifiers = _this.computeDisplayModifiers(paymentSummary);
            _this.hasAdjustClass = _this.computeHasAdjustClass(paymentSummary);
            _this.isReducedCommission = _this.computeReducedCommission(paymentSummary);
            _this.showRoomCommissionAmounts = _this.computeShowRoomCommissionAmounts(paymentSummary);
            _this.showTaxesSection = _this.computeShowTaxesSection(paymentSummary);
            if (paymentSummary) {
                _this.paymentStore.updateCalculatedPaymentWithTax(_this.vendor.eventPartyId, paymentSummary.calculatedPayment);
            }
        });
        this.groupPayConfigStore.isOoivEnabled(this.onyxEvent.eventAgency.code, this.onyxEvent.eventAgency.countryCode, this.vendor.countryCode)
            .pipe(Object(operators["takeUntil"])(this._destroyed$))
            .subscribe(function (applyOoiv) {
            _this.applyOoiv = applyOoiv;
        });
        this.taxDeterminationStore.getGlobalResponseTaxesList()
            .pipe(Object(operators["takeUntil"])(this._destroyed$))
            .subscribe(function (taxes) {
            _this.isNotPendingTaxEstimated = taxes && taxes.isValidTax;
        });
        if (!this.useModifiersMode) {
            this.ooivRulesStore.getVendorOoivExceptionRules(this.vendor.eventPartyId)
                .pipe(Object(operators["takeUntil"])(this._destroyed$))
                .subscribe(function (rule) {
                _this.ooivRulesValidation = rule && rule.ooivExceptionsIsValid;
            });
        }
        this.showDeleteAdjustmentButton = this.computeShowDeleteAdjustmentButton();
        this.reducedCommissionTooltip = this.computeReducedCommissionTooltip();
    };
    PaymentEquationComponent.prototype.ngOnDestroy = function () {
        this._destroyed$.next();
        this._destroyed$.complete();
    };
    PaymentEquationComponent.prototype.computeHasAdjustClass = function (paymentSummary) {
        if (!paymentSummary) {
            return false;
        }
        if (paymentSummary.adjustmentSummaryList && paymentSummary.adjustmentSummaryList.size > 0) {
            return true;
        }
        if (paymentSummary.prepayment) {
            return true;
        }
        if (this.showModifiers && paymentSummary.modifierSummaryList && paymentSummary.modifierSummaryList.size > 0) {
            return true;
        }
        return false;
    };
    PaymentEquationComponent.prototype.computeDisplayModifiers = function (paymentSummary) {
        if (!paymentSummary) {
            return false;
        }
        if (!this.useModifiersMode) {
            return false;
        }
        return PaymentStatus.REQUESTED !== paymentSummary.paymentStatus
            && PaymentStatus.RESENT_REQUEST !== paymentSummary.paymentStatus;
    };
    PaymentEquationComponent.prototype.computeReducedCommission = function (paymentSummary) {
        if (!paymentSummary || !paymentSummary.roomCommissionSummary) {
            return false;
        }
        var roomCommission = paymentSummary.roomCommissionSummary;
        var calculatedCommission = roomCommission.totalSpend * roomCommission.commRate / 100;
        return NumberUtils.round2Fixed(roomCommission.amountDue) < NumberUtils.round2Fixed(calculatedCommission);
    };
    PaymentEquationComponent.prototype.computeReducedCommissionTooltip = function () {
        return this.vendor.subscriber ? 'EVENT.COMMISSION.TOOLTIP_REDUCED_COMMISSION_RESERVATIONS'
            : 'EVENT.COMMISSION.TOOLTIP_REDUCED_COMMISSION_RSVPS';
    };
    /**
     *  If it is an agency user and the event property is subscriber,
     *  the addAdjustment button must be disabled
     *  @returns {boolean}
     */
    PaymentEquationComponent.prototype.computeShowDeleteAdjustmentButton = function () {
        if (!this.isEditMode) {
            return false; // hide
        }
        if (this.useModifiersMode) {
            return false; // hide
        }
        if (this.authenticationStore.isAgencyUser() && this.vendor.subscriber) {
            return false; // hide
        }
        return true; // show
    };
    PaymentEquationComponent.prototype.confirmBeforeDeletingAdjustment = function (adjustment) {
        this.adjustmentToRemove = adjustment;
        // set up the title of the confirmation modal
        var label = 'EVENT.COMMISSION.DELETE_ADJUSTMENT_CONFIRMATION_TITLE';
        var params = {
            adjustmentAmount: this.decimalPipe.transform(adjustment.amountDue, '1.2-2'),
            currency: this.uppercasePipe.transform(this.onyxEvent.currency)
        };
        this.confirmationModalConfig.title = this.translateService.instant(label, params);
        this.confirmationModal.open();
    };
    PaymentEquationComponent.prototype.deleteAdjustment = function (adjustmentId, eventId) {
        this.adjustmentStore.deleteAdjustment(adjustmentId, eventId, this.vendor.eventPartyId).subscribe();
    };
    PaymentEquationComponent.prototype.confirmBeforeDeletingAdjustmentHandler = function (value) {
        if (value) {
            var adjustmentId = this.adjustmentToRemove.eventAdjustmentId;
            var eventId = this.onyxEvent.eventId;
            this.deleteAdjustment(adjustmentId, eventId);
        }
        this.adjustmentToRemove = null;
    };
    PaymentEquationComponent.prototype.computeShowRoomCommissionAmounts = function (paymentSummary) {
        if (!this.useModifiersMode) {
            return true; // show
        }
        if (!paymentSummary || !paymentSummary.roomCommissionSummary || !paymentSummary.roomCommissionSummary.amountDue) {
            return false; // hide => show emptyRoomCommissionSummary
        }
        return paymentSummary.roomCommissionSummary.amountDue > 0;
    };
    PaymentEquationComponent.prototype.computeShowTaxesSection = function (paymentSummary) {
        if (this.useModifiersMode) {
            return true;
        }
        if (!paymentSummary) {
            return false;
        }
        if (paymentSummary.adjustmentSummaryList && paymentSummary.adjustmentSummaryList.size > 0) {
            return true;
        }
        if (paymentSummary.calculatedPayment > 0) {
            return true;
        }
        if (paymentSummary.prepayment) {
            return true;
        }
        return false;
    };
    PaymentEquationComponent.prototype.trackByAdjustmentId = function (index, adjustment) {
        return adjustment.eventAdjustmentId;
    };
    PaymentEquationComponent.prototype.getAmount = function (amount, defaultValue) {
        return amount ? amount : defaultValue;
    };
    return PaymentEquationComponent;
}());
payment_equation_component___decorate([
    Object(core_es5["HostBinding"])('class'),
    payment_equation_component___metadata("design:type", Object)
], payment_equation_component_PaymentEquationComponent.prototype, "defaultClasses", void 0);
payment_equation_component___decorate([
    Object(core_es5["HostBinding"])('class.has-adjust'),
    payment_equation_component___metadata("design:type", Object)
], payment_equation_component_PaymentEquationComponent.prototype, "hasAdjustClass", void 0);
payment_equation_component___decorate([
    Object(core_es5["Input"])(),
    Object(core_es5["HostBinding"])('class.status-rejected'),
    payment_equation_component___metadata("design:type", Object)
], payment_equation_component_PaymentEquationComponent.prototype, "strikeThroughPaymentLines", void 0);
payment_equation_component___decorate([
    Object(core_es5["ViewChild"])(confirmation_modal_component_ConfirmationModalComponent),
    payment_equation_component___metadata("design:type", typeof (payment_equation_component__a = typeof confirmation_modal_component_ConfirmationModalComponent !== "undefined" && confirmation_modal_component_ConfirmationModalComponent) === "function" && payment_equation_component__a || Object)
], payment_equation_component_PaymentEquationComponent.prototype, "confirmationModal", void 0);
payment_equation_component___decorate([
    Object(core_es5["Input"])(),
    payment_equation_component___metadata("design:type", Object)
], payment_equation_component_PaymentEquationComponent.prototype, "strikeThroughFinalPayment", void 0);
payment_equation_component___decorate([
    Object(core_es5["Input"])(),
    payment_equation_component___metadata("design:type", typeof (payment_equation_component__b = typeof Party !== "undefined" && Party) === "function" && payment_equation_component__b || Object)
], payment_equation_component_PaymentEquationComponent.prototype, "vendor", void 0);
payment_equation_component___decorate([
    Object(core_es5["Input"])(),
    payment_equation_component___metadata("design:type", Object)
], payment_equation_component_PaymentEquationComponent.prototype, "strikeThroughPrepayment", void 0);
payment_equation_component___decorate([
    Object(core_es5["Input"])(),
    payment_equation_component___metadata("design:type", typeof (payment_equation_component__c = typeof OnyxEvent !== "undefined" && OnyxEvent) === "function" && payment_equation_component__c || Object),
    payment_equation_component___metadata("design:paramtypes", [typeof (payment_equation_component__d = typeof OnyxEvent !== "undefined" && OnyxEvent) === "function" && payment_equation_component__d || Object])
], payment_equation_component_PaymentEquationComponent.prototype, "event", null);
payment_equation_component___decorate([
    Object(core_es5["Input"])(),
    payment_equation_component___metadata("design:type", Object)
], payment_equation_component_PaymentEquationComponent.prototype, "isEditMode", void 0);
payment_equation_component___decorate([
    Object(core_es5["Input"])(),
    payment_equation_component___metadata("design:type", Object)
], payment_equation_component_PaymentEquationComponent.prototype, "useModifiersMode", void 0);
payment_equation_component_PaymentEquationComponent = payment_equation_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-payment-equation',
        template: __webpack_require__("g9Df"),
        styles: [__webpack_require__("w671")]
    }),
    payment_equation_component___metadata("design:paramtypes", [typeof (payment_equation_component__e = typeof payment_summary_store_PaymentSummaryStore !== "undefined" && payment_summary_store_PaymentSummaryStore) === "function" && payment_equation_component__e || Object, typeof (payment_equation_component__f = typeof core["c" /* TranslateService */] !== "undefined" && core["c" /* TranslateService */]) === "function" && payment_equation_component__f || Object, typeof (payment_equation_component__g = typeof error_handler_service_ErrorHandlerService !== "undefined" && error_handler_service_ErrorHandlerService) === "function" && payment_equation_component__g || Object, typeof (payment_equation_component__h = typeof tax_determination_store_TaxDeterminationStore !== "undefined" && tax_determination_store_TaxDeterminationStore) === "function" && payment_equation_component__h || Object, typeof (payment_equation_component__j = typeof grouppay_config_store_GroupPayConfigStore !== "undefined" && grouppay_config_store_GroupPayConfigStore) === "function" && payment_equation_component__j || Object, typeof (payment_equation_component__k = typeof payment_store_PaymentStore !== "undefined" && payment_store_PaymentStore) === "function" && payment_equation_component__k || Object, typeof (payment_equation_component__l = typeof adjustment_store_AdjustmentStore !== "undefined" && adjustment_store_AdjustmentStore) === "function" && payment_equation_component__l || Object, typeof (payment_equation_component__m = typeof authentication_store_AuthenticationStore !== "undefined" && authentication_store_AuthenticationStore) === "function" && payment_equation_component__m || Object, typeof (payment_equation_component__o = typeof ooiv_rules_store_OoivRulesStore !== "undefined" && ooiv_rules_store_OoivRulesStore) === "function" && payment_equation_component__o || Object, typeof (payment_equation_component__p = typeof common_es5["DecimalPipe"] !== "undefined" && common_es5["DecimalPipe"]) === "function" && payment_equation_component__p || Object, typeof (payment_equation_component__q = typeof common_es5["UpperCasePipe"] !== "undefined" && common_es5["UpperCasePipe"]) === "function" && payment_equation_component__q || Object])
], payment_equation_component_PaymentEquationComponent);

var payment_equation_component__a, payment_equation_component__b, payment_equation_component__c, payment_equation_component__d, payment_equation_component__e, payment_equation_component__f, payment_equation_component__g, payment_equation_component__h, payment_equation_component__j, payment_equation_component__k, payment_equation_component__l, payment_equation_component__m, payment_equation_component__o, payment_equation_component__p, payment_equation_component__q;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/payment-equation.component.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/payment/payment-record/payment-record.component.ts
var payment_record_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var payment_record_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};










var payment_record_component_PaymentRecordComponent = PaymentRecordComponent_1 = (function () {
    function PaymentRecordComponent(paymentStore, authenticationStore) {
        this.paymentStore = paymentStore;
        this.authenticationStore = authenticationStore;
        this.prepayment = null;
        this.finalPaymentStatusList = null;
        this.config = {
            backdrop: 'static',
            keyboard: false
        };
        this.finalPaymentComments = '';
    }
    PaymentRecordComponent.prototype.ngOnInit = function () {
    };
    PaymentRecordComponent.prototype.getPrepaymentClass = function () {
        return payment_status_utils_PaymentStatusUtils.isError(this.prepayment.status) ? 'text-danger font-weight-bold' : '';
    };
    PaymentRecordComponent.prototype.getFinalPaymentStatusClass = function (status) {
        if (payment_status_utils_PaymentStatusUtils.isError(status)) {
            return 'text-danger font-weight-bold';
        }
        else {
            return '';
        }
    };
    PaymentRecordComponent.prototype.displayFinalPaymentStatusList = function () {
        return !!this.finalPaymentStatusList && this.finalPaymentStatusList.length > 0;
    };
    PaymentRecordComponent.prototype.resendPaymentRequest = function () {
        this.paymentStore.resendPaymentRequest(this.event.eventId)
            .take(1)
            .subscribe();
    };
    PaymentRecordComponent.prototype.getFinalPaymentCommentsSubstring = function (finalPayment) {
        var finalPaymentComments = this.getFinalPaymentComments(finalPayment);
        return pioneer_utils_PioneerUtils.safeSubstring(finalPaymentComments, 0, PaymentRecordComponent_1.FINAL_PAYMENT_COMMENTS_MAXLENGTH);
    };
    PaymentRecordComponent.prototype.displayFinalPaymentCommentsMore = function (finalPayment) {
        var finalPaymentComments = this.getFinalPaymentComments(finalPayment);
        return finalPaymentComments && finalPaymentComments.length > PaymentRecordComponent_1.FINAL_PAYMENT_COMMENTS_MAXLENGTH;
    };
    PaymentRecordComponent.prototype.getFinalPaymentComments = function (finalPayment) {
        var finalPaymentComments;
        switch (finalPayment.status) {
            case PaymentStatus.READY:
                if (this.vendor.subscriber === true) {
                    // Final payment comments from the hotel when the event is hotel-controlled.
                    finalPaymentComments = finalPayment.description;
                }
                else {
                    // When the event is agency-controlled and the hotel approves the payment request.
                    finalPaymentComments = '';
                }
                break;
            case PaymentStatus.REQUESTED:
            case PaymentStatus.READY_TO_INITIATE:
            case PaymentStatus.PAID_DIRECT:
            case PaymentStatus.PAY_SENT:
                finalPaymentComments = finalPayment.description;
                break;
            case PaymentStatus.PAY_CLEARED:
                finalPaymentComments = finalPayment.description;
                break;
            case PaymentStatus.PAY_REISSUED:
                finalPaymentComments = finalPayment.description;
                break;
            case PaymentStatus.CANCELLED:
                finalPaymentComments = finalPayment.description;
                break;
            case PaymentStatus.REQUEST_REJECTED:
                // Final payment comments from the hotel when payment request is rejected.
                finalPaymentComments = finalPayment.actionDetails;
                break;
            default:
                finalPaymentComments = '';
                break;
        }
        return finalPaymentComments;
    };
    PaymentRecordComponent.prototype.isPaymentRejectedByHotel = function (finalPayment) {
        return finalPayment.status === PaymentStatus.REQUEST_REJECTED;
    };
    PaymentRecordComponent.prototype.openFinalPaymentCommentsModal = function (finalPayment) {
        this.finalPaymentComments = this.getFinalPaymentComments(finalPayment);
        this.finalPaymentCommentsModal.show();
    };
    PaymentRecordComponent.prototype.closeFinalPaymentCommentsModal = function () {
        this.finalPaymentCommentsModal.hide();
        this.finalPaymentComments = '';
    };
    PaymentRecordComponent.prototype.isSubrow = function (status) {
        return status === PaymentStatus.RESENT_REQUEST;
    };
    PaymentRecordComponent.prototype.getPaymentStatus = function (status) {
        return payment_status_utils_PaymentStatusUtils.getAwePaymentStatus(status, this.authenticationStore.isAgencyUser());
    };
    return PaymentRecordComponent;
}());
payment_record_component_PaymentRecordComponent.FINAL_PAYMENT_COMMENTS_MAXLENGTH = 100;
payment_record_component___decorate([
    Object(core_es5["Input"])(),
    payment_record_component___metadata("design:type", typeof (payment_record_component__a = typeof Payment !== "undefined" && Payment) === "function" && payment_record_component__a || Object)
], payment_record_component_PaymentRecordComponent.prototype, "prepayment", void 0);
payment_record_component___decorate([
    Object(core_es5["Input"])(),
    payment_record_component___metadata("design:type", typeof (payment_record_component__b = typeof OnyxEvent !== "undefined" && OnyxEvent) === "function" && payment_record_component__b || Object)
], payment_record_component_PaymentRecordComponent.prototype, "event", void 0);
payment_record_component___decorate([
    Object(core_es5["Input"])(),
    payment_record_component___metadata("design:type", typeof (payment_record_component__c = typeof Party !== "undefined" && Party) === "function" && payment_record_component__c || Object)
], payment_record_component_PaymentRecordComponent.prototype, "vendor", void 0);
payment_record_component___decorate([
    Object(core_es5["Input"])(),
    payment_record_component___metadata("design:type", Array)
], payment_record_component_PaymentRecordComponent.prototype, "finalPaymentStatusList", void 0);
payment_record_component___decorate([
    Object(core_es5["ViewChild"])(ngx_bootstrap["b" /* ModalDirective */]),
    payment_record_component___metadata("design:type", typeof (payment_record_component__d = typeof ngx_bootstrap["b" /* ModalDirective */] !== "undefined" && ngx_bootstrap["b" /* ModalDirective */]) === "function" && payment_record_component__d || Object)
], payment_record_component_PaymentRecordComponent.prototype, "finalPaymentCommentsModal", void 0);
payment_record_component_PaymentRecordComponent = PaymentRecordComponent_1 = payment_record_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-payment-record',
        template: __webpack_require__("ch4d")
    }),
    payment_record_component___metadata("design:paramtypes", [typeof (payment_record_component__e = typeof payment_store_PaymentStore !== "undefined" && payment_store_PaymentStore) === "function" && payment_record_component__e || Object, typeof (payment_record_component__f = typeof authentication_store_AuthenticationStore !== "undefined" && authentication_store_AuthenticationStore) === "function" && payment_record_component__f || Object])
], payment_record_component_PaymentRecordComponent);

var PaymentRecordComponent_1, payment_record_component__a, payment_record_component__b, payment_record_component__c, payment_record_component__d, payment_record_component__e, payment_record_component__f;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/payment-record.component.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/payment/payment-summary/payment-summary.component.ts
var payment_summary_component___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var payment_summary_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var payment_summary_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
























var payment_summary_component_PaymentSummaryComponent = (function (_super) {
    payment_summary_component___extends(PaymentSummaryComponent, _super);
    function PaymentSummaryComponent(errorHandlerService, translateService, eventStore, paymentStore, adjustmentStore, authenticationStore, uppercasePipe, formBuilder, paymentSummaryStore) {
        var _this = _super.call(this) || this;
        _this.errorHandlerService = errorHandlerService;
        _this.translateService = translateService;
        _this.eventStore = eventStore;
        _this.paymentStore = paymentStore;
        _this.adjustmentStore = adjustmentStore;
        _this.authenticationStore = authenticationStore;
        _this.uppercasePipe = uppercasePipe;
        _this.formBuilder = formBuilder;
        _this.paymentSummaryStore = paymentSummaryStore;
        _this.paymentSummary = null;
        _this.prepayment = null;
        _this.isEventFinished = false;
        _this.latestFinalPayment = null;
        _this.ui = {
            showRejectedMessage: false,
            strikeThroughPaymentLines: false,
            strikeThroughFinalPayment: false,
            strikeThroughPrepayment: false
        };
        return _this;
    }
    Object.defineProperty(PaymentSummaryComponent.prototype, "event", {
        set: function (event) {
            this.onyxEvent = event;
        },
        enumerable: true,
        configurable: true
    });
    PaymentSummaryComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.isPropertyUser = this.authenticationStore.isPropertyUser();
        this.isLastPaymentPayRejected = false;
        if (!this.onyxEvent) {
            this.errorHandlerService.throw('Input property onyxEvent is null in PaymentSummaryComponent', this.translateService.instant('MESSAGES.ERROR.INPUT_PROPERTY_NULL', {
                property: 'onyxEvent',
                className: 'PaymentSummaryComponent'
            }));
        }
        if (!this.vendor || !this.vendor.eventPartyId) {
            var message = this.translateService.instant('MESSAGES.ERROR.INPUT_PROPERTY_NULL', {
                property: 'vendor.eventPartyId',
                className: 'PaymentSummaryComponent'
            });
            this.errorHandlerService.throw('vendor.eventPartyId is null or undefined', message);
            return;
        }
        this.paymentSummaryStore.getPaymentSummary(this.vendor.eventPartyId)
            .pipe(Object(operators["takeUntil"])(this._destroyed$), Object(operators["catchError"])(function (err) {
            _this.errorHandlerService.throw(err.message, _this.translateService.instant('MESSAGES.ERROR.COULD_NOT_GET_PAYMENT_SUMMARY'));
            return Observable["Observable"].empty();
        }))
            .subscribe(function (paymentSummary) {
            _this.paymentSummary = paymentSummary;
            var finalPaymentStatus = _this.paymentSummary ? _this.paymentSummary.paymentStatus : undefined;
            _this.computePaymentStatus(finalPaymentStatus);
            _this.isLastPaymentRequestedOrRequestResentOrRequestRejected =
                _this.paymentStore.isRequestedOrResentRequestOrRequestRejectedOrError(paymentSummary);
        });
        if (this.prepayment) {
            if (payment_status_utils_PaymentStatusUtils.isError(this.prepayment.status)) {
                this.ui.showRejectedMessage = true;
                this.ui.strikeThroughPaymentLines = true;
                this.ui.strikeThroughPrepayment = true;
            }
        }
        this.addNonCommissionDueTypes();
        this.addPaidDirectTypes();
        this.addCancelTypes();
        this.paymentStore.isLastVendorPaymentPayRejected(this.vendor.eventPartyId).subscribe(function (isPayRejected) {
            _this.isLastPaymentPayRejected = isPayRejected;
        });
        this.paymentForm = this.formBuilder.group({
            'description': ['', forms_es5["Validators"].maxLength(255)],
            'type': [null,],
            'commissionAmount': [null, [pioneer_validators_PioneerValidators.isValidAmount]]
        });
        this.paymentStore.getVendorFinalPayment(this.vendor.eventPartyId)
            .take(1)
            .subscribe(function (latestFinalPayment) { return _this.latestFinalPayment = latestFinalPayment; });
        this.checkEventDates();
        this.paymentStore.getCalculatedPaymentWithTax(this.vendor.eventPartyId).pipe(Object(operators["takeUntil"])(this._destroyed$), Object(operators["tap"])(function (calculatedPaymentWithTax) {
            _this.calculatedPaymentWithTax = calculatedPaymentWithTax;
            _this.paymentForm.setValidators([pioneer_validators_PioneerValidators.commissionAmountAndTypeCrossValidator(_this.calculatedPaymentWithTax)]);
            _this.paymentForm.updateValueAndValidity();
        })).subscribe();
    };
    PaymentSummaryComponent.prototype.computePaymentStatus = function (finalPaymentStatus) {
        var isErrorFinalPayment = payment_status_utils_PaymentStatusUtils.isError(finalPaymentStatus);
        if (isErrorFinalPayment) {
            this.ui.showRejectedMessage = true;
            this.ui.strikeThroughPaymentLines = true;
            this.ui.strikeThroughFinalPayment = true;
        }
    };
    PaymentSummaryComponent.prototype.toggleMasterBillPaidSetting = function () {
        for (var i = 0; i < this.onyxEvent.eventVendors.length; i++) {
            var vendor = this.onyxEvent.eventVendors[i];
            var vendorCode = vendor.code ? vendor.code : vendor.chain + '|' + vendor.brand + '|' + vendor.propertyId;
            if (this.getVendorCode() === vendorCode) {
                vendor.masterBillPaid = !vendor.masterBillPaid;
            }
        }
        this.eventStore.updateEventIndicators(this.onyxEvent).subscribe();
    };
    PaymentSummaryComponent.prototype.getVendorCode = function () {
        return this.vendor.code ? this.vendor.code : this.vendor.chain + '|' + this.vendor.brand + '|' + this.vendor.propertyId;
    };
    PaymentSummaryComponent.prototype.showPaymentForm = function () {
        var _this = this;
        return this.paymentStore
            .isLastVendorPaymentRequestedOrRequestResentOrRequestRejected(this.vendor.eventPartyId)
            .map(function (showForm) {
            return showForm && _this.showPayRejected() && !_this.vendor.subscriber;
        });
    };
    PaymentSummaryComponent.prototype.isAuthorizedPayment = function () {
        return this.authenticationStore.hasPermission('AuthorizePayment') && this.isEventControlledByThisUserType();
    };
    PaymentSummaryComponent.prototype.getAmountPaidLabel = function () {
        var label = 'EVENT.COMMISSION.NON_COMM_AMOUNT_PAID';
        var params = {
            currency: this.uppercasePipe.transform(this.onyxEvent.currency)
        };
        return this.translateService.instant(label, params);
    };
    PaymentSummaryComponent.prototype.isPayDirect = function () {
        return this.nonCommType && this.nonCommType.key === PaymentType.PAID_DIRECT;
    };
    PaymentSummaryComponent.prototype.addNonCommissionDueTypes = function () {
        this.nonCommissionTypes = [
            new DropdownItem(PaymentType.PAID_DIRECT, NonCommissionType.PAID_DIRECT),
            new DropdownItem(PaymentType.EVENT_CANCELLED, NonCommissionType.EVENT_CANCELLED)
        ];
    };
    PaymentSummaryComponent.prototype.addPaidDirectTypes = function () {
        this.paidDirectTypes = [
            new DropdownItem(PaymentType.PAID_DIRECT, NonCommissionType.PAID_DIRECT)
        ];
    };
    PaymentSummaryComponent.prototype.addCancelTypes = function () {
        this.cancelTypes = [
            new DropdownItem(PaymentType.EVENT_CANCELLED, NonCommissionType.EVENT_CANCELLED)
        ];
    };
    Object.defineProperty(PaymentSummaryComponent.prototype, "nonCommType", {
        get: function () {
            return this.getFormControlValue('type');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PaymentSummaryComponent.prototype, "nonCommAmountPaid", {
        get: function () {
            return this.getFormControlValue('commissionAmount');
        },
        enumerable: true,
        configurable: true
    });
    PaymentSummaryComponent.prototype.getFormControlValue = function (name) {
        return this.paymentForm ? this.paymentForm.get(name).value : null;
    };
    PaymentSummaryComponent.prototype.isFullAgencyNonCommSelected = function () {
        return this.authenticationStore.hasPermission('AgencyEventLevelIndicators') && this.isNonCommTypeSelected();
    };
    PaymentSummaryComponent.prototype.isNonCommTypeSelected = function () {
        return this.nonCommType != null;
    };
    PaymentSummaryComponent.prototype.unSelectNonCommType = function () {
        this.paymentForm.reset({
            description: this.paymentForm.get('description').value,
            type: null,
            commissionAmount: null
        });
    };
    PaymentSummaryComponent.prototype.isEventControlledByThisUserType = function () {
        return (this.authenticationStore.isAgencyUser() && !this.vendor.subscriber) ||
            (this.isPropertyUser && this.vendor.subscriber);
    };
    PaymentSummaryComponent.prototype.saveNonCommPaymentType = function () {
        var _this = this;
        this.paymentForm.disable();
        var description = this.paymentForm.value.description;
        var paymentType = this.nonCommType.key;
        var commAmount = this.nonCommAmountPaid;
        var payment = new Payment({
            commissionAmount: commAmount,
            description: description,
            commissionCurrency: this.onyxEvent.currency,
            eventId: this.onyxEvent.eventId,
            eventPartyId: this.vendor.eventPartyId,
            type: paymentType
        });
        var obs$ = this.modifyPayment(payment).pipe(Object(operators["tap"])(function () {
            _this.resetPaymentForm();
            var eventId = _this.onyxEvent.eventId;
            if (_this.isMultiVendor()) {
                _this.paymentStore.loadPayments(eventId).subscribe();
                _this.paymentStore.loadLatestFinalPayment(eventId).subscribe();
                _this.paymentStore.loadFinalPaymentStatusList(eventId).subscribe();
                _this.eventStore.getEvent(_this.onyxEvent.eventId).subscribe();
                _this.adjustmentStore.loadVendorsTotalPaymentsSummary(eventId).subscribe();
            }
            else {
                _this.paymentStore.loadPaymentsByParty(eventId, _this.vendor.eventPartyId).subscribe();
                _this.paymentStore.loadLatestFinalPaymentByParty(eventId, _this.vendor.eventPartyId).subscribe();
                _this.paymentStore.loadFinalPaymentStatusList(eventId).subscribe();
                _this.eventStore.getEventByParty(_this.onyxEvent.eventId, _this.vendor.eventPartyId).subscribe();
                _this.adjustmentStore.loadVendorsTotalPaymentsSummaryByParty(eventId, _this.vendor.eventPartyId).subscribe();
            }
        }), Object(operators["catchError"])(function () {
            return Observable["Observable"].of(null);
        }), Object(operators["finalize"])(function () {
            _this.paymentForm.enable();
        }));
        obs$.subscribe();
        return obs$;
    };
    PaymentSummaryComponent.prototype.modifyPayment = function (payment) {
        if (this.latestFinalPayment !== null
            && (this.latestFinalPayment.status === PaymentStatus.REQUESTED)
            || (this.latestFinalPayment.status === PaymentStatus.REQUEST_REJECTED)
            || (this.latestFinalPayment.status === PaymentStatus.RESENT_REQUEST)
            || (this.latestFinalPayment.status === PaymentStatus.INVOICE_REJECTED)) {
            return this.paymentStore.updateFinalPayment(payment).finally(function () {
            });
        }
        else {
            return this.paymentStore.addPayment(payment).finally(function () {
            });
        }
    };
    PaymentSummaryComponent.prototype.resetPaymentForm = function () {
        this.paymentForm.reset({
            description: '',
            type: null,
            commissionAmount: undefined
        });
    };
    PaymentSummaryComponent.prototype.disablePaidDirect = function () {
        if (!this.isPayDirect()) {
            return false;
        }
        if (!this.nonCommAmountPaid || (this.nonCommAmountPaid && this.nonCommAmountPaid < 0)) {
            return true;
        }
        if (!this.paymentForm.valid) {
            return true;
        }
        return false;
    };
    PaymentSummaryComponent.prototype.canPaidDirectAndCancel = function () {
        return this.isLastPaymentRequestedOrRequestResentOrRequestRejected;
    };
    PaymentSummaryComponent.prototype.showPayRejected = function () {
        return !this.isLastPaymentPayRejected;
    };
    PaymentSummaryComponent.prototype.isSubscriber = function () {
        return this.vendor.subscriber;
    };
    PaymentSummaryComponent.prototype.getNonCommDescriptionLabel = function () {
        var label = '';
        if (this.isMultiVendor()) {
            label = 'EVENT.COMMISSION.NON_COMM_DESCRIPTION_VENDOR';
        }
        else {
            label = 'EVENT.COMMISSION.NON_COMM_DESCRIPTION';
        }
        return this.translateService.instant(label);
    };
    PaymentSummaryComponent.prototype.isMultiVendor = function () {
        return this.authenticationStore.hasPermission('MultiVendor');
    };
    PaymentSummaryComponent.prototype.checkEventDates = function () {
        var _endDate = EventUtils.getEventEndDate(this.onyxEvent, this.authenticationStore.isAgencyUser());
        this.isEventFinished = date_util_DateUtil.differenceInCalendarDays(date_util_DateUtil.parseDate(_endDate), new Date()) < 0;
    };
    PaymentSummaryComponent.prototype.onNonCommissionTypeChange = function () {
        if (this.paymentForm && this.paymentForm.get('commissionAmount')) {
            if (this.isPayDirect()) {
                this.paymentForm.get('commissionAmount').setValue(this.calculatedPaymentWithTax.toFixed(2));
                this.paymentForm.get('commissionAmount').markAsTouched();
            }
            else {
                this.paymentForm.get('commissionAmount').setValue(null);
                this.paymentForm.get('commissionAmount').markAsUntouched();
            }
        }
    };
    return PaymentSummaryComponent;
}(unsubscriber_Unsubscriber));
payment_summary_component___decorate([
    Object(core_es5["Input"])(),
    payment_summary_component___metadata("design:type", typeof (payment_summary_component__a = typeof Party !== "undefined" && Party) === "function" && payment_summary_component__a || Object)
], payment_summary_component_PaymentSummaryComponent.prototype, "vendor", void 0);
payment_summary_component___decorate([
    Object(core_es5["Input"])(),
    payment_summary_component___metadata("design:type", typeof (payment_summary_component__b = typeof Payment !== "undefined" && Payment) === "function" && payment_summary_component__b || Object)
], payment_summary_component_PaymentSummaryComponent.prototype, "prepayment", void 0);
payment_summary_component___decorate([
    Object(core_es5["Input"])(),
    payment_summary_component___metadata("design:type", typeof (payment_summary_component__c = typeof OnyxEvent !== "undefined" && OnyxEvent) === "function" && payment_summary_component__c || Object),
    payment_summary_component___metadata("design:paramtypes", [typeof (payment_summary_component__d = typeof OnyxEvent !== "undefined" && OnyxEvent) === "function" && payment_summary_component__d || Object])
], payment_summary_component_PaymentSummaryComponent.prototype, "event", null);
payment_summary_component_PaymentSummaryComponent = payment_summary_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-payment-summary',
        template: __webpack_require__("A0KH")
    }),
    payment_summary_component___metadata("design:paramtypes", [typeof (payment_summary_component__e = typeof error_handler_service_ErrorHandlerService !== "undefined" && error_handler_service_ErrorHandlerService) === "function" && payment_summary_component__e || Object, typeof (payment_summary_component__f = typeof core["c" /* TranslateService */] !== "undefined" && core["c" /* TranslateService */]) === "function" && payment_summary_component__f || Object, typeof (payment_summary_component__g = typeof event_store_EventStore !== "undefined" && event_store_EventStore) === "function" && payment_summary_component__g || Object, typeof (payment_summary_component__h = typeof payment_store_PaymentStore !== "undefined" && payment_store_PaymentStore) === "function" && payment_summary_component__h || Object, typeof (payment_summary_component__j = typeof adjustment_store_AdjustmentStore !== "undefined" && adjustment_store_AdjustmentStore) === "function" && payment_summary_component__j || Object, typeof (payment_summary_component__k = typeof authentication_store_AuthenticationStore !== "undefined" && authentication_store_AuthenticationStore) === "function" && payment_summary_component__k || Object, typeof (payment_summary_component__l = typeof common_es5["UpperCasePipe"] !== "undefined" && common_es5["UpperCasePipe"]) === "function" && payment_summary_component__l || Object, typeof (payment_summary_component__m = typeof forms_es5["FormBuilder"] !== "undefined" && forms_es5["FormBuilder"]) === "function" && payment_summary_component__m || Object, typeof (payment_summary_component__o = typeof payment_summary_store_PaymentSummaryStore !== "undefined" && payment_summary_store_PaymentSummaryStore) === "function" && payment_summary_component__o || Object])
], payment_summary_component_PaymentSummaryComponent);

var payment_summary_component__a, payment_summary_component__b, payment_summary_component__c, payment_summary_component__d, payment_summary_component__e, payment_summary_component__f, payment_summary_component__g, payment_summary_component__h, payment_summary_component__j, payment_summary_component__k, payment_summary_component__l, payment_summary_component__m, payment_summary_component__o;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/payment-summary.component.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/payment/reservations/payment-reservations.component.ts
var payment_reservations_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var payment_reservations_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
















var payment_reservations_component_PaymentReservationsComponent = (function () {
    function PaymentReservationsComponent(reservationStore, userLocalStorageService, authenticationStore, paymentSummaryStore, errorHandlerService, translateService) {
        this.reservationStore = reservationStore;
        this.userLocalStorageService = userLocalStorageService;
        this.authenticationStore = authenticationStore;
        this.paymentSummaryStore = paymentSummaryStore;
        this.errorHandlerService = errorHandlerService;
        this.translateService = translateService;
        this.pagesizeType = PagesizeType.PAYMENT_RESERVATIONS;
        this._destroy$ = new Subject["Subject"]();
    }
    Object.defineProperty(PaymentReservationsComponent.prototype, "event", {
        set: function (event) {
            this.onyxEvent = event;
        },
        enumerable: true,
        configurable: true
    });
    PaymentReservationsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.goToRecordsPage(0);
        this.paymentSummaryStore.getPaymentSummary(this.vendor.eventPartyId)
            .pipe(Object(operators["takeUntil"])(this._destroy$), Object(operators["catchError"])(function (err) {
            _this.errorHandlerService.throw(err.message, _this.translateService.instant('MESSAGES.ERROR.COULD_NOT_GET_PAYMENT_SUMMARY'));
            return Observable["Observable"].empty();
        }), Object(operators["map"])(function (paymentSummary) {
            _this.staySummary = new StaySummary({
                totalNights: paymentSummary.roomCommissionSummary.totalNights,
                totalRevenue: paymentSummary.roomCommissionSummary.totalSpend,
                avgRoomRate: paymentSummary.roomCommissionSummary.avgRoomRate,
                totalCommission: paymentSummary.roomCommissionSummary.amountDue
            });
        }))
            .subscribe();
    };
    PaymentReservationsComponent.prototype.ngOnDestroy = function () {
        this._destroy$.next();
        this._destroy$.complete();
    };
    PaymentReservationsComponent.prototype.getCommission = function (reservation) {
        return reservation ? reservation_utils_ReservationUtils.getCommission(reservation, this.vendor) : undefined;
    };
    PaymentReservationsComponent.prototype.getCommissionFromStaySummary = function (staySummary) {
        return staySummary ? staySummary.totalRevenue * this.vendor.commissionRoomPercentage / 100 : undefined;
    };
    PaymentReservationsComponent.prototype.goToRecordsPage = function (pageNumber) {
        var _this = this;
        this.reservationStore.getReservationsByStatusByParty(this.onyxEvent.eventId, this.vendor.eventPartyId, [ReservationStatusCode.CHECKED_OUT], pageNumber, this.userLocalStorageService.getPagesize(PagesizeType.PAYMENT_RESERVATIONS))
            .map(function (page) { return _this.reservationsPage = page; })
            .take(1)
            .subscribe();
    };
    PaymentReservationsComponent.prototype.isMultiVendor = function () {
        return this.authenticationStore.hasPermission('MultiVendor');
    };
    return PaymentReservationsComponent;
}());
payment_reservations_component___decorate([
    Object(core_es5["Input"])(),
    payment_reservations_component___metadata("design:type", typeof (payment_reservations_component__a = typeof Party !== "undefined" && Party) === "function" && payment_reservations_component__a || Object)
], payment_reservations_component_PaymentReservationsComponent.prototype, "vendor", void 0);
payment_reservations_component___decorate([
    Object(core_es5["Input"])('event'),
    payment_reservations_component___metadata("design:type", typeof (payment_reservations_component__b = typeof OnyxEvent !== "undefined" && OnyxEvent) === "function" && payment_reservations_component__b || Object),
    payment_reservations_component___metadata("design:paramtypes", [typeof (payment_reservations_component__c = typeof OnyxEvent !== "undefined" && OnyxEvent) === "function" && payment_reservations_component__c || Object])
], payment_reservations_component_PaymentReservationsComponent.prototype, "event", null);
payment_reservations_component_PaymentReservationsComponent = payment_reservations_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-payment-reservations',
        template: __webpack_require__("ys9C")
    }),
    payment_reservations_component___metadata("design:paramtypes", [typeof (payment_reservations_component__d = typeof reservation_store_ReservationStore !== "undefined" && reservation_store_ReservationStore) === "function" && payment_reservations_component__d || Object, typeof (payment_reservations_component__e = typeof user_local_storage_service_UserLocalStorageService !== "undefined" && user_local_storage_service_UserLocalStorageService) === "function" && payment_reservations_component__e || Object, typeof (payment_reservations_component__f = typeof authentication_store_AuthenticationStore !== "undefined" && authentication_store_AuthenticationStore) === "function" && payment_reservations_component__f || Object, typeof (payment_reservations_component__g = typeof payment_summary_store_PaymentSummaryStore !== "undefined" && payment_summary_store_PaymentSummaryStore) === "function" && payment_reservations_component__g || Object, typeof (payment_reservations_component__h = typeof error_handler_service_ErrorHandlerService !== "undefined" && error_handler_service_ErrorHandlerService) === "function" && payment_reservations_component__h || Object, typeof (payment_reservations_component__j = typeof core["c" /* TranslateService */] !== "undefined" && core["c" /* TranslateService */]) === "function" && payment_reservations_component__j || Object])
], payment_reservations_component_PaymentReservationsComponent);

var payment_reservations_component__a, payment_reservations_component__b, payment_reservations_component__c, payment_reservations_component__d, payment_reservations_component__e, payment_reservations_component__f, payment_reservations_component__g, payment_reservations_component__h, payment_reservations_component__j;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/payment-reservations.component.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/payment/rsvp/payment-rsvp.component.ts
var payment_rsvp_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var payment_rsvp_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};













var payment_rsvp_component_PaymentRsvpComponent = (function () {
    function PaymentRsvpComponent(rsvpStore, userLocalStorageService, paymentSummaryStore, errorHandlerService, translateService) {
        this.rsvpStore = rsvpStore;
        this.userLocalStorageService = userLocalStorageService;
        this.paymentSummaryStore = paymentSummaryStore;
        this.errorHandlerService = errorHandlerService;
        this.translateService = translateService;
        this.pagesizeType = PagesizeType.PAYMENT_RSVP;
        this._destroy$ = new Subject["Subject"]();
    }
    Object.defineProperty(PaymentRsvpComponent.prototype, "event", {
        set: function (event) {
            this.onyxEvent = event;
        },
        enumerable: true,
        configurable: true
    });
    PaymentRsvpComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.goToRecordsPage(0);
        this.paymentSummaryStore.getPaymentSummary(this.vendor.eventPartyId)
            .pipe(Object(operators["takeUntil"])(this._destroy$), Object(operators["catchError"])(function (err) {
            _this.errorHandlerService.throw(err.message, _this.translateService.instant('MESSAGES.ERROR.COULD_NOT_GET_PAYMENT_SUMMARY'));
            return Observable["Observable"].empty();
        }), Object(operators["map"])(function (paymentSummary) {
            _this.staySummary = new StaySummary({
                totalNights: paymentSummary.roomCommissionSummary.totalNights,
                totalRevenue: paymentSummary.roomCommissionSummary.totalSpend,
                avgRoomRate: paymentSummary.roomCommissionSummary.avgRoomRate,
                totalCommission: paymentSummary.roomCommissionSummary.amountDue
            });
        }))
            .subscribe();
    };
    PaymentRsvpComponent.prototype.ngOnDestroy = function () {
        this._destroy$.next();
        this._destroy$.complete();
    };
    PaymentRsvpComponent.prototype.getCommission = function (rsvp) {
        var commission;
        if (rsvp) {
            var revenue = rsvp.revenue;
            if (!revenue) {
                revenue = this.getRevenue(rsvp);
            }
            commission = (revenue * this.vendor.commissionRoomPercentage) / 100;
        }
        else {
            commission = undefined;
        }
        return commission;
    };
    PaymentRsvpComponent.prototype.getCommissionFromStaySummary = function (staySummary) {
        return staySummary ? staySummary.totalRevenue * this.vendor.commissionRoomPercentage / 100 : undefined;
    };
    PaymentRsvpComponent.prototype.goToRecordsPage = function (pageNumber) {
        var _this = this;
        this.rsvpStore.getRsvpsFromVendor(this.onyxEvent.eventId, this.vendor.eventPartyId, pageNumber, this.userLocalStorageService.getPagesize(PagesizeType.PAYMENT_RSVP))
            .map(function (page) { return _this.rsvpsPage = page; })
            .take(1)
            .subscribe();
    };
    PaymentRsvpComponent.prototype.getRevenue = function (rsvp) {
        return rsvp ? rsvp.nights * rsvp.roomRate : undefined;
    };
    return PaymentRsvpComponent;
}());
payment_rsvp_component___decorate([
    Object(core_es5["Input"])(),
    payment_rsvp_component___metadata("design:type", typeof (payment_rsvp_component__a = typeof Party !== "undefined" && Party) === "function" && payment_rsvp_component__a || Object)
], payment_rsvp_component_PaymentRsvpComponent.prototype, "vendor", void 0);
payment_rsvp_component___decorate([
    Object(core_es5["Input"])('event'),
    payment_rsvp_component___metadata("design:type", typeof (payment_rsvp_component__b = typeof OnyxEvent !== "undefined" && OnyxEvent) === "function" && payment_rsvp_component__b || Object),
    payment_rsvp_component___metadata("design:paramtypes", [typeof (payment_rsvp_component__c = typeof OnyxEvent !== "undefined" && OnyxEvent) === "function" && payment_rsvp_component__c || Object])
], payment_rsvp_component_PaymentRsvpComponent.prototype, "event", null);
payment_rsvp_component_PaymentRsvpComponent = payment_rsvp_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-payment-rsvp',
        template: __webpack_require__("IoFL")
    }),
    payment_rsvp_component___metadata("design:paramtypes", [typeof (payment_rsvp_component__d = typeof rsvp_store_RsvpStore !== "undefined" && rsvp_store_RsvpStore) === "function" && payment_rsvp_component__d || Object, typeof (payment_rsvp_component__e = typeof user_local_storage_service_UserLocalStorageService !== "undefined" && user_local_storage_service_UserLocalStorageService) === "function" && payment_rsvp_component__e || Object, typeof (payment_rsvp_component__f = typeof payment_summary_store_PaymentSummaryStore !== "undefined" && payment_summary_store_PaymentSummaryStore) === "function" && payment_rsvp_component__f || Object, typeof (payment_rsvp_component__g = typeof error_handler_service_ErrorHandlerService !== "undefined" && error_handler_service_ErrorHandlerService) === "function" && payment_rsvp_component__g || Object, typeof (payment_rsvp_component__h = typeof core["c" /* TranslateService */] !== "undefined" && core["c" /* TranslateService */]) === "function" && payment_rsvp_component__h || Object])
], payment_rsvp_component_PaymentRsvpComponent);

var payment_rsvp_component__a, payment_rsvp_component__b, payment_rsvp_component__c, payment_rsvp_component__d, payment_rsvp_component__e, payment_rsvp_component__f, payment_rsvp_component__g, payment_rsvp_component__h;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/payment-rsvp.component.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/payment/vendor-commission-card/vendor-commission-card.component.ts
var vendor_commission_card_component___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var vendor_commission_card_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var vendor_commission_card_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};






























var vendor_commission_card_component_VendorCommissionCardComponent = (function (_super) {
    vendor_commission_card_component___extends(VendorCommissionCardComponent, _super);
    function VendorCommissionCardComponent(formBuilder, menuStore, eventStore, paymentStore, authenticationStore, groupPayConfigStore, environment, adjustmentStore, reportService, agencyLookupStore, flashMessagesService, paymentSummaryStore, errorHandlerService, translateService) {
        var _this = _super.call(this) || this;
        _this.formBuilder = formBuilder;
        _this.menuStore = menuStore;
        _this.eventStore = eventStore;
        _this.paymentStore = paymentStore;
        _this.authenticationStore = authenticationStore;
        _this.groupPayConfigStore = groupPayConfigStore;
        _this.environment = environment;
        _this.adjustmentStore = adjustmentStore;
        _this.reportService = reportService;
        _this.agencyLookupStore = agencyLookupStore;
        _this.flashMessagesService = flashMessagesService;
        _this.paymentSummaryStore = paymentSummaryStore;
        _this.errorHandlerService = errorHandlerService;
        _this.translateService = translateService;
        _this.isCardOpen = false;
        _this.onToggleCard = new core_es5["EventEmitter"]();
        _this.isReadOnly = true;
        _this.imagesUrl = '';
        _this.displayedPrepayment = false;
        _this.isCollapsedAddAdjustment = true;
        _this.canMakePrepayment = false;
        _this.showPrepaymentHintText = true;
        _this.ui = {
            showAddPayment: false,
            showPaymentRecord: false,
            showPaymentSummary: false,
            showDownloadDropdown: false
        };
        _this.vendorFormValidators = {};
        _this.applyOoiv = true;
        _this.agencySubscriberUser = false;
        _this.CONFIRM_ACTION = 'confirm';
        return _this;
    }
    VendorCommissionCardComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (!this.vendor || !this.vendor.eventPartyId) {
            var message = this.translateService.instant('MESSAGES.ERROR.INPUT_PROPERTY_NULL', {
                property: 'vendor.eventPartyId',
                className: 'VendorCommissionCardComponent'
            });
            this.errorHandlerService.throw('vendor.eventPartyId is null or undefined', message);
            return;
        }
        this.paymentSummaryStore.getPaymentSummary(this.vendor.eventPartyId)
            .pipe(Object(operators["takeUntil"])(this._destroyed$), Object(operators["catchError"])(function (err) {
            _this.errorHandlerService.throw(err.message, _this.translateService.instant('MESSAGES.ERROR.COULD_NOT_GET_PAYMENT_SUMMARY'));
            return Observable["Observable"].empty();
        }))
            .subscribe(function (paymentSummary) {
            _this.paymentSummary = paymentSummary;
            var finalPaymentStatus = paymentSummary ? paymentSummary.paymentStatus : undefined;
            _this.computePaymentStatus(finalPaymentStatus);
        });
        this.imagesUrl = this.environment.onyxGPImagesCommonDataUrl;
        this.addSubscription(this.eventStore.selectedEvent.subscribe(function (event) {
            _this.onyxEvent = new OnyxEvent(event);
        }));
        this.addSubscription(this.setupUi().subscribe());
        this.commissionForm = this.formBuilder.group({});
        if (this.onyxEvent && EventUtils.getEventName(this.onyxEvent, this.authenticationStore.isAgencyUser())) {
            this.menuStore.setPageHeader(EventUtils.getEventName(this.onyxEvent, this.authenticationStore.isAgencyUser()), this.onyxEvent.eventProperty.subscriber);
        }
        else {
            this.menuStore.setPageHeader('EVENT.EVENT_INFO_TITLE', false);
        }
        this.minAmountPrepayment = this.getMinAmount();
        this.checkPrepaymentPermissions();
        this.createForm();
        this.addSubscription(this.groupPayConfigStore.isOoivEnabled(this.onyxEvent.eventAgency.code, this.onyxEvent.eventAgency.countryCode, this.vendor.countryCode)
            .subscribe(function (ooivEnabled) {
            _this.applyOoiv = ooivEnabled;
        }));
        if (!this.authenticationStore.isAgencyUser()) {
            this.agencySubscriberUser = false;
        }
        else {
            var iata = this.authenticationStore.getDefaultArcIata();
            if (iata) {
                this.addSubscription(this.agencyLookupStore.isSubscriberAgency(iata).subscribe(function (isSubscriber) {
                    _this.agencySubscriberUser = isSubscriber;
                }));
            }
        }
    };
    VendorCommissionCardComponent.prototype.createForm = function () {
        this.vendorForm = this.formBuilder.group({
            vendorName: this.vendor.name,
            vendorId: this.vendor.eventPartyId,
            vendorType: this.vendor.payorType,
            vendorCurrency: this.onyxEvent.currency,
            vendorStatus: 'Ready to Initiate',
            vendorCalculatedPayment: 150,
            commissionRoomPercentage: this.vendor.commissionRoomPercentage,
            commRetention: this.vendor.commRetention
        }, this.vendorFormValidators);
    };
    VendorCommissionCardComponent.prototype.displayPrepaymentClick = function () {
        this.displayedPrepayment = true;
    };
    VendorCommissionCardComponent.prototype.onAddPrepayment = function () {
        this.displayedPrepayment = false;
        this.hasPrepayment = true;
    };
    VendorCommissionCardComponent.prototype.onCancelPrepayment = function () {
        this.displayedPrepayment = false;
    };
    VendorCommissionCardComponent.prototype.isUserApprover = function () {
        return this.authenticationStore.hasPermission('AuthorizePayment');
    };
    VendorCommissionCardComponent.prototype.displayAddPrepaymentButton = function () {
        return !this.displayedPrepayment && !this.hasPrepayment && !this.isEventStarted() && !this.isFinalPaymentAuthorized
            && !this.authenticationStore.isAgencyUser();
    };
    VendorCommissionCardComponent.prototype.isEventStarted = function () {
        var _startDate = EventUtils.getEventStartDate(this.onyxEvent, this.authenticationStore.isAgencyUser());
        var eventStartDate = date_util_DateUtil.parseDate(_startDate).getTime();
        return (eventStartDate < Date.now());
    };
    VendorCommissionCardComponent.prototype.getPrepayment = function () {
        return this.paymentStore.getVendorPrepayment(this.vendor.eventPartyId).map(function (prepayment) {
            return prepayment && prepayment.status ? prepayment : null;
        }).share();
    };
    VendorCommissionCardComponent.prototype.getMinAmount = function () {
        if (this.vendor.config != null && this.vendor.config.value != null) {
            return Number(this.vendor.config.value);
        }
        return null;
    };
    VendorCommissionCardComponent.prototype.checkPrepaymentPermissions = function () {
        var display = this.displayAddPrepaymentButton();
        var missingAgency = !EventUtils.doesEventHaveAgency(this.onyxEvent);
        this.showPrepaymentHintText = display && missingAgency;
        this.canMakePrepayment = this.isUserApprover() && EventUtils.doesEventHaveAgency(this.onyxEvent);
    };
    VendorCommissionCardComponent.prototype.addAdjustmentClick = function () {
        this.isCollapsedAddAdjustment = false;
    };
    VendorCommissionCardComponent.prototype.displayAddAdjustmentButton = function () {
        return !this.vendor.subscriber && this.ui.showAddPayment && this.isCollapsedAddAdjustment;
    };
    /**
     *  If it is an agency user and the event property is subscriber,
     *  the addAdjustment button must be disabled
     * @returns {boolean}
     */
    VendorCommissionCardComponent.prototype.disableAddAdjustmentButton = function () {
        var disable;
        if (this.authenticationStore.isAgencyUser() && this.vendor.subscriber && this.vendor.payorType === 'PROPERTY') {
            disable = true;
        }
        else {
            disable = false;
        }
        return disable;
    };
    VendorCommissionCardComponent.prototype.onAddAdjustment = function () {
        this.isCollapsedAddAdjustment = true;
    };
    VendorCommissionCardComponent.prototype.onCancelAdjustment = function () {
        this.isCollapsedAddAdjustment = true;
    };
    VendorCommissionCardComponent.prototype.confirmBeforeDelete = function ($event) {
        event.preventDefault();
    };
    VendorCommissionCardComponent.prototype.confirmHandler = function (deleteConfirmed) {
        if (deleteConfirmed) {
        }
    };
    VendorCommissionCardComponent.prototype.isVendorProperty = function () {
        return this.vendor.partyType === PartyType.PROPERTY && this.vendor.payorType === 'PROPERTY';
    };
    VendorCommissionCardComponent.prototype.validEventReferenceNumber = function () {
        return this.vendor.eventReferenceNumber !== null && this.vendor.eventReferenceNumber.length > 0;
    };
    VendorCommissionCardComponent.prototype.getPaymentsReport = function (fileType) {
        var _this = this;
        this.addSubscription(this.reportService.getPaymentsReport(this.onyxEvent.eventId, this.vendor.eventPartyId, fileType)
            .subscribe(function (blob) {
            var filename = response_util_ResponseUtil.getFileNameFromHttpResponse(blob);
            if (!filename) {
                filename = _this.reportService.buildReportFileName(ReportType.PAYMENT_SUMMARY, _this.onyxEvent, fileType);
            }
            saveAs(blob.body, filename);
        }));
    };
    VendorCommissionCardComponent.prototype.canWithdrawPaymentRequest = function () {
        if (this.agencySubscriberUser && !this.vendor.subscriber && this.paymentSummary) {
            return this.paymentSummary.paymentStatus === PaymentStatus.REQUESTED
                || this.paymentSummary.paymentStatus === PaymentStatus.RESENT_REQUEST;
        }
        return false;
    };
    VendorCommissionCardComponent.prototype.openWithDrawPaymentRequestModal = function () {
        if (this.canWithdrawPaymentRequest()) {
            this.confirmWithdrawPaymentRequestModal.open();
        }
    };
    VendorCommissionCardComponent.prototype.confirmWithdrawPaymentRequestHandler = function (action) {
        var _this = this;
        if (action === this.CONFIRM_ACTION) {
            this.addSubscription(this.paymentStore.withdrawPaymentRequest(this.onyxEvent.eventId, this.vendor.eventPartyId)
                .take(1)
                .catch(function () {
                _this.flashMessagesService.error('MESSAGES.ERROR.WITHDRAW_PAYMENT_REQUEST');
                return Observable["Observable"].of();
            }).switchMap(function () {
                return Object(forkJoin["forkJoin"])([
                    _this.paymentSummaryStore.reloadPaymentSummary(_this.vendor.eventPartyId).take(1),
                    _this.paymentStore.loadPayments(_this.onyxEvent.eventId).take(1),
                    _this.paymentStore.loadLatestFinalPayment(_this.onyxEvent.eventId).take(1),
                    _this.paymentStore.loadLatestInitialPayments(_this.onyxEvent.eventId).take(1),
                    _this.paymentStore.loadFinalPaymentStatusList(_this.onyxEvent.eventId).take(1),
                    _this.paymentStore.getVendorCurrentPayment(_this.vendor.eventPartyId).take(1),
                    _this.adjustmentStore.loadVendorsTotalPaymentsSummary(_this.onyxEvent.eventId).take(1),
                ]);
            }).subscribe(function () {
                _this.flashMessagesService.success('EVENT.COMMISSION.WITHDRAW_PAYMENT_REQUEST_SUCCESS');
            }));
        }
    };
    VendorCommissionCardComponent.prototype.computePaymentStatus = function (latestFinalPaymentStatus) {
        if (latestFinalPaymentStatus) {
            this.ui.showPaymentSummary = latestFinalPaymentStatus !== PaymentStatus.REQUEST_REJECTED
                && latestFinalPaymentStatus !== PaymentStatus.INVOICE_REJECTED;
            this.ui.showAddPayment = latestFinalPaymentStatus === PaymentStatus.REQUEST_REJECTED
                || latestFinalPaymentStatus === PaymentStatus.INVOICE_REJECTED;
            this.ui.showDownloadDropdown = true;
            this.isFinalPaymentAuthorized = true;
        }
        else {
            this.ui.showPaymentSummary = false;
            this.ui.showAddPayment = true;
            this.ui.showDownloadDropdown = false;
            this.isFinalPaymentAuthorized = false;
        }
    };
    VendorCommissionCardComponent.prototype.setupUi = function () {
        var _this = this;
        return this.paymentStore.getVendorFinalPaymentStatusList(this.vendor.eventPartyId).flatMap(function (finalPaymentStatusList) {
            return _this.getPrepayment().map(function (prepayment) {
                _this.finalPaymentStatusList = finalPaymentStatusList;
                _this.prepayment = prepayment;
                if (prepayment) {
                    _this.hasPrepayment = true;
                }
                else {
                    _this.hasPrepayment = false;
                }
                if ((_this.finalPaymentStatusList && _this.finalPaymentStatusList.length !== 0) || _this.hasPrepayment) {
                    _this.ui.showPaymentRecord = true;
                }
                else {
                    _this.ui.showPaymentRecord = false;
                }
            });
        });
    };
    VendorCommissionCardComponent.prototype.getPaymentStatus = function (status) {
        return payment_status_utils_PaymentStatusUtils.getAwePaymentStatus(status, this.authenticationStore.isAgencyUser());
    };
    VendorCommissionCardComponent.prototype.toggleCard = function (event) {
        event.preventDefault();
        this.onToggleCard.emit();
    };
    return VendorCommissionCardComponent;
}(unsubscriber_Unsubscriber));
vendor_commission_card_component___decorate([
    Object(core_es5["Input"])(),
    vendor_commission_card_component___metadata("design:type", Array)
], vendor_commission_card_component_VendorCommissionCardComponent.prototype, "vendors", void 0);
vendor_commission_card_component___decorate([
    Object(core_es5["Input"])(),
    vendor_commission_card_component___metadata("design:type", typeof (vendor_commission_card_component__a = typeof Party !== "undefined" && Party) === "function" && vendor_commission_card_component__a || Object)
], vendor_commission_card_component_VendorCommissionCardComponent.prototype, "vendor", void 0);
vendor_commission_card_component___decorate([
    Object(core_es5["Input"])(),
    vendor_commission_card_component___metadata("design:type", typeof (vendor_commission_card_component__b = typeof ConfigResponse !== "undefined" && ConfigResponse) === "function" && vendor_commission_card_component__b || Object)
], vendor_commission_card_component_VendorCommissionCardComponent.prototype, "config", void 0);
vendor_commission_card_component___decorate([
    Object(core_es5["Input"])(),
    vendor_commission_card_component___metadata("design:type", Object)
], vendor_commission_card_component_VendorCommissionCardComponent.prototype, "isCardOpen", void 0);
vendor_commission_card_component___decorate([
    Object(core_es5["Output"])(),
    vendor_commission_card_component___metadata("design:type", Object)
], vendor_commission_card_component_VendorCommissionCardComponent.prototype, "onToggleCard", void 0);
vendor_commission_card_component___decorate([
    Object(core_es5["ViewChild"])('cardWrapper'),
    vendor_commission_card_component___metadata("design:type", typeof (vendor_commission_card_component__c = typeof core_es5["ElementRef"] !== "undefined" && core_es5["ElementRef"]) === "function" && vendor_commission_card_component__c || Object)
], vendor_commission_card_component_VendorCommissionCardComponent.prototype, "cardWrapper", void 0);
vendor_commission_card_component___decorate([
    Object(core_es5["ViewChild"])('confirmWithdrawPaymentRequestModal'),
    vendor_commission_card_component___metadata("design:type", typeof (vendor_commission_card_component__d = typeof confirmation_modal_component_ConfirmationModalComponent !== "undefined" && confirmation_modal_component_ConfirmationModalComponent) === "function" && vendor_commission_card_component__d || Object)
], vendor_commission_card_component_VendorCommissionCardComponent.prototype, "confirmWithdrawPaymentRequestModal", void 0);
vendor_commission_card_component_VendorCommissionCardComponent = vendor_commission_card_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-vendor-commission-card',
        template: __webpack_require__("3lFg"),
        styles: [__webpack_require__("3r7E")]
    }),
    vendor_commission_card_component___metadata("design:paramtypes", [typeof (vendor_commission_card_component__e = typeof forms_es5["FormBuilder"] !== "undefined" && forms_es5["FormBuilder"]) === "function" && vendor_commission_card_component__e || Object, typeof (vendor_commission_card_component__f = typeof menu_store_MenuStore !== "undefined" && menu_store_MenuStore) === "function" && vendor_commission_card_component__f || Object, typeof (vendor_commission_card_component__g = typeof event_store_EventStore !== "undefined" && event_store_EventStore) === "function" && vendor_commission_card_component__g || Object, typeof (vendor_commission_card_component__h = typeof payment_store_PaymentStore !== "undefined" && payment_store_PaymentStore) === "function" && vendor_commission_card_component__h || Object, typeof (vendor_commission_card_component__j = typeof authentication_store_AuthenticationStore !== "undefined" && authentication_store_AuthenticationStore) === "function" && vendor_commission_card_component__j || Object, typeof (vendor_commission_card_component__k = typeof grouppay_config_store_GroupPayConfigStore !== "undefined" && grouppay_config_store_GroupPayConfigStore) === "function" && vendor_commission_card_component__k || Object, typeof (vendor_commission_card_component__l = typeof EnvironmentConfiguration !== "undefined" && EnvironmentConfiguration) === "function" && vendor_commission_card_component__l || Object, typeof (vendor_commission_card_component__m = typeof adjustment_store_AdjustmentStore !== "undefined" && adjustment_store_AdjustmentStore) === "function" && vendor_commission_card_component__m || Object, typeof (vendor_commission_card_component__o = typeof report_service_ReportService !== "undefined" && report_service_ReportService) === "function" && vendor_commission_card_component__o || Object, typeof (vendor_commission_card_component__p = typeof agency_lookup_store_AgencyLookupStore !== "undefined" && agency_lookup_store_AgencyLookupStore) === "function" && vendor_commission_card_component__p || Object, typeof (vendor_commission_card_component__q = typeof flash_messages_service_FlashMessagesService !== "undefined" && flash_messages_service_FlashMessagesService) === "function" && vendor_commission_card_component__q || Object, typeof (vendor_commission_card_component__r = typeof payment_summary_store_PaymentSummaryStore !== "undefined" && payment_summary_store_PaymentSummaryStore) === "function" && vendor_commission_card_component__r || Object, typeof (vendor_commission_card_component__s = typeof error_handler_service_ErrorHandlerService !== "undefined" && error_handler_service_ErrorHandlerService) === "function" && vendor_commission_card_component__s || Object, typeof (vendor_commission_card_component__t = typeof core["c" /* TranslateService */] !== "undefined" && core["c" /* TranslateService */]) === "function" && vendor_commission_card_component__t || Object])
], vendor_commission_card_component_VendorCommissionCardComponent);

var vendor_commission_card_component__a, vendor_commission_card_component__b, vendor_commission_card_component__c, vendor_commission_card_component__d, vendor_commission_card_component__e, vendor_commission_card_component__f, vendor_commission_card_component__g, vendor_commission_card_component__h, vendor_commission_card_component__j, vendor_commission_card_component__k, vendor_commission_card_component__l, vendor_commission_card_component__m, vendor_commission_card_component__o, vendor_commission_card_component__p, vendor_commission_card_component__q, vendor_commission_card_component__r, vendor_commission_card_component__s, vendor_commission_card_component__t;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/vendor-commission-card.component.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/payment/vendors-total-add-payment/vendors-total-add-payment.component.ts
var vendors_total_add_payment_component___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var vendors_total_add_payment_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var vendors_total_add_payment_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};




























var vendors_total_add_payment_component_VendorsTotalAddPaymentComponent = (function (_super) {
    vendors_total_add_payment_component___extends(VendorsTotalAddPaymentComponent, _super);
    function VendorsTotalAddPaymentComponent(translateService, environment, errorHandlerService, logService, authenticationStore, adjustmentStore, decimalPipe, uppercasePipe, flashMessagesService, paymentStore, eventStore, taxDeterminationStore, groupPayConfigStore, ooivRulesStore, paymentSummaryStore) {
        var _this = _super.call(this) || this;
        _this.translateService = translateService;
        _this.environment = environment;
        _this.errorHandlerService = errorHandlerService;
        _this.logService = logService;
        _this.authenticationStore = authenticationStore;
        _this.adjustmentStore = adjustmentStore;
        _this.decimalPipe = decimalPipe;
        _this.uppercasePipe = uppercasePipe;
        _this.flashMessagesService = flashMessagesService;
        _this.paymentStore = paymentStore;
        _this.eventStore = eventStore;
        _this.taxDeterminationStore = taxDeterminationStore;
        _this.groupPayConfigStore = groupPayConfigStore;
        _this.ooivRulesStore = ooivRulesStore;
        _this.paymentSummaryStore = paymentSummaryStore;
        _this.confirmationModalConfig = new ConfirmationModalConfig();
        _this.prepayment = null;
        _this.applyOoiv = false;
        _this.isNotPendingTaxEstimated = true;
        _this.ooivRulesValidation = true;
        _this.ooivEntityReady = true;
        _this.isNotMissingEmailContact = false;
        _this.atLeastOnevendorIsMissingEmailContact = false;
        return _this;
    }
    Object.defineProperty(VendorsTotalAddPaymentComponent.prototype, "calculatedTotalPaid", {
        get: function () {
            return this.adjustmentStore.vendorsTotalPaymentsSummary
                .map(function (totals) {
                return totals.totalPaid;
            });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VendorsTotalAddPaymentComponent.prototype, "calculatedTotalRemaining", {
        get: function () {
            return this.adjustmentStore.vendorsTotalPaymentsSummary
                .map(function (totals) {
                return totals.totalRemaining;
            });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VendorsTotalAddPaymentComponent.prototype, "calculateTotalPayment", {
        get: function () {
            return this.adjustmentStore.vendorsTotalPaymentsSummary
                .map(function (totals) {
                return totals.totalPayment;
            });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VendorsTotalAddPaymentComponent.prototype, "totalVendorsWithRemainingPayment", {
        get: function () {
            return this.adjustmentStore.vendorsTotalPaymentsSummary
                .map(function (totals) {
                return totals.totalVendorsWithRemainingPayment.toString();
            });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VendorsTotalAddPaymentComponent.prototype, "event", {
        set: function (event) {
            this.onyxEvent = event;
        },
        enumerable: true,
        configurable: true
    });
    VendorsTotalAddPaymentComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (!this.onyxEvent) {
            this.errorHandlerService.throw('Input property onyxEvent is null in AddPaymentComponent', this.translateService.instant('MESSAGES.ERROR.INPUT_PROPERTY_NULL', {
                property: 'onyxEvent',
                className: 'AddPaymentComponent'
            }));
        }
        this.retrieveFinalPaymentHint();
        this.groupPayConfigStore.isOoivEnabled(this.onyxEvent.eventAgency.code, this.onyxEvent.eventAgency.countryCode, this.onyxEvent.eventProperty.countryCode)
            .subscribe(function (ooivEnabled) {
            _this.applyOoiv = ooivEnabled;
        });
        this.addSubscription(this.ooivRulesStore.getAnyOoivExceptionRule()
            .subscribe(function (rule) {
            if (rule) {
                _this.ooivRulesValidation = rule.ooivExceptionsIsValid;
            }
            if (_this.ooivRulesValidation) {
                _this.ooivRulesStore.getAgencyOoivExceptionRule().subscribe(function (agencyRule) {
                    if (agencyRule) {
                        _this.ooivEntityReady = agencyRule.ooivExceptionsIsValid;
                    }
                });
            }
        }));
        this.addSubscription(this.taxDeterminationStore.getGlobalResponseTaxesList().subscribe(function (taxes) {
            _this.isNotPendingTaxEstimated = taxes.isValidTax;
        }));
    };
    VendorsTotalAddPaymentComponent.prototype.ngOnChanges = function (changes) {
        if (!changes['event']) {
            return;
        }
    };
    VendorsTotalAddPaymentComponent.prototype.isValidPaymentDate = function () {
        if (!this.onyxEvent || !this.getEventEndDate()) {
            return false;
        }
        var firstPayDate = new Date(this.getEventEndDate());
        firstPayDate.setDate(firstPayDate.getDate() + this.environment.payments.paymentDelayDaysAfterEventEnd + 1);
        var firstPayDateUtcSeconds = firstPayDate.getTime();
        var currentUtcSeconds = new Date().getTime();
        var isValid = currentUtcSeconds >= firstPayDateUtcSeconds;
        this.logService.verbose("allow: " + firstPayDateUtcSeconds + ", current: " + currentUtcSeconds + ", isValid: " + isValid);
        return isValid;
    };
    VendorsTotalAddPaymentComponent.prototype.confirmBeforeAddPaymentHandler = function (value) {
        if (value) {
            this.savePayments();
        }
    };
    VendorsTotalAddPaymentComponent.prototype.isNotMissingVendorEmailContact = function () {
        var _this = this;
        this.onyxEvent.eventVendors.forEach(function (vendor) {
            if (!_this.isNotMissingEmailContact && !Object(util_util["isNullOrUndefined"])(vendor.contact.email) && vendor.contact.email.trim().length > 0) {
                _this.isNotMissingEmailContact = true;
            }
            if (!_this.atLeastOnevendorIsMissingEmailContact && Object(util_util["isNullOrUndefined"])(vendor.contact.email)) {
                _this.atLeastOnevendorIsMissingEmailContact = true;
            }
            else {
                if (!_this.atLeastOnevendorIsMissingEmailContact && vendor.contact.email.trim().length === 0) {
                    _this.atLeastOnevendorIsMissingEmailContact = true;
                }
            }
        });
        return this.isNotMissingEmailContact;
    };
    VendorsTotalAddPaymentComponent.prototype.isAtLeastOneInvalidNonSubscriberVendorEmailContact = function () {
        var atLeastOneVendorHasInvalidEmailContact = false;
        this.onyxEvent.eventVendors.forEach(function (vendor) {
            if (!vendor.subscriber && !pioneer_validators_PioneerValidators.isEmailFormatValid(vendor.contact.email)) {
                atLeastOneVendorHasInvalidEmailContact = true;
            }
        });
        return atLeastOneVendorHasInvalidEmailContact;
    };
    VendorsTotalAddPaymentComponent.prototype.showRequestPaymentFromAllVendors = function () {
        return this.isMultiVendor() && !this.eventOnlyHasSubscribers();
    };
    VendorsTotalAddPaymentComponent.prototype.confirmBeforeAuthorizingPayment = function () {
        var _this = this;
        // set up the title of the confirmation modal
        this.addSubscription(this.adjustmentStore.vendorsTotalPaymentsSummary.map(function (totalSummary) {
            var label = _this.isMultiVendor()
                ? 'EVENT.COMMISSION.REQUEST_PAYMENT_VENDOR_CONFIRMATION_TITLE' : 'EVENT.COMMISSION.AUTHORIZE_PAYMENT_CONFIRMATION_TITLE';
            var confirmLabel = _this.isMultiVendor()
                ? 'EVENT.COMMISSION.CONFIRMATION_REQUEST' : 'EVENT.COMMISSION.CONFIRMATION_CONFIRM';
            var params = {
                vendors: totalSummary.totalVendorsWithRemainingPayment,
                paymentAmount: _this.decimalPipe.transform(totalSummary.totalRemaining, '1.2-2'),
                currency: _this.uppercasePipe.transform(_this.onyxEvent.currency)
            };
            var title = _this.translateService.instant(label, params);
            var confirmTitle = _this.translateService.instant(confirmLabel);
            _this.confirmationModalConfig.title = title;
            _this.confirmationModalConfig.confirm = confirmTitle;
        }).subscribe());
        this.confirmationModal.open();
    };
    VendorsTotalAddPaymentComponent.prototype.retrieveFinalPaymentHint = function () {
        this.isNotMissingVendorEmailContact();
        if (this.atLeastOnevendorIsMissingEmailContact) {
            this.finalPaymentHint = this.translateService.instant('MESSAGES.ERROR.MULTIVENDOR_EMAIL_MISSING');
        }
        else if (this.isAtLeastOneInvalidNonSubscriberVendorEmailContact()) {
            this.finalPaymentHint = this.translateService.instant('MESSAGES.ERROR.MULTIVENDOR_EMAIL_INVALID');
        }
        else {
            this.finalPaymentHint = this.translateService.instant('EVENT.COMMISSION.PAYMENTS_WILL_BE_PROCESSED');
        }
    };
    VendorsTotalAddPaymentComponent.prototype.savePayments = function () {
        var _this = this;
        Object(forkJoin["forkJoin"])(this.onyxEvent.eventVendors.map(function (vendor) { return _this.getVendorPayment(vendor); }))
            .pipe(Object(operators["map"])(function (payments) { return payments.filter(function (payment) { return payment !== null; }); }))
            .subscribe(function (validPayments) {
            _this.processPayments(validPayments);
        });
    };
    VendorsTotalAddPaymentComponent.prototype.getVendorPayment = function (vendor) {
        var _this = this;
        if (!this.isVendorEligible(vendor)) {
            return Object(of["of"])(null);
        }
        return this.paymentSummaryStore.getPaymentSummary(vendor.eventPartyId).pipe(Object(operators["take"])(1), Object(operators["mergeMap"])(function (paymentSummary) {
            if (!paymentSummary.commissionAmount || paymentSummary.commissionAmount <= 0) {
                return Object(of["of"])(null);
            }
            return _this.canAddPayment(vendor.eventPartyId).pipe(Object(operators["take"])(1), Object(operators["mergeMap"])(function (canAddPayment) {
                if (!canAddPayment) {
                    return Object(of["of"])(null);
                }
                return _this.groupPayConfigStore.isOoivEnabled(_this.onyxEvent.eventAgency.code, _this.onyxEvent.eventAgency.countryCode, vendor.countryCode).pipe(Object(operators["take"])(1), Object(operators["mergeMap"])(function (ooivEnabled) {
                    return _this.getVendorTaxDetail(ooivEnabled, vendor).pipe(Object(operators["map"])(function (taxResponseList) {
                        var totalTaxes = ooivEnabled ? paymentSummary.estimatedTax : 0;
                        return _this.buildPayment(paymentSummary.commissionAmount, totalTaxes, taxResponseList, vendor);
                    }));
                }));
            }));
        }));
    };
    VendorsTotalAddPaymentComponent.prototype.isVendorEligible = function (vendor) {
        return vendor &&
            !vendor.subscriber &&
            vendor.contact &&
            vendor.contact.email &&
            vendor.contact.email.length > 1;
    };
    VendorsTotalAddPaymentComponent.prototype.buildPayment = function (commissionAmount, totalVendorTaxes, taxResponseList, vendor) {
        return new Payment({
            commissionAmount: commissionAmount,
            description: '',
            commissionCurrency: this.onyxEvent.currency,
            eventId: this.onyxEvent.eventId,
            type: PaymentType.FINAL_PAYMENT,
            eventPartyId: vendor.eventPartyId,
            totalTaxAmount: totalVendorTaxes,
            eventPaymentTaxDetail: taxResponseList
        });
    };
    VendorsTotalAddPaymentComponent.prototype.getVendorTaxDetail = function (ooivEnabled, vendor) {
        return ooivEnabled
            ? this.taxDeterminationStore.vendorTaxRates(vendor.eventPartyId, true).pipe(Object(operators["take"])(1))
            : Object(of["of"])(null);
    };
    VendorsTotalAddPaymentComponent.prototype.processPayments = function (payments) {
        var _this = this;
        var failedPaymentCounter = 0;
        this.bulkActionInfo = this.translateService.instant('EVENTS.BULK_ACTION.PROCESSING', { paymentCount: payments.length });
        this.paymentStore.bulkActionPayments(payments)
            .subscribe(function (res) {
            var failedPayments = res.filter(function (r) { return r.error; });
            failedPaymentCounter = failedPayments.length;
            // Retrieve failures
            if (failedPaymentCounter > 0) {
                _this.bulkActionInfo = _this.translateService.instant('EVENTS.BULK_ACTION.FAILURES', { failedPaymentCount: failedPayments.length, paymentCount: payments.length });
                failedPayments.forEach(function (r) {
                    var vendor = _this.onyxEvent.eventVendors.find(function (v) { return v.eventPartyId === r.eventPartyId; });
                    _this.bulkActionInfo += _this.translateService.instant('EVENTS.BULK_ACTION.PAYMENT_ERROR', { eventReferenceNumber: vendor.eventReferenceNumber, vendorName: vendor.name, error: r.error });
                });
                _this.logService.debug(_this.bulkActionInfo);
            }
            _this.refreshSelectedEvent(true);
        }, function (err) {
            _this.logService.error("Error processing Bulk Payments: " + err);
            _this.flashMessagesService.error('MESSAGES.ERROR.ADD_PAYMENT', "Error processing Payment: " + err);
        }, function () {
            _this.logService.debug('Bulk Payments completed');
        });
    };
    VendorsTotalAddPaymentComponent.prototype.refreshSelectedEvent = function (successBanner) {
        var _this = this;
        // firing off both calls because both have impacts elsewhere:
        //   CommissionComponent and PaymentEquationComponent
        var eventId = this.onyxEvent.eventId;
        Object(forkJoin["forkJoin"])([
            this.paymentStore.loadPayments(eventId).take(1),
            this.paymentStore.loadLatestFinalPayment(eventId).take(1),
            this.paymentStore.loadFinalPaymentStatusList(eventId).take(1),
            this.eventStore.getEvent(eventId).take(1),
            this.adjustmentStore.loadVendorsTotalPaymentsSummary(eventId).take(1)
        ]).subscribe(function () {
            if (successBanner) {
                _this.flashMessagesService.success('EVENT.COMMISSION.PAYMENTS_SAVED');
            }
        });
    };
    VendorsTotalAddPaymentComponent.prototype.canAddPayment = function (eventPartyId) {
        var _this = this;
        return this.paymentStore.isCurrentVendorPaymentValid(eventPartyId).map(function (currentPaymentValid) {
            return !currentPaymentValid &&
                _this.isValidPaymentDate();
        });
    };
    VendorsTotalAddPaymentComponent.prototype.isMultiVendor = function () {
        return this.authenticationStore.hasPermission('MultiVendor');
    };
    VendorsTotalAddPaymentComponent.prototype.eventOnlyHasSubscribers = function () {
        return this.onyxEvent.eventVendors
            && this.onyxEvent.eventVendors.filter(function (vendor) { return !vendor.subscriber; }).length === 0;
    };
    VendorsTotalAddPaymentComponent.prototype.getEventEndDate = function () {
        return EventUtils.getEventEndDate(this.onyxEvent, this.authenticationStore.isAgencyUser());
    };
    VendorsTotalAddPaymentComponent.prototype.disableConfirmBeforeAuthorizingPayment = function () {
        if (this.isMissingVendorEmailContact()) {
            return Observable["Observable"].of(true);
        }
        else if (this.isAtLeastOneInvalidNonSubscriberVendorEmailContact()) {
            return Observable["Observable"].of(true);
        }
        else if (this.applyOoiv && !this.ooivRulesValidation) {
            return Observable["Observable"].of(true);
        }
        else if (this.applyOoiv && !this.ooivEntityReady) {
            return Observable["Observable"].of(true);
        }
        else if (this.applyOoiv && this.isPendingTaxEstimated()) {
            return Observable["Observable"].of(true);
        }
        else {
            return this.adjustmentStore.vendorsTotalPaymentsSummary
                .map(function (vendorsTotalPaymentsSummary) {
                return !vendorsTotalPaymentsSummary.totalVendorsWithRemainingPayment
                    || vendorsTotalPaymentsSummary.totalVendorsWithRemainingPayment === 0;
            });
        }
    };
    VendorsTotalAddPaymentComponent.prototype.isPendingTaxEstimated = function () {
        return !this.isNotPendingTaxEstimated;
    };
    VendorsTotalAddPaymentComponent.prototype.isMissingVendorEmailContact = function () {
        return !this.isNotMissingVendorEmailContact();
    };
    return VendorsTotalAddPaymentComponent;
}(unsubscriber_Unsubscriber));
vendors_total_add_payment_component___decorate([
    Object(core_es5["ViewChild"])(confirmation_modal_component_ConfirmationModalComponent),
    vendors_total_add_payment_component___metadata("design:type", typeof (vendors_total_add_payment_component__a = typeof confirmation_modal_component_ConfirmationModalComponent !== "undefined" && confirmation_modal_component_ConfirmationModalComponent) === "function" && vendors_total_add_payment_component__a || Object)
], vendors_total_add_payment_component_VendorsTotalAddPaymentComponent.prototype, "confirmationModal", void 0);
vendors_total_add_payment_component___decorate([
    Object(core_es5["Input"])(),
    vendors_total_add_payment_component___metadata("design:type", typeof (vendors_total_add_payment_component__b = typeof Payment !== "undefined" && Payment) === "function" && vendors_total_add_payment_component__b || Object)
], vendors_total_add_payment_component_VendorsTotalAddPaymentComponent.prototype, "prepayment", void 0);
vendors_total_add_payment_component___decorate([
    Object(core_es5["Input"])('event'),
    vendors_total_add_payment_component___metadata("design:type", typeof (vendors_total_add_payment_component__c = typeof OnyxEvent !== "undefined" && OnyxEvent) === "function" && vendors_total_add_payment_component__c || Object),
    vendors_total_add_payment_component___metadata("design:paramtypes", [typeof (vendors_total_add_payment_component__d = typeof OnyxEvent !== "undefined" && OnyxEvent) === "function" && vendors_total_add_payment_component__d || Object])
], vendors_total_add_payment_component_VendorsTotalAddPaymentComponent.prototype, "event", null);
vendors_total_add_payment_component_VendorsTotalAddPaymentComponent = vendors_total_add_payment_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-vendors-total-add-payment',
        template: __webpack_require__("/BnH"),
        styles: [__webpack_require__("wagN")]
    }),
    vendors_total_add_payment_component___metadata("design:paramtypes", [typeof (vendors_total_add_payment_component__e = typeof core["c" /* TranslateService */] !== "undefined" && core["c" /* TranslateService */]) === "function" && vendors_total_add_payment_component__e || Object, typeof (vendors_total_add_payment_component__f = typeof EnvironmentConfiguration !== "undefined" && EnvironmentConfiguration) === "function" && vendors_total_add_payment_component__f || Object, typeof (vendors_total_add_payment_component__g = typeof error_handler_service_ErrorHandlerService !== "undefined" && error_handler_service_ErrorHandlerService) === "function" && vendors_total_add_payment_component__g || Object, typeof (vendors_total_add_payment_component__h = typeof log_service_LogService !== "undefined" && log_service_LogService) === "function" && vendors_total_add_payment_component__h || Object, typeof (vendors_total_add_payment_component__j = typeof authentication_store_AuthenticationStore !== "undefined" && authentication_store_AuthenticationStore) === "function" && vendors_total_add_payment_component__j || Object, typeof (vendors_total_add_payment_component__k = typeof adjustment_store_AdjustmentStore !== "undefined" && adjustment_store_AdjustmentStore) === "function" && vendors_total_add_payment_component__k || Object, typeof (vendors_total_add_payment_component__l = typeof common_es5["DecimalPipe"] !== "undefined" && common_es5["DecimalPipe"]) === "function" && vendors_total_add_payment_component__l || Object, typeof (vendors_total_add_payment_component__m = typeof common_es5["UpperCasePipe"] !== "undefined" && common_es5["UpperCasePipe"]) === "function" && vendors_total_add_payment_component__m || Object, typeof (vendors_total_add_payment_component__o = typeof flash_messages_service_FlashMessagesService !== "undefined" && flash_messages_service_FlashMessagesService) === "function" && vendors_total_add_payment_component__o || Object, typeof (vendors_total_add_payment_component__p = typeof payment_store_PaymentStore !== "undefined" && payment_store_PaymentStore) === "function" && vendors_total_add_payment_component__p || Object, typeof (vendors_total_add_payment_component__q = typeof event_store_EventStore !== "undefined" && event_store_EventStore) === "function" && vendors_total_add_payment_component__q || Object, typeof (vendors_total_add_payment_component__r = typeof tax_determination_store_TaxDeterminationStore !== "undefined" && tax_determination_store_TaxDeterminationStore) === "function" && vendors_total_add_payment_component__r || Object, typeof (vendors_total_add_payment_component__s = typeof grouppay_config_store_GroupPayConfigStore !== "undefined" && grouppay_config_store_GroupPayConfigStore) === "function" && vendors_total_add_payment_component__s || Object, typeof (vendors_total_add_payment_component__t = typeof ooiv_rules_store_OoivRulesStore !== "undefined" && ooiv_rules_store_OoivRulesStore) === "function" && vendors_total_add_payment_component__t || Object, typeof (vendors_total_add_payment_component__u = typeof payment_summary_store_PaymentSummaryStore !== "undefined" && payment_summary_store_PaymentSummaryStore) === "function" && vendors_total_add_payment_component__u || Object])
], vendors_total_add_payment_component_VendorsTotalAddPaymentComponent);

var vendors_total_add_payment_component__a, vendors_total_add_payment_component__b, vendors_total_add_payment_component__c, vendors_total_add_payment_component__d, vendors_total_add_payment_component__e, vendors_total_add_payment_component__f, vendors_total_add_payment_component__g, vendors_total_add_payment_component__h, vendors_total_add_payment_component__j, vendors_total_add_payment_component__k, vendors_total_add_payment_component__l, vendors_total_add_payment_component__m, vendors_total_add_payment_component__o, vendors_total_add_payment_component__p, vendors_total_add_payment_component__q, vendors_total_add_payment_component__r, vendors_total_add_payment_component__s, vendors_total_add_payment_component__t, vendors_total_add_payment_component__u;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/vendors-total-add-payment.component.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/pickup-report-attachment/pickup-report-attachment.component.ts
var pickup_report_attachment_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var pickup_report_attachment_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};










var pickup_report_attachment_component_PickupReportAttachmentComponent = (function () {
    function PickupReportAttachmentComponent(commissionStore, flashMessagesService, authStore, environment) {
        this.commissionStore = commissionStore;
        this.flashMessagesService = flashMessagesService;
        this.authStore = authStore;
        this.environment = environment;
        this.currentAttachment = new core_es5["EventEmitter"]();
        /**
         * Used to determine if the upload bar should be shown while an attachment is uploading.
         * Determines animation delay before attachment list is refreshed.
         * @type {boolean}
         */
        this.isUploadInProgress = false;
        /**
         * Set when attachment delete starts.
         * Determines animation length before attachment list is refreshed.
         * @type {boolean}
         */
        this.isDeleteInProgress = false;
        /**
         * Sets css class on newest item.
         * @type {boolean}
         */
        this.isNewAttachment = false;
        /**
         * Set when some attachment is uploaded.
         * Disable button for upload more than 1 file.
         * @type {boolean}
         */
        this.containFile = false;
        this.startDate = new Date();
        this.fileTypes = this.environment.paymentActionReport.acceptedFileTypes;
        this.maxFileSize = this.environment.paymentActionReport.maxFileSize * 1024 * 1024;
        this.attachments = Object(immutable["List"])([]);
    }
    Object.defineProperty(PickupReportAttachmentComponent.prototype, "event", {
        set: function (event) {
            this.onyxEvent1 = event;
        },
        enumerable: true,
        configurable: true
    });
    PickupReportAttachmentComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.removedAttachments = new Set();
        if (!this.onyxEvent1) {
            throw new Error("An event is required to create the \"pioneer-attachement\" component");
        }
        if (!this.vendor) {
            throw new Error("A vendor is required to create the \"pioneer-attachement\" component");
        }
        this.commissionStore.attachments.subscribe(function (attachments) {
            // No animation delay needed if we're not deleting or uploading an attachment.
            var animationDelay = 0;
            if (_this.isDeleteInProgress) {
                animationDelay = 500;
            }
            else if (_this.isUploadInProgress) {
                animationDelay = 1000;
            }
            _this.containFile = attachments.length > 0;
            _this.currentAttachment.emit(attachments);
            setTimeout(function () {
                _this.attachments = attachments;
                _this.isNewAttachment = _this.isUploadInProgress;
                // When attachments are refreshed, "reset" page (nothing uploading or being deleted)
                _this.isUploadInProgress = false;
                _this.isDeleteInProgress = false;
                _this.removedAttachments = new Set();
            }, _this.getAnimationDelay(animationDelay, _this.startDate));
        });
        this.authStore.user.take(1).subscribe(function (user) {
            _this.user = user;
        });
    };
    PickupReportAttachmentComponent.prototype.uploadFile = function (inputEvent) {
        var _this = this;
        this.startDate = new Date();
        this.isUploadInProgress = true;
        if (!inputEvent || !inputEvent.srcElement || !inputEvent.srcElement.files || inputEvent.srcElement.files.size === 0) {
            this.handleUploadError('MESSAGES.ERROR.UPLOAD_ATTACHMENT');
            return;
        }
        var file = inputEvent.srcElement.files[0];
        var newName = 'PICKUP_REPORT_' + file.name;
        var fileRenamed = this.commissionStore.getFile(file, newName);
        this.clearFileInput();
        if (fileRenamed.size > this.maxFileSize) {
            this.handleUploadError('MESSAGES.ERROR.ATTACHMENT_TOO_LARGE');
            return;
        }
        if (this.environment.paymentActionReport.acceptedFileTypes.indexOf(fileRenamed.type) < 0) {
            this.handleUploadError('MESSAGES.ERROR.ATTACHMENT_UNSUPPORTED_FILE_TYPE_PAYMENT_ACTIONS');
            return;
        }
        this.commissionStore.addAttachment(this.onyxEvent1.eventId, this.vendor.eventPartyId, fileRenamed, this.isMultiVendor())
            .catch(function (error) {
            _this.flashMessagesService.error('MESSAGES.ERROR.UPLOAD_ATTACHMENT', "Error uploading attachment: " + error);
            _this.isUploadInProgress = false;
            _this.isNewAttachment = false;
            return Observable["Observable"].throw(error);
        }).subscribe();
    };
    PickupReportAttachmentComponent.prototype.openFile = function (attachment) {
        var _this = this;
        this.commissionStore.getAttachment(attachment.uniqueId)
            .subscribe(function (response) {
        }, function (error) {
            _this.flashMessagesService.error('MESSAGES.ERROR.DOWNLOAD_ATTACHMENT', "Error retrieving attachments; " + error);
            return Observable["Observable"].throw(error);
        });
    };
    /**
     * Deletes attachment as well as triggers deletion animation.
     * @param attachment
     * @returns {Observable<R|T>}
     */
    PickupReportAttachmentComponent.prototype.deleteFile = function (attachment) {
        var _this = this;
        this.startDate = new Date();
        this.isDeleteInProgress = true;
        // This triggers the animation on the specific item.
        this.removedAttachments.add(attachment.uniqueId);
        this.commissionStore.deleteAttachment(this.onyxEvent1.eventId, this.vendor.eventPartyId, attachment.uniqueId, this.isMultiVendor())
            .subscribe(function (response) {
        }, function (error) {
            _this.flashMessagesService.error('MESSAGES.ERROR.UPLOAD_ATTACHMENT', "Error uploading attachment: " + error);
            _this.isUploadInProgress = false;
            _this.isNewAttachment = false;
            return Observable["Observable"].throw(error);
        });
    };
    PickupReportAttachmentComponent.prototype.confirmBeforeDelete = function (attachment) {
        this.attachmentToRemove = attachment;
        this.confirmationModal.open();
    };
    PickupReportAttachmentComponent.prototype.confirmHandler = function (value) {
        if (value) {
            this.deleteFile(this.attachmentToRemove);
        }
        this.attachmentToRemove = null;
    };
    PickupReportAttachmentComponent.prototype.getAnimationDelay = function (delayMillis, startDate) {
        var animationDelay = delayMillis - (new Date().valueOf() - startDate.valueOf());
        return animationDelay > 0 ? animationDelay : 0;
    };
    PickupReportAttachmentComponent.prototype.getFileExtension = function (filename) {
        if (!filename) {
            return '';
        }
        var filenameParts = filename.split('.');
        return filenameParts[filenameParts.length - 1];
    };
    PickupReportAttachmentComponent.prototype.handleUploadError = function (errorMessage, logMessage) {
        if (logMessage === void 0) { logMessage = null; }
        this.isUploadInProgress = false;
        this.flashMessagesService.error(errorMessage, logMessage);
    };
    /**
     * Returns true if the user has permissions to delete the attachment
     *
     * @param attachment the file to check
     * @returns `true` if both conditions are met; `false` otherwise
     */
    PickupReportAttachmentComponent.prototype.canDeleteFile = function (attachment) {
        if (this.authStore.hasPermissionCommission('DeleteFiles')) {
            return true;
        }
        if (this.authStore.isSupportUser()) {
            return true;
        }
        if (this.isMultiVendor() && this.authStore.matchUserType(attachment.creatorType)) {
            return true;
        }
        if (this.authStore.isPropertyUser() && attachment.eventPartyCreatorId === this.vendor.eventPartyId) {
            return true;
        }
        return false;
    };
    PickupReportAttachmentComponent.prototype.clearFileInput = function () {
        this.fileInput.nativeElement.value = null;
    };
    PickupReportAttachmentComponent.prototype.isMultiVendor = function () {
        return this.authStore.hasPermissionCommission('MultiVendor');
    };
    return PickupReportAttachmentComponent;
}());
pickup_report_attachment_component___decorate([
    Object(core_es5["HostBinding"])('class.margin-content'),
    pickup_report_attachment_component___metadata("design:type", Object)
], pickup_report_attachment_component_PickupReportAttachmentComponent.prototype, "true", void 0);
pickup_report_attachment_component___decorate([
    Object(core_es5["ViewChild"])('file'),
    pickup_report_attachment_component___metadata("design:type", typeof (pickup_report_attachment_component__a = typeof core_es5["ElementRef"] !== "undefined" && core_es5["ElementRef"]) === "function" && pickup_report_attachment_component__a || Object)
], pickup_report_attachment_component_PickupReportAttachmentComponent.prototype, "fileInput", void 0);
pickup_report_attachment_component___decorate([
    Object(core_es5["ViewChild"])(confirmation_modal_component_ConfirmationModalComponent),
    pickup_report_attachment_component___metadata("design:type", typeof (pickup_report_attachment_component__b = typeof confirmation_modal_component_ConfirmationModalComponent !== "undefined" && confirmation_modal_component_ConfirmationModalComponent) === "function" && pickup_report_attachment_component__b || Object)
], pickup_report_attachment_component_PickupReportAttachmentComponent.prototype, "confirmationModal", void 0);
pickup_report_attachment_component___decorate([
    Object(core_es5["Input"])(),
    pickup_report_attachment_component___metadata("design:type", typeof (pickup_report_attachment_component__c = typeof OnyxEvent !== "undefined" && OnyxEvent) === "function" && pickup_report_attachment_component__c || Object),
    pickup_report_attachment_component___metadata("design:paramtypes", [typeof (pickup_report_attachment_component__d = typeof OnyxEvent !== "undefined" && OnyxEvent) === "function" && pickup_report_attachment_component__d || Object])
], pickup_report_attachment_component_PickupReportAttachmentComponent.prototype, "event", null);
pickup_report_attachment_component___decorate([
    Object(core_es5["Input"])(),
    pickup_report_attachment_component___metadata("design:type", typeof (pickup_report_attachment_component__e = typeof Party !== "undefined" && Party) === "function" && pickup_report_attachment_component__e || Object)
], pickup_report_attachment_component_PickupReportAttachmentComponent.prototype, "vendor", void 0);
pickup_report_attachment_component___decorate([
    Object(core_es5["Output"])(),
    pickup_report_attachment_component___metadata("design:type", Object)
], pickup_report_attachment_component_PickupReportAttachmentComponent.prototype, "currentAttachment", void 0);
pickup_report_attachment_component_PickupReportAttachmentComponent = pickup_report_attachment_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-pickup-report-attachment',
        template: __webpack_require__("ooLA"),
        styles: [__webpack_require__("VsoP")]
    }),
    pickup_report_attachment_component___metadata("design:paramtypes", [typeof (pickup_report_attachment_component__f = typeof commission_store_CommissionStore !== "undefined" && commission_store_CommissionStore) === "function" && pickup_report_attachment_component__f || Object, typeof (pickup_report_attachment_component__g = typeof flash_messages_service_FlashMessagesService !== "undefined" && flash_messages_service_FlashMessagesService) === "function" && pickup_report_attachment_component__g || Object, typeof (pickup_report_attachment_component__h = typeof authentication_store_AuthenticationStore !== "undefined" && authentication_store_AuthenticationStore) === "function" && pickup_report_attachment_component__h || Object, typeof (pickup_report_attachment_component__j = typeof EnvironmentConfiguration !== "undefined" && EnvironmentConfiguration) === "function" && pickup_report_attachment_component__j || Object])
], pickup_report_attachment_component_PickupReportAttachmentComponent);

var pickup_report_attachment_component__a, pickup_report_attachment_component__b, pickup_report_attachment_component__c, pickup_report_attachment_component__d, pickup_report_attachment_component__e, pickup_report_attachment_component__f, pickup_report_attachment_component__g, pickup_report_attachment_component__h, pickup_report_attachment_component__j;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/pickup-report-attachment.component.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/pickup-report-attachment/pickup-report-attachment.resolver.ts
var pickup_report_attachment_resolver___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var pickup_report_attachment_resolver___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};



var PickupReportAttachmentResolver = (function () {
    function PickupReportAttachmentResolver(attachmentStore, translateService) {
        this.attachmentStore = attachmentStore;
        this.translateService = translateService;
    }
    PickupReportAttachmentResolver.prototype.resolve = function (route, state) {
        var id = route.params['id'];
        var eventPartyId = route.params['eventPartyId'];
        if (!id) {
            throw new Error(this.translateService.instant('MESSAGES.ERROR.GET_EVENT'));
        }
        if (eventPartyId) {
            return this.attachmentStore.getAttachmentsByParty(id, eventPartyId).first();
        }
        else {
            return this.attachmentStore.getAttachments(id).first();
        }
    };
    return PickupReportAttachmentResolver;
}());
PickupReportAttachmentResolver = pickup_report_attachment_resolver___decorate([
    Object(core_es5["Injectable"])(),
    pickup_report_attachment_resolver___metadata("design:paramtypes", [typeof (pickup_report_attachment_resolver__a = typeof attachment_store_AttachmentStore !== "undefined" && attachment_store_AttachmentStore) === "function" && pickup_report_attachment_resolver__a || Object, typeof (pickup_report_attachment_resolver__b = typeof core["c" /* TranslateService */] !== "undefined" && core["c" /* TranslateService */]) === "function" && pickup_report_attachment_resolver__b || Object])
], PickupReportAttachmentResolver);

var pickup_report_attachment_resolver__a, pickup_report_attachment_resolver__b;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/pickup-report-attachment.resolver.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/service/property/property.http.service.ts
var property_http_service___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var property_http_service___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};





var property_http_service_PropertyHttpService = (function () {
    function PropertyHttpService(http, environment, responseUtilService) {
        this.http = http;
        this.environment = environment;
        this.responseUtilService = responseUtilService;
        this.eventsGetUrl = this.environment.baseUrl + '/api/property';
        this.eventsAddUrl = this.environment.baseUrl + '/api/property';
    }
    Object.defineProperty(PropertyHttpService.prototype, "jsonOptions", {
        get: function () {
            var headers = new http_es5["Headers"]({ 'Content-Type': 'application/json' });
            var options = new http_es5["RequestOptions"]({ headers: headers });
            return options;
        },
        enumerable: true,
        configurable: true
    });
    PropertyHttpService.prototype.get = function (propertyId) {
        var _this = this;
        return this.http.get(this.eventsGetUrl + "/" + propertyId)
            .map(function (response) { return response.json(); })
            .catch(function (response) { return _this.responseUtilService.handleError(response); }).share();
    };
    PropertyHttpService.prototype.add = function (newRec) {
        var _this = this;
        return this.http.post(this.eventsAddUrl, JSON.stringify(newRec.toJS()), this.jsonOptions)
            .map(function (response) { return response.json(); })
            .catch(function (response) { return _this.responseUtilService.handleError(response); }).share();
    };
    return PropertyHttpService;
}());
property_http_service_PropertyHttpService = property_http_service___decorate([
    Object(core_es5["Injectable"])(),
    property_http_service___metadata("design:paramtypes", [typeof (property_http_service__a = typeof AppAuthHttpService !== "undefined" && AppAuthHttpService) === "function" && property_http_service__a || Object, typeof (property_http_service__b = typeof EnvironmentConfiguration !== "undefined" && EnvironmentConfiguration) === "function" && property_http_service__b || Object, typeof (property_http_service__c = typeof response_util_service_ResponseUtilService !== "undefined" && response_util_service_ResponseUtilService) === "function" && property_http_service__c || Object])
], property_http_service_PropertyHttpService);

var property_http_service__a, property_http_service__b, property_http_service__c;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/property.http.service.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/service/property/property.store.ts
var property_store___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var property_store___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};





var property_store_PropertyStore = (function () {
    function PropertyStore(propertyHttpService, flashMessagesService) {
        this.propertyHttpService = propertyHttpService;
        this.flashMessagesService = flashMessagesService;
        this.propertySubject = new BehaviorSubject["BehaviorSubject"](null);
    }
    Object.defineProperty(PropertyStore.prototype, "selectedProperty", {
        /**
         * Returns an observable containing the current property.
         * Used in any case when data needs to be shown on a screen.
         *
         * @returns {Observable<T>}
         */
        get: function () {
            return this.propertySubject.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Retrieves property.  This method returns an observable
     * and should be used only in route resolvers.
     *
     * @param propertyId
     * @returns {Observable<Property>}
     */
    PropertyStore.prototype.getProperty = function (propertyId) {
        var _this = this;
        return this.propertyHttpService.get(propertyId)
            .catch(function (error) {
            // Catch error here so resolver also displays error.
            _this.flashMessagesService.error('MESSAGES.ERROR.GET_PROPERTY', "Error retrieving property: " + error);
            return Observable["Observable"].throw(error);
        })
            .map(function (res) {
            _this.propertySubject.next(res);
            return res;
        });
    };
    /**
     * Add property. This method returns an observable
     * of the saved property.
     *
     * @param newRec property to store
     * @returns {Observable<Property>}
     */
    PropertyStore.prototype.addProperty = function (newRec) {
        var _this = this;
        return this.propertyHttpService.add(newRec)
            .catch(function (error) {
            _this.flashMessagesService.error('MESSAGES.ERROR.ADD_PROPERTY', "Error adding property: " + error);
            return Observable["Observable"].throw(error);
        })
            .map(function (res) {
            _this.flashMessagesService.success('MESSAGES.SUCCESS.ADD_PROPERTY');
            _this.propertySubject.next(res);
            return res;
        });
    };
    /**
     * Add vendor. This method returns an observable
     * of the saved vendor.
     *
     * @param newRec property to store
     * @returns {Observable<Property>}
     */
    PropertyStore.prototype.addVendor = function (newRec) {
        var _this = this;
        return this.propertyHttpService.add(newRec)
            .catch(function (error) {
            _this.flashMessagesService.error('MESSAGES.ERROR.ADD_VENDOR', "Error adding vendor: " + error);
            return Observable["Observable"].throw(error);
        })
            .map(function (res) {
            _this.flashMessagesService.success('MESSAGES.SUCCESS.ADD_VENDOR');
            _this.propertySubject.next(res);
            return res;
        });
    };
    return PropertyStore;
}());
property_store_PropertyStore = property_store___decorate([
    Object(core_es5["Injectable"])(),
    property_store___metadata("design:paramtypes", [typeof (property_store__a = typeof property_http_service_PropertyHttpService !== "undefined" && property_http_service_PropertyHttpService) === "function" && property_store__a || Object, typeof (property_store__b = typeof flash_messages_service_FlashMessagesService !== "undefined" && flash_messages_service_FlashMessagesService) === "function" && property_store__b || Object])
], property_store_PropertyStore);

var property_store__a, property_store__b;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/property.store.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/property.ts
var property___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var PropertyRecord = Object(immutable["Record"])({
    id: 0,
    chain: null,
    brand: null,
    pid: null,
    name: null,
    address1: null,
    address2: null,
    address3: null,
    city: null,
    stateProvinceCode: null,
    countryCode: null,
    postalCode: null,
    phoneNr: null,
    faxNr: null,
    email: null,
    contactFirstNm: null,
    contactLastNm: null,
    subscriber: null,
    manuallyAdded: null,
    payorType: null
});
var Property = (function (_super) {
    property___extends(Property, _super);
    function Property() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Property;
}(PropertyRecord));

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/property.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/property-add/property-add.component.ts
var property_add_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var property_add_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};







var property_add_component_PropertyAddComponent = (function () {
    function PropertyAddComponent(formBuilder, _commonDataStore, propertyStore) {
        this.formBuilder = formBuilder;
        this._commonDataStore = _commonDataStore;
        this.propertyStore = propertyStore;
        this.canceled = new core_es5["EventEmitter"]();
        this.accepted = new core_es5["EventEmitter"]();
        this.propertyFormControlsConfig = {
            name: ['', [forms_es5["Validators"].required, forms_es5["Validators"].maxLength(50)]],
            countryCode: [null, [forms_es5["Validators"].required]],
            address1: ['', [forms_es5["Validators"].required, forms_es5["Validators"].maxLength(50)]],
            address2: ['', [forms_es5["Validators"].maxLength(50)]],
            address3: ['', [forms_es5["Validators"].maxLength(50)]],
            city: ['', [forms_es5["Validators"].required, forms_es5["Validators"].maxLength(50)]],
            stateProvinceCode: [null, []],
            postalCode: ['', [forms_es5["Validators"].maxLength(15)]],
            contactFirstNm: ['', [forms_es5["Validators"].maxLength(50)]],
            contactLastNm: ['', [forms_es5["Validators"].maxLength(50)]],
            email: ['', [forms_es5["Validators"].required, forms_es5["Validators"].maxLength(75), pioneer_validators_PioneerValidators.isValidEmail]],
            phoneNr: ['', [forms_es5["Validators"].maxLength(20)]],
            faxNr: ['', [forms_es5["Validators"].maxLength(20)]]
        };
        this.propertyFormValidators = {
            validator: forms_es5["Validators"].compose([
                pioneer_validators_PioneerValidators.countryStateCrossValidator('countryCode', 'stateProvinceCode'),
                pioneer_validators_PioneerValidators.postalCodeCountryCrossValidator('postalCode', 'countryCode')
            ])
        };
    }
    Object.defineProperty(PropertyAddComponent.prototype, "commonDataStore", {
        get: function () {
            return this._commonDataStore;
        },
        enumerable: true,
        configurable: true
    });
    PropertyAddComponent.prototype.ngOnInit = function () {
        this.reset();
    };
    PropertyAddComponent.prototype.reset = function () {
        this.showState = false;
        this.showPostalCode = false;
        this.states$ = Observable["Observable"].of([]);
        if (!this.propertyForm) {
            this.createForm();
        }
        else {
            this.propertyForm.reset({
                name: '',
                countryCode: null,
                address1: '',
                address2: '',
                address3: '',
                city: '',
                stateProvinceCode: null,
                postalCode: '',
                contactFirstNm: '',
                contactLastNm: '',
                email: '',
                phoneNr: '',
                faxNr: ''
            });
        }
        this.propertyForm.enable();
    };
    PropertyAddComponent.prototype.cancel = function () {
        this.canceled.emit();
        this.reset();
    };
    PropertyAddComponent.prototype.accept = function () {
        var _this = this;
        this.propertyForm.disable();
        var propertyAddRequest = this.extractProperty();
        try {
            this.propertyStore.addProperty(propertyAddRequest).subscribe(function (savedProperty) {
                _this.accepted.emit(savedProperty);
                _this.reset();
            });
        }
        catch (error) {
            this.propertyForm.enable();
            Observable["Observable"].throw(error);
        }
    };
    PropertyAddComponent.prototype.onCountryCodeChanged = function () {
        var _this = this;
        this.propertyForm.get('stateProvinceCode').reset();
        this.propertyForm.get('postalCode').reset('');
        this.states$ = this.commonDataStore.loadStatesFromCountry(this.propertyForm.get('countryCode').value);
        this.states$.take(1).subscribe(function (states) {
            _this.showState = states.length > 0;
        });
        this.showPostalCode = pioneer_validators_PioneerValidators.isPostalCodeRequired(this.propertyForm, 'countryCode');
    };
    PropertyAddComponent.prototype.createForm = function () {
        this.propertyForm = this.formBuilder.group(this.propertyFormControlsConfig, this.propertyFormValidators);
    };
    PropertyAddComponent.prototype.extractProperty = function () {
        return new Property({
            id: null,
            chain: null,
            brand: null,
            pid: null,
            name: this.propertyForm.get('name').value,
            address1: this.propertyForm.get('address1').value,
            address2: this.propertyForm.get('address2').value,
            address3: this.propertyForm.get('address3').value,
            city: this.propertyForm.get('city').value,
            stateProvinceCode: this.propertyForm.get('stateProvinceCode').value,
            countryCode: this.propertyForm.get('countryCode').value,
            postalCode: this.propertyForm.get('postalCode').value,
            phoneNr: this.propertyForm.get('phoneNr').value,
            faxNr: this.propertyForm.get('faxNr').value,
            email: this.propertyForm.get('email').value,
            contactFirstNm: this.propertyForm.get('contactFirstNm').value,
            contactLastNm: this.propertyForm.get('contactLastNm').value
        });
    };
    return PropertyAddComponent;
}());
property_add_component___decorate([
    Object(core_es5["Output"])(),
    property_add_component___metadata("design:type", Object)
], property_add_component_PropertyAddComponent.prototype, "canceled", void 0);
property_add_component___decorate([
    Object(core_es5["Output"])(),
    property_add_component___metadata("design:type", Object)
], property_add_component_PropertyAddComponent.prototype, "accepted", void 0);
property_add_component_PropertyAddComponent = property_add_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-property-add',
        template: __webpack_require__("jeRC"),
        styles: [__webpack_require__("A8ep")]
    }),
    property_add_component___metadata("design:paramtypes", [typeof (property_add_component__a = typeof forms_es5["FormBuilder"] !== "undefined" && forms_es5["FormBuilder"]) === "function" && property_add_component__a || Object, typeof (property_add_component__b = typeof common_data_store_CommonDataStore !== "undefined" && common_data_store_CommonDataStore) === "function" && property_add_component__b || Object, typeof (property_add_component__c = typeof property_store_PropertyStore !== "undefined" && property_store_PropertyStore) === "function" && property_add_component__c || Object])
], property_add_component_PropertyAddComponent);

var property_add_component__a, property_add_component__b, property_add_component__c;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/property-add.component.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/vendor.ts
var vendor___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var VendorRecord = Object(immutable["Record"])({
    id: 0,
    chain: null,
    brand: null,
    pid: null,
    name: null,
    address1: null,
    address2: null,
    address3: null,
    city: null,
    stateProvinceCode: null,
    countryCode: null,
    postalCode: null,
    phoneNr: null,
    faxNr: null,
    email: null,
    contactFirstNm: null,
    contactLastNm: null,
    subscriber: null,
    manuallyAdded: null,
    payorType: null,
    commissionRoomPercentage: null,
    commRetention: false,
    masterBillPaid: false,
    taxResponseList: null
});
var Vendor = (function (_super) {
    vendor___extends(Vendor, _super);
    function Vendor() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Vendor;
}(VendorRecord));

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/vendor.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/TaxRequest.ts
var TaxRequest___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var TaxRequestRecord = Object(immutable["Record"])({
    supplyDate: null,
    buyer: null,
    supplier: null,
    billedTo: null
});
var TaxRequest = (function (_super) {
    TaxRequest___extends(TaxRequest, _super);
    function TaxRequest() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return TaxRequest;
}(TaxRequestRecord));

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/TaxRequest.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/TaxEntity.ts
var TaxEntity___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var TaxEntityRecord = Object(immutable["Record"])({
    countryCode: null,
    region: null,
    subRegion: null,
    postalCode: null,
    city: null
});
var TaxEntity = (function (_super) {
    TaxEntity___extends(TaxEntity, _super);
    function TaxEntity() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return TaxEntity;
}(TaxEntityRecord));

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/TaxEntity.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/utils/property-lookup-converter.ts






var property_lookup_converter_PropertyLookupConverter = (function () {
    function PropertyLookupConverter() {
    }
    PropertyLookupConverter.updateFormFields = function (detail, contactLookupForm, propertyLookupStore) {
        contactLookupForm.patchValue({
            name: detail.name,
            line1: detail.address.line1,
            line2: detail.address.line2,
            city: detail.address.city,
            state: detail.address.state,
            postalCode: detail.address.postalCode,
            propertyId: detail.propertyId,
            chain: detail.chain,
            brand: detail.brand,
            countryCode: detail.address.countryCode,
            manuallyAdded: detail.manuallyAdded
        });
        contactLookupForm.controls['contact'].patchValue({
            firstName: detail.contact.firstName,
            lastName: detail.contact.lastName,
            email: detail.contact.email,
            phone: detail.contact.phone,
            fax: detail.contact.fax
        });
        contactLookupForm.markAsDirty();
        contactLookupForm.controls['propertyNameSearch'].setValue('');
        propertyLookupStore.clearSearchResults();
    };
    /**
     * Convert a Property into Party
     *
     * @param property Property object
     * @param autoGeneratedCode boolean
     * @param manuallyAdded boolean
     * @returns {Party}
     */
    PropertyLookupConverter.propertyToParty = function (property, autoGeneratedCode) {
        return new Party({
            eventPartyId: null,
            version: null,
            createdDate: null,
            modifiedDate: null,
            chain: property.chain,
            brand: property.brand,
            propertyId: property.pid,
            agencyId: null,
            partyType: PartyType.PROPERTY,
            payorType: property.payorType,
            code: null,
            name: property.name,
            dbaName: null,
            countryCode: property.countryCode,
            eventId: null,
            line1: property.address1,
            line2: property.address2,
            line3: property.address3,
            city: property.city,
            state: property.stateProvinceCode,
            postalCode: property.postalCode,
            eventReferenceNumber: null,
            autoGeneratedCode: autoGeneratedCode,
            manuallyAdded: property.manuallyAdded,
            contact: {
                eventContactId: null,
                version: null,
                createdDate: null,
                modifiedDate: null,
                partyType: PartyType.PROPERTY,
                eventId: null,
                firstName: property.contactFirstNm,
                lastName: property.contactLastNm,
                email: property.email,
                phone: property.phoneNr,
                fax: property.faxNr
            },
            subscriber: property.subscriber
        });
    };
    PropertyLookupConverter.createTaxRequest = function (vendor, eventAgency) {
        var buyer = new TaxEntity({
            countryCode: vendor.countryCode,
            region: vendor.stateProvinceCode,
            subRegion: null,
            postalCode: null,
            city: vendor.city
        });
        var supplier = new TaxEntity({
            countryCode: eventAgency.countryCode,
            region: eventAgency.state,
            subRegion: null,
            postalCode: null,
            city: eventAgency.city
        });
        return new TaxRequest({
            supplyDate: null,
            buyer: buyer,
            supplier: supplier,
            billedTo: buyer
        });
    };
    PropertyLookupConverter.vendorToParty = function (vendor, autoGeneratedCode, taxResponseList) {
        return new Party({
            eventPartyId: null,
            version: null,
            createdDate: null,
            modifiedDate: null,
            chain: vendor.chain,
            brand: vendor.brand,
            propertyId: vendor.pid,
            agencyId: null,
            partyType: PartyType.PROPERTY,
            payorType: vendor.payorType,
            code: null,
            name: vendor.name,
            dbaName: null,
            countryCode: vendor.countryCode,
            eventId: null,
            line1: vendor.address1,
            line2: vendor.address2,
            line3: vendor.address3,
            city: vendor.city,
            state: vendor.stateProvinceCode,
            postalCode: vendor.postalCode,
            eventReferenceNumber: null,
            autoGeneratedCode: autoGeneratedCode,
            manuallyAdded: vendor.manuallyAdded,
            commissionRoomPercentage: vendor.commissionRoomPercentage,
            commRetention: vendor.commRetention,
            contact: {
                eventContactId: null,
                version: null,
                createdDate: null,
                modifiedDate: null,
                partyType: PartyType.PROPERTY,
                eventId: null,
                firstName: vendor.contactFirstNm,
                lastName: vendor.contactLastNm,
                email: vendor.email,
                phone: vendor.phoneNr,
                fax: vendor.faxNr
            },
            subscriber: vendor.subscriber,
            taxResponseList: taxResponseList
        });
    };
    PropertyLookupConverter.convertPropertyLookupDetailToProperty = function (propertyLookupDetail) {
        return new Property({
            chain: propertyLookupDetail.chain,
            brand: propertyLookupDetail.brand,
            pid: propertyLookupDetail.propertyId,
            name: propertyLookupDetail.name,
            address1: propertyLookupDetail.address ? propertyLookupDetail.address.line1 : null,
            address2: propertyLookupDetail.address ? propertyLookupDetail.address.line2 : null,
            address3: propertyLookupDetail.address ? propertyLookupDetail.address.line3 : null,
            city: propertyLookupDetail.address ? propertyLookupDetail.address.city : null,
            stateProvinceCode: propertyLookupDetail.address ? propertyLookupDetail.address.state : null,
            countryCode: propertyLookupDetail.address ? propertyLookupDetail.address.countryCode : null,
            postalCode: propertyLookupDetail.address ? propertyLookupDetail.address.postalCode : null,
            phoneNr: propertyLookupDetail.contact ? propertyLookupDetail.contact.phone : null,
            faxNr: propertyLookupDetail.contact ? propertyLookupDetail.contact.fax : null,
            email: propertyLookupDetail.contact ? propertyLookupDetail.contact.email : null,
            contactFirstNm: propertyLookupDetail.contact ? propertyLookupDetail.contact.firstName : null,
            contactLastNm: propertyLookupDetail.contact ? propertyLookupDetail.contact.lastName : null,
            subscriber: propertyLookupDetail.subscriber,
            manuallyAdded: propertyLookupDetail.manuallyAdded,
            payorType: propertyLookupDetail.payorType
        });
    };
    PropertyLookupConverter.propertyToVendor = function (property, vendor) {
        return new Vendor({
            id: property.id,
            chain: property.chain,
            brand: property.brand,
            pid: property.pid,
            name: property.name,
            address1: property.address1,
            address2: property.address2,
            address3: property.address3,
            city: property.city,
            stateProvinceCode: property.stateProvinceCode,
            countryCode: property.countryCode,
            postalCode: property.postalCode,
            phoneNr: property.phoneNr,
            faxNr: property.faxNr,
            email: property.email,
            contactFirstNm: property.contactFirstNm,
            contactLastNm: property.contactLastNm,
            subscriber: property.subscriber,
            manuallyAdded: property.manuallyAdded,
            payorType: property.payorType,
            commissionRoomPercentage: vendor.commissionRoomPercentage,
            commRetention: vendor.commRetention
        });
    };
    PropertyLookupConverter.vendorToProperty = function (vendor) {
        return new Property({
            id: vendor.id,
            chain: vendor.chain,
            brand: vendor.brand,
            pid: vendor.pid,
            name: vendor.name,
            address1: vendor.address1,
            address2: vendor.address2,
            address3: vendor.address3,
            city: vendor.city,
            stateProvinceCode: vendor.stateProvinceCode,
            countryCode: vendor.countryCode,
            postalCode: vendor.postalCode,
            phoneNr: vendor.phoneNr,
            faxNr: vendor.faxNr,
            email: vendor.email,
            contactFirstNm: vendor.contactFirstNm,
            contactLastNm: vendor.contactLastNm,
            subscriber: vendor.subscriber,
            manuallyAdded: vendor.manuallyAdded,
            payorType: vendor.payorType
        });
    };
    return PropertyLookupConverter;
}());

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/property-lookup-converter.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/models/property-search-request.ts
var property_search_request___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var PropertySearchRequestRecord = Object(immutable["Record"])({
    chain: null,
    brand: null,
    property: null,
    city: null,
    stateCode: null,
    countryCode: null,
    onlySubscribers: false
});
var PropertySearchRequest = (function (_super) {
    property_search_request___extends(PropertySearchRequest, _super);
    function PropertySearchRequest() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return PropertySearchRequest;
}(PropertySearchRequestRecord));

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/property-search-request.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/property-search/property-search.component.ts
var property_search_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var property_search_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};













var property_search_component_PropertySearchComponent = (function () {
    function PropertySearchComponent(formBuilder, propertyLookupStore, commonDataStore, chainBrandStore) {
        this.formBuilder = formBuilder;
        this.propertyLookupStore = propertyLookupStore;
        this.commonDataStore = commonDataStore;
        this.chainBrandStore = chainBrandStore;
        this.canceled = new core_es5["EventEmitter"]();
        this.selected = new core_es5["EventEmitter"]();
        this.goToAdd = new core_es5["EventEmitter"]();
        this.propertySearchFormControlsConfig = {
            chain: ['', []],
            brand: ['', []],
            property: ['', []],
            country: ['', []],
            state: ['', []],
            city: ['', []],
            onlySubscribers: [false, []]
        };
        this.propertySearchFormValidators = {
            validator: forms_es5["Validators"].compose([
                pioneer_validators_PioneerValidators.oneIsRequiredValidator('chain', 'brand', 'property', 'country', 'state', 'city')
            ])
        };
        this.list = [];
    }
    PropertySearchComponent.prototype.ngOnInit = function () {
        this.reset();
    };
    PropertySearchComponent.prototype.cancel = function () {
        this.canceled.emit();
    };
    PropertySearchComponent.prototype.selectProperty = function (selectedPropertyLookupSummary) {
        var _this = this;
        var obs$ = this.propertyLookupStore.getDetail(selectedPropertyLookupSummary)
            .pipe(Object(operators["tap"])(function (selectedPropertyLookupDetail) {
            _this.selected.emit(property_lookup_converter_PropertyLookupConverter.convertPropertyLookupDetailToProperty(selectedPropertyLookupDetail));
            _this.reset();
        }), Object(operators["catchError"])(function () {
            return Observable["Observable"].of(null);
        }));
        obs$.take(1).subscribe();
    };
    PropertySearchComponent.prototype.goToAddProperty = function () {
        this.goToAdd.emit();
    };
    PropertySearchComponent.prototype.search = function () {
        var _this = this;
        var propertySearchRequest = this.extractPropertySearchRequest();
        var obs$ = this.propertyLookupStore.advancedSearch(propertySearchRequest)
            .take(1)
            .pipe(Object(operators["catchError"])(function () {
            return Observable["Observable"].of(null);
        }));
        this.searchResults = obs$.map(function (page) {
            _this.totalItems = _this.propertyLookupStore.advancedSearchTotalElements;
            _this.size = _this.propertyLookupStore.advancedSearchSize;
            return page.content;
        });
    };
    PropertySearchComponent.prototype.chainSelected = function (chain) {
        if (this.brandDropdown) {
            this.brandDropdown.reset();
        }
        if (chain) {
            this.brands$ = this.chainBrandStore.loadBrandsFromChain(chain.key);
        }
        else {
            this.brands$ = Observable["Observable"].of([]);
        }
    };
    PropertySearchComponent.prototype.countrySelected = function (country) {
        if (this.stateDropdown) {
            this.stateDropdown.reset();
        }
        if (country) {
            this.states$ = this.commonDataStore.loadStatesFromCountry(country.key);
        }
        else {
            this.states$ = Observable["Observable"].of([]);
        }
    };
    PropertySearchComponent.prototype.reset = function () {
        this.chains$ = this.chainBrandStore.chains;
        this.brands$ = Observable["Observable"].of([]);
        this.states$ = Observable["Observable"].of([]);
        this.chainDropdown.reset();
        this.brandDropdown.reset();
        this.countryDropdown.reset();
        if (this.stateDropdown) {
            this.stateDropdown.reset();
        }
        this.searchResults = Observable["Observable"].of(Object(immutable["List"])([]));
        this.createForm();
        this.propertySearchForm.enable();
    };
    PropertySearchComponent.prototype.createForm = function () {
        this.propertySearchForm = this.formBuilder.group(this.propertySearchFormControlsConfig, this.propertySearchFormValidators);
    };
    PropertySearchComponent.prototype.extractPropertySearchRequest = function () {
        return new PropertySearchRequest({
            chain: pioneer_utils_PioneerUtils.trimToNull(this.propertySearchForm.get('chain').value),
            brand: pioneer_utils_PioneerUtils.trimToNull(this.propertySearchForm.get('brand').value),
            property: pioneer_utils_PioneerUtils.trimToNull(this.propertySearchForm.get('property').value),
            city: pioneer_utils_PioneerUtils.trimToNull(this.propertySearchForm.get('city').value),
            stateCode: pioneer_utils_PioneerUtils.trimToNull(this.propertySearchForm.get('state').value),
            countryCode: pioneer_utils_PioneerUtils.trimToNull(this.propertySearchForm.get('country').value),
            onlySubscribers: this.propertySearchForm.get('onlySubscribers').value
        });
    };
    return PropertySearchComponent;
}());
property_search_component___decorate([
    Object(core_es5["Output"])(),
    property_search_component___metadata("design:type", Object)
], property_search_component_PropertySearchComponent.prototype, "canceled", void 0);
property_search_component___decorate([
    Object(core_es5["Output"])(),
    property_search_component___metadata("design:type", Object)
], property_search_component_PropertySearchComponent.prototype, "selected", void 0);
property_search_component___decorate([
    Object(core_es5["Output"])(),
    property_search_component___metadata("design:type", Object)
], property_search_component_PropertySearchComponent.prototype, "goToAdd", void 0);
property_search_component___decorate([
    Object(core_es5["ViewChild"])('chainDropdown'),
    property_search_component___metadata("design:type", typeof (property_search_component__a = typeof dropdown_search_component_DropdownSearchComponent !== "undefined" && dropdown_search_component_DropdownSearchComponent) === "function" && property_search_component__a || Object)
], property_search_component_PropertySearchComponent.prototype, "chainDropdown", void 0);
property_search_component___decorate([
    Object(core_es5["ViewChild"])('brandDropdown'),
    property_search_component___metadata("design:type", typeof (property_search_component__b = typeof dropdown_search_component_DropdownSearchComponent !== "undefined" && dropdown_search_component_DropdownSearchComponent) === "function" && property_search_component__b || Object)
], property_search_component_PropertySearchComponent.prototype, "brandDropdown", void 0);
property_search_component___decorate([
    Object(core_es5["ViewChild"])('countryDropdown'),
    property_search_component___metadata("design:type", typeof (property_search_component__c = typeof dropdown_search_component_DropdownSearchComponent !== "undefined" && dropdown_search_component_DropdownSearchComponent) === "function" && property_search_component__c || Object)
], property_search_component_PropertySearchComponent.prototype, "countryDropdown", void 0);
property_search_component___decorate([
    Object(core_es5["ViewChild"])('stateDropdown'),
    property_search_component___metadata("design:type", typeof (property_search_component__d = typeof dropdown_search_component_DropdownSearchComponent !== "undefined" && dropdown_search_component_DropdownSearchComponent) === "function" && property_search_component__d || Object)
], property_search_component_PropertySearchComponent.prototype, "stateDropdown", void 0);
property_search_component_PropertySearchComponent = property_search_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-property-search',
        template: __webpack_require__("n6p7"),
        styles: [__webpack_require__("MKb2")]
    }),
    property_search_component___metadata("design:paramtypes", [typeof (property_search_component__e = typeof forms_es5["FormBuilder"] !== "undefined" && forms_es5["FormBuilder"]) === "function" && property_search_component__e || Object, typeof (property_search_component__f = typeof property_lookup_store_PropertyLookupStore !== "undefined" && property_lookup_store_PropertyLookupStore) === "function" && property_search_component__f || Object, typeof (property_search_component__g = typeof common_data_store_CommonDataStore !== "undefined" && common_data_store_CommonDataStore) === "function" && property_search_component__g || Object, typeof (property_search_component__h = typeof chain_brand_store_ChainBrandStore !== "undefined" && chain_brand_store_ChainBrandStore) === "function" && property_search_component__h || Object])
], property_search_component_PropertySearchComponent);

var property_search_component__a, property_search_component__b, property_search_component__c, property_search_component__d, property_search_component__e, property_search_component__f, property_search_component__g, property_search_component__h;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/property-search.component.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/property-popup/property-popup.component.ts
var property_popup_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var property_popup_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};





var property_popup_component_PropertyPopupComponent = (function () {
    function PropertyPopupComponent() {
        this.propertyPopupType = PopupType.SEARCH;
        this.PopupType = PopupType;
        this.config = {
            backdrop: 'static',
            keyboard: false
        };
        this.closed = new core_es5["EventEmitter"]();
    }
    PropertyPopupComponent.prototype.ngOnInit = function () {
    };
    PropertyPopupComponent.prototype.open = function () {
        this.propertyPopupType = PopupType.SEARCH;
        this.propertyModal.show();
    };
    PropertyPopupComponent.prototype.goToAdd = function () {
        this.propertyPopupType = PopupType.ADD;
    };
    PropertyPopupComponent.prototype.cancelSearch = function () {
        this.close(null);
    };
    PropertyPopupComponent.prototype.selectProperty = function (propertySelected) {
        if (this.propertyAdd) {
            this.propertyAdd.reset();
        }
        this.propertySearch.reset();
        this.close(propertySelected);
    };
    PropertyPopupComponent.prototype.acceptAdd = function (savedProperty) {
        if (this.propertyAdd) {
            this.propertyAdd.reset();
            savedProperty.manuallyAdded = true;
        }
        this.propertySearch.reset();
        this.close(savedProperty);
    };
    PropertyPopupComponent.prototype.cancelAdd = function () {
        this.propertyPopupType = PopupType.SEARCH;
    };
    PropertyPopupComponent.prototype.close = function (value) {
        this.closed.emit(value);
        this.propertyModal.hide();
    };
    return PropertyPopupComponent;
}());
property_popup_component___decorate([
    Object(core_es5["ViewChild"])(ngx_bootstrap["b" /* ModalDirective */]),
    property_popup_component___metadata("design:type", typeof (property_popup_component__a = typeof ngx_bootstrap["b" /* ModalDirective */] !== "undefined" && ngx_bootstrap["b" /* ModalDirective */]) === "function" && property_popup_component__a || Object)
], property_popup_component_PropertyPopupComponent.prototype, "propertyModal", void 0);
property_popup_component___decorate([
    Object(core_es5["ViewChild"])(property_search_component_PropertySearchComponent),
    property_popup_component___metadata("design:type", typeof (property_popup_component__b = typeof property_search_component_PropertySearchComponent !== "undefined" && property_search_component_PropertySearchComponent) === "function" && property_popup_component__b || Object)
], property_popup_component_PropertyPopupComponent.prototype, "propertySearch", void 0);
property_popup_component___decorate([
    Object(core_es5["ViewChild"])(property_add_component_PropertyAddComponent),
    property_popup_component___metadata("design:type", typeof (property_popup_component__c = typeof property_add_component_PropertyAddComponent !== "undefined" && property_add_component_PropertyAddComponent) === "function" && property_popup_component__c || Object)
], property_popup_component_PropertyPopupComponent.prototype, "propertyAdd", void 0);
property_popup_component___decorate([
    Object(core_es5["Output"])(),
    property_popup_component___metadata("design:type", Object)
], property_popup_component_PropertyPopupComponent.prototype, "closed", void 0);
property_popup_component_PropertyPopupComponent = property_popup_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-property-popup',
        template: __webpack_require__("+Ads")
    }),
    property_popup_component___metadata("design:paramtypes", [])
], property_popup_component_PropertyPopupComponent);

var property_popup_component__a, property_popup_component__b, property_popup_component__c;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/property-popup.component.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/property-lookup-form/property-lookup-form.component.ts
var property_lookup_form_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var property_lookup_form_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};















var property_lookup_form_component_PropertyLookupFormComponent = (function () {
    function PropertyLookupFormComponent(formBuilder, translateService, propertyLookupStore, logService, authenticationStore, eventValidationService) {
        this.formBuilder = formBuilder;
        this.translateService = translateService;
        this.propertyLookupStore = propertyLookupStore;
        this.logService = logService;
        this.authenticationStore = authenticationStore;
        this.eventValidationService = eventValidationService;
        this.partyType = PartyType.PROPERTY;
        this.isReadOnly = false;
        this.isNewEvent = false;
        this.outputEmail = new core_es5["EventEmitter"]();
        this.isPropertySelected = false;
        this.isContactEditable = true;
        this.showSubscriberBadge = false;
    }
    Object.defineProperty(PropertyLookupFormComponent.prototype, "event", {
        set: function (event) {
            this.onyxEvent = event;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PropertyLookupFormComponent.prototype, "propertyStore", {
        get: function () {
            return this.propertyLookupStore;
        },
        enumerable: true,
        configurable: true
    });
    PropertyLookupFormComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.checkError = false;
        this.contactFormFilled = false;
        if (!this.onyxEvent) {
            this.onyxEvent = new OnyxEvent();
        }
        this.authenticationStore.user.subscribe(function (user) {
            _this.user = user;
        });
        this.translateService.get('EVENT.CONTACT_PROPERTY').subscribe(function (text) { return _this.contactTypeTitle = text; });
        this.translateService.get('EVENT.CONTACT_PROPERTY_REF_CODE')
            .subscribe(function (text) { return _this.contactReferenceNumberTitle = text; });
        this.contactLookupForm = this.dataToFormGroup(this.onyxEvent.eventProperty);
        this.parentForm.setControl('eventProperty', this.contactLookupForm);
        // Load the user prop info in case of single hotel user
        if (this.isSingleProperty() && this.isNewEvent) {
            var propertyQuery = new PropertyLookupDetailQuery({
                chain: this.user.allChains[0],
                brand: this.user.allBrands[0],
                propertyId: this.user.allProperties[0],
            });
            this.onSelectedProperty(propertyQuery);
        }
        /*
         Wire up Property Name Search
         */
        this.propertyLookupStore.selected.subscribe(function (details) {
            _this.logService.verbose("property details " + JSON.stringify(details));
            property_lookup_converter_PropertyLookupConverter.updateFormFields(details, _this.contactLookupForm, _this.propertyLookupStore);
        });
        if (this.onyxEvent.eventProperty.eventPartyId) {
            this.isPropertySelected = true;
        }
        this.isContactEditable = this.authenticationStore.hasPermission('EditPropertyContact');
        this.showAdvancedPropertySearch = this.authenticationStore.hasPermission('ViewExtendedPropertySearch');
        this.isPropertyEditable$ = this.eventValidationService.canChangeProperty();
    };
    PropertyLookupFormComponent.prototype.ngOnChanges = function (changes) {
        if (!changes['event']) {
            return;
        }
        this.dataToFormGroup(this.onyxEvent.eventProperty);
    };
    PropertyLookupFormComponent.prototype.inlineSearchTouched = function () {
        var _this = this;
        // Check for an error if the user has never tried to select a property
        // A delay is required so that this logic is done after onSelectedProperty()
        setTimeout(function () {
            _this.checkError = !_this.contactFormFilled;
            if (!_this.lookupSelected) {
                _this.propertyLookupStore.clearSearchResults();
            }
            else {
                _this.lookupSelected = false;
            }
        }, 100);
    };
    PropertyLookupFormComponent.prototype.isPropertyMissing = function () {
        return this.checkError && this.contactLookupForm.hasError('propertyRequired');
    };
    PropertyLookupFormComponent.prototype.isReadyOnlyProperty = function () {
        return this.isSingleProperty();
    };
    PropertyLookupFormComponent.prototype.updateResults = function (results) {
        this.logService.verbose("results: " + results);
        this.summaryResults = results;
    };
    PropertyLookupFormComponent.prototype.onSelectedProperty = function (propertyQuery) {
        this.contactFormFilled = true;
        this.lookupSelected = true;
        this.isPropertySelected = true;
        this.logService.debug("propertySummary " + JSON.stringify(propertyQuery));
        this.propertyLookupStore.getDetail(propertyQuery).subscribe();
    };
    PropertyLookupFormComponent.prototype.dataToFormGroup = function (party) {
        if (!party) {
            party = new Party();
        }
        else {
            if (!party.contact) {
                party.contact = new Contact();
            }
            party = new Party(party);
        }
        if (!this.isNewEvent) {
            // onyxEvent chain/brand/propertyId is added to party if the event already existed
            party = party.merge({
                propertyId: party.propertyId,
                chain: party.chain,
                brand: party.brand
            });
        }
        var refCodeValidator = [party.eventReferenceNumber, forms_es5["Validators"].nullValidator];
        if (!this.contactLookupForm) {
            var emailValidator = !this.isReadOnly && this.authenticationStore.hasPermission('EditPropertyContact') ?
                [forms_es5["Validators"].required, forms_es5["Validators"].maxLength(75), pioneer_validators_PioneerValidators.isValidEmail] : forms_es5["Validators"].nullValidator;
            this.contactLookupForm = this.formBuilder.group({
                propertyNameSearch: '',
                agencyNameSearch: '',
                name: party.name,
                line1: party.line1,
                line2: party.line2,
                partyType: PartyType.PROPERTY,
                city: party.city,
                state: party.state,
                postalCode: party.postalCode,
                agencyId: party.agencyId,
                code: party.code,
                propertyId: party.propertyId,
                chain: party.chain,
                brand: party.brand,
                eventReferenceNumber: refCodeValidator,
                manuallyAdded: party.manuallyAdded,
                autoGeneratedCode: party.autoGeneratedCode,
                countryCode: party.countryCode,
                contact: this.formBuilder.group({
                    firstName: [party.contact.firstName],
                    lastName: [party.contact.lastName],
                    partyType: PartyType.PROPERTY,
                    email: [party.contact.email, emailValidator],
                    phone: [party.contact.phone],
                    fax: [party.contact.fax]
                })
            }, {
                validator: pioneer_validators_PioneerValidators.isPropertyError
            });
        }
        else {
            this.contactLookupForm.patchValue({
                propertyNameSearch: '',
                agencyNameSearch: '',
                name: party.name,
                line1: party.line1,
                line2: party.line2,
                partyType: PartyType.PROPERTY,
                city: party.city,
                state: party.state,
                postalCode: party.postalCode,
                agencyId: party.agencyId,
                code: party.code,
                propertyId: party.propertyId,
                chain: party.chain,
                brand: party.brand,
                eventReferenceNumber: party.eventReferenceNumber,
                manuallyAdded: party.manuallyAdded,
                autoGeneratedCode: party.autoGeneratedCode,
                countryCode: party.countryCode
            });
            this.contactLookupForm.controls['contact'].patchValue({
                firstName: party.contact.firstName,
                lastName: party.contact.lastName,
                partyType: PartyType.PROPERTY,
                email: party.contact.email,
                phone: party.contact.phone,
                fax: party.contact.fax
            });
            if (party.contact.email) {
                this.outputEmail.emit(party.contact.email);
            }
        }
        this.showSubscriberBadge = party.subscriber && this.authenticationStore.hasPermission('ViewGroupPayPropertyIndicators');
        return this.contactLookupForm;
    };
    PropertyLookupFormComponent.prototype.isSingleProperty = function () {
        return this.authenticationStore.isSinglePropertyUser();
    };
    PropertyLookupFormComponent.prototype.isPropertyInlineSearchEnabled = function () {
        return !this.isSingleProperty() && !this.isReadOnly;
    };
    Object.defineProperty(PropertyLookupFormComponent.prototype, "showLongLabels", {
        get: function () {
            return !this.onyxEvent.eventProperty.subscriber || (this.isNewEvent && this.authenticationStore.hasPermission('EditPropertyContact'));
        },
        enumerable: true,
        configurable: true
    });
    PropertyLookupFormComponent.prototype.openAddPropertyPopup = function (event) {
        event.preventDefault();
        this.propertyPopup.open();
    };
    PropertyLookupFormComponent.prototype.closedPropertyPopup = function (property) {
        if (property) {
            var eventProperty = property_lookup_converter_PropertyLookupConverter.propertyToParty(property, true);
            this.logService.info(JSON.stringify(eventProperty));
            this.contactLookupForm = this.dataToFormGroup(eventProperty);
            this.parentForm.setControl('eventProperty', this.contactLookupForm);
            this.contactFormFilled = true;
            this.isPropertySelected = true;
        }
    };
    PropertyLookupFormComponent.prototype.openAdvancedPropertySearchPopup = function () {
        this.propertyPopup.open();
    };
    PropertyLookupFormComponent.prototype.setupPropertyEmail = function (email) {
        this.outputEmail.emit(email);
    };
    return PropertyLookupFormComponent;
}());
property_lookup_form_component___decorate([
    Object(core_es5["Input"])('parentForm'),
    property_lookup_form_component___metadata("design:type", typeof (property_lookup_form_component__a = typeof forms_es5["FormGroup"] !== "undefined" && forms_es5["FormGroup"]) === "function" && property_lookup_form_component__a || Object)
], property_lookup_form_component_PropertyLookupFormComponent.prototype, "parentForm", void 0);
property_lookup_form_component___decorate([
    Object(core_es5["Input"])('event'),
    property_lookup_form_component___metadata("design:type", typeof (property_lookup_form_component__b = typeof OnyxEvent !== "undefined" && OnyxEvent) === "function" && property_lookup_form_component__b || Object),
    property_lookup_form_component___metadata("design:paramtypes", [typeof (property_lookup_form_component__c = typeof OnyxEvent !== "undefined" && OnyxEvent) === "function" && property_lookup_form_component__c || Object])
], property_lookup_form_component_PropertyLookupFormComponent.prototype, "event", null);
property_lookup_form_component___decorate([
    Object(core_es5["Input"])(),
    property_lookup_form_component___metadata("design:type", Object)
], property_lookup_form_component_PropertyLookupFormComponent.prototype, "isReadOnly", void 0);
property_lookup_form_component___decorate([
    Object(core_es5["Input"])(),
    property_lookup_form_component___metadata("design:type", Object)
], property_lookup_form_component_PropertyLookupFormComponent.prototype, "isNewEvent", void 0);
property_lookup_form_component___decorate([
    Object(core_es5["Input"])(),
    property_lookup_form_component___metadata("design:type", String)
], property_lookup_form_component_PropertyLookupFormComponent.prototype, "inputEmail", void 0);
property_lookup_form_component___decorate([
    Object(core_es5["Output"])(),
    property_lookup_form_component___metadata("design:type", typeof (property_lookup_form_component__d = typeof core_es5["EventEmitter"] !== "undefined" && core_es5["EventEmitter"]) === "function" && property_lookup_form_component__d || Object)
], property_lookup_form_component_PropertyLookupFormComponent.prototype, "outputEmail", void 0);
property_lookup_form_component___decorate([
    Object(core_es5["ViewChild"])(property_popup_component_PropertyPopupComponent),
    property_lookup_form_component___metadata("design:type", typeof (property_lookup_form_component__e = typeof property_popup_component_PropertyPopupComponent !== "undefined" && property_popup_component_PropertyPopupComponent) === "function" && property_lookup_form_component__e || Object)
], property_lookup_form_component_PropertyLookupFormComponent.prototype, "propertyPopup", void 0);
property_lookup_form_component_PropertyLookupFormComponent = property_lookup_form_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-property-lookup-form',
        template: __webpack_require__("pzHy"),
        styles: [__webpack_require__("RYae")]
    }),
    property_lookup_form_component___metadata("design:paramtypes", [typeof (property_lookup_form_component__f = typeof forms_es5["FormBuilder"] !== "undefined" && forms_es5["FormBuilder"]) === "function" && property_lookup_form_component__f || Object, typeof (property_lookup_form_component__g = typeof core["c" /* TranslateService */] !== "undefined" && core["c" /* TranslateService */]) === "function" && property_lookup_form_component__g || Object, typeof (property_lookup_form_component__h = typeof property_lookup_store_PropertyLookupStore !== "undefined" && property_lookup_store_PropertyLookupStore) === "function" && property_lookup_form_component__h || Object, typeof (property_lookup_form_component__j = typeof log_service_LogService !== "undefined" && log_service_LogService) === "function" && property_lookup_form_component__j || Object, typeof (property_lookup_form_component__k = typeof authentication_store_AuthenticationStore !== "undefined" && authentication_store_AuthenticationStore) === "function" && property_lookup_form_component__k || Object, typeof (property_lookup_form_component__l = typeof event_validation_service_EventValidationService !== "undefined" && event_validation_service_EventValidationService) === "function" && property_lookup_form_component__l || Object])
], property_lookup_form_component_PropertyLookupFormComponent);

var property_lookup_form_component__a, property_lookup_form_component__b, property_lookup_form_component__c, property_lookup_form_component__d, property_lookup_form_component__e, property_lookup_form_component__f, property_lookup_form_component__g, property_lookup_form_component__h, property_lookup_form_component__j, property_lookup_form_component__k, property_lookup_form_component__l;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/property-lookup-form.component.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/property-search-results/property-search-results.component.ts
var property_search_results_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var property_search_results_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};



var property_search_results_component_PropertySearchResultsComponent = (function () {
    function PropertySearchResultsComponent() {
        this.itemsPerPage = Constants.PROPERTY_SEARCH_ITEMS_PER_PAGE;
        this.selected = new core_es5["EventEmitter"]();
        this.goToAdd = new core_es5["EventEmitter"]();
        this.hasSearched = false;
    }
    PropertySearchResultsComponent.prototype.ngOnInit = function () {
    };
    PropertySearchResultsComponent.prototype.ngOnChanges = function (changes) {
        // Initialize currentPage for every search
        this.currentPage = 1;
        if (changes.searchResults && changes.searchResults.previousValue) {
            this.hasSearched = true;
        }
    };
    PropertySearchResultsComponent.prototype.selectProperty = function (property) {
        this.selected.emit(property);
    };
    PropertySearchResultsComponent.prototype.getFirstPageItemNumber = function () {
        return (this.currentPage - 1) * this.itemsPerPage;
    };
    PropertySearchResultsComponent.prototype.getLastPageItemNumber = function () {
        return (this.size < (this.currentPage * this.itemsPerPage)) ? this.size : (this.currentPage * this.itemsPerPage);
    };
    PropertySearchResultsComponent.prototype.getSize = function () {
        return this.size;
    };
    PropertySearchResultsComponent.prototype.maxResultsExceeded = function () {
        return this.size > Constants.PROPERTY_SEARCH_MAX_RESULTS;
    };
    PropertySearchResultsComponent.prototype.goToAddProperty = function () {
        this.goToAdd.emit();
    };
    return PropertySearchResultsComponent;
}());
property_search_results_component___decorate([
    Object(core_es5["Input"])(),
    property_search_results_component___metadata("design:type", typeof (property_search_results_component__a = typeof immutable["List"] !== "undefined" && immutable["List"]) === "function" && property_search_results_component__a || Object)
], property_search_results_component_PropertySearchResultsComponent.prototype, "searchResults", void 0);
property_search_results_component___decorate([
    Object(core_es5["Input"])(),
    property_search_results_component___metadata("design:type", Number)
], property_search_results_component_PropertySearchResultsComponent.prototype, "totalItems", void 0);
property_search_results_component___decorate([
    Object(core_es5["Input"])(),
    property_search_results_component___metadata("design:type", Number)
], property_search_results_component_PropertySearchResultsComponent.prototype, "size", void 0);
property_search_results_component___decorate([
    Object(core_es5["Output"])(),
    property_search_results_component___metadata("design:type", Object)
], property_search_results_component_PropertySearchResultsComponent.prototype, "selected", void 0);
property_search_results_component___decorate([
    Object(core_es5["Output"])(),
    property_search_results_component___metadata("design:type", Object)
], property_search_results_component_PropertySearchResultsComponent.prototype, "goToAdd", void 0);
property_search_results_component_PropertySearchResultsComponent = property_search_results_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-property-search-results',
        template: __webpack_require__("3XMG"),
        styles: [__webpack_require__("c+TZ")]
    }),
    property_search_results_component___metadata("design:paramtypes", [])
], property_search_results_component_PropertySearchResultsComponent);

var property_search_results_component__a;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/property-search-results.component.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/rate-plan-code/rate-plan-code/rate-plan-code.component.ts
var rate_plan_code_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var rate_plan_code_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};



var rate_plan_code_component_RatePlanCodeComponent = (function () {
    function RatePlanCodeComponent(translate) {
        this.translate = translate;
        this.delete = new core_es5["EventEmitter"]();
    }
    RatePlanCodeComponent.prototype.ngOnInit = function () {
    };
    RatePlanCodeComponent.prototype.removeRate = function (index) {
        this.delete.emit(index);
    };
    RatePlanCodeComponent.prototype.getTitleFromRpc = function (rpc) {
        return !rpc.closeable ? this.translate.instant('EVENT.RATE_PLAN_CODE_IN_USE') : undefined;
    };
    return RatePlanCodeComponent;
}());
rate_plan_code_component___decorate([
    Object(core_es5["Input"])(),
    rate_plan_code_component___metadata("design:type", Boolean)
], rate_plan_code_component_RatePlanCodeComponent.prototype, "showCloseIcon", void 0);
rate_plan_code_component___decorate([
    Object(core_es5["Input"])(),
    rate_plan_code_component___metadata("design:type", typeof (rate_plan_code_component__a = typeof DisplayedRatePlanCode !== "undefined" && DisplayedRatePlanCode) === "function" && rate_plan_code_component__a || Object)
], rate_plan_code_component_RatePlanCodeComponent.prototype, "ratePlanCodes", void 0);
rate_plan_code_component___decorate([
    Object(core_es5["Output"])(),
    rate_plan_code_component___metadata("design:type", Object)
], rate_plan_code_component_RatePlanCodeComponent.prototype, "delete", void 0);
rate_plan_code_component_RatePlanCodeComponent = rate_plan_code_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-rate-plan-code',
        template: __webpack_require__("S4zL"),
        styles: [__webpack_require__("M+FI")]
    }),
    rate_plan_code_component___metadata("design:paramtypes", [typeof (rate_plan_code_component__b = typeof core["c" /* TranslateService */] !== "undefined" && core["c" /* TranslateService */]) === "function" && rate_plan_code_component__b || Object])
], rate_plan_code_component_RatePlanCodeComponent);

var rate_plan_code_component__a, rate_plan_code_component__b;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/rate-plan-code.component.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/reservations/reservation-bulk/reservation-bulk.component.ts
var reservation_bulk_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var reservation_bulk_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};









var reservation_bulk_component_ReservationBulkComponent = (function () {
    function ReservationBulkComponent(flashMessagesService, environment, reservationStore, authenticationStore, errorHandlerService) {
        this.flashMessagesService = flashMessagesService;
        this.environment = environment;
        this.reservationStore = reservationStore;
        this.authenticationStore = authenticationStore;
        this.errorHandlerService = errorHandlerService;
        this.config = {
            backdrop: 'static',
            keyboard: false
        };
        this.closed = new core_es5["EventEmitter"]();
    }
    Object.defineProperty(ReservationBulkComponent.prototype, "event", {
        set: function (event) {
            this.onyxEvent = event;
        },
        enumerable: true,
        configurable: true
    });
    ReservationBulkComponent.prototype.ngOnInit = function () {
        this.isUploadInProgress = false;
        if (!this.onyxEvent) {
            throw new Error('The "event" attribute must be specified to use the ReservationBulk component');
        }
        this.fileExtensions = this.environment.reservations.acceptedFileExtensions;
        this.acceptedFileTypes = this.environment.reservations.acceptedFileTypes;
        this.templateUrl = this.environment.baseUrl
            + '/api/events/reservations/import/template?Authorization='
            + this.authenticationStore.getToken();
    };
    ReservationBulkComponent.prototype.open = function () {
        this.reservationBulkModal.show();
    };
    ReservationBulkComponent.prototype.close = function (value) {
        this.closed.emit(value);
        this.reservationBulkModal.hide();
    };
    ReservationBulkComponent.prototype.cancel = function () {
        this.close(false);
    };
    ReservationBulkComponent.prototype.importReservationFile = function (inputEvent) {
        var _this = this;
        this.isUploadInProgress = true;
        if (!inputEvent || !inputEvent.srcElement || !inputEvent.srcElement.files || inputEvent.srcElement.files.size === 0) {
            this.handleUploadError('MESSAGES.ERROR.UPLOAD_BULK_RESERVATION');
            return;
        }
        var file = inputEvent.srcElement.files[0];
        this.clearFileInput();
        if (this.acceptedFileTypes.indexOf(file.type) < 0) {
            this.handleUploadError('MESSAGES.ERROR.UPLOAD_BULK_RESERVATION');
            return;
        }
        var eventId = this.onyxEvent.eventId;
        var eventPartyId = this.onyxEvent.eventProperty.eventPartyId;
        this.reservationStore.importReservationFile(eventId, eventPartyId, file, this.isMultiVendor())
            .finally(function () {
            _this.isUploadInProgress = false;
        })
            .catch((function (error) {
            _this.handleUploadError(_this.errorHandlerService.getErrorMessageFromBackendError(error), "Error uploading reservations file: " + error);
            return Observable["Observable"].throw(error);
        }))
            .subscribe(function (response) {
            _this.flashMessagesService.success('MESSAGES.SUCCESS.UPLOAD_BULK_RESERVATION', false, false);
            _this.close(true);
        });
    };
    ReservationBulkComponent.prototype.handleUploadError = function (errorMessage, logMessage) {
        if (logMessage === void 0) { logMessage = null; }
        this.isUploadInProgress = false;
        this.flashMessagesService.error(errorMessage, logMessage);
    };
    /**
     * This needs to be called whenever we do an upload so that someone could do a second upload with a different file
     * without having to reload the page.
     */
    ReservationBulkComponent.prototype.clearFileInput = function () {
        this.fileInput.nativeElement.value = null;
    };
    ReservationBulkComponent.prototype.isMultiVendor = function () {
        return this.authenticationStore.hasPermission('MultiVendor');
    };
    return ReservationBulkComponent;
}());
reservation_bulk_component___decorate([
    Object(core_es5["ViewChild"])(ngx_bootstrap["b" /* ModalDirective */]),
    reservation_bulk_component___metadata("design:type", typeof (reservation_bulk_component__a = typeof ngx_bootstrap["b" /* ModalDirective */] !== "undefined" && ngx_bootstrap["b" /* ModalDirective */]) === "function" && reservation_bulk_component__a || Object)
], reservation_bulk_component_ReservationBulkComponent.prototype, "reservationBulkModal", void 0);
reservation_bulk_component___decorate([
    Object(core_es5["ViewChild"])('file'),
    reservation_bulk_component___metadata("design:type", typeof (reservation_bulk_component__b = typeof core_es5["ElementRef"] !== "undefined" && core_es5["ElementRef"]) === "function" && reservation_bulk_component__b || Object)
], reservation_bulk_component_ReservationBulkComponent.prototype, "fileInput", void 0);
reservation_bulk_component___decorate([
    Object(core_es5["Input"])('event'),
    reservation_bulk_component___metadata("design:type", typeof (reservation_bulk_component__c = typeof OnyxEvent !== "undefined" && OnyxEvent) === "function" && reservation_bulk_component__c || Object),
    reservation_bulk_component___metadata("design:paramtypes", [typeof (reservation_bulk_component__d = typeof OnyxEvent !== "undefined" && OnyxEvent) === "function" && reservation_bulk_component__d || Object])
], reservation_bulk_component_ReservationBulkComponent.prototype, "event", null);
reservation_bulk_component___decorate([
    Object(core_es5["Input"])(),
    reservation_bulk_component___metadata("design:type", Object)
], reservation_bulk_component_ReservationBulkComponent.prototype, "config", void 0);
reservation_bulk_component___decorate([
    Object(core_es5["Output"])(),
    reservation_bulk_component___metadata("design:type", Object)
], reservation_bulk_component_ReservationBulkComponent.prototype, "closed", void 0);
reservation_bulk_component_ReservationBulkComponent = reservation_bulk_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-reservation-bulk',
        template: __webpack_require__("UZA7")
    }),
    reservation_bulk_component___metadata("design:paramtypes", [typeof (reservation_bulk_component__e = typeof flash_messages_service_FlashMessagesService !== "undefined" && flash_messages_service_FlashMessagesService) === "function" && reservation_bulk_component__e || Object, typeof (reservation_bulk_component__f = typeof EnvironmentConfiguration !== "undefined" && EnvironmentConfiguration) === "function" && reservation_bulk_component__f || Object, typeof (reservation_bulk_component__g = typeof reservation_store_ReservationStore !== "undefined" && reservation_store_ReservationStore) === "function" && reservation_bulk_component__g || Object, typeof (reservation_bulk_component__h = typeof authentication_store_AuthenticationStore !== "undefined" && authentication_store_AuthenticationStore) === "function" && reservation_bulk_component__h || Object, typeof (reservation_bulk_component__j = typeof error_handler_service_ErrorHandlerService !== "undefined" && error_handler_service_ErrorHandlerService) === "function" && reservation_bulk_component__j || Object])
], reservation_bulk_component_ReservationBulkComponent);

var reservation_bulk_component__a, reservation_bulk_component__b, reservation_bulk_component__c, reservation_bulk_component__d, reservation_bulk_component__e, reservation_bulk_component__f, reservation_bulk_component__g, reservation_bulk_component__h, reservation_bulk_component__j;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/reservation-bulk.component.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/reservations/reservation-form/reservation-form.component.ts
var reservation_form_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var reservation_form_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
















var reservation_form_component_ReservationFormComponent = (function () {
    function ReservationFormComponent(formBuilder, translateService, reservationStore, reservationCompareStore, router, authenticationStore) {
        this.formBuilder = formBuilder;
        this.translateService = translateService;
        this.reservationStore = reservationStore;
        this.reservationCompareStore = reservationCompareStore;
        this.router = router;
        this.authenticationStore = authenticationStore;
        this.addRatePlanCodeOption = 'addRatePlanCode';
    }
    ReservationFormComponent.prototype.ngOnInit = function () {
        if (!this.event) {
            throw new Error('The "event" attribute must be specified to use the ReservationFormComponent component');
        }
        this.initForm(null);
        this.initStatusList();
    };
    ReservationFormComponent.prototype.initForm = function (reservation) {
        var _this = this;
        this.reservationForm = this.formBuilder.group({
            confirmation: [reservation ? reservation.confirmation : null, [forms_es5["Validators"].required, forms_es5["Validators"].maxLength(32)]],
            firstName: [reservation ? reservation.firstName : null, [forms_es5["Validators"].maxLength(50)]],
            lastName: [reservation ? reservation.lastName : null, [forms_es5["Validators"].required, forms_es5["Validators"].maxLength(50)]],
            checkInDate: [reservation ? reservation.checkInDate : null, [forms_es5["Validators"].required, pioneer_validators_PioneerValidators.isDate]],
            checkOutDate: [reservation ? reservation.checkOutDate : null, [forms_es5["Validators"].required, pioneer_validators_PioneerValidators.isDate]],
            status: [reservation ? reservation.status : null, [forms_es5["Validators"].required]],
            roomType: [reservation ? reservation.roomType : null, [forms_es5["Validators"].maxLength(6)]],
            roomRate: [reservation ? reservation.roomRate : null,
                [forms_es5["Validators"].required, pioneer_validators_PioneerValidators.isValidAmountInRange(0.01, 99999999.99)]],
            ratePlanCode: [reservation ? reservation.ratePlanCode : null, [forms_es5["Validators"].required]]
        }, {
            validator: pioneer_validators_PioneerValidators.isEndDateAfterStartDateCrossValidator('checkInDate', 'checkOutDate')
        });
        this.ratePlanCode.valueChanges.subscribe(function (value) {
            if (value === _this.addRatePlanCodeOption) {
                _this.openAddRatePlanCodeModal();
            }
        });
    };
    ReservationFormComponent.prototype.init = function (reservation) {
        this.initForm(reservation);
        this.currentReservation = reservation;
    };
    ReservationFormComponent.prototype.initStatusList = function () {
        var _this = this;
        var i18nKey = 'RESERVATION_STATUS.';
        this.translateService.get([
            i18nKey + 'RESERVED',
            i18nKey + 'CHECKED_IN',
            i18nKey + 'CHECKED_OUT',
            i18nKey + 'CANCELLED',
            i18nKey + 'NO_SHOW'
        ]).subscribe(function (i18nTexts) {
            _this.statusList = [
                { key: ReservationStatusCode.RESERVED, value: i18nTexts[i18nKey + 'RESERVED'] },
                { key: ReservationStatusCode.CHECKED_IN, value: i18nTexts[i18nKey + 'CHECKED_IN'] },
                { key: ReservationStatusCode.CHECKED_OUT, value: i18nTexts[i18nKey + 'CHECKED_OUT'] },
                { key: ReservationStatusCode.CANCELLED, value: i18nTexts[i18nKey + 'CANCELLED'] },
                { key: ReservationStatusCode.NO_SHOW, value: i18nTexts[i18nKey + 'NO_SHOW'] }
            ];
        });
    };
    Object.defineProperty(ReservationFormComponent.prototype, "checkInDate", {
        get: function () { return this.parseDate(this.reservationForm.get('checkInDate').value); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ReservationFormComponent.prototype, "checkOutDate", {
        get: function () { return this.parseDate(this.reservationForm.get('checkOutDate').value); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ReservationFormComponent.prototype, "ratePlanCode", {
        get: function () { return this.reservationForm.get('ratePlanCode'); },
        enumerable: true,
        configurable: true
    });
    ReservationFormComponent.prototype.parseDate = function (value) {
        if (Object(util_util["isNullOrUndefined"])(value) || value.trim().length === 0) {
            return null;
        }
        return new Date(value);
    };
    Object.defineProperty(ReservationFormComponent.prototype, "nights", {
        get: function () {
            if (!Object(util_util["isDate"])(this.checkInDate) || !Object(util_util["isDate"])(this.checkOutDate)) {
                return 0;
            }
            if (this.checkInDate >= this.checkOutDate) {
                return 0;
            }
            return date_util_DateUtil.differenceInCalendarDays(this.checkOutDate, this.checkInDate);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ReservationFormComponent.prototype, "roomRate", {
        get: function () {
            var value = this.reservationForm.get('roomRate').value;
            if (Object(util_util["isNullOrUndefined"])(value)) {
                return null;
            }
            return value;
        },
        enumerable: true,
        configurable: true
    });
    ReservationFormComponent.prototype.resetForm = function () {
        this.reservationForm.reset({
            confirmation: { value: null, disabled: false },
            firstName: { value: null, disabled: false },
            lastName: { value: null, disabled: false },
            checkInDate: { value: null, disabled: false },
            checkOutDate: { value: null, disabled: false },
            status: { value: null, disabled: false },
            roomType: { value: null, disabled: false },
            roomRate: { value: null, disabled: false },
        });
    };
    ReservationFormComponent.prototype.addReservation = function (source) {
        var _this = this;
        this.reservationForm.disable();
        var reservation = this.createOrUpdateReservation(null);
        var obs = new Observable["Observable"](function (observer) {
            _this.reservationStore.addReservation(reservation, source, _this.isMultiVendor())
                .finally(function () {
                _this.reservationForm.enable();
            })
                .catch(function (error) {
                observer.error();
                return Observable["Observable"].throw(error);
            })
                .subscribe(function () {
                // Refresh reservations or RSVPs depending on the source
                switch (source) {
                    case EventReservationSource.MANUAL:
                        if (_this.isMultiVendor()) {
                            _this.reservationCompareStore.refreshCurrentReservationList(_this.event.eventId);
                        }
                        else {
                            _this.reservationCompareStore.refreshCurrentReservationListByParty(_this.event.eventId, _this.event.eventProperty.eventPartyId);
                        }
                        break;
                    case EventReservationSource.RSVP:
                        if (_this.isMultiVendor()) {
                            _this.reservationCompareStore.refreshCurrentRsvpList(_this.event.eventId);
                        }
                        else {
                            _this.reservationCompareStore.refreshCurrentRsvpListByParty(_this.event.eventId, _this.event.eventProperty.eventPartyId);
                        }
                        break;
                    default:
                        break;
                }
                _this.resetForm();
                observer.next();
            });
        });
        return obs;
    };
    ReservationFormComponent.prototype.cancelAddReservation = function () {
        this.resetForm();
    };
    ReservationFormComponent.prototype.updateReservation = function (eventReservationId) {
        var _this = this;
        this.reservationForm.disable();
        var reservation = this.createOrUpdateReservation(eventReservationId);
        var obs = new Observable["Observable"](function (observer) {
            _this.reservationStore.updateReservation(reservation, _this.isMultiVendor())
                .finally(function () {
                _this.reservationForm.enable();
            })
                .catch(function (error) {
                observer.error();
                return Observable["Observable"].throw(error);
            })
                .subscribe(function () {
                if (_this.isMultiVendor()) {
                    _this.reservationCompareStore.refreshCurrentReservationList(_this.event.eventId);
                }
                else {
                    _this.reservationCompareStore.refreshCurrentReservationListByParty(_this.event.eventId, _this.event.eventProperty.eventPartyId);
                }
                _this.resetForm();
                observer.next();
            });
        });
        return obs;
    };
    ReservationFormComponent.prototype.createOrUpdateReservation = function (eventReservationId) {
        return new Reservation({
            eventReservationId: eventReservationId,
            confirmation: this.reservationForm.get('confirmation').value,
            firstName: this.reservationForm.get('firstName').value,
            lastName: this.reservationForm.get('lastName').value,
            checkInDate: this.checkInDate,
            checkOutDate: this.checkOutDate,
            nights: this.nights,
            roomType: this.reservationForm.get('roomType').value,
            ratePlanCode: this.ratePlanCode.value,
            roomRate: this.roomRate,
            status: this.reservationForm.get('status').value,
            eventId: this.event.eventId,
            eventPartyId: this.event.eventProperty.eventPartyId
        });
    };
    ReservationFormComponent.prototype.openAddRatePlanCodeModal = function () {
        this.addRatePlanCodeModal.open();
        if (this.currentReservation && this.currentReservation.ratePlanCode) {
            this.ratePlanCode.setValue(this.currentReservation.ratePlanCode);
        }
        else {
            this.ratePlanCode.reset(null, { emitEvent: false });
        }
    };
    ReservationFormComponent.prototype.addRatePlanCodeModalHandler = function (addRatePlanCode) {
        if (addRatePlanCode) {
            this.router.navigate(['event/' + this.event.eventId + '/summary/edit']);
            if (this.isMultiVendor()) {
                this.router.navigate(['event/' + this.event.eventId + '/summary/edit']);
            }
            else {
                this.router.navigate(['event/' + this.event.eventId + '/' + this.event.eventProperty.eventPartyId + '/summary/edit']);
            }
        }
    };
    ReservationFormComponent.prototype.isMultiVendor = function () {
        return this.authenticationStore.hasPermission('MultiVendor');
    };
    return ReservationFormComponent;
}());
reservation_form_component___decorate([
    Object(core_es5["ViewChild"])(confirmation_modal_component_ConfirmationModalComponent),
    reservation_form_component___metadata("design:type", typeof (reservation_form_component__a = typeof confirmation_modal_component_ConfirmationModalComponent !== "undefined" && confirmation_modal_component_ConfirmationModalComponent) === "function" && reservation_form_component__a || Object)
], reservation_form_component_ReservationFormComponent.prototype, "addRatePlanCodeModal", void 0);
reservation_form_component___decorate([
    Object(core_es5["Input"])(),
    reservation_form_component___metadata("design:type", typeof (reservation_form_component__b = typeof OnyxEvent !== "undefined" && OnyxEvent) === "function" && reservation_form_component__b || Object)
], reservation_form_component_ReservationFormComponent.prototype, "event", void 0);
reservation_form_component_ReservationFormComponent = reservation_form_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-reservation-form',
        template: __webpack_require__("eEAD"),
        styles: [__webpack_require__("/Ynw")]
    }),
    reservation_form_component___metadata("design:paramtypes", [typeof (reservation_form_component__c = typeof forms_es5["FormBuilder"] !== "undefined" && forms_es5["FormBuilder"]) === "function" && reservation_form_component__c || Object, typeof (reservation_form_component__d = typeof core["c" /* TranslateService */] !== "undefined" && core["c" /* TranslateService */]) === "function" && reservation_form_component__d || Object, typeof (reservation_form_component__e = typeof reservation_store_ReservationStore !== "undefined" && reservation_store_ReservationStore) === "function" && reservation_form_component__e || Object, typeof (reservation_form_component__f = typeof reservation_compare_store_ReservationCompareStore !== "undefined" && reservation_compare_store_ReservationCompareStore) === "function" && reservation_form_component__f || Object, typeof (reservation_form_component__g = typeof router_es5["Router"] !== "undefined" && router_es5["Router"]) === "function" && reservation_form_component__g || Object, typeof (reservation_form_component__h = typeof authentication_store_AuthenticationStore !== "undefined" && authentication_store_AuthenticationStore) === "function" && reservation_form_component__h || Object])
], reservation_form_component_ReservationFormComponent);

var reservation_form_component__a, reservation_form_component__b, reservation_form_component__c, reservation_form_component__d, reservation_form_component__e, reservation_form_component__f, reservation_form_component__g, reservation_form_component__h;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/reservation-form.component.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/reservations/reservation-button-bar/reservation-button-bar.component.ts
var reservation_button_bar_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var reservation_button_bar_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};















var reservation_button_bar_component_ReservationButtonBarComponent = (function () {
    function ReservationButtonBarComponent(reservationCompareStore, reportService, router, authenticationStore, eventValidationService) {
        this.reservationCompareStore = reservationCompareStore;
        this.reportService = reportService;
        this.router = router;
        this.authenticationStore = authenticationStore;
        this.eventValidationService = eventValidationService;
        this.subscription = new Subscription["Subscription"]();
    }
    Object.defineProperty(ReservationButtonBarComponent.prototype, "event", {
        set: function (event) {
            this.onyxEvent = event;
        },
        enumerable: true,
        configurable: true
    });
    ReservationButtonBarComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (!this.onyxEvent) {
            throw new Error('The "event" attribute must be specified to use the ReservationButtonBarComponent component');
        }
        this.isAddFormCollapsed = true;
        this.subscription.add(this.reservationCompareStore.getShowReservationCompareSummary().subscribe(function (value) {
            _this.isSummarySelected = value;
        }));
        this.canChangeReservations$ = this.eventValidationService.canChangeReservations();
    };
    ReservationButtonBarComponent.prototype.ngOnDestroy = function () {
        this.subscription.unsubscribe();
    };
    ReservationButtonBarComponent.prototype.addReservation = function () {
        var _this = this;
        var obs = this.reservationComponent.addReservation(EventReservationSource.MANUAL)
            .catch(function (error) {
            _this.isAddFormCollapsed = false;
            return error;
        });
        obs.subscribe(function () {
            _this.isAddFormCollapsed = true;
        });
        return obs;
    };
    ReservationButtonBarComponent.prototype.cancelAddReservation = function () {
        this.reservationComponent.cancelAddReservation();
        this.isAddFormCollapsed = true;
    };
    ReservationButtonBarComponent.prototype.disableSave = function () {
        var disable;
        if (this.reservationComponent && this.reservationComponent.reservationForm) {
            disable = !this.reservationComponent.reservationForm.valid;
        }
        else {
            disable = true;
        }
        return disable;
    };
    ReservationButtonBarComponent.prototype.openUploadBulkReservation = function () {
        this.reservationBulk.open();
    };
    Object.defineProperty(ReservationButtonBarComponent.prototype, "canManageReservations", {
        get: function () {
            return this.onyxEvent.canManageReservations;
        },
        enumerable: true,
        configurable: true
    });
    ReservationButtonBarComponent.prototype.getSummaryReport = function (fileType) {
        var _this = this;
        this.reportService.getReservationsReport(this.onyxEvent.eventId, this.vendor.eventPartyId, this.summarySelected, fileType)
            .subscribe(function (blob) {
            var filename = response_util_ResponseUtil.getFileNameFromHttpResponse(blob);
            if (!filename) {
                var reportType = _this.summarySelected ? ReportType.RESERVATION_SUMMARY : ReportType.RESERVATION_COMPARE;
                filename = _this.reportService.buildReportFileName(reportType, _this.onyxEvent, fileType);
            }
            saveAs(blob.body, filename);
        });
    };
    ReservationButtonBarComponent.prototype.checkRatePlans = function (event) {
        event.preventDefault();
        if (this.onyxEvent.eventProperty.ratePlanCodes && Array.isArray(this.onyxEvent.eventProperty.ratePlanCodes)
            && this.onyxEvent.eventProperty.ratePlanCodes.length) {
            this.isAddFormCollapsed = !this.isAddFormCollapsed;
        }
        else {
            this.noRatePlanCodeModal.open();
        }
    };
    ReservationButtonBarComponent.prototype.noRatePlanCodeModalHandler = function (addRatePlanCode) {
        if (addRatePlanCode) {
            if (this.isMultiVendor()) {
                this.router.navigate(['event/' + this.onyxEvent.eventId + '/summary/edit']);
            }
            else {
                this.router.navigate(['event/' + this.onyxEvent.eventId + '/' + this.onyxEvent.eventProperty.eventPartyId + '/summary/edit']);
            }
        }
    };
    ReservationButtonBarComponent.prototype.isMultiVendor = function () {
        return this.authenticationStore.hasPermission('MultiVendor');
    };
    return ReservationButtonBarComponent;
}());
reservation_button_bar_component___decorate([
    Object(core_es5["ViewChild"])(reservation_bulk_component_ReservationBulkComponent),
    reservation_button_bar_component___metadata("design:type", typeof (reservation_button_bar_component__a = typeof reservation_bulk_component_ReservationBulkComponent !== "undefined" && reservation_bulk_component_ReservationBulkComponent) === "function" && reservation_button_bar_component__a || Object)
], reservation_button_bar_component_ReservationButtonBarComponent.prototype, "reservationBulk", void 0);
reservation_button_bar_component___decorate([
    Object(core_es5["ViewChild"])(reservation_form_component_ReservationFormComponent),
    reservation_button_bar_component___metadata("design:type", typeof (reservation_button_bar_component__b = typeof reservation_form_component_ReservationFormComponent !== "undefined" && reservation_form_component_ReservationFormComponent) === "function" && reservation_button_bar_component__b || Object)
], reservation_button_bar_component_ReservationButtonBarComponent.prototype, "reservationComponent", void 0);
reservation_button_bar_component___decorate([
    Object(core_es5["ViewChild"])(confirmation_modal_component_ConfirmationModalComponent),
    reservation_button_bar_component___metadata("design:type", typeof (reservation_button_bar_component__c = typeof confirmation_modal_component_ConfirmationModalComponent !== "undefined" && confirmation_modal_component_ConfirmationModalComponent) === "function" && reservation_button_bar_component__c || Object)
], reservation_button_bar_component_ReservationButtonBarComponent.prototype, "noRatePlanCodeModal", void 0);
reservation_button_bar_component___decorate([
    Object(core_es5["Input"])('event'),
    reservation_button_bar_component___metadata("design:type", typeof (reservation_button_bar_component__d = typeof OnyxEvent !== "undefined" && OnyxEvent) === "function" && reservation_button_bar_component__d || Object),
    reservation_button_bar_component___metadata("design:paramtypes", [typeof (reservation_button_bar_component__e = typeof OnyxEvent !== "undefined" && OnyxEvent) === "function" && reservation_button_bar_component__e || Object])
], reservation_button_bar_component_ReservationButtonBarComponent.prototype, "event", null);
reservation_button_bar_component___decorate([
    Object(core_es5["Input"])(),
    reservation_button_bar_component___metadata("design:type", typeof (reservation_button_bar_component__f = typeof Party !== "undefined" && Party) === "function" && reservation_button_bar_component__f || Object)
], reservation_button_bar_component_ReservationButtonBarComponent.prototype, "vendor", void 0);
reservation_button_bar_component___decorate([
    Object(core_es5["Input"])(),
    reservation_button_bar_component___metadata("design:type", Boolean)
], reservation_button_bar_component_ReservationButtonBarComponent.prototype, "showDownloadDropdown", void 0);
reservation_button_bar_component___decorate([
    Object(core_es5["Input"])(),
    reservation_button_bar_component___metadata("design:type", Boolean)
], reservation_button_bar_component_ReservationButtonBarComponent.prototype, "summarySelected", void 0);
reservation_button_bar_component_ReservationButtonBarComponent = reservation_button_bar_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-reservation-button-bar',
        template: __webpack_require__("An3F"),
        styles: [__webpack_require__("57PB")]
    }),
    reservation_button_bar_component___metadata("design:paramtypes", [typeof (reservation_button_bar_component__g = typeof reservation_compare_store_ReservationCompareStore !== "undefined" && reservation_compare_store_ReservationCompareStore) === "function" && reservation_button_bar_component__g || Object, typeof (reservation_button_bar_component__h = typeof report_service_ReportService !== "undefined" && report_service_ReportService) === "function" && reservation_button_bar_component__h || Object, typeof (reservation_button_bar_component__j = typeof router_es5["Router"] !== "undefined" && router_es5["Router"]) === "function" && reservation_button_bar_component__j || Object, typeof (reservation_button_bar_component__k = typeof authentication_store_AuthenticationStore !== "undefined" && authentication_store_AuthenticationStore) === "function" && reservation_button_bar_component__k || Object, typeof (reservation_button_bar_component__l = typeof event_validation_service_EventValidationService !== "undefined" && event_validation_service_EventValidationService) === "function" && reservation_button_bar_component__l || Object])
], reservation_button_bar_component_ReservationButtonBarComponent);

var reservation_button_bar_component__a, reservation_button_bar_component__b, reservation_button_bar_component__c, reservation_button_bar_component__d, reservation_button_bar_component__e, reservation_button_bar_component__f, reservation_button_bar_component__g, reservation_button_bar_component__h, reservation_button_bar_component__j, reservation_button_bar_component__k, reservation_button_bar_component__l;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/reservation-button-bar.component.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/event-reservation-action.ts
var EventReservationAction = (function () {
    function EventReservationAction() {
    }
    return EventReservationAction;
}());

/**
 * Edit an existing reservation
 *
 * @type {string}
 */
EventReservationAction.EDIT_RESERVATION = 'EDIT_RESERVATION';
/**
 * Create a reservation for a RSVP
 *
 * @type {string}
 */
EventReservationAction.RSVP_CONFIRMATION = 'RSVP_CONFIRMATION';
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/event-reservation-action.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/reservations/reservation-modal/reservation-modal.component.ts
var reservation_modal_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var reservation_modal_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};








var reservation_modal_component_ReservationModalComponent = (function () {
    function ReservationModalComponent(translateService) {
        this.translateService = translateService;
        this.config = {
            backdrop: 'static',
            keyboard: false
        };
        this.closed = new core_es5["EventEmitter"]();
    }
    ReservationModalComponent.prototype.ngOnInit = function () {
    };
    ReservationModalComponent.prototype.open = function (reservation) {
        if (!this.event) {
            throw new Error('The "event" attribute must be specified to use the ReservationModalComponent component');
        }
        if (!reservation) {
            throw new Error('The "reservation" parameter must be specified to use the ReservationModalComponent component');
        }
        if (!this.action) {
            throw new Error('The "action" attribute must be specified to use the ReservationModalComponent component');
        }
        switch (this.action) {
            case EventReservationAction.EDIT_RESERVATION:
                this.title = this.translateService.instant('EVENT.EDIT_RESERVATION_MODAL.TITLE');
                break;
            case EventReservationAction.RSVP_CONFIRMATION:
                this.title = this.translateService.instant('EVENT.CONFIRM_RESERVATION_MODAL.TITLE');
                this.placeholder = this.translateService.instant('EVENT.CONFIRM_RESERVATION_MODAL.SMALL_TEXT');
                break;
            default:
                throw new Error('The "action" attribute must be specified to use the ReservationModalComponent component');
        }
        this.reservation = reservation;
        this.reservationFormComponent.init(reservation);
        this.reservationModal.show();
    };
    ReservationModalComponent.prototype.close = function (value) {
        this.closed.emit(value);
        this.reservationModal.hide();
    };
    ReservationModalComponent.prototype.cancel = function () {
        this.reservationFormComponent.cancelAddReservation();
        this.close(false);
    };
    ReservationModalComponent.prototype.accept = function () {
        var _this = this;
        var obs = new Observable["Observable"]();
        switch (this.action) {
            case EventReservationAction.EDIT_RESERVATION:
                obs = this.reservationFormComponent.updateReservation(this.reservation.eventReservationId);
                break;
            case EventReservationAction.RSVP_CONFIRMATION:
                obs = this.reservationFormComponent.addReservation(EventReservationSource.RSVP);
                break;
            default:
                throw new Error('The "action" attribute must be specified to use the ReservationModalComponent component');
        }
        obs.subscribe(function () {
            _this.close(true);
        });
        return obs;
    };
    ReservationModalComponent.prototype.disableSave = function () {
        var disable;
        if (this.reservationFormComponent && this.reservationFormComponent.reservationForm) {
            disable = !this.reservationFormComponent.reservationForm.valid;
        }
        else {
            disable = true;
        }
        return disable;
    };
    return ReservationModalComponent;
}());
reservation_modal_component___decorate([
    Object(core_es5["ViewChild"])(modal["b" /* ModalDirective */]),
    reservation_modal_component___metadata("design:type", typeof (reservation_modal_component__a = typeof modal["b" /* ModalDirective */] !== "undefined" && modal["b" /* ModalDirective */]) === "function" && reservation_modal_component__a || Object)
], reservation_modal_component_ReservationModalComponent.prototype, "reservationModal", void 0);
reservation_modal_component___decorate([
    Object(core_es5["ViewChild"])(reservation_form_component_ReservationFormComponent),
    reservation_modal_component___metadata("design:type", typeof (reservation_modal_component__b = typeof reservation_form_component_ReservationFormComponent !== "undefined" && reservation_form_component_ReservationFormComponent) === "function" && reservation_modal_component__b || Object)
], reservation_modal_component_ReservationModalComponent.prototype, "reservationFormComponent", void 0);
reservation_modal_component___decorate([
    Object(core_es5["Input"])(),
    reservation_modal_component___metadata("design:type", Object)
], reservation_modal_component_ReservationModalComponent.prototype, "config", void 0);
reservation_modal_component___decorate([
    Object(core_es5["Input"])(),
    reservation_modal_component___metadata("design:type", typeof (reservation_modal_component__c = typeof OnyxEvent !== "undefined" && OnyxEvent) === "function" && reservation_modal_component__c || Object)
], reservation_modal_component_ReservationModalComponent.prototype, "event", void 0);
reservation_modal_component___decorate([
    Object(core_es5["Input"])(),
    reservation_modal_component___metadata("design:type", typeof (reservation_modal_component__d = typeof EventReservationAction !== "undefined" && EventReservationAction) === "function" && reservation_modal_component__d || Object)
], reservation_modal_component_ReservationModalComponent.prototype, "action", void 0);
reservation_modal_component___decorate([
    Object(core_es5["Output"])(),
    reservation_modal_component___metadata("design:type", Object)
], reservation_modal_component_ReservationModalComponent.prototype, "closed", void 0);
reservation_modal_component_ReservationModalComponent = reservation_modal_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-reservation-modal',
        template: __webpack_require__("DZNf")
    }),
    reservation_modal_component___metadata("design:paramtypes", [typeof (reservation_modal_component__e = typeof core["c" /* TranslateService */] !== "undefined" && core["c" /* TranslateService */]) === "function" && reservation_modal_component__e || Object])
], reservation_modal_component_ReservationModalComponent);

var reservation_modal_component__a, reservation_modal_component__b, reservation_modal_component__c, reservation_modal_component__d, reservation_modal_component__e;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/reservation-modal.component.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/compare-table-abstract.ts
var compare_table_abstract___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var compare_table_abstract___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};








var compare_table_abstract_CompareTableAbstract = (function () {
    function CompareTableAbstract(pageScrollService, document, rsvpStore) {
        this.pageScrollService = pageScrollService;
        this.document = document;
        this.rsvpStore = rsvpStore;
        this.MatchTypeEnum = MatchTypeEnum;
    }
    Object.defineProperty(CompareTableAbstract.prototype, "event", {
        set: function (event) {
            this.onyxEvent = event;
        },
        enumerable: true,
        configurable: true
    });
    CompareTableAbstract.prototype.getStatusClass = function (compare) {
        if (compare.reservation) {
            switch (compare.reservation.status) {
                case 'R':
                    return 'res-status-reserved';
                case 'I':
                    return 'res-status-checked-in';
                case 'O':
                    return 'res-status-checked-out';
                case 'C':
                    return 'res-status-cancelled';
                case 'N':
                    return 'res-status-no-show';
                default:
                    return '';
            }
        }
        return '';
    };
    CompareTableAbstract.prototype.isCommissionUp = function (compare) {
        return compare.rsvp && compare.delta && compare.delta.commission > 0;
    };
    CompareTableAbstract.prototype.isCommissionDown = function (compare) {
        return compare.rsvp && compare.delta && compare.delta.commission < 0;
    };
    CompareTableAbstract.prototype.isRevenueUp = function (compare) {
        return compare.rsvp && compare.delta && compare.delta.revenue > 0;
    };
    CompareTableAbstract.prototype.isRevenueDown = function (compare) {
        return compare.rsvp && compare.delta && compare.delta.revenue < 0;
    };
    CompareTableAbstract.prototype.isRoomRateUp = function (compare) {
        return compare.rsvp && compare.delta && compare.delta.roomRate > 0;
    };
    CompareTableAbstract.prototype.isRoomRateDown = function (compare) {
        return compare.rsvp && compare.delta && compare.delta.roomRate < 0;
    };
    CompareTableAbstract.prototype.isNightsUp = function (compare) {
        return compare.rsvp && compare.delta && compare.delta.nights > 0;
    };
    CompareTableAbstract.prototype.isNightsDown = function (compare) {
        return compare.rsvp && compare.delta && compare.delta.nights < 0;
    };
    /**
     * Returns true if nights match, RSVP check-in is populated, and it doesn't match reservation check-in.
     * */
    CompareTableAbstract.prototype.isDatesBold = function (compare) {
        return compare.rsvp
            && compare.rsvp.checkInDate
            && compare.delta
            && compare.delta.nights === 0
            && compare.rsvp.checkInDate !== compare.reservation.checkInDate;
    };
    CompareTableAbstract.prototype.confirmBeforeUpdate = function (event, reservationCompare) {
        event.preventDefault();
        this.rsvpToUpdate = reservationCompare;
        this.confirmUpdateRsvpModal.open();
    };
    CompareTableAbstract.prototype.confirmUpdateHandler = function (updateConfirmed) {
        if (updateConfirmed) {
            this.updateRsvp(this.rsvpToUpdate);
        }
        this.rsvpToUpdate = null;
    };
    CompareTableAbstract.prototype.getRsvpId = function (value) {
        var rsvpId;
        if (typeof value === 'number') {
            rsvpId = value;
        }
        else if (value) {
            rsvpId = value.eventRsvpId;
        }
        else {
            return '';
        }
        if (rsvpId) {
            return "rsvp-" + rsvpId;
        }
        else {
            return '';
        }
    };
    CompareTableAbstract.prototype.isNotCommissionable = function (compare) {
        return ReservationStatusCode[compare.reservation.status] === ReservationStatusCode[ReservationStatusCode.CANCELLED]
            || ReservationStatusCode[compare.reservation.status] === ReservationStatusCode[ReservationStatusCode.NO_SHOW];
    };
    CompareTableAbstract.prototype.updateRsvp = function (rsvpToUpdate) {
        var rsvp = new Rsvp({
            eventRsvpId: rsvpToUpdate.rsvp.eventRsvpId,
            eventId: this.onyxEvent.eventId,
            firstName: rsvpToUpdate.reservation.firstName,
            lastName: rsvpToUpdate.reservation.lastName,
            nights: rsvpToUpdate.reservation.nights,
            roomRate: rsvpToUpdate.reservation.roomRate,
            revenue: rsvpToUpdate.reservation.revenue,
            commission: rsvpToUpdate.reservation.commission,
            confirmation: rsvpToUpdate.reservation.confirmation,
            roomType: rsvpToUpdate.reservation.roomType,
            checkInDate: rsvpToUpdate.reservation.checkInDate,
            checkOutDate: rsvpToUpdate.reservation.checkOutDate,
            eventPartyId: rsvpToUpdate.eventPartyId
        });
        return this.rsvpStore.updateRsvp(rsvp);
    };
    CompareTableAbstract.prototype.scrollToElement = function (element) {
        var pageScrollInstance = ng2_page_scroll["c" /* PageScrollInstance */].simpleInstance(this.document, element);
        this.pageScrollService.start(pageScrollInstance);
    };
    return CompareTableAbstract;
}());

compare_table_abstract___decorate([
    Object(core_es5["Input"])('event'),
    compare_table_abstract___metadata("design:type", typeof (compare_table_abstract__a = typeof OnyxEvent !== "undefined" && OnyxEvent) === "function" && compare_table_abstract__a || Object),
    compare_table_abstract___metadata("design:paramtypes", [typeof (compare_table_abstract__b = typeof OnyxEvent !== "undefined" && OnyxEvent) === "function" && compare_table_abstract__b || Object])
], compare_table_abstract_CompareTableAbstract.prototype, "event", null);
compare_table_abstract___decorate([
    Object(core_es5["ViewChild"])('confirmUpdateRsvpModal'),
    compare_table_abstract___metadata("design:type", typeof (compare_table_abstract__c = typeof confirmation_modal_component_ConfirmationModalComponent !== "undefined" && confirmation_modal_component_ConfirmationModalComponent) === "function" && compare_table_abstract__c || Object)
], compare_table_abstract_CompareTableAbstract.prototype, "confirmUpdateRsvpModal", void 0);
compare_table_abstract___decorate([
    Object(core_es5["ViewChild"])(reservation_modal_component_ReservationModalComponent),
    compare_table_abstract___metadata("design:type", typeof (compare_table_abstract__d = typeof reservation_modal_component_ReservationModalComponent !== "undefined" && reservation_modal_component_ReservationModalComponent) === "function" && compare_table_abstract__d || Object)
], compare_table_abstract_CompareTableAbstract.prototype, "reservationModal", void 0);
var compare_table_abstract__a, compare_table_abstract__b, compare_table_abstract__c, compare_table_abstract__d;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/compare-table-abstract.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/reservations/reservation-detail-table/reservation-detail-table.component.ts
var reservation_detail_table_component___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var reservation_detail_table_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var reservation_detail_table_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var reservation_detail_table_component___param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};

/* tslint:disable:no-access-missing-member */



















var reservation_detail_table_component_ReservationDetailTableComponent = (function (_super) {
    reservation_detail_table_component___extends(ReservationDetailTableComponent, _super);
    function ReservationDetailTableComponent(reservationCompareStore, authenticationStore, translateService, logService, pageScrollService, document, rsvpStore, userLocalStorageService, eventValidationService) {
        var _this = _super.call(this, pageScrollService, document, rsvpStore) || this;
        _this.reservationCompareStore = reservationCompareStore;
        _this.authenticationStore = authenticationStore;
        _this.translateService = translateService;
        _this.logService = logService;
        _this.userLocalStorageService = userLocalStorageService;
        _this.eventValidationService = eventValidationService;
        _this.ui = {
            showCards: false,
            showNoMatchesCard: false,
            showNoMatchesDetails: false,
            showNoMatchesWarningCard: false,
            showPartialMatchesCard: false,
            showPartialMatchesDetails: false,
            showPartialMatchesWarningCard: false,
            showExactMatchesCard: false,
            showExactMatchesDetails: false,
            showExactMatchesWarningCard: false,
            showNoReservationsWarning: false
        };
        _this.noMatchespagesizeType = PagesizeType.GROUP_RESERVATIONS_NO_MATCHES;
        _this.partialMatchespagesizeType = PagesizeType.GROUP_RESERVATIONS_PARTIAL_MATCHES;
        _this.exactMatchespagesizeType = PagesizeType.GROUP_RESERVATIONS_EXACT_MATCHES;
        _this.matchSubscription = new Subscription["Subscription"]();
        return _this;
    }
    ReservationDetailTableComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.reservationCompareList = this.reservationCompareStore.getReservationList()
            .map(function (reservationList) {
            return _this.isMultiVendor() ? reservation_utils_ReservationUtils.getCompareByVendor(reservationList, _this.vendor.eventPartyId) : reservationList;
        });
        // all cards
        this.isReservationCompareListEmpty().subscribe(function (value) {
            _this.ui.showNoReservationsWarning = value;
            _this.ui.showCards = !value;
        });
        // no matches
        this.isUnfilteredMatchListEmpty(MatchTypeEnum.NO_MATCH).subscribe(function (value) {
            _this.ui.showNoMatchesCard = !value;
        });
        this.isFilteredMatchListEmpty(MatchTypeEnum.NO_MATCH).subscribe(function (value) {
            _this.ui.showNoMatchesDetails = !value;
            _this.ui.showNoMatchesWarningCard = value;
        });
        // partial matches
        this.isUnfilteredMatchListEmpty(MatchTypeEnum.PARTIAL_MATCH).subscribe(function (value) {
            _this.ui.showPartialMatchesCard = !value;
        });
        this.isFilteredMatchListEmpty(MatchTypeEnum.PARTIAL_MATCH).subscribe(function (value) {
            _this.ui.showPartialMatchesDetails = !value;
            _this.ui.showPartialMatchesWarningCard = value;
        });
        // exact matches
        this.isUnfilteredMatchListEmpty(MatchTypeEnum.EXACT_MATCH).subscribe(function (value) {
            _this.ui.showExactMatchesCard = !value;
        });
        this.isFilteredMatchListEmpty(MatchTypeEnum.EXACT_MATCH).subscribe(function (value) {
            _this.ui.showExactMatchesDetails = !value;
            _this.ui.showExactMatchesWarningCard = value;
        });
        this.headerRecordType = SummaryRecordTypeEnum.RESERVATION;
        this.noMatchPage = page_Page.empty();
        this.noMatchPage.size = this.userLocalStorageService.getPagesize(PagesizeType.GROUP_RESERVATIONS_NO_MATCHES);
        this.buildMatchPage(this.noMatchPage, MatchTypeEnum.NO_MATCH);
        this.partialMatchPage = page_Page.empty();
        this.partialMatchPage.size = this.userLocalStorageService.getPagesize(PagesizeType.GROUP_RESERVATIONS_PARTIAL_MATCHES);
        this.buildMatchPage(this.partialMatchPage, MatchTypeEnum.PARTIAL_MATCH);
        this.exactMatchPage = page_Page.empty();
        this.exactMatchPage.size = this.userLocalStorageService.getPagesize(PagesizeType.GROUP_RESERVATIONS_EXACT_MATCHES);
        this.buildMatchPage(this.exactMatchPage, MatchTypeEnum.EXACT_MATCH);
        this.canChangeRSVPs$ = this.eventValidationService.canChangeRsvps();
    };
    ReservationDetailTableComponent.prototype.buildMatchPage = function (matchPage, matchType) {
        var _this = this;
        this.matchSubscription.add(this.getMatches(matchType).subscribe(function (reservationList) {
            var rsvpId = _this.reservationCompareStore.selectedRsvpId;
            var reservationId = _this.reservationCompareStore.selectedReservationId;
            if (reservationId) {
                var index = reservationList.findIndex(function (compare) {
                    return compare.reservation && compare.reservation.eventReservationId === reservationId;
                });
                if (index >= 0) {
                    matchPage.number = Math.floor(index / matchPage.size);
                }
            }
            else if (rsvpId) {
                var index = reservationList.findIndex(function (compare) {
                    return compare.rsvp && compare.rsvp.eventRsvpId === rsvpId;
                });
                if (index >= 0) {
                    matchPage.number = Math.floor(index / matchPage.size);
                }
            }
            var page = matchPage.number;
            var itemsPerPage = matchPage.size;
            matchPage.content = Object(immutable["List"])(reservationList.slice(page * itemsPerPage, (page + 1) * itemsPerPage));
            matchPage.totalElements = reservationList.size;
            matchPage.numberOfElements = matchPage.content.size;
        }));
    };
    ReservationDetailTableComponent.prototype.ngAfterViewInit = function () {
        var rsvpId = this.reservationCompareStore.selectedRsvpId;
        var reservationId = this.reservationCompareStore.selectedReservationId;
        this.logService.verbose("rsvp: " + rsvpId + ", reservation: " + reservationId);
        var elem;
        if (reservationId) {
            var id = this.getReservationId(reservationId);
            elem = document.querySelector("[data-res-id=" + id + "]");
            elem.classList.add('highlight');
            this.logService.verbose("page scrolling to selector: [data-res-id=" + id + "]");
            this.scrollToElement(elem);
        }
        else if (rsvpId) {
            var id = this.getRsvpId(rsvpId);
            elem = document.querySelector("[data-rsvp-id=" + id + "]");
            elem.classList.add('highlight');
            this.logService.verbose("page scrolling to selector: [data-rsvp-id=" + id + "]");
            this.scrollToElement(elem);
        }
    };
    ReservationDetailTableComponent.prototype.ngOnDestroy = function () {
        this.matchSubscription.unsubscribe();
    };
    ReservationDetailTableComponent.prototype.getMatches = function (matchType) {
        return (this.isMultiVendor() ? this.reservationCompareStore.getVendorCurrentFilteredReservations(this.vendor.eventPartyId) :
            this.reservationCompareStore.getCurrentFilteredReservations())
            .map(function (comparisonList) {
            return comparisonList.filter(function (comparison) { return comparison.matchType === matchType.toString(); }).toList();
        });
    };
    ReservationDetailTableComponent.prototype.getUnfilteredMatches = function (matchType) {
        var _this = this;
        return this.reservationCompareList.map(function (comparisonList) {
            return comparisonList.filter(function (comparison) { return comparison.matchType === matchType.toString(); }).toList();
        }).map(function (reservationList) {
            return _this.isMultiVendor() ? reservation_utils_ReservationUtils.getCompareByVendor(reservationList, _this.vendor.eventPartyId) : reservationList;
        });
    };
    ReservationDetailTableComponent.prototype.getReservationTotalCommission = function (matchType) {
        return reservation_utils_ReservationUtils.calculateCommissionTotal(this.getUnfilteredMatches(matchType));
    };
    ReservationDetailTableComponent.prototype.getReservationId = function (value) {
        var reservationId;
        if (typeof value === 'number') {
            reservationId = value;
        }
        else if (value) {
            reservationId = value.eventReservationId;
        }
        else {
            return '';
        }
        if (reservationId) {
            return "res-" + reservationId;
        }
        else {
            return '';
        }
    };
    ReservationDetailTableComponent.prototype.getRsvpTotalCommission = function (matchType) {
        return reservation_utils_ReservationUtils.calculateRsvpCommissionTotal(this.getUnfilteredMatches(matchType));
    };
    ReservationDetailTableComponent.prototype.isReservationCompareListEmpty = function () {
        return reservation_utils_ReservationUtils.isListEmpty(this.reservationCompareList);
    };
    ReservationDetailTableComponent.prototype.isFilteredMatchListEmpty = function (matchType) {
        return this.isMultiVendor() ? this.reservationCompareStore.isVendorFilteredMatchListEmpty(matchType, this.vendor.eventPartyId) :
            this.reservationCompareStore.isFilteredMatchListEmpty(matchType);
    };
    ReservationDetailTableComponent.prototype.isUnfilteredMatchListEmpty = function (matchType) {
        return reservation_utils_ReservationUtils.isListEmpty(this.getUnfilteredMatches(matchType));
    };
    ReservationDetailTableComponent.prototype.hasFilteredOutResults = function () {
        var _this = this;
        return reservation_utils_ReservationUtils
            .isListEmpty(this.isMultiVendor() ?
            this.reservationCompareStore.getVendorCurrentFilteredReservations(this.vendor.eventPartyId) :
            this.reservationCompareStore.getCurrentFilteredReservations())
            .flatMap(function (filteredListIsEmpty) {
            return _this.isReservationCompareListEmpty().map(function (isReservationListEmpty) { return filteredListIsEmpty !== isReservationListEmpty; });
        });
    };
    ReservationDetailTableComponent.prototype.getCommissionDelta = function (matchType) {
        var reservationCommissionObj = this.getReservationTotalCommission(matchType);
        var rsvpCommissionObj = this.getRsvpTotalCommission(matchType);
        return reservationCommissionObj.flatMap(function (reservationCommission) {
            return rsvpCommissionObj.map(function (rsvpCommission) {
                return reservationCommission - rsvpCommission;
            });
        }).map(function (total) { return NumberUtils.round2Fixed(total); });
    };
    ReservationDetailTableComponent.prototype.getCommissionDeltaText = function (matchType) {
        var _this = this;
        return this.getCommissionDelta(matchType).flatMap(function (delta) {
            if (delta > 0) {
                return _this.translateService.get('EVENT.RESERVATION.TOOLTIP_COMMISSION_DIFFERENCE_MORE');
            }
            else if (delta < 0) {
                return _this.translateService.get('EVENT.RESERVATION.TOOLTIP_COMMISSION_DIFFERENCE_LESS');
            }
            else {
                return _this.translateService.get('EVENT.RESERVATION.TOOLTIP_COMMISSION_DIFFERENCE_EQUAL');
            }
        });
    };
    ReservationDetailTableComponent.prototype.resetStatusCodes = function () {
        this.reservationCompareStore.resetStatusCodes();
    };
    ReservationDetailTableComponent.prototype.getNoMatchCardHeaderTitle = function () {
        return (this.isMultiVendor() ?
            this.reservationCompareStore.areVendorRsvpsPresent(this.vendor.eventPartyId) : this.reservationCompareStore.areRsvpsPresent())
            .map(function (result) {
            return result ? 'EVENT.RESERVATION.NO_MATCH_TITLE' : 'EVENT.RESERVATION.NO_RSVP_TITLE';
        });
    };
    ReservationDetailTableComponent.prototype.updateRsvp = function (rsvpToUpdate) {
        var _this = this;
        var obs$ = _super.prototype.updateRsvp.call(this, rsvpToUpdate);
        obs$.subscribe(function () {
            if (_this.isMultiVendor()) {
                _this.reservationCompareStore.refreshCurrentReservationList(_this.onyxEvent.eventId);
            }
            else {
                _this.reservationCompareStore.refreshCurrentReservationListByParty(_this.onyxEvent.eventId, _this.onyxEvent.eventProperty.eventPartyId);
            }
        });
        return obs$;
    };
    ReservationDetailTableComponent.prototype.onRefreshMatchPage = function (pageNumber, itemsPerPage, matchType, page) {
        this.getMatches(matchType).take(1).subscribe(function (reservationList) {
            page.content = Object(immutable["List"])(reservationList.slice(pageNumber * itemsPerPage, (pageNumber + 1) * itemsPerPage));
            page.number = pageNumber;
            page.size = itemsPerPage;
            page.totalElements = reservationList.size;
            page.numberOfElements = page.content.size;
        });
    };
    ReservationDetailTableComponent.prototype.onRefreshNoMatchList = function (pageNumber, itemsPerPage) {
        this.onRefreshMatchPage(pageNumber, itemsPerPage, MatchTypeEnum.NO_MATCH, this.noMatchPage);
    };
    ReservationDetailTableComponent.prototype.onRefreshPartialMatchList = function (pageNumber, itemsPerPage) {
        this.onRefreshMatchPage(pageNumber, itemsPerPage, MatchTypeEnum.PARTIAL_MATCH, this.partialMatchPage);
    };
    ReservationDetailTableComponent.prototype.onRefreshExactMatchList = function (pageNumber, itemsPerPage) {
        this.onRefreshMatchPage(pageNumber, itemsPerPage, MatchTypeEnum.EXACT_MATCH, this.exactMatchPage);
    };
    ReservationDetailTableComponent.prototype.isMultiVendor = function () {
        return this.authenticationStore.hasPermission('MultiVendor');
    };
    return ReservationDetailTableComponent;
}(compare_table_abstract_CompareTableAbstract));
reservation_detail_table_component___decorate([
    Object(core_es5["Input"])(),
    reservation_detail_table_component___metadata("design:type", typeof (reservation_detail_table_component__a = typeof Party !== "undefined" && Party) === "function" && reservation_detail_table_component__a || Object)
], reservation_detail_table_component_ReservationDetailTableComponent.prototype, "vendor", void 0);
reservation_detail_table_component_ReservationDetailTableComponent = reservation_detail_table_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-reservation-detail-table',
        template: __webpack_require__("OprT"),
        styles: [__webpack_require__("oP5S")]
    }),
    reservation_detail_table_component___param(5, Object(core_es5["Inject"])(platform_browser_es5["DOCUMENT"])),
    reservation_detail_table_component___metadata("design:paramtypes", [typeof (reservation_detail_table_component__b = typeof reservation_compare_store_ReservationCompareStore !== "undefined" && reservation_compare_store_ReservationCompareStore) === "function" && reservation_detail_table_component__b || Object, typeof (reservation_detail_table_component__c = typeof authentication_store_AuthenticationStore !== "undefined" && authentication_store_AuthenticationStore) === "function" && reservation_detail_table_component__c || Object, typeof (reservation_detail_table_component__d = typeof core["c" /* TranslateService */] !== "undefined" && core["c" /* TranslateService */]) === "function" && reservation_detail_table_component__d || Object, typeof (reservation_detail_table_component__e = typeof log_service_LogService !== "undefined" && log_service_LogService) === "function" && reservation_detail_table_component__e || Object, typeof (reservation_detail_table_component__f = typeof ng2_page_scroll["d" /* PageScrollService */] !== "undefined" && ng2_page_scroll["d" /* PageScrollService */]) === "function" && reservation_detail_table_component__f || Object, Object, typeof (reservation_detail_table_component__g = typeof rsvp_store_RsvpStore !== "undefined" && rsvp_store_RsvpStore) === "function" && reservation_detail_table_component__g || Object, typeof (reservation_detail_table_component__h = typeof user_local_storage_service_UserLocalStorageService !== "undefined" && user_local_storage_service_UserLocalStorageService) === "function" && reservation_detail_table_component__h || Object, typeof (reservation_detail_table_component__j = typeof event_validation_service_EventValidationService !== "undefined" && event_validation_service_EventValidationService) === "function" && reservation_detail_table_component__j || Object])
], reservation_detail_table_component_ReservationDetailTableComponent);

var reservation_detail_table_component__a, reservation_detail_table_component__b, reservation_detail_table_component__c, reservation_detail_table_component__d, reservation_detail_table_component__e, reservation_detail_table_component__f, reservation_detail_table_component__g, reservation_detail_table_component__h, reservation_detail_table_component__j;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/reservation-detail-table.component.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/reservations/reservation-filter/reservation-filter.component.ts
var reservation_filter_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var reservation_filter_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};







var reservation_filter_component_ReservationFilterComponent = (function () {
    function ReservationFilterComponent(logService, reservationCompareStore, authenticationStore) {
        this.logService = logService;
        this.reservationCompareStore = reservationCompareStore;
        this.authenticationStore = authenticationStore;
        this.activeStatusCodes = reservation_compare_store_ReservationCompareStore.STATUS_CODES;
        this.ReservationStatusCode = ReservationStatusCode;
        this.reserved = true;
        this.checkedIn = true;
        this.checkedOut = true;
        this.cancelled = true;
        this.noShow = true;
        this.rsvp = true;
    }
    Object.defineProperty(ReservationFilterComponent.prototype, "event", {
        set: function (event) {
            this.onyxEvent = event;
        },
        enumerable: true,
        configurable: true
    });
    ReservationFilterComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.reservationCompareStore.getActiveStatusCodes().subscribe(function (statusCodes) {
            _this.reserved = _this.isPresent(ReservationStatusCode.RESERVED, statusCodes);
            _this.checkedOut = _this.isPresent(ReservationStatusCode.CHECKED_OUT, statusCodes);
            _this.checkedIn = _this.isPresent(ReservationStatusCode.CHECKED_IN, statusCodes);
            _this.cancelled = _this.isPresent(ReservationStatusCode.CANCELLED, statusCodes);
            _this.noShow = _this.isPresent(ReservationStatusCode.NO_SHOW, statusCodes);
            if (_this.isMultiVendor()) {
                _this.eventLink = _this.onyxEvent.eventId + '';
            }
            else {
                _this.eventLink = _this.onyxEvent.eventId + '/' + _this.onyxEvent.eventProperty.eventPartyId;
            }
        });
        this.disableCompareButton$ = this.reservationCompareStore.isCompareListEmpty();
    };
    ReservationFilterComponent.prototype.toggleReserved = function () {
        this.toggleStatusCode(ReservationStatusCode.RESERVED);
    };
    ReservationFilterComponent.prototype.toggleCheckedIn = function () {
        this.toggleStatusCode(ReservationStatusCode.CHECKED_IN);
    };
    ReservationFilterComponent.prototype.toggleCheckedOut = function () {
        this.toggleStatusCode(ReservationStatusCode.CHECKED_OUT);
    };
    ReservationFilterComponent.prototype.toggleCancelled = function () {
        this.toggleStatusCode(ReservationStatusCode.CANCELLED);
    };
    ReservationFilterComponent.prototype.toggleNoShow = function () {
        this.toggleStatusCode(ReservationStatusCode.NO_SHOW);
    };
    ReservationFilterComponent.prototype.toggleRsvp = function () {
        this.toggleStatusCode(STATUS_CODE_RSVP);
    };
    ReservationFilterComponent.prototype.isPresent = function (statusCode, statusCodes) {
        return !Object(util_util["isNullOrUndefined"])(statusCodes.find(function (code) { return code === statusCode; }));
    };
    ReservationFilterComponent.prototype.getActiveStatusCodes = function () {
        return this.reservationCompareStore.getActiveStatusCodes();
    };
    ReservationFilterComponent.prototype.getSummarySelected = function () {
        return this.reservationCompareStore.getShowReservationCompareSummary();
    };
    ReservationFilterComponent.prototype.updateModelWithStatusCode = function (statusCode, value) {
        switch (statusCode) {
            case ReservationStatusCode.CANCELLED:
                this.cancelled = value;
                break;
            case ReservationStatusCode.CHECKED_OUT:
                this.checkedOut = value;
                break;
            case ReservationStatusCode.CHECKED_IN:
                this.checkedIn = value;
                break;
            case ReservationStatusCode.RESERVED:
                this.reserved = value;
                break;
            case ReservationStatusCode.NO_SHOW:
                this.noShow = value;
                break;
            case STATUS_CODE_RSVP:
                this.rsvp = value;
                break;
        }
    };
    ReservationFilterComponent.prototype.toggleStatusCode = function (statusCode) {
        this.logService.verbose("toggleStatusCode " + statusCode + " ");
        var statusCodes = this.reservationCompareStore.getInstantActiveStatusCodes();
        var isPresent = this.isPresent(statusCode, statusCodes);
        this.logService.verbose("toggleStatusCode " + isPresent + " - " + JSON.stringify(statusCodes));
        this.updateModelWithStatusCode(statusCode, !isPresent);
        if (isPresent) {
            this.updateStatusCode(statusCodes.filter(function (code) { return code !== statusCode; }));
        }
        else {
            this.updateStatusCode(statusCodes.concat([statusCode]));
        }
    };
    ReservationFilterComponent.prototype.updateStatusCode = function (statusCodes) {
        this.logService.verbose("UpdateStatusCode: " + JSON.stringify(statusCodes));
        this.reservationCompareStore.setActiveStatusCodes(statusCodes);
    };
    ReservationFilterComponent.prototype.isMultiVendor = function () {
        return this.authenticationStore.hasPermission('MultiVendor');
    };
    return ReservationFilterComponent;
}());
reservation_filter_component___decorate([
    Object(core_es5["Input"])('event'),
    reservation_filter_component___metadata("design:type", typeof (reservation_filter_component__a = typeof OnyxEvent !== "undefined" && OnyxEvent) === "function" && reservation_filter_component__a || Object),
    reservation_filter_component___metadata("design:paramtypes", [typeof (reservation_filter_component__b = typeof OnyxEvent !== "undefined" && OnyxEvent) === "function" && reservation_filter_component__b || Object])
], reservation_filter_component_ReservationFilterComponent.prototype, "event", null);
reservation_filter_component_ReservationFilterComponent = reservation_filter_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-reservation-filter',
        template: __webpack_require__("c28g")
    }),
    reservation_filter_component___metadata("design:paramtypes", [typeof (reservation_filter_component__c = typeof log_service_LogService !== "undefined" && log_service_LogService) === "function" && reservation_filter_component__c || Object, typeof (reservation_filter_component__d = typeof reservation_compare_store_ReservationCompareStore !== "undefined" && reservation_compare_store_ReservationCompareStore) === "function" && reservation_filter_component__d || Object, typeof (reservation_filter_component__e = typeof authentication_store_AuthenticationStore !== "undefined" && authentication_store_AuthenticationStore) === "function" && reservation_filter_component__e || Object])
], reservation_filter_component_ReservationFilterComponent);

var reservation_filter_component__a, reservation_filter_component__b, reservation_filter_component__c, reservation_filter_component__d, reservation_filter_component__e;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/reservation-filter.component.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/reservations/reservation-summary-table/reservation-summary-table.component.ts
var reservation_summary_table_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var reservation_summary_table_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};





















var reservation_summary_table_component_ReservationSummaryTableComponent = (function () {
    function ReservationSummaryTableComponent(reservationCompareStore, translateService, reservationStore, userLocalStorageService, authenticationStore, eventValidationService) {
        this.reservationCompareStore = reservationCompareStore;
        this.translateService = translateService;
        this.reservationStore = reservationStore;
        this.userLocalStorageService = userLocalStorageService;
        this.authenticationStore = authenticationStore;
        this.eventValidationService = eventValidationService;
        this.filteredClass = '';
        this.pagesizeType = PagesizeType.GROUP_RESERVATIONS_SUMMARY;
        this.reservationsSubscription = new Subscription["Subscription"]();
    }
    Object.defineProperty(ReservationSummaryTableComponent.prototype, "event", {
        set: function (event) {
            this.onyxEvent = event;
        },
        enumerable: true,
        configurable: true
    });
    ReservationSummaryTableComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.statusCodes = this.reservationCompareStore.getActiveStatusCodes();
        this.reservations = this.reservationCompareStore.getReservationList()
            .map(function (reservationList) { return reservation_utils_ReservationUtils.onlyReservationsFilter(reservationList); })
            .map(function (reservationList) {
            return _this.isMultiVendor() ? reservation_utils_ReservationUtils.getCompareByVendor(reservationList, _this.vendor.eventPartyId) : reservationList;
        });
        this.editModal = EventReservationAction.EDIT_RESERVATION;
        this.isFiltered().subscribe(function (isFiltered) {
            if (isFiltered) {
                _this.filteredClass = 'filtered';
            }
            else {
                _this.filteredClass = '';
            }
        });
        this.headerRecordType = SummaryRecordTypeEnum.RESERVATION;
        this.reservationsPage = page_Page.empty();
        this.reservationsPage.size = this.userLocalStorageService.getPagesize(PagesizeType.GROUP_RESERVATIONS_SUMMARY);
        this.reservationsSubscription.add(this.getFilteredReservations()
            .map(function (reservationList) {
            return _this.isMultiVendor() ? reservation_utils_ReservationUtils.getCompareByVendor(reservationList, _this.vendor.eventPartyId) : reservationList;
        })
            .subscribe(function (reservationList) {
            var page = _this.reservationsPage.number;
            var itemsPerPage = _this.reservationsPage.size;
            _this.reservationsPage.content = Object(immutable["List"])(reservationList.slice(page * itemsPerPage, (page + 1) * itemsPerPage));
            _this.reservationsPage.totalElements = reservationList.size;
            _this.reservationsPage.numberOfElements = _this.reservationsPage.content.size;
        }));
        this.canChangeReservations$ = this.eventValidationService.canChangeReservations();
    };
    ReservationSummaryTableComponent.prototype.ngOnDestroy = function () {
        this.reservationsSubscription.unsubscribe();
    };
    ReservationSummaryTableComponent.prototype.getReservations = function () {
        return this.reservations;
    };
    ReservationSummaryTableComponent.prototype.getRsvps = function () {
        var _this = this;
        return this.reservationCompareStore.getReservationList()
            .map(function (reservationList) { return reservation_utils_ReservationUtils.onlyRsvpFilter(reservationList); })
            .map(function (reservationList) {
            return _this.isMultiVendor() ? reservation_utils_ReservationUtils.getCompareByVendor(reservationList, _this.vendor.eventPartyId) : reservationList;
        });
    };
    ReservationSummaryTableComponent.prototype.getFilteredReservations = function () {
        var _this = this;
        return this.reservationCompareStore.getCurrentFilteredReservations()
            .map(function (reservationList) { return reservation_utils_ReservationUtils.onlyReservationsFilter(reservationList); })
            .map(function (reservationList) {
            return _this.isMultiVendor() ? reservation_utils_ReservationUtils.getCompareByVendor(reservationList, _this.vendor.eventPartyId) : reservationList;
        });
    };
    ReservationSummaryTableComponent.prototype.getReservationRevenueTotal = function () {
        return reservation_utils_ReservationUtils.calculateRevenueTotal(this.getReservations());
    };
    ReservationSummaryTableComponent.prototype.getFilteredReservationRevenueTotal = function () {
        return reservation_utils_ReservationUtils.calculateRevenueTotal(this.getFilteredReservations());
    };
    ReservationSummaryTableComponent.prototype.getReservationCommissionTotal = function () {
        return reservation_utils_ReservationUtils.calculateCommissionTotal(this.getReservations());
    };
    ReservationSummaryTableComponent.prototype.getRsvpCommissionTotal = function () {
        return reservation_utils_ReservationUtils.calculateRsvpCommissionTotal(this.getRsvps());
    };
    ReservationSummaryTableComponent.prototype.getFilteredReservationCommissionTotal = function () {
        return reservation_utils_ReservationUtils.calculateCommissionTotal(this.getFilteredReservations());
    };
    ReservationSummaryTableComponent.prototype.getFilteredReservationNightsTotal = function () {
        return reservation_utils_ReservationUtils.calculateReservationTotalNights(this.getFilteredReservations());
    };
    ReservationSummaryTableComponent.prototype.isReservationListEmpty = function () {
        return reservation_utils_ReservationUtils.isListEmpty(this.getReservations());
    };
    ReservationSummaryTableComponent.prototype.isRsvpListEmpty = function () {
        return reservation_utils_ReservationUtils.isListEmpty(this.getRsvps());
    };
    ReservationSummaryTableComponent.prototype.isFilteredListEmpty = function () {
        return reservation_utils_ReservationUtils.isListEmpty(this.getFilteredReservations());
    };
    ReservationSummaryTableComponent.prototype.isFiltered = function () {
        var filteredSizeObs = reservation_utils_ReservationUtils.getListSize(this.getFilteredReservations());
        var unfilteredSizeObs = reservation_utils_ReservationUtils.getListSize(this.getReservations());
        return filteredSizeObs.flatMap(function (filteredSize) {
            return unfilteredSizeObs.map(function (unfilteredSize) {
                return filteredSize !== unfilteredSize;
            });
        });
    };
    ReservationSummaryTableComponent.prototype.getCommissionDelta = function () {
        var reservationCommissionObj = this.getReservationCommissionTotal();
        var rsvpCommissionObj = this.getRsvpCommissionTotal();
        return reservationCommissionObj.flatMap(function (reservationCommission) {
            return rsvpCommissionObj.map(function (rsvpCommission) {
                return reservationCommission - rsvpCommission;
            });
        }).map(function (total) { return NumberUtils.round2Fixed(total); });
    };
    ReservationSummaryTableComponent.prototype.getCommissionDeltaText = function () {
        var _this = this;
        return this.getCommissionDelta().flatMap(function (delta) {
            if (delta > 0) {
                return _this.translateService.get('EVENT.RESERVATION.TOOLTIP_COMMISSION_DIFFERENCE_MORE');
            }
            else if (delta < 0) {
                return _this.translateService.get('EVENT.RESERVATION.TOOLTIP_COMMISSION_DIFFERENCE_LESS');
            }
            else {
                return _this.translateService.get('EVENT.RESERVATION.TOOLTIP_COMMISSION_DIFFERENCE_EQUAL');
            }
        });
    };
    ReservationSummaryTableComponent.prototype.hasFilteredOutResults = function () {
        var _this = this;
        return reservation_utils_ReservationUtils.isListEmpty(this.getFilteredReservations()).flatMap(function (filteredListIsEmpty) {
            return _this.isReservationListEmpty().map(function (isReservationListEmpty) { return filteredListIsEmpty !== isReservationListEmpty; });
        });
    };
    ReservationSummaryTableComponent.prototype.resetStatusCodes = function () {
        this.reservationCompareStore.resetStatusCodes();
    };
    ReservationSummaryTableComponent.prototype.totalCommissionClass = function () {
        var _this = this;
        var areRsvpPresent$ = this.isMultiVendor() ?
            this.reservationCompareStore.areVendorRsvpsPresent(this.vendor.eventPartyId) : this.reservationCompareStore.areRsvpsPresent();
        return areRsvpPresent$.flatMap(function (hasRsvps) {
            return _this.getCommissionDelta().map(function (total) {
                return hasRsvps && total > 0 ? 'commission-up' : hasRsvps && total < 0 ? 'commission-down' : '';
            });
        });
    };
    ReservationSummaryTableComponent.prototype.getStatusClass = function (compare) {
        if (compare.reservation) {
            switch (compare.reservation.status) {
                case 'R':
                    return 'res-status-reserved';
                case 'I':
                    return 'res-status-checked-in';
                case 'O':
                    return 'res-status-checked-out';
                case 'C':
                    return 'res-status-cancelled';
                case 'N':
                    return 'res-status-no-show';
                default:
                    return '';
            }
        }
        return '';
    };
    ReservationSummaryTableComponent.prototype.getSourceClass = function (compare) {
        if (compare.reservation) {
            switch (compare.reservation.source) {
                case EventReservationSource.FILE:
                    return 'btn-lock';
                case EventReservationSource.MANUAL:
                    return 'btn-more';
                case EventReservationSource.UPLOADED:
                    return 'btn-more';
                case EventReservationSource.RSVP:
                    return 'btn-more';
                case EventReservationSource.OUT_OF_BLOCK:
                    return 'btn-lock';
                default:
                    return 'btn-lock';
            }
        }
        return '';
    };
    ReservationSummaryTableComponent.prototype.isCommissionUp = function (compare) {
        return compare.rsvp && compare.delta && compare.delta.commission > 0;
    };
    ReservationSummaryTableComponent.prototype.isCommissionDown = function (compare) {
        return compare.rsvp && compare.delta && compare.delta.commission < 0;
    };
    ReservationSummaryTableComponent.prototype.confirmBeforeDelete = function (event, reservation) {
        event.preventDefault();
        this.reservationToDelete = reservation;
        this.confirmDeleteModal.open();
    };
    ReservationSummaryTableComponent.prototype.confirmHandler = function (deleteConfirmed) {
        if (deleteConfirmed) {
            this.deleteReservation(this.reservationToDelete);
        }
        this.reservationToDelete = null;
    };
    ReservationSummaryTableComponent.prototype.deleteReservation = function (reservation) {
        var _this = this;
        var obs = this.reservationStore.deleteReservation(reservation, this.isMultiVendor());
        obs.subscribe(function () {
            if (_this.isMultiVendor()) {
                _this.reservationCompareStore.refreshCurrentReservationList(_this.onyxEvent.eventId);
            }
            else {
                _this.reservationCompareStore.refreshCurrentReservationListByParty(_this.onyxEvent.eventId, _this.onyxEvent.eventProperty.eventPartyId);
            }
        });
        return obs;
    };
    ReservationSummaryTableComponent.prototype.canBeModifiable = function (reservation) {
        return (Constants.UI_MODIFIABLE_SOURCES.indexOf(reservation.source) >= 0);
    };
    ReservationSummaryTableComponent.prototype.canBeUnlinkable = function (reservation) {
        return (Constants.UI_UNLINKABLE_SOURCES.indexOf(reservation.source) >= 0);
    };
    ReservationSummaryTableComponent.prototype.openReservationModal = function (event, reservation) {
        event.preventDefault();
        this.reservationModal.open(reservation);
    };
    Object.defineProperty(ReservationSummaryTableComponent.prototype, "canManageReservations", {
        get: function () {
            return this.onyxEvent.canManageReservations;
        },
        enumerable: true,
        configurable: true
    });
    ReservationSummaryTableComponent.prototype.confirmBeforeUnlink = function (event, reservation) {
        event.preventDefault();
        this.reservationToUnlink = reservation;
        this.confirmUnlinkModal.open();
    };
    ReservationSummaryTableComponent.prototype.confirmUnlinkHandler = function (unlinkConfirmed) {
        if (unlinkConfirmed) {
            this.unlinkReservation(this.reservationToUnlink);
        }
        this.reservationToUnlink = null;
    };
    ReservationSummaryTableComponent.prototype.unlinkReservation = function (reservation) {
        var _this = this;
        var obs = this.reservationStore.unlinkReservation(reservation.eventReservationId, this.onyxEvent.eventId, this.onyxEvent.eventProperty.eventPartyId, this.isMultiVendor());
        obs.subscribe(function () {
            if (_this.isMultiVendor()) {
                _this.reservationCompareStore.refreshCurrentReservationList(_this.onyxEvent.eventId);
            }
            else {
                _this.reservationCompareStore.refreshCurrentReservationListByParty(_this.onyxEvent.eventId, _this.onyxEvent.eventProperty.eventPartyId);
            }
        });
        return obs;
    };
    ReservationSummaryTableComponent.prototype.onRefreshReservationsList = function (pageNumber, itemsPerPage) {
        var _this = this;
        this.getFilteredReservations().take(1).subscribe(function (reservationList) {
            _this.reservationsPage.content = Object(immutable["List"])(reservationList.slice(pageNumber * itemsPerPage, (pageNumber + 1) * itemsPerPage));
            _this.reservationsPage.number = pageNumber;
            _this.reservationsPage.size = itemsPerPage;
            _this.reservationsPage.totalElements = reservationList.size;
            _this.reservationsPage.numberOfElements = _this.reservationsPage.content.size;
        });
    };
    ReservationSummaryTableComponent.prototype.isTransient = function (reservation) {
        return reservation.source === EventReservationSource.OUT_OF_BLOCK;
    };
    ReservationSummaryTableComponent.prototype.getTransientTooltip = function (reservation) {
        return reservation.payViaGp ? 'EVENT.RESERVATION.TOOLTIP_RESERVATION_PAY_VIA_GP'
            : 'EVENT.RESERVATION.TOOLTIP_RESERVATION_NOT_PAY_VIA_GP';
    };
    ReservationSummaryTableComponent.prototype.isMultiVendor = function () {
        return this.authenticationStore.hasPermission('MultiVendor');
    };
    return ReservationSummaryTableComponent;
}());
reservation_summary_table_component___decorate([
    Object(core_es5["Input"])(),
    reservation_summary_table_component___metadata("design:type", typeof (reservation_summary_table_component__a = typeof Party !== "undefined" && Party) === "function" && reservation_summary_table_component__a || Object)
], reservation_summary_table_component_ReservationSummaryTableComponent.prototype, "vendor", void 0);
reservation_summary_table_component___decorate([
    Object(core_es5["ViewChild"])('confirmDeleteModal'),
    reservation_summary_table_component___metadata("design:type", typeof (reservation_summary_table_component__b = typeof confirmation_modal_component_ConfirmationModalComponent !== "undefined" && confirmation_modal_component_ConfirmationModalComponent) === "function" && reservation_summary_table_component__b || Object)
], reservation_summary_table_component_ReservationSummaryTableComponent.prototype, "confirmDeleteModal", void 0);
reservation_summary_table_component___decorate([
    Object(core_es5["ViewChild"])('confirmUnlinkModal'),
    reservation_summary_table_component___metadata("design:type", typeof (reservation_summary_table_component__c = typeof confirmation_modal_component_ConfirmationModalComponent !== "undefined" && confirmation_modal_component_ConfirmationModalComponent) === "function" && reservation_summary_table_component__c || Object)
], reservation_summary_table_component_ReservationSummaryTableComponent.prototype, "confirmUnlinkModal", void 0);
reservation_summary_table_component___decorate([
    Object(core_es5["ViewChild"])(reservation_modal_component_ReservationModalComponent),
    reservation_summary_table_component___metadata("design:type", typeof (reservation_summary_table_component__d = typeof reservation_modal_component_ReservationModalComponent !== "undefined" && reservation_modal_component_ReservationModalComponent) === "function" && reservation_summary_table_component__d || Object)
], reservation_summary_table_component_ReservationSummaryTableComponent.prototype, "reservationModal", void 0);
reservation_summary_table_component___decorate([
    Object(core_es5["Input"])('event'),
    reservation_summary_table_component___metadata("design:type", typeof (reservation_summary_table_component__e = typeof OnyxEvent !== "undefined" && OnyxEvent) === "function" && reservation_summary_table_component__e || Object),
    reservation_summary_table_component___metadata("design:paramtypes", [typeof (reservation_summary_table_component__f = typeof OnyxEvent !== "undefined" && OnyxEvent) === "function" && reservation_summary_table_component__f || Object])
], reservation_summary_table_component_ReservationSummaryTableComponent.prototype, "event", null);
reservation_summary_table_component_ReservationSummaryTableComponent = reservation_summary_table_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-reservation-summary-table',
        template: __webpack_require__("kYhW"),
        styles: [__webpack_require__("oYWb")]
    }),
    reservation_summary_table_component___metadata("design:paramtypes", [typeof (reservation_summary_table_component__g = typeof reservation_compare_store_ReservationCompareStore !== "undefined" && reservation_compare_store_ReservationCompareStore) === "function" && reservation_summary_table_component__g || Object, typeof (reservation_summary_table_component__h = typeof core["c" /* TranslateService */] !== "undefined" && core["c" /* TranslateService */]) === "function" && reservation_summary_table_component__h || Object, typeof (reservation_summary_table_component__j = typeof reservation_store_ReservationStore !== "undefined" && reservation_store_ReservationStore) === "function" && reservation_summary_table_component__j || Object, typeof (reservation_summary_table_component__k = typeof user_local_storage_service_UserLocalStorageService !== "undefined" && user_local_storage_service_UserLocalStorageService) === "function" && reservation_summary_table_component__k || Object, typeof (reservation_summary_table_component__l = typeof authentication_store_AuthenticationStore !== "undefined" && authentication_store_AuthenticationStore) === "function" && reservation_summary_table_component__l || Object, typeof (reservation_summary_table_component__m = typeof event_validation_service_EventValidationService !== "undefined" && event_validation_service_EventValidationService) === "function" && reservation_summary_table_component__m || Object])
], reservation_summary_table_component_ReservationSummaryTableComponent);

var reservation_summary_table_component__a, reservation_summary_table_component__b, reservation_summary_table_component__c, reservation_summary_table_component__d, reservation_summary_table_component__e, reservation_summary_table_component__f, reservation_summary_table_component__g, reservation_summary_table_component__h, reservation_summary_table_component__j, reservation_summary_table_component__k, reservation_summary_table_component__l, reservation_summary_table_component__m;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/reservation-summary-table.component.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/reservations/transient-modal/transient-modal.component.ts
var transient_modal_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var transient_modal_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};













var transient_modal_component_TransientModalComponent = (function () {
    function TransientModalComponent(transientReservationStore, reservationCompareStore, flashMessagesService, authenticationStore) {
        this.transientReservationStore = transientReservationStore;
        this.reservationCompareStore = reservationCompareStore;
        this.flashMessagesService = flashMessagesService;
        this.authenticationStore = authenticationStore;
        this.closed = new core_es5["EventEmitter"]();
        this.config = {
            backdrop: 'static',
            keyboard: false
        };
        this.pagesizeType = PagesizeType.TRANSIENT_RESERVATIONS;
    }
    TransientModalComponent.prototype.ngOnInit = function () {
    };
    TransientModalComponent.prototype.open = function (rsvp) {
        if (!this.event) {
            throw new Error('The "event" attribute must be specified to use the TransientModalComponent component');
        }
        if (!rsvp) {
            throw new Error('The "rsvp" parameter must be specified to use the TransientModalComponent component');
        }
        else {
            this.rsvp = rsvp;
            this.transientSearchComponent.initSearchForm(rsvp);
            var _startDate = EventUtils.getEventStartDate(this.event, this.authenticationStore.isAgencyUser());
            var _endDate = EventUtils.getEventEndDate(this.event, this.authenticationStore.isAgencyUser());
            var defaultParams = new TransientReservationSearchParameters({
                eventId: this.event.eventId,
                eventPartyId: this.event.eventProperty.eventPartyId,
                minCheckInDate: _startDate,
                maxCheckOutDate: _endDate,
                firstName: rsvp.firstName,
                lastName: rsvp.lastName
            });
            this.transientSearchComponent.refreshTransientReservations(Constants.SEARCH_DEFAULT_PAGE, defaultParams);
            this.transientModal.show();
        }
    };
    TransientModalComponent.prototype.accept = function () {
        var _this = this;
        this.transientTableComponent.obtainTransientReservationSelected().subscribe(function (transientReservation) {
            _this.transientReservationStore.linkTransientReservationsToEvent([transientReservation.eventReservationId], _this.event.eventProperty.eventPartyId)
                .subscribe(function () {
                _this.flashMessagesService.success('MESSAGES.SUCCESS.TRANSIENT_RESERVATION_LINKED');
                if (_this.isMultiVendor()) {
                    _this.reservationCompareStore.refreshCurrentRsvpList(_this.event.eventId);
                }
                else {
                    _this.reservationCompareStore.refreshCurrentRsvpListByParty(_this.event.eventId, _this.event.eventProperty.eventPartyId);
                }
                _this.close(true);
            });
        });
    };
    TransientModalComponent.prototype.disableLinkButton = function () {
        var disable = false;
        if (this.transientTableComponent && this.transientTableComponent.searchResults) {
            disable = this.transientTableComponent.searchResults.totalElements === 0;
        }
        return disable;
    };
    TransientModalComponent.prototype.close = function (value) {
        this.transientTableComponent.cleanSelected();
        this.closed.emit(value);
        this.transientModal.hide();
    };
    TransientModalComponent.prototype.cancel = function () {
        this.close(false);
    };
    TransientModalComponent.prototype.onHasSearched = function () {
        var _this = this;
        var obs$ = this.transientReservationStore.searchResults.take(1);
        obs$.subscribe(function (page) {
            _this.searchResults = page;
        });
    };
    TransientModalComponent.prototype.onRefreshList = function (page) {
        this.transientSearchComponent.refreshTransientReservations(page);
    };
    TransientModalComponent.prototype.isMultiVendor = function () {
        return this.authenticationStore.hasPermission('MultiVendor');
    };
    return TransientModalComponent;
}());
transient_modal_component___decorate([
    Object(core_es5["ViewChild"])(ngx_bootstrap["b" /* ModalDirective */]),
    transient_modal_component___metadata("design:type", typeof (transient_modal_component__a = typeof ngx_bootstrap["b" /* ModalDirective */] !== "undefined" && ngx_bootstrap["b" /* ModalDirective */]) === "function" && transient_modal_component__a || Object)
], transient_modal_component_TransientModalComponent.prototype, "transientModal", void 0);
transient_modal_component___decorate([
    Object(core_es5["ViewChild"])(transient_table_component_TransientTableComponent),
    transient_modal_component___metadata("design:type", typeof (transient_modal_component__b = typeof transient_table_component_TransientTableComponent !== "undefined" && transient_table_component_TransientTableComponent) === "function" && transient_modal_component__b || Object)
], transient_modal_component_TransientModalComponent.prototype, "transientTableComponent", void 0);
transient_modal_component___decorate([
    Object(core_es5["ViewChild"])(transient_search_component_TransientSearchComponent),
    transient_modal_component___metadata("design:type", typeof (transient_modal_component__c = typeof transient_search_component_TransientSearchComponent !== "undefined" && transient_search_component_TransientSearchComponent) === "function" && transient_modal_component__c || Object)
], transient_modal_component_TransientModalComponent.prototype, "transientSearchComponent", void 0);
transient_modal_component___decorate([
    Object(core_es5["Output"])(),
    transient_modal_component___metadata("design:type", Object)
], transient_modal_component_TransientModalComponent.prototype, "closed", void 0);
transient_modal_component___decorate([
    Object(core_es5["Input"])(),
    transient_modal_component___metadata("design:type", Object)
], transient_modal_component_TransientModalComponent.prototype, "config", void 0);
transient_modal_component___decorate([
    Object(core_es5["Input"])(),
    transient_modal_component___metadata("design:type", typeof (transient_modal_component__d = typeof OnyxEvent !== "undefined" && OnyxEvent) === "function" && transient_modal_component__d || Object)
], transient_modal_component_TransientModalComponent.prototype, "event", void 0);
transient_modal_component_TransientModalComponent = transient_modal_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-transient-modal',
        template: __webpack_require__("wn9K")
    }),
    transient_modal_component___metadata("design:paramtypes", [typeof (transient_modal_component__e = typeof transient_reservation_store_TransientReservationStore !== "undefined" && transient_reservation_store_TransientReservationStore) === "function" && transient_modal_component__e || Object, typeof (transient_modal_component__f = typeof reservation_compare_store_ReservationCompareStore !== "undefined" && reservation_compare_store_ReservationCompareStore) === "function" && transient_modal_component__f || Object, typeof (transient_modal_component__g = typeof flash_messages_service_FlashMessagesService !== "undefined" && flash_messages_service_FlashMessagesService) === "function" && transient_modal_component__g || Object, typeof (transient_modal_component__h = typeof authentication_store_AuthenticationStore !== "undefined" && authentication_store_AuthenticationStore) === "function" && transient_modal_component__h || Object])
], transient_modal_component_TransientModalComponent);

var transient_modal_component__a, transient_modal_component__b, transient_modal_component__c, transient_modal_component__d, transient_modal_component__e, transient_modal_component__f, transient_modal_component__g, transient_modal_component__h;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/transient-modal.component.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/reservations/vendor-reservation-card/vendor-reservation-card.component.ts
var vendor_reservation_card_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var vendor_reservation_card_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};











var vendor_reservation_card_component_VendorReservationCardComponent = (function () {
    function VendorReservationCardComponent(eventStore, reservationCompareStore, menuStore, router, authStore, formBuilder, environment) {
        this.eventStore = eventStore;
        this.reservationCompareStore = reservationCompareStore;
        this.menuStore = menuStore;
        this.router = router;
        this.authStore = authStore;
        this.formBuilder = formBuilder;
        this.environment = environment;
        this.vendorFormValidators = {};
        this.imagesUrl = '';
    }
    VendorReservationCardComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.imagesUrl = this.environment.onyxGPImagesCommonDataUrl;
        this.eventStore.selectedEvent.subscribe(function (event) { return _this.onyxEvent = event; });
        if (this.onyxEvent) {
            this.menuStore.setPageHeader(EventUtils.getEventName(this.onyxEvent, this.authStore.isAgencyUser()), this.onyxEvent.eventProperty.subscriber);
        }
        this.disableCompareButton$ = this.reservationCompareStore.isVendorCompareListEmpty(this.vendor.eventPartyId);
        this.showReservationCompareSummary$ = this.reservationCompareStore.getShowReservationCompareSummary();
        this.areReservationsPresent$ = this.reservationCompareStore.areVendorReservationPresent(this.vendor.eventPartyId);
        this.checkDetailPath(this.router.url);
        if (this.vendors) {
            if (this.vendors.length === 1) {
                this.vendor.isExpanded = true;
            }
        }
        this.createForm();
        this.headerRecordType = SummaryRecordTypeEnum.RESERVATION;
    };
    VendorReservationCardComponent.prototype.createForm = function () {
        this.vendorForm = this.formBuilder.group({
            vendorName: this.vendor.name,
            vendorAdress: this.getVendorAddress(),
            vendorState: this.vendor.state,
            vendorZip: this.vendor.postalCode
        }, this.vendorFormValidators);
    };
    VendorReservationCardComponent.prototype.getVendorAddress = function () {
        return this.vendor.line1;
    };
    VendorReservationCardComponent.prototype.navigateTo = function (path) {
        this.checkDetailPath(path);
        this.router.navigate([path]);
    };
    VendorReservationCardComponent.prototype.checkDetailPath = function (path) {
        this.isInDetail = path.indexOf('/detail') !== -1;
    };
    VendorReservationCardComponent.prototype.onCardExpandClicked = function (event, eventPartyId, chain, brand, propertyId, expanded) {
        event.preventDefault();
        if (eventPartyId) {
            this.vendors.filter(function (ve) { return ve.eventPartyId === eventPartyId; }).forEach(function (x) {
                x.isExpanded = expanded;
            });
        }
        else {
            this.vendors.filter(function (ve) { return ve.chain === chain && ve.brand === brand && ve.propertyId === propertyId; }).forEach(function (x) {
                x.isExpanded = expanded;
            });
        }
        if (expanded && this.vendors.length > 1) {
            this.disableOthers(eventPartyId, chain, brand, propertyId);
        }
    };
    VendorReservationCardComponent.prototype.disableOthers = function (eventPartyId, chain, brand, propertyId) {
        if (eventPartyId) {
            this.vendors.filter(function (ve) { return ve.eventPartyId !== eventPartyId; }).forEach(function (x) {
                x.isExpanded = false;
            });
        }
        else {
            this.vendors.filter(function (ve) { return ve.chain !== chain || ve.brand !== brand || ve.propertyId !== propertyId; }).forEach(function (x) {
                x.isExpanded = false;
            });
        }
    };
    return VendorReservationCardComponent;
}());
vendor_reservation_card_component___decorate([
    Object(core_es5["Input"])(),
    vendor_reservation_card_component___metadata("design:type", Array)
], vendor_reservation_card_component_VendorReservationCardComponent.prototype, "vendors", void 0);
vendor_reservation_card_component___decorate([
    Object(core_es5["Input"])(),
    vendor_reservation_card_component___metadata("design:type", typeof (vendor_reservation_card_component__a = typeof Party !== "undefined" && Party) === "function" && vendor_reservation_card_component__a || Object)
], vendor_reservation_card_component_VendorReservationCardComponent.prototype, "vendor", void 0);
vendor_reservation_card_component_VendorReservationCardComponent = vendor_reservation_card_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-vendor-reservation-card',
        template: __webpack_require__("hZwZ"),
        styles: [__webpack_require__("YYg3")]
    }),
    vendor_reservation_card_component___metadata("design:paramtypes", [typeof (vendor_reservation_card_component__b = typeof event_store_EventStore !== "undefined" && event_store_EventStore) === "function" && vendor_reservation_card_component__b || Object, typeof (vendor_reservation_card_component__c = typeof reservation_compare_store_ReservationCompareStore !== "undefined" && reservation_compare_store_ReservationCompareStore) === "function" && vendor_reservation_card_component__c || Object, typeof (vendor_reservation_card_component__d = typeof menu_store_MenuStore !== "undefined" && menu_store_MenuStore) === "function" && vendor_reservation_card_component__d || Object, typeof (vendor_reservation_card_component__e = typeof router_es5["Router"] !== "undefined" && router_es5["Router"]) === "function" && vendor_reservation_card_component__e || Object, typeof (vendor_reservation_card_component__f = typeof authentication_store_AuthenticationStore !== "undefined" && authentication_store_AuthenticationStore) === "function" && vendor_reservation_card_component__f || Object, typeof (vendor_reservation_card_component__g = typeof forms_es5["FormBuilder"] !== "undefined" && forms_es5["FormBuilder"]) === "function" && vendor_reservation_card_component__g || Object, typeof (vendor_reservation_card_component__h = typeof EnvironmentConfiguration !== "undefined" && EnvironmentConfiguration) === "function" && vendor_reservation_card_component__h || Object])
], vendor_reservation_card_component_VendorReservationCardComponent);

var vendor_reservation_card_component__a, vendor_reservation_card_component__b, vendor_reservation_card_component__c, vendor_reservation_card_component__d, vendor_reservation_card_component__e, vendor_reservation_card_component__f, vendor_reservation_card_component__g, vendor_reservation_card_component__h;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/vendor-reservation-card.component.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/rsvp/rsvp-bulk/rsvp-bulk.component.ts
var rsvp_bulk_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var rsvp_bulk_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};












var rsvp_bulk_component_RsvpBulkComponent = (function () {
    function RsvpBulkComponent(flashMessagesService, environment, rsvpStore, authenticationStore, errorHandlerService, translateService, reservationCompareStore) {
        this.flashMessagesService = flashMessagesService;
        this.environment = environment;
        this.rsvpStore = rsvpStore;
        this.authenticationStore = authenticationStore;
        this.errorHandlerService = errorHandlerService;
        this.translateService = translateService;
        this.reservationCompareStore = reservationCompareStore;
        this.isBeforeUpload = true;
        this.isAllowedToClosePopup = true;
        this.totalRecords = 0;
        this.processedRecords = 0;
        this.failedRecords = 0;
        this.config = {
            backdrop: 'static',
            keyboard: false
        };
        this.closed = new core_es5["EventEmitter"]();
    }
    Object.defineProperty(RsvpBulkComponent.prototype, "event", {
        set: function (event) {
            this.onyxEvent = event;
        },
        enumerable: true,
        configurable: true
    });
    RsvpBulkComponent.prototype.ngOnInit = function () {
        if (!this.onyxEvent) {
            throw new Error('The "event" attribute must be specified to use the RsvpBulk component');
        }
        this.fileExtensions = this.environment.rsvps.acceptedFileExtensions;
        this.acceptedFileTypes = this.environment.rsvps.acceptedFileTypes;
        this.templateUrl = this.environment.baseUrl
            + '/api/events/rsvps/import/template?Authorization='
            + this.authenticationStore.getToken();
        this.isAllowedToClosePopup = true;
    };
    RsvpBulkComponent.prototype.open = function () {
        this.rsvpBulkModal.show();
    };
    RsvpBulkComponent.prototype.close = function (value) {
        this.closed.emit(value);
        this.rsvpBulkModal.hide();
    };
    RsvpBulkComponent.prototype.cancel = function () {
        this.close(false);
        this.reset();
    };
    RsvpBulkComponent.prototype.reset = function () {
        this.isUploadInProgress = false;
        this.isBeforeUpload = true;
        this.isSuccessful = false;
        this.processedRecords = 0;
        this.totalRecords = 0;
        this.failedRecords = 0;
        this.rejectedFileUrl = null;
        this.isAllowedToClosePopup = true;
    };
    RsvpBulkComponent.prototype.importRsvpFile = function (inputEvent) {
        var _this = this;
        this.isUploadInProgress = true;
        if (!inputEvent || !inputEvent.srcElement || !inputEvent.srcElement.files || inputEvent.srcElement.files.size === 0) {
            this.handleUploadError('MESSAGES.ERROR.UPLOAD_BULK_RSVP');
            return;
        }
        var file = inputEvent.srcElement.files[0];
        this.clearFileInput();
        if (this.acceptedFileTypes.indexOf(file.type) < 0) {
            this.handleUploadError('MESSAGES.ERROR.UPLOAD_BULK_RSVP');
            return;
        }
        var eventId = this.onyxEvent.eventId;
        this.rsvpStore.importRsvpFile(eventId, this.vendor.eventPartyId, file)
            .finally(function () {
            _this.isBeforeUpload = false;
            _this.isUploadInProgress = false;
            if (_this.isSuccessful && _this.processedRecords === 0) {
                _this.handleNothingProcessed();
                return;
            }
        })
            .catch(function (error) {
            _this.isSuccessful = false;
            _this.isAllowedToClosePopup = false;
            _this.handleUploadError(_this.errorHandlerService.getErrorMessageFromBackendError(error), "Error uploading rsvps file: " + error);
            return Observable["Observable"].throw(error);
        })
            .subscribe(function (response) {
            _this.isSuccessful = response.failedRecords === 0;
            _this.totalRecords = response.totalRecords;
            _this.processedRecords = response.processedRecords;
            _this.failedRecords = response.failedRecords;
            _this.rejectedFileUrl = response.rejectedFileUrl;
            if (!_this.isSuccessful) {
                _this.isAllowedToClosePopup = false;
            }
            if (_this.isMultiVendor()) {
                _this.reservationCompareStore.refreshCurrentRsvpList(_this.onyxEvent.eventId);
            }
            else {
                _this.reservationCompareStore.refreshCurrentRsvpListByParty(_this.onyxEvent.eventId, _this.onyxEvent.eventProperty.eventPartyId);
            }
        });
    };
    RsvpBulkComponent.prototype.handleUploadError = function (errorMessage, logMessage) {
        if (logMessage === void 0) { logMessage = null; }
        this.isUploadInProgress = false;
        this.flashMessagesService.error(errorMessage, logMessage);
    };
    RsvpBulkComponent.prototype.handleNothingProcessed = function () {
        this.isBeforeUpload = true;
        this.flashMessagesService.error(this.translateService.instant('EVENT.RSVPS.UPLOAD_BULK_RESERVATION.EMPTY_FILE'));
    };
    /**
     * This needs to be called whenever we do an upload so that someone could do a second upload with a different file
     * without having to reload the page.
     */
    RsvpBulkComponent.prototype.clearFileInput = function () {
        this.fileInput.nativeElement.value = null;
    };
    RsvpBulkComponent.prototype.fileDownloaded = function () {
        this.isAllowedToClosePopup = true;
    };
    RsvpBulkComponent.prototype.isMultiVendor = function () {
        return this.authenticationStore.hasPermission('MultiVendor');
    };
    return RsvpBulkComponent;
}());
rsvp_bulk_component___decorate([
    Object(core_es5["ViewChild"])(ngx_bootstrap["b" /* ModalDirective */]),
    rsvp_bulk_component___metadata("design:type", typeof (rsvp_bulk_component__a = typeof ngx_bootstrap["b" /* ModalDirective */] !== "undefined" && ngx_bootstrap["b" /* ModalDirective */]) === "function" && rsvp_bulk_component__a || Object)
], rsvp_bulk_component_RsvpBulkComponent.prototype, "rsvpBulkModal", void 0);
rsvp_bulk_component___decorate([
    Object(core_es5["Input"])(),
    rsvp_bulk_component___metadata("design:type", typeof (rsvp_bulk_component__b = typeof Party !== "undefined" && Party) === "function" && rsvp_bulk_component__b || Object)
], rsvp_bulk_component_RsvpBulkComponent.prototype, "vendor", void 0);
rsvp_bulk_component___decorate([
    Object(core_es5["ViewChild"])('file'),
    rsvp_bulk_component___metadata("design:type", typeof (rsvp_bulk_component__c = typeof core_es5["ElementRef"] !== "undefined" && core_es5["ElementRef"]) === "function" && rsvp_bulk_component__c || Object)
], rsvp_bulk_component_RsvpBulkComponent.prototype, "fileInput", void 0);
rsvp_bulk_component___decorate([
    Object(core_es5["Input"])('event'),
    rsvp_bulk_component___metadata("design:type", typeof (rsvp_bulk_component__d = typeof OnyxEvent !== "undefined" && OnyxEvent) === "function" && rsvp_bulk_component__d || Object),
    rsvp_bulk_component___metadata("design:paramtypes", [typeof (rsvp_bulk_component__e = typeof OnyxEvent !== "undefined" && OnyxEvent) === "function" && rsvp_bulk_component__e || Object])
], rsvp_bulk_component_RsvpBulkComponent.prototype, "event", null);
rsvp_bulk_component___decorate([
    Object(core_es5["Input"])(),
    rsvp_bulk_component___metadata("design:type", Object)
], rsvp_bulk_component_RsvpBulkComponent.prototype, "config", void 0);
rsvp_bulk_component___decorate([
    Object(core_es5["Output"])(),
    rsvp_bulk_component___metadata("design:type", Object)
], rsvp_bulk_component_RsvpBulkComponent.prototype, "closed", void 0);
rsvp_bulk_component_RsvpBulkComponent = rsvp_bulk_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-rsvp-bulk',
        template: __webpack_require__("dFVK"),
        styles: [__webpack_require__("7CrU")]
    }),
    rsvp_bulk_component___metadata("design:paramtypes", [typeof (rsvp_bulk_component__f = typeof flash_messages_service_FlashMessagesService !== "undefined" && flash_messages_service_FlashMessagesService) === "function" && rsvp_bulk_component__f || Object, typeof (rsvp_bulk_component__g = typeof EnvironmentConfiguration !== "undefined" && EnvironmentConfiguration) === "function" && rsvp_bulk_component__g || Object, typeof (rsvp_bulk_component__h = typeof rsvp_store_RsvpStore !== "undefined" && rsvp_store_RsvpStore) === "function" && rsvp_bulk_component__h || Object, typeof (rsvp_bulk_component__j = typeof authentication_store_AuthenticationStore !== "undefined" && authentication_store_AuthenticationStore) === "function" && rsvp_bulk_component__j || Object, typeof (rsvp_bulk_component__k = typeof error_handler_service_ErrorHandlerService !== "undefined" && error_handler_service_ErrorHandlerService) === "function" && rsvp_bulk_component__k || Object, typeof (rsvp_bulk_component__l = typeof core["c" /* TranslateService */] !== "undefined" && core["c" /* TranslateService */]) === "function" && rsvp_bulk_component__l || Object, typeof (rsvp_bulk_component__m = typeof reservation_compare_store_ReservationCompareStore !== "undefined" && reservation_compare_store_ReservationCompareStore) === "function" && rsvp_bulk_component__m || Object])
], rsvp_bulk_component_RsvpBulkComponent);

var rsvp_bulk_component__a, rsvp_bulk_component__b, rsvp_bulk_component__c, rsvp_bulk_component__d, rsvp_bulk_component__e, rsvp_bulk_component__f, rsvp_bulk_component__g, rsvp_bulk_component__h, rsvp_bulk_component__j, rsvp_bulk_component__k, rsvp_bulk_component__l, rsvp_bulk_component__m;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/rsvp-bulk.component.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/rsvp/rsvp-form/rsvp-form.component.ts
var rsvp_form_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var rsvp_form_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};










var rsvp_form_component_RsvpFormComponent = (function () {
    function RsvpFormComponent(formBuilder, rsvpStore, reservationCompareStore, authenticationStore) {
        this.formBuilder = formBuilder;
        this.rsvpStore = rsvpStore;
        this.reservationCompareStore = reservationCompareStore;
        this.authenticationStore = authenticationStore;
    }
    RsvpFormComponent.prototype.ngOnInit = function () {
        if (!this.event) {
            throw new Error('The "event" attribute must be specified to use the RsvpFormComponent component');
        }
        this.initForm(null);
    };
    RsvpFormComponent.prototype.initForm = function (rsvp) {
        this.rsvpForm = this.formBuilder.group({
            firstName: [rsvp ? rsvp.firstName : null, [forms_es5["Validators"].maxLength(50)]],
            lastName: [rsvp ? rsvp.lastName : null, [forms_es5["Validators"].required, forms_es5["Validators"].maxLength(50)]],
            roomRate: [rsvp ? rsvp.roomRate : null, [forms_es5["Validators"].required, pioneer_validators_PioneerValidators.isValidAmountInRange(0, 9999999999999.99)]],
            checkInDate: [rsvp ? rsvp.checkInDate : null, [forms_es5["Validators"].required, pioneer_validators_PioneerValidators.isDate]],
            checkOutDate: [rsvp ? rsvp.checkOutDate : null, [forms_es5["Validators"].required, pioneer_validators_PioneerValidators.isDate]],
            roomType: [rsvp ? rsvp.roomType : null, [forms_es5["Validators"].maxLength(6)]],
            confirmation: [rsvp ? rsvp.confirmation : null, [forms_es5["Validators"].maxLength(32)]],
        }, {
            validator: pioneer_validators_PioneerValidators.isEndDateAfterStartDateCrossValidator('checkInDate', 'checkOutDate')
        });
    };
    RsvpFormComponent.prototype.init = function (rsvp) {
        this.initForm(rsvp);
    };
    RsvpFormComponent.prototype.addRsvp = function () {
        return this.addUpdateRsvp();
    };
    RsvpFormComponent.prototype.updateRsvp = function (eventRsvpId) {
        return this.addUpdateRsvp(eventRsvpId);
    };
    /**
     * Adds or updates and RSVP by the RSVP identifier
     *
     * @param [eventRsvpId] Optional: the ID of the RSVP
     * @returns an observer
     */
    RsvpFormComponent.prototype.addUpdateRsvp = function (eventRsvpId) {
        var _this = this;
        this.rsvpForm.disable();
        var obs$ = new Observable["Observable"](function (observer) {
            var methodObs$;
            if (eventRsvpId) {
                methodObs$ = _this.rsvpStore.updateRsvp(_this.setRsvp(eventRsvpId));
            }
            else {
                methodObs$ = _this.rsvpStore.addRsvp(_this.setRsvp());
            }
            methodObs$.catch(function (error) {
                _this.rsvpForm.enable();
                observer.error();
                return Observable["Observable"].throw(error);
            }).subscribe(function () {
                if (_this.isMultiVendor()) {
                    _this.reservationCompareStore.refreshCurrentRsvpList(_this.event.eventId);
                }
                else {
                    _this.reservationCompareStore.refreshCurrentRsvpListByParty(_this.event.eventId, _this.event.eventProperty.eventPartyId);
                }
                _this.resetForm();
                _this.rsvpForm.enable();
                observer.next();
            });
        });
        return obs$;
    };
    /**
     * Sets an RSVP with the data from the form
     *
     * @param [eventRsvpId] Optional: the ID of the RSVP
     * @returns the new RSVP created
     */
    RsvpFormComponent.prototype.setRsvp = function (eventRsvpId) {
        return new Rsvp({
            eventRsvpId: eventRsvpId ? eventRsvpId : null,
            eventId: this.event.eventId,
            firstName: this.rsvpForm.get('firstName').value,
            lastName: this.rsvpForm.get('lastName').value,
            roomRate: this.rsvpForm.get('roomRate').value,
            checkInDate: this.rsvpForm.get('checkInDate').value,
            checkOutDate: this.rsvpForm.get('checkOutDate').value,
            roomType: this.rsvpForm.get('roomType').value,
            confirmation: this.rsvpForm.get('confirmation').value,
            eventPartyId: this.vendor.eventPartyId
        });
    };
    RsvpFormComponent.prototype.cancelEditRsvp = function () {
        this.resetForm();
    };
    RsvpFormComponent.prototype.resetForm = function () {
        this.rsvpForm.reset({
            firstName: null,
            lastName: null,
            roomRate: null,
            checkInDate: null,
            checkOutDate: null,
            roomType: null,
            confirmation: null,
        });
    };
    RsvpFormComponent.prototype.isMultiVendor = function () {
        return this.authenticationStore.hasPermission('MultiVendor');
    };
    return RsvpFormComponent;
}());
rsvp_form_component___decorate([
    Object(core_es5["Input"])(),
    rsvp_form_component___metadata("design:type", typeof (rsvp_form_component__a = typeof OnyxEvent !== "undefined" && OnyxEvent) === "function" && rsvp_form_component__a || Object)
], rsvp_form_component_RsvpFormComponent.prototype, "event", void 0);
rsvp_form_component___decorate([
    Object(core_es5["Input"])(),
    rsvp_form_component___metadata("design:type", typeof (rsvp_form_component__b = typeof Party !== "undefined" && Party) === "function" && rsvp_form_component__b || Object)
], rsvp_form_component_RsvpFormComponent.prototype, "vendor", void 0);
rsvp_form_component_RsvpFormComponent = rsvp_form_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-rsvp-form',
        template: __webpack_require__("rLhm")
    }),
    rsvp_form_component___metadata("design:paramtypes", [typeof (rsvp_form_component__c = typeof forms_es5["FormBuilder"] !== "undefined" && forms_es5["FormBuilder"]) === "function" && rsvp_form_component__c || Object, typeof (rsvp_form_component__d = typeof rsvp_store_RsvpStore !== "undefined" && rsvp_store_RsvpStore) === "function" && rsvp_form_component__d || Object, typeof (rsvp_form_component__e = typeof reservation_compare_store_ReservationCompareStore !== "undefined" && reservation_compare_store_ReservationCompareStore) === "function" && rsvp_form_component__e || Object, typeof (rsvp_form_component__f = typeof authentication_store_AuthenticationStore !== "undefined" && authentication_store_AuthenticationStore) === "function" && rsvp_form_component__f || Object])
], rsvp_form_component_RsvpFormComponent);

var rsvp_form_component__a, rsvp_form_component__b, rsvp_form_component__c, rsvp_form_component__d, rsvp_form_component__e, rsvp_form_component__f;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/rsvp-form.component.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/rsvp/add-rsvp/add-rsvp.component.ts
var add_rsvp_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var add_rsvp_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

















var add_rsvp_component_AddRsvpComponent = (function () {
    function AddRsvpComponent(environment, flashMessagesService, paymentStore, pdfService, reservationCompareStore, reportService, eventValidationService, authStore) {
        this.environment = environment;
        this.flashMessagesService = flashMessagesService;
        this.paymentStore = paymentStore;
        this.pdfService = pdfService;
        this.reservationCompareStore = reservationCompareStore;
        this.reportService = reportService;
        this.eventValidationService = eventValidationService;
        this.authStore = authStore;
    }
    Object.defineProperty(AddRsvpComponent.prototype, "event", {
        set: function (event) {
            this.onyxEvent = event;
        },
        enumerable: true,
        configurable: true
    });
    AddRsvpComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.isUploadInProgress = false;
        this.isAddRsvpCollapsed = true;
        this.isRequestPaymentRejected = false;
        if (!this.onyxEvent) {
            throw new Error('The "event" attribute must be specified to use the AddRsvpComponent component');
        }
        if (!this.onyxEvent.eventId) {
            this.hasFinalPayment = false;
        }
        else {
            this.paymentStore.getVendorFinalPayment(this.vendor.eventPartyId).take(1).subscribe(function (lastFinalPayment) {
                var value = lastFinalPayment && lastFinalPayment.eventPaymentId;
                _this.hasFinalPayment = Boolean(value);
                var paymentStatus = lastFinalPayment && lastFinalPayment.status;
                _this.isRequestPaymentRejected = [PaymentStatus.REQUEST_REJECTED, PaymentStatus.REJECTED_WF_APPROVAL].some(function (status) { return status === paymentStatus; });
            });
        }
        this.fileExtensions = this.environment.rsvps.acceptedFileExtensions;
        this.rsvpCompareList = this.reservationCompareStore.getVendorCompareList(this.vendor.eventPartyId);
        this.canChangeRSVPs$ = this.eventValidationService.canChangeRsvps();
        this.showAddRsvpButtons = this.authStore.hasPermission(['AddRsvp', 'UploadRsvp']);
    };
    AddRsvpComponent.prototype.addRsvp = function () {
        var _this = this;
        var obs = this.rsvpComponent.addRsvp()
            .catch(function (error) {
            return error;
        });
        obs.subscribe(function () {
            _this.isAddRsvpCollapsed = true;
        });
        return obs;
    };
    AddRsvpComponent.prototype.cancelAddRsvp = function () {
        this.rsvpComponent.cancelEditRsvp();
        this.isAddRsvpCollapsed = true;
    };
    AddRsvpComponent.prototype.handleUploadError = function (errorMessage, logMessage) {
        if (logMessage === void 0) { logMessage = null; }
        this.isUploadInProgress = false;
        this.flashMessagesService.error(errorMessage, logMessage);
    };
    AddRsvpComponent.prototype.openUploadBulkRsvp = function () {
        this.rsvpBulk.open();
    };
    /**
     * This needs to be called whenever we do an upload so that someone could do a second upload with a different file
     * without having to reload the page.
     */
    AddRsvpComponent.prototype.clearFileInput = function () {
        this.fileInput.nativeElement.value = null;
    };
    AddRsvpComponent.prototype.disableSave = function () {
        var disable;
        if (this.rsvpComponent && this.rsvpComponent.rsvpForm) {
            disable = !this.rsvpComponent.rsvpForm.valid;
        }
        else {
            disable = true;
        }
        return disable;
    };
    AddRsvpComponent.prototype.getRsvpReport = function (fileType) {
        var _this = this;
        this.reportService.getRsvpReport(this.onyxEvent.eventId, this.vendor.eventPartyId, fileType, this.summarySelected)
            .subscribe(function (blob) {
            var filename = response_util_ResponseUtil.getFileNameFromHttpResponse(blob);
            if (!filename) {
                var reportType = _this.summarySelected ? ReportType.RSVP_SUMMARY : ReportType.RSVP_COMPARE;
                filename = _this.reportService.buildReportFileName(reportType, _this.onyxEvent, fileType);
            }
            saveAs(blob.body, filename);
        });
    };
    AddRsvpComponent.prototype.downloadRsvpCompare = function () {
        var _this = this;
        this.getMatches(MatchTypeEnum.NO_MATCH).take(1).subscribe(function (noMatchesListResponse) {
            var noMatchesList = noMatchesListResponse;
            _this.getMatches(MatchTypeEnum.PARTIAL_MATCH).take(1).subscribe(function (partialMatchesListResponse) {
                var partialMatchesList = partialMatchesListResponse;
                _this.getMatches(MatchTypeEnum.EXACT_MATCH).take(1).subscribe(function (exactMatchesListResponse) {
                    var exactMatchesList = exactMatchesListResponse;
                    _this.pdfService.downloadRsvpCompare(_this.onyxEvent, noMatchesList, partialMatchesList, exactMatchesList);
                });
            });
        });
    };
    AddRsvpComponent.prototype.getMatches = function (matchType) {
        return this.rsvpCompareList.map(function (comparisonList) {
            var list = comparisonList.filter(function (comparison) { return comparison.matchType === matchType.toString(); }).toList();
            return list;
        });
    };
    AddRsvpComponent.prototype.displayAddRsvp = function () {
        return this.isAddRsvpCollapsed && (!this.hasFinalPayment || this.isRequestPaymentRejected);
    };
    return AddRsvpComponent;
}());
add_rsvp_component___decorate([
    Object(core_es5["Input"])(),
    add_rsvp_component___metadata("design:type", Boolean)
], add_rsvp_component_AddRsvpComponent.prototype, "showDownloadDropdown", void 0);
add_rsvp_component___decorate([
    Object(core_es5["Input"])(),
    add_rsvp_component___metadata("design:type", typeof (add_rsvp_component__a = typeof Party !== "undefined" && Party) === "function" && add_rsvp_component__a || Object)
], add_rsvp_component_AddRsvpComponent.prototype, "vendor", void 0);
add_rsvp_component___decorate([
    Object(core_es5["ViewChild"])(rsvp_bulk_component_RsvpBulkComponent),
    add_rsvp_component___metadata("design:type", typeof (add_rsvp_component__b = typeof rsvp_bulk_component_RsvpBulkComponent !== "undefined" && rsvp_bulk_component_RsvpBulkComponent) === "function" && add_rsvp_component__b || Object)
], add_rsvp_component_AddRsvpComponent.prototype, "rsvpBulk", void 0);
add_rsvp_component___decorate([
    Object(core_es5["ViewChild"])(rsvp_form_component_RsvpFormComponent),
    add_rsvp_component___metadata("design:type", typeof (add_rsvp_component__c = typeof rsvp_form_component_RsvpFormComponent !== "undefined" && rsvp_form_component_RsvpFormComponent) === "function" && add_rsvp_component__c || Object)
], add_rsvp_component_AddRsvpComponent.prototype, "rsvpComponent", void 0);
add_rsvp_component___decorate([
    Object(core_es5["ViewChild"])('file'),
    add_rsvp_component___metadata("design:type", typeof (add_rsvp_component__d = typeof core_es5["ElementRef"] !== "undefined" && core_es5["ElementRef"]) === "function" && add_rsvp_component__d || Object)
], add_rsvp_component_AddRsvpComponent.prototype, "fileInput", void 0);
add_rsvp_component___decorate([
    Object(core_es5["Input"])(),
    add_rsvp_component___metadata("design:type", Boolean)
], add_rsvp_component_AddRsvpComponent.prototype, "summarySelected", void 0);
add_rsvp_component___decorate([
    Object(core_es5["Input"])('event'),
    add_rsvp_component___metadata("design:type", typeof (add_rsvp_component__e = typeof OnyxEvent !== "undefined" && OnyxEvent) === "function" && add_rsvp_component__e || Object),
    add_rsvp_component___metadata("design:paramtypes", [typeof (add_rsvp_component__f = typeof OnyxEvent !== "undefined" && OnyxEvent) === "function" && add_rsvp_component__f || Object])
], add_rsvp_component_AddRsvpComponent.prototype, "event", null);
add_rsvp_component_AddRsvpComponent = add_rsvp_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-add-rsvp',
        template: __webpack_require__("aYlK")
    }),
    add_rsvp_component___metadata("design:paramtypes", [typeof (add_rsvp_component__g = typeof EnvironmentConfiguration !== "undefined" && EnvironmentConfiguration) === "function" && add_rsvp_component__g || Object, typeof (add_rsvp_component__h = typeof flash_messages_service_FlashMessagesService !== "undefined" && flash_messages_service_FlashMessagesService) === "function" && add_rsvp_component__h || Object, typeof (add_rsvp_component__j = typeof payment_store_PaymentStore !== "undefined" && payment_store_PaymentStore) === "function" && add_rsvp_component__j || Object, typeof (add_rsvp_component__k = typeof pdf_service_PdfService !== "undefined" && pdf_service_PdfService) === "function" && add_rsvp_component__k || Object, typeof (add_rsvp_component__l = typeof reservation_compare_store_ReservationCompareStore !== "undefined" && reservation_compare_store_ReservationCompareStore) === "function" && add_rsvp_component__l || Object, typeof (add_rsvp_component__m = typeof report_service_ReportService !== "undefined" && report_service_ReportService) === "function" && add_rsvp_component__m || Object, typeof (add_rsvp_component__o = typeof event_validation_service_EventValidationService !== "undefined" && event_validation_service_EventValidationService) === "function" && add_rsvp_component__o || Object, typeof (add_rsvp_component__p = typeof authentication_store_AuthenticationStore !== "undefined" && authentication_store_AuthenticationStore) === "function" && add_rsvp_component__p || Object])
], add_rsvp_component_AddRsvpComponent);

var add_rsvp_component__a, add_rsvp_component__b, add_rsvp_component__c, add_rsvp_component__d, add_rsvp_component__e, add_rsvp_component__f, add_rsvp_component__g, add_rsvp_component__h, add_rsvp_component__j, add_rsvp_component__k, add_rsvp_component__l, add_rsvp_component__m, add_rsvp_component__o, add_rsvp_component__p;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/add-rsvp.component.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/rsvp/rsvp-compare/rsvp-compare.component.ts
var rsvp_compare_component___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var rsvp_compare_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var rsvp_compare_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var rsvp_compare_component___param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};

/* tslint:disable:no-access-missing-member */






















var rsvp_compare_component_RsvpCompareComponent = (function (_super) {
    rsvp_compare_component___extends(RsvpCompareComponent, _super);
    function RsvpCompareComponent(reservationCompareStore, authenticationStore, logService, pageScrollService, document, rsvpStore, paymentStore, userLocalStorageService) {
        var _this = _super.call(this, pageScrollService, document, rsvpStore) || this;
        _this.reservationCompareStore = reservationCompareStore;
        _this.authenticationStore = authenticationStore;
        _this.logService = logService;
        _this.paymentStore = paymentStore;
        _this.userLocalStorageService = userLocalStorageService;
        _this.ui = {
            showCards: false,
            showNoMatchesCard: false,
            showPartialMatchesCard: false,
            showExactMatchesCard: false,
            showNoReservationsWarning: false
        };
        _this.noMatchespagesizeType = PagesizeType.RSVP_NO_MATCHES;
        _this.partialMatchespagesizeType = PagesizeType.RSVP_PARTIAL_MATCHES;
        _this.exactMatchespagesizeType = PagesizeType.RSVP_EXACT_MATCHES;
        _this.matchSubscription = new Subscription["Subscription"]();
        return _this;
    }
    RsvpCompareComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (!this.onyxEvent) {
            throw new Error('The "event" attribute must be specified to use the "pioneer-rsvp-compare" component');
        }
        this.rsvpCompareList = this.reservationCompareStore.getVendorCompareList(this.vendor.eventPartyId);
        // all cards
        this.reservationCompareStore.isCompareListEmpty().subscribe(function (value) {
            _this.ui.showNoReservationsWarning = value;
            _this.ui.showCards = !value;
        });
        // no matches
        this.isMatchListEmpty(MatchTypeEnum.NO_MATCH).subscribe(function (value) {
            _this.ui.showNoMatchesCard = !value;
        });
        // partial matches
        this.isMatchListEmpty(MatchTypeEnum.PARTIAL_MATCH).subscribe(function (value) {
            _this.ui.showPartialMatchesCard = !value;
        });
        // exact matches
        this.isMatchListEmpty(MatchTypeEnum.EXACT_MATCH).subscribe(function (value) {
            _this.ui.showExactMatchesCard = !value;
        });
        this.confirmRsvpModal = EventReservationAction.RSVP_CONFIRMATION;
        this.headerRecordType = SummaryRecordTypeEnum.RSVP;
        if (!this.onyxEvent.eventId) {
            this.displayDropdown = true;
        }
        else {
            this.paymentStore.getLatestFinalPayment().take(1).subscribe(function (lastFinalPayment) {
                var hasFinalPayment = Boolean(lastFinalPayment && lastFinalPayment.eventPaymentId);
                _this.displayDropdown = !hasFinalPayment || PaymentStatus.REJECTED_WF_APPROVAL === lastFinalPayment.status;
            });
        }
        // Build no matches page
        this.noMatchPage = page_Page.empty();
        this.noMatchPage.size = this.userLocalStorageService.getPagesize(PagesizeType.RSVP_NO_MATCHES);
        this.buildMatchPage(this.noMatchPage, MatchTypeEnum.NO_MATCH);
        // Build partial matches page
        this.partialMatchPage = page_Page.empty();
        this.partialMatchPage.size = this.userLocalStorageService.getPagesize(PagesizeType.RSVP_PARTIAL_MATCHES);
        this.buildMatchPage(this.partialMatchPage, MatchTypeEnum.PARTIAL_MATCH);
        // Build exact matches page
        this.exactMatchPage = page_Page.empty();
        this.exactMatchPage.size = this.userLocalStorageService.getPagesize(PagesizeType.RSVP_EXACT_MATCHES);
        this.buildMatchPage(this.exactMatchPage, MatchTypeEnum.EXACT_MATCH);
    };
    RsvpCompareComponent.prototype.buildMatchPage = function (matchPage, matchType) {
        var _this = this;
        this.matchSubscription.add(this.getMatches(matchType).subscribe(function (reservationList) {
            var rsvpId = _this.reservationCompareStore.selectedRsvpId;
            if (rsvpId) {
                var index = reservationList.findIndex(function (compare) {
                    return compare.rsvp && compare.rsvp.eventRsvpId === rsvpId;
                });
                if (index >= 0) {
                    matchPage.number = Math.floor(index / matchPage.size);
                }
            }
            var page = matchPage.number;
            var itemsPerPage = matchPage.size;
            matchPage.content = Object(immutable["List"])(reservationList.slice(page * itemsPerPage, (page + 1) * itemsPerPage));
            matchPage.totalElements = reservationList.size;
            matchPage.numberOfElements = matchPage.content.size;
        }));
    };
    RsvpCompareComponent.prototype.ngAfterViewInit = function () {
        var rsvpId = this.reservationCompareStore.selectedRsvpId;
        this.logService.verbose("rsvp: " + rsvpId);
        if (rsvpId) {
            var elem = void 0;
            var id = this.getRsvpId(rsvpId);
            elem = document.querySelector("[data-rsvp-id=" + id + "]");
            elem.classList.add('highlight');
            this.logService.verbose("page scrolling to selector: [data-rsvp-id=" + id + "]");
            this.scrollToElement(elem);
        }
    };
    RsvpCompareComponent.prototype.ngOnDestroy = function () {
        this.matchSubscription.unsubscribe();
    };
    Object.defineProperty(RsvpCompareComponent.prototype, "rsvps", {
        get: function () {
            return this.rsvpCompareList;
        },
        enumerable: true,
        configurable: true
    });
    RsvpCompareComponent.prototype.getMatches = function (matchType) {
        return this.rsvps.map(function (comparisonList) {
            return comparisonList.filter(function (comparison) { return comparison.matchType === matchType.toString(); }).toList();
        });
    };
    RsvpCompareComponent.prototype.isMatchListEmpty = function (matchType) {
        return reservation_utils_ReservationUtils.isListEmpty(this.getMatches(matchType));
    };
    RsvpCompareComponent.prototype.confirmBeforeDelete = function (event, rsvp) {
        event.preventDefault();
        this.rsvpToRemove = rsvp;
        this.confirmDeleteModal.open();
    };
    RsvpCompareComponent.prototype.confirmDeleteHandler = function (deleteConfirmed) {
        if (deleteConfirmed) {
            this.deleteRsvp(this.rsvpToRemove);
        }
        this.rsvpToRemove = null;
    };
    RsvpCompareComponent.prototype.deleteRsvp = function (rsvp) {
        var _this = this;
        rsvp.eventId = this.onyxEvent.eventId;
        var obs = this.rsvpStore.deleteRsvp(rsvp);
        obs.subscribe(function () {
            if (_this.isMultiVendor()) {
                _this.reservationCompareStore.refreshCurrentRsvpList(_this.onyxEvent.eventId);
            }
            else {
                _this.reservationCompareStore.refreshCurrentRsvpListByParty(_this.onyxEvent.eventId, _this.onyxEvent.eventProperty.eventPartyId);
            }
        });
        return obs;
    };
    RsvpCompareComponent.prototype.openReservationModal = function (event, rsvp) {
        event.preventDefault();
        var reservation = new Reservation({
            firstName: rsvp.firstName,
            lastName: rsvp.lastName,
            nights: rsvp.nights,
            roomRate: rsvp.roomRate,
            eventId: this.onyxEvent.eventId,
            confirmation: rsvp.confirmation,
            checkInDate: rsvp.checkInDate,
            checkOutDate: rsvp.checkOutDate,
            roomType: rsvp.roomType
        });
        this.reservationModal.open(reservation);
    };
    RsvpCompareComponent.prototype.openTransientReservationModal = function (event, rsvp) {
        event.preventDefault();
        this.transientModal.open(rsvp);
    };
    Object.defineProperty(RsvpCompareComponent.prototype, "canManageReservations", {
        get: function () {
            return this.onyxEvent.canManageReservations;
        },
        enumerable: true,
        configurable: true
    });
    RsvpCompareComponent.prototype.updateRsvp = function (rsvpToUpdate) {
        var _this = this;
        var obs$ = _super.prototype.updateRsvp.call(this, rsvpToUpdate);
        obs$.subscribe(function () {
            if (_this.isMultiVendor()) {
                _this.reservationCompareStore.refreshCurrentRsvpList(_this.onyxEvent.eventId);
            }
            else {
                _this.reservationCompareStore.refreshCurrentRsvpListByParty(_this.onyxEvent.eventId, _this.onyxEvent.eventProperty.eventPartyId);
            }
        });
        return obs$;
    };
    RsvpCompareComponent.prototype.onRefreshNoMatchList = function (pageNumber, itemsPerPage) {
        this.onRefreshMatchPage(pageNumber, itemsPerPage, MatchTypeEnum.NO_MATCH, this.noMatchPage);
    };
    RsvpCompareComponent.prototype.onRefreshPartialMatchList = function (pageNumber, itemsPerPage) {
        this.onRefreshMatchPage(pageNumber, itemsPerPage, MatchTypeEnum.PARTIAL_MATCH, this.partialMatchPage);
    };
    RsvpCompareComponent.prototype.onRefreshExactMatchList = function (pageNumber, itemsPerPage) {
        this.onRefreshMatchPage(pageNumber, itemsPerPage, MatchTypeEnum.EXACT_MATCH, this.exactMatchPage);
    };
    RsvpCompareComponent.prototype.onRefreshMatchPage = function (pageNumber, itemsPerPage, matchType, page) {
        this.getMatches(matchType).take(1).subscribe(function (reservationList) {
            page.content = Object(immutable["List"])(reservationList.slice(pageNumber * itemsPerPage, (pageNumber + 1) * itemsPerPage));
            page.number = pageNumber;
            page.size = itemsPerPage;
            page.totalElements = reservationList.size;
            page.numberOfElements = page.content.size;
        });
    };
    RsvpCompareComponent.prototype.isMultiVendor = function () {
        return this.authenticationStore.hasPermission('MultiVendor');
    };
    return RsvpCompareComponent;
}(compare_table_abstract_CompareTableAbstract));
rsvp_compare_component___decorate([
    Object(core_es5["Input"])(),
    rsvp_compare_component___metadata("design:type", typeof (rsvp_compare_component__a = typeof Party !== "undefined" && Party) === "function" && rsvp_compare_component__a || Object)
], rsvp_compare_component_RsvpCompareComponent.prototype, "vendor", void 0);
rsvp_compare_component___decorate([
    Object(core_es5["ViewChild"])('confirmDeleteModal'),
    rsvp_compare_component___metadata("design:type", typeof (rsvp_compare_component__b = typeof confirmation_modal_component_ConfirmationModalComponent !== "undefined" && confirmation_modal_component_ConfirmationModalComponent) === "function" && rsvp_compare_component__b || Object)
], rsvp_compare_component_RsvpCompareComponent.prototype, "confirmDeleteModal", void 0);
rsvp_compare_component___decorate([
    Object(core_es5["ViewChild"])('confirmUpdateRsvpModal'),
    rsvp_compare_component___metadata("design:type", typeof (rsvp_compare_component__c = typeof confirmation_modal_component_ConfirmationModalComponent !== "undefined" && confirmation_modal_component_ConfirmationModalComponent) === "function" && rsvp_compare_component__c || Object)
], rsvp_compare_component_RsvpCompareComponent.prototype, "confirmUpdateRsvpModal", void 0);
rsvp_compare_component___decorate([
    Object(core_es5["ViewChild"])(transient_modal_component_TransientModalComponent),
    rsvp_compare_component___metadata("design:type", typeof (rsvp_compare_component__d = typeof transient_modal_component_TransientModalComponent !== "undefined" && transient_modal_component_TransientModalComponent) === "function" && rsvp_compare_component__d || Object)
], rsvp_compare_component_RsvpCompareComponent.prototype, "transientModal", void 0);
rsvp_compare_component_RsvpCompareComponent = rsvp_compare_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-rsvp-compare',
        template: __webpack_require__("tKR5"),
        styles: [__webpack_require__("mrre")]
    }),
    rsvp_compare_component___param(4, Object(core_es5["Inject"])(common_es5["DOCUMENT"])),
    rsvp_compare_component___metadata("design:paramtypes", [typeof (rsvp_compare_component__e = typeof reservation_compare_store_ReservationCompareStore !== "undefined" && reservation_compare_store_ReservationCompareStore) === "function" && rsvp_compare_component__e || Object, typeof (rsvp_compare_component__f = typeof authentication_store_AuthenticationStore !== "undefined" && authentication_store_AuthenticationStore) === "function" && rsvp_compare_component__f || Object, typeof (rsvp_compare_component__g = typeof log_service_LogService !== "undefined" && log_service_LogService) === "function" && rsvp_compare_component__g || Object, typeof (rsvp_compare_component__h = typeof ng2_page_scroll["d" /* PageScrollService */] !== "undefined" && ng2_page_scroll["d" /* PageScrollService */]) === "function" && rsvp_compare_component__h || Object, Object, typeof (rsvp_compare_component__j = typeof rsvp_store_RsvpStore !== "undefined" && rsvp_store_RsvpStore) === "function" && rsvp_compare_component__j || Object, typeof (rsvp_compare_component__k = typeof payment_store_PaymentStore !== "undefined" && payment_store_PaymentStore) === "function" && rsvp_compare_component__k || Object, typeof (rsvp_compare_component__l = typeof user_local_storage_service_UserLocalStorageService !== "undefined" && user_local_storage_service_UserLocalStorageService) === "function" && rsvp_compare_component__l || Object])
], rsvp_compare_component_RsvpCompareComponent);

var rsvp_compare_component__a, rsvp_compare_component__b, rsvp_compare_component__c, rsvp_compare_component__d, rsvp_compare_component__e, rsvp_compare_component__f, rsvp_compare_component__g, rsvp_compare_component__h, rsvp_compare_component__j, rsvp_compare_component__k, rsvp_compare_component__l;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/rsvp-compare.component.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/rsvp/rsvp-modal/rsvp-modal.component.ts
var rsvp_modal_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var rsvp_modal_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};






var rsvp_modal_component_RsvpModalComponent = (function () {
    function RsvpModalComponent(translateService) {
        this.translateService = translateService;
        this.closed = new core_es5["EventEmitter"]();
        this.config = {
            backdrop: 'static',
            keyboard: false
        };
    }
    RsvpModalComponent.prototype.ngOnInit = function () {
        this.title = this.translateService.instant('EVENT.EDIT_RSVP_MODAL.TITLE');
    };
    RsvpModalComponent.prototype.open = function (rsvp, vendor) {
        if (!this.event) {
            throw new Error(this.translateService.instant('EVENT.EDIT_RSVP_MODAL.NO_EVENT_ERROR'));
        }
        if (!rsvp) {
            throw new Error(this.translateService.instant('EVENT.EDIT_RSVP_MODAL.NO_RSVP_ERROR'));
        }
        this.rsvp = rsvp;
        this.vendor = vendor;
        this.rsvpFormComponent.init(rsvp);
        this.rsvpModal.show();
    };
    RsvpModalComponent.prototype.close = function (value) {
        this.closed.emit(value);
        this.rsvpModal.hide();
    };
    RsvpModalComponent.prototype.cancel = function () {
        this.rsvpFormComponent.cancelEditRsvp();
        this.close(false);
    };
    RsvpModalComponent.prototype.accept = function () {
        var _this = this;
        var obs = new Observable["Observable"]();
        obs = this.rsvpFormComponent.updateRsvp(this.rsvp.eventRsvpId);
        obs.subscribe(function () { _this.close(true); });
        return obs;
    };
    RsvpModalComponent.prototype.disableSave = function () {
        var disable;
        if (this.rsvpFormComponent && this.rsvpFormComponent.rsvpForm) {
            disable = !this.rsvpFormComponent.rsvpForm.valid;
        }
        else {
            disable = true;
        }
        return disable;
    };
    return RsvpModalComponent;
}());
rsvp_modal_component___decorate([
    Object(core_es5["ViewChild"])(ngx_bootstrap["b" /* ModalDirective */]),
    rsvp_modal_component___metadata("design:type", typeof (rsvp_modal_component__a = typeof ngx_bootstrap["b" /* ModalDirective */] !== "undefined" && ngx_bootstrap["b" /* ModalDirective */]) === "function" && rsvp_modal_component__a || Object)
], rsvp_modal_component_RsvpModalComponent.prototype, "rsvpModal", void 0);
rsvp_modal_component___decorate([
    Object(core_es5["ViewChild"])(rsvp_form_component_RsvpFormComponent),
    rsvp_modal_component___metadata("design:type", typeof (rsvp_modal_component__b = typeof rsvp_form_component_RsvpFormComponent !== "undefined" && rsvp_form_component_RsvpFormComponent) === "function" && rsvp_modal_component__b || Object)
], rsvp_modal_component_RsvpModalComponent.prototype, "rsvpFormComponent", void 0);
rsvp_modal_component___decorate([
    Object(core_es5["Output"])(),
    rsvp_modal_component___metadata("design:type", Object)
], rsvp_modal_component_RsvpModalComponent.prototype, "closed", void 0);
rsvp_modal_component___decorate([
    Object(core_es5["Input"])(),
    rsvp_modal_component___metadata("design:type", typeof (rsvp_modal_component__c = typeof OnyxEvent !== "undefined" && OnyxEvent) === "function" && rsvp_modal_component__c || Object)
], rsvp_modal_component_RsvpModalComponent.prototype, "event", void 0);
rsvp_modal_component___decorate([
    Object(core_es5["Input"])(),
    rsvp_modal_component___metadata("design:type", Object)
], rsvp_modal_component_RsvpModalComponent.prototype, "config", void 0);
rsvp_modal_component_RsvpModalComponent = rsvp_modal_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-rsvp-modal',
        template: __webpack_require__("oJBG")
    }),
    rsvp_modal_component___metadata("design:paramtypes", [typeof (rsvp_modal_component__d = typeof core["c" /* TranslateService */] !== "undefined" && core["c" /* TranslateService */]) === "function" && rsvp_modal_component__d || Object])
], rsvp_modal_component_RsvpModalComponent);

var rsvp_modal_component__a, rsvp_modal_component__b, rsvp_modal_component__c, rsvp_modal_component__d;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/rsvp-modal.component.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/rsvp/rsvp-summary/rsvp-summary.component.ts
var rsvp_summary_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var rsvp_summary_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};


















var rsvp_summary_component_RsvpSummaryComponent = (function () {
    function RsvpSummaryComponent(rsvpStore, reservationCompareStore, paymentStore, authenticationStore, userLocalStorageService, eventValidationService) {
        this.rsvpStore = rsvpStore;
        this.reservationCompareStore = reservationCompareStore;
        this.paymentStore = paymentStore;
        this.authenticationStore = authenticationStore;
        this.userLocalStorageService = userLocalStorageService;
        this.eventValidationService = eventValidationService;
        this.rsvpSubscription = new Subscription["Subscription"]();
        this.pagesizeType = PagesizeType.RSVP_SUMMARY;
    }
    Object.defineProperty(RsvpSummaryComponent.prototype, "event", {
        set: function (event) {
            this.onyxEvent = event;
        },
        enumerable: true,
        configurable: true
    });
    RsvpSummaryComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (!this.onyxEvent) {
            throw new Error('The "event" attribute must be specified to use the "pioneer-rsvp-summary" component');
        }
        this.rsvpPage = page_Page.empty();
        this.rsvpPage.size = this.userLocalStorageService.getPagesize(PagesizeType.RSVP_SUMMARY);
        this.rsvpSubscription.add(this.getFilteredRsvps().subscribe(function (reservationList) {
            var page = _this.rsvpPage.number;
            var itemsPerPage = _this.rsvpPage.size;
            _this.rsvpPage.content = Object(immutable["List"])(reservationList.slice(page * itemsPerPage, (page + 1) * itemsPerPage));
            _this.rsvpPage.totalElements = reservationList.size;
            _this.rsvpPage.numberOfElements = _this.rsvpPage.content.size;
        }));
        this.headerRecordType = SummaryRecordTypeEnum.RSVP;
        if (!this.onyxEvent.eventId) {
            this.displayDropdown = true;
        }
        else {
            this.paymentStore.getVendorFinalPayment(this.vendor.eventPartyId).take(1).subscribe(function (lastFinalPayment) {
                var hasFinalPayment = Boolean(lastFinalPayment && lastFinalPayment.eventPaymentId);
                _this.displayDropdown = !hasFinalPayment || [PaymentStatus.REQUEST_REJECTED, PaymentStatus.REJECTED_WF_APPROVAL].some(function (status) { return status === lastFinalPayment.status; });
            });
        }
        this.canChangeRSVPs$ = this.eventValidationService.canChangeRsvps();
        this.rsvpDetailLink = '/rsvp/detail';
    };
    RsvpSummaryComponent.prototype.ngOnDestroy = function () {
        this.rsvpSubscription.unsubscribe();
    };
    Object.defineProperty(RsvpSummaryComponent.prototype, "isRsvpListEmpty", {
        get: function () {
            return reservation_utils_ReservationUtils.isListEmpty(this.getFilteredRsvps());
        },
        enumerable: true,
        configurable: true
    });
    RsvpSummaryComponent.prototype.confirmBeforeDelete = function (event, rsvp) {
        event.preventDefault();
        this.rsvpToRemove = rsvp;
        this.confirmationModal.open();
    };
    RsvpSummaryComponent.prototype.confirmHandler = function (deleteConfirmed) {
        if (deleteConfirmed) {
            this.deleteRsvp(this.rsvpToRemove);
        }
        this.rsvpToRemove = null;
    };
    RsvpSummaryComponent.prototype.openRsvpModal = function (event, rsvp, vendor) {
        event.preventDefault();
        this.rsvpModal.open(rsvp, vendor);
    };
    RsvpSummaryComponent.prototype.deleteRsvp = function (rsvp) {
        var _this = this;
        var obs = this.rsvpStore.deleteRsvp(rsvp);
        obs.subscribe(function () {
            if (_this.isMultiVendor()) {
                _this.reservationCompareStore.refreshCurrentRsvpList(_this.onyxEvent.eventId);
            }
            else {
                _this.reservationCompareStore.refreshCurrentRsvpListByParty(_this.onyxEvent.eventId, _this.onyxEvent.eventProperty.eventPartyId);
            }
        });
        return obs;
    };
    RsvpSummaryComponent.prototype.onRefreshRsvpList = function (pageNumber) {
        var _this = this;
        var itemsPerPage = this.userLocalStorageService.getPagesize(PagesizeType.RSVP_SUMMARY);
        this.getFilteredRsvps().take(1).subscribe(function (reservationList) {
            _this.rsvpPage.content = Object(immutable["List"])(reservationList.slice(pageNumber * itemsPerPage, (pageNumber + 1) * itemsPerPage));
            _this.rsvpPage.number = pageNumber;
            _this.rsvpPage.size = itemsPerPage;
            _this.rsvpPage.totalElements = reservationList.size;
            _this.rsvpPage.numberOfElements = _this.rsvpPage.content.size;
        });
    };
    RsvpSummaryComponent.prototype.getFilteredRsvps = function () {
        return this.reservationCompareStore.getVendorCompareList(this.vendor.eventPartyId)
            .map(function (reservationList) { return reservation_utils_ReservationUtils.onlyRsvpFilter(reservationList); });
    };
    RsvpSummaryComponent.prototype.isMultiVendor = function () {
        return this.authenticationStore.hasPermission('MultiVendor');
    };
    return RsvpSummaryComponent;
}());
rsvp_summary_component___decorate([
    Object(core_es5["Input"])(),
    rsvp_summary_component___metadata("design:type", typeof (rsvp_summary_component__a = typeof Party !== "undefined" && Party) === "function" && rsvp_summary_component__a || Object)
], rsvp_summary_component_RsvpSummaryComponent.prototype, "vendor", void 0);
rsvp_summary_component___decorate([
    Object(core_es5["ViewChild"])(confirmation_modal_component_ConfirmationModalComponent),
    rsvp_summary_component___metadata("design:type", typeof (rsvp_summary_component__b = typeof confirmation_modal_component_ConfirmationModalComponent !== "undefined" && confirmation_modal_component_ConfirmationModalComponent) === "function" && rsvp_summary_component__b || Object)
], rsvp_summary_component_RsvpSummaryComponent.prototype, "confirmationModal", void 0);
rsvp_summary_component___decorate([
    Object(core_es5["ViewChild"])(rsvp_modal_component_RsvpModalComponent),
    rsvp_summary_component___metadata("design:type", typeof (rsvp_summary_component__c = typeof rsvp_modal_component_RsvpModalComponent !== "undefined" && rsvp_modal_component_RsvpModalComponent) === "function" && rsvp_summary_component__c || Object)
], rsvp_summary_component_RsvpSummaryComponent.prototype, "rsvpModal", void 0);
rsvp_summary_component___decorate([
    Object(core_es5["Input"])('event'),
    rsvp_summary_component___metadata("design:type", typeof (rsvp_summary_component__d = typeof OnyxEvent !== "undefined" && OnyxEvent) === "function" && rsvp_summary_component__d || Object),
    rsvp_summary_component___metadata("design:paramtypes", [typeof (rsvp_summary_component__e = typeof OnyxEvent !== "undefined" && OnyxEvent) === "function" && rsvp_summary_component__e || Object])
], rsvp_summary_component_RsvpSummaryComponent.prototype, "event", null);
rsvp_summary_component_RsvpSummaryComponent = rsvp_summary_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-rsvp-summary',
        template: __webpack_require__("qc9e")
    }),
    rsvp_summary_component___metadata("design:paramtypes", [typeof (rsvp_summary_component__f = typeof rsvp_store_RsvpStore !== "undefined" && rsvp_store_RsvpStore) === "function" && rsvp_summary_component__f || Object, typeof (rsvp_summary_component__g = typeof reservation_compare_store_ReservationCompareStore !== "undefined" && reservation_compare_store_ReservationCompareStore) === "function" && rsvp_summary_component__g || Object, typeof (rsvp_summary_component__h = typeof payment_store_PaymentStore !== "undefined" && payment_store_PaymentStore) === "function" && rsvp_summary_component__h || Object, typeof (rsvp_summary_component__j = typeof authentication_store_AuthenticationStore !== "undefined" && authentication_store_AuthenticationStore) === "function" && rsvp_summary_component__j || Object, typeof (rsvp_summary_component__k = typeof user_local_storage_service_UserLocalStorageService !== "undefined" && user_local_storage_service_UserLocalStorageService) === "function" && rsvp_summary_component__k || Object, typeof (rsvp_summary_component__l = typeof event_validation_service_EventValidationService !== "undefined" && event_validation_service_EventValidationService) === "function" && rsvp_summary_component__l || Object])
], rsvp_summary_component_RsvpSummaryComponent);

var rsvp_summary_component__a, rsvp_summary_component__b, rsvp_summary_component__c, rsvp_summary_component__d, rsvp_summary_component__e, rsvp_summary_component__f, rsvp_summary_component__g, rsvp_summary_component__h, rsvp_summary_component__j, rsvp_summary_component__k, rsvp_summary_component__l;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/rsvp-summary.component.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/rsvp/vendor-rsvp-card/vendor-rsvp-card.component.ts
var vendor_rsvp_card_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var vendor_rsvp_card_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};











var vendor_rsvp_card_component_VendorRsvpCardComponent = (function () {
    function VendorRsvpCardComponent(eventStore, reservationCompareStore, menuStore, router, authStore, formBuilder, environment) {
        this.eventStore = eventStore;
        this.reservationCompareStore = reservationCompareStore;
        this.menuStore = menuStore;
        this.router = router;
        this.authStore = authStore;
        this.formBuilder = formBuilder;
        this.environment = environment;
        this.vendorFormValidators = {};
        this.imagesUrl = '';
    }
    VendorRsvpCardComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.imagesUrl = this.environment.onyxGPImagesCommonDataUrl;
        this.eventStore.selectedEvent.subscribe(function (event) { return _this.onyxEvent = event; });
        if (this.onyxEvent) {
            this.menuStore.setPageHeader(EventUtils.getEventName(this.onyxEvent, this.authStore.isAgencyUser()), this.onyxEvent.eventProperty.subscriber);
        }
        this.disableCompareButton$ = this.reservationCompareStore.isVendorCompareListEmpty(this.vendor.eventPartyId);
        this.showReservationCompareSummary$ = this.reservationCompareStore.getShowReservationCompareSummary();
        this.areRsvpsPresent$ = this.reservationCompareStore.areVendorRsvpsPresent(this.vendor.eventPartyId);
        this.checkDetailPath(this.router.url);
        this.displayAddRsvp = this.authStore.hasPermission(['AddRsvp', 'UploadRsvp']);
        if (this.vendors) {
            if (this.vendors.length === 1) {
                this.vendor.isExpanded = true;
            }
        }
        this.createForm();
        this.headerRecordType = SummaryRecordTypeEnum.RSVP;
    };
    VendorRsvpCardComponent.prototype.createForm = function () {
        this.vendorForm = this.formBuilder.group({
            vendorName: this.vendor.name,
            vendorAdress: this.getVendorAddress(),
            vendorState: this.vendor.state,
            vendorZip: this.vendor.postalCode
        }, this.vendorFormValidators);
    };
    VendorRsvpCardComponent.prototype.getVendorAddress = function () {
        return this.vendor.line1;
    };
    VendorRsvpCardComponent.prototype.navigateTo = function (path) {
        this.checkDetailPath(path);
        this.router.navigate([path]);
    };
    VendorRsvpCardComponent.prototype.checkDetailPath = function (path) {
        this.isInDetail = path.indexOf('/detail') !== -1;
    };
    VendorRsvpCardComponent.prototype.onCardExpandClicked = function (event, eventPartyId, chain, brand, propertyId, expanded) {
        event.preventDefault();
        if (eventPartyId) {
            this.vendors.filter(function (ve) { return ve.eventPartyId === eventPartyId; }).forEach(function (x) {
                x.isExpanded = expanded;
            });
        }
        else {
            this.vendors.filter(function (ve) { return ve.chain === chain && ve.brand === brand && ve.propertyId === propertyId; }).forEach(function (x) {
                x.isExpanded = expanded;
            });
        }
        if (expanded && this.vendors.length > 1) {
            this.disableOthers(eventPartyId, chain, brand, propertyId);
        }
    };
    VendorRsvpCardComponent.prototype.disableOthers = function (eventPartyId, chain, brand, propertyId) {
        if (eventPartyId) {
            this.vendors.filter(function (ve) { return ve.eventPartyId !== eventPartyId; }).forEach(function (x) {
                x.isExpanded = false;
            });
        }
        else {
            this.vendors.filter(function (ve) { return ve.chain !== chain || ve.brand !== brand || ve.propertyId !== propertyId; }).forEach(function (x) {
                x.isExpanded = false;
            });
        }
    };
    return VendorRsvpCardComponent;
}());
vendor_rsvp_card_component___decorate([
    Object(core_es5["Input"])(),
    vendor_rsvp_card_component___metadata("design:type", Array)
], vendor_rsvp_card_component_VendorRsvpCardComponent.prototype, "vendors", void 0);
vendor_rsvp_card_component___decorate([
    Object(core_es5["Input"])(),
    vendor_rsvp_card_component___metadata("design:type", typeof (vendor_rsvp_card_component__a = typeof Party !== "undefined" && Party) === "function" && vendor_rsvp_card_component__a || Object)
], vendor_rsvp_card_component_VendorRsvpCardComponent.prototype, "vendor", void 0);
vendor_rsvp_card_component_VendorRsvpCardComponent = vendor_rsvp_card_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-vendor-rsvp-card',
        template: __webpack_require__("AvVL"),
        styles: [__webpack_require__("scbP")]
    }),
    vendor_rsvp_card_component___metadata("design:paramtypes", [typeof (vendor_rsvp_card_component__b = typeof event_store_EventStore !== "undefined" && event_store_EventStore) === "function" && vendor_rsvp_card_component__b || Object, typeof (vendor_rsvp_card_component__c = typeof reservation_compare_store_ReservationCompareStore !== "undefined" && reservation_compare_store_ReservationCompareStore) === "function" && vendor_rsvp_card_component__c || Object, typeof (vendor_rsvp_card_component__d = typeof menu_store_MenuStore !== "undefined" && menu_store_MenuStore) === "function" && vendor_rsvp_card_component__d || Object, typeof (vendor_rsvp_card_component__e = typeof router_es5["Router"] !== "undefined" && router_es5["Router"]) === "function" && vendor_rsvp_card_component__e || Object, typeof (vendor_rsvp_card_component__f = typeof authentication_store_AuthenticationStore !== "undefined" && authentication_store_AuthenticationStore) === "function" && vendor_rsvp_card_component__f || Object, typeof (vendor_rsvp_card_component__g = typeof forms_es5["FormBuilder"] !== "undefined" && forms_es5["FormBuilder"]) === "function" && vendor_rsvp_card_component__g || Object, typeof (vendor_rsvp_card_component__h = typeof EnvironmentConfiguration !== "undefined" && EnvironmentConfiguration) === "function" && vendor_rsvp_card_component__h || Object])
], vendor_rsvp_card_component_VendorRsvpCardComponent);

var vendor_rsvp_card_component__a, vendor_rsvp_card_component__b, vendor_rsvp_card_component__c, vendor_rsvp_card_component__d, vendor_rsvp_card_component__e, vendor_rsvp_card_component__f, vendor_rsvp_card_component__g, vendor_rsvp_card_component__h;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/vendor-rsvp-card.component.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/service/events.resolver.ts
var events_resolver___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var events_resolver___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};








var events_resolver_EventsResolver = (function () {
    function EventsResolver(eventsListStore, searchParametersStore, logService, userLocalStorageService) {
        this.eventsListStore = eventsListStore;
        this.searchParametersStore = searchParametersStore;
        this.logService = logService;
        this.userLocalStorageService = userLocalStorageService;
    }
    EventsResolver.prototype.resolve = function (route, state) {
        var searchTextList = search_event_utils_SearchEventUtils.convertParamsToSearchTextSet(route.queryParams);
        var searchFilterList = search_event_utils_SearchEventUtils.convertParamsToSearchFilterSet(route.queryParams);
        if (searchTextList.isEmpty() && searchFilterList.isEmpty()) {
            this.searchParametersStore.reset(true);
        }
        else {
            if (searchTextList) {
                this.searchParametersStore.setSearchTextSet(searchTextList);
            }
            if (searchFilterList) {
                this.searchParametersStore.setFilterSet(searchFilterList);
            }
        }
        this.logService.debug('route.url: ' + route.url);
        this.logService.debug('state.url: ' + state.url);
        if (route.data && route.data['view']) {
            this.logService.debug('route.data[ \'view\' ]: ' + route.data['view']);
            var showDefaultView = route.data['view'];
            this.logService.debug('showDefaultView: ' + showDefaultView);
            this.searchParametersStore.setDefaultViewSelected(showDefaultView === 'default');
        }
        return this.eventsListStore.loadEvents(Constants.SEARCH_DEFAULT_PAGE, this.userLocalStorageService.getPagesize(PagesizeType.EVENTS));
    };
    return EventsResolver;
}());
events_resolver_EventsResolver = events_resolver___decorate([
    Object(core_es5["Injectable"])(),
    events_resolver___metadata("design:paramtypes", [typeof (events_resolver__a = typeof event_list_store_EventListStore !== "undefined" && event_list_store_EventListStore) === "function" && events_resolver__a || Object, typeof (events_resolver__b = typeof event_search_parameters_store_EventSearchParametersStore !== "undefined" && event_search_parameters_store_EventSearchParametersStore) === "function" && events_resolver__b || Object, typeof (events_resolver__c = typeof log_service_LogService !== "undefined" && log_service_LogService) === "function" && events_resolver__c || Object, typeof (events_resolver__d = typeof user_local_storage_service_UserLocalStorageService !== "undefined" && user_local_storage_service_UserLocalStorageService) === "function" && events_resolver__d || Object])
], events_resolver_EventsResolver);

var events_resolver__a, events_resolver__b, events_resolver__c, events_resolver__d;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/events.resolver.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/vendor-add/vendor-add.component.ts
var vendor_add_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var vendor_add_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};








var vendor_add_component_VendorAddComponent = (function () {
    function VendorAddComponent(formBuilder, _commonDataStore, propertyLookupStore, propertyStore) {
        this.formBuilder = formBuilder;
        this._commonDataStore = _commonDataStore;
        this.propertyLookupStore = propertyLookupStore;
        this.propertyStore = propertyStore;
        this.canceled = new core_es5["EventEmitter"]();
        this.accepted = new core_es5["EventEmitter"]();
        this.propertyFormControlsConfig = {
            name: ['', [forms_es5["Validators"].required, forms_es5["Validators"].maxLength(50)]],
            countryCode: [null, [forms_es5["Validators"].required]],
            address1: ['', [forms_es5["Validators"].required, forms_es5["Validators"].maxLength(50)]],
            address2: ['', [forms_es5["Validators"].maxLength(50)]],
            address3: ['', [forms_es5["Validators"].maxLength(50)]],
            city: ['', [forms_es5["Validators"].required, forms_es5["Validators"].maxLength(50)]],
            stateProvinceCode: [null, []],
            postalCode: ['', [forms_es5["Validators"].maxLength(15)]],
            contactFirstNm: ['', [forms_es5["Validators"].maxLength(50)]],
            contactLastNm: ['', [forms_es5["Validators"].maxLength(50)]],
            email: ['', [forms_es5["Validators"].required, forms_es5["Validators"].maxLength(75), pioneer_validators_PioneerValidators.isValidEmail]],
            phoneNr: ['', [forms_es5["Validators"].maxLength(20)]],
            faxNr: ['', [forms_es5["Validators"].maxLength(20)]],
            payorType: [null, [forms_es5["Validators"].required]]
        };
        this.propertyFormValidators = {
            validator: forms_es5["Validators"].compose([
                pioneer_validators_PioneerValidators.countryStateCrossValidator('countryCode', 'stateProvinceCode'),
                pioneer_validators_PioneerValidators.postalCodeCountryCrossValidator('postalCode', 'countryCode')
            ])
        };
    }
    Object.defineProperty(VendorAddComponent.prototype, "commonDataStore", {
        get: function () {
            return this._commonDataStore;
        },
        enumerable: true,
        configurable: true
    });
    VendorAddComponent.prototype.ngOnInit = function () {
        this.reset();
    };
    VendorAddComponent.prototype.reset = function () {
        this.showState = false;
        this.showPostalCode = false;
        this.states$ = Observable["Observable"].of([]);
        if (!this.propertyForm) {
            this.createForm();
        }
        else {
            this.propertyForm.reset({
                name: '',
                countryCode: null,
                address1: '',
                address2: '',
                address3: '',
                city: '',
                stateProvinceCode: null,
                postalCode: '',
                contactFirstNm: '',
                contactLastNm: '',
                email: '',
                phoneNr: '',
                faxNr: ''
            });
        }
        this.propertyForm.enable();
    };
    VendorAddComponent.prototype.cancel = function () {
        this.canceled.emit();
        this.reset();
    };
    VendorAddComponent.prototype.accept = function () {
        var _this = this;
        this.propertyForm.disable();
        var propertyAddRequest = this.extractProperty();
        try {
            this.propertyStore.addVendor(propertyAddRequest).subscribe(function (savedProperty) {
                _this.accepted.emit(savedProperty);
                _this.reset();
            });
        }
        catch (error) {
            this.propertyForm.enable();
            Observable["Observable"].throw(error);
        }
    };
    VendorAddComponent.prototype.onCountryCodeChanged = function () {
        var _this = this;
        this.propertyForm.get('stateProvinceCode').reset();
        this.propertyForm.get('postalCode').reset('');
        this.states$ = this.commonDataStore.loadStatesFromCountry(this.propertyForm.get('countryCode').value);
        this.states$.take(1).subscribe(function (states) {
            _this.showState = states.length > 0;
        });
        this.showPostalCode = pioneer_validators_PioneerValidators.isPostalCodeRequired(this.propertyForm, 'countryCode');
    };
    VendorAddComponent.prototype.createForm = function () {
        this.propertyForm = this.formBuilder.group(this.propertyFormControlsConfig, this.propertyFormValidators);
    };
    VendorAddComponent.prototype.extractProperty = function () {
        return new Property({
            id: null,
            chain: null,
            brand: null,
            pid: null,
            name: this.propertyForm.get('name').value,
            address1: this.propertyForm.get('address1').value,
            address2: this.propertyForm.get('address2').value,
            address3: this.propertyForm.get('address3').value,
            city: this.propertyForm.get('city').value,
            stateProvinceCode: this.propertyForm.get('stateProvinceCode').value,
            countryCode: this.propertyForm.get('countryCode').value,
            postalCode: this.propertyForm.get('postalCode').value,
            phoneNr: this.propertyForm.get('phoneNr').value,
            faxNr: this.propertyForm.get('faxNr').value,
            email: this.propertyForm.get('email').value,
            contactFirstNm: this.propertyForm.get('contactFirstNm').value,
            contactLastNm: this.propertyForm.get('contactLastNm').value,
            payorType: this.propertyForm.get('payorType').value
        });
    };
    return VendorAddComponent;
}());
vendor_add_component___decorate([
    Object(core_es5["Input"])('vendorSelected'),
    vendor_add_component___metadata("design:type", String)
], vendor_add_component_VendorAddComponent.prototype, "vendorSelected", void 0);
vendor_add_component___decorate([
    Object(core_es5["Output"])(),
    vendor_add_component___metadata("design:type", Object)
], vendor_add_component_VendorAddComponent.prototype, "canceled", void 0);
vendor_add_component___decorate([
    Object(core_es5["Output"])(),
    vendor_add_component___metadata("design:type", Object)
], vendor_add_component_VendorAddComponent.prototype, "accepted", void 0);
vendor_add_component_VendorAddComponent = vendor_add_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-vendor-add',
        template: __webpack_require__("1dqF"),
        styles: [__webpack_require__("TAjX")]
    }),
    vendor_add_component___metadata("design:paramtypes", [typeof (vendor_add_component__a = typeof forms_es5["FormBuilder"] !== "undefined" && forms_es5["FormBuilder"]) === "function" && vendor_add_component__a || Object, typeof (vendor_add_component__b = typeof common_data_store_CommonDataStore !== "undefined" && common_data_store_CommonDataStore) === "function" && vendor_add_component__b || Object, typeof (vendor_add_component__c = typeof property_lookup_store_PropertyLookupStore !== "undefined" && property_lookup_store_PropertyLookupStore) === "function" && vendor_add_component__c || Object, typeof (vendor_add_component__d = typeof property_store_PropertyStore !== "undefined" && property_store_PropertyStore) === "function" && vendor_add_component__d || Object])
], vendor_add_component_VendorAddComponent);

var vendor_add_component__a, vendor_add_component__b, vendor_add_component__c, vendor_add_component__d;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/vendor-add.component.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/models/vendor-search-request.ts
var vendor_search_request___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var VendorSearchRequestRecord = Object(immutable["Record"])({
    chain: null,
    brand: null,
    property: null,
    city: null,
    stateCode: null,
    countryCode: null,
    payorType: null,
    onlySubscribers: false,
    excludedParties: null
});
var VendorSearchRequest = (function (_super) {
    vendor_search_request___extends(VendorSearchRequest, _super);
    function VendorSearchRequest() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return VendorSearchRequest;
}(VendorSearchRequestRecord));

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/vendor-search-request.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/vendor-search/vendor-search.component.ts
var vendor_search_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var vendor_search_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};













var vendor_search_component_VendorSearchComponent = (function () {
    function VendorSearchComponent(formBuilder, propertyLookupStore, commonDataStore, chainBrandStore) {
        this.formBuilder = formBuilder;
        this.propertyLookupStore = propertyLookupStore;
        this.commonDataStore = commonDataStore;
        this.chainBrandStore = chainBrandStore;
        this.canceled = new core_es5["EventEmitter"]();
        this.selected = new core_es5["EventEmitter"]();
        this.goToAdd = new core_es5["EventEmitter"]();
        this.propertySearchFormControlsConfig = {
            chain: ['', []],
            brand: ['', []],
            property: ['', []],
            country: ['', []],
            state: ['', []],
            city: ['', []],
            payorType: ['PROPERTY', [forms_es5["Validators"].required]],
            onlySubscribers: [false, []]
        };
        this.propertySearchFormValidators = {
            validator: forms_es5["Validators"].compose([
                pioneer_validators_PioneerValidators.oneIsRequiredValidator('chain', 'brand', 'property', 'country', 'state', 'city', 'payorType')
            ])
        };
        this.list = [];
    }
    VendorSearchComponent.prototype.ngOnInit = function () {
        this.reset();
    };
    VendorSearchComponent.prototype.cancel = function () {
        this.canceled.emit();
        this.reset();
    };
    VendorSearchComponent.prototype.selectProperty = function (selectedPropertyLookupSummary) {
        var _this = this;
        var obs$ = this.propertyLookupStore.getDetail(selectedPropertyLookupSummary)
            .pipe(Object(operators["tap"])(function (selectedPropertyLookupDetail) {
            _this.selected.emit(property_lookup_converter_PropertyLookupConverter.convertPropertyLookupDetailToProperty(selectedPropertyLookupDetail));
            _this.reset();
        }), Object(operators["catchError"])(function () {
            return Observable["Observable"].of(null);
        }));
        obs$.take(1).subscribe();
    };
    Object.defineProperty(VendorSearchComponent.prototype, "payorType", {
        get: function () { return this.propertySearchForm.get('payorType'); },
        enumerable: true,
        configurable: true
    });
    VendorSearchComponent.prototype.goToAddProperty = function () {
        this.goToAdd.emit(this.payorType.value);
    };
    VendorSearchComponent.prototype.search = function () {
        var _this = this;
        var propertySearchRequest = this.extractPropertySearchRequest();
        var obs$ = this.propertyLookupStore.advancedVendorSearch(propertySearchRequest)
            .take(1)
            .pipe(Object(operators["catchError"])(function () {
            return Observable["Observable"].of(null);
        }));
        this.searchResults = obs$.map(function (page) {
            _this.totalItems = _this.propertyLookupStore.advancedSearchTotalElements;
            _this.size = _this.propertyLookupStore.advancedSearchSize;
            return page.content;
        });
    };
    VendorSearchComponent.prototype.chainSelected = function (chain) {
        if (this.brandDropdown) {
            this.brandDropdown.reset();
        }
        if (chain) {
            this.brands$ = this.chainBrandStore.loadBrandsFromChain(chain.key);
        }
        else {
            this.brands$ = Observable["Observable"].of([]);
        }
    };
    VendorSearchComponent.prototype.countrySelected = function (country) {
        if (this.stateDropdown) {
            this.stateDropdown.reset();
        }
        if (country) {
            this.states$ = this.commonDataStore.loadStatesFromCountry(country.key);
        }
        else {
            this.states$ = Observable["Observable"].of([]);
        }
    };
    VendorSearchComponent.prototype.reset = function () {
        this.chains$ = this.chainBrandStore.chains;
        this.brands$ = Observable["Observable"].of([]);
        this.states$ = Observable["Observable"].of([]);
        this.chainDropdown.reset();
        this.brandDropdown.reset();
        this.countryDropdown.reset();
        if (this.stateDropdown) {
            this.stateDropdown.reset();
        }
        this.searchResults = Observable["Observable"].of(Object(immutable["List"])([]));
        this.createForm();
        this.propertySearchForm.enable();
    };
    VendorSearchComponent.prototype.createForm = function () {
        this.propertySearchForm = this.formBuilder.group(this.propertySearchFormControlsConfig, this.propertySearchFormValidators);
    };
    VendorSearchComponent.prototype.extractPropertySearchRequest = function () {
        return new VendorSearchRequest({
            chain: pioneer_utils_PioneerUtils.trimToNull(this.propertySearchForm.get('chain').value),
            brand: pioneer_utils_PioneerUtils.trimToNull(this.propertySearchForm.get('brand').value),
            property: pioneer_utils_PioneerUtils.trimToNull(this.propertySearchForm.get('property').value),
            city: pioneer_utils_PioneerUtils.trimToNull(this.propertySearchForm.get('city').value),
            stateCode: pioneer_utils_PioneerUtils.trimToNull(this.propertySearchForm.get('state').value),
            countryCode: pioneer_utils_PioneerUtils.trimToNull(this.propertySearchForm.get('country').value),
            payorType: pioneer_utils_PioneerUtils.trimToNull(this.propertySearchForm.get('payorType').value),
            onlySubscribers: this.propertySearchForm.get('onlySubscribers').value,
            excludedParties: this.currentEventVendors
        });
    };
    return VendorSearchComponent;
}());
vendor_search_component___decorate([
    Object(core_es5["Input"])(),
    vendor_search_component___metadata("design:type", Array)
], vendor_search_component_VendorSearchComponent.prototype, "currentEventVendors", void 0);
vendor_search_component___decorate([
    Object(core_es5["Output"])(),
    vendor_search_component___metadata("design:type", Object)
], vendor_search_component_VendorSearchComponent.prototype, "canceled", void 0);
vendor_search_component___decorate([
    Object(core_es5["Output"])(),
    vendor_search_component___metadata("design:type", Object)
], vendor_search_component_VendorSearchComponent.prototype, "selected", void 0);
vendor_search_component___decorate([
    Object(core_es5["Output"])(),
    vendor_search_component___metadata("design:type", typeof (vendor_search_component__a = typeof core_es5["EventEmitter"] !== "undefined" && core_es5["EventEmitter"]) === "function" && vendor_search_component__a || Object)
], vendor_search_component_VendorSearchComponent.prototype, "goToAdd", void 0);
vendor_search_component___decorate([
    Object(core_es5["ViewChild"])('chainDropdown'),
    vendor_search_component___metadata("design:type", typeof (vendor_search_component__b = typeof dropdown_search_component_DropdownSearchComponent !== "undefined" && dropdown_search_component_DropdownSearchComponent) === "function" && vendor_search_component__b || Object)
], vendor_search_component_VendorSearchComponent.prototype, "chainDropdown", void 0);
vendor_search_component___decorate([
    Object(core_es5["ViewChild"])('brandDropdown'),
    vendor_search_component___metadata("design:type", typeof (vendor_search_component__c = typeof dropdown_search_component_DropdownSearchComponent !== "undefined" && dropdown_search_component_DropdownSearchComponent) === "function" && vendor_search_component__c || Object)
], vendor_search_component_VendorSearchComponent.prototype, "brandDropdown", void 0);
vendor_search_component___decorate([
    Object(core_es5["ViewChild"])('countryDropdown'),
    vendor_search_component___metadata("design:type", typeof (vendor_search_component__d = typeof dropdown_search_component_DropdownSearchComponent !== "undefined" && dropdown_search_component_DropdownSearchComponent) === "function" && vendor_search_component__d || Object)
], vendor_search_component_VendorSearchComponent.prototype, "countryDropdown", void 0);
vendor_search_component___decorate([
    Object(core_es5["ViewChild"])('stateDropdown'),
    vendor_search_component___metadata("design:type", typeof (vendor_search_component__e = typeof dropdown_search_component_DropdownSearchComponent !== "undefined" && dropdown_search_component_DropdownSearchComponent) === "function" && vendor_search_component__e || Object)
], vendor_search_component_VendorSearchComponent.prototype, "stateDropdown", void 0);
vendor_search_component_VendorSearchComponent = vendor_search_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-vendor-search',
        template: __webpack_require__("4vyA"),
        styles: [__webpack_require__("LfX5")]
    }),
    vendor_search_component___metadata("design:paramtypes", [typeof (vendor_search_component__f = typeof forms_es5["FormBuilder"] !== "undefined" && forms_es5["FormBuilder"]) === "function" && vendor_search_component__f || Object, typeof (vendor_search_component__g = typeof property_lookup_store_PropertyLookupStore !== "undefined" && property_lookup_store_PropertyLookupStore) === "function" && vendor_search_component__g || Object, typeof (vendor_search_component__h = typeof common_data_store_CommonDataStore !== "undefined" && common_data_store_CommonDataStore) === "function" && vendor_search_component__h || Object, typeof (vendor_search_component__j = typeof chain_brand_store_ChainBrandStore !== "undefined" && chain_brand_store_ChainBrandStore) === "function" && vendor_search_component__j || Object])
], vendor_search_component_VendorSearchComponent);

var vendor_search_component__a, vendor_search_component__b, vendor_search_component__c, vendor_search_component__d, vendor_search_component__e, vendor_search_component__f, vendor_search_component__g, vendor_search_component__h, vendor_search_component__j;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/vendor-search.component.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/vendor-popup/vendor-popup.component.ts
var vendor_popup_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var vendor_popup_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};





var vendor_popup_component_VendorPopupComponent = (function () {
    function VendorPopupComponent() {
        this.propertyPopupType = PopupType.SEARCH;
        this.PopupType = PopupType;
        this.config = {
            backdrop: 'static',
            keyboard: false
        };
        this.closed = new core_es5["EventEmitter"]();
    }
    VendorPopupComponent.prototype.ngOnInit = function () {
    };
    VendorPopupComponent.prototype.open = function () {
        this.propertyPopupType = PopupType.SEARCH;
        this.propertyModal.show();
    };
    VendorPopupComponent.prototype.goToAdd = function (vendorType) {
        this.vendorSelected = vendorType;
        this.propertyPopupType = PopupType.ADD;
    };
    VendorPopupComponent.prototype.cancelSearch = function () {
        this.close(null);
    };
    VendorPopupComponent.prototype.selectProperty = function (propertySelected) {
        if (this.propertyAdd) {
            this.propertyAdd.reset();
        }
        this.propertySearch.reset();
        this.selectedProperty = propertySelected;
        this.propertyPopupType = PopupType.RATE;
    };
    VendorPopupComponent.prototype.selectVendorRate = function (propertySelected) {
        this.close(propertySelected);
    };
    VendorPopupComponent.prototype.acceptAdd = function (savedProperty) {
        if (this.propertyAdd) {
            this.propertyAdd.reset();
            savedProperty.manuallyAdded = true;
        }
        this.propertySearch.reset();
        this.selectedProperty = savedProperty;
        this.propertyPopupType = PopupType.RATE;
    };
    VendorPopupComponent.prototype.cancelAdd = function () {
        this.propertyPopupType = PopupType.SEARCH;
    };
    VendorPopupComponent.prototype.close = function (value) {
        this.closed.emit(value);
        this.propertyModal.hide();
    };
    return VendorPopupComponent;
}());
vendor_popup_component___decorate([
    Object(core_es5["Input"])(),
    vendor_popup_component___metadata("design:type", Array)
], vendor_popup_component_VendorPopupComponent.prototype, "currentEventVendors", void 0);
vendor_popup_component___decorate([
    Object(core_es5["ViewChild"])(ngx_bootstrap["b" /* ModalDirective */]),
    vendor_popup_component___metadata("design:type", typeof (vendor_popup_component__a = typeof ngx_bootstrap["b" /* ModalDirective */] !== "undefined" && ngx_bootstrap["b" /* ModalDirective */]) === "function" && vendor_popup_component__a || Object)
], vendor_popup_component_VendorPopupComponent.prototype, "propertyModal", void 0);
vendor_popup_component___decorate([
    Object(core_es5["ViewChild"])(vendor_search_component_VendorSearchComponent),
    vendor_popup_component___metadata("design:type", typeof (vendor_popup_component__b = typeof vendor_search_component_VendorSearchComponent !== "undefined" && vendor_search_component_VendorSearchComponent) === "function" && vendor_popup_component__b || Object)
], vendor_popup_component_VendorPopupComponent.prototype, "propertySearch", void 0);
vendor_popup_component___decorate([
    Object(core_es5["ViewChild"])(vendor_add_component_VendorAddComponent),
    vendor_popup_component___metadata("design:type", typeof (vendor_popup_component__c = typeof vendor_add_component_VendorAddComponent !== "undefined" && vendor_add_component_VendorAddComponent) === "function" && vendor_popup_component__c || Object)
], vendor_popup_component_VendorPopupComponent.prototype, "propertyAdd", void 0);
vendor_popup_component___decorate([
    Object(core_es5["Output"])(),
    vendor_popup_component___metadata("design:type", Object)
], vendor_popup_component_VendorPopupComponent.prototype, "closed", void 0);
vendor_popup_component_VendorPopupComponent = vendor_popup_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-vendor-popup',
        template: __webpack_require__("nQN8")
    }),
    vendor_popup_component___metadata("design:paramtypes", [])
], vendor_popup_component_VendorPopupComponent);

var vendor_popup_component__a, vendor_popup_component__b, vendor_popup_component__c;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/vendor-popup.component.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/vendor-card-detail/vendor-card-detail.component.ts
var vendor_card_detail_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var vendor_card_detail_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};


















var vendor_card_detail_component_VendorCardDetailComponent = (function () {
    function VendorCardDetailComponent(formBuilder, translateService, propertyLookupStore, logService, authenticationStore, eventStore, environment, eventValidationService) {
        this.formBuilder = formBuilder;
        this.translateService = translateService;
        this.propertyLookupStore = propertyLookupStore;
        this.logService = logService;
        this.authenticationStore = authenticationStore;
        this.eventStore = eventStore;
        this.environment = environment;
        this.eventValidationService = eventValidationService;
        this.isReadOnly = false;
        this.isNewEvent = false;
        this.isCardOpen = false;
        this.deleteVendor = new core_es5["EventEmitter"]();
        this.outputEmail = new core_es5["EventEmitter"]();
        this.onToggleCard = new core_es5["EventEmitter"]();
        this.partyType = PartyType.PROPERTY;
        this.isContactEditable = true;
        this.showSubscriberBadge = false;
        this.canRemoveVendor = false;
        this.canEditVendorCommRate = false;
        this.showLongLabels = false;
        this._destroy$ = new Subject["Subject"]();
    }
    VendorCardDetailComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.grouppayLogo = this.environment.onyxGPImagesCommonDataUrl + "/grouppay-logo-symbol.png";
        this.contactReferenceNumberTitle = this.translateService.instant('EVENT.CONTACT_PROPERTY_REF_CODE');
        this.contactLookupForm = this.dataToFormGroup(this.vendor);
        var isSubscriber = !!this.vendor && !!this.vendor.subscriber;
        this.showSubscriberBadge = isSubscriber && this.authenticationStore.hasPermission('ViewGroupPayPropertyIndicators');
        this.parentForm.setControl('eventProperty', this.contactLookupForm);
        this.parentForm.setControl("eventVendor-" + this.getVendorCode(this.vendor), this.contactLookupForm);
        if (this.authenticationStore.isSinglePropertyUser() && this.isNewEvent) {
            this.authenticationStore.user.pipe(Object(operators["take"])(1)).subscribe(function (user) {
                var propertyQuery = new PropertyLookupDetailQuery({
                    chain: user.allChains[0],
                    brand: user.allBrands[0],
                    propertyId: user.allProperties[0],
                });
                _this.onSelectedProperty(propertyQuery);
            });
        }
        this.eventStore.selectedEvent.pipe(Object(operators["take"])(1)).subscribe(function (selectedEvent) {
            if (selectedEvent) {
                _this.eventId = selectedEvent.eventId;
            }
        });
        this.eventValidationService.canRemoveVendor(this.vendor).pipe(Object(operators["take"])(1)).subscribe(function (canRemoveVendor) {
            _this.canRemoveVendor = canRemoveVendor;
        });
        this.eventValidationService.canEditVendorContact(this.vendor).take(1).subscribe(function (canEditContact) {
            _this.isContactEditable = _this.authenticationStore.hasPermission('EditPropertyContact') && canEditContact;
        });
        this.eventValidationService.canEditVendorCommRate(this.vendor).pipe(Object(operators["take"])(1)).subscribe(function (canEditVendorCommRate) {
            _this.canEditVendorCommRate = canEditVendorCommRate;
        });
        this.populateCardTitle();
        this.showLongLabels = !isSubscriber || (this.isNewEvent && this.authenticationStore.hasPermission('EditPropertyContact'));
    };
    VendorCardDetailComponent.prototype.ngOnDestroy = function () {
        this._destroy$.next(true);
        this._destroy$.complete();
    };
    VendorCardDetailComponent.prototype.onSelectedProperty = function (propertyQuery) {
        this.logService.debug("propertySummary " + JSON.stringify(propertyQuery));
        this.propertyLookupStore.getDetail(propertyQuery).pipe(Object(operators["take"])(1)).subscribe();
    };
    VendorCardDetailComponent.prototype.dataToFormGroup = function (party) {
        if (!party) {
            party = new Party();
        }
        else {
            if (!party.contact) {
                party.contact = new Contact();
            }
            party = new Party(party);
        }
        if (!this.isNewEvent) {
            // onyxEvent chain/brand/propertyId is added to party if the event already existed
            party = party.merge({
                propertyId: party.propertyId,
                chain: party.chain,
                brand: party.brand
            });
        }
        var refCodeValidator = [party.eventReferenceNumber, forms_es5["Validators"].nullValidator];
        if (!this.contactLookupForm) {
            var emailValidator = !this.isReadOnly && this.authenticationStore.hasPermission('EditPropertyContact') ?
                [forms_es5["Validators"].required, forms_es5["Validators"].maxLength(75), pioneer_validators_PioneerValidators.isValidEmail] : forms_es5["Validators"].nullValidator;
            this.contactLookupForm = this.formBuilder.group({
                propertyNameSearch: '',
                agencyNameSearch: '',
                name: party.name,
                line1: party.line1,
                line2: party.line2,
                partyType: PartyType.PROPERTY,
                payorType: party.payorType,
                city: party.city,
                state: party.state,
                postalCode: party.postalCode,
                agencyId: party.agencyId,
                code: party.code,
                propertyId: party.propertyId,
                chain: party.chain,
                brand: party.brand,
                eventReferenceNumber: refCodeValidator,
                manuallyAdded: party.manuallyAdded,
                autoGeneratedCode: party.autoGeneratedCode,
                countryCode: party.countryCode,
                commissionRoomPercentage: party.commissionRoomPercentage,
                commRetention: party.commRetention,
                contact: this.formBuilder.group({
                    firstName: [party.contact.firstName],
                    lastName: [party.contact.lastName],
                    partyType: PartyType.PROPERTY,
                    email: [party.contact.email, emailValidator],
                    phone: [party.contact.phone],
                    fax: [party.contact.fax]
                }),
                subscriber: party.subscriber
            }, {
                validator: pioneer_validators_PioneerValidators.isPropertyError
            });
        }
        else {
            this.contactLookupForm.patchValue({
                propertyNameSearch: '',
                agencyNameSearch: '',
                name: party.name,
                line1: party.line1,
                line2: party.line2,
                partyType: PartyType.PROPERTY,
                payorType: party.payorType,
                city: party.city,
                state: party.state,
                postalCode: party.postalCode,
                agencyId: party.agencyId,
                code: party.code,
                propertyId: party.propertyId,
                chain: party.chain,
                brand: party.brand,
                eventReferenceNumber: party.eventReferenceNumber,
                manuallyAdded: party.manuallyAdded,
                autoGeneratedCode: party.autoGeneratedCode,
                countryCode: party.countryCode,
                commissionRoomPercentage: party.commissionRoomPercentage,
                commRetention: party.commRetention
            });
            this.contactLookupForm.controls['contact'].patchValue({
                firstName: party.contact.firstName,
                lastName: party.contact.lastName,
                partyType: PartyType.PROPERTY,
                email: party.contact.email,
                phone: party.contact.phone,
                fax: party.contact.fax
            });
            if (party.contact.email) {
                this.outputEmail.emit(party.contact.email);
            }
        }
        return this.contactLookupForm;
    };
    VendorCardDetailComponent.prototype.setupPropertyEmail = function (email) {
        this.outputEmail.emit(email);
    };
    VendorCardDetailComponent.prototype.confirmBeforeDelete = function ($event) {
        $event.preventDefault();
        this.confirmDeleteModal.open();
    };
    VendorCardDetailComponent.prototype.confirmHandler = function (deleteConfirmed) {
        if (deleteConfirmed) {
            this.deleteVendor.emit(this.vendor);
        }
    };
    VendorCardDetailComponent.prototype.getVendorCode = function (vendor) {
        if (!vendor) {
            return '';
        }
        return vendor.code ? vendor.code : vendor.chain + '|' + vendor.brand + '|' + vendor.propertyId;
    };
    VendorCardDetailComponent.prototype.toggleCard = function (event) {
        event.preventDefault();
        this.onToggleCard.emit();
    };
    VendorCardDetailComponent.prototype.populateCardTitle = function () {
        if (!this.vendor) {
            return;
        }
        var isVendorProperty = this.vendor.partyType === PartyType.PROPERTY && this.vendor.payorType === 'PROPERTY';
        var validEventReferenceNumber = !!this.vendor.eventReferenceNumber;
        var groupCodePart = '';
        if (isVendorProperty && validEventReferenceNumber) {
            groupCodePart = this.translateService.instant('EVENT.GROUP_CODE');
            groupCodePart += ": " + this.vendor.eventReferenceNumber + " ";
        }
        this.cardTitle = " " + this.vendor.name + " " + groupCodePart;
    };
    return VendorCardDetailComponent;
}());
vendor_card_detail_component___decorate([
    Object(core_es5["Input"])(),
    vendor_card_detail_component___metadata("design:type", typeof (vendor_card_detail_component__a = typeof Party !== "undefined" && Party) === "function" && vendor_card_detail_component__a || Object)
], vendor_card_detail_component_VendorCardDetailComponent.prototype, "vendor", void 0);
vendor_card_detail_component___decorate([
    Object(core_es5["Input"])(),
    vendor_card_detail_component___metadata("design:type", typeof (vendor_card_detail_component__b = typeof forms_es5["FormGroup"] !== "undefined" && forms_es5["FormGroup"]) === "function" && vendor_card_detail_component__b || Object)
], vendor_card_detail_component_VendorCardDetailComponent.prototype, "parentForm", void 0);
vendor_card_detail_component___decorate([
    Object(core_es5["Input"])(),
    vendor_card_detail_component___metadata("design:type", Object)
], vendor_card_detail_component_VendorCardDetailComponent.prototype, "isReadOnly", void 0);
vendor_card_detail_component___decorate([
    Object(core_es5["Input"])(),
    vendor_card_detail_component___metadata("design:type", Object)
], vendor_card_detail_component_VendorCardDetailComponent.prototype, "isNewEvent", void 0);
vendor_card_detail_component___decorate([
    Object(core_es5["Input"])(),
    vendor_card_detail_component___metadata("design:type", String)
], vendor_card_detail_component_VendorCardDetailComponent.prototype, "inputEmail", void 0);
vendor_card_detail_component___decorate([
    Object(core_es5["Input"])(),
    vendor_card_detail_component___metadata("design:type", Object)
], vendor_card_detail_component_VendorCardDetailComponent.prototype, "isCardOpen", void 0);
vendor_card_detail_component___decorate([
    Object(core_es5["Output"])(),
    vendor_card_detail_component___metadata("design:type", typeof (vendor_card_detail_component__c = typeof core_es5["EventEmitter"] !== "undefined" && core_es5["EventEmitter"]) === "function" && vendor_card_detail_component__c || Object)
], vendor_card_detail_component_VendorCardDetailComponent.prototype, "deleteVendor", void 0);
vendor_card_detail_component___decorate([
    Object(core_es5["Output"])(),
    vendor_card_detail_component___metadata("design:type", typeof (vendor_card_detail_component__d = typeof core_es5["EventEmitter"] !== "undefined" && core_es5["EventEmitter"]) === "function" && vendor_card_detail_component__d || Object)
], vendor_card_detail_component_VendorCardDetailComponent.prototype, "outputEmail", void 0);
vendor_card_detail_component___decorate([
    Object(core_es5["Output"])(),
    vendor_card_detail_component___metadata("design:type", Object)
], vendor_card_detail_component_VendorCardDetailComponent.prototype, "onToggleCard", void 0);
vendor_card_detail_component___decorate([
    Object(core_es5["ViewChild"])('confirmDeleteModal'),
    vendor_card_detail_component___metadata("design:type", typeof (vendor_card_detail_component__e = typeof confirmation_modal_component_ConfirmationModalComponent !== "undefined" && confirmation_modal_component_ConfirmationModalComponent) === "function" && vendor_card_detail_component__e || Object)
], vendor_card_detail_component_VendorCardDetailComponent.prototype, "confirmDeleteModal", void 0);
vendor_card_detail_component___decorate([
    Object(core_es5["ViewChild"])(vendor_popup_component_VendorPopupComponent),
    vendor_card_detail_component___metadata("design:type", typeof (vendor_card_detail_component__f = typeof vendor_popup_component_VendorPopupComponent !== "undefined" && vendor_popup_component_VendorPopupComponent) === "function" && vendor_card_detail_component__f || Object)
], vendor_card_detail_component_VendorCardDetailComponent.prototype, "propertyPopup", void 0);
vendor_card_detail_component___decorate([
    Object(core_es5["ViewChild"])('cardWrapper'),
    vendor_card_detail_component___metadata("design:type", typeof (vendor_card_detail_component__g = typeof core_es5["ElementRef"] !== "undefined" && core_es5["ElementRef"]) === "function" && vendor_card_detail_component__g || Object)
], vendor_card_detail_component_VendorCardDetailComponent.prototype, "cardWrapper", void 0);
vendor_card_detail_component_VendorCardDetailComponent = vendor_card_detail_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-vendor-card-detail',
        template: __webpack_require__("3oKC"),
        styles: [__webpack_require__("PHNp")]
    }),
    vendor_card_detail_component___metadata("design:paramtypes", [typeof (vendor_card_detail_component__h = typeof forms_es5["FormBuilder"] !== "undefined" && forms_es5["FormBuilder"]) === "function" && vendor_card_detail_component__h || Object, typeof (vendor_card_detail_component__j = typeof core["c" /* TranslateService */] !== "undefined" && core["c" /* TranslateService */]) === "function" && vendor_card_detail_component__j || Object, typeof (vendor_card_detail_component__k = typeof property_lookup_store_PropertyLookupStore !== "undefined" && property_lookup_store_PropertyLookupStore) === "function" && vendor_card_detail_component__k || Object, typeof (vendor_card_detail_component__l = typeof log_service_LogService !== "undefined" && log_service_LogService) === "function" && vendor_card_detail_component__l || Object, typeof (vendor_card_detail_component__m = typeof authentication_store_AuthenticationStore !== "undefined" && authentication_store_AuthenticationStore) === "function" && vendor_card_detail_component__m || Object, typeof (vendor_card_detail_component__o = typeof event_store_EventStore !== "undefined" && event_store_EventStore) === "function" && vendor_card_detail_component__o || Object, typeof (vendor_card_detail_component__p = typeof EnvironmentConfiguration !== "undefined" && EnvironmentConfiguration) === "function" && vendor_card_detail_component__p || Object, typeof (vendor_card_detail_component__q = typeof event_validation_service_EventValidationService !== "undefined" && event_validation_service_EventValidationService) === "function" && vendor_card_detail_component__q || Object])
], vendor_card_detail_component_VendorCardDetailComponent);

var vendor_card_detail_component__a, vendor_card_detail_component__b, vendor_card_detail_component__c, vendor_card_detail_component__d, vendor_card_detail_component__e, vendor_card_detail_component__f, vendor_card_detail_component__g, vendor_card_detail_component__h, vendor_card_detail_component__j, vendor_card_detail_component__k, vendor_card_detail_component__l, vendor_card_detail_component__m, vendor_card_detail_component__o, vendor_card_detail_component__p, vendor_card_detail_component__q;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/vendor-card-detail.component.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/vendor-lookup-form/vendor-lookup-form.component.ts
var vendor_lookup_form_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var vendor_lookup_form_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var vendor_lookup_form_component___awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var vendor_lookup_form_component___generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};















var vendor_lookup_form_component_VendorLookupFormComponent = (function () {
    function VendorLookupFormComponent(translateService, propertyLookupStore, logService, authenticationStore, taxDeterminationStore, eventStore, eventValidationService) {
        this.translateService = translateService;
        this.propertyLookupStore = propertyLookupStore;
        this.logService = logService;
        this.authenticationStore = authenticationStore;
        this.taxDeterminationStore = taxDeterminationStore;
        this.eventStore = eventStore;
        this.eventValidationService = eventValidationService;
        this.isReadOnly = false;
        this.isNewEvent = false;
        this.outputEmail = new core_es5["EventEmitter"]();
        this.removeVendorProcess = new core_es5["EventEmitter"]();
        this.partyType = PartyType.PROPERTY;
        this.addVendorButtonTittle = '';
        this.isPropertySelected = false;
        this.canAddVendor = false;
        this.openedCardIndex = 0;
        this.checkErrorVendorsNum = false;
    }
    VendorLookupFormComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.isPropertySelected = false;
        this.eventStore.selectedEvent.pipe(Object(operators["take"])(1)).subscribe(function (event) {
            if (!event) {
                _this.onyxEvent = new OnyxEvent();
            }
            else if (event instanceof OnyxEvent) {
                _this.onyxEvent = event;
            }
            else {
                _this.onyxEvent = new OnyxEvent(event);
            }
            if (_this.onyxEvent.eventProperty && _this.onyxEvent.eventProperty.eventPartyId) {
                _this.isPropertySelected = true;
            }
        });
        if (this.authenticationStore.isSinglePropertyUser() && this.isNewEvent) {
            this.authenticationStore.user.pipe(Object(operators["take"])(1)).subscribe(function (user) {
                _this.getPropertyDetailFromUser(user);
            });
        }
        this.showAdvancedPropertySearch = this.authenticationStore.hasPermission('ViewExtendedPropertySearch');
        this.eventValidationService.canAddVendor().pipe(Object(operators["take"])(1)).subscribe(function (canAddVendor) {
            _this.canAddVendor = canAddVendor;
        });
        this.isReadyOnlyProperty = this.authenticationStore.isSinglePropertyUser();
    };
    VendorLookupFormComponent.prototype.getPropertyDetailFromUser = function (user) {
        if (user && user.allChains && user.allChains.length > 0
            && user.allBrands && user.allBrands.length > 0
            && user.allProperties && user.allProperties.length > 0) {
            var propertyQuery = new PropertyLookupDetailQuery({
                chain: user.allChains[0],
                brand: user.allBrands[0],
                propertyId: user.allProperties[0],
            });
            this.isPropertySelected = true;
            this.logService.debug("propertySummary " + JSON.stringify(propertyQuery));
            this.propertyLookupStore.getDetail(propertyQuery).pipe(Object(operators["take"])(1)).subscribe();
        }
    };
    VendorLookupFormComponent.prototype.isPropertyMissing = function () {
        var hasVendors = this.onyxEvent && this.onyxEvent.eventVendors && this.onyxEvent.eventVendors.length > 0;
        return this.checkErrorVendorsNum && !hasVendors;
    };
    VendorLookupFormComponent.prototype.closedPropertyPopup = function (vendor) {
        var _this = this;
        if (vendor) {
            // consult tax rate
            var taxResponseList_1 = null;
            var taxRequest = property_lookup_converter_PropertyLookupConverter.createTaxRequest(vendor, this.parentForm.value.eventAgency);
            this.taxDeterminationStore.verifyTaxRatesByParty(taxRequest)
                .subscribe(function (listTaxResponse) { return vendor_lookup_form_component___awaiter(_this, void 0, void 0, function () {
                var eventProperty, eventPropertyStringified, vendorsCount, lastCard;
                return vendor_lookup_form_component___generator(this, function (_a) {
                    taxResponseList_1 = listTaxResponse.isValidTax && listTaxResponse.taxResponses ? listTaxResponse.taxResponses : null;
                    eventProperty = property_lookup_converter_PropertyLookupConverter.vendorToParty(vendor, true, taxResponseList_1);
                    eventPropertyStringified = JSON.stringify(eventProperty);
                    this.logService.info(eventPropertyStringified);
                    if (!this.onyxEvent.eventVendors) {
                        this.onyxEvent.eventVendors = [];
                    }
                    vendorsCount = this.onyxEvent.eventVendors.push(JSON.parse(eventPropertyStringified));
                    lastCard = this.cards ? this.cards.last : undefined;
                    if (lastCard !== undefined) {
                        this.onToggle(vendorsCount - 1, lastCard);
                    }
                    this.isPropertySelected = true;
                    this.checkErrorVendorsNum = false;
                    return [2 /*return*/];
                });
            }); });
        }
    };
    VendorLookupFormComponent.prototype.openAdvancedPropertySearchPopup = function () {
        this.propertyPopup.open();
    };
    VendorLookupFormComponent.prototype.setupPropertyEmail = function (email) {
        this.outputEmail.emit(email);
    };
    VendorLookupFormComponent.prototype.onDeleteVendor = function (vendor) {
        var _this = this;
        this.onyxEvent.eventVendors.forEach(function (item, index) {
            if (item === vendor) {
                _this.deleteVendorForm(vendor);
                _this.onyxEvent.eventVendors.splice(index, 1);
                _this.removeVendorProcess.emit(vendor);
                if (!_this.onyxEvent.eventVendors || _this.onyxEvent.eventVendors.length === 0) {
                    _this.checkErrorVendorsNum = true;
                }
                if (index === _this.openedCardIndex) {
                    _this.openedCardIndex = -1;
                }
            }
        });
        this.eventStore.setEvent(this.onyxEvent);
    };
    VendorLookupFormComponent.prototype.deleteVendorForm = function (vendor) {
        var vendorCode = vendor.code ? vendor.code : vendor.chain + '|' + vendor.brand + '|' + vendor.propertyId;
        var vendorFormName = "eventVendor-" + vendorCode;
        this.parentForm.removeControl(vendorFormName);
    };
    VendorLookupFormComponent.prototype.isValidRequiredInformation = function () {
        if (!this.parentForm.get('event').valid) {
            this.addVendorButtonTittle = this.translateService.instant('EVENT.PROPERTY.ADD_NEW_VENDOR_BUTTON_DISABLED_TOOLTIP');
        }
        else {
            this.addVendorButtonTittle = '';
        }
        return this.parentForm.get('event').valid;
    };
    VendorLookupFormComponent.prototype.onToggle = function (index, card) {
        if (this.openedCardIndex === index) {
            // Toggling the card that was open. By setting the index to -1, all cards will be closed.
            this.openedCardIndex = -1;
        }
        else {
            // Open the vendor card in the provided index.
            this.openedCardIndex = index;
            // Scroll to the card
            setTimeout(function () {
                card.cardWrapper.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }, 100);
        }
    };
    VendorLookupFormComponent.prototype.trackVendorByFn = function (index, vendor) {
        return vendor.eventPartyId;
    };
    VendorLookupFormComponent.prototype.shouldShowAddVendorButton = function () {
        var baseConditions = this.canAddVendor && !this.isReadOnly && this.showAdvancedPropertySearch;
        // Update mode
        if (this.onyxEvent && this.onyxEvent.eventId != null) {
            return baseConditions;
        }
        // New event mode
        var noVendors = !this.onyxEvent || !this.onyxEvent.eventVendors || this.onyxEvent.eventVendors.length === 0;
        return baseConditions && noVendors;
    };
    VendorLookupFormComponent.prototype.shouldShowAddVendorsMessage = function () {
        return this.onyxEvent &&
            this.onyxEvent.eventId == null &&
            this.onyxEvent.eventVendors &&
            this.onyxEvent.eventVendors.length > 0;
    };
    return VendorLookupFormComponent;
}());
vendor_lookup_form_component___decorate([
    Object(core_es5["Input"])(),
    vendor_lookup_form_component___metadata("design:type", typeof (vendor_lookup_form_component__a = typeof forms_es5["FormGroup"] !== "undefined" && forms_es5["FormGroup"]) === "function" && vendor_lookup_form_component__a || Object)
], vendor_lookup_form_component_VendorLookupFormComponent.prototype, "parentForm", void 0);
vendor_lookup_form_component___decorate([
    Object(core_es5["Input"])(),
    vendor_lookup_form_component___metadata("design:type", Object)
], vendor_lookup_form_component_VendorLookupFormComponent.prototype, "isReadOnly", void 0);
vendor_lookup_form_component___decorate([
    Object(core_es5["Input"])(),
    vendor_lookup_form_component___metadata("design:type", Object)
], vendor_lookup_form_component_VendorLookupFormComponent.prototype, "isNewEvent", void 0);
vendor_lookup_form_component___decorate([
    Object(core_es5["Input"])(),
    vendor_lookup_form_component___metadata("design:type", String)
], vendor_lookup_form_component_VendorLookupFormComponent.prototype, "inputEmail", void 0);
vendor_lookup_form_component___decorate([
    Object(core_es5["Output"])(),
    vendor_lookup_form_component___metadata("design:type", typeof (vendor_lookup_form_component__b = typeof core_es5["EventEmitter"] !== "undefined" && core_es5["EventEmitter"]) === "function" && vendor_lookup_form_component__b || Object)
], vendor_lookup_form_component_VendorLookupFormComponent.prototype, "outputEmail", void 0);
vendor_lookup_form_component___decorate([
    Object(core_es5["Output"])(),
    vendor_lookup_form_component___metadata("design:type", typeof (vendor_lookup_form_component__c = typeof core_es5["EventEmitter"] !== "undefined" && core_es5["EventEmitter"]) === "function" && vendor_lookup_form_component__c || Object)
], vendor_lookup_form_component_VendorLookupFormComponent.prototype, "removeVendorProcess", void 0);
vendor_lookup_form_component___decorate([
    Object(core_es5["ViewChild"])(vendor_popup_component_VendorPopupComponent),
    vendor_lookup_form_component___metadata("design:type", typeof (vendor_lookup_form_component__d = typeof vendor_popup_component_VendorPopupComponent !== "undefined" && vendor_popup_component_VendorPopupComponent) === "function" && vendor_lookup_form_component__d || Object)
], vendor_lookup_form_component_VendorLookupFormComponent.prototype, "propertyPopup", void 0);
vendor_lookup_form_component___decorate([
    Object(core_es5["ViewChildren"])('card'),
    vendor_lookup_form_component___metadata("design:type", typeof (vendor_lookup_form_component__e = typeof core_es5["QueryList"] !== "undefined" && core_es5["QueryList"]) === "function" && vendor_lookup_form_component__e || Object)
], vendor_lookup_form_component_VendorLookupFormComponent.prototype, "cards", void 0);
vendor_lookup_form_component_VendorLookupFormComponent = vendor_lookup_form_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-vendor-lookup-form',
        template: __webpack_require__("XZrh"),
        styles: [__webpack_require__("/Y8/")]
    }),
    vendor_lookup_form_component___metadata("design:paramtypes", [typeof (vendor_lookup_form_component__f = typeof core["c" /* TranslateService */] !== "undefined" && core["c" /* TranslateService */]) === "function" && vendor_lookup_form_component__f || Object, typeof (vendor_lookup_form_component__g = typeof property_lookup_store_PropertyLookupStore !== "undefined" && property_lookup_store_PropertyLookupStore) === "function" && vendor_lookup_form_component__g || Object, typeof (vendor_lookup_form_component__h = typeof log_service_LogService !== "undefined" && log_service_LogService) === "function" && vendor_lookup_form_component__h || Object, typeof (vendor_lookup_form_component__j = typeof authentication_store_AuthenticationStore !== "undefined" && authentication_store_AuthenticationStore) === "function" && vendor_lookup_form_component__j || Object, typeof (vendor_lookup_form_component__k = typeof tax_determination_store_TaxDeterminationStore !== "undefined" && tax_determination_store_TaxDeterminationStore) === "function" && vendor_lookup_form_component__k || Object, typeof (vendor_lookup_form_component__l = typeof event_store_EventStore !== "undefined" && event_store_EventStore) === "function" && vendor_lookup_form_component__l || Object, typeof (vendor_lookup_form_component__m = typeof event_validation_service_EventValidationService !== "undefined" && event_validation_service_EventValidationService) === "function" && vendor_lookup_form_component__m || Object])
], vendor_lookup_form_component_VendorLookupFormComponent);

var vendor_lookup_form_component__a, vendor_lookup_form_component__b, vendor_lookup_form_component__c, vendor_lookup_form_component__d, vendor_lookup_form_component__e, vendor_lookup_form_component__f, vendor_lookup_form_component__g, vendor_lookup_form_component__h, vendor_lookup_form_component__j, vendor_lookup_form_component__k, vendor_lookup_form_component__l, vendor_lookup_form_component__m;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/vendor-lookup-form.component.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/vendor-rate/vendor-rate.component.ts
var vendor_rate_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var vendor_rate_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};








var vendor_rate_component_VendorRateComponent = (function () {
    function VendorRateComponent(formBuilder, propertyLookupStore, commonDataStore) {
        this.formBuilder = formBuilder;
        this.propertyLookupStore = propertyLookupStore;
        this.commonDataStore = commonDataStore;
        this.canceled = new core_es5["EventEmitter"]();
        this.accepted = new core_es5["EventEmitter"]();
        this.vendorFormControlsConfig = {
            'commissionRoomPercentage': [null,
                [forms_es5["Validators"].required, pioneer_validators_PioneerValidators.range(0, 100), pioneer_validators_PioneerValidators.isInteger]],
            'commRetention': [false, [forms_es5["Validators"].required]]
        };
        this.vendorFormValidators = {
            validator: forms_es5["Validators"].compose([])
        };
        this.list = [];
    }
    VendorRateComponent.prototype.ngOnInit = function () {
        this.createForm();
        this.vendorRateForm.enable();
    };
    VendorRateComponent.prototype.createForm = function () {
        this.vendorRateForm = this.formBuilder.group(this.vendorFormControlsConfig, this.vendorFormValidators);
    };
    VendorRateComponent.prototype.cancel = function () {
        this.canceled.emit();
    };
    Object.defineProperty(VendorRateComponent.prototype, "commissionRoomPercentage", {
        get: function () { return this.vendorRateForm.get('commissionRoomPercentage'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VendorRateComponent.prototype, "commRetention", {
        get: function () { return this.vendorRateForm.get('commRetention'); },
        enumerable: true,
        configurable: true
    });
    VendorRateComponent.prototype.addCommissionRate = function () {
        var vendor = new Vendor({
            commissionRoomPercentage: this.commissionRoomPercentage.value,
            commRetention: this.commRetention.value
        });
        this.accepted.emit(property_lookup_converter_PropertyLookupConverter.propertyToVendor(this.property, vendor));
    };
    return VendorRateComponent;
}());
vendor_rate_component___decorate([
    Object(core_es5["Output"])(),
    vendor_rate_component___metadata("design:type", Object)
], vendor_rate_component_VendorRateComponent.prototype, "canceled", void 0);
vendor_rate_component___decorate([
    Object(core_es5["Output"])(),
    vendor_rate_component___metadata("design:type", Object)
], vendor_rate_component_VendorRateComponent.prototype, "accepted", void 0);
vendor_rate_component___decorate([
    Object(core_es5["Input"])(),
    vendor_rate_component___metadata("design:type", typeof (vendor_rate_component__a = typeof Property !== "undefined" && Property) === "function" && vendor_rate_component__a || Object)
], vendor_rate_component_VendorRateComponent.prototype, "property", void 0);
vendor_rate_component_VendorRateComponent = vendor_rate_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-vendor-rate',
        template: __webpack_require__("AkXp"),
        styles: [__webpack_require__("Um/v")]
    }),
    vendor_rate_component___metadata("design:paramtypes", [typeof (vendor_rate_component__b = typeof forms_es5["FormBuilder"] !== "undefined" && forms_es5["FormBuilder"]) === "function" && vendor_rate_component__b || Object, typeof (vendor_rate_component__c = typeof property_lookup_store_PropertyLookupStore !== "undefined" && property_lookup_store_PropertyLookupStore) === "function" && vendor_rate_component__c || Object, typeof (vendor_rate_component__d = typeof common_data_store_CommonDataStore !== "undefined" && common_data_store_CommonDataStore) === "function" && vendor_rate_component__d || Object])
], vendor_rate_component_VendorRateComponent);

var vendor_rate_component__a, vendor_rate_component__b, vendor_rate_component__c, vendor_rate_component__d;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/vendor-rate.component.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/vendor-search-results/vendor-search-results.component.ts
var vendor_search_results_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var vendor_search_results_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};



var vendor_search_results_component_VendorSearchResultsComponent = (function () {
    function VendorSearchResultsComponent() {
        this.itemsPerPage = Constants.PROPERTY_SEARCH_ITEMS_PER_PAGE;
        this.selected = new core_es5["EventEmitter"]();
        this.goToAdd = new core_es5["EventEmitter"]();
        this.hasSearched = false;
    }
    VendorSearchResultsComponent.prototype.ngOnInit = function () {
    };
    VendorSearchResultsComponent.prototype.ngOnChanges = function (changes) {
        // Initialize currentPage for every search
        this.currentPage = 1;
        if (changes.searchResults && changes.searchResults.previousValue) {
            this.hasSearched = true;
        }
    };
    VendorSearchResultsComponent.prototype.selectProperty = function (property) {
        this.selected.emit(property);
    };
    VendorSearchResultsComponent.prototype.getFirstPageItemNumber = function () {
        return (this.currentPage - 1) * this.itemsPerPage;
    };
    VendorSearchResultsComponent.prototype.getLastPageItemNumber = function () {
        return (this.size < (this.currentPage * this.itemsPerPage)) ? this.size : (this.currentPage * this.itemsPerPage);
    };
    VendorSearchResultsComponent.prototype.getSize = function () {
        return this.size;
    };
    VendorSearchResultsComponent.prototype.maxResultsExceeded = function () {
        return this.size > Constants.PROPERTY_SEARCH_MAX_RESULTS;
    };
    VendorSearchResultsComponent.prototype.goToAddProperty = function () {
        this.goToAdd.emit();
    };
    return VendorSearchResultsComponent;
}());
vendor_search_results_component___decorate([
    Object(core_es5["Input"])(),
    vendor_search_results_component___metadata("design:type", typeof (vendor_search_results_component__a = typeof immutable["List"] !== "undefined" && immutable["List"]) === "function" && vendor_search_results_component__a || Object)
], vendor_search_results_component_VendorSearchResultsComponent.prototype, "searchResults", void 0);
vendor_search_results_component___decorate([
    Object(core_es5["Input"])(),
    vendor_search_results_component___metadata("design:type", Number)
], vendor_search_results_component_VendorSearchResultsComponent.prototype, "totalItems", void 0);
vendor_search_results_component___decorate([
    Object(core_es5["Input"])(),
    vendor_search_results_component___metadata("design:type", Number)
], vendor_search_results_component_VendorSearchResultsComponent.prototype, "size", void 0);
vendor_search_results_component___decorate([
    Object(core_es5["Output"])(),
    vendor_search_results_component___metadata("design:type", Object)
], vendor_search_results_component_VendorSearchResultsComponent.prototype, "selected", void 0);
vendor_search_results_component___decorate([
    Object(core_es5["Output"])(),
    vendor_search_results_component___metadata("design:type", Object)
], vendor_search_results_component_VendorSearchResultsComponent.prototype, "goToAdd", void 0);
vendor_search_results_component_VendorSearchResultsComponent = vendor_search_results_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-vendor-search-results',
        template: __webpack_require__("9Xkd"),
        styles: [__webpack_require__("oAZY")]
    }),
    vendor_search_results_component___metadata("design:paramtypes", [])
], vendor_search_results_component_VendorSearchResultsComponent);

var vendor_search_results_component__a;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/vendor-search-results.component.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/agency-dashboard/status-chart/status-chart.component.ts
var status_chart_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var status_chart_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};




var status_chart_component_StatusChartComponent = (function () {
    function StatusChartComponent(translateService, predefinedSearchService) {
        this.translateService = translateService;
        this.predefinedSearchService = predefinedSearchService;
        this.labelBySearchStatusMapping = (_a = {},
            _a[UISearchStatusMappingEnum.CANCELLED.toString()] = 'EVENTS.PAYMENT_STATUS_FILTER_VALUE.CANCELLED',
            _a[UISearchStatusMappingEnum.INVOICED.toString()] = 'EVENTS.PAYMENT_STATUS_FILTER_VALUE.INVOICED',
            _a[UISearchStatusMappingEnum.PAID_DIRECT.toString()] = 'EVENTS.PAYMENT_STATUS_FILTER_VALUE.PAID_DIRECT',
            _a[UISearchStatusMappingEnum.PAY_SENT.toString()] = 'EVENTS.PAYMENT_STATUS_FILTER_VALUE.PAY_SENT',
            _a[UISearchStatusMappingEnum.PENDING.toString()] = 'EVENTS.PAYMENT_STATUS_FILTER_VALUE.PENDING',
            _a[UISearchStatusMappingEnum.READY_TO_INITIATE.toString()] = 'EVENTS.PAYMENT_STATUS_FILTER_VALUE.READY_TO_INITIATE',
            _a[UISearchStatusMappingEnum.REQUEST_REJECTED.toString()] = 'EVENTS.PAYMENT_STATUS_FILTER_VALUE.REQUEST_REJECTED',
            _a[UISearchStatusMappingEnum.REQUESTED.toString()] = 'EVENTS.PAYMENT_STATUS_FILTER_VALUE.REQUESTED',
            _a[UISearchStatusMappingEnum.RESENT_REQUEST.toString()] = 'EVENTS.PAYMENT_STATUS_FILTER_VALUE.RESENT_REQUEST',
            _a[UISearchStatusMappingEnum.FUNDED.toString()] = 'EVENTS.PAYMENT_STATUS_FILTER_VALUE.FUNDED',
            _a[UISearchStatusMappingEnum.PAY_CLEARED.toString()] = 'EVENTS.PAYMENT_STATUS_FILTER_VALUE.PAY_CLEARED',
            _a[UISearchStatusMappingEnum.CHECK_STOPPED.toString()] = 'EVENTS.PAYMENT_STATUS_FILTER_VALUE.CHECK_STOPPED',
            _a[UISearchStatusMappingEnum.PAY_REISSUED.toString()] = 'EVENTS.PAYMENT_STATUS_FILTER_VALUE.PAY_REISSUED',
            _a);
        this.chartData = [];
        this.width = 300;
        this.height = 400;
        this.colors = [
            '#00BD12',
            '#007AD1',
            '#44BAEF',
            '#E70000',
            '#96D886',
            '#B1E7FF',
            '#012974',
            '#1D8800',
            '#B3B3B3',
            '#FFCF2C',
            '#B200FF',
            '#FF6A00',
            '#FF00DC',
            '#606060',
        ];
        this.totalEvents = 0;
        this.radius = 95;
        var _a;
    }
    StatusChartComponent.prototype.ngOnInit = function () { };
    StatusChartComponent.prototype.ngOnChanges = function (changes) {
        var _this = this;
        var x = 0;
        this.chartData.sort(function (a, b) {
            return a.list_order < b.list_order ? -1 : a.list_order > b.list_order ? 1 : 0;
        });
        this.chartData.forEach(function (element) {
            element.color = element.color;
            element.selected = false;
            element.label = _this.labelForPaymentStatusValue(element.code);
            x++;
            if (x === 14) {
                x = 0;
            }
            _this.totalEvents += element.value;
        });
        var accumulatedDegrees = 0;
        var childNumber = 1;
        var chartCssString = '';
        this.chartData.forEach(function (element) {
            element.percent = (element.value * 100) / _this.totalEvents;
            var degrees = element.percent * 3.6;
            if (_this.chartData.length > 1 && element.percent > 1) {
                element.rotateDegree = 'calc(-90deg + ' + accumulatedDegrees + 'deg)';
            }
            else {
                element.rotateDegree = 'calc(-90deg + ' + accumulatedDegrees + 'deg)';
            }
            accumulatedDegrees += degrees;
            chartCssString += _this.generateItemCssString(element, childNumber, _this.chartData.length);
            childNumber++;
        });
        this.appendCss(chartCssString);
    };
    StatusChartComponent.prototype.labelForPaymentStatusValue = function (filterValue) {
        var label = this.labelBySearchStatusMapping[filterValue] || filterValue;
        return this.translateService.instant(label);
    };
    StatusChartComponent.prototype.generateItemCssString = function (element, childNumber, total) {
        var pi = 3.14159265359;
        var percent = element.percent;
        // if (total > 1 && element.percent > 1) {
        //   percent = element.percent - 0.4;
        // }
        var val1 = ((this.radius * percent) / 100) * 2 * pi;
        var val2 = this.radius * (1 - percent / 100) * 2 * pi;
        var cssString = "\n      @keyframes percent" +
            childNumber +
            " {\n        to {\n          stroke-dasharray: " +
            val1 +
            " " +
            val2 +
            " ;\n        }\n      }\n      .donut:nth-child(" +
            childNumber +
            ") {\n        transform: rotateZ(" +
            element.rotateDegree +
            ");\n        animation: percent" +
            childNumber +
            " 0s ease-in-out forwards;\n      }";
        return cssString;
    };
    StatusChartComponent.prototype.appendCss = function (cssString) {
        var style = document.createElement('STYLE');
        style.innerText = cssString;
        document.body.appendChild(style);
    };
    StatusChartComponent.prototype.trMouseOver = function (item) {
        item.selected = true;
    };
    StatusChartComponent.prototype.trMouseOut = function (item) {
        item.selected = false;
    };
    StatusChartComponent.prototype.launchEventListPage = function (chartItem) {
        if (chartItem.code === 'readyToInitiate') {
            return;
        }
        this.predefinedSearchService.paymentStatusSearch(chartItem.code);
    };
    return StatusChartComponent;
}());
status_chart_component___decorate([
    Object(core_es5["Input"])(),
    status_chart_component___metadata("design:type", Object)
], status_chart_component_StatusChartComponent.prototype, "chartData", void 0);
status_chart_component___decorate([
    Object(core_es5["Input"])(),
    status_chart_component___metadata("design:type", Object)
], status_chart_component_StatusChartComponent.prototype, "width", void 0);
status_chart_component___decorate([
    Object(core_es5["Input"])(),
    status_chart_component___metadata("design:type", Object)
], status_chart_component_StatusChartComponent.prototype, "height", void 0);
status_chart_component_StatusChartComponent = status_chart_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-status-chart',
        template: __webpack_require__("zobq"),
        styles: [__webpack_require__("3cth")],
    }),
    status_chart_component___metadata("design:paramtypes", [typeof (status_chart_component__a = typeof core["c" /* TranslateService */] !== "undefined" && core["c" /* TranslateService */]) === "function" && status_chart_component__a || Object, typeof (status_chart_component__b = typeof predefined_search_service_PredefinedSearchService !== "undefined" && predefined_search_service_PredefinedSearchService) === "function" && status_chart_component__b || Object])
], status_chart_component_StatusChartComponent);

var status_chart_component__a, status_chart_component__b;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/status-chart.component.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/agency-dashboard/update-status-popup/update-status-popup.component.ts
var update_status_popup_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var update_status_popup_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};



var update_status_popup_component_UpdateStatusPopupComponent = (function () {
    function UpdateStatusPopupComponent() {
        this.propertyPopupType = PopupType.SEARCH;
        this.PopupType = PopupType;
        this.config = {
            backdrop: 'static',
            keyboard: false
        };
        this.closed = new core_es5["EventEmitter"]();
    }
    UpdateStatusPopupComponent.prototype.ngOnInit = function () { };
    UpdateStatusPopupComponent.prototype.cancel = function () {
        this.updateStatusModal.hide();
    };
    UpdateStatusPopupComponent.prototype.open = function () {
        this.propertyPopupType = PopupType.SEARCH;
        this.updateStatusModal.show();
    };
    UpdateStatusPopupComponent.prototype.close = function () {
        this.closed.emit();
        this.updateStatusModal.hide();
    };
    return UpdateStatusPopupComponent;
}());
update_status_popup_component___decorate([
    Object(core_es5["ViewChild"])(ngx_bootstrap["b" /* ModalDirective */]),
    update_status_popup_component___metadata("design:type", typeof (update_status_popup_component__a = typeof ngx_bootstrap["b" /* ModalDirective */] !== "undefined" && ngx_bootstrap["b" /* ModalDirective */]) === "function" && update_status_popup_component__a || Object)
], update_status_popup_component_UpdateStatusPopupComponent.prototype, "updateStatusModal", void 0);
update_status_popup_component___decorate([
    Object(core_es5["Output"])(),
    update_status_popup_component___metadata("design:type", Object)
], update_status_popup_component_UpdateStatusPopupComponent.prototype, "closed", void 0);
update_status_popup_component_UpdateStatusPopupComponent = update_status_popup_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-update-status-popup',
        template: __webpack_require__("cqHV"),
        styles: [__webpack_require__("FA5L")],
    }),
    update_status_popup_component___metadata("design:paramtypes", [])
], update_status_popup_component_UpdateStatusPopupComponent);

var update_status_popup_component__a;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/update-status-popup.component.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/agency-dashboard/dashboard-to-do-card/dashboard-to-do-card.component.ts
var dashboard_to_do_card_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var dashboard_to_do_card_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};












var dashboard_to_do_card_component_DashboardToDoCardComponent = (function () {
    function DashboardToDoCardComponent(completedUnpaidDashboardStore, missingAgencyDashboardStore, multiAgencyService, logger, eventSearchFormsStore, eventSearchParametersStore, predefinedSearchService) {
        this.completedUnpaidDashboardStore = completedUnpaidDashboardStore;
        this.missingAgencyDashboardStore = missingAgencyDashboardStore;
        this.multiAgencyService = multiAgencyService;
        this.logger = logger;
        this.eventSearchFormsStore = eventSearchFormsStore;
        this.eventSearchParametersStore = eventSearchParametersStore;
        this.predefinedSearchService = predefinedSearchService;
        this.defaultAgency$ = this.multiAgencyService.defaultAgency$;
        this.agencySubscription$ = new Subscription["Subscription"]();
    }
    DashboardToDoCardComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.showCompletedAndUnpaid = true;
        this.showMissingAgency = true;
        this.searchText = '';
        this.agencySubscription$ = this.defaultAgency$.subscribe(function () {
            _this.completedUnpaidDashboardStore.loadTotals().subscribe();
            _this.missingAgencyDashboardStore.loadTotals().subscribe();
        });
        this.completedUnpaidDashboardStore.showCard().subscribe(function (bool) {
            _this.showCompletedAndUnpaid = bool;
        });
        this.missingAgencyDashboardStore.showCard().subscribe(function (bool) {
            _this.showMissingAgency = bool;
        });
    };
    DashboardToDoCardComponent.prototype.openBulkActionModal = function (action) {
        // this.eventSearchParametersStore.reset(false);
        this.bulkActionPopup.open(action);
    };
    DashboardToDoCardComponent.prototype.closedBulkActionModal = function (event) { };
    DashboardToDoCardComponent.prototype.launchEventListPage = function (statusCategory) {
        this.eventSearchParametersStore.reset(false);
        var statusCode = '';
        var missingEmail = false;
        switch (statusCategory) {
            case 'Review Rejected Payment Requests':
                statusCode = 'rejectedPaymentRequests';
                break;
            case 'Request Payments':
                statusCode = 'requestPayments';
                break;
            case 'Add Missing Payment Items':
                statusCode = 'missingPaymentItems';
                break;
            case 'Add Missing Vendor Contact Email':
                missingEmail = true;
                break;
            default:
                break;
        }
        if (missingEmail) {
            this.predefinedSearchService.missingVendorContactEmailSearch();
        }
        else {
            this.predefinedSearchService.paymentStatusSearch(statusCode);
        }
    };
    Object.defineProperty(DashboardToDoCardComponent.prototype, "BulkAction", {
        get: function () {
            return BulkAction;
        },
        enumerable: true,
        configurable: true
    });
    DashboardToDoCardComponent.prototype.addSearchText = function () {
        var models = { searchText: this.searchText };
        var eventSearchText = new EventSearchText(models);
        this.logger.info("addSearchText: " + JSON.stringify(models));
        if (!eventSearchText.searchText) {
            return;
        }
        this.eventSearchParametersStore.reset(true);
        this.eventSearchFormsStore.searchFromSearchText(eventSearchText);
    };
    return DashboardToDoCardComponent;
}());
dashboard_to_do_card_component___decorate([
    Object(core_es5["ViewChild"])(bulk_action_popup_component_BulkActionPopupComponent),
    dashboard_to_do_card_component___metadata("design:type", typeof (dashboard_to_do_card_component__a = typeof bulk_action_popup_component_BulkActionPopupComponent !== "undefined" && bulk_action_popup_component_BulkActionPopupComponent) === "function" && dashboard_to_do_card_component__a || Object)
], dashboard_to_do_card_component_DashboardToDoCardComponent.prototype, "bulkActionPopup", void 0);
dashboard_to_do_card_component___decorate([
    Object(core_es5["Input"])(),
    dashboard_to_do_card_component___metadata("design:type", Array)
], dashboard_to_do_card_component_DashboardToDoCardComponent.prototype, "todolist", void 0);
dashboard_to_do_card_component_DashboardToDoCardComponent = dashboard_to_do_card_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-dashboard-to-do-card',
        template: __webpack_require__("ghS0"),
        styles: [__webpack_require__("Gfsy")],
    }),
    dashboard_to_do_card_component___metadata("design:paramtypes", [typeof (dashboard_to_do_card_component__b = typeof completed_unpaid_dashboard_store_CompletedUnpaidDashboardStore !== "undefined" && completed_unpaid_dashboard_store_CompletedUnpaidDashboardStore) === "function" && dashboard_to_do_card_component__b || Object, typeof (dashboard_to_do_card_component__c = typeof missing_agency_dashboard_store_MissingAgencyDashboardStore !== "undefined" && missing_agency_dashboard_store_MissingAgencyDashboardStore) === "function" && dashboard_to_do_card_component__c || Object, typeof (dashboard_to_do_card_component__d = typeof multi_agency_service_MultiAgencyService !== "undefined" && multi_agency_service_MultiAgencyService) === "function" && dashboard_to_do_card_component__d || Object, typeof (dashboard_to_do_card_component__e = typeof log_service_LogService !== "undefined" && log_service_LogService) === "function" && dashboard_to_do_card_component__e || Object, typeof (dashboard_to_do_card_component__f = typeof event_search_forms_store_EventSearchFormsStore !== "undefined" && event_search_forms_store_EventSearchFormsStore) === "function" && dashboard_to_do_card_component__f || Object, typeof (dashboard_to_do_card_component__g = typeof event_search_parameters_store_EventSearchParametersStore !== "undefined" && event_search_parameters_store_EventSearchParametersStore) === "function" && dashboard_to_do_card_component__g || Object, typeof (dashboard_to_do_card_component__h = typeof predefined_search_service_PredefinedSearchService !== "undefined" && predefined_search_service_PredefinedSearchService) === "function" && dashboard_to_do_card_component__h || Object])
], dashboard_to_do_card_component_DashboardToDoCardComponent);

var dashboard_to_do_card_component__a, dashboard_to_do_card_component__b, dashboard_to_do_card_component__c, dashboard_to_do_card_component__d, dashboard_to_do_card_component__e, dashboard_to_do_card_component__f, dashboard_to_do_card_component__g, dashboard_to_do_card_component__h;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/dashboard-to-do-card.component.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/service/calculate-payment.service.ts
var calculate_payment_service___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var calculate_payment_service___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};





var calculate_payment_service_CalculatePaymentService = (function () {
    function CalculatePaymentService(adjustmentStore, taxDeterminationStore) {
        this.adjustmentStore = adjustmentStore;
        this.taxDeterminationStore = taxDeterminationStore;
    }
    CalculatePaymentService.prototype.getCalculatedPayment = function (eventPartyId, subscriberVendor) {
        return this.adjustmentStore.getVendorCalculatedPayment(eventPartyId, ReservationStatusCode.CHECKED_OUT, subscriberVendor, 0).pipe(Object(operators["map"])(function (vendorCalculatedPayment) { return vendorCalculatedPayment ? vendorCalculatedPayment : 0; }));
    };
    CalculatePaymentService.prototype.getVendorCalculatedTaxes = function (eventPartyId, subscriberVendor, applyOoiv) {
        var _this = this;
        return this.getCalculatedPayment(eventPartyId, subscriberVendor).pipe(Object(operators["mergeMap"])(function (calculatedPayment) { return _this.taxDeterminationStore.getVendorCalculatedTaxes(eventPartyId, calculatedPayment, applyOoiv); }));
    };
    CalculatePaymentService.prototype.getCalculatedPaymentWithTax = function (eventPartyId, subscriberVendor, applyOoiv, prepayment) {
        var _this = this;
        return this.getVendorCalculatedTaxes(eventPartyId, subscriberVendor, applyOoiv).pipe(Object(operators["mergeMap"])(function (vendorCalculatedTaxes) {
            return _this.adjustmentStore.getVendorCalculatedPayment(eventPartyId, ReservationStatusCode.CHECKED_OUT, subscriberVendor, vendorCalculatedTaxes);
        }), Object(operators["map"])(function (vendorCalculatedPayment) {
            var payment = vendorCalculatedPayment ? vendorCalculatedPayment : 0;
            var prepaymentAmount = prepayment && prepayment.commissionAmount ? prepayment.commissionAmount : 0;
            return payment - prepaymentAmount;
        }));
    };
    return CalculatePaymentService;
}());
calculate_payment_service_CalculatePaymentService = calculate_payment_service___decorate([
    Object(core_es5["Injectable"])(),
    calculate_payment_service___metadata("design:paramtypes", [typeof (calculate_payment_service__a = typeof adjustment_store_AdjustmentStore !== "undefined" && adjustment_store_AdjustmentStore) === "function" && calculate_payment_service__a || Object, typeof (calculate_payment_service__b = typeof tax_determination_store_TaxDeterminationStore !== "undefined" && tax_determination_store_TaxDeterminationStore) === "function" && calculate_payment_service__b || Object])
], calculate_payment_service_CalculatePaymentService);

var calculate_payment_service__a, calculate_payment_service__b;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/calculate-payment.service.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/matching-agency/matching-agency-list/matching-agency-list.component.ts
var matching_agency_list_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var matching_agency_list_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};





var matching_agency_list_component_MatchingAgencyListComponent = (function () {
    function MatchingAgencyListComponent(environment, matchingAgencyService, router) {
        this.environment = environment;
        this.matchingAgencyService = matchingAgencyService;
        this.router = router;
        this.sortPage = new core_es5["EventEmitter"]();
    }
    MatchingAgencyListComponent.prototype.ngOnInit = function () {
    };
    Object.defineProperty(MatchingAgencyListComponent.prototype, "agencyCount", {
        get: function () {
            return this.agencies.totalElements;
        },
        enumerable: true,
        configurable: true
    });
    MatchingAgencyListComponent.prototype.selectAgency = function (agency) {
        this.matchingAgencyService.setSelectedAgency(agency);
        this.matchingAgencyService.setSelectedPage(this.currentPage);
        this.router.navigate(['/events/matching/agency/candidates'], {});
    };
    MatchingAgencyListComponent.prototype.sortList = function (field, direction) {
        this.sortPage.emit({ field: field, direction: direction });
    };
    return MatchingAgencyListComponent;
}());
matching_agency_list_component___decorate([
    Object(core_es5["Input"])(),
    matching_agency_list_component___metadata("design:type", typeof (matching_agency_list_component__a = typeof page_Page !== "undefined" && page_Page) === "function" && matching_agency_list_component__a || Object)
], matching_agency_list_component_MatchingAgencyListComponent.prototype, "agencies", void 0);
matching_agency_list_component___decorate([
    Object(core_es5["Input"])(),
    matching_agency_list_component___metadata("design:type", Number)
], matching_agency_list_component_MatchingAgencyListComponent.prototype, "currentPage", void 0);
matching_agency_list_component___decorate([
    Object(core_es5["Output"])(),
    matching_agency_list_component___metadata("design:type", typeof (matching_agency_list_component__b = typeof core_es5["EventEmitter"] !== "undefined" && core_es5["EventEmitter"]) === "function" && matching_agency_list_component__b || Object)
], matching_agency_list_component_MatchingAgencyListComponent.prototype, "sortPage", void 0);
matching_agency_list_component_MatchingAgencyListComponent = matching_agency_list_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-matching-agency-list',
        template: __webpack_require__("sMoM"),
        styles: []
    }),
    matching_agency_list_component___metadata("design:paramtypes", [typeof (matching_agency_list_component__c = typeof EnvironmentConfiguration !== "undefined" && EnvironmentConfiguration) === "function" && matching_agency_list_component__c || Object, typeof (matching_agency_list_component__d = typeof matching_agency_service_MatchingAgencyService !== "undefined" && matching_agency_service_MatchingAgencyService) === "function" && matching_agency_list_component__d || Object, typeof (matching_agency_list_component__e = typeof router_es5["Router"] !== "undefined" && router_es5["Router"]) === "function" && matching_agency_list_component__e || Object])
], matching_agency_list_component_MatchingAgencyListComponent);

var matching_agency_list_component__a, matching_agency_list_component__b, matching_agency_list_component__c, matching_agency_list_component__d, matching_agency_list_component__e;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/matching-agency-list.component.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/event.module.ts
var event_module___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};





































































































































































































var EventModule = (function () {
    function EventModule() {
    }
    return EventModule;
}());
EventModule = event_module___decorate([
    Object(core_es5["NgModule"])({
        imports: [
            SharedModule,
            forms_es5["FormsModule"],
            forms_es5["ReactiveFormsModule"],
            router_es5["RouterModule"].forChild(event_routes_routes)
        ],
        declarations: [
            add_event_component_AddEventComponent,
            basic_event_data_component_BasicEventDataComponent,
            contact_form_component_ContactFormComponent,
            property_lookup_form_component_PropertyLookupFormComponent,
            vendor_lookup_form_component_VendorLookupFormComponent,
            event_list_component_EventListComponent,
            event_list_default_table_component_EventListDefaultTableComponent,
            event_list_financial_component_EventListFinancialComponent,
            event_list_multi_vendor_component_EventListMultiVendorComponent,
            event_component_EventComponent,
            commission_component_CommissionComponent,
            vendor_commission_component_VendorCommissionComponent,
            vendor_commission_card_component_VendorCommissionCardComponent,
            payment_reservations_component_PaymentReservationsComponent,
            child_contact_form_component_ChildContactFormComponent,
            HeaderSummaryComponent,
            VendorHeaderSummaryComponent,
            stay_summary_component_StaySummaryComponent,
            add_payment_component_AddPaymentComponent,
            attachment_component_AttachmentComponent,
            pickup_report_attachment_component_PickupReportAttachmentComponent,
            rsvp_page_component_RsvpComponent,
            rsvp_summary_component_RsvpSummaryComponent,
            rsvp_bulk_component_RsvpBulkComponent,
            add_rsvp_component_AddRsvpComponent,
            vendor_rsvp_page_component_VendorRsvpComponent,
            vendor_rsvp_card_component_VendorRsvpCardComponent,
            reservation_filter_component_ReservationFilterComponent,
            reservation_page_component_ReservationPageComponent,
            reservation_summary_table_component_ReservationSummaryTableComponent,
            reservation_detail_table_component_ReservationDetailTableComponent,
            payment_record_component_PaymentRecordComponent,
            payment_equation_component_PaymentEquationComponent,
            automatic_payment_toggle_component_AutomaticPaymentToggleComponent,
            dashboard_component_DashboardComponent,
            agency_dashboard_component_AgencyDashboardComponent,
            status_chart_component_StatusChartComponent,
            completed_unpaid_component_CompletedUnpaidComponent,
            missing_agency_component_MissingAgencyComponent,
            event_list_card_component_EventListCardComponent,
            reservation_button_bar_component_ReservationButtonBarComponent,
            reservation_modal_component_ReservationModalComponent,
            reservation_bulk_component_ReservationBulkComponent,
            reservation_form_component_ReservationFormComponent,
            rsvp_compare_component_RsvpCompareComponent,
            transient_modal_component_TransientModalComponent,
            transient_table_component_TransientTableComponent,
            transient_search_component_TransientSearchComponent,
            transient_reservation_component_TransientReservationComponent,
            edit_event_button_bar_component_EditEventButtonBarComponent,
            add_event_button_bar_component_AddEventButtonBarComponent,
            add_prepayment_component_AddPrepaymentComponent,
            payment_summary_component_PaymentSummaryComponent,
            agency_form_component_AgencyFormComponent,
            add_adjustment_component_AddAdjustmentComponent,
            rsvp_modal_component_RsvpModalComponent,
            rsvp_form_component_RsvpFormComponent,
            overview_page_component_OverviewPageComponent,
            DateRoomTypeSummaryComponent,
            vendor_overview_page_component_VendorOverviewComponent,
            vendor_overview_card_component_VendorOverviewCardComponent,
            property_popup_component_PropertyPopupComponent,
            property_add_component_PropertyAddComponent,
            property_search_component_PropertySearchComponent,
            property_search_results_component_PropertySearchResultsComponent,
            vendor_popup_component_VendorPopupComponent,
            vendor_search_component_VendorSearchComponent,
            vendor_search_results_component_VendorSearchResultsComponent,
            vendor_rate_component_VendorRateComponent,
            vendor_add_component_VendorAddComponent,
            payment_rsvp_component_PaymentRsvpComponent,
            rate_plan_code_component_RatePlanCodeComponent,
            matching_property_component_MatchingPropertyComponent,
            matching_property_list_component_MatchingPropertyListComponent,
            matching_property_candidate_component_MatchingPropertyCandidateComponent,
            bulk_action_popup_component_BulkActionPopupComponent,
            event_match_component_EventMatchComponent,
            invoice_history_component_InvoiceHistoryComponent,
            InvoiceHistoryUserComponent,
            invoice_history_vendor_component_InvoiceHistoryVendorComponent,
            invoice_history_vendor_card_component_InvoiceHistoryVendorCardComponent,
            vendor_card_detail_component_VendorCardDetailComponent,
            vendors_total_add_payment_component_VendorsTotalAddPaymentComponent,
            vendor_reservation_page_component_VendorReservationComponent,
            vendor_reservation_card_component_VendorReservationCardComponent,
            custom_fields_form_component_CustomFieldsFormComponent,
            forecasted_commission_component_ForecastedCommissionComponent,
            matching_agency_component_MatchingAgencyComponent,
            matching_agency_list_component_MatchingAgencyListComponent,
            matching_agency_candidate_component_MatchingAgencyCandidateComponent,
            update_status_popup_component_UpdateStatusPopupComponent,
            dashboard_to_do_card_component_DashboardToDoCardComponent
        ],
        exports: [
            pickup_report_attachment_component_PickupReportAttachmentComponent
        ],
        providers: [
            AttachmentResolver,
            PickupReportAttachmentResolver,
            attachment_store_AttachmentStore,
            commission_store_CommissionStore,
            event_store_EventStore,
            event_list_store_EventListStore,
            event_http_service_EventHttpService,
            events_resolver_EventsResolver,
            event_list_resolver_EventListResolver,
            EventResolver,
            AttachmentHttpService,
            commission_service_CommissionService,
            property_lookup_http_service_PropertyLookupHttpService,
            property_lookup_store_PropertyLookupStore,
            PayorTypeResolver,
            reservation_http_service_ReservationService,
            ReservationResolver,
            event_has_items_resolver_EventHasItemsResolver,
            reservation_store_ReservationStore,
            reservation_compare_http_service_ReservationCompareService,
            reservation_compare_resolver_ReservationCompareResolver,
            reservation_compare_store_ReservationCompareStore,
            payment_store_PaymentStore,
            payment_http_service_PaymentHttpService,
            ooiv_rules_store_OoivRulesStore,
            OoivRulesHttpService,
            awe_store_AweStore,
            awe_http_service_AweHttpService,
            rsvp_store_RsvpStore,
            rsvp_http_service_RsvpHttpService,
            rsvp_compare_resolver_RsvpCompareResolver,
            common_es5["CurrencyPipe"],
            adjustment_store_AdjustmentStore,
            adjustment_http_service_AdjustmentHttpService,
            AdjustmentResolver,
            LatestPaymentResolver,
            PaymentsResolver,
            grouppay_config_store_GroupPayConfigStore,
            grouppay_config_http_service_GroupPayConfigHttpService,
            event_search_parameters_store_EventSearchParametersStore,
            completed_unpaid_dashboard_store_CompletedUnpaidDashboardStore,
            missing_agency_dashboard_store_MissingAgencyDashboardStore,
            matching_property_store_MatchingPropertyStore,
            invoice_history_store_InvoiceHistoryStore,
            invoice_history_http_service_InvoiceHistoryHttpService,
            dashboard_totals_http_service_DashboardTotalsHttpService,
            matching_property_http_service_MatchingPropertyHttpService,
            CanDeactiveReservationDetailTable,
            event_filter_util_service_EventFilterUtilsService,
            event_menu_search_filter_mapper_EventMenuSearchFilterMapper,
            event_search_forms_store_EventSearchFormsStore,
            predefined_search_service_PredefinedSearchService,
            transient_reservation_store_TransientReservationStore,
            transient_reservation_http_service_TransientReservationService,
            LatestPrepaymentResolver,
            common_data_store_CommonDataStore,
            CommonDataHttpService,
            CountryResolver,
            CurrencyResolver,
            adjustment_type_store_AdjustmentTypeStore,
            adjustment_type_http_service_AdjustmentTypeHttpService,
            AdjustmentTypeCreditResolver,
            AdjustmentTypeDebitResolver,
            RsvpResolver,
            OverviewResolver,
            RsvpDetailResolver,
            ReservationDetailResolver,
            property_store_PropertyStore,
            property_http_service_PropertyHttpService,
            core["c" /* TranslateService */],
            transaction_resolver_TransactionResolver,
            vendor_transaction_resolver_VendorTransactionResolver,
            overview_store_OverviewStore,
            OverviewHttpService,
            ChainResolver,
            chain_brand_store_ChainBrandStore,
            chain_brand_http_service_ChainBrandHttpService,
            FinalPaymentStatusResolver,
            event_collision_service_EventCollisionService,
            event_match_log_store_EventMatchLogStore,
            event_match_log_http_service_EventMatchLogHttpService,
            VendorsTotalPaymentsResolver,
            event_validation_service_EventValidationService,
            guid_generator_store_GuidGeneratorStore,
            guid_generator_service_GuidGeneratorService,
            event_validation_service_EventValidationService,
            tax_determination_http_service_TaxDeterminationService,
            tax_determination_store_TaxDeterminationStore,
            TaxDeterminationResolver,
            OoivRulesValidationResolver,
            mstr_http_service_MSTRHttpService,
            custom_label_store_CustomLabelStore,
            custom_label_http_service_CustomLabelHttpService,
            custom_label_resolver_CustomLabelResolver,
            agency_dashboard_http_service_AgencyDashboardService,
            InitialPaymentResolver,
            invoice_history_resolver_InvoiceHistoryResolver,
            calculate_payment_service_CalculatePaymentService,
            matching_agency_store_MatchingAgencyStore,
            matching_agency_http_service_MatchingAgencyHttpService,
            calculate_payment_service_CalculatePaymentService,
            payment_summary_resolver_PaymentSummaryResolver,
            payment_summary_store_PaymentSummaryStore,
            matching_agency_http_service_MatchingAgencyHttpService
        ]
    })
], EventModule);

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/event.module.js.map
// EXTERNAL MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/node_modules/angulartics2/dist/es5/index.js
var es5 = __webpack_require__("AL9+");
var es5_default = /*#__PURE__*/__webpack_require__.n(es5);

// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/expiration-modal/expiration-modal-config.ts
var ExpirationModalConfig = (function () {
    function ExpirationModalConfig(content, logOutEarly, stayLoggedIn, returnToLogin, title, closed) {
        this.content = content;
        this.logOutEarly = logOutEarly;
        this.stayLoggedIn = stayLoggedIn;
        this.returnToLogin = returnToLogin;
        this.title = title;
        this.closed = closed;
    }
    return ExpirationModalConfig;
}());

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/expiration-modal-config.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/services/layout.service.ts
var layout_service___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var layout_service___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};


var layout_service_LayoutService = (function () {
    function LayoutService() {
        this.defaultShowLayoutState = true;
        this.showLayout = new BehaviorSubject["BehaviorSubject"](this.defaultShowLayoutState);
    }
    LayoutService.prototype.resetShowLayout = function () {
        this.showLayout.next(this.defaultShowLayoutState);
    };
    return LayoutService;
}());
layout_service_LayoutService = layout_service___decorate([
    Object(core_es5["Injectable"])(),
    layout_service___metadata("design:paramtypes", [])
], layout_service_LayoutService);

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/layout.service.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/app.component.ts
var app_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var app_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};














var app_component_AppComponent = (function () {
    function AppComponent(translate, authenticationStore, menuStore, angulartics2GoogleAnalytics, ngZone, router, layoutService, environment) {
        var _this = this;
        this.translate = translate;
        this.authenticationStore = authenticationStore;
        this.ngZone = ngZone;
        this.router = router;
        this.layoutService = layoutService;
        this.environment = environment;
        this.showLayout = true;
        this.expirationModalConfig = new ExpirationModalConfig();
        this.userRum = null;
        // Configure the defaults and setup the translation service from ng-translate.
        translate.setDefaultLang('en-US');
        translate.use('en-US');
        // need to change duration, which otherwise would be 1250 milliseconds which feels very slow
        ng2_page_scroll["b" /* PageScrollConfig */].defaultDuration = 0;
        this.userIsLoggedIn = authenticationStore.isLoggedIn();
        menuStore.pageTitle.subscribe(function (pageTitle) {
            // to remove the ExpressionChangedAfterItHasBeenCheckedError
            // https://github.com/angular/angular/issues/17572
            _this.ngZone.runOutsideAngular(function () {
                setTimeout(function () {
                    _this.ngZone.run(function () {
                        _this.title = pageTitle;
                    });
                }, 0);
            });
        });
    }
    AppComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.resetPage();
        this.authenticationStore.user.subscribe(function (user) {
            _this.user = user;
            _this.createUserRum(user);
        });
        var authenticated = false;
        this.userIsLoggedIn.subscribe(function (loggedIn) {
            authenticated = loggedIn;
        });
        // NgZone is used to run the interval because Protractor will wait forever for Observable.interval to finish
        // https://github.com/juliemr/ngconf-2016-zones/blob/master/src/app/main.ts#L88
        this.ngZone.runOutsideAngular(function () {
            setInterval(function () {
                _this.ngZone.run(function () {
                    var diff;
                    if (_this.user && _this.user.expiration) {
                        diff = Date.parse(_this.user.expiration.toString()) - Date.parse(new Date().toString());
                    }
                    else {
                        diff = 0;
                    }
                    var seconds = _this.getSeconds(diff);
                    if (seconds <= Constants.SESSION_EXPIRE_WARNING_SECONDS && authenticated) {
                        if (_this.expirationModal.closed) {
                            _this.expirationModal.open();
                        }
                        if (seconds <= 0) {
                            _this.expirationModal.close(false);
                            _this.authenticationStore.logout();
                            _this.expirationModal.setAlreadyExpired(true);
                            _this.expirationModalConfig.content = _this.translate.instant('AUTHENTICATION_EXPIRATION.CONTENT_EXPIRED');
                            var message = new flash_message_record_FlashMessage(MessageLevel.ERROR, _this.translate.instant('EXTERNAL_LOGIN_EXPIRED.LOG_IN_AGAIN'), true);
                            _this.flashMessageComponent.show(message);
                        }
                        else {
                            _this.expirationModal.setAlreadyExpired(false);
                            _this.expirationModalConfig.content = _this.translate.instant('AUTHENTICATION_EXPIRATION.CONTENT_NOT_EXPIRED', {
                                seconds: seconds
                            });
                        }
                    }
                });
            }, 1000);
        });
        this.showLayoutSubscription = this.layoutService.showLayout.subscribe(function (showLayout) {
            _this.showLayout = showLayout;
        });
        this.setRumMonitor();
    };
    AppComponent.prototype.ngOnDestroy = function () {
        if (this.showLayoutSubscription) {
            this.showLayoutSubscription.unsubscribe();
        }
    };
    AppComponent.prototype.setRumMonitor = function () {
        var _this = this;
        // Implement DataDog RUM
        if (this.environment.cwr.enable === true) {
            // Set user information
            if (this.userRum && this.userRum !== undefined && this.userRum !== null) {
                var email_1 = this.userRum.email || '';
                var id_1 = this.userRum.username || '';
                if (window && window.DD_RUM !== undefined) {
                    window.DD_RUM.onReady(function () {
                        window.DD_RUM.setUser({
                            email: email_1,
                            id: id_1
                        });
                    });
                }
                if (window && window.DD_LOGS !== undefined && typeof window.DD_LOGS.onReady === 'function') {
                    window.DD_LOGS.onReady(function () {
                        if (typeof window.DD_LOGS.setUser === 'function') {
                            window.DD_LOGS.setUser({ email: email_1, id: id_1 });
                        }
                    });
                }
            }
            // Set view name (User journey)
            this.router.events.subscribe(function (event) {
                if (event instanceof router_es5["NavigationEnd"]) {
                    if (window.DD_RUM && typeof window.DD_RUM.startView === 'function') {
                        window.DD_RUM.startView({ name: _this.router.url });
                    }
                }
            });
        }
        // Disabling AWS rum
        /* if (this.environment.cwr.enable === true) {
         this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd && typeof cwr !== 'undefined') {
              cwr('recordPageView', this.router.url);
              if (this.userRum) {
                cwr('addSessionAttributes', { userName: this.userRum.email });
                cwr('recordEvent', {
                  type: `user_custom_event_${this.userRum.email}`,
                  data: {
                    user: this.userRum,
                    page: this.router.url
                  }
                });
              }
            }
          });
        }*/
    };
    AppComponent.prototype.getSeconds = function (t) {
        return Math.max(Math.floor(t / 1000), 0);
    };
    AppComponent.prototype.createUserRum = function (user) {
        if (user && user.email && user.email.length > 0 && this.userRum === null) {
            var userEmail = this.checksum(user.email);
            var userUserName = this.checksum(user.username);
            var fistName = this.checksum(user.firstName);
            var lastName = this.checksum(user.lastName);
            var newUser = JSON.parse(JSON.stringify(user));
            newUser.email = userEmail;
            newUser.fistName = fistName;
            newUser.username = userUserName;
            newUser.lastName = lastName;
            this.userRum = newUser;
        }
    };
    /**
     * Checks to see if navigation was successful and resets the page
     * to an expected state.
     */
    AppComponent.prototype.resetPage = function () {
        var _this = this;
        this.router.events.subscribe(function (routerEvent) {
            if (!(routerEvent instanceof router_es5["NavigationEnd"])) {
                return;
            }
            /**
             * Forces the app to scroll to the top of page when navigation is successful,
             * solving the issue where the user would change pages and stay in the middle
             * of the page.
             * See: https://stackoverflow.com/questions/39601026/angular-2-scroll-to-top-on-route-change
             */
            window.scrollTo(0, 0);
            /**
             * Resets any flash Messages that aren't set to be persistent.
             */
            _this.flashMessageComponent.clearNonPersistentMessages();
        });
    };
    AppComponent.prototype.padStart = function (str, targetLength, padString) {
        targetLength = Math.floor(targetLength);
        padString = String(typeof padString !== 'undefined' ? padString : ' ');
        if (str.length >= targetLength) {
            return String(str);
        }
        else {
            targetLength = targetLength - str.length;
            if (targetLength > padString.length) {
                padString += padString.repeat(targetLength / padString.length);
            }
            return padString.slice(0, targetLength) + String(str);
        }
    };
    AppComponent.prototype.checksum = function (str) {
        var fnv_prime = 0x01000193;
        var hash = 0x811c9dc5;
        for (var i = 0; i < str.length; i++) {
            var charCode = str.charCodeAt(i);
            var hashBinary = this.padStart((hash).toString(2), 32, '0').split('');
            var charCodeBinary = this.padStart((charCode).toString(2), 32, '0').split('');
            for (var j = 0; j < 32; j++) {
                hashBinary[j] = hashBinary[j] === charCodeBinary[j] ? '0' : '1';
            }
            hash = parseInt(hashBinary.join(''), 2);
            hash = Math.floor(hash * fnv_prime) % 4294967296;
        }
        var fnv = hash.toString(16);
        if (fnv.length > 8) {
            fnv = fnv.substring(0, 8);
        }
        return fnv;
    };
    return AppComponent;
}());
app_component___decorate([
    Object(core_es5["ViewChild"])(flash_messages_component_FlashMessagesComponent),
    app_component___metadata("design:type", typeof (app_component__a = typeof flash_messages_component_FlashMessagesComponent !== "undefined" && flash_messages_component_FlashMessagesComponent) === "function" && app_component__a || Object)
], app_component_AppComponent.prototype, "flashMessageComponent", void 0);
app_component___decorate([
    Object(core_es5["ViewChild"])(expiration_modal_component_ExpirationModalComponent),
    app_component___metadata("design:type", typeof (app_component__b = typeof expiration_modal_component_ExpirationModalComponent !== "undefined" && expiration_modal_component_ExpirationModalComponent) === "function" && app_component__b || Object)
], app_component_AppComponent.prototype, "expirationModal", void 0);
app_component_AppComponent = app_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-root',
        template: __webpack_require__("efyd")
    }),
    app_component___metadata("design:paramtypes", [typeof (app_component__c = typeof core["c" /* TranslateService */] !== "undefined" && core["c" /* TranslateService */]) === "function" && app_component__c || Object, typeof (app_component__d = typeof authentication_store_AuthenticationStore !== "undefined" && authentication_store_AuthenticationStore) === "function" && app_component__d || Object, typeof (app_component__e = typeof menu_store_MenuStore !== "undefined" && menu_store_MenuStore) === "function" && app_component__e || Object, typeof (app_component__f = typeof es5["Angulartics2GoogleAnalytics"] !== "undefined" && es5["Angulartics2GoogleAnalytics"]) === "function" && app_component__f || Object, typeof (app_component__g = typeof core_es5["NgZone"] !== "undefined" && core_es5["NgZone"]) === "function" && app_component__g || Object, typeof (app_component__h = typeof router_es5["Router"] !== "undefined" && router_es5["Router"]) === "function" && app_component__h || Object, typeof (app_component__j = typeof layout_service_LayoutService !== "undefined" && layout_service_LayoutService) === "function" && app_component__j || Object, typeof (app_component__k = typeof EnvironmentConfiguration !== "undefined" && EnvironmentConfiguration) === "function" && app_component__k || Object])
], app_component_AppComponent);

var app_component__a, app_component__b, app_component__c, app_component__d, app_component__e, app_component__f, app_component__g, app_component__h, app_component__j, app_component__k;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app.component.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/auth/secured-home/secured-home.component.ts
var secured_home_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var secured_home_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};









var secured_home_component_SecuredHomeComponent = (function () {
    function SecuredHomeComponent(route, router, authenticationStore, userLocalStorageService, logService, http, environment, responseUtilService) {
        this.route = route;
        this.router = router;
        this.authenticationStore = authenticationStore;
        this.userLocalStorageService = userLocalStorageService;
        this.logService = logService;
        this.http = http;
        this.environment = environment;
        this.responseUtilService = responseUtilService;
    }
    SecuredHomeComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.route.queryParams.map(function (params) { return params['authorization']; }).filter(function (token) { return token; })
            .delay(100) // We get errors without this delay
            .subscribe(function (token) { return _this.storeTokenFromQueryString(token); });
    };
    SecuredHomeComponent.prototype.storeTokenFromQueryString = function (token) {
        var _this = this;
        // this is necessary in case they were already logged in before coming to this page
        this.authenticationStore.logout(false);
        this.userLocalStorageService.removeItem(authentication_store_AuthenticationStore.MULTI_AGENCY_STR);
        // get jti
        this.authenticationStore.handleJtiFromExternalSource(token).subscribe(function (jti) {
            if (jti && jti.jti) {
                _this.authenticationStore.handleTokenFromExternalSource(token, jti.jti).subscribe(function (userPermission) {
                    if (_this.authenticationStore.openDefaultArcIataModalPanel(userPermission.token)) {
                        _this.retrieveAgencies().subscribe(function (data) {
                            _this.iataByDefaultModal.open(userPermission.token, data);
                        }, function (error) {
                            if (error === ExternalSourceError.TOKEN_EXPIRED) {
                                _this.router.navigate(['/external-login-expired']);
                                _this.logService.debug("after navigate['/external-login-expired']");
                            }
                            else {
                                _this.router.navigate(['/error', { error: 'MESSAGES.ERROR.EXTERNAL_LOGIN_ERROR' }]);
                            }
                        });
                    }
                    else {
                        _this.router.navigate(['/'], { replaceUrl: true });
                    }
                }, function (error) {
                    if (error === ExternalSourceError.TOKEN_EXPIRED) {
                        _this.router.navigate(['/external-login-expired']);
                        _this.logService.debug("after navigate['/external-login-expired']");
                    }
                    else {
                        _this.router.navigate(['/error', { error: 'MESSAGES.ERROR.EXTERNAL_LOGIN_ERROR' }]);
                    }
                });
            }
            else {
                _this.router.navigate(['/error', { error: 'MESSAGES.ERROR.EXTERNAL_LOGIN_ERROR' }]);
            }
        }, function (error) {
            if (error === ExternalSourceError.TOKEN_EXPIRED) {
                _this.router.navigate(['/external-login-expired']);
                _this.logService.debug("after navigate['/external-login-expired']");
            }
            else {
                _this.router.navigate(['/error', { error: 'MESSAGES.ERROR.EXTERNAL_LOGIN_ERROR' }]);
            }
        });
    };
    SecuredHomeComponent.prototype.retrieveAgencies = function () {
        var _this = this;
        return this.http.get(this.environment.baseUrl + '/api/lookup/agencies/token')
            .map(function (response) { return response.json(); })
            .catch(function (response) { return _this.responseUtilService.handleError(response); }).share();
    };
    return SecuredHomeComponent;
}());
secured_home_component___decorate([
    Object(core_es5["ViewChild"])(iata_by_default_modal_component_IataByDefaultModalComponent),
    secured_home_component___metadata("design:type", typeof (secured_home_component__a = typeof iata_by_default_modal_component_IataByDefaultModalComponent !== "undefined" && iata_by_default_modal_component_IataByDefaultModalComponent) === "function" && secured_home_component__a || Object)
], secured_home_component_SecuredHomeComponent.prototype, "iataByDefaultModal", void 0);
secured_home_component_SecuredHomeComponent = secured_home_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-secured-home',
        template: __webpack_require__("kt5u")
    }),
    secured_home_component___metadata("design:paramtypes", [typeof (secured_home_component__b = typeof router_es5["ActivatedRoute"] !== "undefined" && router_es5["ActivatedRoute"]) === "function" && secured_home_component__b || Object, typeof (secured_home_component__c = typeof router_es5["Router"] !== "undefined" && router_es5["Router"]) === "function" && secured_home_component__c || Object, typeof (secured_home_component__d = typeof authentication_store_AuthenticationStore !== "undefined" && authentication_store_AuthenticationStore) === "function" && secured_home_component__d || Object, typeof (secured_home_component__e = typeof user_local_storage_service_UserLocalStorageService !== "undefined" && user_local_storage_service_UserLocalStorageService) === "function" && secured_home_component__e || Object, typeof (secured_home_component__f = typeof log_service_LogService !== "undefined" && log_service_LogService) === "function" && secured_home_component__f || Object, typeof (secured_home_component__g = typeof AppAuthHttpService !== "undefined" && AppAuthHttpService) === "function" && secured_home_component__g || Object, typeof (secured_home_component__h = typeof EnvironmentConfiguration !== "undefined" && EnvironmentConfiguration) === "function" && secured_home_component__h || Object, typeof (secured_home_component__j = typeof response_util_service_ResponseUtilService !== "undefined" && response_util_service_ResponseUtilService) === "function" && secured_home_component__j || Object])
], secured_home_component_SecuredHomeComponent);

var secured_home_component__a, secured_home_component__b, secured_home_component__c, secured_home_component__d, secured_home_component__e, secured_home_component__f, secured_home_component__g, secured_home_component__h, secured_home_component__j;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/secured-home.component.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/auth/login/login.component.ts
var login_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var login_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};






var LoginComponent = (function () {
    function LoginComponent(router, authenticationStore, logService, flashMessagesService, translateService) {
        this.router = router;
        this.authenticationStore = authenticationStore;
        this.logService = logService;
        this.flashMessagesService = flashMessagesService;
        this.translateService = translateService;
    }
    LoginComponent.prototype.ngOnInit = function () {
    };
    LoginComponent.prototype.onLogin = function () {
        var _this = this;
        if (this.email == null || this.password == null) {
            this.flashMessagesService.error('MESSAGES.VALIDATION.ALL_FIELDS_REQUIRED', 'Login Error: email and password fields required');
            return;
        }
        var obs = this.authenticationStore.login(this.email, this.password);
        obs.subscribe(function (loginSuccess) { return _this.router.navigate(['/']); }, function (error) {
            _this.flashMessagesService.error('LOGIN.CREDENTIALS_INVALID', 'Login Error: ' + error);
        });
        return obs;
    };
    return LoginComponent;
}());
LoginComponent = login_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-login',
        template: __webpack_require__("K2V+")
    }),
    login_component___metadata("design:paramtypes", [typeof (login_component__a = typeof router_es5["Router"] !== "undefined" && router_es5["Router"]) === "function" && login_component__a || Object, typeof (login_component__b = typeof authentication_store_AuthenticationStore !== "undefined" && authentication_store_AuthenticationStore) === "function" && login_component__b || Object, typeof (login_component__c = typeof log_service_LogService !== "undefined" && log_service_LogService) === "function" && login_component__c || Object, typeof (login_component__d = typeof flash_messages_service_FlashMessagesService !== "undefined" && flash_messages_service_FlashMessagesService) === "function" && login_component__d || Object, typeof (login_component__e = typeof core["c" /* TranslateService */] !== "undefined" && core["c" /* TranslateService */]) === "function" && login_component__e || Object])
], LoginComponent);

var login_component__a, login_component__b, login_component__c, login_component__d, login_component__e;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/login.component.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/auth/logout/logout.component.ts
var logout_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var logout_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};




var LogoutComponent = (function () {
    function LogoutComponent(router, authenticationStore, logService) {
        this.router = router;
        this.authenticationStore = authenticationStore;
        this.logService = logService;
        this.errorMessage = null;
        this.logService.verbose('LogoutComponent constructor');
    }
    LogoutComponent.prototype.ngOnInit = function () {
        this.errorMessage = null;
    };
    LogoutComponent.prototype.onLogout = function () {
        this.authenticationStore.logout();
        this.router.navigate(['login']);
    };
    return LogoutComponent;
}());
LogoutComponent = logout_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-logout',
        template: __webpack_require__("1DO0")
    }),
    logout_component___metadata("design:paramtypes", [typeof (logout_component__a = typeof router_es5["Router"] !== "undefined" && router_es5["Router"]) === "function" && logout_component__a || Object, typeof (logout_component__b = typeof authentication_store_AuthenticationStore !== "undefined" && authentication_store_AuthenticationStore) === "function" && logout_component__b || Object, typeof (logout_component__c = typeof log_service_LogService !== "undefined" && log_service_LogService) === "function" && logout_component__c || Object])
], LogoutComponent);

var logout_component__a, logout_component__b, logout_component__c;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/logout.component.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/guards/can-activate-via-guest-guard.ts
var can_activate_via_guest_guard___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var can_activate_via_guest_guard___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};




var CanActivateViaGuestGuard = (function () {
    function CanActivateViaGuestGuard(router, authService, logService) {
        this.router = router;
        this.authService = authService;
        this.logService = logService;
    }
    CanActivateViaGuestGuard.prototype.canActivate = function () {
        var _this = this;
        this.logService.debug('Checking if the user is already authenticated. If so, then redirect to the secure site');
        return this.authService.isLoggedIn().map(function (isLoggedIn) {
            if (isLoggedIn) {
                _this.router.navigate(['/']);
            }
            // Returning !isLoggedIn since we only want to activate the guard is the user is not logged in.
            return !isLoggedIn;
        });
    };
    return CanActivateViaGuestGuard;
}());
CanActivateViaGuestGuard = can_activate_via_guest_guard___decorate([
    Object(core_es5["Injectable"])(),
    can_activate_via_guest_guard___metadata("design:paramtypes", [typeof (can_activate_via_guest_guard__a = typeof router_es5["Router"] !== "undefined" && router_es5["Router"]) === "function" && can_activate_via_guest_guard__a || Object, typeof (can_activate_via_guest_guard__b = typeof authentication_store_AuthenticationStore !== "undefined" && authentication_store_AuthenticationStore) === "function" && can_activate_via_guest_guard__b || Object, typeof (can_activate_via_guest_guard__c = typeof log_service_LogService !== "undefined" && log_service_LogService) === "function" && can_activate_via_guest_guard__c || Object])
], CanActivateViaGuestGuard);

var can_activate_via_guest_guard__a, can_activate_via_guest_guard__b, can_activate_via_guest_guard__c;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/can-activate-via-guest-guard.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/auth/external-login-expired/external-login-expired.component.ts
var external_login_expired_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var external_login_expired_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};



var ExternalLoginExpiredComponent = (function () {
    function ExternalLoginExpiredComponent(environment, route) {
        this.environment = environment;
        this.route = route;
    }
    ExternalLoginExpiredComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (this.route.snapshot.queryParamMap.get('redirect') !== null) {
            setTimeout(function () {
                location.href = _this.environment.portalUrl + _this.environment.portalLogout;
            }, this.environment.portalRedirectTimer);
        }
    };
    return ExternalLoginExpiredComponent;
}());
ExternalLoginExpiredComponent = external_login_expired_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-external-login-expired',
        template: __webpack_require__("o9sb")
    }),
    external_login_expired_component___metadata("design:paramtypes", [typeof (external_login_expired_component__a = typeof EnvironmentConfiguration !== "undefined" && EnvironmentConfiguration) === "function" && external_login_expired_component__a || Object, typeof (external_login_expired_component__b = typeof router_es5["ActivatedRoute"] !== "undefined" && router_es5["ActivatedRoute"]) === "function" && external_login_expired_component__b || Object])
], ExternalLoginExpiredComponent);

var external_login_expired_component__a, external_login_expired_component__b;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/external-login-expired.component.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/auth/auth.routes.ts






var auth_routes_routes = [
    {
        path: 'login',
        component: LoginComponent,
        canActivate: [CanActivateViaGuestGuard]
    },
    {
        path: 'logout',
        component: LogoutComponent,
        canActivate: [CanActivateViaAuthGuard]
    },
    {
        path: 'secured',
        component: secured_home_component_SecuredHomeComponent
    },
    {
        path: 'external-login-expired',
        component: ExternalLoginExpiredComponent,
        canActivate: [CanActivateViaGuestGuard]
    }
];
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/auth.routes.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/guards/allow-api-docs.guard.ts
var allow_api_docs_guard___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var allow_api_docs_guard___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};


var AllowApiDocsGuard = (function () {
    function AllowApiDocsGuard(environment) {
        this.environment = environment;
    }
    AllowApiDocsGuard.prototype.canActivate = function (next, state) {
        return this.environment.allowApiDocs;
    };
    return AllowApiDocsGuard;
}());
AllowApiDocsGuard = allow_api_docs_guard___decorate([
    Object(core_es5["Injectable"])(),
    allow_api_docs_guard___metadata("design:paramtypes", [typeof (allow_api_docs_guard__a = typeof EnvironmentConfiguration !== "undefined" && EnvironmentConfiguration) === "function" && allow_api_docs_guard__a || Object])
], AllowApiDocsGuard);

var allow_api_docs_guard__a;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/allow-api-docs.guard.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/auth/auth.module.ts
var auth_module___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};






















var AuthModule = (function () {
    function AuthModule() {
    }
    return AuthModule;
}());
AuthModule = auth_module___decorate([
    Object(core_es5["NgModule"])({
        imports: [
            common_es5["CommonModule"],
            forms_es5["FormsModule"],
            SharedModule,
            PermissionModule,
            router_es5["RouterModule"].forChild(auth_routes_routes)
        ],
        declarations: [
            LoginComponent,
            LogoutComponent,
            secured_home_component_SecuredHomeComponent,
            ExternalLoginExpiredComponent
        ],
        providers: [
            CanActivateViaAuthGuard,
            CanActivateViaGuestGuard,
            PermissionGuard,
            final_payment_authorized_guard_FinalPaymentAuthorizedGuard,
            authentication_store_AuthenticationStore,
            authentication_http_service_AuthenticationHttpService,
            AllowApiDocsGuard,
            DashboardRedirectGuard,
            AgencyDashboardRedirectGuard,
            OverviewRedirectGuard,
            VendorOverviewRedirectGuard
        ],
        exports: []
    })
], AuthModule);

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/auth.module.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/navigation/header/header.component.ts
var header_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var header_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};






var header_component_HeaderComponent = (function () {
    function HeaderComponent(authenticationStore, environment, multiAgencyService, agencyLookupStore) {
        this.authenticationStore = authenticationStore;
        this.environment = environment;
        this.multiAgencyService = multiAgencyService;
        this.agencyLookupStore = agencyLookupStore;
        this.imagesUrl = '';
        this.agencies = Object(immutable["List"])();
        this.showSupportButton = false;
    }
    HeaderComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.userIsLoggedIn = this.authenticationStore.isLoggedIn();
        this.authenticationStore.user.subscribe(function (user) {
            _this.user = user;
        });
        this.multiAgencyService.isEventSelected$.subscribe(function (event) {
            _this.isEventSelected = event;
        });
        this.multiAgencyService.agencies.subscribe(function (agencies) {
            _this.agencies = agencies;
        });
        this.imagesUrl = this.environment.onyxGPImagesCommonDataUrl;
        var gpWindow = window;
        if (gpWindow.configGroupPay && gpWindow.configGroupPay.showAgencyDashboard && this.authenticationStore.isAgencyUser()) {
            this.multiAgencyService.defaultAgencyId.subscribe(function (agencyId) {
                _this.agencyLookupStore
                    .isSubscriberAgency(agencyId)
                    .subscribe(function (isSubscriber) {
                    var isSubscriberAgency = Boolean(isSubscriber);
                    _this.showSupportButton =
                        _this.authenticationStore.hasPermission('ViewDashboard') &&
                            isSubscriberAgency;
                });
            });
        }
        else {
            this.showSupportButton = false;
        }
    };
    HeaderComponent.prototype.onLogout = function () {
        this.authenticationStore.logout();
    };
    Object.defineProperty(HeaderComponent.prototype, "username", {
        get: function () {
            return {
                username: this.user.username,
            };
        },
        enumerable: true,
        configurable: true
    });
    HeaderComponent.prototype.onClickPrivacy = function (event) {
        window.open(this.environment.policyUrl, '_blank');
    };
    HeaderComponent.prototype.getPortalUrl = function () {
        return this.environment.portalUrl;
    };
    HeaderComponent.prototype.onClickRedirect = function (event) {
        window.open(this.getPortalUrl(), '_self');
    };
    Object.defineProperty(HeaderComponent.prototype, "defaultAgencyId", {
        get: function () {
            return this.multiAgencyService.defaultAgencyId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HeaderComponent.prototype, "defaultAgencyName", {
        get: function () {
            return this.multiAgencyService.defaultAgencyName;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HeaderComponent.prototype, "isMultiAgency", {
        get: function () {
            return this.multiAgencyService.isMultiAgency();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HeaderComponent.prototype, "isSingleAgency", {
        get: function () {
            return this.multiAgencyService.isSingleAgency();
        },
        enumerable: true,
        configurable: true
    });
    HeaderComponent.prototype.onClickAgency = function (agency) {
        var _this = this;
        if (this.multiAgencyService.oldAgencyId !== agency.agencyId) {
            this.authenticationStore
                .updateIataFromToken(agency.agencyId)
                .subscribe(function () {
                _this.multiAgencyService.setAgencySelectedUI(true);
                _this.multiAgencyService.setDefaultAgency(agency);
            });
        }
    };
    HeaderComponent.prototype.onClickSupport = function (event) {
        window.open(this.environment.supportUrl, '_blank');
    };
    return HeaderComponent;
}());
header_component_HeaderComponent = header_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-header',
        template: __webpack_require__("lS7k"),
        styles: [__webpack_require__("ZoyG")],
    }),
    header_component___metadata("design:paramtypes", [typeof (header_component__a = typeof authentication_store_AuthenticationStore !== "undefined" && authentication_store_AuthenticationStore) === "function" && header_component__a || Object, typeof (header_component__b = typeof EnvironmentConfiguration !== "undefined" && EnvironmentConfiguration) === "function" && header_component__b || Object, typeof (header_component__c = typeof multi_agency_service_MultiAgencyService !== "undefined" && multi_agency_service_MultiAgencyService) === "function" && header_component__c || Object, typeof (header_component__d = typeof agency_lookup_store_AgencyLookupStore !== "undefined" && agency_lookup_store_AgencyLookupStore) === "function" && header_component__d || Object])
], header_component_HeaderComponent);

var header_component__a, header_component__b, header_component__c, header_component__d;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/header.component.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/navigation/navigation.module.ts
var navigation_module___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};





var NavigationModule = (function () {
    function NavigationModule() {
    }
    return NavigationModule;
}());
NavigationModule = navigation_module___decorate([
    Object(core_es5["NgModule"])({
        imports: [
            common_es5["CommonModule"],
            SharedModule,
            router_es5["RouterModule"]
        ],
        declarations: [
            header_component_HeaderComponent
        ],
        exports: [
            header_component_HeaderComponent
        ]
    })
], NavigationModule);

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/navigation.module.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/menus/event-search-filter/event-search-filter.component.ts
var event_search_filter_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var event_search_filter_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};



var EventSearchFilterComponent = (function () {
    function EventSearchFilterComponent(eventSearchParametersStore, eventSearchFormsStore) {
        this.eventSearchParametersStore = eventSearchParametersStore;
        this.eventSearchFormsStore = eventSearchFormsStore;
        this.isEventFilterMenuExpanded = false;
    }
    EventSearchFilterComponent.prototype.ngOnInit = function () {
        this.eventFilterForm = this.eventSearchFormsStore.filterForm;
        this.isEventFilterMenuExpanded = this.eventSearchFormsStore.isEventFilterOptionSelected();
    };
    EventSearchFilterComponent.prototype.returnToSearchList = function () {
        this.eventSearchParametersStore.updateUrl();
    };
    EventSearchFilterComponent.prototype.applySearchFilters = function (model) {
        var filterRecord = this.eventSearchFormsStore.createFilterRecord(model);
        this.eventSearchFormsStore.searchFromFilter(filterRecord);
    };
    EventSearchFilterComponent.prototype.resetSearchFilters = function () {
        this.eventSearchParametersStore.resetFilters(true);
    };
    return EventSearchFilterComponent;
}());
EventSearchFilterComponent = event_search_filter_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-event-search-filter',
        template: __webpack_require__("8Q4s")
    }),
    event_search_filter_component___metadata("design:paramtypes", [typeof (event_search_filter_component__a = typeof event_search_parameters_store_EventSearchParametersStore !== "undefined" && event_search_parameters_store_EventSearchParametersStore) === "function" && event_search_filter_component__a || Object, typeof (event_search_filter_component__b = typeof event_search_forms_store_EventSearchFormsStore !== "undefined" && event_search_forms_store_EventSearchFormsStore) === "function" && event_search_filter_component__b || Object])
], EventSearchFilterComponent);

var event_search_filter_component__a, event_search_filter_component__b;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/event-search-filter.component.js.map
// EXTERNAL MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/node_modules/@ngx-translate/http-loader/index.js + 1 modules
var http_loader = __webpack_require__("kkjc");

// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/ng2-translate.config.ts



function createTranslateLoader(http) {
    return new http_loader["a" /* TranslateHttpLoader */](http, './assets/i18n/', '.json');
}
var TranslateModule = core["b" /* TranslateModule */].forRoot({
    loader: {
        provide: core["a" /* TranslateLoader */],
        useFactory: createTranslateLoader,
        deps: [common_http_es5["b" /* HttpClient */]]
    }
});
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/ng2-translate.config.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/payment/payment-request-status.enum.ts
var PaymentRequestStatusEnum;
(function (PaymentRequestStatusEnum) {
    PaymentRequestStatusEnum[PaymentRequestStatusEnum["CONFIRMED"] = 'confirmed'] = "CONFIRMED";
    PaymentRequestStatusEnum[PaymentRequestStatusEnum["APPROVED"] = 'approved'] = "APPROVED";
    PaymentRequestStatusEnum[PaymentRequestStatusEnum["REJECTED"] = 'rejected'] = "REJECTED";
})(PaymentRequestStatusEnum || (PaymentRequestStatusEnum = {}));
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/payment-request-status.enum.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/payment/payment-action-complete/payment-action-complete.component.ts
var payment_action_complete_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var payment_action_complete_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};





var payment_action_complete_component_PaymentActionCompleteComponent = (function () {
    function PaymentActionCompleteComponent(translate, titleCasePipe) {
        this.translate = translate;
        this.titleCasePipe = titleCasePipe;
    }
    PaymentActionCompleteComponent.prototype.ngOnInit = function () {
        this.datetime = new Date();
        if (this.reason) {
            this.cardHeader = this.translate.instant('EVENT.COMMISSION.REJECTION_REASONS_HEADER');
            this.actionBy = this.titleCasePipe.transform(PaymentRequestStatusEnum.REJECTED.toString());
        }
        else {
            this.cardHeader = this.translate.instant('EVENT.COMMISSION.PAYMENT_CONFIRMED');
            this.actionBy = this.titleCasePipe.transform(PaymentRequestStatusEnum.APPROVED.toString());
        }
    };
    Object.defineProperty(PaymentActionCompleteComponent.prototype, "email", {
        get: function () { return this.form.get('email'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PaymentActionCompleteComponent.prototype, "reason", {
        get: function () { return this.form.get('reason'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PaymentActionCompleteComponent.prototype, "description", {
        get: function () { return this.form.get('description'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PaymentActionCompleteComponent.prototype, "details", {
        get: function () { return this.form.get('details'); },
        enumerable: true,
        configurable: true
    });
    return PaymentActionCompleteComponent;
}());
payment_action_complete_component___decorate([
    Object(core_es5["Input"])(),
    payment_action_complete_component___metadata("design:type", typeof (payment_action_complete_component__a = typeof forms_es5["FormGroup"] !== "undefined" && forms_es5["FormGroup"]) === "function" && payment_action_complete_component__a || Object)
], payment_action_complete_component_PaymentActionCompleteComponent.prototype, "form", void 0);
payment_action_complete_component_PaymentActionCompleteComponent = payment_action_complete_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-payment-action-complete',
        template: __webpack_require__("FgJP"),
    }),
    payment_action_complete_component___metadata("design:paramtypes", [typeof (payment_action_complete_component__b = typeof core["c" /* TranslateService */] !== "undefined" && core["c" /* TranslateService */]) === "function" && payment_action_complete_component__b || Object, typeof (payment_action_complete_component__c = typeof common_es5["TitleCasePipe"] !== "undefined" && common_es5["TitleCasePipe"]) === "function" && payment_action_complete_component__c || Object])
], payment_action_complete_component_PaymentActionCompleteComponent);

var payment_action_complete_component__a, payment_action_complete_component__b, payment_action_complete_component__c;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/payment-action-complete.component.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/legal-entity-search.ts
var legal_entity_search___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var LegalEntitySearchRecord = Object(immutable["Record"])({
    code: null,
    chain: null,
    brand: null,
    propertyId: null,
});
var LegalEntitySearch = (function (_super) {
    legal_entity_search___extends(LegalEntitySearch, _super);
    function LegalEntitySearch() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return LegalEntitySearch;
}(LegalEntitySearchRecord));

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/legal-entity-search.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/payment/payment-action.enum.ts
var PaymentActionEnum;
(function (PaymentActionEnum) {
    PaymentActionEnum[PaymentActionEnum["CONFIRM"] = 'confirm'] = "CONFIRM";
    PaymentActionEnum[PaymentActionEnum["REJECT"] = 'reject'] = "REJECT";
})(PaymentActionEnum || (PaymentActionEnum = {}));
var PaymentActions = [
    PaymentActionEnum.CONFIRM.toString(),
    PaymentActionEnum.REJECT.toString()
];
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/payment-action.enum.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/payment/payment-rejection-reasons/payment-rejection-reasons.component.ts
var payment_rejection_reasons_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var payment_rejection_reasons_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};



var payment_rejection_reasons_component_PaymentRejectionReasonsComponent = (function () {
    function PaymentRejectionReasonsComponent(fb, translate) {
        this.fb = fb;
        this.translate = translate;
        this.reasons = [];
    }
    PaymentRejectionReasonsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.form.addControl('reason', this.fb.control('', forms_es5["Validators"].required));
        this.form.addControl('description', this.fb.control(''));
        this.form.addControl('details', this.fb.control('', [forms_es5["Validators"].required, forms_es5["Validators"].maxLength(500)]));
        var commissionReasonText = 'EVENT.COMMISSION.REASON_COMMISSION';
        if (!this.isHotelApprover) {
            commissionReasonText = 'EVENT.COMMISSION.REASON_COMMISSION_AGENCY_APPROVE';
        }
        this.translate.get('EVENT.COMMISSION.REASON_ROOM_NIGHTS').subscribe(function () {
            _this.reasons = [
                { value: 'option1', description: _this.translate.instant('EVENT.COMMISSION.REASON_ROOM_NIGHTS') },
                { value: 'option2', description: _this.translate.instant(commissionReasonText) },
                { value: 'option3', description: _this.translate.instant('EVENT.COMMISSION.REASON_GUESTS') },
                { value: 'option4', description: _this.translate.instant('EVENT.COMMISSION.REASON_OTHERS') },
            ];
        });
        this.reason.valueChanges.subscribe(function (val) {
            _this.reasons.filter(function (reason) {
                if (reason.value === val) {
                    _this.description.setValue(reason.description);
                }
            });
        });
    };
    Object.defineProperty(PaymentRejectionReasonsComponent.prototype, "reason", {
        get: function () { return this.form.get('reason'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PaymentRejectionReasonsComponent.prototype, "description", {
        get: function () { return this.form.get('description'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PaymentRejectionReasonsComponent.prototype, "details", {
        get: function () { return this.form.get('details'); },
        enumerable: true,
        configurable: true
    });
    return PaymentRejectionReasonsComponent;
}());
payment_rejection_reasons_component___decorate([
    Object(core_es5["Input"])(),
    payment_rejection_reasons_component___metadata("design:type", typeof (payment_rejection_reasons_component__a = typeof forms_es5["FormGroup"] !== "undefined" && forms_es5["FormGroup"]) === "function" && payment_rejection_reasons_component__a || Object)
], payment_rejection_reasons_component_PaymentRejectionReasonsComponent.prototype, "form", void 0);
payment_rejection_reasons_component___decorate([
    Object(core_es5["Input"])(),
    payment_rejection_reasons_component___metadata("design:type", Object)
], payment_rejection_reasons_component_PaymentRejectionReasonsComponent.prototype, "isHotelApprover", void 0);
payment_rejection_reasons_component_PaymentRejectionReasonsComponent = payment_rejection_reasons_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-payment-rejection-reasons',
        template: __webpack_require__("J4+O"),
    }),
    payment_rejection_reasons_component___metadata("design:paramtypes", [typeof (payment_rejection_reasons_component__b = typeof forms_es5["FormBuilder"] !== "undefined" && forms_es5["FormBuilder"]) === "function" && payment_rejection_reasons_component__b || Object, typeof (payment_rejection_reasons_component__c = typeof core["c" /* TranslateService */] !== "undefined" && core["c" /* TranslateService */]) === "function" && payment_rejection_reasons_component__c || Object])
], payment_rejection_reasons_component_PaymentRejectionReasonsComponent);

var payment_rejection_reasons_component__a, payment_rejection_reasons_component__b, payment_rejection_reasons_component__c;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/payment-rejection-reasons.component.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/payment/payment-action/payment-action.component.ts
var payment_action_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var payment_action_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};















var payment_action_component_PaymentActionComponent = (function () {
    function PaymentActionComponent(route, translate, commissionStore, commissionService, fb, flashMessagesService) {
        this.route = route;
        this.translate = translate;
        this.commissionStore = commissionStore;
        this.commissionService = commissionService;
        this.fb = fb;
        this.flashMessagesService = flashMessagesService;
        this.isCompleted = false;
        this.isEditEmailDisabled = false;
        this.form = this.fb.group({
            email: ['', [forms_es5["Validators"].required, forms_es5["Validators"].maxLength(75), pioneer_validators_PioneerValidators.isValidEmail]]
        });
        this.applyOoiv = true;
        this.isValidLegalEntityForm = false;
        this.showLegalEntity = false;
        this.agencyCountry = null;
        this.vendorCountry = null;
        this.attachmentId = null;
    }
    Object.defineProperty(PaymentActionComponent.prototype, "email", {
        get: function () { return this.form.get('email'); },
        enumerable: true,
        configurable: true
    });
    PaymentActionComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.route.queryParams
            .filter(function (params) { return params.action; })
            .flatMap(function (params) {
            if (_this.isCompleted) {
                return Observable["Observable"].empty();
            }
            _this.actionToUpdate = params.action;
            if (_this.actionToUpdate !== PaymentActionEnum.CONFIRM.toString()) {
                _this.showLegalEntity = false;
            }
            _this.updateSummary(params.action);
            _this.form = _this.fb.group({
                email: [_this.email.value, [forms_es5["Validators"].required, forms_es5["Validators"].maxLength(75), pioneer_validators_PioneerValidators.isValidEmail]]
            });
            return _this.commissionStore.paymentRequest;
        })
            .subscribe(function (paymentRequest) {
            _this.event = paymentRequest.event;
            _this.approverType = paymentRequest.approverType;
            _this.fundCurrency = paymentRequest.fundCurrency;
            _this.vendor = _this.getPaymentVendor(paymentRequest.finalPayment);
            _this.status = paymentRequest.finalPayment.status; // paymentRequest.finalPayment.status is a string at runtime
            var agencyId = null;
            if (_this.event && _this.event.eventAgency) {
                agencyId = _this.event.eventAgency.code;
                _this.agencyCountry = _this.event.eventAgency.countryCode;
            }
            if (_this.vendor) {
                _this.vendorCountry = _this.vendor.countryCode;
            }
            _this.commissionService.isOoivEnabled(agencyId, _this.agencyCountry, _this.vendorCountry)
                .subscribe(function (ooivEnabled) {
                _this.applyOoiv = ooivEnabled;
                if (ooivEnabled) {
                    if (_this.vendor && !_this.vendor.subscriber && _this.isHotelApprover()
                        && _this.actionToUpdate === PaymentActionEnum.CONFIRM.toString()) {
                        _this.commissionService.getLegalEntityInfo(_this.getLegalEntitySearch(_this.vendor))
                            .subscribe(function (legalEntity) {
                            _this.legalEntity = legalEntity;
                            _this.showLegalEntity = true;
                            _this.updateSummary(_this.actionToUpdate);
                        });
                    }
                }
            });
            _this.updateSummary(_this.actionToUpdate);
            if (!_this.isHotelApprover() && paymentRequest.event && paymentRequest.event.eventAgency) {
                _this.email.setValue(_this.event.eventAgency.contact.email);
                if (_this.event.eventAgency.contact && _this.event.eventAgency.contact.email && _this.event.eventAgency.contact.email.length > 0) {
                    _this.isEditEmailDisabled = true;
                    _this.email.disable();
                }
            }
            if (paymentRequest.event && paymentRequest.event.eventProperty) {
                _this.event.eventReferenceNumber = paymentRequest.event.eventProperty.eventReferenceNumber;
            }
            _this.paymentEquation = new PaymentEquation({
                roomCommissions: paymentRequest.roomCommissions,
                adjustments: paymentRequest.adjustments,
                prepayment: paymentRequest.prepayment,
                totalPaymentRequested: paymentRequest.finalPayment ? paymentRequest.finalPayment.commissionAmount : 0.00,
                totalEstimatedTax: paymentRequest.estimatedTax
            });
        });
        this.pendingWorkflow = false;
    };
    PaymentActionComponent.prototype.isValidEmail = function () {
        return this.email.valid || this.isEditEmailDisabled;
    };
    PaymentActionComponent.prototype.disableForm = function () {
        return (this.action === PaymentActionEnum.CONFIRM.toString() && !this.isValidEmail())
            || (this.action === PaymentActionEnum.REJECT.toString() && (!this.form.valid || !this.isValidEmail()))
            || !this.validLegalEntityForm();
    };
    PaymentActionComponent.prototype.onSubmit = function () {
        var _this = this;
        var summary;
        this.invoiceGenerated = null;
        if (this.action === PaymentActionEnum.CONFIRM.toString()) {
            this.commissionService.approvePaymentRequest(this.email.value, this.legalEntity, this.attachmentId)
                .subscribe(function () {
                _this.isCompleted = true;
                _this.showLegalEntity = false;
                if (_this.status === PaymentStatus.PENDING_WF_APPROVAL) {
                    summary = _this.translate.instant('EVENT.COMMISSION.CONFIRMED_SUMMARY_APPROVAL_WORKFLOW');
                    _this.pendingWorkflow = true;
                }
                else if (_this.isHotelApprover()) {
                    summary = _this.translate.instant('EVENT.COMMISSION.CONFIRMED_SUMMARY');
                    if (_this.applyOoiv) {
                        _this.invoiceGenerated = _this.translate.instant('EVENT.COMMISSION.CONFIRMED_INVOICE_CREATED');
                    }
                }
                else {
                    summary = _this.translate.instant('EVENT.COMMISSION.CONFIRMED_SUMMARY_AGENCY_APPROVE');
                }
                _this.setPageInfo(_this.translate.instant('EVENT.COMMISSION.ACTIONED', { actioned: _this.actioned }), summary);
                _this.flashMessagesService.success('EVENT.COMMISSION.ACTIONED', null, { actioned: _this.actioned });
            }, function (err) {
                _this.isCompleted = false;
                if (err.includes('Unable to request final payment')) {
                    _this.flashMessagesService.error('MESSAGES.ERROR.REQUEST_INVOICE_HEALTH', err);
                }
                else {
                    _this.flashMessagesService.error('MESSAGES.ERROR.APPROVE_PAYMENT_REQUEST', "Error approving payment request: " + err);
                }
                return Observable["Observable"].of(err);
            });
        }
        else {
            this.commissionService.rejectPaymentRequest(this.email.value, this.rejectionReason.description.value, this.rejectionReason.details.value, this.attachmentId)
                .subscribe(function () {
                _this.isCompleted = true;
                if (_this.status === PaymentStatus.PENDING_WF_APPROVAL) {
                    summary = _this.translate.instant('EVENT.COMMISSION.REJECTED_SUMMARY_APPROVAL_WORKFLOW');
                    _this.summary2 = _this.translate.instant('EVENT.COMMISSION.REJECTED_SUMMARY_APPROVAL_WORKFLOW2');
                }
                else if (_this.isHotelApprover()) {
                    summary = _this.translate.instant('EVENT.COMMISSION.REJECTED_SUMMARY');
                }
                else {
                    summary = _this.translate.instant('EVENT.COMMISSION.REJECTED_SUMMARY_AGENCY_APPROVE');
                }
                _this.setPageInfo(_this.translate.instant('EVENT.COMMISSION.ACTIONED', { actioned: _this.actioned }), summary);
                _this.flashMessagesService.success('EVENT.COMMISSION.ACTIONED', null, { actioned: _this.actioned });
            }, function (err) {
                _this.isCompleted = false;
                _this.flashMessagesService.error('MESSAGES.ERROR.REJECT_PAYMENT_REQUEST', "Error rejecting payment request: " + err);
                return Observable["Observable"].of(err);
            });
        }
    };
    PaymentActionComponent.prototype.updateSummary = function (action) {
        var _this = this;
        if (PaymentActions.indexOf(action) >= 0) {
            this.action = action;
            this.translate.get('EVENT.COMMISSION.CONFIRM').subscribe(function () {
                if (action === PaymentActionEnum.CONFIRM.toString()) {
                    _this.setConfirmDetails();
                }
                else {
                    _this.setRejectDetails();
                }
            });
        }
    };
    PaymentActionComponent.prototype.setConfirmDetails = function () {
        this.actioned = PaymentRequestStatusEnum.CONFIRMED.toString();
        this.oppositeAction = PaymentActionEnum.REJECT.toString();
        var confirmSummaryTxt = '';
        if (!this.isHotelApprover()) {
            confirmSummaryTxt = this.translate.instant('EVENT.COMMISSION.CONFIRM_SUMMARY_AGENCY');
        }
        else if (this.status === PaymentStatus.PENDING_WF_APPROVAL) {
            confirmSummaryTxt = this.translate.instant('EVENT.COMMISSION.PENDING_WF_APPROVAL.SUMMARY1');
            this.summary2 = this.translate.instant('EVENT.COMMISSION.PENDING_WF_APPROVAL.SUMMARY2');
        }
        else {
            confirmSummaryTxt = this.translate.instant('EVENT.COMMISSION.CONFIRM_SUMMARY');
            if (this.showLegalEntityForm()) {
                confirmSummaryTxt = '';
            }
        }
        this.setPageInfo(this.translate.instant('EVENT.COMMISSION.ACTION', { action: PaymentActionEnum.CONFIRM.toString() }), confirmSummaryTxt, this.translate.instant('EVENT.COMMISSION.ACTION_BY', { actionBy: PaymentRequestStatusEnum.APPROVED.toString() }));
    };
    PaymentActionComponent.prototype.setRejectDetails = function () {
        this.actioned = PaymentRequestStatusEnum.REJECTED.toString();
        this.oppositeAction = PaymentActionEnum.CONFIRM.toString();
        var rejectSummaryText = 'EVENT.COMMISSION.REJECT_SUMMARY';
        if (!this.isHotelApprover()) {
            rejectSummaryText = 'EVENT.COMMISSION.REJECT_SUMMARY_AGENCY_APPROVE';
        }
        if (this.status === PaymentStatus.PENDING_WF_APPROVAL) {
            rejectSummaryText = 'EVENT.COMMISSION.REJECT_SUMMARY_PENDING_WORKFLOW';
        }
        this.setPageInfo(this.translate.instant('EVENT.COMMISSION.ACTION', { action: PaymentActionEnum.REJECT.toString() }), this.translate.instant(rejectSummaryText), this.translate.instant('EVENT.COMMISSION.ACTION_BY', { actionBy: PaymentRequestStatusEnum.REJECTED.toString() }));
    };
    PaymentActionComponent.prototype.setPageInfo = function (title, summary, emailLabel) {
        this.title = title;
        this.summary = summary;
        this.emailLabel = emailLabel;
    };
    PaymentActionComponent.prototype.getGroupCode = function () {
        return EventUtils.getEventGroupCode(this.event, true);
    };
    PaymentActionComponent.prototype.getStartDate = function () {
        return EventUtils.getEventStartDate(this.event, true);
    };
    PaymentActionComponent.prototype.getEndDate = function () {
        return EventUtils.getEventEndDate(this.event, true);
    };
    PaymentActionComponent.prototype.getEventName = function () {
        return EventUtils.getEventName(this.event, true);
    };
    PaymentActionComponent.prototype.isHotelApprover = function () {
        return this.approverType === 'H' ? true : false;
    };
    PaymentActionComponent.prototype.showCurrencyNote = function () {
        if (!this.vendor.subscriber && this.fundCurrency) {
            return this.event.currency === this.fundCurrency ? false : true;
        }
        else {
            return false;
        }
    };
    PaymentActionComponent.prototype.isSubscriber = function () {
        return this.vendor.subscriber;
    };
    PaymentActionComponent.prototype.getPaymentVendor = function (payment) {
        var vendor = null;
        if (this.event && this.event.eventProperty) {
            vendor = this.event.eventProperty;
        }
        if (payment !== null && payment.eventPartyId !== null) {
            this.event.eventVendors.forEach(function (item) {
                if (item.eventPartyId === payment.eventPartyId) {
                    vendor = item;
                }
            });
        }
        return vendor;
    };
    PaymentActionComponent.prototype.validLegalEntityForm = function () {
        return this.showLegalEntityForm() ? this.isValidLegalEntityForm : true;
    };
    PaymentActionComponent.prototype.showLegalEntityForm = function () {
        if (this.isHotelApprover()) {
            return this.showLegalEntity;
        }
        else {
            return false;
        }
    };
    PaymentActionComponent.prototype.setValidForm = function (value) {
        this.isValidLegalEntityForm = value;
    };
    PaymentActionComponent.prototype.setResultLegalEntity = function (legalEntity) {
        this.legalEntity = legalEntity;
    };
    PaymentActionComponent.prototype.getLegalEntitySearch = function (vendor) {
        return new LegalEntitySearch({
            'code': vendor.code,
            'chain': vendor.chain,
            'brand': vendor.brand,
            'propertyId': vendor.propertyId
        });
    };
    // Not used now, always showing the form for non-subscriber users
    PaymentActionComponent.prototype.validLegalEntity = function () {
        if (this.legalEntity
            && this.legalEntity.vatNumberId
            && this.legalEntity.legalEntityName
            && this.legalEntity.country
            && this.legalEntity.address1
            && this.legalEntity.city) {
            return true;
        }
        else {
            return false;
        }
    };
    PaymentActionComponent.prototype.getAgencyGroupCode = function () {
        if (this.event && this.event.eventAgency && this.event.eventAgency.eventReferenceNumber) {
            return this.event.eventAgency.eventReferenceNumber;
        }
        else if (this.vendor && this.vendor.eventReferenceNumber) {
            return this.vendor.eventReferenceNumber;
        }
        else {
            return this.event.eventProperty.eventReferenceNumber;
        }
    };
    PaymentActionComponent.prototype.getVendorGroupCode = function () {
        if (this.vendor && this.vendor.eventReferenceNumber) {
            return this.vendor.eventReferenceNumber;
        }
        else if (this.event && this.event.eventAgency && this.event.eventAgency.eventReferenceNumber) {
            return this.event.eventAgency.eventReferenceNumber;
        }
        else {
            return this.event.eventProperty.eventReferenceNumber;
        }
    };
    PaymentActionComponent.prototype.setCurrentAttachment = function (attachments) {
        if (attachments && attachments.length > 0) {
            this.attachmentId = attachments[0].uniqueId;
        }
    };
    return PaymentActionComponent;
}());
payment_action_component___decorate([
    Object(core_es5["ViewChild"])(payment_rejection_reasons_component_PaymentRejectionReasonsComponent),
    payment_action_component___metadata("design:type", typeof (payment_action_component__a = typeof payment_rejection_reasons_component_PaymentRejectionReasonsComponent !== "undefined" && payment_rejection_reasons_component_PaymentRejectionReasonsComponent) === "function" && payment_action_component__a || Object)
], payment_action_component_PaymentActionComponent.prototype, "rejectionReason", void 0);
payment_action_component_PaymentActionComponent = payment_action_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-payment-action',
        template: __webpack_require__("AqLj"),
        styles: [__webpack_require__("R0p8")]
    }),
    payment_action_component___metadata("design:paramtypes", [typeof (payment_action_component__b = typeof router_es5["ActivatedRoute"] !== "undefined" && router_es5["ActivatedRoute"]) === "function" && payment_action_component__b || Object, typeof (payment_action_component__c = typeof core["c" /* TranslateService */] !== "undefined" && core["c" /* TranslateService */]) === "function" && payment_action_component__c || Object, typeof (payment_action_component__d = typeof commission_store_CommissionStore !== "undefined" && commission_store_CommissionStore) === "function" && payment_action_component__d || Object, typeof (payment_action_component__e = typeof commission_service_CommissionService !== "undefined" && commission_service_CommissionService) === "function" && payment_action_component__e || Object, typeof (payment_action_component__f = typeof forms_es5["FormBuilder"] !== "undefined" && forms_es5["FormBuilder"]) === "function" && payment_action_component__f || Object, typeof (payment_action_component__g = typeof flash_messages_service_FlashMessagesService !== "undefined" && flash_messages_service_FlashMessagesService) === "function" && payment_action_component__g || Object])
], payment_action_component_PaymentActionComponent);

var payment_action_component__a, payment_action_component__b, payment_action_component__c, payment_action_component__d, payment_action_component__e, payment_action_component__f, payment_action_component__g;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/payment-action.component.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/payment/payment-error/payment-error.component.ts
var payment_error_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var payment_error_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};





var payment_error_component_PaymentErrorComponent = (function () {
    function PaymentErrorComponent(commissionStore, translate) {
        this.commissionStore = commissionStore;
        this.translate = translate;
        this.subscription = new Subscription["Subscription"]();
    }
    PaymentErrorComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.subscription.add(this.commissionStore.errorResponse.subscribe(function (errorResponse) {
            if (errorResponse) {
                if (errorResponse.status === http_status_codes["BAD_REQUEST"]) {
                    _this.errorTitle = _this.translate.instant('EVENT.COMMISSION.RESPONSE_SUBMITTED_TITLE');
                    _this.errorSummary = _this.translate.instant('EVENT.COMMISSION.RESPONSE_SUBMITTED_SUMMARY');
                }
                else {
                    _this.errorTitle = _this.translate.instant('EVENT.COMMISSION.INVALID_LINK_TITLE');
                    _this.errorSummary = _this.translate.instant('EVENT.COMMISSION.INVALID_LINK_SUMMARY');
                }
            }
        }));
    };
    PaymentErrorComponent.prototype.ngOnDestroy = function () {
        this.subscription.unsubscribe();
    };
    return PaymentErrorComponent;
}());
payment_error_component_PaymentErrorComponent = payment_error_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-payment-error',
        template: __webpack_require__("8w4W"),
    }),
    payment_error_component___metadata("design:paramtypes", [typeof (payment_error_component__a = typeof commission_store_CommissionStore !== "undefined" && commission_store_CommissionStore) === "function" && payment_error_component__a || Object, typeof (payment_error_component__b = typeof core["c" /* TranslateService */] !== "undefined" && core["c" /* TranslateService */]) === "function" && payment_error_component__b || Object])
], payment_error_component_PaymentErrorComponent);

var payment_error_component__a, payment_error_component__b;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/payment-error.component.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/payment/payment-layout/payment-layout.component.ts
var payment_layout_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var payment_layout_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};



var PaymentLayoutComponent = (function () {
    function PaymentLayoutComponent(environment, layoutService) {
        this.environment = environment;
        this.layoutService = layoutService;
        this.showLayout = false;
        this.imagesUrl = '';
        this.year = new Date().getFullYear();
    }
    PaymentLayoutComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.imagesUrl = this.environment.onyxGPImagesCommonDataUrl;
        setTimeout(function () {
            _this.layoutService.showLayout.next(_this.showLayout);
        });
    };
    PaymentLayoutComponent.prototype.ngOnDestroy = function () {
        this.layoutService.resetShowLayout();
    };
    return PaymentLayoutComponent;
}());
PaymentLayoutComponent = payment_layout_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-payment-layout',
        template: __webpack_require__("zx3B"),
    }),
    payment_layout_component___metadata("design:paramtypes", [typeof (payment_layout_component__a = typeof EnvironmentConfiguration !== "undefined" && EnvironmentConfiguration) === "function" && payment_layout_component__a || Object, typeof (payment_layout_component__b = typeof layout_service_LayoutService !== "undefined" && layout_service_LayoutService) === "function" && payment_layout_component__b || Object])
], PaymentLayoutComponent);

var payment_layout_component__a, payment_layout_component__b;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/payment-layout.component.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/legal-entity.ts
var legal_entity___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var LegalEntityRecord = Object(immutable["Record"])({
    legalEntityId: null,
    vatNumberId: null,
    legalEntityName: null,
    country: null,
    address1: null,
    address2: null,
    address3: null,
    city: null,
    stateProvince: null,
    postalCode: null
});
var LegalEntity = (function (_super) {
    legal_entity___extends(LegalEntity, _super);
    function LegalEntity() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return LegalEntity;
}(LegalEntityRecord));

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/legal-entity.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/payment/payment-legal-entity/payment-legal-entity.component.ts
var payment_legal_entity_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var payment_legal_entity_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};







var payment_legal_entity_component_PaymentLegalEntityComponent = (function () {
    function PaymentLegalEntityComponent(fb, commonDataStore) {
        this.fb = fb;
        this.commonDataStore = commonDataStore;
        this.validForm = new core_es5["EventEmitter"]();
        this.resultLegalEntity = new core_es5["EventEmitter"]();
        this.isStateRequired = pioneer_validators_PioneerValidators.isStateRequired;
        this.showState = true;
        this.legalEntityForm = this.fb.group({
            vatId: ['', [forms_es5["Validators"].required, forms_es5["Validators"].maxLength(25)]],
            name: ['', [forms_es5["Validators"].required, forms_es5["Validators"].maxLength(250)]],
            country: ['', [forms_es5["Validators"].required, forms_es5["Validators"].maxLength(2)]],
            address1: ['', [forms_es5["Validators"].required, forms_es5["Validators"].maxLength(100)]],
            address2: ['', [forms_es5["Validators"].maxLength(100)]],
            address3: ['', [forms_es5["Validators"].maxLength(100)]],
            city: ['', [forms_es5["Validators"].required, forms_es5["Validators"].maxLength(50)]],
            state: ['', [forms_es5["Validators"].maxLength(3)]],
            postal: ['', [forms_es5["Validators"].maxLength(15)]]
        }, { validator: forms_es5["Validators"].compose([
                pioneer_validators_PioneerValidators.countryStateCrossValidator('country', 'state')
            ]) });
    }
    Object.defineProperty(PaymentLegalEntityComponent.prototype, "vatId", {
        get: function () { return this.legalEntityForm.get('vatId'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PaymentLegalEntityComponent.prototype, "name", {
        get: function () { return this.legalEntityForm.get('name'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PaymentLegalEntityComponent.prototype, "country", {
        get: function () { return this.legalEntityForm.get('country'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PaymentLegalEntityComponent.prototype, "address1", {
        get: function () { return this.legalEntityForm.get('address1'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PaymentLegalEntityComponent.prototype, "address2", {
        get: function () { return this.legalEntityForm.get('address2'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PaymentLegalEntityComponent.prototype, "address3", {
        get: function () { return this.legalEntityForm.get('address3'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PaymentLegalEntityComponent.prototype, "city", {
        get: function () { return this.legalEntityForm.get('city'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PaymentLegalEntityComponent.prototype, "state", {
        get: function () { return this.legalEntityForm.get('state'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PaymentLegalEntityComponent.prototype, "postal", {
        get: function () { return this.legalEntityForm.get('postal'); },
        enumerable: true,
        configurable: true
    });
    PaymentLegalEntityComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.commonDataStore.loadCountries().subscribe(function (countries) {
            _this.countries = countries;
        });
        this.populateLegalEntityInfo();
        this.legalEntityForm.statusChanges.subscribe(function (result) {
            var validForm = result === 'VALID' ? true : false;
            _this.validForm.emit(validForm);
            if (validForm) {
                _this.resultLegalEntity.emit(_this.getResultLegalEntity());
            }
        });
        this.states$ = this.commonDataStore.states;
        this.states$.subscribe(function (states) {
            if (states && states.length > 0) {
                var stateFormControl = _this.legalEntityForm ? _this.legalEntityForm.get('state') : undefined;
                if (stateFormControl) {
                    stateFormControl.enable();
                }
            }
        });
        this.commonDataStore.loadStatesFromCountry(this.country.value).take(1).subscribe();
        this.selectedCountry$ = this.commonDataStore.getCountry(this.country.value);
        if (this.country.value) {
            this.selectedState$ = this.commonDataStore.getState(this.country.value, this.state.value);
        }
        else {
            this.selectedState$ = Observable["Observable"].of(new DropdownItem('', this.state.value));
        }
        if (this.legalEntityForm.valid) {
            this.validForm.emit(true);
            this.resultLegalEntity.emit(this.getResultLegalEntity());
        }
    };
    PaymentLegalEntityComponent.prototype.getResultLegalEntity = function () {
        this.legalEntity['vatNumberId'] = this.vatId.value;
        this.legalEntity['legalEntityName'] = this.name.value;
        this.legalEntity['country'] = this.country.value;
        this.legalEntity['address1'] = this.address1.value;
        this.legalEntity['address2'] = this.address2.value;
        this.legalEntity['address3'] = this.address3.value;
        this.legalEntity['stateProvince'] = this.state.value;
        this.legalEntity['vatNumberId'] = this.vatId.value;
        this.legalEntity['postalCode'] = this.postal.value;
        return this.legalEntity;
    };
    PaymentLegalEntityComponent.prototype.populateLegalEntityInfo = function () {
        this.legalEntityForm.patchValue({ vatId: this.legalEntity.vatNumberId });
        this.legalEntityForm.patchValue({ name: this.legalEntity.legalEntityName });
        this.legalEntityForm.patchValue({ country: this.legalEntity.country });
        this.legalEntityForm.patchValue({ address1: this.legalEntity.address1 });
        this.legalEntityForm.patchValue({ address2: this.legalEntity.address2 });
        this.legalEntityForm.patchValue({ address3: this.legalEntity.address3 });
        this.legalEntityForm.patchValue({ city: this.legalEntity.city });
        this.legalEntityForm.patchValue({ state: this.legalEntity.stateProvince });
        this.legalEntityForm.patchValue({ postal: this.legalEntity.postalCode });
    };
    PaymentLegalEntityComponent.prototype.onCountryCodeChanged = function () {
        var _this = this;
        this.legalEntityForm.get('state').reset();
        this.states$ = this.commonDataStore.loadStatesFromCountry(this.legalEntityForm.get('country').value);
        this.states$.take(1).subscribe(function (states) {
            _this.showState = states.length > 0;
        });
    };
    return PaymentLegalEntityComponent;
}());
payment_legal_entity_component___decorate([
    Object(core_es5["Input"])(),
    payment_legal_entity_component___metadata("design:type", typeof (payment_legal_entity_component__a = typeof LegalEntity !== "undefined" && LegalEntity) === "function" && payment_legal_entity_component__a || Object)
], payment_legal_entity_component_PaymentLegalEntityComponent.prototype, "legalEntity", void 0);
payment_legal_entity_component___decorate([
    Object(core_es5["Output"])(),
    payment_legal_entity_component___metadata("design:type", typeof (payment_legal_entity_component__b = typeof core_es5["EventEmitter"] !== "undefined" && core_es5["EventEmitter"]) === "function" && payment_legal_entity_component__b || Object)
], payment_legal_entity_component_PaymentLegalEntityComponent.prototype, "validForm", void 0);
payment_legal_entity_component___decorate([
    Object(core_es5["Output"])(),
    payment_legal_entity_component___metadata("design:type", typeof (payment_legal_entity_component__c = typeof core_es5["EventEmitter"] !== "undefined" && core_es5["EventEmitter"]) === "function" && payment_legal_entity_component__c || Object)
], payment_legal_entity_component_PaymentLegalEntityComponent.prototype, "resultLegalEntity", void 0);
payment_legal_entity_component_PaymentLegalEntityComponent = payment_legal_entity_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-payment-legal-entity',
        template: __webpack_require__("NuAM"),
        styles: [__webpack_require__("Uvhx")]
    }),
    payment_legal_entity_component___metadata("design:paramtypes", [typeof (payment_legal_entity_component__d = typeof forms_es5["FormBuilder"] !== "undefined" && forms_es5["FormBuilder"]) === "function" && payment_legal_entity_component__d || Object, typeof (payment_legal_entity_component__e = typeof common_data_store_CommonDataStore !== "undefined" && common_data_store_CommonDataStore) === "function" && payment_legal_entity_component__e || Object])
], payment_legal_entity_component_PaymentLegalEntityComponent);

var payment_legal_entity_component__a, payment_legal_entity_component__b, payment_legal_entity_component__c, payment_legal_entity_component__d, payment_legal_entity_component__e;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/payment-legal-entity.component.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/payment/service/commission-attachment.resolver.ts
var commission_attachment_resolver___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var commission_attachment_resolver___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var CommissionAttachmentResolver = (function () {
    function CommissionAttachmentResolver() {
    }
    CommissionAttachmentResolver.prototype.resolve = function () {
    };
    return CommissionAttachmentResolver;
}());
CommissionAttachmentResolver = commission_attachment_resolver___decorate([
    Object(core_es5["Injectable"])(),
    commission_attachment_resolver___metadata("design:paramtypes", [])
], CommissionAttachmentResolver);

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/commission-attachment.resolver.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/payment/payment-routing.module.ts
var payment_routing_module___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};







var payment_routing_module_routes = [
    {
        path: 'payment',
        component: PaymentLayoutComponent,
        children: [
            {
                path: '',
                component: payment_action_component_PaymentActionComponent,
                canActivate: [payment_guard_PaymentGuard],
                resolve: {
                    commissionData: CommissionResolver,
                    attachmentData: CommissionAttachmentResolver
                }
            },
            {
                path: 'error',
                component: payment_error_component_PaymentErrorComponent
            }
        ]
    }
];
var PaymentRoutingModule = (function () {
    function PaymentRoutingModule() {
    }
    return PaymentRoutingModule;
}());
PaymentRoutingModule = payment_routing_module___decorate([
    Object(core_es5["NgModule"])({
        imports: [router_es5["RouterModule"].forChild(payment_routing_module_routes)],
        exports: [router_es5["RouterModule"]]
    })
], PaymentRoutingModule);

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/payment-routing.module.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/payment/payment-title-summary/payment-title-summary.component.ts
var payment_title_summary_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var payment_title_summary_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};






var payment_title_summary_component_PaymentTitleSummaryComponent = (function () {
    function PaymentTitleSummaryComponent(commissionStore, flashMessagesService, logService) {
        this.commissionStore = commissionStore;
        this.flashMessagesService = flashMessagesService;
        this.logService = logService;
        this._resendPaymentRequestAllowed$ = new BehaviorSubject["BehaviorSubject"](false);
        this._resendPaymentRequestDisabled$ = new BehaviorSubject["BehaviorSubject"](true);
        this._isLoading$ = new BehaviorSubject["BehaviorSubject"](true);
    }
    Object.defineProperty(PaymentTitleSummaryComponent.prototype, "resendPaymentRequestAllowed$", {
        get: function () {
            return this._resendPaymentRequestAllowed$.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PaymentTitleSummaryComponent.prototype, "resendPaymentRequestDisabled$", {
        get: function () {
            return this._resendPaymentRequestDisabled$.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PaymentTitleSummaryComponent.prototype, "isLoading$", {
        get: function () {
            return this._isLoading$.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    PaymentTitleSummaryComponent.prototype.ngOnInit = function () {
        var _this = this;
        this._isLoading$.next(true);
        this._resendPaymentRequestAllowed$.next(false);
        this._resendPaymentRequestDisabled$.next(true);
        this.commissionStore.isResendPaymentRequestAllowed().pipe(Object(operators["take"])(1), Object(operators["map"])(function (response) {
            return !!response ? response.resendPaymentRequestAllowed : false;
        })).subscribe(function (resendPaymentRequestAllowed) {
            _this._resendPaymentRequestAllowed$.next(resendPaymentRequestAllowed);
            if (resendPaymentRequestAllowed) {
                _this._resendPaymentRequestDisabled$.next(false);
            }
            else {
                _this._resendPaymentRequestDisabled$.next(true);
            }
        }, function (err) {
            _this.logService.error("Error in isResendPaymentRequestAllowed: " + JSON.stringify(err));
            _this.flashMessagesService.error('MESSAGES.ERROR.IS_RESEND_PAYMENT_REQUEST_ALLOWED');
            _this._resendPaymentRequestDisabled$.next(true);
        }, function () { return _this._isLoading$.next(false); });
    };
    PaymentTitleSummaryComponent.prototype.ngOnDestroy = function () {
        this._resendPaymentRequestAllowed$.complete();
        this._resendPaymentRequestDisabled$.complete();
        this._isLoading$.complete();
    };
    PaymentTitleSummaryComponent.prototype.print = function (event) {
        window.print();
    };
    PaymentTitleSummaryComponent.prototype.resendPaymentRequest = function () {
        var _this = this;
        this._resendPaymentRequestDisabled$.next(true);
        this.commissionStore.resendPaymentRequest().pipe(Object(operators["take"])(1)).subscribe(function () { return _this.flashMessagesService.success('MESSAGES.SUCCESS.PAYMENT_REQUEST_RESENT'); }, function (err) {
            _this.logService.error("Error in resendPaymentRequest: " + JSON.stringify(err));
            _this.flashMessagesService.error('MESSAGES.ERROR.PAYMENT_REQUEST_RESENT');
            _this._resendPaymentRequestDisabled$.next(false);
        });
    };
    return PaymentTitleSummaryComponent;
}());
payment_title_summary_component___decorate([
    Object(core_es5["Input"])(),
    payment_title_summary_component___metadata("design:type", String)
], payment_title_summary_component_PaymentTitleSummaryComponent.prototype, "iconClass", void 0);
payment_title_summary_component___decorate([
    Object(core_es5["Input"])(),
    payment_title_summary_component___metadata("design:type", String)
], payment_title_summary_component_PaymentTitleSummaryComponent.prototype, "title", void 0);
payment_title_summary_component___decorate([
    Object(core_es5["Input"])(),
    payment_title_summary_component___metadata("design:type", Boolean)
], payment_title_summary_component_PaymentTitleSummaryComponent.prototype, "isCompleted", void 0);
payment_title_summary_component___decorate([
    Object(core_es5["Input"])(),
    payment_title_summary_component___metadata("design:type", String)
], payment_title_summary_component_PaymentTitleSummaryComponent.prototype, "summary", void 0);
payment_title_summary_component___decorate([
    Object(core_es5["Input"])(),
    payment_title_summary_component___metadata("design:type", String)
], payment_title_summary_component_PaymentTitleSummaryComponent.prototype, "summary2", void 0);
payment_title_summary_component___decorate([
    Object(core_es5["Input"])(),
    payment_title_summary_component___metadata("design:type", String)
], payment_title_summary_component_PaymentTitleSummaryComponent.prototype, "invoiceGenerated", void 0);
payment_title_summary_component___decorate([
    Object(core_es5["Input"])(),
    payment_title_summary_component___metadata("design:type", Boolean)
], payment_title_summary_component_PaymentTitleSummaryComponent.prototype, "pendingWorkflow", void 0);
payment_title_summary_component_PaymentTitleSummaryComponent = payment_title_summary_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-payment-title-summary',
        template: __webpack_require__("OMmu"),
    }),
    payment_title_summary_component___metadata("design:paramtypes", [typeof (payment_title_summary_component__a = typeof commission_store_CommissionStore !== "undefined" && commission_store_CommissionStore) === "function" && payment_title_summary_component__a || Object, typeof (payment_title_summary_component__b = typeof flash_messages_service_FlashMessagesService !== "undefined" && flash_messages_service_FlashMessagesService) === "function" && payment_title_summary_component__b || Object, typeof (payment_title_summary_component__c = typeof log_service_LogService !== "undefined" && log_service_LogService) === "function" && payment_title_summary_component__c || Object])
], payment_title_summary_component_PaymentTitleSummaryComponent);

var payment_title_summary_component__a, payment_title_summary_component__b, payment_title_summary_component__c;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/payment-title-summary.component.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/payment/payment.module.ts
var payment_module___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};













var PaymentModule = (function () {
    function PaymentModule() {
    }
    return PaymentModule;
}());
PaymentModule = payment_module___decorate([
    Object(core_es5["NgModule"])({
        imports: [
            SharedModule,
            PaymentRoutingModule,
            EventModule,
        ],
        declarations: [
            payment_action_complete_component_PaymentActionCompleteComponent,
            payment_action_component_PaymentActionComponent,
            payment_error_component_PaymentErrorComponent,
            PaymentLayoutComponent,
            payment_rejection_reasons_component_PaymentRejectionReasonsComponent,
            payment_title_summary_component_PaymentTitleSummaryComponent,
            payment_legal_entity_component_PaymentLegalEntityComponent
        ],
        providers: [
            CommissionResolver,
            CommissionAttachmentResolver,
            commission_service_CommissionService,
            commission_store_CommissionStore,
            payment_guard_PaymentGuard,
        ]
    })
], PaymentModule);

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/payment.module.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/app.module.ts
var app_module___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var app_module___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};


























var app_module_routes = [
    { path: 'version', component: VersionComponent },
    { path: '**', component: RouteNotFoundComponent }
];
var app_module_AppModule = (function () {
    function AppModule(injector) {
        this.injector = injector;
        pioneer_validators_PioneerValidators.injector = this.injector;
    }
    return AppModule;
}());
app_module_AppModule = app_module___decorate([
    Object(core_es5["NgModule"])({
        declarations: [
            app_component_AppComponent,
            app_menu_component_AppMenuComponent,
            event_menu_component_EventMenuComponent,
            EventSearchFilterComponent
        ],
        imports: [
            platform_browser_es5["BrowserModule"],
            forms_es5["FormsModule"],
            forms_es5["ReactiveFormsModule"],
            http_es5["HttpModule"],
            router_es5["RouterModule"],
            AuthModule,
            EventModule,
            NavigationModule,
            UserModule,
            SharedModule,
            TranslateModule,
            common_http_es5["c" /* HttpClientModule */],
            // enable HashLocationStrategy
            // https://angular.io/docs/ts/latest/guide/router.html#!#browser-url-styles
            router_es5["RouterModule"].forRoot(app_module_routes, { useHash: true }),
            es5["Angulartics2Module"].forRoot([es5["Angulartics2GoogleAnalytics"]]),
            ngx_spinner_umd["NgxSpinnerModule"],
            PaymentModule,
        ],
        providers: [
            menu_store_MenuStore,
            AppAuthHttpService,
            common_es5["SlicePipe"],
            layout_service_LayoutService,
        ],
        bootstrap: [app_component_AppComponent]
    }),
    app_module___metadata("design:paramtypes", [typeof (app_module__a = typeof core_es5["Injector"] !== "undefined" && core_es5["Injector"]) === "function" && app_module__a || Object])
], app_module_AppModule);

var app_module__a;
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app.module.js.map
// CONCATENATED MODULE: /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/main.ts





/**
 * Setup ngx-bootstrap to use Bootstrap 4
 */
// `window` must be cast to `any` since the compiler does not understand the `__theme` property
window.__theme = 'bs4';
var main_environment = new EnvironmentConfiguration(environments);
ga('create', main_environment.googleAnalytics.id, main_environment.googleAnalytics.loadType);
/**
 * The below code is commented out and intentionally left here.
 * Google Analytics will tell you that it's required, but it's
 * handled by Angulartics2GoogleAnalytics
 */
// ga('send', 'pageview');
if (main_environment.production) {
    Object(core_es5["enableProdMode"])();
}
Object(platform_browser_dynamic_es5["a" /* platformBrowserDynamic */])().bootstrapModule(app_module_AppModule);
//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/main.js.map

/***/ }),

/***/ "ch4d":
/***/ (function(module, exports) {

module.exports = "<pioneer-confirmation-modal confirm=\"COMMON.BUTTON.CLOSE\"></pioneer-confirmation-modal>\n\n<!-- Final payment comments modal -->\n<div class=\"modal fade\" bsModal [config]=\"config\" role=\"dialog\" tabindex=\"-1\">\n  <div class=\"modal-dialog modal-lg\" role=\"document\">\n    <div class=\"modal-content\">\n      <div class=\"modal-header\">\n      </div>\n      <div class=\"modal-body\">\n        {{ finalPaymentComments }}\n      </div>\n      <div class=\"modal-footer\">\n        <button type=\"button\" class=\"btn btn-link\" data-dismiss=\"modal\" (click)=\"closeFinalPaymentCommentsModal()\">\n          {{'COMMON.BUTTON.CLOSE' | translate}}\n        </button>\n      </div>\n    </div>\n  </div>\n</div>\n\n\n<!--           Payment Record         -->\n<script\n  src=\"../payment-modifier-display-calculation/payment-modifier-display.component.ts\"></script>\n<div class=\"card\" data-se-id=\"payment-record\">\n  <div class=\"card-header\" id=\"card-commission-payment\">\n    {{'EVENT.COMMISSION.PAYMENT_RECORD' | translate}}\n  </div>\n\n  <div class=\"table-responsive\">\n    <table class=\"table\">\n      <thead>\n        <tr>\n          <th>{{'EVENT.COMMISSION.TRANSACTION_DATE' | translate}}</th>\n          <th>{{'EVENT.COMMISSION.TYPE' | translate}}</th>\n          <th>{{'EVENT.COMMISSION.STATUS' | translate}}</th>\n          <th>{{'EVENT.COMMISSION.PAYMENT_ID' | translate}}</th>\n          <th>{{'EVENT.COMMISSION.FUNDING_ID' | translate}}</th>\n          <th>\n            {{'EVENT.COMMISSION.AMOUNT' | translate}}\n            <br><small>({{ event.currency | uppercase }})</small>\n          </th>\n          <th>{{'EVENT.COMMISSION.FINAL_PAYMENT_COMMENTS' | translate}}</th>\n        </tr>\n      </thead>\n      <tbody>\n        <tr *ngIf=\"!prepayment && !displayFinalPaymentStatusList()\">\n          <td></td>\n          <td></td>\n          <td></td>\n          <td></td>\n          <td></td>\n          <td></td>\n          <td></td>\n          <td></td>\n        </tr>\n        <tr *ngIf=\"prepayment\" data-se-id=\"prepayment\">\n          <td data-se-id=\"date\">{{prepayment.modifiedDate | localeDateFormat}}</td>\n          <td data-se-id=\"type\">{{prepayment.type | paymentType}}</td>\n          <td [class]=\"getPrepaymentClass()\" data-se-id=\"status\">{{getPaymentStatus(prepayment.status) | paymentStatus }}</td>\n          <td data-se-id=\"paymentReferenceId\">{{prepayment.paymentReferenceId}}</td>\n          <td data-se-id=\"fundingReferenceId\">{{prepayment.fundingReferenceId}}</td>\n          <td data-se-id=\"commissionAmount\">{{prepayment.commissionAmount | number:'1.2-2' }}</td>\n          <td data-se-id=\"description\">{{prepayment.description}}</td>\n        </tr>\n        <ng-container *ngIf=\"displayFinalPaymentStatusList()\">\n          <tr *ngFor=\"let record of finalPaymentStatusList\">\n            <ng-container *ngIf=\"!isSubrow(record.status); else subrow\">\n              <td data-se-id=\"date\">{{record.modifiedDate | localeDateFormat}}</td>\n              <td data-se-id=\"type\">{{record.type | paymentType}}</td>\n              <td [class]=\"getFinalPaymentStatusClass(record.status)\" data-se-id=\"status\">\n                <span class=\"res-value\">{{ getPaymentStatus(record.status) | paymentStatus }}</span>\n              </td>\n              <td data-se-id=\"paymentReferenceId\">{{record.paymentReferenceId}}</td>\n              <td data-se-id=\"fundingReferenceId\">{{record.fundingReferenceId}}</td>\n              <td data-se-id=\"commissionAmount\">\n                 <span *ngIf=\"record.fundCurrency && event.currency !== record.fundCurrency; else noTooltipFunding\"\n                       class=\"res-value tooltip-hint\"\n                       tooltip=\"{{record.fundAmount | number:'1.2-2' }} {{record.fundCurrency | uppercase }}\"\n                       placement=\"right\"\n                       triggers=\"mouseenter:mouseleave\"\n                       container=\"body\">\n                   {{record.commissionAmount + record.totalTaxAmount | number:'1.2-2' }}\n                </span>\n                <ng-template #noTooltipFunding>\n                  {{record.commissionAmount + record.totalTaxAmount | number:'1.2-2' }}\n                </ng-template>\n              </td>\n\n              <td data-se-id=\"description\" width=\"36%\">\n                <ng-container *ngIf=\"isPaymentRejectedByHotel(record); else notRejectedByHotel\">\n                  {{'EVENT.COMMISSION.REJECTION_REASON' | translate}}:\n                  <br>\n                  {{record.actionReason}}\n                  <br>\n                  <a href=\"javascript:void(0)\" (click)=\"openFinalPaymentCommentsModal(record)\">{{'EVENT.COMMISSION.REJECTION_DETAIL_LINK' | translate}}</a>\n                </ng-container>\n                <ng-template #notRejectedByHotel>\n                  <span *ngIf=\"record.oldPaymentReferenceId; else notTooltipComment\"\n                    class=\"res-value tooltip-hint\"\n                    tooltip=\"{{'EVENT.COMMISSION.ORIGINALPAYMENTID' | translate}} : {{record.oldPaymentReferenceId}}\"\n                    placement=\"right\"\n                    triggers=\"mouseenter:mouseleave\"\n                    container=\"body\">\n                  {{ getFinalPaymentCommentsSubstring(record)}}\n                  </span>\n                  <ng-template #notTooltipComment>\n                    {{ getFinalPaymentCommentsSubstring(record)}}\n                  </ng-template>\n                  <ng-container *ngIf=\"displayFinalPaymentCommentsMore(record)\">\n                    ...\n                    <a href=\"javascript:void(0)\" (click)=\"openFinalPaymentCommentsModal(record)\">{{'EVENT.COMMISSION.FINAL_PAYMENT_COMMENTS_MORE' | translate}}</a>\n                  </ng-container>\n                </ng-template>\n              </td>\n            </ng-container>\n            <ng-template #subrow>\n              <td class=\"text-muted subrow-cell\">{{record.modifiedDate | localeDateFormat}}</td>\n              <td class=\"subrow-cell\"></td>\n              <td class=\"text-muted subrow-cell\">\n                <span class=\"res-value\">{{ getPaymentStatus(record.status) | paymentStatus }}</span>\n              </td>\n              <td class=\"subrow-cell\"></td>\n              <td class=\"subrow-cell\"></td>\n              <td class=\"subrow-cell\"></td>\n              <td class=\"subrow-cell\" width=\"36%\"></td>\n            </ng-template>\n          </tr>\n        </ng-container>\n      </tbody>\n    </table>\n  </div>\n\n</div>\n"

/***/ }),

/***/ "cmeK":
/***/ (function(module, exports) {

module.exports = "<div class=\"content-container\">\n  <div class=\"row\">\n    <div class=\"card-content\">\n\n      <ng-container *ngFor=\"let party of onyxEvent.eventVendors\">\n        <pioneer-invoice-history-vendor-card\n          [vendors]=\"onyxEvent.eventVendors\"\n          [vendor]=\"party\"\n          [event]=\"onyxEvent\">\n        </pioneer-invoice-history-vendor-card>\n      </ng-container>\n\n    </div>\n  </div>\n</div>\n"

/***/ }),

/***/ "cqHV":
/***/ (function(module, exports) {

module.exports = "<div class=\"modal fade\" bsModal [config]=\"config\" role=\"dialog\" tabindex=\"-1\">\n  <div class=\"modal-dialog modal-md\">\n    <div class=\"modal-content\">\n      <div class=\"modal-header\">\n        <div class=\"container\">\n          <div class=\"row p-2 justify-content-between\">\n            <h5 class=\"modal-title\">Update Status</h5>\n            <button\n              type=\"button\"\n              class=\"close\"\n              data-dismiss=\"modal\"\n              aria-label=\"Close\"\n              (click)=\"cancel()\"\n            >\n              <span aria-hidden=\"true\">&times;</span>\n            </button>\n          </div>\n        </div>\n      </div>\n\n      <div class=\"modal-body p-4\">\n        <div class=\"row col-12 label\">\n\n\n          Enter the Meeting ID of the Event you want to update status to Paid Direct\n\n        </div>\n        <div class=\"row col-12 input\">\n          <input\n          type=\"text\"\n          class=\"form-control\"\n          [attr.placeholder]=\"'Meeting ID'\"\n        />\n\n        </div>\n        <div class=\"row col-12 view-button mt-3\">\n          <button\n            class=\"btn btn-primary\"\n            data-se-id=\"view-event-button\"\n          >\n            View Event\n          </button>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),

/***/ "dFVK":
/***/ (function(module, exports) {

module.exports = "<div class=\"modal fade\" bsModal [config]=\"config\" role=\"dialog\" tabindex=\"-1\" dataSeId='rsvp-bulk-modal'>\n  <div class=\"modal-dialog modal-lg\" role=\"document\">\n    <div class=\"modal-content\">\n      <div class=\"modal-header\">\n        <h5 class=\"modal-title\">{{'EVENT.RSVPS.UPLOAD_BULK_RESERVATION.TITLE' | translate}}</h5>\n        <button type=\"button\" class=\"close\" [disabled]=\"!isAllowedToClosePopup\" data-dismiss=\"modal\" aria-label=\"Close\" (click)=\"cancel()\">\n          <span aria-hidden=\"true\">&times;</span>\n        </button>\n      </div>\n      <div class=\"modal-body\">\n        <div class=\"row\">\n          <div class=\"col-md-4 text-center\">\n            <div class=\"mt-2\">\n              <a *ngIf=\"isBeforeUpload; else updateIcon\" [href]=\"templateUrl\">\n                <i class=\"fal fa-file-spreadsheet fa-5x mb-3\"></i>\n                <p>\n                  {{'EVENT.RSVPS.UPLOAD_BULK_RESERVATION.DOWNLOAD' | translate}}\n                  <br>\n                  {{'EVENT.RSVPS.UPLOAD_BULK_RESERVATION.EXAMPLE_TEMPLATE' | translate}}\n                </p>\n              </a>\n              <ng-template #updateIcon>\n                <ng-container *ngIf=\"isSuccessful; else areRejected\">\n                  <i class=\"fas fa-check fa-5x mb-3\" style=\"color:green;\"></i>\n                </ng-container>\n                <ng-template #areRejected>\n                  <a [href]=\"rejectedFileUrl\" (click)=\"fileDownloaded()\">\n                    <i class=\"fal fa-file-spreadsheet fa-5x mb-3\" style=\"color: red\"></i>\n                    <p style=\"color: red\">\n                      {{'EVENT.RSVPS.UPLOAD_BULK_RESERVATION.DOWNLOAD' | translate}}\n                      <br>\n                      {{'EVENT.RSVPS.UPLOAD_BULK_RESERVATION.REJECTION_FILE' | translate}}\n                    </p>\n                  </a>\n                </ng-template>\n              </ng-template>\n            </div>\n          </div>\n          <div class=\"col-md-8\">\n            <ng-container *ngIf=\"isBeforeUpload; else checkResult\">\n              <p>\n                <strong>\n                  {{'EVENT.RSVPS.UPLOAD_BULK_RESERVATION.RECOMMENDATIONS_INTRO' | translate}}\n                </strong>\n              </p>\n              <ul>\n                <li>{{'EVENT.RSVPS.UPLOAD_BULK_RESERVATION.RECOMMENDATIONS_BLANK_CELLS' | translate}}</li>\n                <li>{{'EVENT.RSVPS.UPLOAD_BULK_RESERVATION.RECOMMENDATIONS_CHARACTERS' | translate}}</li>\n                <li>{{'EVENT.RSVPS.UPLOAD_BULK_RESERVATION.RECOMMENDATIONS_DATE_FORMAT' | translate}}</li>\n                <li>{{'EVENT.RSVPS.UPLOAD_BULK_RESERVATION.RECOMMENDATIONS_MAX_ROWS' | translate}}</li>\n              </ul>\n            </ng-container>\n            <ng-template #checkResult>\n              <ng-container *ngIf=\"isSuccessful; else areRejected\">\n                <p>\n                  <strong>\n                    {{'MESSAGES.SUCCESS.UPLOAD_BULK_RSVP' | translate}}\n                  </strong>\n                </p>\n              </ng-container>\n              <ng-template #areRejected>\n                <p>\n                  <strong>\n                    {{'MESSAGES.ERROR.RSVP_IMPORT_FAILED' | translate}}\n                  </strong>\n                </p>\n              </ng-template>\n              <ul>\n                <li>{{'EVENT.RSVPS.UPLOAD_BULK_RESERVATION.RECORDS_TOTAL' | translate: {records: totalRecords} }}</li>\n                <li>\n                  {{'EVENT.RSVPS.UPLOAD_BULK_RESERVATION.RECORDS_PROCESSED' | translate: {records: processedRecords} }}\n                </li>\n                <li>\n                  {{'EVENT.RSVPS.UPLOAD_BULK_RESERVATION.RECORDS_FAILED' | translate: {records: failedRecords} }}\n                </li>\n              </ul>\n            </ng-template>\n          </div>\n        </div>\n        <div class=\"progress\" [hidden]=\"!isUploadInProgress\">\n          <div class=\"progress-bar progress-bar-striped progress-bar-animated width-all\"\n               role=\"progressbar\"\n               aria-valuenow=\"100\"\n               aria-valuemin=\"0\"\n               aria-valuemax=\"100\">{{'EVENT.UPLOADING' | translate}}\n          </div>\n        </div>\n\n      </div>\n      <div class=\"modal-footer\">\n        <form data-se-id=\"rsvpBulkForm\">\n          <ng-container *ngIf=\"isBeforeUpload; else showClose\">\n            <button type=\"button\" class=\"btn btn-link\" data-dismiss=\"modal\" (click)=\"cancel()\"\n                    data-se-id=\"rsvp-bulk-modal-cancel\">\n              {{'COMMON.BUTTON.CANCEL' | translate}}\n            </button>\n            <label class=\"btn btn-primary\" for=\"filersvp\" data-se-id=\"rsvp-bulk-modal-upload\">\n              {{'EVENT.RSVPS.UPLOAD_BULK_RESERVATION.UPLOAD_BUTTON' | translate}}\n            </label>\n            <input #file\n                   id=\"filersvp\"\n                   data-se-id=\"rsvp-bulk-input-file\"\n                   hidden\n                   type=\"file\"\n                   accept=\"{{fileExtensions}}\"\n                   [disabled]=\"isUploadInProgress\"\n                   (change)=\"importRsvpFile($event)\"/>\n          </ng-container>\n          <ng-template #showClose>\n            <label [hidden]=\"isAllowedToClosePopup\">{{'EVENT.RSVPS.UPLOAD_BULK_RESERVATION.DOWNLOAD_RESTRICTION_MESSAGE' | translate }}</label>\n            <button type=\"button\" class=\"btn btn-primary\" [disabled]=\"!isAllowedToClosePopup\" data-dismiss=\"modal\" (click)=\"cancel()\"\n                    data-se-id=\"rsvp-bulk-modal-close\">\n              {{ 'COMMON.BUTTON.CLOSE' | translate }}\n            </button>\n          </ng-template>\n        </form>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),

/***/ "dPvB":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("rP7Y")(true);
// imports


// module
exports.push([module.i, ".field{padding-bottom:0;--tw-bg-opacity:1}@media (min-width:640px){.field{-ms-grid-columns:(minmax(0,1fr))[4];grid-template-columns:repeat(4,minmax(0,1fr));display:-ms-grid;display:grid;gap:1rem}}dt{color:rgb(17 24 39/var(--tw-text-opacity))}dd,dt{--tw-text-opacity:1;font-size:.875rem;line-height:1.25rem}dd{color:rgb(107 114 128/var(--tw-text-opacity));font-weight:500}dd,dl{margin:0}.modal-body{padding-right:60px;padding-left:60px}.dd-bordered{border-width:0 3px 0 0!important;border-color:inherit!important;border-style:solid}.space-between{display:-ms-flexbox;display:flex;-ms-flex-flow:row;flex-flow:row;-ms-flex-pack:justify;justify-content:space-between}", "", {"version":3,"sources":["/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/event-collision-modal/event-collision-modal.component.css"],"names":[],"mappings":"AAAA,OACE,iBAAqB,iBACF,CAEpB,yBAGC,OACE,oCAAA,8CAA+C,iBAC/C,aAAc,QACJ,CACX,CACF,GAIC,0CAA8C,CAG/C,MAJC,oBAAqB,kBAEF,mBACE,CAGvB,GAEE,8CAAiD,eAChC,CAGlB,MAGC,QAAU,CACX,YAGC,mBAAoB,iBACD,CACpB,aAGC,iCAAwC,+BACP,kBACb,CACrB,eAGC,oBAAA,aAAc,kBACd,cAAe,sBACf,6BAA+B,CAChC","file":"event-collision-modal.component.css","sourcesContent":[".field {\n  padding-bottom: 0rem;\n  --tw-bg-opacity: 1;\n  /* background-color: rgb(249 250 251 / var(--tw-bg-opacity)); */\n}\n\n@media (min-width: 640px){\n  .field {\n    grid-template-columns: repeat(4,minmax(0,1fr));\n    display: grid;\n    gap: 1rem;\n  }\n}\n\ndt {\n  --tw-text-opacity: 1;\n  color: rgb(17 24 39 / var(--tw-text-opacity));\n  font-size: .875rem;\n  line-height: 1.25rem;\n}\n\ndd {\n  --tw-text-opacity: 1;\n  color: rgb(107 114 128 / var(--tw-text-opacity));\n  font-weight: 500;\n  font-size: .875rem;\n  line-height: 1.25rem;\n}\n\ndd, dl {\n  margin: 0;\n}\n\n.modal-body{\n  padding-right: 60px;\n  padding-left: 60px;\n}\n\n.dd-bordered {\n  border-width: 0px 3px 0px 0px!important;\n  border-color: inherit !important;\n  border-style: solid;\n}\n\n.space-between {\n  display: flex;\n  flex-flow: row;\n  justify-content: space-between;\n}\n"],"sourceRoot":""}]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),

/***/ "doUx":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("rP7Y")(true);
// imports


// module
exports.push([module.i, "@keyframes shine{to{background-position-x:-200%}}.alert-banner{padding:1vw 1.3vw;border-radius:5px;border:1px solid rgba(117,146,183,.55);background-color:#c7d6ea;box-sizing:border-box;font-family:OpenSans-Regular,Open Sans,sans-serif;color:#134758;text-align:left;line-height:normal}.alert-banner #close,.alert-banner #close:hover{float:right;display:inline-block;padding:2px 5px;background-color:#c7d6ea}.alert-banner #close:hover{color:#fff}.alert-banner .close-icon{height:15px}.alert-banner .close-icon:hover{height:17px}.alert-banner .btn{background:transparent;padding:5px 5px;border-radius:20px;height:27px}.alert-banner .btn:hover .close-icon{height:17px}.welcome-banner{height:50px;box-sizing:border-box;font-family:OpenSans-Regular,Open Sans,sans-serif;color:#292b2c;text-align:left;line-height:30px;letter-spacing:1.9px;font-size:22px;-ms-flex-align:end;align-items:end;padding-left:30px}.data-updated{text-align:right;box-sizing:content-box;-ms-flex-item-align:self-end;-ms-grid-row-align:self-end;align-self:self-end;color:#7e8490;font-size:13px;font-weight:700}.data-updated span{font-weight:400}.totals-card{padding:1vw 1.3vw;max-width:225px}.totals-card .total-text{height:48px;box-sizing:border-box;font-family:Open Sans Semibold,Open Sans,sans-serif;font-weight:600;color:#7dc15e;text-align:left;line-height:44px;font-size:clamp(1.5rem,1.386vw + 1.141rem,2.25rem);overflow:hidden;white-space:nowrap}.totals-card .total-text .currency{height:48px;opacity:.5;box-sizing:border-box;font-family:OpenSans-Regular,Open Sans,sans-serif;color:#292b2c;text-align:right;line-height:44px;font-size:clamp(.625rem,.346vw + .535rem,.813rem)}.totals-card .sub-text{height:22px;opacity:.7;box-sizing:border-box;font-family:Open Sans Semibold,Open Sans,sans-serif;font-weight:600;color:#292b2c;text-align:left;line-height:20px;letter-spacing:-.2px;font-size:clamp(.625rem,.462vw + .505rem,.875rem)}.totals-card.is-loading .total-panel{background:#eee;background:linear-gradient(110deg,#ececec 8%,#f5f5f5 18%,#ececec 33%);border-radius:5px;background-size:200% 100%;animation:1.5s shine linear infinite;min-height:40px;margin-bottom:10px}.overview-banner .overview-title{height:27px;box-sizing:border-box;font-family:OpenSans-Bold,Open Sans Bold,Open Sans,sans-serif;font-weight:700;color:#292b2c;text-align:left;letter-spacing:1px;font-size:17px}.overview-banner .overview-select{text-align:right}.recently{padding:1rem 1.5rem}.recently .recently-title{height:17px;box-sizing:border-box;font-family:OpenSans-Bold,Open Sans Bold,Open Sans,sans-serif;font-weight:700;color:#292b2c;text-align:left;line-height:17px;letter-spacing:1px;margin-top:8px;margin-bottom:16px;font-size:17px}.recently th{color:#939aa0;padding:5px 0!important}.recently td,.recently th{border-width:0 0 1px!important}.recently td{padding:12px 2px 8px 2px!important}.recently tbody>tr:hover{background-color:#eef8ff;cursor:pointer}.recently .column-event{height:34px;background-color:hsla(0,0%,100%,0);box-sizing:border-box;font-family:OpenSans-Regular,Open Sans,sans-serif;color:#34c4d5;text-align:left;line-height:normal}.recently .column-right{text-align:right}.recently .view-button{-ms-flex-pack:right;justify-content:right}.recently.is-loading .row-loading{background:#eee;background:linear-gradient(110deg,#ececec 8%,#f5f5f5 18%,#ececec 33%);border-radius:5px;background-size:200% 100%;animation:1.5s shine linear infinite;height:20px}.status-card{padding:16px}.status-card .status-title{height:27px;box-sizing:border-box;font-family:OpenSans-Bold,Open Sans Bold,Open Sans,sans-serif;font-weight:700;color:#292b2c;text-align:left;letter-spacing:1px;font-size:17px}.status-card .status-select{text-align:right}.status-card.is-loading .status-total-label{position:absolute;background:#eee;background:linear-gradient(110deg,#ececec 8%,#f5f5f5 18%,#ececec 33%);border-radius:5px;background-size:200% 100%;animation:1.5s shine linear infinite;height:50px;width:65px;margin-top:50px;margin-left:40px}.status-card.is-loading .status-chart{border:45px solid #eee;border-radius:150px;height:240px;width:240px;background:#fff;place-self:center;margin-top:20px}.status-card.is-loading .status-labels{margin-top:15px;display:-ms-flexbox;display:flex;-ms-flex-item-align:center;align-self:center}.status-card.is-loading .status-labels .status-amount,.status-card.is-loading .status-labels .status-color,.status-card.is-loading .status-labels .status-description{background:#eee;background:linear-gradient(110deg,#ececec 8%,#f5f5f5 18%,#ececec 33%);border-radius:5px;background-size:200% 100%;animation:1.5s shine linear infinite;height:20px;margin-top:5px}.status-card.is-loading .status-labels .status-amount{width:40px;margin-right:10px}.status-card.is-loading .status-labels .status-color{height:15px;width:15px;border-radius:50%;display:inline-block;margin-right:10px}.status-card.is-loading .status-labels .status-description{width:175px}select{border-radius:5px;height:26px;border-color:#9cafbe;font-family:OpenSans-Regular,Open Sans,sans-serif;color:#2e384d;font-size:12px;padding-left:5px;min-width:110px}", "", {"version":3,"sources":["/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/agency-dashboard/agency-dashboard.component.css"],"names":[],"mappings":"AAAA,iBACE,GACE,2BAA6B,CAC9B,CACF,cAGC,kBAAmB,kBACA,uCACyB,yBAClB,sBACH,kDACkC,cAC1C,gBACE,kBACG,CACrB,gDAGC,YAAa,qBACS,gBACL,wBACS,CAG5B,2BAKE,UAAY,CACb,0BAGC,WAAa,CACd,gCAGC,WAAa,CACd,mBAGC,uBAAwB,gBACP,mBACG,WACP,CACd,qCAGC,WAAa,CACd,gBAGC,YAAa,sBACU,kDACkC,cAC1C,gBACE,iBACC,qBACI,eACN,mBAChB,gBAAiB,iBACE,CACpB,cAGC,iBAAkB,uBACM,6BACxB,4BAAA,oBAAqB,cACN,eACC,eACE,CACnB,mBAGC,eAAoB,CACrB,aAGC,kBAAmB,eACF,CAClB,yBAGC,YAAa,sBACU,oDACoC,gBAC1C,cACF,gBACE,iBACC,mDACoC,gBACrC,kBACG,CACrB,mCAGC,YAAa,WACA,sBACU,kDACkC,cAC1C,iBACG,iBACA,iDACuC,CAC1D,uBAGC,YAAa,WACA,sBACU,oDACoC,gBAC1C,cACF,gBACE,iBACC,qBACK,iDACkC,CAC1D,qCAGC,gBAAiB,sEACyD,kBACvD,0BACQ,qCACW,gBACrB,kBACG,CACrB,iCAGC,YAAa,sBACU,8DACiD,gBACvD,cACF,gBACE,mBACG,cACJ,CACjB,kCAGC,gBAAkB,CACnB,UAGC,mBAAqB,CACtB,0BAGC,YAAa,sBACU,8DACiD,gBACvD,cACF,gBACE,iBACC,mBACE,eACJ,mBACI,cACJ,CACjB,aAGC,cAAe,uBAEW,CAC3B,0BAFC,8BAAiC,CAInC,aAEE,kCAAqC,CACtC,yBAGC,yBAA0B,cACV,CACjB,wBAGC,YAAa,mCAC4B,sBAClB,kDACkC,cAC1C,gBACE,kBACG,CACrB,wBAGC,gBAAkB,CACnB,uBAGC,oBAAA,qBAAuB,CACxB,kCAGC,gBAAiB,sEACyD,kBACvD,0BACQ,qCACW,WACzB,CACd,aAGC,YAAc,CACf,2BAGC,YAAa,sBACU,8DACiD,gBACvD,cACF,gBACE,mBACG,cACJ,CACjB,4BAGC,gBAAkB,CACnB,4CAGC,kBAAmB,gBACF,sEACyD,kBACvD,0BACQ,qCACW,YACzB,WACD,gBACK,gBACC,CACnB,sCAGC,uBAAwB,oBACH,aACP,YACD,gBACI,kBACE,eACF,CAClB,uCAGC,gBAAiB,oBACjB,aAAc,2BACd,iBAAmB,CACpB,sKAKC,gBAAiB,sEACyD,kBACvD,0BACQ,qCACW,YACzB,cACG,CACjB,sDAGC,WAAY,iBACO,CACpB,qDAGC,YAAa,WACD,kBACO,qBACG,iBACH,CACpB,2DAGC,WAAa,CACd,OAGC,kBAAmB,YACN,qBACS,kDACmC,cAC1C,eACC,iBACE,eACD,CAClB","file":"agency-dashboard.component.css","sourcesContent":["@keyframes shine {\n  to {\n    background-position-x: -200%;\n  }\n}\n\n.alert-banner {\n  padding: 1vw 1.3vw;\n  border-radius: 5px;\n  border: 1px solid rgba(117, 146, 183, 0.55);\n  background-color: #c7d6ea;\n  box-sizing: border-box;\n  font-family: \"OpenSans-Regular\", \"Open Sans\", sans-serif;\n  color: #134758;\n  text-align: left;\n  line-height: normal;\n}\n\n.alert-banner #close {\n  float: right;\n  display: inline-block;\n  padding: 2px 5px;\n  background-color: #c7d6ea;\n}\n\n.alert-banner #close:hover {\n  float: right;\n  display: inline-block;\n  padding: 2px 5px;\n  background-color: #c7d6ea;\n  color: #fff;\n}\n\n.alert-banner .close-icon {\n  height: 15px;\n}\n\n.alert-banner .close-icon:hover {\n  height: 17px;\n}\n\n.alert-banner .btn {\n  background: transparent;\n  padding: 5px 5px;\n  border-radius: 20px;\n  height: 27px;\n}\n\n.alert-banner .btn:hover .close-icon {\n  height: 17px;\n}\n\n.welcome-banner {\n  height: 50px;\n  box-sizing: border-box;\n  font-family: \"OpenSans-Regular\", \"Open Sans\", sans-serif;\n  color: #292b2c;\n  text-align: left;\n  line-height: 30px;\n  letter-spacing: 1.9px;\n  font-size: 22px;\n  align-items: end;\n  padding-left: 30px;\n}\n\n.data-updated {\n  text-align: right;\n  box-sizing: content-box;\n  align-self: self-end;\n  color: #7E8490;\n  font-size: 13px;\n  font-weight: bold;\n}\n\n.data-updated span {\n  font-weight: normal;\n}\n\n.totals-card {\n  padding: 1vw 1.3vw;\n  max-width: 225px;\n}\n\n.totals-card .total-text {\n  height: 48px;\n  box-sizing: border-box;\n  font-family: \"Open Sans Semibold\", \"Open Sans\", sans-serif;\n  font-weight: 600;\n  color: #7dc15e;\n  text-align: left;\n  line-height: 44px;\n  font-size: clamp(1.5rem, 1.386vw + 1.141rem, 2.25rem);\n  overflow: hidden;\n  white-space: nowrap;\n}\n\n.totals-card .total-text .currency {\n  height: 48px;\n  opacity: 0.5;\n  box-sizing: border-box;\n  font-family: \"OpenSans-Regular\", \"Open Sans\", sans-serif;\n  color: #292b2c;\n  text-align: right;\n  line-height: 44px;\n  font-size: clamp(0.625rem, 0.346vw + 0.535rem, 0.813rem);\n}\n\n.totals-card .sub-text {\n  height: 22px;\n  opacity: 0.7;\n  box-sizing: border-box;\n  font-family: \"Open Sans Semibold\", \"Open Sans\", sans-serif;\n  font-weight: 600;\n  color: #292b2c;\n  text-align: left;\n  line-height: 20px;\n  letter-spacing: -0.2px;\n  font-size: clamp(0.625rem, 0.462vw + 0.505rem, 0.875rem);\n}\n\n.totals-card.is-loading .total-panel {\n  background: #eee;\n  background: linear-gradient(110deg, #ececec 8%, #f5f5f5 18%, #ececec 33%);\n  border-radius: 5px;\n  background-size: 200% 100%;\n  animation: 1.5s shine linear infinite;\n  min-height: 40px;\n  margin-bottom: 10px;\n}\n\n.overview-banner .overview-title {\n  height: 27px;\n  box-sizing: border-box;\n  font-family: \"OpenSans-Bold\", \"Open Sans Bold\", \"Open Sans\", sans-serif;\n  font-weight: 700;\n  color: #292b2c;\n  text-align: left;\n  letter-spacing: 1px;\n  font-size: 17px;\n}\n\n.overview-banner .overview-select {\n  text-align: right;\n}\n\n.recently {\n  padding: 1rem 1.5rem;\n}\n\n.recently .recently-title {\n  height: 17px;\n  box-sizing: border-box;\n  font-family: \"OpenSans-Bold\", \"Open Sans Bold\", \"Open Sans\", sans-serif;\n  font-weight: 700;\n  color: #292b2c;\n  text-align: left;\n  line-height: 17px;\n  letter-spacing: 1px;\n  margin-top: 8px;\n  margin-bottom: 16px;\n  font-size: 17px;\n}\n\n.recently th {\n  color: #939aa0;\n  border-width: 0 0 1px !important;\n  padding: 5px 0 !important;\n}\n\n.recently td {\n  border-width: 0 0 1px !important;\n  padding: 12px 2px 8px 2px !important;\n}\n\n.recently tbody > tr:hover {\n  background-color: #eef8ff;\n  cursor: pointer;\n}\n\n.recently .column-event {\n  height: 34px;\n  background-color: rgba(255, 255, 255, 0);\n  box-sizing: border-box;\n  font-family: \"OpenSans-Regular\", \"Open Sans\", sans-serif;\n  color: #34c4d5;\n  text-align: left;\n  line-height: normal;\n}\n\n.recently .column-right {\n  text-align: right;\n}\n\n.recently .view-button {\n  justify-content: right;\n}\n\n.recently.is-loading .row-loading {\n  background: #eee;\n  background: linear-gradient(110deg, #ececec 8%, #f5f5f5 18%, #ececec 33%);\n  border-radius: 5px;\n  background-size: 200% 100%;\n  animation: 1.5s shine linear infinite;\n  height: 20px;\n}\n\n.status-card {\n  padding: 16px;\n}\n\n.status-card .status-title {\n  height: 27px;\n  box-sizing: border-box;\n  font-family: \"OpenSans-Bold\", \"Open Sans Bold\", \"Open Sans\", sans-serif;\n  font-weight: 700;\n  color: #292b2c;\n  text-align: left;\n  letter-spacing: 1px;\n  font-size: 17px;\n}\n\n.status-card .status-select {\n  text-align: right;\n}\n\n.status-card.is-loading .status-total-label {\n  position: absolute;\n  background: #eee;\n  background: linear-gradient(110deg, #ececec 8%, #f5f5f5 18%, #ececec 33%);\n  border-radius: 5px;\n  background-size: 200% 100%;\n  animation: 1.5s shine linear infinite;\n  height: 50px;\n  width: 65px;\n  margin-top: 50px;\n  margin-left: 40px;\n}\n\n.status-card.is-loading .status-chart {\n  border: 45px solid #eee;\n  border-radius: 150px;\n  height: 240px;\n  width: 240px;\n  background: #fff;\n  place-self: center;\n  margin-top: 20px;\n}\n\n.status-card.is-loading .status-labels {\n  margin-top: 15px;\n  display: flex;\n  align-self: center;\n}\n\n.status-card.is-loading .status-labels .status-amount,\n.status-card.is-loading .status-labels .status-color,\n.status-card.is-loading .status-labels .status-description {\n  background: #eee;\n  background: linear-gradient(110deg, #ececec 8%, #f5f5f5 18%, #ececec 33%);\n  border-radius: 5px;\n  background-size: 200% 100%;\n  animation: 1.5s shine linear infinite;\n  height: 20px;\n  margin-top: 5px;\n}\n\n.status-card.is-loading .status-labels .status-amount {\n  width: 40px;\n  margin-right: 10px;\n}\n\n.status-card.is-loading .status-labels .status-color {\n  height: 15px;\n  width: 15px;\n  border-radius: 50%;\n  display: inline-block;\n  margin-right: 10px;\n}\n\n.status-card.is-loading .status-labels .status-description {\n  width: 175px;\n}\n\nselect {\n  border-radius: 5px;\n  height: 26px;\n  border-color: #9cafbe;\n  font-family: \"OpenSans-Regular\", \"Open Sans\", sans-serif;\n  color: #2e384d;\n  font-size: 12px;\n  padding-left: 5px;\n  min-width: 110px;\n}\n"],"sourceRoot":""}]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),

/***/ "eEAD":
/***/ (function(module, exports) {

module.exports = "<pioneer-confirmation-modal\n  #addRatePlanCodeModal\n  data-se-id=\"addRatePlanCodeModal\"\n  content=\"MESSAGES.CONFIRMATION.PROCEED\"\n  cancel=\"COMMON.BUTTON.CANCEL\"\n  confirm=\"EVENT.RESERVATION.ADD_RATE_PLAN_CODE\"\n  [title]=\"'EVENT.RESERVATION.LOSE_CHANGES'\"\n  (closed)=\"addRatePlanCodeModalHandler($event)\">\n</pioneer-confirmation-modal>\n\n<form [formGroup]=\"reservationForm\" data-se-id=\"reservationForm\" id=\"reservationForm\">\n  <div class=\"row\">\n    <div class=\"col form-container\">\n      <div class=\"form-group\">\n        <pioneer-form-input label=\"EVENT.RESERVATION.FIRST_NAME\">\n          <input formControlName=\"firstName\" type=\"text\" class=\"form-control\" data-se-id=\"firstName\" placeholder=\"{{ 'EVENT.RESERVATION.FIRST_NAME_PLACEHOLDER' | translate }}\"\n            maxlength=\"50\">\n        </pioneer-form-input>\n      </div>\n    </div>\n    <div class=\"col form-container\">\n      <div class=\"form-group form-required\">\n        <pioneer-form-input label=\"EVENT.RESERVATION.LAST_NAME\">\n          <input formControlName=\"lastName\" type=\"text\" class=\"form-control\" data-se-id=\"lastName\" placeholder=\"{{ 'EVENT.RESERVATION.LAST_NAME_PLACEHOLDER' | translate }}\"\n            maxlength=\"50\">\n        </pioneer-form-input>\n      </div>\n    </div>\n    <div class=\"col form-container\">\n      <div class=\"form-group form-required\">\n        <pioneer-form-input label=\"EVENT.RESERVATION.CONFIRMATION_NUMBER\">\n          <input formControlName=\"confirmation\" type=\"text\" class=\"form-control\" data-se-id=\"confirmation\"\n            placeholder=\"{{ 'EVENT.RESERVATION.CONFIRMATION_NUMBER_PLACEHOLDER' | translate }}\" maxlength=\"32\" pioneerUppercase>\n        </pioneer-form-input>\n      </div>\n    </div>\n    <div class=\"col form-container\">\n      <div class=\"form-group form-required\">\n        <pioneer-form-input label=\"EVENT.RESERVATION.STATUS\">\n          <select formControlName=\"status\" class=\"form-control form-control-sm\" data-se-id=\"status\">\n            <option data-se-id=\"statusDefaultOption\" [ngValue]=\"null\">{{ 'EVENT.RESERVATION.STATUS_PLACEHOLDER' |\n              translate }}</option>\n            <option *ngFor=\"let option of statusList\" [ngValue]=\"option.key\">{{ option.value }}</option>\n          </select>\n        </pioneer-form-input>\n      </div>\n    </div>\n  </div>\n  <div class=\"row\">\n    <div class=\"col form-container\">\n      <div class=\"form-group form-required\">\n        <pioneer-form-input label=\"EVENT.RESERVATION.CHECKIN_DATE\">\n          <input formControlName=\"checkInDate\" type=\"date\" class=\"form-control-input-date\" data-se-id=\"checkInDate\" placeholder=\"{{'EVENT.DATE_PLACEHOLDER' | translate}}\">\n        </pioneer-form-input>\n      </div>\n    </div>\n    <div class=\"col form-container\">\n      <div class=\"form-container\">\n        <div class=\"form-group form-required\">\n          <pioneer-form-input label=\"EVENT.RESERVATION.CHECKOUT_DATE\">\n            <input type=\"date\" class=\"form-control-input-date\" formControlName=\"checkOutDate\" data-se-id=\"checkOutDate\" placeholder=\"{{'EVENT.DATE_PLACEHOLDER' | translate}}\">\n            <div class=\"validation-messages\">\n              <pioneer-validation-message error=\"end_date_after_start_date\" message=\"MESSAGES.VALIDATION.CHECKOUT_AFTER_CHECKIN\">\n              </pioneer-validation-message>\n            </div>\n          </pioneer-form-input>\n        </div>\n      </div>\n    </div>\n    <div class=\"col form-container\">\n      <div class=\"form-group form-required\" data-se-id=\"roomRateFormGroup\">\n        <pioneer-form-input label=\"EVENT.RESERVATION.ROOM_RATE\">\n          <div class=\"input-group\">\n            <input formControlName=\"roomRate\" type=\"number\" class=\"form-control\" data-se-id=\"roomRate\" placeholder=\"{{ 'EVENT.RESERVATION.ROOM_RATE_PLACEHOLDER' | translate }}\">\n            <div *ngIf=\"event.currency\" class=\"input-group-addon\">\n              <span class=\"input-group-text\">{{event.currency}}</span>\n            </div>\n          </div>\n        </pioneer-form-input>\n      </div>\n    </div>\n    <div class=\"col form-container\">\n      <div class=\"form-group\">\n        <pioneer-form-input label=\"EVENT.RESERVATION.ROOM_TYPE\">\n          <input formControlName=\"roomType\" type=\"text\" class=\"form-control\" data-se-id=\"roomType\" placeholder=\"{{ 'EVENT.RESERVATION.ROOM_TYPE_PLACEHOLDER' | translate }}\"\n            maxlength=\"6\" pioneerUppercase>\n        </pioneer-form-input>\n      </div>\n    </div>\n  </div>\n  <div class=\"row\">\n    <div class=\"col-lg-3 form-container\">\n      <div class=\"form-group form-required\">\n        <pioneer-form-input label=\"EVENT.RESERVATION.RATE_PLAN_CODE\">\n          <select formControlName=\"ratePlanCode\" class=\"form-control form-control-sm\" data-se-id=\"ratePlanCode\">\n            <option data-se-id=\"ratePlanCodeDefaultOption\" [ngValue]=\"null\" hidden>{{ 'EVENT.RESERVATION.RATE_PLAN_CODE_PLACEHOLDER' | translate }}</option>\n            <option *ngFor=\"let ratePlanCode of event.eventProperty.ratePlanCodes\" [ngValue]=\"ratePlanCode.ratePlanCode\">{{ ratePlanCode.ratePlanCode }}</option>\n            <hr class=\"solid\">\n            <option [ngValue]=\"addRatePlanCodeOption\" class=\"select-option-link\">{{ 'EVENT.RESERVATION.ADD_RATE_PLAN_CODE' | translate }}</option>\n          </select>\n        </pioneer-form-input>\n      </div>\n    </div>\n  </div>\n</form>\n"

/***/ }),

/***/ "eWFu":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("rP7Y")(true);
// imports


// module
exports.push([module.i, ".commission-sum{float:none!important}.summary-title{font-size:18px;font-weight:700;padding-left:1em}.table-multi-prop-total thead th{vertical-align:bottom;text-align:center;font-size:18px;font-weight:700}.table-multi-prop-total{width:91%;max-width:100%;margin-bottom:1rem;font-size:10px;text-align:center}.table-multi-prop thead th{vertical-align:bottom;text-align:center;font-size:18px;font-weight:700}.table-multi-prop{padding-left:20%;width:100%;max-width:100%;font-size:10px;text-align:center;font-weight:400;border-collapse:separate;letter-spacing:normal}", "", {"version":3,"sources":["/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/overview/vendor-header-summary/vendor-header-summary.component.css"],"names":[],"mappings":"AAAA,gBACE,oBAAuB,CACxB,eAGC,eAAgB,gBACE,gBACA,CACnB,iCAGC,sBAAuB,kBACJ,eACH,eACE,CACnB,wBAGC,UAAW,eACK,mBACI,eACJ,iBACG,CACpB,2BAGC,sBAAuB,kBACJ,eACH,eACE,CACnB,kBAGC,iBAAkB,WACN,eACI,eACA,kBACG,gBACC,yBACM,qBACH,CACxB","file":"vendor-header-summary.component.css","sourcesContent":[".commission-sum {\n  float: none !important;\n}\n\n.summary-title {\n  font-size: 18px;\n  font-weight: bold;\n  padding-left: 1em;\n}\n\n.table-multi-prop-total thead th {\n  vertical-align: bottom;\n  text-align: center;\n  font-size: 18px;\n  font-weight: bold;\n}\n\n.table-multi-prop-total {\n  width: 91%;\n  max-width: 100%;\n  margin-bottom: 1rem;\n  font-size: 10px;\n  text-align: center;\n}\n\n.table-multi-prop thead th {\n  vertical-align: bottom;\n  text-align: center;\n  font-size: 18px;\n  font-weight: bold;\n}\n\n.table-multi-prop {\n  padding-left: 20%;\n  width: 100%;\n  max-width: 100%;\n  font-size: 10px;\n  text-align: center;\n  font-weight: normal;\n  border-collapse: separate;\n  letter-spacing: normal;\n}\n\n\n"],"sourceRoot":""}]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),

/***/ "efyd":
/***/ (function(module, exports) {

module.exports = "<pioneer-header *ngIf=\"showLayout && (userIsLoggedIn | async)\"></pioneer-header>\n<div class=\"container-fluid\" *ngIf=\"showLayout && (userIsLoggedIn | async)\">\n  <div class=\"row title-bar\">\n    <div class=\"page-title\">\n      <h1 data-se-id=\"titleBar\">{{title}}</h1>\n    </div>\n  </div>\n</div>\n<pioneer-expiration-modal\n  data-se-id=\"app-component-confirmation-modal\"\n  [content]=\"expirationModalConfig.content\"\n  logOutEarly=\"AUTHENTICATION_EXPIRATION.LOG_OUT_EARLY\"\n  stayLoggedIn=\"AUTHENTICATION_EXPIRATION.STAY_LOGGED_IN\"\n  returnToLogin=\"AUTHENTICATION_EXPIRATION.RETURN_TO_LOGIN\"\n  title=\"AUTHENTICATION_EXPIRATION.TITLE\">\n</pioneer-expiration-modal>\n<pioneer-flash-messages></pioneer-flash-messages>\n<div class=\"container-fluid\">\n  <div class=\"row app-area\">\n    <router-outlet name=\"navigation\"></router-outlet>\n    <div [ngClass]=\"{\n      'content-area': showLayout,\n      'payment-content-area': !showLayout\n    }\">\n      <router-outlet></router-outlet>\n    </div>\n  </div>\n</div>\n<ngx-spinner\n  size=\"large\"\n  type=\"ball-clip-rotate\">\n</ngx-spinner>\n"

/***/ }),

/***/ "epPf":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("rP7Y")(true);
// imports


// module
exports.push([module.i, "span.smaller{font-size:smaller}span.inherit{font-size:inherit}span.larger{font-size:larger}.custom-modal{border-radius:.8rem;.modal-body{padding:0}.lead{font-size:1.5rem;font-weight:400;margin:1.5rem 2rem 0 2rem}.h-line{border-bottom:1px solid #eee;margin:1.5rem 0 0 0}#content{margin:1.5rem 2rem 0 2rem}.button-bar{-ms-flex-pack:right;justify-content:right;margin:2rem}}.custom-content{font-size:small}", "", {"version":3,"sources":["/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/confirmation-modal/confirmation-modal.component.css"],"names":[],"mappings":"AAAA,aACE,iBAAmB,CACpB,aAEC,iBAAmB,CACpB,YAEC,gBAAkB,CACnB,cAGC,oBAAqB,YAEnB,SAAW,CACZ,MAEC,iBAAmB,gBACF,yBACU,CAC5B,QAEC,6BAA8B,mBACT,CACtB,SAEC,yBAA2B,CAC5B,YAEG,oBAAA,sBAAuB,WACV,CAChB,CACF,gBAGC,eAAiB,CAClB","file":"confirmation-modal.component.css","sourcesContent":["span.smaller {\n  font-size: smaller;\n}\nspan.inherit {\n  font-size: inherit;\n}\nspan.larger {\n  font-size: larger;\n}\n\n.custom-modal {\n  border-radius: .8rem;\n  .modal-body {\n    padding: 0;\n  }\n  .lead {\n    font-size: 1.50rem;\n    font-weight: 400;\n    margin: 1.5rem 2rem 0 2rem;\n  }\n  .h-line {\n    border-bottom: 1px solid #eee;\n    margin: 1.5rem 0 0 0;\n  }\n  #content {\n    margin: 1.5rem 2rem 0 2rem;\n  }\n  .button-bar {\n      justify-content: right;\n      margin: 2rem;\n  }\n}\n\n.custom-content {\n  font-size: small;\n}\n\n"],"sourceRoot":""}]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),

/***/ "eyPP":
/***/ (function(module, exports) {

module.exports = "<div class=\"button-bar\">\n  <a class=\"btn btn-link\" (click)=\"cancelClick()\" data-se-id=\"cancelButton\">{{'COMMON.BUTTON.CANCEL'\n    | translate}}</a>\n  <button type=\"button\" [disabled]=\"!eventForm.valid\" (click)=\"saveClick()\" class=\"btn btn-primary\" data-se-id=\"saveButton\">\n    {{'COMMON.BUTTON.SAVE' | translate}}\n  </button>\n</div>"

/***/ }),

/***/ "f0B1":
/***/ (function(module, exports) {

module.exports = "<pioneer-confirmation-modal\n  data-se-id=\"autopayment-confirmation-modal\"\n  [content]=\"confirmationModalConfig.content\"\n  cancel=\"COMMON.BUTTON.CANCEL\"\n  [confirm]=\"confirmationModalConfig.confirm\"\n  [title]=\"confirmationModalConfig.title\"\n  (closed)=\"confirmBeforeAutopaymentToggleHandler($event)\">\n</pioneer-confirmation-modal>\n\n<div class=\"form-group form-toggle\">\n  <label class=\"tgl\">\n    <input type=\"checkbox\"\n           (click)=\"confirmBeforeTogglingAutoPayment()\"\n           [checked]=\"onyxEvent.autoPayment\"\n           data-se-id=\"autoPaymentToggleCheckbox\"\n           hidden/>\n    <span class=\"tgl_body\" data-se-id=\"autoPaymentToggleSwitch\">\n      <span class=\"tgl_switch\"></span>\n      <span class=\"tgl_track\">\n        <span class=\"tgl_bgd\"></span>\n        <span class=\"tgl_bgd tgl_bgd-negative\"></span>\n      </span>\n    </span>\n    <!-- todo: replace labels -->\n    <span class=\"custom-control-description tooltip-hint\"\n          data-toggle=\"tooltip\"\n          data-html=\"false\"\n          data-placement=\"top\"\n          [tooltip]=\"'EVENT.COMMISSION.AUTO_PAYMENT_TOGGLE_TOOLTIP' | translate\">\n      {{ 'EVENT.COMMISSION.AUTO_PAYMENT' | translate }}\n    </span>\n  </label>\n</div>\n"

/***/ }),

/***/ "fWfk":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("rP7Y")(true);
// imports


// module
exports.push([module.i, ".btn-wrap{white-space:normal}", "", {"version":3,"sources":["/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/reservations/transient-table/transient-table.component.css"],"names":[],"mappings":"AAAA,UACE,kBAAoB,CACrB","file":"transient-table.component.css","sourcesContent":[".btn-wrap {\n  white-space: normal;\n}\n"],"sourceRoot":""}]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),

/***/ "g9Df":
/***/ (function(module, exports) {

module.exports = "<ng-container *ngIf=\"paymentSummary\">\n\n  <pioneer-confirmation-modal\n    data-se-id=\"payment-equation-confirmation-modal\"\n    content=\"MESSAGES.CONFIRMATION.PROCEED\"\n    cancel=\"COMMON.BUTTON.CANCEL\"\n    confirm=\"COMMON.BUTTON.CONFIRM\"\n    [title]=\"confirmationModalConfig.title\"\n    (closed)=\"confirmBeforeDeletingAdjustmentHandler($event)\">\n  </pioneer-confirmation-modal>\n\n  <div class=\"form-group\" data-se-id=\"adjustmentList\">\n    <div class=\"commission commission-info\">\n      <span class=\"currency flex20\">\n        <label class=\"form-control-label\">\n          {{ 'EVENT.COMMISSION.TOTAL_SPEND' | translate }}\n        </label>\n      </span>\n      <span class=\"currency flex2\"></span>\n      <span class=\"currency flex12\" style=\"text-align: center;\">\n        <label class=\"form-control-label\">\n          {{ 'EVENT.COMMISSION.COMM_RATE' | translate }}\n        </label>\n      </span>\n      <span class=\"currency flex15\">\n        <label class=\"form-control-label\">\n          {{ 'EVENT.COMMISSION.AMOUNT_DUE' | translate }}\n        </label>\n      </span>\n      <span class=\"flex48 adjustment-description\">\n        <label class=\"form-control-label\">\n          {{ 'EVENT.COMMISSION.ADJ_DESCRIPTION' | translate }}\n        </label>\n      </span>\n    </div>\n\n    <!-- Room Commission -->\n    <div class=\"commission commission-info\">\n      <ng-container *ngIf=\"showRoomCommissionAmounts; else emptyRoomCommissionSummary\">\n        <span data-se-id=\"commissionsSpendAmount\" class=\"currency flex20\">\n          {{ paymentSummary.roomCommissionSummary.totalSpend | number:'1.2-2' }} {{ onyxEvent.currency | uppercase }}\n        </span>\n        <span class=\"currency flex2\"></span>\n        <span data-se-id=\"commissionsCommRate\" class=\"currency flex12\" style=\"text-align: center;\">\n          {{ paymentSummary.roomCommissionSummary.commRate / 100 | percent }}\n        </span>\n      </ng-container>\n      <ng-template #emptyRoomCommissionSummary>\n        <span data-se-id=\"commissionsSpendAmount\" class=\"currency flex20\">\n        </span>\n        <span class=\"currency flex2\">\n        </span>\n        <span data-se-id=\"commissionsCommRate\" class=\"currency flex12\" style=\"text-align: center;\">\n        </span>\n      </ng-template>\n\n      <!-- isReducedCommission -->\n      <span *ngIf=\"isReducedCommission; else nonReducedCommission\" data-se-id=\"commissionsAmount\"\n            class=\"currency flex15 tooltip-hint\"\n            tooltip=\"{{ reducedCommissionTooltip | translate }}\"\n            placement=\"top\"\n            triggers=\"mouseenter:mouseleave\"\n            container=\"body\">\n        {{ paymentSummary.roomCommissionSummary.amountDue | number:'1.2-2' }} {{ onyxEvent.currency | uppercase }}\n      </span>\n      <ng-template #nonReducedCommission>\n        <span data-se-id=\"commissionsAmount\"\n              class=\"currency flex15\">\n          {{ paymentSummary.roomCommissionSummary.amountDue | number:'1.2-2' }} {{ onyxEvent.currency | uppercase }}\n        </span>\n      </ng-template>\n\n      <!-- Based on Reservations/RSVPS -->\n      <span class=\"desc flex48 word-wrap-break adjustment-description\" style=\"font-size: 14px; font-weight: normal;\">\n        {{ 'EVENT.COMMISSION.COMMISSIONS' | translate }}\n        <ng-container *pioneerAuthorize=\"{permission: 'ViewGroupPayPropertyIndicators'}\">\n          <span *ngIf=\"paymentSummary.roomCommissionSummary.roomCommissionType == RoomCommissionType.RSVP\" data-se-id=\"basedOnRsvps\">\n            {{ 'EVENT.COMMISSION.BASED_ON_RSPVS' | translate }}\n          </span>\n          <span *ngIf=\"paymentSummary.roomCommissionSummary.roomCommissionType == RoomCommissionType.RESERVATION\" data-se-id=\"basedOnReservations\">\n            {{ 'EVENT.COMMISSION.BASED_ON_RESERVATIONS' | translate }}\n          </span>\n        </ng-container>\n      </span>\n    </div>\n\n    <!-- Adjustments or modifiers -->\n    <ng-container *ngIf=\"showModifiers; else showAdjustments\">\n      <ng-container *ngTemplateOutlet=\"summaryListTemplate; context: { list: paymentSummary.modifierSummaryList }\"></ng-container>\n    </ng-container>\n\n    <ng-template #showAdjustments>\n      <ng-container *ngTemplateOutlet=\"summaryListTemplate; context: { list: paymentSummary.adjustmentSummaryList }\"></ng-container>\n    </ng-template>\n\n    <ng-template #summaryListTemplate let-list=\"list\">\n      <div *ngFor=\"let adjustment of list; trackBy: trackByAdjustmentId\"\n        [ngClass]=\"{\n          'adjustment': true,\n          'up': adjustment.amountDue >= 0,\n          'down': adjustment.amountDue < 0\n        }\"\n        data-se-id=\"adjustmentEntry\">\n        <ng-container *ngIf=\"adjustment.totalSpend\">\n            <span class=\"currency flex20\" data-se-id=\"adjustmentSpendAmount\">\n              {{ getAmount(adjustment.totalSpend, 0) | number:'1.2-2' }} {{ onyxEvent.currency | uppercase }}\n            </span>\n          <span class=\"currency flex2\"></span>\n          <span class=\"currency flex12\" style=\"text-align: center;\" data-se-id=\"adjustmentCommRate\">\n            {{ adjustment.commRate / 100 | percent }}\n          </span>\n        </ng-container>\n        <ng-container *ngIf=\"!adjustment.totalSpend\">\n          <span class=\"currency flex20\" data-se-id=\"adjustmentSpendAmount\">\n            None\n          </span>\n          <span class=\"currency flex2\"></span>\n          <span class=\"currency flex12\" style=\"text-align: center;\" data-se-id=\"adjustmentCommRate\">\n            None\n          </span>\n        </ng-container>\n        <span [ngClass]=\"{\n              'flex15': true,\n              'currency': true,\n              'text-success': adjustment.amountDue >= 0,\n              'text-warning': adjustment.amountDue < 0\n            }\"\n            data-se-id=\"adjustmentAmount\">\n          {{ adjustment.amountDue | number:'1.2-2' }} {{ onyxEvent.currency | uppercase }}\n        </span>\n\n        <span class=\"desc flex48 word-wrap-break\">\n          {{ adjustment.adjustmentType?.name }}: {{ adjustment.description }}\n        </span>\n\n        <ng-container *ngIf=\"showDeleteAdjustmentButton\">\n          <i data-se-id=\"deleteIcon\"\n              class=\"glyph-trash icon-remove adjustment-left\"\n              *pioneerAuthorize=\"{permission: 'DeleteAdjustment'}\"\n              (click)=\"confirmBeforeDeletingAdjustment(adjustment)\">\n          </i>\n        </ng-container>\n      </div>\n    </ng-template>\n\n    <!-- Prepayment -->\n    <div *ngIf=\"paymentSummary.prepayment?.amount\" class=\"adjustment down\">\n      <span data-se-id=\"prepaymentSpendAmount\" class=\"currency flex20\"\n            [style.text-decoration]=\"strikeThroughPrepayment ? 'line-through' : 'none'\">\n        None\n      </span>\n      <span class=\"currency flex2\"></span>\n      <span data-se-id=\"prepaymentCommRate\" class=\"currency flex12\" style=\"text-align: center;\"\n            [style.text-decoration]=\"strikeThroughPrepayment ? 'line-through' : 'none'\">\n        None\n      </span>\n      <span data-se-id=\"prepaymentAmount\" class=\"currency text-warning flex15\"\n            [style.text-decoration]=\"strikeThroughPrepayment ? 'line-through' : 'none'\">\n        {{ paymentSummary.prepayment.amount | number:'1.2-2' }} {{ onyxEvent.currency | uppercase }}\n      </span>\n      <span class=\"desc flex48 word-wrap-break\"\n            [style.text-decoration]=\"strikeThroughPrepayment ? 'line-through' : 'none'\">\n        {{ paymentSummary.prepayment.description }}\n      </span>\n    </div>\n\n    <ng-container *ngIf=\"showTaxesSection\">\n      <div class=\"total flex98\"></div>\n\n      <!-- OOIV -->\n      <div class=\"commission commission-info\" *ngIf=\"applyOoiv && ooivRulesValidation\">\n        <ng-container *ngIf=\"!isNotPendingTaxEstimated\">\n          <!-- PENDING Estimated Tax -->\n          <span class=\"currency flex17\"></span>\n          <span class=\"currency flex2\"></span>\n          <span class=\"currency flex15 text-danger\"\n                style=\"font-size: 12px; font-weight: normal;\">\n            {{ 'EVENT.COMMISSION.PENDING_TAX_ESTIMATED_TEXT' | translate }}\n          </span>\n        </ng-container>\n\n        <ng-container *ngIf=\"isNotPendingTaxEstimated\">\n          <span class=\"currency flex20\"></span>\n          <span class=\"currency flex2\"></span>\n          <span class=\"currency flex12 text-danger\"></span>\n        </ng-container>\n\n        <!-- Estimated Tax Amount -->\n        <span class=\"currency flex15\">\n          * {{ paymentSummary.estimatedTax | number:'1.2-2' }} {{ onyxEvent.currency | uppercase }}\n        </span>\n        <span class=\"desc flex48 word-wrap-break adjustment-description\" style=\"font-size: 14px; font-weight: normal;\">\n          {{ 'EVENT.COMMISSION.ESTIMATED_TAX' | translate }}\n        </span>\n      </div>\n\n      <!-- Additional tax information required -->\n      <div class=\"commission commission-info\" *ngIf=\"applyOoiv && !ooivRulesValidation\">\n        <span class=\"currency flex25 missing-tax-info\"\n              style=\"font-size: 14px; font-weight: normal;\">\n            {{ 'EVENT.COMMISSION.ADDITIONAL_TAX_INFO_TEXT' | translate : { role: 'Agency' } }}\n        </span>\n        <span class=\"desc flex48 word-wrap-break adjustment-description\" style=\"font-size: 14px; font-weight: normal;\">\n            {{ 'EVENT.COMMISSION.ESTIMATED_TAX' | translate }}\n          </span>\n      </div>\n\n      <div class=\"commission commission-info total amount\">\n        <!-- Pending Calculated Payment -->\n        <ng-container *ngIf=\"!isNotPendingTaxEstimated\">\n          <span class=\"currency flex17\"></span>\n          <span class=\"currency flex2\"></span>\n          <span class=\"currency flex15 text-danger\"\n                style=\"font-size: 12px; font-weight: normal;\">\n            {{ 'EVENT.COMMISSION.PENDING_TAX_CALCULATED_TEXT' | translate }}\n          </span>\n        </ng-container>\n\n        <ng-container *ngIf=\"isNotPendingTaxEstimated\">\n          <span class=\"currency flex20\"></span>\n          <span class=\"currency flex2\"></span>\n          <span class=\"currency flex12 text-danger\"></span>\n        </ng-container>\n\n        <!-- Calculated Payment -->\n        <span class=\"currency flex15\" data-se-id=\"calculatedPayment\">\n          {{ paymentSummary.calculatedPayment | number:'1.2-2' }} {{ onyxEvent.currency | uppercase }}\n        </span>\n        <span class=\"desc flex48 word-wrap-break adjustment-description\" style=\"font-size: 14px; font-weight: normal;\">\n          {{ 'EVENT.COMMISSION.CALCULATED_PAYMENT' | translate }}\n        </span>\n      </div>\n\n      <div class=\"commission commission-info\" *ngIf=\"applyOoiv\">\n        <span class=\"currency flex20\"></span>\n        <span class=\"currency flex2\"></span>\n        <span class=\"currency flex12\"></span>\n        <span class=\"currency flex15\"></span>\n        <span class=\"desc flex48 word-wrap-break tax-label\">\n          {{ 'EVENT.COMMISSION.ESTIMATED_TAX_TEXT' | translate }}\n        </span>\n      </div>\n    </ng-container>\n  </div>\n\n</ng-container>\n"

/***/ }),

/***/ "gAE3":
/***/ (function(module, exports) {

module.exports = "<div class=\"card\" data-se-id=\"addAdjustmentCard\">\n  <div class=\"card-header\" data-se-id=\"addAdjustmentCardHeader\">\n    {{ 'EVENT.ADJUSTMENT.ADD_PAYMENT_ITEMS' | translate }}\n  </div>\n  <div class=\"card-block\">\n    <form [formGroup]=\"adjustmentForm1\" *ngFor=\"let adjustmentForm1 of adjustmentFormList; let i = index;\">\n      <div class=\"row\">\n\n        <div class=\"col-md-2 form-container\">\n          <div class=\"form-group\" data-se-id=\"adjustmentSpendAmount\">\n            <pioneer-form-input [label]=\"i == 0 ? 'EVENT.ADJUSTMENT.AMOUNT_SPEND_FIELD' : null\">\n              <div class=\"input-group\">\n                <input type=\"number\" formControlName=\"spendAmount\" class=\"form-control\" data-se-id=\"adjustmentSpendAmountFormGroup\"\n                  placeholder=\"{{ 'EVENT.ADJUSTMENT.AMOUNT_SPEND_FIELD_PLACEHOLDER' | translate }}\" min=\"0\"\n                  (ngModelChange)=\"calculateAmount($event)\"/>\n                <div *ngIf=\"event.currency\" class=\"input-group-addon\">\n                  <span class=\"input-group-text\">{{ event.currency | uppercase }}</span>\n                </div>\n              </div>\n            </pioneer-form-input>\n          </div>\n        </div>\n\n        <div class=\"col-md-3\">\n          <div class=\"form-group form-required\">\n            <pioneer-form-input [label]=\"i == 0 ? 'EVENT.ADJUSTMENT.TYPE_FIELD' : null\">\n              <select formControlName=\"type\" class=\"form-control form-control-sm\" data-se-id=\"adjustmentType\" [class.form-required]=\"i == 0 ? true : false\">\n                <option [ngValue]=\"null\" data-se-id=\"adjustmentTypeDefaultOption\">{{ 'EVENT.ADJUSTMENT.TYPE_FIELD_PLACEHOLDER' | translate }}</option>\n                <ng-container *ngIf=\"isCredit(); else selectDebitTransactionTypes\">\n                  <option *ngFor=\"let option of (adjustmentTypeStore.getCreditAdjustmentTypes() | async)\" [ngValue]=\"option\">{{\n                    option.description }}</option>\n                </ng-container>\n                <ng-template #selectDebitTransactionTypes>\n                  <option *ngFor=\"let option of (adjustmentTypeStore.getDebitAdjustmentTypes() | async)\" [ngValue]=\"option\">{{\n                    option.description }}</option>\n                </ng-template>\n              </select>\n            </pioneer-form-input>\n          </div>\n        </div>\n\n        <div class=\"col-md-2 form-container\">\n          <div class=\"form-group\" data-se-id=\"adjustmentCommRateFormGroup\">\n            <pioneer-form-input [label]=\"i == 0 ? 'EVENT.ADJUSTMENT.COMM_RATE_FIELD' : null\">\n              <div class=\"input-group\">\n                <input type=\"number\" formControlName=\"commRate\" class=\"form-control\" data-se-id=\"adjustmentCommRateFormGroup\"\n                  placeholder=\"{{ 'EVENT.ADJUSTMENT.COMM_RATE_FIELD_PLACEHOLDER' | translate }}\" min=\"0\" />\n              </div>\n            </pioneer-form-input>\n          </div>\n        </div>\n\n        <div class=\"col-md-2 form-container\">\n          <div class=\"form-group form-required\" data-se-id=\"adjustmentAmountFormGroup\">\n            <pioneer-form-input [label]=\"i == 0 ? 'EVENT.ADJUSTMENT.AMOUNT_FIELD' : null\" [class.form-required]=\"i == 0 ? true : false\">\n              <div class=\"input-group\">\n                <input type=\"number\" formControlName=\"amount\" class=\"form-control\" data-se-id=\"adjustmentAmount\"\n                  placeholder=\"{{ 'EVENT.ADJUSTMENT.AMOUNT_FIELD_PLACEHOLDER' | translate }}\" min=\"0\" />\n                <div *ngIf=\"event.currency\" class=\"input-group-addon\">\n                  <span class=\"input-group-text\">{{ event.currency | uppercase }}</span>\n                </div>\n              </div>\n              <div class=\"validation-messages\">\n                <pioneer-validation-message error=\"amount_must_equal_spend_x_comm_rate\" message=\"MESSAGES.VALIDATION.AMOUNT_MUST_EQUAL_SPEND_AMOUNT_X_COMM_RATE\">\n                </pioneer-validation-message>\n              </div>  \n            </pioneer-form-input>\n          </div>\n        </div>\n\n        <div class=\"col-md-3\">\n          <div class=\"form-group\">\n            <pioneer-form-input [label]=\"i == 0 ? 'EVENT.ADJUSTMENT.DESCRIPTION_FIELD' : null\">\n              <input class=\"form-control\" formControlName=\"description\" data-se-id=\"description\"\n                placeholder=\"{{ 'EVENT.ADJUSTMENT.DESCRIPTION_FIELD_PLACEHOLDER' | translate }}\" />\n            </pioneer-form-input>\n          </div>\n        </div>\n\n      </div>\n    </form>\n    <div class=\"row\">\n      <div class=\"col-md-2 button-bar\">\n        <a routerLink=\".\" class=\"btn btn-link items-link\" (click)=\"addRow()\" data-se-id=\"addMoreItemsButton\">\n          {{'EVENT.ADJUSTMENT.ADD_MORE_ITEMS' | translate}}\n        </a>\n      </div>\n      <div class=\"col-md-10\">\n        <span>&nbsp;</span>\n      </div>\n    </div>\n\n  </div>\n</div>\n<div class=\"button-bar\">\n  <a routerLink=\".\" class=\"btn btn-link\" (click)=\"cancelClick()\" data-se-id=\"cancelButton\">\n    {{'COMMON.BUTTON.CANCEL' | translate}}\n  </a>\n  <button type=\"button\" class=\"btn btn-primary\" [disabled]=\"disableSave()\" (click)=\"saveClick()\" data-se-id=\"saveButton\">\n    {{ \"COMMON.BUTTON.SAVE\" | translate }}\n  </button>\n</div>\n"

/***/ }),

/***/ "gFIY":
/***/ (function(module, exports) {

function webpackEmptyAsyncContext(req) {
	// Here Promise.resolve().then() is used instead of new Promise() to prevent
	// uncatched exception popping up in devtools
	return Promise.resolve().then(function() {
		throw new Error("Cannot find module '" + req + "'.");
	});
}
webpackEmptyAsyncContext.keys = function() { return []; };
webpackEmptyAsyncContext.resolve = webpackEmptyAsyncContext;
module.exports = webpackEmptyAsyncContext;
webpackEmptyAsyncContext.id = "gFIY";

/***/ }),

/***/ "ghS0":
/***/ (function(module, exports) {

module.exports = "<div\n  class=\"card to-do-list\"\n  [ngClass]=\"{ 'is-loading': todolist === undefined }\"\n>\n  <div class=\"to-do-title\">\n    {{ \"DASHBOARD_AGENCY.TODO_LIST.TITLE\" | translate }}\n  </div>\n  <div class=\"row\">\n    <div class=\"col-md-6 to-do-table\">\n      <table class=\"table\" *ngIf=\"todolist !== undefined\">\n        <tbody>\n          <tr\n            *ngFor=\"let item of todolist\"\n            (click)=\"launchEventListPage(item.category)\"\n          >\n            <td>{{ item.category }}</td>\n            <td class=\"column-total\">{{ item.total }}</td>\n          </tr>\n        </tbody>\n      </table>\n      <table class=\"table\" *ngIf=\"todolist === undefined\">\n        <tbody>\n          <tr>\n            <td><div class=\"row-loading\"></div></td>\n          </tr>\n          <tr>\n            <td><div class=\"row-loading\"></div></td>\n          </tr>\n          <tr>\n            <td><div class=\"row-loading\"></div></td>\n          </tr>\n          <tr>\n            <td><div class=\"row-loading\"></div></td>\n          </tr>\n        </tbody>\n      </table>\n    </div>\n    <div class=\"col-md-6\">\n      <div class=\"row col-12 mb-3\">\n          <div class=\"form-group form-search mb-0\">\n            <div class=\"input-group search-event px-0\">\n              <input\n                [(ngModel)]=\"searchText\"\n                class=\"form-control\"\n                type=\"text\"\n                id=\"search\"\n                maxlength=\"100\"\n                name=\"search\"\n                required\n                autocomplete=\"off\"\n                (keydown.enter)=\"addSearchText()\"\n                placeholder=\"{{\n                  'DASHBOARD_AGENCY.TODO_LIST.EVENT_SEARCH' | translate\n                }}\"\n              />\n              <div class=\"input-group-addon\">\n                <i\n                  (click)=\"addSearchText()\"\n                  class=\"glyph-search\"\n                ></i>\n              </div>\n            </div>\n          </div>\n      </div>\n      <div class=\"row col-12 update-button mb-2\">\n        <button\n          class=\"btn btn-secundary\"\n          data-toggle=\"dropdown\"\n          data-se-id=\"update-status-paid-direct-button\"\n          (click)=\"openBulkActionModal(BulkAction.PAID_DIRECT)\"\n        >\n          <img class=\"open-icon\" src=\"assets/svg/open-external.svg\" />{{\n            \"DASHBOARD_AGENCY.TODO_LIST.UPDATE_PAID_DIRECT\" | translate\n          }}\n        </button>\n      </div>\n      <div class=\"row col-12 update-button\">\n        <button\n          class=\"btn btn-secundary\"\n          data-toggle=\"dropdown\"\n          data-se-id=\"udpate-status-cancelled-button\"\n          (click)=\"openBulkActionModal(BulkAction.CANCELLED)\"\n        >\n          <img class=\"open-icon\" src=\"assets/svg/open-external.svg\" />{{\n            \"DASHBOARD_AGENCY.TODO_LIST.UPDATE_CANCELLED\" | translate\n          }}\n        </button>\n      </div>\n    </div>\n  </div>\n</div>\n\n<pioneer-bulk-action-popup\n  *pioneerAuthorize=\"{ permission: 'ViewBulkAction' }\"\n  (closed)=\"closedBulkActionModal($event)\"\n>\n</pioneer-bulk-action-popup>\n"

/***/ }),

/***/ "hZwZ":
/***/ (function(module, exports) {

module.exports = "<div class=\"card commission-card\">\n  <div class=\"card-header\" id=\"heading-{{vendor.chain}}-{{vendor.brand}}-{{vendor.propertyId}}\">\n    <div class=\"container\">\n      <div class=\"row justify-content-between\">\n        <div class=\"col flex33\">\n          <span>\n            <a href=\"#!\" class=\"card-state-toggle no-text-decoration\"\n               (click)=\"vendor.isExpanded ? onCardExpandClicked($event, vendor.eventPartyId, vendor.chain, vendor.brand, vendor.propertyId, false)\n                                            : onCardExpandClicked($event, vendor.eventPartyId, vendor.chain, vendor.brand, vendor.propertyId, true)\">\n              <i class=\"far fa-fw {{vendor.isExpanded ? 'fa-chevron-up' : 'fa-chevron-down'}}\"></i>\n            </a>\n            <ng-container *pioneerAuthorize=\"{permission: 'ViewGroupPayPropertyIndicators'}\">\n              <img *ngIf=\"vendor.subscriber\" src=\"{{imagesUrl}}/grouppay-logo-symbol.png\" width=\"22px\" height=\"22px\"\n                   tooltip=\"{{'EVENTS.PROPERTY_SUBSCRIBED_TOOLTIP' | translate }}\">\n            </ng-container>\n            &nbsp;{{ vendor.name }}\n          </span>\n        </div>\n        <div class=\"col\" *ngIf=\"!vendor.isExpanded\">\n          <pioneer-vendor-header-summary [event]=\"onyxEvent\"\n                                         [type]=\"headerRecordType\"\n                                         [vendor]=\"vendor\">\n          </pioneer-vendor-header-summary>\n        </div>\n      </div>\n    </div>\n  </div>\n\n  <div *ngIf=\"vendor.isExpanded\">\n\n    <div class=\"card-block\">\n      <div [formGroup]=\"vendorForm\">\n        <div class=\"row\">\n          <div class=\"col form-container\">\n            <div class=\"form-group\">\n              <pioneer-form-input label=\"EVENT.COMMISSION.VENDOR_NAME\" [isReadOnly]=\"true\">\n                <input type=\"text\"\n                       class=\"form-control\"\n                       formControlName=\"vendorName\"\n                       maxlength=\"100\"\n                       data-se-id=\"vendorName\"\n                       [readonly]=\"true\"/>\n              </pioneer-form-input>\n            </div>\n          </div>\n          <div class=\"col form-container\">\n            <div class=\"form-group\">\n              <pioneer-form-input label=\"EVENT.COMMISSION.VENDOR_ADDRESS\" [isReadOnly]=\"true\">\n                <input type=\"text\" pioneerUppercase\n                       class=\"form-control\"\n                       formControlName=\"vendorAdress\"\n                       maxlength=\"20\"\n                       [readonly]=\"true\"\n                       data-se-id=\"vendorAdress\"/>\n              </pioneer-form-input>\n            </div>\n          </div>\n          <div class=\"col form-container\">\n            <div class=\"form-group\">\n              <pioneer-form-input label=\"EVENT.COMMISSION.VENDOR_STATE\" [isReadOnly]=\"true\">\n                <input type=\"text\"\n                       class=\"form-control\"\n                       formControlName=\"vendorState\"\n                       maxlength=\"100\"\n                       data-se-id=\"vendorState\"\n                       [readonly]=\"true\"/>\n              </pioneer-form-input>\n            </div>\n          </div>\n          <div class=\"col form-container\">\n            <div class=\"form-group\">\n              <pioneer-form-input label=\"EVENT.COMMISSION.VENDOR_ZIP\" [isReadOnly]=\"true\">\n                <input type=\"text\" pioneerUppercase\n                       class=\"form-control\"\n                       formControlName=\"vendorZip\"\n                       maxlength=\"20\"\n                       [readonly]=\"true\"\n                       data-se-id=\"vendorZip\"/>\n              </pioneer-form-input>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"card-block\">\n      <div class=\"content-container\">\n\n        <div class=\"clearfix mb-5\">\n          <div class=\"active-filters\">\n            <div class=\"view-select float-right\">\n              <div class=\"btn-group btn-group-sm\">\n                <button class=\"btn btn-default\"\n                        [ngClass]=\"{'active': !isInDetail }\"\n                        (click)=\"navigateTo('/event/' + onyxEvent.eventId + '/reservations')\"\n                        data-se-id=\"reservation-summary-toggle-button\">\n                  <i class=\"glyph-page\"></i>{{'EVENT.RESERVATION.SUMMARY_BUTTON' | translate}}\n                </button>\n                <button class=\"btn btn-default\"\n                        [ngClass]=\"{'active': isInDetail }\"\n                        (click)=\"navigateTo('/event/' + onyxEvent.eventId + '/reservations/detail')\"\n                        data-se-id=\"reservation-compare-toggle-button\"\n                        [disabled]=\"disableCompareButton$ | async\">\n                  <i class=\"glyph-pages\"></i>{{'EVENT.RESERVATION.COMPARE_BUTTON' | translate}}\n                </button>\n              </div>\n            </div>\n          </div>\n        </div>\n\n        <pioneer-reservation-button-bar\n          [event]=\"onyxEvent\"\n          data-se-id=\"addReservation\"\n          [showDownloadDropdown]=\"(areReservationsPresent$ | async) === true\"\n          [summarySelected]=\"(showReservationCompareSummary$ | async) === true\"\n          [vendor]=\"vendor\">\n        </pioneer-reservation-button-bar>\n\n        <pioneer-reservation-summary-table\n          *ngIf=\"showReservationCompareSummary$ | async\"\n          [event]=\"onyxEvent\"\n          [vendor]=\"vendor\">\n        </pioneer-reservation-summary-table>\n\n        <pioneer-reservation-detail-table\n          *ngIf=\"!(showReservationCompareSummary$ | async)\"\n          [event]=\"onyxEvent\"\n          [vendor]=\"vendor\">\n        </pioneer-reservation-detail-table>\n\n      </div>\n    </div>\n\n  </div>\n\n</div>\n"

/***/ }),

/***/ "hslH":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("rP7Y")(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"custom-fields-form.component.css","sourceRoot":""}]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),

/***/ "iC+n":
/***/ (function(module, exports) {

module.exports = "<pioneer-event-collision-modal\n  data-se-id=\"event-collision-modal\"\n  mode=\"ADD\"\n  (closed)=\"confirmBeforeSaveEventHandler($event)\"\n  (canceled)=\"cancelMatchingWizard($event)\">\n</pioneer-event-collision-modal>\n<pioneer-event-collision-modal-multiprompt\n  data-se-id=\"event-collision-modal-multiprompt\"\n  mode=\"ADD\"\n  (closed)=\"confirmBeforeSaveEventHandler($event)\"\n  (canceled)=\"cancelMatchingWizard($event)\">\n</pioneer-event-collision-modal-multiprompt>\n\n<form [formGroup]=\"eventForm\"\n      novalidate>\n  <div class=\"content-container\">\n    <div class=\"row\">\n      <div class=\"card-content\">\n        <div formGroupName=\"event\">\n\n          <pioneer-add-event-button-bar data-se-id=\"add-event-button-bar-top\" [eventForm]=\"eventForm\" (save)=\"onSaveBtn(eventForm.value)\"\n            (cancel)=\"returnToSearchList()\"></pioneer-add-event-button-bar>\n\n          <pioneer-basic-event-data\n            [parentForm]=\"eventForm\"\n            [event]=\"onyxEvent\"\n            [isReadOnly]=\"isReadOnly\"\n            [isNewEvent]=\"true\"\n            [focusEventNameSubject]=\"focusEventNameSubject\">\n          </pioneer-basic-event-data>\n\n          <ng-container *pioneerAuthorize=\"{permission: 'SingleVendor'}\">\n            <pioneer-property-lookup-form\n              [parentForm]=\"eventForm\"\n              [event]=\"onyxEvent\"\n              [isReadOnly]=\"isReadOnly\"\n              [isNewEvent]=\"true\"\n              [inputEmail]=\"agencyEmail\"\n              (outputEmail)=\"setupPropertyEmail($event)\">\n            </pioneer-property-lookup-form>\n          </ng-container>\n\n          <ng-container *pioneerAuthorize=\"{permission: 'MultiVendor'}\">\n            <pioneer-vendor-lookup-form\n              [parentForm]=\"eventForm\"\n              [isReadOnly]=\"isReadOnly\"\n              [isNewEvent]=\"true\"\n              [inputEmail]=\"agencyEmail\"\n              (outputEmail)=\"setupPropertyEmail($event)\">\n            </pioneer-vendor-lookup-form>\n          </ng-container>\n\n          <pioneer-agency-form\n            [parentForm]=\"eventForm\"\n            [event]=\"onyxEvent\"\n            [isReadOnly]=\"isReadOnly\"\n            [inputEmail]=\"propertyEmail\"\n            (outputEmail)=\"setupAgencyEmail($event)\"\n            (selectedAgency)=\"selectedAgency()\">\n          </pioneer-agency-form>\n\n          <pioneer-contact-form\n            [parentForm]=\"eventForm\"\n            partyType=\"CLIENT\"\n            [event]=\"onyxEvent\"\n            [isReadOnly]=\"isReadOnly\"\n            [clientContactEditable]=\"clientContactEditable\">\n          </pioneer-contact-form>\n\n          <pioneer-add-event-button-bar data-se-id=\"add-event-button-bar-bottom\" [eventForm]=\"eventForm\" (save)=\"onSaveBtn(eventForm.value)\"\n            (cancel)=\"returnToSearchList()\"></pioneer-add-event-button-bar>\n\n        </div>\n      </div>\n    </div>\n  </div>\n</form>\n\n"

/***/ }),

/***/ "iEAM":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("rP7Y")(true);
// imports


// module
exports.push([module.i, ".loading-data{width:100%;height:100%;position:absolute;background:hsla(0,0%,100%,.8)}.loader{display:block;width:48px;height:48px;border-radius:50%;position:absolute;top:47%;left:47%;animation:rotate 1s linear infinite}.loader:after,.loader:before{content:\"\";box-sizing:border-box;position:absolute;inset:0;border-radius:50%;border:5px solid transparent;animation:prixClipFix 2s linear infinite}.loader:after{border-color:transparent;animation:prixClipFix 2s linear infinite,rotate .5s linear infinite reverse;inset:6px}@keyframes rotate{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}@keyframes prixClipFix{0%{clip-path:polygon(50% 50%,0 0,0 0,0 0,0 0,0 0)}25%{clip-path:polygon(50% 50%,0 0,100% 0,100% 0,100% 0,100% 0)}50%{clip-path:polygon(50% 50%,0 0,100% 0,100% 100%,100% 100%,100% 100%)}75%{clip-path:polygon(50% 50%,0 0,100% 0,100% 100%,0 100%,0 100%)}to{clip-path:polygon(50% 50%,0 0,100% 0,100% 100%,0 100%,0 0)}}", "", {"version":3,"sources":["/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/event-list/event-list.component.css"],"names":[],"mappings":"AAAA,cACI,WAAY,YACC,kBACM,6BACkB,CACtC,QAEI,cAAe,WACF,YACC,kBACM,kBACA,QACV,SACC,mCAC0B,CACrC,6BAEC,WAAY,sBACW,kBACJ,QACR,kBACQ,6BACW,wCACa,CAC5C,cAEC,yBAA0B,4EACsD,SACrE,CACZ,kBAGC,GAAM,sBAAuB,CAAC,GACtB,uBAAyB,CAAC,CACnC,uBAGG,GAAM,8CAA8C,CAAC,IAC/C,0DAA0D,CAAC,IAC3D,mEAAmE,CAAC,IACpE,6DAA6D,CAAC,GAC9D,0DAA0D,CAAC,CACpE","file":"event-list.component.css","sourcesContent":[".loading-data {\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    background: rgba(255, 255, 255, 0.8);\n  }\n  .loader {\n       display: block;\n        width: 48px;\n        height: 48px;\n        border-radius: 50%;\n        position: absolute;\n        top: 47%;\n        left: 47%;\n        animation: rotate 1s linear infinite\n      }\n      .loader::before , .loader::after {\n        content: \"\";\n        box-sizing: border-box;\n        position: absolute;\n        inset: 0px;\n        border-radius: 50%;\n        border: 5px solid transparent;\n        animation: prixClipFix 2s linear infinite ;\n      }\n      .loader::after{\n        border-color: transparent;\n        animation: prixClipFix 2s linear infinite , rotate 0.5s linear infinite reverse;\n        inset: 6px;\n      }\n\n      @keyframes rotate {\n        0%   {transform: rotate(0deg)}\n        100%   {transform: rotate(360deg)}\n      }\n\n      @keyframes prixClipFix {\n          0%   {clip-path:polygon(50% 50%,0 0,0 0,0 0,0 0,0 0)}\n          25%  {clip-path:polygon(50% 50%,0 0,100% 0,100% 0,100% 0,100% 0)}\n          50%  {clip-path:polygon(50% 50%,0 0,100% 0,100% 100%,100% 100%,100% 100%)}\n          75%  {clip-path:polygon(50% 50%,0 0,100% 0,100% 100%,0 100%,0 100%)}\n          100% {clip-path:polygon(50% 50%,0 0,100% 0,100% 100%,0 100%,0 0)}\n      }\n"],"sourceRoot":""}]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),

/***/ "iS/x":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("rP7Y")(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"route-not-found.component.css","sourceRoot":""}]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),

/***/ "j4M3":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("rP7Y")(true);
// imports


// module
exports.push([module.i, ".order-one{-ms-flex-order:1!important;order:1!important}.no-payment,.non-bold{font-weight:400}.no-payment{color:#86b0f5}.no-text-decoration{text-decoration:none}.commission-card{margin-bottom:15px}", "", {"version":3,"sources":["/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/overview/vendor-overview-card/vendor-overview-card.component.css"],"names":[],"mappings":"AAAA,WACE,2BAAA,iBAAoB,CACrB,sBAGC,eAAmB,CAGrB,YAEE,aAAc,CACf,oBAGC,oBAAsB,CACvB,iBAGG,kBAAoB,CACvB","file":"vendor-overview-card.component.css","sourcesContent":[".order-one {\n  order: 1 !important;\n}\n\n.non-bold {\n  font-weight:normal;\n}\n\n.no-payment {\n  font-weight:normal;\n  color: #86B0F5\n}\n\n.no-text-decoration {\n  text-decoration: none;\n}\n\n.commission-card{\n    margin-bottom: 15px;\n}\n"],"sourceRoot":""}]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),

/***/ "jeRC":
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\">\n  <h5 class=\"modal-title\">{{ 'EVENT.PROPERTY.POPUP.ADD.TITLE' | translate }}</h5>\n  <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\" (click)=\"cancel()\">\n    <span aria-hidden=\"true\">&times;</span>\n  </button>\n</div>\n<div class=\"modal-body\">\n  <p class=\"text-muted text-warning\"></p>\n\n  <!-- FORM START -->\n  <div [formGroup]=\"propertyForm\">\n    <div class=\"row\">\n      <div class=\"form-container party-name form-required\">\n        <pioneer-form-input label=\"EVENT.PROPERTY.POPUP.ADD.NAME\">\n          <input type=\"text\" class=\"form-control\" formControlName=\"name\"\n            maxlength=\"50\"\n            [attr.placeholder]=\"'EVENT.PROPERTY.POPUP.ADD.NAME_PLACEHOLDER' | translate\" />\n        </pioneer-form-input>\n      </div>\n      <div class=\"form-container party-name form-required\">\n        <pioneer-form-input label=\"EVENT.PROPERTY.POPUP.ADD.COUNTRY\">\n          <select formControlName=\"countryCode\" (change)=\"onCountryCodeChanged()\" class=\"form-control form-control-sm\">\n            <option [ngValue]=\"null\">{{ 'EVENT.PROPERTY.POPUP.ADD.COUNTRY_PLACEHOLDER' | translate }}</option>\n            <option *ngFor=\"let option of (commonDataStore.countries | async)\" [ngValue]=\"option.key\">{{ option.value }}</option>\n          </select>\n        </pioneer-form-input>\n      </div>\n    </div>\n    <div class=\"row\">\n      <div class=\"form-container party-address form-required address1\">\n        <pioneer-form-input label=\"EVENT.PROPERTY.POPUP.ADD.ADDRESS_1\">\n          <input type=\"text\" class=\"form-control\" formControlName=\"address1\" maxlength=\"50\"\n            [attr.placeholder]=\"'EVENT.PROPERTY.POPUP.ADD.ADDRESS_1_PLACEHOLDER' | translate\" />\n        </pioneer-form-input>\n      </div>\n    </div>\n    <div class=\"row\">\n      <div class=\"form-container party-address\">\n        <pioneer-form-input label=\"EVENT.PROPERTY.POPUP.ADD.ADDRESS_2\">\n          <input type=\"text\" class=\"form-control\" formControlName=\"address2\" maxlength=\"50\"\n            [attr.placeholder]=\"'EVENT.PROPERTY.POPUP.ADD.ADDRESS_2_PLACEHOLDER' | translate\" />\n        </pioneer-form-input>\n      </div>\n      <div class=\"form-container party-address\">\n        <pioneer-form-input label=\"EVENT.PROPERTY.POPUP.ADD.ADDRESS_3\">\n          <input type=\"text\" class=\"form-control\" formControlName=\"address3\" maxlength=\"50\"\n            [attr.placeholder]=\"'EVENT.PROPERTY.POPUP.ADD.ADDRESS_3_PLACEHOLDER' | translate\" />\n        </pioneer-form-input>\n      </div>\n    </div>\n    <div class=\"row\">\n      <div class=\"form-container party-city form-required\">\n        <pioneer-form-input label=\"EVENT.PROPERTY.POPUP.ADD.CITY\">\n          <input type=\"text\" class=\"form-control\" formControlName=\"city\"\n            maxlength=\"50\"\n            [attr.placeholder]=\"'EVENT.PROPERTY.POPUP.ADD.CITY_PLACEHOLDER' | translate\" />\n        </pioneer-form-input>\n      </div>\n      <div class=\"form-container party-state-zip\">\n        <div class=\"row\">\n          <div *ngIf=\"showState\" class=\"form-container form-group party-state form-required\">\n            <pioneer-form-input label=\"EVENT.PROPERTY.POPUP.ADD.STATE\">\n              <select formControlName=\"stateProvinceCode\" class=\"form-control form-control-sm\">\n                <option [ngValue]=\"null\">{{ 'EVENT.PROPERTY.POPUP.ADD.STATE_PLACEHOLDER' | translate }}</option>\n                <option *ngFor=\"let option of (states$ | async)\" [ngValue]=\"option.key\">{{ option.value }}</option>\n              </select>\n              <div class=\"validation-messages\">\n                <pioneer-validation-message error=\"country_state_cross_error\" message=\"MESSAGES.VALIDATION.COUNTRY_STATE_CROSS_ERROR\">\n                </pioneer-validation-message>\n              </div>\n            </pioneer-form-input>\n          </div>\n          <div *ngIf=\"showPostalCode\" class=\"party-zip form-group form-required\">\n            <pioneer-form-input label=\"EVENT.PROPERTY.POPUP.ADD.POSTAL_CODE\">\n              <input type=\"text\" class=\"form-control\" formControlName=\"postalCode\" maxlength=\"15\"\n                [attr.placeholder]=\"'EVENT.PROPERTY.POPUP.ADD.POSTAL_CODE_PLACEHOLDER' | translate\" />\n              <div class=\"validation-messages\">\n                <pioneer-validation-message error=\"postal_code_country_cross_error\"\n                  message=\"MESSAGES.VALIDATION.POSTAL_CODE_COUNTRY_CROSS_ERROR\">\n                </pioneer-validation-message>\n              </div>\n            </pioneer-form-input>\n          </div>\n        </div>\n      </div>\n    </div>\n    <div class=\"row\">\n      <div class=\"form-container contact-name-first\">\n        <pioneer-form-input label=\"EVENT.PROPERTY.POPUP.ADD.FIRST_NAME\">\n          <input type=\"text\" class=\"form-control\" formControlName=\"contactFirstNm\"\n            maxlength=\"50\"\n            [attr.placeholder]=\"'EVENT.PROPERTY.POPUP.ADD.FIRST_NAME_PLACEHOLDER' | translate\" />\n        </pioneer-form-input>\n      </div>\n      <div class=\"form-container contact-name-last\">\n        <pioneer-form-input label=\"EVENT.PROPERTY.POPUP.ADD.LAST_NAME\">\n          <input type=\"text\" class=\"form-control\" formControlName=\"contactLastNm\"\n            maxlength=\"50\"\n            [attr.placeholder]=\"'EVENT.PROPERTY.POPUP.ADD.LAST_NAME_PLACEHOLDER' | translate\" />\n        </pioneer-form-input>\n      </div>\n    </div>\n    <div class=\"row\">\n      <div class=\"form-container form-group contact-email form-required\">\n        <pioneer-form-input label=\"EVENT.PROPERTY.POPUP.ADD.EMAIL\">\n          <input type=\"email\" class=\"form-control\" formControlName=\"email\"\n            maxlength=\"75\"\n            [attr.placeholder]=\"'EVENT.PROPERTY.POPUP.ADD.EMAIL_PLACEHOLDER' | translate\"\n            pioneerLowercase />\n        </pioneer-form-input>\n      </div>\n      <div class=\"form-container contact-tel\">\n        <div class=\"row\">\n          <div class=\"form-container contact-phone\">\n            <pioneer-form-input label=\"EVENT.PROPERTY.POPUP.ADD.PHONE\">\n              <input type=\"tel\" class=\"form-control\" formControlName=\"phoneNr\"\n                maxlength=\"20\"\n                [attr.placeholder]=\"'EVENT.PROPERTY.POPUP.ADD.PHONE_PLACEHOLDER' | translate\" />\n            </pioneer-form-input>\n          </div>\n          <div class=\"form-container contact-fax\">\n            <pioneer-form-input label=\"EVENT.PROPERTY.POPUP.ADD.FAX\">\n              <input type=\"tel\" class=\"form-control\" formControlName=\"faxNr\"\n                maxlength=\"20\"\n                [attr.placeholder]=\"'EVENT.PROPERTY.POPUP.ADD.FAX_PLACEHOLDER' | translate\" />\n            </pioneer-form-input>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n  <!-- FORM END -->\n</div>\n<div class=\"modal-footer\">\n  <button type=\"button\" class=\"btn btn-link\" data-dismiss=\"modal\" (click)=\"cancel()\"\n    data-se-id=\"cancelPropertyPopup\">{{ 'COMMON.BUTTON.CANCEL' | translate}}</button>\n  <button type=\"button\" class=\"btn btn-primary\" [disabled]=\"!propertyForm.valid\" (click)=\"accept()\"\n    data-se-id=\"acceptPropertyPopup\">{{ 'COMMON.BUTTON.SAVE' | translate }}</button>\n</div>\n"

/***/ }),

/***/ "kYhW":
/***/ (function(module, exports) {

module.exports = "<!--              Summary          -->\n<pioneer-confirmation-modal\n  #confirmDeleteModal\n  data-se-id=\"deleteReservationConfirmationModal\"\n  content=\"EVENT.RESERVATION.CONFIRM_DELETE_RESERVATION\"\n  cancel=\"COMMON.BUTTON.CANCEL\"\n  confirm=\"EVENT.RESERVATION.DELETE_RESERVATION\"\n  (closed)=\"confirmHandler($event)\">\n</pioneer-confirmation-modal>\n<pioneer-confirmation-modal\n  #confirmUnlinkModal\n  data-se-id=\"unlinkReservationConfirmationModal\"\n  content=\"EVENT.TRANSIENT_RESERVATION.CONFIRM_UNLINK_RESERVATION\"\n  cancel=\"COMMON.BUTTON.CANCEL\"\n  confirm=\"EVENT.TRANSIENT_RESERVATION.UNLINK_RESERVATION\"\n  (closed)=\"confirmUnlinkHandler($event)\">\n</pioneer-confirmation-modal>\n\n\n<div class=\"card\" *ngIf=\"!(isReservationListEmpty() | async)\">\n  <template #commissionSummaryPopup>\n    <p class='lead' data-se-id=\"summary-tooltip-title\">{{\n      'EVENT.RESERVATION.TOOLTIP_SUMMARY_COMMISSION_TITLE' | translate }}</p>\n    <p class='res-comm'><span class='label'>{{ 'EVENT.RESERVATION.TOOLTIP_COMMISSION_TOTAL' | translate }}</span>\n      {{ getReservationCommissionTotal() | async | number:'1.2-2' }}</p>\n    <div *ngIf=\"!(isRsvpListEmpty() | async)\">\n      <p class='rsvp-comm'><span class='label'>{{ 'EVENT.RESERVATION.TOOLTIP_COMMISSION_RSVP' | translate }}</span>\n        {{ getRsvpCommissionTotal() | async | number:'1.2-2' }}</p>\n      <p class='diff-comm'>\n        <span\n          class='label'>{{ 'EVENT.RESERVATION.TOOLTIP_COMMISSION_DIFFERENCE' | translate }}</span>\n        {{ getCommissionDeltaText() | async }} {{ getCommissionDelta() | async | absolute | number:'1.2-2' }}\n      </p>\n    </div>\n  </template>\n\n  <div id=\"card-reservation-list\">\n    <pioneer-header-summary [event]=\"onyxEvent\"\n                            [title]=\"'EVENT.RESERVATION.RESERVATION_SUMMARY_TITLE' | translate\"\n                            [tooltipText]=\"'EVENT.COMMISSION.HEADER_SUMMARY_TOOLTIP' | translate\"\n                            [type] = \"headerRecordType\"\n                            [vendor]=\"vendor\">\n    </pioneer-header-summary>\n  </div>\n  <div class=\"table-responsive table-dropdown\" *ngIf=\"!(isFilteredListEmpty() | async)\"\n       data-se-id=\"reservation-summary-table\">\n    <table class=\"table reservation-list res-summary\" [ngClass]=\"filteredClass\">\n      <thead>\n      <tr>\n        <ng-container *ngIf=\"canManageReservations && (canChangeReservations$ | async) === true\">\n          <th class=\"control-remove-row\" *pioneerAuthorize=\"{permissions: ['EditReservation','DeleteReservation']}\"></th>\n        </ng-container>\n        <th>\n          <br>{{ 'EVENT.RESERVATION.NAME' | translate }}<br>\n          <span class=\"font-weight-normal\">{{ 'EVENT.RESERVATION.CONFIRMATION_NUMBER' | translate }}</span>\n        </th>\n        <th><br>{{ 'EVENT.RESERVATION.STATUS' | translate }}</th>\n        <th><br>{{ 'EVENT.RESERVATION.CHECKIN_DATE' | translate }}</th>\n        <th><br>{{ 'EVENT.RESERVATION.CHECKOUT_DATE' | translate }}</th>\n        <th class=\"nights\"><br>{{ 'EVENT.RESERVATION.NUMBER_ROOMS' | translate }}</th>\n        <th class=\"nights\"><br>{{ 'EVENT.COMMISSION.ROOM_NIGHTS' | translate }}</th>\n        <th>\n          <br>{{ 'EVENT.RESERVATION.RATE_PLAN_CODE' | translate }}<br>\n          <span class=\"font-weight-normal\">{{ 'EVENT.RESERVATION.ROOM_TYPE' | translate }}</span>\n        </th>\n        <th class=\"currency\">\n          <small>({{ onyxEvent.currency | uppercase }})</small>\n          <br>{{ 'EVENT.RESERVATION.ROOM_RATE' | translate }}\n        </th>\n        <th class=\"currency\">\n          <small>({{ onyxEvent.currency | uppercase }})</small>\n          <br>{{ 'EVENT.RESERVATION.REVENUE' | translate }}\n        </th>\n        <th class=\"currency\">\n          <small>({{ onyxEvent.currency | uppercase }})</small>\n          <br>{{ 'EVENT.RESERVATION.COMMISSION' | translate }}\n        </th>\n      </tr>\n      </thead>\n      <tbody data-se-id=\"reservationSummary\">\n      <tr *ngFor=\"let compare of reservationsPage?.content; last as isLast\"\n          data-se-id=\"reservationSummaryEntry\"\n          [class.commission-up]=\"isCommissionUp(compare)\"\n          [class.commission-down]=\"isCommissionDown(compare)\"\n          [ngClass]=\"[getStatusClass(compare), getSourceClass(compare)]\">\n\n        <ng-container *ngIf=\"canManageReservations && (canChangeReservations$ | async) === true\">\n          <ng-container *pioneerAuthorize=\"{permissions: ['EditReservation','DeleteReservation', 'UnlinkReservation']}\">\n            <td class=\"col-more\" data-se-id=\"openDropdownMenu\" *ngIf=\"canBeModifiable(compare.reservation) || canBeUnlinkable(compare.reservation); else displayLock\">\n              <!-- Use Bootstrap (jQuery) due to better performance  -->\n              <div [ngClass]=\"isLast ? 'dropup' : 'dropdown'\">\n                <button class=\"btn btn-more\" data-toggle=\"dropdown\">\n                  <i class=\"far fa-ellipsis-h\"></i>\n                </button>\n                <ul class=\"dropdown-menu\" *ngIf=\"canBeModifiable(compare.reservation)\">\n                  <li role=\"menuitem\" *pioneerAuthorize=\"{permission: 'EditReservation'}\">\n                    <a class=\"dropdown-item\" href=\"javascript:void(0)\" (click)=\"openReservationModal($event, compare.reservation)\" data-se-id=\"openReservationModal\">\n                      <i class=\"fal fa-pencil fa-fw\"></i>\n                      {{ 'EVENT.RESERVATION.EDIT_RESERVATION_MENU_ITEM' | translate }}\n                    </a>\n                  </li>\n                  <li class=\"divider dropdown-divider\"></li>\n                  <li role=\"menuitem\" *pioneerAuthorize=\"{permission: 'DeleteReservation'}\">\n                    <a class=\"dropdown-item\" href=\"javascript:void(0)\" (click)=\"confirmBeforeDelete($event, compare.reservation)\" data-se-id=\"reservationDelete\">\n                      <i class=\"fal fa-trash-alt fa-fw\"></i>\n                      {{ 'EVENT.RESERVATION.DELETE_RESERVATION_MENU_ITEM' | translate }}\n                    </a>\n                  </li>\n                </ul>\n                <ul class=\"dropdown-menu\" *ngIf=\"canBeUnlinkable(compare.reservation)\">\n                  <li role=\"menuitem\" *pioneerAuthorize=\"{permission: 'UnlinkReservation'}\">\n                    <a class=\"dropdown-item\" href=\"javascript:void(0)\" (click)=\"confirmBeforeUnlink($event, compare.reservation)\" data-se-id=\"openConfirmUnlinkModal\">\n                      <i class=\"fal fa-pencil fa-fw\"></i>\n                      {{ 'EVENT.TRANSIENT_RESERVATION.UNLINK_RESERVATION' | translate }}\n                    </a>\n                  </li>\n                </ul>\n              </div>\n            </td>\n            <ng-template #displayLock>\n              <td class=\"col-more\">\n                <i class=\"fal fa-lock text-muted mt-2\"></i>\n              </td>\n            </ng-template>\n          </ng-container>\n          <ng-template #emptyColumn>\n            <td class=\"col-more\"></td>\n          </ng-template>\n        </ng-container>\n        <td data-se-id=\"name\">\n          <a class=\"complex-link\"\n            [routerLink]=\"['/event/' + onyxEvent.eventId + '/reservations/detail']\"\n            [queryParams]=\"{ reservation: compare.reservation.eventReservationId }\">\n            <span *ngIf=\"compare.reservation.firstName\" class=\"res-guest-name underline-hover\">\n              {{ compare.reservation.lastName }}, {{ compare.reservation.firstName }}\n            </span>\n            <span *ngIf=\"!compare.reservation.firstName\" class=\"res-guest-name underline-hover\">\n              {{ compare.reservation.lastName }}\n            </span>\n            <div class=\"text-muted\">{{ compare.reservation.confirmation }}</div>\n          </a>\n        </td>\n        <td class=\"res-status\" data-se-id=\"status\">\n          <span class=\"res-value\">{{ compare.reservation.status | reservationStatus }}</span>\n        </td>\n        <td data-se-id=\"checkIn\">\n          <span class=\"res-value\">{{ compare.reservation.checkInDate | dateFormat }}</span>\n        </td>\n        <td data-se-id=\"checkOut\">\n          <span class=\"res-value\">{{ compare.reservation.checkOutDate | dateFormat }}</span>\n        </td>\n        <td class=\"nights\" data-se-id=\"rooms\">\n          <span class=\"res-value\">{{ compare.reservation.rooms }}</span>\n        </td>\n        <td class=\"nights\" data-se-id=\"nights\">\n          <span class=\"res-value\">{{ compare.reservation.roomNights }}</span>\n        </td>\n        <td data-se-id=\"ratePlanCode\">\n          <span class=\"res-value\">{{ compare.reservation.ratePlanCode }}</span>\n          <span class=\"res-value text-muted\">{{ compare.reservation.roomType }}</span>\n        </td>\n        <td class=\"currency\" data-se-id=\"roomRate\">\n          <span class=\"res-value\">{{ compare.reservation.roomRate | number:'1.2-2' }}</span>\n        </td>\n        <td class=\"currency\" data-se-id=\"revenue\">\n          <span class=\"res-value\">{{ compare.reservation.revenue | number:'1.2-2' }}</span>\n        </td>\n        <td class=\"currency rsvp-diff\" data-se-id=\"commission\">\n          <span *ngIf=\"!isTransient(compare.reservation)\" class=\"res-value\">{{ compare.reservation.commission | number:'1.2-2' }}</span>\n          <span *ngIf=\"isTransient(compare.reservation)\"\n                class=\"res-value tooltip-hint\"\n                tooltip=\"{{ getTransientTooltip(compare.reservation) | translate }}\"\n                placement=\"top\"\n                triggers=\"mouseenter:mouseleave\"\n                container=\"body\">\n            {{ compare.reservation.commission | number:'1.2-2' }}\n          </span>\n        </td>\n      </tr>\n      </tbody>\n    </table>\n  </div>\n\n  <div class=\"card-footer\" *ngIf=\"reservationsPage?.totalElements > 0\">\n    <pioneer-pagination\n      [resultsPage]=\"reservationsPage\"\n      (updatePage)=\"onRefreshReservationsList($event.page, $event.itemsPerPage)\"\n      [pagesizeType]=\"pagesizeType\">\n    </pioneer-pagination>\n  </div>\n\n  <div *ngIf=\"hasFilteredOutResults() | async\" class=\"result-empty\"\n       data-se-id=\"reservation-filtered-out\">\n    <h3>{{ \"EVENT.RESERVATION.NO_FILTERED_RESERVATIONS_FOUND\" | translate }}</h3>\n    <figure class=\"figure\">\n      <i class=\"glyph-page figure-img\"></i>\n      <figcaption class=\"figure-caption\"><a class=\"btn btn-link\"\n                                            data-se-id=\"reservation-filtered-reset\"\n                                            (click)=\"resetStatusCodes()\">\n        {{ \"EVENT.RESERVATION.NO_FILTERED_RESERVATIONS_FOUND_CAPTION\" | translate }}</a>\n      </figcaption>\n    </figure>\n  </div>\n</div>\n\n<div *ngIf=\"isReservationListEmpty() | async\" class=\"result-empty\"\n     data-se-id=\"reservationSummaryNotFound\">\n  <h3>{{ \"EVENT.RESERVATION.NO_RESERVATIONS_FOUND\" | translate }}</h3>\n  <figure class=\"figure\">\n    <i class=\"glyph-page figure-img\"></i>\n  </figure>\n</div>\n<pioneer-reservation-modal *pioneerAuthorize=\"{permission: 'EditReservation'}\" [event]=\"onyxEvent\" [action]=\"editModal\" data-se-id=\"editModal\">\n</pioneer-reservation-modal>\n"

/***/ }),

/***/ "kt5u":
/***/ (function(module, exports) {

module.exports = "<div class=\"splash-content\">\n  <div class=\"splash-container\">\n    <div class=\"login-logo error\"><span class=\"sr-only\">Onyx CenterSource</span></div>\n  </div>\n</div>\n<pioneer-iata-by-default-modal\n  data-se-id=\"app-component-iata-by-default-modal\">\n</pioneer-iata-by-default-modal>\n"

/***/ }),

/***/ "lOyP":
/***/ (function(module, exports) {

module.exports = "<div class=\"card-block\">\n  <h4 class=\"card-title\">\n    {{ 'EVENTS.RESULTS_RETURNED' | translate: eventCountForTranslate }}\n  </h4>\n</div>\n<div class=\"table-responsive\">\n  <table class=\"table search-results-simple\">\n    <thead>\n    <tr>\n      <th *pioneerAuthorize=\"{permission: 'ViewGroupPayPropertyIndicators'}\"></th>\n      <th>{{'EVENTS.EVENT_NAME' | translate}}</th>\n      <th>{{'EVENTS.REFERENCE_ID' | translate}}</th>\n      <th>{{'EVENTS.START_DATE' | translate}}</th>\n      <th>{{'EVENTS.END_DATE' | translate}}</th>\n      <th>{{'EVENTS.PROPERTY_NAME' | translate}}</th>\n      <th>{{'EVENTS.PROPERTY_ADDRESS' | translate}}</th>\n      <th>{{'EVENTS.PROPERTY_CITY' | translate}}</th>\n      <th>{{'EVENTS.PROPERTY_STATE' | translate}}</th>\n      <th>{{'EVENTS.PROPERTY_ZIP' | translate}}</th>\n    </tr>\n    </thead>\n    <tbody>\n    <tr *ngFor=\"let event of events?.content\">\n      <td *pioneerAuthorize=\"{permission: 'ViewGroupPayPropertyIndicators'}\">\n          <img *ngIf=\"event.propertySubscribed\" src=\"assets/images/GroupPay_Icon_Green_White-01.png\" width=\"17px\" height=\"17px\"\n               tooltip=\"{{'EVENTS.PROPERTY_SUBSCRIBED_TOOLTIP' | translate }}\">\n      </td>\n      <td data-se-id=\"name\">\n        <a data-se-id=\"nameLink\" [routerLink]=\"['/event/' + event.eventId + '/' + event.propertyPartyId]\">\n          <span *ngIf=\"event.autoGenerated\"\n                class=\"tooltip-hint\"\n                [tooltip]=\"'EVENTS.AUTO_GENERATED_TOOLTIP' | translate\"\n                placement=\"right\">\n            {{getEventNameLine1(event.name)}}\n          </span>\n          <span *ngIf=\"event.autoGenerated && getEventNameLine2(event.name)\"\n                class=\"tooltip-hint\"\n                [tooltip]=\"'EVENTS.AUTO_GENERATED_TOOLTIP' | translate\"\n                placement=\"right\">\n            <br>{{getEventNameLine2(event.name)}}\n          </span>\n          <span *ngIf=\"!event.autoGenerated\">\n            {{getEventNameLine1(event.name)}}\n          </span>\n          <span *ngIf=\"!event.autoGenerated && getEventNameLine2(event.name)\">\n            <br>{{getEventNameLine2(event.name)}}\n          </span>\n        </a>\n      </td>\n      <td data-se-id=\"eventReferenceNumber\">\n        {{event.eventReferenceNumber}}\n      </td>\n      <td data-se-id=\"startDate\">{{ event.startDate | localeDateFormat }}</td>\n      <td data-se-id=\"endDate\">{{ event.endDate | localeDateFormat }}</td>\n      <td data-se-id=\"propertyName\">{{event.propertyName}}</td>\n      <td>\n        {{event.propertyLine1}}\n        {{event.propertyLine2}}\n      </td>\n      <td>{{event.propertyCity}}</td>\n      <td>{{event.propertyState}}</td>\n      <td>{{event.propertyPostalCode}}</td>\n    </tr>\n    </tbody>\n  </table>\n</div>\n\n"

/***/ }),

/***/ "lS7k":
/***/ (function(module, exports) {

module.exports = "<div class=\"container-fluid\">\n  <div class=\"row app-header\">\n    <div class=\"header-left\">\n      <div class=\"img-center\">\n        <img src=\"{{imagesUrl}}/grouppay-logo-std.png\" class=\"img-responsive width-250\" title=\"GroupPay\" />\n      </div>\n    </div>\n    <div class=\"header-right help-button d-sm-none d-md-block\"\n      *ngIf=\"showSupportButton && (userIsLoggedIn | async) \">\n      <div class=\"btn-group\" >\n        <button class=\"btn btn-primary dropdown-toggle\" data-toggle=\"dropdown\"\n          data-se-id=\"download-reservation-summary-dropdown-button\">\n          {{'COMMON.HEADER.GROUPPAY_HELP' | translate: username}}\n        </button>\n        <div class=\"dropdown-menu dropdown-menu-right \">\n          <button\n            class=\"dropdown-item\"\n            data-se-id=\"download-reservation-summary-excel-option\"\n            (click)=\"onClickSupport()\">\n            <img class=\"mr-2\" src=\"assets/svg/help-question.svg\" style=\"height: 16px;margin-bottom: 2px;\"/>\n            {{'COMMON.HEADER.CONTACT_SUPPORT' | translate: username}}\n          </button>\n        </div>\n      </div>\n    </div>\n    <div class=\"header-right options \"\n        [ngStyle]=\"showSupportButton ? {\n          'flex-basis': 'auto',\n          'flex-grow': 0\n        }: null\"\n        *ngIf=\"userIsLoggedIn | async\">\n\n      <div class=\"btn-group\">\n        <button class=\"btn btn-link dropdown-toggle\" data-se-id=\"welcome-text\"\n          data-toggle=\"dropdown\">{{'COMMON.HEADER.WELCOME' | translate: username}}\n        </button>\n        <div class=\"dropdown-menu dropdown-menu-right\">\n          <button class=\"dropdown-item\" data-se-id=\"privacy-button\" (click)=\"onClickPrivacy($event)\"\n            type=\"button\">{{'COMMON.PRIVACY_LABEL' | translate}}\n          </button>\n          <button class=\"dropdown-item\" data-se-id=\"redirect-button\" (click)=\"onClickRedirect()\"\n            type=\"button\">{{'COMMON.NAV.BACK_TO_PORTAL' | translate}}\n          </button>\n          <button class=\"dropdown-item\" data-se-id=\"logout-button\" (click)=\"onLogout()\"\n            type=\"button\">{{'LOGOUT.LOGOUT' | translate}}\n          </button>\n        </div>\n      </div>\n\n      <ng-container *pioneerAuthorize=\"{permission: 'ViewIataSelector'}\">\n        <div *ngIf=\"isMultiAgency | async\">\n          <div class=\"btn-group\">\n            <button class=\"btn btn-link dropdown-toggle\" data-se-id=\"default-agency-multi\"\n              data-toggle=\"dropdown\" [disabled]=\"isEventSelected\">\n              {{'COMMON.HEADER.DEFAULT_AGENCY' | translate: {\n                agencyID: defaultAgencyId | async,\n                agencyName: defaultAgencyName | async}\n              }}\n            </button>\n            <div class=\"dropdown-menu dropdown-menu-right\">\n              <button class=\"dropdown-item\" *ngFor=\"let agency of agencies\" data-se-id=\"multi-agency-record\"\n                data-se-id=\"privacy-button\" (click)=\"onClickAgency(agency)\"\n                type=\"button\">{{agency.agencyId}} - {{agency.agencyName}}\n              </button>\n            </div>\n          </div>\n        </div>\n        <div *ngIf=\"isSingleAgency | async\">\n          <p class=\"btn btn-link no-link\" data-se-id=\"default-agency-single\">\n            {{'COMMON.HEADER.DEFAULT_AGENCY' | translate: {\n              agencyID: defaultAgencyId | async,\n              agencyName: defaultAgencyName | async}\n            }}\n          </p>\n        </div>\n      </ng-container>\n    </div>\n  </div>\n</div>\n"

/***/ }),

/***/ "mUMJ":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("rP7Y")(true);
// imports


// module
exports.push([module.i, ".order-one{-ms-flex-order:1!important;order:1!important}.no-payment,.non-bold{font-weight:400}.no-payment{color:#86b0f5}.no-text-decoration{text-decoration:none}.commission-card{margin-bottom:15px}", "", {"version":3,"sources":["/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/invoice-history-vendor-card/invoice-history-vendor-card.component.css"],"names":[],"mappings":"AAAA,WACE,2BAAA,iBAAoB,CACrB,sBAGC,eAAmB,CAGrB,YAEE,aAAc,CACf,oBAGC,oBAAsB,CACvB,iBAGG,kBAAoB,CACvB","file":"invoice-history-vendor-card.component.css","sourcesContent":[".order-one {\n  order: 1 !important;\n}\n\n.non-bold {\n  font-weight:normal;\n}\n\n.no-payment {\n  font-weight:normal;\n  color: #86B0F5\n}\n\n.no-text-decoration {\n  text-decoration: none;\n}\n\n.commission-card{\n    margin-bottom: 15px;\n}"],"sourceRoot":""}]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),

/***/ "mrre":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("rP7Y")(true);
// imports


// module
exports.push([module.i, ".diff{font-weight:700}", "", {"version":3,"sources":["/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/rsvp/rsvp-compare/rsvp-compare.component.css"],"names":[],"mappings":"AAAA,MACE,eAAkB,CACnB","file":"rsvp-compare.component.css","sourcesContent":[".diff {\n  font-weight: bold;\n}\n"],"sourceRoot":""}]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),

/***/ "mwq9":
/***/ (function(module, exports) {

module.exports = "<div class=\"card-header\">{{ 'DASHBOARD.COMPLETED_AND_UNPAID' | translate }}</div>\n<div class=\"card-block row\">\n  <div class=\"col-sm\">\n    <h5 class=\"card-title text-center \">{{ 'DASHBOARD.COMPLETED_AND_UNPAID_LT_15_DAYS' | translate }}</h5>\n    <p class=\"dashboard-display text-success\">\n      <span data-se-id = \"lessThan15DaysTotalBucket\" class=\"count\">{{ completedAndUnpaidLessThan15DaysTotal | async }}</span>\n    </p>\n  </div>\n  <div class=\"col-sm\">\n    <h5 class=\"card-title text-center\">{{ 'DASHBOARD.COMPLETED_AND_UNPAID_15_TO_28_DAYS' | translate }}</h5>\n    <p class=\"dashboard-display text-warning\">\n      <span data-se-id = \"between15And28DaysTotalBucket\" class=\"count\">{{ completedAndUnpaidBetween15And28DaysTotal | async }}</span>\n    </p>\n  </div>\n  <div class=\"col-sm\">\n    <h5 class=\"card-title text-center\">{{ 'DASHBOARD.COMPLETED_AND_UNPAID_GT_28_DAYS' | translate }}</h5>\n    <p class=\"dashboard-display text-danger\">\n      <span data-se-id = \"greaterThan28DaysTotalBucket\" class=\"count\">{{ completedAndUnpaidGreaterThan28DaysTotal | async }}</span>\n    </p>\n  </div>\n</div>\n<div class=\"card-footer\">\n  <a href=\"javascript:void(0)\"\n     (click)=\"completedAndUnpaidPredefinedSearch()\"\n     data-se-id=\"completed-and-unpaid-predefined-search\">\n    {{ 'DASHBOARD.VIEW_COMPLETED_AND_UNPAID' | translate }}\n  </a>\n</div>\n"

/***/ }),

/***/ "n6p7":
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\">\n  <div class=\"container\">\n    <div class=\"row justify-content-between\">\n      <h5 class=\"modal-title\">{{ 'EVENT.PROPERTY.POPUP.SEARCH.TITLE' | translate }}</h5>\n      <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\" (click)=\"cancel()\">\n        <span aria-hidden=\"true\">&times;</span>\n      </button>\n    </div>\n  </div>\n</div>\n\n<div class=\"modal-body\">\n\n  <p class=\"text-muted text-warning\"></p>\n\n  <!-- FORM START -->\n  <form [formGroup]=\"propertySearchForm\" class=\"container\">\n    <div class=\"row\">\n      <div class=\"col form-container\">\n        <pioneer-dropdown-search  [control]=\"propertySearchForm.controls.chain\"\n                                  label=\"EVENT.PROPERTY.POPUP.SEARCH.FILTERS.CHAIN\" \n                                  placeholder=\"EVENT.PROPERTY.POPUP.SEARCH.FILTERS.CHAIN_PLACEHOLDER\"\n                                  [options]=\"chains$ | async\"\n                                  controlName=\"chain\"\n                                  (selected)=\"chainSelected($event)\"\n                                  #chainDropdown>\n        </pioneer-dropdown-search>\n      </div>\n      <div class=\"col form-container\">\n        <pioneer-dropdown-search  [control]=\"propertySearchForm.controls.brand\"\n                                  label=\"EVENT.PROPERTY.POPUP.SEARCH.FILTERS.BRAND\" \n                                  placeholder=\"EVENT.PROPERTY.POPUP.SEARCH.FILTERS.BRAND_PLACEHOLDER\"\n                                  [options]=\"brands$ | async\"\n                                  controlName=\"brand\"\n                                  #brandDropdown>\n        </pioneer-dropdown-search>\n      </div>\n      <div class=\"col-6 form-container\">\n        <pioneer-form-input label=\"EVENT.PROPERTY.POPUP.SEARCH.FILTERS.PROPERTY\">\n          <input type=\"text\" class=\"form-control\" formControlName=\"property\"\n            [attr.placeholder]=\"'EVENT.PROPERTY.POPUP.SEARCH.FILTERS.PROPERTY_PLACEHOLDER' | translate\" />\n        </pioneer-form-input>\n      </div>\n    </div>\n    <div class=\"row\">\n      <div class=\"col form-container\">\n          <pioneer-dropdown-search  [control]=\"propertySearchForm.controls.country\"\n                                    label=\"EVENT.PROPERTY.POPUP.SEARCH.FILTERS.COUNTRY\" \n                                    placeholder=\"EVENT.PROPERTY.POPUP.SEARCH.FILTERS.COUNTRY_PLACEHOLDER\"\n                                    [options]=\"commonDataStore.countries | async\"\n                                    controlName=\"country\"\n                                    (selected)=\"countrySelected($event)\"\n                                    #countryDropdown>\n          </pioneer-dropdown-search>\n      </div>\n      <div class=\"col form-container\" *ngIf=\"(states$ | async)?.length > 0\">\n        <pioneer-dropdown-search  [control]=\"propertySearchForm.controls.state\"\n                                  label=\"EVENT.PROPERTY.POPUP.SEARCH.FILTERS.STATE\" \n                                  placeholder=\"EVENT.PROPERTY.POPUP.SEARCH.FILTERS.STATE_PLACEHOLDER\"\n                                  [options]=\"states$ | async\"\n                                  controlName=\"state\"\n                                  #stateDropdown>\n        </pioneer-dropdown-search>\n      </div>\n      <div class=\"col form-container\">\n        <pioneer-form-input label=\"EVENT.PROPERTY.POPUP.SEARCH.FILTERS.CITY\">\n          <input type=\"text\" class=\"form-control\" formControlName=\"city\"\n            [attr.placeholder]=\"'EVENT.PROPERTY.POPUP.SEARCH.FILTERS.CITY_PLACEHOLDER' | translate\" />\n        </pioneer-form-input>\n      </div>\n      <div class=\"col form-container\">\n        <div class=\"label-placeholder\"></div>\n        <button type=\"button\" class=\"btn btn-primary\" (click)=\"search()\" [disabled]=\"!propertySearchForm.valid\">\n          {{ 'EVENT.PROPERTY.POPUP.SEARCH.FILTERS.SEARCH_BUTTON' | translate }}\n        </button>\n      </div>\n    </div>\n    <div class=\"row\">\n      <div class=\"col form-container form-group\">\n        <div class=\"form-check\">\n          <label class=\"custom-control custom-checkbox\">\n            <input type=\"checkbox\" class=\"custom-control-input\" formControlName=\"onlySubscribers\">\n            <span class=\"custom-control-indicator\"></span>\n            <span class=\"custom-control-description\">{{ 'EVENT.PROPERTY.POPUP.SEARCH.FILTERS.ONLY_SUBSCRIBER' | translate }}</span>\n          </label>\n        </div>\n      </div>\n    </div>\n  </form>\n  <!-- FORM END -->\n\n  <pioneer-property-search-results [searchResults]=\"searchResults | async\"\n                                   [totalItems]=\"totalItems | async\"\n                                   [size]=\"size | async\"\n                                   (selected)=\"selectProperty($event)\"\n                                   (goToAdd)=\"goToAddProperty()\">\n  </pioneer-property-search-results>\n\n</div>\n"

/***/ }),

/***/ "nQN8":
/***/ (function(module, exports) {

module.exports = "<div class=\"modal fade\" bsModal [config]=\"config\" role=\"dialog\" tabindex=\"-1\">\n    <div class=\"modal-dialog modal-xl\">\n      <div class=\"modal-content\">\n        <!-- 'hidden' is used instead of ngIf so that the instance of pioneer-property-search is not destroyed when the condition is false and it preserves the search criteria and results -->\n        <pioneer-vendor-search [hidden]=\"propertyPopupType != PopupType.SEARCH\"\n                               [currentEventVendors]=\"currentEventVendors\"\n                               (canceled)=\"cancelSearch()\"\n                               (selected)=\"selectProperty($event)\"\n                               (goToAdd)=\"goToAdd($event)\"\n                               data-se-id=\"propertySearchComponent\">\n        </pioneer-vendor-search>\n        <pioneer-vendor-add *ngIf=\"propertyPopupType === PopupType.ADD\" [vendorSelected]=\"vendorSelected\" (canceled)=\"cancelAdd()\" (accepted)=\"acceptAdd($event)\"></pioneer-vendor-add>\n        <pioneer-vendor-rate *ngIf=\"propertyPopupType === PopupType.RATE\" [property]=(selectedProperty) (canceled)=\"cancelSearch()\"\n          (accepted)=\"selectVendorRate($event)\"></pioneer-vendor-rate>\n      </div>\n    </div>\n  </div>\n"

/***/ }),

/***/ "o9sb":
/***/ (function(module, exports) {

module.exports = "<div class=\"splash-content\">\n  <div class=\"splash-container\">\n    <div class=\"login-logo error\"><span class=\"sr-only\">Onyx CenterSource</span></div>\n  </div>\n</div>\n"

/***/ }),

/***/ "oAZY":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("rP7Y")(true);
// imports


// module
exports.push([module.i, ".modal-header{border-bottom-style:none;-ms-flex-align:baseline;align-items:baseline}.modal-header .text-muted{font-style:italic;text-align:right;margin-block-end:0}.table tbody tr{cursor:pointer}.table tbody tr:hover{background-color:#eceeef}.text-caption{font-size:85%;color:#62798a;display:block}.text-nowrap{white-space:nowrap!important}", "", {"version":3,"sources":["/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/vendor-search-results/vendor-search-results.component.css"],"names":[],"mappings":"AAAA,cACI,yBAA0B,wBAC1B,oBAAsB,CACzB,0BAGG,kBAAmB,iBACD,kBACE,CACvB,gBAGG,cAAgB,CACnB,sBAGG,wBAAyC,CAC5C,cAGG,cAAe,cACA,aACA,CAClB,aAGG,4BAA8B,CACjC","file":"vendor-search-results.component.css","sourcesContent":[".modal-header {\n    border-bottom-style: none;\n    align-items: baseline;\n}\n\n.modal-header .text-muted {\n    font-style: italic;\n    text-align: right;\n    margin-block-end: 0;\n}\n\n.table tbody tr {\n    cursor: pointer;\n}\n\n.table tbody tr:hover {\n    background-color: rgba(236, 238, 239, 1);\n}\n\n.text-caption {\n    font-size: 85%;\n    color: #62798a;\n    display: block;\n}\n\n.text-nowrap {\n    white-space: nowrap!important;\n}\n"],"sourceRoot":""}]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),

/***/ "oIDS":
/***/ (function(module, exports) {

module.exports = "<div class=\"modal fade\" bsModal [config]=\"config\" role=\"dialog\" tabindex=\"-1\"\n     data-se-id=\"event-collision-modal-multiprompt\" (onHide)=\"onHide()\">\n  <div class=\"modal-dialog modal-xl\" role=\"document\" *ngIf=\"isModalForMultiprompt | async\">\n    <div class=\"modal-content\">\n      <div class=\"modal-header\">\n        <h5 class=\"modal-title\">{{ \"EVENT_COLLISION.MODAL.MULTI.TITLE\" | translate }}</h5>\n        <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\" (click)=\"cancelEventMatching()\">\n          <span aria-hidden=\"true\">&times;</span>\n        </button>\n      </div>\n      <div class=\"modal-body\">\n        <p data-se-id=\"content\" [innerHTML]=\"content | translate\"></p>\n          <div id=\"events-block\">\n            <div id=\"left\">\n              <div style=\"width: 100%\">\n                <div class=\"border bg-light\"><p class=\"lead\" data-se-id=\"heading\"><strong>{{ \"EVENT_COLLISION.MODAL.MULTI.EVENT_DETAILS\" | translate }}</strong></p></div>\n              </div>\n              <div>\n                <dl>\n                  <div class=\"field\">\n                    <dt>{{ \"EVENT_COLLISION.MODAL.MULTI.CLIENT_COMPANY\" | translate }}</dt>\n                    <dd [innerHTML]=\"eventMatch?.clientCompany | translate\"></dd>\n                  </div>\n                </dl>\n                <dl>\n                  <div class=\"field\">\n                    <dt>{{ \"EVENT_COLLISION.MODAL.MULTI.EVENT_NAME\" | translate }}</dt>\n                    <dd [innerHTML]=\"eventMatch?.eventName | translate\"></dd>\n                  </div>\n                </dl>\n                <dl>\n                  <div class=\"field\">\n                    <dt *ngIf=\"isPropertyUser\">{{ \"EVENT_COLLISION.MODAL.MULTI.GROUP_CODE\" | translate }}</dt>\n                    <dt *ngIf=\"!isPropertyUser\">{{ \"EVENT_COLLISION.MODAL.MULTI.MEETING_ID\" | translate }}</dt>\n                    <dd [innerHTML]=\"eventMatch?.groupCode | translate\"></dd>\n                  </div>\n                </dl>\n                <dl>\n                  <div class=\"field\">\n                      <dt>{{ \"EVENT_COLLISION.MODAL.MULTI.CREATED_BY\" | translate }}</dt>\n                      <dd [innerHTML]=\"eventMatch?.createdBy | translate\"></dd>\n                  </div>\n                </dl>\n                <dl>\n                  <div class=\"field\">\n                    <dt>{{ \"EVENT_COLLISION.MODAL.MULTI.START_DATE\" | translate }}</dt>\n                    <dd>{{ eventMatch?.startDate  | localeDateFormat }}</dd>\n                  </div>\n                </dl>\n                <dl>\n                  <div class=\"field\">\n                    <dt>{{ \"EVENT_COLLISION.MODAL.MULTI.END_DATE\" | translate }}</dt>\n                    <dd>{{ eventMatch?.endDate  | localeDateFormat }}</dd>\n                  </div>\n                </dl>\n              </div>\n            </div>\n            <div class=\"divider\"></div>\n            <div id=\"right\">\n              <div style=\"width: 100%\">\n                <div class=\"border bg-light\"><p class=\"lead\" data-se-id=\"heading\"><strong>{{ \"EVENT_COLLISION.MODAL.MULTI.MATCHING_DETAILS\" | translate }}</strong></p></div>\n              </div>\n              <div class=\"form-group form-toggle\" *ngFor=\"let item of match;\" style=\"margin-bottom: 0.5rem;\">\n                <div class=\"form-check center\">\n                  <label class=\"custom-control custom-checkbox\">\n                    <input type=\"checkbox\" [value]=\"item.event_match_id\" class=\"custom-control-input\" data-se-id=\"commRetentionToggleCheckbox\" checked (click)=\"changeSelection($event)\"/>\n                    <span class=\"custom-control-indicator\"></span>\n                    <span class=\"custom-control-description\" style=\"font-weight: 500;\">\n                      <strong *ngIf=\"item.matches[0].name && item.matches[0].name.length > 0\">\n                      {{ item.matches[0].name }}\n                      </strong>\n                      <br *ngIf=\"item.matches[0].name && item.matches[0].name.length > 0\">\n                      {{ item.matches[0].property_name }}\n                      <br *ngIf=\"item.matches[0].property_name && item.matches[0].property_name.length > 0\">\n                      {{ item.matches[0].property_address }}\n                      <br *ngIf=\"item.matches[0].property_address && item.matches[0].property_address.length > 0\">\n                      {{ eventMatch?.startDate  | localeDateFormat }} - {{ eventMatch?.endDate  | localeDateFormat }}\n                    </span> \n                  </label>\n                </div>\n              </div>\n            </div>\n          </div>\n      </div>\n      <div class=\"modal-footer\">\n        <div class=\"button-bar\">\n          <button data-se-id=\"event-collision-modal-multiprompt-cancel\" type=\"button\" class=\"btn\"\n                  (click)=\"doNotMerge()\">{{ \"EVENT_COLLISION.MODAL.MULTI.CANCEL\" | translate }}\n          </button>\n          <button data-se-id=\"event-collision-modal-multiprompt-merge\" type=\"button\" class=\"btn btn-primary btn\"\n                  (click)=\"mergeSelectedEvent()\">{{ \"EVENT_COLLISION.MODAL.MULTI.CONFIRM\" | translate }}\n          </button>\n        </div>\n      </div>      \n    </div>\n  </div>  \n</div>\n"

/***/ }),

/***/ "oJBG":
/***/ (function(module, exports) {

module.exports = "<div class=\"modal fade\" bsModal [config]=\"config\" role=\"dialog\" tabindex=\"-1\" data-se-id=\"rsvpModal\">\n  <div class=\"modal-dialog modal-xl\">\n    <div class=\"modal-content\">\n      <div class=\"modal-header\">\n        <h5 class=\"modal-title\">{{ title }}</h5>\n        <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\" (click)=\"cancel()\" data-se-id=\"closeRsvpModal\">\n          <span aria-hidden=\"true\">&times;</span>\n        </button>\n      </div>\n      <div class=\"modal-body\">\n        <p class=\"text-muted text-warning\"></p>\n        <pioneer-rsvp-form [event]=\"event\" [vendor]=\"vendor\"></pioneer-rsvp-form>\n      </div>\n      <div class=\"modal-footer\">\n        <small class=\"text-placeholder\">{{ placeholder }}</small>\n        <button type=\"button\" class=\"btn btn-link\" data-dismiss=\"modal\" (click)=\"cancel()\" data-se-id=\"cancelRsvpModal\">{{'COMMON.BUTTON.CANCEL' | translate}}</button>\n        <button type=\"button\" class=\"btn btn-primary\" [disabled]=\"disableSave()\" (click)=\"accept()\" data-se-id=\"acceptRsvpModal\">{{ \"COMMON.BUTTON.SAVE\" | translate }}</button>\n      </div>\n    </div>\n  </div>\n</div>"

/***/ }),

/***/ "oP5S":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("rP7Y")(true);
// imports


// module
exports.push([module.i, ".diff{font-weight:700}", "", {"version":3,"sources":["/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/reservations/reservation-detail-table/reservation-detail-table.component.css"],"names":[],"mappings":"AAAA,MACE,eAAkB,CACnB","file":"reservation-detail-table.component.css","sourcesContent":[".diff {\n  font-weight: bold;\n}\n"],"sourceRoot":""}]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),

/***/ "oYWb":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("rP7Y")(true);
// imports


// module
exports.push([module.i, ".complex-link{text-decoration:none!important}.complex-link:hover .underline-hover{text-decoration:underline!important}", "", {"version":3,"sources":["/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/reservations/reservation-summary-table/reservation-summary-table.css"],"names":[],"mappings":"AAAA,cACE,8BAAiC,CAClC,qCAGC,mCAAsC,CACvC","file":"reservation-summary-table.css","sourcesContent":[".complex-link {\n  text-decoration: none !important;\n}\n\n.complex-link:hover .underline-hover {\n  text-decoration: underline !important;\n}\n"],"sourceRoot":""}]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),

/***/ "ooLA":
/***/ (function(module, exports) {

module.exports = "<pioneer-confirmation-modal\n  data-se-id=\"attachmentConfirmationModal\"\n  content=\"EVENT.CONFIRM_REMOVE_DOCUMENT\"\n  cancel=\"COMMON.BUTTON.CANCEL\"\n  confirm=\"EVENT.REMOVE_DOCUMENT\"\n  [title]=\"'EVENT.CONFIRM_REMOVE_DOCUMENT_TITLE'\"\n  (closed)=\"confirmHandler($event)\">\n</pioneer-confirmation-modal>\n\n<div class=\"doc-library\"\n     id=\"card-attachment\">\n  <form>\n    <div class=\"form-group\">\n      <p class=\"font-weight-bold\" style=\"font-size: 16px;\">\n        {{ 'Attach your Room Pick-Up report for this event, here.' | translate }}\n      </p>\n\n      <div class=\"d-flex align-items-center\">\n        <button id=\"file_upload_report\" (click)=\"file.click()\" [disabled]=\"containFile\"\n                style=\"width: 200px;\" class=\"btn btn-link btn-lg mr-3 file-btn\">\n          {{ 'Browser' | translate }}\n        </button>\n\n        <input #file\n               data-se-id=\"file_upload\"\n               hidden\n               type=\"file\"\n               accept=\"{{fileTypes}}\"\n               placeholder=\"{{'EVENT.UPLOAD_DOCUMENT' | translate}}\"\n               (change)=\"uploadFile($event)\"/>\n\n        <div style=\"font-style: italic; font-size: 18px;\">\n          {{ 'PDF, xlsx, xls, csv' | translate }}\n        </div>\n      </div>\n    </div>\n\n  </form>\n  <ol class=\"file-list\" data-se-id=\"uploaded_attachments\">\n    <li class=\"file-item file-uploading\" [hidden]=\"!isUploadInProgress\">\n      <div class=\"progress\">\n        <div class=\"progress-bar progress-bar-striped progress-bar-animated\"\n             role=\"progressbar\"\n             aria-valuenow=\"100\"\n             aria-valuemin=\"0\"\n             aria-valuemax=\"100\"\n             style=\"width: 100%\">{{'EVENT.UPLOADING' | translate}}\n        </div>\n      </div>\n    </li>\n    <li *ngFor=\"let attachment of attachments\" class=\"file-item\"\n        [class.item-new]=\"isNewAttachment\"\n        data-se-id=\"attachment\"\n        [class.discarded]=\"removedAttachments.has(attachment.uniqueId)\">\n      <div class=\"item-link document-item\"\n           [attr.filetype]=\"getFileExtension(attachment.name)\">\n        <i class=\"icon-file\" [class.can-remove]=\"canDeleteFile(attachment)\"\n           data-se-id=\"attachmentIcon\"\n           (click)=\"canDeleteFile(attachment) ? confirmBeforeDelete(attachment) : openFile(attachment)\"></i>\n        <span class=\"item-file-name\"\n              (click)=\"openFile(attachment)\"\n              data-se-id=\"name\">{{attachment.name}}</span>\n      </div>\n    </li>\n  </ol>\n</div>\n"

/***/ }),

/***/ "pGxJ":
/***/ (function(module, exports) {

module.exports = "<pioneer-confirmation-modal\n  data-se-id=\"event-delete-rpc-confirmation-modal\"\n  [title]=\"confirmationModalConfig.title\"\n  [content]=\"confirmationModalConfig.content\"\n  cancel=\"COMMON.BUTTON.CANCEL\"\n  confirm=\"COMMON.BUTTON.DELETE\"\n  (closed)=\"confirmBeforeDeletingRatePlanCodeHandler($event)\">\n</pioneer-confirmation-modal>\n\n<div [formGroup]=\"basicEventDataForm\">\n  <div class=\"card\" id=\"card-basic-event-data\">\n    <div class=\"card-header\">\n      {{ 'EVENT.EVENT_INFO_TITLE' | translate }}\n      <span *ngIf=\"isAutoGenerated()\"\n            class=\"generated-badge\"\n            data-se-id=\"auto-generated-label\">\n        {{ 'EVENT.AUTO_GENERATED' | translate }}\n      </span>\n      &nbsp;\n      <span *ngIf=\"isMultiVendorPayments\"\n            class=\"badge badge-pill non-bold\"\n            [ngClass]=\"getStatusClasses(eventMultiVendorStatus)\"\n            data-se-id=\"payment-status\">\n            {{ eventMultiVendorStatus | paymentStatus }}\n      </span>\n    </div>\n    <div class=\"card-block\">\n      <div class=\"row\">\n        <div class=\"form-container info-name form-required\" >\n          <div class=\"form-group form-required\">\n            <pioneer-form-input label=\"EVENT.NAME\" [isReadOnly]=\"isReadOnly\">\n              <input #eventNameInputEl\n                     type=\"text\"\n                     class=\"form-control\"\n                     formControlName=\"name\"\n                     maxlength=\"100\"\n                     data-se-id=\"eventName\"\n                     [readonly]=\"isReadOnly\"\n                     placeholder=\"{{'EVENT.NAME_PLACEHOLDER' | translate }}\"/>\n            </pioneer-form-input>\n          </div>\n        </div>\n        <div class=\"form-container info-group\">\n          <div class=\"form-group form-required\">\n            <pioneer-form-input label=\"EVENT.GROUP_CODE\" [isReadOnly]=\"isReadOnly\" *ngIf=\"!isAgencyUser()\">\n              <input type=\"text\" pioneerUppercase\n                     class=\"form-control\"\n                     formControlName=\"eventReferenceNumber\"\n                     maxlength=\"20\"\n                     [readonly]=\"isReadOnly\"\n                     data-se-id=\"groupCodeInput\"\n                     placeholder=\"{{!isReadOnly ? ('EVENT.GROUP_CODE_PLACEHOLDER' | translate) : '' }}\"\n                     [attr.disabled]=\"!isEventReferenceNumberEditable || (canEditGroupCode$ | async) === false ? 'disabled' : null\"/>\n            </pioneer-form-input>\n            <pioneer-form-input label=\"EVENT.MEETING_ID\" [isReadOnly]=\"isReadOnly\" *ngIf=\"isAgencyUser()\">\n              <input type=\"text\" pioneerUppercase\n                     class=\"form-control\"\n                     formControlName=\"eventReferenceNumber\"\n                     maxlength=\"20\"\n                     [readonly]=\"isReadOnly\"\n                     data-se-id=\"groupCodeInput\"\n                     placeholder=\"{{!isReadOnly ? ('EVENT.MEETING_ID_PLACEHOLDER' | translate) : '' }}\"\n                     [attr.disabled]=\"!isEventReferenceNumberEditable ? 'disabled' : null\"/>\n            </pioneer-form-input>\n          </div>\n        </div>\n      </div>\n      <div class=\"row\" *ngIf=\"!isNewEvent\">\n        <div class=\"form-container info-group\">\n          <div class=\"form-group\">\n            <pioneer-form-input label=\"EVENT.MEETING_ID\" [isReadOnly]=\"true\" *ngIf=\"!isAgencyUser()\">\n              <input type=\"text\" pioneerUppercase\n                     class=\"form-control\"\n                     formControlName=\"meetingId\"\n                     maxlength=\"20\"\n                     [readonly]=\"true\"\n                     data-se-id=\"eventName\"/>\n            </pioneer-form-input>\n          </div>\n        </div>\n        <div class=\"form-container info-group\">\n          <div class=\"form-group\">\n            <pioneer-form-input label=\"EVENT.GROUP_ID\" [isReadOnly]=\"true\">\n              <input type=\"text\" pioneerUppercase\n                     class=\"form-control\"\n                     formControlName=\"eventId\"\n                     maxlength=\"20\"\n                     [readonly]=\"true\"\n                     data-se-id=\"eventId\">\n            </pioneer-form-input>\n          </div>\n        </div>\n      </div>\n      <div class=\"row\">\n        <div class=\"col form-container\">\n          <div class=\"form-container info-start\">\n            <div class=\"form-group form-required\">\n              <pioneer-form-input label=\"EVENT.START_DATE\">\n                <input type=\"date\"\n                       class=\"form-control-input-date\"\n                       formControlName=\"startDate\"\n                       (blur)=\"datesBlur(startDateInput)\"\n                       (change)=\"datesChange()\"\n                       [readonly]=\"isReadOnly\"\n                       [attr.disabled]=\"isReadOnly || isMultiVendorUserAndEventCreatedByProperty || (canEditEventDates$ | async) === false ? 'disabled' : null\"\n                       placeholder=\"{{'EVENT.DATE_PLACEHOLDER' | translate}}\"\n                       required/>\n              </pioneer-form-input>\n            </div>\n          </div>\n        </div>\n        <div class=\"col form-container\">\n          <div class=\"form-container info-end\">\n            <div class=\"form-group form-required\">\n              <pioneer-form-input label=\"EVENT.END_DATE\">\n                <input type=\"date\"\n                       class=\"form-control-input-date\"\n                       formControlName=\"endDate\"\n                       (blur)=\"datesBlur(endDateInput)\"\n                       (change)=\"datesChange()\"\n                       [readonly]=\"isReadOnly\"\n                       [attr.disabled]=\"isReadOnly || isMultiVendorUserAndEventCreatedByProperty || (canEditEventDates$ | async) === false  ? 'disabled' : null\"\n                       placeholder=\"{{'EVENT.DATE_PLACEHOLDER' | translate}}\"\n                       required/>\n                <div class=\"validation-messages\">\n                  <pioneer-validation-message *ngIf=\"!isReadOnly\"\n                                              error=\"greater\"\n                                              message=\"EVENT.VALIDATION_START_END_DATE\">\n                  </pioneer-validation-message>\n                </div>\n              </pioneer-form-input>\n            </div>\n          </div>\n        </div>\n        <div class=\"col form-container\">\n          <div class=\"form-container info-end\">\n            <div class=\"form-group form-required\">\n              <pioneer-form-input label=\"EVENT.EVENT_CURRENCY\" [isReadOnly]=\"isReadOnly\">\n              <span tooltip=\"{{'EVENT.CURRENCY_TOOLTIP' | translate }}\"\n                    placement=\"right\"\n                    triggers=\"mouseenter:mouseleave\"\n                    container=\"body\">\n                <i class=\"fal fa-question-circle text-muted\"></i>\n              </span>\n                <input type=\"text\" class=\"form-control\"\n                       formControlName=\"currencyName\" *ngIf=\"isReadOnly else selectedCurrency\"\n                       [readonly]=\"isReadOnly\"\n                       [attr.disabled]=\"(canEditEventCurrency$ | async) === false ? 'disabled' : null\"\n                       [value]=\"(selectedCurrency$ | async)?.key\" />\n                <ng-template #selectedCurrency>\n                  <select formControlName=\"currency\" class=\"form-control form-control-sm\" data-se-id=\"eventCurrency\" [attr.disabled]=\"(canEditEventCurrency$ | async) === false ? 'disabled' : null\">\n                    <option [ngValue]=\"null\">{{ 'EVENT.EVENT_CURRENCY_PLACEHOLDER' | translate }}</option>\n                    <option *ngFor=\"let option of (commonDataStore.currenciesDrop | async)\" [ngValue]=\"option.key\">{{ option.key + ' - ' + option.value }}</option>\n                  </select>\n                </ng-template>\n              </pioneer-form-input>\n            </div>\n          </div>\n        </div>\n        <div class=\"col form-container\">\n\n        </div>\n      </div>\n      <div class=\"row\" *pioneerAuthorize=\"{permissions: ['AgencyEventLevelIndicators','ViewAllEvent']}\">\n        <div class=\"col form-container\">\n          <div class=\"form-container\">\n            <div class=\"form-group form-required\">\n              <pioneer-form-input label=\"EVENT.EVENT_COUNTRY\">\n                <input *ngIf=\"isReadOnly; else selectCountry\" type=\"text\" class=\"form-control\" formControlName=\"countryName\" [readonly]=\"true\" [value]=\"(selectedCountry$ | async)?.value\" />\n                <ng-template #selectCountry>\n                <select formControlName=\"countryCode\" (change)=\"onCountryCodeChanged()\" class=\"form-control form-control-sm\"\n                        [attr.disabled]=\"isReadOnly ? 'disabled' : null\">\n                  <option [ngValue]=\"null\">{{ 'EVENT.EVENT_COUNTRY_PLACEHOLDER' | translate }}</option>\n                  <option *ngFor=\"let option of (commonDataStore.countries | async)\" [ngValue]=\"option.key\" >{{ option.value }}</option>\n                </select>\n                </ng-template>\n              </pioneer-form-input>\n            </div>\n          </div>\n        </div>\n        <div class=\"col form-container\">\n          <div class=\"form-container\">\n            <div class=\"form-group\" [ngClass]=\"{ 'form-required': agencyOrSupportUser && isStateRequired(basicEventDataForm, 'countryCode') }\">\n              <pioneer-form-input label=\"EVENT.EVENT_STATE\">\n                <input *ngIf=\"isReadOnly && showState; else selectState\" type=\"text\" class=\"form-control\" formControlName=\"stateName\" [readonly]=\"true\" [value]=\"(selectedState$ | async)?.value\" />\n                <ng-template #selectState>\n                <select formControlName=\"state\" class=\"form-control form-control-sm\" [attr.disabled]=\"isReadOnly ? 'disabled' : null\">\n                  <option [ngValue]=\"null\" >{{ 'EVENT.EVENT_STATE_PLACEHOLDER' | translate }}</option>\n                  <option *ngFor=\"let option of (states$ | async)\" [ngValue]=\"option.key\" >{{ option.value }}</option>\n                </select>\n                <div class=\"validation-messages\">\n                  <pioneer-validation-message error=\"country_state_cross_error\" message=\"MESSAGES.VALIDATION.REQUIRED\">\n                  </pioneer-validation-message>\n                </div>\n              </ng-template>\n              </pioneer-form-input>\n            </div>\n          </div>\n        </div>\n        <div class=\"col form-container\">\n          <div class=\"form-group form-required\">\n            <pioneer-form-input label=\"EVENT.EVENT_CITY\">\n              <input type=\"text\" class=\"form-control\" formControlName=\"city\"\n                maxlength=\"50\"\n                [attr.placeholder]=\"isReadOnly ? '' : 'EVENT.EVENT_CITY_PLACEHOLDER' | translate\"\n                [readonly]=\"isReadOnly\"\n                [attr.disabled]=\"isReadOnly ? 'disabled' : null\"\n                />\n            </pioneer-form-input>\n          </div>\n        </div>\n        <div class=\"col form-container\">\n\n        </div>\n      </div>\n      <div class=\"row\" *ngIf=\"canSeeShoulderDatesSection()\">\n        <div class=\"col form-container\">\n          <div class=\"form-group form-required\">\n            <pioneer-form-input label=\"EVENT.COMMISSION_RATE\" [isReadOnly]=\"isReadOnly\">\n              <input type=\"number\"\n                     class=\"form-control\"\n                     formControlName=\"commissionRoomPercentage\"\n                     min=\"0\"\n                     max=\"100\"\n                     [readonly]=\"isReadOnly\"\n                     data-se-id=\"commissionRateInput\"\n                     placeholder=\"{{'EVENT.FINANCIAL_ROOM_COMMISSION_PLACEHOLDER' | translate}}\"/>\n            </pioneer-form-input>\n          </div>\n        </div>\n        <div class=\"col form-container\" *pioneerAuthorize=\"{permission: 'AgencyEventLevelIndicators'}\">\n          <ng-container *pioneerAuthorize=\"{permission: 'AgencyEventLevelIndicators'}\">\n            <label>&nbsp;</label>\n            <div class=\"form-group form-toggle\">\n              <div class=\"form-check center\">\n                <label class=\"custom-control custom-checkbox\">\n                  <input type=\"checkbox\" class=\"custom-control-input\"\n                    [checked]=\"onyxEvent.eventProperty.commRetention\"\n                    formControlName=\"commRetention\"\n                    data-se-id=\"commRetentionToggleCheckbox\"/>\n                  <span class=\"custom-control-indicator\"></span>\n                  <span class=\"custom-control-description\">{{ 'EVENT.COMMISSION.COMM_RETENTION' | translate }}</span>\n                </label>\n              </div>\n            </div>\n          </ng-container>\n        </div>\n        <div class=\"col form-container\" *pioneerAuthorize=\"{permissions: ['HotelEventLevelIndicators','ViewAllEvent']}\">\n          <div class=\"form-group form-required\">\n            <ng-container *pioneerAuthorize=\"{permissions: ['HotelEventLevelIndicators','ViewAllEvent']}\">\n              <label for=\"\" >{{'EVENT.EVENT_INCLUDE_SHOULDER_DATES' | translate}}</label>\n              <div class=\"form-group form-toggle\">\n                <div class=\"form-check center\">\n                  <label class=\"custom-control custom-radio remove-required\">\n                    <input type=\"radio\" class=\"custom-control-input\"\n                      [checked]=\"onyxEvent.shoulderDatesCommission === true\"\n                      name=\"shoulderDatesCommission\"\n                      [value]=\"true\"\n                      formControlName=\"shoulderDatesCommission\"\n                      data-se-id=\"shoulderDate\"\n                      [attr.disabled]=\"isReadOnly || (canEditShoulderDates$ | async) === false ? 'disabled' : null\"/>\n                    <span class=\"custom-control-indicator\"></span>\n                    <span class=\"custom-control-description\">{{ 'EVENT.EVENT_INCLUDE_SHOULDER_DATES_YES' | translate }}</span>\n                  </label>\n                  <label class=\"custom-control custom-radio remove-required\">\n                    <input type=\"radio\" class=\"custom-control-input\"\n                      [checked]=\"onyxEvent.shoulderDatesCommission === false\"\n                      name=\"shoulderDatesCommission\"\n                      [value]=\"false\"\n                      formControlName=\"shoulderDatesCommission\"\n                      data-se-id=\"shoulderDate\"\n                      [attr.disabled]=\"isReadOnly || (canEditShoulderDates$ | async) === false ? 'disabled' : null\"/>\n                    <span class=\"custom-control-indicator\"></span>\n                    <span class=\"custom-control-description\">{{ 'EVENT.EVENT_INCLUDE_SHOULDER_DATES_NO' | translate }}</span>\n                  </label>\n                </div>\n              </div>\n            </ng-container>\n          </div>\n        </div>\n        <div class=\"col\"> </div>\n      </div>\n      <ng-container *pioneerAuthorize=\"{permission: 'ManageRatePlanCode'}\">\n        <div class=\"row\" *ngIf=\"!isReadOnly\">\n          <div class=\"col-3 form-container\">\n            <div class=\"form-group\">\n              <pioneer-form-input label=\"EVENT.RATE_PLAN_CODE\" class=\"large-error-message\">\n                <div class=\"input-group\">\n                  <input type=\"text\" pioneerUppercase\n                    class=\"form-control\"\n                    formControlName=\"ratePlanCode\"\n                    (blur)=\"ratePlanCodeBlur()\"\n                    data-se-id=\"ratePlanCode\"\n                    placeholder=\"{{ 'EVENT.RATE_PLAN_CODE_PLACEHOLDER' | translate }}\" />\n                  <span class=\"input-group-btn\">\n                    <button class=\"btn btn-group\" [ngClass]=\"!ratePlanCodeInput.value || ratePlanCodeInput.invalid ? 'btn-inactive' : 'btn-secondary'\"\n                      type=\"button\" (click)=\"addRatePlanCode()\">\n                      <i class=\"far fa-plus\" aria-hidden=\"true\"></i>\n                    </button>\n                  </span>\n                </div>\n              </pioneer-form-input>\n            </div>\n          </div>\n        </div>\n        <div class=\"row\" *ngIf=\"ratePlanCodesApplied.length > 0 || onyxEvent?.eventId !== null\">\n          <div class=\"form-container info-rates\">\n            <div class=\"form-group\">\n              <label for=\"rates\">{{'EVENT.RATE_PLAN_CODES' | translate}}</label>\n            </div>\n          </div>\n          <div class=\"form-container info-rates-list\">\n            <div class=\"form-group\" formArrayName=\"ratePlanCodes\">\n              <pioneer-rate-plan-code [ratePlanCodes]=\"displayedRatePlanCodes\" [showCloseIcon]=\"!isReadOnly\"\n                (delete)=\"confirmBeforeDeletingRatePlanCode($event)\"></pioneer-rate-plan-code>\n            </div>\n          </div>\n        </div>\n        <div class=\"row\" *ngIf=\"datesHaveDuplicateRatePlanCodeError()\">\n              <p class=\"form-control-feedback\">{{'MESSAGES.VALIDATION.DUPLICATE_RATE_PLAN_CODES_ERROR' | translate : { duplicateRatePlanCodes: formattedDuplicateRatePlanCodes } }}</p>\n        </div>\n      </ng-container>\n\n      <pioneer-custom-fields-form [parentForm]=\"basicEventDataForm\"\n                                  [event]=\"onyxEvent\"\n                                  [isNewEvent]=\"isNewEvent\">\n      </pioneer-custom-fields-form>\n    </div>\n  </div>\n</div>\n"

/***/ }),

/***/ "pzHy":
/***/ (function(module, exports) {

module.exports = "<div class=\"card\" [ngClass]=\"{ 'collapsed-card': showAdvancedPropertySearch && !isPropertySelected }\" [formGroup]=\"contactLookupForm\" id=\"card-{{partyType | lowercase}}\" data-se-id=\"propertyLookupForm\">\n  <div class=\"card-header\">\n    <div class=\"container\">\n      <div class=\"row justify-content-between\">\n        {{ contactTypeTitle }} {{ 'EVENT.CONTACT_TITLE' | translate }}\n        <span class=\"text-danger\" *ngIf=\"isReadyOnlyProperty()\">*</span>\n        <button *ngIf=\"!isReadOnly && (isPropertyEditable$ | async) === true && showAdvancedPropertySearch && !onyxEvent.eventProperty?.subscriber\" type=\"button\" class=\"btn btn-primary\"\n          (click)=\"openAdvancedPropertySearchPopup()\">\n          {{ isPropertySelected ? ('EVENT.CHANGE_PROPERTY' | translate) : ('EVENT.SELECT_PROPERTY' | translate) }}\n        </button>\n      </div>\n    </div>\n  </div>\n  <div class=\"card-block\">\n\n    <div *ngIf=\"isPropertyMissing()\" class=\"alert alert-danger\">\n      {{ 'EVENT.PROPERTY_REQUIRED' | translate }}\n    </div>\n\n    <div *ngIf=\"!showAdvancedPropertySearch\" class=\"col-12\">\n      <pioneer-inline-search-component *ngIf=\"isPropertyInlineSearchEnabled() && (isPropertyEditable$ | async) === true\"\n                                       (results)=\"updateResults($event)\"\n                                       [lookupStore]=\"propertyStore\"\n                                       [placeholderText]=\"'EVENT.PROPERTY_SEARCH'\"\n                                       (blur)=\"inlineSearchTouched()\">\n        <ul class=\"dropdown-menu\">\n          <!--\n            Using mousedown instead of click\n            so that onSelectedProperty runs before\n            inlineSearchTouched is triggered by blur.\n            -->\n          <li class=\"dropdown-item\"\n              *ngFor=\"let searchProperty of summaryResults\"\n              (mousedown)=\"onSelectedProperty(searchProperty)\"\n              data-se-id=\"property-lookup-result\">\n            <p class=\"prop-name\">{{searchProperty.name}}</p>\n            <div *ngIf=\"searchProperty.address\" class=\"prop-info\">\n              <p class=\"addr\" data-se-id=\"property-lookup-address-line1\">{{searchProperty.address.line1}}</p>\n              <p class=\"addr\">\n                {{searchProperty.address.city}}, {{searchProperty.address.state}} {{searchProperty.address.postalCode}}\n              </p>\n              <p class=\"pid\">{{searchProperty.propertyId}}</p>\n            </div>\n          </li>\n\n          <li class=\"dropdown-item disabled\"\n              *ngIf=\"summaryResults && summaryResults.length == 0\">\n            {{ 'COMMON.NO_RESULTS_FOUND' | translate }}\n          </li>\n        </ul>\n      </pioneer-inline-search-component>\n    </div>\n\n    <pioneer-child-contact-form *ngIf=\"isPropertySelected\"\n                                [contactForm]=\"contactLookupForm\"\n                                [partyType]=\"partyType\"\n                                [event]=\"onyxEvent\"\n                                [contactReferenceNumberTitle]=\"contactReferenceNumberTitle\"\n                                [isReadOnly]=\"isReadOnly || !isContactEditable\"\n                                [showLongLabels]=\"showLongLabels\"\n                                [showSubscriberBadge]=\"showSubscriberBadge\"\n                                [inputEmail]=\"inputEmail\"\n                                (outputEmail)=\"setupPropertyEmail($event)\">\n    </pioneer-child-contact-form>\n  </div>\n</div>\n<pioneer-property-popup *pioneerAuthorize=\"{permission: 'ViewExtendedPropertySearch'}\"\n                             (closed)=\"closedPropertyPopup($event)\">\n</pioneer-property-popup>\n"

/***/ }),

/***/ "qc9e":
/***/ (function(module, exports) {

module.exports = "<pioneer-confirmation-modal\n  data-se-id=\"deleteRsvpConfirmationModal\"\n  content=\"EVENT.RSVPS.CONFIRM_DELETE_RSVP\"\n  cancel=\"COMMON.BUTTON.CANCEL\"\n  confirm=\"EVENT.RSVPS.DELETE_RSVP\"\n  (closed)=\"confirmHandler($event)\">\n</pioneer-confirmation-modal>\n\n<div *ngIf=\"!(isRsvpListEmpty | async)\" class=\"card\" id=\"card-rsvp-list\" data-se-id=\"rsvpList\">\n  <div id=\"card-reservation-list\">\n    <pioneer-header-summary [event]=\"onyxEvent\"\n                            [title]=\"'EVENT.RSVPS.RSVP_LIST_HEADER' | translate\"\n                            [type]=\"headerRecordType\"\n                            [vendor]=\"vendor\">\n    </pioneer-header-summary>\n  </div>\n  <div class=\"table-responsive table-dropdown\">\n    <table class=\"table reservation-list rsvp-list\">\n      <thead>\n      <tr>\n        <th class=\"control-remove-row\" *pioneerAuthorize=\"{permission: 'DeleteRsvp'}\"></th>\n        <th>{{ \"EVENT.RSVPS.NAME\" | translate }}</th>\n        <th>{{ 'EVENT.RSVPS.CONFIRMATION_NUMBER' | translate }}</th>\n        <th>{{ 'EVENT.RSVPS.CHECKIN_DATE' | translate }}</th>\n        <th>{{ 'EVENT.RSVPS.CHECKOUT_DATE' | translate }}</th>\n        <th>{{ 'EVENT.RSVPS.NIGHTS' | translate }}</th>\n        <th>{{ 'EVENT.RSVPS.ROOM_TYPE' | translate }}</th>\n        <th class=\"currency\">\n          <span>{{ 'EVENT.RSVPS.RATE' | translate }}</span>\n          <br />\n          <small>({{ onyxEvent.currency | uppercase }})</small>\n        </th>\n        <th class=\"currency\">\n          <span>{{ 'EVENT.RSVPS.REVENUE' | translate }}</span>\n          <br />\n          <small>({{ onyxEvent.currency | uppercase }})</small>\n        </th>\n        <th class=\"currency\">\n          <span>{{ 'EVENT.RSVPS.COMMISSION' | translate }}</span>\n          <br />\n          <small>({{ onyxEvent.currency | uppercase }})</small>\n        </th>\n      </tr>\n      </thead>\n      <tbody>\n      <tr *ngFor=\"let compare of rsvpPage?.content; last as isLast\" data-se-id=\"rsvpListEntry\">\n        <td class=\"col-more\" *pioneerAuthorize=\"{permission: 'DeleteRsvp'}\" data-se-id=\"openDropdownMenu\">\n          <!-- Bootstrap (jQuery) -->\n          <div [ngClass]=\"isLast ? 'dropup' : 'dropdown'\" *ngIf=\"displayDropdown && (canChangeRSVPs$ | async) === true\">\n            <button class=\"btn btn-more\" data-toggle=\"dropdown\">\n              <i class=\"far fa-ellipsis-h\"></i>\n            </button>\n            <ul class=\"dropdown-menu\">\n              <li role=\"menuitem\" *pioneerAuthorize=\"{permission: 'EditRsvp'}\">\n                <a class=\"dropdown-item\" href=\"javascript:void(0)\" (click)=\"openRsvpModal($event, compare.rsvp, vendor)\" data-se-id=\"openRsvpModal\">\n                  <i class=\"fal fa-pencil fa-fw\"></i>\n                  {{ 'EVENT.RSVPS.EDIT_RSVP_MENU_ITEM' | translate }}\n                </a>\n              </li>\n              <li class=\"divider dropdown-divider\"></li>\n              <li role=\"menuitem\">\n                <a class=\"dropdown-item\" href=\"javascript:void(0)\" (click)=\"confirmBeforeDelete($event, compare.rsvp)\" data-se-id=\"rsvpDelete\">\n                  <i class=\"fal fa-trash-alt fa-fw\"></i>\n                  {{ 'EVENT.RSVPS.DELETE_RSVP_MENU_ITEM' | translate }}\n                </a>\n              </li>\n            </ul>\n          </div>\n        </td>\n        <td class=\"field-wrap res-guest-name\"\n            [routerLink]=\"['/event/' + onyxEvent.eventId + '/rsvp/detail']\"\n            [queryParams]=\"{ rsvp: compare.rsvp.eventRsvpId }\"\n            data-se-id=\"rsvpGuestName\">\n          <span *ngIf=\"compare.rsvp.firstName; else onlyLastName\">\n              {{ compare.rsvp.lastName }}, {{ compare.rsvp.firstName }}\n          </span>\n          <ng-template #onlyLastName>\n            <span>\n              {{ compare.rsvp.lastName }}\n            </span>\n          </ng-template>\n        </td>\n        <td data-se-id=\"rsvpConfirmation\">{{ compare.rsvp.confirmation }}</td>\n        <td data-se-id=\"rsvpCheckin\">{{ compare.rsvp.checkInDate | dateFormat }}</td>\n        <td data-se-id=\"rsvpCheckout\">{{ compare.rsvp.checkOutDate | dateFormat }}</td>\n        <td data-se-id=\"rsvpNights\">{{ compare.rsvp.nights }}</td>\n        <td data-se-id=\"rsvpRoomType\">{{ compare.rsvp.roomType }}</td>\n        <td class=\"currency\" data-se-id=\"rsvpRoomRate\">{{ compare.rsvp.roomRate | number:'1.2-2'  }}\n        </td>\n        <td class=\"currency\" data-se-id=\"rsvpRevenue\">{{ compare.rsvp.revenue | number:'1.2-2'  }}</td>\n        <td class=\"currency\" data-se-id=\"rsvpCommission\">{{ compare.rsvp.commission | number:'1.2-2'\n          }}\n        </td>\n      </tr>\n      </tbody>\n    </table>\n  </div>\n\n  <div class=\"card-footer\" *ngIf=\"rsvpPage?.totalElements > 0\">\n    <pioneer-pagination\n      [resultsPage]=\"rsvpPage\"\n      (updatePage)=\"onRefreshRsvpList($event.page)\"\n      [pagesizeType]=\"pagesizeType\">\n    </pioneer-pagination>\n  </div>\n\n</div>\n\n<div *ngIf=\"isRsvpListEmpty | async\" class=\"result-empty\" data-se-id=\"rsvpsNotFound\">\n  <h3>{{ \"EVENT.RSVPS.NO_RSVPS_FOUND\" | translate }}</h3>\n  <figure class=\"figure\">\n    <i class=\"glyph-page figure-img\"></i>\n  </figure>\n</div>\n\n<pioneer-rsvp-modal *pioneerAuthorize=\"{permission: 'EditRsvp'}\"\n  [event]=\"onyxEvent\"\n  data-se-id=\"editRsvpModal\">\n</pioneer-rsvp-modal>\n"

/***/ }),

/***/ "qeIs":
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-body\">\n  <p class=\"lead\" *ngIf=\"title\" [innerHTML]=\"title | translate\"></p>\n  <p *ngIf=\"content\" [innerHTML]=\"content | translate\"></p>\n  <div class=\"button-bar\">\n    <button type=\"button\" class=\"btn btn-link btn-sm\" (click)=\"cancelClick()\">\n      {{ cancel | translate }}\n    </button>\n    <button type=\"button\" class=\"btn btn-primary btn-sm\" (click)=\"acceptClick()\">\n      {{ confirm | translate }}\n    </button>\n  </div>\n</div>\n"

/***/ }),

/***/ "qwMY":
/***/ (function(module, exports) {

module.exports = "<script src=\"../event-list.component.ts\"></script>\n<div class=\"card-block\">\n  <h4 class=\"card-title\">\n    {{ 'EVENTS.RESULTS_RETURNED' | translate: eventCountForTranslate }}\n  </h4>\n</div>\n<div class=\"table-responsive\">\n  <table class=\"table search-results-simple\">\n    <thead>\n    <tr>\n      <th *pioneerAuthorize=\"{permission: 'ViewGroupPayPropertyIndicators'}\"></th>\n      <th>{{'EVENTS.EVENT_NAME' | translate}}</th>\n      <th>{{'EVENTS.REFERENCE_ID' | translate}}</th>\n      <th>{{'EVENTS.END_DATE' | translate}}</th>\n      <th>{{'EVENTS.PREPAYMENT_AMOUNT' | translate}}</th>\n      <th>{{'EVENTS.FINAL_PAY_INITIATED_DATE' | translate}}</th>\n      <th>{{'EVENTS.FINAL_PAYMENT_STATUS' | translate}}</th>\n      <th>{{'EVENTS.TOTAL_PAID_AMOUNT' | translate}}</th>\n      <th>{{'EVENTS.ESTIMATED_DUE_AMOUNT' | translate}}</th>\n      <th *pioneerAuthorize=\"{permission: 'AgencyEventLevelIndicators'}\">{{'EVENTS.MASTER_BILL' | translate}}</th>\n    </tr>\n    </thead>\n    <tbody>\n    <tr *ngFor=\"let event of events?.content\">\n      <td *pioneerAuthorize=\"{permission: 'ViewGroupPayPropertyIndicators'}\">\n        <img *ngIf=\"event.propertySubscribed\" src=\"assets/images/GroupPay_Icon_Green_White-01.png\" width=\"17px\" height=\"17px\"\n             tooltip=\"{{'EVENTS.PROPERTY_SUBSCRIBED_TOOLTIP' | translate }}\">\n      </td>\n      <td data-se-id=\"name\" >\n        <a data-se-id=\"nameLink\" [routerLink]=\"['/event/' + event.eventId + '/' + event.propertyPartyId]\">\n          <span *ngIf=\"event.autoGenerated\"\n             class=\"tooltip-hint\"\n             [tooltip]=\"'EVENTS.AUTO_GENERATED_TOOLTIP' | translate\"\n             placement=\"right\">\n            {{getEventNameLine1(event.name)}}\n          </span>\n          <span *ngIf=\"event.autoGenerated && getEventNameLine2(event.name)\"\n             class=\"tooltip-hint\"\n             [tooltip]=\"'EVENTS.AUTO_GENERATED_TOOLTIP' | translate\"\n             placement=\"right\">\n             <br>{{getEventNameLine2(event.name)}}\n          </span>\n          <span *ngIf=\"!event.autoGenerated\">\n            {{getEventNameLine1(event.name)}}\n          </span>\n          <span *ngIf=\"!event.autoGenerated && getEventNameLine2(event.name)\">\n            <br>{{getEventNameLine2(event.name)}}\n          </span>\n        </a>\n      </td>\n      <td data-se-id=\"eventReferenceNumber\">\n        {{ event.eventReferenceNumber }}\n      </td>\n      <td data-se-id=\"endDate\"> {{ event.endDate | date: 'shortDate' }} </td>\n      <td data-se-id=\"prepaymentAmount\" class=\"text-right\">\n        <a *ngIf=\"event.prepaymentAmount != null\" [routerLink]=\"['/event/' + event.eventId + '/' + event.propertyPartyId + '/commission']\">\n          {{ getPrepaymentAmount(event) | number:'1.2-2' }} {{ event.currency}}\n        </a>\n      </td>\n      <td>{{ event.paymentCreatedDate | date: 'shortDate' }}</td>\n      <td data-se-id=\"payStatus\"> {{ getPaymentStatus(event.payStatus) | paymentStatus }} </td>\n      <td data-se-id=\"totalPayAmount\" class=\"text-right\">\n        <a [routerLink]=\"['/event/' + event.eventId + '/' + event.propertyPartyId + '/commission']\">\n          <span *ngIf=\"!event.payStatus && isOoivEnabled; else noTooltipTotalPayAmount\"\n                class=\"tooltip-hint\"\n                [tooltip]=\"'EVENTS.NO_TAXES_INCLUDED_TOOLTIP' | translate\"\n                placement=\"left\">\n              {{ getTotalPaymentAmountByStatus(event) | number:'1.2-2' }} {{ event.currency}}\n          </span>\n          <ng-template #noTooltipTotalPayAmount>\n              {{ getTotalPaymentAmountByStatus(event) | number:'1.2-2' }} {{ event.currency}}\n          </ng-template>\n        </a>\n      </td>\n      <td data-se-id=\"estimatedDue\" class=\"text-right\">\n        <a [routerLink]=\"['/event/' + event.eventId + '/' + event.propertyPartyId + '/commission']\">\n          <span *ngIf=\"!event.payStatus && isOoivEnabled; else noTooltipEstimatedDue\"\n                class=\"tooltip-hint\"\n                [tooltip]=\"'EVENTS.NO_TAXES_INCLUDED_TOOLTIP' | translate\"\n                placement=\"left\">\n              {{ getEstimatedDueByStatus(event) | number:'1.2-2' }} {{ event.currency}}\n          </span>\n          <ng-template #noTooltipEstimatedDue>\n            {{ getEstimatedDueByStatus(event) | number:'1.2-2' }} {{ event.currency}}\n          </ng-template>\n        </a>\n      </td>\n      <td *pioneerAuthorize=\"{permission: 'AgencyEventLevelIndicators'}\" data-se-id=\"masterBill\">\n        {{ event.masterBillPaid | masterBill }}\n      </td>\n    </tr>\n    </tbody>\n  </table>\n</div>\n\n"

/***/ }),

/***/ "rF25":
/***/ (function(module, exports) {

module.exports = "<div class=\"content-container\" data-se-id=\"event-match-log\">\n  <div class=\"event-search\">\n    <form [formGroup]=\"matchingSearchTextForm\" novalidate>\n    <div class=\"form-group form-search\">\n      <div class=\"input-group\">\n        <input class=\"form-control\" type=\"text\" id=\"search\" maxlength=\"100\" name=\"search\"\n               required autocomplete=\"off\"\n               formControlName=\"searchText\"\n               (keydown.enter)=\"searchByText(matchingSearchTextForm.value)\"\n               placeholder=\"{{ 'EVENTS.SEARCH_PLACEHOLDER' | translate }}\"/>\n        <div class=\"input-group-addon\">\n          <i (click)=\"searchByText(matchingSearchTextForm.value)\" class=\"glyph-search\"></i>\n        </div>\n      </div>\n    </div>\n    </form>\n  </div>\n  <div class=\"card-content\">\n    <div class=\"card card-table\">\n      <div class=\"card-header\">\n        <div class=\"row row-cols-2 row-cols-lg-5 g-2 g-lg-3 justify-content-between\">\n          <div class=\"col-4\">\n            {{ \"EVENT.MATCH_LOG.TITLE\" | translate }}\n          </div>\n          <div class=\"col-2\">\n            <button\n              class=\"btn btn-secondary text-nowrap\"\n              (click)=\"exportEventMatchLogExcel()\"\n            >\n              <i class=\"far fa-solid fa-file-excel\"></i>\n              <!-- <i class=\"far fa-pencil\" aria-hidden=\"true\"></i> -->\n              {{ \"COMMON.REPORT.EXPORT_DROPDOWN\" | translate }}\n            </button>\n          </div>\n        </div>\n      </div>\n      <div class=\"card-body\">\n        <div class=\"table-responsive\">\n          <table class=\"table table-hover\">\n            <thead>\n              <tr>\n                <th title=\"{{ 'EVENT.MATCH_LOG.GROUPPAY_EVENT_ID_TOOLTIP' | translate }}\">{{ \"EVENT.MATCH_LOG.GROUPPAY_EVENT_ID\" | translate }}</th>\n                <th title=\"{{ 'EVENT.MATCH_LOG.HOTEL_GROUP_CODE_TOOLTIP' | translate }}\" *ngIf=\"isPropertyUser() || isSupportUser()\">{{ \"EVENT.MATCH_LOG.HOTEL_GROUP_CODE\" | translate }}</th>\n                <th title=\"{{ 'EVENT.MATCH_LOG.AGENCY_MEETING_ID_TOOLTIP' | translate }}\" *ngIf=\"isAgencyUser()\">{{ \"EVENT.MATCH_LOG.AGENCY_MEETING_ID\" | translate }}</th>\n                <th title=\"{{ 'EVENT.MATCH_LOG.HOTEL_EVENT_NAME_TOOLTIP' | translate }}\" *ngIf=\"isPropertyUser() || isSupportUser()\">{{ \"EVENT.MATCH_LOG.HOTEL_EVENT_NAME\" | translate }}</th>\n                <th title=\"{{ 'EVENT.MATCH_LOG.AGENCY_EVENT_NAME_TOOLTIP' | translate }}\" *ngIf=\"isAgencyUser()\">{{ \"EVENT.MATCH_LOG.AGENCY_EVENT_NAME\" | translate }}</th>\n                <th title=\"{{ 'EVENT.MATCH_LOG.EVENT_START_DATE_TOOLTIP' | translate }}\">{{ \"EVENT.MATCH_LOG.EVENT_START_DATE\" | translate }}</th>\n                <th title=\"{{ 'EVENT.MATCH_LOG.EVENT_START_DATE_TOOLTIP' | translate }}\">{{ \"EVENT.MATCH_LOG.EVENT_END_DATE\" | translate }}</th>\n                <th *ngIf=\"isPropertyUser() || isSupportUser()\">{{ \"EVENT.MATCH_LOG.PROPERTY_NAME\" | translate }}</th>\n                <th *ngIf=\"isAgencyUser()\">{{ \"EVENT.MATCH_LOG.VENDOR_PROPERTY_NAME\" | translate }}</th>\n                <th title=\"{{ 'EVENT.MATCH_LOG.FIRST_CREATED_BY_TOOLTIP' | translate }}\">{{ \"EVENT.MATCH_LOG.FIRST_CREATED_BY\" | translate }}</th>\n                <th>{{ \"EVENT.MATCH_LOG.DATE_OF_MATCH\" | translate }}</th>\n                <th>{{ \"EVENT.MATCH_LOG.RESULTING_ACTION\" | translate }} <i class=\"fa fa-question-circle fa-lg\" style=\"color: #166293;\" title=\"{{ 'EVENT.MATCH_LOG.RESULTING_ACTION_AUTOMATIC_TOOLTIP' | translate }}&#010;{{ 'EVENT.MATCH_LOG.RESULTING_ACTION_MANUALLY_MERGED_TOOLTIP' | translate }}&#010;{{ 'EVENT.MATCH_LOG.RESULTING_ACTION_CREATED_NEW_TOOLTIP' | translate }}\"></i></th>\n              </tr>\n            </thead>\n            <tbody *ngIf=\"matchingPage?.content as eventList\">\n              <tr *ngFor=\"let event of eventList\">\n                <td>\n                  <a data-se-id=\"nameLink\" [routerLink]=\"['/event/' + event.eventId]\" *pioneerAuthorize=\"{permission: 'MultiVendor'}\">\n                    {{ event.eventId }}\n                  </a>\n                  <a data-se-id=\"nameLink\" [routerLink]=\"['/event/' + event.eventId + '/' + event.eventPartyId]\" *pioneerAuthorize=\"{permission: 'SingleVendor'}\">\n                    {{ event.eventId }}\n                  </a>\n                </td>\n                <td>{{ event.eventReferenceNumber }}</td>\n                <td>{{ event.eventName }}</td>\n                <td>{{ event.startDate }}</td>\n                <td>{{ event.endDate }}</td>\n                <td>{{ event.propertyName }}</td>\n                <td>{{ event.createdBy }}</td>\n                <td>{{ event.createdDate | date: 'yyyy-MM-dd' }}</td>\n                <td>{{ event.status }}</td>\n              </tr>\n            </tbody>\n          </table>\n        </div>\n      </div>\n    </div>\n    <div class=\"card-footer\">\n      <pioneer-pagination\n        [resultsPage]=\"matchingPage\"\n        (updatePage)=\"onRefreshMatchingList($event.page, $event.itemsPerPage)\"\n        [pagesizeType]=\"pagesizeType\">\n    </pioneer-pagination>\n    </div>\n  </div>\n</div>\n"

/***/ }),

/***/ "rLhm":
/***/ (function(module, exports) {

module.exports = "<form [formGroup]=\"rsvpForm\" data-se-id=\"rsvpForm\" id=\"rsvpForm\">\n  <div class=\"row\">\n    <div class=\"col form-container\">\n      <div class=\"form-group\">\n        <pioneer-form-input label=\"EVENT.RSVPS.FIRST_NAME\">\n          <input formControlName=\"firstName\"\n                 type=\"text\"\n                 class=\"form-control\"\n                 data-se-id=\"firstName\"\n                 placeholder=\"{{ 'EVENT.RSVPS.FIRST_NAME_PLACEHOLDER' | translate }}\"\n                 maxlength=\"50\">\n        </pioneer-form-input>\n      </div>\n    </div>\n    <div class=\"col form-container\">\n      <div class=\"form-group form-required\">\n        <pioneer-form-input label=\"EVENT.RSVPS.LAST_NAME\">\n          <input formControlName=\"lastName\"\n                 class=\"form-control\"\n                 type=\"text\"\n                 data-se-id=\"lastName\"\n                 placeholder=\"{{ 'EVENT.RSVPS.LAST_NAME_PLACEHOLDER' | translate }}\"\n                 maxlength=\"50\">\n        </pioneer-form-input>\n      </div>\n    </div>\n    <div class=\"col form-container confirmation-number\">\n      <div class=\"form-group\">\n        <pioneer-form-input label=\"EVENT.RSVPS.CONFIRMATION_NUMBER\">\n          <input formControlName=\"confirmation\" type=\"text\" class=\"form-control\" data-se-id=\"confirmation\"\n                 placeholder=\"{{ 'EVENT.RSVPS.CONFIRMATION_NUMBER_PLACEHOLDER' | translate }}\" maxlength=\"32\"\n                 pioneerUppercase>\n        </pioneer-form-input>\n      </div>\n    </div>\n  </div>\n  <div class=\"row\">\n    <div class=\"col form-container\">\n      <div class=\"form-group form-required\">\n        <pioneer-form-input label=\"EVENT.RSVPS.CHECKIN_DATE\">\n          <input formControlName=\"checkInDate\" type=\"date\" class=\"form-control-input-date\" data-se-id=\"checkInDate\" placeholder=\"{{'EVENT.DATE_PLACEHOLDER' | translate}}\">\n        </pioneer-form-input>\n      </div>\n    </div>\n    <div class=\"col form-container\">\n      <div class=\"form-container\">\n        <div class=\"form-group form-required\">\n          <pioneer-form-input label=\"EVENT.RSVPS.CHECKOUT_DATE\">\n            <input type=\"date\" class=\"form-control-input-date\" formControlName=\"checkOutDate\" data-se-id=\"checkOutDate\" placeholder=\"{{'EVENT.DATE_PLACEHOLDER' | translate}}\">\n            <div class=\"validation-messages\">\n              <pioneer-validation-message error=\"end_date_after_start_date\" message=\"MESSAGES.VALIDATION.CHECKOUT_AFTER_CHECKIN\">\n              </pioneer-validation-message>\n            </div>\n          </pioneer-form-input>\n        </div>\n      </div>\n    </div>\n    <div class=\"col form-container\">\n      <div class=\"form-group form-required\" data-se-id=\"roomRateFormGroup\">\n        <pioneer-form-input label=\"EVENT.RSVPS.ROOM_RATE\">\n          <div class=\"input-group\">\n            <input formControlName=\"roomRate\" type=\"number\" class=\"form-control\" data-se-id=\"roomRate\" placeholder=\"{{ 'EVENT.RSVPS.ROOM_RATE_PLACEHOLDER' | translate }}\">\n            <div *ngIf=\"event.currency\" class=\"input-group-addon\">\n                  <span class=\"input-group-text\">{{ event.currency | uppercase }}</span>\n            </div>\n          </div>\n        </pioneer-form-input>\n      </div>\n    </div>\n    <div class=\"col form-container\">\n      <div class=\"form-group\">\n        <pioneer-form-input label=\"EVENT.RSVPS.ROOM_TYPE\">\n          <input formControlName=\"roomType\" type=\"text\" class=\"form-control\" data-se-id=\"roomType\" placeholder=\"{{ 'EVENT.RSVPS.ROOM_TYPE_PLACEHOLDER' | translate }}\"\n                 maxlength=\"6\" pioneerUppercase>\n        </pioneer-form-input>\n      </div>\n    </div>\n  </div>\n</form>\n"

/***/ }),

/***/ "roPR":
/***/ (function(module, exports) {

//# sourceMappingURL=/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/lookup.store.js.map

/***/ }),

/***/ "sMoM":
/***/ (function(module, exports) {

module.exports = "<div *ngIf=\"agencyCount > 0\" >\n  <table class=\"table search-results-simple\">\n    <thead>\n    <tr>\n      <th>\n        <pioneer-pagination-sort\n          [label]=\"'EVENT.AGENCY_REVIEW.DATE_LOADED' | translate\"\n          [field]=\"'createdDate'\"\n          (sortPage)=\"sortList($event.field, $event.direction)\">\n        </pioneer-pagination-sort>\n      </th>\n      <th>\n        <pioneer-pagination-sort\n          [label]=\"'EVENT.AGENCY_REVIEW.PROPERTY_NAME' | translate\"\n          [field]=\"'propertyName'\"\n          (sortPage)=\"sortList($event.field, $event.direction)\">\n        </pioneer-pagination-sort>\n      </th>\n      <th>\n        <pioneer-pagination-sort\n          [label]=\"'EVENT.AGENCY_REVIEW.PROPERTY_ID' | translate\"\n          [field]=\"'propertyId'\"\n          (sortPage)=\"sortList($event.field, $event.direction)\">\n        </pioneer-pagination-sort>\n      </th>\n      <th>\n        {{'EVENT.AGENCY_REVIEW.AGENCY_NAME' | translate}}\n      </th>\n      <th>{{'EVENT.AGENCY_REVIEW.AGENCY_ADDRESS' | translate}}</th>\n      <th>{{'EVENT.AGENCY_REVIEW.AGENCY_ID_PROVIDED' | translate}}</th>\n      <th>{{'EVENT.AGENCY_REVIEW.EVENT_NAME' | translate}}</th>\n      <th></th>\n    </tr>\n    </thead>\n    <tbody>\n    <tr *ngFor=\"let agency of agencies?.content\">\n      <td data-se-id=\"createdDate\">\n        {{ agency.createdDate | date: 'shortDate' }}\n      </td>\n      <td data-se-id=\"propertyName\">\n        {{ agency.propertyName }}\n      </td>\n      <td data-se-id=\"propertyId\">\n        {{ agency.propertyId }}\n      </td>\n      <td data-se-id=\"agencyName\">\n        {{ agency.agencyName }}\n      </td>\n      <td data-se-id=\"agencyAddress\">\n        <span class=\"res-value\">{{ agency.agencyAddress1 ? agency.agencyAddress1 : '' }}</span>\n        <span class=\"res-value\">{{ agency.agencyAddress2 ? ', ' + agency.agencyAddress2 : '' }}</span>\n        <span class=\"res-value\">{{ agency.agencyAddress3 ? ', ' + agency.agencyAddress3 : '' }}</span>\n        <br>\n        <span class=\"res-value\">{{ agency.agencyCity ? agency.agencyCity : '' }}</span>\n        <span class=\"res-value\">{{ agency.agencyCountryCode ? ', ' + agency.agencyCountryCode : '' }}</span>\n        <span class=\"res-value\">{{ agency.agencyStateProvinceCode ? ', ' + agency.agencyStateProvinceCode : '' }}</span>\n        <span class=\"res-value\">{{ agency.agencyPostalCode ? ', ' + agency.agencyPostalCode : '' }}</span>\n      </td>\n      <td data-se-id=\"agencyId\">\n        {{ agency.taCode }}\n      </td>\n      <td data-se-id=\"eventName\">\n        <a data-se-id=\"nameLink\" [routerLink]=\"['/event/' + agency.eventId]\" *pioneerAuthorize=\"{permission: 'MultiVendor'}\">\n          {{ agency.eventName }}\n        </a>\n        <a data-se-id=\"nameLink\" [routerLink]=\"['/event/' + agency.eventId + '/' + agency.eventPartyId]\" *pioneerAuthorize=\"{permission: 'SingleVendor'}\">\n          {{ agency.eventName }}\n        </a>\n      </td>\n      <td data-se-id=\"view-matches\">\n        <a class=\"col form-text\" href=\"#\" (click)=\"selectAgency(agency)\">\n          {{ 'EVENT.AGENCY_REVIEW.VIEW_MATCHES' | translate }}\n        </a>\n      </td>\n    </tr>\n    </tbody>\n  </table>\n</div>\n\n"

/***/ }),

/***/ "sUjQ":
/***/ (function(module, exports) {

module.exports = {"headerTitle":{"fontSize":"16","bold":"true"},"cardTitle":{"fontSize":"14","bold":"true"},"textCell":{"fontSize":"10"},"numericCell":{"alignment":"right","fontSize":"10"},"headerCell":{"bold":"true","fontSize":"12"},"pageNumberFooter":{"fontSize":"10"}}

/***/ }),

/***/ "scbP":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("rP7Y")(true);
// imports


// module
exports.push([module.i, ".order-one{-ms-flex-order:1!important;order:1!important}.no-payment,.non-bold{font-weight:400}.no-payment{color:#86b0f5}.no-text-decoration{text-decoration:none}.commission-card{margin-bottom:15px}", "", {"version":3,"sources":["/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/rsvp/vendor-rsvp-card/vendor-rsvp-card.component.css"],"names":[],"mappings":"AAAA,WACE,2BAAA,iBAAoB,CACrB,sBAGC,eAAmB,CAGrB,YAEE,aAAc,CACf,oBAGC,oBAAsB,CACvB,iBAGG,kBAAoB,CACvB","file":"vendor-rsvp-card.component.css","sourcesContent":[".order-one {\n  order: 1 !important;\n}\n\n.non-bold {\n  font-weight:normal;\n}\n\n.no-payment {\n  font-weight:normal;\n  color: #86B0F5\n}\n\n.no-text-decoration {\n  text-decoration: none;\n}\n\n.commission-card{\n    margin-bottom: 15px;\n}"],"sourceRoot":""}]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),

/***/ "tKR5":
/***/ (function(module, exports) {

module.exports = "<pioneer-confirmation-modal\n  #confirmDeleteModal\n  data-se-id=\"deleteRsvpConfirmationModal\"\n  content=\"EVENT.RSVPS.CONFIRM_DELETE_RSVP\"\n  cancel=\"COMMON.BUTTON.CANCEL\"\n  confirm=\"EVENT.RSVPS.DELETE_RSVP\"\n  (closed)=\"confirmDeleteHandler($event)\">\n</pioneer-confirmation-modal>\n\n<pioneer-confirmation-modal\n  #confirmUpdateRsvpModal\n  data-se-id=\"updateRsvpConfirmationModal\"\n  content=\"EVENT.RSVPS.CONFIRM_UPDATE_RSVP\"\n  cancel=\"COMMON.BUTTON.CANCEL\"\n  confirm=\"EVENT.RSVPS.UPDATE_RSVP\"\n  (closed)=\"confirmUpdateHandler($event)\">\n</pioneer-confirmation-modal>\n\n<div *ngIf=\"ui.showCards\">\n\n  <!--         No Matches         -->\n  <div *ngIf=\"ui.showNoMatchesCard\"\n       id=\"card-no-match-list\"\n       class=\"card\">\n    <div class=\"card-reservation-list\">\n        <pioneer-header-summary [event]=\"onyxEvent\"\n                              [title]=\"'EVENT.RSVPS.NO_MATCHING_TITLE' | translate\"\n                              [type]=\"headerRecordType\"\n                              [matchType]=\"MatchTypeEnum.NO_MATCH\"\n                              [vendor]=\"vendor\">\n      </pioneer-header-summary>\n    </div>\n    <div class=\"table-responsive table-dropdown\">\n      <table class=\"table reservation-list res-summary\">\n        <thead>\n        <tr>\n          <th *pioneerAuthorize=\"{permissions: ['AddReservation','LinkReservation', 'DeleteRsvp']}\"></th>\n          <th>{{ 'EVENT.RSVPS.NAME' | translate }}</th>\n          <th>{{ 'EVENT.RSVPS.CHECKIN_DATE' | translate }}</th>\n          <th>{{ 'EVENT.RSVPS.CHECKOUT_DATE' | translate }}</th>\n          <th>{{ 'EVENT.RSVPS.NIGHTS' | translate }}</th>\n          <th>{{ 'EVENT.RSVPS.ROOM_TYPE' | translate }}</th>\n          <th class=\"currency\">\n            <span>{{ 'EVENT.RSVPS.RATE' | translate }}</span>\n            <br />\n            <small>({{ onyxEvent.currency | uppercase }})</small>\n          </th>\n          <th class=\"currency\">\n            <span>{{ 'EVENT.RSVPS.REVENUE' | translate }}</span>\n            <br />\n            <small>({{ onyxEvent.currency | uppercase }})</small>\n          </th>\n          <th class=\"currency\">\n            <span>{{ 'EVENT.RSVPS.COMMISSION' | translate }}</span>\n            <br />\n            <small>({{ onyxEvent.currency | uppercase }})</small>\n          </th>\n        </tr>\n        </thead>\n        <tbody data-se-id=\"reservationDetailNoMatch\">\n        <tr *ngFor=\"let compare of noMatchPage?.content; last as isLast\"\n            [attr.data-rsvp-id]=\"getRsvpId(compare.rsvp)\"\n            class=\"res-status-checked-out\"\n            data-se-id=\"reservationDetailEntry\">\n\n          <td class=\"col-more\" *pioneerAuthorize=\"{permissions: ['AddReservation','LinkReservation', 'DeleteRsvp']}\" data-se-id=\"openDropdownMenu\">\n            <!-- Bootstrap (jQuery) -->\n            <div [ngClass]=\"isLast ? 'dropup' : 'dropdown'\" *ngIf=\"displayDropdown\">\n              <button class=\"btn btn-more\" data-toggle=\"dropdown\">\n                <i class=\"far fa-ellipsis-h\"></i>\n              </button>\n              <ul class=\"dropdown-menu\">\n                <ng-container *ngIf=\"canManageReservations\">\n                  <ng-container *pioneerAuthorize=\"{permissions: ['AddReservation','LinkReservation']}\">\n                    <li role=\"menuitem\" *pioneerAuthorize=\"{permission: 'AddReservation'}\">\n                      <a class=\"dropdown-item\" href=\"javascript:void(0)\" (click)=\"openReservationModal($event, compare.rsvp)\" data-se-id=\"openReservationModal\">\n                        <i class=\"fal fa-user-check fa-fw\"></i>\n                        {{ 'EVENT.RESERVATION.CONFIRM_RESERVATION_MENU_ITEM' | translate }}\n                      </a>\n                    </li>\n                    <li class=\"divider dropdown-divider\"></li>\n                    <li role=\"menuitem\"  *pioneerAuthorize=\"{permission: 'LinkReservation'}\">\n                      <a class=\"dropdown-item\" href=\"javascript:void(0)\" (click)=\"openTransientReservationModal($event, compare.rsvp)\" data-se-id=\"openTransientReservationModal\">\n                        <i class=\"fal fa-user-friends fa-fw\"></i>\n                        {{ 'EVENT.RSVPS.MATCH_RSVP_MENU_ITEM' | translate }}\n                      </a>\n                    </li>\n                    <li class=\"divider dropdown-divider\"></li>\n                  </ng-container>\n                </ng-container>\n                <li role=\"menuitem\" *pioneerAuthorize=\"{permission: 'DeleteRsvp'}\">\n                  <a class=\"dropdown-item\" href=\"javascript:void(0)\" (click)=\"confirmBeforeDelete($event, compare.rsvp)\" data-se-id=\"rsvpDelete\">\n                    <i class=\"fal fa-trash-alt fa-fw\"></i>\n                    {{ 'EVENT.RSVPS.DELETE_RSVP_MENU_ITEM' | translate }}\n                  </a>\n                </li>\n              </ul>\n            </div>\n          </td>\n          <td class=\"field-wrap\" data-se-id=\"name\">\n            <span *ngIf=\"compare.rsvp.firstName; else noMatchesOnlyLastName\">\n              {{ compare.rsvp.lastName }}, {{ compare.rsvp.firstName }}\n            </span>\n            <ng-template #noMatchesOnlyLastName>\n              <span>\n                {{ compare.rsvp.lastName }}\n              </span>\n            </ng-template>\n          </td>\n          <td data-se-id=\"rsvpCheckin\">{{ compare.rsvp.checkInDate | dateFormat }}</td>\n          <td data-se-id=\"rsvpCheckout\">{{ compare.rsvp.checkOutDate | dateFormat }}</td>\n          <td data-se-id=\"rsvpNights\">{{ compare.rsvp.nights }}</td>\n          <td data-se-id=\"rsvpRoomType\">{{ compare.rsvp.roomType }}</td>\n          <td class=\"currency\" data-se-id=\"roomRate\">\n            <span>{{ compare.rsvp.roomRate | number:'1.2-2'  }}</span>\n          </td>\n          <td class=\"currency\" data-se-id=\"revenue\">\n            <span *ngIf=\"compare.rsvp\" class=\"rsvp-value\">{{ compare.rsvp.revenue | number:'1.2-2'  }}</span>\n          </td>\n          <td class=\"currency\" data-se-id=\"commission\">\n            <span *ngIf=\"compare.rsvp\" class=\"rsvp-value\">{{ compare.rsvp.commission | number:'1.2-2'  }}</span>\n          </td>\n        </tr>\n        </tbody>\n      </table>\n    </div>\n\n    <div class=\"card-footer\" *ngIf=\"noMatchPage?.totalElements > 0\">\n      <pioneer-pagination\n        [resultsPage]=\"noMatchPage\"\n        (updatePage)=\"onRefreshNoMatchList($event.page, $event.itemsPerPage)\"\n        [pagesizeType]=\"noMatchespagesizeType\">\n      </pioneer-pagination>\n    </div>\n\n  </div>\n\n  <!--         Partial Matches         -->\n  <div *ngIf=\"ui.showPartialMatchesCard\"\n       id=\"card-partial-match-list\"\n       class=\"card\">\n    <div class=\"card-reservation-list\">\n      <pioneer-header-summary [event]=\"onyxEvent\"\n                              [title]=\"'EVENT.RSVPS.PARTIAL_MATCHING_TITLE' | translate\"\n                              [type] = \"headerRecordType\"\n                              [matchType]=\"MatchTypeEnum.PARTIAL_MATCH\"\n                              [vendor]=\"vendor\">\n      </pioneer-header-summary>\n    </div>\n    <div class=\"table-responsive table-dropdown\">\n      <table class=\"table reservation-list res-summary\">\n        <thead>\n        <tr>\n          <th *pioneerAuthorize=\"{permissions: ['DeleteRsvp','EditRsvp']}\"></th>\n          <th>{{ 'EVENT.RSVPS.TYPE' | translate }}</th>\n          <th>{{ 'EVENT.RESERVATION.NAME' | translate }}</th>\n          <th>{{ 'EVENT.RESERVATION.STATUS' | translate }}</th>\n          <th>{{ 'EVENT.RSVPS.CHECKIN_DATE' | translate }}</th>\n          <th>{{ 'EVENT.RSVPS.CHECKOUT_DATE' | translate }}</th>\n          <th class=\"nights\">{{ 'EVENT.RESERVATION.NUMBER_ROOMS' | translate }}</th>\n          <th class=\"nights\">{{ 'EVENT.RESERVATION.NUMBER_NIGHTS' | translate }}</th>\n          <th class=\"nights\">{{ 'EVENT.COMMISSION.ROOM_NIGHTS' | translate }}</th>\n          <th>{{ 'EVENT.RSVPS.ROOM_TYPE' | translate }}</th>\n          <th class=\"currency\">\n            <span>{{ 'EVENT.RSVPS.RATE' | translate }}</span>\n            <br />\n            <small>({{ onyxEvent.currency | uppercase }})</small>\n          </th>\n          <th class=\"currency\">\n            <span>{{ 'EVENT.RSVPS.REVENUE' | translate }}</span>\n            <br />\n            <small>({{ onyxEvent.currency | uppercase }})</small>\n          </th>\n          <th class=\"currency\">\n            <span>{{ 'EVENT.RSVPS.COMMISSION' | translate }}</span>\n            <br />\n            <small>({{ onyxEvent.currency | uppercase }})</small>\n          </th>\n        </tr>\n        </thead>\n        <tbody data-se-id=\"reservationDetailPartial\">\n        <tr *ngFor=\"let compare of partialMatchPage?.content; last as isLast\"\n            [attr.data-rsvp-id]=\"getRsvpId(compare.rsvp)\"\n            data-se-id=\"reservationDetailEntry\"\n            [ngClass]=\"getStatusClass(compare)\">\n          <td class=\"col-more\" *pioneerAuthorize=\"{permissions: ['DeleteRsvp','EditRsvp']}\" data-se-id=\"openDropdownMenu\">\n            <!-- Bootstrap (jQuery) -->\n            <div [ngClass]=\"isLast ? 'dropup' : 'dropdown'\">\n              <button class=\"btn btn-more\" data-toggle=\"dropdown\">\n                <i class=\"far fa-ellipsis-h\"></i>\n              </button>\n              <ul class=\"dropdown-menu\">\n                <ng-container *pioneerAuthorize=\"{permission: 'EditRsvp'}\">\n                  <li role=\"menuitem\">\n                    <a class=\"dropdown-item\" href=\"javascript:void(0)\" (click)=\"confirmBeforeUpdate($event, compare)\" data-se-id=\"openUpdateRsvpModal\">\n                      <i class=\"fal fa-user-edit fa-fw\"></i>\n                      {{ 'EVENT.RSVPS.UPDATE_RSVP_MENU_ITEM' | translate }}\n                    </a>\n                  </li>\n                  <li class=\"divider dropdown-divider\"></li>\n                </ng-container>\n                <li role=\"menuitem\" *pioneerAuthorize=\"{permission: 'DeleteRsvp'}\">\n                  <a class=\"dropdown-item\" href=\"javascript:void(0)\" (click)=\"confirmBeforeDelete($event, compare.rsvp)\" data-se-id=\"rsvpDelete\">\n                    <i class=\"fal fa-trash-alt fa-fw\"></i>\n                    {{ 'EVENT.RSVPS.DELETE_RSVP_MENU_ITEM' | translate }}\n                  </a>\n                </li>\n              </ul>\n            </div>\n          </td>\n          <td data-se-id=\"type\">\n            <span class=\"res-value\">{{ 'EVENT.RSVPS.TYPE_RESERVATION' | translate }}</span>\n            <span class=\"rsvp-value\">{{ 'EVENT.RSVPS.TYPE_RSVP' | translate }}</span>\n          </td>\n          <td class=\"field-wrap\" data-se-id=\"name\">\n            <span class=\"res-value\" *ngIf=\"compare.reservation.firstName; else partialMatchesOnlyLastNameReservation\">\n              {{ compare.reservation.lastName }}, {{ compare.reservation.firstName }}\n            </span>\n            <ng-template #partialMatchesOnlyLastNameReservation>\n              <span class=\"res-value\">\n                {{ compare.reservation.lastName }}\n              </span>\n            </ng-template>\n            <span class=\"rsvp-value\" *ngIf=\"compare.rsvp.firstName; else partialMatchesOnlyLastNameRsvp\">\n              {{ compare.rsvp.lastName }}, {{ compare.rsvp.firstName }}\n            </span>\n            <ng-template #partialMatchesOnlyLastNameRsvp>\n              <span class=\"rsvp-value\">\n                {{ compare.rsvp.lastName }}\n              </span>\n            </ng-template>\n          </td>\n          <td data-se-id=\"status\" class=\"res-status\"\n              [class.diff-down]=\"isNotCommissionable(compare)\">\n            <span class=\"res-value\">{{ compare.reservation.status | reservationStatus }}</span>\n            <span class=\"rsvp-value\">--</span>\n          </td>\n          <td data-se-id=\"checkIn\"\n              [class.diff-up]=\"isNightsUp(compare)\"\n              [class.diff-down]=\"isNightsDown(compare)\"\n              [class.diff]=\"isDatesBold(compare)\">\n            <span class=\"res-value\">{{ compare.reservation.checkInDate | dateFormat }}</span>\n            <span class=\"rsvp-value\">{{ compare.rsvp.checkInDate | dateFormat }}</span>\n          </td>\n          <td data-se-id=\"checkOut\"\n              [class.diff-up]=\"isNightsUp(compare)\"\n              [class.diff-down]=\"isNightsDown(compare)\"\n              [class.diff]=\"isDatesBold(compare)\">\n            <span class=\"res-value\">{{ compare.reservation.checkOutDate | dateFormat }}</span>\n            <span class=\"rsvp-value\">{{ compare.rsvp.checkOutDate | dateFormat }}</span>\n          </td>\n          <td class=\"nights\" data-se-id=\"rooms\">\n            <span class=\"res-value\">{{ compare.reservation.rooms }}</span>\n            <span class=\"rsvp-value\">1</span>\n          </td>\n          <td class=\"nights\" data-se-id=\"nights\"\n              [class.diff-up]=\"isNightsUp(compare)\"\n              [class.diff-down]=\"isNightsDown(compare)\">\n            <span class=\"res-value\">{{ compare.reservation.nights }}</span>\n            <span class=\"rsvp-value\">{{ compare.rsvp.nights }}</span>\n          </td>\n          <td class=\"nights\" data-se-id=\"roomNights\">\n            <span class=\"res-value\">{{ compare.reservation.roomNights }}</span>\n            <span class=\"rsvp-value\">{{ compare.rsvp.nights }}</span>\n          </td>\n          <td data-se-id=\"roomType\">\n            <span class=\"res-value\">{{ compare.reservation.roomType }}</span>\n            <span class=\"rsvp-value\">{{ compare.rsvp.roomType }}</span>\n          </td>\n          <td data-se-id=\"roomRate\" class=\"currency\"\n              [class.diff-up]=\"isRoomRateUp(compare)\"\n              [class.diff-down]=\"isRoomRateDown(compare)\">\n            <span class=\"res-value\">{{ compare.reservation.roomRate | number:'1.2-2'  }}</span>\n            <span class=\"rsvp-value\">{{ compare.rsvp.roomRate | number:'1.2-2'  }}</span>\n          </td>\n          <td data-se-id=\"revenue\" class=\"currency\"\n              [class.diff-up]=\"isRevenueUp(compare)\"\n              [class.diff-down]=\"isRevenueDown(compare)\">\n            <span class=\"res-value\">{{ compare.reservation.revenue | number:'1.2-2'  }}</span>\n            <span class=\"rsvp-value\">{{ compare.rsvp.revenue | number:'1.2-2'  }}</span>\n          </td>\n          <td data-se-id=\"commission\" class=\"currency\"\n              [class.diff-up]=\"isCommissionUp(compare)\"\n              [class.diff-down]=\"isCommissionDown(compare)\">\n            <span class=\"res-value\">{{ compare.reservation.commission | number:'1.2-2'  }}</span>\n            <span class=\"rsvp-value\">{{ compare.rsvp.commission | number:'1.2-2'  }}</span>\n          </td>\n        </tr>\n        </tbody>\n      </table>\n    </div>\n\n    <div class=\"card-footer\" *ngIf=\"partialMatchPage?.totalElements > 0\">\n      <pioneer-pagination\n        [resultsPage]=\"partialMatchPage\"\n        (updatePage)=\"onRefreshPartialMatchList($event.page, $event.itemsPerPage)\"\n        [pagesizeType]=\"partialMatchespagesizeType\">\n      </pioneer-pagination>\n    </div>\n\n  </div>\n\n  <!--         Exact Matches         -->\n  <div *ngIf=\"ui.showExactMatchesCard\"\n       id=\"card-exact-match-list\"\n       class=\"card\">\n    <div class=\"card-reservation-list\">\n      <pioneer-header-summary [event]=\"onyxEvent\"\n                              [title]=\"'EVENT.RSVPS.EXACT_MATCHING_TITLE' | translate\"\n                              [type] = \"headerRecordType\"\n                              [matchType]=\"MatchTypeEnum.EXACT_MATCH\"\n                              [vendor]=\"vendor\">\n      </pioneer-header-summary>\n    </div>\n    <div class=\"table-responsive table-dropdown\">\n      <table class=\"table reservation-list res-summary\">\n        <thead>\n        <tr>\n          <th *pioneerAuthorize=\"{permission: 'DeleteRsvp'}\"></th>\n          <th>{{ 'EVENT.RESERVATION.NAME' | translate }}</th>\n          <th>{{ 'EVENT.RESERVATION.STATUS' | translate }}</th>\n          <th>{{ 'EVENT.RSVPS.CHECKIN_DATE' | translate }}</th>\n          <th>{{ 'EVENT.RSVPS.CHECKOUT_DATE' | translate }}</th>\n          <th class=\"nights\">{{ 'EVENT.RESERVATION.NUMBER_NIGHTS' | translate }}</th>\n          <th>{{ 'EVENT.RSVPS.ROOM_TYPE' | translate }}</th>\n          <th class=\"currency\">\n            <span>{{ 'EVENT.RSVPS.RATE' | translate }}</span>\n            <br />\n            <small>({{ onyxEvent.currency | uppercase }})</small>\n          </th>\n          <th class=\"currency\">\n            <span>{{ 'EVENT.RSVPS.REVENUE' | translate }}</span>\n            <br />\n            <small>({{ onyxEvent.currency | uppercase }})</small>\n          </th>\n          <th class=\"currency\">\n            <span>{{ 'EVENT.RSVPS.COMMISSION' | translate }}</span>\n            <br />\n            <small>({{ onyxEvent.currency | uppercase }})</small>\n          </th>\n        </tr>\n        </thead>\n        <tbody data-se-id=\"reservationDetailExact\">\n        <tr *ngFor=\"let compare of exactMatchPage?.content; last as isLast\"\n            [attr.data-rsvp-id]=\"getRsvpId(compare.rsvp)\"\n            data-se-id=\"reservationDetailEntry\"\n            [ngClass]=\"getStatusClass(compare)\">\n          <td class=\"col-more\" *pioneerAuthorize=\"{permission: 'DeleteRsvp'}\" data-se-id=\"openDropdownMenu\">\n            <!-- Bootstrap (jQuery) -->\n            <div [ngClass]=\"isLast ? 'dropup' : 'dropdown'\">\n              <button class=\"btn btn-more\" data-toggle=\"dropdown\">\n                <i class=\"far fa-ellipsis-h\"></i>\n              </button>\n              <ul class=\"dropdown-menu\">\n                <li role=\"menuitem\">\n                  <a class=\"dropdown-item\" href=\"javascript:void(0)\" (click)=\"confirmBeforeDelete($event, compare.rsvp)\" data-se-id=\"rsvpDelete\">\n                    <i class=\"fal fa-trash-alt fa-fw\"></i>\n                    {{ 'EVENT.RSVPS.DELETE_RSVP_MENU_ITEM' | translate }}\n                  </a>\n                </li>\n              </ul>\n            </div>\n          </td>\n          <td class=\"field-wrap\" data-se-id=\"name\">\n            <span *ngIf=\"compare.reservation.firstName; else exactMatchesOnlyLastName\">\n              {{ compare.reservation.lastName }}, {{ compare.reservation.firstName }}\n            </span>\n            <ng-template #exactMatchesOnlyLastName>\n              <span>\n                {{ compare.reservation.lastName }}\n              </span>\n            </ng-template>\n          </td>\n          <td data-se-id=\"status\" class=\"res-status\">{{ compare.reservation.status | reservationStatus }}</td>\n          <td data-se-id=\"checkIn\">{{ compare.rsvp.checkInDate | dateFormat }}</td>\n          <td data-se-id=\"checkOut\">{{ compare.rsvp.checkOutDate | dateFormat }}</td>\n          <td data-se-id=\"rsvpNights\" class=\"nights\">{{ compare.rsvp.nights }}</td>\n          <td data-se-id=\"roomType\">{{ compare.rsvp.roomType }}</td>\n          <td class=\"currency\" data-se-id=\"roomRate\">{{ compare.reservation.roomRate | number:'1.2-2'  }}</td>\n          <td class=\"currency\" data-se-id=\"revenue\">{{ compare.reservation.revenue | number:'1.2-2'  }}</td>\n          <td class=\"currency\" data-se-id=\"commission\">{{ compare.reservation.commission | number:'1.2-2'  }}</td>\n        </tr>\n        </tbody>\n      </table>\n    </div>\n\n    <div class=\"card-footer\" *ngIf=\"exactMatchPage?.totalElements > 0\">\n      <pioneer-pagination\n        [resultsPage]=\"exactMatchPage\"\n        (updatePage)=\"onRefreshExactMatchList($event.page, $event.itemsPerPage)\"\n        [pagesizeType]=\"exactMatchespagesizeType\">\n      </pioneer-pagination>\n    </div>\n  </div>\n\n</div>\n\n<div *ngIf=\"ui.showNoReservationsWarning\" class=\"result-empty\" data-se-id=\"rsvpsNotFound\">\n  <h3>{{ \"EVENT.RSVPS.NO_RSVPS_FOUND\" | translate }}</h3>\n  <figure class=\"figure\">\n    <i class=\"glyph-page figure-img\"></i>\n  </figure>\n</div>\n\n<pioneer-reservation-modal *pioneerAuthorize=\"{permission: 'AddReservation'}\" [event]=\"onyxEvent\" [action]=\"confirmRsvpModal\" data-se-id=\"confirmRsvpModal\">\n</pioneer-reservation-modal>\n<pioneer-transient-modal *pioneerAuthorize=\"{permission: 'AddReservation'}\" [event]=\"onyxEvent\" data-se-id=\"matchRsvpModal\">\n</pioneer-transient-modal>\n"

/***/ }),

/***/ "tzTa":
/***/ (function(module, exports) {

module.exports = "<li class=\"nav-item\">\n\n  <a (click)=\"navigateToSearch()\"\n     data-se-id=\"editEventLink\"\n     class=\"nav-link active\">\n    <i class=\"glyph-calendar nav-link-addon\"></i>\n    <span class=\"item-text\">{{ eventTitle | translate }}</span>\n    <i class=\"nav-link-addon glyph-close\"></i>\n  </a>\n\n  <ul class=\"sub-nav\">\n\n    <ng-container *ngIf=\"links$ | async as links\">\n\n      <!-- Overview -->\n      <ng-container *pioneerAuthorize=\"{permission: 'ViewOverview'}\">\n        <li class=\"nav-item\">\n          <a  class=\"nav-link\"\n              [routerLink]=\"links.overview\"\n              routerLinkActive=\"active\"\n              [routerLinkActiveOptions]=\"{exact:true}\"\n              data-se-id=\"viewOverview\">\n            <span class=\"item-text\" *pioneerAuthorize=\"{permission: 'SingleVendor'}\">{{ 'EVENT.OVERVIEW_NAVIGATION' | translate }}</span>\n            <span class=\"item-text\" *pioneerAuthorize=\"{permission: 'MultiVendor'}\">{{ 'EVENT.MULTI_PROP_OVERVIEW_NAVIGATION' | translate }}</span>\n          </a>\n        </li>\n      </ng-container>\n\n      <!-- Contract Summary -->\n      <li class=\"nav-item\" *pioneerAuthorize=\"{permission: 'GetFiles'}\">\n        <a  class=\"nav-link\"\n            [routerLink]=\"links.summary\"\n            routerLinkActive=\"active\"\n            [routerLinkActiveOptions]=\"{exact:false}\"\n            data-se-id=\"viewContractSummary\">\n          <span class=\"item-text\">{{ 'EVENT.CONTRACT_SUMMARY_NAVIGATION' | translate }}</span>\n        </a>\n      </li>\n\n      <!-- View RSVPs -->\n      <ng-container *pioneerAuthorize=\"{permission: 'ViewReservationRsvpCompare'}\">\n        <li class=\"nav-item\">\n          <a  class=\"nav-link\"\n              [routerLink]=\"links.rsvps\"\n              routerLinkActive=\"active\"\n              data-se-id=\"viewRsvps\">\n            <span class=\"item-text\">{{ 'EVENT.RSVPS_NAVIGATION' | translate }}</span>\n          </a>\n        </li>\n      </ng-container>\n\n      <!-- View Reservations -->\n      <ng-container *ngIf=\"links.reservations\">\n        <li class=\"nav-item\" *pioneerAuthorize=\"{permission: 'ViewReservationRsvpCompare'}\">\n          <a  class=\"nav-link\"\n              [routerLink]=\"links.reservations\"\n              routerLinkActive=\"active\"\n              data-se-id=\"viewReservationInformation\">\n            <span class=\"item-text\">{{ 'EVENT.RESERVATION_NAVIGATION' | translate }}</span>\n          </a>\n        </li>\n      </ng-container>\n\n      <!-- View Transient Reservations -->\n      <li class=\"nav-item\" *pioneerAuthorize=\"{permission: 'LinkReservation'}\">\n        <a  class=\"nav-link\"\n            [routerLink]=\"links.transientReservations\"\n            routerLinkActive=\"active\"\n            data-se-id=\"viewTransientReservationInformation\">\n          <span class=\"item-text\">{{ 'EVENT.TRANSIENT_RESERVATION_NAVIGATION' | translate }}</span>\n        </a>\n      </li>\n\n      <!-- Commission Information / Payment -->\n      <li class=\"nav-item\">\n        <a  class=\"nav-link\"\n            [routerLink]=\"links.commission\"\n            routerLinkActive=\"active\"\n            data-se-id=\"viewCommissionInformation\">\n          <span class=\"item-text\">{{ 'EVENT.PAYMENT_NAVIGATION' | translate }}</span>\n        </a>\n      </li>\n\n      <li class=\"nav-item\" *ngIf=\"showInvoiceHistory\">\n        <a  class=\"nav-link\"\n            [routerLink]=\"links.invoiceHistory\"\n            routerLinkActive=\"active\"\n            data-se-id=\"viewCommissionInformation\">\n          <span class=\"item-text\">{{ 'EVENT.INVOICE_HISTORY' | translate }}</span>\n        </a>\n      </li>\n\n    </ng-container>\n\n  </ul>\n\n</li>\n"

/***/ }),

/***/ "unYk":
/***/ (function(module, exports) {

module.exports = "<div class=\"content-container\">\n  <div class=\"row\">\n    <div class=\"card-content\">\n      <div class=\"card\" id=\"card-basic-event-data\">\n        <div class=\"card-header\">\n          {{ 'EVENT.AGENCY_REVIEW.LIST_TITLE' | translate }}\n        </div>\n        <div class=\"card-block\">\n\n          <pioneer-matching-agency-list\n            [agencies]=\"agencies | async\"\n            [currentPage]=\"currentPage\"\n            (sortPage)=\"onRefreshList(currentPage, $event.field, $event.direction)\">\n          </pioneer-matching-agency-list>\n\n          <div *ngIf=\"!(agenciesPresent | async)\" class=\"result-empty\">\n            <h3>{{'EVENT.AGENCY_REVIEW.NO_RESULTS' | translate}}</h3>\n          </div>\n\n          <div class=\"card-footer\">\n            <pioneer-pagination *ngIf=\"agenciesPresent | async\"\n                                [resultsPage]=\"agencies | async\"\n                                (updatePage)=\"onRefreshList($event.page)\"\n                                [pagesizeType]=\"pagesizeType\">\n            </pioneer-pagination>\n          </div>\n\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n\n"

/***/ }),

/***/ "vFLc":
/***/ (function(module, exports) {

module.exports = "<div id=\"flashMessages\">\n  <div class=\"flash-message alert {{findClass(message)}}\" *ngFor='let message of messages'>\n    <div [innerHtml]=\"message.message\"></div>\n    <button class=\"close\" *ngIf=\"showClose(message)\" (click)=\"closeMessage(message)\">\n      <span>{{ 'COMMON.BUTTON.CLOSE' | translate }}</span>\n    </button>\n  </div>\n</div>\n"

/***/ }),

/***/ "vWpv":
/***/ (function(module, exports) {

module.exports = "<pioneer-confirmation-modal\n  #confirmationModal\n  data-se-id=\"add-payment-confirmation-modal\"\n  content=\"MESSAGES.CONFIRMATION.PROCEED\"\n  cancel=\"COMMON.BUTTON.CANCEL\"\n  [confirm]=\"confirmationModalConfig.confirm\"\n  [title]=\"confirmationModalConfig.title\"\n  (closed)=\"confirmBeforeAddPaymentHandler($event)\">\n</pioneer-confirmation-modal>\n\n<pioneer-confirmation-modal\n  #approversModal\n  data-se-id=\"add-payment-approvers-modal\"\n  [content]=\"approversModalConfig.content\"\n  [customModal]=\"true\"\n  [customContent]=\"true\"\n  cancel=\"COMMON.BUTTON.CANCEL\"\n  [confirm]=\"approversModalConfig.confirm\"\n  [title]=\"approversModalConfig.title\"\n  (closed)=\"confirmBeforeApprovalWorkflowHandler($event)\">\n</pioneer-confirmation-modal>\n\n<div class=\"card\">\n  <div class=\"card-header\" id=\"card-commission-payment\">\n    {{ 'EVENT.COMMISSION.ADD_PAYMENT_HEADER' | translate }}\n    <pioneer-automatic-payment-toggle *ngIf=\"isEditAutoPayEnabled()\" [event]=\"onyxEvent\">\n    </pioneer-automatic-payment-toggle>\n  </div>\n  <div class=\"card-block\">\n    <form [formGroup]=\"adjustmentForm\" data-se-id=\"addAdjustmentForm\">\n      <div class=\"row\" *ngIf=\"strikeThroughPrepayment\">\n        <div class=\"col form-container col-md-12\">\n          <div class=\"form-group\">\n            <label class=\"form-control-label\">\n              {{ 'EVENT.COMMISSION.PROCESSING_ERROR' | translate }}\n            </label>\n            <p class=\"lead\">\n              {{ 'EVENT.COMMISSION.PROCESSING_ERROR_LEAD' | translate }}\n            </p>\n            <p class=\"lead text-center\">\n              <!-- TODO: replace with support contact message when available: \"EVENT.COMMISSION.CONTACT_MESSAGE\" -->\n            </p>\n          </div>\n        </div>\n      </div>\n      <div class=\"row reverse\">\n        <div class=\"form-container pay-equation flex98\">\n          <div class=\"row\">\n            <pioneer-payment-equation\n              [event]=\"onyxEvent\"\n              [vendor]=\"vendor\"\n              [isEditMode]=\"true\"\n              [strikeThroughPrepayment]=\"strikeThroughPrepayment\"\n              [useModifiersMode]=\"false\">\n            </pioneer-payment-equation>\n          </div>\n        </div>\n      </div>\n    </form>\n\n    <pioneer-forecasted-commission\n      [event]=\"onyxEvent\"\n      [vendor]=\"vendor\">\n    </pioneer-forecasted-commission>\n\n    <ng-container *pioneerAuthorize=\"{permission: 'AgencyEventLevelIndicators'}\">\n      <div class=\"form-group form-toggle\">\n        <div class=\"form-check\">\n          <label>\n            {{ 'EVENT.COMMISSION.MASTER_BILL_PAID_1' | translate }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;\n          </label>\n          <label class=\"custom-control custom-checkbox\">\n            <input type=\"checkbox\" class=\"custom-control-input\"\n                   (click)=\"toggleMasterBillPaidSetting()\"\n                   [checked]=\"vendor.masterBillPaid\"\n                   data-se-id=\"masterBillPaidToggleCheckbox\"/>\n            <span class=\"custom-control-indicator\"></span>\n            <span class=\"custom-control-description\">{{ 'EVENT.COMMISSION.MASTER_BILL_PAID_2' | translate }}</span>\n          </label>\n        </div>\n      </div>\n    </ng-container>\n    <ng-container *pioneerAuthorize=\"{permission: 'PayCommission'}\">\n      <form *ngIf=\"showPaymentForm() | async\" [formGroup]=\"paymentForm\">\n        <div class=\"row\">\n          <div class=\"form-container pay-desc\">\n            <pioneer-form-input label=\"EVENT.COMMISSION.PAYMENT_COMMENTS\" [isReadOnly]=\"false\">\n              <input type=\"text\"\n                     class=\"form-control\"\n                     [placeholder]=\"isAuthorizedPayment() ? ('EVENT.COMMISSION.PAYMENT_COMMENTS_PLACEHOLDER' | translate) : ''\"\n                     id=\"paymentDesc\"\n                     formControlName=\"description\"\n                     [attr.disabled]=\"disablePaymentDescription() ? 'disabled' : null\"\n                     maxlength=\"255\">\n            </pioneer-form-input>\n          </div>\n        </div>\n        <ng-template #nonCommissionAmount>\n          <div class=\"form-container col-7\">\n            <pioneer-form-input label=\"{{getNonCommDescriptionLabel()}}\">\n              <select formControlName=\"type\" class=\"form-control form-control-sm\" data-se-id=\"nonCommissionType\" (change)=\"onNonCommissionTypeChange()\">\n                <option [ngValue]=\"null\"\n                        data-se-id=\"nonCommissionTypeDefaultOption\">{{ 'EVENT.COMMISSION.NON_COMM_DESCRIPTION_PLACEHOLDER' | translate }}</option>\n                <ng-container>\n                  <option *ngFor=\"let option of nonCommissionTypes\" [ngValue]=\"option\">{{ option.value }}</option>\n                </ng-container>\n              </select>\n            </pioneer-form-input>\n          </div>\n          <div class=\"form-container col\">\n            <pioneer-form-input label=\"{{getAmountPaidLabel()}}\" *ngIf=\"isPayDirect()\" [required]=\"true\">\n              <input type=\"number\"\n                     class=\"form-control\"\n                     style=\"width: 14rem;\"\n                     formControlName=\"commissionAmount\"\n                     data-se-id=\"nonCommissionAmountPaid\"\n                     placeholder=\"{{'EVENT.COMMISSION.NON_COMM_AMOUNT_PAID_PLACEHOLDER' | translate}}\"\n                     required\n                     pioneerCurrency />\n              <pioneer-validation-message error=\"amount_paid_not_equals_total_calculated_payment\"\n                message=\"MESSAGES.VALIDATION.AMOUNT_PAID_NOT_EQUALS_TOTAL_CALCULATED_PAYMENT\"\n                [takeSpace]=\"true\">\n              </pioneer-validation-message>\n            </pioneer-form-input>\n          </div>\n        </ng-template>\n        <ng-container *pioneerAuthorize=\"{permission: 'AgencyEventLevelIndicators'}\">\n          <div class=\"row\"\n               *ngIf=\"canPaidDirectAndCancel() && showPayRejected() && !isSubscriber() && isCommissionGreaterThanZero() && isEventFinished\">\n            <ng-container *ngTemplateOutlet=\"nonCommissionAmount\"></ng-container>\n          </div>\n          <div class=\"row\"\n               *ngIf=\"canPaidDirectAndCancel() && showPayRejected() && !isSubscriber() && (!isCommissionGreaterThanZero() || !isEventFinished)\">\n            <div class=\"form-container col-7\">\n              <pioneer-form-input label=\"{{getNonCommDescriptionLabel()}}\">\n                <select formControlName=\"cancelType\" class=\"form-control form-control-sm\" data-se-id=\"cancelType\">\n                  <option [ngValue]=\"null\"\n                          data-se-id=\"cancelTypeDefaultOption\">{{ 'EVENT.COMMISSION.NON_COMM_DESCRIPTION_PLACEHOLDER' | translate }}</option>\n                  <ng-container>\n                    <option *ngFor=\"let option of cancelTypes\" [ngValue]=\"option\">{{ option.value }}</option>\n                  </ng-container>\n                </select>\n              </pioneer-form-input>\n            </div>\n          </div>\n        </ng-container>\n        <ng-container *pioneerAuthorize=\"{permission: 'SingleVendor'}\">\n          <div class=\"row\" *ngIf=\"isPropertyUser && !hasPrePayment && isCommissionGreaterThanZero()\">\n            <ng-container *ngTemplateOutlet=\"nonCommissionAmount\"></ng-container>\n          </div>\n          <div class=\"row\" *ngIf=\"isPropertyUser && !hasPrePayment && !isCommissionGreaterThanZero()\">\n              <div class=\"form-container col-7\">\n                <pioneer-form-input label=\"{{getNonCommDescriptionLabel()}}\">\n                  <select formControlName=\"cancelType\" class=\"form-control form-control-sm\" data-se-id=\"cancelType\">\n                    <option [ngValue]=\"null\"\n                            data-se-id=\"cancelTypeDefaultOption\">{{ 'EVENT.COMMISSION.NON_COMM_DESCRIPTION_PLACEHOLDER' | translate }}</option>\n                    <ng-container>\n                      <option *ngFor=\"let option of cancelTypes\" [ngValue]=\"option\">{{ option.value }}</option>\n                    </ng-container>\n                  </select>\n                </pioneer-form-input>\n              </div>\n          </div>\n        </ng-container>\n      </form>\n    </ng-container>\n  </div>\n  <div class=\"card-footer text-right\" *ngIf=\"isPropertyUser\">\n    <div class=\"row\">\n      <div class=\"col\">\n        <p class=\"text-info\">\n          <strong>\n            <i class=\"far fa-pennant\" aria-hidden=\"true\"></i>\n            {{'EVENT.COMMISSION.VERIFY_PAYMENT_AMOUNT' | translate}}\n          </strong>\n        </p>\n      </div>\n    </div>\n  </div>\n</div>\n\n<ng-container *ngIf=\"isEventControlledByThisUserType() && !isNonCommTypeSelected() && !isCancelTypeSelected()\">\n  <div class=\"button-bar\" *pioneerAuthorize=\"{permission: 'PayCommission'}\">\n    <p *ngIf=\"finalPaymentHint\" class=\"text-hint\">{{ finalPaymentHint | translate }}</p>\n\n    <button class=\"btn btn-primary\"\n            (click)=\"confirmBeforeApprovalWorkflow()\"\n            data-se-id=\"paymentSubmitButton\"\n            [disabled]=\"disableConfirmBeforeAuthorizingPayment() | async\">\n\n      <ng-container *ngIf=\"calculatedPayment > 0\">\n        <small data-se-id=\"paymentSubmitButtonTotal\">{{ 'EVENT.COMMISSION.AUTHORIZE_PAYMENT_TOTAL' | translate }} {{ calculatedPaymentWithTax | number:'1.2-2' }} {{ onyxEvent.currency | uppercase }}</small>\n        <br>\n      </ng-container>\n      <span\n        data-se-id=\"paymentSubmitButtonText\">{{ showRequestPayment() ? approvalButtonLabel : ('EVENT.COMMISSION.AUTHORIZE_PAYMENT' | translate) }}</span>\n    </button>\n  </div>\n</ng-container>\n\n<ng-container *ngIf=\"isNonCommTypeSelected() && canCancelEvent()\">\n  <div class=\"button-bar\" *pioneerAuthorize=\"{permission: 'PayCommission'}\">\n    <button class=\"btn btn-link\" data-se-id=\"updatePaymentReturnButton\" (click)=\"unSelectNonCommType()\">\n      {{ 'EVENT.COMMISSION.UPDATE_PAYMENT_RETURN' | translate}}\n    </button>\n\n    <button class=\"btn btn-primary\"\n            (click)=\"saveNonCommPaymentType()\"\n            data-se-id=\"updatePaymentSubmitButton\"\n            [disabled]=\"disablePaidDirect()\">\n\n      <span data-se-id=\"updatePaymentSubmitButtonText\">{{ 'EVENT.COMMISSION.UPDATE_PAYMENT' | translate }}</span>\n      <br>\n      <span\n        data-se-id=\"updatePaymentSubmitButtonStatusText\">{{ isPayDirect() ? ('EVENT.COMMISSION.UPDATE_PAYMENT_PAID_DIRECT' | translate) : ('EVENT.COMMISSION.UPDATE_PAYMENT_CANCELLED' | translate) }}</span>\n    </button>\n  </div>\n</ng-container>\n\n<ng-container *ngIf=\"isCancelTypeSelected() && canCancelEvent()\">\n  <div class=\"button-bar\" *pioneerAuthorize=\"{permission: 'PayCommission'}\">\n    <button class=\"btn btn-link\" data-se-id=\"updatePaymentReturnButton\" (click)=\"unSelectNonCommType()\">\n      {{ 'EVENT.COMMISSION.UPDATE_PAYMENT_RETURN_ONLY_CANCEL' | translate}}\n    </button>\n\n    <button class=\"btn btn-primary\"\n            (click)=\"saveCancelPaymentType()\"\n            data-se-id=\"updatePaymentSubmitButton\">\n\n      <span data-se-id=\"updatePaymentSubmitButtonText\">{{ 'EVENT.COMMISSION.UPDATE_PAYMENT' | translate }}</span>\n      <br>\n      <span\n        data-se-id=\"updatePaymentSubmitButtonStatusText\">{{ 'EVENT.COMMISSION.UPDATE_PAYMENT_CANCELLED' | translate }}</span>\n    </button>\n  </div>\n</ng-container>\n"

/***/ }),

/***/ "vgM6":
/***/ (function(module, exports) {

module.exports = "<pioneer-confirmation-modal\n  #confirmLinkModal\n  data-se-id=\"linkReservationConfirmationModal\"\n  title=\"EVENT.TRANSIENT_RESERVATION.CONFIRM_LINK_TITLE\"\n  content=\"{{confirmLinkingMessage}}\"\n  cancel=\"COMMON.BUTTON.CANCEL\"\n  [confirm]=\"confirmationModalConfig.confirm\"\n  [confirmClass]=\"'smaller'\"\n  (closed)=\"confirmLinkHandler($event)\"\n  [action]=\"confirmLinkAction\">\n</pioneer-confirmation-modal>\n\n<div *ngIf=\"selectorType === 'checkbox'\" class=\"card-block text-right\">\n  <button type=\"submit\"\n          class=\"btn btn-primary btn-xs col-md-4 btn-wrap\"\n          [disabled]=\"!hasSelectedReservations()\"\n          (click)=\"confirmLinkingAndPayViaGP()\">\n    {{'EVENT.TRANSIENT_RESERVATION.LINK_SELECTED_AND_PAY_VIA_GROUPPAY' | translate}}\n  </button>\n  <span class=\"col-md\"></span>\n  <button type=\"submit\"\n          class=\"btn btn-default btn-xs col-lg-4 btn-wrap\"\n          [disabled]=\"!hasSelectedReservations()\"\n          (click)=\"confirmLinkingAndDoNotPayViaGP()\">\n    {{'EVENT.TRANSIENT_RESERVATION.LINK_SELECTED_AND_DO_NOT_PAY_VIA_GROUPPAY' | translate}}\n  </button>\n</div>\n\n<br /><br />\n\n<div class=\"table-responsive table-dropdown\"\n     data-se-id=\"transientReservationTable\">\n  <table class=\"table table table-hover\">\n    <thead>\n    <tr>\n      <th *ngIf=\"selectorType !== 'checkbox' || noRecords; else displayAllCheckbox\"></th>\n      <ng-template #displayAllCheckbox>\n        <th class=\"form-group col-radio\">\n          <div class=\"form-check center\">\n            <label class=\"custom-control custom-checkbox\">\n              <input type=\"checkbox\"\n                    class=\"custom-control-input\"\n                    (change)=\"onAllCheckboxChange($event)\"\n                    [checked]=\"allReservationsChecked\">\n              <span class=\"custom-control-indicator\"></span>\n            </label>\n          </div>\n        </th>\n      </ng-template>\n      <th *ngIf=\"rsvp\">{{ 'EVENT.RSVPS.TYPE' | translate }}</th>\n      <th>{{ 'EVENT.RESERVATION.NAME' | translate }}</th>\n      <th>{{ 'EVENT.RESERVATION.CONFIRMATION_NUMBER' | translate }}</th>\n      <th>{{ 'EVENT.RESERVATION.STATUS' | translate }}</th>\n      <th>{{ 'EVENT.RESERVATION.CHECKIN_DATE' | translate }}</th>\n      <th>{{ 'EVENT.RESERVATION.CHECKOUT_DATE' | translate }}</th>\n      <th class=\"text-center\">{{ 'EVENT.RESERVATION.NUMBER_NIGHTS' | translate }}</th>\n      <th>{{ 'EVENT.RESERVATION.ROOM_TYPE' | translate }}</th>\n      <th>{{ 'EVENT.RESERVATION.RATE_PLAN_CODE' | translate }}</th>\n      <th class=\"currency\">\n        {{ 'EVENT.RESERVATION.ROOM_RATE' | translate }}\n        <br><small>({{ event.currency | uppercase }})</small>\n      </th>\n    </tr>\n    </thead>\n    <tbody data-se-id=\"transientReservationList\">\n      <tr class=\"table-comparison\" *ngIf=\"rsvp\">\n        <ng-container *pioneerAuthorize=\"{permission: 'LinkReservation'}\">\n          <ng-container *ngIf=\"(canChangeReservations$ | async) === true\">\n            <td class=\"col-radio\"></td>\n          </ng-container>\n        </ng-container>\n        <td>{{ 'EVENT.RSVPS.TYPE_RSVP' | translate }}</td>\n        <td>{{rsvp.lastName}}, {{rsvp.firstName}}</td>\n        <td>{{rsvp.confirmation}}</td>\n        <td>--</td>\n        <td>{{rsvp.checkInDate}}</td>\n        <td>{{rsvp.checkOutDate}}</td>\n        <td class=\"text-center\">{{rsvp.nights}}</td>\n        <td>{{rsvp.roomType}}</td>\n        <td></td>\n        <td class=\"text-right\">{{ rsvp.roomRate | number:'1.2-2' }}</td>\n      </tr>\n      <ng-container *ngIf=\"searchResults?.totalElements > 0\">\n        <tr *ngFor=\"let searchResult of searchResults.content; first as isFirst; last as isLast\"\n            data-se-id=\"transientReservationListEntry\"\n            (click)=\"selectorType !== 'checkbox' ? onSelect(searchResult) : null\">\n            <ng-container *pioneerAuthorize=\"{permission: 'LinkReservation'}\">\n              <ng-container *ngIf=\"(canChangeReservations$ | async) === true\">\n                <td *ngIf=\"selectorType !== 'checkbox'; else displaySelectorAsCheckbox\" class=\"form-group col-radio\" data-se-id=\"selected\">\n                  <div class=\"form-check align-middle\">\n                    <label class=\"custom-control custom-radio\">\n                      <input type=\"radio\"\n                            class=\"custom-control-input\"\n                            name=\"optionsRadios\"\n                            data-se-id=\"selectTransientReservation\"\n                            [checked]=\"searchResult.selected || (isFirst && !transientReservationSelected)\">\n                      <span class=\"custom-control-indicator\"></span>\n                    </label>\n                  </div>\n                </td>\n                <ng-template #displaySelectorAsCheckbox>\n                  <td class=\"form-group col-radio\">\n                    <div class=\"form-check center\">\n                      <label class=\"custom-control custom-checkbox\">\n                        <input type=\"checkbox\"\n                              class=\"custom-control-input\"\n                              (change)=\"onCheckboxChange(searchResult)\"\n                              [checked]=\"searchResult.selected\">\n                        <span class=\"custom-control-indicator\"></span>\n                      </label>\n                    </div>\n                  </td>\n                </ng-template>\n              </ng-container>\n            </ng-container>\n            <ng-template #emptyColumn>\n              <td class=\"col-more\"></td>\n            </ng-template>\n          <td data-se-id=\"type\" *ngIf=\"rsvp\">{{ 'EVENT.RSVPS.TYPE_RESERVATION' | translate }}</td>\n          <td data-se-id=\"name\">{{searchResult.lastName}}, {{searchResult.firstName}}</td>\n          <td data-se-id=\"confirmation\">{{searchResult.confirmation}}</td>\n          <td data-se-id=\"status\">{{searchResult.status | reservationStatus }}</td>\n          <td data-se-id=\"checkIn\">{{searchResult.checkInDate | dateFormat}}</td>\n          <td data-se-id=\"checkOut\">{{searchResult.checkOutDate | dateFormat}}</td>\n          <td data-se-id=\"nights\" class=\"text-center\">{{searchResult.nights}}</td>\n          <td data-se-id=\"roomType\">{{searchResult.roomType}}</td>\n          <td data-se-id=\"ratePlanCode\">{{searchResult.ratePlanCode}}</td>\n          <td data-se-id=\"roomRate\" class=\"text-right\">{{ searchResult.roomRate | number:'1.2-2' }}</td>\n        </tr>\n      </ng-container>\n    </tbody>\n  </table>\n</div>\n\n<ng-container *ngIf=\"searchResults?.totalElements === 0\">\n  <p *ngIf=\"rsvp\" class=\"text-warning\">\n    {{ 'EVENT.TRANSIENT_RESERVATION.NO_MATCHES_RESULT' | translate }}\n  </p>\n  <div *ngIf=\"!rsvp\" class=\"card-watermark mb-4\" data-se-id=\"transientReservationNotFound\">\n    <h3 class=\"mb-2\">\n      {{'EVENT.TRANSIENT_RESERVATION.NO_RESULTS' | translate }}\n    </h3>\n    <figure class=\"figure\">\n      <figcaption class=\"figure-caption\">\n        {{'EVENT.TRANSIENT_RESERVATION.NO_RESULTS_CAPTION' | translate }}\n      </figcaption>\n    </figure>\n  </div>\n</ng-container>\n"

/***/ }),

/***/ "w671":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("rP7Y")(true);
// imports


// module
exports.push([module.i, ".adjustment-left{left:0}.commission-info{display:-ms-flexbox;display:flex;margin-right:-15px;margin-left:-15px}.commission-currency{padding-right:15px;padding-left:15px}.adjustment-description{padding-left:15px;font-size:1.25rem}.tax-label{padding-left:15px;padding-top:10px;font-style:italic;font-size:12px;font-weight:400}.missing-tax-info{color:#c3002f}", "", {"version":3,"sources":["/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/payment/payment-equation/payment-equation.component.css"],"names":[],"mappings":"AAAA,iBACE,MAAQ,CACT,iBAGC,oBAAA,aAAc,mBACM,iBACD,CACpB,qBAGC,mBAAoB,iBACD,CACpB,wBAGC,kBAAmB,iBACA,CACpB,WAGC,kBAAmB,iBACD,kBACC,eACH,eACI,CACrB,kBAGC,aAAe,CAChB","file":"payment-equation.component.css","sourcesContent":[".adjustment-left {\n  left: 0;\n}\n\n.commission-info {\n  display: flex;\n  margin-right: -15px;\n  margin-left: -15px;\n}\n\n.commission-currency {\n  padding-right: 15px;\n  padding-left: 15px;\n}\n\n.adjustment-description {\n  padding-left: 15px;\n  font-size: 1.25rem;\n}\n\n.tax-label {\n  padding-left: 15px;\n  padding-top: 10px;\n  font-style: italic;\n  font-size: 12px;\n  font-weight: normal;\n}\n\n.missing-tax-info {\n  color: #c3002f;\n}\n"],"sourceRoot":""}]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),

/***/ "wagN":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("rP7Y")(true);
// imports


// module
exports.push([module.i, ".totals{text-align:right;height:27px;font-family:OpenSans-Regular,Open Sans,sans-serif;padding:4px 4px 4px 4px;margin-right:25px}.bold,.totals{font-size:16px}.bold{font-weight:700}.button-vendors{margin-top:20px}", "", {"version":3,"sources":["/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/payment/vendors-total-add-payment/vendors-total-add-payment.component.css"],"names":[],"mappings":"AACA,QACE,iBAAkB,YACL,kDAC4C,wBAChC,iBACN,CAEpB,cADC,cAAgB,CAIlB,MAEE,eAAiB,CAClB,gBAGC,eAAiB,CAClB","file":"vendors-total-add-payment.component.css","sourcesContent":["\n.totals {\n  text-align: right;\n  height: 27px;\n  font-family: \"OpenSans-Regular\", \"Open Sans\", sans-serif;\n  padding: 4px 4px 4px 4px; \n  margin-right: 25px;\n  font-size: 16px;    \n}\n\n\n.bold {\n  font-size: 16px;\n  font-weight:bold;\n}\n\n.button-vendors {\n  margin-top: 20px;\n}\n"],"sourceRoot":""}]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),

/***/ "wn9K":
/***/ (function(module, exports) {

module.exports = "<div class=\"modal fade\" bsModal [config]=\"config\" role=\"dialog\" tabindex=\"-1\" data-se-id=\"transientReservationModal\">\n  <div class=\"modal-dialog modal-xl\">\n    <div class=\"modal-content\">\n      <div class=\"modal-header\">\n        <h5 class=\"modal-title\">{{'EVENT.TRANSIENT_RESERVATION.MODAL_TITLE' | translate}}</h5>\n        <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\" (click)=\"cancel()\" data-se-id=\"closeTransientReservationModal\">\n          <span aria-hidden=\"true\">&times;</span>\n        </button>\n      </div>\n        <div class=\"modal-body\">\n\n          <pioneer-transient-search\n            [event]=\"event\"\n            [searchResults]=\"searchResults\"\n            (hasSearched)=\"onHasSearched()\">\n          </pioneer-transient-search>\n\n          <p>{{'EVENT.TRANSIENT_RESERVATION.MODAL_CAPTION' | translate}}</p>\n\n          <pioneer-transient-table\n            [event]=\"event\"\n            [rsvp]=\"rsvp\"\n            [searchResults]=\"searchResults\"\n            (refreshList)=\"onRefreshList($event.page)\">\n          </pioneer-transient-table>\n\n          <pioneer-pagination\n            *ngIf=\"searchResults?.totalElements > 0\"\n            [resultsPage]=\"searchResults\"\n            (updatePage)=\"onRefreshList($event.page)\"\n            [pagesizeType]=\"pagesizeType\">\n          </pioneer-pagination>\n        </div>\n        <div class=\"modal-footer\">\n          <button type=\"button\" class=\"btn btn-link\" data-dismiss=\"modal\" (click)=\"cancel()\" data-se-id=\"cancelTransientReservationModal\">{{'COMMON.BUTTON.CANCEL' | translate}}</button>\n          <button type=\"button\" class=\"btn btn-primary\" [disabled]=\"disableLinkButton()\" (click)=\"accept()\" data-se-id=\"acceptTransientReservationModal\">{{'EVENT.TRANSIENT_RESERVATION.LINK_RESERVATION_TO_EVENT' | translate}}</button>\n        </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),

/***/ "wvGA":
/***/ (function(module, exports) {

module.exports = "<div *ngIf=\"!valid\">\n  <p class=\"form-control-feedback\" [ngClass]=\"{'take-space': takeSpace}\">{{getValidationMessage(error)}}</p>\n</div>\n"

/***/ }),

/***/ "xhPN":
/***/ (function(module, exports) {

module.exports = "<div class=\"splash-content\">\n  <div class=\"splash-container\">\n    <div class=\"login-logo\"><span class=\"sr-only\">Onyx CenterSource</span></div>\n    <div>\n      <h4>Frontend Version:</h4>\n      <pre class=\"splash-message\">{{frontendVersionObj | json}}</pre>\n    </div>\n    <div>\n      <h4>Backend Version:</h4>\n      <pre class=\"splash-message\">{{backendVersionObj | json}}</pre>\n    </div>\n  </div>\n</div>\n"

/***/ }),

/***/ "yKfN":
/***/ (function(module, exports) {

module.exports = "<div class=\"table-responsive\">\n  <table class=\"table\">\n    <thead>\n    <tr>\n      <th>{{'EVENT.COMMISSION.ROOM_TYPE' | translate}}</th>\n      <th class=\"nights\">{{'EVENT.COMMISSION.ROOM_NIGHTS' | translate}}</th>\n      <th class=\"currency\">\n        {{'EVENT.COMMISSION.ROOM_RATE' | translate}}\n        <br><small>({{ onyxEvent.currency | uppercase }})</small>\n      </th>\n      <th class=\"currency\">\n        {{'EVENT.COMMISSION.ROOM_REVENUE' | translate}}\n        <br><small>({{ onyxEvent.currency | uppercase }})</small>\n      </th>\n      <th class=\"currency\">\n        {{'EVENT.COMMISSION.ROOM_COMMISSION' | translate}}\n        <br><small>({{ onyxEvent.currency | uppercase }})</small>\n      </th>\n    </tr>\n    </thead>\n    <tbody>\n    <tr *ngFor=\"let roomTypeRateSummary of roomTypeRateSummaryList | async\" data-se-id=\"roomTypeSummaryRow\">\n      <td data-se-id=\"roomType\">{{roomTypeRateSummary.roomType}}</td>\n      <td class=\"nights\" data-se-id=\"totalNights\">{{roomTypeRateSummary.totalNights}}</td>\n      <td class=\"currency\" data-se-id=\"roomRate\">{{ roomTypeRateSummary.roomRate | number:'1.2-2' }}</td>\n      <td class=\"currency\" data-se-id=\"totalRevenue\">{{ roomTypeRateSummary.totalRevenue | number:'1.2-2' }}</td>\n      <td class=\"currency\" data-se-id=\"totalCommission\">{{ roomTypeRateSummary.totalCommission | number:'1.2-2' }}</td>\n    </tr>\n    </tbody>\n  </table>\n</div>\n"

/***/ }),

/***/ "ys9C":
/***/ (function(module, exports) {

module.exports = "<div class=\"card\">\n  <div class=\"card-header\" id=\"card-stay-information\">{{'EVENT.COMMISSION.DETAILS' | translate}}\n  </div>\n  <div class=\"table-responsive\">\n    <table class=\"table\">\n      <thead>\n      <tr>\n        <th>\n          <br>{{'EVENT.COMMISSION.NAME' | translate}}<br>\n          <span class=\"font-weight-normal\">{{ 'EVENT.RESERVATION.CONFIRMATION_NUMBER' | translate }}\n          </span>\n        </th>\n        <th><br>{{'EVENT.COMMISSION.STATUS' | translate}}</th>\n        <th><br>{{'EVENT.COMMISSION.CHECKIN_DATE' | translate}}</th>\n        <th><br>{{'EVENT.COMMISSION.CHECKOUT_DATE' | translate}}</th>\n        <th class=\"nights\"><br>{{'EVENT.RESERVATION.NUMBER_ROOMS' | translate}}</th>\n        <th class=\"nights\"><br>{{'EVENT.COMMISSION.ROOM_NIGHTS' | translate}}</th>\n        <th>\n          <br>{{ 'EVENT.RESERVATION.RATE_PLAN_CODE' | translate }}<br>\n          <span class=\"font-weight-normal\">{{ 'EVENT.RESERVATION.ROOM_TYPE' | translate }}</span>\n        </th>\n        <th class=\"currency\">\n          <small>({{ onyxEvent.currency | uppercase }})</small>\n          <br>{{'EVENT.COMMISSION.ROOM_RATE' | translate}}\n        </th>\n        <th class=\"currency\">\n          <small>({{ onyxEvent.currency | uppercase }})</small>\n          <br>{{'EVENT.COMMISSION.REVENUE' | translate}}\n        </th>\n        <th class=\"currency\">\n          <small>({{ onyxEvent.currency | uppercase }})</small>\n          <br>{{'EVENT.COMMISSION.COMMISSION' | translate}}\n        </th>\n      </tr>\n      </thead>\n      <tbody>\n      <tr *ngFor=\"let reservation of reservationsPage?.content\"\n          data-se-id=\"reservationRow\">\n        <td class=\"field-wrap\" data-se-id=\"lastName\">\n          <div>{{reservation.lastName}}, {{reservation.firstName}}</div>\n          <div class=\"text-muted\">{{ reservation.confirmation }}</div>\n        </td>\n        <td>{{reservation.status | reservationStatus}}</td>\n        <td>{{reservation.checkInDate | dateFormat}}</td>\n        <td>{{reservation.checkOutDate | dateFormat}}</td>\n        <td class=\"nights\">{{reservation.rooms}}</td>\n        <td class=\"nights\">{{reservation.roomNights}}</td>\n        <td>\n          <div>{{ reservation.ratePlanCode }}</div>\n          <div class=\"text-muted\">{{ reservation.roomType }}</div>\n        </td>\n        <td class=\"currency\">{{ reservation.roomRate | number:'1.2-2' }}</td>\n        <td class=\"currency\" data-se-id=\"revenue\">{{ reservation.revenue | number:'1.2-2' }}\n        </td>\n        <td class=\"currency\" data-se-id=\"commission\">{{ reservation.commission | number:'1.2-2' }}\n        </td>\n      </tr>\n      </tbody>\n      <tfoot>\n      <tr data-se-id=\"reservationsSummaryRow\">\n        <td>{{'EVENT.COMMISSION.TOTAL' | translate}}</td>\n        <td></td>\n        <td></td>\n        <td></td>\n        <td></td>\n        <td class=\"nights\">{{ staySummary?.totalNights }}</td>\n        <td></td>\n        <td></td>\n        <td class=\"currency\">{{ staySummary?.totalRevenue | number:'1.2-2' }}</td>\n        <td class=\"currency\" data-se-id=\"totalCommission\">\n          {{ staySummary?.totalCommission | number:'1.2-2' }}\n        </td>\n      </tr>\n      </tfoot>\n    </table>\n  </div>\n  <div class=\"card-footer\" *ngIf=\"reservationsPage?.totalElements > 0\">\n    <pioneer-pagination\n      [resultsPage]=\"reservationsPage\"\n      (updatePage)=\"goToRecordsPage($event.page)\"\n      [pagesizeType]=\"pagesizeType\">\n    </pioneer-pagination>\n  </div>\n</div>\n"

/***/ }),

/***/ "z++b":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("rP7Y")(true);
// imports


// module
exports.push([module.i, ".can-remove:hover:after{border-radius:3px 12px 3px 3px;content:\"V\"!important;background-color:#c3002f}", "", {"version":3,"sources":["/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/attachment/attachment.component.css"],"names":[],"mappings":"AAAA,wBACE,+BAAgC,sBACJ,wBACF,CAC3B","file":"attachment.component.css","sourcesContent":[".can-remove:hover::after {\n  border-radius: 3px 12px 3px 3px;\n  content: '\\0056' !important;\n  background-color: #c3002f;\n}\n"],"sourceRoot":""}]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),

/***/ "zobq":
/***/ (function(module, exports) {

module.exports = "<div *ngIf=\"chartData\" class=\"chart-panel\">\n  <div\n    class=\"container\"\n    [style.min-width.px]=\"width\"\n    [style.width.px]=\"width\"\n    [style.height.px]=\"height\"\n  >\n    <div class=\"banner\">\n      <div class=\"row chart-title\">\n        {{ totalEvents }}\n      </div>\n      <div class=\"row chart-subtitle text-center\">Events</div>\n    </div>\n    <svg xmlns=\"http://www.w3.org/2000/svg\">\n      <circle\n        *ngFor=\"let item of chartData\"\n        [attr.cx]=\"width / 2\"\n        [attr.cy]=\"height / 2\"\n        class=\"donut\"\n        [ngClass]=\"{ 'donut-disabled': item.code == 'readyToInitiate' }\"\n        [attr.r]=\"radius\"\n        stroke-width=\"45\"\n        [attr.stroke]=\"item.color\"\n        fill=\"none\"\n        [ngStyle]=\"item.selected ? {\n          'stroke-width': 60\n        }: null\"\n        (mouseover)=\"trMouseOver(item)\"\n        (mouseout)=\"trMouseOut(item)\"\n        (click)=\"launchEventListPage(item)\"\n      >\n        <title>{{ item.label }} - {{ item.value }}</title>\n      </circle>\n    </svg>\n  </div>\n  <table class=\"table\">\n    <tbody>\n      <tr\n        *ngFor=\"let item of chartData\"\n        (mouseover)=\"trMouseOver(item)\"\n        (mouseout)=\"trMouseOut(item)\"\n        [ngStyle]=\"item.selected ? {\n          'background-color': '#eef8ff'\n        }: null\"\n        (click)=\"launchEventListPage(item)\"\n        [ngClass]=\"{ 'tr-disabled': item.code == 'readyToInitiate' }\"\n      >\n        <td class=\"bold text-right\">{{ item.value }}</td>\n        <td>\n          <div\n            class=\"color\"\n            [ngStyle]=\"{ 'background-color': item.color }\"\n          ></div>\n        </td>\n        <td>{{ item.label }}</td>\n      </tr>\n    </tbody>\n  </table>\n</div>\n"

/***/ }),

/***/ "zx3B":
/***/ (function(module, exports) {

module.exports = "<div class=\"container-fluid\">\n  <div class=\"row app-header thin\">\n    <div class=\"mx-auto\">\n      <img src=\"{{imagesUrl}}/grouppay-logo-std.png\" class=\"img-responsive width-250\" title=\"GroupPay\"/>\n    </div>\n  </div>\n</div>\n\n<div class=\"container-fluid\">\n  <div class=\"row title-bar bg-inverse\">\n    <div class=\"page-title\">\n      <h1>&nbsp;</h1>\n    </div>\n    <div class=\"action-bar\"></div>\n  </div>\n</div>\n\n<div class=\"container-fluid\">\n  <div class=\"row app-area\">\n    <div class=\"content-area\">\n      <div class=\"content-container\">\n        <router-outlet></router-outlet>\n      </div>\n    </div>\n  </div>\n</div>\n\n<nav class=\"navbar\">\n  <span class=\"navbar-text text-center\">\n    {{ 'COMMON.LAYOUT.FOOTER' | translate: {year: year} }}\n  </span>\n</nav>\n"

/***/ })

},[0]);


// WEBPACK FOOTER //
// main.645dba17ffd16b4f9c32.bundle.js